window.astroLocationsData =[  
	{
    "Area": "A K Pora",
    "State": "Jammu & Kashmir",
    "CountryCode": "IN",
    "Lat": 34.14,
    "Long": 74.7964
  },
  {
    "Area": "A. C Lane",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.5333,
    "Long": 88.3917
  },
  {
    "Area": "A.Konduru",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.0532,
    "Long": 80.7319
  },
  {
    "Area": "A.g.nioda",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 28.4793,
    "Long": 77.5734
  },
  {
    "Area": "A.i .area",
    "State": "Jharkhand",
    "CountryCode": "IN",
    "Lat": 23.2202,
    "Long": 86.0029
  },
  {
    "Area": "A.s.peta",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 15.3506,
    "Long": 79.7344
  },
  {
    "Area": "AMAS",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 24.6991,
    "Long": 84.936
  },
  {
    "Area": "Aau",
    "State": "Rajasthan",
    "CountryCode": "IN",
    "Lat": 27.3439,
    "Long": 73.5195
  },
  {
    "Area": "Abdasa",
    "State": "Gujarat",
    "CountryCode": "IN",
    "Lat": 23.6285,
    "Long": 69.9604
  },
  {
    "Area": "Abhama",
    "State": "Jammu & Kashmir",
    "CountryCode": "IN",
    "Lat": 33.8463,
    "Long": 74.8035
  },
  {
    "Area": "Abhanga",
    "State": "Tripura",
    "CountryCode": "IN",
    "Lat": 24.0789,
    "Long": 91.8987
  },
  {
    "Area": "Abhanpur",
    "State": "Chattisgarh",
    "CountryCode": "IN",
    "Lat": 21.3782,
    "Long": 82.1027
  },
  {
    "Area": "Abhayapuri",
    "State": "Assam",
    "CountryCode": "IN",
    "Lat": 26.3225,
    "Long": 90.6853
  },
  {
    "Area": "Abi Karlpora",
    "State": "Jammu & Kashmir",
    "CountryCode": "IN",
    "Lat": 33.4307,
    "Long": 74.8979
  },
  {
    "Area": "Aboahr",
    "State": "Punjab",
    "CountryCode": "IN",
    "Lat": 30.0704,
    "Long": 74.2609
  },
  {
    "Area": "Abohar",
    "State": "Punjab",
    "CountryCode": "IN",
    "Lat": 30.8402,
    "Long": 74.7043
  },
  {
    "Area": "Abu Road",
    "State": "Rajasthan",
    "CountryCode": "IN",
    "Lat": 24.6916,
    "Long": 72.8039
  },
  {
    "Area": "Aburoad",
    "State": "Rajasthan",
    "CountryCode": "IN",
    "Lat": 24.6122,
    "Long": 72.9606
  },
  {
    "Area": "Achabal",
    "State": "Jammu & Kashmir",
    "CountryCode": "IN",
    "Lat": 33.6841,
    "Long": 75.2184
  },
  {
    "Area": "Achalpur City",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 21.3428,
    "Long": 77.5021
  },
  {
    "Area": "Achampet",
    "State": "Telangana",
    "CountryCode": "IN",
    "Lat": 16.6555,
    "Long": 78.9479
  },
  {
    "Area": "Achan",
    "State": "Jammu & Kashmir",
    "CountryCode": "IN",
    "Lat": 33.8643,
    "Long": 74.6951
  },
  {
    "Area": "Achheja",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 28.5965,
    "Long": 77.502
  },
  {
    "Area": "Achina",
    "State": "Haryana",
    "CountryCode": "IN",
    "Lat": 28.674,
    "Long": 76.3722
  },
  {
    "Area": "Adalbari",
    "State": "Assam",
    "CountryCode": "IN",
    "Lat": 26.7706,
    "Long": 91.3933
  },
  {
    "Area": "Adalhat",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 25.2414,
    "Long": 83.0944
  },
  {
    "Area": "Adampur",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.4784,
    "Long": 88.5822
  },
  {
    "Area": "Adapur",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 26.6661,
    "Long": 84.894
  },
  {
    "Area": "Adasimla",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.1762,
    "Long": 87.6063
  },
  {
    "Area": "Adbhar",
    "State": "Chattisgarh",
    "CountryCode": "IN",
    "Lat": 21.9648,
    "Long": 83.2005
  },
  {
    "Area": "Addanki",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 15.7871,
    "Long": 79.9223
  },
  {
    "Area": "Addateegala",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.5136,
    "Long": 82.0454
  },
  {
    "Area": "Addathigala",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.4787,
    "Long": 82.0077
  },
  {
    "Area": "Addatigala",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.5273,
    "Long": 82.0893
  },
  {
    "Area": "Addconagar",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.9775,
    "Long": 88.1701
  },
  {
    "Area": "Adhata",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.8464,
    "Long": 88.5736
  },
  {
    "Area": "Adhaura",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 24.6974,
    "Long": 83.6437
  },
  {
    "Area": "Adhikashimpur",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.1994,
    "Long": 88.0296
  },
  {
    "Area": "Adichanallur",
    "State": "Kerala",
    "CountryCode": "IN",
    "Lat": 8.8805,
    "Long": 76.7156
  },
  {
    "Area": "Adilabad",
    "State": "Telangana",
    "CountryCode": "IN",
    "Lat": 19.8565,
    "Long": 79.0548
  },
  {
    "Area": "Adlalhat",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 25.1171,
    "Long": 83.0277
  },
  {
    "Area": "Adoni",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 15.8061,
    "Long": 77.7505
  },
  {
    "Area": "Adoor",
    "State": "Kerala",
    "CountryCode": "IN",
    "Lat": 9.9552,
    "Long": 76.9238
  },
  {
    "Area": "Adra",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 23.6244,
    "Long": 86.8734
  },
  {
    "Area": "Adur",
    "State": "Kerala",
    "CountryCode": "IN",
    "Lat": 9.9552,
    "Long": 76.8924
  },
  {
    "Area": "Adva",
    "State": "Odisha",
    "CountryCode": "IN",
    "Lat": 19.5568,
    "Long": 84.0747
  },
  {
    "Area": "Afjalpur",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 17.4744,
    "Long": 76.8695
  },
  {
    "Area": "Afjlpur",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 17.1507,
    "Long": 76.608
  },
  {
    "Area": "Afzalpur",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 17.311,
    "Long": 76.5884
  },
  {
    "Area": "Agali",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 13.8342,
    "Long": 77.0723
  },
  {
    "Area": "Agamoni",
    "State": "Assam",
    "CountryCode": "IN",
    "Lat": 26.271,
    "Long": 89.7904
  },
  {
    "Area": "Agar",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 23.6721,
    "Long": 76.3458
  },
  {
    "Area": "Agar Malwa",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 23.7952,
    "Long": 76.3458
  },
  {
    "Area": "Agarpada",
    "State": "Odisha",
    "CountryCode": "IN",
    "Lat": 20.9859,
    "Long": 86.6254
  },
  {
    "Area": "Agartala",
    "State": "Tripura",
    "CountryCode": "IN",
    "Lat": 23.6182,
    "Long": 91.356
  },
  {
    "Area": "Agasteeswaram",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 8.1733,
    "Long": 77.5683
  },
  {
    "Area": "Agastheeswaram",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 8.3113,
    "Long": 77.5781
  },
  {
    "Area": "Aghunato",
    "State": "Nagaland",
    "CountryCode": "IN",
    "Lat": 26.0213,
    "Long": 94.528
  },
  {
    "Area": "Agiaon",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 25.4652,
    "Long": 84.5717
  },
  {
    "Area": "Agiripalle",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.3619,
    "Long": 82.0551
  },
  {
    "Area": "Agomoni",
    "State": "Assam",
    "CountryCode": "IN",
    "Lat": 26.2954,
    "Long": 89.8278
  },
  {
    "Area": "Agra",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 27.6236,
    "Long": 78.4728
  },
  {
    "Area": "Agrico",
    "State": "Jharkhand",
    "CountryCode": "IN",
    "Lat": 23.0604,
    "Long": 85.9466
  },
  {
    "Area": "Aheri",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 19.7849,
    "Long": 80.4776
  },
  {
    "Area": "Ahmadabad City",
    "State": "Gujarat",
    "CountryCode": "IN",
    "Lat": 23.9941,
    "Long": 73.063
  },
  {
    "Area": "Ahmadpur",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 18.3605,
    "Long": 76.7751
  },
  {
    "Area": "Ahmedabad",
    "State": "Gujarat",
    "CountryCode": "IN",
    "Lat": 23.0833,
    "Long": 72.836
  },
  {
    "Area": "Ahmedabad City",
    "State": "Gujarat",
    "CountryCode": "IN",
    "Lat": 22.9764,
    "Long": 72.836
  },
  {
    "Area": "Ahmedangar",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 19.2306,
    "Long": 74.6025
  },
  {
    "Area": "Ahmednagar",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 19.6713,
    "Long": 75.7265
  },
  {
    "Area": "Ahmedpuer",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 18.3737,
    "Long": 76.6492
  },
  {
    "Area": "Ahmedpur",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 20.0648,
    "Long": 76.9373
  },
  {
    "Area": "Ahmedpur",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 23.5189,
    "Long": 77.7254
  },
  {
    "Area": "Ahopa",
    "State": "Assam",
    "CountryCode": "IN",
    "Lat": 26.536,
    "Long": 91.4097
  },
  {
    "Area": "Ahore",
    "State": "Rajasthan",
    "CountryCode": "IN",
    "Lat": 25.6542,
    "Long": 73.2873
  },
  {
    "Area": "Ahrod",
    "State": "Haryana",
    "CountryCode": "IN",
    "Lat": 28.1872,
    "Long": 76.3809
  },
  {
    "Area": "Ahwa",
    "State": "Gujarat",
    "CountryCode": "IN",
    "Lat": 21.0476,
    "Long": 73.7738
  },
  {
    "Area": "Aiary",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 25.0688,
    "Long": 85.8679
  },
  {
    "Area": "Aibawk",
    "State": "Mizoram",
    "CountryCode": "IN",
    "Lat": 23.5828,
    "Long": 92.7586
  },
  {
    "Area": "Ainavilli",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.1292,
    "Long": 82.2643
  },
  {
    "Area": "Ainavilli Mandal",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.5048,
    "Long": 82.0118
  },
  {
    "Area": "Air Force",
    "State": "Haryana",
    "CountryCode": "IN",
    "Lat": 28.418,
    "Long": 76.9839
  },
  {
    "Area": "Aizawl",
    "State": "Mizoram",
    "CountryCode": "IN",
    "Lat": 23.781,
    "Long": 92.7273
  },
  {
    "Area": "Ajaigarh",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 25.0039,
    "Long": 80.4789
  },
  {
    "Area": "Ajara",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 17.2734,
    "Long": 74.5379
  },
  {
    "Area": "Ajaygarh",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 24.8173,
    "Long": 80.0938
  },
  {
    "Area": "Ajijnagar",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.4784,
    "Long": 88.5822
  },
  {
    "Area": "Ajmer",
    "State": "Rajasthan",
    "CountryCode": "IN",
    "Lat": 26.641,
    "Long": 74.806
  },
  {
    "Area": "Ajnala",
    "State": "Punjab",
    "CountryCode": "IN",
    "Lat": 32.0109,
    "Long": 75.2076
  },
  {
    "Area": "Ajnla",
    "State": "Punjab",
    "CountryCode": "IN",
    "Lat": 31.7715,
    "Long": 74.863
  },
  {
    "Area": "Ajodhyapur",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.2758,
    "Long": 88.831
  },
  {
    "Area": "Ajoya",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 23.5034,
    "Long": 87.9832
  },
  {
    "Area": "Ajra",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 17.2734,
    "Long": 74.5379
  },
  {
    "Area": "Akabarpur",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 26.4201,
    "Long": 82.6685
  },
  {
    "Area": "Akaipur",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.8889,
    "Long": 88.4146
  },
  {
    "Area": "Akaltara",
    "State": "Chattisgarh",
    "CountryCode": "IN",
    "Lat": 22.1265,
    "Long": 82.4975
  },
  {
    "Area": "Akanda",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.8223,
    "Long": 87.5059
  },
  {
    "Area": "Akandaberia",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 24.5731,
    "Long": 87.974
  },
  {
    "Area": "Akandakeshari",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.5864,
    "Long": 88.4145
  },
  {
    "Area": "Akbapur",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 26.3756,
    "Long": 79.8667
  },
  {
    "Area": "Akbarpur",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 25.1284,
    "Long": 85.9234
  },
  {
    "Area": "Akbarpur",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 26.7157,
    "Long": 82.8642
  },
  {
    "Area": "Akbarur",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 26.5614,
    "Long": 82.6685
  },
  {
    "Area": "Akberpur",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 26.6415,
    "Long": 82.6685
  },
  {
    "Area": "Akberpur",
    "State": "Haryana",
    "CountryCode": "IN",
    "Lat": 28.1729,
    "Long": 76.1432
  },
  {
    "Area": "Akhnoor",
    "State": "Jammu & Kashmir",
    "CountryCode": "IN",
    "Lat": 33.3614,
    "Long": 74.7514
  },
  {
    "Area": "Akimamudpur",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.795,
    "Long": 88.1206
  },
  {
    "Area": "Akividu (mdl)",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 16.5823,
    "Long": 81.3811
  },
  {
    "Area": "Akkaikot",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 17.5287,
    "Long": 76.1524
  },
  {
    "Area": "Akkal Kuwa",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 21.2857,
    "Long": 74.2573
  },
  {
    "Area": "Akkalkot",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 18.064,
    "Long": 76.4236
  },
  {
    "Area": "Akkalkuwa",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 21.7829,
    "Long": 75.3512
  },
  {
    "Area": "Akkurthi",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 14.1388,
    "Long": 79.6972
  },
  {
    "Area": "Akoda",
    "State": "Haryana",
    "CountryCode": "IN",
    "Lat": 28.4851,
    "Long": 76.4735
  },
  {
    "Area": "Akodia",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 23.3803,
    "Long": 76.5988
  },
  {
    "Area": "Akola",
    "State": "Rajasthan",
    "CountryCode": "IN",
    "Lat": 24.8287,
    "Long": 74.7797
  },
  {
    "Area": "Akola",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 21.0915,
    "Long": 78.894
  },
  {
    "Area": "Akole",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 19.7583,
    "Long": 75.5847
  },
  {
    "Area": "Akorha",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 25.2236,
    "Long": 82.1505
  },
  {
    "Area": "Akorhi",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 24.9765,
    "Long": 84.2055
  },
  {
    "Area": "Akorhi Bazar",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 25.0237,
    "Long": 84.2065
  },
  {
    "Area": "Akorhi Gola",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 25.1359,
    "Long": 84.163
  },
  {
    "Area": "Akot",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 21.0963,
    "Long": 77.5881
  },
  {
    "Area": "Akpura",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.3836,
    "Long": 87.8747
  },
  {
    "Area": "Akratola",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.3687,
    "Long": 88.562
  },
  {
    "Area": "Akrjat",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 20.0535,
    "Long": 74.2457
  },
  {
    "Area": "Aktail",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 23.0119,
    "Long": 87.5938
  },
  {
    "Area": "Akuluto",
    "State": "Nagaland",
    "CountryCode": "IN",
    "Lat": 26.1661,
    "Long": 94.528
  },
  {
    "Area": "Akunuru",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 16.4196,
    "Long": 80.8292
  },
  {
    "Area": "Alair",
    "State": "Telangana",
    "CountryCode": "IN",
    "Lat": 17.604,
    "Long": 79.1139
  },
  {
    "Area": "Alal",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 25.1367,
    "Long": 88.0923
  },
  {
    "Area": "Alamanada",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 18.0031,
    "Long": 83.2086
  },
  {
    "Area": "Alamanda",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 18.0205,
    "Long": 83.2033
  },
  {
    "Area": "Alamanda Rs",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.9999,
    "Long": 83.2015
  },
  {
    "Area": "Alamchak Belda",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 23.8386,
    "Long": 88.171
  },
  {
    "Area": "Alamnagar",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 25.6109,
    "Long": 86.9252
  },
  {
    "Area": "Alamuru",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.293,
    "Long": 82.2794
  },
  {
    "Area": "Aland",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 17.8079,
    "Long": 77.0003
  },
  {
    "Area": "Alandur",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 12.8072,
    "Long": 80.0591
  },
  {
    "Area": "Alangiri",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.4305,
    "Long": 87.4447
  },
  {
    "Area": "Alangudi",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 10.6297,
    "Long": 79.2125
  },
  {
    "Area": "Alangulam",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 11.2589,
    "Long": 79.7156
  },
  {
    "Area": "Alankarpur",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.63,
    "Long": 87.7168
  },
  {
    "Area": "Alapur",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 26.5453,
    "Long": 83.0794
  },
  {
    "Area": "Alathur",
    "State": "Kerala",
    "CountryCode": "IN",
    "Lat": 10.8328,
    "Long": 76.781
  },
  {
    "Area": "Alatur",
    "State": "Kerala",
    "CountryCode": "IN",
    "Lat": 10.7085,
    "Long": 76.6922
  },
  {
    "Area": "Alibag",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 19.9934,
    "Long": 73.3257
  },
  {
    "Area": "Aliganj",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 27.5735,
    "Long": 79.2703
  },
  {
    "Area": "Aliganj",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 24.9852,
    "Long": 85.925
  },
  {
    "Area": "Aligarh",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 28.1316,
    "Long": 78.8191
  },
  {
    "Area": "Alinye",
    "State": "Arunachal Pradesh",
    "CountryCode": "IN",
    "Lat": 28.604,
    "Long": 95.8664
  },
  {
    "Area": "Alipurduar",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 26.8537,
    "Long": 89.763
  },
  {
    "Area": "Alipurduar - II",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 26.5148,
    "Long": 89.6522
  },
  {
    "Area": "Alirajpur",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 22.3403,
    "Long": 74.4566
  },
  {
    "Area": "Alisinga",
    "State": "Assam",
    "CountryCode": "IN",
    "Lat": 26.6589,
    "Long": 92.4784
  },
  {
    "Area": "Alladurg",
    "State": "Telangana",
    "CountryCode": "IN",
    "Lat": 17.6136,
    "Long": 78.0576
  },
  {
    "Area": "Allagadda",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 15.7407,
    "Long": 79.9128
  },
  {
    "Area": "Allahabad",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 25.8922,
    "Long": 82.4043
  },
  {
    "Area": "Allahabad **",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 25.5625,
    "Long": 81.9717
  },
  {
    "Area": "Allapur",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 26.5262,
    "Long": 83.0214
  },
  {
    "Area": "Allapur **",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 26.6469,
    "Long": 83.0636
  },
  {
    "Area": "Allavaram",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.1885,
    "Long": 82.0118
  },
  {
    "Area": "Allavaram Mandal",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 16.4862,
    "Long": 81.4719
  },
  {
    "Area": "Allgadda",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 15.7407,
    "Long": 79.9128
  },
  {
    "Area": "Allia",
    "State": "Assam",
    "CountryCode": "IN",
    "Lat": 26.4408,
    "Long": 91.8873
  },
  {
    "Area": "Allur",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 14.7363,
    "Long": 80.1061
  },
  {
    "Area": "Allur Mandalam",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 14.6833,
    "Long": 80.0667
  },
  {
    "Area": "Almora",
    "State": "Uttarakhand",
    "CountryCode": "IN",
    "Lat": 29.7241,
    "Long": 79.8166
  },
  {
    "Area": "Almora.",
    "State": "Uttarakhand",
    "CountryCode": "IN",
    "Lat": 29.6681,
    "Long": 79.6602
  },
  {
    "Area": "Aloosa",
    "State": "Jammu & Kashmir",
    "CountryCode": "IN",
    "Lat": 34.4383,
    "Long": 74.5575
  },
  {
    "Area": "Alot",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 23.501,
    "Long": 75.5526
  },
  {
    "Area": "Alote",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 23.6387,
    "Long": 75.4856
  },
  {
    "Area": "Alsisar",
    "State": "Rajasthan",
    "CountryCode": "IN",
    "Lat": 28.4056,
    "Long": 75.3663
  },
  {
    "Area": "Alukaranbarh",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.3836,
    "Long": 87.8747
  },
  {
    "Area": "Alund",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 17.3624,
    "Long": 76.9389
  },
  {
    "Area": "Alur",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 13.2113,
    "Long": 76.1091
  },
  {
    "Area": "Aluva",
    "State": "Kerala",
    "CountryCode": "IN",
    "Lat": 11.7352,
    "Long": 76.5333
  },
  {
    "Area": "Alwar",
    "State": "Rajasthan",
    "CountryCode": "IN",
    "Lat": 27.9669,
    "Long": 76.7983
  },
  {
    "Area": "Amabajipeta",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.5048,
    "Long": 81.6638
  },
  {
    "Area": "Amadagur",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 13.9433,
    "Long": 78.0753
  },
  {
    "Area": "Amadaguru",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 13.7896,
    "Long": 78.4924
  },
  {
    "Area": "Amadalavalasa",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 18.4049,
    "Long": 83.908
  },
  {
    "Area": "Amadalavalasa Manal",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 18.4408,
    "Long": 83.9183
  },
  {
    "Area": "Amadalavalasa Mandal",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 18.4476,
    "Long": 83.908
  },
  {
    "Area": "Amal",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 22.1406,
    "Long": 77.5606
  },
  {
    "Area": "Amalapuram",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.1292,
    "Long": 82.2643
  },
  {
    "Area": "Amalapuram Mandal",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.1885,
    "Long": 82.2643
  },
  {
    "Area": "Amalapuram.",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.1292,
    "Long": 81.9064
  },
  {
    "Area": "Amalner",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 21.2038,
    "Long": 75.4899
  },
  {
    "Area": "Amandikandi",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 23.5228,
    "Long": 88.1967
  },
  {
    "Area": "Amangal",
    "State": "Telangana",
    "CountryCode": "IN",
    "Lat": 17.4844,
    "Long": 78.8275
  },
  {
    "Area": "Amar Patan",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 24.3943,
    "Long": 80.9708
  },
  {
    "Area": "Amarapuram",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 14.1632,
    "Long": 77.0868
  },
  {
    "Area": "Amaravathi",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 16.2988,
    "Long": 80.345
  },
  {
    "Area": "Amaravati",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 20.8648,
    "Long": 77.7352
  },
  {
    "Area": "Amarawara",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 22.3337,
    "Long": 79.226
  },
  {
    "Area": "Amarda",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.8923,
    "Long": 87.3704
  },
  {
    "Area": "Amaria",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 28.7551,
    "Long": 79.9558
  },
  {
    "Area": "Amarpatan",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 24.7118,
    "Long": 81.1989
  },
  {
    "Area": "Amarpur",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.0208,
    "Long": 87.7744
  },
  {
    "Area": "Amarpur",
    "State": "Tripura",
    "CountryCode": "IN",
    "Lat": 23.5257,
    "Long": 91.6588
  },
  {
    "Area": "Amarpur",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 25.274,
    "Long": 87.4892
  },
  {
    "Area": "Amarshi",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.3836,
    "Long": 87.8747
  },
  {
    "Area": "Amarsinghi",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 25.3249,
    "Long": 87.9524
  },
  {
    "Area": "Amartaluru",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 16.2576,
    "Long": 80.9145
  },
  {
    "Area": "Amarwara",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 22.5924,
    "Long": 79.3099
  },
  {
    "Area": "Amb",
    "State": "Himachal Pradesh",
    "CountryCode": "IN",
    "Lat": 32.1818,
    "Long": 77.2597
  },
  {
    "Area": "Amb(T)",
    "State": "Himachal Pradesh",
    "CountryCode": "IN",
    "Lat": 32.1818,
    "Long": 77.2597
  },
  {
    "Area": "Amba",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 25.0549,
    "Long": 84.5756
  },
  {
    "Area": "Ambabhana",
    "State": "Odisha",
    "CountryCode": "IN",
    "Lat": 21.7195,
    "Long": 83.6375
  },
  {
    "Area": "Ambabhona",
    "State": "Odisha",
    "CountryCode": "IN",
    "Lat": 21.6758,
    "Long": 83.6112
  },
  {
    "Area": "Ambad",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 20.0314,
    "Long": 76.5642
  },
  {
    "Area": "Ambadala",
    "State": "Odisha",
    "CountryCode": "IN",
    "Lat": 19.7408,
    "Long": 83.7136
  },
  {
    "Area": "Ambagan",
    "State": "Assam",
    "CountryCode": "IN",
    "Lat": 26.5544,
    "Long": 92.4077
  },
  {
    "Area": "Ambagarh",
    "State": "Chattisgarh",
    "CountryCode": "IN",
    "Lat": 20.8515,
    "Long": 80.7107
  },
  {
    "Area": "Ambagarh Chowk",
    "State": "Chattisgarh",
    "CountryCode": "IN",
    "Lat": 20.7764,
    "Long": 80.7461
  },
  {
    "Area": "Ambagarh Chowki",
    "State": "Chattisgarh",
    "CountryCode": "IN",
    "Lat": 21.4131,
    "Long": 80.9951
  },
  {
    "Area": "Ambah",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 26.8257,
    "Long": 78.4225
  },
  {
    "Area": "Ambajgoai",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 18.9979,
    "Long": 76.6468
  },
  {
    "Area": "Ambajipeta",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.5048,
    "Long": 82.2643
  },
  {
    "Area": "Ambajipeta Mandal",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.5048,
    "Long": 82.2643
  },
  {
    "Area": "Ambajogai",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 18.9979,
    "Long": 77.531
  },
  {
    "Area": "Ambala",
    "State": "Haryana",
    "CountryCode": "IN",
    "Lat": 30.686,
    "Long": 77.4649
  },
  {
    "Area": "Ambala City",
    "State": "Haryana",
    "CountryCode": "IN",
    "Lat": 30.7987,
    "Long": 77.128
  },
  {
    "Area": "Ambala City Ho",
    "State": "Haryana",
    "CountryCode": "IN",
    "Lat": 30.5564,
    "Long": 76.9394
  },
  {
    "Area": "Ambalappuzha",
    "State": "Kerala",
    "CountryCode": "IN",
    "Lat": 9.7869,
    "Long": 76.3551
  },
  {
    "Area": "Ambalapuha",
    "State": "Kerala",
    "CountryCode": "IN",
    "Lat": 9.4333,
    "Long": 76.35
  },
  {
    "Area": "Ambalapuzh A",
    "State": "Kerala",
    "CountryCode": "IN",
    "Lat": 9.4333,
    "Long": 76.35
  },
  {
    "Area": "Ambalapuzha",
    "State": "Kerala",
    "CountryCode": "IN",
    "Lat": 10.1954,
    "Long": 76.3551
  },
  {
    "Area": "Ambarnath",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 19.9522,
    "Long": 76.5833
  },
  {
    "Area": "Ambasamudram",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 9.9393,
    "Long": 77.9962
  },
  {
    "Area": "Ambassa",
    "State": "Tripura",
    "CountryCode": "IN",
    "Lat": 23.936,
    "Long": 91.8544
  },
  {
    "Area": "Ambattur",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 13.3062,
    "Long": 80.3018
  },
  {
    "Area": "Ambedkarnagar",
    "State": "Tripura",
    "CountryCode": "IN",
    "Lat": 24.1597,
    "Long": 92.0329
  },
  {
    "Area": "Ambegaon",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 19.9443,
    "Long": 75.1632
  },
  {
    "Area": "Ambejogai",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 19.0486,
    "Long": 76.6468
  },
  {
    "Area": "Amber",
    "State": "Rajasthan",
    "CountryCode": "IN",
    "Lat": 26.8709,
    "Long": 75.893
  },
  {
    "Area": "Amberia",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.795,
    "Long": 88.1206
  },
  {
    "Area": "Amberpet",
    "State": "Telangana",
    "CountryCode": "IN",
    "Lat": 17.3939,
    "Long": 79.408
  },
  {
    "Area": "Ambikapur",
    "State": "Chattisgarh",
    "CountryCode": "IN",
    "Lat": 23.6915,
    "Long": 83.7088
  },
  {
    "Area": "Ambikapur",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 23.1303,
    "Long": 88.7566
  },
  {
    "Area": "Amda",
    "State": "Jharkhand",
    "CountryCode": "IN",
    "Lat": 22.7388,
    "Long": 85.8133
  },
  {
    "Area": "Amda",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.4364,
    "Long": 87.9624
  },
  {
    "Area": "Amdanga",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.8464,
    "Long": 88.5736
  },
  {
    "Area": "Amdobe",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 23.5022,
    "Long": 88.5404
  },
  {
    "Area": "Ameerpet",
    "State": "Telangana",
    "CountryCode": "IN",
    "Lat": 17.5902,
    "Long": 78.6668
  },
  {
    "Area": "Amer",
    "State": "Rajasthan",
    "CountryCode": "IN",
    "Lat": 27.103,
    "Long": 75.9913
  },
  {
    "Area": "Amet",
    "State": "Rajasthan",
    "CountryCode": "IN",
    "Lat": 25.5756,
    "Long": 74.1313
  },
  {
    "Area": "Amethi",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 26.3194,
    "Long": 82.398
  },
  {
    "Area": "Amgaon",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 21.4489,
    "Long": 80.4896
  },
  {
    "Area": "Amgoan",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 21.2981,
    "Long": 80.3362
  },
  {
    "Area": "Amherst Street",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.7101,
    "Long": 88.3167
  },
  {
    "Area": "Amini",
    "State": "Lakshadweep",
    "CountryCode": "IN",
    "Lat": 9.1858,
    "Long": 73.3524
  },
  {
    "Area": "Amirgadh",
    "State": "Gujarat",
    "CountryCode": "IN",
    "Lat": 24.256,
    "Long": 72.7055
  },
  {
    "Area": "Amla",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 22.1812,
    "Long": 78.3936
  },
  {
    "Area": "Amlarem",
    "State": "Meghalaya",
    "CountryCode": "IN",
    "Lat": 25.1837,
    "Long": 92.0244
  },
  {
    "Area": "Amloh (P)",
    "State": "Punjab",
    "CountryCode": "IN",
    "Lat": 30.6594,
    "Long": 76.3539
  },
  {
    "Area": "Ammalladinne",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 14.8742,
    "Long": 78.1082
  },
  {
    "Area": "Amnagal",
    "State": "Telangana",
    "CountryCode": "IN",
    "Lat": 17.4844,
    "Long": 78.5343
  },
  {
    "Area": "Amnour",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 25.8794,
    "Long": 84.8189
  },
  {
    "Area": "Amod",
    "State": "Gujarat",
    "CountryCode": "IN",
    "Lat": 23.2244,
    "Long": 73.4541
  },
  {
    "Area": "Amodpur",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.6389,
    "Long": 88.746
  },
  {
    "Area": "Amour",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 26.2843,
    "Long": 80.3637
  },
  {
    "Area": "Ampati",
    "State": "Meghalaya",
    "CountryCode": "IN",
    "Lat": 25.4623,
    "Long": 89.9333
  },
  {
    "Area": "Ampi",
    "State": "Tripura",
    "CountryCode": "IN",
    "Lat": 23.5257,
    "Long": 91.6588
  },
  {
    "Area": "Amrabad",
    "State": "Telangana",
    "CountryCode": "IN",
    "Lat": 17.2085,
    "Long": 79.1368
  },
  {
    "Area": "Amrapara",
    "State": "Jharkhand",
    "CountryCode": "IN",
    "Lat": 24.6254,
    "Long": 87.656
  },
  {
    "Area": "Amraudha",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 26.2309,
    "Long": 79.8477
  },
  {
    "Area": "Amreli",
    "State": "Gujarat",
    "CountryCode": "IN",
    "Lat": 23.5172,
    "Long": 74.002
  },
  {
    "Area": "Amritsar",
    "State": "Punjab",
    "CountryCode": "IN",
    "Lat": 31.9954,
    "Long": 75.8226
  },
  {
    "Area": "Amritsar -I",
    "State": "Punjab",
    "CountryCode": "IN",
    "Lat": 31.8029,
    "Long": 75.8226
  },
  {
    "Area": "Amritsar- II",
    "State": "Punjab",
    "CountryCode": "IN",
    "Lat": 31.7677,
    "Long": 75.1383
  },
  {
    "Area": "Amroha",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 29.0488,
    "Long": 78.6587
  },
  {
    "Area": "Amta",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.4653,
    "Long": 88.7803
  },
  {
    "Area": "Amta - II",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 23.2168,
    "Long": 87.9004
  },
  {
    "Area": "Amtalia",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.4305,
    "Long": 87.4447
  },
  {
    "Area": "Amudia",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 23.1406,
    "Long": 88.5427
  },
  {
    "Area": "Anadapur",
    "State": "Odisha",
    "CountryCode": "IN",
    "Lat": 20.8939,
    "Long": 85.4145
  },
  {
    "Area": "Anakapalle",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 18.1752,
    "Long": 83.7157
  },
  {
    "Area": "Analberia",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 24.3444,
    "Long": 87.9089
  },
  {
    "Area": "Ananatasagaram",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 14.5455,
    "Long": 79.4769
  },
  {
    "Area": "Anand",
    "State": "Gujarat",
    "CountryCode": "IN",
    "Lat": 24.1655,
    "Long": 74.1142
  },
  {
    "Area": "Anand Nagar",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 26.5934,
    "Long": 80.6879
  },
  {
    "Area": "Anandabazar",
    "State": "Tripura",
    "CountryCode": "IN",
    "Lat": 23.9923,
    "Long": 91.6205
  },
  {
    "Area": "Anandapur",
    "State": "Tripura",
    "CountryCode": "IN",
    "Lat": 23.2518,
    "Long": 91.4541
  },
  {
    "Area": "Anandapur",
    "State": "Odisha",
    "CountryCode": "IN",
    "Lat": 21.9913,
    "Long": 86.1536
  },
  {
    "Area": "Anandapuram",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.7878,
    "Long": 83.2176
  },
  {
    "Area": "Anandpur Sahib",
    "State": "Punjab",
    "CountryCode": "IN",
    "Lat": 31.3897,
    "Long": 76.6315
  },
  {
    "Area": "Anantapur",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 15.1449,
    "Long": 78.3626
  },
  {
    "Area": "Anantasagaram",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 14.8814,
    "Long": 80.0201
  },
  {
    "Area": "Anantavaram",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 16.546,
    "Long": 80.0943
  },
  {
    "Area": "Ananthagiri",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 18.4261,
    "Long": 83.0432
  },
  {
    "Area": "Ananthnag",
    "State": "Jammu & Kashmir",
    "CountryCode": "IN",
    "Lat": 33.8312,
    "Long": 75.3407
  },
  {
    "Area": "Anantnag",
    "State": "Jammu & Kashmir",
    "CountryCode": "IN",
    "Lat": 34.0397,
    "Long": 75.1966
  },
  {
    "Area": "Anantnag Ho",
    "State": "Jammu & Kashmir",
    "CountryCode": "IN",
    "Lat": 33.7392,
    "Long": 75.147
  },
  {
    "Area": "Anaparthy",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.1881,
    "Long": 82.2257
  },
  {
    "Area": "Anapur",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 25.5849,
    "Long": 82.703
  },
  {
    "Area": "Anara",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 23.4194,
    "Long": 86.6102
  },
  {
    "Area": "Anara Rs",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 23.4194,
    "Long": 86.6102
  },
  {
    "Area": "Anathagiri",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 18.2236,
    "Long": 82.9875
  },
  {
    "Area": "Andal",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 23.9614,
    "Long": 87.8981
  },
  {
    "Area": "Andar",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 26.1024,
    "Long": 84.295
  },
  {
    "Area": "Andhari",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.164,
    "Long": 87.0901
  },
  {
    "Area": "Andhari Maubhandar",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.164,
    "Long": 87.0901
  },
  {
    "Area": "Andhirampara",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 25.3249,
    "Long": 87.9524
  },
  {
    "Area": "Andhratharhi",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 26.4296,
    "Long": 86.3612
  },
  {
    "Area": "Andipatti",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 10.0415,
    "Long": 77.7329
  },
  {
    "Area": "Andnapur",
    "State": "Odisha",
    "CountryCode": "IN",
    "Lat": 21.5371,
    "Long": 85.7051
  },
  {
    "Area": "Andole",
    "State": "Telangana",
    "CountryCode": "IN",
    "Lat": 17.7732,
    "Long": 78.0507
  },
  {
    "Area": "Andul-Mouri,Howrah",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 23.2934,
    "Long": 88.0202
  },
  {
    "Area": "Anekal",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 13.2257,
    "Long": 77.7953
  },
  {
    "Area": "Anemadugu",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 15.1092,
    "Long": 80.0267
  },
  {
    "Area": "Angalakudur",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 16.0544,
    "Long": 80.3204
  },
  {
    "Area": "Angara",
    "State": "Jharkhand",
    "CountryCode": "IN",
    "Lat": 23.4455,
    "Long": 85.6078
  },
  {
    "Area": "Angardhowa",
    "State": "Assam",
    "CountryCode": "IN",
    "Lat": 26.4211,
    "Long": 91.7374
  },
  {
    "Area": "Angarkata",
    "State": "Assam",
    "CountryCode": "IN",
    "Lat": 26.7306,
    "Long": 91.5564
  },
  {
    "Area": "Angrail",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 23.0762,
    "Long": 88.8272
  },
  {
    "Area": "Angua",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.6315,
    "Long": 87.428
  },
  {
    "Area": "Angul",
    "State": "Odisha",
    "CountryCode": "IN",
    "Lat": 21.4328,
    "Long": 85.8799
  },
  {
    "Area": "Ani(S.T)",
    "State": "Himachal Pradesh",
    "CountryCode": "IN",
    "Lat": 31.9045,
    "Long": 77.4354
  },
  {
    "Area": "Anikola",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.3836,
    "Long": 87.8747
  },
  {
    "Area": "Anini",
    "State": "Arunachal Pradesh",
    "CountryCode": "IN",
    "Lat": 28.9513,
    "Long": 95.9028
  },
  {
    "Area": "Anjad",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 22.0417,
    "Long": 75.0552
  },
  {
    "Area": "Anjangaon",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 21.1652,
    "Long": 77.3768
  },
  {
    "Area": "Anjar",
    "State": "Gujarat",
    "CountryCode": "IN",
    "Lat": 23.6285,
    "Long": 70.4091
  },
  {
    "Area": "Anklav",
    "State": "Gujarat",
    "CountryCode": "IN",
    "Lat": 22.6045,
    "Long": 73.0503
  },
  {
    "Area": "Ankleshwar",
    "State": "Gujarat",
    "CountryCode": "IN",
    "Lat": 21.7667,
    "Long": 73.1833
  },
  {
    "Area": "Anklesvar",
    "State": "Gujarat",
    "CountryCode": "IN",
    "Lat": 22.3913,
    "Long": 73.5464
  },
  {
    "Area": "Ankola",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 14.7333,
    "Long": 74.8009
  },
  {
    "Area": "Annavasal",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 10.4342,
    "Long": 78.7424
  },
  {
    "Area": "Anni",
    "State": "Himachal Pradesh",
    "CountryCode": "IN",
    "Lat": 31.4632,
    "Long": 77.4713
  },
  {
    "Area": "Annuppura",
    "State": "Rajasthan",
    "CountryCode": "IN",
    "Lat": 25.3221,
    "Long": 74.8175
  },
  {
    "Area": "Annur",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 11.2444,
    "Long": 77.5695
  },
  {
    "Area": "Anoop Shahr",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 28.4538,
    "Long": 78.2359
  },
  {
    "Area": "Anoopgarh",
    "State": "Rajasthan",
    "CountryCode": "IN",
    "Lat": 28.4771,
    "Long": 74.1443
  },
  {
    "Area": "Anoup  Shaher",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 28.3237,
    "Long": 78.2404
  },
  {
    "Area": "Antagarh",
    "State": "Chattisgarh",
    "CountryCode": "IN",
    "Lat": 20.4886,
    "Long": 81.4283
  },
  {
    "Area": "Anugul",
    "State": "Odisha",
    "CountryCode": "IN",
    "Lat": 21.1745,
    "Long": 85.1397
  },
  {
    "Area": "Anumasamudrampeta Mandal",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 15.3506,
    "Long": 78.8318
  },
  {
    "Area": "Anumula",
    "State": "Telangana",
    "CountryCode": "IN",
    "Lat": 17.3225,
    "Long": 79.3039
  },
  {
    "Area": "Anupgarh",
    "State": "Rajasthan",
    "CountryCode": "IN",
    "Lat": 29.7491,
    "Long": 75.5395
  },
  {
    "Area": "Anuppur",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 23.9491,
    "Long": 81.9061
  },
  {
    "Area": "Anupshaher",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 28.515,
    "Long": 78.2465
  },
  {
    "Area": "Anupshahr",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 28.5294,
    "Long": 78.2841
  },
  {
    "Area": "Anupshashr",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 28.3734,
    "Long": 78.0448
  },
  {
    "Area": "Anupshhar",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 28.5009,
    "Long": 78.0962
  },
  {
    "Area": "Anwarganj",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 26.3805,
    "Long": 81.3448
  },
  {
    "Area": "Aonla",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 28.5447,
    "Long": 79.8632
  },
  {
    "Area": "Appikatla",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 15.9748,
    "Long": 80.5099
  },
  {
    "Area": "Apspqrs",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.9817,
    "Long": 82.8311
  },
  {
    "Area": "Araimile",
    "State": "Meghalaya",
    "CountryCode": "IN",
    "Lat": 25.5545,
    "Long": 90.3369
  },
  {
    "Area": "Araira",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 26.14,
    "Long": 87.0761
  },
  {
    "Area": "Arakalagud",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 12.6485,
    "Long": 76.1992
  },
  {
    "Area": "Arakkonam",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 13.1675,
    "Long": 79.7734
  },
  {
    "Area": "Arakonam",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 13.0947,
    "Long": 79.692
  },
  {
    "Area": "Araku",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 18.3767,
    "Long": 83.0001
  },
  {
    "Area": "Araku Valley",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 18.3767,
    "Long": 83.0001
  },
  {
    "Area": "Arambag",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.6703,
    "Long": 88.4803
  },
  {
    "Area": "Arambagh",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 23.4607,
    "Long": 88.5162
  },
  {
    "Area": "Aranangi",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 10.5789,
    "Long": 79.3245
  },
  {
    "Area": "Arang",
    "State": "Chattisgarh",
    "CountryCode": "IN",
    "Lat": 21.3779,
    "Long": 82.174
  },
  {
    "Area": "Arani",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 12.7255,
    "Long": 79.3112
  },
  {
    "Area": "Aranjhami",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 26.2843,
    "Long": 80.3637
  },
  {
    "Area": "Arankiarana",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.661,
    "Long": 88.7265
  },
  {
    "Area": "Arantangi",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 10.5789,
    "Long": 79.3245
  },
  {
    "Area": "Aranthangi",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 10.2863,
    "Long": 79.2314
  },
  {
    "Area": "Araon",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 27.163,
    "Long": 78.7495
  },
  {
    "Area": "Araraia",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 25.9499,
    "Long": 87.0413
  },
  {
    "Area": "Araria",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 26.4569,
    "Long": 87.8605
  },
  {
    "Area": "Araria Rs",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 26.03,
    "Long": 87.2742
  },
  {
    "Area": "Aratangi",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 10.0411,
    "Long": 78.9235
  },
  {
    "Area": "Arath",
    "State": "Jammu & Kashmir",
    "CountryCode": "IN",
    "Lat": 33.9245,
    "Long": 74.6725
  },
  {
    "Area": "Aravakurichi",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 11.0258,
    "Long": 78.1331
  },
  {
    "Area": "Arcot",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 13.0269,
    "Long": 79.4733
  },
  {
    "Area": "Ardhapur",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 19.8137,
    "Long": 78.1911
  },
  {
    "Area": "Ardhaveedu",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 15.7017,
    "Long": 78.9538
  },
  {
    "Area": "Areraj",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 26.965,
    "Long": 84.9247
  },
  {
    "Area": "Argoal",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 21.9694,
    "Long": 87.634
  },
  {
    "Area": "Argora",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 23.8386,
    "Long": 88.171
  },
  {
    "Area": "Arikuchi",
    "State": "Assam",
    "CountryCode": "IN",
    "Lat": 26.3796,
    "Long": 91.2951
  },
  {
    "Area": "Aripal",
    "State": "Jammu & Kashmir",
    "CountryCode": "IN",
    "Lat": 33.9306,
    "Long": 75.1134
  },
  {
    "Area": "Ariyalur",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 11.357,
    "Long": 79.39
  },
  {
    "Area": "Ariyari",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 25.1319,
    "Long": 85.891
  },
  {
    "Area": "Arjun Nagar",
    "State": "Haryana",
    "CountryCode": "IN",
    "Lat": 28.418,
    "Long": 76.9839
  },
  {
    "Area": "Arjuni Morgaon",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 20.9122,
    "Long": 80.17
  },
  {
    "Area": "Arjunnagar",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 21.9837,
    "Long": 87.635
  },
  {
    "Area": "Arkalagud",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 12.5962,
    "Long": 76.1231
  },
  {
    "Area": "Arkalgud",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 13.2022,
    "Long": 76.4697
  },
  {
    "Area": "Arkalud",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 12.9954,
    "Long": 76.1091
  },
  {
    "Area": "Arki",
    "State": "Himachal Pradesh",
    "CountryCode": "IN",
    "Lat": 31.2838,
    "Long": 77.2256
  },
  {
    "Area": "Armapur",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 26.5167,
    "Long": 80.3155
  },
  {
    "Area": "Armoor",
    "State": "Telangana",
    "CountryCode": "IN",
    "Lat": 18.9741,
    "Long": 78.919
  },
  {
    "Area": "Armori",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 20.5547,
    "Long": 80.2411
  },
  {
    "Area": "Armur",
    "State": "Telangana",
    "CountryCode": "IN",
    "Lat": 18.7584,
    "Long": 78.2436
  },
  {
    "Area": "Arni",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 12.7747,
    "Long": 79.7085
  },
  {
    "Area": "Arni",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 20.2286,
    "Long": 78.7471
  },
  {
    "Area": "Arnod",
    "State": "Rajasthan",
    "CountryCode": "IN",
    "Lat": 25.189,
    "Long": 75.7459
  },
  {
    "Area": "Aroun",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 24.5546,
    "Long": 77.5222
  },
  {
    "Area": "Arrah",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 25.7958,
    "Long": 84.8549
  },
  {
    "Area": "Arraia",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 26.14,
    "Long": 87.0761
  },
  {
    "Area": "Arsha",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 23.4386,
    "Long": 86.5939
  },
  {
    "Area": "Arsiekre",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 13.3975,
    "Long": 76.3451
  },
  {
    "Area": "Arsikere",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 13.5159,
    "Long": 76.4565
  },
  {
    "Area": "Arsikre",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 13.4827,
    "Long": 76.352
  },
  {
    "Area": "Arskiere",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 13.3036,
    "Long": 76.3493
  },
  {
    "Area": "Artc",
    "State": "Nagaland",
    "CountryCode": "IN",
    "Lat": 25.9288,
    "Long": 94.3486
  },
  {
    "Area": "Arugonda",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 14.1932,
    "Long": 79.0656
  },
  {
    "Area": "Aruppukkottai",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 9.5287,
    "Long": 78.219
  },
  {
    "Area": "Aruppukottai",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 9.5287,
    "Long": 78.2914
  },
  {
    "Area": "Arvapally",
    "State": "Telangana",
    "CountryCode": "IN",
    "Lat": 17.674,
    "Long": 79.6529
  },
  {
    "Area": "Arvi",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 21.1825,
    "Long": 78.5876
  },
  {
    "Area": "Arwal",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 25.2428,
    "Long": 85.1444
  },
  {
    "Area": "Arya Nagar",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 26.5167,
    "Long": 80.3155
  },
  {
    "Area": "Asansol MC",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 24.1034,
    "Long": 87.8777
  },
  {
    "Area": "Asarganj",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 25.1505,
    "Long": 86.6864
  },
  {
    "Area": "Asda",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.3564,
    "Long": 87.8021
  },
  {
    "Area": "Asfjalpur",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 17.1507,
    "Long": 76.608
  },
  {
    "Area": "Asharambari",
    "State": "Tripura",
    "CountryCode": "IN",
    "Lat": 24.0796,
    "Long": 91.5997
  },
  {
    "Area": "Asharu",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 23.5022,
    "Long": 88.5404
  },
  {
    "Area": "Ashok Nagar",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 24.5528,
    "Long": 77.9975
  },
  {
    "Area": "Ashok Nagar",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 27.0884,
    "Long": 81.7153
  },
  {
    "Area": "Ashoknagar",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 24.8218,
    "Long": 78.0084
  },
  {
    "Area": "Ashta",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 24.1101,
    "Long": 77.1285
  },
  {
    "Area": "Ashtawan",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 25.2208,
    "Long": 85.4559
  },
  {
    "Area": "Ashthwan",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 25.4276,
    "Long": 86.1703
  },
  {
    "Area": "Ashti",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 21.3079,
    "Long": 78.5876
  },
  {
    "Area": "Asifabad",
    "State": "Telangana",
    "CountryCode": "IN",
    "Lat": 19.7381,
    "Long": 79.6667
  },
  {
    "Area": "Asifnagar",
    "State": "Telangana",
    "CountryCode": "IN",
    "Lat": 17.3991,
    "Long": 78.462
  },
  {
    "Area": "Asika",
    "State": "Odisha",
    "CountryCode": "IN",
    "Lat": 20.0969,
    "Long": 84.7939
  },
  {
    "Area": "Aska",
    "State": "Odisha",
    "CountryCode": "IN",
    "Lat": 20.8372,
    "Long": 85.1448
  },
  {
    "Area": "Asop",
    "State": "Rajasthan",
    "CountryCode": "IN",
    "Lat": 26.8292,
    "Long": 73.5195
  },
  {
    "Area": "Aspur",
    "State": "Rajasthan",
    "CountryCode": "IN",
    "Lat": 26.9805,
    "Long": 75.7243
  },
  {
    "Area": "Assandh",
    "State": "Haryana",
    "CountryCode": "IN",
    "Lat": 29.6316,
    "Long": 76.8496
  },
  {
    "Area": "Astarang",
    "State": "Odisha",
    "CountryCode": "IN",
    "Lat": 20.3205,
    "Long": 86.2701
  },
  {
    "Area": "Asthama",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 25.2773,
    "Long": 85.6882
  },
  {
    "Area": "Asthawan",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 25.4407,
    "Long": 86.1703
  },
  {
    "Area": "Astichak",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.3159,
    "Long": 88.0212
  },
  {
    "Area": "Aswapuram",
    "State": "Telangana",
    "CountryCode": "IN",
    "Lat": 18.1928,
    "Long": 80.7933
  },
  {
    "Area": "Aswaraopet",
    "State": "Telangana",
    "CountryCode": "IN",
    "Lat": 17.4551,
    "Long": 81.1285
  },
  {
    "Area": "Aswaraopeta",
    "State": "Telangana",
    "CountryCode": "IN",
    "Lat": 17.3193,
    "Long": 80.968
  },
  {
    "Area": "Aswathapur",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.2088,
    "Long": 88.0387
  },
  {
    "Area": "Aswini Nagar",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.7807,
    "Long": 88.3001
  },
  {
    "Area": "Atapur",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.3484,
    "Long": 88.8997
  },
  {
    "Area": "Atbati",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.3159,
    "Long": 88.0212
  },
  {
    "Area": "Atchampet",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 16.6489,
    "Long": 80.131
  },
  {
    "Area": "Atchanta (mdl)",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 16.3905,
    "Long": 81.2707
  },
  {
    "Area": "Atchutapuram",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.5469,
    "Long": 82.8395
  },
  {
    "Area": "Ater",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 26.7353,
    "Long": 78.79
  },
  {
    "Area": "Atghara",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.7969,
    "Long": 88.7759
  },
  {
    "Area": "Athagad",
    "State": "Odisha",
    "CountryCode": "IN",
    "Lat": 21.1341,
    "Long": 85.7057
  },
  {
    "Area": "Athagarh",
    "State": "Odisha",
    "CountryCode": "IN",
    "Lat": 21.1341,
    "Long": 85.7057
  },
  {
    "Area": "Athamallik",
    "State": "Odisha",
    "CountryCode": "IN",
    "Lat": 21.0542,
    "Long": 85.085
  },
  {
    "Area": "Athani",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 16.889,
    "Long": 75.3964
  },
  {
    "Area": "Athmalgola",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 25.4604,
    "Long": 85.6968
  },
  {
    "Area": "Athmallik",
    "State": "Odisha",
    "CountryCode": "IN",
    "Lat": 20.7444,
    "Long": 84.6287
  },
  {
    "Area": "Athni",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 17.0606,
    "Long": 75.6057
  },
  {
    "Area": "Athpur",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.8347,
    "Long": 88.4655
  },
  {
    "Area": "Atlur",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 14.5889,
    "Long": 79.0993
  },
  {
    "Area": "Atmakur",
    "State": "Telangana",
    "CountryCode": "IN",
    "Lat": 18.1427,
    "Long": 79.7992
  },
  {
    "Area": "Atmakur",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 15.5871,
    "Long": 80.06
  },
  {
    "Area": "Atmakur Mandall",
    "State": "Telangana",
    "CountryCode": "IN",
    "Lat": 18.1427,
    "Long": 79.4385
  },
  {
    "Area": "Atmakur(nl)",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 14.6738,
    "Long": 79.7462
  },
  {
    "Area": "Atoizu",
    "State": "Nagaland",
    "CountryCode": "IN",
    "Lat": 26.0213,
    "Long": 94.528
  },
  {
    "Area": "Ator Nagla",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 28.7416,
    "Long": 77.4102
  },
  {
    "Area": "Atpadi",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 18.2081,
    "Long": 75.5649
  },
  {
    "Area": "Atpukur",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.4784,
    "Long": 88.5822
  },
  {
    "Area": "Atrampur",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 25.5975,
    "Long": 82.2374
  },
  {
    "Area": "Atrauli",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 27.9824,
    "Long": 78.3122
  },
  {
    "Area": "Atreyapuram",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.4008,
    "Long": 82.3102
  },
  {
    "Area": "Atreyapuram Mandal",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.4008,
    "Long": 82.3102
  },
  {
    "Area": "Atreypauram",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 16.936,
    "Long": 81.8973
  },
  {
    "Area": "Atri",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 25.238,
    "Long": 85.458
  },
  {
    "Area": "Attabira",
    "State": "Odisha",
    "CountryCode": "IN",
    "Lat": 21.4505,
    "Long": 83.8653
  },
  {
    "Area": "Attair",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 26.7579,
    "Long": 78.7324
  },
  {
    "Area": "Attari",
    "State": "Punjab",
    "CountryCode": "IN",
    "Lat": 31.6659,
    "Long": 74.6314
  },
  {
    "Area": "Atterikhat",
    "State": "Assam",
    "CountryCode": "IN",
    "Lat": 26.6138,
    "Long": 92.0365
  },
  {
    "Area": "Attili (mdl)",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 16.8946,
    "Long": 81.6667
  },
  {
    "Area": "Attur",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 12.0509,
    "Long": 79.7159
  },
  {
    "Area": "Atur",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 12.0509,
    "Long": 79.774
  },
  {
    "Area": "Aturia",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.4653,
    "Long": 88.7803
  },
  {
    "Area": "Auad (b)",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 18.3015,
    "Long": 77.4366
  },
  {
    "Area": "Auarad (b)",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 17.3703,
    "Long": 76.8318
  },
  {
    "Area": "Aukiripalli",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 17.3619,
    "Long": 82.0551
  },
  {
    "Area": "Aul",
    "State": "Odisha",
    "CountryCode": "IN",
    "Lat": 21.1011,
    "Long": 86.6481
  },
  {
    "Area": "Aundha Nagnath",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 19.6152,
    "Long": 77.1544
  },
  {
    "Area": "Aundipatti",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 10.0415,
    "Long": 77.7329
  },
  {
    "Area": "Aurad",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 18.1391,
    "Long": 77.5181
  },
  {
    "Area": "Aurad (b)",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 18.4252,
    "Long": 77.5714
  },
  {
    "Area": "Aurad(b)",
    "State": "Karnataka",
    "CountryCode": "IN",
    "Lat": 18.3015,
    "Long": 77.5417
  },
  {
    "Area": "Aurai",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 22.4305,
    "Long": 87.4447
  },
  {
    "Area": "Aurai",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 26.1511,
    "Long": 85.3308
  },
  {
    "Area": "Auraiy",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 26.2657,
    "Long": 79.1594
  },
  {
    "Area": "Auraiya",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 26.8156,
    "Long": 80.1331
  },
  {
    "Area": "Aurangabad",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 20.7418,
    "Long": 76.4428
  },
  {
    "Area": "Aurangabad",
    "State": "Bihar",
    "CountryCode": "IN",
    "Lat": 24.8741,
    "Long": 84.4425
  },
  {
    "Area": "Aurangabad Ristal",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 28.7594,
    "Long": 77.365
  },
  {
    "Area": "Ausa",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 18.3605,
    "Long": 76.7751
  },
  {
    "Area": "Ausgram - I",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 23.7617,
    "Long": 87.979
  },
  {
    "Area": "Ausgram - II",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 24.0243,
    "Long": 87.7017
  },
  {
    "Area": "Aushgram",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 23.7617,
    "Long": 87.979
  },
  {
    "Area": "Aut",
    "State": "Himachal Pradesh",
    "CountryCode": "IN",
    "Lat": 31.6383,
    "Long": 76.9929
  },
  {
    "Area": "Aut(S.T)",
    "State": "Himachal Pradesh",
    "CountryCode": "IN",
    "Lat": 31.6221,
    "Long": 77.2746
  },
  {
    "Area": "Avadaiyarkoil",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 10.4315,
    "Long": 79.2314
  },
  {
    "Area": "Avadi",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 13.158,
    "Long": 80.1063
  },
  {
    "Area": "Avanashi",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 12.9042,
    "Long": 78.7984
  },
  {
    "Area": "Avanigadda",
    "State": "Andhra Pradesh",
    "CountryCode": "IN",
    "Lat": 16.3693,
    "Long": 81.0694
  },
  {
    "Area": "Avas Vikas Yojna No. 3",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 26.5666,
    "Long": 80.9724
  },
  {
    "Area": "Avudayarkoil",
    "State": "Tamil Nadu",
    "CountryCode": "IN",
    "Lat": 10.4315,
    "Long": 79.2314
  },
  {
    "Area": "Awantipora",
    "State": "Jammu & Kashmir",
    "CountryCode": "IN",
    "Lat": 33.9942,
    "Long": 74.9835
  },
  {
    "Area": "Awantipur Barodiya",
    "State": "Madhya Pradesh",
    "CountryCode": "IN",
    "Lat": 23.1906,
    "Long": 76.6055
  },
  {
    "Area": "Awaraopet",
    "State": "Telangana",
    "CountryCode": "IN",
    "Lat": 17.1891,
    "Long": 80.581
  },
  {
    "Area": "Awenura",
    "State": "Jammu & Kashmir",
    "CountryCode": "IN",
    "Lat": 33.9563,
    "Long": 74.834
  },
  {
    "Area": "Ayma Barbaria",
    "State": "West Bengal",
    "CountryCode": "IN",
    "Lat": 23.8386,
    "Long": 88.171
  },
  {
    "Area": "Azadnagar",
    "State": "Jharkhand",
    "CountryCode": "IN",
    "Lat": 22.9195,
    "Long": 85.7645
  },
  {
    "Area": "Azamabad Mukhota",
    "State": "Haryana",
    "CountryCode": "IN",
    "Lat": 28.0799,
    "Long": 76.0612
  },
  {
    "Area": "Azamgarh",
    "State": "Uttar Pradesh",
    "CountryCode": "IN",
    "Lat": 26.8355,
    "Long": 83.6394
  },
  {
    "Area": "amravati",
    "State": "Maharashtra",
    "CountryCode": "IN",
    "Lat": 21.1878,
    "Long": 78.1087
  },
  {
    "Area": "Aalborg",
    "Lat": "57.0337",
    "Long": "9.9166",
    "CountryCode": "DK"
  },
  {
    "Area": "Aba",
    "Lat": "5.1004",
    "Long": "7.35",
    "CountryCode": "NG"
  },
  {
    "Area": "Abadan",
    "Lat": "30.3307",
    "Long": "48.2797",
    "CountryCode": "IR"
  },
  {
    "Area": "Abaetetuba",
    "Lat": "-1.7245",
    "Long": "-48.8849",
    "CountryCode": "BR"
  },
  {
    "Area": "Abakan",
    "Lat": "53.7037",
    "Long": "91.445",
    "CountryCode": "RU"
  },
  {
    "Area": "Abancay",
    "Lat": "-13.6396",
    "Long": "-72.89",
    "CountryCode": "PE"
  },
  {
    "Area": "Abbotsford",
    "Lat": "49.0504",
    "Long": "-122.3",
    "CountryCode": "CA"
  },
  {
    "Area": "Abbottabad",
    "Lat": "34.1495",
    "Long": "73.1995",
    "CountryCode": "PK"
  },
  {
    "Area": "Abéché",
    "Lat": "13.84",
    "Long": "20.83",
    "CountryCode": "TD"
  },
  {
    "Area": "Abengourou",
    "Lat": "6.7304",
    "Long": "-3.49",
    "CountryCode": "CL"
  },
  {
    "Area": "Abeokuta",
    "Lat": "7.1604",
    "Long": "3.35",
    "CountryCode": "NG"
  },
  {
    "Area": "Aberdeen",
    "Lat": "57.1704",
    "Long": "-2.08",
    "CountryCode": "GB"
  },
  {
    "Area": "Abha",
    "Lat": "18.2301",
    "Long": "42.5001",
    "CountryCode": "SA"
  },
  {
    "Area": "Abidjan",
    "Lat": "5.32",
    "Long": "-4.04",
    "CountryCode": "CL"
  },
  {
    "Area": "Abilene",
    "Lat": "32.4543",
    "Long": "-99.7384",
    "CountryCode": "US"
  },
  {
    "Area": "Abomey",
    "Lat": "7.1904",
    "Long": "1.99",
    "CountryCode": "BJ"
  },
  {
    "Area": "Abu Dhabi",
    "Lat": "24.4667",
    "Long": "54.3666",
    "CountryCode": "AE"
  },
  {
    "Area": "Abu Kamal",
    "Lat": "34.4504",
    "Long": "40.9186",
    "CountryCode": "SY"
  },
  {
    "Area": "Abuja",
    "Lat": "9.0833",
    "Long": "7.5333",
    "CountryCode": "NG"
  },
  {
    "Area": "Acapulco",
    "Lat": "16.85",
    "Long": "-99.916",
    "CountryCode": "MX"
  },
  {
    "Area": "Acarigua",
    "Lat": "9.5804",
    "Long": "-69.2",
    "CountryCode": "VE"
  },
  {
    "Area": "Accra",
    "Lat": "5.55",
    "Long": "-0.2167",
    "CountryCode": "GH"
  },
  {
    "Area": "Achinsk",
    "Lat": "56.27",
    "Long": "90.5",
    "CountryCode": "RU"
  },
  {
    "Area": "Ad Damazīn",
    "Lat": "11.7704",
    "Long": "34.35",
    "CountryCode": "SD"
  },
  {
    "Area": "Ad Damman",
    "Lat": "26.4282",
    "Long": "50.0997",
    "CountryCode": "SA"
  },
  {
    "Area": "Ad Diwaniyah",
    "Lat": "31.9889",
    "Long": "44.924",
    "CountryCode": "IQ"
  },
  {
    "Area": "Ad Nabk",
    "Lat": "34.017",
    "Long": "36.7333",
    "CountryCode": "SY"
  },
  {
    "Area": "Adana",
    "Lat": "36.995",
    "Long": "35.32",
    "CountryCode": "TR"
  },
  {
    "Area": "Adapazarı",
    "Lat": "40.8",
    "Long": "30.415",
    "CountryCode": "TR"
  },
  {
    "Area": "Addis Ababa",
    "Lat": "9.0333",
    "Long": "38.7",
    "CountryCode": "ET"
  },
  {
    "Area": "Adelaide",
    "Lat": "-34.935",
    "Long": "138.6",
    "CountryCode": "AU"
  },
  {
    "Area": "Aden",
    "Lat": "12.7797",
    "Long": "45.0095",
    "CountryCode": "YE"
  },
  {
    "Area": "Adigrat",
    "Lat": "14.2804",
    "Long": "39.47",
    "CountryCode": "ET"
  },
  {
    "Area": "Adıyaman",
    "Lat": "37.7704",
    "Long": "38.2799",
    "CountryCode": "TR"
  },
  {
    "Area": "Ado Ekiti",
    "Lat": "7.6304",
    "Long": "5.22",
    "CountryCode": "NG"
  },
  {
    "Area": "Adrar",
    "Lat": "27.87",
    "Long": "-0.29",
    "CountryCode": "DZ"
  },
  {
    "Area": "Afyon",
    "Lat": "38.7504",
    "Long": "30.55",
    "CountryCode": "TR"
  },
  {
    "Area": "Agadez",
    "Lat": "16.9959",
    "Long": "7.9828",
    "CountryCode": "NE"
  },
  {
    "Area": "Agadir",
    "Lat": "30.44",
    "Long": "-9.62",
    "CountryCode": "MA"
  },
  {
    "Area": "Agboville",
    "Lat": "5.9403",
    "Long": "-4.28",
    "CountryCode": "CL"
  },
  {
    "Area": "Agen",
    "Lat": "44.2004",
    "Long": "0.6333",
    "CountryCode": "FR"
  },
  {
    "Area": "Agrinio",
    "Lat": "38.6218",
    "Long": "21.4077",
    "CountryCode": "GR"
  },
  {
    "Area": "Ağrı",
    "Lat": "39.7198",
    "Long": "43.0513",
    "CountryCode": "TR"
  },
  {
    "Area": "Agua Prieta",
    "Lat": "31.3223",
    "Long": "-109.563",
    "CountryCode": "MX"
  },
  {
    "Area": "Aguascalientes",
    "Lat": "21.8795",
    "Long": "-102.2904",
    "CountryCode": "MX"
  },
  {
    "Area": "Ahar",
    "Lat": "38.4829",
    "Long": "47.0629",
    "CountryCode": "IR"
  },
  {
    "Area": "Ahvaz",
    "Lat": "31.28",
    "Long": "48.72",
    "CountryCode": "IR"
  },
  {
    "Area": "Aix-en-Provence",
    "Lat": "43.52",
    "Long": "5.45",
    "CountryCode": "FR"
  },
  {
    "Area": "Ajaccio",
    "Lat": "41.9271",
    "Long": "8.7283",
    "CountryCode": "FR"
  },
  {
    "Area": "Ajdabiya",
    "Lat": "30.77",
    "Long": "20.22",
    "CountryCode": "LY"
  },
  {
    "Area": "Aketi",
    "Lat": "2.7405",
    "Long": "23.78",
    "CountryCode": "CD"
  },
  {
    "Area": "Akita",
    "Lat": "39.71",
    "Long": "140.09",
    "CountryCode": "JP"
  },
  {
    "Area": "Akron",
    "Lat": "41.0802",
    "Long": "-81.5219",
    "CountryCode": "US"
  },
  {
    "Area": "Aksu",
    "Lat": "41.15",
    "Long": "80.25",
    "CountryCode": "CN"
  },
  {
    "Area": "Akure",
    "Lat": "7.2504",
    "Long": "5.2",
    "CountryCode": "NG"
  },
  {
    "Area": "Al Ahmadi",
    "Lat": "29.0769",
    "Long": "48.0838",
    "CountryCode": "KW"
  },
  {
    "Area": "Al Amarah",
    "Lat": "31.8416",
    "Long": "47.1512",
    "CountryCode": "IQ"
  },
  {
    "Area": "Al Aqabah",
    "Lat": "29.527",
    "Long": "35.0777",
    "CountryCode": "JO"
  },
  {
    "Area": "Al Ayn",
    "Lat": "24.2305",
    "Long": "55.74",
    "CountryCode": "AE"
  },
  {
    "Area": "Al Fallujah",
    "Lat": "33.3477",
    "Long": "43.7773",
    "CountryCode": "IQ"
  },
  {
    "Area": "Al Fujayrah",
    "Lat": "25.1234",
    "Long": "56.3375",
    "CountryCode": "AE"
  },
  {
    "Area": "Al Hasakah",
    "Lat": "36.4833",
    "Long": "40.75",
    "CountryCode": "SY"
  },
  {
    "Area": "Al Hillah",
    "Lat": "23.4895",
    "Long": "46.7564",
    "CountryCode": "SA"
  },
  {
    "Area": "Al Hillah",
    "Lat": "32.4721",
    "Long": "44.4217",
    "CountryCode": "IQ"
  },
  {
    "Area": "Al Hudaydah",
    "Lat": "14.7979",
    "Long": "42.953",
    "CountryCode": "YE"
  },
  {
    "Area": "Al Hufuf",
    "Lat": "25.3487",
    "Long": "49.5856",
    "CountryCode": "SA"
  },
  {
    "Area": "Al Jahra",
    "Lat": "29.3375",
    "Long": "47.6581",
    "CountryCode": "KW"
  },
  {
    "Area": "Al Jubayl",
    "Lat": "27.0046",
    "Long": "49.646",
    "CountryCode": "SA"
  },
  {
    "Area": "Al Karak",
    "Lat": "31.1851",
    "Long": "35.7047",
    "CountryCode": "JO"
  },
  {
    "Area": "Al Kharj",
    "Lat": "24.1556",
    "Long": "47.312",
    "CountryCode": "SA"
  },
  {
    "Area": "Al Khums",
    "Lat": "32.6604",
    "Long": "14.26",
    "CountryCode": "LY"
  },
  {
    "Area": "Al Kut",
    "Lat": "32.4907",
    "Long": "45.8304",
    "CountryCode": "IQ"
  },
  {
    "Area": "Al Ladhiqiyah",
    "Lat": "35.54",
    "Long": "35.78",
    "CountryCode": "SY"
  },
  {
    "Area": "Al Mafraq",
    "Lat": "32.2833",
    "Long": "36.2333",
    "CountryCode": "JO"
  },
  {
    "Area": "Al Marj",
    "Lat": "32.5005",
    "Long": "20.83",
    "CountryCode": "LY"
  },
  {
    "Area": "Al Mubarraz",
    "Lat": "25.4291",
    "Long": "49.5659",
    "CountryCode": "SA"
  },
  {
    "Area": "Al Mukalla",
    "Lat": "14.5412",
    "Long": "49.1259",
    "CountryCode": "YE"
  },
  {
    "Area": "Al Musayyib",
    "Lat": "32.7786",
    "Long": "44.29",
    "CountryCode": "IQ"
  },
  {
    "Area": "Al Qamishli",
    "Lat": "37.03",
    "Long": "41.23",
    "CountryCode": "SY"
  },
  {
    "Area": "Al-Qatif",
    "Lat": "26.5196",
    "Long": "50.0115",
    "CountryCode": "SA"
  },
  {
    "Area": "Alagoinhas",
    "Lat": "-12.14",
    "Long": "-38.43",
    "CountryCode": "BR"
  },
  {
    "Area": "Alajuela",
    "Lat": "10.02",
    "Long": "-84.23",
    "CountryCode": "CR"
  },
  {
    "Area": "Alameda",
    "Lat": "37.767",
    "Long": "-122.2673",
    "CountryCode": "US"
  },
  {
    "Area": "Alba Lulia",
    "Lat": "46.077",
    "Long": "23.58",
    "CountryCode": "RO"
  },
  {
    "Area": "Albacete",
    "Lat": "39.0003",
    "Long": "-1.87",
    "CountryCode": "ES"
  },
  {
    "Area": "Albany",
    "Lat": "42.6664",
    "Long": "-73.7987",
    "CountryCode": "US"
  },
  {
    "Area": "Albany",
    "Lat": "31.5776",
    "Long": "-84.1762",
    "CountryCode": "US"
  },
  {
    "Area": "Albany",
    "Lat": "44.6274",
    "Long": "-123.0966",
    "CountryCode": "US"
  },
  {
    "Area": "Albuquerque",
    "Lat": "35.1053",
    "Long": "-106.6464",
    "CountryCode": "US"
  },
  {
    "Area": "Albury",
    "Lat": "-36.06",
    "Long": "146.92",
    "CountryCode": "AU"
  },
  {
    "Area": "Aleksin",
    "Lat": "54.5143",
    "Long": "37.0944",
    "CountryCode": "RU"
  },
  {
    "Area": "Aleppo",
    "Lat": "36.23",
    "Long": "37.17",
    "CountryCode": "SY"
  },
  {
    "Area": "Alexandria",
    "Lat": "31.2",
    "Long": "29.95",
    "CountryCode": "EG"
  },
  {
    "Area": "Alexandria",
    "Lat": "38.8185",
    "Long": "-77.0861",
    "CountryCode": "US"
  },
  {
    "Area": "Alexandria",
    "Lat": "31.2923",
    "Long": "-92.4702",
    "CountryCode": "US"
  },
  {
    "Area": "Alexandroupoli",
    "Lat": "40.8486",
    "Long": "25.8744",
    "CountryCode": "GR"
  },
  {
    "Area": "Algeciras",
    "Lat": "36.1267",
    "Long": "-5.4665",
    "CountryCode": "ES"
  },
  {
    "Area": "Algiers",
    "Lat": "36.7631",
    "Long": "3.0506",
    "CountryCode": "DZ"
  },
  {
    "Area": "Alhambra",
    "Lat": "34.084",
    "Long": "-118.1355",
    "CountryCode": "US"
  },
  {
    "Area": "Ali Bayramli",
    "Lat": "39.9323",
    "Long": "48.9203",
    "CountryCode": "AZ"
  },
  {
    "Area": "Alicante",
    "Lat": "38.3512",
    "Long": "-0.4836",
    "CountryCode": "ES"
  },
  {
    "Area": "Aliso Viejo",
    "Lat": "33.5792",
    "Long": "-117.729",
    "CountryCode": "US"
  },
  {
    "Area": "Allanmyo",
    "Lat": "19.3783",
    "Long": "95.2279",
    "CountryCode": "MM"
  },
  {
    "Area": "Allen",
    "Lat": "33.1088",
    "Long": "-96.6735",
    "CountryCode": "US"
  },
  {
    "Area": "Allentown",
    "Lat": "40.5961",
    "Long": "-75.4756",
    "CountryCode": "US"
  },
  {
    "Area": "Almaty",
    "Lat": "43.325",
    "Long": "76.915",
    "CountryCode": "KZ"
  },
  {
    "Area": "Almería",
    "Lat": "36.8303",
    "Long": "-2.43",
    "CountryCode": "ES"
  },
  {
    "Area": "Almetyevsk",
    "Lat": "54.9004",
    "Long": "52.3199",
    "CountryCode": "RU"
  },
  {
    "Area": "Alor Setar",
    "Lat": "6.1133",
    "Long": "100.3729",
    "CountryCode": "MY"
  },
  {
    "Area": "Alpharetta",
    "Lat": "34.0704",
    "Long": "-84.2739",
    "CountryCode": "US"
  },
  {
    "Area": "Altamira",
    "Lat": "-3.1996",
    "Long": "-52.21",
    "CountryCode": "BR"
  },
  {
    "Area": "Altay",
    "Lat": "47.8666",
    "Long": "88.1166",
    "CountryCode": "CN"
  },
  {
    "Area": "Alton",
    "Lat": "38.9033",
    "Long": "-90.1523",
    "CountryCode": "US"
  },
  {
    "Area": "Altoona",
    "Lat": "40.5082",
    "Long": "-78.4007",
    "CountryCode": "US"
  },
  {
    "Area": "Alxa Zuoqi",
    "Lat": "38.839",
    "Long": "105.6686",
    "CountryCode": "CN"
  },
  {
    "Area": "Amarillo",
    "Lat": "35.1988",
    "Long": "-101.8308",
    "CountryCode": "US"
  },
  {
    "Area": "Amasya",
    "Lat": "40.6537",
    "Long": "35.833",
    "CountryCode": "TR"
  },
  {
    "Area": "Ambato",
    "Lat": "-1.2696",
    "Long": "-78.62",
    "CountryCode": "EC"
  },
  {
    "Area": "Ambon",
    "Lat": "-3.7167",
    "Long": "128.2",
    "CountryCode": "ID"
  },
  {
    "Area": "Americana",
    "Lat": "-22.7499",
    "Long": "-47.33",
    "CountryCode": "BR"
  },
  {
    "Area": "Ames",
    "Lat": "42.0261",
    "Long": "-93.6279",
    "CountryCode": "US"
  },
  {
    "Area": "Amiens",
    "Lat": "49.9004",
    "Long": "2.3",
    "CountryCode": "FR"
  },
  {
    "Area": "Amman",
    "Lat": "31.95",
    "Long": "35.9333",
    "CountryCode": "JO"
  },
  {
    "Area": "Amol",
    "Lat": "36.4713",
    "Long": "52.3633",
    "CountryCode": "IR"
  },
  {
    "Area": "Amsterdam",
    "Lat": "52.35",
    "Long": "4.9166",
    "CountryCode": "NL"
  },
  {
    "Area": "An Najaf",
    "Lat": "32.0003",
    "Long": "44.3354",
    "CountryCode": "IQ"
  },
  {
    "Area": "An Nasiriyah",
    "Lat": "31.0429",
    "Long": "46.2676",
    "CountryCode": "IQ"
  },
  {
    "Area": "Anaco",
    "Lat": "9.44",
    "Long": "-64.46",
    "CountryCode": "VE"
  },
  {
    "Area": "Anaheim",
    "Lat": "33.839",
    "Long": "-117.8572",
    "CountryCode": "US"
  },
  {
    "Area": "Anápolis",
    "Lat": "-16.3196",
    "Long": "-48.96",
    "CountryCode": "BR"
  },
  {
    "Area": "Anchorage",
    "Lat": "61.1508",
    "Long": "-149.1091",
    "CountryCode": "US"
  },
  {
    "Area": "Ancona",
    "Lat": "43.6004",
    "Long": "13.4999",
    "CountryCode": "IT"
  },
  {
    "Area": "Anda",
    "Lat": "46.4",
    "Long": "125.32",
    "CountryCode": "CN"
  },
  {
    "Area": "Anderson",
    "Lat": "40.0874",
    "Long": "-85.692",
    "CountryCode": "US"
  },
  {
    "Area": "Anderson",
    "Lat": "34.5212",
    "Long": "-82.6479",
    "CountryCode": "US"
  },
  {
    "Area": "Andijon",
    "Lat": "40.79",
    "Long": "72.34",
    "CountryCode": "UZ"
  },
  {
    "Area": "Andkhvoy",
    "Lat": "36.9317",
    "Long": "65.1015",
    "CountryCode": "AF"
  },
  {
    "Area": "Andong",
    "Lat": "36.5659",
    "Long": "128.725",
    "CountryCode": "kr"
  },
  {
    "Area": "AD",
    "Lat": "42.5",
    "Long": "1.5165",
    "CountryCode": "AD"
  },
  {
    "Area": "Andradina",
    "Lat": "-20.9096",
    "Long": "-51.3799",
    "CountryCode": "BR"
  },
  {
    "Area": "Angarsk",
    "Lat": "52.56",
    "Long": "103.92",
    "CountryCode": "RU"
  },
  {
    "Area": "Angeles",
    "Lat": "15.1451",
    "Long": "120.5451",
    "CountryCode": "PH"
  },
  {
    "Area": "Angers",
    "Lat": "47.48",
    "Long": "-0.53",
    "CountryCode": "FR"
  },
  {
    "Area": "Angoche",
    "Lat": "-16.23",
    "Long": "39.91",
    "CountryCode": "MZ"
  },
  {
    "Area": "Angren",
    "Lat": "41.0304",
    "Long": "70.1549",
    "CountryCode": "UZ"
  },
  {
    "Area": "Ankang",
    "Lat": "32.68",
    "Long": "109.02",
    "CountryCode": "CN"
  },
  {
    "Area": "Ankara",
    "Lat": "39.9272",
    "Long": "32.8644",
    "CountryCode": "TR"
  },
  {
    "Area": "Ankeny",
    "Lat": "41.728",
    "Long": "-93.6031",
    "CountryCode": "US"
  },
  {
    "Area": "Anlu",
    "Lat": "31.27",
    "Long": "113.67",
    "CountryCode": "CN"
  },
  {
    "Area": "Ann Arbor",
    "Lat": "42.2755",
    "Long": "-83.7312",
    "CountryCode": "US"
  },
  {
    "Area": "Annaba",
    "Lat": "36.92",
    "Long": "7.76",
    "CountryCode": "DZ"
  },
  {
    "Area": "Annecy",
    "Lat": "45.9",
    "Long": "6.1167",
    "CountryCode": "FR"
  },
  {
    "Area": "Anniston",
    "Lat": "33.6713",
    "Long": "-85.8136",
    "CountryCode": "US"
  },
  {
    "Area": "Anqing",
    "Lat": "30.5",
    "Long": "117.05",
    "CountryCode": "CN"
  },
  {
    "Area": "Ansan",
    "Lat": "37.3481",
    "Long": "126.8595",
    "CountryCode": "kr"
  },
  {
    "Area": "Anshan",
    "Lat": "41.115",
    "Long": "122.94",
    "CountryCode": "CN"
  },
  {
    "Area": "Anshun",
    "Lat": "26.2504",
    "Long": "105.93",
    "CountryCode": "CN"
  },
  {
    "Area": "Antalya",
    "Lat": "36.89",
    "Long": "30.7",
    "CountryCode": "TR"
  },
  {
    "Area": "Antananarivo",
    "Lat": "-18.9166",
    "Long": "47.5166",
    "CountryCode": "MG"
  },
  {
    "Area": "Antioch",
    "Lat": "37.9789",
    "Long": "-121.7957",
    "CountryCode": "US"
  },
  {
    "Area": "Antofagasta",
    "Lat": "-23.65",
    "Long": "-70.4",
    "CountryCode": "CL"
  },
  {
    "Area": "Antsirabe",
    "Lat": "-19.85",
    "Long": "47.0333",
    "CountryCode": "MG"
  },
  {
    "Area": "AntsIRana",
    "Lat": "-12.2765",
    "Long": "49.3115",
    "CountryCode": "MG"
  },
  {
    "Area": "Antwerpen",
    "Lat": "51.2204",
    "Long": "4.415",
    "CountryCode": "BE"
  },
  {
    "Area": "Anuradhapura",
    "Lat": "8.35",
    "Long": "80.3833",
    "CountryCode": "LK"
  },
  {
    "Area": "Anyang",
    "Lat": "36.08",
    "Long": "114.35",
    "CountryCode": "CN"
  },
  {
    "Area": "Anzhero Sudzhensk",
    "Lat": "56.08",
    "Long": "86.04",
    "CountryCode": "RU"
  },
  {
    "Area": "Aomori",
    "Lat": "40.825",
    "Long": "140.71",
    "CountryCode": "JP"
  },
  {
    "Area": "Apatity",
    "Lat": "67.5731",
    "Long": "33.393",
    "CountryCode": "RU"
  },
  {
    "Area": "Apatzingán",
    "Lat": "19.08",
    "Long": "-102.35",
    "CountryCode": "MX"
  },
  {
    "Area": "Apex",
    "Lat": "35.7248",
    "Long": "-78.8659",
    "CountryCode": "US"
  },
  {
    "Area": "Apia",
    "Lat": "-13.8415",
    "Long": "-171.7386",
    "CountryCode": "WS"
  },
  {
    "Area": "Apopka",
    "Lat": "28.7015",
    "Long": "-81.5308",
    "CountryCode": "US"
  },
  {
    "Area": "Apple Valley",
    "Lat": "34.5329",
    "Long": "-117.2102",
    "CountryCode": "US"
  },
  {
    "Area": "Apple Valley",
    "Lat": "44.7458",
    "Long": "-93.2006",
    "CountryCode": "US"
  },
  {
    "Area": "Appleton",
    "Lat": "44.2774",
    "Long": "-88.3894",
    "CountryCode": "US"
  },
  {
    "Area": "Apucarana",
    "Lat": "-23.55",
    "Long": "-51.47",
    "CountryCode": "BR"
  },
  {
    "Area": "Aqtobe",
    "Lat": "50.28",
    "Long": "57.17",
    "CountryCode": "KZ"
  },
  {
    "Area": "Ar Ramadi",
    "Lat": "33.42",
    "Long": "43.3",
    "CountryCode": "IQ"
  },
  {
    "Area": "Ar Raqqah",
    "Lat": "35.9304",
    "Long": "39.02",
    "CountryCode": "SY"
  },
  {
    "Area": "Aracaju",
    "Lat": "-10.9",
    "Long": "-37.12",
    "CountryCode": "BR"
  },
  {
    "Area": "Araçatuba",
    "Lat": "-21.21",
    "Long": "-50.45",
    "CountryCode": "BR"
  },
  {
    "Area": "Arad",
    "Lat": "46.17",
    "Long": "21.32",
    "CountryCode": "RO"
  },
  {
    "Area": "Araguaína",
    "Lat": "-7.19",
    "Long": "-48.21",
    "CountryCode": "BR"
  },
  {
    "Area": "Araguari",
    "Lat": "-18.64",
    "Long": "-48.2",
    "CountryCode": "BR"
  },
  {
    "Area": "Arak",
    "Lat": "34.0804",
    "Long": "49.7",
    "CountryCode": "IR"
  },
  {
    "Area": "Arapiraca",
    "Lat": "-9.75",
    "Long": "-36.67",
    "CountryCode": "BR"
  },
  {
    "Area": "Arapongas",
    "Lat": "-23.41",
    "Long": "-51.43",
    "CountryCode": "BR"
  },
  {
    "Area": "Arar",
    "Lat": "30.99",
    "Long": "41.0207",
    "CountryCode": "SA"
  },
  {
    "Area": "Arauca",
    "Lat": "7.0907",
    "Long": "-70.7616",
    "CountryCode": "CO"
  },
  {
    "Area": "Araxá",
    "Lat": "-19.5796",
    "Long": "-46.95",
    "CountryCode": "BR"
  },
  {
    "Area": "Arba Minch",
    "Lat": "6.04",
    "Long": "37.55",
    "CountryCode": "ET"
  },
  {
    "Area": "Arcadia",
    "Lat": "34.1342",
    "Long": "-118.0373",
    "CountryCode": "US"
  },
  {
    "Area": "Archangel",
    "Lat": "64.575",
    "Long": "40.545",
    "CountryCode": "RU"
  },
  {
    "Area": "Arcoverde",
    "Lat": "-8.42",
    "Long": "-37.07",
    "CountryCode": "BR"
  },
  {
    "Area": "Ardabil",
    "Lat": "38.25",
    "Long": "48.3",
    "CountryCode": "IR"
  },
  {
    "Area": "Arequipa",
    "Lat": "-16.42",
    "Long": "-71.53",
    "CountryCode": "PE"
  },
  {
    "Area": "Arezzo",
    "Lat": "43.4617",
    "Long": "11.875",
    "CountryCode": "IT"
  },
  {
    "Area": "Århus",
    "Lat": "56.1572",
    "Long": "10.2107",
    "CountryCode": "DK"
  },
  {
    "Area": "Arica",
    "Lat": "-18.5",
    "Long": "-70.29",
    "CountryCode": "CL"
  },
  {
    "Area": "Ariquemes",
    "Lat": "-9.9396",
    "Long": "-63.08",
    "CountryCode": "BR"
  },
  {
    "Area": "Arjona",
    "Lat": "10.26",
    "Long": "-75.35",
    "CountryCode": "CO"
  },
  {
    "Area": "Arlington",
    "Lat": "32.6998",
    "Long": "-97.125",
    "CountryCode": "US"
  },
  {
    "Area": "Arlington Heights",
    "Lat": "42.0956",
    "Long": "-87.9825",
    "CountryCode": "US"
  },
  {
    "Area": "Arlit",
    "Lat": "18.82",
    "Long": "7.33",
    "CountryCode": "NE"
  },
  {
    "Area": "Armavir",
    "Lat": "45.0004",
    "Long": "41.13",
    "CountryCode": "RU"
  },
  {
    "Area": "AM",
    "Lat": "4.5343",
    "Long": "-75.6811",
    "CountryCode": "CO"
  },
  {
    "Area": "Arnhem",
    "Lat": "51.988",
    "Long": "5.923",
    "CountryCode": "NL"
  },
  {
    "Area": "Arqalyq",
    "Lat": "50.2418",
    "Long": "66.8976",
    "CountryCode": "KZ"
  },
  {
    "Area": "Arras",
    "Lat": "50.2833",
    "Long": "2.7833",
    "CountryCode": "FR"
  },
  {
    "Area": "Arrecife",
    "Lat": "28.969",
    "Long": "-13.5378",
    "CountryCode": "ES"
  },
  {
    "Area": "Arroyo Grande",
    "Lat": "35.1241",
    "Long": "-120.5845",
    "CountryCode": "US"
  },
  {
    "Area": "Arsenyev",
    "Lat": "44.1623",
    "Long": "133.2823",
    "CountryCode": "RU"
  },
  {
    "Area": "Artemisa",
    "Lat": "22.8134",
    "Long": "-82.7619",
    "CountryCode": "CU"
  },
  {
    "Area": "Arua",
    "Lat": "3.0204",
    "Long": "30.9",
    "CountryCode": "UG"
  },
  {
    "Area": "Arusha",
    "Lat": "-3.36",
    "Long": "36.67",
    "CountryCode": "TZ"
  },
  {
    "Area": "Arvada",
    "Lat": "39.8321",
    "Long": "-105.151",
    "CountryCode": "US"
  },
  {
    "Area": "Arzamas",
    "Lat": "55.4",
    "Long": "43.8",
    "CountryCode": "RU"
  },
  {
    "Area": "As Salt",
    "Lat": "32.0392",
    "Long": "35.7272",
    "CountryCode": "JO"
  },
  {
    "Area": "As Samawah",
    "Lat": "31.3099",
    "Long": "45.2803",
    "CountryCode": "IQ"
  },
  {
    "Area": "As Sib",
    "Lat": "23.6802",
    "Long": "58.1825",
    "CountryCode": "OM"
  },
  {
    "Area": "As Sulaymaniyah",
    "Lat": "35.5613",
    "Long": "45.4309",
    "CountryCode": "IQ"
  },
  {
    "Area": "As Suwayda",
    "Lat": "32.7004",
    "Long": "36.5666",
    "CountryCode": "SY"
  },
  {
    "Area": "Asahikawa",
    "Lat": "43.755",
    "Long": "142.38",
    "CountryCode": "JP"
  },
  {
    "Area": "Asbest",
    "Lat": "57.023",
    "Long": "61.458",
    "CountryCode": "RU"
  },
  {
    "Area": "Asela",
    "Lat": "7.9504",
    "Long": "39.1399",
    "CountryCode": "ET"
  },
  {
    "Area": "Ash Shatrah",
    "Lat": "31.4175",
    "Long": "46.1772",
    "CountryCode": "IQ"
  },
  {
    "Area": "Ash Shihr",
    "Lat": "14.7593",
    "Long": "49.6092",
    "CountryCode": "YE"
  },
  {
    "Area": "Asheville",
    "Lat": "35.5706",
    "Long": "-82.5537",
    "CountryCode": "US"
  },
  {
    "Area": "Ashgabat",
    "Lat": "37.95",
    "Long": "58.3833",
    "CountryCode": "TM"
  },
  {
    "Area": "Asmara",
    "Lat": "15.3333",
    "Long": "38.9333",
    "CountryCode": "ER"
  },
  {
    "Area": "Assab",
    "Lat": "13.01",
    "Long": "42.73",
    "CountryCode": "ER"
  },
  {
    "Area": "Assen",
    "Lat": "53",
    "Long": "6.55",
    "CountryCode": "NL"
  },
  {
    "Area": "Assis",
    "Lat": "-22.6596",
    "Long": "-50.42",
    "CountryCode": "BR"
  },
  {
    "Area": "Astana",
    "Lat": "51.1811",
    "Long": "71.4278",
    "CountryCode": "KZ"
  },
  {
    "Area": "Asti",
    "Lat": "44.93",
    "Long": "8.21",
    "CountryCode": "IT"
  },
  {
    "Area": "Astrakhan",
    "Lat": "46.3487",
    "Long": "48.055",
    "CountryCode": "RU"
  },
  {
    "Area": "Asunción",
    "Lat": "-25.2964",
    "Long": "-57.6415",
    "CountryCode": "PY"
  },
  {
    "Area": "Aswan",
    "Lat": "24.0875",
    "Long": "32.8989",
    "CountryCode": "EG"
  },
  {
    "Area": "Asyut",
    "Lat": "27.19",
    "Long": "31.1799",
    "CountryCode": "EG"
  },
  {
    "Area": "At Taif",
    "Lat": "21.2622",
    "Long": "40.3823",
    "CountryCode": "SA"
  },
  {
    "Area": "Atakpamé",
    "Lat": "7.53",
    "Long": "1.12",
    "CountryCode": "TG"
  },
  {
    "Area": "Atbara",
    "Lat": "17.71",
    "Long": "33.98",
    "CountryCode": "SD"
  },
  {
    "Area": "Athens",
    "Lat": "37.9833",
    "Long": "23.7333",
    "CountryCode": "GR"
  },
  {
    "Area": "Athens",
    "Lat": "33.9508",
    "Long": "-83.3689",
    "CountryCode": "US"
  },
  {
    "Area": "Atlanta",
    "Lat": "33.7626",
    "Long": "-84.4228",
    "CountryCode": "US"
  },
  {
    "Area": "Atlantic City",
    "Lat": "39.3797",
    "Long": "-74.4527",
    "CountryCode": "US"
  },
  {
    "Area": "Atlixco",
    "Lat": "18.9",
    "Long": "-98.45",
    "CountryCode": "MX"
  },
  {
    "Area": "Atyrau",
    "Lat": "47.1127",
    "Long": "51.92",
    "CountryCode": "KZ"
  },
  {
    "Area": "Auburn",
    "Lat": "32.6084",
    "Long": "-85.4897",
    "CountryCode": "US"
  },
  {
    "Area": "Auburn",
    "Lat": "47.3041",
    "Long": "-122.211",
    "CountryCode": "US"
  },
  {
    "Area": "Auckland",
    "Lat": "-36.8481",
    "Long": "174.763",
    "CountryCode": "NZ"
  },
  {
    "Area": "Augsburg",
    "Lat": "48.35",
    "Long": "10.9",
    "CountryCode": "DE"
  },
  {
    "Area": "Augusta",
    "Lat": "33.3645",
    "Long": "-82.0708",
    "CountryCode": "US"
  },
  {
    "Area": "Aurora",
    "Lat": "39.7084",
    "Long": "-104.7274",
    "CountryCode": "US"
  },
  {
    "Area": "Aurora",
    "Lat": "41.7638",
    "Long": "-88.2901",
    "CountryCode": "US"
  },
  {
    "Area": "Austin",
    "Lat": "30.3006",
    "Long": "-97.7517",
    "CountryCode": "US"
  },
  {
    "Area": "Avaré",
    "Lat": "-23.11",
    "Long": "-48.93",
    "CountryCode": "BR"
  },
  {
    "Area": "Aveiro",
    "Lat": "40.641",
    "Long": "-8.651",
    "CountryCode": "PT"
  },
  {
    "Area": "Avondale",
    "Lat": "33.3858",
    "Long": "-112.3236",
    "CountryCode": "US"
  },
  {
    "Area": "Awasa",
    "Lat": "7.06",
    "Long": "38.477",
    "CountryCode": "ET"
  },
  {
    "Area": "Awka",
    "Lat": "6.2104",
    "Long": "7.07",
    "CountryCode": "NG"
  },
  {
    "Area": "Ayacucho",
    "Lat": "-13.175",
    "Long": "-74.22",
    "CountryCode": "PE"
  },
  {
    "Area": "Aydın",
    "Lat": "37.85",
    "Long": "27.85",
    "CountryCode": "TR"
  },
  {
    "Area": "Ayr",
    "Lat": "55.4504",
    "Long": "-4.6167",
    "CountryCode": "GB"
  },
  {
    "Area": "Ayutthaya",
    "Lat": "14.3588",
    "Long": "100.5684",
    "CountryCode": "TH"
  },
  {
    "Area": "Az Aubayr",
    "Lat": "30.3892",
    "Long": "47.708",
    "CountryCode": "IQ"
  },
  {
    "Area": "Az Zahran",
    "Lat": "26.2914",
    "Long": "50.1583",
    "CountryCode": "SA"
  },
  {
    "Area": "Az Zarqa",
    "Lat": "32.07",
    "Long": "36.1",
    "CountryCode": "JO"
  },
  {
    "Area": "Az Zawiyah",
    "Lat": "32.7604",
    "Long": "12.72",
    "CountryCode": "LY"
  },
  {
    "Area": "Azare",
    "Lat": "11.6804",
    "Long": "10.19",
    "CountryCode": "NG"
  },
  {
    "Area": "Azogues",
    "Lat": "-2.74",
    "Long": "-78.84",
    "CountryCode": "EC"
  },
  {
    "Area": "Azua",
    "Lat": "18.454",
    "Long": "-70.729",
    "CountryCode": "DO"
  },
  {
    "Area": "Azul",
    "Lat": "-36.7796",
    "Long": "-59.87",
    "CountryCode": "AR"
  },
    {
		"Area": "b..bagewadi",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 16.6964,
		"Long": 76.0319
	},
    {
		"Area": "B B Ashram",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.3196,
		"Long": 76.611
	},
	{
		"Area": "B Bagewadi",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 16.3803,
		"Long": 76.0021
	},
	{
		"Area": "B K Samudram",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 14.6254,
		"Long": 77.9714
	},
	{
		"Area": "B. Bagha",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 29.9084,
		"Long": 75.4389
	},
	{
		"Area": "B. Pali",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 23.8029,
		"Long": 81.1354
	},
	{
		"Area": "B.Kodur",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 14.92,
		"Long": 79.0557
	},
	{
		"Area": "B.Kothakota",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 13.3352,
		"Long": 78.503
	},
	{
		"Area": "B.S.City RS",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 23.6915,
		"Long": 85.988
	},
	{
		"Area": "B.bagewadi",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 17.3227,
		"Long": 76.7018
	},
	{
		"Area": "B.bagha",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 30.3673,
		"Long": 75.1394
	},
	{
		"Area": "B.m.pur",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.8746,
		"Long": 83.9417
	},
	{
		"Area": "B.n.pahad",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 17.5969,
		"Long": 80.6873
	},
	{
		"Area": "B.pali",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 23.5393,
		"Long": 81.193
	},
	{
		"Area": "B.s. Gram",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.3167,
		"Long": 91.1281
	},
	{
		"Area": "B.s.gram",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.3652,
		"Long": 90.6248
	},
	{
		"Area": "B.s.gram.",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.3652,
		"Long": 90.6248
	},
	{
		"Area": "B.tallavalasa",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 18.036,
		"Long": 83.3038
	},
	{
		"Area": "BEGUMGANJ",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 23.5962,
		"Long": 78.8991
	},
	{
		"Area": "BELAGAVI",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 15.9887,
		"Long": 74.6656
	},
	{
		"Area": "BELIATORE",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.3102,
		"Long": 87.2788
	},
	{
		"Area": "BHARSAR",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 25.9241,
		"Long": 83.8577
	},
	{
		"Area": "BRAHMAGIRI",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.3216,
		"Long": 85.7209
	},
	{
		"Area": "Baba Bakala",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 31.7046,
		"Long": 75.3376
	},
	{
		"Area": "Babai",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.7657,
		"Long": 78.0923
	},
	{
		"Area": "Babain",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 30.0718,
		"Long": 76.9831
	},
	{
		"Area": "Babhulgaon",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 20.646,
		"Long": 78.9844
	},
	{
		"Area": "Babla",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3564,
		"Long": 87.8021
	},
	{
		"Area": "Babra",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 21.8236,
		"Long": 71.2742
	},
	{
		"Area": "Babubarhi",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 26.4057,
		"Long": 86.3439
	},
	{
		"Area": "Bachaibari",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.0796,
		"Long": 91.5997
	},
	{
		"Area": "Bachannapet",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 18.046,
		"Long": 79.6518
	},
	{
		"Area": "Bachhrawan",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.4372,
		"Long": 81.1471
	},
	{
		"Area": "Bachhurkhoyar",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.164,
		"Long": 87.0901
	},
	{
		"Area": "Bachra",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 24.1735,
		"Long": 84.8871
	},
	{
		"Area": "Bad Malahara",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 24.7967,
		"Long": 79.6661
	},
	{
		"Area": "Badalapur",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 25.9781,
		"Long": 82.5759
	},
	{
		"Area": "Badamalahara",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 24.7967,
		"Long": 79.6661
	},
	{
		"Area": "Badamalahra",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 24.449,
		"Long": 79.1598
	},
	{
		"Area": "Badamalehara",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 24.8785,
		"Long": 79.6661
	},
	{
		"Area": "Badamba",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.4496,
		"Long": 85.7057
	},
	{
		"Area": "Badami",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 16.2205,
		"Long": 75.9141
	},
	{
		"Area": "Badangi",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 18.5553,
		"Long": 83.4718
	},
	{
		"Area": "Badarpur Bazar",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 24.8457,
		"Long": 92.5086
	},
	{
		"Area": "Badati",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.9439,
		"Long": 94.4075
	},
	{
		"Area": "Badgam",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 34.14,
		"Long": 74.7964
	},
	{
		"Area": "Badgaon",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 24.7338,
		"Long": 73.9656
	},
	{
		"Area": "Badhara",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.5104,
		"Long": 75.9372
	},
	{
		"Area": "Badi Khairi",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.6445,
		"Long": 80.4078
	},
	{
		"Area": "Badla",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 26.2299,
		"Long": 74.7752
	},
	{
		"Area": "Badlabari",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.019,
		"Long": 91.625
	},
	{
		"Area": "Badlapur",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 25.9808,
		"Long": 82.7906
	},
	{
		"Area": "Badnagar",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 24.4106,
		"Long": 79.0409
	},
	{
		"Area": "Badnapur",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 20.0391,
		"Long": 76.0835
	},
	{
		"Area": "Badnapura",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 19.8182,
		"Long": 75.9819
	},
	{
		"Area": "Badnawar",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 23.0715,
		"Long": 75.4092
	},
	{
		"Area": "Badran",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 33.89,
		"Long": 74.663
	},
	{
		"Area": "Badrav",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.0813,
		"Long": 83.4519
	},
	{
		"Area": "Badshahpur",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.3932,
		"Long": 77.0492
	},
	{
		"Area": "Baduria",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.5239,
		"Long": 88.7865
	},
	{
		"Area": "Badvel",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 14.845,
		"Long": 79.2131
	},
	{
		"Area": "Badyar Balla",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 33.8359,
		"Long": 74.8589
	},
	{
		"Area": "Bagafa",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 23.0015,
		"Long": 91.7243
	},
	{
		"Area": "Bagaha-1",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 27.0992,
		"Long": 84.09
	},
	{
		"Area": "Bagaicherri",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.1959,
		"Long": 91.8344
	},
	{
		"Area": "Bagalkot",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 16.293,
		"Long": 76.1284
	},
	{
		"Area": "Bagangram",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.5022,
		"Long": 88.5404
	},
	{
		"Area": "Baganpara",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.4211,
		"Long": 91.7374
	},
	{
		"Area": "Bagasara",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 21.4872,
		"Long": 70.9807
	},
	{
		"Area": "Bagbahra",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 21.2071,
		"Long": 82.6128
	},
	{
		"Area": "Bagbassa",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.0447,
		"Long": 91.7553
	},
	{
		"Area": "Bagda",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.5022,
		"Long": 88.7482
	},
	{
		"Area": "Bagdah",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.2147,
		"Long": 88.8863
	},
	{
		"Area": "Bagepalli",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 13.8309,
		"Long": 78.2177
	},
	{
		"Area": "Bageshwar",
		"State": "Uttarakhand",
		"CountryCode": "IN",
		"Lat": 29.9911,
		"Long": 79.8897
	},
	{
		"Area": "Bagh Mehtab",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 34.14,
		"Long": 74.7964
	},
	{
		"Area": "Baghapurana",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 30.77,
		"Long": 75.7763
	},
	{
		"Area": "Baghasti",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.4364,
		"Long": 87.9624
	},
	{
		"Area": "Baghaurana",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 30.597,
		"Long": 75.1028
	},
	{
		"Area": "Baghiabahal",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.6468,
		"Long": 84.1776
	},
	{
		"Area": "Baghmara",
		"State": "Meghalaya",
		"CountryCode": "IN",
		"Lat": 25.1895,
		"Long": 90.6479
	},
	{
		"Area": "Baghmarabazar",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.6242,
		"Long": 91.5994
	},
	{
		"Area": "Baghmudni",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.05,
		"Long": 87.6874
	},
	{
		"Area": "Baghmundi",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.05,
		"Long": 87.6874
	},
	{
		"Area": "Baghot",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.4013,
		"Long": 76.373
	},
	{
		"Area": "Baghpat",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 29.2099,
		"Long": 82.9176
	},
	{
		"Area": "Baghthala",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.1297,
		"Long": 76.5558
	},
	{
		"Area": "Bagicha",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 22.9773,
		"Long": 84.0212
	},
	{
		"Area": "Bagidora",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 23.5954,
		"Long": 74.0852
	},
	{
		"Area": "Bagli",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 23.1712,
		"Long": 77.0144
	},
	{
		"Area": "Bagma",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 23.4955,
		"Long": 91.3298
	},
	{
		"Area": "Bagmudni",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.05,
		"Long": 87.6874
	},
	{
		"Area": "Bagmundi",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.05,
		"Long": 87.6874
	},
	{
		"Area": "Bagmundih",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.2662,
		"Long": 85.9023
	},
	{
		"Area": "Bagnan,Howrah",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.7896,
		"Long": 87.9004
	},
	{
		"Area": "Bagodar",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 24.2313,
		"Long": 86.0498
	},
	{
		"Area": "Bagora",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 25.0978,
		"Long": 72.2119
	},
	{
		"Area": "Bagra",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 25.0978,
		"Long": 72.2119
	},
	{
		"Area": "Bagra",
		"State": "Arunachal Pradesh",
		"CountryCode": "IN",
		"Lat": 28.2358,
		"Long": 94.6742
	},
	{
		"Area": "Bagribari",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.1989,
		"Long": 90.1292
	},
	{
		"Area": "Bagsra",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 23.0747,
		"Long": 70.1726
	},
	{
		"Area": "Bagu",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.5864,
		"Long": 88.4145
	},
	{
		"Area": "Bagulamari",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.4211,
		"Long": 91.7374
	},
	{
		"Area": "Bagundi",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.286,
		"Long": 88.2996
	},
	{
		"Area": "Bah",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 27.1347,
		"Long": 78.7974
	},
	{
		"Area": "Bah",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.63,
		"Long": 85.0325
	},
	{
		"Area": "Bahadurarh",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.6328,
		"Long": 76.7875
	},
	{
		"Area": "Bahadurgarh",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.8238,
		"Long": 76.9365
	},
	{
		"Area": "Bahadurpura",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 17.3568,
		"Long": 78.4524
	},
	{
		"Area": "Bahalda",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 22.4446,
		"Long": 86.4112
	},
	{
		"Area": "Baharadari",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.164,
		"Long": 87.0901
	},
	{
		"Area": "Baharagora",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 22.5826,
		"Long": 86.7183
	},
	{
		"Area": "Baharganj",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.5034,
		"Long": 87.9832
	},
	{
		"Area": "Baharihat",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.3379,
		"Long": 91.2087
	},
	{
		"Area": "Bahaudrgarh",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.6328,
		"Long": 76.7875
	},
	{
		"Area": "Baheri",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.8459,
		"Long": 79.8907
	},
	{
		"Area": "Baheri",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 26.1138,
		"Long": 86.2455
	},
	{
		"Area": "Bahinsdehi",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 21.6365,
		"Long": 77.7045
	},
	{
		"Area": "Bahitrakunda",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.2758,
		"Long": 88.831
	},
	{
		"Area": "Bahoriaband",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 23.763,
		"Long": 80.0245
	},
	{
		"Area": "Bahoriband",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 23.8038,
		"Long": 80.0558
	},
	{
		"Area": "Bahraich",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.1667,
		"Long": 81.8038
	},
	{
		"Area": "Bahrmour",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 32.5139,
		"Long": 76.2629
	},
	{
		"Area": "Bahror",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 28.0445,
		"Long": 76.8349
	},
	{
		"Area": "Bahruch",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 22.206,
		"Long": 72.8478
	},
	{
		"Area": "Bahurupa",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.3029,
		"Long": 87.818
	},
	{
		"Area": "Baidyapur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.4653,
		"Long": 88.7803
	},
	{
		"Area": "Baigund",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 33.9306,
		"Long": 75.1134
	},
	{
		"Area": "Baihar",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.3656,
		"Long": 80.8289
	},
	{
		"Area": "Baijanath",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 32.1252,
		"Long": 76.4406
	},
	{
		"Area": "Baijnath",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 32.134,
		"Long": 76.8251
	},
	{
		"Area": "Baikara",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.1465,
		"Long": 88.1117
	},
	{
		"Area": "Baikunth",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 21.4333,
		"Long": 81.7333
	},
	{
		"Area": "Baikunthapur",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 23.4829,
		"Long": 82.8212
	},
	{
		"Area": "Baikunthapur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.0208,
		"Long": 87.7744
	},
	{
		"Area": "Baikunthpur",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.1685,
		"Long": 80.3428
	},
	{
		"Area": "Bailhogal",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 15.6739,
		"Long": 74.8739
	},
	{
		"Area": "Bailhongal",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 16.1195,
		"Long": 75.4318
	},
	{
		"Area": "Bairampur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3578,
		"Long": 88.1922
	},
	{
		"Area": "Bairawas",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.1904,
		"Long": 76.1312
	},
	{
		"Area": "Bairgania",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 26.7406,
		"Long": 85.5397
	},
	{
		"Area": "Bairi Gaon",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.3805,
		"Long": 80.2158
	},
	{
		"Area": "Bairia",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.8142,
		"Long": 84.4814
	},
	{
		"Area": "Baishnabnagar",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 25.0957,
		"Long": 87.9659
	},
	{
		"Area": "Baisi",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.8919,
		"Long": 87.6207
	},
	{
		"Area": "Baitabazar",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.4305,
		"Long": 87.4447
	},
	{
		"Area": "Baitamari",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.3656,
		"Long": 90.6348
	},
	{
		"Area": "Baitu",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 26.9352,
		"Long": 72.473
	},
	{
		"Area": "Bajag",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 23.4436,
		"Long": 81.3503
	},
	{
		"Area": "Bajali",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.6325,
		"Long": 91.6412
	},
	{
		"Area": "Bajitpur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.4653,
		"Long": 88.7803
	},
	{
		"Area": "Bajna",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 27.5968,
		"Long": 77.6276
	},
	{
		"Area": "Bajna",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 23.1084,
		"Long": 76.3935
	},
	{
		"Area": "Bajpatti",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 26.576,
		"Long": 85.5397
	},
	{
		"Area": "Bakhrabad",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.8223,
		"Long": 87.5059
	},
	{
		"Area": "Bakhtiarpur",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.4724,
		"Long": 85.5798
	},
	{
		"Area": "Bakhtiarpurj",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.4687,
		"Long": 85.4964
	},
	{
		"Area": "Bakola",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.7887,
		"Long": 92.965
	},
	{
		"Area": "Bakra Dabar",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.795,
		"Long": 88.1206
	},
	{
		"Area": "Bakrachak",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.2471,
		"Long": 87.8066
	},
	{
		"Area": "Bakrahat",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.415,
		"Long": 88.307
	},
	{
		"Area": "Baksha",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.2147,
		"Long": 88.8863
	},
	{
		"Area": "Bakshi Ka Ta",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 27.1453,
		"Long": 81.0005
	},
	{
		"Area": "Bakshi Ka Talab",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 27.0978,
		"Long": 81.1139
	},
	{
		"Area": "Bakshirhat",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 26.3692,
		"Long": 89.7693
	},
	{
		"Area": "Baksispur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.2758,
		"Long": 88.831
	},
	{
		"Area": "Baktara",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.9911,
		"Long": 77.9733
	},
	{
		"Area": "Bakuajari",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.5004,
		"Long": 91.4784
	},
	{
		"Area": "Bakurpada",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3836,
		"Long": 87.8747
	},
	{
		"Area": "Bala",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.3796,
		"Long": 91.2951
	},
	{
		"Area": "Balachaur",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 31.8232,
		"Long": 76.5033
	},
	{
		"Area": "Balagarh",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.2719,
		"Long": 88.435
	},
	{
		"Area": "Balageria",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3159,
		"Long": 88.0212
	},
	{
		"Area": "Balaghat",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.6445,
		"Long": 80.4662
	},
	{
		"Area": "Balakdih",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.5693,
		"Long": 87.1521
	},
	{
		"Area": "Balanagar",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 17.4849,
		"Long": 78.4324
	},
	{
		"Area": "Balangir",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.1888,
		"Long": 84.0039
	},
	{
		"Area": "Balapanur",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 14.5435,
		"Long": 78.1979
	},
	{
		"Area": "Balapur",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 20.624,
		"Long": 77.0776
	},
	{
		"Area": "Balaram",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.007,
		"Long": 91.6093
	},
	{
		"Area": "Balarampur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.05,
		"Long": 87.6874
	},
	{
		"Area": "Balari",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.6709,
		"Long": 78.7941
	},
	{
		"Area": "Balasinor",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 23.2032,
		"Long": 74.1142
	},
	{
		"Area": "Balasore",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.8832,
		"Long": 87.1111
	},
	{
		"Area": "Balat",
		"State": "Meghalaya",
		"CountryCode": "IN",
		"Lat": 25.6019,
		"Long": 91.9144
	},
	{
		"Area": "Balayapalli",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 14.9912,
		"Long": 79.7344
	},
	{
		"Area": "Balconagar",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 22.5219,
		"Long": 82.7091
	},
	{
		"Area": "Baldeogarh",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 25.1088,
		"Long": 79.4621
	},
	{
		"Area": "Baldwara(S.T)",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 31.6377,
		"Long": 76.8472
	},
	{
		"Area": "Balesar",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 26.4894,
		"Long": 72.5885
	},
	{
		"Area": "Baleshwar Sadar",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.7722,
		"Long": 86.917
	},
	{
		"Area": "Bali",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.536,
		"Long": 91.4097
	},
	{
		"Area": "Bali",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 25.7756,
		"Long": 73.8768
	},
	{
		"Area": "Bali Chowki(S.T)",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 31.7203,
		"Long": 77.2352
	},
	{
		"Area": "Balia",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.5351,
		"Long": 86.3692
	},
	{
		"Area": "Baliadanga",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.5022,
		"Long": 88.5404
	},
	{
		"Area": "Balianta",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.7521,
		"Long": 85.8149
	},
	{
		"Area": "Baliapal",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.7766,
		"Long": 87.2889
	},
	{
		"Area": "Balicherra",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.1597,
		"Long": 92.0329
	},
	{
		"Area": "Balichowki",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 31.6221,
		"Long": 77.2307
	},
	{
		"Area": "Balidhum",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.0447,
		"Long": 91.7553
	},
	{
		"Area": "Baligaon",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.1959,
		"Long": 91.8344
	},
	{
		"Area": "Baligeria",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.5234,
		"Long": 87.6598
	},
	{
		"Area": "Balighai",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3159,
		"Long": 88.0212
	},
	{
		"Area": "Baliguda",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.0627,
		"Long": 84.0975
	},
	{
		"Area": "Balijan",
		"State": "Arunachal Pradesh",
		"CountryCode": "IN",
		"Lat": 27.5535,
		"Long": 93.7868
	},
	{
		"Area": "Balijana",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.1315,
		"Long": 90.6795
	},
	{
		"Area": "Balijipeta",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 18.6595,
		"Long": 83.574
	},
	{
		"Area": "Balikaria",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.5004,
		"Long": 91.4784
	},
	{
		"Area": "Balikuchi",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.3679,
		"Long": 91.3877
	},
	{
		"Area": "Balikuda",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.2328,
		"Long": 86.7643
	},
	{
		"Area": "Balilecha",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.3796,
		"Long": 91.2951
	},
	{
		"Area": "Balimi",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.9729,
		"Long": 85.3045
	},
	{
		"Area": "Balipara",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.8198,
		"Long": 92.684
	},
	{
		"Area": "Balipatna",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.3222,
		"Long": 85.3639
	},
	{
		"Area": "Balisai",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.4761,
		"Long": 86.8761
	},
	{
		"Area": "Balisanakara",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 22.1285,
		"Long": 84.0417
	},
	{
		"Area": "Balisankara",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 22.5029,
		"Long": 84.8218
	},
	{
		"Area": "Balisha Chowmatha",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.8767,
		"Long": 88.585
	},
	{
		"Area": "Ballabgarh",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.7556,
		"Long": 77.4665
	},
	{
		"Area": "Ballari",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 15.2984,
		"Long": 76.6996
	},
	{
		"Area": "Ballarpur",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 20.3083,
		"Long": 79.6698
	},
	{
		"Area": "Ballavpur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.1465,
		"Long": 88.1117
	},
	{
		"Area": "Ballia",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 25.9657,
		"Long": 84.4459
	},
	{
		"Area": "Ballichak",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 25.2838,
		"Long": 87.9695
	},
	{
		"Area": "Balliguda",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.1997,
		"Long": 84.0975
	},
	{
		"Area": "Bally Jagachha",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.6486,
		"Long": 88.7067
	},
	{
		"Area": "Bally-Jagacha",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.6368,
		"Long": 88.288
	},
	{
		"Area": "Ballyagobindapur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.475,
		"Long": 87.8219
	},
	{
		"Area": "Balmoor",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 16.6555,
		"Long": 78.874
	},
	{
		"Area": "Balod",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 21.2161,
		"Long": 81.5108
	},
	{
		"Area": "Baloda",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 22.1489,
		"Long": 82.8557
	},
	{
		"Area": "Baloda  Bazar",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 21.6866,
		"Long": 82.1809
	},
	{
		"Area": "Baloda Bazar",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 21.7241,
		"Long": 82.3412
	},
	{
		"Area": "Balotra",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 25.8607,
		"Long": 72.2959
	},
	{
		"Area": "Balowa",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.4348,
		"Long": 91.1657
	},
	{
		"Area": "Balrampur",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 27.6833,
		"Long": 84.038
	},
	{
		"Area": "Balti",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.1406,
		"Long": 88.5427
	},
	{
		"Area": "Balumath",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 24.3728,
		"Long": 84.9035
	},
	{
		"Area": "Balurghat",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 26.4299,
		"Long": 89.9656
	},
	{
		"Area": "Balurgthat",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 25.4031,
		"Long": 87.8175
	},
	{
		"Area": "Bamanbarh",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 21.9837,
		"Long": 87.635
	},
	{
		"Area": "Bamancherra",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.0789,
		"Long": 91.8987
	},
	{
		"Area": "Bamangachi",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.1994,
		"Long": 88.0296
	},
	{
		"Area": "Bamangola",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 25.2576,
		"Long": 88.3456
	},
	{
		"Area": "Bamanibad",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3687,
		"Long": 88.562
	},
	{
		"Area": "Bamankhi",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.8803,
		"Long": 87.1491
	},
	{
		"Area": "Bamanpukur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.5081,
		"Long": 88.7067
	},
	{
		"Area": "Bamanwas",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 26.6502,
		"Long": 76.6396
	},
	{
		"Area": "Bame",
		"State": "Arunachal Pradesh",
		"CountryCode": "IN",
		"Lat": 27.9314,
		"Long": 94.7569
	},
	{
		"Area": "Bamhni Bazar",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 22.5323,
		"Long": 82.7353
	},
	{
		"Area": "Bamongola",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 25.2576,
		"Long": 87.9852
	},
	{
		"Area": "Bamori",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 24.9087,
		"Long": 77.4457
	},
	{
		"Area": "Bamra",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 22.0526,
		"Long": 84.4565
	},
	{
		"Area": "Bamunbari",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 27.3779,
		"Long": 95.2828
	},
	{
		"Area": "Bamunigaon",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.1289,
		"Long": 84.0472
	},
	{
		"Area": "Banaganapalle",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 15.5473,
		"Long": 78.61
	},
	{
		"Area": "Banaganapalli",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 15.0849,
		"Long": 78.1732
	},
	{
		"Area": "Banaganpallie",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 15.0517,
		"Long": 78.1144
	},
	{
		"Area": "Banagram",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.3834,
		"Long": 92.7945
	},
	{
		"Area": "Banagrasm",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.3834,
		"Long": 92.7945
	},
	{
		"Area": "Banaharapali",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.806,
		"Long": 83.9547
	},
	{
		"Area": "Banamalichatta",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3564,
		"Long": 87.8021
	},
	{
		"Area": "Banar",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 26.7508,
		"Long": 73.3972
	},
	{
		"Area": "Banarpal",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.9578,
		"Long": 85.2872
	},
	{
		"Area": "Banbari",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.7706,
		"Long": 91.3933
	},
	{
		"Area": "Banbazar",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.0796,
		"Long": 91.5997
	},
	{
		"Area": "Banda",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 24.3879,
		"Long": 79.6019
	},
	{
		"Area": "Banda",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 25.8991,
		"Long": 81.7426
	},
	{
		"Area": "Bandar",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 16.8749,
		"Long": 81.4554
	},
	{
		"Area": "Bandarmari",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.6833,
		"Long": 92.65
	},
	{
		"Area": "Bandel",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.9333,
		"Long": 88.3667
	},
	{
		"Area": "Banderdewa",
		"State": "Arunachal Pradesh",
		"CountryCode": "IN",
		"Lat": 27.5535,
		"Long": 93.7868
	},
	{
		"Area": "Bandgam",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 33.9245,
		"Long": 74.6725
	},
	{
		"Area": "Bandgaon",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 23.0126,
		"Long": 85.5196
	},
	{
		"Area": "Bandhogarh",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 24.0527,
		"Long": 81.1354
	},
	{
		"Area": "Bandhu Bagicha",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.0794,
		"Long": 86.1733
	},
	{
		"Area": "Bandhuchak",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 21.9467,
		"Long": 87.4938
	},
	{
		"Area": "Bandi Atmakur",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 15.5336,
		"Long": 78.1495
	},
	{
		"Area": "Bandipora",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 34.3316,
		"Long": 74.6801
	},
	{
		"Area": "Bandlaguda",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 17.3724,
		"Long": 78.4997
	},
	{
		"Area": "Bandra",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 19.0587,
		"Long": 72.8452
	},
	{
		"Area": "Bandra",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 26.1511,
		"Long": 85.4933
	},
	{
		"Area": "Banei",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 22.0798,
		"Long": 85.0417
	},
	{
		"Area": "Banekuchi",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.5004,
		"Long": 91.4784
	},
	{
		"Area": "Baneswarpur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.3294,
		"Long": 87.9528
	},
	{
		"Area": "Banga",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 31.2724,
		"Long": 76.156
	},
	{
		"Area": "Bangalore",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 13.336,
		"Long": 77.9274
	},
	{
		"Area": "Bangalore North",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 13.4353,
		"Long": 78.2593
	},
	{
		"Area": "Bangalore South",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 13.4353,
		"Long": 77.9274
	},
	{
		"Area": "Bangaloresouth",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 13.133,
		"Long": 77.9274
	},
	{
		"Area": "Bangana",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 31.8074,
		"Long": 77.0786
	},
	{
		"Area": "Bangana(T)",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 31.803,
		"Long": 77.0786
	},
	{
		"Area": "Bangaon",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.0455,
		"Long": 88.8308
	},
	{
		"Area": "Bangaon",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.4167,
		"Long": 91.3333
	},
	{
		"Area": "Bangaon.",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.4167,
		"Long": 91.3333
	},
	{
		"Area": "Bangarapet",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 13.3279,
		"Long": 78.4874
	},
	{
		"Area": "Bangarpet",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 13.3279,
		"Long": 78.4129
	},
	{
		"Area": "Bangarpet Tq",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 13.1393,
		"Long": 78.2177
	},
	{
		"Area": "Bangarupalem",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 13.8227,
		"Long": 79.5309
	},
	{
		"Area": "Banglani",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.1454,
		"Long": 88.6128
	},
	{
		"Area": "Banglore",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 12.9833,
		"Long": 77.5833
	},
	{
		"Area": "Banglorenorth",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 13.2257,
		"Long": 77.575
	},
	{
		"Area": "Bani",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 32.9706,
		"Long": 75.7307
	},
	{
		"Area": "Baniapur",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 26.0342,
		"Long": 84.7773
	},
	{
		"Area": "Banihal",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 33.4018,
		"Long": 75.6497
	},
	{
		"Area": "Banipur",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.087,
		"Long": 76.6021
	},
	{
		"Area": "Banisole",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.5234,
		"Long": 87.6598
	},
	{
		"Area": "Banjar",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 32.2438,
		"Long": 77.4902
	},
	{
		"Area": "Banjar(T)",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 31.6987,
		"Long": 77.4808
	},
	{
		"Area": "Banjaria",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 26.712,
		"Long": 84.8165
	},
	{
		"Area": "Banjhatia",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.6315,
		"Long": 87.428
	},
	{
		"Area": "Banka",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.4396,
		"Long": 87.0588
	},
	{
		"Area": "Bankatwa",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 26.3268,
		"Long": 84.894
	},
	{
		"Area": "Bankey Bajar",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 24.522,
		"Long": 84.6918
	},
	{
		"Area": "Bankey Bazar",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 24.5358,
		"Long": 84.7142
	},
	{
		"Area": "Bankhedi",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.8219,
		"Long": 78.5517
	},
	{
		"Area": "Banki",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.8834,
		"Long": 85.7057
	},
	{
		"Area": "Bankibheri",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3836,
		"Long": 87.8747
	},
	{
		"Area": "Bankimongra",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 22.5323,
		"Long": 82.6119
	},
	{
		"Area": "Bankiput",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 21.7907,
		"Long": 87.8635
	},
	{
		"Area": "Bankra",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.4653,
		"Long": 88.7803
	},
	{
		"Area": "Bankura",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.0931,
		"Long": 87.5766
	},
	{
		"Area": "Bankura - I",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.0931,
		"Long": 87.5027
	},
	{
		"Area": "Bankura - II",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.5835,
		"Long": 87.3385
	},
	{
		"Area": "Banma",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.8166,
		"Long": 86.5898
	},
	{
		"Area": "Bannu Bagicha",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.0794,
		"Long": 86.1991
	},
	{
		"Area": "Bannubagicha (chanan)",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.1269,
		"Long": 86.1305
	},
	{
		"Area": "Bano",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 22.7712,
		"Long": 85.0467
	},
	{
		"Area": "Banpur",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.8127,
		"Long": 85.55
	},
	{
		"Area": "Bansberia",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.9539,
		"Long": 88.401
	},
	{
		"Area": "Bansda",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 23.1018,
		"Long": 73.1852
	},
	{
		"Area": "Bansdih",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 25.9993,
		"Long": 84.3778
	},
	{
		"Area": "Bansgaon",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.8146,
		"Long": 83.4635
	},
	{
		"Area": "Bansgora Bazar",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.5034,
		"Long": 87.9832
	},
	{
		"Area": "Banshi Surajpur",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 24.6991,
		"Long": 84.936
	},
	{
		"Area": "Banshi Surajpura",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 24.6991,
		"Long": 84.936
	},
	{
		"Area": "Banshihari",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 25.5027,
		"Long": 88.4973
	},
	{
		"Area": "Banshisurajpura",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.0168,
		"Long": 84.9396
	},
	{
		"Area": "Banshtala",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.795,
		"Long": 88.1206
	},
	{
		"Area": "Bansi",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 27.2741,
		"Long": 83.0935
	},
	{
		"Area": "Bansihari",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 25.0576,
		"Long": 88.1934
	},
	{
		"Area": "Banskuthi",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.5234,
		"Long": 87.6598
	},
	{
		"Area": "Banspal",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.6908,
		"Long": 85.284
	},
	{
		"Area": "Bansur",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 27.9226,
		"Long": 76.6788
	},
	{
		"Area": "Banswada",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 18.4081,
		"Long": 78.529
	},
	{
		"Area": "Banswara",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 24.7789,
		"Long": 75.3153
	},
	{
		"Area": "Bant",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.5203,
		"Long": 86.917
	},
	{
		"Area": "Bantumalli",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 16.6117,
		"Long": 81.1663
	},
	{
		"Area": "Bantumilli",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 16.6352,
		"Long": 81.2937
	},
	{
		"Area": "Bantval",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 13.4836,
		"Long": 75.5862
	},
	{
		"Area": "Bantwal",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 12.8667,
		"Long": 75.2667
	},
	{
		"Area": "Banwaribad Raj",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.7617,
		"Long": 87.979
	},
	{
		"Area": "Bap",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 27.4477,
		"Long": 72.2333
	},
	{
		"Area": "Bapatla",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 16.3815,
		"Long": 80.7029
	},
	{
		"Area": "Bapulapadu",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 17.2226,
		"Long": 81.4066
	},
	{
		"Area": "Bara",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 25.4941,
		"Long": 82.0095
	},
	{
		"Area": "Bara Chauraha",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.5442,
		"Long": 80.1097
	},
	{
		"Area": "Barabani",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 25.493,
		"Long": 87.9075
	},
	{
		"Area": "Barabankra",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.5239,
		"Long": 87.8703
	},
	{
		"Area": "Barabantalia",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3836,
		"Long": 87.8747
	},
	{
		"Area": "Barabari South",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.5034,
		"Long": 87.9832
	},
	{
		"Area": "Barabatia",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 21.9467,
		"Long": 87.4938
	},
	{
		"Area": "Barabazar",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.3989,
		"Long": 86.7836
	},
	{
		"Area": "Barabhum",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.3989,
		"Long": 86.7677
	},
	{
		"Area": "Baraboni",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 25.9307,
		"Long": 87.9232
	},
	{
		"Area": "Barabruah",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.8437,
		"Long": 94.2001
	},
	{
		"Area": "Barachara",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.1762,
		"Long": 87.6063
	},
	{
		"Area": "Barachatti",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 24.6995,
		"Long": 85.2167
	},
	{
		"Area": "Barada Bazar",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 21.9958,
		"Long": 87.8022
	},
	{
		"Area": "Baradwar",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 22.5323,
		"Long": 83.152
	},
	{
		"Area": "Baragaon",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.7179,
		"Long": 84.1661
	},
	{
		"Area": "Baragudha",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 29.9298,
		"Long": 75.3455
	},
	{
		"Area": "Barahat",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.3885,
		"Long": 87.1431
	},
	{
		"Area": "Barahcatti",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 24.5592,
		"Long": 84.9756
	},
	{
		"Area": "Barahchatti",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 24.4549,
		"Long": 85.0711
	},
	{
		"Area": "Baraigarh",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.2843,
		"Long": 80.3637
	},
	{
		"Area": "Baraigram",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 24.6949,
		"Long": 92.3182
	},
	{
		"Area": "Baraily",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 23.2914,
		"Long": 78.3808
	},
	{
		"Area": "Barajamda",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 22.1649,
		"Long": 85.4272
	},
	{
		"Area": "Barajol",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.4408,
		"Long": 91.8873
	},
	{
		"Area": "Barakalankai",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.3029,
		"Long": 87.818
	},
	{
		"Area": "Barakhama",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.3194,
		"Long": 84.0444
	},
	{
		"Area": "Baralutma",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.0789,
		"Long": 91.8987
	},
	{
		"Area": "Barama",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.54,
		"Long": 91.3877
	},
	{
		"Area": "Baramaidan",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 23.9225,
		"Long": 91.6031
	},
	{
		"Area": "Baramati",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 20.4907,
		"Long": 77.4313
	},
	{
		"Area": "Baramba",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.4901,
		"Long": 85.7057
	},
	{
		"Area": "Baramchari",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.5736,
		"Long": 91.3017
	},
	{
		"Area": "Baramulla",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 34.2319,
		"Long": 74.6565
	},
	{
		"Area": "Baran",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 25.599,
		"Long": 77.3551
	},
	{
		"Area": "Baranegui",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.5234,
		"Long": 87.6598
	},
	{
		"Area": "Barang",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.4712,
		"Long": 85.9172
	},
	{
		"Area": "Barangabari",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 27.4496,
		"Long": 94.2788
	},
	{
		"Area": "Barangi",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3836,
		"Long": 87.8747
	},
	{
		"Area": "Baranihary",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 21.8995,
		"Long": 87.5379
	},
	{
		"Area": "Barapali",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.2337,
		"Long": 83.5955
	},
	{
		"Area": "Barara",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 30.3285,
		"Long": 77.0981
	},
	{
		"Area": "Barasahi",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.0258,
		"Long": 85.1116
	},
	{
		"Area": "Barasat - I",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.8848,
		"Long": 88.5396
	},
	{
		"Area": "Barasat - II",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.6894,
		"Long": 88.4668
	},
	{
		"Area": "Baratala",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 21.8532,
		"Long": 87.9147
	},
	{
		"Area": "Baraudaypur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 21.9837,
		"Long": 87.635
	},
	{
		"Area": "Barauni",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.4709,
		"Long": 85.976
	},
	{
		"Area": "Baraut",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 29.282,
		"Long": 82.3193
	},
	{
		"Area": "Baraut **",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 29.1246,
		"Long": 77.3122
	},
	{
		"Area": "Barbari",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.477,
		"Long": 91.4874
	},
	{
		"Area": "Barbarua",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.5654,
		"Long": 94.0443
	},
	{
		"Area": "Barbaruah",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 27.3664,
		"Long": 95.0562
	},
	{
		"Area": "Barbigha",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.2735,
		"Long": 85.8289
	},
	{
		"Area": "Barbil",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 22.1131,
		"Long": 85.7051
	},
	{
		"Area": "Barda",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.3955,
		"Long": 75.9426
	},
	{
		"Area": "Bardez",
		"State": "Goa",
		"CountryCode": "IN",
		"Lat": 15.723,
		"Long": 73.9513
	},
	{
		"Area": "Bardhaman",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.105,
		"Long": 87.8869
	},
	{
		"Area": "Bardoli",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 21.8241,
		"Long": 74.2515
	},
	{
		"Area": "Bareilly",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.5502,
		"Long": 79.7005
	},
	{
		"Area": "Bareilly Ho",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.2431,
		"Long": 79.5552
	},
	{
		"Area": "Bareilly I",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.3099,
		"Long": 79.5067
	},
	{
		"Area": "Barengapara",
		"State": "Meghalaya",
		"CountryCode": "IN",
		"Lat": 25.5545,
		"Long": 90.3369
	},
	{
		"Area": "Baresei",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 26.8168,
		"Long": 77.6513
	},
	{
		"Area": "Baresri",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 26.4793,
		"Long": 77.3596
	},
	{
		"Area": "Bareta",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 30.4863,
		"Long": 75.4389
	},
	{
		"Area": "Bargam",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 33.9306,
		"Long": 75.1134
	},
	{
		"Area": "Bargaon",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 22.0798,
		"Long": 84.5106
	},
	{
		"Area": "Bargarh",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.4582,
		"Long": 83.8613
	},
	{
		"Area": "Bargarh Sadar",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.369,
		"Long": 83.699
	},
	{
		"Area": "Barghat",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.448,
		"Long": 79.8932
	},
	{
		"Area": "Barghorai",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.4948,
		"Long": 88.4232
	},
	{
		"Area": "Barh",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.4834,
		"Long": 85.8028
	},
	{
		"Area": "Barhait",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 25.0367,
		"Long": 87.6796
	},
	{
		"Area": "Barhaj",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.9308,
		"Long": 83.8366
	},
	{
		"Area": "Barhaj **",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.4227,
		"Long": 83.8366
	},
	{
		"Area": "Barhampur",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.6732,
		"Long": 84.3801
	},
	{
		"Area": "Barhara",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.7958,
		"Long": 84.647
	},
	{
		"Area": "Barharwa",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 25.0081,
		"Long": 87.8194
	},
	{
		"Area": "Barhat",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 24.96,
		"Long": 86.2936
	},
	{
		"Area": "Barhat",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3836,
		"Long": 87.8747
	},
	{
		"Area": "Barhi",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 24.2788,
		"Long": 85.5439
	},
	{
		"Area": "Barhit",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 25.0081,
		"Long": 87.6796
	},
	{
		"Area": "Barhiya",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.3325,
		"Long": 86.186
	},
	{
		"Area": "Bari",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 27.0625,
		"Long": 77.8636
	},
	{
		"Area": "Bari Sadari",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 25.6983,
		"Long": 75.4568
	},
	{
		"Area": "Bari Sadrai",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 24.9559,
		"Long": 74.6593
	},
	{
		"Area": "Bari Sadri",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 25.4116,
		"Long": 74.0986
	},
	{
		"Area": "Bariarpur",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.2955,
		"Long": 86.6524
	},
	{
		"Area": "Barida",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.2471,
		"Long": 87.8066
	},
	{
		"Area": "Barida Bazar",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 21.8995,
		"Long": 87.5379
	},
	{
		"Area": "Baridatara",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.477,
		"Long": 91.4874
	},
	{
		"Area": "Baridih Colony",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 23.5378,
		"Long": 85.9803
	},
	{
		"Area": "Baril",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.6652,
		"Long": 85.0891
	},
	{
		"Area": "Barimakha",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.3796,
		"Long": 91.2951
	},
	{
		"Area": "Barimukh",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.7706,
		"Long": 91.3933
	},
	{
		"Area": "Baripada",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 22.1801,
		"Long": 86.9427
	},
	{
		"Area": "Barisadari",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 25.6983,
		"Long": 75.4568
	},
	{
		"Area": "Barisadri",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 25.4116,
		"Long": 74.6593
	},
	{
		"Area": "Barjora",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.4756,
		"Long": 87.8906
	},
	{
		"Area": "Barkagaon",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 23.9065,
		"Long": 85.2872
	},
	{
		"Area": "Barkatha",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 24.2885,
		"Long": 85.6314
	},
	{
		"Area": "Barkhatha",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 24.2126,
		"Long": 85.619
	},
	{
		"Area": "Barkhera",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.6726,
		"Long": 79.9617
	},
	{
		"Area": "Barkhetri",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.7306,
		"Long": 91.5994
	},
	{
		"Area": "Barkoda",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.0799,
		"Long": 76.0612
	},
	{
		"Area": "Barkot",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.4716,
		"Long": 84.8037
	},
	{
		"Area": "Barkote",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.54,
		"Long": 85.0786
	},
	{
		"Area": "Barmakhal",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.5526,
		"Long": 88.4901
	},
	{
		"Area": "Barmer",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 26.1505,
		"Long": 72.8272
	},
	{
		"Area": "Barmer Ho",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 25.8479,
		"Long": 72.8272
	},
	{
		"Area": "Barmura",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.007,
		"Long": 91.6093
	},
	{
		"Area": "Barnagar",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 23.3317,
		"Long": 76.3895
	},
	{
		"Area": "Barnala",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 31.0358,
		"Long": 75.8063
	},
	{
		"Area": "Baro Sujapur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 25.1367,
		"Long": 88.0923
	},
	{
		"Area": "Barode",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 23.6833,
		"Long": 76.3458
	},
	{
		"Area": "Barodia Kumaria",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 23.7184,
		"Long": 76.4021
	},
	{
		"Area": "Baroh",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 32.0521,
		"Long": 76.3125
	},
	{
		"Area": "Baroh(T)",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 32.0348,
		"Long": 76.305
	},
	{
		"Area": "Barpali",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.2492,
		"Long": 83.687
	},
	{
		"Area": "Barpeta",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.6242,
		"Long": 91.5994
	},
	{
		"Area": "Barpetaroad",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.5028,
		"Long": 90.9694
	},
	{
		"Area": "Barpit",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.536,
		"Long": 91.4097
	},
	{
		"Area": "Barra",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.4302,
		"Long": 80.2963
	},
	{
		"Area": "Barrackpore",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.3945,
		"Long": 88.3917
	},
	{
		"Area": "Barrackpore Sripalli",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3578,
		"Long": 88.1922
	},
	{
		"Area": "Barrackpur - I",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.37,
		"Long": 88.7803
	},
	{
		"Area": "Barrackpur - II",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.5719,
		"Long": 88.394
	},
	{
		"Area": "Barsahi",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 22.3834,
		"Long": 86.7254
	},
	{
		"Area": "Barsar",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 31.7423,
		"Long": 76.9169
	},
	{
		"Area": "Barsar(T)",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 31.863,
		"Long": 76.5681
	},
	{
		"Area": "Barsashi",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.1075,
		"Long": 85.4405
	},
	{
		"Area": "Barshi",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 19.5631,
		"Long": 76.9466
	},
	{
		"Area": "Barshitakli",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 20.7184,
		"Long": 77.4151
	},
	{
		"Area": "Barsimlaguri",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.54,
		"Long": 91.3489
	},
	{
		"Area": "Barsoo",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 33.9942,
		"Long": 74.9835
	},
	{
		"Area": "Bartana",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 21.8995,
		"Long": 87.5379
	},
	{
		"Area": "Bartola",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.263,
		"Long": 91.3011
	},
	{
		"Area": "Baruakandi",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.0447,
		"Long": 91.7553
	},
	{
		"Area": "Baruat",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 29.1913,
		"Long": 77.3814
	},
	{
		"Area": "Barugur",
		"State": "Tamil Nadu",
		"CountryCode": "IN",
		"Lat": 12.6039,
		"Long": 78.2873
	},
	{
		"Area": "Baruipur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.7771,
		"Long": 88.7883
	},
	{
		"Area": "Barun",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 24.9491,
		"Long": 84.4504
	},
	{
		"Area": "Barunhat",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.5181,
		"Long": 88.9486
	},
	{
		"Area": "Barwadih",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 23.8478,
		"Long": 84.1398
	},
	{
		"Area": "Barwaha",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 24.1277,
		"Long": 76.7437
	},
	{
		"Area": "Barwala",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 22.71,
		"Long": 74.1152
	},
	{
		"Area": "Barwani",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.0644,
		"Long": 75.2089
	},
	{
		"Area": "Basai",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.1729,
		"Long": 76.1432
	},
	{
		"Area": "Basai Road",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.418,
		"Long": 76.9839
	},
	{
		"Area": "Basanti",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3862,
		"Long": 88.6875
	},
	{
		"Area": "Basantia",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 21.7907,
		"Long": 87.8635
	},
	{
		"Area": "Basantpur",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 26.5082,
		"Long": 87.3367
	},
	{
		"Area": "Basar",
		"State": "Arunachal Pradesh",
		"CountryCode": "IN",
		"Lat": 27.9901,
		"Long": 94.6945
	},
	{
		"Area": "Basavakalyan",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 18.3686,
		"Long": 77.4539
	},
	{
		"Area": "Basavana Bagevadi",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 16.7453,
		"Long": 76.3537
	},
	{
		"Area": "Basbatori",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.1769,
		"Long": 76.5079
	},
	{
		"Area": "Basduda",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.1673,
		"Long": 76.4131
	},
	{
		"Area": "Basduevpur",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.6241,
		"Long": 85.2842
	},
	{
		"Area": "Baseri",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 26.6808,
		"Long": 77.7033
	},
	{
		"Area": "Basgaob",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.502,
		"Long": 83.3684
	},
	{
		"Area": "Basgaon",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.6631,
		"Long": 83.4929
	},
	{
		"Area": "Bashirpur",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.0799,
		"Long": 76.0612
	},
	{
		"Area": "Bashohli",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 32.9706,
		"Long": 75.5938
	},
	{
		"Area": "Basia",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 23.0049,
		"Long": 84.8638
	},
	{
		"Area": "Basirhat",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.6632,
		"Long": 88.823
	},
	{
		"Area": "Basirhat - I",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.0289,
		"Long": 88.9039
	},
	{
		"Area": "Basirhat - II",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.6247,
		"Long": 88.5454
	},
	{
		"Area": "Basllia",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 25.8327,
		"Long": 84.2314
	},
	{
		"Area": "Basmath",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 19.8298,
		"Long": 77.1189
	},
	{
		"Area": "Basmathnagar",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 19.4708,
		"Long": 76.6551
	},
	{
		"Area": "Basna",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 21.3636,
		"Long": 83.0111
	},
	{
		"Area": "Basoda",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 24.0398,
		"Long": 78.2042
	},
	{
		"Area": "Basoli",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 32.9338,
		"Long": 75.8142
	},
	{
		"Area": "Basopatti",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 26.2711,
		"Long": 86.0921
	},
	{
		"Area": "Bassein",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 19.4191,
		"Long": 72.9126
	},
	{
		"Area": "Bassi",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 30.7036,
		"Long": 76.3845
	},
	{
		"Area": "Bassi",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 26.8561,
		"Long": 76.5139
	},
	{
		"Area": "Bassi Pathana",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 30.5243,
		"Long": 76.7021
	},
	{
		"Area": "Basta",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.8144,
		"Long": 87.2314
	},
	{
		"Area": "Basti",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 27.1356,
		"Long": 83.0786
	},
	{
		"Area": "Basti East",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.8518,
		"Long": 82.726
	},
	{
		"Area": "Basti Sadar",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.9509,
		"Long": 83.0786
	},
	{
		"Area": "Basudebberia",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.3444,
		"Long": 87.9089
	},
	{
		"Area": "Basudebpur",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.7955,
		"Long": 86.8965
	},
	{
		"Area": "Basudebpur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 21.8201,
		"Long": 87.6292
	},
	{
		"Area": "Basudevpur",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.6304,
		"Long": 86.8998
	},
	{
		"Area": "Basuli Bazar",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.0093,
		"Long": 87.7037
	},
	{
		"Area": "Batagund",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 33.9509,
		"Long": 75.0932
	},
	{
		"Area": "Batala",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 32.0242,
		"Long": 75.5058
	},
	{
		"Area": "Bathalapalle",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 14.5453,
		"Long": 78.2141
	},
	{
		"Area": "Bathalapalli",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 14.7011,
		"Long": 77.969
	},
	{
		"Area": "Bathani",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 24.9722,
		"Long": 85.2735
	},
	{
		"Area": "Bathinda",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 30.4262,
		"Long": 75.0969
	},
	{
		"Area": "Bathnaha",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 26.6433,
		"Long": 85.6152
	},
	{
		"Area": "Bathnoor",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 33.9306,
		"Long": 75.1134
	},
	{
		"Area": "Bathuary",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3159,
		"Long": 88.0212
	},
	{
		"Area": "Batiyagarh",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 24.2505,
		"Long": 79.6601
	},
	{
		"Area": "Batpora",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 33.7648,
		"Long": 74.8905
	},
	{
		"Area": "Batrara",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 33.8359,
		"Long": 74.8589
	},
	{
		"Area": "Battala",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.5034,
		"Long": 87.9832
	},
	{
		"Area": "Baund",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.7792,
		"Long": 76.3416
	},
	{
		"Area": "Bausar",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.2867,
		"Long": 80.4378
	},
	{
		"Area": "Bausi",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.0622,
		"Long": 87.076
	},
	{
		"Area": "Bavla",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 23.0714,
		"Long": 72.6953
	},
	{
		"Area": "Bawal",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.1729,
		"Long": 76.1432
	},
	{
		"Area": "Bawana",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.3721,
		"Long": 76.1857
	},
	{
		"Area": "Bawani Khera",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 29.0466,
		"Long": 76.1138
	},
	{
		"Area": "Bawania",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.3732,
		"Long": 76.8881
	},
	{
		"Area": "Bawanikhera",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.9719,
		"Long": 76.1006
	},
	{
		"Area": "Bawngkawn",
		"State": "Mizoram",
		"CountryCode": "IN",
		"Lat": 23.8005,
		"Long": 92.7342
	},
	{
		"Area": "Bawwa",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.4146,
		"Long": 76.3674
	},
	{
		"Area": "Bayad",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 23.6593,
		"Long": 73.5401
	},
	{
		"Area": "Bayal",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 29.3043,
		"Long": 77.0492
	},
	{
		"Area": "Bayana",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 27.2457,
		"Long": 77.4475
	},
	{
		"Area": "Bayana Mdg",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 27.7102,
		"Long": 77.7118
	},
	{
		"Area": "Bayenda",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.0093,
		"Long": 87.7037
	},
	{
		"Area": "Bayyaram",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 18.3021,
		"Long": 81.0042
	},
	{
		"Area": "Bazarhathnoor",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 19.4273,
		"Long": 78.4151
	},
	{
		"Area": "Bazpur",
		"State": "Uttarakhand",
		"CountryCode": "IN",
		"Lat": 29.3158,
		"Long": 79.385
	},
	{
		"Area": "Bb",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 17.3574,
		"Long": 79.0324
	},
	{
		"Area": "Bdh",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 30.0517,
		"Long": 75.6795
	},
	{
		"Area": "Beara",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.1828,
		"Long": 88.7963
	},
	{
		"Area": "Beas",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 31.7046,
		"Long": 74.9007
	},
	{
		"Area": "Beawar",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 26.4107,
		"Long": 75.0912
	},
	{
		"Area": "Becharaji",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 23.609,
		"Long": 72.4619
	},
	{
		"Area": "Bedeti",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.971,
		"Long": 93.8695
	},
	{
		"Area": "Bediadanga",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.5668,
		"Long": 88.3016
	},
	{
		"Area": "Beed",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 20.0435,
		"Long": 77.9838
	},
	{
		"Area": "Beejadandi",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.9037,
		"Long": 80.046
	},
	{
		"Area": "Beerwah",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 34.0716,
		"Long": 74.663
	},
	{
		"Area": "Begamganj",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 23.7042,
		"Long": 78.8991
	},
	{
		"Area": "Begarwani",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.5226,
		"Long": 79.8042
	},
	{
		"Area": "Begumpur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.6165,
		"Long": 88.5454
	},
	{
		"Area": "Begun",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 25.3463,
		"Long": 75.1
	},
	{
		"Area": "Begunia",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.8923,
		"Long": 87.3704
	},
	{
		"Area": "Begunia",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.7867,
		"Long": 85.5114
	},
	{
		"Area": "Begusarai",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.7653,
		"Long": 86.7963
	},
	{
		"Area": "Begusarai H.o",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.5495,
		"Long": 86.1527
	},
	{
		"Area": "Behalabari",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.0796,
		"Long": 91.5997
	},
	{
		"Area": "Behali",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.8325,
		"Long": 93.3452
	},
	{
		"Area": "Behali",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.2242,
		"Long": 76.5554
	},
	{
		"Area": "Behat",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 30.3173,
		"Long": 78.6641
	},
	{
		"Area": "Behea",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.5434,
		"Long": 84.8026
	},
	{
		"Area": "Behibagh",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 33.9563,
		"Long": 74.834
	},
	{
		"Area": "Behrampore",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.9685,
		"Long": 87.8257
	},
	{
		"Area": "Behror",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 27.6573,
		"Long": 76.597
	},
	{
		"Area": "Behta Gambhirpur",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.2608,
		"Long": 80.3204
	},
	{
		"Area": "Bejjanki",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 18.5497,
		"Long": 79.2436
	},
	{
		"Area": "Bejjur",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 18.8274,
		"Long": 79.2002
	},
	{
		"Area": "Bela",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 19.6348,
		"Long": 78.6893
	},
	{
		"Area": "Bela",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 30.9274,
		"Long": 76.4078
	},
	{
		"Area": "Belaganj",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.1872,
		"Long": 85.1867
	},
	{
		"Area": "Belcherra",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.0796,
		"Long": 91.5997
	},
	{
		"Area": "Belchi",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.4564,
		"Long": 85.7904
	},
	{
		"Area": "Belchi Sharif",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.2773,
		"Long": 85.5858
	},
	{
		"Area": "Belda",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.0843,
		"Long": 87.352
	},
	{
		"Area": "Beldanga",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.9685,
		"Long": 87.8257
	},
	{
		"Area": "Beldanga - I",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 25.0597,
		"Long": 88.0651
	},
	{
		"Area": "Beldanga - II",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.3535,
		"Long": 88.1958
	},
	{
		"Area": "Beldaur",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.5263,
		"Long": 86.7346
	},
	{
		"Area": "Beleghata",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.8436,
		"Long": 88.2293
	},
	{
		"Area": "Belgahana",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 22.5539,
		"Long": 82.2221
	},
	{
		"Area": "Belgahna",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 22.374,
		"Long": 82.2221
	},
	{
		"Area": "Belgaum",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 16.1195,
		"Long": 75.4038
	},
	{
		"Area": "Belgharia",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.3945,
		"Long": 88.2559
	},
	{
		"Area": "Belhar",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.0641,
		"Long": 86.8409
	},
	{
		"Area": "Bellamkonda",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 16.6774,
		"Long": 80.0426
	},
	{
		"Area": "Bellampalle",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 19.0558,
		"Long": 79.493
	},
	{
		"Area": "Bellandur",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 13.0907,
		"Long": 77.6423
	},
	{
		"Area": "Bellary",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 15.5754,
		"Long": 77.1143
	},
	{
		"Area": "Belmula",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.6315,
		"Long": 87.428
	},
	{
		"Area": "Beloniya",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 23.2518,
		"Long": 91.4541
	},
	{
		"Area": "Belpahar",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.8218,
		"Long": 83.8458
	},
	{
		"Area": "Belpur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.7067,
		"Long": 88.6786
	},
	{
		"Area": "Belsand",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 26.576,
		"Long": 85.5397
	},
	{
		"Area": "Belsar",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.9904,
		"Long": 85.2378
	},
	{
		"Area": "Belsor",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.3703,
		"Long": 91.3481
	},
	{
		"Area": "Belta",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.8451,
		"Long": 88.5958
	},
	{
		"Area": "Beltangadi",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 13.0248,
		"Long": 75.4035
	},
	{
		"Area": "Belthagady",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 13.0248,
		"Long": 75.3888
	},
	{
		"Area": "Belthangady",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 13.1924,
		"Long": 75.4875
	},
	{
		"Area": "Belthra Road",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 25.7467,
		"Long": 84.1931
	},
	{
		"Area": "Beluguppa",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 14.7416,
		"Long": 77.9311
	},
	{
		"Area": "Belur",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 13.2498,
		"Long": 76.3854
	},
	{
		"Area": "Bemetara",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 21.9278,
		"Long": 81.65
	},
	{
		"Area": "Ben",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.2277,
		"Long": 85.4559
	},
	{
		"Area": "Bena",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.5103,
		"Long": 88.9361
	},
	{
		"Area": "Benachakri",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 21.8995,
		"Long": 87.5379
	},
	{
		"Area": "Benadiha",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.4364,
		"Long": 87.9624
	},
	{
		"Area": "Bene",
		"State": "Arunachal Pradesh",
		"CountryCode": "IN",
		"Lat": 28.2358,
		"Long": 94.6742
	},
	{
		"Area": "Bengabad",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 24.4381,
		"Long": 86.4015
	},
	{
		"Area": "Bengabd",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 24.0914,
		"Long": 86.1201
	},
	{
		"Area": "Bengaluru",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 13.0187,
		"Long": 77.5673
	},
	{
		"Area": "Bengtal",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.5807,
		"Long": 91.4583
	},
	{
		"Area": "Bengtol",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.5807,
		"Long": 91.4583
	},
	{
		"Area": "Beniadih",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 24.1803,
		"Long": 86.2631
	},
	{
		"Area": "Benichak",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 21.7907,
		"Long": 87.8635
	},
	{
		"Area": "Beniipur]",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 26.1188,
		"Long": 86.1721
	},
	{
		"Area": "Benipatti",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 26.5666,
		"Long": 86.3959
	},
	{
		"Area": "Beniptti",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 26.4353,
		"Long": 85.6648
	},
	{
		"Area": "Benipur",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 26.2123,
		"Long": 86.2813
	},
	{
		"Area": "Benipur]",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 26.0065,
		"Long": 86.2509
	},
	{
		"Area": "Bennabari",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.3796,
		"Long": 91.2951
	},
	{
		"Area": "Beohari",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 24.2328,
		"Long": 81.4728
	},
	{
		"Area": "Berabari",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.3294,
		"Long": 87.9528
	},
	{
		"Area": "Beraberi",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.8712,
		"Long": 88.5674
	},
	{
		"Area": "Berchha",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 23.2819,
		"Long": 76.3515
	},
	{
		"Area": "Bergoom",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.1383,
		"Long": 88.2387
	},
	{
		"Area": "Berhampore",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.7341,
		"Long": 88.2538
	},
	{
		"Area": "Berhampur",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.2159,
		"Long": 85.0853
	},
	{
		"Area": "Berhampurf",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.043,
		"Long": 84.6615
	},
	{
		"Area": "Beri",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.1729,
		"Long": 76.1432
	},
	{
		"Area": "Berinag",
		"State": "Uttarakhand",
		"CountryCode": "IN",
		"Lat": 30.1119,
		"Long": 80.3477
	},
	{
		"Area": "Berla",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 21.7395,
		"Long": 81.5971
	},
	{
		"Area": "Bermajur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3687,
		"Long": 88.562
	},
	{
		"Area": "Bermo",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 24.359,
		"Long": 86.3127
	},
	{
		"Area": "Bero",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 23.3313,
		"Long": 85.3708
	},
	{
		"Area": "Besesria",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.6833,
		"Long": 92.65
	},
	{
		"Area": "Besseria",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.6833,
		"Long": 92.65
	},
	{
		"Area": "Bestawaripeta",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 15.6213,
		"Long": 79.5158
	},
	{
		"Area": "Betal Ghat",
		"State": "Uttarakhand",
		"CountryCode": "IN",
		"Lat": 29.5589,
		"Long": 79.341
	},
	{
		"Area": "Betalghat",
		"State": "Uttarakhand",
		"CountryCode": "IN",
		"Lat": 29.5694,
		"Long": 79.3523
	},
	{
		"Area": "Betcherra",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.1597,
		"Long": 92.0329
	},
	{
		"Area": "Betchesrra",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.1597,
		"Long": 92.0329
	},
	{
		"Area": "Bethamcherla",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 15.6004,
		"Long": 78.0972
	},
	{
		"Area": "Bethuadahari",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.3019,
		"Long": 87.8172
	},
	{
		"Area": "Betnoti",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 22.0034,
		"Long": 86.9116
	},
	{
		"Area": "Bettiah",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 27.2496,
		"Long": 84.7136
	},
	{
		"Area": "Bettiah H.o.",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 27.0083,
		"Long": 84.7145
	},
	{
		"Area": "Betul",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.2745,
		"Long": 78.2014
	},
	{
		"Area": "Bewal",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.2242,
		"Long": 76.5554
	},
	{
		"Area": "Bewar",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 26.0285,
		"Long": 74.3277
	},
	{
		"Area": "Bezera Block",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.45,
		"Long": 91.985
	},
	{
		"Area": "Bg North",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 13.2257,
		"Long": 77.6169
	},
	{
		"Area": "Bg South",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 13.1303,
		"Long": 77.7495
	},
	{
		"Area": "Bgnorth",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 13.1125,
		"Long": 77.6611
	},
	{
		"Area": "Bgsouth",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 13.2381,
		"Long": 77.9374
	},
	{
		"Area": "Bhabanipur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.4653,
		"Long": 88.7803
	},
	{
		"Area": "Bhabhar",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 24.2835,
		"Long": 72.0319
	},
	{
		"Area": "Bhabua",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.1195,
		"Long": 83.8548
	},
	{
		"Area": "Bhabuaa",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 24.8531,
		"Long": 83.6269
	},
	{
		"Area": "Bhachau",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 23.8326,
		"Long": 70.6438
	},
	{
		"Area": "Bhaderwah",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 33.0255,
		"Long": 75.7172
	},
	{
		"Area": "Bhadesar",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 25.1959,
		"Long": 74.7797
	},
	{
		"Area": "Bhadgaon",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 20.9355,
		"Long": 75.4899
	},
	{
		"Area": "Bhadohi",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 25.9845,
		"Long": 82.6449
	},
	{
		"Area": "Bhadra",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.3679,
		"Long": 91.3877
	},
	{
		"Area": "Bhadra",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 29.51,
		"Long": 75.4124
	},
	{
		"Area": "Bhadrachalam",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 18.0476,
		"Long": 80.9408
	},
	{
		"Area": "Bhadrak",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.0864,
		"Long": 86.6254
	},
	{
		"Area": "Bhadrak Rural",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.5203,
		"Long": 86.6254
	},
	{
		"Area": "Bhadrakali",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.3029,
		"Long": 87.818
	},
	{
		"Area": "Bhadravaathi",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 14.0436,
		"Long": 75.2207
	},
	{
		"Area": "Bhadravathi",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 15.2212,
		"Long": 76.2965
	},
	{
		"Area": "Bhadravathii",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 13.84,
		"Long": 75.6022
	},
	{
		"Area": "Bhadravati",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 15.2212,
		"Long": 76.2965
	},
	{
		"Area": "Bhadrawati",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 20.5062,
		"Long": 79.4438
	},
	{
		"Area": "Bhadrsa",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.3801,
		"Long": 80.4141
	},
	{
		"Area": "Bhaduria",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.5239,
		"Long": 87.8703
	},
	{
		"Area": "Bhagabannagar",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.0789,
		"Long": 91.8987
	},
	{
		"Area": "Bhagalpur",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.2982,
		"Long": 86.7475
	},
	{
		"Area": "Bhagawangola - I",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.3321,
		"Long": 88.058
	},
	{
		"Area": "Bhagawangola - II",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.5109,
		"Long": 88.231
	},
	{
		"Area": "Bhagawanpur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.3588,
		"Long": 88.0631
	},
	{
		"Area": "Bhagawanpur-ii",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.198,
		"Long": 87.9301
	},
	{
		"Area": "Bhagawanpura",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 21.6095,
		"Long": 75.7265
	},
	{
		"Area": "Bhagha Purana",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 30.77,
		"Long": 75.7763
	},
	{
		"Area": "Bhaghadari",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.0093,
		"Long": 87.7037
	},
	{
		"Area": "Bhaghwanpur",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.8468,
		"Long": 85.3564
	},
	{
		"Area": "Bhagirathpara",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.0789,
		"Long": 91.8987
	},
	{
		"Area": "Bhagta Bhai",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 30.4907,
		"Long": 75.1361
	},
	{
		"Area": "Bhagwanpur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.3588,
		"Long": 87.8041
	},
	{
		"Area": "Bhagwanpur",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.9427,
		"Long": 85.37
	},
	{
		"Area": "Bhagwanpur Hat",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 26.1218,
		"Long": 84.7643
	},
	{
		"Area": "Bhagwanpura",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 21.9362,
		"Long": 76.5714
	},
	{
		"Area": "Bhagwarpur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.6606,
		"Long": 88.0631
	},
	{
		"Area": "Bhagyamantapur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.3733,
		"Long": 88.2391
	},
	{
		"Area": "Bhagyapur",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.0447,
		"Long": 91.7553
	},
	{
		"Area": "Bhai Rupa",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 30.4274,
		"Long": 75.2738
	},
	{
		"Area": "Bhaini Bagha",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 30.3673,
		"Long": 75.4389
	},
	{
		"Area": "Bhainsa",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 19.4968,
		"Long": 78.8306
	},
	{
		"Area": "Bhainsdehi",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.1406,
		"Long": 78.1614
	},
	{
		"Area": "Bhairabkunda",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.7198,
		"Long": 91.9902
	},
	{
		"Area": "Bhairabsingipur",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 19.3596,
		"Long": 82.7213
	},
	{
		"Area": "Bhairamgarh",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 19.0064,
		"Long": 81.1842
	},
	{
		"Area": "Bhairampur",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.3805,
		"Long": 80.2158
	},
	{
		"Area": "Bhaisma",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 22.5323,
		"Long": 83.0751
	},
	{
		"Area": "Bhajachauli",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.871,
		"Long": 88.0316
	},
	{
		"Area": "Bhakarapet",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 13.4673,
		"Long": 79.0143
	},
	{
		"Area": "Bhakatpara",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.743,
		"Long": 93.2247
	},
	{
		"Area": "Bhakli",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.4165,
		"Long": 76.4754
	},
	{
		"Area": "Bhalei",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 32.676,
		"Long": 76.0263
	},
	{
		"Area": "Bhalessa (Gandoh)",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 33.0741,
		"Long": 75.603
	},
	{
		"Area": "Bhalki",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 18.1445,
		"Long": 77.3891
	},
	{
		"Area": "Bhallai",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 32.5095,
		"Long": 76.3507
	},
	{
		"Area": "Bhalukpong",
		"State": "Arunachal Pradesh",
		"CountryCode": "IN",
		"Lat": 27.3143,
		"Long": 92.3716
	},
	{
		"Area": "Bhamani Mandal",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 18.7953,
		"Long": 83.874
	},
	{
		"Area": "Bhamini",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 18.9519,
		"Long": 83.8963
	},
	{
		"Area": "Bhamini Mandal",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 18.9643,
		"Long": 83.8675
	},
	{
		"Area": "Bhamora",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.4494,
		"Long": 79.4223
	},
	{
		"Area": "Bhamragadh",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 19.4182,
		"Long": 80.4776
	},
	{
		"Area": "Bhandair",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 25.8505,
		"Long": 78.746
	},
	{
		"Area": "Bhandara",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 21.2316,
		"Long": 79.9317
	},
	{
		"Area": "Bhandara",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 23.3772,
		"Long": 85.4379
	},
	{
		"Area": "Bhandarhati",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.9282,
		"Long": 88.1015
	},
	{
		"Area": "Bhandari",
		"State": "Nagaland",
		"CountryCode": "IN",
		"Lat": 25.662,
		"Long": 94.1084
	},
	{
		"Area": "Bhandari Pokhari",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.5203,
		"Long": 85.9726
	},
	{
		"Area": "Bhandarra",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 21.1557,
		"Long": 79.6177
	},
	{
		"Area": "Bhander",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 25.8505,
		"Long": 78.6956
	},
	{
		"Area": "Bhanderhati",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.8808,
		"Long": 88.0924
	},
	{
		"Area": "Bhanderkhali",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.4323,
		"Long": 88.373
	},
	{
		"Area": "Bhanderkhola",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.8451,
		"Long": 88.5958
	},
	{
		"Area": "Bhandra",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 23.4789,
		"Long": 85.3708
	},
	{
		"Area": "Bhangar",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.5239,
		"Long": 88.6093
	},
	{
		"Area": "Bhangar - I",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3916,
		"Long": 88.503
	},
	{
		"Area": "Bhangar - II",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.5864,
		"Long": 88.503
	},
	{
		"Area": "Bhangatushkhali",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3484,
		"Long": 88.8997
	},
	{
		"Area": "Bhangmun",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.1597,
		"Long": 92.0329
	},
	{
		"Area": "Bhanjanagar",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.5228,
		"Long": 85.1448
	},
	{
		"Area": "Bhanoli",
		"State": "Uttarakhand",
		"CountryCode": "IN",
		"Lat": 29.7745,
		"Long": 79.9881
	},
	{
		"Area": "Bhanpur",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 27.0955,
		"Long": 82.8918
	},
	{
		"Area": "Bhanpur (sonha)",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 27.0369,
		"Long": 82.7167
	},
	{
		"Area": "Bhanpur Baboo",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.9556,
		"Long": 82.7635
	},
	{
		"Area": "Bhanpur Babu",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.9575,
		"Long": 82.7984
	},
	{
		"Area": "Bhanpur)sonha)",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 27.3364,
		"Long": 82.6561
	},
	{
		"Area": "Bhanpura",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 24.5413,
		"Long": 76.2046
	},
	{
		"Area": "Bhanupali",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 31.0954,
		"Long": 75.7016
	},
	{
		"Area": "Bhanupratappur",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 20.3888,
		"Long": 81.0976
	},
	{
		"Area": "Bhanupratappur4",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 20.2657,
		"Long": 80.9748
	},
	{
		"Area": "Bhanvad",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 22.6925,
		"Long": 71.827
	},
	{
		"Area": "Bhaoranj",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 31.8209,
		"Long": 76.4944
	},
	{
		"Area": "Bhapur",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.3401,
		"Long": 85.3
	},
	{
		"Area": "Bharaf",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.3119,
		"Long": 76.3262
	},
	{
		"Area": "Bharat Nagar Chowk",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 31.3267,
		"Long": 75.6916
	},
	{
		"Area": "Bharatgarh",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 31.0982,
		"Long": 76.6098
	},
	{
		"Area": "Bharatpur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.5022,
		"Long": 88.5404
	},
	{
		"Area": "Bharatpur",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 27.7731,
		"Long": 77.7331
	},
	{
		"Area": "Bharatpur - I",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.6125,
		"Long": 87.8092
	},
	{
		"Area": "Bharatpur - II",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.9685,
		"Long": 87.8257
	},
	{
		"Area": "Bharatsardarbari",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.019,
		"Long": 91.625
	},
	{
		"Area": "Bharghat",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.1305,
		"Long": 79.7481
	},
	{
		"Area": "Bharmour",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 32.6775,
		"Long": 76.5893
	},
	{
		"Area": "Bharno",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 23.2204,
		"Long": 84.8891
	},
	{
		"Area": "Bharthana",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 27.3061,
		"Long": 79.8479
	},
	{
		"Area": "Bharthna",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.998,
		"Long": 79.2869
	},
	{
		"Area": "Bhartipur",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.6404,
		"Long": 80.5134
	},
	{
		"Area": "Bharu",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.3325,
		"Long": 80.3211
	},
	{
		"Area": "Bharuch",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 23.1192,
		"Long": 73.7111
	},
	{
		"Area": "Bharwain",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 31.8587,
		"Long": 76.227
	},
	{
		"Area": "Bharwain(S.T)",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 31.8003,
		"Long": 76.3112
	},
	{
		"Area": "Bhasila",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.6856,
		"Long": 88.4668
	},
	{
		"Area": "Bhasma",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 22.0798,
		"Long": 84.8555
	},
	{
		"Area": "Bhasra",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.4364,
		"Long": 87.9624
	},
	{
		"Area": "Bhatapara",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 21.8542,
		"Long": 82.3172
	},
	{
		"Area": "Bhatar",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.1564,
		"Long": 88.3634
	},
	{
		"Area": "Bhatda",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3159,
		"Long": 88.0212
	},
	{
		"Area": "Bhater",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.6319,
		"Long": 88.202
	},
	{
		"Area": "Bhatgaon",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 21.6666,
		"Long": 82.9302
	},
	{
		"Area": "Bhatiyat",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 32.6987,
		"Long": 76.3542
	},
	{
		"Area": "Bhatkal",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 14.7941,
		"Long": 74.8207
	},
	{
		"Area": "Bhatkuli",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 21.086,
		"Long": 77.7046
	},
	{
		"Area": "Bhatli",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.5177,
		"Long": 83.6857
	},
	{
		"Area": "Bhatpachlana",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 24.4106,
		"Long": 79.0409
	},
	{
		"Area": "Bhatpar Rani",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.4254,
		"Long": 84.1383
	},
	{
		"Area": "Bhatpar Rani **",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.2364,
		"Long": 84.0383
	},
	{
		"Area": "Bhatpara",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.8664,
		"Long": 88.4011
	},
	{
		"Area": "Bhatparrani",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.4136,
		"Long": 84.0666
	},
	{
		"Area": "Bhatpsar Rani",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.4227,
		"Long": 83.8366
	},
	{
		"Area": "Bhatsana",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.1749,
		"Long": 76.7553
	},
	{
		"Area": "Bhattiprole",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 16.1209,
		"Long": 79.6508
	},
	{
		"Area": "Bhattiprolu",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 16.2988,
		"Long": 80.7807
	},
	{
		"Area": "Bhatwari",
		"State": "Uttarakhand",
		"CountryCode": "IN",
		"Lat": 31.0333,
		"Long": 79.1165
	},
	{
		"Area": "Bhaungerka",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 29.3043,
		"Long": 77.0492
	},
	{
		"Area": "Bhaupratappur",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 20.1916,
		"Long": 81.1167
	},
	{
		"Area": "Bhauti Pratappur",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.6874,
		"Long": 79.9367
	},
	{
		"Area": "Bhavani",
		"State": "Tamil Nadu",
		"CountryCode": "IN",
		"Lat": 11.6808,
		"Long": 77.7659
	},
	{
		"Area": "Bhavi",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 26.7508,
		"Long": 73.6055
	},
	{
		"Area": "Bhavnagar",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 22.9013,
		"Long": 72.9807
	},
	{
		"Area": "Bhavra",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.3138,
		"Long": 74.5639
	},
	{
		"Area": "Bhawanathpur",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 24.119,
		"Long": 83.9687
	},
	{
		"Area": "Bhawaniaptna",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 19.9606,
		"Long": 83.2228
	},
	{
		"Area": "Bhawanichak",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.4305,
		"Long": 87.4447
	},
	{
		"Area": "Bhawanipatana",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 19.9761,
		"Long": 83.2292
	},
	{
		"Area": "Bhawanipatna",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.3562,
		"Long": 83.4577
	},
	{
		"Area": "Bhawanipur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.4653,
		"Long": 88.7803
	},
	{
		"Area": "Bhawanpur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.6606,
		"Long": 88.0631
	},
	{
		"Area": "Bhdesar",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 24.5651,
		"Long": 73.8896
	},
	{
		"Area": "Bhdra",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 29.0232,
		"Long": 74.9727
	},
	{
		"Area": "Bhebia",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.6389,
		"Long": 88.746
	},
	{
		"Area": "Bheden",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.5731,
		"Long": 84.3305
	},
	{
		"Area": "Bheemadevarpalle",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 18.3038,
		"Long": 79.4892
	},
	{
		"Area": "Bheemgal",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 18.6891,
		"Long": 78.5006
	},
	{
		"Area": "Bheemunipatnam",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 18.0849,
		"Long": 83.2936
	},
	{
		"Area": "Bhella",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.2989,
		"Long": 91.076
	},
	{
		"Area": "Bhensrorgarh",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 25.096,
		"Long": 74.9658
	},
	{
		"Area": "Bheoli",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.3805,
		"Long": 80.2158
	},
	{
		"Area": "Bhesan",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 21.5521,
		"Long": 70.7073
	},
	{
		"Area": "Bhgaon",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 27.1079,
		"Long": 79.2863
	},
	{
		"Area": "Bhikangaon",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.166,
		"Long": 76.6198
	},
	{
		"Area": "Bhikhiwind",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 31.7046,
		"Long": 74.9007
	},
	{
		"Area": "Bhikia Sain",
		"State": "Uttarakhand",
		"CountryCode": "IN",
		"Lat": 29.5992,
		"Long": 79.1015
	},
	{
		"Area": "Bhikiyasen",
		"State": "Uttarakhand",
		"CountryCode": "IN",
		"Lat": 29.9137,
		"Long": 79.3718
	},
	{
		"Area": "Bhiknoor",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 18.443,
		"Long": 78.5019
	},
	{
		"Area": "Bhiloda",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 23.8656,
		"Long": 73.7897
	},
	{
		"Area": "Bhilwara",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 26.0488,
		"Long": 75.4297
	},
	{
		"Area": "Bhim",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 25.4112,
		"Long": 73.9529
	},
	{
		"Area": "Bhimadole",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 16.8993,
		"Long": 81.385
	},
	{
		"Area": "Bhimavaram",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 16.8327,
		"Long": 81.5074
	},
	{
		"Area": "Bhimavaram (mdl)",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 16.5259,
		"Long": 81.5388
	},
	{
		"Area": "Bhimavaram(mdl)",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 16.475,
		"Long": 81.5855
	},
	{
		"Area": "Bhimeswaribazar",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3836,
		"Long": 87.8747
	},
	{
		"Area": "Bhimsen",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.4221,
		"Long": 80.2225
	},
	{
		"Area": "Bhimtal",
		"State": "Uttarakhand",
		"CountryCode": "IN",
		"Lat": 29.5193,
		"Long": 79.486
	},
	{
		"Area": "Bhina",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 26.0389,
		"Long": 74.7792
	},
	{
		"Area": "Bhinai",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 26.2028,
		"Long": 75.3157
	},
	{
		"Area": "Bhind",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 26.7515,
		"Long": 79.0814
	},
	{
		"Area": "Bhinder",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 25.353,
		"Long": 74.9059
	},
	{
		"Area": "Bhinga",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 27.8032,
		"Long": 82.2461
	},
	{
		"Area": "Bhinmal",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 25.1843,
		"Long": 74.367
	},
	{
		"Area": "Bhipur",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.3365,
		"Long": 86.9266
	},
	{
		"Area": "Bhitarwar",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 26.0114,
		"Long": 78.2196
	},
	{
		"Area": "Bhiwandi",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 20.018,
		"Long": 73.4096
	},
	{
		"Area": "Bhiwani",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 29.0425,
		"Long": 76.3051
	},
	{
		"Area": "Bhiwapur",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 21.1763,
		"Long": 79.5733
	},
	{
		"Area": "Bhogaon",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 27.3436,
		"Long": 79.3701
	},
	{
		"Area": "Bhogapuram",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 18.5002,
		"Long": 83.5486
	},
	{
		"Area": "Bhogpur",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 27.169,
		"Long": 94.1258
	},
	{
		"Area": "Bhograi",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.7537,
		"Long": 87.4622
	},
	{
		"Area": "Bhojawas",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.3732,
		"Long": 76.8881
	},
	{
		"Area": "Bhojipura",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.4494,
		"Long": 79.4223
	},
	{
		"Area": "Bhojpur",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.498,
		"Long": 84.4386
	},
	{
		"Area": "Bhojudih",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 23.8971,
		"Long": 86.4412
	},
	{
		"Area": "Bhokar",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 19.9708,
		"Long": 78.2303
	},
	{
		"Area": "Bhokardan",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 20.4628,
		"Long": 75.9819
	},
	{
		"Area": "Bholaganj Bazar",
		"State": "Meghalaya",
		"CountryCode": "IN",
		"Lat": 25.6019,
		"Long": 91.9144
	},
	{
		"Area": "Bholardan",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 20.3759,
		"Long": 75.9321
	},
	{
		"Area": "Bholath",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 31.3844,
		"Long": 75.4182
	},
	{
		"Area": "Bhondsi",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 27.9738,
		"Long": 76.9248
	},
	{
		"Area": "Bhongaon",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 27.3935,
		"Long": 79.3925
	},
	{
		"Area": "Bhongir",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 18.1631,
		"Long": 79.267
	},
	{
		"Area": "Bhongiri",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 17.4121,
		"Long": 79.1617
	},
	{
		"Area": "Bhoom",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 20.1863,
		"Long": 76.3884
	},
	{
		"Area": "Bhootpur",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 16.6274,
		"Long": 77.9341
	},
	{
		"Area": "Bhopal",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 24.1137,
		"Long": 79.7572
	},
	{
		"Area": "Bhopalgarh",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 26.8121,
		"Long": 73.5195
	},
	{
		"Area": "Bhopalpatnam",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 19.1978,
		"Long": 81.3796
	},
	{
		"Area": "Bhopalsagar",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 24.8823,
		"Long": 74.2559
	},
	{
		"Area": "Bhor",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 19.6874,
		"Long": 77.6251
	},
	{
		"Area": "Bhorakalan",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.2178,
		"Long": 76.7962
	},
	{
		"Area": "Bhorang",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 31.8209,
		"Long": 76.4944
	},
	{
		"Area": "Bhoranj",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 32.1493,
		"Long": 76.9289
	},
	{
		"Area": "Bhoranj(T)",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 31.7872,
		"Long": 76.4841
	},
	{
		"Area": "Bhorkardan",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 20.3759,
		"Long": 75.9321
	},
	{
		"Area": "Bhotwas Ahir",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.1769,
		"Long": 76.5079
	},
	{
		"Area": "Bhowanipur",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.346,
		"Long": 91.677
	},
	{
		"Area": "Bhowapar",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.6238,
		"Long": 83.3645
	},
	{
		"Area": "Bhowraguri",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.4267,
		"Long": 90.0997
	},
	{
		"Area": "Bhrthala",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.3498,
		"Long": 76.5026
	},
	{
		"Area": "Bhua Bichhia",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.4985,
		"Long": 80.5042
	},
	{
		"Area": "Bhua Bichhiya",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.6404,
		"Long": 80.8967
	},
	{
		"Area": "Bhuabichhia",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.9989,
		"Long": 80.9392
	},
	{
		"Area": "Bhuabichhiya",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.6404,
		"Long": 80.8084
	},
	{
		"Area": "Bhuban",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.0647,
		"Long": 85.5221
	},
	{
		"Area": "Bhubaneshwar",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.2597,
		"Long": 85.7899
	},
	{
		"Area": "Bhubaneswar",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.1067,
		"Long": 86.0071
	},
	{
		"Area": "Bhubichhiya",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.3814,
		"Long": 80.7038
	},
	{
		"Area": "Bhucho",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 30.2682,
		"Long": 75.1227
	},
	{
		"Area": "Bhucho Manda",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 30.2106,
		"Long": 75.0959
	},
	{
		"Area": "Bhudargad",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 17.7197,
		"Long": 74.6581
	},
	{
		"Area": "Bhuj",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 23.9695,
		"Long": 70.7595
	},
	{
		"Area": "Bhulath",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 31.6346,
		"Long": 75.5848
	},
	{
		"Area": "Bhuniajibarh",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3703,
		"Long": 88.2092
	},
	{
		"Area": "Bhuopalsagar",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 24.8614,
		"Long": 73.9825
	},
	{
		"Area": "Bhup Kheri",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.7416,
		"Long": 77.4102
	},
	{
		"Area": "Bhupalapalli",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 18.2969,
		"Long": 79.9273
	},
	{
		"Area": "Bhupalpalle",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 18.0544,
		"Long": 79.491
	},
	{
		"Area": "Bhupalsagar",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 24.8823,
		"Long": 74.7797
	},
	{
		"Area": "Bhupatinagar",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.0093,
		"Long": 87.7037
	},
	{
		"Area": "Bhuragaon",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.5544,
		"Long": 92.4077
	},
	{
		"Area": "Bhuranj",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 31.8933,
		"Long": 76.5453
	},
	{
		"Area": "Bhurkunda",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.5455,
		"Long": 88.9366
	},
	{
		"Area": "Bhusawal",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 21.0429,
		"Long": 76.1007
	},
	{
		"Area": "Bhushan Kalan",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.0799,
		"Long": 76.0612
	},
	{
		"Area": "Biakner",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 28.8706,
		"Long": 74.1068
	},
	{
		"Area": "Biaora",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 23.9982,
		"Long": 77.2403
	},
	{
		"Area": "Bibhisanpur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3836,
		"Long": 87.8747
	},
	{
		"Area": "Bibhutpur",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.7722,
		"Long": 85.9608
	},
	{
		"Area": "Bibinagar",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 17.1362,
		"Long": 78.7712
	},
	{
		"Area": "Bichhua",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.1214,
		"Long": 79.1175
	},
	{
		"Area": "Bichkunda",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 18.3428,
		"Long": 78.0065
	},
	{
		"Area": "Bicholim",
		"State": "Goa",
		"CountryCode": "IN",
		"Lat": 15.7,
		"Long": 74.0468
	},
	{
		"Area": "Bid",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 20.0435,
		"Long": 77.9838
	},
	{
		"Area": "Bidar",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 18.2944,
		"Long": 77.6246
	},
	{
		"Area": "Bidhnoo",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.1628,
		"Long": 80.5482
	},
	{
		"Area": "Bidhuna",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 27.1089,
		"Long": 80.3365
	},
	{
		"Area": "Bidupur",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.9263,
		"Long": 85.8861
	},
	{
		"Area": "Bidurpur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3159,
		"Long": 88.0212
	},
	{
		"Area": "Bihaguri",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.6833,
		"Long": 92.65
	},
	{
		"Area": "Bihar",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.286,
		"Long": 80.8296
	},
	{
		"Area": "Bihar",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.1766,
		"Long": 85.537
	},
	{
		"Area": "Bihar Sharif",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.2334,
		"Long": 85.3319
	},
	{
		"Area": "Bihariganj",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.8259,
		"Long": 87.2831
	},
	{
		"Area": "Biharsarif",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.3056,
		"Long": 85.6267
	},
	{
		"Area": "Biharsharif",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.4171,
		"Long": 85.5869
	},
	{
		"Area": "Bihpur",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.4217,
		"Long": 87.0844
	},
	{
		"Area": "Bihpuria",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.9439,
		"Long": 94.4075
	},
	{
		"Area": "Bihta",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.5927,
		"Long": 85.25
	},
	{
		"Area": "Bihupuria",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 27.169,
		"Long": 94.4075
	},
	{
		"Area": "Bijainagar",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 25.9298,
		"Long": 74.6492
	},
	{
		"Area": "Bijaipur",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 26.0505,
		"Long": 77.3714
	},
	{
		"Area": "Bijapur",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 19.2422,
		"Long": 81.0918
	},
	{
		"Area": "Bijapur",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 17.2089,
		"Long": 76.4964
	},
	{
		"Area": "Bijawar",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 24.7967,
		"Long": 79.6869
	},
	{
		"Area": "Bijaypur",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 26.0545,
		"Long": 77.5932
	},
	{
		"Area": "Bijepur",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.3833,
		"Long": 83.687
	},
	{
		"Area": "Bijhari",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 31.8933,
		"Long": 77.3471
	},
	{
		"Area": "Bijnapally",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 17.1579,
		"Long": 78.6796
	},
	{
		"Area": "Bijni",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.5214,
		"Long": 90.8806
	},
	{
		"Area": "Bijnor",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 29.6205,
		"Long": 78.4378
	},
	{
		"Area": "Bikaner",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.2555,
		"Long": 76.61
	},
	{
		"Area": "Bikaner",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 28.9423,
		"Long": 74.7458
	},
	{
		"Area": "Bikansr",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 27.5811,
		"Long": 73.6224
	},
	{
		"Area": "Bikapaur",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.6825,
		"Long": 82.19
	},
	{
		"Area": "Bikapur",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.7536,
		"Long": 82.3862
	},
	{
		"Area": "Bikkavolu",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 17.3395,
		"Long": 82.2257
	},
	{
		"Area": "Bikram",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.4851,
		"Long": 84.8631
	},
	{
		"Area": "Bikramganj",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.3646,
		"Long": 84.3073
	},
	{
		"Area": "Bilaigarh",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 21.702,
		"Long": 82.8279
	},
	{
		"Area": "Bilapur",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 31.2583,
		"Long": 76.8377
	},
	{
		"Area": "Bilara",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 26.9764,
		"Long": 73.9466
	},
	{
		"Area": "Bilari",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 29.0576,
		"Long": 78.8997
	},
	{
		"Area": "Bilashpur",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.0789,
		"Long": 91.8987
	},
	{
		"Area": "Bilasipara",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.3617,
		"Long": 90.3394
	},
	{
		"Area": "Bilasour",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.8811,
		"Long": 79.2337
	},
	{
		"Area": "Bilaspur",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 29.0429,
		"Long": 79.3815
	},
	{
		"Area": "Bilaspur",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 22.3293,
		"Long": 82.2545
	},
	{
		"Area": "Bilaspur",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 31.7511,
		"Long": 77.7173
	},
	{
		"Area": "Bilaspur Sadar",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 31.3879,
		"Long": 76.9638
	},
	{
		"Area": "Bilaspur Sadar(T)",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 31.2196,
		"Long": 76.9638
	},
	{
		"Area": "Bilgi",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 16.3471,
		"Long": 75.9539
	},
	{
		"Area": "Bilgram",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 27.25,
		"Long": 80.032
	},
	{
		"Area": "Bilha",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 22.1092,
		"Long": 82.2181
	},
	{
		"Area": "Bilhaur",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.8675,
		"Long": 79.9703
	},
	{
		"Area": "Bilkhawthlir",
		"State": "Mizoram",
		"CountryCode": "IN",
		"Lat": 23.6567,
		"Long": 92.7452
	},
	{
		"Area": "Bilkisganj",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 23.0698,
		"Long": 76.7129
	},
	{
		"Area": "Billanapalli",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 16.5627,
		"Long": 80.8006
	},
	{
		"Area": "Billawar",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 32.6901,
		"Long": 75.5683
	},
	{
		"Area": "Billawer",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 32.6516,
		"Long": 75.4472
	},
	{
		"Area": "Billwar",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 32.6901,
		"Long": 75.6096
	},
	{
		"Area": "Biloi",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 18.8478,
		"Long": 77.5824
	},
	{
		"Area": "Biloli",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 19.2145,
		"Long": 77.8279
	},
	{
		"Area": "Bilsi",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.358,
		"Long": 79.0145
	},
	{
		"Area": "Bilsi **",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.2692,
		"Long": 78.8847
	},
	{
		"Area": "Bilthara Road",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.1991,
		"Long": 84.1055
	},
	{
		"Area": "Bilthararoad",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.1991,
		"Long": 84.2706
	},
	{
		"Area": "Bilthjara Road",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 25.941,
		"Long": 83.691
	},
	{
		"Area": "Bilthra Rioad",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.1214,
		"Long": 83.7134
	},
	{
		"Area": "Bilthra Road",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.1991,
		"Long": 84.3246
	},
	{
		"Area": "Bimangarh",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 23.7062,
		"Long": 91.4203
	},
	{
		"Area": "Bimjharpur",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.733,
		"Long": 85.8278
	},
	{
		"Area": "Bina",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 24.2122,
		"Long": 78.6696
	},
	{
		"Area": "Binandapur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.2471,
		"Long": 87.8066
	},
	{
		"Area": "Bind",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.3349,
		"Long": 85.7049
	},
	{
		"Area": "Bindranawagarh",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 21.0976,
		"Long": 82.174
	},
	{
		"Area": "Bindukuri",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.7167,
		"Long": 92.7167
	},
	{
		"Area": "Binjharpur",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.8559,
		"Long": 86.6106
	},
	{
		"Area": "Binka",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.1303,
		"Long": 83.812
	},
	{
		"Area": "Binour",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.5127,
		"Long": 80.5703
	},
	{
		"Area": "Binpur-I",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.5946,
		"Long": 87.9178
	},
	{
		"Area": "Binpur-II",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.386,
		"Long": 88.5238
	},
	{
		"Area": "Bira",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.7774,
		"Long": 88.5686
	},
	{
		"Area": "Biramitrapur",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 22.2419,
		"Long": 85.1005
	},
	{
		"Area": "Biramnagar",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.6191,
		"Long": 88.8788
	},
	{
		"Area": "Biranarasinghpur",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.7549,
		"Long": 84.4026
	},
	{
		"Area": "Birasinghpur",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.7146,
		"Long": 84.3277
	},
	{
		"Area": "Biraul",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 26.1138,
		"Long": 86.3496
	},
	{
		"Area": "Birbhum",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.5795,
		"Long": 88.5271
	},
	{
		"Area": "Birbira",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.3029,
		"Long": 87.818
	},
	{
		"Area": "Birchandranagar",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.0789,
		"Long": 91.8987
	},
	{
		"Area": "Birendranagar",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 23.6622,
		"Long": 91.3881
	},
	{
		"Area": "Birgaon",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 21.5612,
		"Long": 81.731
	},
	{
		"Area": "Birhana Road",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.5442,
		"Long": 80.1097
	},
	{
		"Area": "Biridi",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.4871,
		"Long": 85.2666
	},
	{
		"Area": "Birigumma",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 19.3596,
		"Long": 82.6092
	},
	{
		"Area": "Birlapur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.9861,
		"Long": 88.4168
	},
	{
		"Area": "Birmaharajpur",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.0228,
		"Long": 85.1451
	},
	{
		"Area": "Birni",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 24.3639,
		"Long": 86.0672
	},
	{
		"Area": "Birpur",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 26.4032,
		"Long": 87.3367
	},
	{
		"Area": "Birpur",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 23.2491,
		"Long": 73.5415
	},
	{
		"Area": "Birra",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 22.5323,
		"Long": 82.6119
	},
	{
		"Area": "Birsinghpur Pali",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 23.4077,
		"Long": 81.1354
	},
	{
		"Area": "Bisalpur",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.5418,
		"Long": 79.9617
	},
	{
		"Area": "Bisara",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.3979,
		"Long": 77.5471
	},
	{
		"Area": "Bisauli",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.4532,
		"Long": 79.0314
	},
	{
		"Area": "Bisayakpur",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.5127,
		"Long": 80.5703
	},
	{
		"Area": "Bishala",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 26.0634,
		"Long": 73.1425
	},
	{
		"Area": "Bishalgarh",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 23.7215,
		"Long": 91.4203
	},
	{
		"Area": "Bishamakatak",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 19.4831,
		"Long": 83.6258
	},
	{
		"Area": "Bishna",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 32.513,
		"Long": 74.7793
	},
	{
		"Area": "Bishnpur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.9793,
		"Long": 87.3579
	},
	{
		"Area": "Bishnugarh",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 24.0332,
		"Long": 85.5774
	},
	{
		"Area": "Bishnupur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.2279,
		"Long": 88.4145
	},
	{
		"Area": "Bishnupur",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.1597,
		"Long": 92.0329
	},
	{
		"Area": "Bishnupur - I",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.4126,
		"Long": 88.3292
	},
	{
		"Area": "Bishnupur - II",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3252,
		"Long": 88.4168
	},
	{
		"Area": "Bishnupur II",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.415,
		"Long": 88.307
	},
	{
		"Area": "Bishpur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.795,
		"Long": 88.1206
	},
	{
		"Area": "Bishrakh",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.569,
		"Long": 77.4372
	},
	{
		"Area": "Bishramganj",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 23.6182,
		"Long": 91.356
	},
	{
		"Area": "Bishrampur",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 24.2649,
		"Long": 83.6821
	},
	{
		"Area": "Bishungarh",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 24.0243,
		"Long": 85.7866
	},
	{
		"Area": "Bishunpur",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 23.3743,
		"Long": 84.4887
	},
	{
		"Area": "Bisli",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.2304,
		"Long": 78.8847
	},
	{
		"Area": "Bisowa",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.4146,
		"Long": 76.3674
	},
	{
		"Area": "Bisra",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 22.2495,
		"Long": 85.063
	},
	{
		"Area": "Bisra Block",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 22.237,
		"Long": 84.9568
	},
	{
		"Area": "Bisrampur",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 24.502,
		"Long": 84.0613
	},
	{
		"Area": "Bissamcuttack",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 19.8552,
		"Long": 83.5946
	},
	{
		"Area": "Bissmagiri",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 19.4053,
		"Long": 84.4986
	},
	{
		"Area": "Bistupur Bazar",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 22.808,
		"Long": 86.2029
	},
	{
		"Area": "Bisuali",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.2721,
		"Long": 79.058
	},
	{
		"Area": "Biswan",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 27.7326,
		"Long": 81.3907
	},
	{
		"Area": "Biswanathghat",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.971,
		"Long": 93.8695
	},
	{
		"Area": "Biswanathpur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.0208,
		"Long": 87.7744
	},
	{
		"Area": "Bithara Road",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.1991,
		"Long": 83.8253
	},
	{
		"Area": "Bithari",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.1454,
		"Long": 88.6128
	},
	{
		"Area": "Bithoor",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.1685,
		"Long": 80.3428
	},
	{
		"Area": "Bithwana",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.3196,
		"Long": 76.611
	},
	{
		"Area": "Bitragunta",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 15.0296,
		"Long": 80.0185
	},
	{
		"Area": "Biwani",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 29.0425,
		"Long": 76.1726
	},
	{
		"Area": "Bkh",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 30.1194,
		"Long": 75.6287
	},
	{
		"Area": "Bkt",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.6402,
		"Long": 93.6005
	},
	{
		"Area": "Blaspur",
		"State": "Himachal Pradesh",
		"CountryCode": "IN",
		"Lat": 31.2082,
		"Long": 76.9419
	},
	{
		"Area": "Blthra Road",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.1214,
		"Long": 83.7134
	},
	{
		"Area": "Bnarayanpur",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 24.0304,
		"Long": 85.8211
	},
	{
		"Area": "Bngarpet",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 13.3279,
		"Long": 78.0098
	},
	{
		"Area": "Bnpahad",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 17.5939,
		"Long": 81.2293
	},
	{
		"Area": "Boaldah",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.0762,
		"Long": 88.8272
	},
	{
		"Area": "Boarijor",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 25.0577,
		"Long": 87.3923
	},
	{
		"Area": "Boarijore",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 25.0912,
		"Long": 87.4709
	},
	{
		"Area": "Boath",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 19.6419,
		"Long": 78.9721
	},
	{
		"Area": "Bobbili",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 18.6127,
		"Long": 83.4799
	},
	{
		"Area": "Bochaha",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 26.1511,
		"Long": 85.9574
	},
	{
		"Area": "Boda",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 23.9806,
		"Long": 76.9149
	},
	{
		"Area": "Bodai",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.8004,
		"Long": 88.4864
	},
	{
		"Area": "Bodeb",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.3184,
		"Long": 82.6076
	},
	{
		"Area": "Bodeli",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 22.2345,
		"Long": 73.5717
	},
	{
		"Area": "Boden",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.3808,
		"Long": 82.8264
	},
	{
		"Area": "Bodh Gaya",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.5218,
		"Long": 86.0699
	},
	{
		"Area": "Bodhan",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 18.6621,
		"Long": 78.1439
	},
	{
		"Area": "Bodhgaya",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 24.8781,
		"Long": 84.9946
	},
	{
		"Area": "Bodhra",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.4761,
		"Long": 86.8761
	},
	{
		"Area": "Bodinayakanur",
		"State": "Tamil Nadu",
		"CountryCode": "IN",
		"Lat": 10.0789,
		"Long": 77.7791
	},
	{
		"Area": "Bodwad",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 20.9355,
		"Long": 76.1383
	},
	{
		"Area": "Boenpali",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 18.5336,
		"Long": 78.9126
	},
	{
		"Area": "Boenpalli",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 18.5336,
		"Long": 79.0104
	},
	{
		"Area": "Boga",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 21.8532,
		"Long": 87.9147
	},
	{
		"Area": "Boginadi",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 27.169,
		"Long": 94.1258
	},
	{
		"Area": "Boha",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 30.0715,
		"Long": 75.4834
	},
	{
		"Area": "Bohara",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.7343,
		"Long": 88.5795
	},
	{
		"Area": "Boinchi",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.1203,
		"Long": 88.1936
	},
	{
		"Area": "Boipariguda",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 19.8548,
		"Long": 83.4836
	},
	{
		"Area": "Boitamari",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.5214,
		"Long": 90.8806
	},
	{
		"Area": "Bokajan",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.1303,
		"Long": 93.7795
	},
	{
		"Area": "Bokakhat",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.6402,
		"Long": 93.6005
	},
	{
		"Area": "Bokaro",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 24.359,
		"Long": 86.5629
	},
	{
		"Area": "Bokhara",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.2803,
		"Long": 86.4741
	},
	{
		"Area": "Bokhra",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 26.576,
		"Long": 86.4741
	},
	{
		"Area": "Boko",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.0989,
		"Long": 91.2614
	},
	{
		"Area": "Bolagarh",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.2485,
		"Long": 85.5114
	},
	{
		"Area": "Bolba",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 22.4308,
		"Long": 84.3445
	},
	{
		"Area": "Bolkhusda",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.2088,
		"Long": 88.0387
	},
	{
		"Area": "Bollapalle",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 16.4142,
		"Long": 80.1301
	},
	{
		"Area": "Bolpur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.5164,
		"Long": 87.8648
	},
	{
		"Area": "Bolpur Sriniketan",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.6823,
		"Long": 87.6864
	},
	{
		"Area": "Bomakei",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 19.1028,
		"Long": 83.1031
	},
	{
		"Area": "Bomdila",
		"State": "Arunachal Pradesh",
		"CountryCode": "IN",
		"Lat": 27.2895,
		"Long": 92.4247
	},
	{
		"Area": "Bommakal",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 17.0197,
		"Long": 80.4988
	},
	{
		"Area": "Bommanahal",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 15.0162,
		"Long": 77.6801
	},
	{
		"Area": "Bonagand",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 33.9509,
		"Long": 75.0932
	},
	{
		"Area": "Bonai",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.1762,
		"Long": 87.6063
	},
	{
		"Area": "Bonaigarh",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.8219,
		"Long": 84.9777
	},
	{
		"Area": "Bonakal",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 17.1891,
		"Long": 80.581
	},
	{
		"Area": "Bonangi",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 18.1473,
		"Long": 83.2193
	},
	{
		"Area": "Bondamunda",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.9012,
		"Long": 84.7169
	},
	{
		"Area": "Bondapalli",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 18.4673,
		"Long": 83.3882
	},
	{
		"Area": "Bongaigaon",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.5214,
		"Long": 91.1281
	},
	{
		"Area": "Bongaon",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.5807,
		"Long": 91.4583
	},
	{
		"Area": "Bongaon",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.5022,
		"Long": 88.8272
	},
	{
		"Area": "Bongaon ( Boko)",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.0214,
		"Long": 91.2624
	},
	{
		"Area": "Bonli",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 26.4626,
		"Long": 76.4155
	},
	{
		"Area": "Bonnakal",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 17.0194,
		"Long": 80.3972
	},
	{
		"Area": "Bonpura",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.164,
		"Long": 87.0901
	},
	{
		"Area": "Boothpur",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 17.0753,
		"Long": 78.0839
	},
	{
		"Area": "Borah",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.4364,
		"Long": 87.9624
	},
	{
		"Area": "Borai",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3836,
		"Long": 87.8747
	},
	{
		"Area": "Boral",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.7807,
		"Long": 88.3001
	},
	{
		"Area": "Bordoloni",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 27.4029,
		"Long": 94.4187
	},
	{
		"Area": "Bordumsa",
		"State": "Arunachal Pradesh",
		"CountryCode": "IN",
		"Lat": 27.9126,
		"Long": 96.1288
	},
	{
		"Area": "Bordumsa Circle",
		"State": "Arunachal Pradesh",
		"CountryCode": "IN",
		"Lat": 28.1695,
		"Long": 94.8006
	},
	{
		"Area": "Borgaon",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.6404,
		"Long": 80.5134
	},
	{
		"Area": "Borgong",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.782,
		"Long": 93.6636
	},
	{
		"Area": "Boria Kamalpur",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.2601,
		"Long": 76.5563
	},
	{
		"Area": "Boriguma",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 19.086,
		"Long": 82.751
	},
	{
		"Area": "Borigumma",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 19.8548,
		"Long": 83.4836
	},
	{
		"Area": "Borio",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 25.209,
		"Long": 87.7409
	},
	{
		"Area": "Borivali East",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 19.1699,
		"Long": 72.8504
	},
	{
		"Area": "Borivali West",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 19.2361,
		"Long": 72.8694
	},
	{
		"Area": "Borivlai East",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 19.1699,
		"Long": 72.8504
	},
	{
		"Area": "Borjora",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.4166,
		"Long": 87.8906
	},
	{
		"Area": "Borjuli",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.7274,
		"Long": 92.2645
	},
	{
		"Area": "Boro Bazar",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.5214,
		"Long": 90.8806
	},
	{
		"Area": "Borobazar",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.5214,
		"Long": 90.8806
	},
	{
		"Area": "Borsad",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 23.1936,
		"Long": 73.4431
	},
	{
		"Area": "Borsola",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.6589,
		"Long": 92.4784
	},
	{
		"Area": "Borunda",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 26.4711,
		"Long": 73.8019
	},
	{
		"Area": "Botad",
		"State": "Gujarat",
		"CountryCode": "IN",
		"Lat": 22.5464,
		"Long": 71.8411
	},
	{
		"Area": "Boudh",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.8441,
		"Long": 84.6128
	},
	{
		"Area": "Boudhraj",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.5863,
		"Long": 84.6128
	},
	{
		"Area": "Bouli",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 33.9306,
		"Long": 75.1134
	},
	{
		"Area": "Bounsi",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 24.9395,
		"Long": 87.14
	},
	{
		"Area": "Bounsuni",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.8245,
		"Long": 84.4749
	},
	{
		"Area": "Bousuni",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.7016,
		"Long": 84.0722
	},
	{
		"Area": "Bowthakurani",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3484,
		"Long": 88.8997
	},
	{
		"Area": "Boxonagar",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 23.6637,
		"Long": 91.2781
	},
	{
		"Area": "Boyermari",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.3687,
		"Long": 88.562
	},
	{
		"Area": "Boyra",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.2147,
		"Long": 88.8863
	},
	{
		"Area": "Brachatti",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 24.5024,
		"Long": 85.0072
	},
	{
		"Area": "Brahamankhalisa",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 21.9467,
		"Long": 87.4938
	},
	{
		"Area": "Brahma Samudram",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 14.492,
		"Long": 77.7181
	},
	{
		"Area": "Brahmacherra",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.007,
		"Long": 91.6093
	},
	{
		"Area": "Brahmadevam",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 14.3899,
		"Long": 80.0961
	},
	{
		"Area": "Brahmamgarimattam",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 14.9076,
		"Long": 79.0052
	},
	{
		"Area": "Brahmani Tarang",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 22.2164,
		"Long": 84.8436
	},
	{
		"Area": "Brahmapur Sadar",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.8006,
		"Long": 85.0853
	},
	{
		"Area": "Brahmasamudram",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 14.5829,
		"Long": 77.7181
	},
	{
		"Area": "Brajaballavepur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 21.9837,
		"Long": 87.635
	},
	{
		"Area": "Brajarajnagar",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.9281,
		"Long": 83.9252
	},
	{
		"Area": "Brajendranagar",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.1597,
		"Long": 92.0329
	},
	{
		"Area": "Bramhapuri",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 20.669,
		"Long": 79.9517
	},
	{
		"Area": "Brhama Samudram",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 14.492,
		"Long": 77.7181
	},
	{
		"Area": "Brmaharajpur",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.7627,
		"Long": 84.3482
	},
	{
		"Area": "Bsna",
		"State": "Chattisgarh",
		"CountryCode": "IN",
		"Lat": 21.185,
		"Long": 82.8879
	},
	{
		"Area": "Bti",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 30.4262,
		"Long": 74.8657
	},
	{
		"Area": "Bubang",
		"State": "Arunachal Pradesh",
		"CountryCode": "IN",
		"Lat": 27.1318,
		"Long": 95.7349
	},
	{
		"Area": "Buchannapet",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 17.9552,
		"Long": 79.7992
	},
	{
		"Area": "Buchayyapeta",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 17.8322,
		"Long": 82.8606
	},
	{
		"Area": "Buchinaidu Kandriga",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 13.7858,
		"Long": 79.7646
	},
	{
		"Area": "Buchireddipalem Mandalam",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 14.5419,
		"Long": 79.8847
	},
	{
		"Area": "Buchireddypalem",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 14.6514,
		"Long": 79.9013
	},
	{
		"Area": "Buchireddypalem Mandalam",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 14.5789,
		"Long": 79.8193
	},
	{
		"Area": "Buchoo",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 33.9306,
		"Long": 75.1134
	},
	{
		"Area": "Budan Pur",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.2998,
		"Long": 83.5629
	},
	{
		"Area": "Budanpur",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.2445,
		"Long": 83.0111
	},
	{
		"Area": "Budaun",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.4532,
		"Long": 79.9089
	},
	{
		"Area": "Budbud",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.43,
		"Long": 87.6334
	},
	{
		"Area": "Buddin",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.4851,
		"Long": 76.4735
	},
	{
		"Area": "Budgam",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 33.9245,
		"Long": 74.8589
	},
	{
		"Area": "Budge Budge",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.4256,
		"Long": 88.1934
	},
	{
		"Area": "Budge Budge - I",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.588,
		"Long": 88.5318
	},
	{
		"Area": "Budge Budge - II",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.9861,
		"Long": 88.1934
	},
	{
		"Area": "Budhan Pur",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.047,
		"Long": 83.0697
	},
	{
		"Area": "Budhana",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 29.439,
		"Long": 77.7857
	},
	{
		"Area": "Budhlada",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 29.928,
		"Long": 75.5621
	},
	{
		"Area": "Budhna",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 29.3044,
		"Long": 77.594
	},
	{
		"Area": "Budhni",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.8667,
		"Long": 77.8448
	},
	{
		"Area": "Budhpur",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.3196,
		"Long": 76.611
	},
	{
		"Area": "Budhwa",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 29.3043,
		"Long": 77.0492
	},
	{
		"Area": "Budlana",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 20.3394,
		"Long": 75.9568
	},
	{
		"Area": "Budni",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 22.9054,
		"Long": 78.0167
	},
	{
		"Area": "Buduan",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.0038,
		"Long": 79.2631
	},
	{
		"Area": "Bugam",
		"State": "Jammu & Kashmir",
		"CountryCode": "IN",
		"Lat": 33.8152,
		"Long": 75.3575
	},
	{
		"Area": "Buguda",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 20.5228,
		"Long": 85.0241
	},
	{
		"Area": "Buhaana",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 28.045,
		"Long": 75.832
	},
	{
		"Area": "Buhana",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 28.4061,
		"Long": 76.0869
	},
	{
		"Area": "Builaspur",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.962,
		"Long": 79.1578
	},
	{
		"Area": "Bukkapatnam",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 14.3333,
		"Long": 77.9727
	},
	{
		"Area": "Bukkaraya Samudram",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 14.8325,
		"Long": 77.9932
	},
	{
		"Area": "Bukkarayasamudram",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 14.7955,
		"Long": 77.9714
	},
	{
		"Area": "Bukkrayasamudram",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 14.6941,
		"Long": 77.6328
	},
	{
		"Area": "Bulakipur",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.8386,
		"Long": 88.171
	},
	{
		"Area": "Bulandshahr",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 28.6789,
		"Long": 78.4082
	},
	{
		"Area": "Bulbulchandi",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.0119,
		"Long": 87.5938
	},
	{
		"Area": "Buldana",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 20.6794,
		"Long": 76.5537
	},
	{
		"Area": "Bullongbassa",
		"State": "Tripura",
		"CountryCode": "IN",
		"Lat": 24.0789,
		"Long": 91.8987
	},
	{
		"Area": "Bundala",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 31.5326,
		"Long": 74.98
	},
	{
		"Area": "Bundalal",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 31.5753,
		"Long": 74.9554
	},
	{
		"Area": "Bundi",
		"State": "Rajasthan",
		"CountryCode": "IN",
		"Lat": 25.7895,
		"Long": 76.2262
	},
	{
		"Area": "Bundu",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 23.6843,
		"Long": 85.7054
	},
	{
		"Area": "Bundwan",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.6167,
		"Long": 87.224
	},
	{
		"Area": "Bunghmun",
		"State": "Mizoram",
		"CountryCode": "IN",
		"Lat": 23.2628,
		"Long": 92.6304
	},
	{
		"Area": "Burdwan",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.4057,
		"Long": 88.1273
	},
	{
		"Area": "Burdwan - I",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.4057,
		"Long": 88.0651
	},
	{
		"Area": "Burdwan - II",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 23.7617,
		"Long": 88.0371
	},
	{
		"Area": "Burdwan Sadar",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.4057,
		"Long": 88.0651
	},
	{
		"Area": "Burgamapahad",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 17.8741,
		"Long": 80.1765
	},
	{
		"Area": "Burgampahad",
		"State": "Telangana",
		"CountryCode": "IN",
		"Lat": 17.9401,
		"Long": 80.9028
	},
	{
		"Area": "Burhanpur",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 26.2529,
		"Long": 83.7395
	},
	{
		"Area": "Burhanpur",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 21.828,
		"Long": 77.3711
	},
	{
		"Area": "Burhar",
		"State": "Madhya Pradesh",
		"CountryCode": "IN",
		"Lat": 24.0458,
		"Long": 81.4728
	},
	{
		"Area": "Burinagar",
		"State": "Assam",
		"CountryCode": "IN",
		"Lat": 26.5004,
		"Long": 91.4784
	},
	{
		"Area": "Burja",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 18.5315,
		"Long": 83.814
	},
	{
		"Area": "Burja Mandal",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 18.5689,
		"Long": 83.908
	},
	{
		"Area": "Burkot",
		"State": "Uttarakhand",
		"CountryCode": "IN",
		"Lat": 30.9731,
		"Long": 79.0568
	},
	{
		"Area": "Burla",
		"State": "Odisha",
		"CountryCode": "IN",
		"Lat": 21.5174,
		"Long": 83.8727
	},
	{
		"Area": "Burma Mines",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 23.0604,
		"Long": 85.9466
	},
	{
		"Area": "Burmu",
		"State": "Jharkhand",
		"CountryCode": "IN",
		"Lat": 23.6639,
		"Long": 84.9677
	},
	{
		"Area": "Buroli",
		"State": "Haryana",
		"CountryCode": "IN",
		"Lat": 28.2488,
		"Long": 76.4482
	},
	{
		"Area": "Buruj",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 22.4653,
		"Long": 88.7803
	},
	{
		"Area": "Burwan",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.1251,
		"Long": 87.9561
	},
	{
		"Area": "Burwan Sadar",
		"State": "West Bengal",
		"CountryCode": "IN",
		"Lat": 24.0711,
		"Long": 88.0371
	},
	{
		"Area": "Busauli",
		"State": "Uttar Pradesh",
		"CountryCode": "IN",
		"Lat": 27.8997,
		"Long": 79.4195
	},
	{
		"Area": "Butala",
		"State": "Punjab",
		"CountryCode": "IN",
		"Lat": 31.6158,
		"Long": 75.3378
	},
	{
		"Area": "Butchayyapeta",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 17.8724,
		"Long": 83.0121
	},
	{
		"Area": "Buttayagudem",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 17.3531,
		"Long": 81.6559
	},
	{
		"Area": "Buttayagudem Mandalam",
		"State": "Andhra Pradesh",
		"CountryCode": "IN",
		"Lat": 17.3543,
		"Long": 81.7422
	},
	{
		"Area": "Buxar",
		"State": "Bihar",
		"CountryCode": "IN",
		"Lat": 25.6738,
		"Long": 84.1018
	},
	{
		"Area": "Bvhokar",
		"State": "Maharashtra",
		"CountryCode": "IN",
		"Lat": 19.1979,
		"Long": 77.7499
	},
	{
		"Area": "Byadgi",
		"State": "Karnataka",
		"CountryCode": "IN",
		"Lat": 14.7427,
		"Long": 75.5138
	},
	{
		"Area": "Byrnihat",
		"State": "Meghalaya",
		"CountryCode": "IN",
		"Lat": 25.6019,
		"Long": 91.9144
	},
	{
		"Area": "Babahoyo",
		"Lat": "-1.7996",
		"Long": "-79.54",
		"CountryCode": "EC"
	  },
	  {
		"Area": "Babruysk",
		"Lat": "53.1266",
		"Long": "29.1928",
		"CountryCode": "BY"
	  },
	  {
		"Area": "Bắc Giang",
		"Lat": "21.267",
		"Long": "106.2",
		"CountryCode": "VN"
	  },
	  {
		"Area": "Bạc Liêu",
		"Lat": "9.2804",
		"Long": "105.72",
		"CountryCode": "VN"
	  },
	  {
		"Area": "Bacabal",
		"Lat": "-4.23",
		"Long": "-44.8",
		"CountryCode": "BR"
	  },
	  {
		"Area": "Bacău",
		"Lat": "46.5784",
		"Long": "26.9196",
		"CountryCode": "RO"
	  },
	  {
		"Area": "Bacolod",
		"Lat": "10.6317",
		"Long": "122.9817",
		"CountryCode": "PH"
	  },
	  {
		"Area": "Badajoz",
		"Lat": "38.8804",
		"Long": "-6.97",
		"CountryCode": "ES"
	  },
	  {
		"Area": "Bade",
		"Lat": "24.9575",
		"Long": "121.2989",
		"CountryCode": "TW"
	  },
	  {
		"Area": "Bærum",
		"Lat": "59.9135",
		"Long": "11.3472",
		"CountryCode": "NO"
	  },
	  {
		"Area": "Bafang",
		"Lat": "5.1704",
		"Long": "10.18",
		"CountryCode": "CM"
	  },
	  {
		"Area": "Bafia",
		"Lat": "4.7504",
		"Long": "11.23",
		"CountryCode": "CM"
	  },
	  {
		"Area": "Bafoussam",
		"Lat": "5.4904",
		"Long": "10.4099",
		"CountryCode": "CM"
	  },
	  {
		"Area": "Bafra",
		"Lat": "41.5682",
		"Long": "35.9069",
		"CountryCode": "TR"
	  },
	  {
		"Area": "Bagamoyo",
		"Lat": "-6.4396",
		"Long": "38.89",
		"CountryCode": "TZ"
	  },
	  {
		"Area": "Bagé",
		"Lat": "-31.32",
		"Long": "-54.1",
		"CountryCode": "BR"
	  },
	  {
		"Area": "Baghdad",
		"Lat": "33.3386",
		"Long": "44.3939",
		"CountryCode": "IQ"
	  },
	  {
		"Area": "Baghlan",
		"Lat": "36.1393",
		"Long": "68.6993",
		"CountryCode": "AF"
	  },
	  {
		"Area": "Bago",
		"Lat": "17.32",
		"Long": "96.515",
		"CountryCode": "MM"
	  },
	  {
		"Area": "Baguio City",
		"Lat": "16.43",
		"Long": "120.5699",
		"CountryCode": "PH"
	  },
	  {
		"Area": "Bahawalpur",
		"Lat": "29.39",
		"Long": "71.675",
		"CountryCode": "PK"
	  },
	  {
		"Area": "Bahía Blanca",
		"Lat": "-38.74",
		"Long": "-62.265",
		"CountryCode": "AR"
	  },
	  {
		"Area": "Bahir Dar",
		"Lat": "11.6001",
		"Long": "37.3833",
		"CountryCode": "ET"
	  },
	  {
		"Area": "Baia Mare",
		"Lat": "47.6595",
		"Long": "23.5791",
		"CountryCode": "RO"
	  },
	  {
		"Area": "Baicheng",
		"Lat": "45.62",
		"Long": "122.82",
		"CountryCode": "CN"
	  },
	  {
		"Area": "Baiquan",
		"Lat": "47.6018",
		"Long": "126.0819",
		"CountryCode": "CN"
	  },
	  {
		"Area": "Bairin Zuoqi",
		"Lat": "43.9837",
		"Long": "119.1834",
		"CountryCode": "CN"
	  },
	  {
		"Area": "Baishan",
		"Lat": "41.9",
		"Long": "126.43",
		"CountryCode": "CN"
	  },
	  {
		"Area": "Bakersfield",
		"Lat": "35.353",
		"Long": "-119.036",
		"CountryCode": "US"
	  },
	  {
		"Area": "Baku",
		"Lat": "40.3953",
		"Long": "49.8622",
		"CountryCode": "AZ"
	  },
	  {
		"Area": "Balakhna",
		"Lat": "56.4943",
		"Long": "43.5944",
		"CountryCode": "RU"
	  },
	  {
		"Area": "Balakovo",
		"Lat": "52.03",
		"Long": "47.8",
		"CountryCode": "RU"
	  },
	  {
		"Area": "Balashov",
		"Lat": "51.5535",
		"Long": "43.1631",
		"CountryCode": "RU"
	  },
	  {
		"Area": "Balboa",
		"Lat": "8.95",
		"Long": "-79.5667",
		"CountryCode": "PA"
	  },
	  {
		"Area": "Baldwin Park",
		"Lat": "34.0829",
		"Long": "-117.972",
		"CountryCode": "US"
	  },
	  {
		"Area": "Balikpapan",
		"Lat": "-1.25",
		"Long": "116.83",
		"CountryCode": "ID"
	  },
	  {
		"Area": "Balıkesir",
		"Lat": "39.6504",
		"Long": "27.89",
		"CountryCode": "TR"
	  },
	  {
		"Area": "Balkanabat",
		"Lat": "39.5124",
		"Long": "54.3649",
		"CountryCode": "TM"
	  },
	  {
		"Area": "Balkh",
		"Lat": "36.7501",
		"Long": "66.8997",
		"CountryCode": "AF"
	  },
	  {
		"Area": "Ballarat",
		"Lat": "-37.5596",
		"Long": "143.84",
		"CountryCode": "AU"
	  },
	  {
		"Area": "Balqash",
		"Lat": "46.8532",
		"Long": "74.9502",
		"CountryCode": "KZ"
	  },
	  {
		"Area": "Balsas",
		"Lat": "-7.52",
		"Long": "-46.05",
		"CountryCode": "BR"
	  },
	  {
		"Area": "Bălți",
		"Lat": "47.7591",
		"Long": "27.9053",
		"CountryCode": "MD"
	  },
	  {
		"Area": "Baltimore",
		"Lat": "39.3051",
		"Long": "-76.6144",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bam",
		"Lat": "29.1077",
		"Long": "58.362",
		"CountryCode": "IR"
	  },
	  {
		"Area": "Bama",
		"Lat": "11.5204",
		"Long": "13.69",
		"CountryCode": "NG"
	  },
	  {
		"Area": "Bamako",
		"Lat": "12.65",
		"Long": "-8",
		"CountryCode": "ML"
	  },
	  {
		"Area": "Bambari",
		"Lat": "5.762",
		"Long": "20.6672",
		"CountryCode": "CF"
	  },
	  {
		"Area": "Bamenda",
		"Lat": "5.96",
		"Long": "10.15",
		"CountryCode": "CM"
	  },
	  {
		"Area": "Bamian",
		"Lat": "34.8211",
		"Long": "67.521",
		"CountryCode": "AF"
	  },
	  {
		"Area": "Banda Aceh",
		"Lat": "5.55",
		"Long": "95.32",
		"CountryCode": "ID"
	  },
	  {
		"Area": "Bandar Lampung",
		"Lat": "-5.43",
		"Long": "105.27",
		"CountryCode": "ID"
	  },
	  {
		"Area": "Bandar Seri Begawan",
		"Lat": "4.8833",
		"Long": "114.9333",
		"CountryCode": "BN"
	  },
	  {
		"Area": "Bandar-e Bushehr",
		"Lat": "28.92",
		"Long": "50.83",
		"CountryCode": "IR"
	  },
	  {
		"Area": "Bandar-e-Abbas",
		"Lat": "27.2041",
		"Long": "56.2721",
		"CountryCode": "IR"
	  },
	  {
		"Area": "Bandjarmasin",
		"Lat": "-3.33",
		"Long": "114.5801",
		"CountryCode": "ID"
	  },
	  {
		"Area": "Bandundu",
		"Lat": "-3.31",
		"Long": "17.38",
		"CountryCode": "CD"
	  },
	  {
		"Area": "Bandung",
		"Lat": "-6.95",
		"Long": "107.57",
		"CountryCode": "ID"
	  },
	  {
		"Area": "Banes",
		"Lat": "20.9629",
		"Long": "-75.7186",
		"CountryCode": "CU"
	  },
	  {
		"Area": "Banfora",
		"Lat": "10.6304",
		"Long": "-4.76",
		"CountryCode": "BF"
	  },
	  {
		"Area": "Banghazi",
		"Lat": "32.1167",
		"Long": "20.0667",
		"CountryCode": "LY"
	  },
	  {
		"Area": "Bangkok",
		"Lat": "13.75",
		"Long": "100.5166",
		"CountryCode": "TH"
	  },
	  {
		"Area": "Bangor",
		"Lat": "44.8322",
		"Long": "-68.7906",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bangui",
		"Lat": "4.3666",
		"Long": "18.5583",
		"CountryCode": "CF"
	  },
	  {
		"Area": "Baní",
		"Lat": "18.28",
		"Long": "-70.331",
		"CountryCode": "DO"
	  },
	  {
		"Area": "Bani Walid",
		"Lat": "31.7704",
		"Long": "13.99",
		"CountryCode": "LY"
	  },
	  {
		"Area": "Banja Luka",
		"Lat": "44.7804",
		"Long": "17.18",
		"CountryCode": "BA"
	  },
	  {
		"Area": "Bannu",
		"Lat": "32.989",
		"Long": "70.5986",
		"CountryCode": "PK"
	  },
	  {
		"Area": "Banská Bystrica",
		"Lat": "48.7333",
		"Long": "19.15",
		"CountryCode": "SK"
	  },
	  {
		"Area": "Banyuwangi",
		"Lat": "-8.195",
		"Long": "114.3696",
		"CountryCode": "ID"
	  },
	  {
		"Area": "Baoding",
		"Lat": "38.8704",
		"Long": "115.48",
		"CountryCode": "CN"
	  },
	  {
		"Area": "Baoji",
		"Lat": "34.38",
		"Long": "107.15",
		"CountryCode": "CN"
	  },
	  {
		"Area": "Baoshan",
		"Lat": "25.12",
		"Long": "99.15",
		"CountryCode": "CN"
	  },
	  {
		"Area": "Baotou",
		"Lat": "40.6522",
		"Long": "109.822",
		"CountryCode": "CN"
	  },
	  {
		"Area": "Baqubah",
		"Lat": "33.7476",
		"Long": "44.6573",
		"CountryCode": "IQ"
	  },
	  {
		"Area": "Barahona",
		"Lat": "18.2004",
		"Long": "-71.1",
		"CountryCode": "DO"
	  },
	  {
		"Area": "Baranavichy",
		"Lat": "53.1368",
		"Long": "26.0134",
		"CountryCode": "BY"
	  },
	  {
		"Area": "Barbacena",
		"Lat": "-21.22",
		"Long": "-43.77",
		"CountryCode": "BR"
	  },
	  {
		"Area": "Barcelona",
		"Lat": "41.3833",
		"Long": "2.1834",
		"CountryCode": "ES"
	  },
	  {
		"Area": "Barcelona",
		"Lat": "10.1304",
		"Long": "-64.72",
		"CountryCode": "VE"
	  },
	  {
		"Area": "Bari",
		"Lat": "41.1142",
		"Long": "16.8728",
		"CountryCode": "IT"
	  },
	  {
		"Area": "Barinas",
		"Lat": "8.6",
		"Long": "-70.25",
		"CountryCode": "VE"
	  },
	  {
		"Area": "Barisal",
		"Lat": "22.7004",
		"Long": "90.375",
		"CountryCode": "BD"
	  },
	  {
		"Area": "Barletta",
		"Lat": "41.32",
		"Long": "16.27",
		"CountryCode": "IT"
	  },
	  {
		"Area": "Barnaul",
		"Lat": "53.355",
		"Long": "83.745",
		"CountryCode": "RU"
	  },
	  {
		"Area": "Barquisimeto",
		"Lat": "10.05",
		"Long": "-69.3",
		"CountryCode": "VE"
	  },
	  {
		"Area": "Barra do Garças",
		"Lat": "-15.8796",
		"Long": "-52.26",
		"CountryCode": "BR"
	  },
	  {
		"Area": "Barra Mansa",
		"Lat": "-22.56",
		"Long": "-44.17",
		"CountryCode": "BR"
	  },
	  {
		"Area": "Barrancabermeja",
		"Lat": "7.09",
		"Long": "-73.85",
		"CountryCode": "CO"
	  },
	  {
		"Area": "Barranquilla",
		"Lat": "10.96",
		"Long": "-74.8",
		"CountryCode": "CO"
	  },
	  {
		"Area": "Barreiras",
		"Lat": "-12.14",
		"Long": "-45",
		"CountryCode": "BR"
	  },
	  {
		"Area": "Barretos",
		"Lat": "-20.55",
		"Long": "-48.58",
		"CountryCode": "BR"
	  },
	  {
		"Area": "Barrie",
		"Lat": "44.3838",
		"Long": "-79.7",
		"CountryCode": "CA"
	  },
	  {
		"Area": "Bartlett",
		"Lat": "35.2337",
		"Long": "-89.8195",
		"CountryCode": "US"
	  },
	  {
		"Area": "Barysaw",
		"Lat": "54.226",
		"Long": "28.4922",
		"CountryCode": "BY"
	  },
	  {
		"Area": "Basankusu",
		"Lat": "1.2337",
		"Long": "19.8",
		"CountryCode": "CD"
	  },
	  {
		"Area": "Basel",
		"Lat": "47.5804",
		"Long": "7.59",
		"CountryCode": "CH"
	  },
	  {
		"Area": "Basra",
		"Lat": "30.5135",
		"Long": "47.8136",
		"CountryCode": "IQ"
	  },
	  {
		"Area": "Bassar",
		"Lat": "9.261",
		"Long": "0.789",
		"CountryCode": "TG"
	  },
	  {
		"Area": "Bata",
		"Lat": "1.87",
		"Long": "9.77",
		"CountryCode": "GQ"
	  },
	  {
		"Area": "Batangas",
		"Lat": "13.7817",
		"Long": "121.0217",
		"CountryCode": "PH"
	  },
	  {
		"Area": "Batatais",
		"Lat": "-20.89",
		"Long": "-47.59",
		"CountryCode": "BR"
	  },
	  {
		"Area": "Bataysk",
		"Lat": "47.1368",
		"Long": "39.7449",
		"CountryCode": "RU"
	  },
	  {
		"Area": "Bath",
		"Lat": "51.3837",
		"Long": "-2.35",
		"CountryCode": "GB"
	  },
	  {
		"Area": "Batman",
		"Lat": "37.8904",
		"Long": "41.14",
		"CountryCode": "TR"
	  },
	  {
		"Area": "Batna",
		"Lat": "35.57",
		"Long": "6.17",
		"CountryCode": "DZ"
	  },
	  {
		"Area": "Baton Rouge",
		"Lat": "30.4423",
		"Long": "-91.1314",
		"CountryCode": "US"
	  },
	  {
		"Area": "Battambang",
		"Lat": "13.1",
		"Long": "103.2",
		"CountryCode": "KH"
	  },
	  {
		"Area": "Batticaloa",
		"Lat": "7.717",
		"Long": "81.7",
		"CountryCode": "LK"
	  },
	  {
		"Area": "Battle Creek",
		"Lat": "42.2985",
		"Long": "-85.2296",
		"CountryCode": "US"
	  },
	  {
		"Area": "Batu Pahat",
		"Lat": "1.8504",
		"Long": "102.9333",
		"CountryCode": "MY"
	  },
	  {
		"Area": "Batumi",
		"Lat": "41.6",
		"Long": "41.63",
		"CountryCode": "GE"
	  },
	  {
		"Area": "Bauchi",
		"Lat": "10.3104",
		"Long": "9.84",
		"CountryCode": "NG"
	  },
	  {
		"Area": "Bauru",
		"Lat": "-22.33",
		"Long": "-49.08",
		"CountryCode": "BR"
	  },
	  {
		"Area": "Bawku",
		"Lat": "11.0604",
		"Long": "-0.24",
		"CountryCode": "GH"
	  },
	  {
		"Area": "Bay City",
		"Lat": "43.5903",
		"Long": "-83.8886",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bayamo",
		"Lat": "20.3795",
		"Long": "-76.6433",
		"CountryCode": "CU"
	  },
	  {
		"Area": "Baydhabo",
		"Lat": "3.12",
		"Long": "43.65",
		"CountryCode": "SO"
	  },
	  {
		"Area": "Bayonne",
		"Lat": "40.6659",
		"Long": "-74.1141",
		"CountryCode": "US"
	  },
	  {
		"Area": "Baytown",
		"Lat": "29.7607",
		"Long": "-94.9628",
		"CountryCode": "US"
	  },
	  {
		"Area": "Beaufort",
		"Lat": "32.4487",
		"Long": "-80.7103",
		"CountryCode": "US"
	  },
	  {
		"Area": "Beaumont",
		"Lat": "30.0849",
		"Long": "-94.1451",
		"CountryCode": "US"
	  },
	  {
		"Area": "Beaverton",
		"Lat": "45.4779",
		"Long": "-122.8168",
		"CountryCode": "US"
	  },
	  {
		"Area": "Béchar",
		"Lat": "31.6111",
		"Long": "-2.23",
		"CountryCode": "DZ"
	  },
	  {
		"Area": "Beckley",
		"Lat": "37.7878",
		"Long": "-81.1841",
		"CountryCode": "US"
	  },
	  {
		"Area": "Beer Sheva",
		"Lat": "31.25",
		"Long": "34.83",
		"CountryCode": "IL"
	  },
	  {
		"Area": "Behbehan",
		"Lat": "30.5818",
		"Long": "50.2615",
		"CountryCode": "IR"
	  },
	  {
		"Area": "Beian",
		"Lat": "48.239",
		"Long": "126.482",
		"CountryCode": "CN"
	  },
	  {
		"Area": "Beihai",
		"Lat": "21.4804",
		"Long": "109.1",
		"CountryCode": "CN"
	  },
	  {
		"Area": "Beijing",
		"Lat": "39.9289",
		"Long": "116.3883",
		"CountryCode": "CN"
	  },
	  {
		"Area": "Beipiao",
		"Lat": "41.81",
		"Long": "120.76",
		"CountryCode": "CN"
	  },
	  {
		"Area": "Beira",
		"Lat": "-19.82",
		"Long": "34.87",
		"CountryCode": "MZ"
	  },
	  {
		"Area": "Beirut",
		"Lat": "33.872",
		"Long": "35.5097",
		"CountryCode": "LB"
	  },
	  {
		"Area": "Béja",
		"Lat": "36.7304",
		"Long": "9.19",
		"CountryCode": "TN"
	  },
	  {
		"Area": "Béjaïa",
		"Lat": "36.7604",
		"Long": "5.07",
		"CountryCode": "DZ"
	  },
	  {
		"Area": "Bekasi",
		"Lat": "-6.2173",
		"Long": "106.9723",
		"CountryCode": "ID"
	  },
	  {
		"Area": "Békéscsaba",
		"Lat": "46.672",
		"Long": "21.101",
		"CountryCode": "HU"
	  },
	  {
		"Area": "Belebey",
		"Lat": "54.1291",
		"Long": "54.1187",
		"CountryCode": "RU"
	  },
	  {
		"Area": "Beledweyne",
		"Lat": "4.74",
		"Long": "45.2",
		"CountryCode": "SO"
	  },
	  {
		"Area": "Belém",
		"Lat": "-1.45",
		"Long": "-48.48",
		"CountryCode": "BR"
	  },
	  {
		"Area": "Belfast",
		"Lat": "54.6",
		"Long": "-5.96",
		"CountryCode": "GB"
	  },
	  {
		"Area": "Belgorod",
		"Lat": "50.63",
		"Long": "36.5999",
		"CountryCode": "RU"
	  },
	  {
		"Area": "Belgrade",
		"Lat": "44.8186",
		"Long": "20.468",
		"CountryCode": "RS"
	  },
	  {
		"Area": "BZ City",
		"Lat": "17.4987",
		"Long": "-88.1884",
		"CountryCode": "BZ"
	  },
	  {
		"Area": "Bellevue",
		"Lat": "47.5953",
		"Long": "-122.1551",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bellevue",
		"Lat": "41.1535",
		"Long": "-95.9357",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bellflower",
		"Lat": "33.888",
		"Long": "-118.1271",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bellingham",
		"Lat": "48.7543",
		"Long": "-122.4687",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bello",
		"Lat": "6.33",
		"Long": "-75.57",
		"CountryCode": "CO"
	  },
	  {
		"Area": "Belo Horizonte",
		"Lat": "-19.915",
		"Long": "-43.915",
		"CountryCode": "BR"
	  },
	  {
		"Area": "Belogorsk",
		"Lat": "50.9191",
		"Long": "128.4637",
		"CountryCode": "RU"
	  },
	  {
		"Area": "Beloit",
		"Lat": "42.523",
		"Long": "-89.0184",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bend",
		"Lat": "44.0562",
		"Long": "-121.3087",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bendigo",
		"Lat": "-36.76",
		"Long": "144.28",
		"CountryCode": "AU"
	  },
	  {
		"Area": "Benevento",
		"Lat": "41.1337",
		"Long": "14.75",
		"CountryCode": "IT"
	  },
	  {
		"Area": "Bengbu",
		"Lat": "32.95",
		"Long": "117.33",
		"CountryCode": "CN"
	  },
	  {
		"Area": "Bengkulu",
		"Lat": "-3.8",
		"Long": "102.27",
		"CountryCode": "ID"
	  },
	  {
		"Area": "Benguela",
		"Lat": "-12.5783",
		"Long": "13.4072",
		"CountryCode": "AO"
	  },
	  {
		"Area": "Benha",
		"Lat": "30.4667",
		"Long": "31.1833",
		"CountryCode": "EG"
	  },
	  {
		"Area": "Beni",
		"Lat": "0.4904",
		"Long": "29.45",
		"CountryCode": "CD"
	  },
	  {
		"Area": "Beni Mazar",
		"Lat": "28.4904",
		"Long": "30.81",
		"CountryCode": "EG"
	  },
	  {
		"Area": "Beni Suef",
		"Lat": "29.0804",
		"Long": "31.09",
		"CountryCode": "EG"
	  },
	  {
		"Area": "BJ City",
		"Lat": "6.3405",
		"Long": "5.62",
		"CountryCode": "NG"
	  },
	  {
		"Area": "Benoni",
		"Lat": "-26.1496",
		"Long": "28.3299",
		"CountryCode": "ZA"
	  },
	  {
		"Area": "Bento Gonçalves",
		"Lat": "-29.1695",
		"Long": "-51.52",
		"CountryCode": "BR"
	  },
	  {
		"Area": "Benton Harbor",
		"Lat": "42.1159",
		"Long": "-86.4488",
		"CountryCode": "US"
	  },
	  {
		"Area": "Benxi",
		"Lat": "41.3304",
		"Long": "123.75",
		"CountryCode": "CN"
	  },
	  {
		"Area": "Berbérati",
		"Lat": "4.25",
		"Long": "15.78",
		"CountryCode": "CF"
	  },
	  {
		"Area": "Berdyansk",
		"Lat": "46.7568",
		"Long": "36.7868",
		"CountryCode": "UA"
	  },
	  {
		"Area": "Berezniki",
		"Lat": "59.42",
		"Long": "56.76",
		"CountryCode": "RU"
	  },
	  {
		"Area": "Bergamo",
		"Lat": "45.7004",
		"Long": "9.67",
		"CountryCode": "IT"
	  },
	  {
		"Area": "Bergen",
		"Lat": "60.391",
		"Long": "5.3245",
		"CountryCode": "NO"
	  },
	  {
		"Area": "Berkeley",
		"Lat": "37.8723",
		"Long": "-122.276",
		"CountryCode": "US"
	  },
	  {
		"Area": "Berlin",
		"Lat": "52.5218",
		"Long": "13.4015",
		"CountryCode": "DE"
	  },
	  {
		"Area": "Bern",
		"Lat": "46.9167",
		"Long": "7.467",
		"CountryCode": "CH"
	  },
	  {
		"Area": "Bertoua",
		"Lat": "4.5804",
		"Long": "13.68",
		"CountryCode": "CM"
	  },
	  {
		"Area": "Berwyn",
		"Lat": "41.8433",
		"Long": "-87.7909",
		"CountryCode": "US"
	  },
	  {
		"Area": "Besançon",
		"Lat": "47.23",
		"Long": "6.03",
		"CountryCode": "FR"
	  },
	  {
		"Area": "Bethal",
		"Lat": "-26.4696",
		"Long": "29.45",
		"CountryCode": "ZA"
	  },
	  {
		"Area": "Bethlehem",
		"Lat": "-28.2196",
		"Long": "28.3",
		"CountryCode": "ZA"
	  },
	  {
		"Area": "Bethlehem",
		"Lat": "40.6266",
		"Long": "-75.3679",
		"CountryCode": "US"
	  },
	  {
		"Area": "Béziers",
		"Lat": "43.3505",
		"Long": "3.21",
		"CountryCode": "FR"
	  },
	  {
		"Area": "Bhairawa",
		"Lat": "27.5333",
		"Long": "83.3833",
		"CountryCode": "NP"
	  },
	  {
		"Area": "Bhisho",
		"Lat": "-32.87",
		"Long": "27.39",
		"CountryCode": "ZA"
	  },
	  {
		"Area": "Biak",
		"Lat": "-1.1615",
		"Long": "136.0485",
		"CountryCode": "ID"
	  },
	  {
		"Area": "Białystok",
		"Lat": "53.1504",
		"Long": "23.17",
		"CountryCode": "PL"
	  },
	  {
		"Area": "Biarritz",
		"Lat": "43.4733",
		"Long": "-1.5616",
		"CountryCode": "FR"
	  },
	  {
		"Area": "Bida",
		"Lat": "9.0804",
		"Long": "6.01",
		"CountryCode": "NG"
	  },
	  {
		"Area": "Biel",
		"Lat": "47.1666",
		"Long": "7.25",
		"CountryCode": "CH"
	  },
	  {
		"Area": "Bielefeld",
		"Lat": "52.03",
		"Long": "8.53",
		"CountryCode": "DE"
	  },
	  {
		"Area": "Biên Hòa",
		"Lat": "10.97",
		"Long": "106.8301",
		"CountryCode": "VN"
	  },
	  {
		"Area": "Bijar",
		"Lat": "35.8741",
		"Long": "47.5937",
		"CountryCode": "IR"
	  },
	  {
		"Area": "Bila Tserkva",
		"Lat": "49.7743",
		"Long": "30.1309",
		"CountryCode": "UA"
	  },
	  {
		"Area": "Bilbao",
		"Lat": "43.25",
		"Long": "-2.93",
		"CountryCode": "ES"
	  },
	  {
		"Area": "Billings",
		"Lat": "45.7889",
		"Long": "-108.5503",
		"CountryCode": "US"
	  },
	  {
		"Area": "Binga",
		"Lat": "2.3834",
		"Long": "20.42",
		"CountryCode": "CD"
	  },
	  {
		"Area": "Binghamton",
		"Lat": "42.1014",
		"Long": "-75.9093",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bingöl",
		"Lat": "38.885",
		"Long": "40.498",
		"CountryCode": "TR"
	  },
	  {
		"Area": "Binjai",
		"Lat": "3.6204",
		"Long": "98.5001",
		"CountryCode": "ID"
	  },
	  {
		"Area": "Bintulu",
		"Lat": "3.1664",
		"Long": "113.036",
		"CountryCode": "MY"
	  },
	  {
		"Area": "Biratnagar",
		"Lat": "26.4837",
		"Long": "87.2833",
		"CountryCode": "NP"
	  },
	  {
		"Area": "Birganj",
		"Lat": "27.0004",
		"Long": "84.8666",
		"CountryCode": "NP"
	  },
	  {
		"Area": "Birjand",
		"Lat": "32.88",
		"Long": "59.2199",
		"CountryCode": "IR"
	  },
	  {
		"Area": "Birmingham",
		"Lat": "52.475",
		"Long": "-1.92",
		"CountryCode": "GB"
	  },
	  {
		"Area": "Birmingham",
		"Lat": "33.5276",
		"Long": "-86.7988",
		"CountryCode": "US"
	  },
	  {
		"Area": "Birni Nkonni",
		"Lat": "13.7904",
		"Long": "5.2599",
		"CountryCode": "NE"
	  },
	  {
		"Area": "Birnin Kebbi",
		"Lat": "12.4504",
		"Long": "4.1999",
		"CountryCode": "NG"
	  },
	  {
		"Area": "Birobidzhan",
		"Lat": "48.7974",
		"Long": "132.9508",
		"CountryCode": "RU"
	  },
	  {
		"Area": "Bishkek",
		"Lat": "42.8731",
		"Long": "74.5852",
		"CountryCode": "KG"
	  },
	  {
		"Area": "Biskra",
		"Lat": "34.86",
		"Long": "5.73",
		"CountryCode": "DZ"
	  },
	  {
		"Area": "Bismarck",
		"Lat": "46.814",
		"Long": "-100.7695",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bissau",
		"Lat": "11.865",
		"Long": "-15.5984",
		"CountryCode": "GW"
	  },
	  {
		"Area": "Bistrița",
		"Lat": "47.138",
		"Long": "24.513",
		"CountryCode": "RO"
	  },
	  {
		"Area": "Bitlis",
		"Lat": "38.394",
		"Long": "42.123",
		"CountryCode": "TR"
	  },
	  {
		"Area": "Bitola",
		"Lat": "41.0391",
		"Long": "21.3395",
		"CountryCode": "MK"
	  },
	  {
		"Area": "Biu",
		"Lat": "10.6204",
		"Long": "12.19",
		"CountryCode": "NG"
	  },
	  {
		"Area": "Biysk",
		"Lat": "52.5341",
		"Long": "85.18",
		"CountryCode": "RU"
	  },
	  {
		"Area": "Bizerte",
		"Lat": "37.2904",
		"Long": "9.855",
		"CountryCode": "TN"
	  },
	  {
		"Area": "Blackpool",
		"Lat": "53.8304",
		"Long": "-3.05",
		"CountryCode": "GB"
	  },
	  {
		"Area": "Blacksburg",
		"Lat": "37.23",
		"Long": "-80.428",
		"CountryCode": "US"
	  },
	  {
		"Area": "Blagoveshchensk",
		"Lat": "50.2666",
		"Long": "127.5333",
		"CountryCode": "RU"
	  },
	  {
		"Area": "Blaine",
		"Lat": "45.1696",
		"Long": "-93.2077",
		"CountryCode": "US"
	  },
	  {
		"Area": "Blantyre",
		"Lat": "-15.79",
		"Long": "34.9899",
		"CountryCode": "MW"
	  },
	  {
		"Area": "Blida",
		"Lat": "36.4203",
		"Long": "2.83",
		"CountryCode": "DZ"
	  },
	  {
		"Area": "Blitar",
		"Lat": "-8.0696",
		"Long": "112.15",
		"CountryCode": "ID"
	  },
	  {
		"Area": "Bloemfontein",
		"Lat": "-29.12",
		"Long": "26.2299",
		"CountryCode": "ZA"
	  },
	  {
		"Area": "Bloomington",
		"Lat": "40.4757",
		"Long": "-88.9705",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bloomington",
		"Lat": "39.1637",
		"Long": "-86.5256",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bloomington",
		"Lat": "44.8306",
		"Long": "-93.3151",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bloomsburg",
		"Lat": "41.0027",
		"Long": "-76.4561",
		"CountryCode": "US"
	  },
	  {
		"Area": "Blue Springs",
		"Lat": "39.0124",
		"Long": "-94.2722",
		"CountryCode": "US"
	  },
	  {
		"Area": "Blumenau",
		"Lat": "-26.92",
		"Long": "-49.09",
		"CountryCode": "BR"
	  },
	  {
		"Area": "Bo",
		"Lat": "7.97",
		"Long": "-11.74",
		"CountryCode": "SL"
	  },
	  {
		"Area": "Boa Vista",
		"Lat": "2.8161",
		"Long": "-60.666",
		"CountryCode": "BR"
	  },
	  {
		"Area": "Bobo Dioulasso",
		"Lat": "11.18",
		"Long": "-4.29",
		"CountryCode": "BF"
	  },
	  {
		"Area": "Boca Raton",
		"Lat": "26.3749",
		"Long": "-80.1077",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bogor",
		"Lat": "-6.57",
		"Long": "106.75",
		"CountryCode": "ID"
	  },
	  {
		"Area": "Bogota",
		"Lat": "4.5964",
		"Long": "-74.0833",
		"CountryCode": "CO"
	  },
	  {
		"Area": "Boise",
		"Lat": "43.6006",
		"Long": "-116.2316",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bojnurd",
		"Lat": "37.47",
		"Long": "57.32",
		"CountryCode": "IR"
	  },
	  {
		"Area": "Boké",
		"Lat": "10.94",
		"Long": "-14.3",
		"CountryCode": "GN"
	  },
	  {
		"Area": "Bolgatanga",
		"Lat": "10.7904",
		"Long": "-0.85",
		"CountryCode": "GH"
	  },
	  {
		"Area": "Boli",
		"Lat": "45.7564",
		"Long": "130.5759",
		"CountryCode": "CN"
	  },
	  {
		"Area": "Bolingbrook",
		"Lat": "41.6903",
		"Long": "-88.102",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bologna",
		"Lat": "44.5004",
		"Long": "11.34",
		"CountryCode": "IT"
	  },
	  {
		"Area": "Bolu",
		"Lat": "40.7363",
		"Long": "31.6061",
		"CountryCode": "TR"
	  },
	  {
		"Area": "Bolzano",
		"Lat": "46.5004",
		"Long": "11.36",
		"CountryCode": "IT"
	  },
	  {
		"Area": "Boma",
		"Lat": "-5.83",
		"Long": "13.05",
		"CountryCode": "CD"
	  },
	  {
		"Area": "Bombo",
		"Lat": "0.5833",
		"Long": "32.5333",
		"CountryCode": "UG"
	  },
	  {
		"Area": "Bonao",
		"Lat": "18.942",
		"Long": "-70.409",
		"CountryCode": "DO"
	  },
	  {
		"Area": "Bondoukou",
		"Lat": "8.0304",
		"Long": "-2.8",
		"CountryCode": "CL"
	  },
	  {
		"Area": "Bongor",
		"Lat": "10.2859",
		"Long": "15.3872",
		"CountryCode": "TD"
	  },
	  {
		"Area": "Bonita Springs",
		"Lat": "26.3559",
		"Long": "-81.7861",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bonn",
		"Lat": "50.7205",
		"Long": "7.08",
		"CountryCode": "DE"
	  },
	  {
		"Area": "Bontang",
		"Lat": "0.1333",
		"Long": "117.5",
		"CountryCode": "ID"
	  },
	  {
		"Area": "Borås",
		"Lat": "57.7304",
		"Long": "12.92",
		"CountryCode": "SE"
	  },
	  {
		"Area": "Bordeaux",
		"Lat": "44.85",
		"Long": "-0.595",
		"CountryCode": "FR"
	  },
	  {
		"Area": "Bordj Bou Arréridj",
		"Lat": "36.059",
		"Long": "4.63",
		"CountryCode": "DZ"
	  },
	  {
		"Area": "Borisoglebsk",
		"Lat": "51.3687",
		"Long": "42.0887",
		"CountryCode": "RU"
	  },
	  {
		"Area": "Borovichi",
		"Lat": "58.3978",
		"Long": "33.8974",
		"CountryCode": "RU"
	  },
	  {
		"Area": "Borujerd",
		"Lat": "33.92",
		"Long": "48.8",
		"CountryCode": "IR"
	  },
	  {
		"Area": "Bose",
		"Lat": "23.8997",
		"Long": "106.6133",
		"CountryCode": "CN"
	  },
	  {
		"Area": "Bossangoa",
		"Lat": "6.4837",
		"Long": "17.45",
		"CountryCode": "CF"
	  },
	  {
		"Area": "Bossier City",
		"Lat": "32.523",
		"Long": "-93.6666",
		"CountryCode": "US"
	  },
	  {
		"Area": "Boston",
		"Lat": "42.3188",
		"Long": "-71.0846",
		"CountryCode": "US"
	  },
	  {
		"Area": "Botoșani",
		"Lat": "47.7484",
		"Long": "26.6597",
		"CountryCode": "RO"
	  },
	  {
		"Area": "Botucatu",
		"Lat": "-22.8796",
		"Long": "-48.45",
		"CountryCode": "BR"
	  },
	  {
		"Area": "Bouaflé",
		"Lat": "6.978",
		"Long": "-5.748",
		"CountryCode": "CL"
	  },
	  {
		"Area": "Bouaké",
		"Lat": "7.69",
		"Long": "-5.03",
		"CountryCode": "CL"
	  },
	  {
		"Area": "Bouïra",
		"Lat": "36.3805",
		"Long": "3.9",
		"CountryCode": "DZ"
	  },
	  {
		"Area": "Boulder",
		"Lat": "40.0249",
		"Long": "-105.2523",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bourges",
		"Lat": "47.0837",
		"Long": "2.4",
		"CountryCode": "FR"
	  },
	  {
		"Area": "Bournemouth",
		"Lat": "50.73",
		"Long": "-1.9",
		"CountryCode": "GB"
	  },
	  {
		"Area": "Bowie",
		"Lat": "38.9575",
		"Long": "-76.7421",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bowling Green",
		"Lat": "36.9721",
		"Long": "-86.4367",
		"CountryCode": "US"
	  },
	  {
		"Area": "Boynton Beach",
		"Lat": "26.5282",
		"Long": "-80.0811",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bozeman",
		"Lat": "45.6828",
		"Long": "-111.0548",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bradenton",
		"Lat": "27.49",
		"Long": "-82.5743",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bradford",
		"Lat": "53.8",
		"Long": "-1.75",
		"CountryCode": "GB"
	  },
	  {
		"Area": "Braga",
		"Lat": "41.555",
		"Long": "-8.4213",
		"CountryCode": "PT"
	  },
	  {
		"Area": "Bragança",
		"Lat": "-1.05",
		"Long": "-46.77",
		"CountryCode": "BR"
	  },
	  {
		"Area": "Bragança Paulista",
		"Lat": "-22.95",
		"Long": "-46.55",
		"CountryCode": "BR"
	  },
	  {
		"Area": "Brăila",
		"Lat": "45.292",
		"Long": "27.969",
		"CountryCode": "RO"
	  },
	  {
		"Area": "Brasília",
		"Lat": "-15.7833",
		"Long": "-47.9161",
		"CountryCode": "BR"
	  },
	  {
		"Area": "Brașov",
		"Lat": "45.6475",
		"Long": "25.6072",
		"CountryCode": "RO"
	  },
	  {
		"Area": "Bratislava",
		"Lat": "48.15",
		"Long": "17.117",
		"CountryCode": "SK"
	  },
	  {
		"Area": "Bratsk",
		"Lat": "56.157",
		"Long": "101.615",
		"CountryCode": "RU"
	  },
	  {
		"Area": "Braunschweig",
		"Lat": "52.25",
		"Long": "10.5",
		"CountryCode": "DE"
	  },
	  {
		"Area": "Brazzaville",
		"Lat": "-4.2592",
		"Long": "15.2847",
		"CountryCode": "CG"
	  },
	  {
		"Area": "Bremen",
		"Lat": "53.08",
		"Long": "8.8",
		"CountryCode": "DE"
	  },
	  {
		"Area": "Bremerhaven",
		"Lat": "53.5504",
		"Long": "8.58",
		"CountryCode": "DE"
	  },
	  {
		"Area": "Bremerton",
		"Lat": "47.5436",
		"Long": "-122.7122",
		"CountryCode": "US"
	  },
	  {
		"Area": "Brentwood",
		"Lat": "37.9355",
		"Long": "-121.7191",
		"CountryCode": "US"
	  },
	  {
		"Area": "Brest",
		"Lat": "52.1",
		"Long": "23.7",
		"CountryCode": "BY"
	  },
	  {
		"Area": "Brest",
		"Lat": "48.3904",
		"Long": "-4.495",
		"CountryCode": "FR"
	  },
	  {
		"Area": "Bridgeport",
		"Lat": "41.1909",
		"Long": "-73.1958",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bridgetown",
		"Lat": "13.102",
		"Long": "-59.6165",
		"CountryCode": "BB"
	  },
	  {
		"Area": "Brighton",
		"Lat": "50.8303",
		"Long": "-0.17",
		"CountryCode": "GB"
	  },
	  {
		"Area": "Brikama",
		"Lat": "13.2804",
		"Long": "-16.6599",
		"CountryCode": "GM"
	  },
	  {
		"Area": "Brindisi",
		"Lat": "40.6403",
		"Long": "17.93",
		"CountryCode": "IT"
	  },
	  {
		"Area": "Brisbane",
		"Lat": "-27.455",
		"Long": "153.0351",
		"CountryCode": "AU"
	  },
	  {
		"Area": "Bristol",
		"Lat": "51.45",
		"Long": "-2.5833",
		"CountryCode": "GB"
	  },
	  {
		"Area": "Bristol",
		"Lat": "36.5572",
		"Long": "-82.2144",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bristol",
		"Lat": "41.6812",
		"Long": "-72.9407",
		"CountryCode": "US"
	  },
	  {
		"Area": "Brits",
		"Lat": "-25.6296",
		"Long": "27.78",
		"CountryCode": "ZA"
	  },
	  {
		"Area": "Brive",
		"Lat": "45.1504",
		"Long": "1.5333",
		"CountryCode": "FR"
	  },
	  {
		"Area": "Brno",
		"Lat": "49.2004",
		"Long": "16.61",
		"CountryCode": "CZ"
	  },
	  {
		"Area": "Brockton",
		"Lat": "42.0821",
		"Long": "-71.0242",
		"CountryCode": "US"
	  },
	  {
		"Area": "Broken Arrow",
		"Lat": "36.0365",
		"Long": "-95.7808",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bronx",
		"Lat": "40.8501",
		"Long": "-73.8662",
		"CountryCode": "US"
	  },
	  {
		"Area": "Brookhaven",
		"Lat": "33.8746",
		"Long": "-84.3314",
		"CountryCode": "US"
	  },
	  {
		"Area": "Brooklyn",
		"Lat": "40.6501",
		"Long": "-73.9496",
		"CountryCode": "US"
	  },
	  {
		"Area": "Brooklyn Park",
		"Lat": "45.1112",
		"Long": "-93.3505",
		"CountryCode": "US"
	  },
	  {
		"Area": "Broomfield",
		"Lat": "39.9541",
		"Long": "-105.0527",
		"CountryCode": "US"
	  },
	  {
		"Area": "Brovary",
		"Lat": "50.4943",
		"Long": "30.7809",
		"CountryCode": "UA"
	  },
	  {
		"Area": "Brownsville",
		"Lat": "25.998",
		"Long": "-97.4565",
		"CountryCode": "US"
	  },
	  {
		"Area": "Brugge",
		"Lat": "51.2204",
		"Long": "3.23",
		"CountryCode": "BE"
	  },
	  {
		"Area": "Brunswick",
		"Lat": "31.145",
		"Long": "-81.474",
		"CountryCode": "US"
	  },
	  {
		"Area": "Brusque",
		"Lat": "-27.13",
		"Long": "-48.93",
		"CountryCode": "BR"
	  },
	  {
		"Area": "Brussels",
		"Lat": "50.8333",
		"Long": "4.3333",
		"CountryCode": "BE"
	  },
	  {
		"Area": "Bryan",
		"Lat": "30.6657",
		"Long": "-96.3672",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bryansk",
		"Lat": "53.26",
		"Long": "34.43",
		"CountryCode": "RU"
	  },
	  {
		"Area": "Bucaramanga",
		"Lat": "7.1301",
		"Long": "-73.1259",
		"CountryCode": "CO"
	  },
	  {
		"Area": "Bucharest",
		"Lat": "44.4334",
		"Long": "26.0999",
		"CountryCode": "RO"
	  },
	  {
		"Area": "Buckeye",
		"Lat": "33.4318",
		"Long": "-112.643",
		"CountryCode": "US"
	  },
	  {
		"Area": "Budapest",
		"Lat": "47.5",
		"Long": "19.0833",
		"CountryCode": "HU"
	  },
	  {
		"Area": "Buea",
		"Lat": "4.155",
		"Long": "9.231",
		"CountryCode": "CM"
	  },
	  {
		"Area": "Buena Park",
		"Lat": "33.8572",
		"Long": "-118.0046",
		"CountryCode": "US"
	  },
	  {
		"Area": "Buenaventura",
		"Lat": "3.8724",
		"Long": "-77.0505",
		"CountryCode": "CO"
	  },
	  {
		"Area": "Buenos Aires",
		"Lat": "-34.6025",
		"Long": "-58.3975",
		"CountryCode": "AR"
	  },
	  {
		"Area": "Buffalo",
		"Lat": "42.9017",
		"Long": "-78.8487",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bugulma",
		"Lat": "54.5543",
		"Long": "52.7943",
		"CountryCode": "RU"
	  },
	  {
		"Area": "Buguruslan",
		"Lat": "53.663",
		"Long": "52.433",
		"CountryCode": "RU"
	  },
	  {
		"Area": "Buizhou",
		"Lat": "37.3704",
		"Long": "118.02",
		"CountryCode": "CN"
	  },
	  {
		"Area": "Bujumbura",
		"Lat": "-3.3761",
		"Long": "29.36",
		"CountryCode": "BI"
	  },
	  {
		"Area": "Bukavu",
		"Lat": "-2.51",
		"Long": "28.84",
		"CountryCode": "CD"
	  },
	  {
		"Area": "Bukhara",
		"Lat": "39.78",
		"Long": "64.43",
		"CountryCode": "UZ"
	  },
	  {
		"Area": "Bukittinggi",
		"Lat": "-0.3031",
		"Long": "100.3615",
		"CountryCode": "ID"
	  },
	  {
		"Area": "Bukoba",
		"Lat": "-1.3196",
		"Long": "31.8",
		"CountryCode": "TZ"
	  },
	  {
		"Area": "Bulawayo",
		"Lat": "-20.17",
		"Long": "28.58",
		"CountryCode": "ZW"
	  },
	  {
		"Area": "Bumba",
		"Lat": "2.19",
		"Long": "22.46",
		"CountryCode": "CD"
	  },
	  {
		"Area": "Bundaberg",
		"Lat": "-24.8791",
		"Long": "152.3509",
		"CountryCode": "AU"
	  },
	  {
		"Area": "Bungoma",
		"Lat": "0.5704",
		"Long": "34.56",
		"CountryCode": "KE"
	  },
	  {
		"Area": "Bunia",
		"Lat": "1.5604",
		"Long": "30.24",
		"CountryCode": "CD"
	  },
	  {
		"Area": "Buon Me Thuot",
		"Lat": "12.667",
		"Long": "108.05",
		"CountryCode": "VN"
	  },
	  {
		"Area": "Bur Said",
		"Lat": "31.26",
		"Long": "32.29",
		"CountryCode": "EG"
	  },
	  {
		"Area": "Buraydah",
		"Lat": "26.3664",
		"Long": "43.9628",
		"CountryCode": "SA"
	  },
	  {
		"Area": "Burbank",
		"Lat": "34.1879",
		"Long": "-118.3234",
		"CountryCode": "US"
	  },
	  {
		"Area": "Burdur",
		"Lat": "37.7167",
		"Long": "30.2833",
		"CountryCode": "TR"
	  },
	  {
		"Area": "Burgas",
		"Lat": "42.5146",
		"Long": "27.4746",
		"CountryCode": "BG"
	  },
	  {
		"Area": "Burgos",
		"Lat": "42.3504",
		"Long": "-3.68",
		"CountryCode": "ES"
	  },
	  {
		"Area": "Burien",
		"Lat": "47.4762",
		"Long": "-122.3393",
		"CountryCode": "US"
	  },
	  {
		"Area": "Burlington",
		"Lat": "36.0762",
		"Long": "-79.4687",
		"CountryCode": "US"
	  },
	  {
		"Area": "Burlington",
		"Lat": "44.4877",
		"Long": "-73.2314",
		"CountryCode": "US"
	  },
	  {
		"Area": "Burnsville",
		"Lat": "44.7648",
		"Long": "-93.2795",
		"CountryCode": "US"
	  },
	  {
		"Area": "Bursa",
		"Lat": "40.2",
		"Long": "29.07",
		"CountryCode": "TR"
	  },
	  {
		"Area": "Busan",
		"Lat": "35.0951",
		"Long": "129.01",
		"CountryCode": "kr"
	  },
	  {
		"Area": "Butare",
		"Lat": "-2.5896",
		"Long": "29.73",
		"CountryCode": "RW"
	  },
	  {
		"Area": "Butembo",
		"Lat": "0.13",
		"Long": "29.28",
		"CountryCode": "CD"
	  },
	  {
		"Area": "Butterworth",
		"Lat": "5.4171",
		"Long": "100.4",
		"CountryCode": "MY"
	  },
	  {
		"Area": "Butuan",
		"Lat": "8.9495",
		"Long": "125.5436",
		"CountryCode": "PH"
	  },
	  {
		"Area": "Buynaksk",
		"Lat": "42.8335",
		"Long": "47.113",
		"CountryCode": "RU"
	  },
	  {
		"Area": "Buzău",
		"Lat": "45.1565",
		"Long": "26.8065",
		"CountryCode": "RO"
	  },
	  {
		"Area": "Buzuluk",
		"Lat": "52.7821",
		"Long": "52.2618",
		"CountryCode": "RU"
	  },
	  {
		"Area": "Bydgoszcz",
		"Lat": "53.1204",
		"Long": "18.01",
		"CountryCode": "PL"
	  },
	  {
		"Area": "Bytom",
		"Lat": "50.35",
		"Long": "18.91",
		"CountryCode": "PL"
	  },
	  {
		"Area": "Byumba",
		"Lat": "-1.5796",
		"Long": "30.06",
		"CountryCode": "RW"
	  },
      {
        "Area": "C N Halli",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 13.527,
        "Long": 76.9477
      },
      {
        "Area": "C R Mgrh",
        "State": "Haryana",
        "CountryCode": "IN",
        "Lat": 28.4851,
        "Long": 76.4735
      },
      {
        "Area": "C.Belagal",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 15.8548,
        "Long": 78.0061
      },
      {
        "Area": "C.k. Palli",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 14.3072,
        "Long": 77.917
      },
      {
        "Area": "C.k.. Palli",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 14.2042,
        "Long": 77.8111
      },
      {
        "Area": "C.k.palli",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 14.2819,
        "Long": 77.917
      },
      {
        "Area": "C.n. Halli",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 13.5836,
        "Long": 76.5423
      },
      {
        "Area": "C.n.halli",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 13.7952,
        "Long": 77.2814
      },
      {
        "Area": "C.n.hally",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 13.5202,
        "Long": 76.9477
      },
      {
        "Area": "CHALAKUDI",
        "State": "Kerala",
        "CountryCode": "IN",
        "Lat": 10.5386,
        "Long": 76.3299
      },
      {
        "Area": "Cachar",
        "State": "Assam",
        "CountryCode": "IN",
        "Lat": 24.8313,
        "Long": 92.804
      },
      {
        "Area": "Cahrata",
        "State": "Uttarakhand",
        "CountryCode": "IN",
        "Lat": 30.4635,
        "Long": 77.9732
      },
      {
        "Area": "Campeirganj",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 26.998,
        "Long": 83.4665
      },
      {
        "Area": "Camperganj",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 27.052,
        "Long": 83.3001
      },
      {
        "Area": "Campierganj",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 27.069,
        "Long": 83.3614
      },
      {
        "Area": "Canacona",
        "State": "Goa",
        "CountryCode": "IN",
        "Lat": 15.0763,
        "Long": 74.0714
      },
      {
        "Area": "Cancona",
        "State": "Goa",
        "CountryCode": "IN",
        "Lat": 15.0278,
        "Long": 74.0865
      },
      {
        "Area": "Canning",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.4854,
        "Long": 88.5638
      },
      {
        "Area": "Canning - I",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.415,
        "Long": 88.7883
      },
      {
        "Area": "Canning - II",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.415,
        "Long": 88.6324
      },
      {
        "Area": "Canning town",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.1996,
        "Long": 88.6324
      },
      {
        "Area": "Cantt.",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 26.5167,
        "Long": 80.3155
      },
      {
        "Area": "Carnicobar",
        "State": "Andaman & Nicobar Islands",
        "CountryCode": "IN",
        "Lat": 9.2333,
        "Long": 93.6031
      },
      {
        "Area": "Cc",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 17.5397,
        "Long": 79.2245
      },
      {
        "Area": "Cckunta",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 16.9382,
        "Long": 78.0455
      },
      {
        "Area": "Central Market",
        "State": "Jammu & Kashmir",
        "CountryCode": "IN",
        "Lat": 33.8359,
        "Long": 74.8589
      },
      {
        "Area": "Ch-dadri",
        "State": "Haryana",
        "CountryCode": "IN",
        "Lat": 28.4948,
        "Long": 76.2706
      },
      {
        "Area": "Ch.madharam",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 17.5969,
        "Long": 80.6873
      },
      {
        "Area": "Ch.udepur",
        "State": "Gujarat",
        "CountryCode": "IN",
        "Lat": 22.2446,
        "Long": 74.0194
      },
      {
        "Area": "Chabhal",
        "State": "Punjab",
        "CountryCode": "IN",
        "Lat": 31.7046,
        "Long": 74.9007
      },
      {
        "Area": "Chabua",
        "State": "Assam",
        "CountryCode": "IN",
        "Lat": 27.5786,
        "Long": 95.6265
      },
      {
        "Area": "Chacauda",
        "State": "Madhya Pradesh",
        "CountryCode": "IN",
        "Lat": 24.5546,
        "Long": 77.2008
      },
      {
        "Area": "Chachauda",
        "State": "Madhya Pradesh",
        "CountryCode": "IN",
        "Lat": 24.5546,
        "Long": 77.2008
      },
      {
        "Area": "Chachiot",
        "State": "Himachal Pradesh",
        "CountryCode": "IN",
        "Lat": 31.6383,
        "Long": 77.2301
      },
      {
        "Area": "Chachoda",
        "State": "Madhya Pradesh",
        "CountryCode": "IN",
        "Lat": 24.1894,
        "Long": 77.0321
      },
      {
        "Area": "Chachyot(T)",
        "State": "Himachal Pradesh",
        "CountryCode": "IN",
        "Lat": 31.6383,
        "Long": 77.2301
      },
      {
        "Area": "Chadarlapadu",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 16.6238,
        "Long": 80.2461
      },
      {
        "Area": "Chadi",
        "State": "Rajasthan",
        "CountryCode": "IN",
        "Lat": 27.3417,
        "Long": 73.0992
      },
      {
        "Area": "Chadoora",
        "State": "Jammu & Kashmir",
        "CountryCode": "IN",
        "Lat": 33.8072,
        "Long": 74.8689
      },
      {
        "Area": "Chadura",
        "State": "Jammu & Kashmir",
        "CountryCode": "IN",
        "Lat": 34.0151,
        "Long": 74.919
      },
      {
        "Area": "Chagallu Mandal",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 16.9928,
        "Long": 81.6649
      },
      {
        "Area": "Chagallu Mandalam",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 16.9698,
        "Long": 81.6994
      },
      {
        "Area": "Chagally Mandalam",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 16.9607,
        "Long": 81.7023
      },
      {
        "Area": "Chaibari",
        "State": "Assam",
        "CountryCode": "IN",
        "Lat": 26.5004,
        "Long": 91.4784
      },
      {
        "Area": "Chaibasa",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 22.7629,
        "Long": 86.4527
      },
      {
        "Area": "Chaigharia",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.6259,
        "Long": 88.6827
      },
      {
        "Area": "Chail",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 25.7478,
        "Long": 81.9717
      },
      {
        "Area": "Chailengta",
        "State": "Tripura",
        "CountryCode": "IN",
        "Lat": 23.9923,
        "Long": 91.6205
      },
      {
        "Area": "Chaini ( Jharobari)",
        "State": "Assam",
        "CountryCode": "IN",
        "Lat": 26.243,
        "Long": 91.7368
      },
      {
        "Area": "Chainpur",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 25.3342,
        "Long": 84.0864
      },
      {
        "Area": "Chainpur",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 24.0919,
        "Long": 84.5347
      },
      {
        "Area": "Chaita",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.399,
        "Long": 88.0555
      },
      {
        "Area": "Chaital",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.5152,
        "Long": 88.7758
      },
      {
        "Area": "Chak Islampur",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.3836,
        "Long": 87.8747
      },
      {
        "Area": "Chakai",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 24.9239,
        "Long": 86.444
      },
      {
        "Area": "Chakai So",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 24.5661,
        "Long": 86.4441
      },
      {
        "Area": "Chakalakonda",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 15.0079,
        "Long": 79.7344
      },
      {
        "Area": "Chakapad",
        "State": "Odisha",
        "CountryCode": "IN",
        "Lat": 20.2651,
        "Long": 84.5272
      },
      {
        "Area": "Chakar Nagar",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 27.3061,
        "Long": 79.8479
      },
      {
        "Area": "Chakarbhata Camp",
        "State": "Chattisgarh",
        "CountryCode": "IN",
        "Lat": 22.0677,
        "Long": 82.0221
      },
      {
        "Area": "Chakarnagar",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 26.5833,
        "Long": 79.1579
      },
      {
        "Area": "Chakarnagar **",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 26.3901,
        "Long": 79.2369
      },
      {
        "Area": "Chakarpur",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 26.3805,
        "Long": 80.2158
      },
      {
        "Area": "Chakbhabani",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.475,
        "Long": 87.8219
      },
      {
        "Area": "Chakdah",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 23.7129,
        "Long": 88.637
      },
      {
        "Area": "Chakdaha",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 23.7129,
        "Long": 88.5215
      },
      {
        "Area": "Chakdradharpur",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 22.8218,
        "Long": 85.6399
      },
      {
        "Area": "Chakeri",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 26.5167,
        "Long": 80.3155
      },
      {
        "Area": "Chakia",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 26.786,
        "Long": 84.9986
      },
      {
        "Area": "Chakia",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 25.4017,
        "Long": 83.4194
      },
      {
        "Area": "Chakia(Pipra)",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 26.4827,
        "Long": 84.9923
      },
      {
        "Area": "Chakki",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 25.5958,
        "Long": 84.2366
      },
      {
        "Area": "Chakla",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.7561,
        "Long": 88.6904
      },
      {
        "Area": "Chakmaghat",
        "State": "Tripura",
        "CountryCode": "IN",
        "Lat": 24.007,
        "Long": 91.6093
      },
      {
        "Area": "Chakmahima",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.8223,
        "Long": 87.5059
      },
      {
        "Area": "Chakpatli",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.5455,
        "Long": 88.9366
      },
      {
        "Area": "Chakpikarong",
        "State": "Manipur",
        "CountryCode": "IN",
        "Lat": 24.8782,
        "Long": 93.9796
      },
      {
        "Area": "Chakradharpur",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 22.8458,
        "Long": 85.9516
      },
      {
        "Area": "Chakrata",
        "State": "Uttarakhand",
        "CountryCode": "IN",
        "Lat": 30.8621,
        "Long": 78.0026
      },
      {
        "Area": "Chakrayapet",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 14.4599,
        "Long": 78.7836
      },
      {
        "Area": "Chakrdharpur",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 22.6314,
        "Long": 85.4805
      },
      {
        "Area": "Chaksu",
        "State": "Rajasthan",
        "CountryCode": "IN",
        "Lat": 26.6901,
        "Long": 76.1395
      },
      {
        "Area": "Chakulia",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 23.1667,
        "Long": 86.7179
      },
      {
        "Area": "Chakur",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 18.8192,
        "Long": 76.8733
      },
      {
        "Area": "Chalisgaon",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 21.0372,
        "Long": 75.4899
      },
      {
        "Area": "Chalisgoan",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 20.4193,
        "Long": 75.0468
      },
      {
        "Area": "Challakere",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 14.6089,
        "Long": 76.9258
      },
      {
        "Area": "Challapalli",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 17.8724,
        "Long": 82.8737
      },
      {
        "Area": "Challapeta",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 18.3756,
        "Long": 83.25
      },
      {
        "Area": "Chamarajanagar",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 12.0978,
        "Long": 76.9212
      },
      {
        "Area": "Chamarajanagara",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 12.6167,
        "Long": 77.3021
      },
      {
        "Area": "Chamaria",
        "State": "Assam",
        "CountryCode": "IN",
        "Lat": 26.2077,
        "Long": 91.4061
      },
      {
        "Area": "Chamaria Block",
        "State": "Assam",
        "CountryCode": "IN",
        "Lat": 26.1111,
        "Long": 90.9902
      },
      {
        "Area": "Chamata",
        "State": "Assam",
        "CountryCode": "IN",
        "Lat": 26.3379,
        "Long": 91.2087
      },
      {
        "Area": "Chamba",
        "State": "Himachal Pradesh",
        "CountryCode": "IN",
        "Lat": 32.9973,
        "Long": 76.5398
      },
      {
        "Area": "Chamba(T)",
        "State": "Himachal Pradesh",
        "CountryCode": "IN",
        "Lat": 32.3441,
        "Long": 76.4579
      },
      {
        "Area": "Chambang",
        "State": "Arunachal Pradesh",
        "CountryCode": "IN",
        "Lat": 27.964,
        "Long": 93.5532
      },
      {
        "Area": "Chamiari",
        "State": "Punjab",
        "CountryCode": "IN",
        "Lat": 31.9049,
        "Long": 74.8919
      },
      {
        "Area": "Chamiyala",
        "State": "Uttarakhand",
        "CountryCode": "IN",
        "Lat": 30.5789,
        "Long": 78.6481
      },
      {
        "Area": "Chamkaur Sahib",
        "State": "Punjab",
        "CountryCode": "IN",
        "Lat": 30.8869,
        "Long": 76.4071
      },
      {
        "Area": "Chamoli",
        "State": "Uttarakhand",
        "CountryCode": "IN",
        "Lat": 30.4953,
        "Long": 79.5787
      },
      {
        "Area": "Chamorhsi",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 19.6423,
        "Long": 79.7968
      },
      {
        "Area": "Chamorshi",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 19.9769,
        "Long": 79.9866
      },
      {
        "Area": "Champa",
        "State": "Chattisgarh",
        "CountryCode": "IN",
        "Lat": 22.173,
        "Long": 83.1586
      },
      {
        "Area": "Champahati",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.4003,
        "Long": 88.4921
      },
      {
        "Area": "Champang",
        "State": "Nagaland",
        "CountryCode": "IN",
        "Lat": 26.624,
        "Long": 94.935
      },
      {
        "Area": "Champawat",
        "State": "Uttarakhand",
        "CountryCode": "IN",
        "Lat": 29.3708,
        "Long": 80.1065
      },
      {
        "Area": "Champhai",
        "State": "Mizoram",
        "CountryCode": "IN",
        "Lat": 23.7576,
        "Long": 93.3814
      },
      {
        "Area": "Champua",
        "State": "Odisha",
        "CountryCode": "IN",
        "Lat": 22.0673,
        "Long": 85.7679
      },
      {
        "Area": "Chamroshid",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 19.9971,
        "Long": 79.9905
      },
      {
        "Area": "Chanan",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 25.0498,
        "Long": 86.8409
      },
      {
        "Area": "Chanan (bannu Bagicha)",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 25.0845,
        "Long": 86.1408
      },
      {
        "Area": "Chanan(bannu Bagicha)",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 25.0423,
        "Long": 86.1961
      },
      {
        "Area": "Chanasma",
        "State": "Gujarat",
        "CountryCode": "IN",
        "Lat": 23.9073,
        "Long": 72.7225
      },
      {
        "Area": "Chanchal",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 25.426,
        "Long": 88.0923
      },
      {
        "Area": "Chand",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 25.1572,
        "Long": 83.6964
      },
      {
        "Area": "Chanda",
        "State": "Assam",
        "CountryCode": "IN",
        "Lat": 26.2685,
        "Long": 91.6169
      },
      {
        "Area": "Chandabali",
        "State": "Odisha",
        "CountryCode": "IN",
        "Lat": 21.0699,
        "Long": 86.6254
      },
      {
        "Area": "Chandabila",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 23.5234,
        "Long": 87.6598
      },
      {
        "Area": "Chandaka",
        "State": "Odisha",
        "CountryCode": "IN",
        "Lat": 20.4178,
        "Long": 85.2538
      },
      {
        "Area": "Chandametta",
        "State": "Madhya Pradesh",
        "CountryCode": "IN",
        "Lat": 22.1901,
        "Long": 78.7047
      },
      {
        "Area": "Chandan",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 25.0498,
        "Long": 86.8409
      },
      {
        "Area": "Chandanagar",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.8245,
        "Long": 88.3384
      },
      {
        "Area": "Chandangaon",
        "State": "Madhya Pradesh",
        "CountryCode": "IN",
        "Lat": 22.0342,
        "Long": 78.9278
      },
      {
        "Area": "Chandankiyari",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 23.7751,
        "Long": 86.0051
      },
      {
        "Area": "Chandannagar",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 23.4607,
        "Long": 88.3384
      },
      {
        "Area": "Chandanpur",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.0208,
        "Long": 87.7744
      },
      {
        "Area": "Chandanpurhat",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.2088,
        "Long": 88.0387
      },
      {
        "Area": "Chandaralpadu",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 16.6735,
        "Long": 80.2056
      },
      {
        "Area": "Chandarlapadu",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 16.7419,
        "Long": 80.2144
      },
      {
        "Area": "Chandauli",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 25.6318,
        "Long": 83.4852
      },
      {
        "Area": "Chandausi",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 28.7752,
        "Long": 78.9136
      },
      {
        "Area": "Chandbali",
        "State": "Odisha",
        "CountryCode": "IN",
        "Lat": 21.0699,
        "Long": 86.9557
      },
      {
        "Area": "Chandel",
        "State": "Manipur",
        "CountryCode": "IN",
        "Lat": 24.3299,
        "Long": 94.0038
      },
      {
        "Area": "Chanderi",
        "State": "Madhya Pradesh",
        "CountryCode": "IN",
        "Lat": 24.7637,
        "Long": 78.1993
      },
      {
        "Area": "Chandgad",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 17.4896,
        "Long": 74.4146
      },
      {
        "Area": "Chandi",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 25.4171,
        "Long": 85.624
      },
      {
        "Area": "Chandigarh",
        "State": "Chandigarh",
        "CountryCode": "IN",
        "Lat": 31.2068,
        "Long": 76.7621
      },
      {
        "Area": "Chandil",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 23.1846,
        "Long": 86.0533
      },
      {
        "Area": "Chandipur",
        "State": "Tripura",
        "CountryCode": "IN",
        "Lat": 24.332,
        "Long": 92.0039
      },
      {
        "Area": "Chandipur",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.9706,
        "Long": 88.7803
      },
      {
        "Area": "Chanditala - I",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.8151,
        "Long": 88.2096
      },
      {
        "Area": "Chanditala - II",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.8847,
        "Long": 88.291
      },
      {
        "Area": "Chandkuchi",
        "State": "Assam",
        "CountryCode": "IN",
        "Lat": 26.3796,
        "Long": 91.2951
      },
      {
        "Area": "Chandkuri-batikati",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.1762,
        "Long": 87.6063
      },
      {
        "Area": "Chandmary",
        "State": "Mizoram",
        "CountryCode": "IN",
        "Lat": 23.8106,
        "Long": 92.8891
      },
      {
        "Area": "Chandole",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 16.079,
        "Long": 80.568
      },
      {
        "Area": "Chandpara",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.1465,
        "Long": 88.1117
      },
      {
        "Area": "Chandpur",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.4653,
        "Long": 88.7803
      },
      {
        "Area": "Chandpur",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 29.5758,
        "Long": 78.7235
      },
      {
        "Area": "Chandragiri",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 13.8198,
        "Long": 79.7697
      },
      {
        "Area": "Chandrahalampara",
        "State": "Tripura",
        "CountryCode": "IN",
        "Lat": 24.1597,
        "Long": 92.0329
      },
      {
        "Area": "Chandrakona-I",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.9041,
        "Long": 88.1806
      },
      {
        "Area": "Chandrakona-II",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.9041,
        "Long": 88.1806
      },
      {
        "Area": "Chandrapur",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 20.5774,
        "Long": 79.6099
      },
      {
        "Area": "Chandrapur",
        "State": "Chattisgarh",
        "CountryCode": "IN",
        "Lat": 22.0291,
        "Long": 83.2327
      },
      {
        "Area": "Chandrapur",
        "State": "Tripura",
        "CountryCode": "IN",
        "Lat": 24.0447,
        "Long": 91.7553
      },
      {
        "Area": "Chandrapur Block",
        "State": "Assam",
        "CountryCode": "IN",
        "Lat": 26.2296,
        "Long": 91.9191
      },
      {
        "Area": "Chandrapur Ho",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 20.1448,
        "Long": 79.0792
      },
      {
        "Area": "Chanduali",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 25.2806,
        "Long": 83.2611
      },
      {
        "Area": "Chandur",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 17.1219,
        "Long": 79.2887
      },
      {
        "Area": "Chandur",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 20.186,
        "Long": 78.9057
      },
      {
        "Area": "Chandur Bazar",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 21.5088,
        "Long": 78.0551
      },
      {
        "Area": "Chandur Railway",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 21.1878,
        "Long": 78.0619
      },
      {
        "Area": "Chandur Raiway",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 20.8541,
        "Long": 77.9913
      },
      {
        "Area": "Chandur Rly",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 20.9426,
        "Long": 78.0577
      },
      {
        "Area": "Chandur Rly.",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 20.8541,
        "Long": 77.9913
      },
      {
        "Area": "Chandurthi",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 18.6314,
        "Long": 79.5356
      },
      {
        "Area": "Chandvad",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 20.3194,
        "Long": 74.456
      },
      {
        "Area": "Chandwa",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 23.7985,
        "Long": 84.8403
      },
      {
        "Area": "Chandwad",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 20.5718,
        "Long": 74.814
      },
      {
        "Area": "Chandwara",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 24.393,
        "Long": 85.7535
      },
      {
        "Area": "Chandwd",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 20.2388,
        "Long": 74.3815
      },
      {
        "Area": "Changanacherry",
        "State": "Kerala",
        "CountryCode": "IN",
        "Lat": 9.6875,
        "Long": 76.7789
      },
      {
        "Area": "Changanassery",
        "State": "Kerala",
        "CountryCode": "IN",
        "Lat": 9.6875,
        "Long": 76.8523
      },
      {
        "Area": "Changlang",
        "State": "Arunachal Pradesh",
        "CountryCode": "IN",
        "Lat": 27.1318,
        "Long": 95.7349
      },
      {
        "Area": "Changtogia",
        "State": "Nagaland",
        "CountryCode": "IN",
        "Lat": 26.6144,
        "Long": 94.6856
      },
      {
        "Area": "Changtongya",
        "State": "Nagaland",
        "CountryCode": "IN",
        "Lat": 26.6543,
        "Long": 94.6856
      },
      {
        "Area": "Chanho",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 23.371,
        "Long": 84.9682
      },
      {
        "Area": "Chankhala",
        "State": "Tripura",
        "CountryCode": "IN",
        "Lat": 24.019,
        "Long": 91.625
      },
      {
        "Area": "Chanmary",
        "State": "Mizoram",
        "CountryCode": "IN",
        "Lat": 23.9394,
        "Long": 92.7693
      },
      {
        "Area": "Channagiri",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 14.5305,
        "Long": 76.5068
      },
      {
        "Area": "Channapatna",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 13.1252,
        "Long": 77.4545
      },
      {
        "Area": "Channarayapatana",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 12.9954,
        "Long": 76.1091
      },
      {
        "Area": "Channarayapatna",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 13.3236,
        "Long": 76.6165
      },
      {
        "Area": "Channarayaptna",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 12.9954,
        "Long": 76.6177
      },
      {
        "Area": "Channaryapatna",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 12.881,
        "Long": 76.4707
      },
      {
        "Area": "Channrayapatna",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 13.063,
        "Long": 76.6165
      },
      {
        "Area": "Chantail",
        "State": "Tripura",
        "CountryCode": "IN",
        "Lat": 23.9923,
        "Long": 91.6205
      },
      {
        "Area": "Chanwad",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 20.0532,
        "Long": 74.1305
      },
      {
        "Area": "Chapad",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 14.7781,
        "Long": 78.5707
      },
      {
        "Area": "Chapadu",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 14.7704,
        "Long": 78.6637
      },
      {
        "Area": "Chapakhowa",
        "State": "Assam",
        "CountryCode": "IN",
        "Lat": 27.831,
        "Long": 95.6682
      },
      {
        "Area": "Chapar Salkocha",
        "State": "Assam",
        "CountryCode": "IN",
        "Lat": 26.2727,
        "Long": 90.4456
      },
      {
        "Area": "Chapatala",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 21.7907,
        "Long": 87.8635
      },
      {
        "Area": "Chapra",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 23.8101,
        "Long": 88.5215
      },
      {
        "Area": "Chapra",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 26.1448,
        "Long": 85.9653
      },
      {
        "Area": "Char-sharief",
        "State": "Jammu & Kashmir",
        "CountryCode": "IN",
        "Lat": 33.8463,
        "Long": 74.8035
      },
      {
        "Area": "Charal",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 18.2139,
        "Long": 80.5396
      },
      {
        "Area": "Charalkhali",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 23.4323,
        "Long": 88.373
      },
      {
        "Area": "Charama",
        "State": "Chattisgarh",
        "CountryCode": "IN",
        "Lat": 20.5407,
        "Long": 81.3983
      },
      {
        "Area": "Charbhuja",
        "State": "Rajasthan",
        "CountryCode": "IN",
        "Lat": 25.5756,
        "Long": 74.1313
      },
      {
        "Area": "Charghat",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.4948,
        "Long": 88.4232
      },
      {
        "Area": "Chariali",
        "State": "Assam",
        "CountryCode": "IN",
        "Lat": 26.6726,
        "Long": 94.0108
      },
      {
        "Area": "Chariantatapur",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 24.5656,
        "Long": 87.9504
      },
      {
        "Area": "Chariduar",
        "State": "Assam",
        "CountryCode": "IN",
        "Lat": 26.4206,
        "Long": 93.2317
      },
      {
        "Area": "Charilai",
        "State": "Assam",
        "CountryCode": "IN",
        "Lat": 26.6726,
        "Long": 94.0108
      },
      {
        "Area": "Charkhi Dadri",
        "State": "Haryana",
        "CountryCode": "IN",
        "Lat": 28.8431,
        "Long": 76.4483
      },
      {
        "Area": "Charla",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 18.2871,
        "Long": 81.0042
      },
      {
        "Area": "Charminar",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 17.3862,
        "Long": 78.4896
      },
      {
        "Area": "Charwa",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 25.7478,
        "Long": 81.8826
      },
      {
        "Area": "Chas",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 24.0262,
        "Long": 86.5629
      },
      {
        "Area": "Chataparru",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 16.6822,
        "Long": 81.2126
      },
      {
        "Area": "Chatapur",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 26.4573,
        "Long": 87.0413
      },
      {
        "Area": "Chatla",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 21.9958,
        "Long": 87.8022
      },
      {
        "Area": "Chatra",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.4948,
        "Long": 88.4232
      },
      {
        "Area": "Chatra",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 24.4123,
        "Long": 85.0758
      },
      {
        "Area": "Chatrai",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 17.0571,
        "Long": 80.9187
      },
      {
        "Area": "Chatrapur",
        "State": "Odisha",
        "CountryCode": "IN",
        "Lat": 19.9269,
        "Long": 85.0833
      },
      {
        "Area": "Chattapur",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 26.1185,
        "Long": 87.0754
      },
      {
        "Area": "Chattargam",
        "State": "Jammu & Kashmir",
        "CountryCode": "IN",
        "Lat": 33.9306,
        "Long": 75.1134
      },
      {
        "Area": "Chaubepur",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 26.4768,
        "Long": 80.4124
      },
      {
        "Area": "Chaudachulli",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 23.5034,
        "Long": 87.9832
      },
      {
        "Area": "Chaukhutia",
        "State": "Uttarakhand",
        "CountryCode": "IN",
        "Lat": 29.9296,
        "Long": 79.6441
      },
      {
        "Area": "Chaulia",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 21.939,
        "Long": 87.2942
      },
      {
        "Area": "Chaulkhola",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.3703,
        "Long": 88.2092
      },
      {
        "Area": "Chauparan",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 24.3391,
        "Long": 85.5435
      },
      {
        "Area": "Chauradano",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 26.8613,
        "Long": 85.0051
      },
      {
        "Area": "Chauraha",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 26.4302,
        "Long": 80.2963
      },
      {
        "Area": "Chaurai",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 26.2857,
        "Long": 80.2744
      },
      {
        "Area": "Chaurai",
        "State": "Madhya Pradesh",
        "CountryCode": "IN",
        "Lat": 22.1598,
        "Long": 79.3109
      },
      {
        "Area": "Chaurdano",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 26.6826,
        "Long": 84.8947
      },
      {
        "Area": "Chauri Chaura",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 27.0953,
        "Long": 83.5969
      },
      {
        "Area": "Chausa",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 25.8259,
        "Long": 87.0808
      },
      {
        "Area": "Chauth Ka Barwara",
        "State": "Rajasthan",
        "CountryCode": "IN",
        "Lat": 26.7119,
        "Long": 76.4679
      },
      {
        "Area": "Chavakkad",
        "State": "Kerala",
        "CountryCode": "IN",
        "Lat": 11.2984,
        "Long": 76.3162
      },
      {
        "Area": "Chawand",
        "State": "Rajasthan",
        "CountryCode": "IN",
        "Lat": 24.1768,
        "Long": 73.7936
      },
      {
        "Area": "Chawmanu",
        "State": "Tripura",
        "CountryCode": "IN",
        "Lat": 23.9923,
        "Long": 91.6205
      },
      {
        "Area": "Chawngte",
        "State": "Mizoram",
        "CountryCode": "IN",
        "Lat": 22.9719,
        "Long": 92.7373
      },
      {
        "Area": "Chebri",
        "State": "Tripura",
        "CountryCode": "IN",
        "Lat": 24.019,
        "Long": 91.625
      },
      {
        "Area": "Chebrole",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 16.9018,
        "Long": 81.4274
      },
      {
        "Area": "Chechapani",
        "State": "Assam",
        "CountryCode": "IN",
        "Lat": 26.7306,
        "Long": 91.5564
      },
      {
        "Area": "Cheedikada",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 17.9135,
        "Long": 82.8964
      },
      {
        "Area": "Cheepurupalle",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 18.1535,
        "Long": 83.221
      },
      {
        "Area": "Chegam",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 12.4316,
        "Long": 78.5701
      },
      {
        "Area": "Chehra Kalan",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 25.8887,
        "Long": 85.4122
      },
      {
        "Area": "Chehrakala",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 25.9016,
        "Long": 85.4453
      },
      {
        "Area": "Chejerla",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 14.5188,
        "Long": 79.7344
      },
      {
        "Area": "Chekati",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.1465,
        "Long": 88.1117
      },
      {
        "Area": "Chelpur",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 18.1951,
        "Long": 79.6402
      },
      {
        "Area": "Chembur",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 19.0931,
        "Long": 72.9049
      },
      {
        "Area": "Chenani",
        "State": "Jammu & Kashmir",
        "CountryCode": "IN",
        "Lat": 33.0725,
        "Long": 75.4258
      },
      {
        "Area": "Chenari",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 25.0192,
        "Long": 84.4619
      },
      {
        "Area": "Chendurthi",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 18.6258,
        "Long": 78.702
      },
      {
        "Area": "Chendurthy",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 18.5189,
        "Long": 78.8312
      },
      {
        "Area": "Chengallpattu",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 12.7039,
        "Long": 79.8292
      },
      {
        "Area": "Chengalpatatu",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 12.7039,
        "Long": 79.8292
      },
      {
        "Area": "Chengalpattu",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 12.8525,
        "Long": 80.1747
      },
      {
        "Area": "Chengalpattu Taluk",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 12.4025,
        "Long": 79.9866
      },
      {
        "Area": "Chengalplattu",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 12.8525,
        "Long": 80.0467
      },
      {
        "Area": "Chengam",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 12.7112,
        "Long": 79.3144
      },
      {
        "Area": "Chengannur",
        "State": "Kerala",
        "CountryCode": "IN",
        "Lat": 9.9552,
        "Long": 76.7973
      },
      {
        "Area": "Chengkap",
        "State": "Tripura",
        "CountryCode": "IN",
        "Lat": 24.0789,
        "Long": 91.8987
      },
      {
        "Area": "Chennai",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 13.1281,
        "Long": 80.2828
      },
      {
        "Area": "Chennai City",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 13.0647,
        "Long": 80.2523
      },
      {
        "Area": "Chennai City Corporation",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 13.1096,
        "Long": 80.2603
      },
      {
        "Area": "Chennai Corporation",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 13.0722,
        "Long": 80.2014
      },
      {
        "Area": "Chennaraopet",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 17.9552,
        "Long": 79.8715
      },
      {
        "Area": "Chennekothapalle",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 14.4811,
        "Long": 77.7512
      },
      {
        "Area": "Chennoor",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 18.5813,
        "Long": 79.7109
      },
      {
        "Area": "Chennraopet",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 17.8935,
        "Long": 79.8322
      },
      {
        "Area": "Chennur",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 19.2565,
        "Long": 79.9408
      },
      {
        "Area": "Chennur",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 14.5946,
        "Long": 79.1687
      },
      {
        "Area": "Cherial",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 17.9552,
        "Long": 79.7992
      },
      {
        "Area": "Cherrabazar",
        "State": "Meghalaya",
        "CountryCode": "IN",
        "Lat": 25.4353,
        "Long": 91.6422
      },
      {
        "Area": "Cherrapunjee",
        "State": "Meghalaya",
        "CountryCode": "IN",
        "Lat": 25.4184,
        "Long": 91.798
      },
      {
        "Area": "Cherthala",
        "State": "Kerala",
        "CountryCode": "IN",
        "Lat": 10.5079,
        "Long": 76.4496
      },
      {
        "Area": "Cherthla",
        "State": "Kerala",
        "CountryCode": "IN",
        "Lat": 9.8694,
        "Long": 76.305
      },
      {
        "Area": "Cherukupalle",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 16.2988,
        "Long": 80.1225
      },
      {
        "Area": "Cherukupalli",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 16.2988,
        "Long": 80.0915
      },
      {
        "Area": "Cheruuvu",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 15.9625,
        "Long": 80.4728
      },
      {
        "Area": "Cheruvu",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 15.984,
        "Long": 80.459
      },
      {
        "Area": "Cheruvumadharam",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 17.0884,
        "Long": 79.4494
      },
      {
        "Area": "Cheruvumadhram",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 17.5969,
        "Long": 80.6873
      },
      {
        "Area": "Chetanpura",
        "State": "Punjab",
        "CountryCode": "IN",
        "Lat": 31.8612,
        "Long": 74.9131
      },
      {
        "Area": "Chewara",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 25.1013,
        "Long": 85.9056
      },
      {
        "Area": "Cheyur",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 12.6952,
        "Long": 80.003
      },
      {
        "Area": "Cheyyar",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 12.8417,
        "Long": 79.941
      },
      {
        "Area": "Cheyyaru",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 12.7613,
        "Long": 79.6051
      },
      {
        "Area": "Cheyyur",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 13.0753,
        "Long": 80.1067
      },
      {
        "Area": "Chhachhrauli",
        "State": "Haryana",
        "CountryCode": "IN",
        "Lat": 30.4048,
        "Long": 77.4034
      },
      {
        "Area": "Chhajli",
        "State": "Punjab",
        "CountryCode": "IN",
        "Lat": 30.0428,
        "Long": 75.7978
      },
      {
        "Area": "Chhapiheda",
        "State": "Madhya Pradesh",
        "CountryCode": "IN",
        "Lat": 23.9351,
        "Long": 76.4818
      },
      {
        "Area": "Chharrah",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 23.2872,
        "Long": 88.3425
      },
      {
        "Area": "Chhata",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 27.8414,
        "Long": 77.8803
      },
      {
        "Area": "Chhata Pur",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 26.2209,
        "Long": 87.0367
      },
      {
        "Area": "Chhatapru",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 24.3114,
        "Long": 84.2117
      },
      {
        "Area": "Chhatapur",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 26.3272,
        "Long": 87.077
      },
      {
        "Area": "Chhatargarh",
        "State": "Rajasthan",
        "CountryCode": "IN",
        "Lat": 28.625,
        "Long": 73.5079
      },
      {
        "Area": "Chhatarpru",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 24.4635,
        "Long": 84.2947
      },
      {
        "Area": "Chhatarpur",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 24.5346,
        "Long": 84.373
      },
      {
        "Area": "Chhatarpur",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 26.3805,
        "Long": 80.2158
      },
      {
        "Area": "Chhatarpur",
        "State": "Madhya Pradesh",
        "CountryCode": "IN",
        "Lat": 25.5503,
        "Long": 80.0818
      },
      {
        "Area": "Chhatna",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 24.1794,
        "Long": 87.8621
      },
      {
        "Area": "Chhatorekole",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.1762,
        "Long": 87.6063
      },
      {
        "Area": "Chhatrapur",
        "State": "Odisha",
        "CountryCode": "IN",
        "Lat": 20.5861,
        "Long": 85.4897
      },
      {
        "Area": "Chhatri",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 21.8995,
        "Long": 87.5379
      },
      {
        "Area": "Chhaygaon Pantan",
        "State": "Assam",
        "CountryCode": "IN",
        "Lat": 26.5807,
        "Long": 91.4583
      },
      {
        "Area": "Chhaygaonpantan",
        "State": "Assam",
        "CountryCode": "IN",
        "Lat": 26.3127,
        "Long": 91.4061
      },
      {
        "Area": "Chhendipada",
        "State": "Odisha",
        "CountryCode": "IN",
        "Lat": 21.198,
        "Long": 85.1262
      },
      {
        "Area": "Chhindwar",
        "State": "Madhya Pradesh",
        "CountryCode": "IN",
        "Lat": 22.1357,
        "Long": 78.8883
      },
      {
        "Area": "Chhindwara",
        "State": "Madhya Pradesh",
        "CountryCode": "IN",
        "Lat": 22.2874,
        "Long": 79.1805
      },
      {
        "Area": "Chhindwra",
        "State": "Madhya Pradesh",
        "CountryCode": "IN",
        "Lat": 22.0365,
        "Long": 79.0092
      },
      {
        "Area": "Chhorda",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 24.2471,
        "Long": 87.8066
      },
      {
        "Area": "Chhota Udepur",
        "State": "Gujarat",
        "CountryCode": "IN",
        "Lat": 22.6922,
        "Long": 73.9032
      },
      {
        "Area": "Chhota-udepur",
        "State": "Gujarat",
        "CountryCode": "IN",
        "Lat": 22.6922,
        "Long": 73.9032
      },
      {
        "Area": "Chhotaudepur",
        "State": "Gujarat",
        "CountryCode": "IN",
        "Lat": 22.6922,
        "Long": 74.0649
      },
      {
        "Area": "Chhoti Sadari",
        "State": "Rajasthan",
        "CountryCode": "IN",
        "Lat": 24.7891,
        "Long": 74.6731
      },
      {
        "Area": "Chhoti Sadrai",
        "State": "Rajasthan",
        "CountryCode": "IN",
        "Lat": 24.8287,
        "Long": 74.7797
      },
      {
        "Area": "Chhoti Sadri",
        "State": "Rajasthan",
        "CountryCode": "IN",
        "Lat": 25.1322,
        "Long": 74.6731
      },
      {
        "Area": "Chhotisadari",
        "State": "Rajasthan",
        "CountryCode": "IN",
        "Lat": 24.7891,
        "Long": 74.6731
      },
      {
        "Area": "Chhotisadri",
        "State": "Rajasthan",
        "CountryCode": "IN",
        "Lat": 24.7891,
        "Long": 74.6731
      },
      {
        "Area": "Chhoto Jagulia",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.7343,
        "Long": 88.5795
      },
      {
        "Area": "Chhoto Srikrishnapur",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 23.5034,
        "Long": 87.9832
      },
      {
        "Area": "Chhprola",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 28.6472,
        "Long": 77.4282
      },
      {
        "Area": "Chhpyana",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 28.6472,
        "Long": 77.4282
      },
      {
        "Area": "Chhtarpur",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 24.1279,
        "Long": 84.3122
      },
      {
        "Area": "Chhuikhadan",
        "State": "Chattisgarh",
        "CountryCode": "IN",
        "Lat": 21.6457,
        "Long": 81.1474
      },
      {
        "Area": "Chhura",
        "State": "Chattisgarh",
        "CountryCode": "IN",
        "Lat": 21.0713,
        "Long": 82.3213
      },
      {
        "Area": "Chhuria",
        "State": "Chattisgarh",
        "CountryCode": "IN",
        "Lat": 21.165,
        "Long": 80.82
      },
      {
        "Area": "Chickballapur",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 13.776,
        "Long": 78.3601
      },
      {
        "Area": "Chidabamram",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 11.3632,
        "Long": 79.693
      },
      {
        "Area": "Chidambaram",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 11.7497,
        "Long": 79.7668
      },
      {
        "Area": "Chidambaram North",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 11.6327,
        "Long": 79.4467
      },
      {
        "Area": "Chiechama",
        "State": "Nagaland",
        "CountryCode": "IN",
        "Lat": 25.8234,
        "Long": 94.2273
      },
      {
        "Area": "Chigurumamidi",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 18.6139,
        "Long": 79.5655
      },
      {
        "Area": "Chik Ballapur",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 13.5861,
        "Long": 77.956
      },
      {
        "Area": "Chikanpara",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 23.3901,
        "Long": 88.4818
      },
      {
        "Area": "Chikhaldara",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 21.4004,
        "Long": 77.3186
      },
      {
        "Area": "Chikhali",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 20.1965,
        "Long": 76.8221
      },
      {
        "Area": "Chikhli",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 20.8589,
        "Long": 76.9581
      },
      {
        "Area": "Chikhli",
        "State": "Gujarat",
        "CountryCode": "IN",
        "Lat": 23.3924,
        "Long": 74.3241
      },
      {
        "Area": "Chikiti",
        "State": "Odisha",
        "CountryCode": "IN",
        "Lat": 20.8222,
        "Long": 84.8424
      },
      {
        "Area": "Chikkanayakanahlli",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 13.2706,
        "Long": 76.5577
      },
      {
        "Area": "Chikmagalur",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 13.83,
        "Long": 76.0393
      },
      {
        "Area": "Chiknayakanhalli",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 13.3394,
        "Long": 76.7671
      },
      {
        "Area": "Chikodi",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 16.5587,
        "Long": 76.3099
      },
      {
        "Area": "Chilakaluripet",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 16.6279,
        "Long": 80.2222
      },
      {
        "Area": "Chilamathur",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 14.4811,
        "Long": 77.9646
      },
      {
        "Area": "Chilika",
        "State": "Odisha",
        "CountryCode": "IN",
        "Lat": 20.606,
        "Long": 85.5114
      },
      {
        "Area": "Chilika Nuapada",
        "State": "Odisha",
        "CountryCode": "IN",
        "Lat": 19.5667,
        "Long": 85.25
      },
      {
        "Area": "Chilkipada",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 23.5234,
        "Long": 87.6598
      },
      {
        "Area": "Chillakur",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 14.1963,
        "Long": 80.053
      },
      {
        "Area": "Chilling",
        "State": "Assam",
        "CountryCode": "IN",
        "Lat": 26.4408,
        "Long": 91.8873
      },
      {
        "Area": "Chillro",
        "State": "Haryana",
        "CountryCode": "IN",
        "Lat": 28.0799,
        "Long": 76.0612
      },
      {
        "Area": "Chimta Kachari",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.6389,
        "Long": 88.746
      },
      {
        "Area": "Chimur",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 20.6967,
        "Long": 79.7305
      },
      {
        "Area": "Chimur Bo",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 20.479,
        "Long": 79.4699
      },
      {
        "Area": "China Raman Cherla",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 17.7912,
        "Long": 79.0865
      },
      {
        "Area": "Chincholi",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 17.8996,
        "Long": 77.4636
      },
      {
        "Area": "Chingelpet",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 12.7865,
        "Long": 80.2506
      },
      {
        "Area": "Chinglepet",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 12.9194,
        "Long": 80.2506
      },
      {
        "Area": "Chingleput",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 12.7873,
        "Long": 80.2216
      },
      {
        "Area": "Chingurdania",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 23.5034,
        "Long": 87.9832
      },
      {
        "Area": "Chinnagottigallu",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 13.7496,
        "Long": 79.1647
      },
      {
        "Area": "Chinnagottigallu Mandal",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 13.6695,
        "Long": 79.1574
      },
      {
        "Area": "Chinnamandem",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 14.4599,
        "Long": 78.7836
      },
      {
        "Area": "Chinnasalem Taluk",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 11.8004,
        "Long": 78.7111
      },
      {
        "Area": "Chinpur",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 24.3322,
        "Long": 83.961
      },
      {
        "Area": "Chinsurah",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 23.5138,
        "Long": 88.0606
      },
      {
        "Area": "Chinsurah - Magra",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 24.1096,
        "Long": 88.4116
      },
      {
        "Area": "Chintakani",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 18.4306,
        "Long": 80.9944
      },
      {
        "Area": "Chintalapudi",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 17.1635,
        "Long": 81.5644
      },
      {
        "Area": "Chintamani",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 13.5782,
        "Long": 78.2177
      },
      {
        "Area": "Chintamanij",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 13.1393,
        "Long": 78.2177
      },
      {
        "Area": "Chintapalle",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 17.8089,
        "Long": 82.435
      },
      {
        "Area": "Chintapalli",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 17.8089,
        "Long": 82.435
      },
      {
        "Area": "Chinthakommadinne",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 14.4666,
        "Long": 79.1828
      },
      {
        "Area": "Chintoor Mandal",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 17.1584,
        "Long": 81.9251
      },
      {
        "Area": "Chinturu",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 17.1885,
        "Long": 82.0118
      },
      {
        "Area": "Chiplun",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 19.8506,
        "Long": 76.3111
      },
      {
        "Area": "Chipurupalle",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 18.7907,
        "Long": 83.63
      },
      {
        "Area": "Chiraia",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 26.8148,
        "Long": 84.9247
      },
      {
        "Area": "Chiral",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 15.9135,
        "Long": 80.2217
      },
      {
        "Area": "Chirala",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 16.0438,
        "Long": 80.4315
      },
      {
        "Area": "Chirawa",
        "State": "Rajasthan",
        "CountryCode": "IN",
        "Lat": 28.4926,
        "Long": 75.8833
      },
      {
        "Area": "Chirayinkeezh",
        "State": "Kerala",
        "CountryCode": "IN",
        "Lat": 8.6344,
        "Long": 76.9382
      },
      {
        "Area": "Chirayinkeezhu",
        "State": "Kerala",
        "CountryCode": "IN",
        "Lat": 8.8025,
        "Long": 77.0803
      },
      {
        "Area": "Chirayinkil",
        "State": "Kerala",
        "CountryCode": "IN",
        "Lat": 8.7691,
        "Long": 76.9156
      },
      {
        "Area": "Chirgaon",
        "State": "Himachal Pradesh",
        "CountryCode": "IN",
        "Lat": 31.3968,
        "Long": 77.9417
      },
      {
        "Area": "Chiria",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 22.3109,
        "Long": 85.3992
      },
      {
        "Area": "Chirimiri",
        "State": "Chattisgarh",
        "CountryCode": "IN",
        "Lat": 23.1316,
        "Long": 82.8212
      },
      {
        "Area": "Chirulia",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 21.9958,
        "Long": 87.8022
      },
      {
        "Area": "Chiryal",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 17.3908,
        "Long": 78.9107
      },
      {
        "Area": "Chita Dungra",
        "State": "Haryana",
        "CountryCode": "IN",
        "Lat": 28.1673,
        "Long": 76.4131
      },
      {
        "Area": "Chitapur",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 17.1993,
        "Long": 77.0062
      },
      {
        "Area": "Chitarpur",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 23.5756,
        "Long": 85.6275
      },
      {
        "Area": "Chitradurga",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 14.7541,
        "Long": 76.5164
      },
      {
        "Area": "Chitrakonda",
        "State": "Odisha",
        "CountryCode": "IN",
        "Lat": 18.6956,
        "Long": 82.5323
      },
      {
        "Area": "Chitrangi",
        "State": "Madhya Pradesh",
        "CountryCode": "IN",
        "Lat": 24.5023,
        "Long": 82.3364
      },
      {
        "Area": "Chitrasenpur,Howrah",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.9007,
        "Long": 88.1241
      },
      {
        "Area": "Chitrauli",
        "State": "Haryana",
        "CountryCode": "IN",
        "Lat": 28.4013,
        "Long": 76.373
      },
      {
        "Area": "Chittamur",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 14.0748,
        "Long": 80.1158
      },
      {
        "Area": "Chittamuru",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 13.9121,
        "Long": 80.053
      },
      {
        "Area": "Chittapur",
        "State": "Karnataka",
        "CountryCode": "IN",
        "Lat": 17.4527,
        "Long": 77.2341
      },
      {
        "Area": "Chittoor",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 13.7692,
        "Long": 79.398
      },
      {
        "Area": "Chittorgah",
        "State": "Rajasthan",
        "CountryCode": "IN",
        "Lat": 25.0919,
        "Long": 74.8961
      },
      {
        "Area": "Chittorgarh",
        "State": "Rajasthan",
        "CountryCode": "IN",
        "Lat": 25.1959,
        "Long": 75.724
      },
      {
        "Area": "Chitttorgarh",
        "State": "Rajasthan",
        "CountryCode": "IN",
        "Lat": 24.8287,
        "Long": 74.7797
      },
      {
        "Area": "Chittur",
        "State": "Kerala",
        "CountryCode": "IN",
        "Lat": 10.9661,
        "Long": 76.8363
      },
      {
        "Area": "Chitvel",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 14.2341,
        "Long": 79.356
      },
      {
        "Area": "Chityal",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 18.3707,
        "Long": 79.7992
      },
      {
        "Area": "Chizami",
        "State": "Nagaland",
        "CountryCode": "IN",
        "Lat": 25.8234,
        "Long": 94.4743
      },
      {
        "Area": "Chjandpur",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.4653,
        "Long": 88.7803
      },
      {
        "Area": "Chmaba",
        "State": "Himachal Pradesh",
        "CountryCode": "IN",
        "Lat": 32.1939,
        "Long": 76.3833
      },
      {
        "Area": "Chnadwad",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 20.2388,
        "Long": 74.3815
      },
      {
        "Area": "Chodavaram",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 18.3767,
        "Long": 83.0803
      },
      {
        "Area": "Chodayapalem",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 15.7114,
        "Long": 80.4916
      },
      {
        "Area": "Chogawan",
        "State": "Punjab",
        "CountryCode": "IN",
        "Lat": 31.7653,
        "Long": 75.0588
      },
      {
        "Area": "Chohtan",
        "State": "Rajasthan",
        "CountryCode": "IN",
        "Lat": 25.7356,
        "Long": 71.4733
      },
      {
        "Area": "Chola Sahib",
        "State": "Punjab",
        "CountryCode": "IN",
        "Lat": 31.7046,
        "Long": 74.9007
      },
      {
        "Area": "Chopal",
        "State": "Himachal Pradesh",
        "CountryCode": "IN",
        "Lat": 31.197,
        "Long": 77.6957
      },
      {
        "Area": "Chopda",
        "State": "Maharashtra",
        "CountryCode": "IN",
        "Lat": 21.2477,
        "Long": 75.5188
      },
      {
        "Area": "Chopl",
        "State": "Himachal Pradesh",
        "CountryCode": "IN",
        "Lat": 31.0108,
        "Long": 77.4919
      },
      {
        "Area": "Choppadandi",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 18.6383,
        "Long": 79.2409
      },
      {
        "Area": "Chopra",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 26.3676,
        "Long": 88.3126
      },
      {
        "Area": "Chorashi",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.614,
        "Long": 88.5475
      },
      {
        "Area": "Chorasi",
        "State": "Gujarat",
        "CountryCode": "IN",
        "Lat": 23.1064,
        "Long": 73.2309
      },
      {
        "Area": "Choraut",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 26.5795,
        "Long": 85.7878
      },
      {
        "Area": "Chorayasi",
        "State": "Gujarat",
        "CountryCode": "IN",
        "Lat": 21.2542,
        "Long": 72.8628
      },
      {
        "Area": "Chorolmoni",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 25.3249,
        "Long": 87.9524
      },
      {
        "Area": "Chorpalia",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 21.9958,
        "Long": 87.8022
      },
      {
        "Area": "Choryasi",
        "State": "Gujarat",
        "CountryCode": "IN",
        "Lat": 23.1064,
        "Long": 73.2309
      },
      {
        "Area": "Chotila",
        "State": "Gujarat",
        "CountryCode": "IN",
        "Lat": 22.7982,
        "Long": 71.5402
      },
      {
        "Area": "Choto Sahebkhali",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 23.4323,
        "Long": 88.373
      },
      {
        "Area": "Choto Sehara",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.3687,
        "Long": 88.562
      },
      {
        "Area": "Chotosarma",
        "State": "Tripura",
        "CountryCode": "IN",
        "Lat": 24.1959,
        "Long": 91.8344
      },
      {
        "Area": "Chotta-chatla",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.8223,
        "Long": 87.5059
      },
      {
        "Area": "Chouai",
        "State": "Madhya Pradesh",
        "CountryCode": "IN",
        "Lat": 22.0533,
        "Long": 79.3397
      },
      {
        "Area": "Choudwar",
        "State": "Odisha",
        "CountryCode": "IN",
        "Lat": 20.5697,
        "Long": 85.9151
      },
      {
        "Area": "Choupal",
        "State": "Himachal Pradesh",
        "CountryCode": "IN",
        "Lat": 30.9753,
        "Long": 77.4764
      },
      {
        "Area": "Chouparan",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 24.2014,
        "Long": 85.0095
      },
      {
        "Area": "Chourai",
        "State": "Madhya Pradesh",
        "CountryCode": "IN",
        "Lat": 22.205,
        "Long": 79.3517
      },
      {
        "Area": "Chourak",
        "State": "Madhya Pradesh",
        "CountryCode": "IN",
        "Lat": 22.1598,
        "Long": 79.2227
      },
      {
        "Area": "Chousa",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 25.634,
        "Long": 87.0061
      },
      {
        "Area": "Choutuppal",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 17.3526,
        "Long": 78.9535
      },
      {
        "Area": "Chowberia",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 23.1467,
        "Long": 88.803
      },
      {
        "Area": "Chowdepalle",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 13.8318,
        "Long": 78.6933
      },
      {
        "Area": "Chowhata",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.4784,
        "Long": 88.5822
      },
      {
        "Area": "Chowk Bazar",
        "State": "Assam",
        "CountryCode": "IN",
        "Lat": 26.3796,
        "Long": 91.2951
      },
      {
        "Area": "Chowka",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 23.0401,
        "Long": 85.9083
      },
      {
        "Area": "Chowkbazar",
        "State": "Assam",
        "CountryCode": "IN",
        "Lat": 26.3796,
        "Long": 91.2951
      },
      {
        "Area": "Chowkham",
        "State": "Arunachal Pradesh",
        "CountryCode": "IN",
        "Lat": 27.7955,
        "Long": 96.1825
      },
      {
        "Area": "Chowki Mirdadpur",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 24.5939,
        "Long": 87.7973
      },
      {
        "Area": "Chozoba",
        "State": "Nagaland",
        "CountryCode": "IN",
        "Lat": 25.8234,
        "Long": 94.2273
      },
      {
        "Area": "Chozuba",
        "State": "Nagaland",
        "CountryCode": "IN",
        "Lat": 25.8234,
        "Long": 94.2273
      },
      {
        "Area": "Chuanr",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 25.2852,
        "Long": 83.0262
      },
      {
        "Area": "Chuchulang",
        "State": "Nagaland",
        "CountryCode": "IN",
        "Lat": 26.4291,
        "Long": 94.6213
      },
      {
        "Area": "Chuchuyimlang",
        "State": "Nagaland",
        "CountryCode": "IN",
        "Lat": 26.4291,
        "Long": 94.6213
      },
      {
        "Area": "Chumukedima",
        "State": "Nagaland",
        "CountryCode": "IN",
        "Lat": 25.9288,
        "Long": 94.3486
      },
      {
        "Area": "Chunar",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 25.2852,
        "Long": 83.0131
      },
      {
        "Area": "Chungthang",
        "State": "Sikkim",
        "CountryCode": "IN",
        "Lat": 27.7304,
        "Long": 88.7443
      },
      {
        "Area": "Chunpara",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 24.2471,
        "Long": 87.8066
      },
      {
        "Area": "Churachandpur",
        "State": "Manipur",
        "CountryCode": "IN",
        "Lat": 24.6994,
        "Long": 93.8593
      },
      {
        "Area": "Churah",
        "State": "Himachal Pradesh",
        "CountryCode": "IN",
        "Lat": 32.8516,
        "Long": 76.2763
      },
      {
        "Area": "Churaibari",
        "State": "Tripura",
        "CountryCode": "IN",
        "Lat": 24.1597,
        "Long": 92.0329
      },
      {
        "Area": "Churchu",
        "State": "Jharkhand",
        "CountryCode": "IN",
        "Lat": 24.1341,
        "Long": 85.6754
      },
      {
        "Area": "Churhat",
        "State": "Madhya Pradesh",
        "CountryCode": "IN",
        "Lat": 24.5015,
        "Long": 81.9509
      },
      {
        "Area": "Churu",
        "State": "Rajasthan",
        "CountryCode": "IN",
        "Lat": 28.479,
        "Long": 75.1932
      },
      {
        "Area": "Chuth Ka Barwara",
        "State": "Rajasthan",
        "CountryCode": "IN",
        "Lat": 26.8471,
        "Long": 75.6693
      },
      {
        "Area": "Circus Avenue",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.8436,
        "Long": 88.2293
      },
      {
        "Area": "Cittorgarh",
        "State": "Rajasthan",
        "CountryCode": "IN",
        "Lat": 25.0703,
        "Long": 74.0702
      },
      {
        "Area": "City Ahmedabad",
        "State": "Gujarat",
        "CountryCode": "IN",
        "Lat": 23.0333,
        "Long": 73.0122
      },
      {
        "Area": "City Taluka",
        "State": "Gujarat",
        "CountryCode": "IN",
        "Lat": 23.0333,
        "Long": 72.6181
      },
      {
        "Area": "Civil Line",
        "State": "Haryana",
        "CountryCode": "IN",
        "Lat": 28.0799,
        "Long": 76.07
      },
      {
        "Area": "Cleaver House",
        "State": "Assam",
        "CountryCode": "IN",
        "Lat": 24.7441,
        "Long": 92.7721
      },
      {
        "Area": "Cod",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 26.2429,
        "Long": 79.7876
      },
      {
        "Area": "Coimabtore North",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 11.1162,
        "Long": 76.7549
      },
      {
        "Area": "Coimbatore",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 11.3697,
        "Long": 77.4524
      },
      {
        "Area": "Coimbatore North",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 11.3534,
        "Long": 78.145
      },
      {
        "Area": "Coimbatore South",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 11.1623,
        "Long": 78.145
      },
      {
        "Area": "Colgong",
        "State": "Bihar",
        "CountryCode": "IN",
        "Lat": 25.3523,
        "Long": 87.3064
      },
      {
        "Area": "Colliery",
        "State": "Odisha",
        "CountryCode": "IN",
        "Lat": 20.8573,
        "Long": 84.9125
      },
      {
        "Area": "Colonelganj",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 27.2781,
        "Long": 82.321
      },
      {
        "Area": "Colony Simulia",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 23.5228,
        "Long": 88.1967
      },
      {
        "Area": "Cononel Ganj",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 27.0916,
        "Long": 81.7989
      },
      {
        "Area": "Contai",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 22.3836,
        "Long": 88.831
      },
      {
        "Area": "Cooch Behar",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 26.4231,
        "Long": 89.5546
      },
      {
        "Area": "Cooch Behar - I",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 26.3144,
        "Long": 89.3013
      },
      {
        "Area": "Cooch Behar - II",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 26.3599,
        "Long": 89.7645
      },
      {
        "Area": "Coonoor",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 11.5338,
        "Long": 77.2327
      },
      {
        "Area": "Cotton Mill",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 26.5442,
        "Long": 80.1097
      },
      {
        "Area": "Csa",
        "State": "Uttar Pradesh",
        "CountryCode": "IN",
        "Lat": 26.5167,
        "Long": 80.3155
      },
      {
        "Area": "Cuddalore",
        "State": "Pondicherry",
        "CountryCode": "IN",
        "Lat": 11.7681,
        "Long": 79.3947
      },
      {
        "Area": "Cuddapah",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 14.6466,
        "Long": 78.9831
      },
      {
        "Area": "Cumbum",
        "State": "Andhra Pradesh",
        "CountryCode": "IN",
        "Lat": 15.7917,
        "Long": 79.3356
      },
      {
        "Area": "Curchorem",
        "State": "Goa",
        "CountryCode": "IN",
        "Lat": 15.2651,
        "Long": 74.096
      },
      {
        "Area": "Cuttack",
        "State": "Odisha",
        "CountryCode": "IN",
        "Lat": 20.5096,
        "Long": 85.9249
      },
      {
        "Area": "Cuttack  Sadar",
        "State": "Odisha",
        "CountryCode": "IN",
        "Lat": 20.4297,
        "Long": 85.9938
      },
      {
        "Area": "Cuttack Sadar",
        "State": "Odisha",
        "CountryCode": "IN",
        "Lat": 20.5703,
        "Long": 86.15
      },
      {
        "Area": "Cxc",
        "State": "Telangana",
        "CountryCode": "IN",
        "Lat": 17.3671,
        "Long": 79.0848
      },
      {
        "Area": "coochbehar",
        "State": "West Bengal",
        "CountryCode": "IN",
        "Lat": 25.315,
        "Long": 88.8041
      },
      {
        "Area": "cuddalore",
        "State": "Tamil Nadu",
        "CountryCode": "IN",
        "Lat": 12.2091,
        "Long": 79.8107
      },
      {
        "Area": "Cà Mau",
        "Lat": "9.1774",
        "Long": "105.15",
        "CountryCode": "VN"
      },
      {
        "Area": "Cabanatuan",
        "Lat": "15.5021",
        "Long": "120.9617",
        "CountryCode": "PH"
      },
      {
        "Area": "Cabimas",
        "Lat": "10.43",
        "Long": "-71.45",
        "CountryCode": "VE"
      },
      {
        "Area": "Cabinda",
        "Lat": "-5.5596",
        "Long": "12.19",
        "CountryCode": "AO"
      },
      {
        "Area": "Cabo de Santo Agostinho",
        "Lat": "-8.29",
        "Long": "-35.03",
        "CountryCode": "BR"
      },
      {
        "Area": "Cabo Frio",
        "Lat": "-22.89",
        "Long": "-42.04",
        "CountryCode": "BR"
      },
      {
        "Area": "Caborca",
        "Lat": "30.7161",
        "Long": "-112.1642",
        "CountryCode": "MX"
      },
      {
        "Area": "Caçador",
        "Lat": "-26.77",
        "Long": "-51.02",
        "CountryCode": "BR"
      },
      {
        "Area": "Čačak",
        "Lat": "43.8897",
        "Long": "20.3301",
        "CountryCode": "RS"
      },
      {
        "Area": "Cáceres",
        "Lat": "-16.05",
        "Long": "-57.51",
        "CountryCode": "BR"
      },
      {
        "Area": "Cachoeira do Sul",
        "Lat": "-30.03",
        "Long": "-52.91",
        "CountryCode": "BR"
      },
      {
        "Area": "Cachoeiro de Itapemirim",
        "Lat": "-20.85",
        "Long": "-41.13",
        "CountryCode": "BR"
      },
      {
        "Area": "Cadiz",
        "Lat": "10.9587",
        "Long": "123.3086",
        "CountryCode": "PH"
      },
      {
        "Area": "Cádiz",
        "Lat": "36.535",
        "Long": "-6.225",
        "CountryCode": "ES"
      },
      {
        "Area": "Caen",
        "Lat": "49.1838",
        "Long": "-0.35",
        "CountryCode": "FR"
      },
      {
        "Area": "Cagayan de Oro",
        "Lat": "8.4508",
        "Long": "124.6853",
        "CountryCode": "PH"
      },
      {
        "Area": "Cagliari",
        "Lat": "39.2224",
        "Long": "9.104",
        "CountryCode": "IT"
      },
      {
        "Area": "Cahul",
        "Lat": "45.9079",
        "Long": "28.1944",
        "CountryCode": "MD"
      },
      {
        "Area": "Caicó",
        "Lat": "-6.4596",
        "Long": "-37.1",
        "CountryCode": "BR"
      },
      {
        "Area": "Cairns",
        "Lat": "-16.8878",
        "Long": "145.7633",
        "CountryCode": "AU"
      },
      {
        "Area": "Cairo",
        "Lat": "30.05",
        "Long": "31.25",
        "CountryCode": "EG"
      },
      {
        "Area": "Cajamarca",
        "Lat": "-7.15",
        "Long": "-78.53",
        "CountryCode": "PE"
      },
      {
        "Area": "Calabar",
        "Lat": "4.9604",
        "Long": "8.33",
        "CountryCode": "NG"
      },
      {
        "Area": "Calabozo",
        "Lat": "8.9304",
        "Long": "-67.44",
        "CountryCode": "VE"
      },
      {
        "Area": "Calais",
        "Lat": "50.9504",
        "Long": "1.8333",
        "CountryCode": "FR"
      },
      {
        "Area": "Calama",
        "Lat": "-22.45",
        "Long": "-68.92",
        "CountryCode": "CL"
      },
      {
        "Area": "Călărași",
        "Lat": "44.2063",
        "Long": "27.3259",
        "CountryCode": "RO"
      },
      {
        "Area": "Calbayog",
        "Lat": "12.0672",
        "Long": "124.6042",
        "CountryCode": "PH"
      },
      {
        "Area": "Caldwell",
        "Lat": "43.6458",
        "Long": "-116.6591",
        "CountryCode": "US"
      },
      {
        "Area": "Calgary",
        "Lat": "51.083",
        "Long": "-114.08",
        "CountryCode": "CA"
      },
      {
        "Area": "Cali",
        "Lat": "3.4",
        "Long": "-76.5",
        "CountryCode": "CO"
      },
      {
        "Area": "Callao",
        "Lat": "-12.07",
        "Long": "-77.135",
        "CountryCode": "PE"
      },
      {
        "Area": "Cẩm Phả",
        "Lat": "21.0404",
        "Long": "107.32",
        "CountryCode": "VN"
      },
      {
        "Area": "Cam Ranh",
        "Lat": "11.902",
        "Long": "109.2207",
        "CountryCode": "VN"
      },
      {
        "Area": "Camagüey",
        "Lat": "21.3808",
        "Long": "-77.9169",
        "CountryCode": "CU"
      },
      {
        "Area": "Camaquã",
        "Lat": "-30.8396",
        "Long": "-51.81",
        "CountryCode": "BR"
      },
      {
        "Area": "Camarillo",
        "Lat": "34.223",
        "Long": "-119.0323",
        "CountryCode": "US"
      },
      {
        "Area": "Cambridge",
        "Lat": "52.2004",
        "Long": "0.1166",
        "CountryCode": "GB"
      },
      {
        "Area": "Cambridge",
        "Lat": "42.3758",
        "Long": "-71.1184",
        "CountryCode": "US"
      },
      {
        "Area": "Camden",
        "Lat": "39.9361",
        "Long": "-75.1073",
        "CountryCode": "US"
      },
      {
        "Area": "Campana",
        "Lat": "-34.16",
        "Long": "-58.96",
        "CountryCode": "AR"
      },
      {
        "Area": "Campeche",
        "Lat": "19.83",
        "Long": "-90.5",
        "CountryCode": "MX"
      },
      {
        "Area": "Campina Grande",
        "Lat": "-7.23",
        "Long": "-35.88",
        "CountryCode": "BR"
      },
      {
        "Area": "Campinas",
        "Lat": "-22.9",
        "Long": "-47.1",
        "CountryCode": "BR"
      },
      {
        "Area": "Campo Grande",
        "Lat": "-20.45",
        "Long": "-54.6166",
        "CountryCode": "BR"
      },
      {
        "Area": "Campo Murao",
        "Lat": "-24.0496",
        "Long": "-52.42",
        "CountryCode": "BR"
      },
      {
        "Area": "Campobasso",
        "Lat": "41.563",
        "Long": "14.656",
        "CountryCode": "IT"
      },
      {
        "Area": "Campos",
        "Lat": "-21.75",
        "Long": "-41.32",
        "CountryCode": "BR"
      },
      {
        "Area": "Can Tho",
        "Lat": "10.05",
        "Long": "105.77",
        "CountryCode": "VN"
      },
      {
        "Area": "Çanakkale",
        "Lat": "40.1459",
        "Long": "26.4064",
        "CountryCode": "TR"
      },
      {
        "Area": "Canberra",
        "Lat": "-35.283",
        "Long": "149.129",
        "CountryCode": "AU"
      },
      {
        "Area": "Cancún",
        "Lat": "21.17",
        "Long": "-86.83",
        "CountryCode": "MX"
      },
      {
        "Area": "Canela",
        "Lat": "-29.36",
        "Long": "-50.81",
        "CountryCode": "BR"
      },
      {
        "Area": "Cangzhou",
        "Lat": "38.3204",
        "Long": "116.87",
        "CountryCode": "CN"
      },
      {
        "Area": "Çankırı",
        "Lat": "40.607",
        "Long": "33.621",
        "CountryCode": "TR"
      },
      {
        "Area": "Canoas",
        "Lat": "-29.92",
        "Long": "-51.18",
        "CountryCode": "BR"
      },
      {
        "Area": "Canton",
        "Lat": "40.8076",
        "Long": "-81.3677",
        "CountryCode": "US"
      },
      {
        "Area": "Cao Lãnh",
        "Lat": "10.467",
        "Long": "105.636",
        "CountryCode": "VN"
      },
      {
        "Area": "Cap-Haïtien",
        "Lat": "19.7592",
        "Long": "-72.2125",
        "CountryCode": "HT"
      },
      {
        "Area": "Cape Coast",
        "Lat": "5.1104",
        "Long": "-1.25",
        "CountryCode": "GH"
      },
      {
        "Area": "Cape Coral",
        "Lat": "26.6444",
        "Long": "-81.9956",
        "CountryCode": "US"
      },
      {
        "Area": "Cape Girardeau",
        "Lat": "37.3108",
        "Long": "-89.5596",
        "CountryCode": "US"
      },
      {
        "Area": "Cape Town",
        "Lat": "-33.92",
        "Long": "18.435",
        "CountryCode": "ZA"
      },
      {
        "Area": "Capenda-Camulemba",
        "Lat": "-9.4196",
        "Long": "18.43",
        "CountryCode": "AO"
      },
      {
        "Area": "Caracas",
        "Lat": "10.501",
        "Long": "-66.917",
        "CountryCode": "VE"
      },
      {
        "Area": "Caratinga",
        "Lat": "-19.79",
        "Long": "-42.14",
        "CountryCode": "BR"
      },
      {
        "Area": "Carazinho",
        "Lat": "-28.29",
        "Long": "-52.8",
        "CountryCode": "BR"
      },
      {
        "Area": "Carbondale",
        "Lat": "37.722",
        "Long": "-89.2238",
        "CountryCode": "US"
      },
      {
        "Area": "Cardiff",
        "Lat": "51.5",
        "Long": "-3.225",
        "CountryCode": "GB"
      },
      {
        "Area": "Carlisle",
        "Lat": "54.88",
        "Long": "-2.93",
        "CountryCode": "GB"
      },
      {
        "Area": "Carlsbad",
        "Lat": "33.1246",
        "Long": "-117.2837",
        "CountryCode": "US"
      },
      {
        "Area": "Carmel",
        "Lat": "39.9658",
        "Long": "-86.1461",
        "CountryCode": "US"
      },
      {
        "Area": "Carora",
        "Lat": "10.19",
        "Long": "-70.08",
        "CountryCode": "VE"
      },
      {
        "Area": "Carpina",
        "Lat": "-7.84",
        "Long": "-35.26",
        "CountryCode": "BR"
      },
      {
        "Area": "Carrollton",
        "Lat": "32.9886",
        "Long": "-96.9",
        "CountryCode": "US"
      },
      {
        "Area": "Carson",
        "Lat": "33.8374",
        "Long": "-118.2559",
        "CountryCode": "US"
      },
      {
        "Area": "Carson City",
        "Lat": "39.1512",
        "Long": "-119.7474",
        "CountryCode": "US"
      },
      {
        "Area": "Cartagena",
        "Lat": "10.3997",
        "Long": "-75.5144",
        "CountryCode": "CO"
      },
      {
        "Area": "Cartagena",
        "Lat": "37.6004",
        "Long": "-0.98",
        "CountryCode": "ES"
      },
      {
        "Area": "Cartago",
        "Lat": "9.87",
        "Long": "-83.93",
        "CountryCode": "CR"
      },
      {
        "Area": "Cartago",
        "Lat": "4.75",
        "Long": "-75.91",
        "CountryCode": "CO"
      },
      {
        "Area": "Cartersville",
        "Lat": "34.1632",
        "Long": "-84.8007",
        "CountryCode": "US"
      },
      {
        "Area": "Caruaru",
        "Lat": "-8.28",
        "Long": "-35.98",
        "CountryCode": "BR"
      },
      {
        "Area": "Carúpano",
        "Lat": "10.67",
        "Long": "-63.23",
        "CountryCode": "VE"
      },
      {
        "Area": "Cary",
        "Lat": "35.7814",
        "Long": "-78.8167",
        "CountryCode": "US"
      },
      {
        "Area": "Casa Grande",
        "Lat": "32.907",
        "Long": "-111.7624",
        "CountryCode": "US"
      },
      {
        "Area": "Casablanca",
        "Lat": "33.6",
        "Long": "-7.6164",
        "CountryCode": "MA"
      },
      {
        "Area": "Cascavel",
        "Lat": "-24.9596",
        "Long": "-53.46",
        "CountryCode": "BR"
      },
      {
        "Area": "Caserta",
        "Lat": "41.06",
        "Long": "14.3374",
        "CountryCode": "IT"
      },
      {
        "Area": "Casper",
        "Lat": "42.8421",
        "Long": "-106.3208",
        "CountryCode": "US"
      },
      {
        "Area": "Castanhal",
        "Lat": "-1.2896",
        "Long": "-47.93",
        "CountryCode": "BR"
      },
      {
        "Area": "Castello",
        "Lat": "39.9704",
        "Long": "-0.05",
        "CountryCode": "ES"
      },
      {
        "Area": "Castle Rock",
        "Lat": "39.3761",
        "Long": "-104.8534",
        "CountryCode": "US"
      },
      {
        "Area": "Catalão",
        "Lat": "-18.18",
        "Long": "-47.95",
        "CountryCode": "BR"
      },
      {
        "Area": "Catamarca",
        "Lat": "-28.47",
        "Long": "-65.78",
        "CountryCode": "AR"
      },
      {
        "Area": "Catanduva",
        "Lat": "-21.14",
        "Long": "-48.98",
        "CountryCode": "BR"
      },
      {
        "Area": "Catania",
        "Lat": "37.5",
        "Long": "15.08",
        "CountryCode": "IT"
      },
      {
        "Area": "Catanzaro",
        "Lat": "38.9004",
        "Long": "16.6",
        "CountryCode": "IT"
      },
      {
        "Area": "Cathedral City",
        "Lat": "33.8363",
        "Long": "-116.4642",
        "CountryCode": "US"
      },
      {
        "Area": "Caxias",
        "Lat": "-4.833",
        "Long": "-43.35",
        "CountryCode": "BR"
      },
      {
        "Area": "Caxias do Sul",
        "Lat": "-29.18",
        "Long": "-51.17",
        "CountryCode": "BR"
      },
      {
        "Area": "Cayenne",
        "Lat": "4.933",
        "Long": "-52.33",
        "CountryCode": "GF"
      },
      {
        "Area": "Cebu",
        "Lat": "10.32",
        "Long": "123.9001",
        "CountryCode": "PH"
      },
      {
        "Area": "Cedar Park",
        "Lat": "30.5105",
        "Long": "-97.8198",
        "CountryCode": "US"
      },
      {
        "Area": "Cedar Rapids",
        "Lat": "41.9667",
        "Long": "-91.6782",
        "CountryCode": "US"
      },
      {
        "Area": "Celaya",
        "Lat": "20.53",
        "Long": "-100.8",
        "CountryCode": "MX"
      },
      {
        "Area": "Centennial",
        "Lat": "39.5926",
        "Long": "-104.8674",
        "CountryCode": "US"
      },
      {
        "Area": "Cerritos",
        "Lat": "33.8677",
        "Long": "-118.0686",
        "CountryCode": "US"
      },
      {
        "Area": "Cerro de Pasco",
        "Lat": "-10.69",
        "Long": "-76.27",
        "CountryCode": "PE"
      },
      {
        "Area": "České Budějovice",
        "Lat": "48.98",
        "Long": "14.46",
        "CountryCode": "CZ"
      },
      {
        "Area": "Ceuta",
        "Lat": "35.889",
        "Long": "-5.307",
        "CountryCode": "ES"
      },
      {
        "Area": "Chabahar",
        "Lat": "25.3004",
        "Long": "60.6299",
        "CountryCode": "IR"
      },
      {
        "Area": "Chaiyaphum",
        "Lat": "15.804",
        "Long": "102.0386",
        "CountryCode": "TH"
      },
      {
        "Area": "Chalkida",
        "Lat": "38.464",
        "Long": "23.6124",
        "CountryCode": "GR"
      },
      {
        "Area": "Chaman",
        "Lat": "30.925",
        "Long": "66.4463",
        "CountryCode": "PK"
      },
      {
        "Area": "Chambersburg",
        "Lat": "39.9315",
        "Long": "-77.6556",
        "CountryCode": "US"
      },
      {
        "Area": "Chamdo",
        "Lat": "31.1667",
        "Long": "97.2333",
        "CountryCode": "CN"
      },
      {
        "Area": "Champaign",
        "Lat": "40.1144",
        "Long": "-88.2735",
        "CountryCode": "US"
      },
      {
        "Area": "Chandler",
        "Lat": "33.2827",
        "Long": "-111.8516",
        "CountryCode": "US"
      },
      {
        "Area": "Changchun",
        "Lat": "43.865",
        "Long": "125.34",
        "CountryCode": "CN"
      },
      {
        "Area": "Changde",
        "Lat": "29.03",
        "Long": "111.68",
        "CountryCode": "CN"
      },
      {
        "Area": "Changhua",
        "Lat": "24.0734",
        "Long": "120.5134",
        "CountryCode": "TW"
      },
      {
        "Area": "Changling",
        "Lat": "44.27",
        "Long": "123.99",
        "CountryCode": "CN"
      },
      {
        "Area": "Changping",
        "Lat": "40.2248",
        "Long": "116.1944",
        "CountryCode": "CN"
      },
      {
        "Area": "Changsha",
        "Lat": "28.2",
        "Long": "112.97",
        "CountryCode": "CN"
      },
      {
        "Area": "Changting",
        "Lat": "25.867",
        "Long": "116.3167",
        "CountryCode": "CN"
      },
      {
        "Area": "Changwon",
        "Lat": "35.2191",
        "Long": "128.5836",
        "CountryCode": "kr"
      },
      {
        "Area": "Changzhi",
        "Lat": "36.1839",
        "Long": "113.1053",
        "CountryCode": "CN"
      },
      {
        "Area": "Changzhou",
        "Lat": "31.78",
        "Long": "119.97",
        "CountryCode": "CN"
      },
      {
        "Area": "Chanthaburi",
        "Lat": "12.6133",
        "Long": "102.0979",
        "CountryCode": "TH"
      },
      {
        "Area": "Chaoyang",
        "Lat": "41.5504",
        "Long": "120.42",
        "CountryCode": "CN"
      },
      {
        "Area": "Chaozhou",
        "Lat": "23.68",
        "Long": "116.63",
        "CountryCode": "CN"
      },
      {
        "Area": "Chapayevsk",
        "Lat": "52.9743",
        "Long": "49.7243",
        "CountryCode": "RU"
      },
      {
        "Area": "Chapel Hill",
        "Lat": "35.9269",
        "Long": "-79.039",
        "CountryCode": "US"
      },
      {
        "Area": "Charikar",
        "Lat": "35.0183",
        "Long": "69.1679",
        "CountryCode": "AF"
      },
      {
        "Area": "Charleroi",
        "Lat": "50.4204",
        "Long": "4.45",
        "CountryCode": "BE"
      },
      {
        "Area": "Charleston",
        "Lat": "32.8137",
        "Long": "-79.9643",
        "CountryCode": "US"
      },
      {
        "Area": "Charleston",
        "Lat": "38.3484",
        "Long": "-81.6323",
        "CountryCode": "US"
      },
      {
        "Area": "Charlotte",
        "Lat": "35.2079",
        "Long": "-80.8303",
        "CountryCode": "US"
      },
      {
        "Area": "Charlottesville",
        "Lat": "38.0375",
        "Long": "-78.4855",
        "CountryCode": "US"
      },
      {
        "Area": "Chattanooga",
        "Lat": "35.0657",
        "Long": "-85.2488",
        "CountryCode": "US"
      },
      {
        "Area": "Châu Đốc",
        "Lat": "10.7004",
        "Long": "105.1167",
        "CountryCode": "VN"
      },
      {
        "Area": "Chauk",
        "Lat": "20.9085",
        "Long": "94.823",
        "CountryCode": "MM"
      },
      {
        "Area": "Cheboksary",
        "Lat": "56.13",
        "Long": "47.25",
        "CountryCode": "RU"
      },
      {
        "Area": "Chelyabinsk",
        "Lat": "55.155",
        "Long": "61.4387",
        "CountryCode": "RU"
      },
      {
        "Area": "Chemnitz",
        "Lat": "50.83",
        "Long": "12.92",
        "CountryCode": "DE"
      },
      {
        "Area": "Chengde",
        "Lat": "40.9604",
        "Long": "117.93",
        "CountryCode": "CN"
      },
      {
        "Area": "Chengdu",
        "Lat": "30.67",
        "Long": "104.07",
        "CountryCode": "CN"
      },
      {
        "Area": "Chenzhou",
        "Lat": "25.8004",
        "Long": "113.0301",
        "CountryCode": "CN"
      },
      {
        "Area": "Cheongju",
        "Lat": "36.6439",
        "Long": "127.5012",
        "CountryCode": "kr"
      },
      {
        "Area": "Cherbourg",
        "Lat": "49.6504",
        "Long": "-1.65",
        "CountryCode": "FR"
      },
      {
        "Area": "Cheremkhovo",
        "Lat": "53.1588",
        "Long": "103.0739",
        "CountryCode": "RU"
      },
      {
        "Area": "Cherepovets",
        "Lat": "59.1404",
        "Long": "37.91",
        "CountryCode": "RU"
      },
      {
        "Area": "Cherkasy",
        "Lat": "49.4347",
        "Long": "32.0709",
        "CountryCode": "UA"
      },
      {
        "Area": "Cherkessk",
        "Lat": "44.2904",
        "Long": "42.06",
        "CountryCode": "RU"
      },
      {
        "Area": "Chernihiv",
        "Lat": "51.5049",
        "Long": "31.3015",
        "CountryCode": "UA"
      },
      {
        "Area": "Chernivtsi",
        "Lat": "48.3053",
        "Long": "25.9216",
        "CountryCode": "UA"
      },
      {
        "Area": "Chernogorsk",
        "Lat": "53.8313",
        "Long": "91.2227",
        "CountryCode": "RU"
      },
      {
        "Area": "Chesapeake",
        "Lat": "36.6778",
        "Long": "-76.3024",
        "CountryCode": "US"
      },
      {
        "Area": "Chester",
        "Lat": "53.2",
        "Long": "-2.92",
        "CountryCode": "GB"
      },
      {
        "Area": "Chetumal",
        "Lat": "18.5",
        "Long": "-88.3",
        "CountryCode": "MX"
      },
      {
        "Area": "Cheyenne",
        "Lat": "41.1406",
        "Long": "-104.7926",
        "CountryCode": "US"
      },
      {
        "Area": "Chiang Mai",
        "Lat": "18.8",
        "Long": "98.98",
        "CountryCode": "TH"
      },
      {
        "Area": "Chiang Rai",
        "Lat": "19.9119",
        "Long": "99.8265",
        "CountryCode": "TH"
      },
      {
        "Area": "Chiayi",
        "Lat": "23.4755",
        "Long": "120.4351",
        "CountryCode": "TW"
      },
      {
        "Area": "Chicago",
        "Lat": "41.8373",
        "Long": "-87.6861",
        "CountryCode": "US"
      },
      {
        "Area": "Chiclayo",
        "Lat": "-6.7629",
        "Long": "-79.8366",
        "CountryCode": "PE"
      },
      {
        "Area": "Chico",
        "Lat": "39.7574",
        "Long": "-121.815",
        "CountryCode": "US"
      },
      {
        "Area": "Chicopee",
        "Lat": "42.1764",
        "Long": "-72.5719",
        "CountryCode": "US"
      },
      {
        "Area": "Chicoutimi",
        "Lat": "48.4333",
        "Long": "-71.0667",
        "CountryCode": "CA"
      },
      {
        "Area": "Chifeng",
        "Lat": "42.27",
        "Long": "118.95",
        "CountryCode": "CN"
      },
      {
        "Area": "Chihuahua",
        "Lat": "28.645",
        "Long": "-106.085",
        "CountryCode": "MX"
      },
      {
        "Area": "Chililabombwe",
        "Lat": "-12.3696",
        "Long": "27.82",
        "CountryCode": "ZM"
      },
      {
        "Area": "Chillán",
        "Lat": "-36.6",
        "Long": "-72.106",
        "CountryCode": "CL"
      },
      {
        "Area": "Chilliwack",
        "Lat": "49.1666",
        "Long": "-121.95",
        "CountryCode": "CA"
      },
      {
        "Area": "Chilpancingo",
        "Lat": "17.55",
        "Long": "-99.5",
        "CountryCode": "MX"
      },
      {
        "Area": "Chimaltenango",
        "Lat": "14.662",
        "Long": "-90.82",
        "CountryCode": "GT"
      },
      {
        "Area": "Chimbote",
        "Lat": "-9.07",
        "Long": "-78.57",
        "CountryCode": "PE"
      },
      {
        "Area": "Chimoio",
        "Lat": "-19.12",
        "Long": "33.47",
        "CountryCode": "MZ"
      },
      {
        "Area": "CNndega",
        "Lat": "12.6304",
        "Long": "-87.13",
        "CountryCode": "NI"
      },
      {
        "Area": "Chincha Alta",
        "Lat": "-13.4196",
        "Long": "-76.14",
        "CountryCode": "PE"
      },
      {
        "Area": "Chingola",
        "Lat": "-12.5396",
        "Long": "27.85",
        "CountryCode": "ZM"
      },
      {
        "Area": "Chinhoyi",
        "Lat": "-17.3596",
        "Long": "30.18",
        "CountryCode": "ZW"
      },
      {
        "Area": "Chiniot",
        "Lat": "31.72",
        "Long": "72.98",
        "CountryCode": "PK"
      },
      {
        "Area": "Chino",
        "Lat": "33.9836",
        "Long": "-117.6653",
        "CountryCode": "US"
      },
      {
        "Area": "Chino Hills",
        "Lat": "33.9508",
        "Long": "-117.7254",
        "CountryCode": "US"
      },
      {
        "Area": "Chipata",
        "Lat": "-13.6296",
        "Long": "32.64",
        "CountryCode": "ZM"
      },
      {
        "Area": "Chiquinquirá",
        "Lat": "5.6204",
        "Long": "-73.8199",
        "CountryCode": "CO"
      },
      {
        "Area": "Chirchiq",
        "Lat": "41.455",
        "Long": "69.56",
        "CountryCode": "UZ"
      },
      {
        "Area": "Chișinău",
        "Lat": "47.005",
        "Long": "28.8577",
        "CountryCode": "MD"
      },
      {
        "Area": "Chistopol",
        "Lat": "55.3648",
        "Long": "50.6407",
        "CountryCode": "RU"
      },
      {
        "Area": "Chita",
        "Lat": "52.055",
        "Long": "113.465",
        "CountryCode": "RU"
      },
      {
        "Area": "Chittagong",
        "Lat": "22.33",
        "Long": "91.8",
        "CountryCode": "BD"
      },
      {
        "Area": "Chitungwiza",
        "Lat": "-18",
        "Long": "31.1",
        "CountryCode": "ZW"
      },
      {
        "Area": "Chivilcoy",
        "Lat": "-34.9",
        "Long": "-60.04",
        "CountryCode": "AR"
      },
      {
        "Area": "Chlef",
        "Lat": "36.1704",
        "Long": "1.32",
        "CountryCode": "DZ"
      },
      {
        "Area": "Choluteca",
        "Lat": "13.3007",
        "Long": "-87.1908",
        "CountryCode": "HN"
      },
      {
        "Area": "Chon Buri",
        "Lat": "13.4004",
        "Long": "101",
        "CountryCode": "TH"
      },
      {
        "Area": "Chongjin",
        "Lat": "41.7846",
        "Long": "129.79",
        "CountryCode": "KP"
      },
      {
        "Area": "Chongju",
        "Lat": "39.6813",
        "Long": "125.2163",
        "CountryCode": "KP"
      },
      {
        "Area": "Chongqing",
        "Lat": "29.565",
        "Long": "106.595",
        "CountryCode": "CN"
      },
      {
        "Area": "Chosica",
        "Lat": "-11.93",
        "Long": "-76.71",
        "CountryCode": "PE"
      },
      {
        "Area": "Christchurch",
        "Lat": "-43.535",
        "Long": "172.63",
        "CountryCode": "NZ"
      },
      {
        "Area": "Chukai",
        "Lat": "4.2332",
        "Long": "103.4479",
        "CountryCode": "MY"
      },
      {
        "Area": "Chula Vista",
        "Lat": "32.6281",
        "Long": "-117.0145",
        "CountryCode": "US"
      },
      {
        "Area": "Chulucanas",
        "Lat": "-5.0896",
        "Long": "-80.17",
        "CountryCode": "PE"
      },
      {
        "Area": "Chumphon",
        "Lat": "10.5127",
        "Long": "99.1872",
        "CountryCode": "TH"
      },
      {
        "Area": "Chuncheon",
        "Lat": "37.8747",
        "Long": "127.7342",
        "CountryCode": "kr"
      },
      {
        "Area": "Chusovoy",
        "Lat": "58.2934",
        "Long": "57.813",
        "CountryCode": "RU"
      },
      {
        "Area": "Chuxiong",
        "Lat": "25.0364",
        "Long": "101.5456",
        "CountryCode": "CN"
      },
      {
        "Area": "Cicero",
        "Lat": "41.8445",
        "Long": "-87.7593",
        "CountryCode": "US"
      },
      {
        "Area": "Ciego de Ávila",
        "Lat": "21.84",
        "Long": "-78.7619",
        "CountryCode": "CU"
      },
      {
        "Area": "Ciénaga",
        "Lat": "11.0104",
        "Long": "-74.25",
        "CountryCode": "CO"
      },
      {
        "Area": "Cienfuegos",
        "Lat": "22.1444",
        "Long": "-80.4403",
        "CountryCode": "CU"
      },
      {
        "Area": "Cilacap",
        "Lat": "-7.7188",
        "Long": "109.0154",
        "CountryCode": "ID"
      },
      {
        "Area": "Cincinnati",
        "Lat": "39.1412",
        "Long": "-84.5059",
        "CountryCode": "US"
      },
      {
        "Area": "Cirebon",
        "Lat": "-6.7333",
        "Long": "108.5666",
        "CountryCode": "ID"
      },
      {
        "Area": "Citrus Heights",
        "Lat": "38.6948",
        "Long": "-121.288",
        "CountryCode": "US"
      },
      {
        "Area": "City of Milford (balance)",
        "Lat": "41.2253",
        "Long": "-73.0624",
        "CountryCode": "US"
      },
      {
        "Area": "Ciudad Bolívar",
        "Lat": "8.1",
        "Long": "-63.6",
        "CountryCode": "VE"
      },
      {
        "Area": "Ciudad del Carmen",
        "Lat": "18.6537",
        "Long": "-91.8245",
        "CountryCode": "MX"
      },
      {
        "Area": "Ciudad del Este",
        "Lat": "-25.5167",
        "Long": "-54.6161",
        "CountryCode": "PY"
      },
      {
        "Area": "Ciudad Guayana",
        "Lat": "8.37",
        "Long": "-62.62",
        "CountryCode": "VE"
      },
      {
        "Area": "Ciudad Guzman",
        "Lat": "19.7104",
        "Long": "-103.46",
        "CountryCode": "MX"
      },
      {
        "Area": "Ciudad Hidalgo",
        "Lat": "19.68",
        "Long": "-100.57",
        "CountryCode": "MX"
      },
      {
        "Area": "Ciudad Juárez",
        "Lat": "31.6904",
        "Long": "-106.49",
        "CountryCode": "MX"
      },
      {
        "Area": "Ciudad Madero",
        "Lat": "22.3189",
        "Long": "-97.8361",
        "CountryCode": "MX"
      },
      {
        "Area": "Ciudad Mante",
        "Lat": "22.7334",
        "Long": "-98.95",
        "CountryCode": "MX"
      },
      {
        "Area": "Ciudad Obregon",
        "Lat": "27.4666",
        "Long": "-109.925",
        "CountryCode": "MX"
      },
      {
        "Area": "Ciudad Valles",
        "Lat": "21.98",
        "Long": "-99.02",
        "CountryCode": "MX"
      },
      {
        "Area": "Ciudad Victoria",
        "Lat": "23.72",
        "Long": "-99.13",
        "CountryCode": "MX"
      },
      {
        "Area": "Civitavecchia",
        "Lat": "42.1004",
        "Long": "11.8",
        "CountryCode": "IT"
      },
      {
        "Area": "Clarksville",
        "Lat": "36.5696",
        "Long": "-87.3428",
        "CountryCode": "US"
      },
      {
        "Area": "Clearwater",
        "Lat": "27.9786",
        "Long": "-82.7622",
        "CountryCode": "US"
      },
      {
        "Area": "Clermont-Ferrand",
        "Lat": "45.78",
        "Long": "3.08",
        "CountryCode": "FR"
      },
      {
        "Area": "Cleveland",
        "Lat": "41.4767",
        "Long": "-81.6805",
        "CountryCode": "US"
      },
      {
        "Area": "Cleveland",
        "Lat": "35.1817",
        "Long": "-84.8707",
        "CountryCode": "US"
      },
      {
        "Area": "Clifton",
        "Lat": "40.8631",
        "Long": "-74.1575",
        "CountryCode": "US"
      },
      {
        "Area": "Clovis",
        "Lat": "36.8278",
        "Long": "-119.6841",
        "CountryCode": "US"
      },
      {
        "Area": "Cluj-Napoca",
        "Lat": "46.7884",
        "Long": "23.5984",
        "CountryCode": "RO"
      },
      {
        "Area": "Coari",
        "Lat": "-4.08",
        "Long": "-63.13",
        "CountryCode": "BR"
      },
      {
        "Area": "Coatzacoalcos",
        "Lat": "18.1204",
        "Long": "-94.42",
        "CountryCode": "MX"
      },
      {
        "Area": "Cobán",
        "Lat": "15.47",
        "Long": "-90.38",
        "CountryCode": "GT"
      },
      {
        "Area": "Coburg",
        "Lat": "50.2666",
        "Long": "10.9666",
        "CountryCode": "DE"
      },
      {
        "Area": "Cochabamba",
        "Lat": "-17.41",
        "Long": "-66.17",
        "CountryCode": "BO"
      },
      {
        "Area": "Coconut Creek",
        "Lat": "26.2803",
        "Long": "-80.1842",
        "CountryCode": "US"
      },
      {
        "Area": "Codó",
        "Lat": "-4.4796",
        "Long": "-43.88",
        "CountryCode": "BR"
      },
      {
        "Area": "Coeur d'Alene",
        "Lat": "47.7039",
        "Long": "-116.7933",
        "CountryCode": "US"
      },
      {
        "Area": "Coffs Harbour",
        "Lat": "-30.3071",
        "Long": "153.1123",
        "CountryCode": "AU"
      },
      {
        "Area": "Coimbra",
        "Lat": "40.2004",
        "Long": "-8.4167",
        "CountryCode": "PT"
      },
      {
        "Area": "Colima",
        "Lat": "19.23",
        "Long": "-103.72",
        "CountryCode": "MX"
      },
      {
        "Area": "College Station",
        "Lat": "30.5852",
        "Long": "-96.296",
        "CountryCode": "US"
      },
      {
        "Area": "Collierville",
        "Lat": "35.0474",
        "Long": "-89.699",
        "CountryCode": "US"
      },
      {
        "Area": "Cologne",
        "Lat": "50.93",
        "Long": "6.95",
        "CountryCode": "DE"
      },
      {
        "Area": "Colombo",
        "Lat": "6.932",
        "Long": "79.8578",
        "CountryCode": "LK"
      },
      {
        "Area": "Colón",
        "Lat": "9.365",
        "Long": "-79.875",
        "CountryCode": "PA"
      },
      {
        "Area": "Colón",
        "Lat": "22.7196",
        "Long": "-80.9058",
        "CountryCode": "CU"
      },
      {
        "Area": "Colorado Springs",
        "Lat": "38.8674",
        "Long": "-104.7606",
        "CountryCode": "US"
      },
      {
        "Area": "Colton",
        "Lat": "34.0538",
        "Long": "-117.3254",
        "CountryCode": "US"
      },
      {
        "Area": "Columbia",
        "Lat": "34.037",
        "Long": "-80.9042",
        "CountryCode": "US"
      },
      {
        "Area": "Columbia",
        "Lat": "38.9478",
        "Long": "-92.3258",
        "CountryCode": "US"
      },
      {
        "Area": "Columbus",
        "Lat": "39.986",
        "Long": "-82.9852",
        "CountryCode": "US"
      },
      {
        "Area": "Columbus",
        "Lat": "32.51",
        "Long": "-84.8771",
        "CountryCode": "US"
      },
      {
        "Area": "Columbus",
        "Lat": "39.2091",
        "Long": "-85.918",
        "CountryCode": "US"
      },
      {
        "Area": "Comayagua",
        "Lat": "14.4604",
        "Long": "-87.65",
        "CountryCode": "HN"
      },
      {
        "Area": "Comilla",
        "Lat": "23.4704",
        "Long": "91.17",
        "CountryCode": "BD"
      },
      {
        "Area": "Commerce City",
        "Lat": "39.8642",
        "Long": "-104.8434",
        "CountryCode": "US"
      },
      {
        "Area": "Como",
        "Lat": "45.81",
        "Long": "9.08",
        "CountryCode": "IT"
      },
      {
        "Area": "Comodoro Rivadavia",
        "Lat": "-45.87",
        "Long": "-67.5",
        "CountryCode": "AR"
      },
      {
        "Area": "Compton",
        "Lat": "33.893",
        "Long": "-118.2275",
        "CountryCode": "US"
      },
      {
        "Area": "Conakry",
        "Lat": "9.5315",
        "Long": "-13.6802",
        "CountryCode": "GN"
      },
      {
        "Area": "Concepción",
        "Lat": "-36.83",
        "Long": "-73.05",
        "CountryCode": "CL"
      },
      {
        "Area": "Concepción",
        "Lat": "-23.4064",
        "Long": "-57.4344",
        "CountryCode": "PY"
      },
      {
        "Area": "Concepción del UY",
        "Lat": "-32.48",
        "Long": "-58.24",
        "CountryCode": "AR"
      },
      {
        "Area": "Concord",
        "Lat": "37.9722",
        "Long": "-122.0016",
        "CountryCode": "US"
      },
      {
        "Area": "Concord",
        "Lat": "35.3933",
        "Long": "-80.636",
        "CountryCode": "US"
      },
      {
        "Area": "Concordia",
        "Lat": "-31.3896",
        "Long": "-58.03",
        "CountryCode": "AR"
      },
      {
        "Area": "Concórdia",
        "Lat": "-27.23",
        "Long": "-52.03",
        "CountryCode": "BR"
      },
      {
        "Area": "Conroe",
        "Lat": "30.322",
        "Long": "-95.4807",
        "CountryCode": "US"
      },
      {
        "Area": "Conselheiro Lafaiete",
        "Lat": "-20.67",
        "Long": "-43.79",
        "CountryCode": "BR"
      },
      {
        "Area": "Constanța",
        "Lat": "44.2027",
        "Long": "28.61",
        "CountryCode": "RO"
      },
      {
        "Area": "Constantine",
        "Lat": "36.36",
        "Long": "6.5999",
        "CountryCode": "DZ"
      },
      {
        "Area": "Conway",
        "Lat": "35.0753",
        "Long": "-92.4695",
        "CountryCode": "US"
      },
      {
        "Area": "Coon Rapids",
        "Lat": "45.1755",
        "Long": "-93.3094",
        "CountryCode": "US"
      },
      {
        "Area": "Copiapó",
        "Lat": "-27.36",
        "Long": "-70.34",
        "CountryCode": "CL"
      },
      {
        "Area": "Coquimbo",
        "Lat": "-29.9529",
        "Long": "-71.3436",
        "CountryCode": "CL"
      },
      {
        "Area": "Coral Gables",
        "Lat": "25.7037",
        "Long": "-80.2715",
        "CountryCode": "US"
      },
      {
        "Area": "Coral Springs",
        "Lat": "26.2701",
        "Long": "-80.2592",
        "CountryCode": "US"
      },
      {
        "Area": "Córdoba",
        "Lat": "-31.4",
        "Long": "-64.1823",
        "CountryCode": "AR"
      },
      {
        "Area": "Córdoba",
        "Lat": "37.88",
        "Long": "-4.77",
        "CountryCode": "ES"
      },
      {
        "Area": "Córdoba",
        "Lat": "18.9204",
        "Long": "-96.92",
        "CountryCode": "MX"
      },
      {
        "Area": "Cork",
        "Lat": "51.8986",
        "Long": "-8.4958",
        "CountryCode": "IE"
      },
      {
        "Area": "Coro",
        "Lat": "11.42",
        "Long": "-69.68",
        "CountryCode": "VE"
      },
      {
        "Area": "Corona",
        "Lat": "33.862",
        "Long": "-117.5644",
        "CountryCode": "US"
      },
      {
        "Area": "Coronel",
        "Lat": "-37.03",
        "Long": "-73.16",
        "CountryCode": "CL"
      },
      {
        "Area": "Coronel Oviedo",
        "Lat": "-25.45",
        "Long": "-56.44",
        "CountryCode": "PY"
      },
      {
        "Area": "Corpus Christi",
        "Lat": "27.7173",
        "Long": "-97.3822",
        "CountryCode": "US"
      },
      {
        "Area": "Corrientes",
        "Lat": "-27.49",
        "Long": "-58.81",
        "CountryCode": "AR"
      },
      {
        "Area": "Corum",
        "Lat": "40.52",
        "Long": "34.95",
        "CountryCode": "TR"
      },
      {
        "Area": "Corumbá",
        "Lat": "-19.016",
        "Long": "-57.65",
        "CountryCode": "BR"
      },
      {
        "Area": "Corvallis",
        "Lat": "44.5697",
        "Long": "-123.278",
        "CountryCode": "US"
      },
      {
        "Area": "Costa Mesa",
        "Lat": "33.6667",
        "Long": "-117.9135",
        "CountryCode": "US"
      },
      {
        "Area": "Cotabato",
        "Lat": "7.2169",
        "Long": "124.2484",
        "CountryCode": "PH"
      },
      {
        "Area": "Cotonou",
        "Lat": "6.4",
        "Long": "2.52",
        "CountryCode": "BJ"
      },
      {
        "Area": "Cottbus",
        "Lat": "51.7704",
        "Long": "14.33",
        "CountryCode": "DE"
      },
      {
        "Area": "Council Bluffs",
        "Lat": "41.2369",
        "Long": "-95.8517",
        "CountryCode": "US"
      },
      {
        "Area": "Coventry",
        "Lat": "52.4204",
        "Long": "-1.5",
        "CountryCode": "GB"
      },
      {
        "Area": "Cozumel",
        "Lat": "20.51",
        "Long": "-86.95",
        "CountryCode": "MX"
      },
      {
        "Area": "Craiova",
        "Lat": "44.3263",
        "Long": "23.8259",
        "CountryCode": "RO"
      },
      {
        "Area": "Cranbourne",
        "Lat": "-38.0996",
        "Long": "145.2834",
        "CountryCode": "AU"
      },
      {
        "Area": "Cranston",
        "Lat": "41.7658",
        "Long": "-71.4858",
        "CountryCode": "US"
      },
      {
        "Area": "Crateús",
        "Lat": "-5.1656",
        "Long": "-40.666",
        "CountryCode": "BR"
      },
      {
        "Area": "Crato",
        "Lat": "-7.4639",
        "Long": "-63.04",
        "CountryCode": "BR"
      },
      {
        "Area": "Crato",
        "Lat": "-7.2296",
        "Long": "-39.42",
        "CountryCode": "BR"
      },
      {
        "Area": "Criciúma",
        "Lat": "-28.68",
        "Long": "-49.39",
        "CountryCode": "BR"
      },
      {
        "Area": "Crotone",
        "Lat": "39.0833",
        "Long": "17.1233",
        "CountryCode": "IT"
      },
      {
        "Area": "Cruzeiro do Sul",
        "Lat": "-7.63",
        "Long": "-72.67",
        "CountryCode": "BR"
      },
      {
        "Area": "Cuamba",
        "Lat": "-14.7896",
        "Long": "36.54",
        "CountryCode": "MZ"
      },
      {
        "Area": "Cuauhtémoc",
        "Lat": "28.4257",
        "Long": "-106.8696",
        "CountryCode": "MX"
      },
      {
        "Area": "Cúcuta",
        "Lat": "7.92",
        "Long": "-72.52",
        "CountryCode": "CO"
      },
      {
        "Area": "Cuenca",
        "Lat": "-2.9",
        "Long": "-79",
        "CountryCode": "EC"
      },
      {
        "Area": "Cuernavaca",
        "Lat": "18.9211",
        "Long": "-99.24",
        "CountryCode": "MX"
      },
      {
        "Area": "Cuiabá",
        "Lat": "-15.5696",
        "Long": "-56.085",
        "CountryCode": "BR"
      },
      {
        "Area": "Culiacán",
        "Lat": "24.83",
        "Long": "-107.38",
        "CountryCode": "MX"
      },
      {
        "Area": "Cumaná",
        "Lat": "10.45",
        "Long": "-64.18",
        "CountryCode": "VE"
      },
      {
        "Area": "Cupertino",
        "Lat": "37.3168",
        "Long": "-122.0465",
        "CountryCode": "US"
      },
      {
        "Area": "Curepipe",
        "Lat": "-20.3162",
        "Long": "57.5166",
        "CountryCode": "MU"
      },
      {
        "Area": "Curicó",
        "Lat": "-34.98",
        "Long": "-71.24",
        "CountryCode": "CL"
      },
      {
        "Area": "Curitiba",
        "Lat": "-25.42",
        "Long": "-49.32",
        "CountryCode": "BR"
      },
      {
        "Area": "Curvelo",
        "Lat": "-18.7596",
        "Long": "-44.43",
        "CountryCode": "BR"
      },
      {
        "Area": "Cusco",
        "Lat": "-13.525",
        "Long": "-71.9722",
        "CountryCode": "PE"
      },
        {
          "Area": "D B Nagar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.5697,
          "Long": 88.3697
        },
        {
          "Area": "D B Nagr",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.5697,
          "Long": 88.3697
        },
        {
          "Area": "D.Hirehal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.9459,
          "Long": 77.1561
        },
        {
          "Area": "D.b.j.singh.",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.5764,
          "Long": 75.3312
        },
        {
          "Area": "D.gannavaram Mandal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.741,
          "Long": 81.0201
        },
        {
          "Area": "D.kalamdan",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5034,
          "Long": 87.9832
        },
        {
          "Area": "D.khasa",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.7046,
          "Long": 74.9007
        },
        {
          "Area": "D.s.boni",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.2471,
          "Long": 87.8066
        },
        {
          "Area": "D.tirumala",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.9834,
          "Long": 81.2748
        },
        {
          "Area": "DEHGAON",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.4171,
          "Long": 78.5341
        },
        {
          "Area": "Dabhara",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.998,
          "Long": 82.3545
        },
        {
          "Area": "Dabhoi",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.0923,
          "Long": 73.6732
        },
        {
          "Area": "Dabhra",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 22.0162,
          "Long": 83.1053
        },
        {
          "Area": "Dabra",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 26.4211,
          "Long": 78.7226
        },
        {
          "Area": "Dabugan",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 19.9097,
          "Long": 83.1193
        },
        {
          "Area": "Dabwali",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.9038,
          "Long": 74.6887
        },
        {
          "Area": "Dachepalle",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.686,
          "Long": 80.0809
        },
        {
          "Area": "Dada Nagar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.418,
          "Long": 80.298
        },
        {
          "Area": "Dadar",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.0167,
          "Long": 72.85
        },
        {
          "Area": "Dadari",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.4948,
          "Long": 76.2706
        },
        {
          "Area": "Dadra & Nagar Haveli",
          "State": "Dadra & Nagar Haveli",
          "CountryCode": "IN",
          "Lat": 23.0929,
          "Long": 73.9679
        },
        {
          "Area": "Dadra & Nagar Haveli",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.0929,
          "Long": 73.9679
        },
        {
          "Area": "Dadri",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.6302,
          "Long": 77.8448
        },
        {
          "Area": "Dadri",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.8431,
          "Long": 76.4037
        },
        {
          "Area": "Dadsar",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.9306,
          "Long": 75.1134
        },
        {
          "Area": "Dagadarthi",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.7385,
          "Long": 79.8867
        },
        {
          "Area": "Dahanu",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.1157,
          "Long": 73.5785
        },
        {
          "Area": "Dahina",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.1729,
          "Long": 76.1432
        },
        {
          "Area": "Dahisar East",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.2565,
          "Long": 72.8733
        },
        {
          "Area": "Dahisar West",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.2565,
          "Long": 72.8733
        },
        {
          "Area": "Dahisara",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.0055,
          "Long": 70.6103
        },
        {
          "Area": "Dahod",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.4011,
          "Long": 74.439
        },
        {
          "Area": "Dahrhara",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.21,
          "Long": 86.5274
        },
        {
          "Area": "Dainhat",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.2174,
          "Long": 87.9944
        },
        {
          "Area": "Daisai",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3564,
          "Long": 87.8021
        },
        {
          "Area": "Dakhin Sandalpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3444,
          "Long": 87.9089
        },
        {
          "Area": "Dakhin Sarubansar ( C. Block)",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.243,
          "Long": 91.7368
        },
        {
          "Area": "Dakhin Sarubanswar ( Rampur)",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3127,
          "Long": 91.4179
        },
        {
          "Area": "Dakhin Sarubanswar (rampur)",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.0779,
          "Long": 91.4179
        },
        {
          "Area": "Dakhin Sarubanswar Mauza",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.1314,
          "Long": 91.4625
        },
        {
          "Area": "Dakhinbadalpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4761,
          "Long": 86.8761
        },
        {
          "Area": "Dakhinsarubanswar ( R. Block)",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.118,
          "Long": 91.4061
        },
        {
          "Area": "Dakhora",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.2955,
          "Long": 76.4283
        },
        {
          "Area": "Dakkili",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.4268,
          "Long": 79.7344
        },
        {
          "Area": "Dakor",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.9465,
          "Long": 73.2224
        },
        {
          "Area": "Dakra",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 23.7619,
          "Long": 84.6809
        },
        {
          "Area": "Dakshin Kalyanpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3703,
          "Long": 88.2092
        },
        {
          "Area": "Dakshin Kalynpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3703,
          "Long": 88.2092
        },
        {
          "Area": "Dakshin Padmabil",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.019,
          "Long": 91.625
        },
        {
          "Area": "Dal Housia",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.5095,
          "Long": 76.3507
        },
        {
          "Area": "Dalanwas",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.3955,
          "Long": 75.9426
        },
        {
          "Area": "Dalapatipara",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0789,
          "Long": 91.8987
        },
        {
          "Area": "Dalbari",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3796,
          "Long": 91.2951
        },
        {
          "Area": "Dalgaon",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.5597,
          "Long": 92.1983
        },
        {
          "Area": "Dalhousie(T)",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.5522,
          "Long": 76.2115
        },
        {
          "Area": "Dali",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.9314,
          "Long": 94.7569
        },
        {
          "Area": "Dalkhola",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.9084,
          "Long": 88.1583
        },
        {
          "Area": "Dalla",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.2576,
          "Long": 87.9852
        },
        {
          "Area": "Dalmau",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.2511,
          "Long": 81.4931
        },
        {
          "Area": "Dalsinghsarai",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.6798,
          "Long": 85.8173
        },
        {
          "Area": "Daltoganj",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.253,
          "Long": 83.925
        },
        {
          "Area": "Daltonganj",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.0475,
          "Long": 84.2725
        },
        {
          "Area": "Dalu",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 24.9232,
          "Long": 92.7829
        },
        {
          "Area": "Damaipur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.3249,
          "Long": 87.9524
        },
        {
          "Area": "Damalacheruvu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 13.4988,
          "Long": 79.0676
        },
        {
          "Area": "Daman",
          "State": "Daman & Diu",
          "CountryCode": "IN",
          "Lat": 20.4143,
          "Long": 72.8834
        },
        {
          "Area": "Damanjodi",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.4682,
          "Long": 83.7161
        },
        {
          "Area": "Damavaram",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.808,
          "Long": 80.0705
        },
        {
          "Area": "Dambo Rongjeng",
          "State": "Meghalaya",
          "CountryCode": "IN",
          "Lat": 25.96,
          "Long": 91.0578
        },
        {
          "Area": "Damcherra",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0447,
          "Long": 91.7553
        },
        {
          "Area": "Damhal Hanji Pora",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.4795,
          "Long": 75.3575
        },
        {
          "Area": "Damin",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.964,
          "Long": 93.5532
        },
        {
          "Area": "Dammapeta",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.5969,
          "Long": 81.0831
        },
        {
          "Area": "Damodarpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.2758,
          "Long": 88.831
        },
        {
          "Area": "Damoh",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.2073,
          "Long": 79.8719
        },
        {
          "Area": "Danapur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.69,
          "Long": 85.2222
        },
        {
          "Area": "Dandirhat",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.6384,
          "Long": 88.8947
        },
        {
          "Area": "Dang",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 21.0476,
          "Long": 73.7738
        },
        {
          "Area": "Dangarmakha",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3796,
          "Long": 91.2951
        },
        {
          "Area": "Dangauli  Koiria par,Mau",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.0431,
          "Long": 83.5629
        },
        {
          "Area": "Dangs",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 20.6938,
          "Long": 73.7738
        },
        {
          "Area": "Danguaposi",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 22.3584,
          "Long": 85.7446
        },
        {
          "Area": "Daniyawan",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.4564,
          "Long": 85.2453
        },
        {
          "Area": "Dankuni",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.6685,
          "Long": 88.291
        },
        {
          "Area": "Danta",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 24.4073,
          "Long": 72.976
        },
        {
          "Area": "Danta Ramgarh",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 27.6366,
          "Long": 75.8405
        },
        {
          "Area": "Dantaewada",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 18.8682,
          "Long": 81.4659
        },
        {
          "Area": "Dantan",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.9466,
          "Long": 87.2768
        },
        {
          "Area": "Danteawada",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 19.4717,
          "Long": 81.5735
        },
        {
          "Area": "Dantewada",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 19.4717,
          "Long": 81.6754
        },
        {
          "Area": "Dantewda",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 18.579,
          "Long": 81.3223
        },
        {
          "Area": "Dantiwada",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 24.4441,
          "Long": 72.3952
        },
        {
          "Area": "Dapoli",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.0159,
          "Long": 77.6699
        },
        {
          "Area": "Daporijo",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.9911,
          "Long": 94.2295
        },
        {
          "Area": "Darak",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 28.2358,
          "Long": 94.6742
        },
        {
          "Area": "Darangamala",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.7306,
          "Long": 91.5564
        },
        {
          "Area": "Darangapara",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.7306,
          "Long": 91.5564
        },
        {
          "Area": "Daraundha",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.1562,
          "Long": 84.6181
        },
        {
          "Area": "Darbhanga",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.4629,
          "Long": 86.5762
        },
        {
          "Area": "Darbhnaga",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.9426,
          "Long": 86.0471
        },
        {
          "Area": "Darchai",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1597,
          "Long": 92.0329
        },
        {
          "Area": "Dariapur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8729,
          "Long": 88.5067
        },
        {
          "Area": "Dariapur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.8714,
          "Long": 85.1568
        },
        {
          "Area": "Daring",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.8727,
          "Long": 94.8192
        },
        {
          "Area": "Daringbadi",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.1289,
          "Long": 84.158
        },
        {
          "Area": "Darjeeling",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 27.1256,
          "Long": 88.3992
        },
        {
          "Area": "Darjeeling Pulbazar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 27.1256,
          "Long": 88.3947
        },
        {
          "Area": "Darka",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 28.2358,
          "Long": 94.6742
        },
        {
          "Area": "Darlawn",
          "State": "Mizoram",
          "CountryCode": "IN",
          "Lat": 24.1986,
          "Long": 92.939
        },
        {
          "Area": "Daroli",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.2955,
          "Long": 76.4283
        },
        {
          "Area": "Daroli Ahir",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.1904,
          "Long": 76.1312
        },
        {
          "Area": "Darpan",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.0859,
          "Long": 86.1522
        },
        {
          "Area": "Darpanigarh",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.7086,
          "Long": 86.1522
        },
        {
          "Area": "Darrang Panbari",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.6589,
          "Long": 92.4784
        },
        {
          "Area": "Darua",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.2758,
          "Long": 88.831
        },
        {
          "Area": "Darwan Nawgam",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.8463,
          "Long": 74.8035
        },
        {
          "Area": "Darwha",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.4368,
          "Long": 78.0352
        },
        {
          "Area": "Daryapu",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.813,
          "Long": 77.3768
        },
        {
          "Area": "Daryapur",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.1056,
          "Long": 77.5147
        },
        {
          "Area": "Dasada",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 24.1107,
          "Long": 72.6134
        },
        {
          "Area": "Dasagram",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.1762,
          "Long": 87.6063
        },
        {
          "Area": "Dasamantapur",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 19.3149,
          "Long": 83.4683
        },
        {
          "Area": "Dascroi",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.0548,
          "Long": 73.2824
        },
        {
          "Area": "Dasda",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.9923,
          "Long": 91.6205
        },
        {
          "Area": "Dasda",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.5276,
          "Long": 72.4427
        },
        {
          "Area": "Dasdaa",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.1465,
          "Long": 72.6134
        },
        {
          "Area": "Dasghara",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.3558,
          "Long": 88.0798
        },
        {
          "Area": "Daskroi",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.1202,
          "Long": 74.1152
        },
        {
          "Area": "Daspalla",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.4043,
          "Long": 85.0433
        },
        {
          "Area": "Daspur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.0497,
          "Long": 88.0914
        },
        {
          "Area": "Daspur-I",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.2275,
          "Long": 88.6725
        },
        {
          "Area": "Daspur-II",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4143,
          "Long": 87.267
        },
        {
          "Area": "Dasroi",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.8486,
          "Long": 72.5914
        },
        {
          "Area": "Dasua",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.7292,
          "Long": 75.8588
        },
        {
          "Area": "Dasuya",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.6655,
          "Long": 75.7136
        },
        {
          "Area": "Dataganj",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.335,
          "Long": 79.9089
        },
        {
          "Area": "Dataganj`",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.1399,
          "Long": 78.9664
        },
        {
          "Area": "Datagnj",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.9627,
          "Long": 78.9137
        },
        {
          "Area": "Datganj",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.9677,
          "Long": 79.3678
        },
        {
          "Area": "Datia",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 25.8505,
          "Long": 78.6894
        },
        {
          "Area": "Datti Rajeru",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.446,
          "Long": 83.4167
        },
        {
          "Area": "Dattirajeru",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.4701,
          "Long": 83.4121
        },
        {
          "Area": "Dattirajeru Bo",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.3574,
          "Long": 83.2853
        },
        {
          "Area": "Daudnagar",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.1076,
          "Long": 84.7788
        },
        {
          "Area": "Daudpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.0208,
          "Long": 87.7744
        },
        {
          "Area": "Daunagar",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.0266,
          "Long": 84.4141
        },
        {
          "Area": "Daund",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.7629,
          "Long": 76.188
        },
        {
          "Area": "Dausa",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 27.2462,
          "Long": 77.3913
        },
        {
          "Area": "Davanagere",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.5714,
          "Long": 76.3058
        },
        {
          "Area": "Davanangere",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.3935,
          "Long": 76.0449
        },
        {
          "Area": "Davangere",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.3658,
          "Long": 75.9911
        },
        {
          "Area": "Dawarahat",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.7779,
          "Long": 79.4273
        },
        {
          "Area": "Dawaraht",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.8511,
          "Long": 79.4252
        },
        {
          "Area": "Dawath",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.3592,
          "Long": 84.2598
        },
        {
          "Area": "Dawki",
          "State": "Meghalaya",
          "CountryCode": "IN",
          "Lat": 25.3804,
          "Long": 92.0244
        },
        {
          "Area": "Ddhanwan",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.3719,
          "Long": 85.9801
        },
        {
          "Area": "Deara",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4948,
          "Long": 88.4232
        },
        {
          "Area": "Debachara",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3796,
          "Long": 91.2951
        },
        {
          "Area": "Debagarh",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.533,
          "Long": 84.7904
        },
        {
          "Area": "Debagram",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.035,
          "Long": 88.5215
        },
        {
          "Area": "Debai",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.3576,
          "Long": 78.441
        },
        {
          "Area": "Debalaya",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.614,
          "Long": 88.5475
        },
        {
          "Area": "Debhog",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 20.2557,
          "Long": 82.3879
        },
        {
          "Area": "Debipur",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.328,
          "Long": 86.976
        },
        {
          "Area": "Debitala",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3833,
          "Long": 91.9667
        },
        {
          "Area": "Debitola",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3833,
          "Long": 91.9667
        },
        {
          "Area": "Debra",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.2838,
          "Long": 88.6725
        },
        {
          "Area": "Debuipur",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.328,
          "Long": 86.7411
        },
        {
          "Area": "Dechu",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.9187,
          "Long": 72.3875
        },
        {
          "Area": "Dediapada",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.3543,
          "Long": 73.8417
        },
        {
          "Area": "Deeg",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 27.1367,
          "Long": 77.4502
        },
        {
          "Area": "Deesa",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 24.0719,
          "Long": 71.938
        },
        {
          "Area": "Degana",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 27.8771,
          "Long": 75.0135
        },
        {
          "Area": "Deganga",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8151,
          "Long": 88.7803
        },
        {
          "Area": "Degloor",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.102,
          "Long": 77.8481
        },
        {
          "Area": "Deharadun",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.3222,
          "Long": 77.9372
        },
        {
          "Area": "Dehardun",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.2598,
          "Long": 78.1151
        },
        {
          "Area": "Dehgam",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.5972,
          "Long": 73.5882
        },
        {
          "Area": "Dehlawas Gulabpur",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.3196,
          "Long": 76.611
        },
        {
          "Area": "Dehli Ujagar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.1628,
          "Long": 80.5482
        },
        {
          "Area": "Dehra",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.3763,
          "Long": 76.5591
        },
        {
          "Area": "Dehra Gopipur",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.8558,
          "Long": 76.2205
        },
        {
          "Area": "Dehradun",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.6908,
          "Long": 78.4813
        },
        {
          "Area": "Dehraudun",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.2266,
          "Long": 78.1393
        },
        {
          "Area": "Dehri",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.2458,
          "Long": 85.2564
        },
        {
          "Area": "Dehri On Sone",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.176,
          "Long": 84.4241
        },
        {
          "Area": "Dekargaon",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.7824,
          "Long": 92.9393
        },
        {
          "Area": "Dekhali",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5034,
          "Long": 87.9832
        },
        {
          "Area": "Delhi",
          "State": "Delhi",
          "CountryCode": "IN",
          "Lat": 28.8527,
          "Long": 77.2982
        },
        {
          "Area": "Delhi North East",
          "State": "Delhi",
          "CountryCode": "IN",
          "Lat": 28.6114,
          "Long": 77.2982
        },
        {
          "Area": "Demagiri",
          "State": "Mizoram",
          "CountryCode": "IN",
          "Lat": 22.912,
          "Long": 92.498
        },
        {
          "Area": "Demcherra",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.9923,
          "Long": 91.6205
        },
        {
          "Area": "Demdun",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1048,
          "Long": 92.0073
        },
        {
          "Area": "Demidulla",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.9563,
          "Long": 74.834
        },
        {
          "Area": "Denduluru",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.7578,
          "Long": 81.1649
        },
        {
          "Area": "Denkada",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.2026,
          "Long": 83.5214
        },
        {
          "Area": "Denkanikotta",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 12.6549,
          "Long": 78.4437
        },
        {
          "Area": "Denkanikottai",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 12.6438,
          "Long": 78.183
        },
        {
          "Area": "Deo",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.7929,
          "Long": 84.6674
        },
        {
          "Area": "Deoband",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 29.9496,
          "Long": 78.0079
        },
        {
          "Area": "Deobhag",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 20.2557,
          "Long": 82.3879
        },
        {
          "Area": "Deobhog",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.2248,
          "Long": 82.6579
        },
        {
          "Area": "Deocherra",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1597,
          "Long": 92.0329
        },
        {
          "Area": "Deodar",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 24.1639,
          "Long": 72.6444
        },
        {
          "Area": "Deodurga",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 16.3831,
          "Long": 77.334
        },
        {
          "Area": "Deogarh",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.4478,
          "Long": 84.7904
        },
        {
          "Area": "Deogarh",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.6278,
          "Long": 74.0884
        },
        {
          "Area": "Deoghar",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.7424,
          "Long": 87.105
        },
        {
          "Area": "Deola",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.1726,
          "Long": 73.9417
        },
        {
          "Area": "Deoli",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.1773,
          "Long": 79.0113
        },
        {
          "Area": "Deomali",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.3162,
          "Long": 95.9869
        },
        {
          "Area": "Deomornoi",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.6676,
          "Long": 92.4009
        },
        {
          "Area": "Deoni",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 18.6896,
          "Long": 77.0819
        },
        {
          "Area": "Deoprayag",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.2705,
          "Long": 78.85
        },
        {
          "Area": "Deoracherra",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0789,
          "Long": 91.8987
        },
        {
          "Area": "Deori",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.5872,
          "Long": 86.4625
        },
        {
          "Area": "Deori",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.5629,
          "Long": 80.4064
        },
        {
          "Area": "Deori",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.8481,
          "Long": 79.2599
        },
        {
          "Area": "Deoria",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.1255,
          "Long": 84.1635
        },
        {
          "Area": "Deoria Sadar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.1255,
          "Long": 84.1635
        },
        {
          "Area": "Deosar",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.5065,
          "Long": 82.2307
        },
        {
          "Area": "Deosarh",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.1628,
          "Long": 80.5482
        },
        {
          "Area": "Deotala",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3409,
          "Long": 87.9885
        },
        {
          "Area": "Depal",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.7344,
          "Long": 87.5491
        },
        {
          "Area": "Depalpur",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.5941,
          "Long": 76.7944
        },
        {
          "Area": "Dera Baba Nanak",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 32.0373,
          "Long": 75.3864
        },
        {
          "Area": "Dera Bassi",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 30.7093,
          "Long": 76.8363
        },
        {
          "Area": "Dera Gopipur(T)",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.0348,
          "Long": 76.5591
        },
        {
          "Area": "Derabassi",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 30.7465,
          "Long": 76.9086
        },
        {
          "Area": "Desaiganj",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.6235,
          "Long": 79.9645
        },
        {
          "Area": "Desari",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.7233,
          "Long": 85.4395
        },
        {
          "Area": "Desh Bandhu Nagar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.5697,
          "Long": 88.3697
        },
        {
          "Area": "Deshbandhunagar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.7807,
          "Long": 88.3282
        },
        {
          "Area": "Deshdattabarh",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3836,
          "Long": 87.8747
        },
        {
          "Area": "Desuri",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.7079,
          "Long": 73.6446
        },
        {
          "Area": "Detrioj-rampura",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.71,
          "Long": 72.196
        },
        {
          "Area": "Detroj Rampura",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.2864,
          "Long": 72.595
        },
        {
          "Area": "Detroj- Rampura",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.71,
          "Long": 72.6196
        },
        {
          "Area": "Detroj-Rampura",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.4068,
          "Long": 72.6196
        },
        {
          "Area": "Deulbarh",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4305,
          "Long": 87.4447
        },
        {
          "Area": "Deulgaon Mahi",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.5111,
          "Long": 76.4083
        },
        {
          "Area": "Deulgaon Raja",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.8462,
          "Long": 76.9581
        },
        {
          "Area": "Deuli",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.4323,
          "Long": 88.373
        },
        {
          "Area": "Deulinekurseni",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3836,
          "Long": 87.8747
        },
        {
          "Area": "Deulpota Keshabchak",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5034,
          "Long": 87.9832
        },
        {
          "Area": "Devadurga",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 16.2646,
          "Long": 76.9902
        },
        {
          "Area": "Devakottai",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.3066,
          "Long": 78.8631
        },
        {
          "Area": "Devanahalli",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.431,
          "Long": 77.7118
        },
        {
          "Area": "Devanakonda",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.8108,
          "Long": 77.6288
        },
        {
          "Area": "Devanhalli",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.2257,
          "Long": 77.6468
        },
        {
          "Area": "Devarakonda",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.0908,
          "Long": 78.9773
        },
        {
          "Area": "Devarapalle",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.9206,
          "Long": 82.8421
        },
        {
          "Area": "Devarapalli",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.0487,
          "Long": 83.0089
        },
        {
          "Area": "Devarapalli Mandal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.7753,
          "Long": 81.174
        },
        {
          "Area": "Devarapalli Mandalam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.1047,
          "Long": 81.5721
        },
        {
          "Area": "Devarkadra",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.0255,
          "Long": 78.2171
        },
        {
          "Area": "Devaruppal",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.0949,
          "Long": 79.7992
        },
        {
          "Area": "Devaruppala",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.894,
          "Long": 79.9638
        },
        {
          "Area": "Devaruppula",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.705,
          "Long": 79.6333
        },
        {
          "Area": "Devendra",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.3341,
          "Long": 80.365
        },
        {
          "Area": "Devendra Nagar",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.6036,
          "Long": 80.5037
        },
        {
          "Area": "Deverapalli",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.7753,
          "Long": 81.174
        },
        {
          "Area": "Deverapalli Mandalam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.047,
          "Long": 81.4966
        },
        {
          "Area": "Devgad",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.6614,
          "Long": 77.9338
        },
        {
          "Area": "Devgadbaria",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.0954,
          "Long": 73.7069
        },
        {
          "Area": "Devgadh Baria",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.2192,
          "Long": 74.1046
        },
        {
          "Area": "Devikulam",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 10.2764,
          "Long": 77.2097
        },
        {
          "Area": "Devipatnam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.5187,
          "Long": 81.9479
        },
        {
          "Area": "Devipatnam Mandalam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.4115,
          "Long": 81.6559
        },
        {
          "Area": "Devipatnammandalam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.3531,
          "Long": 81.6559
        },
        {
          "Area": "Devipur",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.328,
          "Long": 86.7411
        },
        {
          "Area": "Devla",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.4623,
          "Long": 74.5466
        },
        {
          "Area": "Devprayag",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.4374,
          "Long": 78.85
        },
        {
          "Area": "Devsar",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.5339,
          "Long": 75.1844
        },
        {
          "Area": "Devsar",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.2387,
          "Long": 82.1052
        },
        {
          "Area": "Dewanpassa",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0447,
          "Long": 91.7553
        },
        {
          "Area": "Dewas",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.211,
          "Long": 76.8643
        },
        {
          "Area": "Dewas",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.3732,
          "Long": 76.8881
        },
        {
          "Area": "Dhadaon",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.4151,
          "Long": 74.365
        },
        {
          "Area": "Dhadgaon",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.8303,
          "Long": 74.2573
        },
        {
          "Area": "Dhadhot",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.4851,
          "Long": 76.4735
        },
        {
          "Area": "Dhaka",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.8148,
          "Long": 85.8326
        },
        {
          "Area": "Dhakuakhana",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.2011,
          "Long": 94.4571
        },
        {
          "Area": "Dhalbelun",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8223,
          "Long": 87.5059
        },
        {
          "Area": "Dhalbhum",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.255,
          "Long": 86.4527
        },
        {
          "Area": "Dhalbhum Jamshedpur",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 23.0301,
          "Long": 85.9734
        },
        {
          "Area": "Dhalbhum,Jamshedpur",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.255,
          "Long": 86.8109
        },
        {
          "Area": "Dhalbhumgarh",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 23.6576,
          "Long": 86.7861
        },
        {
          "Area": "Dhalpur",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.169,
          "Long": 94.2767
        },
        {
          "Area": "Dhaltita",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8337,
          "Long": 88.8136
        },
        {
          "Area": "Dhama",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.3405,
          "Long": 84.3382
        },
        {
          "Area": "Dhamanagar",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.0279,
          "Long": 86.6254
        },
        {
          "Area": "Dhamangaon",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.9009,
          "Long": 77.9838
        },
        {
          "Area": "Dhamangaon R.s.",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.1432,
          "Long": 77.9838
        },
        {
          "Area": "Dhamangaon Railway",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.7548,
          "Long": 78.282
        },
        {
          "Area": "Dhamangaon Rly",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.7762,
          "Long": 78.0956
        },
        {
          "Area": "Dhamdha",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.5869,
          "Long": 81.5406
        },
        {
          "Area": "Dhamnagar",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.5203,
          "Long": 86.6254
        },
        {
          "Area": "Dhamotar",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 24.5489,
          "Long": 74.3996
        },
        {
          "Area": "Dhampur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 29.4547,
          "Long": 79.252
        },
        {
          "Area": "Dhamtari",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 20.9945,
          "Long": 81.8814
        },
        {
          "Area": "Dhana",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.2358,
          "Long": 76.5433
        },
        {
          "Area": "Dhanarua",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.3508,
          "Long": 85.0694
        },
        {
          "Area": "Dhanaunda",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.4013,
          "Long": 76.373
        },
        {
          "Area": "Dhanaura",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 29.0284,
          "Long": 78.5124
        },
        {
          "Area": "Dhanbad",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.3134,
          "Long": 87.0645
        },
        {
          "Area": "Dhanbil",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.5004,
          "Long": 91.4784
        },
        {
          "Area": "Dhanbilash",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0789,
          "Long": 91.8987
        },
        {
          "Area": "Dhandalibarh",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.871,
          "Long": 88.0316
        },
        {
          "Area": "Dhandhuka",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.4751,
          "Long": 74.1152
        },
        {
          "Area": "Dhanera",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 24.5097,
          "Long": 72.3652
        },
        {
          "Area": "Dhangaon",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.2758,
          "Long": 88.831
        },
        {
          "Area": "Dhangarpara",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8223,
          "Long": 87.5059
        },
        {
          "Area": "Dhanghara",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.0208,
          "Long": 87.7744
        },
        {
          "Area": "Dhanghata",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.7902,
          "Long": 83.1636
        },
        {
          "Area": "Dhaniakhali",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.3187,
          "Long": 88.1509
        },
        {
          "Area": "Dhanicherra",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1597,
          "Long": 92.0329
        },
        {
          "Area": "Dhankauda",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.5488,
          "Long": 84.3546
        },
        {
          "Area": "Dhankrabanka",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.5526,
          "Long": 88.4901
        },
        {
          "Area": "Dhanolti",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.5659,
          "Long": 78.537
        },
        {
          "Area": "Dhanora",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.3487,
          "Long": 80.4713
        },
        {
          "Area": "Dhanota",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.0799,
          "Long": 76.0612
        },
        {
          "Area": "Dhanoulti",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.4574,
          "Long": 77.8988
        },
        {
          "Area": "Dhanpur",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.2191,
          "Long": 74.1805
        },
        {
          "Area": "Dhansura",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 24.1359,
          "Long": 73.5725
        },
        {
          "Area": "Dhanupali",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.4256,
          "Long": 84.0292
        },
        {
          "Area": "Dhanwar",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.471,
          "Long": 86.2708
        },
        {
          "Area": "Dhanwatr",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.5173,
          "Long": 85.889
        },
        {
          "Area": "Dhanyakuria",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.683,
          "Long": 88.7907
        },
        {
          "Area": "Dhaolti",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.5659,
          "Long": 78.0766
        },
        {
          "Area": "Dhapa",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.966,
          "Long": 88.2036
        },
        {
          "Area": "Dhar",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.7895,
          "Long": 75.7275
        },
        {
          "Area": "Dhar Kalan",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 32.477,
          "Long": 75.8919
        },
        {
          "Area": "Dharagaon",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.927,
          "Long": 75.067
        },
        {
          "Area": "Dharakot",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.0631,
          "Long": 75.3067
        },
        {
          "Area": "Dharamberia",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.795,
          "Long": 88.1206
        },
        {
          "Area": "Dharamgarh",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.2513,
          "Long": 83.796
        },
        {
          "Area": "Dharamkot",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.0631,
          "Long": 75.3067
        },
        {
          "Area": "Dharampukuria",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.0762,
          "Long": 88.8272
        },
        {
          "Area": "Dharampur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4653,
          "Long": 88.7803
        },
        {
          "Area": "Dharampur",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.1018,
          "Long": 73.4056
        },
        {
          "Area": "Dharampuri",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.0116,
          "Long": 75.7321
        },
        {
          "Area": "Dharamsala",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.2798,
          "Long": 76.458
        },
        {
          "Area": "Dharan",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.1729,
          "Long": 76.1432
        },
        {
          "Area": "Dharangaon",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.1976,
          "Long": 75.558
        },
        {
          "Area": "Dharapram",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.5152,
          "Long": 77.4143
        },
        {
          "Area": "Dharapuram",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 12.0998,
          "Long": 78.3383
        },
        {
          "Area": "Dharaupram",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.5152,
          "Long": 77.4143
        },
        {
          "Area": "Dharchula",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.1795,
          "Long": 80.8588
        },
        {
          "Area": "Dharhara",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.444,
          "Long": 86.4728
        },
        {
          "Area": "Dhari",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.5193,
          "Long": 79.8555
        },
        {
          "Area": "Dhari",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 21.6823,
          "Long": 71.3701
        },
        {
          "Area": "Dharia",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.8537,
          "Long": 86.8409
        },
        {
          "Area": "Dhariawad",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.3912,
          "Long": 75.6524
        },
        {
          "Area": "Dharmabad",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.2549,
          "Long": 77.8879
        },
        {
          "Area": "Dharmagarh",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.2513,
          "Long": 83.796
        },
        {
          "Area": "Dharmajaigarh",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 23.2948,
          "Long": 83.9171
        },
        {
          "Area": "Dharmajigudem",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.9477,
          "Long": 81.07
        },
        {
          "Area": "Dharmakot",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.0631,
          "Long": 75.3067
        },
        {
          "Area": "Dharmanagar",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0447,
          "Long": 91.7553
        },
        {
          "Area": "Dharmapuri",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 12.2839,
          "Long": 78.8305
        },
        {
          "Area": "Dharmapuri",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.9489,
          "Long": 79.4075
        },
        {
          "Area": "Dharmaram",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.7775,
          "Long": 79.082
        },
        {
          "Area": "Dharmaram Mandal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.5387,
          "Long": 79.0803
        },
        {
          "Area": "Dharmasagar",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.4548,
          "Long": 80.0043
        },
        {
          "Area": "Dharmasala",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.951,
          "Long": 86.3199
        },
        {
          "Area": "Dharmavaram",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.5796,
          "Long": 77.9602
        },
        {
          "Area": "Dharmpur(S.T)",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.4419,
          "Long": 76.8086
        },
        {
          "Area": "Dharni",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.5088,
          "Long": 77.572
        },
        {
          "Area": "Dharpalle",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.0777,
          "Long": 78.7021
        },
        {
          "Area": "Dharsiwa",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 20.5553,
          "Long": 82.2147
        },
        {
          "Area": "Dharson",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.1167,
          "Long": 76.0833
        },
        {
          "Area": "Dharuhera",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.2055,
          "Long": 76.7969
        },
        {
          "Area": "Dharur",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.2077,
          "Long": 77.0702
        },
        {
          "Area": "Dharur",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 16.4204,
          "Long": 77.6893
        },
        {
          "Area": "Dharwad",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.8194,
          "Long": 75.37
        },
        {
          "Area": "Dhatrigram",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.3857,
          "Long": 88.0371
        },
        {
          "Area": "Dhaulana",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.871,
          "Long": 77.6956
        },
        {
          "Area": "Dhaurahara",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.1225,
          "Long": 81.3267
        },
        {
          "Area": "Dhawana",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.2413,
          "Long": 76.3937
        },
        {
          "Area": "Dhekiajuli",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.7037,
          "Long": 92.4781
        },
        {
          "Area": "Dheknamari",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3687,
          "Long": 88.562
        },
        {
          "Area": "Dhemaji",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.5777,
          "Long": 94.7778
        },
        {
          "Area": "Dhenkanal",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.5259,
          "Long": 85.5262
        },
        {
          "Area": "Dhenkanal Sadar",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.0239,
          "Long": 85.5262
        },
        {
          "Area": "Dhilwan",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.5143,
          "Long": 75.3457
        },
        {
          "Area": "Dhing",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.4679,
          "Long": 92.4734
        },
        {
          "Area": "Dhjar",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.5077,
          "Long": 75.5305
        },
        {
          "Area": "Dhlapur",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.919,
          "Long": 94.2767
        },
        {
          "Area": "Dholahat",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3131,
          "Long": 88.4106
        },
        {
          "Area": "Dholera",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.3043,
          "Long": 77.0492
        },
        {
          "Area": "Dholka",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.4751,
          "Long": 73.1752
        },
        {
          "Area": "Dholmari",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.7907,
          "Long": 87.8635
        },
        {
          "Area": "Dholpur",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.8897,
          "Long": 78.0829
        },
        {
          "Area": "Dhone",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.4115,
          "Long": 77.9376
        },
        {
          "Area": "Dhoom",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.5793,
          "Long": 77.5799
        },
        {
          "Area": "Dhoomakot",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.9968,
          "Long": 79.1732
        },
        {
          "Area": "Dhor Kalan",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.0799,
          "Long": 76.0612
        },
        {
          "Area": "Dhoraji",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.8634,
          "Long": 71.5304
        },
        {
          "Area": "Dhorimana",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.7356,
          "Long": 72.4458
        },
        {
          "Area": "Dhotian",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.7046,
          "Long": 75.1597
        },
        {
          "Area": "Dhramgarh",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 19.9486,
          "Long": 82.9978
        },
        {
          "Area": "Dhrangadhra",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.1455,
          "Long": 72.0546
        },
        {
          "Area": "Dhrangsadhra",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.9917,
          "Long": 71.4679
        },
        {
          "Area": "Dhrol",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.6415,
          "Long": 70.593
        },
        {
          "Area": "Dhubri",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3513,
          "Long": 91.1281
        },
        {
          "Area": "Dhubulia",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.4827,
          "Long": 88.5215
        },
        {
          "Area": "Dhuchnikhali",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3484,
          "Long": 88.8997
        },
        {
          "Area": "Dhuipada",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3836,
          "Long": 87.8747
        },
        {
          "Area": "Dhula",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.6676,
          "Long": 92.4009
        },
        {
          "Area": "Dhule",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.3448,
          "Long": 74.9783
        },
        {
          "Area": "Dhulipudi",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.5588,
          "Long": 79.888
        },
        {
          "Area": "Dhumacherra",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.9923,
          "Long": 91.6205
        },
        {
          "Area": "Dhumakot",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.8929,
          "Long": 79.1732
        },
        {
          "Area": "Dhumsai",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5234,
          "Long": 87.6598
        },
        {
          "Area": "Dhupguri",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.792,
          "Long": 89.1837
        },
        {
          "Area": "Dhupguri Sadar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.589,
          "Long": 89.0073
        },
        {
          "Area": "Dhupirbond",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0447,
          "Long": 91.7553
        },
        {
          "Area": "Dhuraiya",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.3885,
          "Long": 87.1123
        },
        {
          "Area": "Dhuri",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 30.9531,
          "Long": 76.0076
        },
        {
          "Area": "Dhusuri",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.1165,
          "Long": 86.6852
        },
        {
          "Area": "Dhutradaha",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4784,
          "Long": 88.5822
        },
        {
          "Area": "Dialgam",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.6809,
          "Long": 75.1654
        },
        {
          "Area": "Diamond Harbour - I",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4328,
          "Long": 88.6625
        },
        {
          "Area": "Diamond Harbour - II",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4328,
          "Long": 88.2677
        },
        {
          "Area": "Dibai",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.166,
          "Long": 78.057
        },
        {
          "Area": "Dibarpanda",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3029,
          "Long": 87.818
        },
        {
          "Area": "Dibipur",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.328,
          "Long": 86.7411
        },
        {
          "Area": "Dibrugarh",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.3779,
          "Long": 95.2828
        },
        {
          "Area": "Dichpalle",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.5261,
          "Long": 78.4353
        },
        {
          "Area": "Didihat",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.1119,
          "Long": 80.3477
        },
        {
          "Area": "Didwana",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 28.1073,
          "Long": 75.3372
        },
        {
          "Area": "Didwana]",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.6949,
          "Long": 75.0607
        },
        {
          "Area": "Digapahandi",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.383,
          "Long": 84.6711
        },
        {
          "Area": "Digha",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.151,
          "Long": 72.9962
        },
        {
          "Area": "Digha",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4653,
          "Long": 88.7803
        },
        {
          "Area": "Dighadari",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3444,
          "Long": 87.9089
        },
        {
          "Area": "Dighalbar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.2576,
          "Long": 87.9852
        },
        {
          "Area": "Dighari",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.1467,
          "Long": 88.803
        },
        {
          "Area": "Dighwara",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.8009,
          "Long": 85.0333
        },
        {
          "Area": "Diglipur",
          "State": "Andaman & Nicobar Islands",
          "CountryCode": "IN",
          "Lat": 13.2667,
          "Long": 93
        },
        {
          "Area": "Digod",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.1241,
          "Long": 76.1293
        },
        {
          "Area": "Digras",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.2376,
          "Long": 78.1622
        },
        {
          "Area": "Digrota",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.3955,
          "Long": 75.9426
        },
        {
          "Area": "Dihira",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3679,
          "Long": 91.3877
        },
        {
          "Area": "Dikchu",
          "State": "Sikkim",
          "CountryCode": "IN",
          "Lat": 27.4034,
          "Long": 88.5029
        },
        {
          "Area": "Dikom",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.2851,
          "Long": 95.2188
        },
        {
          "Area": "Dikrong",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.169,
          "Long": 94.1258
        },
        {
          "Area": "Dimakuchi",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.741,
          "Long": 92.0374
        },
        {
          "Area": "Dimapur",
          "State": "Nagaland",
          "CountryCode": "IN",
          "Lat": 25.9288,
          "Long": 94.3486
        },
        {
          "Area": "Dimapur Bazar",
          "State": "Nagaland",
          "CountryCode": "IN",
          "Lat": 25.9288,
          "Long": 94.3486
        },
        {
          "Area": "Dimapur Mdg",
          "State": "Nagaland",
          "CountryCode": "IN",
          "Lat": 25.9288,
          "Long": 94.3486
        },
        {
          "Area": "Dimapur Sadar",
          "State": "Nagaland",
          "CountryCode": "IN",
          "Lat": 25.9288,
          "Long": 94.3486
        },
        {
          "Area": "Dimni",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 26.6958,
          "Long": 78.1003
        },
        {
          "Area": "Dinapur-Cum-Khagaul",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.6938,
          "Long": 85.0874
        },
        {
          "Area": "Dinara",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.3342,
          "Long": 84.0864
        },
        {
          "Area": "Dindigul",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.7946,
          "Long": 78.3592
        },
        {
          "Area": "Dindoir",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.2567,
          "Long": 74.8934
        },
        {
          "Area": "Dindori",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.5449,
          "Long": 76.2302
        },
        {
          "Area": "Dindori",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.3254,
          "Long": 81.6356
        },
        {
          "Area": "Dinhata",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.3599,
          "Long": 89.5546
        },
        {
          "Area": "Dinhata - I",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.3599,
          "Long": 89.5546
        },
        {
          "Area": "Dinhata - II",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.3599,
          "Long": 89.5546
        },
        {
          "Area": "Diomukh",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.1454,
          "Long": 93.7532
        },
        {
          "Area": "Diphu",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.5784,
          "Long": 93.17
        },
        {
          "Area": "Dirang",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.3333,
          "Long": 92.2667
        },
        {
          "Area": "Dirang Basti",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.4,
          "Long": 92.1833
        },
        {
          "Area": "Dirua",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3571,
          "Long": 91.3397
        },
        {
          "Area": "Disa",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 24.423,
          "Long": 73.5033
        },
        {
          "Area": "Diskit",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.6632,
          "Long": 77.5479
        },
        {
          "Area": "Diu",
          "State": "Daman & Diu",
          "CountryCode": "IN",
          "Lat": 20.9432,
          "Long": 71.0823
        },
        {
          "Area": "Diu U.T.",
          "State": "Daman & Diu",
          "CountryCode": "IN",
          "Lat": 20.9432,
          "Long": 71.0823
        },
        {
          "Area": "Djanwar",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.3674,
          "Long": 85.981
        },
        {
          "Area": "Dlf Ph-ii",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.418,
          "Long": 76.9839
        },
        {
          "Area": "Dlf Ph-iii",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.4001,
          "Long": 76.9661
        },
        {
          "Area": "Dlf Qe",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.418,
          "Long": 76.9839
        },
        {
          "Area": "Dobaria",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3836,
          "Long": 87.8747
        },
        {
          "Area": "Dobasipara",
          "State": "Meghalaya",
          "CountryCode": "IN",
          "Lat": 25.7466,
          "Long": 90.3804
        },
        {
          "Area": "Dobhi",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.5331,
          "Long": 84.9053
        },
        {
          "Area": "Doboka",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 25.8862,
          "Long": 93.0109
        },
        {
          "Area": "Dochana",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.0733,
          "Long": 75.9979
        },
        {
          "Area": "Dod Ballapur",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.1907,
          "Long": 77.3615
        },
        {
          "Area": "Doda",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.2644,
          "Long": 75.6526
        },
        {
          "Area": "Dodamarg",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 15.7909,
          "Long": 74.1023
        },
        {
          "Area": "Dodbalapura",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.2257,
          "Long": 77.575
        },
        {
          "Area": "Dodballapura",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.3697,
          "Long": 77.6259
        },
        {
          "Area": "Doddaballapura",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.4412,
          "Long": 77.6671
        },
        {
          "Area": "Doddaballpura",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.2506,
          "Long": 77.56
        },
        {
          "Area": "Doddabllapur",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.2257,
          "Long": 77.575
        },
        {
          "Area": "Dodra Kawar",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.1885,
          "Long": 77.3245
        },
        {
          "Area": "Dogachhi",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.5009,
          "Long": 88.1442
        },
        {
          "Area": "Dogachia",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8767,
          "Long": 88.585
        },
        {
          "Area": "Doghar",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.7424,
          "Long": 85.7764
        },
        {
          "Area": "Dohad",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.0014,
          "Long": 74.4008
        },
        {
          "Area": "Doimukh",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.2072,
          "Long": 93.757
        },
        {
          "Area": "Doiwala",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.23,
          "Long": 78.0734
        },
        {
          "Area": "Dokra",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5234,
          "Long": 87.6598
        },
        {
          "Area": "Dolgram",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5234,
          "Long": 87.6598
        },
        {
          "Area": "Domagariaganj",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.3451,
          "Long": 82.6519
        },
        {
          "Area": "Domariaganj",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.3839,
          "Long": 82.9574
        },
        {
          "Area": "Domjur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.2934,
          "Long": 88.7067
        },
        {
          "Area": "Domkal",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3584,
          "Long": 88.231
        },
        {
          "Area": "Dompara",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.3477,
          "Long": 85.3452
        },
        {
          "Area": "Donakonda",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.8887,
          "Long": 79.5354
        },
        {
          "Area": "Dondi",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.1912,
          "Long": 81.3538
        },
        {
          "Area": "Dondi Awari",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 20.6682,
          "Long": 81.1771
        },
        {
          "Area": "Dondi Lohara",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.1912,
          "Long": 81.3538
        },
        {
          "Area": "Dondiluhara",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.5457,
          "Long": 81.2705
        },
        {
          "Area": "Dongargaon",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.0374,
          "Long": 80.9479
        },
        {
          "Area": "Dongargarh",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.251,
          "Long": 80.8691
        },
        {
          "Area": "Dongra Ahir",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.2242,
          "Long": 76.5554
        },
        {
          "Area": "Donka",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.0654,
          "Long": 93.1487
        },
        {
          "Area": "Donkamokam",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.0434,
          "Long": 92.2762
        },
        {
          "Area": "Doom Dooma",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.6999,
          "Long": 95.6265
        },
        {
          "Area": "Doomdooma",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.6999,
          "Long": 95.6124
        },
        {
          "Area": "Doomni",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.536,
          "Long": 91.4097
        },
        {
          "Area": "Doongala",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.6983,
          "Long": 75.2276
        },
        {
          "Area": "Doongla",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.5144,
          "Long": 76.8822
        },
        {
          "Area": "Dooru",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.8159,
          "Long": 75.1293
        },
        {
          "Area": "Doraha",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.7839,
          "Long": 77.1285
        },
        {
          "Area": "Doravarisatram",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.2839,
          "Long": 80.1158
        },
        {
          "Area": "Dornakal",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.9552,
          "Long": 80.1491
        },
        {
          "Area": "Dornala",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.8855,
          "Long": 79.5057
        },
        {
          "Area": "Dornipadu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.3388,
          "Long": 78.3007
        },
        {
          "Area": "Dotma",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.764,
          "Long": 92.2216
        },
        {
          "Area": "Dotoma",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.4674,
          "Long": 90.4195
        },
        {
          "Area": "Doulatchak",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.0302,
          "Long": 87.807
        },
        {
          "Area": "Doyang H Project",
          "State": "Nagaland",
          "CountryCode": "IN",
          "Lat": 26.2193,
          "Long": 94.2654
        },
        {
          "Area": "Drass",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.3669,
          "Long": 75.5907
        },
        {
          "Area": "Dshrangadhra",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.9013,
          "Long": 71.8624
        },
        {
          "Area": "Duajhar",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.286,
          "Long": 82.682
        },
        {
          "Area": "Dubbak",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.888,
          "Long": 78.7392
        },
        {
          "Area": "Dubda",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.9958,
          "Long": 87.8022
        },
        {
          "Area": "Dubrajpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.8367,
          "Long": 87.4371
        },
        {
          "Area": "Dudhi",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 24.5068,
          "Long": 83.336
        },
        {
          "Area": "Dudhnai",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.0672,
          "Long": 90.511
        },
        {
          "Area": "Dudhnoi",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.0672,
          "Long": 90.9533
        },
        {
          "Area": "Dudhpur",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1048,
          "Long": 92.0073
        },
        {
          "Area": "Dudnai",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.0672,
          "Long": 90.9533
        },
        {
          "Area": "Duggirala",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.3786,
          "Long": 80.6293
        },
        {
          "Area": "Duggondi",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.0544,
          "Long": 79.8146
        },
        {
          "Area": "Dulana",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.4851,
          "Long": 76.4735
        },
        {
          "Area": "Dulat Jat",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.2242,
          "Long": 76.5554
        },
        {
          "Area": "Dulduli Mathbari",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.4323,
          "Long": 88.373
        },
        {
          "Area": "Dulgaon Raja",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.6162,
          "Long": 76.9581
        },
        {
          "Area": "Dulhin Bazar",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.3734,
          "Long": 84.8775
        },
        {
          "Area": "Duliajan",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.3723,
          "Long": 95.3075
        },
        {
          "Area": "Dulot Ahir",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.4851,
          "Long": 76.4735
        },
        {
          "Area": "Dum Dum Park",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.3945,
          "Long": 88.2559
        },
        {
          "Area": "Duma",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.1465,
          "Long": 88.1117
        },
        {
          "Area": "Dumandari",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.0093,
          "Long": 87.7037
        },
        {
          "Area": "Dumaria",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 22.4925,
          "Long": 86.4672
        },
        {
          "Area": "Dumbriguda",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.3099,
          "Long": 82.8237
        },
        {
          "Area": "Dumka",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.8959,
          "Long": 87.5082
        },
        {
          "Area": "Dummagudem",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.9319,
          "Long": 80.9612
        },
        {
          "Area": "Dumporijo",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.9911,
          "Long": 94.2295
        },
        {
          "Area": "Dumra",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.576,
          "Long": 85.6152
        },
        {
          "Area": "Dumraon",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.6371,
          "Long": 84.7436
        },
        {
          "Area": "Dumri",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.7068,
          "Long": 86.1103
        },
        {
          "Area": "Dunara",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.7508,
          "Long": 73.5797
        },
        {
          "Area": "Dunda",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.9731,
          "Long": 79.1165
        },
        {
          "Area": "Dunderwas",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.1881,
          "Long": 76.754
        },
        {
          "Area": "Dungargarh",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 28.4905,
          "Long": 74.1156
        },
        {
          "Area": "Dungarpur",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 24.6628,
          "Long": 74.3499
        },
        {
          "Area": "Dungri",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 20.6849,
          "Long": 72.92
        },
        {
          "Area": "Duni",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.9211,
          "Long": 75.4753
        },
        {
          "Area": "Duni",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.4695,
          "Long": 91.844
        },
        {
          "Area": "Duragpur Mc",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.2028,
          "Long": 87.9815
        },
        {
          "Area": "Duraon",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.6116,
          "Long": 84.2216
        },
        {
          "Area": "Durg",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.3917,
          "Long": 81.4813
        },
        {
          "Area": "Durgacherra",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.9923,
          "Long": 91.6205
        },
        {
          "Area": "Durgamandop",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3484,
          "Long": 88.8997
        },
        {
          "Area": "Durgapur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.2028,
          "Long": 88.5958
        },
        {
          "Area": "Durgapur",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.9225,
          "Long": 91.6031
        },
        {
          "Area": "Durgapur Mc",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.2028,
          "Long": 87.9815
        },
        {
          "Area": "Durgapur Municipal Corporation",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.2028,
          "Long": 87.9815
        },
        {
          "Area": "Durgawati",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.2129,
          "Long": 83.5671
        },
        {
          "Area": "Durgi",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.44,
          "Long": 79.6458
        },
        {
          "Area": "Duria",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4143,
          "Long": 87.267
        },
        {
          "Area": "Durmuth",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.2758,
          "Long": 88.831
        },
        {
          "Area": "Duthalur",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.004,
          "Long": 79.9691
        },
        {
          "Area": "Duttapara",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.1454,
          "Long": 88.6128
        },
        {
          "Area": "Duvvur",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.0891,
          "Long": 79.8575
        },
        {
          "Area": "Dwarahat",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.8511,
          "Long": 79.4896
        },
        {
          "Area": "Dwarakatirumala",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.9543,
          "Long": 81.2558
        },
        {
          "Area": "Dwarikapur",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.9225,
          "Long": 91.6031
        },
        {
          "Area": "Dwarikjungle",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3484,
          "Long": 88.8997
        },
        {
          "Area": "E. Lungdar",
          "State": "Mizoram",
          "CountryCode": "IN",
          "Lat": 23.2811,
          "Long": 92.8494
        },
        {
          "Area": "East Bishnupur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.1406,
          "Long": 88.5427
        },
        {
          "Area": "East Champaran",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.5431,
          "Long": 84.9441
        },
        {
          "Area": "East Delhi",
          "State": "Delhi",
          "CountryCode": "IN",
          "Lat": 28.6866,
          "Long": 77.2982
        },
        {
          "Area": "East District",
          "State": "Sikkim",
          "CountryCode": "IN",
          "Lat": 27.3417,
          "Long": 88.7553
        },
        {
          "Area": "East Huruah",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0447,
          "Long": 91.7553
        },
        {
          "Area": "East Lungdar (Part)",
          "State": "Mizoram",
          "CountryCode": "IN",
          "Lat": 23.4434,
          "Long": 93.1214
        },
        {
          "Area": "East Singhbhum",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 23.6576,
          "Long": 86.7861
        },
        {
          "Area": "Edappadi",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.6533,
          "Long": 77.9079
        },
        {
          "Area": "Edlapadu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.1823,
          "Long": 80.2754
        },
        {
          "Area": "Edlapdu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.1469,
          "Long": 80.2312
        },
        {
          "Area": "Egmore Nungambakka",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 13.0717,
          "Long": 80.2556
        },
        {
          "Area": "Egmore Nungambakkam",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 13.1141,
          "Long": 80.2947
        },
        {
          "Area": "Egmore Nungambakkm",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 13.07,
          "Long": 80.2408
        },
        {
          "Area": "Egra",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.8995,
          "Long": 87.5379
        },
        {
          "Area": "Ekangarsarai",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.2385,
          "Long": 85.277
        },
        {
          "Area": "Ekangersarai",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.2773,
          "Long": 85.4559
        },
        {
          "Area": "Ekarukhi",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3564,
          "Long": 87.8021
        },
        {
          "Area": "Ekma",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.9922,
          "Long": 84.6063
        },
        {
          "Area": "Ellamanchili (mdl)",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.8946,
          "Long": 81.4023
        },
        {
          "Area": "Ellanthakunta",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.5497,
          "Long": 79.2409
        },
        {
          "Area": "Ellanthkunta",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.3978,
          "Long": 78.977
        },
        {
          "Area": "Eluru",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.8946,
          "Long": 81.4023
        },
        {
          "Area": "Emani",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.3131,
          "Long": 80.5147
        },
        {
          "Area": "English Bazar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.9293,
          "Long": 87.9576
        },
        {
          "Area": "Englishbazar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.4076,
          "Long": 88.1253
        },
        {
          "Area": "Enkoor",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.2368,
          "Long": 80.8769
        },
        {
          "Area": "Eojnagar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.7371,
          "Long": 88.7422
        },
        {
          "Area": "Eranad",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 11.178,
          "Long": 75.8689
        },
        {
          "Area": "Erandol",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.9351,
          "Long": 75.4042
        },
        {
          "Area": "Erenda",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.8995,
          "Long": 87.5379
        },
        {
          "Area": "Ernad",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 11.6978,
          "Long": 76.3221
        },
        {
          "Area": "Ernakulam",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 10.2263,
          "Long": 76.4759
        },
        {
          "Area": "Erode",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.7011,
          "Long": 78.3003
        },
        {
          "Area": "Erragondapalem",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.6213,
          "Long": 79.5158
        },
        {
          "Area": "Ersama",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.7516,
          "Long": 86.4077
        },
        {
          "Area": "Esagarh",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 25.0777,
          "Long": 77.9784
        },
        {
          "Area": "Etah",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.7274,
          "Long": 79.2381
        },
        {
          "Area": "Etapalli",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.7689,
          "Long": 80.2537
        },
        {
          "Area": "Etawah",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.3061,
          "Long": 79.2804
        },
        {
          "Area": "Etcherla",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.4949,
          "Long": 83.9012
        },
        {
          "Area": "Etcherla Mandal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.5786,
          "Long": 83.9881
        },
        {
          "Area": "Etdmadpur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.2544,
          "Long": 78.2309
        },
        {
          "Area": "Etmadpur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.5239,
          "Long": 78.4442
        },
        {
          "Area": "Ettaiyapuram",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 9.3266,
          "Long": 78.1336
        },
        {
          "Area": "Ettapalli",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.8511,
          "Long": 80.4217
        },
        {
          "Area": "Ettayapuram",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 9.7368,
          "Long": 78.1811
        },
        {
          "Area": "Eturnagaram",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.1967,
          "Long": 79.664
        },
        {
          "Area": "Eturunagaram",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.573,
          "Long": 80.4339
        },
        {
          "Area": "Fahimabad",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5442,
          "Long": 80.1097
        },
        {
          "Area": "Faizabad",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.8037,
          "Long": 82.4545
        },
        {
          "Area": "Falakata",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.6605,
          "Long": 89.2102
        },
        {
          "Area": "Falta",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3252,
          "Long": 88.2837
        },
        {
          "Area": "Farakka",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.8167,
          "Long": 88.5022
        },
        {
          "Area": "Farenda",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.2137,
          "Long": 83.5333
        },
        {
          "Area": "Faridabad",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.4873,
          "Long": 77.4094
        },
        {
          "Area": "Faridkot",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 30.7884,
          "Long": 74.9343
        },
        {
          "Area": "Faridpur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.7234,
          "Long": 79.8632
        },
        {
          "Area": "Faridpur Durgapur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.2028,
          "Long": 87.9815
        },
        {
          "Area": "Farooqnagar",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.2233,
          "Long": 78.485
        },
        {
          "Area": "Farooqnqgar",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.0272,
          "Long": 78.1
        },
        {
          "Area": "Farrashkhana",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5442,
          "Long": 80.1097
        },
        {
          "Area": "Farrukh Nagar",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.4616,
          "Long": 76.8708
        },
        {
          "Area": "Farrukhabad",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.7424,
          "Long": 80.807
        },
        {
          "Area": "Fatahabad",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.0564,
          "Long": 78.0946
        },
        {
          "Area": "Fateh Garh Sahib",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 30.5642,
          "Long": 76.172
        },
        {
          "Area": "Fateh Pur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.3035,
          "Long": 81.3274
        },
        {
          "Area": "Fatehabad",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.143,
          "Long": 78.4059
        },
        {
          "Area": "Fatehabad",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.5927,
          "Long": 75.7761
        },
        {
          "Area": "Fatehgargh Sahib",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 30.6562,
          "Long": 76.528
        },
        {
          "Area": "Fatehgarh",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.4659,
          "Long": 71.7701
        },
        {
          "Area": "Fatehgarh Sahib",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 30.6432,
          "Long": 76.6159
        },
        {
          "Area": "Fatehgarhsahib",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 30.6608,
          "Long": 76.2874
        },
        {
          "Area": "Fatehpur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.0072,
          "Long": 85.3039
        },
        {
          "Area": "Fatehpur",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.1088,
          "Long": 76.3177
        },
        {
          "Area": "Fatehpur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.2563,
          "Long": 81.4626
        },
        {
          "Area": "Fatehpur",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 28.186,
          "Long": 76.2846
        },
        {
          "Area": "Fatehpur Block",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.7016,
          "Long": 85.0001
        },
        {
          "Area": "Fatehpur Rajputan",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.6578,
          "Long": 75.0471
        },
        {
          "Area": "Fatehpur Roshnai",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5127,
          "Long": 80.5703
        },
        {
          "Area": "Fatehpur Shekhawati",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 28.1636,
          "Long": 76.2846
        },
        {
          "Area": "Fatehpur(T)",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.1262,
          "Long": 76.3224
        },
        {
          "Area": "Fatepura",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 24.3366,
          "Long": 74.0967
        },
        {
          "Area": "Fatikcherra",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0447,
          "Long": 91.7553
        },
        {
          "Area": "Fatikroy",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0447,
          "Long": 91.7553
        },
        {
          "Area": "Fatwa",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.5204,
          "Long": 85.2358
        },
        {
          "Area": "Fatwah",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.5237,
          "Long": 85.2943
        },
        {
          "Area": "Fazalganj",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.0884,
          "Long": 81.7153
        },
        {
          "Area": "Fazilka",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 30.9918,
          "Long": 74.7949
        },
        {
          "Area": "Fekamari",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.0672,
          "Long": 90.511
        },
        {
          "Area": "Feroeepur",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 30.8414,
          "Long": 74.8963
        },
        {
          "Area": "Ferozepur",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.0255,
          "Long": 74.9651
        },
        {
          "Area": "Ferozepur Jhirka",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.3681,
          "Long": 76.9408
        },
        {
          "Area": "Ferozpeur",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 30.9962,
          "Long": 74.8793
        },
        {
          "Area": "Ferozpur",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 30.9951,
          "Long": 74.6612
        },
        {
          "Area": "Ferrargunj",
          "State": "Andaman & Nicobar Islands",
          "CountryCode": "IN",
          "Lat": 11.7167,
          "Long": 92.7333
        },
        {
          "Area": "Fetehabad",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.0118,
          "Long": 78.0474
        },
        {
          "Area": "Fharenda",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.1454,
          "Long": 83.2762
        },
        {
          "Area": "Fikhana",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.3888,
          "Long": 81.8697
        },
        {
          "Area": "Filkhana",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5442,
          "Long": 80.1097
        },
        {
          "Area": "Fingapara",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8347,
          "Long": 88.4655
        },
        {
          "Area": "Firozabad",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.3685,
          "Long": 79.204
        },
        {
          "Area": "Firozbaad",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.337,
          "Long": 78.3438
        },
        {
          "Area": "Firozepur",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.0619,
          "Long": 74.8477
        },
        {
          "Area": "Firozpur",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 30.9814,
          "Long": 74.8097
        },
        {
          "Area": "Fort Songadh",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 21.7084,
          "Long": 73.5759
        },
        {
          "Area": "Fridpur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.4494,
          "Long": 79.4223
        },
        {
          "Area": "Frisal",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.9563,
          "Long": 74.834
        },
        {
          "Area": "Fulbari",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1597,
          "Long": 92.0329
        },
        {
          "Area": "Fulbari",
          "State": "Meghalaya",
          "CountryCode": "IN",
          "Lat": 25.7466,
          "Long": 90.3804
        },
        {
          "Area": "Fuleswar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.2758,
          "Long": 88.831
        },
        {
          "Area": "Fulgeria",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3029,
          "Long": 87.818
        },
        {
          "Area": "Fulldumar",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.0352,
          "Long": 85.8641
        },
        {
          "Area": "Fullidumar",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.0352,
          "Long": 86.8409
        },
        {
          "Area": "Fultala",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.1383,
          "Long": 88.2387
        },
        {
          "Area": "Fultali",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0789,
          "Long": 91.8987
        },
        {
          "Area": "G B nagar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.4373,
          "Long": 77.5392
        },
        {
          "Area": "G K Veedhi",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.8265,
          "Long": 82.29
        },
        {
          "Area": "G T Road",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5167,
          "Long": 80.3155
        },
        {
          "Area": "G Udayagiri",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.3543,
          "Long": 84.4515
        },
        {
          "Area": "G.ghati",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.227,
          "Long": 87.7217
        },
        {
          "Area": "G.k.palle",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.3753,
          "Long": 79.0143
        },
        {
          "Area": "G.madugula",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.0789,
          "Long": 82.4405
        },
        {
          "Area": "G.mills",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.7944,
          "Long": 85.0966
        },
        {
          "Area": "G.sigadam Mandal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.386,
          "Long": 83.7677
        },
        {
          "Area": "G.udayagiri",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.3543,
          "Long": 84.4515
        },
        {
          "Area": "GP Village  Deori",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 20.9769,
          "Long": 82.5287
        },
        {
          "Area": "GP Village Bhotha",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 20.9289,
          "Long": 82.3829
        },
        {
          "Area": "GP Village Hathibahra",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 20.9574,
          "Long": 82.3477
        },
        {
          "Area": "GP Village Khatti",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.0509,
          "Long": 82.1786
        },
        {
          "Area": "GP Village Komakhan of  Mahasa",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 20.9718,
          "Long": 82.4578
        },
        {
          "Area": "GP Village Salhebhata",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 20.9522,
          "Long": 82.5393
        },
        {
          "Area": "GP Village of Kaskera",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 20.958,
          "Long": 82.4217
        },
        {
          "Area": "GP Village of Narra",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 20.9096,
          "Long": 82.4833
        },
        {
          "Area": "Gadag",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.7022,
          "Long": 75.8327
        },
        {
          "Area": "Gadarpur",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.0631,
          "Long": 79.8242
        },
        {
          "Area": "Gadarwara",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.1618,
          "Long": 79.1292
        },
        {
          "Area": "Gadchiroli",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.3231,
          "Long": 80.2411
        },
        {
          "Area": "Gadhada",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.9013,
          "Long": 72.5226
        },
        {
          "Area": "Gadhada Sn",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.9013,
          "Long": 73.0371
        },
        {
          "Area": "Gadhinglaj",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 18.1182,
          "Long": 75.9769
        },
        {
          "Area": "Gadivemula",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.6966,
          "Long": 78.41
        },
        {
          "Area": "Gadpukuria",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8889,
          "Long": 88.4146
        },
        {
          "Area": "Gadra Road",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.0873,
          "Long": 71.4733
        },
        {
          "Area": "Gadwal",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 16.7275,
          "Long": 78.2037
        },
        {
          "Area": "Gaganbavada",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.2219,
          "Long": 74.1598
        },
        {
          "Area": "Gaganeswar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4364,
          "Long": 87.9624
        },
        {
          "Area": "Gahtagaon",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.2532,
          "Long": 85.5332
        },
        {
          "Area": "Gaighata",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.3901,
          "Long": 88.7336
        },
        {
          "Area": "Gairain",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.4953,
          "Long": 79.5787
        },
        {
          "Area": "Gairatganj",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.5143,
          "Long": 78.45
        },
        {
          "Area": "Gairsain",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.6542,
          "Long": 79.9409
        },
        {
          "Area": "Gaisain",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.4953,
          "Long": 79.5787
        },
        {
          "Area": "Gaisilet",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.0911,
          "Long": 83.4525
        },
        {
          "Area": "Gaita",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8223,
          "Long": 87.5059
        },
        {
          "Area": "Gajapathinagaram",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.3921,
          "Long": 83.3717
        },
        {
          "Area": "Gajja",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.4374,
          "Long": 78.7833
        },
        {
          "Area": "Gajol",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.4986,
          "Long": 88.1936
        },
        {
          "Area": "Gajol.",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3409,
          "Long": 87.9885
        },
        {
          "Area": "Gajsinghpur",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 29.9433,
          "Long": 74.1837
        },
        {
          "Area": "Gajsinghpura",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 29.7739,
          "Long": 73.8479
        },
        {
          "Area": "Gajsingpur",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 29.6596,
          "Long": 73.4403
        },
        {
          "Area": "Gajuwaka",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.7878,
          "Long": 83.2176
        },
        {
          "Area": "Gakulbari",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0796,
          "Long": 91.5997
        },
        {
          "Area": "Gakulnagar",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0447,
          "Long": 91.7553
        },
        {
          "Area": "Gakulpur",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.4955,
          "Long": 91.3298
        },
        {
          "Area": "Galiveedu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.4599,
          "Long": 78.7836
        },
        {
          "Area": "Galleria Dlf-iv",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.418,
          "Long": 76.9839
        },
        {
          "Area": "Galsi",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.0652,
          "Long": 88.2157
        },
        {
          "Area": "Galsi - I",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.0652,
          "Long": 87.9525
        },
        {
          "Area": "Galsi - II",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.0652,
          "Long": 87.9058
        },
        {
          "Area": "Gamaharia",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.1198,
          "Long": 86.6906
        },
        {
          "Area": "Gamahria",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.9584,
          "Long": 86.6026
        },
        {
          "Area": "Gambhiraopet",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.5497,
          "Long": 79.2409
        },
        {
          "Area": "Gamgavathi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.1414,
          "Long": 75.8404
        },
        {
          "Area": "Gamgavati",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.5617,
          "Long": 76.2219
        },
        {
          "Area": "Gamgavatjhi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.2798,
          "Long": 75.9707
        },
        {
          "Area": "Gamharia",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 22.8517,
          "Long": 86.1034
        },
        {
          "Area": "Gamharia",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.9584,
          "Long": 86.6026
        },
        {
          "Area": "Gampalagudem",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.0717,
          "Long": 80.5619
        },
        {
          "Area": "Gamplagudem",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.972,
          "Long": 80.5306
        },
        {
          "Area": "Gamplaguedem",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.5627,
          "Long": 80.8006
        },
        {
          "Area": "Ganagavati",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.4302,
          "Long": 76.4869
        },
        {
          "Area": "Ganapavaram Mandal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.8946,
          "Long": 81.55
        },
        {
          "Area": "Ganapavaram Mandalam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.5283,
          "Long": 82.307
        },
        {
          "Area": "Ganapavaramandalam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.532,
          "Long": 81.1664
        },
        {
          "Area": "Ganapavaramm Andalam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.7497,
          "Long": 81.533
        },
        {
          "Area": "Ganapavarammandal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.532,
          "Long": 81.1664
        },
        {
          "Area": "Ganapavarammandalam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.8946,
          "Long": 81.449
        },
        {
          "Area": "Ganasarisa",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4364,
          "Long": 87.9624
        },
        {
          "Area": "Ganaur",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.1547,
          "Long": 77.1122
        },
        {
          "Area": "Gandai Pandaria",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.7042,
          "Long": 81.1659
        },
        {
          "Area": "Gandarvakkottai",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.7706,
          "Long": 79.1203
        },
        {
          "Area": "Gandarvakotai",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.3586,
          "Long": 78.8812
        },
        {
          "Area": "Gandarvakottai",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.7706,
          "Long": 79.1347
        },
        {
          "Area": "Gandavaram",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.6375,
          "Long": 79.9333
        },
        {
          "Area": "Gandepalli",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.3931,
          "Long": 82.2271
        },
        {
          "Area": "Ganderbal",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.2947,
          "Long": 75.2
        },
        {
          "Area": "Gandevi",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.9231,
          "Long": 74.3241
        },
        {
          "Area": "Gandharbapur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5239,
          "Long": 87.8703
        },
        {
          "Area": "Gandhi Nagar",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.9941,
          "Long": 73.063
        },
        {
          "Area": "Gandhia",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3637,
          "Long": 91.3439
        },
        {
          "Area": "Gandhidham",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.6285,
          "Long": 70.4091
        },
        {
          "Area": "Gandhinagar",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.9941,
          "Long": 73.5543
        },
        {
          "Area": "Gandia",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.8667,
          "Long": 85.3048
        },
        {
          "Area": "Gandipalem",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.0598,
          "Long": 79.3549
        },
        {
          "Area": "Gandlapenta",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.1119,
          "Long": 78.3104
        },
        {
          "Area": "Ganga Ganj",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.4731,
          "Long": 80.2407
        },
        {
          "Area": "Gangadevi",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.3249,
          "Long": 87.9524
        },
        {
          "Area": "Gangadhara",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.6519,
          "Long": 79.1593
        },
        {
          "Area": "Gangadhara Nellore",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 13.2651,
          "Long": 79.2876
        },
        {
          "Area": "Gangadharchak",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3444,
          "Long": 87.9089
        },
        {
          "Area": "Gangajalghati",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.4756,
          "Long": 87.7217
        },
        {
          "Area": "Gangakhed",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.1599,
          "Long": 76.9343
        },
        {
          "Area": "Ganganagar",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0447,
          "Long": 91.8544
        },
        {
          "Area": "Gangapur",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.7092,
          "Long": 76.9349
        },
        {
          "Area": "Gangapur",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.7418,
          "Long": 76.4428
        },
        {
          "Area": "Gangarampur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.4547,
          "Long": 88.7459
        },
        {
          "Area": "Gangavahi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.1456,
          "Long": 75.3724
        },
        {
          "Area": "Gangavalli",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.7723,
          "Long": 78.7453
        },
        {
          "Area": "Gangavaram",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.5198,
          "Long": 82.3928
        },
        {
          "Area": "Gangavathi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.7254,
          "Long": 76.6595
        },
        {
          "Area": "Gangavati",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.7254,
          "Long": 76.6013
        },
        {
          "Area": "Gangavthi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.4446,
          "Long": 76.1393
        },
        {
          "Area": "Gangawati",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.7254,
          "Long": 76.6013
        },
        {
          "Area": "Gangoh",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 29.8365,
          "Long": 77.3001
        },
        {
          "Area": "Gangolihat",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.1119,
          "Long": 80.3477
        },
        {
          "Area": "Gangotri",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.9959,
          "Long": 78.9432
        },
        {
          "Area": "Gangpur",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.5938,
          "Long": 76.9009
        },
        {
          "Area": "Gangrar",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.1329,
          "Long": 74.71
        },
        {
          "Area": "Gangtok",
          "State": "Sikkim",
          "CountryCode": "IN",
          "Lat": 27.3801,
          "Long": 88.8198
        },
        {
          "Area": "Ganguvada Sigadam Mandal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.3787,
          "Long": 83.6817
        },
        {
          "Area": "Gangvathi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.5617,
          "Long": 76.2219
        },
        {
          "Area": "Ganiar",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.2242,
          "Long": 76.5554
        },
        {
          "Area": "Ganiyari",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 22.259,
          "Long": 82.0921
        },
        {
          "Area": "Ganki",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0796,
          "Long": 91.5997
        },
        {
          "Area": "Gannavaram",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.5409,
          "Long": 80.8021
        },
        {
          "Area": "Ganrapota",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.1333,
          "Long": 88.8193
        },
        {
          "Area": "Ganti",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.5719,
          "Long": 88.394
        },
        {
          "Area": "Gantyada",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.4673,
          "Long": 83.4121
        },
        {
          "Area": "Ganwan",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.6424,
          "Long": 85.9342
        },
        {
          "Area": "Gara",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.3545,
          "Long": 84.0687
        },
        {
          "Area": "Gara Mandal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.3756,
          "Long": 83.9846
        },
        {
          "Area": "Garabandha",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 19.8979,
          "Long": 84.1607
        },
        {
          "Area": "Garadpur",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.5531,
          "Long": 86.6097
        },
        {
          "Area": "Garakupi",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.5873,
          "Long": 88.8059
        },
        {
          "Area": "Garautha",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.77,
          "Long": 79.3483
        },
        {
          "Area": "Garbada",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.7468,
          "Long": 74.312
        },
        {
          "Area": "Garchirampara",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.9923,
          "Long": 91.6205
        },
        {
          "Area": "Garend",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.9245,
          "Long": 74.6725
        },
        {
          "Area": "Garh Haripur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.9467,
          "Long": 87.4938
        },
        {
          "Area": "Garh Nokha",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.1655,
          "Long": 84.203
        },
        {
          "Area": "Garh Radhanagar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3564,
          "Long": 87.8021
        },
        {
          "Area": "Garh-monoharpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3836,
          "Long": 87.8747
        },
        {
          "Area": "Garhakota",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.2167,
          "Long": 79.6019
        },
        {
          "Area": "Garhani",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.4809,
          "Long": 84.5787
        },
        {
          "Area": "Garhbeta",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4586,
          "Long": 87.7745
        },
        {
          "Area": "Garhbeta-I",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5946,
          "Long": 87.8149
        },
        {
          "Area": "Garhbeta-II",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5946,
          "Long": 87.7745
        },
        {
          "Area": "Garhbeta-III",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.9317,
          "Long": 88.1806
        },
        {
          "Area": "Garheta",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4586,
          "Long": 87.7745
        },
        {
          "Area": "Garhi",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.1596,
          "Long": 76.2642
        },
        {
          "Area": "Garhi Bolni",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.3196,
          "Long": 76.611
        },
        {
          "Area": "Garhi Harsaru",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.4655,
          "Long": 76.9395
        },
        {
          "Area": "Garhmukteshwer",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.7276,
          "Long": 78.1723
        },
        {
          "Area": "Garhshankar",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.5497,
          "Long": 76.2175
        },
        {
          "Area": "Garhwa",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.4797,
          "Long": 83.9125
        },
        {
          "Area": "Garia",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.0208,
          "Long": 87.7744
        },
        {
          "Area": "Gariaband",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.0713,
          "Long": 82.5903
        },
        {
          "Area": "Gariand",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 20.7467,
          "Long": 82.1212
        },
        {
          "Area": "Garividi",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.4673,
          "Long": 83.5157
        },
        {
          "Area": "Gariyadhar",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.1061,
          "Long": 73.0371
        },
        {
          "Area": "Garjaipur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.206,
          "Long": 86.5939
        },
        {
          "Area": "Garjee",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.4668,
          "Long": 91.4007
        },
        {
          "Area": "Garkha",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.9335,
          "Long": 84.9852
        },
        {
          "Area": "Garla",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.5969,
          "Long": 80.6873
        },
        {
          "Area": "Garladinna",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.8711,
          "Long": 77.962
        },
        {
          "Area": "Garladinne",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.9265,
          "Long": 77.9434
        },
        {
          "Area": "Garobadha",
          "State": "Meghalaya",
          "CountryCode": "IN",
          "Lat": 25.5732,
          "Long": 90.0018
        },
        {
          "Area": "Garoth",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.3491,
          "Long": 75.7238
        },
        {
          "Area": "Garubathan I",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.725,
          "Long": 88.7436
        },
        {
          "Area": "Garugubilli",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.7488,
          "Long": 83.6056
        },
        {
          "Area": "Garulia",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8211,
          "Long": 88.3744
        },
        {
          "Area": "Garunda",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.5061,
          "Long": 76.9992
        },
        {
          "Area": "Garur",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.9911,
          "Long": 79.8596
        },
        {
          "Area": "Gauraiganj",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.2769,
          "Long": 81.7728
        },
        {
          "Area": "Gauribidanur",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.7233,
          "Long": 78.2177
        },
        {
          "Area": "Gauribidanure",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.6904,
          "Long": 77.1411
        },
        {
          "Area": "Gauribidnur",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.6904,
          "Long": 77.1411
        },
        {
          "Area": "Gauriganj",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.4084,
          "Long": 82.0201
        },
        {
          "Area": "Gaurihar",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 25.2701,
          "Long": 80.1963
        },
        {
          "Area": "Gaurobidanur",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.2001,
          "Long": 77.819
        },
        {
          "Area": "Gautam Buddha Nagar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.5408,
          "Long": 77.7205
        },
        {
          "Area": "Gautam Budh Nagar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.4793,
          "Long": 77.5734
        },
        {
          "Area": "Gautham Buddha Nagar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.5408,
          "Long": 77.7205
        },
        {
          "Area": "Gaya",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.5218,
          "Long": 86.0699
        },
        {
          "Area": "Gayatri Seedh Peeth Khadeshar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.1628,
          "Long": 80.5482
        },
        {
          "Area": "Gayzing",
          "State": "Sikkim",
          "CountryCode": "IN",
          "Lat": 27.2836,
          "Long": 88.2709
        },
        {
          "Area": "Gazipur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.3805,
          "Long": 80.2158
        },
        {
          "Area": "Gazipur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.1364,
          "Long": 88.771
        },
        {
          "Area": "Gazole",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.5657,
          "Long": 88.3296
        },
        {
          "Area": "Geegugonda",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.7277,
          "Long": 79.1172
        },
        {
          "Area": "Geesugonda",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.7277,
          "Long": 79.7992
        },
        {
          "Area": "Geesugonda Mandal",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.1427,
          "Long": 79.4385
        },
        {
          "Area": "Geesungonda Mandal",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.1427,
          "Long": 79.4385
        },
        {
          "Area": "Georai",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.8235,
          "Long": 77.3476
        },
        {
          "Area": "Gerua",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.4211,
          "Long": 91.7374
        },
        {
          "Area": "Geruapara",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.5736,
          "Long": 91.3017
        },
        {
          "Area": "Gerukamukh",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.6746,
          "Long": 92.7955
        },
        {
          "Area": "Gevrai",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.8235,
          "Long": 77.3476
        },
        {
          "Area": "Ggesugonda",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.8712,
          "Long": 79.7689
        },
        {
          "Area": "Ghanpur (Station)",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.9456,
          "Long": 79.4455
        },
        {
          "Area": "Ghanpur (mulug)",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.3,
          "Long": 79.9333
        },
        {
          "Area": "Ghanpur Station",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.9552,
          "Long": 79.7992
        },
        {
          "Area": "Ghanpur Stn",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.9564,
          "Long": 79.5386
        },
        {
          "Area": "Ghanpur(m)",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.8501,
          "Long": 79.9322
        },
        {
          "Area": "Ghanpur(mulug)",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.2969,
          "Long": 78.6865
        },
        {
          "Area": "Ghansali",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.5562,
          "Long": 78.997
        },
        {
          "Area": "Ghansali **",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.0116,
          "Long": 78.7659
        },
        {
          "Area": "Ghansawangi",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.6633,
          "Long": 76.3381
        },
        {
          "Area": "Ghansire",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.6245,
          "Long": 79.9514
        },
        {
          "Area": "Ghanslai",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.3226,
          "Long": 78.6089
        },
        {
          "Area": "Ghansore",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.8064,
          "Long": 80.1821
        },
        {
          "Area": "Ghantapada",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.6468,
          "Long": 85.0665
        },
        {
          "Area": "Ghantasala",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.8724,
          "Long": 82.8737
        },
        {
          "Area": "Ghanwangi",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.6549,
          "Long": 76.123
        },
        {
          "Area": "Gharghoda",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 22.1796,
          "Long": 83.3308
        },
        {
          "Area": "Gharsana",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 28.4771,
          "Long": 74.1443
        },
        {
          "Area": "Gharudna",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.5578,
          "Long": 76.9289
        },
        {
          "Area": "Gharunda",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.6875,
          "Long": 77.0914
        },
        {
          "Area": "Ghat",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.4953,
          "Long": 79.6221
        },
        {
          "Area": "Ghat Koshamba",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.2652,
          "Long": 85.2794
        },
        {
          "Area": "Ghat Kushambha",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.2137,
          "Long": 85.8336
        },
        {
          "Area": "Ghatagaon",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.7293,
          "Long": 86.481
        },
        {
          "Area": "Ghatal",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.2438,
          "Long": 88.6725
        },
        {
          "Area": "Ghatampur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.8318,
          "Long": 80.168
        },
        {
          "Area": "Ghatanji",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.2383,
          "Long": 78.5353
        },
        {
          "Area": "Ghatbour",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.0762,
          "Long": 88.8272
        },
        {
          "Area": "Ghateswar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.2052,
          "Long": 88.2369
        },
        {
          "Area": "Ghathashi",
          "State": "Nagaland",
          "CountryCode": "IN",
          "Lat": 26.0213,
          "Long": 94.528
        },
        {
          "Area": "Ghatihara",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3687,
          "Long": 88.562
        },
        {
          "Area": "Ghatiya",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.4977,
          "Long": 77.1461
        },
        {
          "Area": "Ghatkesar",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.695,
          "Long": 79.0645
        },
        {
          "Area": "Ghatkeshambha",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.1855,
          "Long": 85.941
        },
        {
          "Area": "Ghatkusumbha",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.2652,
          "Long": 85.2794
        },
        {
          "Area": "Ghatpatila",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5022,
          "Long": 88.5404
        },
        {
          "Area": "Ghatshila",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 23.5392,
          "Long": 86.7596
        },
        {
          "Area": "Ghatsila",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 23.5392,
          "Long": 86.7596
        },
        {
          "Area": "Ghattia",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.6815,
          "Long": 77.1461
        },
        {
          "Area": "Ghatua Purusottampur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.5163,
          "Long": 87.8093
        },
        {
          "Area": "Ghaziabad",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.8595,
          "Long": 78.4417
        },
        {
          "Area": "Ghazipur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.8916,
          "Long": 83.9277
        },
        {
          "Area": "Ghazipur Sadar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.8916,
          "Long": 83.327
        },
        {
          "Area": "Ghilamara",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.3097,
          "Long": 94.4632
        },
        {
          "Area": "Ghilamara`",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.3097,
          "Long": 94.4632
        },
        {
          "Area": "Ghilatali",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.9225,
          "Long": 91.6031
        },
        {
          "Area": "Ghiyanagar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.6107,
          "Long": 81.9876
        },
        {
          "Area": "Ghnapur Mulug",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.1951,
          "Long": 79.6402
        },
        {
          "Area": "Ghoghamba",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.6395,
          "Long": 73.8356
        },
        {
          "Area": "Ghoghardiha",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.3883,
          "Long": 86.4059
        },
        {
          "Area": "Ghoghmba",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.3578,
          "Long": 73.6641
        },
        {
          "Area": "Ghograpar",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.4408,
          "Long": 91.8873
        },
        {
          "Area": "Ghona",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.399,
          "Long": 88.0555
        },
        {
          "Area": "Ghoni",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.5455,
          "Long": 88.9366
        },
        {
          "Area": "Ghonza",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5228,
          "Long": 88.1967
        },
        {
          "Area": "Ghoraghata",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4305,
          "Long": 87.4447
        },
        {
          "Area": "Ghoramari",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.7824,
          "Long": 93.7795
        },
        {
          "Area": "Ghorasahan",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.6223,
          "Long": 84.9615
        },
        {
          "Area": "Ghosalbati",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.5455,
          "Long": 88.9366
        },
        {
          "Area": "Ghoshi",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.0969,
          "Long": 83.6087
        },
        {
          "Area": "Ghoshi",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.2635,
          "Long": 85.0892
        },
        {
          "Area": "Ghoshpara",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3687,
          "Long": 88.562
        },
        {
          "Area": "Ghoshpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4653,
          "Long": 88.7803
        },
        {
          "Area": "Ghoshwari",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.4564,
          "Long": 86.0222
        },
        {
          "Area": "Ghosi",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.4722,
          "Long": 83.7341
        },
        {
          "Area": "Ghoswari",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.3694,
          "Long": 85.9533
        },
        {
          "Area": "Ghuamrwin",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.6316,
          "Long": 76.6939
        },
        {
          "Area": "Ghumarwin",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.1874,
          "Long": 77.7153
        },
        {
          "Area": "Giba",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.9911,
          "Long": 94.2295
        },
        {
          "Area": "Giddalur",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.6213,
          "Long": 79.5158
        },
        {
          "Area": "Giddarbaha",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 30.5305,
          "Long": 74.8737
        },
        {
          "Area": "Gidhaur",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.409,
          "Long": 85.1906
        },
        {
          "Area": "Gidhaur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.9085,
          "Long": 86.3587
        },
        {
          "Area": "Gilund",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.6038,
          "Long": 74.3042
        },
        {
          "Area": "Gingee",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 12.485,
          "Long": 79.8235
        },
        {
          "Area": "Gingia",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.7887,
          "Long": 92.965
        },
        {
          "Area": "Gir Somnath",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 21.7402,
          "Long": 70.6908
        },
        {
          "Area": "Gird",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 26.3161,
          "Long": 78.3579
        },
        {
          "Area": "Giriak",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.127,
          "Long": 85.5622
        },
        {
          "Area": "Giridih",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.6429,
          "Long": 86.3617
        },
        {
          "Area": "Girisola",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 19.1623,
          "Long": 84.7109
        },
        {
          "Area": "Girva",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 24.5059,
          "Long": 73.6109
        },
        {
          "Area": "Girwa",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 24.9064,
          "Long": 74.0471
        },
        {
          "Area": "Glgt",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3242,
          "Long": 94.0871
        },
        {
          "Area": "Glt",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.0371,
          "Long": 94.633
        },
        {
          "Area": "Glt.",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.0371,
          "Long": 93.9636
        },
        {
          "Area": "Gmc",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.37,
          "Long": 91.8762
        },
        {
          "Area": "Gmc ( North Gh Circle )",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.1849,
          "Long": 91.6786
        },
        {
          "Area": "Goalbathan",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.1465,
          "Long": 88.1117
        },
        {
          "Area": "Goaldaha",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5239,
          "Long": 87.8703
        },
        {
          "Area": "Goalpara",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.1767,
          "Long": 91.0578
        },
        {
          "Area": "Goalpokhar - I",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.0528,
          "Long": 88.1583
        },
        {
          "Area": "Goalpokhar - II",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.0528,
          "Long": 87.9738
        },
        {
          "Area": "Goalpukher",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.881,
          "Long": 88.1583
        },
        {
          "Area": "Gobardanga",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8774,
          "Long": 88.7548
        },
        {
          "Area": "Gobardhanpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.6856,
          "Long": 88.4668
        },
        {
          "Area": "Gobichettipalayam",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.6378,
          "Long": 78.3003
        },
        {
          "Area": "Gobila",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.6794,
          "Long": 88.7008
        },
        {
          "Area": "Gobindapur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.1406,
          "Long": 88.5427
        },
        {
          "Area": "Gobindapur",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0447,
          "Long": 91.7553
        },
        {
          "Area": "Gobindpur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.811,
          "Long": 85.622
        },
        {
          "Area": "Gobindpur",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 23.5378,
          "Long": 85.9803
        },
        {
          "Area": "Gobindpur",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.4178,
          "Long": 86.0202
        },
        {
          "Area": "Gobra",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.0208,
          "Long": 87.7744
        },
        {
          "Area": "Gobradal",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.4526,
          "Long": 91.3843
        },
        {
          "Area": "Gobrapur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.1308,
          "Long": 88.8143
        },
        {
          "Area": "Godda",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 25.0351,
          "Long": 87.405
        },
        {
          "Area": "Godhan Pur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.555,
          "Long": 83.1705
        },
        {
          "Area": "Godhra",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.3583,
          "Long": 73.801
        },
        {
          "Area": "Gogamukh",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.5777,
          "Long": 94.7778
        },
        {
          "Area": "Gogha",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.7503,
          "Long": 72.9362
        },
        {
          "Area": "Goghat",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.6524,
          "Long": 87.801
        },
        {
          "Area": "Goghat - I",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8434,
          "Long": 87.976
        },
        {
          "Area": "Goghat - II",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.2158,
          "Long": 87.9877
        },
        {
          "Area": "Goghat-1",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.2506,
          "Long": 88.0798
        },
        {
          "Area": "Goghat-i",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3551,
          "Long": 88.2569
        },
        {
          "Area": "Goghat-ii",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.2506,
          "Long": 88.0798
        },
        {
          "Area": "Gogunda",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.8431,
          "Long": 74.5711
        },
        {
          "Area": "Goh",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.2492,
          "Long": 84.6853
        },
        {
          "Area": "Gohad",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5552,
          "Long": 78.9898
        },
        {
          "Area": "Gohana",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.2025,
          "Long": 76.8139
        },
        {
          "Area": "Goharganj",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.6073,
          "Long": 78.2337
        },
        {
          "Area": "Gohpur",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.8818,
          "Long": 93.6156
        },
        {
          "Area": "Goilkera",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 22.5844,
          "Long": 85.4519
        },
        {
          "Area": "Gokak",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 16.3672,
          "Long": 76.2343
        },
        {
          "Area": "Gokalgarh",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.2358,
          "Long": 76.5433
        },
        {
          "Area": "Gokalpur",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.1729,
          "Long": 76.1432
        },
        {
          "Area": "Gokavaram",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.5292,
          "Long": 82.201
        },
        {
          "Area": "Gokinepalli",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.5431,
          "Long": 80.6873
        },
        {
          "Area": "Gokna",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.7371,
          "Long": 88.7422
        },
        {
          "Area": "Gokulpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.7782,
          "Long": 88.8491
        },
        {
          "Area": "Gola",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 23.9125,
          "Long": 85.7883
        },
        {
          "Area": "Gola",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.2909,
          "Long": 83.653
        },
        {
          "Area": "Gola Bazar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.6578,
          "Long": 83.3614
        },
        {
          "Area": "Gola Gokaran Nath",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.1951,
          "Long": 80.9194
        },
        {
          "Area": "Golabari",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.007,
          "Long": 91.6093
        },
        {
          "Area": "Golaghat",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.0371,
          "Long": 94.633
        },
        {
          "Area": "Golakganj",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.2105,
          "Long": 89.864
        },
        {
          "Area": "Golakganj S.o.",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.1512,
          "Long": 89.8416
        },
        {
          "Area": "Golamunda",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.2513,
          "Long": 83.796
        },
        {
          "Area": "Golanthara",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.043,
          "Long": 84.6615
        },
        {
          "Area": "Golconda",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.4207,
          "Long": 78.4699
        },
        {
          "Area": "Goldharpur",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.9923,
          "Long": 91.6205
        },
        {
          "Area": "Golibandha",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.4167,
          "Long": 91.3333
        },
        {
          "Area": "Gollapalli",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.793,
          "Long": 79.2409
        },
        {
          "Area": "Gollaprolu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.3608,
          "Long": 82.344
        },
        {
          "Area": "Golmuri",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 23.0604,
          "Long": 85.9466
        },
        {
          "Area": "Golokganj",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.1512,
          "Long": 89.8416
        },
        {
          "Area": "Golugonda",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.7804,
          "Long": 82.4771
        },
        {
          "Area": "Golwa",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.3043,
          "Long": 77.0492
        },
        {
          "Area": "Gomia",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 23.9106,
          "Long": 85.988
        },
        {
          "Area": "Gomla",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 22.9783,
          "Long": 84.4751
        },
        {
          "Area": "Gomunda",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3836,
          "Long": 87.8747
        },
        {
          "Area": "Gonda",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.3677,
          "Long": 84.038
        },
        {
          "Area": "Gondal",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.2628,
          "Long": 71.0244
        },
        {
          "Area": "Gondia",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.5821,
          "Long": 80.3345
        },
        {
          "Area": "Gondipipri",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.9434,
          "Long": 79.7299
        },
        {
          "Area": "Gondiya",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.5515,
          "Long": 80.203
        },
        {
          "Area": "Gondpipri",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.1822,
          "Long": 79.7401
        },
        {
          "Area": "Gonegandla",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.7137,
          "Long": 77.6393
        },
        {
          "Area": "Goniana Mandi",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 30.3481,
          "Long": 74.8841
        },
        {
          "Area": "Gool Gulab Garh",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.5759,
          "Long": 75.527
        },
        {
          "Area": "Gooty",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.5727,
          "Long": 77.7341
        },
        {
          "Area": "Gop",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.6307,
          "Long": 86.1141
        },
        {
          "Area": "Gopad Vanas",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.4937,
          "Long": 82.2397
        },
        {
          "Area": "Gopadbanas",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.3923,
          "Long": 82.3364
        },
        {
          "Area": "Gopadvanas",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.3923,
          "Long": 81.2935
        },
        {
          "Area": "Gopal Pora",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.0397,
          "Long": 74.7612
        },
        {
          "Area": "Gopal;ganj",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.5694,
          "Long": 85.6398
        },
        {
          "Area": "Gopalapuram Mandal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.9091,
          "Long": 81.4023
        },
        {
          "Area": "Gopalapuram Mandalam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.3717,
          "Long": 81.7422
        },
        {
          "Area": "Gopalchak",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.7787,
          "Long": 87.8341
        },
        {
          "Area": "Gopalgan J",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.3715,
          "Long": 84.9706
        },
        {
          "Area": "Gopalganj",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.6033,
          "Long": 85.6398
        },
        {
          "Area": "Gopalnagar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3578,
          "Long": 88.1922
        },
        {
          "Area": "Gopalnagar",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.9723,
          "Long": 82.3696
        },
        {
          "Area": "Gopalpet",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 16.4935,
          "Long": 78.3415
        },
        {
          "Area": "Gopalpur",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 19.0714,
          "Long": 84.5469
        },
        {
          "Area": "Gopalpur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.4155,
          "Long": 80.2523
        },
        {
          "Area": "Gopalpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.399,
          "Long": 88.0555
        },
        {
          "Area": "Gopalpur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.5139,
          "Long": 87.1925
        },
        {
          "Area": "Gopalthan",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3796,
          "Long": 91.2951
        },
        {
          "Area": "Gopannapalem",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.8863,
          "Long": 81.1466
        },
        {
          "Area": "Gopavaram",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.7841,
          "Long": 79.0843
        },
        {
          "Area": "Gopiballavpur-I",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.5918,
          "Long": 88.5238
        },
        {
          "Area": "Gopiballavpur-II",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.2721,
          "Long": 86.9541
        },
        {
          "Area": "Gopichak",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.8532,
          "Long": 87.9147
        },
        {
          "Area": "Gopikandar",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.4383,
          "Long": 87.5613
        },
        {
          "Area": "Gopikander",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.3197,
          "Long": 87.2666
        },
        {
          "Area": "Goradih",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.1957,
          "Long": 87.1098
        },
        {
          "Area": "Gorakhpur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.057,
          "Long": 83.4488
        },
        {
          "Area": "Gorakhpur Sadar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.8979,
          "Long": 83.5263
        },
        {
          "Area": "Gorantla",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.4811,
          "Long": 78.0086
        },
        {
          "Area": "Goraul",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.9427,
          "Long": 85.3491
        },
        {
          "Area": "Goregaon",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.3728,
          "Long": 80.271
        },
        {
          "Area": "Goregaon East",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.1699,
          "Long": 72.8694
        },
        {
          "Area": "Goregaon West",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.1624,
          "Long": 72.8694
        },
        {
          "Area": "Goreswar Block",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.5311,
          "Long": 92.7973
        },
        {
          "Area": "Goribpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8889,
          "Long": 88.4146
        },
        {
          "Area": "Gorifa",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.907,
          "Long": 88.4133
        },
        {
          "Area": "Goripur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.3249,
          "Long": 87.9524
        },
        {
          "Area": "Goroimari",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.0989,
          "Long": 91.1425
        },
        {
          "Area": "Goroimari Block",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.1314,
          "Long": 91.4625
        },
        {
          "Area": "Goroul",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.9427,
          "Long": 85.434
        },
        {
          "Area": "Gorubathan",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 27.0046,
          "Long": 88.8228
        },
        {
          "Area": "Gosaba",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4711,
          "Long": 88.9111
        },
        {
          "Area": "Gospadu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.7407,
          "Long": 79.9128
        },
        {
          "Area": "Gossaigaon",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.5145,
          "Long": 90.4381
        },
        {
          "Area": "Gotegaon",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.0801,
          "Long": 79.5115
        },
        {
          "Area": "Gothera",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.2955,
          "Long": 76.4283
        },
        {
          "Area": "Gothra",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.1673,
          "Long": 76.4131
        },
        {
          "Area": "Gotra",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.6191,
          "Long": 88.8788
        },
        {
          "Area": "Gotri",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5228,
          "Long": 88.1967
        },
        {
          "Area": "Gouraijore",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.7323,
          "Long": 87.4709
        },
        {
          "Area": "Gouramari",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.0677,
          "Long": 87.9151
        },
        {
          "Area": "Gournagar",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0789,
          "Long": 91.8987
        },
        {
          "Area": "Goutam  Budd  Nagar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.38,
          "Long": 77.5801
        },
        {
          "Area": "Goutam Budd Nagar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.4171,
          "Long": 77.7162
        },
        {
          "Area": "Gouthampur",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.9953,
          "Long": 80.7096
        },
        {
          "Area": "Goverdhan",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.5802,
          "Long": 77.4448
        },
        {
          "Area": "Govind Nagar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5167,
          "Long": 80.3155
        },
        {
          "Area": "Govindaraopet",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.7441,
          "Long": 80.1836
        },
        {
          "Area": "Govindpur",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.5041,
          "Long": 84.4565
        },
        {
          "Area": "Grasim Vihar Rawan",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.5996,
          "Long": 82.0601
        },
        {
          "Area": "Greater Noida",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.5877,
          "Long": 77.8448
        },
        {
          "Area": "Greswar Block",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.486,
          "Long": 92.7973
        },
        {
          "Area": "Grobadha",
          "State": "Meghalaya",
          "CountryCode": "IN",
          "Lat": 25.5732,
          "Long": 90.0018
        },
        {
          "Area": "Gua",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 22.2136,
          "Long": 85.3877
        },
        {
          "Area": "Guakuchi",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.4408,
          "Long": 91.8873
        },
        {
          "Area": "Guarunda",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.4478,
          "Long": 76.9621
        },
        {
          "Area": "Gubbi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.7607,
          "Long": 77.1818
        },
        {
          "Area": "Gudalur",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.5674,
          "Long": 77.1296
        },
        {
          "Area": "Gudamalani",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.7356,
          "Long": 72.5213
        },
        {
          "Area": "Gudamalni",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.1797,
          "Long": 72.5213
        },
        {
          "Area": "Gudari",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 19.508,
          "Long": 83.9042
        },
        {
          "Area": "Gudibanda",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.0288,
          "Long": 77.3088
        },
        {
          "Area": "Gudibanda",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.2141,
          "Long": 78.2177
        },
        {
          "Area": "Gudipala",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 13.3992,
          "Long": 79.1337
        },
        {
          "Area": "Gudivada",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.8797,
          "Long": 81.0471
        },
        {
          "Area": "Gudiyatham",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 13.0015,
          "Long": 79.0104
        },
        {
          "Area": "Gudiyattam",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 13.0911,
          "Long": 79.4095
        },
        {
          "Area": "Gudlavalleru",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.1611,
          "Long": 82.1864
        },
        {
          "Area": "Gudlavallru",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.1611,
          "Long": 82.1864
        },
        {
          "Area": "Gudupalle",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 13.7135,
          "Long": 79.1475
        },
        {
          "Area": "Gudur",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.0648,
          "Long": 79.9494
        },
        {
          "Area": "Gudur",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.4268,
          "Long": 79.9842
        },
        {
          "Area": "Guduru",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.7799,
          "Long": 81.4013
        },
        {
          "Area": "Gugodh",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.3894,
          "Long": 76.5166
        },
        {
          "Area": "Guhagar",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 18.734,
          "Long": 74.5122
        },
        {
          "Area": "Guhla",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 30.1728,
          "Long": 76.4191
        },
        {
          "Area": "Guirdaspur",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.9914,
          "Long": 75.3491
        },
        {
          "Area": "Gujar Majra",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.1297,
          "Long": 76.5558
        },
        {
          "Area": "Gujarwas",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.1729,
          "Long": 76.1432
        },
        {
          "Area": "Gujvail",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.9388,
          "Long": 78.7005
        },
        {
          "Area": "Gujwail",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.713,
          "Long": 78.9669
        },
        {
          "Area": "Gulakpur",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.332,
          "Long": 92.0039
        },
        {
          "Area": "Gulathol",
          "State": "Manipur",
          "CountryCode": "IN",
          "Lat": 24.7381,
          "Long": 93.7279
        },
        {
          "Area": "Gulbarga",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 17.8996,
          "Long": 77.1957
        },
        {
          "Area": "Gulmarg",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.0536,
          "Long": 74.3819
        },
        {
          "Area": "Guma",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8135,
          "Long": 88.6066
        },
        {
          "Area": "Gumagarh",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.4344,
          "Long": 84.3753
        },
        {
          "Area": "Gumgong",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 28.2358,
          "Long": 94.6742
        },
        {
          "Area": "Gumla",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 23.5561,
          "Long": 84.9558
        },
        {
          "Area": "Gummagatta",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.8449,
          "Long": 77.5768
        },
        {
          "Area": "Gummalakshmipuram",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 19.1299,
          "Long": 83.6593
        },
        {
          "Area": "Gummidipoondi",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 13.3974,
          "Long": 80.2467
        },
        {
          "Area": "Gummidipundi",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 13.5258,
          "Long": 80.1985
        },
        {
          "Area": "Gummidipundii",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 13.4274,
          "Long": 80.1388
        },
        {
          "Area": "Gummidpundi",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 13.3974,
          "Long": 79.9891
        },
        {
          "Area": "Gumparlapadu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.7993,
          "Long": 79.7739
        },
        {
          "Area": "Guna",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.9937,
          "Long": 77.6158
        },
        {
          "Area": "Gund",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.1829,
          "Long": 74.7662
        },
        {
          "Area": "Gunderdehi",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.5631,
          "Long": 81.5323
        },
        {
          "Area": "Gundluper",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 11.9369,
          "Long": 76.5934
        },
        {
          "Area": "Gundlupet",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 12.0422,
          "Long": 77.581
        },
        {
          "Area": "Gundugolanu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.7615,
          "Long": 81.2315
        },
        {
          "Area": "Gunga",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.4698,
          "Long": 71.5465
        },
        {
          "Area": "Gunnaur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.3059,
          "Long": 78.5965
        },
        {
          "Area": "Gunnor",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.1963,
          "Long": 79.5935
        },
        {
          "Area": "Gunnour",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.3718,
          "Long": 78.9454
        },
        {
          "Area": "Gunore",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.3059,
          "Long": 80.4007
        },
        {
          "Area": "Guntakal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.1954,
          "Long": 77.9668
        },
        {
          "Area": "Guntur",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.6894,
          "Long": 80.6598
        },
        {
          "Area": "Gunupur",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.7642,
          "Long": 85.5283
        },
        {
          "Area": "Guoour",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.4197,
          "Long": 78.3519
        },
        {
          "Area": "Guptipara",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.2719,
          "Long": 88.1269
        },
        {
          "Area": "Guraora",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.3827,
          "Long": 76.6429
        },
        {
          "Area": "Gurap",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.0354,
          "Long": 88.3005
        },
        {
          "Area": "Guraru",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.0162,
          "Long": 84.936
        },
        {
          "Area": "Gurazalla",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.6395,
          "Long": 79.6844
        },
        {
          "Area": "Gurdaspur",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 32.309,
          "Long": 75.8827
        },
        {
          "Area": "Gurez",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.5906,
          "Long": 74.9701
        },
        {
          "Area": "Gurgaon",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.418,
          "Long": 76.9839
        },
        {
          "Area": "Gurgaon Kty.",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.418,
          "Long": 76.9839
        },
        {
          "Area": "Gurh",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.7552,
          "Long": 81.5896
        },
        {
          "Area": "Gurha",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.1729,
          "Long": 76.1432
        },
        {
          "Area": "Guriani",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.3569,
          "Long": 76.536
        },
        {
          "Area": "Guribidanur",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.1393,
          "Long": 78.2177
        },
        {
          "Area": "Gurla",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.2847,
          "Long": 83.566
        },
        {
          "Area": "Gurramkonda",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.3466,
          "Long": 79.0143
        },
        {
          "Area": "Gurrampode",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 16.8399,
          "Long": 79.1442
        },
        {
          "Area": "Gurua",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.6991,
          "Long": 84.936
        },
        {
          "Area": "Gurugram",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.418,
          "Long": 76.9839
        },
        {
          "Area": "Gurundia",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 22.0798,
          "Long": 84.9625
        },
        {
          "Area": "Gurur",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 20.7788,
          "Long": 81.4689
        },
        {
          "Area": "Guruwa",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.7895,
          "Long": 84.8481
        },
        {
          "Area": "Gurzalla",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.2988,
          "Long": 80.0915
        },
        {
          "Area": "Gushkara",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.7617,
          "Long": 87.9959
        },
        {
          "Area": "Guthani",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.1035,
          "Long": 84.3432
        },
        {
          "Area": "Guwahati",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.2528,
          "Long": 91.5362
        },
        {
          "Area": "Gwalapara",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.5609,
          "Long": 86.6739
        },
        {
          "Area": "Gwalior",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 26.3179,
          "Long": 78.5378
        },
        {
          "Area": "Gwalor",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 25.9795,
          "Long": 77.7756
        },
        {
          "Area": "Gwaltoli",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5442,
          "Long": 80.2158
        },
        {
          "Area": "Gyanpur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.1194,
          "Long": 82.9938
        },
        {
          "Area": "Gyaraspur",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.676,
          "Long": 78.1906
        },
        {
          "Area": "H B Halli",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.8777,
          "Long": 76.387
        },
        {
          "Area": "H Colony",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3294,
          "Long": 87.9528
        },
        {
          "Area": "H D Kote",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 12.937,
          "Long": 76.5136
        },
        {
          "Area": "H Kharagpur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.1882,
          "Long": 86.6168
        },
        {
          "Area": "HALDI",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.8754,
          "Long": 84.1055
        },
        {
          "Area": "Habibpir",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.0677,
          "Long": 87.9151
        },
        {
          "Area": "Habibpuir",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.2576,
          "Long": 87.9852
        },
        {
          "Area": "Habibpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.2576,
          "Long": 87.9852
        },
        {
          "Area": "Habibpur  (arajimistrabati)",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3409,
          "Long": 87.9885
        },
        {
          "Area": "Habibpur (srirampur Anchal)",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.0677,
          "Long": 87.9151
        },
        {
          "Area": "Habra - I",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.1383,
          "Long": 88.8719
        },
        {
          "Area": "Habra - II",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.1383,
          "Long": 88.637
        },
        {
          "Area": "Hadagalli",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.9268,
          "Long": 75.9339
        },
        {
          "Area": "Hadgaon",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.9076,
          "Long": 77.9884
        },
        {
          "Area": "Hadrai",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.007,
          "Long": 91.6093
        },
        {
          "Area": "Hadwara",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.4564,
          "Long": 74.1949
        },
        {
          "Area": "Haflong",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 25.2421,
          "Long": 93.0147
        },
        {
          "Area": "Hagaribommanahalli",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.1895,
          "Long": 76.3726
        },
        {
          "Area": "Haider Garh",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.9626,
          "Long": 81.6393
        },
        {
          "Area": "Haidergarh",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.9386,
          "Long": 81.4163
        },
        {
          "Area": "Hailakandi",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3703,
          "Long": 91.3481
        },
        {
          "Area": "Haillymandi",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.3598,
          "Long": 76.7487
        },
        {
          "Area": "Haipur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5034,
          "Long": 87.9832
        },
        {
          "Area": "Hajipur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.8503,
          "Long": 85.8861
        },
        {
          "Area": "Hajo Block",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3442,
          "Long": 91.7577
        },
        {
          "Area": "Hakimpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.1406,
          "Long": 88.5427
        },
        {
          "Area": "Hal Colony",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5167,
          "Long": 80.3155
        },
        {
          "Area": "Halahali",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0789,
          "Long": 91.8987
        },
        {
          "Area": "Haldharpur S.O",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.0431,
          "Long": 83.6745
        },
        {
          "Area": "Haldia",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8486,
          "Long": 88.0483
        },
        {
          "Area": "Haldia Municipality",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.0907,
          "Long": 88.1375
        },
        {
          "Area": "Haldia Patna",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.63,
          "Long": 87.7168
        },
        {
          "Area": "Haldiamunicipality",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.0758,
          "Long": 88.1375
        },
        {
          "Area": "Haldibari",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.3389,
          "Long": 89.3436
        },
        {
          "Area": "Haldwani",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.4516,
          "Long": 79.704
        },
        {
          "Area": "Halem",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.971,
          "Long": 93.8695
        },
        {
          "Area": "Halflong",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0447,
          "Long": 91.7553
        },
        {
          "Area": "Halhuli",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1959,
          "Long": 91.8344
        },
        {
          "Area": "Halishahar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.9322,
          "Long": 88.4186
        },
        {
          "Area": "Haliyal",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.3286,
          "Long": 74.8009
        },
        {
          "Area": "Halol",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.6395,
          "Long": 73.6641
        },
        {
          "Area": "Halsi",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.1717,
          "Long": 86.1312
        },
        {
          "Area": "Halsidar",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.9509,
          "Long": 75.0932
        },
        {
          "Area": "Haludbari",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5034,
          "Long": 87.9832
        },
        {
          "Area": "Halvad",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.0645,
          "Long": 71.5402
        },
        {
          "Area": "Hamidpur",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.0911,
          "Long": 76.0378
        },
        {
          "Area": "Hamiltonganj",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.5233,
          "Long": 88.9736
        },
        {
          "Area": "Hamirpur",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.6245,
          "Long": 77.7109
        },
        {
          "Area": "Hamirpur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.1956,
          "Long": 80.3281
        },
        {
          "Area": "Hamirpur(T)",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.2065,
          "Long": 77.5705
        },
        {
          "Area": "Hamren",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.1303,
          "Long": 92.8827
        },
        {
          "Area": "Hanamkonda",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.2238,
          "Long": 79.7992
        },
        {
          "Area": "Hanamkonda Mandal",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.0563,
          "Long": 79.7992
        },
        {
          "Area": "Handia",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.7735,
          "Long": 82.3492
        },
        {
          "Area": "Handlarajgarh",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3029,
          "Long": 87.818
        },
        {
          "Area": "Handwara",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.55,
          "Long": 74.4905
        },
        {
          "Area": "Hangal",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.9479,
          "Long": 75.2813
        },
        {
          "Area": "Hangrang",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.8888,
          "Long": 78.6183
        },
        {
          "Area": "Hanhthial",
          "State": "Mizoram",
          "CountryCode": "IN",
          "Lat": 22.9403,
          "Long": 92.9651
        },
        {
          "Area": "Hansi",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.3809,
          "Long": 76.3259
        },
        {
          "Area": "Hanskhali",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.5009,
          "Long": 88.6819
        },
        {
          "Area": "Hanskhlai",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.4597,
          "Long": 88.2516
        },
        {
          "Area": "Hansot",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.4533,
          "Long": 73.3605
        },
        {
          "Area": "Hanumaganj",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.6471,
          "Long": 81.7933
        },
        {
          "Area": "Hanuman Bhagda",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 21.3463,
          "Long": 72.6189
        },
        {
          "Area": "Hanumana",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.7789,
          "Long": 82.2172
        },
        {
          "Area": "Hanumanganj",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.4171,
          "Long": 82.0829
        },
        {
          "Area": "Hanumangarh",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 29.7517,
          "Long": 75.7831
        },
        {
          "Area": "Hanumangarh Jn.",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 28.4738,
          "Long": 75.5476
        },
        {
          "Area": "Hanumangrh",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 28.4738,
          "Long": 75.5476
        },
        {
          "Area": "Hanumannagar",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.702,
          "Long": 86.5762
        },
        {
          "Area": "Hapur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.8768,
          "Long": 78.1723
        },
        {
          "Area": "Harabhanga",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.6496,
          "Long": 84.6247
        },
        {
          "Area": "Harabhnaga",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.6285,
          "Long": 84.6247
        },
        {
          "Area": "Harabhuin",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.6075,
          "Long": 84.6668
        },
        {
          "Area": "Haralpanahalli",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.408,
          "Long": 75.9548
        },
        {
          "Area": "Harapanahalli",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.9013,
          "Long": 76.1729
        },
        {
          "Area": "Harapanahallli",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.408,
          "Long": 75.9548
        },
        {
          "Area": "Harcahkian",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.9371,
          "Long": 76.3229
        },
        {
          "Area": "Harchakian(S.T)",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.0772,
          "Long": 76.1699
        },
        {
          "Area": "Harchand Khera",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.2843,
          "Long": 80.3637
        },
        {
          "Area": "Harda",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.4387,
          "Long": 77.2004
        },
        {
          "Area": "Hardamnagar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.3486,
          "Long": 87.8676
        },
        {
          "Area": "Hardauli",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.2812,
          "Long": 80.327
        },
        {
          "Area": "Hardibazar",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 22.5323,
          "Long": 82.9574
        },
        {
          "Area": "Hardoi",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.7279,
          "Long": 80.4362
        },
        {
          "Area": "Hardudalwan",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.8463,
          "Long": 74.8035
        },
        {
          "Area": "Hardwar",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.9431,
          "Long": 78.1805
        },
        {
          "Area": "Haria",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5034,
          "Long": 87.9832
        },
        {
          "Area": "Hariahra",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.486,
          "Long": 75.7889
        },
        {
          "Area": "Haribhanga",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.536,
          "Long": 91.4097
        },
        {
          "Area": "Haridwar",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.9843,
          "Long": 78.1603
        },
        {
          "Area": "Harihar",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.5408,
          "Long": 75.9548
        },
        {
          "Area": "Harihar Ganj",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.5238,
          "Long": 84.2516
        },
        {
          "Area": "Harihara",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.5129,
          "Long": 75.8084
        },
        {
          "Area": "Hariharganj",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.5238,
          "Long": 84.2516
        },
        {
          "Area": "Hariharpara",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.7341,
          "Long": 88.1155
        },
        {
          "Area": "Harihra",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.4531,
          "Long": 76.264
        },
        {
          "Area": "Harij",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.8205,
          "Long": 73.2181
        },
        {
          "Area": "Harike",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.2132,
          "Long": 74.928
        },
        {
          "Area": "Haringhat",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.4733,
          "Long": 88.7615
        },
        {
          "Area": "Haringhata",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.7107,
          "Long": 88.7615
        },
        {
          "Area": "Haripal",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8465,
          "Long": 88.1925
        },
        {
          "Area": "Haripora",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.9306,
          "Long": 75.1134
        },
        {
          "Area": "Harirampur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.097,
          "Long": 87.9915
        },
        {
          "Area": "Harishchandrapur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.4863,
          "Long": 87.932
        },
        {
          "Area": "Harishchandrapur -ii",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.4471,
          "Long": 87.8601
        },
        {
          "Area": "Harisinga",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.7198,
          "Long": 92.0374
        },
        {
          "Area": "Harjinder Nagar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5167,
          "Long": 80.3155
        },
        {
          "Area": "Harlakhi",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.572,
          "Long": 85.9672
        },
        {
          "Area": "Harlog",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.485,
          "Long": 76.7628
        },
        {
          "Area": "Harnaut",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.4008,
          "Long": 85.6246
        },
        {
          "Area": "Haroa",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.6085,
          "Long": 88.6772
        },
        {
          "Area": "Harodi",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.3496,
          "Long": 80.5221
        },
        {
          "Area": "Haroli",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.0893,
          "Long": 77.2597
        },
        {
          "Area": "Haroli(S.T)",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.0893,
          "Long": 76.3292
        },
        {
          "Area": "Harrai",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.7441,
          "Long": 79.2484
        },
        {
          "Area": "Harraina",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.7405,
          "Long": 82.679
        },
        {
          "Area": "Harraiya",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.0638,
          "Long": 82.8122
        },
        {
          "Area": "Harrraiya",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.6618,
          "Long": 82.8122
        },
        {
          "Area": "Harsidhi",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.4133,
          "Long": 84.8616
        },
        {
          "Area": "Harsud",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.1672,
          "Long": 76.8202
        },
        {
          "Area": "Harur",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 12.2616,
          "Long": 78.7102
        },
        {
          "Area": "Hasadurga",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.6259,
          "Long": 76.2903
        },
        {
          "Area": "Hasanaparthy",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.0813,
          "Long": 79.4992
        },
        {
          "Area": "Hasanparthy",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.1427,
          "Long": 79.7992
        },
        {
          "Area": "Hasanpur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.9054,
          "Long": 78.3725
        },
        {
          "Area": "Hasanpur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.7816,
          "Long": 86.1394
        },
        {
          "Area": "Hasanpura",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.1228,
          "Long": 84.3655
        },
        {
          "Area": "Hasimara",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.7644,
          "Long": 89.3538
        },
        {
          "Area": "Hasnabad",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.286,
          "Long": 88.9325
        },
        {
          "Area": "Hasnparthy",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.0885,
          "Long": 79.5994
        },
        {
          "Area": "Haspura",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.0919,
          "Long": 84.6618
        },
        {
          "Area": "Hassan",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.5247,
          "Long": 76.3552
        },
        {
          "Area": "Hata",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.9704,
          "Long": 83.9349
        },
        {
          "Area": "Hatadihi",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.5371,
          "Long": 85.7358
        },
        {
          "Area": "Hatbaincha",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3159,
          "Long": 88.0212
        },
        {
          "Area": "Hatgachha",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3482,
          "Long": 88.9366
        },
        {
          "Area": "Hatgamaria",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 22.2623,
          "Long": 85.8001
        },
        {
          "Area": "Hatgopalpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3836,
          "Long": 87.8747
        },
        {
          "Area": "Hathband",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.6095,
          "Long": 82.174
        },
        {
          "Area": "Hathin",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.3327,
          "Long": 77.3548
        },
        {
          "Area": "Hathiyawan",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.0973,
          "Long": 85.7917
        },
        {
          "Area": "Hathua",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.2537,
          "Long": 84.3396
        },
        {
          "Area": "Hatia",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5442,
          "Long": 80.1097
        },
        {
          "Area": "Hatiara",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.6028,
          "Long": 88.4493
        },
        {
          "Area": "Hatibari",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.7336,
          "Long": 84.8977
        },
        {
          "Area": "Hatidhura",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.5145,
          "Long": 90.1306
        },
        {
          "Area": "Hatigarh",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.6138,
          "Long": 92.0365
        },
        {
          "Area": "Hatinamati",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3796,
          "Long": 91.2951
        },
        {
          "Area": "Hatinda",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.4192,
          "Long": 87.9739
        },
        {
          "Area": "Hatisala",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4653,
          "Long": 88.7803
        },
        {
          "Area": "Hatkalangada",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 16.9138,
          "Long": 74.4432
        },
        {
          "Area": "Hatkanagale",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 17.8906,
          "Long": 74.5193
        },
        {
          "Area": "Hatkanangale",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.715,
          "Long": 79.0301
        },
        {
          "Area": "Hatkanangle",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.8084,
          "Long": 77.4552
        },
        {
          "Area": "Hatkurulia",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.2147,
          "Long": 88.8863
        },
        {
          "Area": "Hatras",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.5776,
          "Long": 78.1616
        },
        {
          "Area": "Hatta",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.3472,
          "Long": 79.8269
        },
        {
          "Area": "Hatuganj",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.6268,
          "Long": 88.2046
        },
        {
          "Area": "Haveli",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.7398,
          "Long": 77.2028
        },
        {
          "Area": "Haveri",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.9747,
          "Long": 75.7022
        },
        {
          "Area": "Haweli Kharagpur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.2907,
          "Long": 86.6006
        },
        {
          "Area": "Hawelikharagpur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.1667,
          "Long": 86.5614
        },
        {
          "Area": "Hawelikhragpur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.1451,
          "Long": 86.5895
        },
        {
          "Area": "Hayathnagar",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.4661,
          "Long": 78.7099
        },
        {
          "Area": "Hayuliang",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.9799,
          "Long": 96.6724
        },
        {
          "Area": "Hayulinag",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.9799,
          "Long": 96.6724
        },
        {
          "Area": "Hazarapar",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.5735,
          "Long": 91.1499
        },
        {
          "Area": "Hazaribag",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.0869,
          "Long": 85.2116
        },
        {
          "Area": "Hazaribagh",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.7604,
          "Long": 85.7832
        },
        {
          "Area": "Haziragaon",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.7306,
          "Long": 91.5564
        },
        {
          "Area": "Hb Halli",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.288,
          "Long": 77.06
        },
        {
          "Area": "Heggadadevankote",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 12.4492,
          "Long": 76.3001
        },
        {
          "Area": "Helana",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.4167,
          "Long": 91.3333
        },
        {
          "Area": "Hemgir",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 22.0798,
          "Long": 84.5106
        },
        {
          "Area": "Hemgri",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.9971,
          "Long": 83.6058
        },
        {
          "Area": "Hemnagar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.4323,
          "Long": 88.373
        },
        {
          "Area": "Hemtabad",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.6771,
          "Long": 88.2228
        },
        {
          "Area": "Herial",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.9852,
          "Long": 77.5768
        },
        {
          "Area": "Hgatal",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.2275,
          "Long": 87.9256
        },
        {
          "Area": "Hidilatari",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.263,
          "Long": 91.3011
        },
        {
          "Area": "Hili",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.307,
          "Long": 88.1246
        },
        {
          "Area": "Hilli",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.2425,
          "Long": 88.8459
        },
        {
          "Area": "Hilsa",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.3516,
          "Long": 85.4559
        },
        {
          "Area": "Himatanagar",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.1897,
          "Long": 73.1233
        },
        {
          "Area": "Himatnagar",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.8218,
          "Long": 73.3751
        },
        {
          "Area": "Himatnagar.",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.4512,
          "Long": 73.2461
        },
        {
          "Area": "Himayathnagar",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.456,
          "Long": 78.6476
        },
        {
          "Area": "Himayatnagar",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.4192,
          "Long": 77.752
        },
        {
          "Area": "Hindaun",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 27.1539,
          "Long": 77.1919
        },
        {
          "Area": "Hindol",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.8615,
          "Long": 85.4172
        },
        {
          "Area": "Hindoli",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.5849,
          "Long": 75.6526
        },
        {
          "Area": "Hinduan",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.5207,
          "Long": 76.9639
        },
        {
          "Area": "Hindupur",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.3033,
          "Long": 77.8819
        },
        {
          "Area": "Hingalganj",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.4323,
          "Long": 88.9899
        },
        {
          "Area": "Hinganghat",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.2198,
          "Long": 79.1015
        },
        {
          "Area": "Hinganghjat",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.5834,
          "Long": 78.452
        },
        {
          "Area": "Hingli",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.1467,
          "Long": 88.803
        },
        {
          "Area": "Hingna",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.0938,
          "Long": 78.9728
        },
        {
          "Area": "Hingoli",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.9244,
          "Long": 77.3908
        },
        {
          "Area": "Hinjili",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.904,
          "Long": 84.7939
        },
        {
          "Area": "Hinjli",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.904,
          "Long": 84.7939
        },
        {
          "Area": "Hirakud",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.525,
          "Long": 83.8727
        },
        {
          "Area": "Hiramandalam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.7149,
          "Long": 83.9711
        },
        {
          "Area": "Hiramandalam Mandal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.7233,
          "Long": 83.961
        },
        {
          "Area": "Hiranagar",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.6635,
          "Long": 75.5938
        },
        {
          "Area": "Hiranpur",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.7051,
          "Long": 87.762
        },
        {
          "Area": "Hirapur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.0208,
          "Long": 87.7744
        },
        {
          "Area": "Hirbandh",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.0388,
          "Long": 87.5766
        },
        {
          "Area": "Hirekerur",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.7278,
          "Long": 75.6627
        },
        {
          "Area": "Hirekeruru",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.5051,
          "Long": 75.5724
        },
        {
          "Area": "Hirekrur",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.4944,
          "Long": 75.3949
        },
        {
          "Area": "Hiriyur",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.1821,
          "Long": 76.908
        },
        {
          "Area": "Hirmi",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.6139,
          "Long": 81.9805
        },
        {
          "Area": "Hirri Mines",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.9731,
          "Long": 82.05
        },
        {
          "Area": "Hisar",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.5764,
          "Long": 76.0946
        },
        {
          "Area": "Hishabi",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8464,
          "Long": 88.5736
        },
        {
          "Area": "Hisua",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.9459,
          "Long": 85.5941
        },
        {
          "Area": "Hithgaon",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.2681,
          "Long": 80.4657
        },
        {
          "Area": "Hnahthial",
          "State": "Mizoram",
          "CountryCode": "IN",
          "Lat": 23.0949,
          "Long": 93.0987
        },
        {
          "Area": "Hoadurga",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.7065,
          "Long": 76.4246
        },
        {
          "Area": "Hodadurga",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.1642,
          "Long": 76.2343
        },
        {
          "Area": "Hodal",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.3327,
          "Long": 77.4552
        },
        {
          "Area": "Hojai",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3504,
          "Long": 93.17
        },
        {
          "Area": "Holagarh",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.652,
          "Long": 81.7639
        },
        {
          "Area": "Holalkere",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.1675,
          "Long": 76.5164
        },
        {
          "Area": "Holeanarasipur",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.1435,
          "Long": 76.2402
        },
        {
          "Area": "Holeanrasipur",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 12.8522,
          "Long": 76.1979
        },
        {
          "Area": "Holenarasipur",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 12.9954,
          "Long": 76.1091
        },
        {
          "Area": "Holenarasipura",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 12.68,
          "Long": 76.1777
        },
        {
          "Area": "Holenarsipur",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 12.8509,
          "Long": 76.2515
        },
        {
          "Area": "Holgarh",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.703,
          "Long": 81.7634
        },
        {
          "Area": "Holi",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.6775,
          "Long": 76.5932
        },
        {
          "Area": "Holol",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.4232,
          "Long": 73.6086
        },
        {
          "Area": "Homnabad",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 18.2174,
          "Long": 77.468
        },
        {
          "Area": "Honavar",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.8742,
          "Long": 74.9148
        },
        {
          "Area": "Honnali",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.2212,
          "Long": 76.2965
        },
        {
          "Area": "Hosadurga",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.1675,
          "Long": 76.5164
        },
        {
          "Area": "Hosakote",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.2149,
          "Long": 77.7981
        },
        {
          "Area": "Hosanagar",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.0436,
          "Long": 75.3838
        },
        {
          "Area": "Hosanagara",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.1772,
          "Long": 75.4616
        },
        {
          "Area": "Hosdurg",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 12.606,
          "Long": 75.5983
        },
        {
          "Area": "Hoshangabad",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.7,
          "Long": 78.0923
        },
        {
          "Area": "Hoshiar  Pur",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.5497,
          "Long": 75.6624
        },
        {
          "Area": "Hoshiar Pur",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.6479,
          "Long": 76.1487
        },
        {
          "Area": "Hoshiarpur",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 32.0487,
          "Long": 76.2497
        },
        {
          "Area": "Hoskote",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.2953,
          "Long": 77.9578
        },
        {
          "Area": "Hospet",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.9527,
          "Long": 77.1212
        },
        {
          "Area": "Hospet Ho",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.0747,
          "Long": 76.348
        },
        {
          "Area": "Hosur",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 12.8738,
          "Long": 78.1851
        },
        {
          "Area": "Howaibari",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.007,
          "Long": 91.6093
        },
        {
          "Area": "Howajan",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.782,
          "Long": 93.6636
        },
        {
          "Area": "Howly",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.4224,
          "Long": 90.98
        },
        {
          "Area": "Howrah",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.2934,
          "Long": 88.5234
        },
        {
          "Area": "Hrishyamukh",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.2518,
          "Long": 91.4541
        },
        {
          "Area": "Hubballi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.381,
          "Long": 75.1084
        },
        {
          "Area": "Hubli",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.4508,
          "Long": 75.3036
        },
        {
          "Area": "Hudina",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.0799,
          "Long": 76.0612
        },
        {
          "Area": "Hukeri",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 16.3218,
          "Long": 75.7761
        },
        {
          "Area": "Hukumpeta",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.1676,
          "Long": 82.881
        },
        {
          "Area": "Hulasganj",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.1566,
          "Long": 85.1848
        },
        {
          "Area": "Hulashganj",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.1755,
          "Long": 85.3364
        },
        {
          "Area": "Humnabad",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 17.9941,
          "Long": 77.3866
        },
        {
          "Area": "Hungund",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 16.2618,
          "Long": 76.3037
        },
        {
          "Area": "Hungund Taluk",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 16.2079,
          "Long": 75.891
        },
        {
          "Area": "Hunsabad",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.5497,
          "Long": 79.2409
        },
        {
          "Area": "Hunsur",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 12.6161,
          "Long": 76.4739
        },
        {
          "Area": "Hunterganj",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.4336,
          "Long": 84.9106
        },
        {
          "Area": "Hura",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.6167,
          "Long": 87.224
        },
        {
          "Area": "Huruah",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0447,
          "Long": 91.7553
        },
        {
          "Area": "Husnabad",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.5497,
          "Long": 79.4045
        },
        {
          "Area": "Hut Bay",
          "State": "Andaman & Nicobar Islands",
          "CountryCode": "IN",
          "Lat": 12.6435,
          "Long": 92.8794
        },
        {
          "Area": "Hutmarah",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.0397,
          "Long": 74.7612
        },
        {
          "Area": "Hutmura",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5693,
          "Long": 87.1521
        },
        {
          "Area": "Huvinagadagali",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.4512,
          "Long": 76.6791
        },
        {
          "Area": "Huvinahadagali",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.3011,
          "Long": 76.5334
        },
        {
          "Area": "Huvinhadagali",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.9268,
          "Long": 75.9339
        },
        {
          "Area": "Huzur",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 25.0345,
          "Long": 81.703
        },
        {
          "Area": "Huzurabad",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.5497,
          "Long": 79.4651
        },
        {
          "Area": "Huzurnagar",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.4399,
          "Long": 80.1766
        },
        {
          "Area": "Hyd",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.7942,
          "Long": 79.0645
        },
        {
          "Area": "Hyderabad",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.5902,
          "Long": 78.6668
        },
        {
          "Area": "Hyderpora",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.14,
          "Long": 74.7964
        },
        {
          "Area": "I.polavaram",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.6589,
          "Long": 82.1875
        },
        {
          "Area": "I.polavaram Mandal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.6589,
          "Long": 82.1875
        },
        {
          "Area": "Ibrahimpatnam",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.7112,
          "Long": 78.9988
        },
        {
          "Area": "Ibrahimpatnam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.5768,
          "Long": 81.0236
        },
        {
          "Area": "Ichabari",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3444,
          "Long": 87.9089
        },
        {
          "Area": "Ichabpur",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.332,
          "Long": 92.0039
        },
        {
          "Area": "Ichailalcherra",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0447,
          "Long": 91.7553
        },
        {
          "Area": "Ichak",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.2526,
          "Long": 85.5317
        },
        {
          "Area": "Ichapur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.805,
          "Long": 88.3709
        },
        {
          "Area": "Ichapurabad",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.5455,
          "Long": 88.9366
        },
        {
          "Area": "Ichawar",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.0531,
          "Long": 77.2191
        },
        {
          "Area": "Ichchapuram",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 19.1139,
          "Long": 84.6872
        },
        {
          "Area": "Ichchapuram Mandal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.7179,
          "Long": 84.1331
        },
        {
          "Area": "Ichgam",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.9245,
          "Long": 74.6725
        },
        {
          "Area": "Ichhawar",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.1199,
          "Long": 77.0563
        },
        {
          "Area": "Idappadi",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.9154,
          "Long": 78.2221
        },
        {
          "Area": "Idar",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 24.1007,
          "Long": 73.5386
        },
        {
          "Area": "Igatpuri",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.6043,
          "Long": 75.473
        },
        {
          "Area": "Iglas",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.757,
          "Long": 77.9765
        },
        {
          "Area": "Ijayaraghavgarh.",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.9493,
          "Long": 80.6641
        },
        {
          "Area": "Ikauna",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.7364,
          "Long": 83.179
        },
        {
          "Area": "Ikauna **",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.6547,
          "Long": 82.2735
        },
        {
          "Area": "Ilayangudi",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.1096,
          "Long": 78.7956
        },
        {
          "Area": "Illuppur",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.6467,
          "Long": 78.8812
        },
        {
          "Area": "Illupur",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.495,
          "Long": 78.5167
        },
        {
          "Area": "Ilsmapur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.2654,
          "Long": 88.1898
        },
        {
          "Area": "Ilsobamandal",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.3102,
          "Long": 87.2788
        },
        {
          "Area": "Ilsobamandali",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.3102,
          "Long": 87.2788
        },
        {
          "Area": "Ilsomandalai",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.3102,
          "Long": 87.2788
        },
        {
          "Area": "Iluppur",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.6451,
          "Long": 78.8375
        },
        {
          "Area": "Imamganj",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.4518,
          "Long": 84.5351
        },
        {
          "Area": "Imamgnaj",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.4545,
          "Long": 84.5869
        },
        {
          "Area": "Imphal West",
          "State": "Manipur",
          "CountryCode": "IN",
          "Lat": 24.4065,
          "Long": 93.3452
        },
        {
          "Area": "Impur",
          "State": "Nagaland",
          "CountryCode": "IN",
          "Lat": 26.4339,
          "Long": 94.7678
        },
        {
          "Area": "Indapur",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.4967,
          "Long": 75.889
        },
        {
          "Area": "Indas",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.8237,
          "Long": 88.2308
        },
        {
          "Area": "Indergah",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 26.0626,
          "Long": 78.4043
        },
        {
          "Area": "Indergarh",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 26.0626,
          "Long": 78.5688
        },
        {
          "Area": "Indi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 17.3227,
          "Long": 76.7018
        },
        {
          "Area": "Indira Nagar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.418,
          "Long": 80.298
        },
        {
          "Area": "Indora",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.2225,
          "Long": 75.9466
        },
        {
          "Area": "Indora So",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.2266,
          "Long": 75.6632
        },
        {
          "Area": "Indore",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.861,
          "Long": 76.0506
        },
        {
          "Area": "Indpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.0931,
          "Long": 87.5766
        },
        {
          "Area": "Indranagar",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 23.0301,
          "Long": 85.9734
        },
        {
          "Area": "Indri",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.9336,
          "Long": 77.1166
        },
        {
          "Area": "Indri]",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.842,
          "Long": 77.0298
        },
        {
          "Area": "Indukurpeta",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.5092,
          "Long": 80.1256
        },
        {
          "Area": "Indukurpeta Mandalam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.8411,
          "Long": 80.046
        },
        {
          "Area": "Indukurupet",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.4922,
          "Long": 80.0763
        },
        {
          "Area": "Indurail",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1597,
          "Long": 92.0329
        },
        {
          "Area": "Indus",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8333,
          "Long": 88.0833
        },
        {
          "Area": "Industrial Complex Dundahera",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.4001,
          "Long": 76.9661
        },
        {
          "Area": "Industrial Estate",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.418,
          "Long": 76.9839
        },
        {
          "Area": "Ingram Institute",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.6667,
          "Long": 77.4333
        },
        {
          "Area": "Intur",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.7645,
          "Long": 81.5637
        },
        {
          "Area": "Inturu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.7645,
          "Long": 81.5637
        },
        {
          "Area": "Ipuru",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.2887,
          "Long": 79.8337
        },
        {
          "Area": "Iragavaram (mdl)",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.7776,
          "Long": 81.6742
        },
        {
          "Area": "Iragavaram(mdl)",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.7167,
          "Long": 81.6667
        },
        {
          "Area": "Iral",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 13.4556,
          "Long": 79.0306
        },
        {
          "Area": "Irala",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 13.4103,
          "Long": 78.9128
        },
        {
          "Area": "Irani",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0789,
          "Long": 91.8987
        },
        {
          "Area": "Isabeel",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 24.6949,
          "Long": 92.3182
        },
        {
          "Area": "Isalmgaon",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.1699,
          "Long": 94.2281
        },
        {
          "Area": "Ishlampur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.1407,
          "Long": 85.2059
        },
        {
          "Area": "Ishupur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.0529,
          "Long": 84.9759
        },
        {
          "Area": "Islam Nagar",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.9159,
          "Long": 85.899
        },
        {
          "Area": "Islamgaon",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.1699,
          "Long": 94.2281
        },
        {
          "Area": "Islamnagar",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.9767,
          "Long": 86.2459
        },
        {
          "Area": "Islampur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.3179,
          "Long": 88.29
        },
        {
          "Area": "Islampur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.3162,
          "Long": 85.4559
        },
        {
          "Area": "Ismailpur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.3084,
          "Long": 87.1692
        },
        {
          "Area": "Iswarigacha",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8464,
          "Long": 88.5736
        },
        {
          "Area": "Itaberia",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.9837,
          "Long": 87.635
        },
        {
          "Area": "Itachuna",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.398,
          "Long": 88.0798
        },
        {
          "Area": "Itahar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.881,
          "Long": 88.1583
        },
        {
          "Area": "Itanagar",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.422,
          "Long": 93.6719
        },
        {
          "Area": "Itarhi",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.4914,
          "Long": 84.2173
        },
        {
          "Area": "Itarsi",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.8571,
          "Long": 78.0798
        },
        {
          "Area": "Itinda",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.6773,
          "Long": 88.9167
        },
        {
          "Area": "Itkhori",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.3449,
          "Long": 85.296
        },
        {
          "Area": "Itki",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 23.4517,
          "Long": 85.3708
        },
        {
          "Area": "Itra",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.3805,
          "Long": 80.2158
        },
        {
          "Area": "Itwa",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.3839,
          "Long": 83.148
        },
        {
          "Area": "J.PANGULUR",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.8212,
          "Long": 79.9261
        },
        {
          "Area": "J.r.gudem",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.2025,
          "Long": 81.305
        },
        {
          "Area": "J.r.gudem Bo",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.1575,
          "Long": 81.2495
        },
        {
          "Area": "Jabalpur",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.4483,
          "Long": 80.2247
        },
        {
          "Area": "Jabda",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.9837,
          "Long": 87.635
        },
        {
          "Area": "Jabera",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.8278,
          "Long": 79.8665
        },
        {
          "Area": "Jadcherla",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.3183,
          "Long": 78.2998
        },
        {
          "Area": "Jadugoda",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 22.9294,
          "Long": 85.9593
        },
        {
          "Area": "Jadurhati",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.7371,
          "Long": 88.7422
        },
        {
          "Area": "Jael",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 27.347,
          "Long": 74.2887
        },
        {
          "Area": "Jaffrabad",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.1277,
          "Long": 75.9931
        },
        {
          "Area": "Jafrabad",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 21.6823,
          "Long": 71.3701
        },
        {
          "Area": "Jagabandhupara",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0789,
          "Long": 91.8987
        },
        {
          "Area": "Jagadhri",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 30.3045,
          "Long": 77.3216
        },
        {
          "Area": "Jagadishpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4653,
          "Long": 88.7803
        },
        {
          "Area": "Jagalur",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.5606,
          "Long": 76.3888
        },
        {
          "Area": "Jagannathpur",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 22.77,
          "Long": 85.6991
        },
        {
          "Area": "Jagannathpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.321,
          "Long": 88.7803
        },
        {
          "Area": "Jagannathpur",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0789,
          "Long": 91.8987
        },
        {
          "Area": "Jagatballavpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.1175,
          "Long": 88.2278
        },
        {
          "Area": "Jagatdal",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8827,
          "Long": 88.4655
        },
        {
          "Area": "Jagatpur",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.5697,
          "Long": 85.9151
        },
        {
          "Area": "Jagatsinghapur",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.9079,
          "Long": 86.3437
        },
        {
          "Area": "Jagatsinghpur",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.9079,
          "Long": 86.3437
        },
        {
          "Area": "Jagdalpur",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 20.0683,
          "Long": 82.1652
        },
        {
          "Area": "Jagdishpur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.641,
          "Long": 87.1989
        },
        {
          "Area": "Jagdishpur",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.4825,
          "Long": 82.8111
        },
        {
          "Area": "Jagdishpur  jagdishpur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.3788,
          "Long": 84.3405
        },
        {
          "Area": "Jaggaiahpet",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.5768,
          "Long": 81.0236
        },
        {
          "Area": "Jaggampeta",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.263,
          "Long": 82.1181
        },
        {
          "Area": "Jagganathpur",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 22.2667,
          "Long": 85.6637
        },
        {
          "Area": "Jaggayyapeta",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.3078,
          "Long": 80.6043
        },
        {
          "Area": "Jagiroad",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.2081,
          "Long": 92.5395
        },
        {
          "Area": "Jagra",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.4348,
          "Long": 91.1657
        },
        {
          "Area": "Jagraon",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.0738,
          "Long": 75.8962
        },
        {
          "Area": "Jagtial",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.8804,
          "Long": 79.2409
        },
        {
          "Area": "Jahalda",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.9467,
          "Long": 87.4938
        },
        {
          "Area": "Jahana Ganj",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.9874,
          "Long": 82.9688
        },
        {
          "Area": "Jahanabad",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5034,
          "Long": 87.9832
        },
        {
          "Area": "Jahjjar",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.6277,
          "Long": 76.6007
        },
        {
          "Area": "Jahlod",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.0906,
          "Long": 73.8912
        },
        {
          "Area": "Jaiinghpur",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.9366,
          "Long": 76.3468
        },
        {
          "Area": "Jaijaipur",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 22.5323,
          "Long": 82.851
        },
        {
          "Area": "Jainad",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 19.6355,
          "Long": 78.7946
        },
        {
          "Area": "Jainagar",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.3771,
          "Long": 85.7974
        },
        {
          "Area": "Jainagar",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.6243,
          "Long": 86.3439
        },
        {
          "Area": "Jainoor",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 19.3931,
          "Long": 78.9077
        },
        {
          "Area": "Jainshgpur",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.9126,
          "Long": 76.4971
        },
        {
          "Area": "Jainti",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.6892,
          "Long": 79.8526
        },
        {
          "Area": "Jaipatana",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 19.8677,
          "Long": 83.1092
        },
        {
          "Area": "Jaipatn A",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 19.9743,
          "Long": 83.6877
        },
        {
          "Area": "Jaipatna",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.9993,
          "Long": 83.6877
        },
        {
          "Area": "Jaipur",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 27.7298,
          "Long": 76.5458
        },
        {
          "Area": "Jaipur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.2772,
          "Long": 86.5939
        },
        {
          "Area": "Jairamnagar",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 22.3513,
          "Long": 82.3601
        },
        {
          "Area": "Jairampur",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.2343,
          "Long": 95.9139
        },
        {
          "Area": "Jaisalmer",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 27.7958,
          "Long": 73.7288
        },
        {
          "Area": "Jaisinghnagar",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.9066,
          "Long": 81.5009
        },
        {
          "Area": "Jaisinghpur",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.1755,
          "Long": 76.9445
        },
        {
          "Area": "Jaisinghpur Khera",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.1297,
          "Long": 76.5558
        },
        {
          "Area": "Jaisisnghpur",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.8571,
          "Long": 76.4617
        },
        {
          "Area": "Jaitaran",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.4444,
          "Long": 74.491
        },
        {
          "Area": "Jaithari",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.629,
          "Long": 81.8747
        },
        {
          "Area": "Jaitpur",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.016,
          "Long": 82.0489
        },
        {
          "Area": "Jaitu",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 30.6109,
          "Long": 75.0165
        },
        {
          "Area": "Jajapur",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.8313,
          "Long": 86.6106
        },
        {
          "Area": "Jajapur Road",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.8939,
          "Long": 85.4145
        },
        {
          "Area": "Jajmau",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5934,
          "Long": 80.6879
        },
        {
          "Area": "Jajpur",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 22.0443,
          "Long": 87.1571
        },
        {
          "Area": "Jajpur Raod",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.8559,
          "Long": 86.1522
        },
        {
          "Area": "Jajpur Road",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.1435,
          "Long": 86.52
        },
        {
          "Area": "Jajpur Road.",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.6724,
          "Long": 85.5273
        },
        {
          "Area": "Jakhal Mandi",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.6789,
          "Long": 75.4207
        },
        {
          "Area": "Jakhala",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.3848,
          "Long": 76.5351
        },
        {
          "Area": "Jakhania",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.8215,
          "Long": 83.6994
        },
        {
          "Area": "Jakhanian **",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.7768,
          "Long": 83.5562
        },
        {
          "Area": "Jakhnidhar",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.4488,
          "Long": 78.6343
        },
        {
          "Area": "Jakhnidharr",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.9957,
          "Long": 78.6343
        },
        {
          "Area": "Jakholi",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.5303,
          "Long": 79.2236
        },
        {
          "Area": "Jaladanki",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.9502,
          "Long": 79.8459
        },
        {
          "Area": "Jalahghat",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.6242,
          "Long": 91.5994
        },
        {
          "Area": "Jalai",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0789,
          "Long": 91.8987
        },
        {
          "Area": "Jalalabad",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 30.9364,
          "Long": 74.9503
        },
        {
          "Area": "Jalalabad",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.0637,
          "Long": 80.0538
        },
        {
          "Area": "Jalalpore",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 21.1264,
          "Long": 73.333
        },
        {
          "Area": "Jalalporre",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 20.9299,
          "Long": 73.0988
        },
        {
          "Area": "Jalalpur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.8741,
          "Long": 83.0709
        },
        {
          "Area": "Jalalpur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.0529,
          "Long": 84.9343
        },
        {
          "Area": "Jalandhar",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.6708,
          "Long": 76.0849
        },
        {
          "Area": "Jalandhar - I",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.564,
          "Long": 76.0849
        },
        {
          "Area": "Jalandhar -II",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.7421,
          "Long": 76.3534
        },
        {
          "Area": "Jalandhar-II",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.3288,
          "Long": 75.4193
        },
        {
          "Area": "Jalangi",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.6278,
          "Long": 88.5022
        },
        {
          "Area": "Jalaun",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.9368,
          "Long": 79.6351
        },
        {
          "Area": "Jale",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.6518,
          "Long": 85.7383
        },
        {
          "Area": "Jaleasr",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.524,
          "Long": 78.7132
        },
        {
          "Area": "Jalesar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.598,
          "Long": 78.7132
        },
        {
          "Area": "Jalesasr",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.524,
          "Long": 78.3662
        },
        {
          "Area": "Jaleshar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.4223,
          "Long": 78.4351
        },
        {
          "Area": "Jalesher",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.5036,
          "Long": 78.5075
        },
        {
          "Area": "Jalessar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.5665,
          "Long": 78.4655
        },
        {
          "Area": "Jaleswar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5228,
          "Long": 88.1967
        },
        {
          "Area": "Jaleswar",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.8952,
          "Long": 87.1928
        },
        {
          "Area": "Jalgaon",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.4046,
          "Long": 76.5877
        },
        {
          "Area": "Jalgaon (Jamod)",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.1078,
          "Long": 76.6072
        },
        {
          "Area": "Jalgoan",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.9355,
          "Long": 76.4159
        },
        {
          "Area": "Jalholi",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.8125,
          "Long": 79.1194
        },
        {
          "Area": "Jalkot",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 18.3045,
          "Long": 76.8507
        },
        {
          "Area": "Jalna",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.2702,
          "Long": 76.197
        },
        {
          "Area": "Jalor",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.4262,
          "Long": 74.0134
        },
        {
          "Area": "Jalore",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.2918,
          "Long": 73.456
        },
        {
          "Area": "Jalpaiguri",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.9954,
          "Long": 89.3436
        },
        {
          "Area": "Jalpaiguri Sadar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.5004,
          "Long": 88.2369
        },
        {
          "Area": "Jalukbari Lac",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.1577,
          "Long": 91.7031
        },
        {
          "Area": "Jalumuru",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.5811,
          "Long": 84.0775
        },
        {
          "Area": "Jalumuru Mandal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.5965,
          "Long": 84.0775
        },
        {
          "Area": "Jama",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.8959,
          "Long": 87.42
        },
        {
          "Area": "Jamai",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.3539,
          "Long": 79.2942
        },
        {
          "Area": "Jamakhandi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 16.7489,
          "Long": 76.0514
        },
        {
          "Area": "Jamalpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.7617,
          "Long": 88.1499
        },
        {
          "Area": "Jamalpur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.4849,
          "Long": 86.5907
        },
        {
          "Area": "Jamankira",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.6512,
          "Long": 84.4687
        },
        {
          "Area": "Jamboni",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.4111,
          "Long": 86.9911
        },
        {
          "Area": "Jambsuar",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.1713,
          "Long": 72.7465
        },
        {
          "Area": "Jambughoda",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.185,
          "Long": 73.936
        },
        {
          "Area": "Jambusar",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.1192,
          "Long": 73.6666
        },
        {
          "Area": "Jamhor",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.0421,
          "Long": 84.5402
        },
        {
          "Area": "Jami",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.0745,
          "Long": 83.3347
        },
        {
          "Area": "Jamirapalgarh",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.6315,
          "Long": 87.428
        },
        {
          "Area": "Jamircherra",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.9923,
          "Long": 91.6205
        },
        {
          "Area": "Jamjodhpur",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 24.2438,
          "Long": 72.4586
        },
        {
          "Area": "Jamkalyanpur",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.2522,
          "Long": 69.9137
        },
        {
          "Area": "Jamkandi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.9651,
          "Long": 75.9744
        },
        {
          "Area": "Jamkandorna",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.4603,
          "Long": 71.5304
        },
        {
          "Area": "Jamkhandi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 16.9796,
          "Long": 76.5917
        },
        {
          "Area": "Jamkhed",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.2034,
          "Long": 76.1405
        },
        {
          "Area": "Jammalamadugu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.1138,
          "Long": 78.4489
        },
        {
          "Area": "Jammalamdugu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.0624,
          "Long": 78.492
        },
        {
          "Area": "Jammalmadugu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.9387,
          "Long": 78.3271
        },
        {
          "Area": "Jammikunta",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.3373,
          "Long": 79.5135
        },
        {
          "Area": "Jammu",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.4645,
          "Long": 75.0903
        },
        {
          "Area": "Jamnagar",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.9029,
          "Long": 74.014
        },
        {
          "Area": "Jamner",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.5797,
          "Long": 76.6833
        },
        {
          "Area": "Jamnipali",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 22.4806,
          "Long": 82.6126
        },
        {
          "Area": "Jampui",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1597,
          "Long": 92.0329
        },
        {
          "Area": "Jamshedpur",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 23.62,
          "Long": 86.4527
        },
        {
          "Area": "Jamsole",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4364,
          "Long": 87.9624
        },
        {
          "Area": "Jamtara",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.1674,
          "Long": 86.9172
        },
        {
          "Area": "Jamthing",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0789,
          "Long": 91.8987
        },
        {
          "Area": "Jamu",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.3805,
          "Long": 80.2158
        },
        {
          "Area": "Jamua",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.6512,
          "Long": 86.3085
        },
        {
          "Area": "Jamua Sankarpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4305,
          "Long": 87.4447
        },
        {
          "Area": "Jamuagiridih",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.2963,
          "Long": 86.0916
        },
        {
          "Area": "Jamualachimpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3159,
          "Long": 88.0212
        },
        {
          "Area": "Jamugurihat",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.7887,
          "Long": 92.965
        },
        {
          "Area": "Jamui",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.1717,
          "Long": 86.2952
        },
        {
          "Area": "Jamuria",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3192,
          "Long": 88.4456
        },
        {
          "Area": "Jamuriahat",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.9614,
          "Long": 87.1708
        },
        {
          "Area": "Janakpur",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 23.4681,
          "Long": 82.8212
        },
        {
          "Area": "Janaphul",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.1383,
          "Long": 88.2387
        },
        {
          "Area": "Jandaha",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.7382,
          "Long": 85.3919
        },
        {
          "Area": "Jandiala",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.7046,
          "Long": 75.0764
        },
        {
          "Area": "Jandiala Guru",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.5508,
          "Long": 75.0636
        },
        {
          "Area": "Jandila Guru",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.5494,
          "Long": 75.0492
        },
        {
          "Area": "Jang",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.5667,
          "Long": 91.9833
        },
        {
          "Area": "Jangalpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8151,
          "Long": 88.4296
        },
        {
          "Area": "Jangaon",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.065,
          "Long": 79.5612
        },
        {
          "Area": "Jangareddigudem",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.1575,
          "Long": 81.305
        },
        {
          "Area": "Janghai Bazar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.6986,
          "Long": 82.3492
        },
        {
          "Area": "Jangipara",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.4387,
          "Long": 88.0059
        },
        {
          "Area": "Jangipur Barrage",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.5173,
          "Long": 88.0273
        },
        {
          "Area": "Janidiala Resistant/s",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.5638,
          "Long": 75.1216
        },
        {
          "Area": "Janijog",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3796,
          "Long": 91.2951
        },
        {
          "Area": "Janjgir",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 22.5219,
          "Long": 82.775
        },
        {
          "Area": "Janka",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.8532,
          "Long": 87.9147
        },
        {
          "Area": "Jansath",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 29.5456,
          "Long": 78.0464
        },
        {
          "Area": "Jaora",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.7845,
          "Long": 76.0192
        },
        {
          "Area": "Japla",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.6269,
          "Long": 84.3119
        },
        {
          "Area": "Jarada",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.8222,
          "Long": 84.5272
        },
        {
          "Area": "Jarkala",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.3464,
          "Long": 80.3867
        },
        {
          "Area": "Jarmudi",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.549,
          "Long": 87.0801
        },
        {
          "Area": "Jarmundi",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.7128,
          "Long": 87.6191
        },
        {
          "Area": "Jarwa",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.4019,
          "Long": 75.9576
        },
        {
          "Area": "Jasaikati",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.7583,
          "Long": 88.8028
        },
        {
          "Area": "Jasarana",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.3705,
          "Long": 79.3119
        },
        {
          "Area": "Jasdan",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 24.212,
          "Long": 72.9571
        },
        {
          "Area": "Jashipur",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.4888,
          "Long": 85.328
        },
        {
          "Area": "Jashpur",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 22.8767,
          "Long": 84.0447
        },
        {
          "Area": "Jashpurnagar",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 23.118,
          "Long": 84.3691
        },
        {
          "Area": "Jasinghpur",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.9126,
          "Long": 76.4971
        },
        {
          "Area": "Jasol",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.8167,
          "Long": 72.2167
        },
        {
          "Area": "Jaspur",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.3083,
          "Long": 78.8022
        },
        {
          "Area": "Jasra",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.2831,
          "Long": 81.776
        },
        {
          "Area": "Jasrana",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.4752,
          "Long": 79.3119
        },
        {
          "Area": "Jasteghori",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.2088,
          "Long": 88.0387
        },
        {
          "Area": "Jaswan(T)",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.0984,
          "Long": 76.2871
        },
        {
          "Area": "Jaswant Nagar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.9401,
          "Long": 79.0966
        },
        {
          "Area": "Jat",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.817,
          "Long": 75.4517
        },
        {
          "Area": "Jatanbari",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.5938,
          "Long": 91.3855
        },
        {
          "Area": "Jatara",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 25.1569,
          "Long": 79.1111
        },
        {
          "Area": "Jath",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 17.7244,
          "Long": 75.4517
        },
        {
          "Area": "Jatni",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.4382,
          "Long": 85.7385
        },
        {
          "Area": "Jatusana Rs",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.3196,
          "Long": 76.611
        },
        {
          "Area": "Jaunpur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.0787,
          "Long": 82.7837
        },
        {
          "Area": "Javali",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 17.6686,
          "Long": 74.1738
        },
        {
          "Area": "Jawad",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 25.6565,
          "Long": 76.7198
        },
        {
          "Area": "Jawahar Nagar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.0884,
          "Long": 81.7153
        },
        {
          "Area": "Jawahar Nagar",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.0672,
          "Long": 74.8257
        },
        {
          "Area": "Jawalapora",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.9245,
          "Long": 74.6725
        },
        {
          "Area": "Jawali",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.3073,
          "Long": 76.3873
        },
        {
          "Area": "Jawali",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.1806,
          "Long": 76.1932
        },
        {
          "Area": "Jawali(T)",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.1812,
          "Long": 76.227
        },
        {
          "Area": "Jawar",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.1135,
          "Long": 76.5597
        },
        {
          "Area": "Jawhar",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.9243,
          "Long": 73.6094
        },
        {
          "Area": "Jawoli",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 18.0553,
          "Long": 74.5306
        },
        {
          "Area": "Jayamkondacholapuram",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.3715,
          "Long": 79.4883
        },
        {
          "Area": "Jayamkondcholapuram",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.0289,
          "Long": 79.2366
        },
        {
          "Area": "Jayamkondocholapuram",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.0289,
          "Long": 79.2366
        },
        {
          "Area": "Jaynagar",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.6522,
          "Long": 86.4481
        },
        {
          "Area": "Jaynagar - I",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.415,
          "Long": 88.5694
        },
        {
          "Area": "Jaynagar - II",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.2569,
          "Long": 88.5694
        },
        {
          "Area": "Jaypur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.6214,
          "Long": 87.913
        },
        {
          "Area": "Jaysagar",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.2685,
          "Long": 91.6169
        },
        {
          "Area": "Jeelugumilli",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.3173,
          "Long": 81.2332
        },
        {
          "Area": "Jehanabad",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.3551,
          "Long": 85.1605
        },
        {
          "Area": "Jenkapur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5034,
          "Long": 87.9832
        },
        {
          "Area": "Jeoldanga",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.0361,
          "Long": 88.7773
        },
        {
          "Area": "Jerthan",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4305,
          "Long": 87.4447
        },
        {
          "Area": "Jesar",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 21.4208,
          "Long": 71.6947
        },
        {
          "Area": "Jessore Road",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.3945,
          "Long": 88.2559
        },
        {
          "Area": "Jetaran",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.4197,
          "Long": 74.0869
        },
        {
          "Area": "Jetpur",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.0024,
          "Long": 71.3043
        },
        {
          "Area": "Jewar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.2515,
          "Long": 77.705
        },
        {
          "Area": "Jewargi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 17.5717,
          "Long": 76.8695
        },
        {
          "Area": "Jewargio",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 17.1231,
          "Long": 76.4438
        },
        {
          "Area": "Jewer",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.3979,
          "Long": 78.778
        },
        {
          "Area": "Jeypore",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 18.9994,
          "Long": 82.7213
        },
        {
          "Area": "Jeypore",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.3779,
          "Long": 95.2828
        },
        {
          "Area": "Jeypore(k)",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 19.1054,
          "Long": 83.2638
        },
        {
          "Area": "Jeypur",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 18.9973,
          "Long": 82.4728
        },
        {
          "Area": "Jhabua",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.6716,
          "Long": 75.5935
        },
        {
          "Area": "Jhabuwa",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.1297,
          "Long": 76.5558
        },
        {
          "Area": "Jhadol",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 24.6034,
          "Long": 73.7064
        },
        {
          "Area": "Jhadol (P)",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 24.7272,
          "Long": 73.8024
        },
        {
          "Area": "Jhadrajing",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.6468,
          "Long": 84.4734
        },
        {
          "Area": "Jhagadia",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.5135,
          "Long": 73.4367
        },
        {
          "Area": "Jhagroli",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.3732,
          "Long": 76.8881
        },
        {
          "Area": "Jhajah",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.897,
          "Long": 86.3813
        },
        {
          "Area": "Jhajajr",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.6344,
          "Long": 76.688
        },
        {
          "Area": "Jhajar",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.5047,
          "Long": 76.589
        },
        {
          "Area": "Jhajha",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.897,
          "Long": 86.4667
        },
        {
          "Area": "Jhajjar",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.0372,
          "Long": 76.8561
        },
        {
          "Area": "Jhajjr",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.6344,
          "Long": 76.688
        },
        {
          "Area": "Jhal",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.4063,
          "Long": 76.4363
        },
        {
          "Area": "Jhalawar",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.2194,
          "Long": 76.8018
        },
        {
          "Area": "Jhalda",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.45,
          "Long": 86.4183
        },
        {
          "Area": "Jhalda - II",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.4233,
          "Long": 85.9981
        },
        {
          "Area": "Jhalda I",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.206,
          "Long": 86.5939
        },
        {
          "Area": "Jhalda Ii",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.4387,
          "Long": 86.5939
        },
        {
          "Area": "Jhalod",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.4864,
          "Long": 74.2619
        },
        {
          "Area": "Jhamdutta",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.4227,
          "Long": 76.7998
        },
        {
          "Area": "Jhamri",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.483,
          "Long": 76.4732
        },
        {
          "Area": "Jhanda",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.7438,
          "Long": 85.5133
        },
        {
          "Area": "Jhandaha",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.9016,
          "Long": 85.5128
        },
        {
          "Area": "Jhanduta",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.4227,
          "Long": 76.7998
        },
        {
          "Area": "Jhanduta(T)",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.2283,
          "Long": 77.2004
        },
        {
          "Area": "Jhandutha",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.4761,
          "Long": 77.0951
        },
        {
          "Area": "Jhandutt",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.4227,
          "Long": 76.7998
        },
        {
          "Area": "Jhandutta",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.4761,
          "Long": 77.3977
        },
        {
          "Area": "Jhanjhapur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.5997,
          "Long": 85.8119
        },
        {
          "Area": "Jhanjharpur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.5997,
          "Long": 86.4952
        },
        {
          "Area": "Jhanjianankar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3029,
          "Long": 87.818
        },
        {
          "Area": "Jhansdutta",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.4761,
          "Long": 75.9907
        },
        {
          "Area": "Jhansi",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.7648,
          "Long": 79.2439
        },
        {
          "Area": "Jhanswakalan",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.482,
          "Long": 76.4931
        },
        {
          "Area": "Jharbandh",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.1285,
          "Long": 82.8239
        },
        {
          "Area": "Jharda",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.6056,
          "Long": 75.7251
        },
        {
          "Area": "Jhargram",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.4111,
          "Long": 88.5238
        },
        {
          "Area": "Jhari Jamni",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.9353,
          "Long": 78.5353
        },
        {
          "Area": "Jharia",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.033,
          "Long": 87.1722
        },
        {
          "Area": "Jharigan",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 19.4454,
          "Long": 82.327
        },
        {
          "Area": "Jharli",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.4972,
          "Long": 76.385
        },
        {
          "Area": "Jharobari Block",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.1239,
          "Long": 91.5397
        },
        {
          "Area": "Jharobari Block ( Chainibardua",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 25.9774,
          "Long": 91.4742
        },
        {
          "Area": "Jharobari Block(chaini Barduar",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 25.9774,
          "Long": 91.4742
        },
        {
          "Area": "Jharobariblock(chainibarduar)",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 25.9774,
          "Long": 91.4742
        },
        {
          "Area": "Jharoda",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.1729,
          "Long": 76.1432
        },
        {
          "Area": "Jharsuguda",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.9211,
          "Long": 84.1557
        },
        {
          "Area": "Jharsuguda Sadar",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.9211,
          "Long": 84.1019
        },
        {
          "Area": "Jhasuguda Sadar",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.937,
          "Long": 84.0178
        },
        {
          "Area": "Jhawa",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3836,
          "Long": 87.8747
        },
        {
          "Area": "Jhawdanga",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.1465,
          "Long": 88.1117
        },
        {
          "Area": "Jhawgeria",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.63,
          "Long": 87.7168
        },
        {
          "Area": "Jhikra",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.6653,
          "Long": 88.7037
        },
        {
          "Area": "Jhinjhak",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5837,
          "Long": 79.8352
        },
        {
          "Area": "Jhinkpani",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 22.4174,
          "Long": 85.7124
        },
        {
          "Area": "Jhiranya",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 21.7242,
          "Long": 76.0625
        },
        {
          "Area": "Jhirnia",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.0659,
          "Long": 75.7805
        },
        {
          "Area": "Jhirniya",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 21.9595,
          "Long": 76.142
        },
        {
          "Area": "Jhnsi",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.783,
          "Long": 78.8122
        },
        {
          "Area": "Jhoiri",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.1729,
          "Long": 76.1432
        },
        {
          "Area": "Jhook",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.3164,
          "Long": 76.1796
        },
        {
          "Area": "Jhopkhali",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3687,
          "Long": 88.562
        },
        {
          "Area": "Jhrasuguda Sadar",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.918,
          "Long": 84.0755
        },
        {
          "Area": "Jhunjhunu",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 28.3043,
          "Long": 75.7638
        },
        {
          "Area": "Jhunjhunui",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 28.2202,
          "Long": 75.468
        },
        {
          "Area": "Jhunjhunun",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 28.3878,
          "Long": 75.5524
        },
        {
          "Area": "Jiawan",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.2916,
          "Long": 82.3776
        },
        {
          "Area": "Jind",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.7054,
          "Long": 76.6403
        },
        {
          "Area": "Jind  jind",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.0992,
          "Long": 76.3393
        },
        {
          "Area": "Jintur",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.7714,
          "Long": 77.1544
        },
        {
          "Area": "Jirania",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.6622,
          "Long": 91.3881
        },
        {
          "Area": "Jirapur",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.1401,
          "Long": 76.7346
        },
        {
          "Area": "Jiribam",
          "State": "Manipur",
          "CountryCode": "IN",
          "Lat": 24.6188,
          "Long": 93.3374
        },
        {
          "Area": "Jiudaru",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.4387,
          "Long": 87.2151
        },
        {
          "Area": "Jiwati",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.186,
          "Long": 79.1972
        },
        {
          "Area": "Jiyyammavalasa",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.8205,
          "Long": 83.6042
        },
        {
          "Area": "Jiyyammavalsa",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.7234,
          "Long": 83.5124
        },
        {
          "Area": "Jlebassa",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1597,
          "Long": 92.0329
        },
        {
          "Area": "Jmua",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.1831,
          "Long": 86.1118
        },
        {
          "Area": "Jodhpur",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 27.3766,
          "Long": 73.9768
        },
        {
          "Area": "Jodia",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.6177,
          "Long": 72.406
        },
        {
          "Area": "Jodiya",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.2395,
          "Long": 70.0173
        },
        {
          "Area": "Jogeshganj",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.4323,
          "Long": 88.373
        },
        {
          "Area": "Jogeshwari East",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.1699,
          "Long": 72.8504
        },
        {
          "Area": "Jogeshwari West",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.1624,
          "Long": 72.8694
        },
        {
          "Area": "Jogindarnagar(T)",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.9287,
          "Long": 76.8786
        },
        {
          "Area": "Joginder Nagar",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.9873,
          "Long": 77.0686
        },
        {
          "Area": "Jogindernagar",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.0068,
          "Long": 76.9929
        },
        {
          "Area": "Jogindr Nagar",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.5782,
          "Long": 76.9814
        },
        {
          "Area": "Jogipet",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.0891,
          "Long": 78.2157
        },
        {
          "Area": "Joida",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.4124,
          "Long": 75.3986
        },
        {
          "Area": "Joka",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.0602,
          "Long": 88.4168
        },
        {
          "Area": "Jolaibari",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.0015,
          "Long": 91.7243
        },
        {
          "Area": "Jonai",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.7246,
          "Long": 94.8545
        },
        {
          "Area": "Jondhi",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.6344,
          "Long": 76.688
        },
        {
          "Area": "Jonk",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.9083,
          "Long": 82.5839
        },
        {
          "Area": "Jorebunglow Sukiapokhri",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 27.008,
          "Long": 88.3462
        },
        {
          "Area": "Jorethang",
          "State": "Sikkim",
          "CountryCode": "IN",
          "Lat": 27.3491,
          "Long": 88.2608
        },
        {
          "Area": "Jorhat",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.2498,
          "Long": 94.8545
        },
        {
          "Area": "Jori",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.27,
          "Long": 84.9832
        },
        {
          "Area": "Joshimath",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.7683,
          "Long": 79.8269
        },
        {
          "Area": "Joura",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 26.4739,
          "Long": 78.2301
        },
        {
          "Area": "Jowai",
          "State": "Meghalaya",
          "CountryCode": "IN",
          "Lat": 25.6086,
          "Long": 92.4591
        },
        {
          "Area": "Joygopalpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3484,
          "Long": 88.8997
        },
        {
          "Area": "Joygram",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4784,
          "Long": 88.5822
        },
        {
          "Area": "Joynagar Majilpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.2569,
          "Long": 88.5694
        },
        {
          "Area": "Joypul",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.7774,
          "Long": 88.5686
        },
        {
          "Area": "Joypur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.4541,
          "Long": 87.9687
        },
        {
          "Area": "Joypur Rajabazar",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 24.8112,
          "Long": 92.8564
        },
        {
          "Area": "Jqamkhandi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.9978,
          "Long": 75.5946
        },
        {
          "Area": "Jsbslpur",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.3159,
          "Long": 79.9614
        },
        {
          "Area": "Jubarajnagar",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0447,
          "Long": 91.7553
        },
        {
          "Area": "Jubaraznagar",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0789,
          "Long": 91.8987
        },
        {
          "Area": "Jubbal",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.2779,
          "Long": 77.8326
        },
        {
          "Area": "Juddi",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.3498,
          "Long": 76.5026
        },
        {
          "Area": "Jugrajpur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.3805,
          "Long": 80.2158
        },
        {
          "Area": "Jugsalai",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 22.7767,
          "Long": 86.1835
        },
        {
          "Area": "Juhi",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5934,
          "Long": 80.6879
        },
        {
          "Area": "Jujomura",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.2332,
          "Long": 84.1382
        },
        {
          "Area": "Jujumura",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.546,
          "Long": 84.2694
        },
        {
          "Area": "Jukhia Bazar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5034,
          "Long": 87.9832
        },
        {
          "Area": "Juki",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.9958,
          "Long": 87.8022
        },
        {
          "Area": "Julapalle",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.6062,
          "Long": 79.1098
        },
        {
          "Area": "Jullapalli",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.5497,
          "Long": 79.2409
        },
        {
          "Area": "Julurpahad",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.8092,
          "Long": 80.6873
        },
        {
          "Area": "Julurupad",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.8092,
          "Long": 79.656
        },
        {
          "Area": "Julurupadu",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.8092,
          "Long": 79.656
        },
        {
          "Area": "Jumki",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.9958,
          "Long": 87.8022
        },
        {
          "Area": "Junagadh",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.5623,
          "Long": 73.7315
        },
        {
          "Area": "Junagarh",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.9993,
          "Long": 83.6877
        },
        {
          "Area": "Junagrh",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 19.9257,
          "Long": 82.8036
        },
        {
          "Area": "Junboni",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.871,
          "Long": 88.0316
        },
        {
          "Area": "Jundla",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.6749,
          "Long": 76.921
        },
        {
          "Area": "June Belda",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4364,
          "Long": 87.9624
        },
        {
          "Area": "Junga",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 30.9534,
          "Long": 77.2115
        },
        {
          "Area": "Junnar",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.7452,
          "Long": 75.3725
        },
        {
          "Area": "Junnardeo",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.4909,
          "Long": 78.8555
        },
        {
          "Area": "Junnareo",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.0531,
          "Long": 78.4246
        },
        {
          "Area": "Junput",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3836,
          "Long": 87.8747
        },
        {
          "Area": "Jupadu Bungalow",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.545,
          "Long": 78.0233
        },
        {
          "Area": "Juri",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1597,
          "Long": 92.0329
        },
        {
          "Area": "K Dharur",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.2077,
          "Long": 77.0702
        },
        {
          "Area": "K Mahankal",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 18.906,
          "Long": 76.5271
        },
        {
          "Area": "K Mhankal",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 17.0607,
          "Long": 74.8642
        },
        {
          "Area": "K P University",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.418,
          "Long": 80.298
        },
        {
          "Area": "K R Nagar",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 12.6516,
          "Long": 76.4422
        },
        {
          "Area": "K. Mahankal",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 18.4063,
          "Long": 75.8557
        },
        {
          "Area": "K. Mandvi",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.9424,
          "Long": 69.5135
        },
        {
          "Area": "K.Kotapadu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.9169,
          "Long": 83.0812
        },
        {
          "Area": "K.V.Rangareddy",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.5902,
          "Long": 78.6668
        },
        {
          "Area": "K.c.works",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.4539,
          "Long": 80.6105
        },
        {
          "Area": "K.e.pete",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 12.7268,
          "Long": 76.5388
        },
        {
          "Area": "K.g.basss",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 27.937,
          "Long": 76.6909
        },
        {
          "Area": "K.kota",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.0288,
          "Long": 81.2156
        },
        {
          "Area": "K.r.pete",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 12.942,
          "Long": 76.798
        },
        {
          "Area": "K.singhpur",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.0691,
          "Long": 83.8471
        },
        {
          "Area": "K.v.b.puram",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 13.6688,
          "Long": 79.7942
        },
        {
          "Area": "KHORDA",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.8591,
          "Long": 85.7143
        },
        {
          "Area": "Kaanwali",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.7759,
          "Long": 75.1249
        },
        {
          "Area": "Kabisuryanagar",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.1268,
          "Long": 84.8777
        },
        {
          "Area": "Kacha Pacca",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.7046,
          "Long": 74.9007
        },
        {
          "Area": "Kachachakote",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.9306,
          "Long": 75.1134
        },
        {
          "Area": "Kacharicherra",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0447,
          "Long": 91.7553
        },
        {
          "Area": "Kacharigaon",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.7824,
          "Long": 92.9393
        },
        {
          "Area": "Kachch",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 21.8717,
          "Long": 70.1557
        },
        {
          "Area": "Kachchh",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.5386,
          "Long": 68.6014
        },
        {
          "Area": "Kachdaha",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4948,
          "Long": 88.4232
        },
        {
          "Area": "Kachua",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.614,
          "Long": 88.5475
        },
        {
          "Area": "Kachua Swarupnagar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.7371,
          "Long": 88.7422
        },
        {
          "Area": "Kachucherra",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.9923,
          "Long": 91.6205
        },
        {
          "Area": "Kachugaon",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3513,
          "Long": 90.3634
        },
        {
          "Area": "Kachwari",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.9245,
          "Long": 74.6725
        },
        {
          "Area": "Kadakandla",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.0809,
          "Long": 79.6458
        },
        {
          "Area": "Kadaladi",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 9.4401,
          "Long": 78.7716
        },
        {
          "Area": "Kadambagachi",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.7572,
          "Long": 88.4556
        },
        {
          "Area": "Kadampukur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.5864,
          "Long": 88.4145
        },
        {
          "Area": "Kadamtala",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1597,
          "Long": 92.0329
        },
        {
          "Area": "Kadamtala",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.1367,
          "Long": 88.0923
        },
        {
          "Area": "Kadana",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.4252,
          "Long": 73.8497
        },
        {
          "Area": "Kadari Champatpur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.1628,
          "Long": 80.5482
        },
        {
          "Area": "Kadavur",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.8717,
          "Long": 78.4263
        },
        {
          "Area": "Kaddam (Peddur)",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 19.0526,
          "Long": 78.7908
        },
        {
          "Area": "Kadegaon",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.3701,
          "Long": 77.2977
        },
        {
          "Area": "Kadi",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 24.0647,
          "Long": 72.7848
        },
        {
          "Area": "Kadipiur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.3216,
          "Long": 82.3895
        },
        {
          "Area": "Kadipur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.6066,
          "Long": 82.6813
        },
        {
          "Area": "Kadiri",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.2056,
          "Long": 78.1903
        },
        {
          "Area": "Kadiyam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.936,
          "Long": 81.8973
        },
        {
          "Area": "Kadma",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 22.5826,
          "Long": 86.4527
        },
        {
          "Area": "Kadur",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.0488,
          "Long": 76.3346
        },
        {
          "Area": "Kagal",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.0535,
          "Long": 77.2844
        },
        {
          "Area": "Kagaznagar",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 19.2565,
          "Long": 79.2403
        },
        {
          "Area": "Kahal",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.0271,
          "Long": 78.9697
        },
        {
          "Area": "Kahalgaon",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.3925,
          "Long": 87.3601
        },
        {
          "Area": "Kahalgoan",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.3944,
          "Long": 87.3192
        },
        {
          "Area": "Kahanapur",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 17.112,
          "Long": 74.7699
        },
        {
          "Area": "Kahandala Bawada",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 17.9982,
          "Long": 74.2036
        },
        {
          "Area": "Kahandala Bawda",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 17.9982,
          "Long": 74.2036
        },
        {
          "Area": "Kahankia",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.1465,
          "Long": 88.1117
        },
        {
          "Area": "Kahanpur",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 17.112,
          "Long": 74.7699
        },
        {
          "Area": "Kahara",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.9414,
          "Long": 86.6174
        },
        {
          "Area": "Kahatav",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.1806,
          "Long": 75.6891
        },
        {
          "Area": "Kahbhalia",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.3965,
          "Long": 70.0048
        },
        {
          "Area": "Kahleel",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.9306,
          "Long": 75.1134
        },
        {
          "Area": "Kahmgaon",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.698,
          "Long": 76.5855
        },
        {
          "Area": "Kahra",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.9926,
          "Long": 86.5898
        },
        {
          "Area": "Kaihar",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.529,
          "Long": 87.7033
        },
        {
          "Area": "Kaij",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.6881,
          "Long": 77.9838
        },
        {
          "Area": "Kaijuri",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5239,
          "Long": 87.8703
        },
        {
          "Area": "Kaikalur",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.5779,
          "Long": 81.2946
        },
        {
          "Area": "Kaikaram",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.8108,
          "Long": 81.3661
        },
        {
          "Area": "Kailaras",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 26.3286,
          "Long": 77.7529
        },
        {
          "Area": "Kailashahar",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.332,
          "Long": 92.0039
        },
        {
          "Area": "Kaindha",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.1628,
          "Long": 80.5482
        },
        {
          "Area": "Kaipukuria",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.1465,
          "Long": 88.1117
        },
        {
          "Area": "Kairana",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 29.6707,
          "Long": 77.5923
        },
        {
          "Area": "Kairon",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.3717,
          "Long": 74.9174
        },
        {
          "Area": "Kaisarganj",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.3192,
          "Long": 81.7303
        },
        {
          "Area": "Kaiserganj",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.8286,
          "Long": 81.7303
        },
        {
          "Area": "Kaithal",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.9531,
          "Long": 76.5294
        },
        {
          "Area": "Kaithalkaithal",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.5838,
          "Long": 76.4837
        },
        {
          "Area": "Kaithalkuchi",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.4526,
          "Long": 91.3843
        },
        {
          "Area": "Kaithore",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.8995,
          "Long": 87.5379
        },
        {
          "Area": "Kajlagarh",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.9706,
          "Long": 88.0631
        },
        {
          "Area": "Kajli",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3159,
          "Long": 88.0212
        },
        {
          "Area": "Kajuluru",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.1885,
          "Long": 82.2028
        },
        {
          "Area": "Kakadeo",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.418,
          "Long": 80.298
        },
        {
          "Area": "Kakatpur",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.444,
          "Long": 86.2824
        },
        {
          "Area": "Kakaya",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3637,
          "Long": 91.3439
        },
        {
          "Area": "Kakching",
          "State": "Manipur",
          "CountryCode": "IN",
          "Lat": 24.4468,
          "Long": 93.9124
        },
        {
          "Area": "Kakdwip",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.5961,
          "Long": 88.3478
        },
        {
          "Area": "Kakhania",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.6224,
          "Long": 83.5562
        },
        {
          "Area": "Kakinada",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.3191,
          "Long": 82.2347
        },
        {
          "Area": "Kakinada (Urban)",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.3229,
          "Long": 82.4308
        },
        {
          "Area": "Kakinada Rural",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.1885,
          "Long": 82.0118
        },
        {
          "Area": "Kako",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.2242,
          "Long": 85.0938
        },
        {
          "Area": "Kakraban",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.4856,
          "Long": 91.3989
        },
        {
          "Area": "Kakrajit",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.6315,
          "Long": 87.428
        },
        {
          "Area": "Kakranan",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.4856,
          "Long": 91.3989
        },
        {
          "Area": "Kakrola",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.4013,
          "Long": 76.373
        },
        {
          "Area": "Kakulapadu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.4837,
          "Long": 80.8155
        },
        {
          "Area": "Kakumanu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.3227,
          "Long": 80.3937
        },
        {
          "Area": "Kalabari",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.9081,
          "Long": 93.7088
        },
        {
          "Area": "Kalaburagi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 17.2967,
          "Long": 76.6671
        },
        {
          "Area": "Kalachari",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1959,
          "Long": 91.8344
        },
        {
          "Area": "Kalacherra",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0447,
          "Long": 91.7553
        },
        {
          "Area": "Kaladhungi",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.4586,
          "Long": 79.4841
        },
        {
          "Area": "Kalag",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.477,
          "Long": 91.4874
        },
        {
          "Area": "Kalagachia",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5034,
          "Long": 87.9832
        },
        {
          "Area": "Kalaghatgi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.3894,
          "Long": 75.2653
        },
        {
          "Area": "Kalagong",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1597,
          "Long": 92.0329
        },
        {
          "Area": "Kalaigaon",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.6257,
          "Long": 92.2582
        },
        {
          "Area": "Kalain",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 24.9687,
          "Long": 92.5691
        },
        {
          "Area": "Kalakada",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 13.9542,
          "Long": 79.6351
        },
        {
          "Area": "Kalaktang",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.1006,
          "Long": 92.1039
        },
        {
          "Area": "Kalamb",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.5249,
          "Long": 78.4484
        },
        {
          "Area": "Kalameshwar",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.3748,
          "Long": 78.8076
        },
        {
          "Area": "Kalamnuri",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.8318,
          "Long": 77.4936
        },
        {
          "Area": "Kalampur",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.9993,
          "Long": 83.1092
        },
        {
          "Area": "Kalan Wali",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.8369,
          "Long": 75.1386
        },
        {
          "Area": "Kalangangarpar",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1597,
          "Long": 92.0329
        },
        {
          "Area": "Kalanwali",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.8573,
          "Long": 75.203
        },
        {
          "Area": "Kalapahar",
          "State": "Manipur",
          "CountryCode": "IN",
          "Lat": 25.13,
          "Long": 93.9562
        },
        {
          "Area": "Kalapani",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.9923,
          "Long": 91.6205
        },
        {
          "Area": "Kalapathar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.6244,
          "Long": 86.8734
        },
        {
          "Area": "Kalapipal",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.8293,
          "Long": 76.8517
        },
        {
          "Area": "Kalapur",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.0839,
          "Long": 78.4424
        },
        {
          "Area": "Kalasapadu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.1077,
          "Long": 79.1688
        },
        {
          "Area": "Kalasbarh",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.1762,
          "Long": 87.6063
        },
        {
          "Area": "Kalavad",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.5216,
          "Long": 74.014
        },
        {
          "Area": "Kalayandurg",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.5942,
          "Long": 77.3048
        },
        {
          "Area": "Kalayat",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.814,
          "Long": 76.4182
        },
        {
          "Area": "Kalchini",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.8477,
          "Long": 89.4483
        },
        {
          "Area": "Kaler",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.1913,
          "Long": 84.9779
        },
        {
          "Area": "Kalgachia",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3592,
          "Long": 90.8711
        },
        {
          "Area": "Kalgahtagi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.1655,
          "Long": 75.1128
        },
        {
          "Area": "Kalgahtgi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.1933,
          "Long": 75.2653
        },
        {
          "Area": "Kalghatagi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.3894,
          "Long": 75.2653
        },
        {
          "Area": "Kalghatgi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.3894,
          "Long": 75.2653
        },
        {
          "Area": "Kaliabhomora",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.5735,
          "Long": 91.1499
        },
        {
          "Area": "Kaliabor",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.4868,
          "Long": 92.9697
        },
        {
          "Area": "Kaliacahak",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.5656,
          "Long": 87.9504
        },
        {
          "Area": "Kaliachak",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.418,
          "Long": 88.0923
        },
        {
          "Area": "Kaliachak Ii",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.2529,
          "Long": 88.039
        },
        {
          "Area": "Kaliachak-1",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.4514,
          "Long": 88.039
        },
        {
          "Area": "Kaliachak-i",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.99,
          "Long": 88.0221
        },
        {
          "Area": "Kaliachak-ii",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.0957,
          "Long": 88.039
        },
        {
          "Area": "Kaliachak-iii",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.4986,
          "Long": 87.9359
        },
        {
          "Area": "Kaliaganj",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.881,
          "Long": 88.1583
        },
        {
          "Area": "Kaliani",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.6856,
          "Long": 88.4668
        },
        {
          "Area": "Kalidindi",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.547,
          "Long": 81.3699
        },
        {
          "Area": "Kalidinid",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.5396,
          "Long": 81.2955
        },
        {
          "Area": "Kaliganj",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.3601,
          "Long": 88.5215
        },
        {
          "Area": "Kaligiri",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.0373,
          "Long": 79.7394
        },
        {
          "Area": "Kalikiri",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.3753,
          "Long": 79.299
        },
        {
          "Area": "Kalimela",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 18.6956,
          "Long": 82.5323
        },
        {
          "Area": "Kalimpong",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 27.1539,
          "Long": 88.6617
        },
        {
          "Area": "Kalimpong - II",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 27.0886,
          "Long": 88.5287
        },
        {
          "Area": "Kalimpong -I",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.9319,
          "Long": 88.9486
        },
        {
          "Area": "Kalinagar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3687,
          "Long": 88.562
        },
        {
          "Area": "Kalindi",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3703,
          "Long": 88.2092
        },
        {
          "Area": "Kalindi Teghari",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3703,
          "Long": 88.2092
        },
        {
          "Area": "Kalinga",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.2159,
          "Long": 84.415
        },
        {
          "Area": "Kalipur",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.7306,
          "Long": 91.5564
        },
        {
          "Area": "Kalisindh",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.4335,
          "Long": 76.5021
        },
        {
          "Area": "Kalitala",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.4323,
          "Long": 88.373
        },
        {
          "Area": "Kaliyaganj",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.881,
          "Long": 88.3266
        },
        {
          "Area": "Kaljar",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.54,
          "Long": 91.3489
        },
        {
          "Area": "Kalka",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 30.8398,
          "Long": 76.9406
        },
        {
          "Area": "Kalkulam",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 8.8335,
          "Long": 77.454
        },
        {
          "Area": "Kalla (mdl)",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.6353,
          "Long": 81.4718
        },
        {
          "Area": "Kallakkurichi",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.7524,
          "Long": 78.9779
        },
        {
          "Area": "Kallakurichi",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.9734,
          "Long": 79.2921
        },
        {
          "Area": "Kallam",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 18.9395,
          "Long": 76.3096
        },
        {
          "Area": "Kalligang",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.035,
          "Long": 88.0659
        },
        {
          "Area": "Kallur",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.5969,
          "Long": 80.6873
        },
        {
          "Area": "Kallur",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.8117,
          "Long": 78.659
        },
        {
          "Area": "Kalmapukhuria",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.033,
          "Long": 87.1722
        },
        {
          "Area": "Kalmeshwar",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.3101,
          "Long": 79.3574
        },
        {
          "Area": "Kalna",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.449,
          "Long": 88.4436
        },
        {
          "Area": "Kalna - I",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.7617,
          "Long": 88.3629
        },
        {
          "Area": "Kalna - II",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.2194,
          "Long": 88.3629
        },
        {
          "Area": "Kalol",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.8579,
          "Long": 73.6891
        },
        {
          "Area": "Kalpa(T)",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.5922,
          "Long": 78.2987
        },
        {
          "Area": "Kalpi",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.1824,
          "Long": 79.9172
        },
        {
          "Area": "Kalpi Road",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5167,
          "Long": 80.3155
        },
        {
          "Area": "Kalsi",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.9837,
          "Long": 87.635
        },
        {
          "Area": "Kaluahi",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.3464,
          "Long": 86.0206
        },
        {
          "Area": "Kalupur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.0762,
          "Long": 88.8272
        },
        {
          "Area": "Kaluvoya",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.5117,
          "Long": 79.7344
        },
        {
          "Area": "Kalwad",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.9288,
          "Long": 75.5852
        },
        {
          "Area": "Kalwakurhy",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.6436,
          "Long": 78.4367
        },
        {
          "Area": "Kalwakurthy",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.6436,
          "Long": 78.4825
        },
        {
          "Area": "Kalwan",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.6861,
          "Long": 74.6931
        },
        {
          "Area": "Kalwn",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.4355,
          "Long": 74.1537
        },
        {
          "Area": "Kalyan",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.0771,
          "Long": 77.1744
        },
        {
          "Area": "Kalyanasingpur",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 19.3623,
          "Long": 83.5138
        },
        {
          "Area": "Kalyandurg",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.7082,
          "Long": 78.0161
        },
        {
          "Area": "Kalyanpur",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.9225,
          "Long": 91.6031
        },
        {
          "Area": "Kalyanpur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5934,
          "Long": 80.9724
        },
        {
          "Area": "Kalyanpur",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.2522,
          "Long": 69.9137
        },
        {
          "Area": "Kalyanpur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.6184,
          "Long": 84.9846
        },
        {
          "Area": "Kalyanpur",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.2063,
          "Long": 72.9889
        },
        {
          "Area": "Kalyanpur Tentulmuri",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.8104,
          "Long": 87.448
        },
        {
          "Area": "Kamakhyanagar",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.1353,
          "Long": 85.8333
        },
        {
          "Area": "Kamakshyanagar",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.0773,
          "Long": 85.5467
        },
        {
          "Area": "Kamalapuram",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.6385,
          "Long": 78.9254
        },
        {
          "Area": "Kamalghat",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0447,
          "Long": 91.7553
        },
        {
          "Area": "Kamalpur",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3584,
          "Long": 91.7046
        },
        {
          "Area": "Kamalpur",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1959,
          "Long": 91.8344
        },
        {
          "Area": "Kamalpur Block",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.5263,
          "Long": 91.962
        },
        {
          "Area": "Kamalpur Block Taluk of Kamrup",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.0759,
          "Long": 91.3622
        },
        {
          "Area": "Kaman",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 27.5872,
          "Long": 77.3019
        },
        {
          "Area": "Kamania",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.0799,
          "Long": 76.0612
        },
        {
          "Area": "Kamanpur",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.8095,
          "Long": 79.3808
        },
        {
          "Area": "Kamarda Bazar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5034,
          "Long": 87.9832
        },
        {
          "Area": "Kamareddy",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.5261,
          "Long": 78.5737
        },
        {
          "Area": "Kamarkuchi",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.5004,
          "Long": 91.4784
        },
        {
          "Area": "Kamarposh Balang",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.9635,
          "Long": 85.0248
        },
        {
          "Area": "Kamavarapukota",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.9508,
          "Long": 81.1946
        },
        {
          "Area": "Kambadur",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.4811,
          "Long": 78.0161
        },
        {
          "Area": "Kambaduru",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.4443,
          "Long": 77.5902
        },
        {
          "Area": "Kambang",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 28.2358,
          "Long": 94.6634
        },
        {
          "Area": "Kambhamvaripalle",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.3753,
          "Long": 79.0143
        },
        {
          "Area": "Kamdara",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 23.2523,
          "Long": 85.0981
        },
        {
          "Area": "Kamdevkati",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8151,
          "Long": 88.4296
        },
        {
          "Area": "Kamdevpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.7572,
          "Long": 88.4556
        },
        {
          "Area": "Kamduni",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.5864,
          "Long": 88.4145
        },
        {
          "Area": "Kameswar",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0447,
          "Long": 91.7553
        },
        {
          "Area": "Kamkeilon",
          "State": "Manipur",
          "CountryCode": "IN",
          "Lat": 24.3884,
          "Long": 93.5819
        },
        {
          "Area": "Kamlang Nagar",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.7955,
          "Long": 96.1825
        },
        {
          "Area": "Kamlapur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.3805,
          "Long": 80.2158
        },
        {
          "Area": "Kamptee",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.3102,
          "Long": 79.4524
        },
        {
          "Area": "Kampur",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3504,
          "Long": 93.1671
        },
        {
          "Area": "Kamrej",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.042,
          "Long": 73.4336
        },
        {
          "Area": "Kamthi",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.4208,
          "Long": 79.5482
        },
        {
          "Area": "Kamudhi",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 9.6655,
          "Long": 78.6733
        },
        {
          "Area": "Kamudi",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 9.5016,
          "Long": 78.4357
        },
        {
          "Area": "Kamuthi",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 9.6655,
          "Long": 78.6733
        },
        {
          "Area": "Kanad",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.7037,
          "Long": 76.3458
        },
        {
          "Area": "Kanagala",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.2797,
          "Long": 79.3627
        },
        {
          "Area": "Kanaganapalle",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.4785,
          "Long": 77.5227
        },
        {
          "Area": "Kanaganapalli",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.8082,
          "Long": 78.0945
        },
        {
          "Area": "Kanaidighi",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3444,
          "Long": 87.9089
        },
        {
          "Area": "Kanakapaura",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 12.4506,
          "Long": 77.1895
        },
        {
          "Area": "Kanakapura",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.0925,
          "Long": 77.5459
        },
        {
          "Area": "Kanakpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.0208,
          "Long": 87.7744
        },
        {
          "Area": "Kanakvli",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 18.0062,
          "Long": 73.7666
        },
        {
          "Area": "Kanandala Bawada",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 18.0555,
          "Long": 73.9376
        },
        {
          "Area": "Kanayannoor",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 10.1131,
          "Long": 76.4032
        },
        {
          "Area": "Kanayannur",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 10.5833,
          "Long": 76.4727
        },
        {
          "Area": "Kanayanoor",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 10.1131,
          "Long": 76.2858
        },
        {
          "Area": "Kanchanbari",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1048,
          "Long": 92.0073
        },
        {
          "Area": "Kanchanpur",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.6526,
          "Long": 91.2372
        },
        {
          "Area": "Kancheepuram",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 13.1879,
          "Long": 79.9479
        },
        {
          "Area": "Kanchili Mandal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 19.016,
          "Long": 84.61
        },
        {
          "Area": "Kanchipuram",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 13.0198,
          "Long": 79.9479
        },
        {
          "Area": "Kanchrapara",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.37,
          "Long": 88.7803
        },
        {
          "Area": "Kanda",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.9999,
          "Long": 79.9978
        },
        {
          "Area": "Kandaghat",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.152,
          "Long": 77.2115
        },
        {
          "Area": "Kandagram",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.2088,
          "Long": 88.0387
        },
        {
          "Area": "Kandahr",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 18.9587,
          "Long": 77.298
        },
        {
          "Area": "Kandakhal",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.8923,
          "Long": 78.5371
        },
        {
          "Area": "Kandala Bawada",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 18.2491,
          "Long": 75.1056
        },
        {
          "Area": "Kandhar",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.8619,
          "Long": 77.8951
        },
        {
          "Area": "Kandhr",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.1973,
          "Long": 77.3601
        },
        {
          "Area": "Kandi",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.1612,
          "Long": 88.2538
        },
        {
          "Area": "Kandivali East",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.1624,
          "Long": 72.8694
        },
        {
          "Area": "Kandivali West",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.1699,
          "Long": 72.8504
        },
        {
          "Area": "Kandivlai West",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.1699,
          "Long": 72.8504
        },
        {
          "Area": "Kandra",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 22.8517,
          "Long": 86.0519
        },
        {
          "Area": "Kandukur",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.4844,
          "Long": 78.0129
        },
        {
          "Area": "Kandukur",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.128,
          "Long": 80.2015
        },
        {
          "Area": "Kandukur H.O",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.1461,
          "Long": 79.9397
        },
        {
          "Area": "Kanekal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.9459,
          "Long": 77.5768
        },
        {
          "Area": "Kanera",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 24.9632,
          "Long": 74.6857
        },
        {
          "Area": "Kang",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.515,
          "Long": 75.0132
        },
        {
          "Area": "Kangan",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.2652,
          "Long": 74.9418
        },
        {
          "Area": "Kangara",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.0623,
          "Long": 76.2523
        },
        {
          "Area": "Kangayam",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.5152,
          "Long": 78.1161
        },
        {
          "Area": "Kangeyam",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.5152,
          "Long": 78.1161
        },
        {
          "Area": "Kangpokpi",
          "State": "Manipur",
          "CountryCode": "IN",
          "Lat": 25.1964,
          "Long": 93.9334
        },
        {
          "Area": "Kangra",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.2069,
          "Long": 76.4215
        },
        {
          "Area": "Kangra(T)",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.2038,
          "Long": 76.4518
        },
        {
          "Area": "Kangrai",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1597,
          "Long": 92.0329
        },
        {
          "Area": "Kanidagan",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.8463,
          "Long": 74.8035
        },
        {
          "Area": "Kanigiri",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.04,
          "Long": 80.1683
        },
        {
          "Area": "Kaniha",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.8558,
          "Long": 84.7414
        },
        {
          "Area": "Kanihama",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.14,
          "Long": 74.7964
        },
        {
          "Area": "Kanina",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.3309,
          "Long": 76.311
        },
        {
          "Area": "Kanina Mandi",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.4013,
          "Long": 76.373
        },
        {
          "Area": "Kanipakam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 13.851,
          "Long": 79.0602
        },
        {
          "Area": "Kanjirapally",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 9.5982,
          "Long": 76.8856
        },
        {
          "Area": "Kanjirappally",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 9.6371,
          "Long": 76.8894
        },
        {
          "Area": "Kankal I",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.5947,
          "Long": 74.1045
        },
        {
          "Area": "Kankalvi",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.5947,
          "Long": 74.1045
        },
        {
          "Area": "Kankavi",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.5947,
          "Long": 74.1045
        },
        {
          "Area": "Kankavli",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.5947,
          "Long": 78.6173
        },
        {
          "Area": "Kanke",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 23.6051,
          "Long": 85.3594
        },
        {
          "Area": "Kanker",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 20.6224,
          "Long": 81.7797
        },
        {
          "Area": "Kankinara",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8628,
          "Long": 88.3981
        },
        {
          "Area": "Kankipadu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.5627,
          "Long": 80.8351
        },
        {
          "Area": "Kankraj",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 24.2143,
          "Long": 72.4851
        },
        {
          "Area": "Kankrej",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 24.2835,
          "Long": 72.3628
        },
        {
          "Area": "Kankroli",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.355,
          "Long": 74.032
        },
        {
          "Area": "Kanksa",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.2028,
          "Long": 88.0871
        },
        {
          "Area": "Kankurgachi",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.3945,
          "Long": 88.2559
        },
        {
          "Area": "Kanmari",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3687,
          "Long": 88.562
        },
        {
          "Area": "Kannad",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.4635,
          "Long": 75.5551
        },
        {
          "Area": "Kannapuram",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.2119,
          "Long": 81.4635
        },
        {
          "Area": "Kannauj",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.284,
          "Long": 80.3217
        },
        {
          "Area": "Kannaura",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.359,
          "Long": 76.6377
        },
        {
          "Area": "Kannod",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.8077,
          "Long": 76.8867
        },
        {
          "Area": "Kannur",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 12.2886,
          "Long": 76.1313
        },
        {
          "Area": "Kanpu Dehat",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.4448,
          "Long": 79.8571
        },
        {
          "Area": "Kanpur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.7443,
          "Long": 80.9724
        },
        {
          "Area": "Kanpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4143,
          "Long": 87.267
        },
        {
          "Area": "Kanpur  Dehat",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.7443,
          "Long": 79.872
        },
        {
          "Area": "Kanpur Cantt.",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5167,
          "Long": 80.3155
        },
        {
          "Area": "Kanpur Court",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5442,
          "Long": 80.1097
        },
        {
          "Area": "Kanpur Dehat",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.11,
          "Long": 80.1924
        },
        {
          "Area": "Kanpur Dehta",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.8716,
          "Long": 79.8571
        },
        {
          "Area": "Kanpur Dheat",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.3587,
          "Long": 79.6848
        },
        {
          "Area": "Kanpur Nagar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.4092,
          "Long": 80.3149
        },
        {
          "Area": "Kantabagan",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.1454,
          "Long": 88.6128
        },
        {
          "Area": "Kantabanji",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.0617,
          "Long": 83.4882
        },
        {
          "Area": "Kantai",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.2758,
          "Long": 88.831
        },
        {
          "Area": "Kantamal",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.6582,
          "Long": 83.751
        },
        {
          "Area": "Kanth",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 29.0201,
          "Long": 78.5556
        },
        {
          "Area": "Kanthalia",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3029,
          "Long": 87.818
        },
        {
          "Area": "Kanti",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.6395,
          "Long": 80.4439
        },
        {
          "Area": "Kanti",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.0482,
          "Long": 76.3098
        },
        {
          "Area": "Kanti",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.2708,
          "Long": 85.4379
        },
        {
          "Area": "Kanti Kheri",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.2242,
          "Long": 76.5554
        },
        {
          "Area": "Kanturka",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.0119,
          "Long": 87.5938
        },
        {
          "Area": "Kanubari",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.0217,
          "Long": 95.5368
        },
        {
          "Area": "Kanwali",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.3116,
          "Long": 76.4113
        },
        {
          "Area": "Kanwi",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.0799,
          "Long": 76.0612
        },
        {
          "Area": "Kapadvanj",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.1198,
          "Long": 73.163
        },
        {
          "Area": "Kapadwanj",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.1198,
          "Long": 73.2209
        },
        {
          "Area": "Kapasan",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.1421,
          "Long": 74.7797
        },
        {
          "Area": "Kapileswarapuram",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.4522,
          "Long": 82.206
        },
        {
          "Area": "Kapileswarpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4948,
          "Long": 88.4232
        },
        {
          "Area": "Kapkote",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.1132,
          "Long": 79.9911
        },
        {
          "Area": "Kaplabari",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.263,
          "Long": 91.3011
        },
        {
          "Area": "Kaprada",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 21.7065,
          "Long": 73.4056
        },
        {
          "Area": "Kaprin",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.9509,
          "Long": 75.0932
        },
        {
          "Area": "Kapurthala",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.6389,
          "Long": 75.5666
        },
        {
          "Area": "Karad",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.9402,
          "Long": 77.2104
        },
        {
          "Area": "Karad.",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 17.3385,
          "Long": 74.1102
        },
        {
          "Area": "Karahal",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 25.7525,
          "Long": 77.3573
        },
        {
          "Area": "Karahal",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.2756,
          "Long": 79.2173
        },
        {
          "Area": "Karaicherra",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1597,
          "Long": 92.0329
        },
        {
          "Area": "Karaikal",
          "State": "Pondicherry",
          "CountryCode": "IN",
          "Lat": 10.9709,
          "Long": 79.792
        },
        {
          "Area": "Karaikkudi",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.0514,
          "Long": 78.8387
        },
        {
          "Area": "Karaikudi",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.1856,
          "Long": 78.8254
        },
        {
          "Area": "Karaikudi -kallal Block",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.0613,
          "Long": 78.7189
        },
        {
          "Area": "Karaikudi -sakkottai Block",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.1096,
          "Long": 78.7956
        },
        {
          "Area": "Karaikudi--sakkottai Block",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.1461,
          "Long": 78.8031
        },
        {
          "Area": "Karaikudi-kallal Block",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.0619,
          "Long": 78.7198
        },
        {
          "Area": "Karaikudi-kallalblock",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.081,
          "Long": 78.7448
        },
        {
          "Area": "Karaikudi-sakkottai Block",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.1856,
          "Long": 78.8254
        },
        {
          "Area": "Karaikudi-sakkottaiblock",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.0927,
          "Long": 78.8551
        },
        {
          "Area": "Karailong",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.007,
          "Long": 91.6093
        },
        {
          "Area": "Karaipersurai",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.4122,
          "Long": 85.4559
        },
        {
          "Area": "Karakat",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.1578,
          "Long": 84.3549
        },
        {
          "Area": "Karaldanimakbarh",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3564,
          "Long": 87.8021
        },
        {
          "Area": "Karamcherra",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1597,
          "Long": 92.0329
        },
        {
          "Area": "Karan Nagar",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.14,
          "Long": 74.7964
        },
        {
          "Area": "Karandighi",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.0557,
          "Long": 88.1583
        },
        {
          "Area": "Karanga",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5022,
          "Long": 88.5404
        },
        {
          "Area": "Karanja",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.2277,
          "Long": 78.6062
        },
        {
          "Area": "Karanjali",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.0184,
          "Long": 88.2409
        },
        {
          "Area": "Karanji",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4761,
          "Long": 86.8761
        },
        {
          "Area": "Karanjia",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 22.1013,
          "Long": 86.4112
        },
        {
          "Area": "Karanprayag",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.5152,
          "Long": 79.9315
        },
        {
          "Area": "Karapa",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.5047,
          "Long": 82.6784
        },
        {
          "Area": "Karari",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.4524,
          "Long": 81.4268
        },
        {
          "Area": "Karatampadu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.7,
          "Long": 79.7344
        },
        {
          "Area": "Karaticherra",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.9923,
          "Long": 91.6205
        },
        {
          "Area": "Karaui",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.8449,
          "Long": 76.815
        },
        {
          "Area": "Karauli",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.8098,
          "Long": 77.4669
        },
        {
          "Area": "Karawara",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.359,
          "Long": 76.6377
        },
        {
          "Area": "Karbigawan",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.3801,
          "Long": 80.4141
        },
        {
          "Area": "Karchana",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.5513,
          "Long": 82.1435
        },
        {
          "Area": "Karchhana",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.6986,
          "Long": 82.3492
        },
        {
          "Area": "Kareli",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.1148,
          "Long": 79.2539
        },
        {
          "Area": "Karempudi",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.524,
          "Long": 79.7483
        },
        {
          "Area": "Karemura",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3679,
          "Long": 91.3877
        },
        {
          "Area": "Karepalli",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.5969,
          "Long": 80.9944
        },
        {
          "Area": "Karera",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 25.6889,
          "Long": 78.4711
        },
        {
          "Area": "Kargahar",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.9794,
          "Long": 84.0277
        },
        {
          "Area": "Kargi Road",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 22.4087,
          "Long": 82.0367
        },
        {
          "Area": "Kargil",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.6569,
          "Long": 76.6138
        },
        {
          "Area": "Kargil Kargil",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.5099,
          "Long": 76.4496
        },
        {
          "Area": "Kargil; Kargil",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.5099,
          "Long": 76.4496
        },
        {
          "Area": "Kargiroad",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 22.374,
          "Long": 82.2221
        },
        {
          "Area": "Kargl",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.9666,
          "Long": 76.4845
        },
        {
          "Area": "Karhal",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.2183,
          "Long": 79.191
        },
        {
          "Area": "Karia",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3796,
          "Long": 91.2951
        },
        {
          "Area": "Kariapatti",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 9.7403,
          "Long": 78.2759
        },
        {
          "Area": "Karimanj",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 24.8513,
          "Long": 92.3148
        },
        {
          "Area": "Karimganj",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 24.8373,
          "Long": 92.4926
        },
        {
          "Area": "Karimnagar",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.5687,
          "Long": 79.3396
        },
        {
          "Area": "Karimpur I",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.9808,
          "Long": 88.7197
        },
        {
          "Area": "Karimpur Ii",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.6783,
          "Long": 88.5469
        },
        {
          "Area": "Karimpur Ii (mohisbatan)",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.1253,
          "Long": 88.5469
        },
        {
          "Area": "Karjan",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.7845,
          "Long": 73.5319
        },
        {
          "Area": "Karjat",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.1496,
          "Long": 76.5883
        },
        {
          "Area": "Karkal",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.4922,
          "Long": 75.1335
        },
        {
          "Area": "Karkala",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.698,
          "Long": 75.5532
        },
        {
          "Area": "Karlamunda",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.2398,
          "Long": 83.2569
        },
        {
          "Area": "Karlapalem",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.9702,
          "Long": 80.5856
        },
        {
          "Area": "Karma",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.3742,
          "Long": 85.2421
        },
        {
          "Area": "Karmala",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.4314,
          "Long": 75.5692
        },
        {
          "Area": "Karmalaa",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.4314,
          "Long": 75.4829
        },
        {
          "Area": "Karnal",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.842,
          "Long": 77.1008
        },
        {
          "Area": "Karnal'karnal",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.6247,
          "Long": 77.0141
        },
        {
          "Area": "Karnawas",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.1281,
          "Long": 76.6053
        },
        {
          "Area": "Karnolkora",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8337,
          "Long": 88.8136
        },
        {
          "Area": "Karnprayag",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.4953,
          "Long": 79.5787
        },
        {
          "Area": "Karoli",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.1729,
          "Long": 76.1432
        },
        {
          "Area": "Karon",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.4442,
          "Long": 86.8177
        },
        {
          "Area": "Karong",
          "State": "Manipur",
          "CountryCode": "IN",
          "Lat": 25.3034,
          "Long": 94.044
        },
        {
          "Area": "Karota",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.0799,
          "Long": 76.0612
        },
        {
          "Area": "Karpi",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.3417,
          "Long": 85.1093
        },
        {
          "Area": "Karra",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 23.3313,
          "Long": 85.3708
        },
        {
          "Area": "Karsog",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.6383,
          "Long": 77.3549
        },
        {
          "Area": "Karsog(T)",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.9851,
          "Long": 77.3227
        },
        {
          "Area": "Karsontala",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.7887,
          "Long": 92.965
        },
        {
          "Area": "Karthikapally",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 9.1223,
          "Long": 76.5315
        },
        {
          "Area": "Karthikappally",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 10.6098,
          "Long": 76.5933
        },
        {
          "Area": "Kartikkhali",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.8532,
          "Long": 87.9147
        },
        {
          "Area": "Karunagapally",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 9.1348,
          "Long": 76.5933
        },
        {
          "Area": "Karunagappally",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 9.1348,
          "Long": 76.7631
        },
        {
          "Area": "Karunagappaly",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 9.4277,
          "Long": 76.4746
        },
        {
          "Area": "Karur",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.5431,
          "Long": 78.2172
        },
        {
          "Area": "Karveer",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.4627,
          "Long": 77.2373
        },
        {
          "Area": "Karveern",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.4627,
          "Long": 77.1326
        },
        {
          "Area": "Karvetinagar",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 13.353,
          "Long": 79.4219
        },
        {
          "Area": "Karvir",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.4627,
          "Long": 77.2373
        },
        {
          "Area": "Karwar",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.9074,
          "Long": 74.8009
        },
        {
          "Area": "Kasaragod",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 12.761,
          "Long": 75.2729
        },
        {
          "Area": "Kasarawad",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.2065,
          "Long": 76.9845
        },
        {
          "Area": "Kasaria",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.8532,
          "Long": 87.9147
        },
        {
          "Area": "Kasauli",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 30.9284,
          "Long": 77.0472
        },
        {
          "Area": "Kasauli(T)",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 30.9635,
          "Long": 77.1628
        },
        {
          "Area": "Kasbagola",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.8104,
          "Long": 87.448
        },
        {
          "Area": "Kasdol",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.6782,
          "Long": 82.521
        },
        {
          "Area": "Kasganj",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.9092,
          "Long": 80.0793
        },
        {
          "Area": "Kashi Chak",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.1894,
          "Long": 84.9684
        },
        {
          "Area": "Kashichak",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.087,
          "Long": 85.7562
        },
        {
          "Area": "Kashimpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.3249,
          "Long": 87.9524
        },
        {
          "Area": "Kashinagar",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 18.8954,
          "Long": 83.9012
        },
        {
          "Area": "Kashinagar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.7771,
          "Long": 88.4393
        },
        {
          "Area": "Kashinagara",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 19.1734,
          "Long": 84.1607
        },
        {
          "Area": "Kashinathpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.5864,
          "Long": 88.4145
        },
        {
          "Area": "Kashipur",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.3334,
          "Long": 79.5235
        },
        {
          "Area": "Kashipur",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 19.464,
          "Long": 83.5138
        },
        {
          "Area": "Kashipur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.7322,
          "Long": 87.8261
        },
        {
          "Area": "Kashmir University",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.1621,
          "Long": 74.8647
        },
        {
          "Area": "Kasia",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.6626,
          "Long": 83.7723
        },
        {
          "Area": "Kasigaon",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.3843,
          "Long": 80.3275
        },
        {
          "Area": "Kasmar",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 23.6035,
          "Long": 85.9745
        },
        {
          "Area": "Kasrawad",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.1317,
          "Long": 76.6971
        },
        {
          "Area": "Katakamsandi",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.0641,
          "Long": 85.2798
        },
        {
          "Area": "Katalutma",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0789,
          "Long": 91.8987
        },
        {
          "Area": "Katangi",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 21.9215,
          "Long": 80.0987
        },
        {
          "Area": "Kataram",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.1921,
          "Long": 79.5066
        },
        {
          "Area": "Katarbaga",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.766,
          "Long": 84.1406
        },
        {
          "Area": "Katghora",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 22.954,
          "Long": 82.7005
        },
        {
          "Area": "Katgi",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.7254,
          "Long": 82.6092
        },
        {
          "Area": "Kathalapur",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.7337,
          "Long": 79.2409
        },
        {
          "Area": "Kathalcherra",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1048,
          "Long": 92.0073
        },
        {
          "Area": "Kathalia",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.3481,
          "Long": 91.3204
        },
        {
          "Area": "Kathara",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.3027,
          "Long": 80.221
        },
        {
          "Area": "Katherua",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.1628,
          "Long": 80.5482
        },
        {
          "Area": "Kathi Darwaza",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.4307,
          "Long": 74.8979
        },
        {
          "Area": "Kathikiund",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.3197,
          "Long": 87.2666
        },
        {
          "Area": "Kathikund",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.4,
          "Long": 87.545
        },
        {
          "Area": "Kathlal",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.3601,
          "Long": 73.1468
        },
        {
          "Area": "Kathongar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.3594,
          "Long": 80.3401
        },
        {
          "Area": "Kathua",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 32.798,
          "Long": 75.6194
        },
        {
          "Area": "Kathumar",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 27.3478,
          "Long": 76.595
        },
        {
          "Area": "Kathunanagal",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.7031,
          "Long": 75.0357
        },
        {
          "Area": "Kathunangal",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.7432,
          "Long": 75.0801
        },
        {
          "Area": "Kathur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.6191,
          "Long": 88.8788
        },
        {
          "Area": "Katiahat",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5239,
          "Long": 87.8703
        },
        {
          "Area": "Katihar",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.8602,
          "Long": 87.9774
        },
        {
          "Area": "Katka Debichak",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.8532,
          "Long": 87.9147
        },
        {
          "Area": "Katkamsandi",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.0855,
          "Long": 85.3453
        },
        {
          "Area": "Katni",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.9619,
          "Long": 80.7916
        },
        {
          "Area": "Katol",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.3618,
          "Long": 79.0336
        },
        {
          "Area": "Katoria",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.0498,
          "Long": 86.9071
        },
        {
          "Area": "Katpadi",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 13.1276,
          "Long": 79.7691
        },
        {
          "Area": "Katra",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.576,
          "Long": 85.7511
        },
        {
          "Area": "Katra",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.2398,
          "Long": 75.0799
        },
        {
          "Area": "Katranka",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3836,
          "Long": 87.8747
        },
        {
          "Area": "Katrasoo",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.9563,
          "Long": 74.834
        },
        {
          "Area": "Katrenikona",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.1885,
          "Long": 82.1528
        },
        {
          "Area": "Katrenikona Mandal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.5826,
          "Long": 82.1528
        },
        {
          "Area": "Kattmannarkoil",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.476,
          "Long": 79.5623
        },
        {
          "Area": "Kattumanarkoil",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.4248,
          "Long": 79.4875
        },
        {
          "Area": "Kattumannarkioil",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.3463,
          "Long": 79.4373
        },
        {
          "Area": "Kattumannarkoil",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.7497,
          "Long": 79.6269
        },
        {
          "Area": "Kattummannarkoil",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.3361,
          "Long": 79.4755
        },
        {
          "Area": "Katuru",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.4413,
          "Long": 80.8788
        },
        {
          "Area": "Katwa",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.2174,
          "Long": 88.4436
        },
        {
          "Area": "Katwa - I",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.2174,
          "Long": 88.3634
        },
        {
          "Area": "Katwa - II",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.2174,
          "Long": 87.9944
        },
        {
          "Area": "Kauli",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.7306,
          "Long": 91.5564
        },
        {
          "Area": "Kaushalpuri",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.0884,
          "Long": 81.7153
        },
        {
          "Area": "Kavali",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.1899,
          "Long": 80.0762
        },
        {
          "Area": "Kavaratti HO",
          "State": "Lakshadweep",
          "CountryCode": "IN",
          "Lat": 10.0826,
          "Long": 73.6432
        },
        {
          "Area": "Kavas",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.2631,
          "Long": 71.7262
        },
        {
          "Area": "Kavathe Mahankal",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 18.906,
          "Long": 76.5271
        },
        {
          "Area": "Kaveripattinam",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 12.4219,
          "Long": 78.2188
        },
        {
          "Area": "Kaviti",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.7179,
          "Long": 84.1331
        },
        {
          "Area": "Kaviti Mandal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.8941,
          "Long": 84.1331
        },
        {
          "Area": "Kavthe Mahankal",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 18.6366,
          "Long": 75.9463
        },
        {
          "Area": "Kawakol",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.0163,
          "Long": 86.0604
        },
        {
          "Area": "Kawant",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.2331,
          "Long": 74.079
        },
        {
          "Area": "Kawardha",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 22.0282,
          "Long": 82.776
        },
        {
          "Area": "Kawnpui",
          "State": "Mizoram",
          "CountryCode": "IN",
          "Lat": 24.0219,
          "Long": 92.7346
        },
        {
          "Area": "Kayemgeria",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3444,
          "Long": 87.9089
        },
        {
          "Area": "Kaying",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 28.4116,
          "Long": 94.6805
        },
        {
          "Area": "Kealras",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 26.4138,
          "Long": 77.8688
        },
        {
          "Area": "Kekai",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.8386,
          "Long": 88.171
        },
        {
          "Area": "Kekankuchi",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.263,
          "Long": 91.3011
        },
        {
          "Area": "Kekri",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.1043,
          "Long": 75.3081
        },
        {
          "Area": "Kelapur",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.3329,
          "Long": 78.7024
        },
        {
          "Area": "Kelaras",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 26.3286,
          "Long": 77.7529
        },
        {
          "Area": "Keller",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.9304,
          "Long": 74.71
        },
        {
          "Area": "Keller Mastpora",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.8463,
          "Long": 74.8035
        },
        {
          "Area": "Kenda",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.274,
          "Long": 86.4902
        },
        {
          "Area": "Kendrapara",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.6147,
          "Long": 86.6097
        },
        {
          "Area": "Kendujhar Town",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.3455,
          "Long": 85.2354
        },
        {
          "Area": "Kendukuchi",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.5004,
          "Long": 91.4784
        },
        {
          "Area": "Keolari",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.6912,
          "Long": 80.0756
        },
        {
          "Area": "Keonjhar",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.8654,
          "Long": 85.7667
        },
        {
          "Area": "Keragarh",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.8064,
          "Long": 77.472
        },
        {
          "Area": "Kerakat",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.2088,
          "Long": 83.4198
        },
        {
          "Area": "Kerameri",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 19.4583,
          "Long": 79.1132
        },
        {
          "Area": "Kesa Colony",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5167,
          "Long": 80.3155
        },
        {
          "Area": "Kesamudram",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.9968,
          "Long": 79.9278
        },
        {
          "Area": "Kesaria",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.384,
          "Long": 84.8003
        },
        {
          "Area": "Kesath",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.6934,
          "Long": 84.6106
        },
        {
          "Area": "Keshampet",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.1958,
          "Long": 78.3437
        },
        {
          "Area": "Keshiapada",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.2471,
          "Long": 87.8066
        },
        {
          "Area": "Keshiary",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.1167,
          "Long": 87.2345
        },
        {
          "Area": "Keshkal",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 20.4399,
          "Long": 81.8569
        },
        {
          "Area": "Keshod",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.9236,
          "Long": 71.0883
        },
        {
          "Area": "Keshpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8464,
          "Long": 88.1806
        },
        {
          "Area": "Keshrambha",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3836,
          "Long": 87.8747
        },
        {
          "Area": "Kesinga",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.4276,
          "Long": 83.3835
        },
        {
          "Area": "Kesli",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.6327,
          "Long": 78.9389
        },
        {
          "Area": "Kesrisinghpur",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 30.122,
          "Long": 74.0525
        },
        {
          "Area": "Ketekibari",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.6833,
          "Long": 92.65
        },
        {
          "Area": "Ketugram",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.9378,
          "Long": 87.979
        },
        {
          "Area": "Ketugram - I",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.7617,
          "Long": 88.1497
        },
        {
          "Area": "Ketugram - II",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.7617,
          "Long": 87.979
        },
        {
          "Area": "Ketugram-I",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.766,
          "Long": 88.3634
        },
        {
          "Area": "Keunchia",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.8532,
          "Long": 87.9147
        },
        {
          "Area": "Keut Khalisa",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.9467,
          "Long": 87.4938
        },
        {
          "Area": "Keutgeria",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3159,
          "Long": 88.0212
        },
        {
          "Area": "Khacharod",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.4106,
          "Long": 79.0409
        },
        {
          "Area": "Khachraud",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.4106,
          "Long": 79.0409
        },
        {
          "Area": "Khadgawan",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 23.1316,
          "Long": 82.2859
        },
        {
          "Area": "Khadoor Sahib",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.7046,
          "Long": 75.3236
        },
        {
          "Area": "Khagaria",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.7049,
          "Long": 86.8097
        },
        {
          "Area": "Khagda",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.871,
          "Long": 88.0316
        },
        {
          "Area": "Khagrabari",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.4211,
          "Long": 91.7374
        },
        {
          "Area": "Khagual",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.6341,
          "Long": 84.9787
        },
        {
          "Area": "Khain",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.2426,
          "Long": 81.9857
        },
        {
          "Area": "Khaira",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.8804,
          "Long": 86.2703
        },
        {
          "Area": "Khaira",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.6541,
          "Long": 85.6193
        },
        {
          "Area": "Khaira Bo",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.839,
          "Long": 86.1605
        },
        {
          "Area": "Khairagarh",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.4666,
          "Long": 81.1206
        },
        {
          "Area": "Khairagarh Raj",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.4364,
          "Long": 80.9137
        },
        {
          "Area": "Khairatabad",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.5902,
          "Long": 78.6839
        },
        {
          "Area": "Khairlanji",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 21.8808,
          "Long": 80.3606
        },
        {
          "Area": "Khajani",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.8146,
          "Long": 83.6044
        },
        {
          "Area": "Khajauli",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.4481,
          "Long": 86.2027
        },
        {
          "Area": "Khajipet",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.7163,
          "Long": 78.7836
        },
        {
          "Area": "Khajni",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.6827,
          "Long": 83.593
        },
        {
          "Area": "Khajuriapada",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.1289,
          "Long": 84.0472
        },
        {
          "Area": "Khajuripada",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.5125,
          "Long": 84.5997
        },
        {
          "Area": "Khajuripda",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.6756,
          "Long": 84.3379
        },
        {
          "Area": "Khajuwala",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 28.4499,
          "Long": 73.7978
        },
        {
          "Area": "Khaknar",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 21.8887,
          "Long": 76.7721
        },
        {
          "Area": "Khakurda",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3564,
          "Long": 87.8021
        },
        {
          "Area": "Khalapur",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.6919,
          "Long": 75.4244
        },
        {
          "Area": "Khaleta",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.2301,
          "Long": 76.4189
        },
        {
          "Area": "Khalihamari",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.5735,
          "Long": 91.1499
        },
        {
          "Area": "Khalikote",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.5861,
          "Long": 85.4897
        },
        {
          "Area": "Khalilabad",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.9509,
          "Long": 83.1277
        },
        {
          "Area": "Khalilpur",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.2747,
          "Long": 76.6806
        },
        {
          "Area": "Khalina",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8223,
          "Long": 87.5059
        },
        {
          "Area": "Khalisabhanga",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5034,
          "Long": 87.9832
        },
        {
          "Area": "Khalisadi",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4784,
          "Long": 88.5822
        },
        {
          "Area": "Khalitpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.6259,
          "Long": 88.6827
        },
        {
          "Area": "Khallikote",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.5861,
          "Long": 85.4897
        },
        {
          "Area": "Khalra",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.7046,
          "Long": 74.9007
        },
        {
          "Area": "Khalsi",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.3128,
          "Long": 76.8427
        },
        {
          "Area": "Khamanon",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 30.8845,
          "Long": 76.3908
        },
        {
          "Area": "Khamanoo",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 30.6688,
          "Long": 76.4594
        },
        {
          "Area": "Khamar",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.2481,
          "Long": 85.2138
        },
        {
          "Area": "Khamargachi",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.1986,
          "Long": 88.3369
        },
        {
          "Area": "Khambha",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 21.3025,
          "Long": 71.2805
        },
        {
          "Area": "Khambhalia",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.6247,
          "Long": 70.534
        },
        {
          "Area": "Khambhat",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.9129,
          "Long": 73.4062
        },
        {
          "Area": "Khamgaon",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.9449,
          "Long": 77.0388
        },
        {
          "Area": "Khamgoan",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.9449,
          "Long": 76.8346
        },
        {
          "Area": "Khammam",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.5969,
          "Long": 80.6873
        },
        {
          "Area": "Khammam (Urban)",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.3428,
          "Long": 79.9044
        },
        {
          "Area": "Khamnore",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.2163,
          "Long": 73.8923
        },
        {
          "Area": "Khanabal",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.7423,
          "Long": 75.1356
        },
        {
          "Area": "Khanakul",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.2246,
          "Long": 87.7621
        },
        {
          "Area": "Khanakul 1b",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8847,
          "Long": 88.0798
        },
        {
          "Area": "Khanakul 2b",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.0611,
          "Long": 88.0798
        },
        {
          "Area": "Khanakul I.b",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8283,
          "Long": 88.0778
        },
        {
          "Area": "Khanakul-1b",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.2246,
          "Long": 88.0778
        },
        {
          "Area": "Khanakul-2b",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.2246,
          "Long": 88.1608
        },
        {
          "Area": "Khanakul-i",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.8847,
          "Long": 88.4803
        },
        {
          "Area": "Khanakul2b",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.0611,
          "Long": 87.8823
        },
        {
          "Area": "Khanapur",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 19.2697,
          "Long": 78.8645
        },
        {
          "Area": "Khanapur",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.076,
          "Long": 75.1058
        },
        {
          "Area": "Khanapur",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 16.1195,
          "Long": 75.623
        },
        {
          "Area": "Khandaghosh",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.6524,
          "Long": 88.0746
        },
        {
          "Area": "Khandala",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 18.848,
          "Long": 75.9876
        },
        {
          "Area": "Khandala Bawada",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 18.2491,
          "Long": 75.1056
        },
        {
          "Area": "Khandala Bawada.",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 18.2491,
          "Long": 75.1056
        },
        {
          "Area": "Khandalabavada",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 18.2491,
          "Long": 75.1056
        },
        {
          "Area": "Khandalabawada",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 18.2491,
          "Long": 75.1056
        },
        {
          "Area": "Khandapara",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.8454,
          "Long": 85.2276
        },
        {
          "Area": "Khandaparagarh",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.4565,
          "Long": 85.2448
        },
        {
          "Area": "Khandapra",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.1631,
          "Long": 85.0355
        },
        {
          "Area": "Khandar",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.7301,
          "Long": 76.8551
        },
        {
          "Area": "Khandora",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.0487,
          "Long": 76.4705
        },
        {
          "Area": "Khandwa",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.2698,
          "Long": 76.577
        },
        {
          "Area": "Khaniadhana",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 25.6224,
          "Long": 78.2361
        },
        {
          "Area": "Khanjarpur",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.8102,
          "Long": 77.601
        },
        {
          "Area": "Khanna",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 30.8087,
          "Long": 76.3022
        },
        {
          "Area": "Khanpur",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.395,
          "Long": 73.6483
        },
        {
          "Area": "Khanpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.9655,
          "Long": 88.1729
        },
        {
          "Area": "Khanpur Hubaspur 165",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.4058,
          "Long": 87.9036
        },
        {
          "Area": "Khapra Mohal",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5167,
          "Long": 80.3155
        },
        {
          "Area": "Khaprakhol",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.6862,
          "Long": 82.726
        },
        {
          "Area": "Khar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.8995,
          "Long": 87.5379
        },
        {
          "Area": "Kharagpur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.7649,
          "Long": 85.2588
        },
        {
          "Area": "Kharagpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.2838,
          "Long": 88.7326
        },
        {
          "Area": "Kharagpur-I",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.6386,
          "Long": 88.4458
        },
        {
          "Area": "Kharampur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4653,
          "Long": 88.7803
        },
        {
          "Area": "Kharar",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.0594,
          "Long": 76.6697
        },
        {
          "Area": "Kharba",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.426,
          "Long": 88.0689
        },
        {
          "Area": "Khargapur",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 25.1138,
          "Long": 79.3184
        },
        {
          "Area": "Khargone",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.0629,
          "Long": 76.751
        },
        {
          "Area": "Khargram",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.6147,
          "Long": 87.9905
        },
        {
          "Area": "Khariar",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.6196,
          "Long": 83.3929
        },
        {
          "Area": "Khariar Road",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.9284,
          "Long": 82.6622
        },
        {
          "Area": "Kharibari",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.6827,
          "Long": 88.22
        },
        {
          "Area": "Kharihatabad",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3687,
          "Long": 88.562
        },
        {
          "Area": "Kharik",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.4271,
          "Long": 87.0196
        },
        {
          "Area": "Kharik Bazar",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.4271,
          "Long": 87.0196
        },
        {
          "Area": "Kharikamathani",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.033,
          "Long": 87.1722
        },
        {
          "Area": "Kharikbazar",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.4271,
          "Long": 87.0844
        },
        {
          "Area": "Kharkhara",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.1963,
          "Long": 76.767
        },
        {
          "Area": "Kharkhoda",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.8787,
          "Long": 76.9107
        },
        {
          "Area": "Kharod",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 22.0552,
          "Long": 82.7379
        },
        {
          "Area": "Kharora",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.6597,
          "Long": 82.5308
        },
        {
          "Area": "Kharsang",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.4545,
          "Long": 96.09
        },
        {
          "Area": "Kharsawangarh",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 22.7909,
          "Long": 85.831
        },
        {
          "Area": "Kharsia",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 22.0858,
          "Long": 83.306
        },
        {
          "Area": "Kharsitha",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.4526,
          "Long": 91.3843
        },
        {
          "Area": "Kharua",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3679,
          "Long": 91.3877
        },
        {
          "Area": "Kharua Rajapur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.1465,
          "Long": 88.1117
        },
        {
          "Area": "Kharuigarh",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.8995,
          "Long": 87.5379
        },
        {
          "Area": "Kharupala",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4784,
          "Long": 88.5822
        },
        {
          "Area": "Kharupetiaghat",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.6589,
          "Long": 92.4784
        },
        {
          "Area": "Khasbalanda",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.5947,
          "Long": 88.6869
        },
        {
          "Area": "Khasiamangal",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.007,
          "Long": 91.6093
        },
        {
          "Area": "Khatav",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.4018,
          "Long": 75.5209
        },
        {
          "Area": "Khategaon",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.8806,
          "Long": 77.1038
        },
        {
          "Area": "Khatiguda",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 19.4001,
          "Long": 83.6944
        },
        {
          "Area": "Khatikuchi",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.4408,
          "Long": 91.8873
        },
        {
          "Area": "Khatima",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.151,
          "Long": 79.9708
        },
        {
          "Area": "Khatnagar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3836,
          "Long": 87.8747
        },
        {
          "Area": "Khatod",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.4851,
          "Long": 76.4735
        },
        {
          "Area": "Khatra",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.387,
          "Long": 87.135
        },
        {
          "Area": "Khatriar",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.4657,
          "Long": 82.5783
        },
        {
          "Area": "Khawbung",
          "State": "Mizoram",
          "CountryCode": "IN",
          "Lat": 23.5424,
          "Long": 93.3842
        },
        {
          "Area": "Khawzawl",
          "State": "Mizoram",
          "CountryCode": "IN",
          "Lat": 23.6161,
          "Long": 93.241
        },
        {
          "Area": "Khayerpur",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.6182,
          "Long": 91.356
        },
        {
          "Area": "Khed",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.8506,
          "Long": 75.4848
        },
        {
          "Area": "Khed (rtg)",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.8506,
          "Long": 75.4848
        },
        {
          "Area": "Kheda",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.0401,
          "Long": 73.0167
        },
        {
          "Area": "Khedacherra",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0447,
          "Long": 91.7553
        },
        {
          "Area": "Khedbrahma",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 24.4647,
          "Long": 73.6102
        },
        {
          "Area": "Khejurda",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3159,
          "Long": 88.0212
        },
        {
          "Area": "Khejuri",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.8532,
          "Long": 87.9147
        },
        {
          "Area": "Khekada",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.8045,
          "Long": 77.5102
        },
        {
          "Area": "Khekra",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.8369,
          "Long": 77.3861
        },
        {
          "Area": "Khellong",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.3143,
          "Long": 92.3716
        },
        {
          "Area": "Khelmati",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.6833,
          "Long": 92.65
        },
        {
          "Area": "Khem Karan",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.7046,
          "Long": 74.9007
        },
        {
          "Area": "Khem Karn",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.2182,
          "Long": 74.6092
        },
        {
          "Area": "Khemiyong",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.1318,
          "Long": 95.7349
        },
        {
          "Area": "Kheora",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5666,
          "Long": 80.9724
        },
        {
          "Area": "Kheragah",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5141,
          "Long": 78.2984
        },
        {
          "Area": "Kheragarh",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.0463,
          "Long": 78.412
        },
        {
          "Area": "Kheralu",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 24.2088,
          "Long": 72.9726
        },
        {
          "Area": "Kherem Bisa",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.9126,
          "Long": 96.1288
        },
        {
          "Area": "Kheri",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.0486,
          "Long": 76.3417
        },
        {
          "Area": "Kherwara",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 24.6879,
          "Long": 74.2322
        },
        {
          "Area": "Khetri",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 28.3396,
          "Long": 76.1583
        },
        {
          "Area": "Khiara",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.8528,
          "Long": 86.1605
        },
        {
          "Area": "Khichan",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.9821,
          "Long": 72.788
        },
        {
          "Area": "Khigogipora",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.9563,
          "Long": 74.834
        },
        {
          "Area": "Khijersarai",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.0266,
          "Long": 85.2327
        },
        {
          "Area": "Khijri",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 23.3731,
          "Long": 85.4455
        },
        {
          "Area": "Khilchaian",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.498,
          "Long": 75.2569
        },
        {
          "Area": "Khilchian",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.5971,
          "Long": 75.2569
        },
        {
          "Area": "Khilchipur",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.2516,
          "Long": 76.7346
        },
        {
          "Area": "Khilkapur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.7572,
          "Long": 88.4556
        },
        {
          "Area": "Khiluai",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.7276,
          "Long": 78.1723
        },
        {
          "Area": "Khinwsar",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 27.084,
          "Long": 74.1879
        },
        {
          "Area": "Khiowang",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.2754,
          "Long": 94.4401
        },
        {
          "Area": "Khiowang Ghat",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.2754,
          "Long": 94.4401
        },
        {
          "Area": "Khira",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.8528,
          "Long": 86.1065
        },
        {
          "Area": "Khirkiya",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.2958,
          "Long": 78.0798
        },
        {
          "Area": "Khirkiyan",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.2958,
          "Long": 78.0798
        },
        {
          "Area": "Khizirsarai",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.0266,
          "Long": 85.2327
        },
        {
          "Area": "Khizrabad West",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 30.8782,
          "Long": 76.6763
        },
        {
          "Area": "Khliehriat",
          "State": "Meghalaya",
          "CountryCode": "IN",
          "Lat": 25.4167,
          "Long": 92.5667
        },
        {
          "Area": "Khnapur",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 17.1177,
          "Long": 74.6544
        },
        {
          "Area": "Khoirabari",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.6384,
          "Long": 92.0374
        },
        {
          "Area": "Khokra Kalan",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.5797,
          "Long": 76.3458
        },
        {
          "Area": "Khol",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.1963,
          "Long": 76.3974
        },
        {
          "Area": "Kholapota",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4653,
          "Long": 88.7803
        },
        {
          "Area": "Khonsa",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.0317,
          "Long": 95.5667
        },
        {
          "Area": "Khopoli",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.6919,
          "Long": 75.4244
        },
        {
          "Area": "Khori",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.2013,
          "Long": 76.4874
        },
        {
          "Area": "Khowai",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0796,
          "Long": 91.6093
        },
        {
          "Area": "Khowang",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.3664,
          "Long": 95.0562
        },
        {
          "Area": "Khowang  Ghat",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.2754,
          "Long": 94.4401
        },
        {
          "Area": "Khowang Ghat",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.3664,
          "Long": 95.0562
        },
        {
          "Area": "Khrew",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.0333,
          "Long": 74.9251
        },
        {
          "Area": "Khuandian",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.8808,
          "Long": 76.3945
        },
        {
          "Area": "Khudana",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.4072,
          "Long": 76.1175
        },
        {
          "Area": "Khujner",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.8612,
          "Long": 76.7346
        },
        {
          "Area": "Khukurdaha",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.0254,
          "Long": 87.8966
        },
        {
          "Area": "Khuldabad",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.2711,
          "Long": 76.2588
        },
        {
          "Area": "Khulna",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3642,
          "Long": 88.8783
        },
        {
          "Area": "Khultabad",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.5118,
          "Long": 75.009
        },
        {
          "Area": "Khundian",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.076,
          "Long": 76.5591
        },
        {
          "Area": "Khundian(T)",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.913,
          "Long": 76.3847
        },
        {
          "Area": "Khunta",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 22.3834,
          "Long": 86.0815
        },
        {
          "Area": "Khunti",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 23.3313,
          "Long": 85.7599
        },
        {
          "Area": "Khurai",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.3606,
          "Long": 78.659
        },
        {
          "Area": "Khurda",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.0275,
          "Long": 85.6125
        },
        {
          "Area": "Khurja",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.3576,
          "Long": 78.0876
        },
        {
          "Area": "Khurshi",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3029,
          "Long": 87.818
        },
        {
          "Area": "Khurutia",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.9958,
          "Long": 87.8022
        },
        {
          "Area": "Khusdhowa",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 25.96,
          "Long": 91.0578
        },
        {
          "Area": "Khusrupur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.479,
          "Long": 85.4794
        },
        {
          "Area": "Kiashan Garh",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 27.0195,
          "Long": 75.0023
        },
        {
          "Area": "Kichha",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.3287,
          "Long": 79.9012
        },
        {
          "Area": "Kidwai Nagar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.5934,
          "Long": 80.6879
        },
        {
          "Area": "Kilak",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.8491,
          "Long": 79.181
        },
        {
          "Area": "Kille Dahrur",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.2077,
          "Long": 77.0702
        },
        {
          "Area": "Kille Dharur",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.2077,
          "Long": 77.0702
        },
        {
          "Area": "Kilvelur",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.8494,
          "Long": 79.8349
        },
        {
          "Area": "Kimin",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.5535,
          "Long": 93.7868
        },
        {
          "Area": "Kinjirkela",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.3382,
          "Long": 84.1244
        },
        {
          "Area": "Kinwat",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.8909,
          "Long": 78.2934
        },
        {
          "Area": "Kioppal",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.3318,
          "Long": 76.0455
        },
        {
          "Area": "Kiphire",
          "State": "Nagaland",
          "CountryCode": "IN",
          "Lat": 26.4339,
          "Long": 94.7678
        },
        {
          "Area": "Kiranpur",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 21.6962,
          "Long": 80.2527
        },
        {
          "Area": "Kiraoli",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 27.2022,
          "Long": 78.2984
        },
        {
          "Area": "Kiratpur Sahib",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.0351,
          "Long": 76.3631
        },
        {
          "Area": "Kiriburu",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 22.7406,
          "Long": 85.6306
        },
        {
          "Area": "Kirishnarayapuram",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.9549,
          "Long": 78.2349
        },
        {
          "Area": "Kirlampudi",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.2035,
          "Long": 82.1824
        },
        {
          "Area": "Kirmira",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.8867,
          "Long": 84.1768
        },
        {
          "Area": "Kirnapur",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.0377,
          "Long": 80.4855
        },
        {
          "Area": "Kirtinagar",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.4374,
          "Long": 78.8102
        },
        {
          "Area": "Kirtinagr",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 30.4374,
          "Long": 78.8102
        },
        {
          "Area": "Kirtipur`",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4653,
          "Long": 88.7803
        },
        {
          "Area": "Kishaganj",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.2217,
          "Long": 87.669
        },
        {
          "Area": "Kishagnaj",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.4326,
          "Long": 87.8945
        },
        {
          "Area": "Kishan Garh",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 27.9611,
          "Long": 76.7782
        },
        {
          "Area": "Kishan Garh Bass",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 28.0727,
          "Long": 76.7629
        },
        {
          "Area": "Kishanaganj",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.2217,
          "Long": 87.7438
        },
        {
          "Area": "Kishanagnj",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.0445,
          "Long": 87.8441
        },
        {
          "Area": "Kishandaspet",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.5497,
          "Long": 80.1059
        },
        {
          "Area": "Kishangaj",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.1374,
          "Long": 87.7111
        },
        {
          "Area": "Kishanganhj",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.1085,
          "Long": 87.9267
        },
        {
          "Area": "Kishanganj",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.4376,
          "Long": 88.1311
        },
        {
          "Area": "Kishangarh",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 27.0195,
          "Long": 75.0023
        },
        {
          "Area": "Kishangnj",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.2956,
          "Long": 87.9353
        },
        {
          "Area": "Kishanpur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.2477,
          "Long": 86.8001
        },
        {
          "Area": "Kishorenagar",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.1001,
          "Long": 86.2292
        },
        {
          "Area": "Kishsangarh",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.688,
          "Long": 74.8584
        },
        {
          "Area": "Kishtwar",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.374,
          "Long": 75.859
        },
        {
          "Area": "Kisinda",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.1823,
          "Long": 84.4189
        },
        {
          "Area": "Kithore",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 28.8979,
          "Long": 77.9253
        },
        {
          "Area": "Kiwat",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.8951,
          "Long": 78.1373
        },
        {
          "Area": "Kkhallikote",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.4787,
          "Long": 85.2055
        },
        {
          "Area": "Klampur",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 19.9951,
          "Long": 83.1426
        },
        {
          "Area": "Klhowang",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 27.2754,
          "Long": 94.4401
        },
        {
          "Area": "Klyanpur",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.8426,
          "Long": 84.9846
        },
        {
          "Area": "Knpur Dehat",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.3061,
          "Long": 79.913
        },
        {
          "Area": "Ko0nch",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.8964,
          "Long": 84.7563
        },
        {
          "Area": "Koaria",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.1185,
          "Long": 74.0216
        },
        {
          "Area": "Kochas",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.2828,
          "Long": 83.9592
        },
        {
          "Area": "Kochi",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 10.1975,
          "Long": 76.3159
        },
        {
          "Area": "Kochinda",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.7673,
          "Long": 84.4229
        },
        {
          "Area": "Kodad",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.2419,
          "Long": 79.9463
        },
        {
          "Area": "Kodaikanal",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.7686,
          "Long": 77.9789
        },
        {
          "Area": "Kodair",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 16.4935,
          "Long": 78.3415
        },
        {
          "Area": "Kodakandal",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.507,
          "Long": 79.6086
        },
        {
          "Area": "Kodakandla",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.2688,
          "Long": 79.7992
        },
        {
          "Area": "Kodakondla",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.0809,
          "Long": 79.4732
        },
        {
          "Area": "Kodala",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.1268,
          "Long": 85.1649
        },
        {
          "Area": "Kodangal",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.1047,
          "Long": 77.6299
        },
        {
          "Area": "Kodarma",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.77,
          "Long": 85.8344
        },
        {
          "Area": "Kodavalur",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.6037,
          "Long": 80.0241
        },
        {
          "Area": "Kodavalur Mandalam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.5722,
          "Long": 80.0653
        },
        {
          "Area": "Kodavaluru",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.5882,
          "Long": 80.0137
        },
        {
          "Area": "Kodavaluru Mandalam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.5669,
          "Long": 80.0034
        },
        {
          "Area": "Kodavasal",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.987,
          "Long": 79.7217
        },
        {
          "Area": "Kodavasla",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.6689,
          "Long": 79.2989
        },
        {
          "Area": "Koderma",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.3115,
          "Long": 85.2903
        },
        {
          "Area": "Kodimial",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.6307,
          "Long": 79.2409
        },
        {
          "Area": "Kodinar",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 23.7859,
          "Long": 72.6389
        },
        {
          "Area": "Kodinda",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 19.2216,
          "Long": 82.6406
        },
        {
          "Area": "Kodinga",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 19.3874,
          "Long": 83.0575
        },
        {
          "Area": "Kodumur",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.6813,
          "Long": 77.8241
        },
        {
          "Area": "Kodungallur",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 10.9299,
          "Long": 76.8488
        },
        {
          "Area": "Kodur",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.4599,
          "Long": 79.3978
        },
        {
          "Area": "Koduru",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.7257,
          "Long": 81.2491
        },
        {
          "Area": "Koheda",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.6328,
          "Long": 79.3769
        },
        {
          "Area": "Kohima",
          "State": "Nagaland",
          "CountryCode": "IN",
          "Lat": 25.9247,
          "Long": 94.3045
        },
        {
          "Area": "Kohima Sadar",
          "State": "Nagaland",
          "CountryCode": "IN",
          "Lat": 25.662,
          "Long": 94.1084
        },
        {
          "Area": "Kohima Science College",
          "State": "Nagaland",
          "CountryCode": "IN",
          "Lat": 25.6542,
          "Long": 94.0218
        },
        {
          "Area": "Kohima Village",
          "State": "Nagaland",
          "CountryCode": "IN",
          "Lat": 25.6698,
          "Long": 94.1951
        },
        {
          "Area": "Kohlan",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.8122,
          "Long": 75.7831
        },
        {
          "Area": "Kohrar",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.4146,
          "Long": 76.3674
        },
        {
          "Area": "Koida",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.9971,
          "Long": 85.2421
        },
        {
          "Area": "Koilabad",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.2919,
          "Long": 87.9302
        },
        {
          "Area": "Koilakuntla",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.2088,
          "Long": 78.5278
        },
        {
          "Area": "Koilkuntla",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.7286,
          "Long": 78.5278
        },
        {
          "Area": "Koilwar",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.6838,
          "Long": 84.8517
        },
        {
          "Area": "Koira",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.8894,
          "Long": 85.3097
        },
        {
          "Area": "Kokernag",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.5785,
          "Long": 75.3181
        },
        {
          "Area": "Kokila",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.5535,
          "Long": 93.7868
        },
        {
          "Area": "Kokilabari",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3796,
          "Long": 91.2951
        },
        {
          "Area": "Kokrajhar",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.5145,
          "Long": 90.513
        },
        {
          "Area": "Kolabira",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.8344,
          "Long": 84.2738
        },
        {
          "Area": "Kolakaluru",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.3061,
          "Long": 80.6181
        },
        {
          "Area": "Kolana",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.1673,
          "Long": 76.4131
        },
        {
          "Area": "Kolanda",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.1762,
          "Long": 87.6063
        },
        {
          "Area": "Kolar",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.2758,
          "Long": 78.2557
        },
        {
          "Area": "Kolaras",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 25.6617,
          "Long": 77.8476
        },
        {
          "Area": "Kolasib",
          "State": "Mizoram",
          "CountryCode": "IN",
          "Lat": 24.2239,
          "Long": 92.6787
        },
        {
          "Area": "Kolayat",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 27.8709,
          "Long": 72.4132
        },
        {
          "Area": "Kolebira",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 22.8522,
          "Long": 84.8954
        },
        {
          "Area": "Kolibera",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 22.8522,
          "Long": 84.7895
        },
        {
          "Area": "Kolibira",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 23.1795,
          "Long": 84.7774
        },
        {
          "Area": "Kolimigundla",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.0517,
          "Long": 78.1844
        },
        {
          "Area": "Kolkata",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.1209,
          "Long": 88.7833
        },
        {
          "Area": "Kollam",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 9.1167,
          "Long": 77.0236
        },
        {
          "Area": "Kollapur",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 16.3435,
          "Long": 78.3201
        },
        {
          "Area": "Kollegal",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 12.7539,
          "Long": 77.3504
        },
        {
          "Area": "Kollipara",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.3159,
          "Long": 80.7514
        },
        {
          "Area": "Kolllam",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 8.8663,
          "Long": 76.7057
        },
        {
          "Area": "Kolluru",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.6213,
          "Long": 81.024
        },
        {
          "Area": "Koloriang",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 27.964,
          "Long": 93.5532
        },
        {
          "Area": "Komarada",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.9435,
          "Long": 83.5173
        },
        {
          "Area": "Komarolu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.306,
          "Long": 79.3031
        },
        {
          "Area": "Kombo",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 28.2358,
          "Long": 94.6742
        },
        {
          "Area": "Komminepalli",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.8583,
          "Long": 80.6873
        },
        {
          "Area": "Komna",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.5536,
          "Long": 82.7797
        },
        {
          "Area": "Konada",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.0173,
          "Long": 83.5629
        },
        {
          "Area": "Konaraopet",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.5497,
          "Long": 79.2409
        },
        {
          "Area": "Konardam",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.0332,
          "Long": 85.4957
        },
        {
          "Area": "Konarpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3029,
          "Long": 87.818
        },
        {
          "Area": "Konch",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.0854,
          "Long": 85.1421
        },
        {
          "Area": "Konch",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.2812,
          "Long": 79.8924
        },
        {
          "Area": "Kondagaon",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 20.4399,
          "Long": 82.1613
        },
        {
          "Area": "Kondapalli",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.6586,
          "Long": 80.5832
        },
        {
          "Area": "Kondapuram",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.1899,
          "Long": 79.7599
        },
        {
          "Area": "Kondurgu",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.0908,
          "Long": 78.0839
        },
        {
          "Area": "Koni",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 22.3513,
          "Long": 82.5991
        },
        {
          "Area": "Koniara",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5022,
          "Long": 88.5404
        },
        {
          "Area": "Konta",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 18.8914,
          "Long": 81.8872
        },
        {
          "Area": "Kopargaon",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.2974,
          "Long": 76.7784
        },
        {
          "Area": "Kopati",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.6589,
          "Long": 92.4784
        },
        {
          "Area": "Kopergaon",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.155,
          "Long": 75.3028
        },
        {
          "Area": "Koppa",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.5941,
          "Long": 75.9279
        },
        {
          "Area": "Koppal",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.9836,
          "Long": 76.4368
        },
        {
          "Area": "Koradacherry",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.7874,
          "Long": 79.536
        },
        {
          "Area": "Korai",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.3157,
          "Long": 79.6902
        },
        {
          "Area": "Korakati",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3484,
          "Long": 88.8997
        },
        {
          "Area": "Koraon",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.3094,
          "Long": 82.2005
        },
        {
          "Area": "Koraon **",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.3094,
          "Long": 82.2005
        },
        {
          "Area": "Koraput",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.4682,
          "Long": 83.7161
        },
        {
          "Area": "Koratagere",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.5949,
          "Long": 77.3543
        },
        {
          "Area": "Koratal",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.5497,
          "Long": 79.2409
        },
        {
          "Area": "Korategere",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.517,
          "Long": 77.1915
        },
        {
          "Area": "Koratla",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.8215,
          "Long": 79.2409
        },
        {
          "Area": "Korba",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 22.3489,
          "Long": 82.9004
        },
        {
          "Area": "Korchi",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.8184,
          "Long": 80.601
        },
        {
          "Area": "Koregaon",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.1806,
          "Long": 76.1932
        },
        {
          "Area": "Koria",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5034,
          "Long": 87.9832
        },
        {
          "Area": "Koriawas",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.0799,
          "Long": 76.0612
        },
        {
          "Area": "Koron",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.4442,
          "Long": 86.8131
        },
        {
          "Area": "Koronu",
          "State": "Arunachal Pradesh",
          "CountryCode": "IN",
          "Lat": 28.31,
          "Long": 95.7475
        },
        {
          "Area": "Korpana",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.5785,
          "Long": 79.4438
        },
        {
          "Area": "Korphana",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.342,
          "Long": 79.6093
        },
        {
          "Area": "Korukonda",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.3749,
          "Long": 82.2756
        },
        {
          "Area": "Koshya Kutali",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.5135,
          "Long": 79.6742
        },
        {
          "Area": "Kosli",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.3982,
          "Long": 76.4845
        },
        {
          "Area": "Kosli R S",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.3498,
          "Long": 76.5026
        },
        {
          "Area": "Kosya Kutauli",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.5595,
          "Long": 79.7231
        },
        {
          "Area": "Kot Mit Sing",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.5777,
          "Long": 74.9076
        },
        {
          "Area": "Kot Mit Singh",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 31.5891,
          "Long": 75.0736
        },
        {
          "Area": "Kota",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.7755,
          "Long": 80.0637
        },
        {
          "Area": "Kota",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.778,
          "Long": 76.8438
        },
        {
          "Area": "Kotabommali",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.5251,
          "Long": 84.0775
        },
        {
          "Area": "Kotabommali Mandal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.6693,
          "Long": 84.1625
        },
        {
          "Area": "Kotabommalimandal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.5251,
          "Long": 84.0773
        },
        {
          "Area": "Kotagandredu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.2581,
          "Long": 83.4656
        },
        {
          "Area": "Kotagiri",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.516,
          "Long": 76.9337
        },
        {
          "Area": "Kotaigarh",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3029,
          "Long": 87.818
        },
        {
          "Area": "Kotalpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.1367,
          "Long": 88.0923
        },
        {
          "Area": "Kotananduru",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.5037,
          "Long": 82.5287
        },
        {
          "Area": "Kotda",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.0898,
          "Long": 70.9089
        },
        {
          "Area": "Kotda Saangani",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.0615,
          "Long": 71.1629
        },
        {
          "Area": "Kotda Sangani",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.0873,
          "Long": 72.9457
        },
        {
          "Area": "Kotda Sanghani",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 20.5087,
          "Long": 72.9457
        },
        {
          "Area": "Kotdwar",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.9029,
          "Long": 78.9302
        },
        {
          "Area": "Kotdwara",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.9754,
          "Long": 79.0826
        },
        {
          "Area": "Kotdwra",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.8999,
          "Long": 78.5852
        },
        {
          "Area": "Kotepada",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.6315,
          "Long": 87.428
        },
        {
          "Area": "Kotha Patnam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.5042,
          "Long": 80.1291
        },
        {
          "Area": "Kothabari",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.795,
          "Long": 88.1206
        },
        {
          "Area": "Kothacheruvu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.4811,
          "Long": 78.004
        },
        {
          "Area": "Kothagarh",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.1289,
          "Long": 84.0472
        },
        {
          "Area": "Kothaguda",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.9552,
          "Long": 80.2016
        },
        {
          "Area": "Kothagudem",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.3558,
          "Long": 80.6873
        },
        {
          "Area": "Kothaira",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 24.9577,
          "Long": 73.8659
        },
        {
          "Area": "Kothakota",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.1796,
          "Long": 78.7719
        },
        {
          "Area": "Kothal Khurd",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.1904,
          "Long": 76.1312
        },
        {
          "Area": "Kothamangalam",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 10.1503,
          "Long": 76.7771
        },
        {
          "Area": "Kothapalli",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.6974,
          "Long": 82.93
        },
        {
          "Area": "Kothapeta",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.0747,
          "Long": 82.2643
        },
        {
          "Area": "Kothapeta Mandal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.9362,
          "Long": 82.2643
        },
        {
          "Area": "Kothapeta Taluk",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.4366,
          "Long": 82.8914
        },
        {
          "Area": "Kothavalasa",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.4673,
          "Long": 83.3793
        },
        {
          "Area": "Kothkhai",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.2399,
          "Long": 77.6822
        },
        {
          "Area": "Kothur",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.7896,
          "Long": 79.5385
        },
        {
          "Area": "Kotia",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.3476,
          "Long": 76.3385
        },
        {
          "Area": "Kotkapura",
          "State": "Punjab",
          "CountryCode": "IN",
          "Lat": 30.5921,
          "Long": 74.783
        },
        {
          "Area": "Kotkhai",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.2483,
          "Long": 77.6574
        },
        {
          "Area": "Kotla",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.2199,
          "Long": 75.9986
        },
        {
          "Area": "Kotli(S.T)",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.7202,
          "Long": 76.9929
        },
        {
          "Area": "Kotma",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.7942,
          "Long": 82.0563
        },
        {
          "Area": "Kotpad",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 19.8548,
          "Long": 83.4836
        },
        {
          "Area": "Kotra",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 24.6434,
          "Long": 73.7064
        },
        {
          "Area": "Kotri",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.3892,
          "Long": 76.3997
        },
        {
          "Area": "Kotshila",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.4387,
          "Long": 85.9953
        },
        {
          "Area": "Kottarakara",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 9.0833,
          "Long": 76.9709
        },
        {
          "Area": "Kottarakkara",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 9.4646,
          "Long": 77.0164
        },
        {
          "Area": "Kottayam",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 9.6851,
          "Long": 76.8748
        },
        {
          "Area": "Kottucherry Commune Panchayat",
          "State": "Pondicherry",
          "CountryCode": "IN",
          "Lat": 10.9434,
          "Long": 79.7558
        },
        {
          "Area": "Kotturu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.7974,
          "Long": 83.9383
        },
        {
          "Area": "Kotturu Mandal",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.8111,
          "Long": 83.9305
        },
        {
          "Area": "Kotulpur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.341,
          "Long": 88.0649
        },
        {
          "Area": "Kotwa",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.3833,
          "Long": 84.7696
        },
        {
          "Area": "Koura",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.0463,
          "Long": 83.7926
        },
        {
          "Area": "Kovilpatti",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.8028,
          "Long": 78.2467
        },
        {
          "Area": "Kovur",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.5293,
          "Long": 80.0266
        },
        {
          "Area": "Kovur Mandalam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.5005,
          "Long": 79.9852
        },
        {
          "Area": "Kovvali",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.7392,
          "Long": 81.2013
        },
        {
          "Area": "Kovvur",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.0509,
          "Long": 81.6176
        },
        {
          "Area": "Kovvur Mandalam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.021,
          "Long": 81.6176
        },
        {
          "Area": "Kovvuru Mandalam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.2211,
          "Long": 81.9387
        },
        {
          "Area": "Koyilandi",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 11.638,
          "Long": 76.2482
        },
        {
          "Area": "Koyilani",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 11.534,
          "Long": 75.8689
        },
        {
          "Area": "Koyyalagudem",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.1876,
          "Long": 81.5507
        },
        {
          "Area": "Kozhencherri",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 9.265,
          "Long": 76.7873
        },
        {
          "Area": "Kozhencherry",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 10.2652,
          "Long": 76.8924
        },
        {
          "Area": "Kozhenchery",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 10.2652,
          "Long": 76.929
        },
        {
          "Area": "Kozhikode",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 11.855,
          "Long": 76.0066
        },
        {
          "Area": "Kragsoo",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.0397,
          "Long": 74.7612
        },
        {
          "Area": "Krem Shora",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.9245,
          "Long": 74.6725
        },
        {
          "Area": "Kriahnanagar",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0447,
          "Long": 91.7553
        },
        {
          "Area": "Krishan Nagar",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.0799,
          "Long": 76.0612
        },
        {
          "Area": "Krishna",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.3619,
          "Long": 82.0551
        },
        {
          "Area": "Krishnachandapur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5022,
          "Long": 88.5404
        },
        {
          "Area": "Krishnaganj",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.5099,
          "Long": 88.7637
        },
        {
          "Area": "Krishnagar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.5009,
          "Long": 88.1442
        },
        {
          "Area": "Krishnagar - I",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.5009,
          "Long": 88.5215
        },
        {
          "Area": "Krishnagar - II",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.6685,
          "Long": 88.5215
        },
        {
          "Area": "Krishnagar I",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.5009,
          "Long": 88.1442
        },
        {
          "Area": "Krishnagar-i",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.5009,
          "Long": 88.1442
        },
        {
          "Area": "Krishnagar-ii",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.601,
          "Long": 88.1273
        },
        {
          "Area": "Krishnagiri",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.7127,
          "Long": 77.8949
        },
        {
          "Area": "Krishnagiri",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 12.7742,
          "Long": 78.6705
        },
        {
          "Area": "Krishnai",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.093,
          "Long": 90.6865
        },
        {
          "Area": "Krishnanagar",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0447,
          "Long": 91.7553
        },
        {
          "Area": "Krishnanagar Contai",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5034,
          "Long": 87.9832
        },
        {
          "Area": "Krishnanagar I",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.5009,
          "Long": 88.5215
        },
        {
          "Area": "Krishnanagar Ii",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.6685,
          "Long": 88.5215
        },
        {
          "Area": "Krishnanagar Municipality",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.5009,
          "Long": 88.1442
        },
        {
          "Area": "Krishnanagar-i",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3562,
          "Long": 87.8848
        },
        {
          "Area": "Krishnangar Ii",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.6685,
          "Long": 88.0961
        },
        {
          "Area": "Krishnaprasad",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 19.5667,
          "Long": 85.25
        },
        {
          "Area": "Krishnapur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.1367,
          "Long": 88.0923
        },
        {
          "Area": "Krishnarajpet",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 12.775,
          "Long": 76.798
        },
        {
          "Area": "Krishnarayapuram",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.2308,
          "Long": 78.6419
        },
        {
          "Area": "Krithivennu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.448,
          "Long": 81.4233
        },
        {
          "Area": "Krosuru",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.6038,
          "Long": 80.2185
        },
        {
          "Area": "Krushnaprasad",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.3216,
          "Long": 85.25
        },
        {
          "Area": "Krushnaprsad",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 19.5667,
          "Long": 85.25
        },
        {
          "Area": "Kruthivennu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.3989,
          "Long": 81.3824
        },
        {
          "Area": "Kuarmunda",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 22.4,
          "Long": 85.1005
        },
        {
          "Area": "Kubeer",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 19.2123,
          "Long": 78.0584
        },
        {
          "Area": "Kuchainala",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.0789,
          "Long": 91.8987
        },
        {
          "Area": "Kuchamancity",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 26.5879,
          "Long": 74.4465
        },
        {
          "Area": "Kuchinapudi",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.2988,
          "Long": 80.7583
        },
        {
          "Area": "Kuchinda",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.8335,
          "Long": 84.4328
        },
        {
          "Area": "Kuchipudi",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.2988,
          "Long": 80.0915
        },
        {
          "Area": "Kudair",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.7756,
          "Long": 77.589
        },
        {
          "Area": "Kudal",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 19.9048,
          "Long": 75.6811
        },
        {
          "Area": "Kudani",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.2843,
          "Long": 80.3637
        },
        {
          "Area": "Kuderu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.8495,
          "Long": 77.4834
        },
        {
          "Area": "Kudlgi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.5102,
          "Long": 76.1433
        },
        {
          "Area": "Kudligi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.1096,
          "Long": 76.6266
        },
        {
          "Area": "Kudna",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.832,
          "Long": 81.757
        },
        {
          "Area": "Kudra",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.1961,
          "Long": 83.8548
        },
        {
          "Area": "Kuhi",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 21.1763,
          "Long": 79.6119
        },
        {
          "Area": "Kuishgeria",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4364,
          "Long": 87.9624
        },
        {
          "Area": "Kujang",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.2998,
          "Long": 86.6085
        },
        {
          "Area": "Kujanga",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.2033,
          "Long": 86.4077
        },
        {
          "Area": "Kukai",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4364,
          "Long": 87.9624
        },
        {
          "Area": "Kukarnag",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.8297,
          "Long": 75.1966
        },
        {
          "Area": "Kukshai",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.3844,
          "Long": 74.8543
        },
        {
          "Area": "Kukshi",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 22.5023,
          "Long": 75.1041
        },
        {
          "Area": "Kukshtagi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.6627,
          "Long": 76.2219
        },
        {
          "Area": "Kukunoor",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.1983,
          "Long": 81.5937
        },
        {
          "Area": "Kulai",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.007,
          "Long": 91.6093
        },
        {
          "Area": "Kulan",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.1758,
          "Long": 74.9148
        },
        {
          "Area": "Kulanjara",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4305,
          "Long": 87.4447
        },
        {
          "Area": "Kulathur",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 10.6663,
          "Long": 78.8878
        },
        {
          "Area": "Kuldiha",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.5234,
          "Long": 87.6598
        },
        {
          "Area": "Kulgam",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.933,
          "Long": 75.0373
        },
        {
          "Area": "Kulgaon",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.3705,
          "Long": 80.4468
        },
        {
          "Area": "Kulia",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3294,
          "Long": 87.9528
        },
        {
          "Area": "Kuliadanga",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.6389,
          "Long": 88.746
        },
        {
          "Area": "Kulikawn",
          "State": "Mizoram",
          "CountryCode": "IN",
          "Lat": 23.7104,
          "Long": 92.7268
        },
        {
          "Area": "Kulithalai",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.2308,
          "Long": 78.7163
        },
        {
          "Area": "Kulittalai",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.0563,
          "Long": 78.7163
        },
        {
          "Area": "Kullu",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.0666,
          "Long": 77.5279
        },
        {
          "Area": "Kullu(T)",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 32.2656,
          "Long": 77.5279
        },
        {
          "Area": "Kulpahar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.3367,
          "Long": 79.4008
        },
        {
          "Area": "Kulpi",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.6486,
          "Long": 88.4168
        },
        {
          "Area": "Kultali",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4339,
          "Long": 88.6324
        },
        {
          "Area": "Kultazpur",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.0799,
          "Long": 76.0612
        },
        {
          "Area": "Kulti",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.4891,
          "Long": 87.8306
        },
        {
          "Area": "Kulti MC",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.9348,
          "Long": 87.9106
        },
        {
          "Area": "Kultikri",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.2471,
          "Long": 87.8066
        },
        {
          "Area": "Kultikri Aranga",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.9958,
          "Long": 87.8022
        },
        {
          "Area": "Kumarda",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3836,
          "Long": 87.8747
        },
        {
          "Area": "Kumarganj",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.5178,
          "Long": 88.7674
        },
        {
          "Area": "Kumarghat",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1597,
          "Long": 92.0329
        },
        {
          "Area": "Kumargramduar",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 26.5148,
          "Long": 89.6522
        },
        {
          "Area": "Kumargunj",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.2786,
          "Long": 88.3207
        },
        {
          "Area": "Kumarikata",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 26.3679,
          "Long": 91.3877
        },
        {
          "Area": "Kumarkhan",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.9294,
          "Long": 86.9841
        },
        {
          "Area": "Kumarkhand",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.0428,
          "Long": 87.0491
        },
        {
          "Area": "Kumarkhola",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3294,
          "Long": 87.9528
        },
        {
          "Area": "Kumarsain",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.3433,
          "Long": 77.5279
        },
        {
          "Area": "Kumarzole",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.4784,
          "Long": 88.5822
        },
        {
          "Area": "Kumbakonam",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.703,
          "Long": 79.4809
        },
        {
          "Area": "Kumbhalgarh",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.2163,
          "Long": 73.8923
        },
        {
          "Area": "Kumbhraj",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.4188,
          "Long": 77.0484
        },
        {
          "Area": "Kumharsain(T)",
          "State": "Himachal Pradesh",
          "CountryCode": "IN",
          "Lat": 31.3546,
          "Long": 77.6324
        },
        {
          "Area": "Kumher",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 27.3506,
          "Long": 77.5385
        },
        {
          "Area": "Kumirda",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3444,
          "Long": 87.9089
        },
        {
          "Area": "Kumra",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.2312,
          "Long": 88.4785
        },
        {
          "Area": "Kumta",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.9497,
          "Long": 74.8387
        },
        {
          "Area": "Kunavaram",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 17.9777,
          "Long": 82.2105
        },
        {
          "Area": "Kund",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.1506,
          "Long": 76.4002
        },
        {
          "Area": "Kund Bo",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 33.933,
          "Long": 75.0373
        },
        {
          "Area": "Kunda",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 25.9097,
          "Long": 81.9829
        },
        {
          "Area": "Kundah",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.4695,
          "Long": 76.663
        },
        {
          "Area": "Kundahir",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.2777,
          "Long": 87.224
        },
        {
          "Area": "Kundahit",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.2777,
          "Long": 87.224
        },
        {
          "Area": "Kundam",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.312,
          "Long": 80.4681
        },
        {
          "Area": "Kundapura",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.0461,
          "Long": 75.0199
        },
        {
          "Area": "Kundgol",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.3894,
          "Long": 75.4139
        },
        {
          "Area": "Kundhahit",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 24.2777,
          "Long": 87.224
        },
        {
          "Area": "Kundheigola",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.4659,
          "Long": 84.8094
        },
        {
          "Area": "Kundli",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.098,
          "Long": 77.0684
        },
        {
          "Area": "Kundpaura",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 13.606,
          "Long": 74.6967
        },
        {
          "Area": "Kundura",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 18.9059,
          "Long": 82.8778
        },
        {
          "Area": "Kundurpi",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 14.4811,
          "Long": 77.8416
        },
        {
          "Area": "Kungol",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 15.1902,
          "Long": 75.3382
        },
        {
          "Area": "Kunigal",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 14.0524,
          "Long": 77.1818
        },
        {
          "Area": "Kunjaban",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 23.9225,
          "Long": 91.6031
        },
        {
          "Area": "Kunjapur",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 21.8532,
          "Long": 87.9147
        },
        {
          "Area": "Kunjpura",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 29.7179,
          "Long": 77.1083
        },
        {
          "Area": "Kunkuri",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 22.8831,
          "Long": 84.2795
        },
        {
          "Area": "Kunkvav-vadia",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.1848,
          "Long": 71.1809
        },
        {
          "Area": "Kunnam",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.4055,
          "Long": 79.1122
        },
        {
          "Area": "Kunnathunad",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 10.2263,
          "Long": 76.5473
        },
        {
          "Area": "Kunnathunadu",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 9.984,
          "Long": 76.4273
        },
        {
          "Area": "Kunnathur",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 9.6544,
          "Long": 76.8749
        },
        {
          "Area": "Kunzer",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.0665,
          "Long": 74.5238
        },
        {
          "Area": "Kuppam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 13.7135,
          "Long": 79.1475
        },
        {
          "Area": "Kupwara",
          "State": "Jammu & Kashmir",
          "CountryCode": "IN",
          "Lat": 34.55,
          "Long": 74.4905
        },
        {
          "Area": "Kuraj",
          "State": "Rajasthan",
          "CountryCode": "IN",
          "Lat": 25.0743,
          "Long": 74.0984
        },
        {
          "Area": "Kuravi",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 17.9552,
          "Long": 79.9764
        },
        {
          "Area": "Kurawar",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 23.5322,
          "Long": 76.4052
        },
        {
          "Area": "Kurawata",
          "State": "Haryana",
          "CountryCode": "IN",
          "Lat": 28.4851,
          "Long": 76.4735
        },
        {
          "Area": "Kurdeg",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 22.5949,
          "Long": 84.1411
        },
        {
          "Area": "Kurhani",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 26.3294,
          "Long": 85.6789
        },
        {
          "Area": "Kurhanni",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.9496,
          "Long": 85.3667
        },
        {
          "Area": "Kurichedu",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 15.8504,
          "Long": 79.4107
        },
        {
          "Area": "Kurkheda",
          "State": "Maharashtra",
          "CountryCode": "IN",
          "Lat": 20.6703,
          "Long": 80.3412
        },
        {
          "Area": "Kurnool",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 16.0722,
          "Long": 79.9939
        },
        {
          "Area": "Kursela",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.5139,
          "Long": 86.7362
        },
        {
          "Area": "Kurseong",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 27.0886,
          "Long": 88.9486
        },
        {
          "Area": "Kurtamgarh",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 20.0667,
          "Long": 83.75
        },
        {
          "Area": "Kurtha",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 25.3551,
          "Long": 85.0084
        },
        {
          "Area": "Kurti",
          "State": "Tripura",
          "CountryCode": "IN",
          "Lat": 24.1597,
          "Long": 92.0329
        },
        {
          "Area": "Kuru",
          "State": "Jharkhand",
          "CountryCode": "IN",
          "Lat": 23.591,
          "Long": 84.9418
        },
        {
          "Area": "Kurud",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 21.0713,
          "Long": 82.174
        },
        {
          "Area": "Kurupam",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.9562,
          "Long": 83.8131
        },
        {
          "Area": "Kurwai",
          "State": "Madhya Pradesh",
          "CountryCode": "IN",
          "Lat": 24.2513,
          "Long": 78.6979
        },
        {
          "Area": "Kushbasan",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3564,
          "Long": 87.8021
        },
        {
          "Area": "Kushdhowa",
          "State": "Assam",
          "CountryCode": "IN",
          "Lat": 25.96,
          "Long": 91.0578
        },
        {
          "Area": "Kushida",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.2142,
          "Long": 87.8895
        },
        {
          "Area": "Kushinagar",
          "State": "Uttar Pradesh",
          "CountryCode": "IN",
          "Lat": 26.9736,
          "Long": 84.1312
        },
        {
          "Area": "Kushmandi",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 24.3955,
          "Long": 88.0943
        },
        {
          "Area": "Kushmundi",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 25.0576,
          "Long": 88.1934
        },
        {
          "Area": "Kushtagi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 16.2178,
          "Long": 76.4242
        },
        {
          "Area": "Kushtagui",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 16.2178,
          "Long": 76.4242
        },
        {
          "Area": "Kushya Kuali",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.4816,
          "Long": 79.46
        },
        {
          "Area": "Kushya Kutali",
          "State": "Uttarakhand",
          "CountryCode": "IN",
          "Lat": 29.5114,
          "Long": 79.511
        },
        {
          "Area": "Kusmi",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 23.5267,
          "Long": 83.9823
        },
        {
          "Area": "Kusmunda",
          "State": "Chattisgarh",
          "CountryCode": "IN",
          "Lat": 22.3335,
          "Long": 82.6735
        },
        {
          "Area": "Kustagi",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 16.2178,
          "Long": 76.4242
        },
        {
          "Area": "Kusthgati",
          "State": "Karnataka",
          "CountryCode": "IN",
          "Lat": 16.0524,
          "Long": 76.3578
        },
        {
          "Area": "Kusumanchi",
          "State": "Telangana",
          "CountryCode": "IN",
          "Lat": 18.5431,
          "Long": 80.8438
        },
        {
          "Area": "Kuta",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 21.5417,
          "Long": 84.0365
        },
        {
          "Area": "Kutiyana",
          "State": "Gujarat",
          "CountryCode": "IN",
          "Lat": 22.004,
          "Long": 70.7119
        },
        {
          "Area": "Kutki",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 22.3836,
          "Long": 87.8747
        },
        {
          "Area": "Kutra",
          "State": "Odisha",
          "CountryCode": "IN",
          "Lat": 22.339,
          "Long": 84.5993
        },
        {
          "Area": "Kuttalam",
          "State": "Tamil Nadu",
          "CountryCode": "IN",
          "Lat": 11.1374,
          "Long": 79.7389
        },
        {
          "Area": "Kuttanad",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 9.6875,
          "Long": 76.7789
        },
        {
          "Area": "Kuttanadu",
          "State": "Kerala",
          "CountryCode": "IN",
          "Lat": 9.6875,
          "Long": 76.7789
        },
        {
          "Area": "Kutumba",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.6348,
          "Long": 84.2456
        },
        {
          "Area": "dumaria",
          "State": "Bihar",
          "CountryCode": "IN",
          "Lat": 24.6991,
          "Long": 84.936
        },
        {
          "Area": "gajapathinagram",
          "State": "Andhra Pradesh",
          "CountryCode": "IN",
          "Lat": 18.2315,
          "Long": 83.3506
        },
        {
          "Area": "kharagpur-II",
          "State": "West Bengal",
          "CountryCode": "IN",
          "Lat": 23.0979,
          "Long": 88.2441
        },
        {
          "Area": "Da Lat",
          "Lat": "11.9304",
          "Long": "108.42",
          "CountryCode": "VN"
        },
        {
          "Area": "Da Nang",
          "Lat": "16.06",
          "Long": "108.25",
          "CountryCode": "VN"
        },
        {
          "Area": "Daan",
          "Lat": "45.5",
          "Long": "124.3",
          "CountryCode": "CN"
        },
        {
          "Area": "Dabou",
          "Lat": "5.3204",
          "Long": "-4.3899",
          "CountryCode": "CL"
        },
        {
          "Area": "Daegu",
          "Lat": "35.8668",
          "Long": "128.607",
          "CountryCode": "kr"
        },
        {
          "Area": "Daejeon",
          "Lat": "36.3355",
          "Long": "127.425",
          "CountryCode": "kr"
        },
        {
          "Area": "Dagupan",
          "Lat": "16.0479",
          "Long": "120.3408",
          "CountryCode": "PH"
        },
        {
          "Area": "Dahuk",
          "Lat": "36.8667",
          "Long": "43",
          "CountryCode": "IQ"
        },
        {
          "Area": "Dakar",
          "Lat": "14.7158",
          "Long": "-17.4731",
          "CountryCode": "SN"
        },
        {
          "Area": "Dali",
          "Lat": "25.7",
          "Long": "100.18",
          "CountryCode": "CN"
        },
        {
          "Area": "Dali",
          "Lat": "34.7953",
          "Long": "109.9378",
          "CountryCode": "CN"
        },
        {
          "Area": "Dalian",
          "Lat": "38.9228",
          "Long": "121.6298",
          "CountryCode": "CN"
        },
        {
          "Area": "Dallas",
          "Lat": "32.7937",
          "Long": "-96.7662",
          "CountryCode": "US"
        },
        {
          "Area": "Daloa",
          "Lat": "6.89",
          "Long": "-6.45",
          "CountryCode": "CL"
        },
        {
          "Area": "Dalton",
          "Lat": "34.7689",
          "Long": "-84.9711",
          "CountryCode": "US"
        },
        {
          "Area": "Daly City",
          "Lat": "37.6863",
          "Long": "-122.4684",
          "CountryCode": "US"
        },
        {
          "Area": "Damanhûr",
          "Lat": "31.0504",
          "Long": "30.47",
          "CountryCode": "EG"
        },
        {
          "Area": "Damascus",
          "Lat": "33.5",
          "Long": "36.3",
          "CountryCode": "SY"
        },
        {
          "Area": "Damaturu",
          "Lat": "11.749",
          "Long": "11.966",
          "CountryCode": "NG"
        },
        {
          "Area": "Danbury",
          "Lat": "41.4016",
          "Long": "-73.471",
          "CountryCode": "US"
        },
        {
          "Area": "Dandong",
          "Lat": "40.1436",
          "Long": "124.3936",
          "CountryCode": "CN"
        },
        {
          "Area": "Danjiangkou",
          "Lat": "32.52",
          "Long": "111.5",
          "CountryCode": "CN"
        },
        {
          "Area": "Daphne",
          "Lat": "30.6291",
          "Long": "-87.8872",
          "CountryCode": "US"
        },
        {
          "Area": "Daqing",
          "Lat": "46.58",
          "Long": "125",
          "CountryCode": "CN"
        },
        {
          "Area": "Dar es Salaam",
          "Lat": "-6.8",
          "Long": "39.2683",
          "CountryCode": "TZ"
        },
        {
          "Area": "Dar'a",
          "Lat": "32.625",
          "Long": "36.105",
          "CountryCode": "SY"
        },
        {
          "Area": "Darhan",
          "Lat": "49.6167",
          "Long": "106.35",
          "CountryCode": "MN"
        },
        {
          "Area": "Darnah",
          "Lat": "32.7648",
          "Long": "22.6391",
          "CountryCode": "LY"
        },
        {
          "Area": "Darwin",
          "Lat": "-12.4254",
          "Long": "130.85",
          "CountryCode": "AU"
        },
        {
          "Area": "Daşoguz",
          "Lat": "41.84",
          "Long": "59.965",
          "CountryCode": "TM"
        },
        {
          "Area": "Datong",
          "Lat": "40.08",
          "Long": "113.3",
          "CountryCode": "CN"
        },
        {
          "Area": "Daugavpils",
          "Lat": "55.88",
          "Long": "26.51",
          "CountryCode": "LV"
        },
        {
          "Area": "Davao",
          "Lat": "7.11",
          "Long": "125.63",
          "CountryCode": "PH"
        },
        {
          "Area": "Davenport",
          "Lat": "41.5563",
          "Long": "-90.6052",
          "CountryCode": "US"
        },
        {
          "Area": "David",
          "Lat": "8.4333",
          "Long": "-82.4333",
          "CountryCode": "PA"
        },
        {
          "Area": "Davie",
          "Lat": "26.079",
          "Long": "-80.287",
          "CountryCode": "US"
        },
        {
          "Area": "Davis",
          "Lat": "38.5552",
          "Long": "-121.7365",
          "CountryCode": "US"
        },
        {
          "Area": "Dawei",
          "Lat": "14.098",
          "Long": "98.195",
          "CountryCode": "MM"
        },
        {
          "Area": "Dayr az Zawr",
          "Lat": "35.3304",
          "Long": "40.13",
          "CountryCode": "SY"
        },
        {
          "Area": "Dayton",
          "Lat": "39.7797",
          "Long": "-84.1998",
          "CountryCode": "US"
        },
        {
          "Area": "Daytona Beach",
          "Lat": "29.1995",
          "Long": "-81.0982",
          "CountryCode": "US"
        },
        {
          "Area": "Dearborn",
          "Lat": "42.3127",
          "Long": "-83.2129",
          "CountryCode": "US"
        },
        {
          "Area": "Dearborn Heights",
          "Lat": "42.3164",
          "Long": "-83.2769",
          "CountryCode": "US"
        },
        {
          "Area": "Debre Birhan",
          "Lat": "9.6804",
          "Long": "39.53",
          "CountryCode": "ET"
        },
        {
          "Area": "Debre Markos",
          "Lat": "10.34",
          "Long": "37.72",
          "CountryCode": "ET"
        },
        {
          "Area": "Debrecen",
          "Lat": "47.5305",
          "Long": "21.63",
          "CountryCode": "HU"
        },
        {
          "Area": "Decatur",
          "Lat": "39.8556",
          "Long": "-88.9337",
          "CountryCode": "US"
        },
        {
          "Area": "Decatur",
          "Lat": "34.573",
          "Long": "-86.9905",
          "CountryCode": "US"
        },
        {
          "Area": "Deerfield Beach",
          "Lat": "26.305",
          "Long": "-80.1278",
          "CountryCode": "US"
        },
        {
          "Area": "DeKalb",
          "Lat": "41.9312",
          "Long": "-88.7483",
          "CountryCode": "US"
        },
        {
          "Area": "Delano",
          "Lat": "35.767",
          "Long": "-119.2637",
          "CountryCode": "US"
        },
        {
          "Area": "Delicias",
          "Lat": "28.2",
          "Long": "-105.5",
          "CountryCode": "MX"
        },
        {
          "Area": "Delray Beach",
          "Lat": "26.455",
          "Long": "-80.0905",
          "CountryCode": "US"
        },
        {
          "Area": "Deltona",
          "Lat": "28.905",
          "Long": "-81.2136",
          "CountryCode": "US"
        },
        {
          "Area": "Dengzhou",
          "Lat": "32.6804",
          "Long": "112.08",
          "CountryCode": "CN"
        },
        {
          "Area": "Denizli",
          "Lat": "37.7704",
          "Long": "29.08",
          "CountryCode": "TR"
        },
        {
          "Area": "Denow",
          "Lat": "38.2772",
          "Long": "67.8872",
          "CountryCode": "UZ"
        },
        {
          "Area": "Denpasar",
          "Lat": "-8.65",
          "Long": "115.22",
          "CountryCode": "ID"
        },
        {
          "Area": "Denton",
          "Lat": "33.2176",
          "Long": "-97.1421",
          "CountryCode": "US"
        },
        {
          "Area": "Denver",
          "Lat": "39.7621",
          "Long": "-104.8759",
          "CountryCode": "US"
        },
        {
          "Area": "Dera Ghazi Khan",
          "Lat": "30.0604",
          "Long": "70.6351",
          "CountryCode": "PK"
        },
        {
          "Area": "Dera Ismail Khan",
          "Lat": "31.829",
          "Long": "70.8986",
          "CountryCode": "PK"
        },
        {
          "Area": "Derbent",
          "Lat": "42.0578",
          "Long": "48.2774",
          "CountryCode": "RU"
        },
        {
          "Area": "Des Moines",
          "Lat": "41.5725",
          "Long": "-93.6104",
          "CountryCode": "US"
        },
        {
          "Area": "Des Plaines",
          "Lat": "42.0344",
          "Long": "-87.9008",
          "CountryCode": "US"
        },
        {
          "Area": "Dese",
          "Lat": "11.13",
          "Long": "39.63",
          "CountryCode": "ET"
        },
        {
          "Area": "DeSoto",
          "Lat": "32.5992",
          "Long": "-96.8633",
          "CountryCode": "US"
        },
        {
          "Area": "Detroit",
          "Lat": "42.3834",
          "Long": "-83.1024",
          "CountryCode": "US"
        },
        {
          "Area": "Deva",
          "Lat": "45.8833",
          "Long": "22.9167",
          "CountryCode": "RO"
        },
        {
          "Area": "Deyang",
          "Lat": "31.1333",
          "Long": "104.4",
          "CountryCode": "CN"
        },
        {
          "Area": "Dezful",
          "Lat": "32.3804",
          "Long": "48.47",
          "CountryCode": "IR"
        },
        {
          "Area": "Dezhou",
          "Lat": "37.4504",
          "Long": "116.3",
          "CountryCode": "CN"
        },
        {
          "Area": "Dhaka",
          "Lat": "23.7231",
          "Long": "90.4086",
          "CountryCode": "BD"
        },
        {
          "Area": "Dhamar",
          "Lat": "14.5575",
          "Long": "44.3875",
          "CountryCode": "YE"
        },
        {
          "Area": "Dhangarhi",
          "Lat": "28.695",
          "Long": "80.593",
          "CountryCode": "NP"
        },
        {
          "Area": "Diamond Bar",
          "Lat": "33.9992",
          "Long": "-117.8161",
          "CountryCode": "US"
        },
        {
          "Area": "Dijon",
          "Lat": "47.3304",
          "Long": "5.03",
          "CountryCode": "FR"
        },
        {
          "Area": "Dili",
          "Lat": "-8.5594",
          "Long": "125.5795",
          "CountryCode": "TL"
        },
        {
          "Area": "Dimbokro",
          "Lat": "6.6505",
          "Long": "-4.71",
          "CountryCode": "CL"
        },
        {
          "Area": "Dimitrovgrad",
          "Lat": "54.2504",
          "Long": "49.56",
          "CountryCode": "RU"
        },
        {
          "Area": "Dingzhou",
          "Lat": "38.5004",
          "Long": "115",
          "CountryCode": "CN"
        },
        {
          "Area": "Diourbel",
          "Lat": "14.6604",
          "Long": "-16.24",
          "CountryCode": "SN"
        },
        {
          "Area": "Dire Dawa",
          "Lat": "9.59",
          "Long": "41.86",
          "CountryCode": "ET"
        },
        {
          "Area": "Divinópolis",
          "Lat": "-20.1495",
          "Long": "-44.9",
          "CountryCode": "BR"
        },
        {
          "Area": "Divo",
          "Lat": "5.839",
          "Long": "-5.36",
          "CountryCode": "CL"
        },
        {
          "Area": "Diyarbakır",
          "Lat": "37.9204",
          "Long": "40.23",
          "CountryCode": "TR"
        },
        {
          "Area": "Djelfa",
          "Lat": "34.68",
          "Long": "3.25",
          "CountryCode": "DZ"
        },
        {
          "Area": "DJ",
          "Lat": "11.595",
          "Long": "43.148",
          "CountryCode": "DJ"
        },
        {
          "Area": "Djougou",
          "Lat": "9.7004",
          "Long": "1.68",
          "CountryCode": "BJ"
        },
        {
          "Area": "Dnipro",
          "Lat": "48.48",
          "Long": "35",
          "CountryCode": "UA"
        },
        {
          "Area": "Dobrich",
          "Lat": "43.5851",
          "Long": "27.84",
          "CountryCode": "BG"
        },
        {
          "Area": "Dodoma",
          "Lat": "-6.1833",
          "Long": "35.75",
          "CountryCode": "TZ"
        },
        {
          "Area": "Doha",
          "Lat": "25.2866",
          "Long": "51.533",
          "CountryCode": "QA"
        },
        {
          "Area": "Dondo",
          "Lat": "-19.6196",
          "Long": "34.73",
          "CountryCode": "MZ"
        },
        {
          "Area": "Donetsk",
          "Lat": "48",
          "Long": "37.83",
          "CountryCode": "UA"
        },
        {
          "Area": "Đồng Hới",
          "Lat": "17.4833",
          "Long": "106.6",
          "CountryCode": "VN"
        },
        {
          "Area": "Dongguan",
          "Lat": "23.0489",
          "Long": "113.7447",
          "CountryCode": "CN"
        },
        {
          "Area": "Doral",
          "Lat": "25.8149",
          "Long": "-80.3565",
          "CountryCode": "US"
        },
        {
          "Area": "Dortmund",
          "Lat": "51.53",
          "Long": "7.45",
          "CountryCode": "DE"
        },
        {
          "Area": "Dothan",
          "Lat": "31.2336",
          "Long": "-85.4068",
          "CountryCode": "US"
        },
        {
          "Area": "Douala",
          "Lat": "4.0604",
          "Long": "9.71",
          "CountryCode": "CM"
        },
        {
          "Area": "Douliou",
          "Lat": "23.7075",
          "Long": "120.5439",
          "CountryCode": "TW"
        },
        {
          "Area": "Douma",
          "Lat": "33.5833",
          "Long": "36.4",
          "CountryCode": "SY"
        },
        {
          "Area": "Dourados",
          "Lat": "-22.23",
          "Long": "-54.81",
          "CountryCode": "BR"
        },
        {
          "Area": "Dover",
          "Lat": "39.1603",
          "Long": "-75.5203",
          "CountryCode": "US"
        },
        {
          "Area": "Dover",
          "Lat": "43.1887",
          "Long": "-70.8845",
          "CountryCode": "US"
        },
        {
          "Area": "Downey",
          "Lat": "33.9379",
          "Long": "-118.1312",
          "CountryCode": "US"
        },
        {
          "Area": "Drammen",
          "Lat": "59.7572",
          "Long": "10.1907",
          "CountryCode": "NO"
        },
        {
          "Area": "Dresden",
          "Lat": "51.05",
          "Long": "13.75",
          "CountryCode": "DE"
        },
        {
          "Area": "Drobeta-Turnu Severin",
          "Lat": "44.6459",
          "Long": "22.6659",
          "CountryCode": "RO"
        },
        {
          "Area": "Drohobych",
          "Lat": "49.3444",
          "Long": "23.4994",
          "CountryCode": "UA"
        },
        {
          "Area": "Drummondville",
          "Lat": "45.8833",
          "Long": "-72.4834",
          "CountryCode": "CA"
        },
        {
          "Area": "Dubai",
          "Lat": "25.23",
          "Long": "55.28",
          "CountryCode": "AE"
        },
        {
          "Area": "Dublin",
          "Lat": "53.3331",
          "Long": "-6.2489",
          "CountryCode": "IE"
        },
        {
          "Area": "Dublin",
          "Lat": "37.7161",
          "Long": "-121.8964",
          "CountryCode": "US"
        },
        {
          "Area": "Dubuque",
          "Lat": "42.5007",
          "Long": "-90.7067",
          "CountryCode": "US"
        },
        {
          "Area": "Duisburg",
          "Lat": "51.43",
          "Long": "6.75",
          "CountryCode": "DE"
        },
        {
          "Area": "Duitama",
          "Lat": "5.8305",
          "Long": "-73.02",
          "CountryCode": "CO"
        },
        {
          "Area": "Duluth",
          "Lat": "46.7757",
          "Long": "-92.1392",
          "CountryCode": "US"
        },
        {
          "Area": "Dumyat",
          "Lat": "31.4204",
          "Long": "31.82",
          "CountryCode": "EG"
        },
        {
          "Area": "Dundee",
          "Lat": "56.4704",
          "Long": "-3",
          "CountryCode": "GB"
        },
        {
          "Area": "Dunedin",
          "Lat": "-45.8854",
          "Long": "170.491",
          "CountryCode": "NZ"
        },
        {
          "Area": "Dunhua",
          "Lat": "43.3505",
          "Long": "128.22",
          "CountryCode": "CN"
        },
        {
          "Area": "Dunhuang",
          "Lat": "40.1427",
          "Long": "94.662",
          "CountryCode": "CN"
        },
        {
          "Area": "Durango",
          "Lat": "24.0311",
          "Long": "-104.67",
          "CountryCode": "MX"
        },
        {
          "Area": "Durban",
          "Lat": "-29.865",
          "Long": "30.98",
          "CountryCode": "ZA"
        },
        {
          "Area": "Durham",
          "Lat": "35.9797",
          "Long": "-78.9037",
          "CountryCode": "US"
        },
        {
          "Area": "Durrës",
          "Lat": "41.3178",
          "Long": "19.4482",
          "CountryCode": "AL"
        },
        {
          "Area": "Dushanbe",
          "Lat": "38.56",
          "Long": "68.7739",
          "CountryCode": "TJ"
        },
        {
          "Area": "Düsseldorf",
          "Lat": "51.2204",
          "Long": "6.78",
          "CountryCode": "DE"
        },
        {
          "Area": "Dzerzhinsk",
          "Lat": "56.2504",
          "Long": "43.46",
          "CountryCode": "RU"
        },
        {
          "Area": "Eagan",
          "Lat": "44.817",
          "Long": "-93.1638",
          "CountryCode": "US"
        },
        {
          "Area": "Eagle Pass",
          "Lat": "28.7118",
          "Long": "-100.4832",
          "CountryCode": "US"
        },
        {
          "Area": "East London",
          "Lat": "-32.97",
          "Long": "27.87",
          "CountryCode": "ZA"
        },
        {
          "Area": "East Orange",
          "Lat": "40.7651",
          "Long": "-74.2117",
          "CountryCode": "US"
        },
        {
          "Area": "East Stroudsburg",
          "Lat": "41.0023",
          "Long": "-75.1779",
          "CountryCode": "US"
        },
        {
          "Area": "Eastvale",
          "Lat": "33.9617",
          "Long": "-117.5802",
          "CountryCode": "US"
        },
        {
          "Area": "Eau Claire",
          "Lat": "44.8203",
          "Long": "-91.4951",
          "CountryCode": "US"
        },
        {
          "Area": "Ebolowa",
          "Lat": "2.9",
          "Long": "11.15",
          "CountryCode": "CM"
        },
        {
          "Area": "Ed Dueim",
          "Lat": "13.9904",
          "Long": "32.3",
          "CountryCode": "SD"
        },
        {
          "Area": "EdDamer",
          "Lat": "17.59",
          "Long": "33.96",
          "CountryCode": "SD"
        },
        {
          "Area": "Edéa",
          "Lat": "3.8005",
          "Long": "10.12",
          "CountryCode": "CM"
        },
        {
          "Area": "Eden Prairie",
          "Lat": "44.8488",
          "Long": "-93.4595",
          "CountryCode": "US"
        },
        {
          "Area": "Edina",
          "Lat": "44.8914",
          "Long": "-93.3602",
          "CountryCode": "US"
        },
        {
          "Area": "Edinburg",
          "Lat": "26.319",
          "Long": "-98.1607",
          "CountryCode": "US"
        },
        {
          "Area": "Edinburgh",
          "Lat": "55.9483",
          "Long": "-3.2191",
          "CountryCode": "GB"
        },
        {
          "Area": "Edirne",
          "Lat": "41.6704",
          "Long": "26.57",
          "CountryCode": "TR"
        },
        {
          "Area": "Edmond",
          "Lat": "35.6689",
          "Long": "-97.4159",
          "CountryCode": "US"
        },
        {
          "Area": "Edmonton",
          "Lat": "53.55",
          "Long": "-113.5",
          "CountryCode": "CA"
        },
        {
          "Area": "Eger",
          "Lat": "47.895",
          "Long": "20.383",
          "CountryCode": "HU"
        },
        {
          "Area": "Eindhoven",
          "Lat": "51.43",
          "Long": "5.5",
          "CountryCode": "NL"
        },
        {
          "Area": "Ekibastuz",
          "Lat": "51.73",
          "Long": "75.3199",
          "CountryCode": "KZ"
        },
        {
          "Area": "El Arish",
          "Lat": "31.1249",
          "Long": "33.8006",
          "CountryCode": "EG"
        },
        {
          "Area": "El Banco",
          "Lat": "9.0003",
          "Long": "-73.98",
          "CountryCode": "CO"
        },
        {
          "Area": "El Bayadh",
          "Lat": "33.6904",
          "Long": "1.01",
          "CountryCode": "DZ"
        },
        {
          "Area": "El Cajon",
          "Lat": "32.8017",
          "Long": "-116.9604",
          "CountryCode": "US"
        },
        {
          "Area": "El Carmen de Bolívar",
          "Lat": "9.7204",
          "Long": "-75.13",
          "CountryCode": "CO"
        },
        {
          "Area": "El Centro",
          "Lat": "32.7873",
          "Long": "-115.5579",
          "CountryCode": "US"
        },
        {
          "Area": "El Faiyum",
          "Lat": "29.31",
          "Long": "30.84",
          "CountryCode": "EG"
        },
        {
          "Area": "El Fasher",
          "Lat": "13.63",
          "Long": "25.35",
          "CountryCode": "SD"
        },
        {
          "Area": "El Giza",
          "Lat": "30.01",
          "Long": "31.19",
          "CountryCode": "EG"
        },
        {
          "Area": "El Jadida",
          "Lat": "33.2604",
          "Long": "-8.51",
          "CountryCode": "MA"
        },
        {
          "Area": "El Manaqil",
          "Lat": "14.2504",
          "Long": "32.98",
          "CountryCode": "SD"
        },
        {
          "Area": "El Mansura",
          "Lat": "31.0504",
          "Long": "31.38",
          "CountryCode": "EG"
        },
        {
          "Area": "El Minya",
          "Lat": "28.09",
          "Long": "30.75",
          "CountryCode": "EG"
        },
        {
          "Area": "El Monte",
          "Lat": "34.074",
          "Long": "-118.0291",
          "CountryCode": "US"
        },
        {
          "Area": "El Obeid",
          "Lat": "13.1833",
          "Long": "30.2167",
          "CountryCode": "SD"
        },
        {
          "Area": "El Oued",
          "Lat": "33.3704",
          "Long": "6.86",
          "CountryCode": "DZ"
        },
        {
          "Area": "El Paso",
          "Lat": "31.8479",
          "Long": "-106.4309",
          "CountryCode": "US"
        },
        {
          "Area": "El Progreso",
          "Lat": "14.85",
          "Long": "-90.0167",
          "CountryCode": "GT"
        },
        {
          "Area": "El Tigre",
          "Lat": "8.8903",
          "Long": "-64.26",
          "CountryCode": "VE"
        },
        {
          "Area": "Elâzığ",
          "Lat": "38.68",
          "Long": "39.23",
          "CountryCode": "TR"
        },
        {
          "Area": "Elbasan",
          "Lat": "41.1215",
          "Long": "20.0838",
          "CountryCode": "AL"
        },
        {
          "Area": "Elbląg",
          "Lat": "54.19",
          "Long": "19.4027",
          "CountryCode": "PL"
        },
        {
          "Area": "Eldoret",
          "Lat": "0.52",
          "Long": "35.27",
          "CountryCode": "KE"
        },
        {
          "Area": "Elgin",
          "Lat": "42.0385",
          "Long": "-88.3229",
          "CountryCode": "US"
        },
        {
          "Area": "Elista",
          "Lat": "46.3287",
          "Long": "44.2087",
          "CountryCode": "RU"
        },
        {
          "Area": "Elizabeth",
          "Lat": "40.6657",
          "Long": "-74.1912",
          "CountryCode": "US"
        },
        {
          "Area": "Elizabethtown",
          "Lat": "37.703",
          "Long": "-85.8772",
          "CountryCode": "US"
        },
        {
          "Area": "Ełk",
          "Lat": "53.8337",
          "Long": "22.35",
          "CountryCode": "PL"
        },
        {
          "Area": "Elk Grove",
          "Lat": "38.416",
          "Long": "-121.384",
          "CountryCode": "US"
        },
        {
          "Area": "Elkhart",
          "Lat": "41.6913",
          "Long": "-85.9628",
          "CountryCode": "US"
        },
        {
          "Area": "Elmira",
          "Lat": "42.0938",
          "Long": "-76.8097",
          "CountryCode": "US"
        },
        {
          "Area": "Elyria",
          "Lat": "41.3761",
          "Long": "-82.1063",
          "CountryCode": "US"
        },
        {
          "Area": "Embu",
          "Lat": "-0.5196",
          "Long": "37.45",
          "CountryCode": "KE"
        },
        {
          "Area": "Emden",
          "Lat": "53.3667",
          "Long": "7.2167",
          "CountryCode": "DE"
        },
        {
          "Area": "En Nuhud",
          "Lat": "12.6904",
          "Long": "28.42",
          "CountryCode": "SD"
        },
        {
          "Area": "Encarnación",
          "Lat": "-27.3472",
          "Long": "-55.8739",
          "CountryCode": "PY"
        },
        {
          "Area": "Encinitas",
          "Lat": "33.0492",
          "Long": "-117.2613",
          "CountryCode": "US"
        },
        {
          "Area": "Ende",
          "Lat": "-8.8623",
          "Long": "121.6489",
          "CountryCode": "ID"
        },
        {
          "Area": "Engels",
          "Lat": "51.5004",
          "Long": "46.12",
          "CountryCode": "RU"
        },
        {
          "Area": "Ensenada",
          "Lat": "31.87",
          "Long": "-116.62",
          "CountryCode": "MX"
        },
        {
          "Area": "Entebbe",
          "Lat": "0.0604",
          "Long": "32.46",
          "CountryCode": "UG"
        },
        {
          "Area": "Enugu",
          "Lat": "6.45",
          "Long": "7.5",
          "CountryCode": "NG"
        },
        {
          "Area": "Er Rachidia",
          "Lat": "31.9404",
          "Long": "-4.45",
          "CountryCode": "MA"
        },
        {
          "Area": "Erdenet",
          "Lat": "49.0533",
          "Long": "104.1183",
          "CountryCode": "MN"
        },
        {
          "Area": "Erechim",
          "Lat": "-27.63",
          "Long": "-52.27",
          "CountryCode": "BR"
        },
        {
          "Area": "Ereğli",
          "Lat": "37.5063",
          "Long": "34.0517",
          "CountryCode": "TR"
        },
        {
          "Area": "Erfurt",
          "Lat": "50.9701",
          "Long": "11.03",
          "CountryCode": "DE"
        },
        {
          "Area": "Erie",
          "Lat": "42.1168",
          "Long": "-80.0733",
          "CountryCode": "US"
        },
        {
          "Area": "Erzincan",
          "Lat": "39.7526",
          "Long": "39.4928",
          "CountryCode": "TR"
        },
        {
          "Area": "Erzurum",
          "Lat": "39.9204",
          "Long": "41.29",
          "CountryCode": "TR"
        },
        {
          "Area": "Esbjerg",
          "Lat": "55.467",
          "Long": "8.45",
          "CountryCode": "DK"
        },
        {
          "Area": "Escondido",
          "Lat": "33.1347",
          "Long": "-117.0722",
          "CountryCode": "US"
        },
        {
          "Area": "Escuintla",
          "Lat": "15.33",
          "Long": "-92.63",
          "CountryCode": "MX"
        },
        {
          "Area": "Escuintla",
          "Lat": "14.3004",
          "Long": "-90.78",
          "CountryCode": "GT"
        },
        {
          "Area": "Eskişehir",
          "Lat": "39.795",
          "Long": "30.53",
          "CountryCode": "TR"
        },
        {
          "Area": "Esmeraldas",
          "Lat": "0.9304",
          "Long": "-79.67",
          "CountryCode": "EC"
        },
        {
          "Area": "Essen",
          "Lat": "51.45",
          "Long": "7.0166",
          "CountryCode": "DE"
        },
        {
          "Area": "Estância",
          "Lat": "-11.2696",
          "Long": "-37.45",
          "CountryCode": "BR"
        },
        {
          "Area": "Estelí",
          "Lat": "13.09",
          "Long": "-86.36",
          "CountryCode": "NI"
        },
        {
          "Area": "Eugene",
          "Lat": "44.0563",
          "Long": "-123.1173",
          "CountryCode": "US"
        },
        {
          "Area": "Euless",
          "Lat": "32.8508",
          "Long": "-97.0798",
          "CountryCode": "US"
        },
        {
          "Area": "Evanston",
          "Lat": "42.0463",
          "Long": "-87.6942",
          "CountryCode": "US"
        },
        {
          "Area": "Evansville",
          "Lat": "37.9882",
          "Long": "-87.5339",
          "CountryCode": "US"
        },
        {
          "Area": "Everett",
          "Lat": "47.9524",
          "Long": "-122.167",
          "CountryCode": "US"
        },
        {
          "Area": "Évora",
          "Lat": "38.56",
          "Long": "-7.906",
          "CountryCode": "PT"
        },
        {
          "Area": "Exeter",
          "Lat": "50.7004",
          "Long": "-3.53",
          "CountryCode": "GB"
        },
        {
          "Area": "Fairbanks",
          "Lat": "64.8353",
          "Long": "-147.6533",
          "CountryCode": "US"
        },
        {
          "Area": "Fairfield",
          "Lat": "38.2594",
          "Long": "-122.0319",
          "CountryCode": "US"
        },
        {
          "Area": "Faisalabad",
          "Lat": "31.41",
          "Long": "73.11",
          "CountryCode": "PK"
        },
        {
          "Area": "Fall River",
          "Lat": "41.7136",
          "Long": "-71.1015",
          "CountryCode": "US"
        },
        {
          "Area": "Farah",
          "Lat": "32.3917",
          "Long": "62.0968",
          "CountryCode": "AF"
        },
        {
          "Area": "Fargo",
          "Lat": "46.8653",
          "Long": "-96.8292",
          "CountryCode": "US"
        },
        {
          "Area": "Fargona",
          "Lat": "40.39",
          "Long": "71.78",
          "CountryCode": "UZ"
        },
        {
          "Area": "Farmington",
          "Lat": "36.7555",
          "Long": "-108.1823",
          "CountryCode": "US"
        },
        {
          "Area": "Farmington Hills",
          "Lat": "42.486",
          "Long": "-83.3771",
          "CountryCode": "US"
        },
        {
          "Area": "Fasa",
          "Lat": "28.9718",
          "Long": "53.6715",
          "CountryCode": "IR"
        },
        {
          "Area": "Fayetteville",
          "Lat": "36.0713",
          "Long": "-94.166",
          "CountryCode": "US"
        },
        {
          "Area": "Fayetteville",
          "Lat": "35.0846",
          "Long": "-78.9776",
          "CountryCode": "US"
        },
        {
          "Area": "Federal Way",
          "Lat": "47.309",
          "Long": "-122.3359",
          "CountryCode": "US"
        },
        {
          "Area": "Feira de Santana",
          "Lat": "-12.25",
          "Long": "-38.97",
          "CountryCode": "BR"
        },
        {
          "Area": "Fengcheng",
          "Lat": "28.2004",
          "Long": "115.77",
          "CountryCode": "CN"
        },
        {
          "Area": "Fengzhen",
          "Lat": "40.4547",
          "Long": "113.1443",
          "CountryCode": "CN"
        },
        {
          "Area": "Ferkessédougou",
          "Lat": "9.6004",
          "Long": "-5.2",
          "CountryCode": "CL"
        },
        {
          "Area": "Fernandópolis",
          "Lat": "-20.2696",
          "Long": "-50.26",
          "CountryCode": "BR"
        },
        {
          "Area": "Ferrara",
          "Lat": "44.8504",
          "Long": "11.6099",
          "CountryCode": "IT"
        },
        {
          "Area": "Ferreñafe",
          "Lat": "-6.63",
          "Long": "-79.8",
          "CountryCode": "PE"
        },
        {
          "Area": "Feyzabad",
          "Lat": "37.1298",
          "Long": "70.5792",
          "CountryCode": "AF"
        },
        {
          "Area": "Fez",
          "Lat": "34.0546",
          "Long": "-5.0004",
          "CountryCode": "MA"
        },
        {
          "Area": "Fianarantsoa",
          "Lat": "-21.4333",
          "Long": "47.0833",
          "CountryCode": "MG"
        },
        {
          "Area": "Fier",
          "Lat": "40.73",
          "Long": "19.573",
          "CountryCode": "AL"
        },
        {
          "Area": "Fishers",
          "Lat": "39.9589",
          "Long": "-85.967",
          "CountryCode": "US"
        },
        {
          "Area": "Flagstaff",
          "Lat": "35.1872",
          "Long": "-111.6195",
          "CountryCode": "US"
        },
        {
          "Area": "Flensburg",
          "Lat": "54.7837",
          "Long": "9.4333",
          "CountryCode": "DE"
        },
        {
          "Area": "Flint",
          "Lat": "43.0236",
          "Long": "-83.6922",
          "CountryCode": "US"
        },
        {
          "Area": "Florence",
          "Lat": "43.78",
          "Long": "11.25",
          "CountryCode": "IT"
        },
        {
          "Area": "Florence",
          "Lat": "34.1785",
          "Long": "-79.7857",
          "CountryCode": "US"
        },
        {
          "Area": "Florence",
          "Lat": "34.83",
          "Long": "-87.6658",
          "CountryCode": "US"
        },
        {
          "Area": "Florencia",
          "Lat": "1.6104",
          "Long": "-75.62",
          "CountryCode": "CO"
        },
        {
          "Area": "Florianópolis",
          "Lat": "-27.58",
          "Long": "-48.52",
          "CountryCode": "BR"
        },
        {
          "Area": "Florissant",
          "Lat": "38.7996",
          "Long": "-90.3269",
          "CountryCode": "US"
        },
        {
          "Area": "Flower Mound",
          "Lat": "33.0344",
          "Long": "-97.1147",
          "CountryCode": "US"
        },
        {
          "Area": "Focșani",
          "Lat": "45.6966",
          "Long": "27.1865",
          "CountryCode": "RO"
        },
        {
          "Area": "Foggia",
          "Lat": "41.4605",
          "Long": "15.56",
          "CountryCode": "IT"
        },
        {
          "Area": "Folsom",
          "Lat": "38.6669",
          "Long": "-121.1422",
          "CountryCode": "US"
        },
        {
          "Area": "Fond du Lac",
          "Lat": "43.772",
          "Long": "-88.4396",
          "CountryCode": "US"
        },
        {
          "Area": "Fontana",
          "Lat": "34.0968",
          "Long": "-117.4599",
          "CountryCode": "US"
        },
        {
          "Area": "Formiga",
          "Lat": "-20.46",
          "Long": "-45.43",
          "CountryCode": "BR"
        },
        {
          "Area": "Formosa",
          "Lat": "-26.1728",
          "Long": "-58.1828",
          "CountryCode": "AR"
        },
        {
          "Area": "Formosa",
          "Lat": "-15.5395",
          "Long": "-47.34",
          "CountryCode": "BR"
        },
        {
          "Area": "Fort Collins",
          "Lat": "40.5479",
          "Long": "-105.0658",
          "CountryCode": "US"
        },
        {
          "Area": "Fort Lauderdale",
          "Lat": "26.1412",
          "Long": "-80.1464",
          "CountryCode": "US"
        },
        {
          "Area": "Fort Myers",
          "Lat": "26.6195",
          "Long": "-81.8302",
          "CountryCode": "US"
        },
        {
          "Area": "Fort Smith",
          "Lat": "35.3494",
          "Long": "-94.3695",
          "CountryCode": "US"
        },
        {
          "Area": "Fort Wayne",
          "Lat": "41.0885",
          "Long": "-85.1436",
          "CountryCode": "US"
        },
        {
          "Area": "Fort Worth",
          "Lat": "32.7814",
          "Long": "-97.3473",
          "CountryCode": "US"
        },
        {
          "Area": "Fort-de-FR",
          "Lat": "14.6104",
          "Long": "-61.08",
          "CountryCode": "MQ"
        },
        {
          "Area": "Fortaleza",
          "Lat": "-3.75",
          "Long": "-38.58",
          "CountryCode": "BR"
        },
        {
          "Area": "Foshan",
          "Lat": "23.0301",
          "Long": "113.12",
          "CountryCode": "CN"
        },
        {
          "Area": "Foumban",
          "Lat": "5.7304",
          "Long": "10.9",
          "CountryCode": "CM"
        },
        {
          "Area": "Fountain Valley",
          "Lat": "33.7105",
          "Long": "-117.9514",
          "CountryCode": "US"
        },
        {
          "Area": "Foz do Iguaçu",
          "Lat": "-25.5235",
          "Long": "-54.53",
          "CountryCode": "BR"
        },
        {
          "Area": "Franca",
          "Lat": "-20.53",
          "Long": "-47.39",
          "CountryCode": "BR"
        },
        {
          "Area": "Francistown",
          "Lat": "-21.17",
          "Long": "27.5",
          "CountryCode": "BW"
        },
        {
          "Area": "Frankfurt",
          "Lat": "50.1",
          "Long": "8.675",
          "CountryCode": "DE"
        },
        {
          "Area": "Franklin",
          "Lat": "35.9214",
          "Long": "-86.8524",
          "CountryCode": "US"
        },
        {
          "Area": "Frederick",
          "Lat": "39.4335",
          "Long": "-77.4157",
          "CountryCode": "US"
        },
        {
          "Area": "Fredericksburg",
          "Lat": "38.2992",
          "Long": "-77.4872",
          "CountryCode": "US"
        },
        {
          "Area": "Fredericton",
          "Lat": "45.95",
          "Long": "-66.6333",
          "CountryCode": "CA"
        },
        {
          "Area": "Freetown",
          "Lat": "8.47",
          "Long": "-13.2342",
          "CountryCode": "SL"
        },
        {
          "Area": "Freiburg",
          "Lat": "48.0004",
          "Long": "7.8699",
          "CountryCode": "DE"
        },
        {
          "Area": "Fremont",
          "Lat": "37.5265",
          "Long": "-121.9852",
          "CountryCode": "US"
        },
        {
          "Area": "Fresnillo",
          "Lat": "23.1704",
          "Long": "-102.86",
          "CountryCode": "MX"
        },
        {
          "Area": "Fresno",
          "Lat": "36.7834",
          "Long": "-119.7941",
          "CountryCode": "US"
        },
        {
          "Area": "Frisco",
          "Lat": "33.1553",
          "Long": "-96.8218",
          "CountryCode": "US"
        },
        {
          "Area": "Fuan",
          "Lat": "27.0704",
          "Long": "119.62",
          "CountryCode": "CN"
        },
        {
          "Area": "Fujin",
          "Lat": "47.2704",
          "Long": "132.02",
          "CountryCode": "CN"
        },
        {
          "Area": "Fukui",
          "Lat": "36.0704",
          "Long": "136.22",
          "CountryCode": "JP"
        },
        {
          "Area": "Fukuoka",
          "Lat": "33.595",
          "Long": "130.41",
          "CountryCode": "JP"
        },
        {
          "Area": "Fukushima",
          "Lat": "37.74",
          "Long": "140.47",
          "CountryCode": "JP"
        },
        {
          "Area": "Fullerton",
          "Lat": "33.8841",
          "Long": "-117.9279",
          "CountryCode": "US"
        },
        {
          "Area": "Funchal",
          "Lat": "32.65",
          "Long": "-16.88",
          "CountryCode": "PT"
        },
        {
          "Area": "Funtua",
          "Lat": "11.5204",
          "Long": "7.32",
          "CountryCode": "NG"
        },
        {
          "Area": "Fürth",
          "Lat": "49.47",
          "Long": "11",
          "CountryCode": "DE"
        },
        {
          "Area": "Fushun",
          "Lat": "41.8654",
          "Long": "123.87",
          "CountryCode": "CN"
        },
        {
          "Area": "Fuxin",
          "Lat": "42.0105",
          "Long": "121.66",
          "CountryCode": "CN"
        },
        {
          "Area": "Fuyang",
          "Lat": "30.0533",
          "Long": "119.9519",
          "CountryCode": "CN"
        },
        {
          "Area": "Fuyang",
          "Lat": "32.9004",
          "Long": "115.82",
          "CountryCode": "CN"
        },
        {
          "Area": "Fuyu",
          "Lat": "45.1804",
          "Long": "124.82",
          "CountryCode": "CN"
        },
        {
          "Area": "Fuzhou",
          "Lat": "26.08",
          "Long": "119.3",
          "CountryCode": "CN"
        },
        {
          "Area": "Gaalkacyo",
          "Lat": "6.77",
          "Long": "47.43",
          "CountryCode": "SO"
        },
        {
          "Area": "Gabès",
          "Lat": "33.9004",
          "Long": "10.1",
          "CountryCode": "TN"
        },
        {
          "Area": "Gaborone",
          "Lat": "-24.6463",
          "Long": "25.9119",
          "CountryCode": "BW"
        },
        {
          "Area": "Gadsden",
          "Lat": "34.009",
          "Long": "-86.0156",
          "CountryCode": "US"
        },
        {
          "Area": "Gafsa",
          "Lat": "34.4204",
          "Long": "8.78",
          "CountryCode": "TN"
        },
        {
          "Area": "Gagnoa",
          "Lat": "6.1504",
          "Long": "-5.88",
          "CountryCode": "CL"
        },
        {
          "Area": "Gainesville",
          "Lat": "29.6808",
          "Long": "-82.3455",
          "CountryCode": "US"
        },
        {
          "Area": "Gainesville",
          "Lat": "34.2901",
          "Long": "-83.8301",
          "CountryCode": "US"
        },
        {
          "Area": "Gaithersburg",
          "Lat": "39.1347",
          "Long": "-77.213",
          "CountryCode": "US"
        },
        {
          "Area": "Galați",
          "Lat": "45.4559",
          "Long": "28.0459",
          "CountryCode": "RO"
        },
        {
          "Area": "Galle",
          "Lat": "6.03",
          "Long": "80.24",
          "CountryCode": "LK"
        },
        {
          "Area": "Galway",
          "Lat": "53.2724",
          "Long": "-9.0488",
          "CountryCode": "IE"
        },
        {
          "Area": "Ganca",
          "Lat": "40.685",
          "Long": "46.35",
          "CountryCode": "AZ"
        },
        {
          "Area": "Gandajika",
          "Lat": "-6.7396",
          "Long": "23.96",
          "CountryCode": "CD"
        },
        {
          "Area": "Gangneung",
          "Lat": "37.7559",
          "Long": "128.8962",
          "CountryCode": "kr"
        },
        {
          "Area": "Gannan",
          "Lat": "47.9204",
          "Long": "123.51",
          "CountryCode": "CN"
        },
        {
          "Area": "Ganzhou",
          "Lat": "25.92",
          "Long": "114.95",
          "CountryCode": "CN"
        },
        {
          "Area": "Gao",
          "Lat": "16.2666",
          "Long": "-0.05",
          "CountryCode": "ML"
        },
        {
          "Area": "Garanhuns",
          "Lat": "-8.89",
          "Long": "-36.5",
          "CountryCode": "BR"
        },
        {
          "Area": "Garden Grove",
          "Lat": "33.7787",
          "Long": "-117.9601",
          "CountryCode": "US"
        },
        {
          "Area": "Gardena",
          "Lat": "33.8944",
          "Long": "-118.3073",
          "CountryCode": "US"
        },
        {
          "Area": "Gardiz",
          "Lat": "33.6001",
          "Long": "69.2146",
          "CountryCode": "AF"
        },
        {
          "Area": "Garissa",
          "Lat": "-0.4396",
          "Long": "39.67",
          "CountryCode": "KE"
        },
        {
          "Area": "Garland",
          "Lat": "32.91",
          "Long": "-96.6305",
          "CountryCode": "US"
        },
        {
          "Area": "Garoua",
          "Lat": "9.3",
          "Long": "13.39",
          "CountryCode": "CM"
        },
        {
          "Area": "Gary",
          "Lat": "41.5906",
          "Long": "-87.3472",
          "CountryCode": "US"
        },
        {
          "Area": "Garzón",
          "Lat": "2.2104",
          "Long": "-75.65",
          "CountryCode": "CO"
        },
        {
          "Area": "Gashua",
          "Lat": "12.8705",
          "Long": "11.04",
          "CountryCode": "NG"
        },
        {
          "Area": "Gastonia",
          "Lat": "35.2494",
          "Long": "-81.1855",
          "CountryCode": "US"
        },
        {
          "Area": "GatCN",
          "Lat": "59.5707",
          "Long": "30.1333",
          "CountryCode": "RU"
        },
        {
          "Area": "Gävle",
          "Lat": "60.667",
          "Long": "17.1666",
          "CountryCode": "SE"
        },
        {
          "Area": "Gaziantep",
          "Lat": "37.075",
          "Long": "37.385",
          "CountryCode": "TR"
        },
        {
          "Area": "Gbadolite",
          "Lat": "4.2904",
          "Long": "21.0199",
          "CountryCode": "CD"
        },
        {
          "Area": "Gdańsk",
          "Lat": "54.36",
          "Long": "18.64",
          "CountryCode": "PL"
        },
        {
          "Area": "Gdynia",
          "Lat": "54.5204",
          "Long": "18.53",
          "CountryCode": "PL"
        },
        {
          "Area": "Gedaref",
          "Lat": "14.04",
          "Long": "35.38",
          "CountryCode": "SD"
        },
        {
          "Area": "Geelong",
          "Lat": "-38.1675",
          "Long": "144.3956",
          "CountryCode": "AU"
        },
        {
          "Area": "Gejiu",
          "Lat": "23.38",
          "Long": "103.1501",
          "CountryCode": "CN"
        },
        {
          "Area": "Gelendzhik",
          "Lat": "44.5748",
          "Long": "38.0644",
          "CountryCode": "RU"
        },
        {
          "Area": "Gemena",
          "Lat": "3.26",
          "Long": "19.77",
          "CountryCode": "CD"
        },
        {
          "Area": "Geneina",
          "Lat": "13.45",
          "Long": "22.44",
          "CountryCode": "SD"
        },
        {
          "Area": "General Pico",
          "Lat": "-35.6596",
          "Long": "-63.77",
          "CountryCode": "AR"
        },
        {
          "Area": "General Roca",
          "Lat": "-39.02",
          "Long": "-67.61",
          "CountryCode": "AR"
        },
        {
          "Area": "General Santos",
          "Lat": "6.1108",
          "Long": "125.1747",
          "CountryCode": "PH"
        },
        {
          "Area": "Geneva",
          "Lat": "46.21",
          "Long": "6.14",
          "CountryCode": "CH"
        },
        {
          "Area": "Genoa",
          "Lat": "44.41",
          "Long": "8.93",
          "CountryCode": "IT"
        },
        {
          "Area": "Gent",
          "Lat": "51.03",
          "Long": "3.7",
          "CountryCode": "BE"
        },
        {
          "Area": "George",
          "Lat": "-33.95",
          "Long": "22.45",
          "CountryCode": "ZA"
        },
        {
          "Area": "George Town",
          "Lat": "5.4136",
          "Long": "100.3294",
          "CountryCode": "MY"
        },
        {
          "Area": "Georgetown",
          "Lat": "6.802",
          "Long": "-58.167",
          "CountryCode": "GY"
        },
        {
          "Area": "Georgetown",
          "Lat": "30.6664",
          "Long": "-97.6937",
          "CountryCode": "US"
        },
        {
          "Area": "Georgievsk",
          "Lat": "44.1599",
          "Long": "43.4699",
          "CountryCode": "RU"
        },
        {
          "Area": "Gera",
          "Lat": "50.8704",
          "Long": "12.07",
          "CountryCode": "DE"
        },
        {
          "Area": "Ghardaia",
          "Lat": "32.49",
          "Long": "3.67",
          "CountryCode": "DZ"
        },
        {
          "Area": "Gharyan",
          "Lat": "32.1704",
          "Long": "13.02",
          "CountryCode": "LY"
        },
        {
          "Area": "Ghazni",
          "Lat": "33.5633",
          "Long": "68.4178",
          "CountryCode": "AF"
        },
        {
          "Area": "GI",
          "Lat": "36.1324",
          "Long": "-5.3781",
          "CountryCode": "GI"
        },
        {
          "Area": "Gießen",
          "Lat": "50.5837",
          "Long": "8.65",
          "CountryCode": "DE"
        },
        {
          "Area": "Gifu",
          "Lat": "35.4231",
          "Long": "136.7628",
          "CountryCode": "JP"
        },
        {
          "Area": "Gijón",
          "Lat": "43.53",
          "Long": "-5.67",
          "CountryCode": "ES"
        },
        {
          "Area": "Gilbert",
          "Lat": "33.3103",
          "Long": "-111.7463",
          "CountryCode": "US"
        },
        {
          "Area": "Gilgit",
          "Lat": "35.9171",
          "Long": "74.3",
          "CountryCode": "PK"
        },
        {
          "Area": "Gilroy",
          "Lat": "37.0047",
          "Long": "-121.5843",
          "CountryCode": "US"
        },
        {
          "Area": "Girardot",
          "Lat": "4.31",
          "Long": "-74.81",
          "CountryCode": "CO"
        },
        {
          "Area": "Giresun",
          "Lat": "40.913",
          "Long": "38.39",
          "CountryCode": "TR"
        },
        {
          "Area": "Girga",
          "Lat": "26.3304",
          "Long": "31.88",
          "CountryCode": "EG"
        },
        {
          "Area": "Gisenyi",
          "Lat": "-1.6847",
          "Long": "29.2629",
          "CountryCode": "RW"
        },
        {
          "Area": "Gitarama",
          "Lat": "-2.0696",
          "Long": "29.76",
          "CountryCode": "RW"
        },
        {
          "Area": "Giurgiu",
          "Lat": "43.93",
          "Long": "25.84",
          "CountryCode": "RO"
        },
        {
          "Area": "Giyon",
          "Lat": "8.5304",
          "Long": "37.97",
          "CountryCode": "ET"
        },
        {
          "Area": "Glasgow",
          "Lat": "55.8744",
          "Long": "-4.2507",
          "CountryCode": "GB"
        },
        {
          "Area": "Glazov",
          "Lat": "58.1232",
          "Long": "52.6288",
          "CountryCode": "RU"
        },
        {
          "Area": "Glendale",
          "Lat": "33.5796",
          "Long": "-112.2258",
          "CountryCode": "US"
        },
        {
          "Area": "Glendale",
          "Lat": "34.1818",
          "Long": "-118.2468",
          "CountryCode": "US"
        },
        {
          "Area": "Glendora",
          "Lat": "34.1449",
          "Long": "-117.8468",
          "CountryCode": "US"
        },
        {
          "Area": "Glens Falls",
          "Lat": "43.3109",
          "Long": "-73.6459",
          "CountryCode": "US"
        },
        {
          "Area": "Gliwice",
          "Lat": "50.3304",
          "Long": "18.67",
          "CountryCode": "PL"
        },
        {
          "Area": "Gode",
          "Lat": "5.95",
          "Long": "43.45",
          "CountryCode": "ET"
        },
        {
          "Area": "Gogrial",
          "Lat": "8.5337",
          "Long": "28.1167",
          "CountryCode": "SD"
        },
        {
          "Area": "Goiana",
          "Lat": "-7.5596",
          "Long": "-35",
          "CountryCode": "BR"
        },
        {
          "Area": "Goiânia",
          "Lat": "-16.72",
          "Long": "-49.3",
          "CountryCode": "BR"
        },
        {
          "Area": "Gold Coast",
          "Lat": "-28.0815",
          "Long": "153.4482",
          "CountryCode": "AU"
        },
        {
          "Area": "Goldsboro",
          "Lat": "35.3777",
          "Long": "-77.972",
          "CountryCode": "US"
        },
        {
          "Area": "Golmud",
          "Lat": "36.4166",
          "Long": "94.8833",
          "CountryCode": "CN"
        },
        {
          "Area": "Goma",
          "Lat": "-1.6788",
          "Long": "29.2218",
          "CountryCode": "CD"
        },
        {
          "Area": "Gombe",
          "Lat": "10.2904",
          "Long": "11.17",
          "CountryCode": "NG"
        },
        {
          "Area": "Gómez Palacio",
          "Lat": "25.5701",
          "Long": "-103.5",
          "CountryCode": "MX"
        },
        {
          "Area": "Gonaïves",
          "Lat": "19.4504",
          "Long": "-72.6832",
          "CountryCode": "HT"
        },
        {
          "Area": "Gonbad-e Kavus",
          "Lat": "37.2518",
          "Long": "55.1715",
          "CountryCode": "IR"
        },
        {
          "Area": "Gondar",
          "Lat": "12.61",
          "Long": "37.46",
          "CountryCode": "ET"
        },
        {
          "Area": "Goodyear",
          "Lat": "33.2614",
          "Long": "-112.3622",
          "CountryCode": "US"
        },
        {
          "Area": "Gorgan",
          "Lat": "36.8303",
          "Long": "54.48",
          "CountryCode": "IR"
        },
        {
          "Area": "Gorno Altaysk",
          "Lat": "51.9613",
          "Long": "85.9577",
          "CountryCode": "RU"
        },
        {
          "Area": "Gorontalo",
          "Lat": "0.55",
          "Long": "123.07",
          "CountryCode": "ID"
        },
        {
          "Area": "Göteborg",
          "Lat": "57.75",
          "Long": "12",
          "CountryCode": "SE"
        },
        {
          "Area": "Göttingen",
          "Lat": "51.5204",
          "Long": "9.92",
          "CountryCode": "DE"
        },
        {
          "Area": "Goulimine",
          "Lat": "28.98",
          "Long": "-10.07",
          "CountryCode": "MA"
        },
        {
          "Area": "Governador Valadares",
          "Lat": "-18.87",
          "Long": "-41.97",
          "CountryCode": "BR"
        },
        {
          "Area": "Goya",
          "Lat": "-29.14",
          "Long": "-59.27",
          "CountryCode": "AR"
        },
        {
          "Area": "Goyang",
          "Lat": "37.6527",
          "Long": "126.8372",
          "CountryCode": "kr"
        },
        {
          "Area": "Graaff Reinet",
          "Lat": "-32.3",
          "Long": "24.54",
          "CountryCode": "ZA"
        },
        {
          "Area": "Grahamstown",
          "Lat": "-33.2996",
          "Long": "26.52",
          "CountryCode": "ZA"
        },
        {
          "Area": "Granada‎",
          "Lat": "37.165",
          "Long": "-3.585",
          "CountryCode": "ES"
        },
        {
          "Area": "Granada‎",
          "Lat": "11.9337",
          "Long": "-85.95",
          "CountryCode": "NI"
        },
        {
          "Area": "Grand Bassam",
          "Lat": "5.2004",
          "Long": "-3.75",
          "CountryCode": "CL"
        },
        {
          "Area": "Grand Forks",
          "Lat": "47.9223",
          "Long": "-97.0887",
          "CountryCode": "US"
        },
        {
          "Area": "Grand Island",
          "Lat": "40.9214",
          "Long": "-98.3584",
          "CountryCode": "US"
        },
        {
          "Area": "Grand Junction",
          "Lat": "39.0878",
          "Long": "-108.5673",
          "CountryCode": "US"
        },
        {
          "Area": "Grand Prairie",
          "Lat": "32.6869",
          "Long": "-97.0209",
          "CountryCode": "US"
        },
        {
          "Area": "Grand Rapids",
          "Lat": "42.9615",
          "Long": "-85.6557",
          "CountryCode": "US"
        },
        {
          "Area": "Grants Pass",
          "Lat": "42.4333",
          "Long": "-123.3317",
          "CountryCode": "US"
        },
        {
          "Area": "Grapevine",
          "Lat": "32.9343",
          "Long": "-97.0744",
          "CountryCode": "US"
        },
        {
          "Area": "Graz",
          "Lat": "47.0778",
          "Long": "15.41",
          "CountryCode": "AT"
        },
        {
          "Area": "Great Falls",
          "Lat": "47.5022",
          "Long": "-111.2995",
          "CountryCode": "US"
        },
        {
          "Area": "Greeley",
          "Lat": "40.415",
          "Long": "-104.7696",
          "CountryCode": "US"
        },
        {
          "Area": "Green Bay",
          "Lat": "44.515",
          "Long": "-87.9896",
          "CountryCode": "US"
        },
        {
          "Area": "Greenock",
          "Lat": "55.9333",
          "Long": "-4.75",
          "CountryCode": "GB"
        },
        {
          "Area": "Greensboro",
          "Lat": "36.0956",
          "Long": "-79.8269",
          "CountryCode": "US"
        },
        {
          "Area": "Greenville",
          "Lat": "34.8363",
          "Long": "-82.365",
          "CountryCode": "US"
        },
        {
          "Area": "Greenville",
          "Lat": "35.5957",
          "Long": "-77.3764",
          "CountryCode": "US"
        },
        {
          "Area": "Greenwood",
          "Lat": "39.6019",
          "Long": "-86.1073",
          "CountryCode": "US"
        },
        {
          "Area": "Grenoble",
          "Lat": "45.1804",
          "Long": "5.72",
          "CountryCode": "FR"
        },
        {
          "Area": "Gresham",
          "Lat": "45.5023",
          "Long": "-122.4414",
          "CountryCode": "US"
        },
        {
          "Area": "Groningen",
          "Lat": "53.2204",
          "Long": "6.58",
          "CountryCode": "NL"
        },
        {
          "Area": "Groznyy",
          "Lat": "43.3187",
          "Long": "45.6987",
          "CountryCode": "RU"
        },
        {
          "Area": "Grudziądz",
          "Lat": "53.4804",
          "Long": "18.75",
          "CountryCode": "PL"
        },
        {
          "Area": "Guadalajara",
          "Lat": "20.67",
          "Long": "-103.33",
          "CountryCode": "MX"
        },
        {
          "Area": "Guadalajara",
          "Lat": "40.6337",
          "Long": "-3.1666",
          "CountryCode": "ES"
        },
        {
          "Area": "Guajara-Miram",
          "Lat": "-10.8",
          "Long": "-65.3499",
          "CountryCode": "BR"
        },
        {
          "Area": "Gualeguaychú",
          "Lat": "-33.02",
          "Long": "-58.52",
          "CountryCode": "AR"
        },
        {
          "Area": "GUúchil",
          "Lat": "25.4704",
          "Long": "-108.09",
          "CountryCode": "MX"
        },
        {
          "Area": "Guanajuato",
          "Lat": "21.0204",
          "Long": "-101.28",
          "CountryCode": "MX"
        },
        {
          "Area": "Guanambi",
          "Lat": "-14.2296",
          "Long": "-42.79",
          "CountryCode": "BR"
        },
        {
          "Area": "Guanare",
          "Lat": "9.05",
          "Long": "-69.75",
          "CountryCode": "VE"
        },
        {
          "Area": "Guangshui",
          "Lat": "31.6204",
          "Long": "114",
          "CountryCode": "CN"
        },
        {
          "Area": "Guangyuan",
          "Lat": "32.43",
          "Long": "105.87",
          "CountryCode": "CN"
        },
        {
          "Area": "Guangzhou",
          "Lat": "23.145",
          "Long": "113.325",
          "CountryCode": "CN"
        },
        {
          "Area": "Guantánamo",
          "Lat": "20.1453",
          "Long": "-75.2061",
          "CountryCode": "CU"
        },
        {
          "Area": "Guarapuava",
          "Lat": "-25.38",
          "Long": "-51.48",
          "CountryCode": "BR"
        },
        {
          "Area": "Guaratinguetá",
          "Lat": "-22.82",
          "Long": "-45.19",
          "CountryCode": "BR"
        },
        {
          "Area": "Guasave",
          "Lat": "25.5705",
          "Long": "-108.47",
          "CountryCode": "MX"
        },
        {
          "Area": "GT",
          "Lat": "14.6211",
          "Long": "-90.527",
          "CountryCode": "GT"
        },
        {
          "Area": "Guayaquil",
          "Lat": "-2.22",
          "Long": "-79.92",
          "CountryCode": "EC"
        },
        {
          "Area": "Guaymas",
          "Lat": "27.93",
          "Long": "-110.89",
          "CountryCode": "MX"
        },
        {
          "Area": "Gueckedou",
          "Lat": "8.554",
          "Long": "-10.151",
          "CountryCode": "GN"
        },
        {
          "Area": "Guelma",
          "Lat": "36.466",
          "Long": "7.428",
          "CountryCode": "DZ"
        },
        {
          "Area": "Guider",
          "Lat": "9.9304",
          "Long": "13.94",
          "CountryCode": "CM"
        },
        {
          "Area": "Guilin",
          "Lat": "25.28",
          "Long": "110.28",
          "CountryCode": "CN"
        },
        {
          "Area": "Güines",
          "Lat": "22.8361",
          "Long": "-82.028",
          "CountryCode": "CU"
        },
        {
          "Area": "Guiyang",
          "Lat": "26.58",
          "Long": "106.72",
          "CountryCode": "CN"
        },
        {
          "Area": "Gujranwala",
          "Lat": "32.1604",
          "Long": "74.185",
          "CountryCode": "PK"
        },
        {
          "Area": "Gujrat",
          "Lat": "32.58",
          "Long": "74.08",
          "CountryCode": "PK"
        },
        {
          "Area": "Gulfport",
          "Lat": "30.4271",
          "Long": "-89.0703",
          "CountryCode": "US"
        },
        {
          "Area": "Guliston",
          "Lat": "40.4957",
          "Long": "68.7907",
          "CountryCode": "UZ"
        },
        {
          "Area": "Gulu",
          "Lat": "2.78",
          "Long": "32.28",
          "CountryCode": "UG"
        },
        {
          "Area": "Gunsan",
          "Lat": "35.9818",
          "Long": "126.716",
          "CountryCode": "kr"
        },
        {
          "Area": "Gurupi",
          "Lat": "-11.7196",
          "Long": "-49.06",
          "CountryCode": "BR"
        },
        {
          "Area": "Gusau",
          "Lat": "12.1704",
          "Long": "6.66",
          "CountryCode": "NG"
        },
        {
          "Area": "Gwadar",
          "Lat": "25.139",
          "Long": "62.3286",
          "CountryCode": "PK"
        },
        {
          "Area": "Gwangju",
          "Lat": "35.171",
          "Long": "126.9104",
          "CountryCode": "kr"
        },
        {
          "Area": "Gweru",
          "Lat": "-19.45",
          "Long": "29.82",
          "CountryCode": "ZW"
        },
        {
          "Area": "Gyeongju",
          "Lat": "35.8428",
          "Long": "129.2117",
          "CountryCode": "kr"
        },
        {
          "Area": "Győr",
          "Lat": "47.7004",
          "Long": "17.63",
          "CountryCode": "HU"
        },
        {
          "Area": "Gyumri",
          "Lat": "40.7894",
          "Long": "43.8475",
          "CountryCode": "AM"
        },
        {
          "Area": "Hà Tĩnh",
          "Lat": "18.3338",
          "Long": "105.9",
          "CountryCode": "VN"
        },
        {
          "Area": "Haarlem",
          "Lat": "52.3804",
          "Long": "4.63",
          "CountryCode": "NL"
        },
        {
          "Area": "Hachinohe",
          "Lat": "40.51",
          "Long": "141.54",
          "CountryCode": "JP"
        },
        {
          "Area": "Hachiōji",
          "Lat": "35.6577",
          "Long": "139.3261",
          "CountryCode": "JP"
        },
        {
          "Area": "Haeju",
          "Lat": "38.0394",
          "Long": "125.7144",
          "CountryCode": "KP"
        },
        {
          "Area": "Hafar al Batin",
          "Lat": "28.4337",
          "Long": "45.9601",
          "CountryCode": "SA"
        },
        {
          "Area": "Hagerstown",
          "Lat": "39.6401",
          "Long": "-77.7217",
          "CountryCode": "US"
        },
        {
          "Area": "Hai Duong",
          "Lat": "20.942",
          "Long": "106.331",
          "CountryCode": "VN"
        },
        {
          "Area": "Haifa",
          "Lat": "32.8204",
          "Long": "34.98",
          "CountryCode": "IL"
        },
        {
          "Area": "Haikou",
          "Lat": "20.05",
          "Long": "110.32",
          "CountryCode": "CN"
        },
        {
          "Area": "Hail",
          "Lat": "27.5236",
          "Long": "41.7001",
          "CountryCode": "SA"
        },
        {
          "Area": "Hailar",
          "Lat": "49.2",
          "Long": "119.7",
          "CountryCode": "CN"
        },
        {
          "Area": "Hailun",
          "Lat": "47.4504",
          "Long": "126.93",
          "CountryCode": "CN"
        },
        {
          "Area": "Haiphong",
          "Lat": "20.83",
          "Long": "106.6801",
          "CountryCode": "VN"
        },
        {
          "Area": "Hajjah",
          "Lat": "15.6917",
          "Long": "43.6021",
          "CountryCode": "YE"
        },
        {
          "Area": "Hakkâri",
          "Lat": "37.5744",
          "Long": "43.7408",
          "CountryCode": "TR"
        },
        {
          "Area": "Hakodate",
          "Lat": "41.795",
          "Long": "140.74",
          "CountryCode": "JP"
        },
        {
          "Area": "Half Way Tree",
          "Lat": "18.0333",
          "Long": "-76.8",
          "CountryCode": "JM"
        },
        {
          "Area": "Halifax",
          "Lat": "44.65",
          "Long": "-63.6",
          "CountryCode": "CA"
        },
        {
          "Area": "Halmstad",
          "Lat": "56.6718",
          "Long": "12.8556",
          "CountryCode": "SE"
        },
        {
          "Area": "Hamadan",
          "Lat": "34.796",
          "Long": "48.515",
          "CountryCode": "IR"
        },
        {
          "Area": "Hamah",
          "Lat": "35.1503",
          "Long": "36.73",
          "CountryCode": "SY"
        },
        {
          "Area": "Hamamatsu",
          "Lat": "34.7181",
          "Long": "137.7327",
          "CountryCode": "JP"
        },
        {
          "Area": "Hamburg",
          "Lat": "53.55",
          "Long": "10",
          "CountryCode": "DE"
        },
        {
          "Area": "Hamhung",
          "Lat": "39.9101",
          "Long": "127.5454",
          "CountryCode": "KP"
        },
        {
          "Area": "Hami",
          "Lat": "42.827",
          "Long": "93.515",
          "CountryCode": "CN"
        },
        {
          "Area": "Hamilton",
          "Lat": "43.25",
          "Long": "-79.83",
          "CountryCode": "CA"
        },
        {
          "Area": "Hamilton",
          "Lat": "-37.7783",
          "Long": "175.2896",
          "CountryCode": "NZ"
        },
        {
          "Area": "Hamilton",
          "Lat": "39.3938",
          "Long": "-84.5653",
          "CountryCode": "US"
        },
        {
          "Area": "Hamilton",
          "Lat": "32.2942",
          "Long": "-64.7839",
          "CountryCode": "BM"
        },
        {
          "Area": "Hammond",
          "Lat": "41.617",
          "Long": "-87.4908",
          "CountryCode": "US"
        },
        {
          "Area": "Hammond",
          "Lat": "30.506",
          "Long": "-90.456",
          "CountryCode": "US"
        },
        {
          "Area": "Hampton",
          "Lat": "37.0551",
          "Long": "-76.3629",
          "CountryCode": "US"
        },
        {
          "Area": "Hancheng",
          "Lat": "35.4704",
          "Long": "110.43",
          "CountryCode": "CN"
        },
        {
          "Area": "Handan",
          "Lat": "36.58",
          "Long": "114.48",
          "CountryCode": "CN"
        },
        {
          "Area": "Hanford",
          "Lat": "36.326",
          "Long": "-119.654",
          "CountryCode": "US"
        },
        {
          "Area": "Hangu",
          "Lat": "39.232",
          "Long": "117.777",
          "CountryCode": "CN"
        },
        {
          "Area": "Hangzhou",
          "Lat": "30.25",
          "Long": "120.17",
          "CountryCode": "CN"
        },
        {
          "Area": "Hania",
          "Lat": "35.5122",
          "Long": "24.0156",
          "CountryCode": "GR"
        },
        {
          "Area": "Hannover",
          "Lat": "52.367",
          "Long": "9.7167",
          "CountryCode": "DE"
        },
        {
          "Area": "Hanoi",
          "Lat": "21.0333",
          "Long": "105.85",
          "CountryCode": "VN"
        },
        {
          "Area": "Hanover",
          "Lat": "39.8117",
          "Long": "-76.9835",
          "CountryCode": "US"
        },
        {
          "Area": "Hanzhong",
          "Lat": "33.13",
          "Long": "107.03",
          "CountryCode": "CN"
        },
        {
          "Area": "Harar",
          "Lat": "9.32",
          "Long": "42.15",
          "CountryCode": "ET"
        },
        {
          "Area": "Harare",
          "Lat": "-17.8178",
          "Long": "31.0447",
          "CountryCode": "ZW"
        },
        {
          "Area": "Harbin",
          "Lat": "45.75",
          "Long": "126.65",
          "CountryCode": "CN"
        },
        {
          "Area": "Harlingen",
          "Lat": "26.1917",
          "Long": "-97.6977",
          "CountryCode": "US"
        },
        {
          "Area": "Harrisburg",
          "Lat": "40.2752",
          "Long": "-76.8843",
          "CountryCode": "US"
        },
        {
          "Area": "Harrisonburg",
          "Lat": "38.4362",
          "Long": "-78.8735",
          "CountryCode": "US"
        },
        {
          "Area": "Hartford",
          "Lat": "41.7661",
          "Long": "-72.6834",
          "CountryCode": "US"
        },
        {
          "Area": "Hasselt",
          "Lat": "50.964",
          "Long": "5.484",
          "CountryCode": "BE"
        },
        {
          "Area": "Hat Yai",
          "Lat": "6.9964",
          "Long": "100.4714",
          "CountryCode": "TH"
        },
        {
          "Area": "Hatay",
          "Lat": "36.2304",
          "Long": "36.12",
          "CountryCode": "TR"
        },
        {
          "Area": "Hattiesburg",
          "Lat": "31.3072",
          "Long": "-89.3168",
          "CountryCode": "US"
        },
        {
          "Area": "Havana",
          "Lat": "23.132",
          "Long": "-82.3642",
          "CountryCode": "CU"
        },
        {
          "Area": "Haverhill",
          "Lat": "42.7838",
          "Long": "-71.0871",
          "CountryCode": "US"
        },
        {
          "Area": "Hawthorne",
          "Lat": "33.9147",
          "Long": "-118.3476",
          "CountryCode": "US"
        },
        {
          "Area": "Hayward",
          "Lat": "37.6328",
          "Long": "-122.0772",
          "CountryCode": "US"
        },
        {
          "Area": "Hazleton",
          "Lat": "40.9504",
          "Long": "-75.9724",
          "CountryCode": "US"
        },
        {
          "Area": "Hebi",
          "Lat": "35.9504",
          "Long": "114.22",
          "CountryCode": "CN"
        },
        {
          "Area": "Hechi",
          "Lat": "23.0965",
          "Long": "109.6091",
          "CountryCode": "CN"
        },
        {
          "Area": "Hefei",
          "Lat": "31.85",
          "Long": "117.28",
          "CountryCode": "CN"
        },
        {
          "Area": "Hegang",
          "Lat": "47.4",
          "Long": "130.37",
          "CountryCode": "CN"
        },
        {
          "Area": "Heidelberg",
          "Lat": "49.42",
          "Long": "8.7",
          "CountryCode": "DE"
        },
        {
          "Area": "Heihe",
          "Lat": "50.25",
          "Long": "127.446",
          "CountryCode": "CN"
        },
        {
          "Area": "Helena",
          "Lat": "46.5964",
          "Long": "-112.0197",
          "CountryCode": "US"
        },
        {
          "Area": "Helong",
          "Lat": "42.5348",
          "Long": "129.0044",
          "CountryCode": "CN"
        },
        {
          "Area": "Helsingborg",
          "Lat": "56.0505",
          "Long": "12.7",
          "CountryCode": "SE"
        },
        {
          "Area": "Helsinki",
          "Lat": "60.1756",
          "Long": "24.9341",
          "CountryCode": "FI"
        },
        {
          "Area": "Hemet",
          "Lat": "33.7341",
          "Long": "-116.9969",
          "CountryCode": "US"
        },
        {
          "Area": "Hempstead",
          "Lat": "40.7043",
          "Long": "-73.6193",
          "CountryCode": "US"
        },
        {
          "Area": "Henderson",
          "Lat": "36.0145",
          "Long": "-115.0362",
          "CountryCode": "US"
        },
        {
          "Area": "Hendersonville",
          "Lat": "36.3063",
          "Long": "-86.5997",
          "CountryCode": "US"
        },
        {
          "Area": "Hengshui",
          "Lat": "37.72",
          "Long": "115.7",
          "CountryCode": "CN"
        },
        {
          "Area": "Hengyang",
          "Lat": "26.88",
          "Long": "112.59",
          "CountryCode": "CN"
        },
        {
          "Area": "Herat",
          "Lat": "34.33",
          "Long": "62.17",
          "CountryCode": "AF"
        },
        {
          "Area": "Hermosillo",
          "Lat": "29.0989",
          "Long": "-110.9541",
          "CountryCode": "MX"
        },
        {
          "Area": "Hesperia",
          "Lat": "34.3974",
          "Long": "-117.3144",
          "CountryCode": "US"
        },
        {
          "Area": "Hetauda",
          "Lat": "27.4167",
          "Long": "85.0334",
          "CountryCode": "NP"
        },
        {
          "Area": "Heyuan",
          "Lat": "23.7304",
          "Long": "114.68",
          "CountryCode": "CN"
        },
        {
          "Area": "Heze",
          "Lat": "35.23",
          "Long": "115.45",
          "CountryCode": "CN"
        },
        {
          "Area": "Hialeah",
          "Lat": "25.8696",
          "Long": "-80.3045",
          "CountryCode": "US"
        },
        {
          "Area": "Hickory",
          "Lat": "35.7427",
          "Long": "-81.3233",
          "CountryCode": "US"
        },
        {
          "Area": "Hidalgo del Parral",
          "Lat": "26.9334",
          "Long": "-105.6666",
          "CountryCode": "MX"
        },
        {
          "Area": "High Point",
          "Lat": "35.9902",
          "Long": "-79.9938",
          "CountryCode": "US"
        },
        {
          "Area": "Highland",
          "Lat": "34.1113",
          "Long": "-117.1653",
          "CountryCode": "US"
        },
        {
          "Area": "Higuey",
          "Lat": "18.616",
          "Long": "-68.708",
          "CountryCode": "DO"
        },
        {
          "Area": "Hillsboro",
          "Lat": "45.5271",
          "Long": "-122.9358",
          "CountryCode": "US"
        },
        {
          "Area": "Hilton Head Island",
          "Lat": "32.1896",
          "Long": "-80.7499",
          "CountryCode": "US"
        },
        {
          "Area": "Hims",
          "Lat": "34.73",
          "Long": "36.72",
          "CountryCode": "SY"
        },
        {
          "Area": "Hinesville",
          "Lat": "31.8247",
          "Long": "-81.6135",
          "CountryCode": "US"
        },
        {
          "Area": "Hinthada",
          "Lat": "17.6483",
          "Long": "95.4679",
          "CountryCode": "MM"
        },
        {
          "Area": "Hirosaki",
          "Lat": "40.57",
          "Long": "140.47",
          "CountryCode": "JP"
        },
        {
          "Area": "Hiroshima",
          "Lat": "34.3878",
          "Long": "132.4429",
          "CountryCode": "JP"
        },
        {
          "Area": "Ho",
          "Lat": "6.6004",
          "Long": "0.47",
          "CountryCode": "GH"
        },
        {
          "Area": "Ho Chi Minh City",
          "Lat": "10.78",
          "Long": "106.695",
          "CountryCode": "VN"
        },
        {
          "Area": "Hoa Binh",
          "Lat": "20.8137",
          "Long": "105.3383",
          "CountryCode": "VN"
        },
        {
          "Area": "Hobart",
          "Lat": "-42.85",
          "Long": "147.295",
          "CountryCode": "AU"
        },
        {
          "Area": "Hoboken",
          "Lat": "40.7453",
          "Long": "-74.0279",
          "CountryCode": "US"
        },
        {
          "Area": "Hof",
          "Lat": "50.317",
          "Long": "11.9167",
          "CountryCode": "DE"
        },
        {
          "Area": "Hoffman Eareas",
          "Lat": "42.0638",
          "Long": "-88.1463",
          "CountryCode": "US"
        },
        {
          "Area": "Hohhot",
          "Lat": "40.82",
          "Long": "111.66",
          "CountryCode": "CN"
        },
        {
          "Area": "Holguín",
          "Lat": "20.8872",
          "Long": "-76.2631",
          "CountryCode": "CU"
        },
        {
          "Area": "Holland",
          "Lat": "42.7677",
          "Long": "-86.0984",
          "CountryCode": "US"
        },
        {
          "Area": "Hollywood",
          "Lat": "26.0293",
          "Long": "-80.1678",
          "CountryCode": "US"
        },
        {
          "Area": "Homestead",
          "Lat": "25.4664",
          "Long": "-80.4472",
          "CountryCode": "US"
        },
        {
          "Area": "Homyel",
          "Lat": "52.43",
          "Long": "31",
          "CountryCode": "BY"
        },
        {
          "Area": "Hong Gai",
          "Lat": "20.9604",
          "Long": "107.1",
          "CountryCode": "VN"
        },
        {
          "Area": "HK",
          "Lat": "22.305",
          "Long": "114.185",
          "CountryCode": "HK"
        },
        {
          "Area": "Honiara",
          "Lat": "-9.438",
          "Long": "159.9498",
          "CountryCode": "SB"
        },
        {
          "Area": "Honolulu",
          "Lat": "21.3294",
          "Long": "-157.846",
          "CountryCode": "US"
        },
        {
          "Area": "Hoover",
          "Lat": "33.3763",
          "Long": "-86.8058",
          "CountryCode": "US"
        },
        {
          "Area": "Horlivka",
          "Lat": "48.2996",
          "Long": "38.0547",
          "CountryCode": "UA"
        },
        {
          "Area": "Hosaina",
          "Lat": "7.5504",
          "Long": "37.85",
          "CountryCode": "ET"
        },
        {
          "Area": "Hot Springs",
          "Lat": "34.4902",
          "Long": "-93.0498",
          "CountryCode": "US"
        },
        {
          "Area": "Hotan",
          "Lat": "37.0997",
          "Long": "79.9269",
          "CountryCode": "CN"
        },
        {
          "Area": "Houma",
          "Lat": "29.5799",
          "Long": "-90.7058",
          "CountryCode": "US"
        },
        {
          "Area": "Houma",
          "Lat": "35.62",
          "Long": "111.21",
          "CountryCode": "CN"
        },
        {
          "Area": "Houston",
          "Lat": "29.7868",
          "Long": "-95.3905",
          "CountryCode": "US"
        },
        {
          "Area": "Hradec Králové",
          "Lat": "50.206",
          "Long": "15.812",
          "CountryCode": "CZ"
        },
        {
          "Area": "Hrodna",
          "Lat": "53.6779",
          "Long": "23.8341",
          "CountryCode": "BY"
        },
        {
          "Area": "Hsinchu",
          "Lat": "24.8168",
          "Long": "120.9767",
          "CountryCode": "TW"
        },
        {
          "Area": "Hua Hin",
          "Lat": "12.5697",
          "Long": "99.9443",
          "CountryCode": "TH"
        },
        {
          "Area": "Huacho",
          "Lat": "-11.11",
          "Long": "-77.6199",
          "CountryCode": "PE"
        },
        {
          "Area": "Huaibei",
          "Lat": "33.9504",
          "Long": "116.75",
          "CountryCode": "CN"
        },
        {
          "Area": "Huainan",
          "Lat": "32.63",
          "Long": "116.98",
          "CountryCode": "CN"
        },
        {
          "Area": "Huaiyin",
          "Lat": "33.58",
          "Long": "119.03",
          "CountryCode": "CN"
        },
        {
          "Area": "Hualien",
          "Lat": "23.9837",
          "Long": "121.6",
          "CountryCode": "TW"
        },
        {
          "Area": "Huambo",
          "Lat": "-12.75",
          "Long": "15.76",
          "CountryCode": "AO"
        },
        {
          "Area": "Huancayo",
          "Lat": "-12.08",
          "Long": "-75.2",
          "CountryCode": "PE"
        },
        {
          "Area": "Huanghua",
          "Lat": "38.3704",
          "Long": "117.33",
          "CountryCode": "CN"
        },
        {
          "Area": "Huangshi",
          "Lat": "30.22",
          "Long": "115.1",
          "CountryCode": "CN"
        },
        {
          "Area": "Huangyan",
          "Lat": "28.65",
          "Long": "121.25",
          "CountryCode": "CN"
        },
        {
          "Area": "Huanren",
          "Lat": "41.2563",
          "Long": "125.346",
          "CountryCode": "CN"
        },
        {
          "Area": "Huánuco",
          "Lat": "-9.92",
          "Long": "-76.24",
          "CountryCode": "PE"
        },
        {
          "Area": "Huaraz",
          "Lat": "-9.53",
          "Long": "-77.53",
          "CountryCode": "PE"
        },
        {
          "Area": "Hue",
          "Lat": "16.47",
          "Long": "107.58",
          "CountryCode": "VN"
        },
        {
          "Area": "Huehuetenango",
          "Lat": "15.3204",
          "Long": "-91.47",
          "CountryCode": "GT"
        },
        {
          "Area": "Huelva",
          "Lat": "37.2504",
          "Long": "-6.9299",
          "CountryCode": "ES"
        },
        {
          "Area": "Huinan",
          "Lat": "42.6229",
          "Long": "126.2614",
          "CountryCode": "CN"
        },
        {
          "Area": "Huizhou",
          "Lat": "23.08",
          "Long": "114.4",
          "CountryCode": "CN"
        },
        {
          "Area": "Hulan Ergi",
          "Lat": "47.21",
          "Long": "123.61",
          "CountryCode": "CN"
        },
        {
          "Area": "Hungnam",
          "Lat": "39.8231",
          "Long": "127.6232",
          "CountryCode": "KP"
        },
        {
          "Area": "Huntersville",
          "Lat": "35.4057",
          "Long": "-80.873",
          "CountryCode": "US"
        },
        {
          "Area": "Huntington",
          "Lat": "38.4109",
          "Long": "-82.4344",
          "CountryCode": "US"
        },
        {
          "Area": "Huntington Beach",
          "Lat": "33.696",
          "Long": "-118.0025",
          "CountryCode": "US"
        },
        {
          "Area": "Huntington Park",
          "Lat": "33.98",
          "Long": "-118.2167",
          "CountryCode": "US"
        },
        {
          "Area": "Huntsville",
          "Lat": "34.6989",
          "Long": "-86.6414",
          "CountryCode": "US"
        },
        {
          "Area": "Hurghada",
          "Lat": "27.23",
          "Long": "33.83",
          "CountryCode": "EG"
        },
        {
          "Area": "Huzhou",
          "Lat": "30.8704",
          "Long": "120.1",
          "CountryCode": "CN"
        },
        {
          "Area": "Hyderabad",
          "Lat": "25.38",
          "Long": "68.375",
          "CountryCode": "PK"
        },
        {
          "Area": "Hyeson",
          "Lat": "41.3927",
          "Long": "128.1927",
          "CountryCode": "KP"
        },
        {
          "Area": "Iași",
          "Lat": "47.1683",
          "Long": "27.5749",
          "CountryCode": "RO"
        },
        {
          "Area": "Ibadan",
          "Lat": "7.38",
          "Long": "3.93",
          "CountryCode": "NG"
        },
        {
          "Area": "Ibagué",
          "Lat": "4.4389",
          "Long": "-75.2322",
          "CountryCode": "CO"
        },
        {
          "Area": "Ibarra",
          "Lat": "0.3604",
          "Long": "-78.13",
          "CountryCode": "EC"
        },
        {
          "Area": "Ibb",
          "Lat": "13.9759",
          "Long": "44.1709",
          "CountryCode": "YE"
        },
        {
          "Area": "Ibri",
          "Lat": "23.2254",
          "Long": "56.517",
          "CountryCode": "OM"
        },
        {
          "Area": "Ica",
          "Lat": "-14.068",
          "Long": "-75.7255",
          "CountryCode": "PE"
        },
        {
          "Area": "Idah",
          "Lat": "7.1104",
          "Long": "6.7399",
          "CountryCode": "NG"
        },
        {
          "Area": "Idaho Falls",
          "Lat": "43.4868",
          "Long": "-112.0363",
          "CountryCode": "US"
        },
        {
          "Area": "Idlib",
          "Lat": "35.9297",
          "Long": "36.6317",
          "CountryCode": "SY"
        },
        {
          "Area": "Ife",
          "Lat": "7.4804",
          "Long": "4.56",
          "CountryCode": "NG"
        },
        {
          "Area": "Iguala",
          "Lat": "18.37",
          "Long": "-99.54",
          "CountryCode": "MX"
        },
        {
          "Area": "Iguatu",
          "Lat": "-6.36",
          "Long": "-39.3",
          "CountryCode": "BR"
        },
        {
          "Area": "Ijebu Ode",
          "Lat": "6.8204",
          "Long": "3.92",
          "CountryCode": "NG"
        },
        {
          "Area": "Ijuí",
          "Lat": "-28.3895",
          "Long": "-53.9199",
          "CountryCode": "BR"
        },
        {
          "Area": "Ikare",
          "Lat": "7.5304",
          "Long": "5.76",
          "CountryCode": "NG"
        },
        {
          "Area": "Iksan",
          "Lat": "35.941",
          "Long": "126.9454",
          "CountryCode": "kr"
        },
        {
          "Area": "Ilam",
          "Lat": "33.6304",
          "Long": "46.43",
          "CountryCode": "IR"
        },
        {
          "Area": "Ilebo",
          "Lat": "-4.3196",
          "Long": "20.61",
          "CountryCode": "CD"
        },
        {
          "Area": "Ilhéus",
          "Lat": "-14.78",
          "Long": "-39.05",
          "CountryCode": "BR"
        },
        {
          "Area": "Iligan",
          "Lat": "8.1712",
          "Long": "124.2154",
          "CountryCode": "PH"
        },
        {
          "Area": "Illichivsk",
          "Lat": "46.3",
          "Long": "30.6666",
          "CountryCode": "UA"
        },
        {
          "Area": "Ilo",
          "Lat": "-17.64",
          "Long": "-71.34",
          "CountryCode": "PE"
        },
        {
          "Area": "Iloilo",
          "Lat": "10.705",
          "Long": "122.545",
          "CountryCode": "PH"
        },
        {
          "Area": "Ilorin",
          "Lat": "8.49",
          "Long": "4.55",
          "CountryCode": "NG"
        },
        {
          "Area": "Imperatriz",
          "Lat": "-5.52",
          "Long": "-47.49",
          "CountryCode": "BR"
        },
        {
          "Area": "Incheon",
          "Lat": "37.4761",
          "Long": "126.6422",
          "CountryCode": "kr"
        },
        {
          "Area": "Independence",
          "Lat": "39.0871",
          "Long": "-94.3503",
          "CountryCode": "US"
        },
        {
          "Area": "Indianapolis",
          "Lat": "39.7771",
          "Long": "-86.1458",
          "CountryCode": "US"
        },
        {
          "Area": "Indio",
          "Lat": "33.7346",
          "Long": "-116.2346",
          "CountryCode": "US"
        },
        {
          "Area": "Indramayu",
          "Lat": "-6.3356",
          "Long": "108.319",
          "CountryCode": "ID"
        },
        {
          "Area": "Inglewood",
          "Lat": "33.9566",
          "Long": "-118.3444",
          "CountryCode": "US"
        },
        {
          "Area": "Ingolstadt",
          "Lat": "48.7704",
          "Long": "11.45",
          "CountryCode": "DE"
        },
        {
          "Area": "Inhambane",
          "Lat": "-23.858",
          "Long": "35.3398",
          "CountryCode": "MZ"
        },
        {
          "Area": "Innsbruck",
          "Lat": "47.2804",
          "Long": "11.41",
          "CountryCode": "AT"
        },
        {
          "Area": "Inowrocław",
          "Lat": "52.7799",
          "Long": "18.25",
          "CountryCode": "PL"
        },
        {
          "Area": "Ioanina",
          "Lat": "39.6679",
          "Long": "20.8509",
          "CountryCode": "GR"
        },
        {
          "Area": "Iowa City",
          "Lat": "41.6559",
          "Long": "-91.5304",
          "CountryCode": "US"
        },
        {
          "Area": "Ipatinga",
          "Lat": "-19.4796",
          "Long": "-42.52",
          "CountryCode": "BR"
        },
        {
          "Area": "Ipiales",
          "Lat": "0.8304",
          "Long": "-77.65",
          "CountryCode": "CO"
        },
        {
          "Area": "Ipoh",
          "Lat": "4.6",
          "Long": "101.065",
          "CountryCode": "MY"
        },
        {
          "Area": "Ipswich",
          "Lat": "52.0703",
          "Long": "1.17",
          "CountryCode": "GB"
        },
        {
          "Area": "Iquique",
          "Lat": "-20.25",
          "Long": "-70.13",
          "CountryCode": "CL"
        },
        {
          "Area": "Iquitos",
          "Lat": "-3.75",
          "Long": "-73.25",
          "CountryCode": "PE"
        },
        {
          "Area": "Iraklio",
          "Lat": "35.325",
          "Long": "25.1305",
          "CountryCode": "GR"
        },
        {
          "Area": "Irapuato",
          "Lat": "20.67",
          "Long": "-101.5",
          "CountryCode": "MX"
        },
        {
          "Area": "Irbid",
          "Lat": "32.55",
          "Long": "35.85",
          "CountryCode": "JO"
        },
        {
          "Area": "Irbil",
          "Lat": "36.179",
          "Long": "44.0086",
          "CountryCode": "IQ"
        },
        {
          "Area": "Irecê",
          "Lat": "-11.3",
          "Long": "-41.87",
          "CountryCode": "BR"
        },
        {
          "Area": "Iringa",
          "Lat": "-7.7696",
          "Long": "35.69",
          "CountryCode": "TZ"
        },
        {
          "Area": "Irkutsk",
          "Lat": "52.32",
          "Long": "104.245",
          "CountryCode": "RU"
        },
        {
          "Area": "Irvine",
          "Lat": "33.6772",
          "Long": "-117.7738",
          "CountryCode": "US"
        },
        {
          "Area": "Irving",
          "Lat": "32.8584",
          "Long": "-96.9702",
          "CountryCode": "US"
        },
        {
          "Area": "Iseyin",
          "Lat": "7.97",
          "Long": "3.59",
          "CountryCode": "NG"
        },
        {
          "Area": "Isfahan",
          "Lat": "32.7",
          "Long": "51.7",
          "CountryCode": "IR"
        },
        {
          "Area": "Ishim",
          "Lat": "56.1502",
          "Long": "69.4498",
          "CountryCode": "RU"
        },
        {
          "Area": "Isiro",
          "Lat": "2.76",
          "Long": "27.62",
          "CountryCode": "CD"
        },
        {
          "Area": "Iskandar",
          "Lat": "41.5507",
          "Long": "69.6807",
          "CountryCode": "UZ"
        },
        {
          "Area": "İskenderun",
          "Lat": "36.5804",
          "Long": "36.17",
          "CountryCode": "TR"
        },
        {
          "Area": "Iskitim",
          "Lat": "54.6509",
          "Long": "83.2865",
          "CountryCode": "RU"
        },
        {
          "Area": "Islamabad",
          "Lat": "33.7",
          "Long": "73.1666",
          "CountryCode": "PK"
        },
        {
          "Area": "Ismaïlia",
          "Lat": "30.5903",
          "Long": "32.26",
          "CountryCode": "EG"
        },
        {
          "Area": "Isna",
          "Lat": "25.2904",
          "Long": "32.5499",
          "CountryCode": "EG"
        },
        {
          "Area": "Isparta",
          "Lat": "37.77",
          "Long": "30.53",
          "CountryCode": "TR"
        },
        {
          "Area": "Istanbul",
          "Lat": "41.105",
          "Long": "29.01",
          "CountryCode": "TR"
        },
        {
          "Area": "Itabuna",
          "Lat": "-14.7896",
          "Long": "-39.28",
          "CountryCode": "BR"
        },
        {
          "Area": "Itacoatiara",
          "Lat": "-3.14",
          "Long": "-58.44",
          "CountryCode": "BR"
        },
        {
          "Area": "Itaituba",
          "Lat": "-4.2586",
          "Long": "-55.925",
          "CountryCode": "BR"
        },
        {
          "Area": "Itajaí",
          "Lat": "-26.8996",
          "Long": "-48.68",
          "CountryCode": "BR"
        },
        {
          "Area": "Itanhaem",
          "Lat": "-24.18",
          "Long": "-46.8",
          "CountryCode": "BR"
        },
        {
          "Area": "Itapetinga",
          "Lat": "-15.25",
          "Long": "-40.25",
          "CountryCode": "BR"
        },
        {
          "Area": "Itapetininga",
          "Lat": "-23.59",
          "Long": "-48.04",
          "CountryCode": "BR"
        },
        {
          "Area": "Itapeva",
          "Lat": "-23.9796",
          "Long": "-48.88",
          "CountryCode": "BR"
        },
        {
          "Area": "Itapipoca",
          "Lat": "-3.4995",
          "Long": "-39.58",
          "CountryCode": "BR"
        },
        {
          "Area": "Itaúna",
          "Lat": "-20.06",
          "Long": "-44.57",
          "CountryCode": "BR"
        },
        {
          "Area": "Ithaca",
          "Lat": "42.4442",
          "Long": "-76.5032",
          "CountryCode": "US"
        },
        {
          "Area": "Itu",
          "Lat": "-23.26",
          "Long": "-47.3",
          "CountryCode": "BR"
        },
        {
          "Area": "Ituiutaba",
          "Lat": "-18.97",
          "Long": "-49.46",
          "CountryCode": "BR"
        },
        {
          "Area": "Itumbiara",
          "Lat": "-18.3996",
          "Long": "-49.21",
          "CountryCode": "BR"
        },
        {
          "Area": "Ivano-Frankivsk",
          "Lat": "48.9348",
          "Long": "24.7094",
          "CountryCode": "UA"
        },
        {
          "Area": "Ivanovo",
          "Lat": "57.01",
          "Long": "41.01",
          "CountryCode": "RU"
        },
        {
          "Area": "Iwaki",
          "Lat": "37.0553",
          "Long": "140.89",
          "CountryCode": "JP"
        },
        {
          "Area": "Iwo",
          "Lat": "7.63",
          "Long": "4.18",
          "CountryCode": "NG"
        },
        {
          "Area": "Izhevsk",
          "Lat": "56.85",
          "Long": "53.23",
          "CountryCode": "RU"
        },
        {
          "Area": "Izmayil",
          "Lat": "45.3503",
          "Long": "28.8374",
          "CountryCode": "UA"
        },
        {
          "Area": "İzmir",
          "Lat": "38.4361",
          "Long": "27.1518",
          "CountryCode": "TR"
        },
        {
          "Area": "İzmit",
          "Lat": "40.776",
          "Long": "29.9306",
          "CountryCode": "TR"
        },
        {
          "Area": "Jaboatao",
          "Lat": "-8.11",
          "Long": "-35.02",
          "CountryCode": "BR"
        },
        {
          "Area": "Jaboticabal",
          "Lat": "-21.25",
          "Long": "-48.33",
          "CountryCode": "BR"
        },
        {
          "Area": "Jackson",
          "Lat": "32.3163",
          "Long": "-90.2124",
          "CountryCode": "US"
        },
        {
          "Area": "Jackson",
          "Lat": "42.2431",
          "Long": "-84.4038",
          "CountryCode": "US"
        },
        {
          "Area": "Jackson",
          "Lat": "35.6533",
          "Long": "-88.8352",
          "CountryCode": "US"
        },
        {
          "Area": "Jacksonville",
          "Lat": "30.3322",
          "Long": "-81.6749",
          "CountryCode": "US"
        },
        {
          "Area": "Jacksonville",
          "Lat": "34.7323",
          "Long": "-77.3962",
          "CountryCode": "US"
        },
        {
          "Area": "Jaén",
          "Lat": "37.7704",
          "Long": "-3.8",
          "CountryCode": "ES"
        },
        {
          "Area": "Jaén",
          "Lat": "-5.7096",
          "Long": "-78.81",
          "CountryCode": "PE"
        },
        {
          "Area": "Jaffna",
          "Lat": "9.675",
          "Long": "80.005",
          "CountryCode": "LK"
        },
        {
          "Area": "Jakarta",
          "Lat": "-6.1744",
          "Long": "106.8294",
          "CountryCode": "ID"
        },
        {
          "Area": "Jalal Abad",
          "Lat": "40.9429",
          "Long": "73.0025",
          "CountryCode": "KG"
        },
        {
          "Area": "Jalalabad",
          "Lat": "34.4415",
          "Long": "70.4361",
          "CountryCode": "AF"
        },
        {
          "Area": "Jalingo",
          "Lat": "8.9004",
          "Long": "11.36",
          "CountryCode": "NG"
        },
        {
          "Area": "Jaltipan",
          "Lat": "17.94",
          "Long": "-94.74",
          "CountryCode": "MX"
        },
        {
          "Area": "Jamaame",
          "Lat": "0.0722",
          "Long": "42.7506",
          "CountryCode": "SO"
        },
        {
          "Area": "Jamalpur",
          "Lat": "24.9004",
          "Long": "89.95",
          "CountryCode": "BD"
        },
        {
          "Area": "Jambi",
          "Lat": "-1.59",
          "Long": "103.61",
          "CountryCode": "ID"
        },
        {
          "Area": "Janaúba",
          "Lat": "-15.7996",
          "Long": "-43.31",
          "CountryCode": "BR"
        },
        {
          "Area": "Janesville",
          "Lat": "42.6855",
          "Long": "-89.0136",
          "CountryCode": "US"
        },
        {
          "Area": "Jaraguá do Sul",
          "Lat": "-26.48",
          "Long": "-49.1",
          "CountryCode": "BR"
        },
        {
          "Area": "Jataí",
          "Lat": "-17.8796",
          "Long": "-51.75",
          "CountryCode": "BR"
        },
        {
          "Area": "Jaú",
          "Lat": "-22.2896",
          "Long": "-48.57",
          "CountryCode": "BR"
        },
        {
          "Area": "Jawhar",
          "Lat": "2.767",
          "Long": "45.5166",
          "CountryCode": "SO"
        },
        {
          "Area": "Jayapura",
          "Lat": "-2.533",
          "Long": "140.7",
          "CountryCode": "ID"
        },
        {
          "Area": "Jeddah",
          "Lat": "21.5169",
          "Long": "39.2192",
          "CountryCode": "SA"
        },
        {
          "Area": "Jefferson City",
          "Lat": "38.5677",
          "Long": "-92.1757",
          "CountryCode": "US"
        },
        {
          "Area": "Jeju",
          "Lat": "33.5101",
          "Long": "126.5219",
          "CountryCode": "kr"
        },
        {
          "Area": "Jelgava",
          "Lat": "56.6527",
          "Long": "23.7128",
          "CountryCode": "LV"
        },
        {
          "Area": "Jember",
          "Lat": "-8.1727",
          "Long": "113.6873",
          "CountryCode": "ID"
        },
        {
          "Area": "Jena",
          "Lat": "50.9304",
          "Long": "11.58",
          "CountryCode": "DE"
        },
        {
          "Area": "Jendouba",
          "Lat": "36.5",
          "Long": "8.75",
          "CountryCode": "TN"
        },
        {
          "Area": "Jeonju",
          "Lat": "35.8314",
          "Long": "127.1404",
          "CountryCode": "kr"
        },
        {
          "Area": "Jequié",
          "Lat": "-13.85",
          "Long": "-40.08",
          "CountryCode": "BR"
        },
        {
          "Area": "Jersey City",
          "Lat": "40.7161",
          "Long": "-74.0682",
          "CountryCode": "US"
        },
        {
          "Area": "Jerusalem",
          "Lat": "31.7784",
          "Long": "35.2066",
          "CountryCode": "IL"
        },
        {
          "Area": "Jessore",
          "Lat": "23.1704",
          "Long": "89.2",
          "CountryCode": "BD"
        },
        {
          "Area": "Jhang",
          "Lat": "31.2804",
          "Long": "72.325",
          "CountryCode": "PK"
        },
        {
          "Area": "Ji-Paraná",
          "Lat": "-10.8333",
          "Long": "-61.967",
          "CountryCode": "BR"
        },
        {
          "Area": "Jiamusi",
          "Lat": "46.83",
          "Long": "130.35",
          "CountryCode": "CN"
        },
        {
          "Area": "Jian",
          "Lat": "27.1304",
          "Long": "115",
          "CountryCode": "CN"
        },
        {
          "Area": "Jiangmen",
          "Lat": "22.5804",
          "Long": "113.08",
          "CountryCode": "CN"
        },
        {
          "Area": "Jianmen",
          "Lat": "30.6501",
          "Long": "113.16",
          "CountryCode": "CN"
        },
        {
          "Area": "Jiaohe",
          "Lat": "43.7163",
          "Long": "127.346",
          "CountryCode": "CN"
        },
        {
          "Area": "Jiaojing",
          "Lat": "28.6804",
          "Long": "121.45",
          "CountryCode": "CN"
        },
        {
          "Area": "Jiaozuo",
          "Lat": "35.25",
          "Long": "113.22",
          "CountryCode": "CN"
        },
        {
          "Area": "Jiaxing",
          "Lat": "30.7704",
          "Long": "120.75",
          "CountryCode": "CN"
        },
        {
          "Area": "Jiayuguan",
          "Lat": "39.82",
          "Long": "98.3",
          "CountryCode": "CN"
        },
        {
          "Area": "Jieshou",
          "Lat": "33.2504",
          "Long": "115.35",
          "CountryCode": "CN"
        },
        {
          "Area": "Jiexiu",
          "Lat": "37.04",
          "Long": "111.9",
          "CountryCode": "CN"
        },
        {
          "Area": "Jihlava",
          "Lat": "49.4004",
          "Long": "15.5833",
          "CountryCode": "CZ"
        },
        {
          "Area": "Jijel",
          "Lat": "36.822",
          "Long": "5.766",
          "CountryCode": "DZ"
        },
        {
          "Area": "Jijiga",
          "Lat": "9.3504",
          "Long": "42.79",
          "CountryCode": "ET"
        },
        {
          "Area": "Jilin",
          "Lat": "43.85",
          "Long": "126.55",
          "CountryCode": "CN"
        },
        {
          "Area": "Jima",
          "Lat": "7.68",
          "Long": "36.83",
          "CountryCode": "ET"
        },
        {
          "Area": "Jinan",
          "Lat": "36.675",
          "Long": "116.995",
          "CountryCode": "CN"
        },
        {
          "Area": "Jinchang",
          "Lat": "38.4957",
          "Long": "102.1739",
          "CountryCode": "CN"
        },
        {
          "Area": "Jincheng",
          "Lat": "35.5004",
          "Long": "112.83",
          "CountryCode": "CN"
        },
        {
          "Area": "Jingdezhen",
          "Lat": "29.2704",
          "Long": "117.18",
          "CountryCode": "CN"
        },
        {
          "Area": "Jingmen",
          "Lat": "31.0304",
          "Long": "112.1",
          "CountryCode": "CN"
        },
        {
          "Area": "Jinhua",
          "Lat": "29.12",
          "Long": "119.65",
          "CountryCode": "CN"
        },
        {
          "Area": "Jining",
          "Lat": "35.4004",
          "Long": "116.55",
          "CountryCode": "CN"
        },
        {
          "Area": "Jining",
          "Lat": "41.03",
          "Long": "113.08",
          "CountryCode": "CN"
        },
        {
          "Area": "Jinja",
          "Lat": "0.4404",
          "Long": "33.1999",
          "CountryCode": "UG"
        },
        {
          "Area": "Jinotega",
          "Lat": "13.091",
          "Long": "-86",
          "CountryCode": "NI"
        },
        {
          "Area": "Jinshi",
          "Lat": "29.6321",
          "Long": "111.8517",
          "CountryCode": "CN"
        },
        {
          "Area": "Jinxi",
          "Lat": "40.7503",
          "Long": "120.83",
          "CountryCode": "CN"
        },
        {
          "Area": "Jinzhou",
          "Lat": "41.1204",
          "Long": "121.1",
          "CountryCode": "CN"
        },
        {
          "Area": "Jiujiang",
          "Lat": "29.73",
          "Long": "115.98",
          "CountryCode": "CN"
        },
        {
          "Area": "Jiutai",
          "Lat": "44.1447",
          "Long": "125.8443",
          "CountryCode": "CN"
        },
        {
          "Area": "Jixi",
          "Lat": "45.3",
          "Long": "130.97",
          "CountryCode": "CN"
        },
        {
          "Area": "Jizan",
          "Lat": "16.9066",
          "Long": "42.5566",
          "CountryCode": "SA"
        },
        {
          "Area": "Jizzax",
          "Lat": "40.1004",
          "Long": "67.83",
          "CountryCode": "UZ"
        },
        {
          "Area": "João Pessoa",
          "Lat": "-7.1011",
          "Long": "-34.8761",
          "CountryCode": "BR"
        },
        {
          "Area": "Joensuu",
          "Lat": "62.6",
          "Long": "29.7666",
          "CountryCode": "FI"
        },
        {
          "Area": "Johannesburg",
          "Lat": "-26.17",
          "Long": "28.03",
          "CountryCode": "ZA"
        },
        {
          "Area": "Johns Creek",
          "Lat": "34.0333",
          "Long": "-84.2027",
          "CountryCode": "US"
        },
        {
          "Area": "Johnson City",
          "Lat": "36.3406",
          "Long": "-82.3804",
          "CountryCode": "US"
        },
        {
          "Area": "Johnstown",
          "Lat": "40.3258",
          "Long": "-78.9194",
          "CountryCode": "US"
        },
        {
          "Area": "Johor Bahru",
          "Lat": "1.48",
          "Long": "103.73",
          "CountryCode": "MY"
        },
        {
          "Area": "Joinville",
          "Lat": "-26.32",
          "Long": "-48.8399",
          "CountryCode": "BR"
        },
        {
          "Area": "Joliet",
          "Lat": "41.5193",
          "Long": "-88.1501",
          "CountryCode": "US"
        },
        {
          "Area": "Jonesboro",
          "Lat": "35.8212",
          "Long": "-90.6795",
          "CountryCode": "US"
        },
        {
          "Area": "Jönköping",
          "Lat": "57.7713",
          "Long": "14.165",
          "CountryCode": "SE"
        },
        {
          "Area": "Joplin",
          "Lat": "37.0766",
          "Long": "-94.5016",
          "CountryCode": "US"
        },
        {
          "Area": "Jos",
          "Lat": "9.93",
          "Long": "8.89",
          "CountryCode": "NG"
        },
        {
          "Area": "Juazeiro",
          "Lat": "-9.42",
          "Long": "-40.5",
          "CountryCode": "BR"
        },
        {
          "Area": "Juazeiro do Norte",
          "Lat": "-7.21",
          "Long": "-39.32",
          "CountryCode": "BR"
        },
        {
          "Area": "Juba",
          "Lat": "4.83",
          "Long": "31.58",
          "CountryCode": "SD"
        },
        {
          "Area": "Juchitan",
          "Lat": "16.43",
          "Long": "-95.02",
          "CountryCode": "MX"
        },
        {
          "Area": "Juigalpa",
          "Lat": "12.11",
          "Long": "-85.38",
          "CountryCode": "NI"
        },
        {
          "Area": "Juiz de Fora",
          "Lat": "-21.77",
          "Long": "-43.375",
          "CountryCode": "BR"
        },
        {
          "Area": "Juliaca",
          "Lat": "-15.5",
          "Long": "-70.14",
          "CountryCode": "PE"
        },
        {
          "Area": "Jundiaí",
          "Lat": "-23.2",
          "Long": "-46.88",
          "CountryCode": "BR"
        },
        {
          "Area": "Junín",
          "Lat": "-34.5846",
          "Long": "-60.9589",
          "CountryCode": "AR"
        },
        {
          "Area": "Jupiter",
          "Lat": "26.9199",
          "Long": "-80.1127",
          "CountryCode": "US"
        },
        {
          "Area": "Jutiapa",
          "Lat": "14.29",
          "Long": "-89.9",
          "CountryCode": "GT"
        },
        {
          "Area": "Jyväskylä",
          "Lat": "62.2603",
          "Long": "25.75",
          "CountryCode": "FI"
        },
        {
          "Area": "Kabinda",
          "Lat": "-6.1296",
          "Long": "24.48",
          "CountryCode": "CD"
        },
        {
          "Area": "Kabul",
          "Lat": "34.5167",
          "Long": "69.1833",
          "CountryCode": "AF"
        },
        {
          "Area": "Kabwe",
          "Lat": "-14.44",
          "Long": "28.45",
          "CountryCode": "ZM"
        },
        {
          "Area": "Kadoma",
          "Lat": "-18.33",
          "Long": "29.9099",
          "CountryCode": "ZW"
        },
        {
          "Area": "Kadugli",
          "Lat": "11.01",
          "Long": "29.7",
          "CountryCode": "SD"
        },
        {
          "Area": "Kaduna",
          "Lat": "10.52",
          "Long": "7.44",
          "CountryCode": "NG"
        },
        {
          "Area": "Kaesong",
          "Lat": "37.964",
          "Long": "126.5644",
          "CountryCode": "KP"
        },
        {
          "Area": "Kafr el Sheikh",
          "Lat": "31.109",
          "Long": "30.936",
          "CountryCode": "EG"
        },
        {
          "Area": "Kaga Bandoro",
          "Lat": "6.9804",
          "Long": "19.18",
          "CountryCode": "CF"
        },
        {
          "Area": "Kagoshima",
          "Lat": "31.586",
          "Long": "130.5611",
          "CountryCode": "JP"
        },
        {
          "Area": "Kahemba",
          "Lat": "-7.2829",
          "Long": "19",
          "CountryCode": "CD"
        },
        {
          "Area": "Kahramanmaraş",
          "Lat": "37.61",
          "Long": "36.945",
          "CountryCode": "TR"
        },
        {
          "Area": "Kaifeng",
          "Lat": "34.85",
          "Long": "114.35",
          "CountryCode": "CN"
        },
        {
          "Area": "Kakamega",
          "Lat": "0.2904",
          "Long": "34.73",
          "CountryCode": "KE"
        },
        {
          "Area": "Kalamata",
          "Lat": "37.0389",
          "Long": "22.1142",
          "CountryCode": "GR"
        },
        {
          "Area": "Kalamazoo",
          "Lat": "42.2749",
          "Long": "-85.5881",
          "CountryCode": "US"
        },
        {
          "Area": "Kalasin",
          "Lat": "16.428",
          "Long": "103.509",
          "CountryCode": "TH"
        },
        {
          "Area": "Kalemie",
          "Lat": "-5.9333",
          "Long": "29.2",
          "CountryCode": "CD"
        },
        {
          "Area": "Kaliningrad",
          "Lat": "54.7",
          "Long": "20.4973",
          "CountryCode": "RU"
        },
        {
          "Area": "Kaluga",
          "Lat": "54.5204",
          "Long": "36.27",
          "CountryCode": "RU"
        },
        {
          "Area": "Kamensk Shakhtinskiy",
          "Lat": "48.3318",
          "Long": "40.2518",
          "CountryCode": "RU"
        },
        {
          "Area": "Kamensk Uralskiy",
          "Lat": "56.4205",
          "Long": "61.935",
          "CountryCode": "RU"
        },
        {
          "Area": "Kamina",
          "Lat": "-8.73",
          "Long": "25.01",
          "CountryCode": "CD"
        },
        {
          "Area": "Kamloops",
          "Lat": "50.6667",
          "Long": "-120.3333",
          "CountryCode": "CA"
        },
        {
          "Area": "Kampala",
          "Lat": "0.3167",
          "Long": "32.5833",
          "CountryCode": "UG"
        },
        {
          "Area": "Kamphaeng Phet",
          "Lat": "16.473",
          "Long": "99.529",
          "CountryCode": "TH"
        },
        {
          "Area": "Kampong Cham",
          "Lat": "12.0004",
          "Long": "105.45",
          "CountryCode": "KH"
        },
        {
          "Area": "Kampot",
          "Lat": "10.6171",
          "Long": "104.1833",
          "CountryCode": "KH"
        },
        {
          "Area": "Kamyanets-Podilskyy",
          "Lat": "48.6843",
          "Long": "26.5809",
          "CountryCode": "UA"
        },
        {
          "Area": "Kamyshin",
          "Lat": "50.0804",
          "Long": "45.4",
          "CountryCode": "RU"
        },
        {
          "Area": "Kananga",
          "Lat": "-5.89",
          "Long": "22.4",
          "CountryCode": "CD"
        },
        {
          "Area": "Kanazawa",
          "Lat": "36.56",
          "Long": "136.64",
          "CountryCode": "JP"
        },
        {
          "Area": "Kanchanaburi",
          "Lat": "14.0174",
          "Long": "99.522",
          "CountryCode": "TH"
        },
        {
          "Area": "Kandahar",
          "Lat": "31.61",
          "Long": "65.6949",
          "CountryCode": "AF"
        },
        {
          "Area": "Kandalaksha",
          "Lat": "67.1643",
          "Long": "32.4144",
          "CountryCode": "RU"
        },
        {
          "Area": "Kandi",
          "Lat": "11.1304",
          "Long": "2.94",
          "CountryCode": "BJ"
        },
        {
          "Area": "Kandy",
          "Lat": "7.28",
          "Long": "80.67",
          "CountryCode": "LK"
        },
        {
          "Area": "Kangar",
          "Lat": "6.433",
          "Long": "100.19",
          "CountryCode": "MY"
        },
        {
          "Area": "Kanggye",
          "Lat": "40.9732",
          "Long": "126.6032",
          "CountryCode": "KP"
        },
        {
          "Area": "Kankakee",
          "Lat": "41.102",
          "Long": "-87.8643",
          "CountryCode": "US"
        },
        {
          "Area": "Kankan",
          "Lat": "10.39",
          "Long": "-9.31",
          "CountryCode": "GN"
        },
        {
          "Area": "Kano",
          "Lat": "12",
          "Long": "8.52",
          "CountryCode": "NG"
        },
        {
          "Area": "Kanoya",
          "Lat": "31.3833",
          "Long": "130.85",
          "CountryCode": "JP"
        },
        {
          "Area": "Kansas City",
          "Lat": "39.1239",
          "Long": "-94.5541",
          "CountryCode": "US"
        },
        {
          "Area": "Kansas City",
          "Lat": "39.1234",
          "Long": "-94.7443",
          "CountryCode": "US"
        },
        {
          "Area": "Kansk",
          "Lat": "56.19",
          "Long": "95.71",
          "CountryCode": "RU"
        },
        {
          "Area": "Kaohsiung",
          "Lat": "22.6333",
          "Long": "120.2666",
          "CountryCode": "TW"
        },
        {
          "Area": "Kaolack",
          "Lat": "14.15",
          "Long": "-16.1",
          "CountryCode": "SN"
        },
        {
          "Area": "Kaposvár",
          "Lat": "46.367",
          "Long": "17.8",
          "CountryCode": "HU"
        },
        {
          "Area": "Kara Balta",
          "Lat": "42.8306",
          "Long": "73.8857",
          "CountryCode": "KG"
        },
        {
          "Area": "Karabük",
          "Lat": "41.2",
          "Long": "32.6",
          "CountryCode": "TR"
        },
        {
          "Area": "Karachi",
          "Lat": "24.87",
          "Long": "66.99",
          "CountryCode": "PK"
        },
        {
          "Area": "Karaj",
          "Lat": "35.8004",
          "Long": "50.97",
          "CountryCode": "IR"
        },
        {
          "Area": "Karakol",
          "Lat": "42.492",
          "Long": "78.3818",
          "CountryCode": "KG"
        },
        {
          "Area": "Karaman",
          "Lat": "37.1815",
          "Long": "33.215",
          "CountryCode": "TR"
        },
        {
          "Area": "Karamay",
          "Lat": "45.5899",
          "Long": "84.8599",
          "CountryCode": "CN"
        },
        {
          "Area": "Karbala",
          "Lat": "32.6149",
          "Long": "44.0245",
          "CountryCode": "IQ"
        },
        {
          "Area": "Karlovac",
          "Lat": "45.4872",
          "Long": "15.5478",
          "CountryCode": "HR"
        },
        {
          "Area": "Karlsruhe",
          "Lat": "49",
          "Long": "8.4",
          "CountryCode": "DE"
        },
        {
          "Area": "Karlstad",
          "Lat": "59.3671",
          "Long": "13.4999",
          "CountryCode": "SE"
        },
        {
          "Area": "Kars",
          "Lat": "40.6085",
          "Long": "43.0975",
          "CountryCode": "TR"
        },
        {
          "Area": "Kasama",
          "Lat": "-10.1996",
          "Long": "31.1799",
          "CountryCode": "ZM"
        },
        {
          "Area": "Kasese",
          "Lat": "0.2325",
          "Long": "29.9883",
          "CountryCode": "UG"
        },
        {
          "Area": "Kashan",
          "Lat": "33.9804",
          "Long": "51.58",
          "CountryCode": "IR"
        },
        {
          "Area": "Kashgar",
          "Lat": "39.4763",
          "Long": "75.9699",
          "CountryCode": "CN"
        },
        {
          "Area": "Kashmar",
          "Lat": "35.1814",
          "Long": "58.4515",
          "CountryCode": "IR"
        },
        {
          "Area": "Kasongo",
          "Lat": "-4.45",
          "Long": "26.66",
          "CountryCode": "CD"
        },
        {
          "Area": "Kaspiysk",
          "Lat": "42.8747",
          "Long": "47.6244",
          "CountryCode": "RU"
        },
        {
          "Area": "Kassala",
          "Lat": "15.46",
          "Long": "36.39",
          "CountryCode": "SD"
        },
        {
          "Area": "Kassel",
          "Lat": "51.3",
          "Long": "9.5",
          "CountryCode": "DE"
        },
        {
          "Area": "Kastamonu",
          "Lat": "41.389",
          "Long": "33.783",
          "CountryCode": "TR"
        },
        {
          "Area": "Kasur",
          "Lat": "31.1254",
          "Long": "74.455",
          "CountryCode": "PK"
        },
        {
          "Area": "Katerini",
          "Lat": "40.2723",
          "Long": "22.5025",
          "CountryCode": "GR"
        },
        {
          "Area": "Kathmandu",
          "Lat": "27.7167",
          "Long": "85.3166",
          "CountryCode": "NP"
        },
        {
          "Area": "Kati",
          "Lat": "12.7504",
          "Long": "-8.08",
          "CountryCode": "ML"
        },
        {
          "Area": "Katowice",
          "Lat": "50.2604",
          "Long": "19.02",
          "CountryCode": "PL"
        },
        {
          "Area": "Katsina",
          "Lat": "12.9904",
          "Long": "7.6",
          "CountryCode": "NG"
        },
        {
          "Area": "Kattaqorgon",
          "Lat": "39.9007",
          "Long": "66.2608",
          "CountryCode": "UZ"
        },
        {
          "Area": "Kaunas",
          "Lat": "54.9504",
          "Long": "23.88",
          "CountryCode": "LT"
        },
        {
          "Area": "Kavala",
          "Lat": "40.9412",
          "Long": "24.4018",
          "CountryCode": "GR"
        },
        {
          "Area": "Kawagoe",
          "Lat": "35.9177",
          "Long": "139.4911",
          "CountryCode": "JP"
        },
        {
          "Area": "Kawasaki",
          "Lat": "35.53",
          "Long": "139.705",
          "CountryCode": "JP"
        },
        {
          "Area": "Kayes",
          "Lat": "14.45",
          "Long": "-11.44",
          "CountryCode": "ML"
        },
        {
          "Area": "Kayes",
          "Lat": "-4.18",
          "Long": "13.28",
          "CountryCode": "CG"
        },
        {
          "Area": "Kayseri",
          "Lat": "38.735",
          "Long": "35.49",
          "CountryCode": "TR"
        },
        {
          "Area": "Kazan",
          "Lat": "55.7499",
          "Long": "49.1263",
          "CountryCode": "RU"
        },
        {
          "Area": "Kecskemét",
          "Lat": "46.9",
          "Long": "19.7",
          "CountryCode": "HU"
        },
        {
          "Area": "Kediri",
          "Lat": "-7.7896",
          "Long": "112",
          "CountryCode": "ID"
        },
        {
          "Area": "Keelung",
          "Lat": "25.1333",
          "Long": "121.7333",
          "CountryCode": "TW"
        },
        {
          "Area": "Keffi",
          "Lat": "8.849",
          "Long": "7.8736",
          "CountryCode": "NG"
        },
        {
          "Area": "Kelang",
          "Lat": "3.0204",
          "Long": "101.55",
          "CountryCode": "MY"
        },
        {
          "Area": "Kelo",
          "Lat": "9.3171",
          "Long": "15.8",
          "CountryCode": "TD"
        },
        {
          "Area": "Kelowna",
          "Lat": "49.9",
          "Long": "-119.4833",
          "CountryCode": "CA"
        },
        {
          "Area": "Keluang",
          "Lat": "2.0383",
          "Long": "103.3179",
          "CountryCode": "MY"
        },
        {
          "Area": "Kemerovo",
          "Lat": "55.34",
          "Long": "86.09",
          "CountryCode": "RU"
        },
        {
          "Area": "Kendari",
          "Lat": "-3.9553",
          "Long": "122.5973",
          "CountryCode": "ID"
        },
        {
          "Area": "Kendu Bay",
          "Lat": "-0.3596",
          "Long": "34.64",
          "CountryCode": "KE"
        },
        {
          "Area": "Kenema",
          "Lat": "7.8804",
          "Long": "-11.19",
          "CountryCode": "SL"
        },
        {
          "Area": "Kenitra",
          "Lat": "34.2704",
          "Long": "-6.58",
          "CountryCode": "MA"
        },
        {
          "Area": "Kenner",
          "Lat": "30.0109",
          "Long": "-90.2549",
          "CountryCode": "US"
        },
        {
          "Area": "Kennewick",
          "Lat": "46.1979",
          "Long": "-119.1732",
          "CountryCode": "US"
        },
        {
          "Area": "Kenosha",
          "Lat": "42.5863",
          "Long": "-87.8759",
          "CountryCode": "US"
        },
        {
          "Area": "Kent",
          "Lat": "47.3887",
          "Long": "-122.2128",
          "CountryCode": "US"
        },
        {
          "Area": "Kentau",
          "Lat": "43.5165",
          "Long": "68.5199",
          "CountryCode": "KZ"
        },
        {
          "Area": "Kentwood",
          "Lat": "42.8852",
          "Long": "-85.5925",
          "CountryCode": "US"
        },
        {
          "Area": "Keren",
          "Lat": "15.6804",
          "Long": "38.45",
          "CountryCode": "ER"
        },
        {
          "Area": "Kericho",
          "Lat": "-0.3596",
          "Long": "35.28",
          "CountryCode": "KE"
        },
        {
          "Area": "Kerman",
          "Lat": "30.3",
          "Long": "57.08",
          "CountryCode": "IR"
        },
        {
          "Area": "Kermanshah",
          "Lat": "34.38",
          "Long": "47.06",
          "CountryCode": "IR"
        },
        {
          "Area": "Keshan",
          "Lat": "48.0263",
          "Long": "125.866",
          "CountryCode": "CN"
        },
        {
          "Area": "Kettering",
          "Lat": "39.6957",
          "Long": "-84.1496",
          "CountryCode": "US"
        },
        {
          "Area": "Khabarovsk",
          "Lat": "48.455",
          "Long": "135.12",
          "CountryCode": "RU"
        },
        {
          "Area": "Khanty Mansiysk",
          "Lat": "61.0015",
          "Long": "69.0015",
          "CountryCode": "RU"
        },
        {
          "Area": "Kharkiv",
          "Lat": "50",
          "Long": "36.25",
          "CountryCode": "UA"
        },
        {
          "Area": "Khartoum",
          "Lat": "15.5881",
          "Long": "32.5342",
          "CountryCode": "SD"
        },
        {
          "Area": "Khaskovo",
          "Lat": "41.9438",
          "Long": "25.5633",
          "CountryCode": "BG"
        },
        {
          "Area": "Kherson",
          "Lat": "46.6325",
          "Long": "32.6007",
          "CountryCode": "UA"
        },
        {
          "Area": "Khiwa",
          "Lat": "41.3911",
          "Long": "60.3557",
          "CountryCode": "UZ"
        },
        {
          "Area": "Khmelnytskyy",
          "Lat": "49.4249",
          "Long": "27.0015",
          "CountryCode": "UA"
        },
        {
          "Area": "Khomeini Shahr",
          "Lat": "32.7004",
          "Long": "51.47",
          "CountryCode": "IR"
        },
        {
          "Area": "Khon Kaen",
          "Lat": "16.42",
          "Long": "102.83",
          "CountryCode": "TH"
        },
        {
          "Area": "Khorramabad",
          "Lat": "33.4804",
          "Long": "48.35",
          "CountryCode": "IR"
        },
        {
          "Area": "Khujand",
          "Lat": "40.29",
          "Long": "69.6199",
          "CountryCode": "TJ"
        },
        {
          "Area": "Khujayli",
          "Lat": "42.4047",
          "Long": "59.4517",
          "CountryCode": "UZ"
        },
        {
          "Area": "Khulna",
          "Lat": "22.84",
          "Long": "89.56",
          "CountryCode": "BD"
        },
        {
          "Area": "Khvoy",
          "Lat": "38.5304",
          "Long": "44.97",
          "CountryCode": "IR"
        },
        {
          "Area": "Kiel",
          "Lat": "54.3304",
          "Long": "10.13",
          "CountryCode": "DE"
        },
        {
          "Area": "Kielce",
          "Lat": "50.8904",
          "Long": "20.66",
          "CountryCode": "PL"
        },
        {
          "Area": "Kiev",
          "Lat": "50.4334",
          "Long": "30.5166",
          "CountryCode": "UA"
        },
        {
          "Area": "Kiffa",
          "Lat": "16.62",
          "Long": "-11.4",
          "CountryCode": "MR"
        },
        {
          "Area": "Kigali",
          "Lat": "-1.9536",
          "Long": "30.0605",
          "CountryCode": "RW"
        },
        {
          "Area": "Kigoma",
          "Lat": "-4.8796",
          "Long": "29.61",
          "CountryCode": "TZ"
        },
        {
          "Area": "Kikwit",
          "Lat": "-5.03",
          "Long": "18.85",
          "CountryCode": "CD"
        },
        {
          "Area": "Kilchu",
          "Lat": "40.9604",
          "Long": "129.3204",
          "CountryCode": "KP"
        },
        {
          "Area": "Kilifi",
          "Lat": "-3.6096",
          "Long": "39.85",
          "CountryCode": "KE"
        },
        {
          "Area": "Kilinochchi",
          "Lat": "9.4004",
          "Long": "80.3999",
          "CountryCode": "LK"
        },
        {
          "Area": "Kilis",
          "Lat": "36.7204",
          "Long": "37.12",
          "CountryCode": "TR"
        },
        {
          "Area": "Killeen",
          "Lat": "31.0754",
          "Long": "-97.7293",
          "CountryCode": "US"
        },
        {
          "Area": "Kilosa",
          "Lat": "-6.8396",
          "Long": "36.99",
          "CountryCode": "TZ"
        },
        {
          "Area": "Kimberley",
          "Lat": "-28.7468",
          "Long": "24.77",
          "CountryCode": "ZA"
        },
        {
          "Area": "Kimchaek",
          "Lat": "40.6723",
          "Long": "129.2027",
          "CountryCode": "KP"
        },
        {
          "Area": "Kimry",
          "Lat": "56.8691",
          "Long": "37.3444",
          "CountryCode": "RU"
        },
        {
          "Area": "Kindia",
          "Lat": "10.06",
          "Long": "-12.87",
          "CountryCode": "GN"
        },
        {
          "Area": "Kindu",
          "Lat": "-2.9639",
          "Long": "25.91",
          "CountryCode": "CD"
        },
        {
          "Area": "Kineshma",
          "Lat": "57.47",
          "Long": "42.13",
          "CountryCode": "RU"
        },
        {
          "Area": "Kingsport",
          "Lat": "36.522",
          "Long": "-82.5453",
          "CountryCode": "US"
        },
        {
          "Area": "Kingston",
          "Lat": "17.9771",
          "Long": "-76.7674",
          "CountryCode": "JM"
        },
        {
          "Area": "Kingston",
          "Lat": "44.2337",
          "Long": "-76.4833",
          "CountryCode": "CA"
        },
        {
          "Area": "Kingston",
          "Lat": "41.9295",
          "Long": "-73.9968",
          "CountryCode": "US"
        },
        {
          "Area": "Kingston upon Hull",
          "Lat": "53.7504",
          "Long": "-0.33",
          "CountryCode": "GB"
        },
        {
          "Area": "Kinshasa",
          "Lat": "-4.3297",
          "Long": "15.315",
          "CountryCode": "CD"
        },
        {
          "Area": "Kipushi",
          "Lat": "-11.7596",
          "Long": "27.25",
          "CountryCode": "CD"
        },
        {
          "Area": "Kirkland",
          "Lat": "47.6997",
          "Long": "-122.2041",
          "CountryCode": "US"
        },
        {
          "Area": "Kirkuk",
          "Lat": "35.4722",
          "Long": "44.3923",
          "CountryCode": "IQ"
        },
        {
          "Area": "Kirov",
          "Lat": "58.5901",
          "Long": "49.67",
          "CountryCode": "RU"
        },
        {
          "Area": "Kirovo-Chepetsk",
          "Lat": "58.5544",
          "Long": "50.0444",
          "CountryCode": "RU"
        },
        {
          "Area": "Kirovohrad",
          "Lat": "48.5041",
          "Long": "32.2603",
          "CountryCode": "UA"
        },
        {
          "Area": "Kisangani",
          "Lat": "0.52",
          "Long": "25.22",
          "CountryCode": "CD"
        },
        {
          "Area": "Kiselevsk",
          "Lat": "54",
          "Long": "86.64",
          "CountryCode": "RU"
        },
        {
          "Area": "Kislovodsk",
          "Lat": "43.91",
          "Long": "42.72",
          "CountryCode": "RU"
        },
        {
          "Area": "Kismaayo",
          "Lat": "-0.3566",
          "Long": "42.5183",
          "CountryCode": "SO"
        },
        {
          "Area": "Kissidougou",
          "Lat": "9.1905",
          "Long": "-10.12",
          "CountryCode": "GN"
        },
        {
          "Area": "Kissimmee",
          "Lat": "28.3042",
          "Long": "-81.4164",
          "CountryCode": "US"
        },
        {
          "Area": "Kisumu",
          "Lat": "-0.09",
          "Long": "34.75",
          "CountryCode": "KE"
        },
        {
          "Area": "Kitakyūshū",
          "Lat": "33.8704",
          "Long": "130.82",
          "CountryCode": "JP"
        },
        {
          "Area": "Kitale",
          "Lat": "1.0305",
          "Long": "34.9899",
          "CountryCode": "KE"
        },
        {
          "Area": "Kitami",
          "Lat": "43.8504",
          "Long": "143.9",
          "CountryCode": "JP"
        },
        {
          "Area": "Kitchener",
          "Lat": "43.45",
          "Long": "-80.5",
          "CountryCode": "CA"
        },
        {
          "Area": "Kitgum",
          "Lat": "3.3004",
          "Long": "32.87",
          "CountryCode": "UG"
        },
        {
          "Area": "Kitwe",
          "Lat": "-12.81",
          "Long": "28.22",
          "CountryCode": "ZM"
        },
        {
          "Area": "Kırıkkale",
          "Lat": "39.8504",
          "Long": "33.53",
          "CountryCode": "TR"
        },
        {
          "Area": "Kırklareli",
          "Lat": "41.743",
          "Long": "27.226",
          "CountryCode": "TR"
        },
        {
          "Area": "Kırşehir",
          "Lat": "39.142",
          "Long": "34.171",
          "CountryCode": "TR"
        },
        {
          "Area": "Klagenfurt",
          "Lat": "46.6203",
          "Long": "14.31",
          "CountryCode": "AT"
        },
        {
          "Area": "Klaipėda",
          "Lat": "55.7204",
          "Long": "21.1199",
          "CountryCode": "LT"
        },
        {
          "Area": "Klerksdorp",
          "Lat": "-26.88",
          "Long": "26.62",
          "CountryCode": "ZA"
        },
        {
          "Area": "Klin",
          "Lat": "56.3431",
          "Long": "36.6987",
          "CountryCode": "RU"
        },
        {
          "Area": "Klintsy",
          "Lat": "52.7652",
          "Long": "32.2448",
          "CountryCode": "RU"
        },
        {
          "Area": "Knoxville",
          "Lat": "35.9692",
          "Long": "-83.9495",
          "CountryCode": "US"
        },
        {
          "Area": "Knysna",
          "Lat": "-34.0329",
          "Long": "23.0333",
          "CountryCode": "ZA"
        },
        {
          "Area": "Kōbe",
          "Lat": "34.68",
          "Long": "135.17",
          "CountryCode": "JP"
        },
        {
          "Area": "København",
          "Lat": "55.6786",
          "Long": "12.5635",
          "CountryCode": "DK"
        },
        {
          "Area": "Koblenz",
          "Lat": "50.3505",
          "Long": "7.6",
          "CountryCode": "DE"
        },
        {
          "Area": "Kōchi",
          "Lat": "33.5624",
          "Long": "133.5375",
          "CountryCode": "JP"
        },
        {
          "Area": "Koforidua",
          "Lat": "6.0904",
          "Long": "-0.26",
          "CountryCode": "GH"
        },
        {
          "Area": "Kōfu",
          "Lat": "35.6504",
          "Long": "138.5833",
          "CountryCode": "JP"
        },
        {
          "Area": "Kogon",
          "Lat": "39.7211",
          "Long": "64.5458",
          "CountryCode": "UZ"
        },
        {
          "Area": "Kohat",
          "Lat": "33.6027",
          "Long": "71.4327",
          "CountryCode": "PK"
        },
        {
          "Area": "Koidu",
          "Lat": "8.4405",
          "Long": "-10.85",
          "CountryCode": "SL"
        },
        {
          "Area": "Kokomo",
          "Lat": "40.464",
          "Long": "-86.1277",
          "CountryCode": "US"
        },
        {
          "Area": "Kokshetau",
          "Lat": "53.3",
          "Long": "69.42",
          "CountryCode": "KZ"
        },
        {
          "Area": "Koktokay",
          "Lat": "47.0004",
          "Long": "89.4666",
          "CountryCode": "CN"
        },
        {
          "Area": "Kolda",
          "Lat": "12.9104",
          "Long": "-14.95",
          "CountryCode": "SN"
        },
        {
          "Area": "Kolomna",
          "Lat": "55.08",
          "Long": "38.785",
          "CountryCode": "RU"
        },
        {
          "Area": "Kolpino",
          "Lat": "59.73",
          "Long": "30.65",
          "CountryCode": "RU"
        },
        {
          "Area": "Kolwezi",
          "Lat": "-10.7167",
          "Long": "25.4724",
          "CountryCode": "CD"
        },
        {
          "Area": "Kom Ombo",
          "Lat": "24.47",
          "Long": "32.95",
          "CountryCode": "EG"
        },
        {
          "Area": "Kompong Chhnang",
          "Lat": "12.2505",
          "Long": "104.6666",
          "CountryCode": "KH"
        },
        {
          "Area": "Komsomolsk na Amure",
          "Lat": "50.555",
          "Long": "137.02",
          "CountryCode": "RU"
        },
        {
          "Area": "Kon Tum",
          "Lat": "14.3838",
          "Long": "107.9833",
          "CountryCode": "VN"
        },
        {
          "Area": "Kondoz",
          "Lat": "36.728",
          "Long": "68.8725",
          "CountryCode": "AF"
        },
        {
          "Area": "Kongolo",
          "Lat": "-5.3795",
          "Long": "26.98",
          "CountryCode": "CD"
        },
        {
          "Area": "Konibodom",
          "Lat": "40.2922",
          "Long": "70.4272",
          "CountryCode": "TJ"
        },
        {
          "Area": "Konotop",
          "Lat": "51.2424",
          "Long": "33.209",
          "CountryCode": "UA"
        },
        {
          "Area": "Kontagora",
          "Lat": "10.4004",
          "Long": "5.4699",
          "CountryCode": "NG"
        },
        {
          "Area": "Konya",
          "Lat": "37.875",
          "Long": "32.475",
          "CountryCode": "TR"
        },
        {
          "Area": "Korçë",
          "Lat": "40.6167",
          "Long": "20.7667",
          "CountryCode": "AL"
        },
        {
          "Area": "Korhogo",
          "Lat": "9.46",
          "Long": "-5.64",
          "CountryCode": "CL"
        },
        {
          "Area": "Kōriyama",
          "Lat": "37.41",
          "Long": "140.38",
          "CountryCode": "JP"
        },
        {
          "Area": "Korla",
          "Lat": "41.73",
          "Long": "86.15",
          "CountryCode": "CN"
        },
        {
          "Area": "Korogwe",
          "Lat": "-5.0896",
          "Long": "38.54",
          "CountryCode": "TZ"
        },
        {
          "Area": "Korosten",
          "Lat": "50.9504",
          "Long": "28.65",
          "CountryCode": "UA"
        },
        {
          "Area": "Košice",
          "Lat": "48.7304",
          "Long": "21.25",
          "CountryCode": "SK"
        },
        {
          "Area": "Kosti",
          "Lat": "13.17",
          "Long": "32.66",
          "CountryCode": "SD"
        },
        {
          "Area": "Kostroma",
          "Lat": "57.77",
          "Long": "40.94",
          "CountryCode": "RU"
        },
        {
          "Area": "Koszalin",
          "Lat": "54.2",
          "Long": "16.1833",
          "CountryCode": "PL"
        },
        {
          "Area": "Kota Baharu",
          "Lat": "6.12",
          "Long": "102.23",
          "CountryCode": "MY"
        },
        {
          "Area": "Kota Kinabalu",
          "Lat": "5.98",
          "Long": "116.11",
          "CountryCode": "MY"
        },
        {
          "Area": "Kotlas",
          "Lat": "61.2631",
          "Long": "46.6631",
          "CountryCode": "RU"
        },
        {
          "Area": "Koudougou",
          "Lat": "12.2505",
          "Long": "-2.37",
          "CountryCode": "BF"
        },
        {
          "Area": "Koutiala",
          "Lat": "12.3904",
          "Long": "-5.47",
          "CountryCode": "ML"
        },
        {
          "Area": "Kovel",
          "Lat": "51.2171",
          "Long": "24.7166",
          "CountryCode": "UA"
        },
        {
          "Area": "Kovrov",
          "Lat": "56.3604",
          "Long": "41.33",
          "CountryCode": "RU"
        },
        {
          "Area": "Kpalimé",
          "Lat": "6.9004",
          "Long": "0.63",
          "CountryCode": "TG"
        },
        {
          "Area": "Kragujevac",
          "Lat": "44.02",
          "Long": "20.92",
          "CountryCode": "RS"
        },
        {
          "Area": "Kraków",
          "Lat": "50.06",
          "Long": "19.96",
          "CountryCode": "PL"
        },
        {
          "Area": "Kramatorsk",
          "Lat": "48.7194",
          "Long": "37.5344",
          "CountryCode": "UA"
        },
        {
          "Area": "Krasnodar",
          "Lat": "45.02",
          "Long": "39",
          "CountryCode": "RU"
        },
        {
          "Area": "Krasnokamensk",
          "Lat": "50.0665",
          "Long": "118.0265",
          "CountryCode": "RU"
        },
        {
          "Area": "Krasnokamsk",
          "Lat": "58.0747",
          "Long": "55.7443",
          "CountryCode": "RU"
        },
        {
          "Area": "Krasnoturinsk",
          "Lat": "59.7948",
          "Long": "60.4848",
          "CountryCode": "RU"
        },
        {
          "Area": "Krasnoyarsk",
          "Lat": "56.014",
          "Long": "92.866",
          "CountryCode": "RU"
        },
        {
          "Area": "Kremenchuk",
          "Lat": "49.0835",
          "Long": "33.4296",
          "CountryCode": "UA"
        },
        {
          "Area": "Kribi",
          "Lat": "2.9404",
          "Long": "9.91",
          "CountryCode": "CM"
        },
        {
          "Area": "Kristiansand",
          "Lat": "58.1666",
          "Long": "8",
          "CountryCode": "NO"
        },
        {
          "Area": "Kroonstad",
          "Lat": "-27.66",
          "Long": "27.21",
          "CountryCode": "ZA"
        },
        {
          "Area": "Kropotkin",
          "Lat": "45.4471",
          "Long": "40.5821",
          "CountryCode": "RU"
        },
        {
          "Area": "Kryvyy Rih",
          "Lat": "47.9283",
          "Long": "33.345",
          "CountryCode": "UA"
        },
        {
          "Area": "Ksar El Kebir",
          "Lat": "35.0204",
          "Long": "-5.91",
          "CountryCode": "MA"
        },
        {
          "Area": "Kuala Lumpur",
          "Lat": "3.1667",
          "Long": "101.7",
          "CountryCode": "MY"
        },
        {
          "Area": "Kuala Terengganu",
          "Lat": "5.3304",
          "Long": "103.12",
          "CountryCode": "MY"
        },
        {
          "Area": "Kuantan",
          "Lat": "3.83",
          "Long": "103.32",
          "CountryCode": "MY"
        },
        {
          "Area": "Kuching",
          "Lat": "1.53",
          "Long": "110.33",
          "CountryCode": "MY"
        },
        {
          "Area": "Kuito",
          "Lat": "-12.38",
          "Long": "16.94",
          "CountryCode": "AO"
        },
        {
          "Area": "Kulob",
          "Lat": "37.9212",
          "Long": "69.7757",
          "CountryCode": "TJ"
        },
        {
          "Area": "Kumamoto",
          "Lat": "32.8009",
          "Long": "130.7006",
          "CountryCode": "JP"
        },
        {
          "Area": "Kumasi",
          "Lat": "6.69",
          "Long": "-1.63",
          "CountryCode": "GH"
        },
        {
          "Area": "Kumba",
          "Lat": "4.6404",
          "Long": "9.44",
          "CountryCode": "CM"
        },
        {
          "Area": "Kumbo",
          "Lat": "6.2204",
          "Long": "10.68",
          "CountryCode": "CM"
        },
        {
          "Area": "Kumertau",
          "Lat": "52.7748",
          "Long": "55.7843",
          "CountryCode": "RU"
        },
        {
          "Area": "Kungur",
          "Lat": "57.4348",
          "Long": "56.9543",
          "CountryCode": "RU"
        },
        {
          "Area": "Kunming",
          "Lat": "25.07",
          "Long": "102.68",
          "CountryCode": "CN"
        },
        {
          "Area": "Kuopio",
          "Lat": "62.8943",
          "Long": "27.6949",
          "CountryCode": "FI"
        },
        {
          "Area": "Kupang",
          "Lat": "-10.1787",
          "Long": "123.583",
          "CountryCode": "ID"
        },
        {
          "Area": "Kupyansk",
          "Lat": "49.7218",
          "Long": "37.5981",
          "CountryCode": "UA"
        },
        {
          "Area": "Kuqa",
          "Lat": "41.7277",
          "Long": "82.9364",
          "CountryCode": "CN"
        },
        {
          "Area": "Kure",
          "Lat": "34.251",
          "Long": "132.5656",
          "CountryCode": "JP"
        },
        {
          "Area": "Kurgan",
          "Lat": "55.46",
          "Long": "65.345",
          "CountryCode": "RU"
        },
        {
          "Area": "Kursk",
          "Lat": "51.74",
          "Long": "36.19",
          "CountryCode": "RU"
        },
        {
          "Area": "Kushiro",
          "Lat": "42.975",
          "Long": "144.3747",
          "CountryCode": "JP"
        },
        {
          "Area": "Kütahya",
          "Lat": "39.42",
          "Long": "29.93",
          "CountryCode": "TR"
        },
        {
          "Area": "Kutaisi",
          "Lat": "42.25",
          "Long": "42.73",
          "CountryCode": "GE"
        },
        {
          "Area": "KW",
          "Lat": "29.3697",
          "Long": "47.9783",
          "CountryCode": "KW"
        },
        {
          "Area": "Kuznetsk",
          "Lat": "53.1204",
          "Long": "46.6",
          "CountryCode": "RU"
        },
        {
          "Area": "Kwekwe",
          "Lat": "-18.9296",
          "Long": "29.8",
          "CountryCode": "ZW"
        },
        {
          "Area": "Kyoto",
          "Lat": "35.03",
          "Long": "135.75",
          "CountryCode": "JP"
        },
        {
          "Area": "Kyshtym",
          "Lat": "55.7",
          "Long": "60.5595",
          "CountryCode": "RU"
        },
        {
          "Area": "Kyustendil",
          "Lat": "42.2843",
          "Long": "22.6911",
          "CountryCode": "BG"
        },
        {
          "Area": "Kyzyl",
          "Lat": "51.7067",
          "Long": "94.3831",
          "CountryCode": "RU"
        },
          {
            "Area": "L Kota",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 18.054,
            "Long": 83.1842
          },
          {
            "Area": "Leh",
            "State": "Jammu & Kashmir",
            "CountryCode": "IN",
            "Lat": 34.3869,
            "Long": 76.762
          },
          {
            "Area": "Ladrymbai",
            "State": "Meghalaya",
            "CountryCode": "IN",
            "Lat": 25.2302,
            "Long": 92.2435
          },
          {
            "Area": "LALSOT",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 26.7471,
            "Long": 76.4023
          },
          {
            "Area": "Laban",
            "State": "Meghalaya",
            "CountryCode": "IN",
            "Lat": 25.5675,
            "Long": 91.8645
          },
          {
            "Area": "Labancherra",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 23.9923,
            "Long": 91.6205
          },
          {
            "Area": "Labpur",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.817,
            "Long": 87.8043
          },
          {
            "Area": "Labukhali",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.4323,
            "Long": 88.373
          },
          {
            "Area": "Laburra",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 21.8429,
            "Long": 80.1476
          },
          {
            "Area": "Lachhmangarh",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 27.8659,
            "Long": 76.6308
          },
          {
            "Area": "Lad Bharol(T)",
            "State": "Himachal Pradesh",
            "CountryCode": "IN",
            "Lat": 31.9287,
            "Long": 76.8597
          },
          {
            "Area": "Ladakh",
            "State": "Jammu & Kashmir",
            "CountryCode": "IN",
            "Lat": 34.1391,
            "Long": 77.536
          },
          {
            "Area": "Ladania",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.5906,
            "Long": 86.2966
          },
          {
            "Area": "Ladda",
            "State": "Punjab",
            "CountryCode": "IN",
            "Lat": 30.4297,
            "Long": 75.9985
          },
          {
            "Area": "Ladnun",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 27.9849,
            "Long": 76.7908
          },
          {
            "Area": "Ladpura",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 24.4084,
            "Long": 76.7433
          },
          {
            "Area": "Ladrymbai",
            "State": "Meghalaya",
            "CountryCode": "IN",
            "Lat": 25.2302,
            "Long": 92.2435
          },
          {
            "Area": "Ladwa",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 30.1145,
            "Long": 77.0768
          },
          {
            "Area": "Lahar",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 26.5589,
            "Long": 79.0051
          },
          {
            "Area": "Laharp[ur",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.4797,
            "Long": 80.8687
          },
          {
            "Area": "Laharpur",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.8367,
            "Long": 81.3907
          },
          {
            "Area": "Laharur",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.5789,
            "Long": 80.9921
          },
          {
            "Area": "Lahaul",
            "State": "Himachal Pradesh",
            "CountryCode": "IN",
            "Lat": 32.6588,
            "Long": 77.6161
          },
          {
            "Area": "Lahladpur",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.0551,
            "Long": 84.8253
          },
          {
            "Area": "Lahoal",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.5654,
            "Long": 94.0443
          },
          {
            "Area": "Lahoal;",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.5654,
            "Long": 94.0443
          },
          {
            "Area": "Lahul     (T)",
            "State": "Himachal Pradesh",
            "CountryCode": "IN",
            "Lat": 32.4739,
            "Long": 77.13
          },
          {
            "Area": "Lahunipara",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 22.0798,
            "Long": 85.3284
          },
          {
            "Area": "Laikera",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 21.9426,
            "Long": 84.4565
          },
          {
            "Area": "Laitkor Peak",
            "State": "Meghalaya",
            "CountryCode": "IN",
            "Lat": 25.5378,
            "Long": 91.8754
          },
          {
            "Area": "Lajpat Nagar",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.5167,
            "Long": 80.3155
          },
          {
            "Area": "Lajpore",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 21.4053,
            "Long": 73.2118
          },
          {
            "Area": "Lakhanadon",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 22.8175,
            "Long": 80.0269
          },
          {
            "Area": "Lakhandur",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 21.2909,
            "Long": 79.8827
          },
          {
            "Area": "Lakhani",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 21.0931,
            "Long": 79.8537
          },
          {
            "Area": "Lakhanpur",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 21.8183,
            "Long": 83.9639
          },
          {
            "Area": "Lakhanpur",
            "State": "Chattisgarh",
            "CountryCode": "IN",
            "Lat": 23.5661,
            "Long": 83.6584
          },
          {
            "Area": "Lakhanpur Bo",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 21.6748,
            "Long": 83.778
          },
          {
            "Area": "Lakhanpur Ho",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 21.6569,
            "Long": 83.972
          },
          {
            "Area": "Lakhapat",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.6285,
            "Long": 69.9604
          },
          {
            "Area": "Lakhi",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.5034,
            "Long": 87.9832
          },
          {
            "Area": "Lakhimpur",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 27.4154,
            "Long": 94.684
          },
          {
            "Area": "Lakhimpur",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 28.1951,
            "Long": 82.4361
          },
          {
            "Area": "Lakhinagar",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 24.1597,
            "Long": 92.0329
          },
          {
            "Area": "Lakhipur",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.1315,
            "Long": 90.9533
          },
          {
            "Area": "Lakhisarai",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 25.2652,
            "Long": 86.1871
          },
          {
            "Area": "Lakhnadon",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 22.8204,
            "Long": 79.8402
          },
          {
            "Area": "Lakhni",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 21.1292,
            "Long": 79.9388
          },
          {
            "Area": "Lakhpat",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.5556,
            "Long": 70.1557
          },
          {
            "Area": "Lakhtar",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 22.8734,
            "Long": 72.8969
          },
          {
            "Area": "Lakkavaram",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 17.0858,
            "Long": 81.2919
          },
          {
            "Area": "Lakkireddipalle",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 14.2617,
            "Long": 79.1224
          },
          {
            "Area": "Lakri Nabiganj",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.2331,
            "Long": 84.6388
          },
          {
            "Area": "Laksar",
            "State": "Uttarakhand",
            "CountryCode": "IN",
            "Lat": 29.8091,
            "Long": 78.1702
          },
          {
            "Area": "Lakshadweep",
            "State": "Lakshadweep",
            "CountryCode": "IN",
            "Lat": 9.1858,
            "Long": 73.3524
          },
          {
            "Area": "Lakshipur",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 25.0677,
            "Long": 87.9151
          },
          {
            "Area": "Lakshmanchak",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 21.8532,
            "Long": 87.9147
          },
          {
            "Area": "Lakshminarayan Pur",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 24.019,
            "Long": 91.625
          },
          {
            "Area": "Lakshminarsupeta",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 18.4853,
            "Long": 83.7275
          },
          {
            "Area": "Lakshmipur",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 19.5423,
            "Long": 83.103
          },
          {
            "Area": "Lal Bangla",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.5167,
            "Long": 80.3155
          },
          {
            "Area": "Lal Ganj",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.047,
            "Long": 83.5629
          },
          {
            "Area": "Lalaganj",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.0622,
            "Long": 81.7213
          },
          {
            "Area": "Lalat",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 21.9467,
            "Long": 87.4938
          },
          {
            "Area": "Lalbarra",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 22.0202,
            "Long": 80.2203
          },
          {
            "Area": "Lalburra",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 22.0118,
            "Long": 80.5087
          },
          {
            "Area": "Lalcherra",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 24.0447,
            "Long": 91.7553
          },
          {
            "Area": "Lalgam",
            "State": "Jammu & Kashmir",
            "CountryCode": "IN",
            "Lat": 33.9709,
            "Long": 74.7819
          },
          {
            "Area": "Lalgang",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 25.9118,
            "Long": 85.2295
          },
          {
            "Area": "Lalgang",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.9255,
            "Long": 81.6848
          },
          {
            "Area": "Lalganj",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 25.9118,
            "Long": 85.37
          },
          {
            "Area": "Lalganj",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.4791,
            "Long": 83.568
          },
          {
            "Area": "Lalgola",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 24.3584,
            "Long": 88.0833
          },
          {
            "Area": "Lalgopal Ganj",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.7735,
            "Long": 81.9322
          },
          {
            "Area": "Lalgopalganj",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.7735,
            "Long": 81.9717
          },
          {
            "Area": "Lalgudi",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 11.3141,
            "Long": 79.2262
          },
          {
            "Area": "Lalitapur",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.6315,
            "Long": 87.428
          },
          {
            "Area": "Lalitpur",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.0904,
            "Long": 79.271
          },
          {
            "Area": "Laljuri",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 24.1048,
            "Long": 92.0073
          },
          {
            "Area": "Lalkuwan",
            "State": "Uttarakhand",
            "CountryCode": "IN",
            "Lat": 29.0721,
            "Long": 79.5148
          },
          {
            "Area": "Lallung",
            "State": "Arunachal Pradesh",
            "CountryCode": "IN",
            "Lat": 27.9126,
            "Long": 96.1288
          },
          {
            "Area": "Lalnagar",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.8223,
            "Long": 87.5059
          },
          {
            "Area": "Lalpul Bazar",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.7198,
            "Long": 91.9902
          },
          {
            "Area": "Lalpur",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.4282,
            "Long": 72.4018
          },
          {
            "Area": "Lalua",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 21.9837,
            "Long": 87.635
          },
          {
            "Area": "Laluk",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 27.169,
            "Long": 94.1258
          },
          {
            "Area": "Lambhua",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.3274,
            "Long": 82.4183
          },
          {
            "Area": "Lambi",
            "State": "Punjab",
            "CountryCode": "IN",
            "Lat": 30.1015,
            "Long": 74.5299
          },
          {
            "Area": "Lamkhelpat",
            "State": "Manipur",
            "CountryCode": "IN",
            "Lat": 24.4065,
            "Long": 93.3452
          },
          {
            "Area": "Lamlong",
            "State": "Manipur",
            "CountryCode": "IN",
            "Lat": 24.4065,
            "Long": 93.3452
          },
          {
            "Area": "Lamsang",
            "State": "Manipur",
            "CountryCode": "IN",
            "Lat": 24.8452,
            "Long": 93.8226
          },
          {
            "Area": "Langjing",
            "State": "Manipur",
            "CountryCode": "IN",
            "Lat": 24.6432,
            "Long": 93.6703
          },
          {
            "Area": "Langthabal",
            "State": "Manipur",
            "CountryCode": "IN",
            "Lat": 24.4065,
            "Long": 93.3452
          },
          {
            "Area": "Lanja",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 21.4937,
            "Long": 77.0805
          },
          {
            "Area": "Lanji",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 21.6243,
            "Long": 80.6561
          },
          {
            "Area": "Lanjigarh",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 19.9958,
            "Long": 83.8582
          },
          {
            "Area": "Lanka",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.0171,
            "Long": 93.0465
          },
          {
            "Area": "Lansdowne",
            "State": "Uttarakhand",
            "CountryCode": "IN",
            "Lat": 30.1121,
            "Long": 79.0983
          },
          {
            "Area": "Lapla",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 24.2024,
            "Long": 84.1674
          },
          {
            "Area": "Lapung",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 23.1025,
            "Long": 84.9461
          },
          {
            "Area": "Larkuchi",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.263,
            "Long": 91.3011
          },
          {
            "Area": "Larnoo",
            "State": "Jammu & Kashmir",
            "CountryCode": "IN",
            "Lat": 33.7041,
            "Long": 75.1966
          },
          {
            "Area": "Lasadia",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 25.353,
            "Long": 74.9059
          },
          {
            "Area": "Latehar",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 23.8717,
            "Long": 84.6635
          },
          {
            "Area": "Later Chadoora",
            "State": "Jammu & Kashmir",
            "CountryCode": "IN",
            "Lat": 33.9245,
            "Long": 74.6725
          },
          {
            "Area": "Lateri",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 24.2172,
            "Long": 77.5084
          },
          {
            "Area": "Lathi",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.0327,
            "Long": 71.9838
          },
          {
            "Area": "Lathikata",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 22.2107,
            "Long": 84.8436
          },
          {
            "Area": "Latiapur",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 24.0789,
            "Long": 91.8987
          },
          {
            "Area": "Latur",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 18.9384,
            "Long": 76.7751
          },
          {
            "Area": "Laudaha",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 24.2471,
            "Long": 87.8066
          },
          {
            "Area": "Laudangri",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.3564,
            "Long": 87.8021
          },
          {
            "Area": "Laudoha",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.8832,
            "Long": 87.899
          },
          {
            "Area": "Laukaha",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.4795,
            "Long": 86.5665
          },
          {
            "Area": "Laukahi",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.5906,
            "Long": 86.3025
          },
          {
            "Area": "Laund",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 25.2881,
            "Long": 80.2737
          },
          {
            "Area": "Laundi",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 25.3193,
            "Long": 80.287
          },
          {
            "Area": "Lavanur",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 14.7808,
            "Long": 78.3193
          },
          {
            "Area": "Lavera Baori",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 26.7508,
            "Long": 73.2987
          },
          {
            "Area": "Laveru",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 18.2282,
            "Long": 83.7926
          },
          {
            "Area": "Laveru Mandal",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 18.5786,
            "Long": 83.9881
          },
          {
            "Area": "Lawa Sardargarh",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 25.2859,
            "Long": 74.1983
          },
          {
            "Area": "Lawan",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.1729,
            "Long": 76.1432
          },
          {
            "Area": "Lawan",
            "State": "Chattisgarh",
            "CountryCode": "IN",
            "Lat": 21.7661,
            "Long": 82.4295
          },
          {
            "Area": "Lawngtlai",
            "State": "Mizoram",
            "CountryCode": "IN",
            "Lat": 22.5325,
            "Long": 92.899
          },
          {
            "Area": "Laxaman Garh",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 27.7602,
            "Long": 76.9291
          },
          {
            "Area": "Laxman Garh",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 27.4183,
            "Long": 77.0677
          },
          {
            "Area": "Laxmangarh",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 27.5915,
            "Long": 76.7679
          },
          {
            "Area": "Laxmangarh Alwar",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 27.5915,
            "Long": 77.0764
          },
          {
            "Area": "Laxmipul",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.7774,
            "Long": 88.5686
          },
          {
            "Area": "Laxmipur",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 25.1014,
            "Long": 86.4332
          },
          {
            "Area": "Laxmipur",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 24.0789,
            "Long": 91.8987
          },
          {
            "Area": "Laxmipur",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 19.5423,
            "Long": 83.103
          },
          {
            "Area": "Laxmzn Garh",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 27.5915,
            "Long": 76.9558
          },
          {
            "Area": "Leh",
            "State": "Jammu & Kashmir",
            "CountryCode": "IN",
            "Lat": 34.7796,
            "Long": 78.3574
          },
          {
            "Area": "Lehragaga",
            "State": "Punjab",
            "CountryCode": "IN",
            "Lat": 29.8964,
            "Long": 75.7331
          },
          {
            "Area": "Lekang",
            "State": "Arunachal Pradesh",
            "CountryCode": "IN",
            "Lat": 27.9126,
            "Long": 96.1825
          },
          {
            "Area": "Lemalle",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.471,
            "Long": 80.4028
          },
          {
            "Area": "Lemiking",
            "State": "Arunachal Pradesh",
            "CountryCode": "IN",
            "Lat": 27.9911,
            "Long": 94.2295
          },
          {
            "Area": "Len",
            "State": "Jammu & Kashmir",
            "CountryCode": "IN",
            "Lat": 33.3605,
            "Long": 78.3574
          },
          {
            "Area": "Lengamara",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.4364,
            "Long": 87.9624
          },
          {
            "Area": "Lengpui",
            "State": "Mizoram",
            "CountryCode": "IN",
            "Lat": 23.8623,
            "Long": 92.5797
          },
          {
            "Area": "Lepajaring",
            "State": "Arunachal Pradesh",
            "CountryCode": "IN",
            "Lat": 27.9911,
            "Long": 94.2295
          },
          {
            "Area": "Lepakshi",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 14.4811,
            "Long": 77.6119
          },
          {
            "Area": "Lephripara",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 22.0835,
            "Long": 84.5106
          },
          {
            "Area": "Leshliganj",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 24.2024,
            "Long": 84.3559
          },
          {
            "Area": "Lesliganj",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 24.3948,
            "Long": 84.3588
          },
          {
            "Area": "Likabali",
            "State": "Arunachal Pradesh",
            "CountryCode": "IN",
            "Lat": 27.5535,
            "Long": 93.7868
          },
          {
            "Area": "Likheda",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.0604,
            "Long": 73.9617
          },
          {
            "Area": "Liliya",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 21.5368,
            "Long": 71.449
          },
          {
            "Area": "Lilodh",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.1729,
            "Long": 76.1432
          },
          {
            "Area": "Lilong",
            "State": "Manipur",
            "CountryCode": "IN",
            "Lat": 24.5217,
            "Long": 93.9404
          },
          {
            "Area": "Limbdi",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 22.927,
            "Long": 72.1254
          },
          {
            "Area": "Limbdiq",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 22.5716,
            "Long": 72.0555
          },
          {
            "Area": "Limkheda",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.1628,
            "Long": 74.2619
          },
          {
            "Area": "Limndi",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 22.927,
            "Long": 71.6246
          },
          {
            "Area": "Linepada",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 20.4169,
            "Long": 84.3034
          },
          {
            "Area": "Lingal",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 16.3427,
            "Long": 78.5161
          },
          {
            "Area": "Lingal Ghanpur",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.3986,
            "Long": 79.6176
          },
          {
            "Area": "Lingala",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 14.5688,
            "Long": 78.1704
          },
          {
            "Area": "Lingala",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 16.3427,
            "Long": 78.5161
          },
          {
            "Area": "Lingala Ghanpur",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.0161,
            "Long": 79.5644
          },
          {
            "Area": "Lingalaghanpur",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.0161,
            "Long": 79.7992
          },
          {
            "Area": "Lingampet",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.2553,
            "Long": 78.1231
          },
          {
            "Area": "Lingaraj",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 20.4916,
            "Long": 85.5114
          },
          {
            "Area": "Lingasugur",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 16.3831,
            "Long": 76.8931
          },
          {
            "Area": "Linglish",
            "State": "Jammu & Kashmir",
            "CountryCode": "IN",
            "Lat": 33.9138,
            "Long": 75.1312
          },
          {
            "Area": "Lingsugur",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 16.3831,
            "Long": 76.6604
          },
          {
            "Area": "Liromoba",
            "State": "Arunachal Pradesh",
            "CountryCode": "IN",
            "Lat": 27.9314,
            "Long": 94.7569
          },
          {
            "Area": "Lisan",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.3566,
            "Long": 76.3743
          },
          {
            "Area": "Lish",
            "State": "Arunachal Pradesh",
            "CountryCode": "IN",
            "Lat": 27.4,
            "Long": 92.1833
          },
          {
            "Area": "Litan",
            "State": "Manipur",
            "CountryCode": "IN",
            "Lat": 25.0203,
            "Long": 94.434
          },
          {
            "Area": "Litipara",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 24.6945,
            "Long": 87.7376
          },
          {
            "Area": "Littipara",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 24.6044,
            "Long": 86.1935
          },
          {
            "Area": "Lkhtar",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 22.4087,
            "Long": 72.1895
          },
          {
            "Area": "Loanr",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 20.5111,
            "Long": 76.4083
          },
          {
            "Area": "Lodha",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.9499,
            "Long": 77.9366
          },
          {
            "Area": "Lodhika",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 22.4354,
            "Long": 71.0896
          },
          {
            "Area": "Logum Jining",
            "State": "Arunachal Pradesh",
            "CountryCode": "IN",
            "Lat": 28.2358,
            "Long": 94.6742
          },
          {
            "Area": "Loha",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.1911,
            "Long": 77.6241
          },
          {
            "Area": "Lohabaranchak",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 24.3029,
            "Long": 87.818
          },
          {
            "Area": "Lohaghat",
            "State": "Uttarakhand",
            "CountryCode": "IN",
            "Lat": 29.8833,
            "Long": 80.0988
          },
          {
            "Area": "Lohara",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 18.0609,
            "Long": 76.3864
          },
          {
            "Area": "Lohardaga",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 23.5579,
            "Long": 84.7906
          },
          {
            "Area": "Lohardags",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 23.4483,
            "Long": 84.7538
          },
          {
            "Area": "Loharu",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.8395,
            "Long": 75.8912
          },
          {
            "Area": "Lohasrkata",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.2685,
            "Long": 91.6169
          },
          {
            "Area": "Lohawat",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 26.9044,
            "Long": 72.788
          },
          {
            "Area": "Loisingha",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 21.052,
            "Long": 84.1281
          },
          {
            "Area": "Lokeswaram",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 19.104,
            "Long": 78.35
          },
          {
            "Area": "Lokra",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.4206,
            "Long": 93.2317
          },
          {
            "Area": "Lonar",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 20.5111,
            "Long": 76.817
          },
          {
            "Area": "Londa",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 15.6008,
            "Long": 74.9175
          },
          {
            "Area": "Longding",
            "State": "Arunachal Pradesh",
            "CountryCode": "IN",
            "Lat": 27.0217,
            "Long": 95.5368
          },
          {
            "Area": "Longkhim",
            "State": "Nagaland",
            "CountryCode": "IN",
            "Lat": 26.4339,
            "Long": 94.8967
          },
          {
            "Area": "Longleng",
            "State": "Nagaland",
            "CountryCode": "IN",
            "Lat": 26.4899,
            "Long": 94.8177
          },
          {
            "Area": "Longtharai",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 23.9923,
            "Long": 91.6205
          },
          {
            "Area": "Loni",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 28.6988,
            "Long": 77.3334
          },
          {
            "Area": "Lonkhim",
            "State": "Nagaland",
            "CountryCode": "IN",
            "Lat": 26.4339,
            "Long": 94.7678
          },
          {
            "Area": "Lookhi",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.4146,
            "Long": 76.3674
          },
          {
            "Area": "Lormi",
            "State": "Chattisgarh",
            "CountryCode": "IN",
            "Lat": 22.4063,
            "Long": 81.9617
          },
          {
            "Area": "Losingha",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 20.9667,
            "Long": 83.8295
          },
          {
            "Area": "Lower Chandmari",
            "State": "Meghalaya",
            "CountryCode": "IN",
            "Lat": 25.7466,
            "Long": 90.3804
          },
          {
            "Area": "Lower Mundah",
            "State": "Jammu & Kashmir",
            "CountryCode": "IN",
            "Lat": 33.9509,
            "Long": 75.0932
          },
          {
            "Area": "Lowtola",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.2685,
            "Long": 91.6169
          },
          {
            "Area": "Lucknow",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.7397,
            "Long": 81.295
          },
          {
            "Area": "Ludhiana",
            "State": "Punjab",
            "CountryCode": "IN",
            "Lat": 31.982,
            "Long": 76.3395
          },
          {
            "Area": "Ludhiana  ludhiana",
            "State": "Punjab",
            "CountryCode": "IN",
            "Lat": 30.6367,
            "Long": 76.0454
          },
          {
            "Area": "Ludhiana (East)",
            "State": "Punjab",
            "CountryCode": "IN",
            "Lat": 31.5327,
            "Long": 76.0968
          },
          {
            "Area": "Ludhiana (West)",
            "State": "Punjab",
            "CountryCode": "IN",
            "Lat": 30.9417,
            "Long": 75.8529
          },
          {
            "Area": "Ludhiana East",
            "State": "Punjab",
            "CountryCode": "IN",
            "Lat": 31.5327,
            "Long": 75.1683
          },
          {
            "Area": "Luki ( Boko Block)",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 25.8902,
            "Long": 91.1839
          },
          {
            "Area": "Luki (boko Block)",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 25.8902,
            "Long": 91.1839
          },
          {
            "Area": "Lula Ahir",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.3498,
            "Long": 76.5026
          },
          {
            "Area": "Lumla",
            "State": "Arunachal Pradesh",
            "CountryCode": "IN",
            "Lat": 27.4852,
            "Long": 92.0686
          },
          {
            "Area": "Lumshnong",
            "State": "Meghalaya",
            "CountryCode": "IN",
            "Lat": 25.3816,
            "Long": 92.4569
          },
          {
            "Area": "Lunawada",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.2951,
            "Long": 73.9617
          },
          {
            "Area": "Lungdar",
            "State": "Mizoram",
            "CountryCode": "IN",
            "Lat": 23.266,
            "Long": 92.9592
          },
          {
            "Area": "Lunglei",
            "State": "Mizoram",
            "CountryCode": "IN",
            "Lat": 23.2794,
            "Long": 92.8729
          },
          {
            "Area": "Luni",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 26.7975,
            "Long": 72.9843
          },
          {
            "Area": "Lunkaransar",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 28.7861,
            "Long": 73.8435
          },
          {
            "Area": "Lurgam",
            "State": "Jammu & Kashmir",
            "CountryCode": "IN",
            "Lat": 33.9306,
            "Long": 75.1134
          },
          {
            "Area": "Lutheri",
            "State": "Punjab",
            "CountryCode": "IN",
            "Lat": 30.8377,
            "Long": 76.4322
          },
          {
            "Area": "Luxettipet",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 19.3647,
            "Long": 79.69
          },
          {
            "Area": "M Songel",
            "State": "Manipur",
            "CountryCode": "IN",
            "Lat": 24.3884,
            "Long": 93.5819
          },
          {
            "Area": "M. Ganj",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.7259,
            "Long": 85.5397
          },
          {
            "Area": "M.b. Gohana",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.0431,
            "Long": 83.5629
          },
          {
            "Area": "M.b. Gohna",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.9947,
            "Long": 83.2398
          },
          {
            "Area": "M.b.gohana",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.0431,
            "Long": 83.5629
          },
          {
            "Area": "M.bad",
            "State": "Uttarakhand",
            "CountryCode": "IN",
            "Lat": 29.8718,
            "Long": 78.6641
          },
          {
            "Area": "M.bad",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 30.1662,
            "Long": 83.5585
          },
          {
            "Area": "M.dabwali",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 29.9663,
            "Long": 74.7003
          },
          {
            "Area": "M.ramour",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 20.2398,
            "Long": 83.2569
          },
          {
            "Area": "M.rampur",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 20.3245,
            "Long": 83.451
          },
          {
            "Area": "M/gufan",
            "State": "Jammu & Kashmir",
            "CountryCode": "IN",
            "Lat": 33.9563,
            "Long": 74.834
          },
          {
            "Area": "MALIARA",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.4756,
            "Long": 87.2248
          },
          {
            "Area": "MASUDA",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 26.1365,
            "Long": 74.5892
          },
          {
            "Area": "Mabarakpur",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 25.0677,
            "Long": 87.9151
          },
          {
            "Area": "Machadoli",
            "State": "Chattisgarh",
            "CountryCode": "IN",
            "Lat": 22.6036,
            "Long": 82.7091
          },
          {
            "Area": "Machali Shahar",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.746,
            "Long": 82.5759
          },
          {
            "Area": "Machalpur",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 24.1642,
            "Long": 76.4138
          },
          {
            "Area": "Machareddy",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.3998,
            "Long": 78.4219
          },
          {
            "Area": "Machavaram",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.5062,
            "Long": 80.4825
          },
          {
            "Area": "Macherla",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.579,
            "Long": 80.0915
          },
          {
            "Area": "Machh kund",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 18.7065,
            "Long": 82.612
          },
          {
            "Area": "Machhali Shahar",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.0502,
            "Long": 82.6678
          },
          {
            "Area": "Machhali Shshar",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.7227,
            "Long": 82.4301
          },
          {
            "Area": "Machhalishahar",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.7719,
            "Long": 82.4965
          },
          {
            "Area": "Machhkund",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 18.7065,
            "Long": 82.3284
          },
          {
            "Area": "Machhlishahr",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.157,
            "Long": 82.7067
          },
          {
            "Area": "Machibhanga",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.5864,
            "Long": 88.4145
          },
          {
            "Area": "Machilipatnam",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.7559,
            "Long": 81.4554
          },
          {
            "Area": "Machillipatnam",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.5775,
            "Long": 81.4554
          },
          {
            "Area": "Machkhowa",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 27.1699,
            "Long": 94.2281
          },
          {
            "Area": "Machkund",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 19.0723,
            "Long": 82.911
          },
          {
            "Area": "Machmara",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 24.1597,
            "Long": 92.0329
          },
          {
            "Area": "Madakasira",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 14.0123,
            "Long": 77.5481
          },
          {
            "Area": "Madanapalle",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 14.1723,
            "Long": 79.0143
          },
          {
            "Area": "Madanmohanpur",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.3836,
            "Long": 87.8747
          },
          {
            "Area": "Madanpalle",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 13.6122,
            "Long": 78.6933
          },
          {
            "Area": "Madanpur",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 24.9331,
            "Long": 84.6164
          },
          {
            "Area": "Madanpur Krishnapur",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.3733,
            "Long": 88.2391
          },
          {
            "Area": "Madanpur Rampur",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 20.5373,
            "Long": 83.5332
          },
          {
            "Area": "Madanpurrampur",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 20.2398,
            "Long": 83.2569
          },
          {
            "Area": "Madanriting",
            "State": "Meghalaya",
            "CountryCode": "IN",
            "Lat": 25.556,
            "Long": 92.0616
          },
          {
            "Area": "Madarat",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.7771,
            "Long": 88.1942
          },
          {
            "Area": "Madarihat",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 26.8537,
            "Long": 89.0856
          },
          {
            "Area": "Maddikera (East)",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 15.2767,
            "Long": 77.5387
          },
          {
            "Area": "Maddur",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.166,
            "Long": 79.7992
          },
          {
            "Area": "Maddur",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 13.1142,
            "Long": 77.2711
          },
          {
            "Area": "Madgul",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 17.2085,
            "Long": 78.8275
          },
          {
            "Area": "Madha",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 18.3187,
            "Long": 76.167
          },
          {
            "Area": "Madhabdihi",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.6524,
            "Long": 88.0871
          },
          {
            "Area": "Madhana Kalan",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.0799,
            "Long": 76.0612
          },
          {
            "Area": "Madhapur",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.54,
            "Long": 91.3489
          },
          {
            "Area": "Madhavapuram",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 10.9562,
            "Long": 76.7594
          },
          {
            "Area": "Madhavkathi",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.4323,
            "Long": 88.373
          },
          {
            "Area": "Madhepur",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.2002,
            "Long": 86.3875
          },
          {
            "Area": "Madhepura",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.0028,
            "Long": 86.9161
          },
          {
            "Area": "Madhepura Mdg",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 25.8964,
            "Long": 86.8082
          },
          {
            "Area": "Madhira",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 17.5969,
            "Long": 80.6873
          },
          {
            "Area": "Madhogarh",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.5345,
            "Long": 79.5032
          },
          {
            "Area": "Madhogarh",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.3955,
            "Long": 75.9426
          },
          {
            "Area": "Madhu Ban",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.8355,
            "Long": 83.6446
          },
          {
            "Area": "Madhuban",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 29.6247,
            "Long": 77.0141
          },
          {
            "Area": "Madhuban",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.8355,
            "Long": 83.8276
          },
          {
            "Area": "Madhuban",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.4407,
            "Long": 85.0054
          },
          {
            "Area": "Madhuban **",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.2549,
            "Long": 83.773
          },
          {
            "Area": "Madhubani",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.6298,
            "Long": 86.4727
          },
          {
            "Area": "Madhubnai",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.5988,
            "Long": 86.3158
          },
          {
            "Area": "Madhugiri",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 13.8063,
            "Long": 77.4265
          },
          {
            "Area": "Madhupur",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 24.4442,
            "Long": 86.8926
          },
          {
            "Area": "Madhya Krishnapur",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 24.007,
            "Long": 91.6093
          },
          {
            "Area": "Madiahat",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.3578,
            "Long": 88.1922
          },
          {
            "Area": "Madikeri",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 13.381,
            "Long": 75.9829
          },
          {
            "Area": "Madnoor",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.5847,
            "Long": 77.7634
          },
          {
            "Area": "Maduban",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.3614,
            "Long": 81.8588
          },
          {
            "Area": "Madurai North",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 10.4247,
            "Long": 78.5732
          },
          {
            "Area": "Madurai South",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 10.0239,
            "Long": 78.2458
          },
          {
            "Area": "Madurantakam",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 12.7122,
            "Long": 79.9823
          },
          {
            "Area": "Maduranthakam",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 12.7122,
            "Long": 80.166
          },
          {
            "Area": "Maduravoyal",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 13.0734,
            "Long": 80.2523
          },
          {
            "Area": "Magadi",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 13.2257,
            "Long": 77.8445
          },
          {
            "Area": "Magam",
            "State": "Jammu & Kashmir",
            "CountryCode": "IN",
            "Lat": 34.0716,
            "Long": 74.663
          },
          {
            "Area": "Magra",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.398,
            "Long": 88.5469
          },
          {
            "Area": "Magrahat",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.6563,
            "Long": 88.2423
          },
          {
            "Area": "Magrahat - I",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.7771,
            "Long": 88.3355
          },
          {
            "Area": "Magrahat - II",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.2307,
            "Long": 88.4168
          },
          {
            "Area": "Magrahat Taluk",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.6563,
            "Long": 88.2423
          },
          {
            "Area": "Mah'bad",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.2585,
            "Long": 79.9493
          },
          {
            "Area": "Mahabaleshawar",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 17.6756,
            "Long": 74.2283
          },
          {
            "Area": "Mahabaleshwar",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 18.3771,
            "Long": 74.9778
          },
          {
            "Area": "Mahabaleshwr",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 17.6756,
            "Long": 74.2283
          },
          {
            "Area": "Mahabub Nagar",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 16.4985,
            "Long": 78.1461
          },
          {
            "Area": "Mahabubabad",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 17.6023,
            "Long": 79.5572
          },
          {
            "Area": "Mahabubnagar H.o",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 16.7915,
            "Long": 77.9797
          },
          {
            "Area": "Mahad",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 18.6704,
            "Long": 75.27
          },
          {
            "Area": "Mahadevpur",
            "State": "Arunachal Pradesh",
            "CountryCode": "IN",
            "Lat": 27.7955,
            "Long": 96.1825
          },
          {
            "Area": "Mahagam",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 25.047,
            "Long": 87.2945
          },
          {
            "Area": "Mahagama",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 25.0912,
            "Long": 87.4709
          },
          {
            "Area": "Mahagama.",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 24.8596,
            "Long": 87.3121
          },
          {
            "Area": "Mahagaon",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 20.0839,
            "Long": 78.1622
          },
          {
            "Area": "Mahamaya",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.1989,
            "Long": 90.1292
          },
          {
            "Area": "Mahanandi",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 15.121,
            "Long": 78.5035
          },
          {
            "Area": "Mahanga",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 20.9235,
            "Long": 86.2427
          },
          {
            "Area": "Maharaganj",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.9515,
            "Long": 83.504
          },
          {
            "Area": "Maharaj Ganj S.O",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.047,
            "Long": 83.2852
          },
          {
            "Area": "Maharaj Ganj Sadar",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.0474,
            "Long": 83.5679
          },
          {
            "Area": "Maharajang",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.2025,
            "Long": 83.5333
          },
          {
            "Area": "Maharajgang",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.1822,
            "Long": 83.5073
          },
          {
            "Area": "Maharajganj",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.1069,
            "Long": 84.4935
          },
          {
            "Area": "Maharajganj",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.4275,
            "Long": 83.5333
          },
          {
            "Area": "Maharajganj Sadar",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.9506,
            "Long": 83.3823
          },
          {
            "Area": "Maharajpur",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.3231,
            "Long": 80.467
          },
          {
            "Area": "Maharanipur",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 24.007,
            "Long": 91.6205
          },
          {
            "Area": "Maharganj",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.9515,
            "Long": 83.504
          },
          {
            "Area": "Maharjang",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.1011,
            "Long": 83.603
          },
          {
            "Area": "Mahasamund",
            "State": "Chattisgarh",
            "CountryCode": "IN",
            "Lat": 21.4825,
            "Long": 82.8267
          },
          {
            "Area": "Mahasi",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.7364,
            "Long": 81.7023
          },
          {
            "Area": "Mahasi **",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.6516,
            "Long": 81.6129
          },
          {
            "Area": "Mahasi Tahsil",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.4902,
            "Long": 81.5929
          },
          {
            "Area": "Mahauli",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.3805,
            "Long": 80.2158
          },
          {
            "Area": "Mahbubnagar",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 16.7915,
            "Long": 77.9797
          },
          {
            "Area": "Mahda",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 18.1617,
            "Long": 75.4829
          },
          {
            "Area": "Mahe Ut",
            "State": "Pondicherry",
            "CountryCode": "IN",
            "Lat": 11.7017,
            "Long": 75.5347
          },
          {
            "Area": "Maheashwar",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 21.984,
            "Long": 75.7294
          },
          {
            "Area": "Mahemdabad",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.2982,
            "Long": 73.1972
          },
          {
            "Area": "Mahemdavad",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.5972,
            "Long": 73.1972
          },
          {
            "Area": "Mahendergarh",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.3732,
            "Long": 76.8881
          },
          {
            "Area": "Mahendraganj",
            "State": "Meghalaya",
            "CountryCode": "IN",
            "Lat": 25.3008,
            "Long": 89.8494
          },
          {
            "Area": "Mahendraganjj",
            "State": "Meghalaya",
            "CountryCode": "IN",
            "Lat": 25.3008,
            "Long": 89.8494
          },
          {
            "Area": "Mahendragarh",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.3626,
            "Long": 76.7003
          },
          {
            "Area": "Mahesana",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 24.0963,
            "Long": 73.7794
          },
          {
            "Area": "Mahesapur",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 24.5442,
            "Long": 87.5764
          },
          {
            "Area": "Maheshpru",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 24.4292,
            "Long": 87.6437
          },
          {
            "Area": "Maheshpur",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 24.5711,
            "Long": 87.7795
          },
          {
            "Area": "Maheshwar",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 22.5927,
            "Long": 77.9775
          },
          {
            "Area": "Maheshwari",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.1881,
            "Long": 76.754
          },
          {
            "Area": "Mahespur",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.0208,
            "Long": 87.7744
          },
          {
            "Area": "Mahestala",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.4069,
            "Long": 88.1497
          },
          {
            "Area": "Maheswaram",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 17.7896,
            "Long": 79.5385
          },
          {
            "Area": "Mahgama",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 25.0721,
            "Long": 87.3143
          },
          {
            "Area": "Mahidpur",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 23.6346,
            "Long": 75.9775
          },
          {
            "Area": "Mahisadal",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 24.4536,
            "Long": 88.1065
          },
          {
            "Area": "Mahisagote",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.2758,
            "Long": 88.831
          },
          {
            "Area": "Mahishi",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 25.9473,
            "Long": 86.5898
          },
          {
            "Area": "Mahmoodabad",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.5177,
            "Long": 81.4993
          },
          {
            "Area": "Mahmudabad",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.7351,
            "Long": 81.4993
          },
          {
            "Area": "Mahnar",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 25.7807,
            "Long": 85.6343
          },
          {
            "Area": "Mahore",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.9708,
            "Long": 78.2498
          },
          {
            "Area": "Mahore",
            "State": "Jammu & Kashmir",
            "CountryCode": "IN",
            "Lat": 33.5759,
            "Long": 75.527
          },
          {
            "Area": "Mahraganj",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.2045,
            "Long": 83.6453
          },
          {
            "Area": "Mahrajgang",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.0836,
            "Long": 83.4649
          },
          {
            "Area": "Mahrajganj",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.2458,
            "Long": 83.733
          },
          {
            "Area": "Mahrajganj.",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.2482,
            "Long": 83.5743
          },
          {
            "Area": "Mahroni",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 24.947,
            "Long": 79.271
          },
          {
            "Area": "Mahsi",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.6401,
            "Long": 81.4603
          },
          {
            "Area": "Mahua",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 25.9016,
            "Long": 85.4994
          },
          {
            "Area": "Mahua Gaon",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.3801,
            "Long": 80.4141
          },
          {
            "Area": "Mahudha",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.3664,
            "Long": 73.2799
          },
          {
            "Area": "Mahulia",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 22.6495,
            "Long": 86.4146
          },
          {
            "Area": "Mahulpada",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 22.0798,
            "Long": 85.3284
          },
          {
            "Area": "Mahulpalli",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 21.9492,
            "Long": 84.5255
          },
          {
            "Area": "Mahur",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 25.1608,
            "Long": 93.2078
          },
          {
            "Area": "Mahuva",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.1404,
            "Long": 74.2515
          },
          {
            "Area": "Mahuwa",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 25.9016,
            "Long": 85.537
          },
          {
            "Area": "Mahuwadand",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 23.96,
            "Long": 84.4432
          },
          {
            "Area": "Mahuwdand",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 23.778,
            "Long": 84.5736
          },
          {
            "Area": "Maigonga",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 24.007,
            "Long": 91.6093
          },
          {
            "Area": "Maihar",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 24.5327,
            "Long": 80.8438
          },
          {
            "Area": "Mainerma",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 23.9923,
            "Long": 91.6205
          },
          {
            "Area": "Mainpuri",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.443,
            "Long": 79.1459
          },
          {
            "Area": "Mairang",
            "State": "Meghalaya",
            "CountryCode": "IN",
            "Lat": 25.7015,
            "Long": 91.6372
          },
          {
            "Area": "Mairwa",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.0309,
            "Long": 84.47
          },
          {
            "Area": "Maisali",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.5526,
            "Long": 88.4901
          },
          {
            "Area": "Maitana",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.5034,
            "Long": 87.9832
          },
          {
            "Area": "Majalgaon",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.8365,
            "Long": 76.8138
          },
          {
            "Area": "Majalgaon S.o.",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.8365,
            "Long": 76.8138
          },
          {
            "Area": "Majalgoan",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 18.9382,
            "Long": 76.3146
          },
          {
            "Area": "Majauli",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 24.2198,
            "Long": 81.9209
          },
          {
            "Area": "Majhawan",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.3063,
            "Long": 80.3177
          },
          {
            "Area": "Majitha",
            "State": "Punjab",
            "CountryCode": "IN",
            "Lat": 31.7301,
            "Long": 74.9423
          },
          {
            "Area": "Majna",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.5034,
            "Long": 87.9832
          },
          {
            "Area": "Majorganj",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.4648,
            "Long": 85.2689
          },
          {
            "Area": "Majra Gurdas",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.1686,
            "Long": 76.6599
          },
          {
            "Area": "Majra Sheoraj  majra Sheoraj",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.1964,
            "Long": 76.6745
          },
          {
            "Area": "Majuli",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.832,
            "Long": 94.4165
          },
          {
            "Area": "Maker",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 25.5961,
            "Long": 85.9653
          },
          {
            "Area": "Makhalgacha",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.6191,
            "Long": 88.8788
          },
          {
            "Area": "Makhdumpur",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 25.0864,
            "Long": 84.9434
          },
          {
            "Area": "Makhibaha",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.4463,
            "Long": 91.2674
          },
          {
            "Area": "Makkuva",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 18.732,
            "Long": 83.3361
          },
          {
            "Area": "Makrampur",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.0208,
            "Long": 87.7744
          },
          {
            "Area": "Makrampurbazar",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 24.3029,
            "Long": 87.818
          },
          {
            "Area": "Makrana",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 27.8037,
            "Long": 74.8058
          },
          {
            "Area": "Makrej",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 22.0054,
            "Long": 73.4336
          },
          {
            "Area": "Maksudangarh",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 24.8757,
            "Long": 77.5459
          },
          {
            "Area": "Mal",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 26.9251,
            "Long": 89.0856
          },
          {
            "Area": "Malad East",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.2361,
            "Long": 72.8338
          },
          {
            "Area": "Malad West",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.2361,
            "Long": 72.8496
          },
          {
            "Area": "Malahara",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 24.6874,
            "Long": 79.5179
          },
          {
            "Area": "Malahargarh",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 24.0836,
            "Long": 75.2894
          },
          {
            "Area": "Malancha",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.4653,
            "Long": 88.7803
          },
          {
            "Area": "Malarna Doongar",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 26.3594,
            "Long": 76.5894
          },
          {
            "Area": "Malarna Dungar",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 26.2866,
            "Long": 76.6306
          },
          {
            "Area": "Malavalli",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 12.8355,
            "Long": 77.2784
          },
          {
            "Area": "Malegaon",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 20.7436,
            "Long": 74.8709
          },
          {
            "Area": "Malehara",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 24.8376,
            "Long": 79.97
          },
          {
            "Area": "Malehra",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 24.6994,
            "Long": 79.3715
          },
          {
            "Area": "Malekangumti",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.4323,
            "Long": 88.373
          },
          {
            "Area": "Malerkotla",
            "State": "Punjab",
            "CountryCode": "IN",
            "Lat": 30.9531,
            "Long": 76.5507
          },
          {
            "Area": "Malhargarh",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 25.0977,
            "Long": 78.1123
          },
          {
            "Area": "Malia",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 21.6182,
            "Long": 70.8256
          },
          {
            "Area": "Malia Hatina",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 21.3947,
            "Long": 70.8256
          },
          {
            "Area": "Malia(m)",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.0055,
            "Long": 70.6103
          },
          {
            "Area": "Malidah",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.2147,
            "Long": 88.8863
          },
          {
            "Area": "Malihabad",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.0917,
            "Long": 81.2541
          },
          {
            "Area": "Malikagherai",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.6389,
            "Long": 88.746
          },
          {
            "Area": "Malikapur",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.6494,
            "Long": 88.2897
          },
          {
            "Area": "Malikipuram",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 17.3437,
            "Long": 82.0769
          },
          {
            "Area": "Malikipuram Mandal",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 17.3437,
            "Long": 82.0769
          },
          {
            "Area": "Malior",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 25.3922,
            "Long": 87.8549
          },
          {
            "Area": "Maliya",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.0055,
            "Long": 72.8731
          },
          {
            "Area": "Maliya  Miyana",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 21.7674,
            "Long": 70.8645
          },
          {
            "Area": "Maliya Miyana",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 22.6104,
            "Long": 72.8731
          },
          {
            "Area": "Maljamuna",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.3836,
            "Long": 87.8747
          },
          {
            "Area": "Malkangiri",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 18.9352,
            "Long": 82.776
          },
          {
            "Area": "Malkapur",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 21.0828,
            "Long": 76.4211
          },
          {
            "Area": "Malkharoda",
            "State": "Chattisgarh",
            "CountryCode": "IN",
            "Lat": 22.5323,
            "Long": 83.0247
          },
          {
            "Area": "Mallappally",
            "State": "Kerala",
            "CountryCode": "IN",
            "Lat": 9.676,
            "Long": 76.929
          },
          {
            "Area": "Mallapur",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.9669,
            "Long": 79.4697
          },
          {
            "Area": "Mallawan",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.0903,
            "Long": 80.3838
          },
          {
            "Area": "Mallial",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.7632,
            "Long": 79.2409
          },
          {
            "Area": "Malout",
            "State": "Punjab",
            "CountryCode": "IN",
            "Lat": 30.3728,
            "Long": 74.6914
          },
          {
            "Area": "Malpur",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.6593,
            "Long": 73.5102
          },
          {
            "Area": "Malrna Doongar",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 26.3259,
            "Long": 76.5215
          },
          {
            "Area": "Malshira",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 17.7898,
            "Long": 75.4829
          },
          {
            "Area": "Malshiras",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 18.9724,
            "Long": 76.3112
          },
          {
            "Area": "Malsiras",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 18.9724,
            "Long": 75.758
          },
          {
            "Area": "Malsisar",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 28.3536,
            "Long": 75.3184
          },
          {
            "Area": "Malsras",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 18.9724,
            "Long": 75.7184
          },
          {
            "Area": "Malumath",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 23.8331,
            "Long": 84.8658
          },
          {
            "Area": "Malur",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 13.2354,
            "Long": 78.289
          },
          {
            "Area": "Malvan",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.9327,
            "Long": 76.0224
          },
          {
            "Area": "Malwan",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 17.7992,
            "Long": 75.7764
          },
          {
            "Area": "Mamaria Ahir",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.1769,
            "Long": 76.5079
          },
          {
            "Area": "Mambalam",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 12.9293,
            "Long": 80.034
          },
          {
            "Area": "Mambhagina",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.2147,
            "Long": 88.8863
          },
          {
            "Area": "Mamidikuduru",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 17.1734,
            "Long": 81.9669
          },
          {
            "Area": "Mamidikuduru Mandal",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.741,
            "Long": 81.0201
          },
          {
            "Area": "Mamit",
            "State": "Mizoram",
            "CountryCode": "IN",
            "Lat": 23.9265,
            "Long": 92.4054
          },
          {
            "Area": "Man",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 18.7965,
            "Long": 76.1027
          },
          {
            "Area": "Man (dahiwadi)",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 20.1806,
            "Long": 75.6891
          },
          {
            "Area": "Man(dahivadi)",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 18.3569,
            "Long": 76.1027
          },
          {
            "Area": "Mana Camp",
            "State": "Chattisgarh",
            "CountryCode": "IN",
            "Lat": 21.2051,
            "Long": 81.7833
          },
          {
            "Area": "Manachanalloor",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 11.1114,
            "Long": 79.1837
          },
          {
            "Area": "Manachanallur",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 11.1114,
            "Long": 79.1837
          },
          {
            "Area": "Manakondur",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.5497,
            "Long": 79.2409
          },
          {
            "Area": "Manakpur",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.0562,
            "Long": 82.2932
          },
          {
            "Area": "Manali(T)",
            "State": "Himachal Pradesh",
            "CountryCode": "IN",
            "Lat": 32.412,
            "Long": 77.25
          },
          {
            "Area": "Manamadurai",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 10.27,
            "Long": 78.7326
          },
          {
            "Area": "Manamelkudi",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 12.3262,
            "Long": 79.3245
          },
          {
            "Area": "Manamunda",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 20.8782,
            "Long": 84.1776
          },
          {
            "Area": "Manantahvady",
            "State": "Kerala",
            "CountryCode": "IN",
            "Lat": 11.7238,
            "Long": 76.0032
          },
          {
            "Area": "Mananthavady",
            "State": "Kerala",
            "CountryCode": "IN",
            "Lat": 11.8333,
            "Long": 76.2001
          },
          {
            "Area": "Manaparai",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 11.0563,
            "Long": 78.5704
          },
          {
            "Area": "Manapparai",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 10.8889,
            "Long": 78.5704
          },
          {
            "Area": "Manapur",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.029,
            "Long": 82.2866
          },
          {
            "Area": "Manasa",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 24.6578,
            "Long": 76.0654
          },
          {
            "Area": "Manavadar",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 22.3483,
            "Long": 70.7119
          },
          {
            "Area": "Manawar",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 22.5194,
            "Long": 75.278
          },
          {
            "Area": "Manbazar",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.6244,
            "Long": 87.2151
          },
          {
            "Area": "Manbazar - I",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.274,
            "Long": 86.4902
          },
          {
            "Area": "Manbazar - II",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.2774,
            "Long": 86.4183
          },
          {
            "Area": "Manbazar Ii",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.2912,
            "Long": 87.2151
          },
          {
            "Area": "Mancherial",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 19.3322,
            "Long": 79.4617
          },
          {
            "Area": "Manchili (mdl)",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.7717,
            "Long": 81.4423
          },
          {
            "Area": "Mandal",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.4536,
            "Long": 72.595
          },
          {
            "Area": "Mandalgarh",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 25.7595,
            "Long": 75.2283
          },
          {
            "Area": "Mandamarri",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 19.3322,
            "Long": 79.4126
          },
          {
            "Area": "Mandangad",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.6184,
            "Long": 77.6699
          },
          {
            "Area": "Mandapeta",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 17.5283,
            "Long": 82.307
          },
          {
            "Area": "Mandar",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 23.6702,
            "Long": 85.3708
          },
          {
            "Area": "Mandar",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.63,
            "Long": 87.7168
          },
          {
            "Area": "Mandarpur",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.5034,
            "Long": 87.9832
          },
          {
            "Area": "Mandasa",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 18.8683,
            "Long": 84.463
          },
          {
            "Area": "Mandasa Mandal",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 18.8683,
            "Long": 84.463
          },
          {
            "Area": "Mandavalli",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 17.0336,
            "Long": 81.1973
          },
          {
            "Area": "Mandavi",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 22.8698,
            "Long": 69.63
          },
          {
            "Area": "Mandawar",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 28.0704,
            "Long": 76.6959
          },
          {
            "Area": "Manddar Cement Factory",
            "State": "Chattisgarh",
            "CountryCode": "IN",
            "Lat": 21.6123,
            "Long": 82.559
          },
          {
            "Area": "Mander",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 23.6843,
            "Long": 85.3708
          },
          {
            "Area": "Mandhana",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.1685,
            "Long": 80.3428
          },
          {
            "Area": "Mandi",
            "State": "Himachal Pradesh",
            "CountryCode": "IN",
            "Lat": 31.7437,
            "Long": 77.2089
          },
          {
            "Area": "Mandi",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.0444,
            "Long": 76.1172
          },
          {
            "Area": "Mandi Ateli",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.2358,
            "Long": 76.5554
          },
          {
            "Area": "Mandi Dabwali",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 29.9258,
            "Long": 74.8257
          },
          {
            "Area": "Mandi R Hasod",
            "State": "Chattisgarh",
            "CountryCode": "IN",
            "Lat": 21.0976,
            "Long": 81.7223
          },
          {
            "Area": "Mandi(T)",
            "State": "Himachal Pradesh",
            "CountryCode": "IN",
            "Lat": 31.7202,
            "Long": 77.1534
          },
          {
            "Area": "Mandia",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.2832,
            "Long": 91.1467
          },
          {
            "Area": "Mandir Hasod",
            "State": "Chattisgarh",
            "CountryCode": "IN",
            "Lat": 21.0976,
            "Long": 81.7223
          },
          {
            "Area": "Mandirbazar",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.4201,
            "Long": 88.2627
          },
          {
            "Area": "Mandla",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 22.9133,
            "Long": 80.8477
          },
          {
            "Area": "Mandola",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.231,
            "Long": 76.373
          },
          {
            "Area": "Mandoora",
            "State": "Jammu & Kashmir",
            "CountryCode": "IN",
            "Lat": 33.9306,
            "Long": 75.1134
          },
          {
            "Area": "Mandore",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 26.7101,
            "Long": 73.478
          },
          {
            "Area": "Mandra",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.4653,
            "Long": 88.7803
          },
          {
            "Area": "Mandrail",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 26.7049,
            "Long": 77.4669
          },
          {
            "Area": "Mandro",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 25.1435,
            "Long": 87.4983
          },
          {
            "Area": "Mandsaur",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 24.2113,
            "Long": 76.517
          },
          {
            "Area": "Mandu",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 23.823,
            "Long": 85.557
          },
          {
            "Area": "Mandvi",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.6285,
            "Long": 73.5759
          },
          {
            "Area": "Mandya",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 12.85,
            "Long": 77.0036
          },
          {
            "Area": "Manendragarh",
            "State": "Chattisgarh",
            "CountryCode": "IN",
            "Lat": 23.4681,
            "Long": 82.8212
          },
          {
            "Area": "Manendrgarh",
            "State": "Chattisgarh",
            "CountryCode": "IN",
            "Lat": 22.9805,
            "Long": 82.3013
          },
          {
            "Area": "Maner",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 25.6462,
            "Long": 85.2222
          },
          {
            "Area": "Manesar",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.3553,
            "Long": 76.9215
          },
          {
            "Area": "Maneswar",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 21.5331,
            "Long": 84.1011
          },
          {
            "Area": "Mangalagiri",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.4555,
            "Long": 80.5787
          },
          {
            "Area": "Mangalagiri Ho",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.5192,
            "Long": 80.5896
          },
          {
            "Area": "Mangaldoi",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.743,
            "Long": 93.2247
          },
          {
            "Area": "Mangalkote",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.5307,
            "Long": 88.3634
          },
          {
            "Area": "Mangalore",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 13.8465,
            "Long": 75.4875
          },
          {
            "Area": "Mangalvedha",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.4807,
            "Long": 76.7199
          },
          {
            "Area": "Mangalvedhe",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.3674,
            "Long": 76.7199
          },
          {
            "Area": "Mangalwedha",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 18.013,
            "Long": 75.695
          },
          {
            "Area": "Mangan",
            "State": "Sikkim",
            "CountryCode": "IN",
            "Lat": 27.5214,
            "Long": 88.5833
          },
          {
            "Area": "Mangaon",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.9808,
            "Long": 77.6997
          },
          {
            "Area": "Mangapet",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.254,
            "Long": 80.5198
          },
          {
            "Area": "Manglamaro",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.5526,
            "Long": 88.4901
          },
          {
            "Area": "Mango",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 24.255,
            "Long": 86.4527
          },
          {
            "Area": "Mango Notified Area",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 22.5826,
            "Long": 86.4527
          },
          {
            "Area": "Mangolkote",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.7617,
            "Long": 88.3634
          },
          {
            "Area": "Mangrol",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 24.7001,
            "Long": 75.1512
          },
          {
            "Area": "Mangrol",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.985,
            "Long": 73.6352
          },
          {
            "Area": "Mangrulpir",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 20.4373,
            "Long": 77.7168
          },
          {
            "Area": "Manguria",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.4181,
            "Long": 88.3425
          },
          {
            "Area": "Maniari",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.1511,
            "Long": 85.3993
          },
          {
            "Area": "Manihara",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 24.1939,
            "Long": 87.8753
          },
          {
            "Area": "Manikabasan",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 21.7344,
            "Long": 87.5491
          },
          {
            "Area": "Manikbhander",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 24.0789,
            "Long": 91.8987
          },
          {
            "Area": "Manikchak",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 25.4031,
            "Long": 88.0923
          },
          {
            "Area": "Manikchjak",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 25.4031,
            "Long": 87.8175
          },
          {
            "Area": "Manikjore",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 21.9837,
            "Long": 87.635
          },
          {
            "Area": "Manikkathi",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.4323,
            "Long": 88.373
          },
          {
            "Area": "Manikpur",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.5214,
            "Long": 90.8806
          },
          {
            "Area": "Manikpur",
            "State": "Chattisgarh",
            "CountryCode": "IN",
            "Lat": 21.9375,
            "Long": 82.8855
          },
          {
            "Area": "Manikpur",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 23.9923,
            "Long": 91.6205
          },
          {
            "Area": "Manjeri",
            "State": "Kerala",
            "CountryCode": "IN",
            "Lat": 11.1274,
            "Long": 76.1064
          },
          {
            "Area": "Manjhanpur",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.814,
            "Long": 81.6878
          },
          {
            "Area": "Manjhi",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.0046,
            "Long": 85.0567
          },
          {
            "Area": "Manjlegaon",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.8365,
            "Long": 77.9838
          },
          {
            "Area": "Manjmoh",
            "State": "Jammu & Kashmir",
            "CountryCode": "IN",
            "Lat": 33.5339,
            "Long": 75.1844
          },
          {
            "Area": "Mankachar",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.043,
            "Long": 90.9533
          },
          {
            "Area": "Mankapur",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.2275,
            "Long": 82.6464
          },
          {
            "Area": "Mannargudi",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 10.7375,
            "Long": 79.6384
          },
          {
            "Area": "Mannarkad",
            "State": "Kerala",
            "CountryCode": "IN",
            "Lat": 11.1651,
            "Long": 76.7696
          },
          {
            "Area": "Mannarkad Q",
            "State": "Kerala",
            "CountryCode": "IN",
            "Lat": 10.7946,
            "Long": 76.5586
          },
          {
            "Area": "Mannarkkad",
            "State": "Kerala",
            "CountryCode": "IN",
            "Lat": 11.1388,
            "Long": 76.7696
          },
          {
            "Area": "Mannarkudi",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 10.7286,
            "Long": 79.5276
          },
          {
            "Area": "Manoharpur",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 22.5445,
            "Long": 85.3362
          },
          {
            "Area": "Manpur",
            "State": "Chattisgarh",
            "CountryCode": "IN",
            "Lat": 21.6228,
            "Long": 81.1783
          },
          {
            "Area": "Manpur",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 24.9619,
            "Long": 85.2963
          },
          {
            "Area": "Mansa",
            "State": "Punjab",
            "CountryCode": "IN",
            "Lat": 30.5368,
            "Long": 75.5859
          },
          {
            "Area": "Mansa",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.555,
            "Long": 74.0108
          },
          {
            "Area": "Mansi",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 25.5468,
            "Long": 86.5683
          },
          {
            "Area": "Mant",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 28.0171,
            "Long": 78.3083
          },
          {
            "Area": "Manteswar",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.639,
            "Long": 88.3583
          },
          {
            "Area": "Mantha",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.8822,
            "Long": 76.4731
          },
          {
            "Area": "Manthani",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.5497,
            "Long": 79.2409
          },
          {
            "Area": "Mantralayam",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 15.8831,
            "Long": 77.2241
          },
          {
            "Area": "Mantripukhri",
            "State": "Manipur",
            "CountryCode": "IN",
            "Lat": 24.4065,
            "Long": 93.3452
          },
          {
            "Area": "Manu",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 24.1597,
            "Long": 92.0329
          },
          {
            "Area": "Manubazar",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 23.0015,
            "Long": 91.7243
          },
          {
            "Area": "Manubolu",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 14.3112,
            "Long": 79.9399
          },
          {
            "Area": "Manughat",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 23.9923,
            "Long": 91.6205
          },
          {
            "Area": "Manugur",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.1395,
            "Long": 81.5853
          },
          {
            "Area": "Manugurq",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.1395,
            "Long": 80.2009
          },
          {
            "Area": "Manuguru",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.1395,
            "Long": 81.1929
          },
          {
            "Area": "Manuvelly",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 24.332,
            "Long": 92.0039
          },
          {
            "Area": "Manvi",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 16.3831,
            "Long": 77.4437
          },
          {
            "Area": "Manwath",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.3664,
            "Long": 76.6246
          },
          {
            "Area": "Maracherra",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 24.1959,
            "Long": 91.8344
          },
          {
            "Area": "Marajganj",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.9506,
            "Long": 83.3823
          },
          {
            "Area": "Marajganj Sadar",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.9515,
            "Long": 83.504
          },
          {
            "Area": "Maram",
            "State": "Manipur",
            "CountryCode": "IN",
            "Lat": 25.4161,
            "Long": 94.112
          },
          {
            "Area": "Marasaghai",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 20.5217,
            "Long": 85.4837
          },
          {
            "Area": "Mardanpur",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.4301,
            "Long": 80.2672
          },
          {
            "Area": "Maredumilli",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 17.7773,
            "Long": 82.0118
          },
          {
            "Area": "Maregaon",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 20.2478,
            "Long": 78.8759
          },
          {
            "Area": "Margfherita",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.9855,
            "Long": 93.7217
          },
          {
            "Area": "Margherita",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 27.6999,
            "Long": 95.7652
          },
          {
            "Area": "Marhaura",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.0283,
            "Long": 84.9177
          },
          {
            "Area": "Mariahu",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.8024,
            "Long": 82.7668
          },
          {
            "Area": "Mariahun",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.7813,
            "Long": 82.7668
          },
          {
            "Area": "Mariary",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 25.3579,
            "Long": 87.8677
          },
          {
            "Area": "Marihan",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 24.9292,
            "Long": 82.687
          },
          {
            "Area": "Maripeda",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.4548,
            "Long": 80.0043
          },
          {
            "Area": "Marisda",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.3564,
            "Long": 87.8021
          },
          {
            "Area": "Mariyang",
            "State": "Arunachal Pradesh",
            "CountryCode": "IN",
            "Lat": 28.3184,
            "Long": 95.077
          },
          {
            "Area": "Markach",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 24.3193,
            "Long": 85.812
          },
          {
            "Area": "Markacho",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 24.3613,
            "Long": 85.8346
          },
          {
            "Area": "Markanda",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.4364,
            "Long": 87.9624
          },
          {
            "Area": "Markapur",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.1625,
            "Long": 79.5388
          },
          {
            "Area": "Markapur Ho",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 15.5381,
            "Long": 79.2958
          },
          {
            "Area": "Markpur",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 15.9619,
            "Long": 79.4951
          },
          {
            "Area": "Marmugao",
            "State": "Goa",
            "CountryCode": "IN",
            "Lat": 15.3974,
            "Long": 73.9035
          },
          {
            "Area": "Maro",
            "State": "Arunachal Pradesh",
            "CountryCode": "IN",
            "Lat": 27.9911,
            "Long": 94.2295
          },
          {
            "Area": "Marowa",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.5004,
            "Long": 91.4784
          },
          {
            "Area": "Marriguda",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 17.1597,
            "Long": 79.0661
          },
          {
            "Area": "Marripadu",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 15.1347,
            "Long": 80.2717
          },
          {
            "Area": "Marsaghai",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 20.6632,
            "Long": 86.6097
          },
          {
            "Area": "Martand",
            "State": "Jammu & Kashmir",
            "CountryCode": "IN",
            "Lat": 33.75,
            "Long": 75.2167
          },
          {
            "Area": "Maruanipur",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.6955,
            "Long": 79.1024
          },
          {
            "Area": "Marwahi",
            "State": "Chattisgarh",
            "CountryCode": "IN",
            "Lat": 22.9303,
            "Long": 82.6119
          },
          {
            "Area": "Marwar  Jn.",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 25.4876,
            "Long": 73.5991
          },
          {
            "Area": "Marwar In.",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 25.6267,
            "Long": 73.8288
          },
          {
            "Area": "Marwar Jn",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 25.6695,
            "Long": 73.7568
          },
          {
            "Area": "Marwar Jn.",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 26.395,
            "Long": 74.0635
          },
          {
            "Area": "Marwar Mundwa",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 26.5222,
            "Long": 73.6679
          },
          {
            "Area": "Masalia",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 24.6117,
            "Long": 87.5082
          },
          {
            "Area": "Masaliya",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 24.2274,
            "Long": 86.946
          },
          {
            "Area": "Masani",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.2047,
            "Long": 76.733
          },
          {
            "Area": "Masauli",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 24.1048,
            "Long": 92.0073
          },
          {
            "Area": "Masaurhi",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 25.5005,
            "Long": 85.9919
          },
          {
            "Area": "Mashrakh",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 25.9963,
            "Long": 84.8253
          },
          {
            "Area": "Mashyampur",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.2147,
            "Long": 88.8863
          },
          {
            "Area": "Masli",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 23.9923,
            "Long": 91.6205
          },
          {
            "Area": "Maslishpur",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.6856,
            "Long": 88.4668
          },
          {
            "Area": "Mastapur",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.3196,
            "Long": 76.611
          },
          {
            "Area": "Masturi",
            "State": "Chattisgarh",
            "CountryCode": "IN",
            "Lat": 22.0508,
            "Long": 82.3816
          },
          {
            "Area": "Masunda",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.8889,
            "Long": 88.4146
          },
          {
            "Area": "Matai",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 23.2518,
            "Long": 91.4541
          },
          {
            "Area": "Matar",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.3897,
            "Long": 73.4451
          },
          {
            "Area": "Matarbari",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 23.4955,
            "Long": 91.3298
          },
          {
            "Area": "Matelli",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 26.9861,
            "Long": 88.8119
          },
          {
            "Area": "Mathabhanga",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 26.4963,
            "Long": 89.3436
          },
          {
            "Area": "Mathabhanga - I",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 26.1252,
            "Long": 88.5347
          },
          {
            "Area": "Mathabhanga - II",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 26.4963,
            "Long": 89.3013
          },
          {
            "Area": "Mathabhanga`",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 26.0188,
            "Long": 89.0137
          },
          {
            "Area": "Mathania",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 26.4865,
            "Long": 73.0082
          },
          {
            "Area": "Mathbariabad",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.3687,
            "Long": 88.562
          },
          {
            "Area": "Mathili",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 18.4475,
            "Long": 82.0722
          },
          {
            "Area": "Mathur",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 12.3328,
            "Long": 78.3678
          },
          {
            "Area": "Mathura",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.7716,
            "Long": 78.0889
          },
          {
            "Area": "Mathura",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 21.9979,
            "Long": 87.636
          },
          {
            "Area": "Mathurapur",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.463,
            "Long": 88.4168
          },
          {
            "Area": "Mathurapur - I",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.463,
            "Long": 88.4393
          },
          {
            "Area": "Mathurapur - II",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.463,
            "Long": 88.4393
          },
          {
            "Area": "Matia",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.1271,
            "Long": 90.9533
          },
          {
            "Area": "Matia",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.4653,
            "Long": 88.7803
          },
          {
            "Area": "Matiaghata",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.5864,
            "Long": 88.4145
          },
          {
            "Area": "Matibaruan",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.3836,
            "Long": 87.8747
          },
          {
            "Area": "Matigara",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 26.7111,
            "Long": 88.3462
          },
          {
            "Area": "Matteli",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 26.9954,
            "Long": 88.8173
          },
          {
            "Area": "Mau",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.9987,
            "Long": 83.528
          },
          {
            "Area": "Mau Aima",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.633,
            "Long": 81.9154
          },
          {
            "Area": "Mauaima",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.7155,
            "Long": 81.7887
          },
          {
            "Area": "Mauda",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 21.3239,
            "Long": 79.5476
          },
          {
            "Area": "Mauganj",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 24.7869,
            "Long": 81.9683
          },
          {
            "Area": "Maunath Bhanjan",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.081,
            "Long": 83.5631
          },
          {
            "Area": "Maur",
            "State": "Punjab",
            "CountryCode": "IN",
            "Lat": 30.5368,
            "Long": 75.3253
          },
          {
            "Area": "Maur Mandi",
            "State": "Punjab",
            "CountryCode": "IN",
            "Lat": 30.5368,
            "Long": 75.3253
          },
          {
            "Area": "Mauranipur",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.7799,
            "Long": 79.2563
          },
          {
            "Area": "Maval",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.6594,
            "Long": 76.3844
          },
          {
            "Area": "Mavelikara",
            "State": "Kerala",
            "CountryCode": "IN",
            "Lat": 9.2808,
            "Long": 76.7873
          },
          {
            "Area": "Mavelikkara",
            "State": "Kerala",
            "CountryCode": "IN",
            "Lat": 9.3031,
            "Long": 76.6395
          },
          {
            "Area": "Mavli",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 24.8632,
            "Long": 74.1317
          },
          {
            "Area": "Mawal",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.4781,
            "Long": 76.3844
          },
          {
            "Area": "Mawana",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 29.2327,
            "Long": 82.9176
          },
          {
            "Area": "Mawkynrew",
            "State": "Meghalaya",
            "CountryCode": "IN",
            "Lat": 25.5022,
            "Long": 91.9037
          },
          {
            "Area": "Mawkyrwat",
            "State": "Meghalaya",
            "CountryCode": "IN",
            "Lat": 25.3926,
            "Long": 91.5155
          },
          {
            "Area": "Mawlai",
            "State": "Meghalaya",
            "CountryCode": "IN",
            "Lat": 25.5675,
            "Long": 92.0616
          },
          {
            "Area": "Mawpat",
            "State": "Meghalaya",
            "CountryCode": "IN",
            "Lat": 25.5378,
            "Long": 91.8754
          },
          {
            "Area": "Mawphlang",
            "State": "Meghalaya",
            "CountryCode": "IN",
            "Lat": 25.5265,
            "Long": 91.7579
          },
          {
            "Area": "Mawsynram",
            "State": "Meghalaya",
            "CountryCode": "IN",
            "Lat": 25.2985,
            "Long": 91.5823
          },
          {
            "Area": "Mayabander",
            "State": "Andaman & Nicobar Islands",
            "CountryCode": "IN",
            "Lat": 12.7167,
            "Long": 92.9
          },
          {
            "Area": "Mayachari",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 24.1959,
            "Long": 91.8344
          },
          {
            "Area": "Mayan",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.2156,
            "Long": 76.4183
          },
          {
            "Area": "Mayanbari",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.6242,
            "Long": 91.5994
          },
          {
            "Area": "Mayang Imphal",
            "State": "Manipur",
            "CountryCode": "IN",
            "Lat": 24.61,
            "Long": 93.8887
          },
          {
            "Area": "Mayiaduthurai",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 11.2048,
            "Long": 79.5702
          },
          {
            "Area": "Mayiladuthurai",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 11.712,
            "Long": 79.7677
          },
          {
            "Area": "Maynaguri",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 26.8537,
            "Long": 89.0856
          },
          {
            "Area": "Mayureswar - I",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 24.0927,
            "Long": 87.6892
          },
          {
            "Area": "Mazbat",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.8097,
            "Long": 92.2543
          },
          {
            "Area": "Md. Gohana",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.0088,
            "Long": 82.9628
          },
          {
            "Area": "Mebo",
            "State": "Arunachal Pradesh",
            "CountryCode": "IN",
            "Lat": 28.1268,
            "Long": 94.934
          },
          {
            "Area": "Mechuka",
            "State": "Arunachal Pradesh",
            "CountryCode": "IN",
            "Lat": 28.3892,
            "Long": 94.8382
          },
          {
            "Area": "Mechuria",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 23.9923,
            "Long": 91.6205
          },
          {
            "Area": "Medak",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.3427,
            "Long": 78.6319
          },
          {
            "Area": "Medakhali",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 21.8532,
            "Long": 87.9147
          },
          {
            "Area": "Medapalli",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.642,
            "Long": 78.7553
          },
          {
            "Area": "Medchal",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 17.583,
            "Long": 78.9223
          },
          {
            "Area": "Medical College",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.5167,
            "Long": 80.3155
          },
          {
            "Area": "Medikonduru",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.3934,
            "Long": 80.6945
          },
          {
            "Area": "Medo",
            "State": "Arunachal Pradesh",
            "CountryCode": "IN",
            "Lat": 27.7955,
            "Long": 96.1825
          },
          {
            "Area": "Medpalli",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.7987,
            "Long": 79.2409
          },
          {
            "Area": "Medziphema",
            "State": "Nagaland",
            "CountryCode": "IN",
            "Lat": 25.7446,
            "Long": 93.9696
          },
          {
            "Area": "Meenachil",
            "State": "Kerala",
            "CountryCode": "IN",
            "Lat": 9.7997,
            "Long": 76.8128
          },
          {
            "Area": "Meerganj",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 28.7467,
            "Long": 79.4728
          },
          {
            "Area": "Meerpur",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.5167,
            "Long": 80.3155
          },
          {
            "Area": "Meerut",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 29.1837,
            "Long": 78.6904
          },
          {
            "Area": "Megahatuburu",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 22.0724,
            "Long": 85.2692
          },
          {
            "Area": "Meghnagar",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 23.1044,
            "Long": 75.0302
          },
          {
            "Area": "Meghraj",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.8415,
            "Long": 73.607
          },
          {
            "Area": "Meh Nagar",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.9623,
            "Long": 83.0466
          },
          {
            "Area": "Meharma",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 25.2108,
            "Long": 87.4371
          },
          {
            "Area": "Mehem",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 29.3352,
            "Long": 76.5027
          },
          {
            "Area": "Mehgaon",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 26.562,
            "Long": 79.0051
          },
          {
            "Area": "Mehgoun",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 26.6444,
            "Long": 78.773
          },
          {
            "Area": "Mehidpur",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 23.5896,
            "Long": 75.9775
          },
          {
            "Area": "Mehkar",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 20.8256,
            "Long": 76.817
          },
          {
            "Area": "Mehmedabad",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.5972,
            "Long": 73.1972
          },
          {
            "Area": "Mehnagar",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.047,
            "Long": 83.32
          },
          {
            "Area": "Mehnagar **",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.5088,
            "Long": 83.5629
          },
          {
            "Area": "Mehre",
            "State": "Himachal Pradesh",
            "CountryCode": "IN",
            "Lat": 31.863,
            "Long": 77.2597
          },
          {
            "Area": "Mehroni",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 24.743,
            "Long": 78.6457
          },
          {
            "Area": "Mehsi",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.3557,
            "Long": 85.0925
          },
          {
            "Area": "Mehta Chowk",
            "State": "Punjab",
            "CountryCode": "IN",
            "Lat": 31.8824,
            "Long": 75.279
          },
          {
            "Area": "Mehus",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 25.1319,
            "Long": 85.8289
          },
          {
            "Area": "Meja",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.6571,
            "Long": 82.4043
          },
          {
            "Area": "Mejhia",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.3392,
            "Long": 87.1821
          },
          {
            "Area": "Mejia",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.4756,
            "Long": 87.2248
          },
          {
            "Area": "Mekhliganj",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 26.8537,
            "Long": 89.0856
          },
          {
            "Area": "Mekhliganjs.o.",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 24.293,
            "Long": 88.454
          },
          {
            "Area": "Mekliganj",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 26.4156,
            "Long": 88.9187
          },
          {
            "Area": "Melaghar",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 23.4955,
            "Long": 91.3298
          },
          {
            "Area": "Melchhamunda",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 21.3833,
            "Long": 83.584
          },
          {
            "Area": "Meliaputti",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 18.3729,
            "Long": 83.9818
          },
          {
            "Area": "Meliaputti Mandal",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 18.8229,
            "Long": 84.3539
          },
          {
            "Area": "Melli",
            "State": "Sikkim",
            "CountryCode": "IN",
            "Lat": 27.1179,
            "Long": 88.4574
          },
          {
            "Area": "Melur",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 11.7359,
            "Long": 78.6225
          },
          {
            "Area": "Meluri",
            "State": "Nagaland",
            "CountryCode": "IN",
            "Lat": 25.7219,
            "Long": 94.6799
          },
          {
            "Area": "Memari",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 24.0711,
            "Long": 88.3583
          },
          {
            "Area": "Memari - I",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 24.0318,
            "Long": 88.0965
          },
          {
            "Area": "Memari - II",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 24.0711,
            "Long": 88.0371
          },
          {
            "Area": "Mendarda",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 21.3211,
            "Long": 70.4408
          },
          {
            "Area": "Mendihaor",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 23.9923,
            "Long": 91.6205
          },
          {
            "Area": "Mendipathar",
            "State": "Meghalaya",
            "CountryCode": "IN",
            "Lat": 25.6007,
            "Long": 90.6107
          },
          {
            "Area": "Menhdawal",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.2741,
            "Long": 83.2075
          },
          {
            "Area": "Menkapur",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.5034,
            "Long": 87.9832
          },
          {
            "Area": "Mentada",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 18.3382,
            "Long": 83.4325
          },
          {
            "Area": "Meraka Mudidam",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 18.4673,
            "Long": 83.3793
          },
          {
            "Area": "Merakamudidam",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 18.7119,
            "Long": 83.5901
          },
          {
            "Area": "Merakamudidam Mandal",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 18.3003,
            "Long": 83.3238
          },
          {
            "Area": "Meral",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 24.3178,
            "Long": 84.1939
          },
          {
            "Area": "Merta",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 27.064,
            "Long": 75.1306
          },
          {
            "Area": "Merudandi",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.6846,
            "Long": 88.8911
          },
          {
            "Area": "Meskaur",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 24.8928,
            "Long": 85.2029
          },
          {
            "Area": "Metpalle",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.6399,
            "Long": 78.9988
          },
          {
            "Area": "Metpalli",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.7811,
            "Long": 79.9296
          },
          {
            "Area": "Mettupalayam",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 12.9042,
            "Long": 78.7984
          },
          {
            "Area": "Mettupalyaam",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 11.3214,
            "Long": 77.0052
          },
          {
            "Area": "Mettur",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 11.9066,
            "Long": 78.4134
          },
          {
            "Area": "Metwada",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 22.9651,
            "Long": 76.5437
          },
          {
            "Area": "Mewanagar",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 25.8061,
            "Long": 72.7027
          },
          {
            "Area": "Mhasla",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 21.03,
            "Long": 75.4923
          },
          {
            "Area": "Mhol",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 17.796,
            "Long": 75.6584
          },
          {
            "Area": "Mhow",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 22.8973,
            "Long": 76.7187
          },
          {
            "Area": "Miahat",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 25.3579,
            "Long": 87.8677
          },
          {
            "Area": "Miao",
            "State": "Arunachal Pradesh",
            "CountryCode": "IN",
            "Lat": 27.4934,
            "Long": 96.1812
          },
          {
            "Area": "Midjil",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 17.0076,
            "Long": 78.3673
          },
          {
            "Area": "Midnapore",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 25.2838,
            "Long": 88.7326
          },
          {
            "Area": "Midroo",
            "State": "Jammu & Kashmir",
            "CountryCode": "IN",
            "Lat": 33.9306,
            "Long": 75.1134
          },
          {
            "Area": "Mihona",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 26.3834,
            "Long": 79.1078
          },
          {
            "Area": "Mijikajan",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.971,
            "Long": 93.8695
          },
          {
            "Area": "Milak",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 28.7955,
            "Long": 79.8404
          },
          {
            "Area": "Milanpur",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.3796,
            "Long": 91.2951
          },
          {
            "Area": "Milkipur",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.8741,
            "Long": 82.8107
          },
          {
            "Area": "Milkipur **",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.4308,
            "Long": 82.2111
          },
          {
            "Area": "Milkpur",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.5619,
            "Long": 81.735
          },
          {
            "Area": "Minakhan",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.6389,
            "Long": 88.746
          },
          {
            "Area": "Minapur",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.2977,
            "Long": 85.7068
          },
          {
            "Area": "Minavilluru(mdl)",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.7717,
            "Long": 81.4423
          },
          {
            "Area": "Mini Sectt.",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.418,
            "Long": 76.9839
          },
          {
            "Area": "Minikpur",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.5214,
            "Long": 90.8806
          },
          {
            "Area": "Miraj",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.076,
            "Long": 76.0248
          },
          {
            "Area": "Mirazapur Sadar",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.2055,
            "Long": 82.812
          },
          {
            "Area": "Mirgoda",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 21.7213,
            "Long": 87.4833
          },
          {
            "Area": "Mirhati",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.7572,
            "Long": 88.4556
          },
          {
            "Area": "Mirik",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 26.9709,
            "Long": 88.3462
          },
          {
            "Area": "Miryalaguda",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 17.5196,
            "Long": 79.0149
          },
          {
            "Area": "Miryalguda",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 17.6078,
            "Long": 79.7935
          },
          {
            "Area": "Miryalgudda",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 17.5196,
            "Long": 78.822
          },
          {
            "Area": "Mirzapur",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.3713,
            "Long": 83.192
          },
          {
            "Area": "Mirzapur Belda",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.3564,
            "Long": 87.8021
          },
          {
            "Area": "Mirzapur Sadar",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.461,
            "Long": 83.2977
          },
          {
            "Area": "Mirzapursadar",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 24.95,
            "Long": 82.8503
          },
          {
            "Area": "Mirzpaur",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.1327,
            "Long": 82.5374
          },
          {
            "Area": "Mishrikh",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.7683,
            "Long": 81.1588
          },
          {
            "Area": "Misrikh",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.5177,
            "Long": 81.0267
          },
          {
            "Area": "Missamari",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.8061,
            "Long": 92.5977
          },
          {
            "Area": "Miukundapuram",
            "State": "Kerala",
            "CountryCode": "IN",
            "Lat": 10.3205,
            "Long": 76.3594
          },
          {
            "Area": "Modasa",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 24.1359,
            "Long": 73.542
          },
          {
            "Area": "Modinagar",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 28.8866,
            "Long": 78.0167
          },
          {
            "Area": "Moga",
            "State": "Punjab",
            "CountryCode": "IN",
            "Lat": 31.0631,
            "Long": 75.3627
          },
          {
            "Area": "Mogalturu(mdl)",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.3802,
            "Long": 81.5493
          },
          {
            "Area": "Mogullapalle",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.2688,
            "Long": 79.6821
          },
          {
            "Area": "Mogullapalli",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.3337,
            "Long": 79.7992
          },
          {
            "Area": "Mogullapally",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.3078,
            "Long": 79.6552
          },
          {
            "Area": "Mohadi",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 21.3928,
            "Long": 79.7912
          },
          {
            "Area": "Mohamda Bad Gohana",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.102,
            "Long": 83.7395
          },
          {
            "Area": "Mohammabad",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.6791,
            "Long": 83.6509
          },
          {
            "Area": "Mohammada Bad Gohana",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.9947,
            "Long": 83.27
          },
          {
            "Area": "Mohammadabad",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.9947,
            "Long": 83.9385
          },
          {
            "Area": "Mohammadabad Gohan",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.0088,
            "Long": 82.9628
          },
          {
            "Area": "Mohammadabad Gohana",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.0813,
            "Long": 83.6007
          },
          {
            "Area": "Mohammadabad Gohna",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.9139,
            "Long": 83.4244
          },
          {
            "Area": "Mohammadabad Yusufpur",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.7573,
            "Long": 83.8811
          },
          {
            "Area": "Mohammadi",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 27.9485,
            "Long": 80.3581
          },
          {
            "Area": "Mohammdabad Gohana",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.9947,
            "Long": 83.2398
          },
          {
            "Area": "Mohammdi",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 28.1225,
            "Long": 81.261
          },
          {
            "Area": "Mohammedabad",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.9032,
            "Long": 83.9595
          },
          {
            "Area": "Mohammmadabad",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.9947,
            "Long": 83.2398
          },
          {
            "Area": "Mohana",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 19.7366,
            "Long": 84.3951
          },
          {
            "Area": "Mohanbari",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.5654,
            "Long": 94.0443
          },
          {
            "Area": "Mohania",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 25.3514,
            "Long": 83.8548
          },
          {
            "Area": "Mohanlalganj",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.8416,
            "Long": 81.2005
          },
          {
            "Area": "Mohanpur",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 24.0447,
            "Long": 91.7553
          },
          {
            "Area": "Mohanpur",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.0557,
            "Long": 76.5055
          },
          {
            "Area": "Mohanpur",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.8923,
            "Long": 88.746
          },
          {
            "Area": "Mohanpur",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 24.7424,
            "Long": 87.0801
          },
          {
            "Area": "Mohanpur",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 24.7016,
            "Long": 85.0819
          },
          {
            "Area": "Moharcherra",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 23.9225,
            "Long": 91.6031
          },
          {
            "Area": "Mohati",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.5034,
            "Long": 87.9832
          },
          {
            "Area": "Mohd. Gohana",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.0431,
            "Long": 83.5629
          },
          {
            "Area": "Mohindergarh",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.4851,
            "Long": 76.4735
          },
          {
            "Area": "Mohiuddinagar",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 25.8802,
            "Long": 85.6989
          },
          {
            "Area": "Mohla",
            "State": "Chattisgarh",
            "CountryCode": "IN",
            "Lat": 21.0394,
            "Long": 80.9565
          },
          {
            "Area": "Mohol",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 18.6191,
            "Long": 77.4089
          },
          {
            "Area": "Moida",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 18.2219,
            "Long": 83.416
          },
          {
            "Area": "Moinabad",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 17.3901,
            "Long": 78.3279
          },
          {
            "Area": "Moinapara",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.6602,
            "Long": 92.0187
          },
          {
            "Area": "Moirang",
            "State": "Manipur",
            "CountryCode": "IN",
            "Lat": 24.4975,
            "Long": 93.7779
          },
          {
            "Area": "Moiyna",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.7639,
            "Long": 88.7265
          },
          {
            "Area": "Mokalsar",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 25.7356,
            "Long": 72.7892
          },
          {
            "Area": "Mokama",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 25.3988,
            "Long": 86.0222
          },
          {
            "Area": "Mokamah",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 25.3325,
            "Long": 86.186
          },
          {
            "Area": "Mokhada",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.9365,
            "Long": 74.7254
          },
          {
            "Area": "Mokokchung",
            "State": "Nagaland",
            "CountryCode": "IN",
            "Lat": 26.6643,
            "Long": 94.7678
          },
          {
            "Area": "Molakalmuru",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 14.881,
            "Long": 76.8323
          },
          {
            "Area": "Molgi",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 21.7382,
            "Long": 74.0377
          },
          {
            "Area": "Moman Badodiya",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 23.6594,
            "Long": 76.5988
          },
          {
            "Area": "Mominpur",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.78,
            "Long": 88.6252
          },
          {
            "Area": "Momong",
            "State": "Arunachal Pradesh",
            "CountryCode": "IN",
            "Lat": 27.7955,
            "Long": 96.1825
          },
          {
            "Area": "Mon",
            "State": "Nagaland",
            "CountryCode": "IN",
            "Lat": 26.8149,
            "Long": 95.0584
          },
          {
            "Area": "Mongalkote",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.766,
            "Long": 88.3634
          },
          {
            "Area": "Mongkholemba",
            "State": "Nagaland",
            "CountryCode": "IN",
            "Lat": 26.3748,
            "Long": 94.6222
          },
          {
            "Area": "Monigong",
            "State": "Arunachal Pradesh",
            "CountryCode": "IN",
            "Lat": 28.2358,
            "Long": 94.6742
          },
          {
            "Area": "Monkhed",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 22.0325,
            "Long": 79.1195
          },
          {
            "Area": "Monmohanpur",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.1465,
            "Long": 88.1117
          },
          {
            "Area": "Monteswar",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 24.0711,
            "Long": 87.7373
          },
          {
            "Area": "Moonak",
            "State": "Punjab",
            "CountryCode": "IN",
            "Lat": 30.2135,
            "Long": 76.0815
          },
          {
            "Area": "Moorang",
            "State": "Himachal Pradesh",
            "CountryCode": "IN",
            "Lat": 31.6665,
            "Long": 78.3199
          },
          {
            "Area": "Mopidevi",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.5055,
            "Long": 81.0694
          },
          {
            "Area": "Moradabad",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 29.1689,
            "Long": 79.0586
          },
          {
            "Area": "Moradabad Thehsil",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 28.8063,
            "Long": 78.9376
          },
          {
            "Area": "Morang(T)",
            "State": "Himachal Pradesh",
            "CountryCode": "IN",
            "Lat": 31.7576,
            "Long": 78.5684
          },
          {
            "Area": "Morar",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 26.3358,
            "Long": 78.7277
          },
          {
            "Area": "Morbi",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 22.8536,
            "Long": 70.8981
          },
          {
            "Area": "Morchi",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.5234,
            "Long": 87.6598
          },
          {
            "Area": "Moreh",
            "State": "Manipur",
            "CountryCode": "IN",
            "Lat": 24.3182,
            "Long": 94.224
          },
          {
            "Area": "Morena",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 26.747,
            "Long": 78.5037
          },
          {
            "Area": "Morigaon",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.5544,
            "Long": 92.727
          },
          {
            "Area": "Mormugao",
            "State": "Goa",
            "CountryCode": "IN",
            "Lat": 15.399,
            "Long": 73.9732
          },
          {
            "Area": "Morshi",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 21.3937,
            "Long": 78.0823
          },
          {
            "Area": "Morta",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 28.7238,
            "Long": 77.4553
          },
          {
            "Area": "Morva Hadaf",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.2428,
            "Long": 73.9075
          },
          {
            "Area": "Morvi",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.0055,
            "Long": 70.8981
          },
          {
            "Area": "Morwa (Hadaf)",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.3578,
            "Long": 73.811
          },
          {
            "Area": "Mosabani",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 23.5392,
            "Long": 86.7596
          },
          {
            "Area": "Motala",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 20.9554,
            "Long": 76.7816
          },
          {
            "Area": "Moth",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 25.8752,
            "Long": 79.066
          },
          {
            "Area": "Mothabari",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 24.853,
            "Long": 88.039
          },
          {
            "Area": "Mothkur",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 17.4251,
            "Long": 79.1665
          },
          {
            "Area": "Motihari",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.8872,
            "Long": 84.9951
          },
          {
            "Area": "Motihari H.o.",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.6703,
            "Long": 84.8962
          },
          {
            "Area": "Motijheel",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.5167,
            "Long": 80.3155
          },
          {
            "Area": "Motinagar",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.3334,
            "Long": 82.0337
          },
          {
            "Area": "Motipur",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.7706,
            "Long": 91.3933
          },
          {
            "Area": "Motipur",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.1511,
            "Long": 86.1613
          },
          {
            "Area": "Motla Kalan",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.3021,
            "Long": 76.4675
          },
          {
            "Area": "Motu",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 19.3627,
            "Long": 82.7237
          },
          {
            "Area": "Motunga",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 20.8615,
            "Long": 85.362
          },
          {
            "Area": "Moubhandar",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 23.2202,
            "Long": 86.0029
          },
          {
            "Area": "Mouda",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 21.0899,
            "Long": 79.3403
          },
          {
            "Area": "Movva",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.8262,
            "Long": 81.0333
          },
          {
            "Area": "Moyna",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.8486,
            "Long": 88.7265
          },
          {
            "Area": "Moyyeru(mdl)",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.7717,
            "Long": 81.4423
          },
          {
            "Area": "Mozampur",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 24.5656,
            "Long": 87.9504
          },
          {
            "Area": "Mrg",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.5859,
            "Long": 81.6771
          },
          {
            "Area": "Mrizapur",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 24.7096,
            "Long": 82.6142
          },
          {
            "Area": "Mudargi",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 15.2716,
            "Long": 75.6521
          },
          {
            "Area": "Muddanur",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 15.0695,
            "Long": 78.9388
          },
          {
            "Area": "Muddebihal",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 16.8707,
            "Long": 76.422
          },
          {
            "Area": "Mudhol",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 16.3888,
            "Long": 76.2099
          },
          {
            "Area": "Mudhole",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 19.6419,
            "Long": 78.3252
          },
          {
            "Area": "Mudiahat",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.3733,
            "Long": 88.2391
          },
          {
            "Area": "Mudigee",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 13.1439,
            "Long": 75.9407
          },
          {
            "Area": "Mudigere",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 13.4681,
            "Long": 76.1944
          },
          {
            "Area": "Mudigubba",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 14.4953,
            "Long": 78.2141
          },
          {
            "Area": "Mudinepalle",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.1495,
            "Long": 80.5637
          },
          {
            "Area": "Mudinepalli",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 17.0174,
            "Long": 81.2488
          },
          {
            "Area": "Mudinepelli",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.7729,
            "Long": 80.4427
          },
          {
            "Area": "Mudkhed",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.383,
            "Long": 77.6241
          },
          {
            "Area": "Mudukulathur",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 9.4653,
            "Long": 78.6733
          },
          {
            "Area": "Mugberia",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.0093,
            "Long": 87.7037
          },
          {
            "Area": "Mugkuchi",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.3796,
            "Long": 91.2951
          },
          {
            "Area": "Muhammadabad Gohana",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.0431,
            "Long": 83.5629
          },
          {
            "Area": "Muhuripur",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 23.0015,
            "Long": 91.7243
          },
          {
            "Area": "Mukalmua",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.3209,
            "Long": 91.6169
          },
          {
            "Area": "Mukerian",
            "State": "Punjab",
            "CountryCode": "IN",
            "Lat": 32.0363,
            "Long": 75.8588
          },
          {
            "Area": "Mukhed",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.1557,
            "Long": 77.8357
          },
          {
            "Area": "Muktai Nagar",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 21.0096,
            "Long": 76.3997
          },
          {
            "Area": "Muktainagar",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 21.0937,
            "Long": 76.049
          },
          {
            "Area": "Muktapur",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.3679,
            "Long": 91.3877
          },
          {
            "Area": "Muktsar",
            "State": "Punjab",
            "CountryCode": "IN",
            "Lat": 30.5305,
            "Long": 74.6802
          },
          {
            "Area": "Mukundapuram",
            "State": "Kerala",
            "CountryCode": "IN",
            "Lat": 10.9299,
            "Long": 76.8488
          },
          {
            "Area": "Mukundapuram Taluk",
            "State": "Kerala",
            "CountryCode": "IN",
            "Lat": 10.9299,
            "Long": 76.2977
          },
          {
            "Area": "Mul",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 20.507,
            "Long": 79.8057
          },
          {
            "Area": "Mulakalacheruvu",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 14.1723,
            "Long": 78.7348
          },
          {
            "Area": "Mulashi",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 18.6032,
            "Long": 73.7626
          },
          {
            "Area": "Mulati",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 21.8654,
            "Long": 78.4932
          },
          {
            "Area": "Mulbagal",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 13.4557,
            "Long": 78.5644
          },
          {
            "Area": "Mulbek",
            "State": "Jammu & Kashmir",
            "CountryCode": "IN",
            "Lat": 34.5099,
            "Long": 76.4496
          },
          {
            "Area": "Mulchera",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.7643,
            "Long": 80.2735
          },
          {
            "Area": "Muli",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 22.8543,
            "Long": 71.5402
          },
          {
            "Area": "Mullanpur",
            "State": "Punjab",
            "CountryCode": "IN",
            "Lat": 30.8312,
            "Long": 76.7378
          },
          {
            "Area": "Mulshi",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.7398,
            "Long": 77.2028
          },
          {
            "Area": "Multai",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 22.121,
            "Long": 78.519
          },
          {
            "Area": "Multhan",
            "State": "Himachal Pradesh",
            "CountryCode": "IN",
            "Lat": 31.8721,
            "Long": 76.8182
          },
          {
            "Area": "Mulug",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.3563,
            "Long": 79.9437
          },
          {
            "Area": "Mumbai",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.2361,
            "Long": 72.9488
          },
          {
            "Area": "Mummidivaram",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 17.1885,
            "Long": 82.0118
          },
          {
            "Area": "Mummidivaram Mandal",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.644,
            "Long": 82.1074
          },
          {
            "Area": "Munagapaka",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 17.8909,
            "Long": 82.6924
          },
          {
            "Area": "Munchingpu",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 18.3433,
            "Long": 82.8957
          },
          {
            "Area": "Munchingput",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 18.3433,
            "Long": 82.8957
          },
          {
            "Area": "Mundargi",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 15.4311,
            "Long": 75.9401
          },
          {
            "Area": "Mundgod",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 15.0587,
            "Long": 75.0525
          },
          {
            "Area": "Mundha",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 28.7794,
            "Long": 79.0586
          },
          {
            "Area": "Mundhal",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.9886,
            "Long": 76.1204
          },
          {
            "Area": "Mundi",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.2456,
            "Long": 76.4869
          },
          {
            "Area": "Mundra",
            "State": "Gujarat",
            "CountryCode": "IN",
            "Lat": 23.6285,
            "Long": 71.797
          },
          {
            "Area": "Mundwa",
            "State": "Rajasthan",
            "CountryCode": "IN",
            "Lat": 27.064,
            "Long": 74.5828
          },
          {
            "Area": "Mungaoli",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 24.6094,
            "Long": 78.306
          },
          {
            "Area": "Mungeli",
            "State": "Chattisgarh",
            "CountryCode": "IN",
            "Lat": 22.3513,
            "Long": 81.9617
          },
          {
            "Area": "Munger",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 25.452,
            "Long": 86.5676
          },
          {
            "Area": "Muniguda",
            "State": "Odisha",
            "CountryCode": "IN",
            "Lat": 19.8502,
            "Long": 83.8815
          },
          {
            "Area": "Munna Camp",
            "State": "Arunachal Pradesh",
            "CountryCode": "IN",
            "Lat": 27.4,
            "Long": 92.1833
          },
          {
            "Area": "Munshipurwa",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.418,
            "Long": 80.298
          },
          {
            "Area": "Munsiari",
            "State": "Uttarakhand",
            "CountryCode": "IN",
            "Lat": 30.1119,
            "Long": 80.3477
          },
          {
            "Area": "Munugode",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 17.2063,
            "Long": 79.0886
          },
          {
            "Area": "Muppalla",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.3768,
            "Long": 80.1159
          },
          {
            "Area": "Muppalla(sa)",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.5586,
            "Long": 80.2211
          },
          {
            "Area": "Muppalla(sap)",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.3768,
            "Long": 80.1419
          },
          {
            "Area": "Murabani",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.6315,
            "Long": 87.428
          },
          {
            "Area": "Murad Nagar",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 28.7379,
            "Long": 77.6571
          },
          {
            "Area": "Murakambattu",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 13.283,
            "Long": 79.1506
          },
          {
            "Area": "Murarai - I",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 24.3192,
            "Long": 87.7925
          },
          {
            "Area": "Murardih",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 23.2878,
            "Long": 86.4834
          },
          {
            "Area": "Murarisah",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.6389,
            "Long": 88.746
          },
          {
            "Area": "Muraul",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.1511,
            "Long": 85.5268
          },
          {
            "Area": "Murbad",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 19.5992,
            "Long": 74.0107
          },
          {
            "Area": "Murhu",
            "State": "Jharkhand",
            "CountryCode": "IN",
            "Lat": 23.4163,
            "Long": 85.7457
          },
          {
            "Area": "Muri",
            "State": "Arunachal Pradesh",
            "CountryCode": "IN",
            "Lat": 27.9911,
            "Long": 94.2295
          },
          {
            "Area": "Murisai",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 22.871,
            "Long": 88.0316
          },
          {
            "Area": "Murliganj",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 25.9771,
            "Long": 86.9958
          },
          {
            "Area": "Murshidabad",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 25.0597,
            "Long": 88.7005
          },
          {
            "Area": "Murshidabad Jiaganj",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 24.1874,
            "Long": 88.2717
          },
          {
            "Area": "Murticherra",
            "State": "Tripura",
            "CountryCode": "IN",
            "Lat": 24.332,
            "Long": 92.0039
          },
          {
            "Area": "Murtijapur",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 20.7319,
            "Long": 77.4279
          },
          {
            "Area": "Murud",
            "State": "Maharashtra",
            "CountryCode": "IN",
            "Lat": 18.8156,
            "Long": 73.8298
          },
          {
            "Area": "Murwara",
            "State": "Madhya Pradesh",
            "CountryCode": "IN",
            "Lat": 23.8167,
            "Long": 80.7916
          },
          {
            "Area": "Musafirkhana",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.7409,
            "Long": 82.1798
          },
          {
            "Area": "Musafirkna",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 26.5495,
            "Long": 81.6485
          },
          {
            "Area": "Musepur",
            "State": "Haryana",
            "CountryCode": "IN",
            "Lat": 28.3196,
            "Long": 76.611
          },
          {
            "Area": "Mushahari",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.1511,
            "Long": 87.4771
          },
          {
            "Area": "Mushahri",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.1511,
            "Long": 85.3308
          },
          {
            "Area": "Musheerabad",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 17.4057,
            "Long": 78.4944
          },
          {
            "Area": "Musiri",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 11.6088,
            "Long": 79.4994
          },
          {
            "Area": "Mussalpur",
            "State": "Assam",
            "CountryCode": "IN",
            "Lat": 26.7706,
            "Long": 91.3933
          },
          {
            "Area": "Mustabad",
            "State": "Telangana",
            "CountryCode": "IN",
            "Lat": 18.67,
            "Long": 79.3033
          },
          {
            "Area": "Mustafapur",
            "State": "West Bengal",
            "CountryCode": "IN",
            "Lat": 21.9467,
            "Long": 87.4938
          },
          {
            "Area": "Musunuru",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.9191,
            "Long": 81.0277
          },
          {
            "Area": "Muthukur",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 14.4205,
            "Long": 80.1239
          },
          {
            "Area": "Muthukur Mandalam",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 14.2946,
            "Long": 80.0937
          },
          {
            "Area": "Muvattupuzha",
            "State": "Kerala",
            "CountryCode": "IN",
            "Lat": 9.9899,
            "Long": 76.6717
          },
          {
            "Area": "Muzafarnagar",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 29.4763,
            "Long": 77.881
          },
          {
            "Area": "Muzaffarabad",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 30.1109,
            "Long": 77.6188
          },
          {
            "Area": "Muzaffarnagar",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 29.7441,
            "Long": 78.0042
          },
          {
            "Area": "Muzaffarnagarmuzaffarnagar",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 29.6291,
            "Long": 77.818
          },
          {
            "Area": "Muzaffarpur",
            "State": "Bihar",
            "CountryCode": "IN",
            "Lat": 26.1511,
            "Long": 87.4771
          },
          {
            "Area": "Muzaffrabad",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 30.0846,
            "Long": 78.6641
          },
          {
            "Area": "Muzaffrabad",
            "State": "Uttarakhand",
            "CountryCode": "IN",
            "Lat": 28.8152,
            "Long": 78.6641
          },
          {
            "Area": "Muzaffrabad`",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 30.0846,
            "Long": 77.5833
          },
          {
            "Area": "Mydekur",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 14.8018,
            "Long": 78.8083
          },
          {
            "Area": "Mylapore - Triplicane",
            "State": "Tamil Nadu",
            "CountryCode": "IN",
            "Lat": 12.9695,
            "Long": 80.2588
          },
          {
            "Area": "Mylavaram",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 16.852,
            "Long": 80.6198
          },
          {
            "Area": "Mypadu",
            "State": "Andhra Pradesh",
            "CountryCode": "IN",
            "Lat": 14.8411,
            "Long": 80.157
          },
          {
            "Area": "Mysore",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 12.5028,
            "Long": 76.9021
          },
          {
            "Area": "Mysuru",
            "State": "Karnataka",
            "CountryCode": "IN",
            "Lat": 12.3014,
            "Long": 76.6169
          },
          {
            "Area": "Mzn",
            "State": "Uttar Pradesh",
            "CountryCode": "IN",
            "Lat": 29.5281,
            "Long": 77.7794
          },
          {
            "Area": "L'Aquila",
            "Lat": "42.3504",
            "Long": "13.39",
            "CountryCode": "IT"
          },
          {
            "Area": "L'Ariana",
            "Lat": "36.8667",
            "Long": "10.2",
            "CountryCode": "TN"
          },
          {
            "Area": "La Ceiba",
            "Lat": "15.7631",
            "Long": "-86.797",
            "CountryCode": "HN"
          },
          {
            "Area": "La Coruña",
            "Lat": "43.33",
            "Long": "-8.42",
            "CountryCode": "ES"
          },
          {
            "Area": "La Crosse",
            "Lat": "43.8241",
            "Long": "-91.2268",
            "CountryCode": "US"
          },
          {
            "Area": "La Habra",
            "Lat": "33.9278",
            "Long": "-117.9513",
            "CountryCode": "US"
          },
          {
            "Area": "La Mesa",
            "Lat": "32.7703",
            "Long": "-117.0204",
            "CountryCode": "US"
          },
          {
            "Area": "La Paz",
            "Lat": "-16.498",
            "Long": "-68.15",
            "CountryCode": "BO"
          },
          {
            "Area": "La Paz",
            "Lat": "24.14",
            "Long": "-110.32",
            "CountryCode": "MX"
          },
          {
            "Area": "La Plata",
            "Lat": "-34.9096",
            "Long": "-57.96",
            "CountryCode": "AR"
          },
          {
            "Area": "La Rioja",
            "Lat": "-29.41",
            "Long": "-66.85",
            "CountryCode": "AR"
          },
          {
            "Area": "La Rochelle",
            "Lat": "46.1667",
            "Long": "-1.15",
            "CountryCode": "FR"
          },
          {
            "Area": "La ROMa",
            "Lat": "18.417",
            "Long": "-68.9666",
            "CountryCode": "DO"
          },
          {
            "Area": "La Serena",
            "Lat": "-29.9",
            "Long": "-71.25",
            "CountryCode": "CL"
          },
          {
            "Area": "La Vega",
            "Lat": "19.2166",
            "Long": "-70.5166",
            "CountryCode": "DO"
          },
          {
            "Area": "Labé",
            "Lat": "11.32",
            "Long": "-12.3",
            "CountryCode": "GN"
          },
          {
            "Area": "Labinsk",
            "Lat": "44.6348",
            "Long": "40.7443",
            "CountryCode": "RU"
          },
          {
            "Area": "Lae",
            "Lat": "-6.733",
            "Long": "146.99",
            "CountryCode": "PG"
          },
          {
            "Area": "Lafayette",
            "Lat": "30.2083",
            "Long": "-92.0322",
            "CountryCode": "US"
          },
          {
            "Area": "Lafayette",
            "Lat": "40.3991",
            "Long": "-86.8594",
            "CountryCode": "US"
          },
          {
            "Area": "Lafayette",
            "Lat": "39.9949",
            "Long": "-105.0997",
            "CountryCode": "US"
          },
          {
            "Area": "Lafia",
            "Lat": "8.4904",
            "Long": "8.52",
            "CountryCode": "NG"
          },
          {
            "Area": "Laghouat",
            "Lat": "33.81",
            "Long": "2.88",
            "CountryCode": "DZ"
          },
          {
            "Area": "Lagos",
            "Lat": "6.4433",
            "Long": "3.3915",
            "CountryCode": "NG"
          },
          {
            "Area": "Lagos de Moreno",
            "Lat": "21.3704",
            "Long": "-101.93",
            "CountryCode": "MX"
          },
          {
            "Area": "Laguna Niguel",
            "Lat": "33.5275",
            "Long": "-117.705",
            "CountryCode": "US"
          },
          {
            "Area": "Lahad Datu",
            "Lat": "5.0464",
            "Long": "118.336",
            "CountryCode": "MY"
          },
          {
            "Area": "Lahat",
            "Lat": "-3.8",
            "Long": "103.5333",
            "CountryCode": "ID"
          },
          {
            "Area": "Lahij",
            "Lat": "13.0582",
            "Long": "44.8838",
            "CountryCode": "YE"
          },
          {
            "Area": "Lahore",
            "Lat": "31.56",
            "Long": "74.35",
            "CountryCode": "PK"
          },
          {
            "Area": "Lahti",
            "Lat": "60.9939",
            "Long": "25.6649",
            "CountryCode": "FI"
          },
          {
            "Area": "Laiwu",
            "Lat": "36.2004",
            "Long": "117.66",
            "CountryCode": "CN"
          },
          {
            "Area": "Laiyang",
            "Lat": "36.9684",
            "Long": "120.7084",
            "CountryCode": "CN"
          },
          {
            "Area": "Lajes",
            "Lat": "-27.8096",
            "Long": "-50.31",
            "CountryCode": "BR"
          },
          {
            "Area": "Lake Charles",
            "Lat": "30.203",
            "Long": "-93.215",
            "CountryCode": "US"
          },
          {
            "Area": "Lake Elsinore",
            "Lat": "33.6843",
            "Long": "-117.3348",
            "CountryCode": "US"
          },
          {
            "Area": "Lake Forest",
            "Lat": "33.6607",
            "Long": "-117.6712",
            "CountryCode": "US"
          },
          {
            "Area": "Lake Havasu City",
            "Lat": "34.5006",
            "Long": "-114.3115",
            "CountryCode": "US"
          },
          {
            "Area": "Lake Jackson",
            "Lat": "29.0516",
            "Long": "-95.4522",
            "CountryCode": "US"
          },
          {
            "Area": "Lakeland",
            "Lat": "28.0557",
            "Long": "-81.9543",
            "CountryCode": "US"
          },
          {
            "Area": "Lakeville",
            "Lat": "44.6776",
            "Long": "-93.2521",
            "CountryCode": "US"
          },
          {
            "Area": "Lakewood",
            "Lat": "39.6978",
            "Long": "-105.1168",
            "CountryCode": "US"
          },
          {
            "Area": "Lakewood",
            "Lat": "33.8471",
            "Long": "-118.1221",
            "CountryCode": "US"
          },
          {
            "Area": "Lakewood",
            "Lat": "47.1628",
            "Long": "-122.5299",
            "CountryCode": "US"
          },
          {
            "Area": "Lakewood",
            "Lat": "41.4824",
            "Long": "-81.8008",
            "CountryCode": "US"
          },
          {
            "Area": "Lalitpur",
            "Lat": "27.6666",
            "Long": "85.3333",
            "CountryCode": "NP"
          },
          {
            "Area": "Lampang",
            "Lat": "18.2916",
            "Long": "99.4813",
            "CountryCode": "TH"
          },
          {
            "Area": "Lancaster",
            "Lat": "40.0421",
            "Long": "-76.3012",
            "CountryCode": "US"
          },
          {
            "Area": "Lancaster",
            "Lat": "34.6934",
            "Long": "-118.1753",
            "CountryCode": "US"
          },
          {
            "Area": "Lạng Sơn",
            "Lat": "21.846",
            "Long": "106.757",
            "CountryCode": "VN"
          },
          {
            "Area": "Langfang",
            "Lat": "39.5204",
            "Long": "116.68",
            "CountryCode": "CN"
          },
          {
            "Area": "Langsa",
            "Lat": "4.6736",
            "Long": "97.9664",
            "CountryCode": "ID"
          },
          {
            "Area": "Langzhong",
            "Lat": "31.5759",
            "Long": "105.9656",
            "CountryCode": "CN"
          },
          {
            "Area": "Lankaran",
            "Lat": "38.754",
            "Long": "48.8511",
            "CountryCode": "AZ"
          },
          {
            "Area": "Lansing",
            "Lat": "42.7142",
            "Long": "-84.56",
            "CountryCode": "US"
          },
          {
            "Area": "Lanxi",
            "Lat": "46.2664",
            "Long": "126.276",
            "CountryCode": "CN"
          },
          {
            "Area": "Lanzhou",
            "Lat": "36.056",
            "Long": "103.792",
            "CountryCode": "CN"
          },
          {
            "Area": "Lao Chi",
            "Lat": "22.5014",
            "Long": "103.966",
            "CountryCode": "VN"
          },
          {
            "Area": "Laoag",
            "Lat": "18.1988",
            "Long": "120.5936",
            "CountryCode": "PH"
          },
          {
            "Area": "Lappeenranta",
            "Lat": "61.0671",
            "Long": "28.1833",
            "CountryCode": "FI"
          },
          {
            "Area": "Larache",
            "Lat": "35.2004",
            "Long": "-6.16",
            "CountryCode": "MA"
          },
          {
            "Area": "Laredo",
            "Lat": "27.5616",
            "Long": "-99.487",
            "CountryCode": "US"
          },
          {
            "Area": "Largo",
            "Lat": "27.9088",
            "Long": "-82.7713",
            "CountryCode": "US"
          },
          {
            "Area": "Larissa",
            "Lat": "39.6304",
            "Long": "22.42",
            "CountryCode": "GR"
          },
          {
            "Area": "Larkana",
            "Lat": "27.5618",
            "Long": "68.2068",
            "CountryCode": "PK"
          },
          {
            "Area": "Las Cruces",
            "Lat": "32.3265",
            "Long": "-106.7893",
            "CountryCode": "US"
          },
          {
            "Area": "Las Heras",
            "Lat": "-32.825",
            "Long": "-68.8017",
            "CountryCode": "AR"
          },
          {
            "Area": "Las Palmas",
            "Lat": "28.1",
            "Long": "-15.43",
            "CountryCode": "ES"
          },
          {
            "Area": "Las Tunas",
            "Lat": "20.9601",
            "Long": "-76.9544",
            "CountryCode": "CU"
          },
          {
            "Area": "Las Vegas",
            "Lat": "36.2291",
            "Long": "-115.2607",
            "CountryCode": "US"
          },
          {
            "Area": "Lashkar Gah",
            "Lat": "31.583",
            "Long": "64.36",
            "CountryCode": "AF"
          },
          {
            "Area": "Latacunga",
            "Lat": "-0.9296",
            "Long": "-78.61",
            "CountryCode": "EC"
          },
          {
            "Area": "Lauderhill",
            "Lat": "26.1605",
            "Long": "-80.2241",
            "CountryCode": "US"
          },
          {
            "Area": "Launceston",
            "Lat": "-41.4498",
            "Long": "147.1302",
            "CountryCode": "AU"
          },
          {
            "Area": "Lausanne",
            "Lat": "46.5304",
            "Long": "6.65",
            "CountryCode": "CH"
          },
          {
            "Area": "Lautoka",
            "Lat": "-17.6161",
            "Long": "177.4666",
            "CountryCode": "Fiji"
          },
          {
            "Area": "Lavras",
            "Lat": "-21.2496",
            "Long": "-45.01",
            "CountryCode": "BR"
          },
          {
            "Area": "Lawrence",
            "Lat": "38.9597",
            "Long": "-95.2641",
            "CountryCode": "US"
          },
          {
            "Area": "Lawrence",
            "Lat": "42.7003",
            "Long": "-71.1626",
            "CountryCode": "US"
          },
          {
            "Area": "Lawton",
            "Lat": "34.6171",
            "Long": "-98.4204",
            "CountryCode": "US"
          },
          {
            "Area": "Layton",
            "Lat": "41.0771",
            "Long": "-111.9622",
            "CountryCode": "US"
          },
          {
            "Area": "Lázaro Cárdenas",
            "Lat": "17.9587",
            "Long": "-102.2",
            "CountryCode": "MX"
          },
          {
            "Area": "Le Havre",
            "Lat": "49.505",
            "Long": "0.105",
            "CountryCode": "FR"
          },
          {
            "Area": "Le Mans",
            "Lat": "48.0004",
            "Long": "0.1",
            "CountryCode": "FR"
          },
          {
            "Area": "League City",
            "Lat": "29.4874",
            "Long": "-95.1087",
            "CountryCode": "US"
          },
          {
            "Area": "LB",
            "Lat": "40.3412",
            "Long": "-76.4228",
            "CountryCode": "US"
          },
          {
            "Area": "Lecce",
            "Lat": "40.3604",
            "Long": "18.15",
            "CountryCode": "IT"
          },
          {
            "Area": "Leeds",
            "Lat": "53.83",
            "Long": "-1.58",
            "CountryCode": "GB"
          },
          {
            "Area": "Lees Summit",
            "Lat": "38.9172",
            "Long": "-94.3816",
            "CountryCode": "US"
          },
          {
            "Area": "Leesburg",
            "Lat": "28.7674",
            "Long": "-81.8981",
            "CountryCode": "US"
          },
          {
            "Area": "Leesburg",
            "Lat": "39.1058",
            "Long": "-77.5544",
            "CountryCode": "US"
          },
          {
            "Area": "Leeuwarden",
            "Lat": "53.2504",
            "Long": "5.7834",
            "CountryCode": "NL"
          },
          {
            "Area": "Legazpi",
            "Lat": "13.17",
            "Long": "123.75",
            "CountryCode": "PH"
          },
          {
            "Area": "Lehi",
            "Lat": "40.4137",
            "Long": "-111.8728",
            "CountryCode": "US"
          },
          {
            "Area": "Leicester",
            "Lat": "52.63",
            "Long": "-1.1332",
            "CountryCode": "GB"
          },
          {
            "Area": "Leipzig",
            "Lat": "51.3354",
            "Long": "12.41",
            "CountryCode": "DE"
          },
          {
            "Area": "Lemosos",
            "Lat": "34.6754",
            "Long": "33.0333",
            "CountryCode": "CY"
          },
          {
            "Area": "Lenexa",
            "Lat": "38.9609",
            "Long": "-94.8018",
            "CountryCode": "US"
          },
          {
            "Area": "Leninogorsk",
            "Lat": "54.5987",
            "Long": "52.4487",
            "CountryCode": "RU"
          },
          {
            "Area": "Leninsk Kuznetsky",
            "Lat": "54.66",
            "Long": "86.17",
            "CountryCode": "RU"
          },
          {
            "Area": "Leominster",
            "Lat": "42.5209",
            "Long": "-71.7717",
            "CountryCode": "US"
          },
          {
            "Area": "León",
            "Lat": "21.15",
            "Long": "-101.7",
            "CountryCode": "MX"
          },
          {
            "Area": "León",
            "Lat": "12.4356",
            "Long": "-86.8794",
            "CountryCode": "NI"
          },
          {
            "Area": "León",
            "Lat": "42.58",
            "Long": "-5.57",
            "CountryCode": "ES"
          },
          {
            "Area": "Les Cayes",
            "Lat": "18.2004",
            "Long": "-73.75",
            "CountryCode": "HT"
          },
          {
            "Area": "Leshan",
            "Lat": "29.5671",
            "Long": "103.7333",
            "CountryCode": "CN"
          },
          {
            "Area": "Lesosibirsk",
            "Lat": "58.2433",
            "Long": "92.4833",
            "CountryCode": "RU"
          },
          {
            "Area": "Lethbridge",
            "Lat": "49.7005",
            "Long": "-112.8333",
            "CountryCode": "CA"
          },
          {
            "Area": "Leticia",
            "Lat": "-4.22",
            "Long": "-69.94",
            "CountryCode": "CO"
          },
          {
            "Area": "Letpadan",
            "Lat": "17.7819",
            "Long": "95.7415",
            "CountryCode": "MM"
          },
          {
            "Area": "Lewiston",
            "Lat": "44.0915",
            "Long": "-70.1681",
            "CountryCode": "US"
          },
          {
            "Area": "Lewiston",
            "Lat": "46.3935",
            "Long": "-116.9934",
            "CountryCode": "US"
          },
          {
            "Area": "Lewisville",
            "Lat": "33.0453",
            "Long": "-96.9823",
            "CountryCode": "US"
          },
          {
            "Area": "Lexington",
            "Lat": "38.0423",
            "Long": "-84.4587",
            "CountryCode": "US"
          },
          {
            "Area": "Lhasa",
            "Lat": "29.645",
            "Long": "91.1",
            "CountryCode": "CN"
          },
          {
            "Area": "Lhokseumawe",
            "Lat": "5.1914",
            "Long": "97.1415",
            "CountryCode": "ID"
          },
          {
            "Area": "Lianxian",
            "Lat": "24.7815",
            "Long": "112.3825",
            "CountryCode": "CN"
          },
          {
            "Area": "Lianyungang",
            "Lat": "34.6004",
            "Long": "119.17",
            "CountryCode": "CN"
          },
          {
            "Area": "Liaocheng",
            "Lat": "36.4304",
            "Long": "115.97",
            "CountryCode": "CN"
          },
          {
            "Area": "Liaoyang",
            "Lat": "41.28",
            "Long": "123.18",
            "CountryCode": "CN"
          },
          {
            "Area": "Liaoyuan",
            "Lat": "42.9",
            "Long": "125.13",
            "CountryCode": "CN"
          },
          {
            "Area": "Liberec",
            "Lat": "50.8",
            "Long": "15.08",
            "CountryCode": "CZ"
          },
          {
            "Area": "Libreville",
            "Lat": "0.3854",
            "Long": "9.458",
            "CountryCode": "GA"
          },
          {
            "Area": "Lichinga",
            "Lat": "-13.3",
            "Long": "35.24",
            "CountryCode": "MZ"
          },
          {
            "Area": "Lida",
            "Lat": "53.8885",
            "Long": "25.2846",
            "CountryCode": "BY"
          },
          {
            "Area": "Liège",
            "Lat": "50.63",
            "Long": "5.58",
            "CountryCode": "BE"
          },
          {
            "Area": "Liepaga",
            "Lat": "56.51",
            "Long": "21.01",
            "CountryCode": "LV"
          },
          {
            "Area": "Likasi",
            "Lat": "-10.97",
            "Long": "26.78",
            "CountryCode": "CD"
          },
          {
            "Area": "Lille",
            "Lat": "50.65",
            "Long": "3.08",
            "CountryCode": "FR"
          },
          {
            "Area": "Lilongwe",
            "Lat": "-13.9833",
            "Long": "33.7833",
            "CountryCode": "MW"
          },
          {
            "Area": "Lima",
            "Lat": "-12.048",
            "Long": "-77.0501",
            "CountryCode": "PE"
          },
          {
            "Area": "Lima",
            "Lat": "40.7409",
            "Long": "-84.1121",
            "CountryCode": "US"
          },
          {
            "Area": "Limbe",
            "Lat": "4.0304",
            "Long": "9.19",
            "CountryCode": "CM"
          },
          {
            "Area": "Limeira",
            "Lat": "-22.5495",
            "Long": "-47.4",
            "CountryCode": "BR"
          },
          {
            "Area": "Limerick",
            "Lat": "52.6647",
            "Long": "-8.6231",
            "CountryCode": "IE"
          },
          {
            "Area": "Limoges",
            "Lat": "45.83",
            "Long": "1.25",
            "CountryCode": "FR"
          },
          {
            "Area": "Linares",
            "Lat": "-35.84",
            "Long": "-71.59",
            "CountryCode": "CL"
          },
          {
            "Area": "Linares",
            "Lat": "38.0833",
            "Long": "-3.6334",
            "CountryCode": "ES"
          },
          {
            "Area": "Linares",
            "Lat": "24.8604",
            "Long": "-99.57",
            "CountryCode": "MX"
          },
          {
            "Area": "Linchuan",
            "Lat": "27.9703",
            "Long": "116.36",
            "CountryCode": "CN"
          },
          {
            "Area": "Lincoln",
            "Lat": "40.8098",
            "Long": "-96.6802",
            "CountryCode": "US"
          },
          {
            "Area": "Linfen",
            "Lat": "36.0803",
            "Long": "111.52",
            "CountryCode": "CN"
          },
          {
            "Area": "Lingyuan",
            "Lat": "41.24",
            "Long": "119.4011",
            "CountryCode": "CN"
          },
          {
            "Area": "Linhai",
            "Lat": "28.85",
            "Long": "121.12",
            "CountryCode": "CN"
          },
          {
            "Area": "Linhares",
            "Lat": "-19.39",
            "Long": "-40.05",
            "CountryCode": "BR"
          },
          {
            "Area": "Linjiang",
            "Lat": "41.8363",
            "Long": "126.936",
            "CountryCode": "CN"
          },
          {
            "Area": "Linköping",
            "Lat": "58.41",
            "Long": "15.6299",
            "CountryCode": "SE"
          },
          {
            "Area": "Linkou",
            "Lat": "45.2819",
            "Long": "130.2519",
            "CountryCode": "CN"
          },
          {
            "Area": "Linqing",
            "Lat": "36.8504",
            "Long": "115.68",
            "CountryCode": "CN"
          },
          {
            "Area": "Linxia",
            "Lat": "35.6",
            "Long": "103.2",
            "CountryCode": "CN"
          },
          {
            "Area": "Linyi",
            "Lat": "35.08",
            "Long": "118.33",
            "CountryCode": "CN"
          },
          {
            "Area": "Linz",
            "Lat": "48.3192",
            "Long": "14.2888",
            "CountryCode": "AT"
          },
          {
            "Area": "Lipetsk",
            "Lat": "52.62",
            "Long": "39.64",
            "CountryCode": "RU"
          },
          {
            "Area": "Lira",
            "Lat": "2.2604",
            "Long": "32.89",
            "CountryCode": "UG"
          },
          {
            "Area": "Lisala",
            "Lat": "2.14",
            "Long": "21.51",
            "CountryCode": "CD"
          },
          {
            "Area": "Lisbon",
            "Lat": "38.7227",
            "Long": "-9.1449",
            "CountryCode": "PT"
          },
          {
            "Area": "Lishui",
            "Lat": "28.4504",
            "Long": "119.9",
            "CountryCode": "CN"
          },
          {
            "Area": "Little Rock",
            "Lat": "34.7255",
            "Long": "-92.3581",
            "CountryCode": "US"
          },
          {
            "Area": "Liuhe",
            "Lat": "42.2789",
            "Long": "125.7173",
            "CountryCode": "CN"
          },
          {
            "Area": "Liuzhou",
            "Lat": "24.28",
            "Long": "109.25",
            "CountryCode": "CN"
          },
          {
            "Area": "Livermore",
            "Lat": "37.6861",
            "Long": "-121.7608",
            "CountryCode": "US"
          },
          {
            "Area": "Liverpool",
            "Lat": "53.416",
            "Long": "-2.918",
            "CountryCode": "GB"
          },
          {
            "Area": "Livingstone",
            "Lat": "-17.86",
            "Long": "25.86",
            "CountryCode": "ZM"
          },
          {
            "Area": "Livny",
            "Lat": "52.4248",
            "Long": "37.6044",
            "CountryCode": "RU"
          },
          {
            "Area": "Livonia",
            "Lat": "42.3972",
            "Long": "-83.3733",
            "CountryCode": "US"
          },
          {
            "Area": "Livorno",
            "Lat": "43.5511",
            "Long": "10.3023",
            "CountryCode": "IT"
          },
          {
            "Area": "Ljubljana",
            "Lat": "46.0553",
            "Long": "14.515",
            "CountryCode": "SI"
          },
          {
            "Area": "Lobatse",
            "Lat": "-25.2196",
            "Long": "25.68",
            "CountryCode": "BW"
          },
          {
            "Area": "Lobito",
            "Lat": "-12.37",
            "Long": "13.5412",
            "CountryCode": "AO"
          },
          {
            "Area": "Lodi",
            "Lat": "38.1218",
            "Long": "-121.2932",
            "CountryCode": "US"
          },
          {
            "Area": "Lodja",
            "Lat": "-3.4896",
            "Long": "23.42",
            "CountryCode": "CD"
          },
          {
            "Area": "Łódź",
            "Lat": "51.775",
            "Long": "19.4514",
            "CountryCode": "PL"
          },
          {
            "Area": "Logan",
            "Lat": "41.7402",
            "Long": "-111.8419",
            "CountryCode": "US"
          },
          {
            "Area": "Logroño",
            "Lat": "42.4704",
            "Long": "-2.43",
            "CountryCode": "ES"
          },
          {
            "Area": "Loja",
            "Lat": "-3.99",
            "Long": "-79.21",
            "CountryCode": "EC"
          },
          {
            "Area": "Lokoja",
            "Lat": "7.8004",
            "Long": "6.7399",
            "CountryCode": "NG"
          },
          {
            "Area": "Lokossa",
            "Lat": "6.615",
            "Long": "1.715",
            "CountryCode": "BJ"
          },
          {
            "Area": "Lomé",
            "Lat": "6.1319",
            "Long": "1.2228",
            "CountryCode": "TG"
          },
          {
            "Area": "Lompoc",
            "Lat": "34.6618",
            "Long": "-120.4714",
            "CountryCode": "US"
          },
          {
            "Area": "London",
            "Lat": "51.5",
            "Long": "-0.1167",
            "CountryCode": "GB"
          },
          {
            "Area": "London",
            "Lat": "42.97",
            "Long": "-81.25",
            "CountryCode": "CA"
          },
          {
            "Area": "Londonderry",
            "Lat": "55.0004",
            "Long": "-7.3333",
            "CountryCode": "GB"
          },
          {
            "Area": "Londrina",
            "Lat": "-23.3",
            "Long": "-51.18",
            "CountryCode": "BR"
          },
          {
            "Area": "Long Beach",
            "Lat": "33.8059",
            "Long": "-118.161",
            "CountryCode": "US"
          },
          {
            "Area": "Long Xuyen",
            "Lat": "10.3804",
            "Long": "105.42",
            "CountryCode": "VN"
          },
          {
            "Area": "Longjiang",
            "Lat": "47.3404",
            "Long": "123.18",
            "CountryCode": "CN"
          },
          {
            "Area": "Longmont",
            "Lat": "40.1691",
            "Long": "-105.0996",
            "CountryCode": "US"
          },
          {
            "Area": "Longview",
            "Lat": "32.5192",
            "Long": "-94.7622",
            "CountryCode": "US"
          },
          {
            "Area": "Longview",
            "Lat": "46.146",
            "Long": "-122.963",
            "CountryCode": "US"
          },
          {
            "Area": "Longxi",
            "Lat": "35.0476",
            "Long": "104.6394",
            "CountryCode": "CN"
          },
          {
            "Area": "Longyan",
            "Lat": "25.1804",
            "Long": "117.03",
            "CountryCode": "CN"
          },
          {
            "Area": "Lop Buri",
            "Lat": "14.804",
            "Long": "100.6186",
            "CountryCode": "TH"
          },
          {
            "Area": "Lorain",
            "Lat": "41.4409",
            "Long": "-82.184",
            "CountryCode": "US"
          },
          {
            "Area": "Lorca",
            "Lat": "37.6886",
            "Long": "-1.6985",
            "CountryCode": "ES"
          },
          {
            "Area": "Lorica",
            "Lat": "9.2419",
            "Long": "-75.816",
            "CountryCode": "CO"
          },
          {
            "Area": "Lorient",
            "Lat": "47.7504",
            "Long": "-3.3666",
            "CountryCode": "FR"
          },
          {
            "Area": "Los Andes",
            "Lat": "-32.8296",
            "Long": "-70.6",
            "CountryCode": "CL"
          },
          {
            "Area": "Los Angeles",
            "Lat": "34.1139",
            "Long": "-118.4068",
            "CountryCode": "US"
          },
          {
            "Area": "Los Angeles",
            "Lat": "-37.46",
            "Long": "-72.36",
            "CountryCode": "CL"
          },
          {
            "Area": "Los Lunas",
            "Lat": "34.8114",
            "Long": "-106.7808",
            "CountryCode": "US"
          },
          {
            "Area": "Los Mochis",
            "Lat": "25.79",
            "Long": "-109",
            "CountryCode": "MX"
          },
          {
            "Area": "Los Teques",
            "Lat": "10.42",
            "Long": "-67.02",
            "CountryCode": "VE"
          },
          {
            "Area": "Louangphrabang",
            "Lat": "19.8845",
            "Long": "102.1416",
            "CountryCode": "LA"
          },
          {
            "Area": "Loubomo",
            "Lat": "-4.1796",
            "Long": "12.67",
            "CountryCode": "CG"
          },
          {
            "Area": "Louga",
            "Lat": "15.6104",
            "Long": "-16.25",
            "CountryCode": "SN"
          },
          {
            "Area": "Louisville",
            "Lat": "38.1662",
            "Long": "-85.6488",
            "CountryCode": "US"
          },
          {
            "Area": "Loveland",
            "Lat": "40.4167",
            "Long": "-105.0621",
            "CountryCode": "US"
          },
          {
            "Area": "Lowell",
            "Lat": "42.6389",
            "Long": "-71.3217",
            "CountryCode": "US"
          },
          {
            "Area": "Lower Hutt",
            "Lat": "-41.2037",
            "Long": "174.9123",
            "CountryCode": "NZ"
          },
          {
            "Area": "Luan",
            "Lat": "31.7503",
            "Long": "116.48",
            "CountryCode": "CN"
          },
          {
            "Area": "Luanda",
            "Lat": "-8.8383",
            "Long": "13.2344",
            "CountryCode": "AO"
          },
          {
            "Area": "Luanshya",
            "Lat": "-13.1333",
            "Long": "28.4",
            "CountryCode": "ZM"
          },
          {
            "Area": "Lubango",
            "Lat": "-14.91",
            "Long": "13.49",
            "CountryCode": "AO"
          },
          {
            "Area": "Lubbock",
            "Lat": "33.5643",
            "Long": "-101.8871",
            "CountryCode": "US"
          },
          {
            "Area": "Lübeck",
            "Lat": "53.8704",
            "Long": "10.67",
            "CountryCode": "DE"
          },
          {
            "Area": "Lublin",
            "Lat": "51.2504",
            "Long": "22.5727",
            "CountryCode": "PL"
          },
          {
            "Area": "Lubumbashi",
            "Lat": "-11.68",
            "Long": "27.48",
            "CountryCode": "CD"
          },
          {
            "Area": "Lugano",
            "Lat": "46.0004",
            "Long": "8.9667",
            "CountryCode": "CH"
          },
          {
            "Area": "Luhansk",
            "Lat": "48.5698",
            "Long": "39.3344",
            "CountryCode": "UA"
          },
          {
            "Area": "Luján",
            "Lat": "-34.5796",
            "Long": "-59.11",
            "CountryCode": "AR"
          },
          {
            "Area": "Lüleburgaz",
            "Lat": "41.4067",
            "Long": "27.3552",
            "CountryCode": "TR"
          },
          {
            "Area": "Luohe",
            "Lat": "33.57",
            "Long": "114.03",
            "CountryCode": "CN"
          },
          {
            "Area": "Luoyang",
            "Lat": "34.68",
            "Long": "112.4701",
            "CountryCode": "CN"
          },
          {
            "Area": "Lupanshui",
            "Lat": "26.5944",
            "Long": "104.8333",
            "CountryCode": "CN"
          },
          {
            "Area": "Lusaka",
            "Lat": "-15.4166",
            "Long": "28.2833",
            "CountryCode": "ZM"
          },
          {
            "Area": "Luton",
            "Lat": "51.8804",
            "Long": "-0.42",
            "CountryCode": "GB"
          },
          {
            "Area": "Lutsk",
            "Lat": "50.7472",
            "Long": "25.3334",
            "CountryCode": "UA"
          },
          {
            "Area": "LU",
            "Lat": "49.6117",
            "Long": "6.13",
            "CountryCode": "LU"
          },
          {
            "Area": "Luxor",
            "Lat": "25.7",
            "Long": "32.65",
            "CountryCode": "EG"
          },
          {
            "Area": "Luzern",
            "Lat": "47.0504",
            "Long": "8.28",
            "CountryCode": "CH"
          },
          {
            "Area": "Luzhou",
            "Lat": "28.88",
            "Long": "105.38",
            "CountryCode": "CN"
          },
          {
            "Area": "Lvov",
            "Lat": "49.835",
            "Long": "24.03",
            "CountryCode": "UA"
          },
          {
            "Area": "Lynchburg",
            "Lat": "37.4003",
            "Long": "-79.1908",
            "CountryCode": "US"
          },
          {
            "Area": "Lynn",
            "Lat": "42.4779",
            "Long": "-70.9663",
            "CountryCode": "US"
          },
          {
            "Area": "Lynwood",
            "Lat": "33.924",
            "Long": "-118.2017",
            "CountryCode": "US"
          },
          {
            "Area": "Lyon",
            "Lat": "45.77",
            "Long": "4.83",
            "CountryCode": "FR"
          },
          {
            "Area": "Lysychansk",
            "Lat": "48.9204",
            "Long": "38.4274",
            "CountryCode": "UA"
          },
          {
            "Area": "M'sila",
            "Lat": "35.7",
            "Long": "4.545",
            "CountryCode": "DZ"
          },
          {
            "Area": "Ma'an",
            "Lat": "30.192",
            "Long": "35.736",
            "CountryCode": "JO"
          },
          {
            "Area": "Maanshan",
            "Lat": "31.7304",
            "Long": "118.48",
            "CountryCode": "CN"
          },
          {
            "Area": "Maastricht",
            "Lat": "50.853",
            "Long": "5.677",
            "CountryCode": "NL"
          },
          {
            "Area": "Macaé",
            "Lat": "-22.38",
            "Long": "-41.79",
            "CountryCode": "BR"
          },
          {
            "Area": "Macapá",
            "Lat": "0.033",
            "Long": "-51.05",
            "CountryCode": "BR"
          },
          {
            "Area": "MO",
            "Lat": "22.203",
            "Long": "113.545",
            "CountryCode": "MO"
          },
          {
            "Area": "Maceió",
            "Lat": "-9.62",
            "Long": "-35.73",
            "CountryCode": "BR"
          },
          {
            "Area": "Machakos",
            "Lat": "-1.5095",
            "Long": "37.26",
            "CountryCode": "KE"
          },
          {
            "Area": "Machala",
            "Lat": "-3.26",
            "Long": "-79.96",
            "CountryCode": "EC"
          },
          {
            "Area": "Macheng",
            "Lat": "31.18",
            "Long": "115.03",
            "CountryCode": "CN"
          },
          {
            "Area": "Machiques",
            "Lat": "10.0704",
            "Long": "-72.5499",
            "CountryCode": "VE"
          },
          {
            "Area": "Mackay",
            "Lat": "-21.1439",
            "Long": "149.15",
            "CountryCode": "AU"
          },
          {
            "Area": "Madang",
            "Lat": "-5.2248",
            "Long": "145.7853",
            "CountryCode": "PG"
          },
          {
            "Area": "Madera",
            "Lat": "36.964",
            "Long": "-120.0803",
            "CountryCode": "US"
          },
          {
            "Area": "Madinat ath Thawrah",
            "Lat": "35.8367",
            "Long": "38.5481",
            "CountryCode": "SY"
          },
          {
            "Area": "Madison",
            "Lat": "43.0808",
            "Long": "-89.3922",
            "CountryCode": "US"
          },
          {
            "Area": "Madiun",
            "Lat": "-7.6346",
            "Long": "111.515",
            "CountryCode": "ID"
          },
          {
            "Area": "Madrid",
            "Lat": "40.4",
            "Long": "-3.6834",
            "CountryCode": "ES"
          },
          {
            "Area": "Maebashi",
            "Lat": "36.3927",
            "Long": "139.0727",
            "CountryCode": "JP"
          },
          {
            "Area": "Mafetang",
            "Lat": "-29.8166",
            "Long": "27.25",
            "CountryCode": "LS"
          },
          {
            "Area": "Magadan",
            "Lat": "59.575",
            "Long": "150.81",
            "CountryCode": "RU"
          },
          {
            "Area": "Magangué",
            "Lat": "9.23",
            "Long": "-74.74",
            "CountryCode": "CO"
          },
          {
            "Area": "Magdeburg",
            "Lat": "52.1304",
            "Long": "11.62",
            "CountryCode": "DE"
          },
          {
            "Area": "Magelang",
            "Lat": "-7.4696",
            "Long": "110.18",
            "CountryCode": "ID"
          },
          {
            "Area": "MagniTGrsk",
            "Lat": "53.4227",
            "Long": "58.98",
            "CountryCode": "RU"
          },
          {
            "Area": "Magong",
            "Lat": "23.5667",
            "Long": "119.5833",
            "CountryCode": "TW"
          },
          {
            "Area": "Magway",
            "Lat": "20.1445",
            "Long": "94.9196",
            "CountryCode": "MM"
          },
          {
            "Area": "Maha Sarakham",
            "Lat": "16.184",
            "Long": "103.298",
            "CountryCode": "TH"
          },
          {
            "Area": "Mahabad",
            "Lat": "36.7704",
            "Long": "45.72",
            "CountryCode": "IR"
          },
          {
            "Area": "Mahajanga",
            "Lat": "-15.67",
            "Long": "46.345",
            "CountryCode": "MG"
          },
          {
            "Area": "Mahalapye",
            "Lat": "-23.1",
            "Long": "26.82",
            "CountryCode": "BW"
          },
          {
            "Area": "Mahilyow",
            "Lat": "53.8985",
            "Long": "30.3247",
            "CountryCode": "BY"
          },
          {
            "Area": "Maiduguri",
            "Lat": "11.85",
            "Long": "13.16",
            "CountryCode": "NG"
          },
          {
            "Area": "Maina",
            "Lat": "13.4692",
            "Long": "144.7332",
            "CountryCode": "GU"
          },
          {
            "Area": "Mainz",
            "Lat": "49.9825",
            "Long": "8.2732",
            "CountryCode": "DE"
          },
          {
            "Area": "Maiquetía",
            "Lat": "10.6004",
            "Long": "-66.97",
            "CountryCode": "VE"
          },
          {
            "Area": "Maizuru",
            "Lat": "35.4504",
            "Long": "135.3333",
            "CountryCode": "JP"
          },
          {
            "Area": "Majene",
            "Lat": "-3.5336",
            "Long": "118.966",
            "CountryCode": "ID"
          },
          {
            "Area": "Makeni",
            "Lat": "8.8804",
            "Long": "-12.05",
            "CountryCode": "SL"
          },
          {
            "Area": "Makhachkala",
            "Lat": "42.98",
            "Long": "47.5",
            "CountryCode": "RU"
          },
          {
            "Area": "Makiyivka",
            "Lat": "48.0297",
            "Long": "37.9746",
            "CountryCode": "UA"
          },
          {
            "Area": "Makkah",
            "Lat": "21.43",
            "Long": "39.82",
            "CountryCode": "SA"
          },
          {
            "Area": "Makurdi",
            "Lat": "7.73",
            "Long": "8.53",
            "CountryCode": "NG"
          },
          {
            "Area": "Malabo",
            "Lat": "3.75",
            "Long": "8.7833",
            "CountryCode": "GQ"
          },
          {
            "Area": "Malacca",
            "Lat": "2.2064",
            "Long": "102.2465",
            "CountryCode": "MY"
          },
          {
            "Area": "Maladzyechna",
            "Lat": "54.3188",
            "Long": "26.8653",
            "CountryCode": "BY"
          },
          {
            "Area": "Málaga",
            "Lat": "36.7204",
            "Long": "-4.42",
            "CountryCode": "ES"
          },
          {
            "Area": "Malakal",
            "Lat": "9.5369",
            "Long": "31.656",
            "CountryCode": "SD"
          },
          {
            "Area": "Malang",
            "Lat": "-7.98",
            "Long": "112.61",
            "CountryCode": "ID"
          },
          {
            "Area": "Malanje",
            "Lat": "-9.54",
            "Long": "16.34",
            "CountryCode": "AO"
          },
          {
            "Area": "Malatya",
            "Lat": "38.3704",
            "Long": "38.3",
            "CountryCode": "TR"
          },
          {
            "Area": "Malayer",
            "Lat": "34.32",
            "Long": "48.85",
            "CountryCode": "IR"
          },
          {
            "Area": "Malden",
            "Lat": "42.4305",
            "Long": "-71.0576",
            "CountryCode": "US"
          },
          {
            "Area": "Maldonado",
            "Lat": "-34.91",
            "Long": "-54.96",
            "CountryCode": "UY"
          },
          {
            "Area": "Malé",
            "Lat": "4.1667",
            "Long": "73.4999",
            "CountryCode": "MV"
          },
          {
            "Area": "MLndi",
            "Lat": "-3.21",
            "Long": "40.1",
            "CountryCode": "KE"
          },
          {
            "Area": "Mallawi",
            "Lat": "27.7304",
            "Long": "30.84",
            "CountryCode": "EG"
          },
          {
            "Area": "Malmö",
            "Lat": "55.5833",
            "Long": "13.0333",
            "CountryCode": "SE"
          },
          {
            "Area": "Mamou",
            "Lat": "10.3804",
            "Long": "-12.1",
            "CountryCode": "GN"
          },
          {
            "Area": "Man",
            "Lat": "7.4004",
            "Long": "-7.55",
            "CountryCode": "CL"
          },
          {
            "Area": "Manacapuru",
            "Lat": "-3.2896",
            "Long": "-60.62",
            "CountryCode": "BR"
          },
          {
            "Area": "Manado",
            "Lat": "1.48",
            "Long": "124.85",
            "CountryCode": "ID"
          },
          {
            "Area": "Managua",
            "Lat": "12.153",
            "Long": "-86.2685",
            "CountryCode": "NI"
          },
          {
            "Area": "Manama",
            "Lat": "26.2361",
            "Long": "50.5831",
            "CountryCode": "BH"
          },
          {
            "Area": "Manaus",
            "Lat": "-3.1",
            "Long": "-60",
            "CountryCode": "BR"
          },
          {
            "Area": "Manbij",
            "Lat": "36.5266",
            "Long": "37.9563",
            "CountryCode": "SY"
          },
          {
            "Area": "Manchester",
            "Lat": "53.5004",
            "Long": "-2.248",
            "CountryCode": "GB"
          },
          {
            "Area": "Manchester",
            "Lat": "42.9848",
            "Long": "-71.4447",
            "CountryCode": "US"
          },
          {
            "Area": "Mandalay",
            "Lat": "21.97",
            "Long": "96.085",
            "CountryCode": "MM"
          },
          {
            "Area": "Mandeville",
            "Lat": "30.375",
            "Long": "-90.0906",
            "CountryCode": "US"
          },
          {
            "Area": "Mandurah",
            "Lat": "-32.5235",
            "Long": "115.7471",
            "CountryCode": "AU"
          },
          {
            "Area": "Mangochi",
            "Lat": "-14.4596",
            "Long": "35.27",
            "CountryCode": "MW"
          },
          {
            "Area": "Mangyshlak",
            "Lat": "43.6905",
            "Long": "51.1417",
            "CountryCode": "KZ"
          },
          {
            "Area": "Manhattan",
            "Lat": "40.7834",
            "Long": "-73.9662",
            "CountryCode": "US"
          },
          {
            "Area": "Manhattan",
            "Lat": "39.1882",
            "Long": "-96.6053",
            "CountryCode": "US"
          },
          {
            "Area": "Manila",
            "Lat": "14.6042",
            "Long": "120.9822",
            "CountryCode": "PH"
          },
          {
            "Area": "Manisa",
            "Lat": "38.6304",
            "Long": "27.44",
            "CountryCode": "TR"
          },
          {
            "Area": "Manizales",
            "Lat": "5.06",
            "Long": "-75.52",
            "CountryCode": "CO"
          },
          {
            "Area": "Mankato",
            "Lat": "44.1712",
            "Long": "-93.9773",
            "CountryCode": "US"
          },
          {
            "Area": "Mannheim",
            "Lat": "49.5004",
            "Long": "8.47",
            "CountryCode": "DE"
          },
          {
            "Area": "Manokwari",
            "Lat": "-0.8711",
            "Long": "134.0693",
            "CountryCode": "ID"
          },
          {
            "Area": "Manpo",
            "Lat": "41.1454",
            "Long": "126.2958",
            "CountryCode": "KP"
          },
          {
            "Area": "Mansehra",
            "Lat": "34.3418",
            "Long": "73.1968",
            "CountryCode": "PK"
          },
          {
            "Area": "Mansfield",
            "Lat": "40.7656",
            "Long": "-82.5275",
            "CountryCode": "US"
          },
          {
            "Area": "Mansfield",
            "Lat": "32.569",
            "Long": "-97.1211",
            "CountryCode": "US"
          },
          {
            "Area": "Manta",
            "Lat": "-0.98",
            "Long": "-80.73",
            "CountryCode": "EC"
          },
          {
            "Area": "Manteca",
            "Lat": "37.7938",
            "Long": "-121.227",
            "CountryCode": "US"
          },
          {
            "Area": "Manukau",
            "Lat": "-37",
            "Long": "174.885",
            "CountryCode": "NZ"
          },
          {
            "Area": "Manzanillo",
            "Lat": "20.3438",
            "Long": "-77.1166",
            "CountryCode": "CU"
          },
          {
            "Area": "Manzanillo",
            "Lat": "19.0496",
            "Long": "-104.3231",
            "CountryCode": "MX"
          },
          {
            "Area": "Manzhouli",
            "Lat": "49.6",
            "Long": "117.43",
            "CountryCode": "CN"
          },
          {
            "Area": "Manzini",
            "Lat": "-26.495",
            "Long": "31.388",
            "CountryCode": "SZ"
          },
          {
            "Area": "Maoming",
            "Lat": "21.9204",
            "Long": "110.87",
            "CountryCode": "CN"
          },
          {
            "Area": "Maple Grove",
            "Lat": "45.1089",
            "Long": "-93.4626",
            "CountryCode": "US"
          },
          {
            "Area": "Maputo",
            "Lat": "-25.9553",
            "Long": "32.5892",
            "CountryCode": "MZ"
          },
          {
            "Area": "Mar del Plata",
            "Lat": "-38",
            "Long": "-57.58",
            "CountryCode": "AR"
          },
          {
            "Area": "Marabá",
            "Lat": "-5.35",
            "Long": "-49.116",
            "CountryCode": "BR"
          },
          {
            "Area": "Maracaibo",
            "Lat": "10.73",
            "Long": "-71.66",
            "CountryCode": "VE"
          },
          {
            "Area": "Maracay",
            "Lat": "10.2469",
            "Long": "-67.5958",
            "CountryCode": "VE"
          },
          {
            "Area": "Maradi",
            "Lat": "13.4916",
            "Long": "7.0964",
            "CountryCode": "NE"
          },
          {
            "Area": "Maragheh",
            "Lat": "37.4204",
            "Long": "46.22",
            "CountryCode": "IR"
          },
          {
            "Area": "Marbella",
            "Lat": "36.5166",
            "Long": "-4.8833",
            "CountryCode": "ES"
          },
          {
            "Area": "Mardan",
            "Lat": "34.2",
            "Long": "72.04",
            "CountryCode": "PK"
          },
          {
            "Area": "Mardin",
            "Lat": "37.3115",
            "Long": "40.7427",
            "CountryCode": "TR"
          },
          {
            "Area": "Margate",
            "Lat": "26.2465",
            "Long": "-80.2119",
            "CountryCode": "US"
          },
          {
            "Area": "Maribor",
            "Lat": "46.5405",
            "Long": "15.65",
            "CountryCode": "SI"
          },
          {
            "Area": "Marietta",
            "Lat": "33.9532",
            "Long": "-84.5421",
            "CountryCode": "US"
          },
          {
            "Area": "Marília",
            "Lat": "-22.21",
            "Long": "-49.95",
            "CountryCode": "BR"
          },
          {
            "Area": "Maringá",
            "Lat": "-23.4095",
            "Long": "-51.93",
            "CountryCode": "BR"
          },
          {
            "Area": "Mariupol",
            "Lat": "47.0962",
            "Long": "37.5562",
            "CountryCode": "UA"
          },
          {
            "Area": "Markala",
            "Lat": "13.6704",
            "Long": "-6.07",
            "CountryCode": "ML"
          },
          {
            "Area": "Maroua",
            "Lat": "10.5956",
            "Long": "14.3247",
            "CountryCode": "CM"
          },
          {
            "Area": "Marrakesh",
            "Lat": "31.63",
            "Long": "-8",
            "CountryCode": "MA"
          },
          {
            "Area": "Marsala",
            "Lat": "37.8054",
            "Long": "12.4387",
            "CountryCode": "IT"
          },
          {
            "Area": "Marseille",
            "Lat": "43.29",
            "Long": "5.375",
            "CountryCode": "FR"
          },
          {
            "Area": "Martapura",
            "Lat": "-3.4135",
            "Long": "114.8365",
            "CountryCode": "ID"
          },
          {
            "Area": "Marv Dasht",
            "Lat": "29.8014",
            "Long": "52.8215",
            "CountryCode": "IR"
          },
          {
            "Area": "Mary",
            "Lat": "37.6",
            "Long": "61.8333",
            "CountryCode": "TM"
          },
          {
            "Area": "Marysville",
            "Lat": "48.0809",
            "Long": "-122.1558",
            "CountryCode": "US"
          },
          {
            "Area": "Marzuq",
            "Lat": "25.9044",
            "Long": "13.8972",
            "CountryCode": "LY"
          },
          {
            "Area": "Masaka",
            "Lat": "-0.3296",
            "Long": "31.73",
            "CountryCode": "UG"
          },
          {
            "Area": "Masaya",
            "Lat": "11.969",
            "Long": "-86.095",
            "CountryCode": "NI"
          },
          {
            "Area": "Mascara",
            "Lat": "35.4004",
            "Long": "0.14",
            "CountryCode": "DZ"
          },
          {
            "Area": "Maseru",
            "Lat": "-29.3167",
            "Long": "27.4833",
            "CountryCode": "LS"
          },
          {
            "Area": "Mashhad",
            "Lat": "36.27",
            "Long": "59.57",
            "CountryCode": "IR"
          },
          {
            "Area": "Masjed Soleyman",
            "Lat": "31.98",
            "Long": "49.2999",
            "CountryCode": "IR"
          },
          {
            "Area": "Massawa",
            "Lat": "15.6101",
            "Long": "39.45",
            "CountryCode": "ER"
          },
          {
            "Area": "Masvingo",
            "Lat": "-20.0596",
            "Long": "30.82",
            "CountryCode": "ZW"
          },
          {
            "Area": "Matadi",
            "Lat": "-5.8166",
            "Long": "13.45",
            "CountryCode": "CD"
          },
          {
            "Area": "Matagalpa",
            "Lat": "12.9171",
            "Long": "-85.9167",
            "CountryCode": "NI"
          },
          {
            "Area": "Matamoros",
            "Lat": "25.88",
            "Long": "-97.5",
            "CountryCode": "MX"
          },
          {
            "Area": "Matanzas",
            "Lat": "23.0415",
            "Long": "-81.5775",
            "CountryCode": "CU"
          },
          {
            "Area": "Matara",
            "Lat": "5.949",
            "Long": "80.5428",
            "CountryCode": "LK"
          },
          {
            "Area": "Mataram",
            "Lat": "-8.5795",
            "Long": "116.135",
            "CountryCode": "ID"
          },
          {
            "Area": "Mataró",
            "Lat": "41.54",
            "Long": "2.45",
            "CountryCode": "ES"
          },
          {
            "Area": "Matehuala",
            "Lat": "23.6604",
            "Long": "-100.65",
            "CountryCode": "MX"
          },
          {
            "Area": "Matola",
            "Lat": "-25.9696",
            "Long": "32.46",
            "CountryCode": "MZ"
          },
          {
            "Area": "Matruh",
            "Lat": "31.3504",
            "Long": "27.23",
            "CountryCode": "EG"
          },
          {
            "Area": "Matsue",
            "Lat": "35.467",
            "Long": "133.0666",
            "CountryCode": "JP"
          },
          {
            "Area": "Matsumoto",
            "Lat": "36.2404",
            "Long": "137.97",
            "CountryCode": "JP"
          },
          {
            "Area": "Matsuyama",
            "Lat": "33.8455",
            "Long": "132.7658",
            "CountryCode": "JP"
          },
          {
            "Area": "Maturín",
            "Lat": "9.75",
            "Long": "-63.17",
            "CountryCode": "VE"
          },
          {
            "Area": "Mauldin",
            "Lat": "34.7864",
            "Long": "-82.2996",
            "CountryCode": "US"
          },
          {
            "Area": "Maumere",
            "Lat": "-8.6189",
            "Long": "122.2123",
            "CountryCode": "ID"
          },
          {
            "Area": "Mawlamyine",
            "Lat": "16.5004",
            "Long": "97.67",
            "CountryCode": "MM"
          },
          {
            "Area": "Maxixe",
            "Lat": "-23.866",
            "Long": "35.3886",
            "CountryCode": "MZ"
          },
          {
            "Area": "May Pen",
            "Lat": "17.9666",
            "Long": "-77.2333",
            "CountryCode": "JM"
          },
          {
            "Area": "Maykop",
            "Lat": "44.61",
            "Long": "40.12",
            "CountryCode": "RU"
          },
          {
            "Area": "Mazabuka",
            "Lat": "-15.86",
            "Long": "27.76",
            "CountryCode": "ZM"
          },
          {
            "Area": "Mazar-e Sharif",
            "Lat": "36.7",
            "Long": "67.1",
            "CountryCode": "AF"
          },
          {
            "Area": "Mazatenango",
            "Lat": "14.5304",
            "Long": "-91.51",
            "CountryCode": "GT"
          },
          {
            "Area": "Mazatlán",
            "Lat": "29.0171",
            "Long": "-110.1333",
            "CountryCode": "MX"
          },
          {
            "Area": "Mazatlán",
            "Lat": "23.2211",
            "Long": "-106.42",
            "CountryCode": "MX"
          },
          {
            "Area": "Mazyr",
            "Lat": "52.046",
            "Long": "29.2722",
            "CountryCode": "BY"
          },
          {
            "Area": "Mbabane",
            "Lat": "-26.3167",
            "Long": "31.1333",
            "CountryCode": "SZ"
          },
          {
            "Area": "Mbaïki",
            "Lat": "3.8704",
            "Long": "18",
            "CountryCode": "CF"
          },
          {
            "Area": "Mbale",
            "Lat": "1.0904",
            "Long": "34.17",
            "CountryCode": "UG"
          },
          {
            "Area": "Mbalmayo",
            "Lat": "3.5204",
            "Long": "11.5",
            "CountryCode": "CM"
          },
          {
            "Area": "Mbandaka",
            "Lat": "0.04",
            "Long": "18.26",
            "CountryCode": "CD"
          },
          {
            "Area": "Mbanza-Congo",
            "Lat": "-6.2696",
            "Long": "14.24",
            "CountryCode": "AO"
          },
          {
            "Area": "Mbanza-Ngungu",
            "Lat": "-5.2496",
            "Long": "14.86",
            "CountryCode": "CD"
          },
          {
            "Area": "Mbarara",
            "Lat": "-0.5996",
            "Long": "30.65",
            "CountryCode": "UG"
          },
          {
            "Area": "Mbeya",
            "Lat": "-8.89",
            "Long": "33.43",
            "CountryCode": "TZ"
          },
          {
            "Area": "Mbuji-Mayi",
            "Lat": "-6.15",
            "Long": "23.6",
            "CountryCode": "CD"
          },
          {
            "Area": "McAllen",
            "Lat": "26.2325",
            "Long": "-98.2467",
            "CountryCode": "US"
          },
          {
            "Area": "McKinney",
            "Lat": "33.2016",
            "Long": "-96.6669",
            "CountryCode": "US"
          },
          {
            "Area": "Medan",
            "Lat": "3.58",
            "Long": "98.65",
            "CountryCode": "ID"
          },
          {
            "Area": "Medani",
            "Lat": "14.4",
            "Long": "33.52",
            "CountryCode": "SD"
          },
          {
            "Area": "Médéa",
            "Lat": "36.2704",
            "Long": "2.77",
            "CountryCode": "DZ"
          },
          {
            "Area": "Medellín",
            "Lat": "6.275",
            "Long": "-75.575",
            "CountryCode": "CO"
          },
          {
            "Area": "Medenine",
            "Lat": "33.4",
            "Long": "10.4167",
            "CountryCode": "TN"
          },
          {
            "Area": "Medford",
            "Lat": "42.3372",
            "Long": "-122.8537",
            "CountryCode": "US"
          },
          {
            "Area": "Medford",
            "Lat": "42.4234",
            "Long": "-71.1087",
            "CountryCode": "US"
          },
          {
            "Area": "Medicine Hat",
            "Lat": "50.0333",
            "Long": "-110.6833",
            "CountryCode": "CA"
          },
          {
            "Area": "Medina",
            "Lat": "24.5",
            "Long": "39.58",
            "CountryCode": "SA"
          },
          {
            "Area": "Meiganga",
            "Lat": "6.5205",
            "Long": "14.29",
            "CountryCode": "CM"
          },
          {
            "Area": "Meizhou",
            "Lat": "24.3005",
            "Long": "116.12",
            "CountryCode": "CN"
          },
          {
            "Area": "Mekele",
            "Lat": "13.5",
            "Long": "39.47",
            "CountryCode": "ET"
          },
          {
            "Area": "Meknes",
            "Lat": "33.9004",
            "Long": "-5.56",
            "CountryCode": "MA"
          },
          {
            "Area": "Melbourne",
            "Lat": "-37.82",
            "Long": "144.975",
            "CountryCode": "AU"
          },
          {
            "Area": "Melbourne",
            "Lat": "28.1084",
            "Long": "-80.6628",
            "CountryCode": "US"
          },
          {
            "Area": "Melilla",
            "Lat": "35.3",
            "Long": "-2.95",
            "CountryCode": "ES"
          },
          {
            "Area": "Melitopol",
            "Lat": "46.8378",
            "Long": "35.3775",
            "CountryCode": "UA"
          },
          {
            "Area": "Melo",
            "Lat": "-32.3595",
            "Long": "-54.18",
            "CountryCode": "UY"
          },
          {
            "Area": "Melun",
            "Lat": "48.5333",
            "Long": "2.6666",
            "CountryCode": "FR"
          },
          {
            "Area": "Memphis",
            "Lat": "35.1047",
            "Long": "-89.9773",
            "CountryCode": "US"
          },
          {
            "Area": "Mendefera",
            "Lat": "14.886",
            "Long": "38.8163",
            "CountryCode": "ER"
          },
          {
            "Area": "Mendoza",
            "Lat": "-32.8833",
            "Long": "-68.8166",
            "CountryCode": "AR"
          },
          {
            "Area": "Mengzi",
            "Lat": "23.3619",
            "Long": "103.4061",
            "CountryCode": "CN"
          },
          {
            "Area": "Menifee",
            "Lat": "33.6909",
            "Long": "-117.1849",
            "CountryCode": "US"
          },
          {
            "Area": "Merced",
            "Lat": "37.3058",
            "Long": "-120.4778",
            "CountryCode": "US"
          },
          {
            "Area": "Mercedes",
            "Lat": "-34.66",
            "Long": "-59.44",
            "CountryCode": "AR"
          },
          {
            "Area": "Merida",
            "Lat": "8.4",
            "Long": "-71.13",
            "CountryCode": "VE"
          },
          {
            "Area": "Mérida",
            "Lat": "20.9666",
            "Long": "-89.6166",
            "CountryCode": "MX"
          },
          {
            "Area": "Mérida",
            "Lat": "38.912",
            "Long": "-6.338",
            "CountryCode": "ES"
          },
          {
            "Area": "Meriden",
            "Lat": "41.5367",
            "Long": "-72.7943",
            "CountryCode": "US"
          },
          {
            "Area": "Meridian",
            "Lat": "43.6113",
            "Long": "-116.3972",
            "CountryCode": "US"
          },
          {
            "Area": "Mesa",
            "Lat": "33.4017",
            "Long": "-111.7181",
            "CountryCode": "US"
          },
          {
            "Area": "Mesquite",
            "Lat": "32.7622",
            "Long": "-96.5889",
            "CountryCode": "US"
          },
          {
            "Area": "Messina",
            "Lat": "38.2005",
            "Long": "15.55",
            "CountryCode": "IT"
          },
          {
            "Area": "Methuen",
            "Lat": "42.734",
            "Long": "-71.1889",
            "CountryCode": "US"
          },
          {
            "Area": "Metz",
            "Lat": "49.1203",
            "Long": "6.18",
            "CountryCode": "FR"
          },
          {
            "Area": "Mexicali",
            "Lat": "32.65",
            "Long": "-115.48",
            "CountryCode": "MX"
          },
          {
            "Area": "MX City",
            "Lat": "19.4424",
            "Long": "-99.131",
            "CountryCode": "MX"
          },
          {
            "Area": "Meymaneh",
            "Lat": "35.9302",
            "Long": "64.7701",
            "CountryCode": "AF"
          },
          {
            "Area": "Miami",
            "Lat": "25.784",
            "Long": "-80.2102",
            "CountryCode": "US"
          },
          {
            "Area": "Miami Beach",
            "Lat": "25.8171",
            "Long": "-80.1396",
            "CountryCode": "US"
          },
          {
            "Area": "Miami Gardens",
            "Lat": "25.9433",
            "Long": "-80.2425",
            "CountryCode": "US"
          },
          {
            "Area": "Mianyang",
            "Lat": "31.47",
            "Long": "104.77",
            "CountryCode": "CN"
          },
          {
            "Area": "Miaoli",
            "Lat": "24.57",
            "Long": "120.82",
            "CountryCode": "TW"
          },
          {
            "Area": "Miass",
            "Lat": "54.9954",
            "Long": "60.0949",
            "CountryCode": "RU"
          },
          {
            "Area": "Michigan City",
            "Lat": "41.7098",
            "Long": "-86.8705",
            "CountryCode": "US"
          },
          {
            "Area": "Michurinsk",
            "Lat": "52.9",
            "Long": "40.5",
            "CountryCode": "RU"
          },
          {
            "Area": "Middelburg",
            "Lat": "-25.7596",
            "Long": "29.47",
            "CountryCode": "ZA"
          },
          {
            "Area": "Middlesbrough",
            "Lat": "54.5804",
            "Long": "-1.23",
            "CountryCode": "GB"
          },
          {
            "Area": "Middletown",
            "Lat": "39.5032",
            "Long": "-84.3659",
            "CountryCode": "US"
          },
          {
            "Area": "Middletown",
            "Lat": "41.4458",
            "Long": "-74.4228",
            "CountryCode": "US"
          },
          {
            "Area": "Midland",
            "Lat": "32.0249",
            "Long": "-102.1137",
            "CountryCode": "US"
          },
          {
            "Area": "Midland",
            "Lat": "43.6239",
            "Long": "-84.2315",
            "CountryCode": "US"
          },
          {
            "Area": "Midwest City",
            "Lat": "35.463",
            "Long": "-97.371",
            "CountryCode": "US"
          },
          {
            "Area": "Mikhaylovka",
            "Lat": "50.0679",
            "Long": "43.2175",
            "CountryCode": "RU"
          },
          {
            "Area": "Milagro",
            "Lat": "-2.1796",
            "Long": "-79.6",
            "CountryCode": "EC"
          },
          {
            "Area": "Milan",
            "Lat": "45.47",
            "Long": "9.205",
            "CountryCode": "IT"
          },
          {
            "Area": "Millcreek",
            "Lat": "40.6892",
            "Long": "-111.8291",
            "CountryCode": "US"
          },
          {
            "Area": "Milpitas",
            "Lat": "37.4338",
            "Long": "-121.8921",
            "CountryCode": "US"
          },
          {
            "Area": "Milwaukee",
            "Lat": "43.064",
            "Long": "-87.9669",
            "CountryCode": "US"
          },
          {
            "Area": "Minatitlán",
            "Lat": "17.9805",
            "Long": "-94.53",
            "CountryCode": "MX"
          },
          {
            "Area": "Mindelo",
            "Lat": "16.8838",
            "Long": "-25",
            "CountryCode": "CV"
          },
          {
            "Area": "Minna",
            "Lat": "9.62",
            "Long": "6.55",
            "CountryCode": "NG"
          },
          {
            "Area": "Minneapolis",
            "Lat": "44.9635",
            "Long": "-93.2678",
            "CountryCode": "US"
          },
          {
            "Area": "Minnetonka",
            "Lat": "44.9332",
            "Long": "-93.4617",
            "CountryCode": "US"
          },
          {
            "Area": "Minsk",
            "Lat": "53.9",
            "Long": "27.5666",
            "CountryCode": "BY"
          },
          {
            "Area": "Minxian",
            "Lat": "34.4362",
            "Long": "104.0306",
            "CountryCode": "CN"
          },
          {
            "Area": "Miramar",
            "Lat": "25.9773",
            "Long": "-80.3358",
            "CountryCode": "US"
          },
          {
            "Area": "Miri",
            "Lat": "4.3999",
            "Long": "113.9845",
            "CountryCode": "MY"
          },
          {
            "Area": "Mirput Khas",
            "Lat": "25.5318",
            "Long": "69.0118",
            "CountryCode": "PK"
          },
          {
            "Area": "Mishan",
            "Lat": "45.5504",
            "Long": "131.88",
            "CountryCode": "CN"
          },
          {
            "Area": "Miskolc",
            "Lat": "48.1004",
            "Long": "20.78",
            "CountryCode": "HU"
          },
          {
            "Area": "Misratah",
            "Lat": "32.38",
            "Long": "15.1",
            "CountryCode": "LY"
          },
          {
            "Area": "Mission",
            "Lat": "26.204",
            "Long": "-98.3251",
            "CountryCode": "US"
          },
          {
            "Area": "Mission Viejo",
            "Lat": "33.6095",
            "Long": "-117.6551",
            "CountryCode": "US"
          },
          {
            "Area": "Missoula",
            "Lat": "46.8685",
            "Long": "-114.0094",
            "CountryCode": "US"
          },
          {
            "Area": "Missouri City",
            "Lat": "29.5635",
            "Long": "-95.5377",
            "CountryCode": "US"
          },
          {
            "Area": "Mito",
            "Lat": "36.3704",
            "Long": "140.48",
            "CountryCode": "JP"
          },
          {
            "Area": "Miyazaki",
            "Lat": "31.9182",
            "Long": "131.4184",
            "CountryCode": "JP"
          },
          {
            "Area": "Mmabatho",
            "Lat": "-25.83",
            "Long": "25.61",
            "CountryCode": "ZA"
          },
          {
            "Area": "Moanda",
            "Lat": "-5.9229",
            "Long": "12.355",
            "CountryCode": "CD"
          },
          {
            "Area": "Mobile",
            "Lat": "30.6783",
            "Long": "-88.1162",
            "CountryCode": "US"
          },
          {
            "Area": "Moca",
            "Lat": "19.397",
            "Long": "-70.523",
            "CountryCode": "DO"
          },
          {
            "Area": "Mocambique",
            "Lat": "-15.0399",
            "Long": "40.6822",
            "CountryCode": "MZ"
          },
          {
            "Area": "MoCU",
            "Lat": "-16.8496",
            "Long": "38.26",
            "CountryCode": "MZ"
          },
          {
            "Area": "Modena",
            "Lat": "44.65",
            "Long": "10.92",
            "CountryCode": "IT"
          },
          {
            "Area": "Modesto",
            "Lat": "37.6374",
            "Long": "-121.0028",
            "CountryCode": "US"
          },
          {
            "Area": "Mogadishu",
            "Lat": "2.0667",
            "Long": "45.3667",
            "CountryCode": "SO"
          },
          {
            "Area": "Mojokerto",
            "Lat": "-7.4696",
            "Long": "112.43",
            "CountryCode": "ID"
          },
          {
            "Area": "Mokpo",
            "Lat": "34.8068",
            "Long": "126.3958",
            "CountryCode": "kr"
          },
          {
            "Area": "Molepolole",
            "Lat": "-24.4",
            "Long": "25.51",
            "CountryCode": "BW"
          },
          {
            "Area": "Mombasa",
            "Lat": "-4.04",
            "Long": "39.6899",
            "CountryCode": "KE"
          },
          {
            "Area": "Monastir",
            "Lat": "35.7307",
            "Long": "10.7673",
            "CountryCode": "TN"
          },
          {
            "Area": "Monclova",
            "Lat": "26.9",
            "Long": "-101.42",
            "CountryCode": "MX"
          },
          {
            "Area": "Moncton",
            "Lat": "46.0833",
            "Long": "-64.7667",
            "CountryCode": "CA"
          },
          {
            "Area": "Monessen",
            "Lat": "40.1519",
            "Long": "-79.8828",
            "CountryCode": "US"
          },
          {
            "Area": "Mongu",
            "Lat": "-15.2796",
            "Long": "23.12",
            "CountryCode": "ZM"
          },
          {
            "Area": "Monroe",
            "Lat": "32.5184",
            "Long": "-92.0774",
            "CountryCode": "US"
          },
          {
            "Area": "Monrovia",
            "Lat": "6.3106",
            "Long": "-10.8048",
            "CountryCode": "LR"
          },
          {
            "Area": "Mons",
            "Lat": "50.446",
            "Long": "3.939",
            "CountryCode": "BE"
          },
          {
            "Area": "Montebello",
            "Lat": "34.0155",
            "Long": "-118.1108",
            "CountryCode": "US"
          },
          {
            "Area": "Montego Bay",
            "Lat": "18.4667",
            "Long": "-77.9167",
            "CountryCode": "JM"
          },
          {
            "Area": "Montepuez",
            "Lat": "-13.1196",
            "Long": "39",
            "CountryCode": "MZ"
          },
          {
            "Area": "Monterey Park",
            "Lat": "34.0497",
            "Long": "-118.1325",
            "CountryCode": "US"
          },
          {
            "Area": "Montería",
            "Lat": "8.7575",
            "Long": "-75.89",
            "CountryCode": "CO"
          },
          {
            "Area": "Montero",
            "Lat": "-17.3496",
            "Long": "-63.26",
            "CountryCode": "BO"
          },
          {
            "Area": "Monterrey",
            "Lat": "25.67",
            "Long": "-100.33",
            "CountryCode": "MX"
          },
          {
            "Area": "Montes Claros",
            "Lat": "-16.72",
            "Long": "-43.86",
            "CountryCode": "BR"
          },
          {
            "Area": "Montevideo",
            "Lat": "-34.858",
            "Long": "-56.1711",
            "CountryCode": "UY"
          },
          {
            "Area": "Montgomery",
            "Lat": "32.347",
            "Long": "-86.2663",
            "CountryCode": "US"
          },
          {
            "Area": "Montpellier",
            "Lat": "43.6104",
            "Long": "3.87",
            "CountryCode": "FR"
          },
          {
            "Area": "Montréal",
            "Lat": "45.5",
            "Long": "-73.5833",
            "CountryCode": "CA"
          },
          {
            "Area": "Monywa",
            "Lat": "22.105",
            "Long": "95.15",
            "CountryCode": "MM"
          },
          {
            "Area": "Moore",
            "Lat": "35.3294",
            "Long": "-97.4758",
            "CountryCode": "US"
          },
          {
            "Area": "Mopti",
            "Lat": "14.49",
            "Long": "-4.18",
            "CountryCode": "ML"
          },
          {
            "Area": "Moquegua",
            "Lat": "-17.19",
            "Long": "-70.94",
            "CountryCode": "PE"
          },
          {
            "Area": "Moratuwa",
            "Lat": "6.7804",
            "Long": "79.88",
            "CountryCode": "LK"
          },
          {
            "Area": "Morelia",
            "Lat": "19.7334",
            "Long": "-101.1895",
            "CountryCode": "MX"
          },
          {
            "Area": "Moreno Valley",
            "Lat": "33.9244",
            "Long": "-117.2045",
            "CountryCode": "US"
          },
          {
            "Area": "Morgantown",
            "Lat": "39.638",
            "Long": "-79.9468",
            "CountryCode": "US"
          },
          {
            "Area": "Morioka",
            "Lat": "39.72",
            "Long": "141.13",
            "CountryCode": "JP"
          },
          {
            "Area": "Morogoro",
            "Lat": "-6.82",
            "Long": "37.66",
            "CountryCode": "TZ"
          },
          {
            "Area": "Morón",
            "Lat": "22.1099",
            "Long": "-78.6275",
            "CountryCode": "CU"
          },
          {
            "Area": "Moroni",
            "Lat": "-11.7042",
            "Long": "43.2402",
            "CountryCode": "KM"
          },
          {
            "Area": "Morristown",
            "Lat": "36.2043",
            "Long": "-83.3001",
            "CountryCode": "US"
          },
          {
            "Area": "Moscow",
            "Lat": "55.7522",
            "Long": "37.6155",
            "CountryCode": "RU"
          },
          {
            "Area": "Moshi",
            "Lat": "-3.3396",
            "Long": "37.34",
            "CountryCode": "TZ"
          },
          {
            "Area": "Mossoró",
            "Lat": "-5.19",
            "Long": "-37.34",
            "CountryCode": "BR"
          },
          {
            "Area": "Mostaganem",
            "Lat": "35.9404",
            "Long": "0.09",
            "CountryCode": "DZ"
          },
          {
            "Area": "Mostar",
            "Lat": "43.3505",
            "Long": "17.82",
            "CountryCode": "BA"
          },
          {
            "Area": "Mosul",
            "Lat": "36.345",
            "Long": "43.145",
            "CountryCode": "IQ"
          },
          {
            "Area": "Moundou",
            "Lat": "8.55",
            "Long": "16.09",
            "CountryCode": "TD"
          },
          {
            "Area": "Mount Pleasant",
            "Lat": "32.8533",
            "Long": "-79.8269",
            "CountryCode": "US"
          },
          {
            "Area": "Mount Prospect",
            "Lat": "42.0653",
            "Long": "-87.937",
            "CountryCode": "US"
          },
          {
            "Area": "Mount Vernon",
            "Lat": "48.4202",
            "Long": "-122.3116",
            "CountryCode": "US"
          },
          {
            "Area": "Mount Vernon",
            "Lat": "40.9136",
            "Long": "-73.8291",
            "CountryCode": "US"
          },
          {
            "Area": "Mountain View",
            "Lat": "37.4",
            "Long": "-122.0796",
            "CountryCode": "US"
          },
          {
            "Area": "Mpanda",
            "Lat": "-6.3596",
            "Long": "31.05",
            "CountryCode": "TZ"
          },
          {
            "Area": "Mt. Hagen",
            "Lat": "-5.8632",
            "Long": "144.2168",
            "CountryCode": "PG"
          },
          {
            "Area": "Mtwara",
            "Lat": "-10.2696",
            "Long": "40.19",
            "CountryCode": "TZ"
          },
          {
            "Area": "Muar",
            "Lat": "2.0337",
            "Long": "102.5666",
            "CountryCode": "MY"
          },
          {
            "Area": "Mubi",
            "Lat": "10.2703",
            "Long": "13.27",
            "CountryCode": "NG"
          },
          {
            "Area": "Mudangiang",
            "Lat": "44.575",
            "Long": "129.59",
            "CountryCode": "CN"
          },
          {
            "Area": "Mudon",
            "Lat": "16.2618",
            "Long": "97.7215",
            "CountryCode": "MM"
          },
          {
            "Area": "Mufulira",
            "Lat": "-12.55",
            "Long": "28.26",
            "CountryCode": "ZM"
          },
          {
            "Area": "Mulhouse",
            "Lat": "47.7504",
            "Long": "7.35",
            "CountryCode": "FR"
          },
          {
            "Area": "Multan",
            "Lat": "30.2",
            "Long": "71.455",
            "CountryCode": "PK"
          },
          {
            "Area": "Munchon",
            "Lat": "39.3813",
            "Long": "127.2517",
            "CountryCode": "KP"
          },
          {
            "Area": "Muncie",
            "Lat": "40.1989",
            "Long": "-85.395",
            "CountryCode": "US"
          },
          {
            "Area": "Munich",
            "Lat": "48.1299",
            "Long": "11.575",
            "CountryCode": "DE"
          },
          {
            "Area": "Münster",
            "Lat": "51.9704",
            "Long": "7.62",
            "CountryCode": "DE"
          },
          {
            "Area": "Murcia",
            "Lat": "37.98",
            "Long": "-1.13",
            "CountryCode": "ES"
          },
          {
            "Area": "Murfreesboro",
            "Lat": "35.8493",
            "Long": "-86.4098",
            "CountryCode": "US"
          },
          {
            "Area": "Muriaé",
            "Lat": "-21.13",
            "Long": "-42.39",
            "CountryCode": "BR"
          },
          {
            "Area": "Murmansk",
            "Lat": "68.97",
            "Long": "33.1",
            "CountryCode": "RU"
          },
          {
            "Area": "Murom",
            "Lat": "55.5704",
            "Long": "42.04",
            "CountryCode": "RU"
          },
          {
            "Area": "Muroran",
            "Lat": "42.35",
            "Long": "140.98",
            "CountryCode": "JP"
          },
          {
            "Area": "Murrieta",
            "Lat": "33.5719",
            "Long": "-117.1909",
            "CountryCode": "US"
          },
          {
            "Area": "Muş",
            "Lat": "38.749",
            "Long": "41.4969",
            "CountryCode": "TR"
          },
          {
            "Area": "Musan",
            "Lat": "42.2304",
            "Long": "129.2304",
            "CountryCode": "KP"
          },
          {
            "Area": "Muscat",
            "Lat": "23.6133",
            "Long": "58.5933",
            "CountryCode": "OM"
          },
          {
            "Area": "Muskegon",
            "Lat": "43.2281",
            "Long": "-86.2562",
            "CountryCode": "US"
          },
          {
            "Area": "Musoma",
            "Lat": "-1.4896",
            "Long": "33.8",
            "CountryCode": "TZ"
          },
          {
            "Area": "Mutare",
            "Lat": "-18.97",
            "Long": "32.65",
            "CountryCode": "ZW"
          },
          {
            "Area": "Muyinga",
            "Lat": "-2.8523",
            "Long": "30.3173",
            "CountryCode": "BI"
          },
          {
            "Area": "Mwanza",
            "Lat": "-2.52",
            "Long": "32.93",
            "CountryCode": "TZ"
          },
          {
            "Area": "Mweka",
            "Lat": "-4.8396",
            "Long": "21.57",
            "CountryCode": "CD"
          },
          {
            "Area": "Mwene-Ditu",
            "Lat": "-7",
            "Long": "23.44",
            "CountryCode": "CD"
          },
          {
            "Area": "Mỹ Tho",
            "Lat": "10.3504",
            "Long": "106.35",
            "CountryCode": "VN"
          },
          {
            "Area": "Myeik",
            "Lat": "12.4541",
            "Long": "98.6115",
            "CountryCode": "MM"
          },
          {
            "Area": "Myingyan",
            "Lat": "21.4618",
            "Long": "95.3914",
            "CountryCode": "MM"
          },
          {
            "Area": "Myitkyina",
            "Lat": "25.3596",
            "Long": "97.3928",
            "CountryCode": "MM"
          },
          {
            "Area": "Mykolayiv",
            "Lat": "46.9677",
            "Long": "31.9843",
            "CountryCode": "UA"
          },
          {
            "Area": "Mymensingh",
            "Lat": "24.7504",
            "Long": "90.38",
            "CountryCode": "BD"
          },
          {
            "Area": "Myrtle Beach",
            "Lat": "33.7096",
            "Long": "-78.8843",
            "CountryCode": "US"
          },
          {
            "Area": "Mzuzu",
            "Lat": "-11.46",
            "Long": "34.02",
            "CountryCode": "MW"
          },
            {
              "Area": "N.c.pukur",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.8848,
              "Long": 88.3469
            },
            {
              "Area": "N.p. Kunta",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 14.2256,
              "Long": 78.4369
            },
            {
              "Area": "N.solapur",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 18.1742,
              "Long": 76.4093
            },
            {
              "Area": "NAGARAM",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 18.146,
              "Long": 79.2386
            },
            {
              "Area": "NEIGRIHMS S.O",
              "State": "Meghalaya",
              "CountryCode": "IN",
              "Lat": 25.5378,
              "Long": 91.8754
            },
            {
              "Area": "Naahata",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.4653,
              "Long": 88.7803
            },
            {
              "Area": "Nabadwip",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 23.601,
              "Long": 88.1273
            },
            {
              "Area": "Nabadwip Municipality",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 23.601,
              "Long": 88.1273
            },
            {
              "Area": "Nabagram",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 24.7341,
              "Long": 88.12
            },
            {
              "Area": "Nabarangapur",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 19.5827,
              "Long": 82.6459
            },
            {
              "Area": "Nabarangour",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 19.5827,
              "Long": 82.7452
            },
            {
              "Area": "Nabarangpu",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 19.1357,
              "Long": 82.6013
            },
            {
              "Area": "Nabarangpur",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 20.2342,
              "Long": 83.6944
            },
            {
              "Area": "Nabarngpur",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 18.755,
              "Long": 82.4239
            },
            {
              "Area": "Nabha",
              "State": "Punjab",
              "CountryCode": "IN",
              "Lat": 30.5349,
              "Long": 76.3221
            },
            {
              "Area": "Nabhid",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 20.6284,
              "Long": 79.6165
            },
            {
              "Area": "Nabi Nagar",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 24.5627,
              "Long": 84.5953
            },
            {
              "Area": "Nabinagar",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 24.9835,
              "Long": 84.5953
            },
            {
              "Area": "Nabincherra",
              "State": "Tripura",
              "CountryCode": "IN",
              "Lat": 24.1597,
              "Long": 92.0329
            },
            {
              "Area": "Nachhipur",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.4364,
              "Long": 87.9624
            },
            {
              "Area": "Nachinda",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 24.3444,
              "Long": 87.9089
            },
            {
              "Area": "Nacho",
              "State": "Arunachal Pradesh",
              "CountryCode": "IN",
              "Lat": 27.9911,
              "Long": 94.2295
            },
            {
              "Area": "Nachulwa",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 26.6344,
              "Long": 82.4733
            },
            {
              "Area": "Nadanghat",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 23.3392,
              "Long": 88.3583
            },
            {
              "Area": "Nadaun",
              "State": "Himachal Pradesh",
              "CountryCode": "IN",
              "Lat": 32.348,
              "Long": 77.175
            },
            {
              "Area": "Nadaun(T)",
              "State": "Himachal Pradesh",
              "CountryCode": "IN",
              "Lat": 32.2773,
              "Long": 77.1649
            },
            {
              "Area": "Nadbai",
              "State": "Rajasthan",
              "CountryCode": "IN",
              "Lat": 27.2457,
              "Long": 77.2788
            },
            {
              "Area": "Nadendla",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.301,
              "Long": 80.2606
            },
            {
              "Area": "Nadiad",
              "State": "Gujarat",
              "CountryCode": "IN",
              "Lat": 23.9069,
              "Long": 73.5554
            },
            {
              "Area": "Nadod",
              "State": "Gujarat",
              "CountryCode": "IN",
              "Lat": 23.019,
              "Long": 73.6666
            },
            {
              "Area": "Nadoti",
              "State": "Rajasthan",
              "CountryCode": "IN",
              "Lat": 27.3634,
              "Long": 76.9639
            },
            {
              "Area": "Nafra",
              "State": "Arunachal Pradesh",
              "CountryCode": "IN",
              "Lat": 27.2895,
              "Long": 92.3982
            },
            {
              "Area": "Nagal",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 29.9496,
              "Long": 79.111
            },
            {
              "Area": "Nagal Katha",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.0799,
              "Long": 76.0612
            },
            {
              "Area": "Nagam",
              "State": "Jammu & Kashmir",
              "CountryCode": "IN",
              "Lat": 33.89,
              "Long": 74.663
            },
            {
              "Area": "Nagamangala",
              "State": "Karnataka",
              "CountryCode": "IN",
              "Lat": 13.0026,
              "Long": 76.9193
            },
            {
              "Area": "Nagaon",
              "State": "Assam",
              "CountryCode": "IN",
              "Lat": 27.5467,
              "Long": 94.7206
            },
            {
              "Area": "Nagapattinam",
              "State": "Tamil Nadu",
              "CountryCode": "IN",
              "Lat": 11.0762,
              "Long": 79.8391
            },
            {
              "Area": "Nagar",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 19.0005,
              "Long": 75.8513
            },
            {
              "Area": "Nagar",
              "State": "Rajasthan",
              "CountryCode": "IN",
              "Lat": 27.6461,
              "Long": 77.2788
            },
            {
              "Area": "Nagar Utari",
              "State": "Jharkhand",
              "CountryCode": "IN",
              "Lat": 24.262,
              "Long": 84.1674
            },
            {
              "Area": "Nagaram",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 15.7114,
              "Long": 80.4916
            },
            {
              "Area": "Nagari",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 13.3406,
              "Long": 79.6174
            },
            {
              "Area": "Nagarkurnool",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 17.0926,
              "Long": 78.4585
            },
            {
              "Area": "Nagarnausa",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 25.4006,
              "Long": 85.5146
            },
            {
              "Area": "Nagaur",
              "State": "Rajasthan",
              "CountryCode": "IN",
              "Lat": 27.5407,
              "Long": 74.4696
            },
            {
              "Area": "Nagayalanka",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.4298,
              "Long": 80.9932
            },
            {
              "Area": "Nagbangshi",
              "State": "Tripura",
              "CountryCode": "IN",
              "Lat": 24.0789,
              "Long": 91.8987
            },
            {
              "Area": "Nagbhid",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 20.6763,
              "Long": 79.7201
            },
            {
              "Area": "Nagbhir",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 20.5139,
              "Long": 79.7309
            },
            {
              "Area": "Nagbhri",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 20.4895,
              "Long": 79.7426
            },
            {
              "Area": "Nagda",
              "State": "Madhya Pradesh",
              "CountryCode": "IN",
              "Lat": 23.9409,
              "Long": 76.9913
            },
            {
              "Area": "Naggar",
              "State": "Himachal Pradesh",
              "CountryCode": "IN",
              "Lat": 32.3143,
              "Long": 77.4002
            },
            {
              "Area": "Nagina",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 29.6349,
              "Long": 79.252
            },
            {
              "Area": "Nagina",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 27.9256,
              "Long": 77.0174
            },
            {
              "Area": "Naginimora",
              "State": "Nagaland",
              "CountryCode": "IN",
              "Lat": 26.8149,
              "Long": 94.8432
            },
            {
              "Area": "Nagir",
              "State": "Chattisgarh",
              "CountryCode": "IN",
              "Lat": 20.753,
              "Long": 81.6181
            },
            {
              "Area": "Nagod",
              "State": "Madhya Pradesh",
              "CountryCode": "IN",
              "Lat": 25.069,
              "Long": 81.0722
            },
            {
              "Area": "Nagon",
              "State": "Assam",
              "CountryCode": "IN",
              "Lat": 25.8862,
              "Long": 93.0109
            },
            {
              "Area": "Nagpur",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 21.1793,
              "Long": 79.3114
            },
            {
              "Area": "Nagpur (Rural)",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 20.9657,
              "Long": 79.0835
            },
            {
              "Area": "Nagpur (Urban)",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 21.1555,
              "Long": 79.0909
            },
            {
              "Area": "Nagpur Rural",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 21.1763,
              "Long": 79.0876
            },
            {
              "Area": "Nagra",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 25.9395,
              "Long": 85.0606
            },
            {
              "Area": "Nagrakata",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 26.8803,
              "Long": 89.0287
            },
            {
              "Area": "Nagri",
              "State": "Jharkhand",
              "CountryCode": "IN",
              "Lat": 23.3151,
              "Long": 85.2384
            },
            {
              "Area": "Nagri",
              "State": "Chattisgarh",
              "CountryCode": "IN",
              "Lat": 20.7447,
              "Long": 81.9966
            },
            {
              "Area": "Nagrijuli",
              "State": "Assam",
              "CountryCode": "IN",
              "Lat": 26.4408,
              "Long": 91.8873
            },
            {
              "Area": "Nagripada",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 23.5234,
              "Long": 87.6598
            },
            {
              "Area": "Nagshankar",
              "State": "Assam",
              "CountryCode": "IN",
              "Lat": 26.7887,
              "Long": 92.965
            },
            {
              "Area": "Nahan",
              "State": "Himachal Pradesh",
              "CountryCode": "IN",
              "Lat": 30.7407,
              "Long": 77.4603
            },
            {
              "Area": "Nahan(T)",
              "State": "Himachal Pradesh",
              "CountryCode": "IN",
              "Lat": 30.6089,
              "Long": 77.3475
            },
            {
              "Area": "Nahar",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.4102,
              "Long": 76.3981
            },
            {
              "Area": "Naharbari",
              "State": "Assam",
              "CountryCode": "IN",
              "Lat": 26.7887,
              "Long": 92.965
            },
            {
              "Area": "Nahariatia",
              "State": "Assam",
              "CountryCode": "IN",
              "Lat": 27.3779,
              "Long": 95.2828
            },
            {
              "Area": "Naharkatia",
              "State": "Assam",
              "CountryCode": "IN",
              "Lat": 27.3779,
              "Long": 95.3439
            },
            {
              "Area": "Naharlagun",
              "State": "Arunachal Pradesh",
              "CountryCode": "IN",
              "Lat": 27.1257,
              "Long": 93.7072
            },
            {
              "Area": "Naholia",
              "State": "Assam",
              "CountryCode": "IN",
              "Lat": 27.3011,
              "Long": 95.3439
            },
            {
              "Area": "Nai Sarak",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 26.5442,
              "Long": 80.1097
            },
            {
              "Area": "Naichana",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.1297,
              "Long": 76.5558
            },
            {
              "Area": "Naidiad",
              "State": "Gujarat",
              "CountryCode": "IN",
              "Lat": 23.0401,
              "Long": 73.0053
            },
            {
              "Area": "Naidupet",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 14.0329,
              "Long": 80.0596
            },
            {
              "Area": "Naidupeta",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 14.5423,
              "Long": 79.9815
            },
            {
              "Area": "Naigaon",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 19.116,
              "Long": 77.6241
            },
            {
              "Area": "Naigawan",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.1729,
              "Long": 76.1432
            },
            {
              "Area": "Naijibabad",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 29.5449,
              "Long": 78.0996
            },
            {
              "Area": "Naina Devi",
              "State": "Himachal Pradesh",
              "CountryCode": "IN",
              "Lat": 31.7634,
              "Long": 76.9362
            },
            {
              "Area": "Nainital",
              "State": "Uttarakhand",
              "CountryCode": "IN",
              "Lat": 29.7748,
              "Long": 79.7231
            },
            {
              "Area": "Nainpur",
              "State": "Madhya Pradesh",
              "CountryCode": "IN",
              "Lat": 22.6404,
              "Long": 80.5134
            },
            {
              "Area": "Naipur",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 23.8386,
              "Long": 88.171
            },
            {
              "Area": "Najibabad",
              "State": "Uttarakhand",
              "CountryCode": "IN",
              "Lat": 29.7962,
              "Long": 78.2582
            },
            {
              "Area": "Najibabad",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 29.7026,
              "Long": 78.4456
            },
            {
              "Area": "Nakashipara",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 24.5163,
              "Long": 88.5215
            },
            {
              "Area": "Nakhatrana",
              "State": "Gujarat",
              "CountryCode": "IN",
              "Lat": 23.6285,
              "Long": 69.9604
            },
            {
              "Area": "Nakkapalle",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 17.5811,
              "Long": 82.6338
            },
            {
              "Area": "Nakodar",
              "State": "Punjab",
              "CountryCode": "IN",
              "Lat": 31.531,
              "Long": 75.6371
            },
            {
              "Area": "Nakoder",
              "State": "Punjab",
              "CountryCode": "IN",
              "Lat": 31.1606,
              "Long": 75.5274
            },
            {
              "Area": "Nakpul",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 23.0762,
              "Long": 88.8272
            },
            {
              "Area": "Nakpul Kuchlia",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.8774,
              "Long": 88.7548
            },
            {
              "Area": "Nakrekal",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 17.3799,
              "Long": 79.4863
            },
            {
              "Area": "Naksha",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.7343,
              "Long": 88.5795
            },
            {
              "Area": "Naktideul",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 21.4519,
              "Long": 84.6548
            },
            {
              "Area": "Nakur",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 30.0892,
              "Long": 77.949
            },
            {
              "Area": "Nala",
              "State": "Jharkhand",
              "CountryCode": "IN",
              "Lat": 24.1674,
              "Long": 86.9669
            },
            {
              "Area": "Nalagarh",
              "State": "Himachal Pradesh",
              "CountryCode": "IN",
              "Lat": 31.0429,
              "Long": 76.9095
            },
            {
              "Area": "Nalbari",
              "State": "Assam",
              "CountryCode": "IN",
              "Lat": 26.5004,
              "Long": 91.4784
            },
            {
              "Area": "Nalgnda",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 17.5042,
              "Long": 78.9777
            },
            {
              "Area": "Nalgoda",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 17.447,
              "Long": 78.9232
            },
            {
              "Area": "Nalgodna",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 17.4023,
              "Long": 79.3745
            },
            {
              "Area": "Nalgolnda",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 17.1362,
              "Long": 78.7712
            },
            {
              "Area": "Nalgonda",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 18.1631,
              "Long": 80.1911
            },
            {
              "Area": "Nalhati - I",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 24.2653,
              "Long": 87.7712
            },
            {
              "Area": "Nalicherra",
              "State": "Tripura",
              "CountryCode": "IN",
              "Lat": 24.007,
              "Long": 91.6093
            },
            {
              "Area": "Nalkata",
              "State": "Tripura",
              "CountryCode": "IN",
              "Lat": 24.1597,
              "Long": 92.0329
            },
            {
              "Area": "Nalkheda",
              "State": "Madhya Pradesh",
              "CountryCode": "IN",
              "Lat": 24.0532,
              "Long": 76.7452
            },
            {
              "Area": "Nalkora",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.3687,
              "Long": 88.562
            },
            {
              "Area": "Nallabelli",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 18.2688,
              "Long": 79.6821
            },
            {
              "Area": "Nallacheruvu",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 14.0232,
              "Long": 78.187
            },
            {
              "Area": "Nallajarla Mandal",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.7717,
              "Long": 81.4423
            },
            {
              "Area": "Nallajarla Mandalam",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.9109,
              "Long": 81.4423
            },
            {
              "Area": "Nallajarlamandalam",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.9167,
              "Long": 81.4329
            },
            {
              "Area": "Nallajerla",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.9109,
              "Long": 81.4013
            },
            {
              "Area": "Nallajerla Mandal",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.9109,
              "Long": 81.4013
            },
            {
              "Area": "Nallajerla Mandalam",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.9475,
              "Long": 81.406
            },
            {
              "Area": "Nallajerlamandalam",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.9109,
              "Long": 81.4013
            },
            {
              "Area": "Nallamada",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 14.4811,
              "Long": 78.2141
            },
            {
              "Area": "Nallampalli",
              "State": "Tamil Nadu",
              "CountryCode": "IN",
              "Lat": 12.0575,
              "Long": 78.1492
            },
            {
              "Area": "Nallbelli",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 18.0544,
              "Long": 79.491
            },
            {
              "Area": "Nallikaddr",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 17.594,
              "Long": 79.8232
            },
            {
              "Area": "Nallikaddur",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 17.594,
              "Long": 79.8232
            },
            {
              "Area": "Nalognda",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 17.0694,
              "Long": 79.1157
            },
            {
              "Area": "Namakkal",
              "State": "Tamil Nadu",
              "CountryCode": "IN",
              "Lat": 11.6463,
              "Long": 78.5445
            },
            {
              "Area": "Namal",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.2758,
              "Long": 88.831
            },
            {
              "Area": "Namaldiha",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.4305,
              "Long": 87.4447
            },
            {
              "Area": "Nambal",
              "State": "Jammu & Kashmir",
              "CountryCode": "IN",
              "Lat": 34.3295,
              "Long": 74.3058
            },
            {
              "Area": "Nambol",
              "State": "Manipur",
              "CountryCode": "IN",
              "Lat": 24.6994,
              "Long": 93.8593
            },
            {
              "Area": "Namburu",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.3927,
              "Long": 80.5026
            },
            {
              "Area": "Namchi",
              "State": "Sikkim",
              "CountryCode": "IN",
              "Lat": 27.3424,
              "Long": 88.8438
            },
            {
              "Area": "Namdang",
              "State": "Arunachal Pradesh",
              "CountryCode": "IN",
              "Lat": 27.1318,
              "Long": 95.7349
            },
            {
              "Area": "Namkhana",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 23.8189,
              "Long": 88.4168
            },
            {
              "Area": "Namkum",
              "State": "Jharkhand",
              "CountryCode": "IN",
              "Lat": 23.3318,
              "Long": 85.4993
            },
            {
              "Area": "Nampally",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 17.4498,
              "Long": 78.5553
            },
            {
              "Area": "Nampong",
              "State": "Arunachal Pradesh",
              "CountryCode": "IN",
              "Lat": 27.3061,
              "Long": 96.106
            },
            {
              "Area": "Namrup",
              "State": "Assam",
              "CountryCode": "IN",
              "Lat": 27.1939,
              "Long": 95.3193
            },
            {
              "Area": "Namsai",
              "State": "Arunachal Pradesh",
              "CountryCode": "IN",
              "Lat": 27.8401,
              "Long": 96.1952
            },
            {
              "Area": "Namtok",
              "State": "Arunachal Pradesh",
              "CountryCode": "IN",
              "Lat": 27.1318,
              "Long": 95.7349
            },
            {
              "Area": "Nanadura",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 20.9279,
              "Long": 76.4767
            },
            {
              "Area": "Nanauta",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 29.9496,
              "Long": 77.9249
            },
            {
              "Area": "Nancorie",
              "State": "Andaman & Nicobar Islands",
              "CountryCode": "IN",
              "Lat": 9.1833,
              "Long": 92.7667
            },
            {
              "Area": "Nancowrie",
              "State": "Andaman & Nicobar Islands",
              "CountryCode": "IN",
              "Lat": 9.1833,
              "Long": 92.7667
            },
            {
              "Area": "Nand Rampurbas",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.1881,
              "Long": 76.754
            },
            {
              "Area": "Nandakumar",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 24.4536,
              "Long": 88.1922
            },
            {
              "Area": "Nandalur",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 14.4599,
              "Long": 79.2266
            },
            {
              "Area": "Nandapur",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 19.1214,
              "Long": 83.2667
            },
            {
              "Area": "Nandavaram",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 15.8533,
              "Long": 77.8355
            },
            {
              "Area": "Nanded",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 19.2271,
              "Long": 77.541
            },
            {
              "Area": "Nandgaon",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 20.6425,
              "Long": 74.909
            },
            {
              "Area": "Nandgaon Khandeshwar",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 20.6847,
              "Long": 77.8334
            },
            {
              "Area": "Nandghat",
              "State": "Chattisgarh",
              "CountryCode": "IN",
              "Lat": 21.9,
              "Long": 81.9045
            },
            {
              "Area": "Nandigam Mandal",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 18.6542,
              "Long": 84.3047
            },
            {
              "Area": "Nandigama",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.758,
              "Long": 80.8006
            },
            {
              "Area": "Nandigram",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 23.1832,
              "Long": 88.3792
            },
            {
              "Area": "Nandigram Ii",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.0208,
              "Long": 87.7744
            },
            {
              "Area": "Nandigram-i",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 23.1832,
              "Long": 88.2753
            },
            {
              "Area": "Nandigram-ii",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.8722,
              "Long": 88.3792
            },
            {
              "Area": "Nandigram-iii",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.9706,
              "Long": 88.0631
            },
            {
              "Area": "Nandikotkur",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 15.6486,
              "Long": 78.7634
            },
            {
              "Area": "Nandimandalam",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 14.4599,
              "Long": 79.0809
            },
            {
              "Area": "Nandipadu",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 14.8316,
              "Long": 79.7344
            },
            {
              "Area": "Nandivada",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 17.2226,
              "Long": 81.3678
            },
            {
              "Area": "Nandivelugu",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.2921,
              "Long": 80.6434
            },
            {
              "Area": "Nandod",
              "State": "Gujarat",
              "CountryCode": "IN",
              "Lat": 23.2244,
              "Long": 74.1551
            },
            {
              "Area": "Nandpora",
              "State": "Jammu & Kashmir",
              "CountryCode": "IN",
              "Lat": 33.4307,
              "Long": 74.8979
            },
            {
              "Area": "Nandura",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 20.9365,
              "Long": 76.48
            },
            {
              "Area": "Nandurbar",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 21.5497,
              "Long": 74.4269
            },
            {
              "Area": "Nandyal",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 15.6194,
              "Long": 78.884
            },
            {
              "Area": "Nandyal .",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 15.3998,
              "Long": 78.4079
            },
            {
              "Area": "Nangal",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.3378,
              "Long": 76.408
            },
            {
              "Area": "Nangal Dargu",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 29.3043,
              "Long": 77.0492
            },
            {
              "Area": "Nangal Jamalpur",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.1673,
              "Long": 76.4131
            },
            {
              "Area": "Nangal Pathani",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.3602,
              "Long": 76.4977
            },
            {
              "Area": "Nangal Sirohi",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.1904,
              "Long": 76.1312
            },
            {
              "Area": "Nangal Teju",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.0182,
              "Long": 76.5628
            },
            {
              "Area": "Nangalmala",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.3955,
              "Long": 75.9426
            },
            {
              "Area": "Nangli Godha",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.1666,
              "Long": 76.5505
            },
            {
              "Area": "Nanguneri",
              "State": "Tamil Nadu",
              "CountryCode": "IN",
              "Lat": 8.7987,
              "Long": 77.9478
            },
            {
              "Area": "Nangwalbibra",
              "State": "Meghalaya",
              "CountryCode": "IN",
              "Lat": 25.5545,
              "Long": 90.3369
            },
            {
              "Area": "Nanil",
              "State": "Jammu & Kashmir",
              "CountryCode": "IN",
              "Lat": 34.0397,
              "Long": 74.7612
            },
            {
              "Area": "Nanjangud",
              "State": "Karnataka",
              "CountryCode": "IN",
              "Lat": 12.5817,
              "Long": 76.8404
            },
            {
              "Area": "Nankahri",
              "State": "Himachal Pradesh",
              "CountryCode": "IN",
              "Lat": 31.326,
              "Long": 77.6333
            },
            {
              "Area": "Nankarbhaira",
              "State": "Assam",
              "CountryCode": "IN",
              "Lat": 26.4408,
              "Long": 91.8873
            },
            {
              "Area": "Nankarmaguria",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 24.3029,
              "Long": 87.818
            },
            {
              "Area": "Nankhari",
              "State": "Himachal Pradesh",
              "CountryCode": "IN",
              "Lat": 31.3653,
              "Long": 77.6324
            },
            {
              "Area": "Nankhari(S.T)",
              "State": "Himachal Pradesh",
              "CountryCode": "IN",
              "Lat": 31.3401,
              "Long": 77.6032
            },
            {
              "Area": "Nannilam",
              "State": "Tamil Nadu",
              "CountryCode": "IN",
              "Lat": 11.1354,
              "Long": 79.7585
            },
            {
              "Area": "Nanoor",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 24.5795,
              "Long": 88.1013
            },
            {
              "Area": "Nanpara",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 28.2167,
              "Long": 81.6932
            },
            {
              "Area": "Nanpur",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 26.576,
              "Long": 85.959
            },
            {
              "Area": "Nanukalan",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.8208,
              "Long": 76.7655
            },
            {
              "Area": "Naoboicha",
              "State": "Assam",
              "CountryCode": "IN",
              "Lat": 27.169,
              "Long": 94.1258
            },
            {
              "Area": "Napaam",
              "State": "Assam",
              "CountryCode": "IN",
              "Lat": 26.5735,
              "Long": 91.1499
            },
            {
              "Area": "Naraingarh",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 30.5335,
              "Long": 77.1037
            },
            {
              "Area": "Naramau",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 26.1685,
              "Long": 80.3428
            },
            {
              "Area": "Narandia",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.4761,
              "Long": 86.8761
            },
            {
              "Area": "Narasannapeta",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 18.3808,
              "Long": 84.0133
            },
            {
              "Area": "Narasannapeta Mandal",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 18.5786,
              "Long": 84.0446
            },
            {
              "Area": "Narasapuram",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.449,
              "Long": 81.692
            },
            {
              "Area": "Narasaraopet",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.3878,
              "Long": 80.1091
            },
            {
              "Area": "Narasimharajapura",
              "State": "Karnataka",
              "CountryCode": "IN",
              "Lat": 13.6108,
              "Long": 75.6913
            },
            {
              "Area": "Narasimulapet",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 17.9552,
              "Long": 79.8841
            },
            {
              "Area": "Narasinghpur",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 20.481,
              "Long": 85.7057
            },
            {
              "Area": "Narassaraopet",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.2579,
              "Long": 79.9256
            },
            {
              "Area": "Narayanapur",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 17.1125,
              "Long": 78.9209
            },
            {
              "Area": "Narayanavanam",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 14.0638,
              "Long": 79.7768
            },
            {
              "Area": "Narayanavaram",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 14.0638,
              "Long": 79.7768
            },
            {
              "Area": "Narayangarh",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 24.3029,
              "Long": 87.818
            },
            {
              "Area": "Narayankhed",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 18.2345,
              "Long": 78.7553
            },
            {
              "Area": "Narayanpatana",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 19.0384,
              "Long": 83.2746
            },
            {
              "Area": "Narayanpatna",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 19.5423,
              "Long": 83.127
            },
            {
              "Area": "Narayanpet",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 17.0133,
              "Long": 77.7697
            },
            {
              "Area": "Narayanpur",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 25.4526,
              "Long": 87.0844
            },
            {
              "Area": "Narayanpur",
              "State": "Jharkhand",
              "CountryCode": "IN",
              "Lat": 24.0719,
              "Long": 86.9172
            },
            {
              "Area": "Narayanpur",
              "State": "Chattisgarh",
              "CountryCode": "IN",
              "Lat": 20.5579,
              "Long": 81.6914
            },
            {
              "Area": "Narayapur",
              "State": "Jharkhand",
              "CountryCode": "IN",
              "Lat": 24.0304,
              "Long": 85.8211
            },
            {
              "Area": "Narbhir",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 20.2278,
              "Long": 79.7025
            },
            {
              "Area": "Narda",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.164,
              "Long": 87.0901
            },
            {
              "Area": "Nardiganj",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 25.238,
              "Long": 85.458
            },
            {
              "Area": "Narender Nagar",
              "State": "Uttarakhand",
              "CountryCode": "IN",
              "Lat": 30.2661,
              "Long": 78.3671
            },
            {
              "Area": "Narendernagar",
              "State": "Uttarakhand",
              "CountryCode": "IN",
              "Lat": 30.4831,
              "Long": 78.7457
            },
            {
              "Area": "Narendra Nagar",
              "State": "Uttarakhand",
              "CountryCode": "IN",
              "Lat": 30.4603,
              "Long": 78.721
            },
            {
              "Area": "Narendra Nagr",
              "State": "Uttarakhand",
              "CountryCode": "IN",
              "Lat": 30.1136,
              "Long": 78.341
            },
            {
              "Area": "Narendranagar",
              "State": "Tripura",
              "CountryCode": "IN",
              "Lat": 24.0447,
              "Long": 91.7553
            },
            {
              "Area": "Narendranagar",
              "State": "Uttarakhand",
              "CountryCode": "IN",
              "Lat": 30.4831,
              "Long": 78.7457
            },
            {
              "Area": "Nargund",
              "State": "Karnataka",
              "CountryCode": "IN",
              "Lat": 15.8595,
              "Long": 75.6663
            },
            {
              "Area": "Narharpur",
              "State": "Chattisgarh",
              "CountryCode": "IN",
              "Lat": 20.2817,
              "Long": 81.6534
            },
            {
              "Area": "Narhat",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 24.8928,
              "Long": 85.2029
            },
            {
              "Area": "Nariyara",
              "State": "Chattisgarh",
              "CountryCode": "IN",
              "Lat": 22.0063,
              "Long": 82.4561
            },
            {
              "Area": "Narkeldanga",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.8436,
              "Long": 88.2293
            },
            {
              "Area": "Narkhed",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 21.4874,
              "Long": 78.6453
            },
            {
              "Area": "Narkher",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 21.4723,
              "Long": 78.7439
            },
            {
              "Area": "Narkuli",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.4761,
              "Long": 86.8761
            },
            {
              "Area": "Narla",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 20.5373,
              "Long": 83.3801
            },
            {
              "Area": "Narmetta",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 17.8942,
              "Long": 79.6777
            },
            {
              "Area": "Narmitta",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 17.9552,
              "Long": 79.7992
            },
            {
              "Area": "Narnaul",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 29.3043,
              "Long": 77.0492
            },
            {
              "Area": "Narnoor",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 19.2993,
              "Long": 78.7046
            },
            {
              "Area": "Narpala",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 14.7665,
              "Long": 78.3731
            },
            {
              "Area": "Narsampet",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 18.0407,
              "Long": 79.9516
            },
            {
              "Area": "Narsapur",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 18.0199,
              "Long": 78.7657
            },
            {
              "Area": "Narsapur (mdl)",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.7517,
              "Long": 81.692
            },
            {
              "Area": "Narsimhapur",
              "State": "Madhya Pradesh",
              "CountryCode": "IN",
              "Lat": 23.0753,
              "Long": 79.4179
            },
            {
              "Area": "Narsimhulapet",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 17.5995,
              "Long": 79.7727
            },
            {
              "Area": "Narsimulapet",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 17.5341,
              "Long": 79.7727
            },
            {
              "Area": "Narsinghgarh",
              "State": "Madhya Pradesh",
              "CountryCode": "IN",
              "Lat": 24.1036,
              "Long": 77.2403
            },
            {
              "Area": "Narsinghpur",
              "State": "Madhya Pradesh",
              "CountryCode": "IN",
              "Lat": 22.993,
              "Long": 79.343
            },
            {
              "Area": "Narsinghpur",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.4135,
              "Long": 76.9942
            },
            {
              "Area": "Narsinghpur",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 20.412,
              "Long": 85.2201
            },
            {
              "Area": "Narsinghpur Ho",
              "State": "Madhya Pradesh",
              "CountryCode": "IN",
              "Lat": 22.9398,
              "Long": 79.2539
            },
            {
              "Area": "Narsipatnam",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 18.0328,
              "Long": 82.7373
            },
            {
              "Area": "Narua",
              "State": "Assam",
              "CountryCode": "IN",
              "Lat": 26.263,
              "Long": 91.3011
            },
            {
              "Area": "Narwal",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 26.2394,
              "Long": 80.4336
            },
            {
              "Area": "Narwana",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 29.7617,
              "Long": 76.4508
            },
            {
              "Area": "Narwar",
              "State": "Madhya Pradesh",
              "CountryCode": "IN",
              "Lat": 25.7005,
              "Long": 78.1315
            },
            {
              "Area": "Narwnaa",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 29.5008,
              "Long": 76.2254
            },
            {
              "Area": "Nashik",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 20.9671,
              "Long": 79.3816
            },
            {
              "Area": "Nasira Bad",
              "State": "Rajasthan",
              "CountryCode": "IN",
              "Lat": 26.4021,
              "Long": 74.7926
            },
            {
              "Area": "Nasirabad",
              "State": "Rajasthan",
              "CountryCode": "IN",
              "Lat": 26.4024,
              "Long": 76.2758
            },
            {
              "Area": "Naskarpur",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.0208,
              "Long": 87.7744
            },
            {
              "Area": "Nasra",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 26.3805,
              "Long": 80.2158
            },
            {
              "Area": "Nasriganj",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 25.1351,
              "Long": 84.408
            },
            {
              "Area": "Nasrullagaj",
              "State": "Madhya Pradesh",
              "CountryCode": "IN",
              "Lat": 22.6692,
              "Long": 77.1847
            },
            {
              "Area": "Nasrullaganj",
              "State": "Madhya Pradesh",
              "CountryCode": "IN",
              "Lat": 22.9911,
              "Long": 77.3573
            },
            {
              "Area": "Nasvadi",
              "State": "Gujarat",
              "CountryCode": "IN",
              "Lat": 22.4083,
              "Long": 73.2983
            },
            {
              "Area": "Naswadi",
              "State": "Gujarat",
              "CountryCode": "IN",
              "Lat": 22.5619,
              "Long": 74.0355
            },
            {
              "Area": "Nataberia",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.8358,
              "Long": 88.7482
            },
            {
              "Area": "Natagram",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 23.5228,
              "Long": 88.1967
            },
            {
              "Area": "Nateran",
              "State": "Madhya Pradesh",
              "CountryCode": "IN",
              "Lat": 24.3211,
              "Long": 80.0087
            },
            {
              "Area": "Natham",
              "State": "Tamil Nadu",
              "CountryCode": "IN",
              "Lat": 10.6447,
              "Long": 78.3104
            },
            {
              "Area": "Nathavaram",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 17.5315,
              "Long": 82.4993
            },
            {
              "Area": "Nathdwara",
              "State": "Rajasthan",
              "CountryCode": "IN",
              "Lat": 25.2163,
              "Long": 73.9711
            },
            {
              "Area": "Nathnagar",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 25.3523,
              "Long": 87.2959
            },
            {
              "Area": "Nathnager",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 25.2965,
              "Long": 86.8584
            },
            {
              "Area": "Natinmanu",
              "State": "Tripura",
              "CountryCode": "IN",
              "Lat": 23.9923,
              "Long": 91.6205
            },
            {
              "Area": "Natipora",
              "State": "Jammu & Kashmir",
              "CountryCode": "IN",
              "Lat": 34.14,
              "Long": 74.7964
            },
            {
              "Area": "Naubasta",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 26.3843,
              "Long": 80.3275
            },
            {
              "Area": "Naubatpur",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 25.5064,
              "Long": 84.9506
            },
            {
              "Area": "Naugachhia",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 25.5139,
              "Long": 86.7362
            },
            {
              "Area": "Naugachia",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 25.5139,
              "Long": 87.1866
            },
            {
              "Area": "Naugaon",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 20.6213,
              "Long": 85.6603
            },
            {
              "Area": "Naugaonhat",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 20.6213,
              "Long": 85.6603
            },
            {
              "Area": "Naugarh",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 27.3809,
              "Long": 83.3423
            },
            {
              "Area": "Nauhatta",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 26.0343,
              "Long": 86.459
            },
            {
              "Area": "Nausher Panvan",
              "State": "Punjab",
              "CountryCode": "IN",
              "Lat": 31.7046,
              "Long": 74.9007
            },
            {
              "Area": "Naushera Panvan",
              "State": "Punjab",
              "CountryCode": "IN",
              "Lat": 31.7996,
              "Long": 74.9131
            },
            {
              "Area": "Nautana",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.4013,
              "Long": 76.373
            },
            {
              "Area": "Nautanawa",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 27.2028,
              "Long": 83.6966
            },
            {
              "Area": "Nautanwa",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 27.2424,
              "Long": 83.6798
            },
            {
              "Area": "Navalagund",
              "State": "Karnataka",
              "CountryCode": "IN",
              "Lat": 15.4508,
              "Long": 75.3036
            },
            {
              "Area": "Navalgund",
              "State": "Karnataka",
              "CountryCode": "IN",
              "Lat": 15.6684,
              "Long": 75.4738
            },
            {
              "Area": "Navapur",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 21.5921,
              "Long": 74.245
            },
            {
              "Area": "Naveen Nagar",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 26.3805,
              "Long": 80.2158
            },
            {
              "Area": "Navsari",
              "State": "Gujarat",
              "CountryCode": "IN",
              "Lat": 21.0384,
              "Long": 73.1205
            },
            {
              "Area": "Navunda",
              "State": "Karnataka",
              "CountryCode": "IN",
              "Lat": 13.745,
              "Long": 74.6489
            },
            {
              "Area": "Nawab Ganj",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 28.5281,
              "Long": 81.2913
            },
            {
              "Area": "Nawabganj",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 28.6149,
              "Long": 82.2618
            },
            {
              "Area": "Nawabpet",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 17.4488,
              "Long": 78.1168
            },
            {
              "Area": "Nawacity",
              "State": "Rajasthan",
              "CountryCode": "IN",
              "Lat": 27.3815,
              "Long": 75.0109
            },
            {
              "Area": "Nawada",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 25.059,
              "Long": 85.8208
            },
            {
              "Area": "Nawadha",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 25.0168,
              "Long": 85.6328
            },
            {
              "Area": "Nawadih",
              "State": "Jharkhand",
              "CountryCode": "IN",
              "Lat": 23.8787,
              "Long": 85.988
            },
            {
              "Area": "Nawagarh",
              "State": "Jharkhand",
              "CountryCode": "IN",
              "Lat": 23.1478,
              "Long": 84.688
            },
            {
              "Area": "Nawagarh",
              "State": "Chattisgarh",
              "CountryCode": "IN",
              "Lat": 21.9616,
              "Long": 82.5934
            },
            {
              "Area": "Nawalgarh",
              "State": "Rajasthan",
              "CountryCode": "IN",
              "Lat": 28.3287,
              "Long": 75.8177
            },
            {
              "Area": "Nawalglarh",
              "State": "Rajasthan",
              "CountryCode": "IN",
              "Lat": 27.4559,
              "Long": 75.5951
            },
            {
              "Area": "Nawan",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.1729,
              "Long": 76.1432
            },
            {
              "Area": "Nawanagar",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 25.6873,
              "Long": 84.2683
            },
            {
              "Area": "Nawanshahar",
              "State": "Punjab",
              "CountryCode": "IN",
              "Lat": 31.9541,
              "Long": 76.2265
            },
            {
              "Area": "Nawanshahr",
              "State": "Punjab",
              "CountryCode": "IN",
              "Lat": 31.1981,
              "Long": 76.2035
            },
            {
              "Area": "Nawapur",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 21.2868,
              "Long": 74.101
            },
            {
              "Area": "Nawda",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 25.0597,
              "Long": 88.0489
            },
            {
              "Area": "Nawgarh",
              "State": "Chattisgarh",
              "CountryCode": "IN",
              "Lat": 22.003,
              "Long": 81.626
            },
            {
              "Area": "Nawlgarh",
              "State": "Rajasthan",
              "CountryCode": "IN",
              "Lat": 27.9022,
              "Long": 75.2256
            },
            {
              "Area": "Naxalbari",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 26.7111,
              "Long": 88.368
            },
            {
              "Area": "Naya Basti",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.4653,
              "Long": 88.7803
            },
            {
              "Area": "Naya Harsud",
              "State": "Madhya Pradesh",
              "CountryCode": "IN",
              "Lat": 21.9704,
              "Long": 76.6198
            },
            {
              "Area": "Nayaganj",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 26.5442,
              "Long": 80.2158
            },
            {
              "Area": "Nayagarh",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 20.8454,
              "Long": 85.2276
            },
            {
              "Area": "Nayagram",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.033,
              "Long": 87.1722
            },
            {
              "Area": "Nayaput",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.2758,
              "Long": 88.831
            },
            {
              "Area": "Nayasarai",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.8847,
              "Long": 88.0798
            },
            {
              "Area": "Nazat",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.3687,
              "Long": 88.562
            },
            {
              "Area": "Nazrpur",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 23.1253,
              "Long": 88.5469
            },
            {
              "Area": "Nedumangad",
              "State": "Kerala",
              "CountryCode": "IN",
              "Lat": 8.9043,
              "Long": 77.0803
            },
            {
              "Area": "Nedungadu Commune Panchayat",
              "State": "Pondicherry",
              "CountryCode": "IN",
              "Lat": 10.9742,
              "Long": 79.7585
            },
            {
              "Area": "Needamangalam",
              "State": "Tamil Nadu",
              "CountryCode": "IN",
              "Lat": 11.7874,
              "Long": 79.5509
            },
            {
              "Area": "Neem-Ka-Thana",
              "State": "Rajasthan",
              "CountryCode": "IN",
              "Lat": 27.6366,
              "Long": 76.0059
            },
            {
              "Area": "Neemrana",
              "State": "Rajasthan",
              "CountryCode": "IN",
              "Lat": 28.1555,
              "Long": 76.6453
            },
            {
              "Area": "Neemuch",
              "State": "Madhya Pradesh",
              "CountryCode": "IN",
              "Lat": 25.3131,
              "Long": 76.2874
            },
            {
              "Area": "Neerada",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 17.8961,
              "Long": 79.9078
            },
            {
              "Area": "Neerpur",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.0799,
              "Long": 76.0612
            },
            {
              "Area": "Negua",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 21.9958,
              "Long": 87.8022
            },
            {
              "Area": "Nehalpur",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.6165,
              "Long": 88.5454
            },
            {
              "Area": "Nehrugarh",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.4146,
              "Long": 76.3674
            },
            {
              "Area": "Nekarikallu",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.3946,
              "Long": 80.0915
            },
            {
              "Area": "Nekkonda",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 17.9968,
              "Long": 79.8606
            },
            {
              "Area": "Nekrasole",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.033,
              "Long": 87.1722
            },
            {
              "Area": "Nekurseni",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.3836,
              "Long": 87.8747
            },
            {
              "Area": "Nelamagala",
              "State": "Karnataka",
              "CountryCode": "IN",
              "Lat": 13.2257,
              "Long": 77.575
            },
            {
              "Area": "Nelamangala",
              "State": "Karnataka",
              "CountryCode": "IN",
              "Lat": 13.4395,
              "Long": 77.7495
            },
            {
              "Area": "Nellimarla",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 18.4673,
              "Long": 83.6039
            },
            {
              "Area": "Nellipaka",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 16.7712,
              "Long": 80.9568
            },
            {
              "Area": "Nellore",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 15.0202,
              "Long": 80.1583
            },
            {
              "Area": "Nenguneri",
              "State": "Tamil Nadu",
              "CountryCode": "IN",
              "Lat": 8.5528,
              "Long": 77.6844
            },
            {
              "Area": "Neora",
              "State": "Chattisgarh",
              "CountryCode": "IN",
              "Lat": 21.5887,
              "Long": 82.0903
            },
            {
              "Area": "Nepanagar",
              "State": "Madhya Pradesh",
              "CountryCode": "IN",
              "Lat": 22.1214,
              "Long": 78.8555
            },
            {
              "Area": "Ner Parsopant",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 20.4897,
              "Long": 78.898
            },
            {
              "Area": "Ner Persopant",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 20.556,
              "Long": 78.1622
            },
            {
              "Area": "Neradigonda",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 19.2895,
              "Long": 78.4702
            },
            {
              "Area": "Neravy Commune Panchayat",
              "State": "Pondicherry",
              "CountryCode": "IN",
              "Lat": 10.9434,
              "Long": 79.792
            },
            {
              "Area": "Nermand(T)",
              "State": "Himachal Pradesh",
              "CountryCode": "IN",
              "Lat": 31.9045,
              "Long": 77.5951
            },
            {
              "Area": "Nerparsopant",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 20.2712,
              "Long": 77.9733
            },
            {
              "Area": "Nettapakkam Commune Panchayat",
              "State": "Tamil Nadu",
              "CountryCode": "IN",
              "Lat": 11.8584,
              "Long": 79.6829
            },
            {
              "Area": "Neturia",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 23.6631,
              "Long": 86.8734
            },
            {
              "Area": "Nevasa",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 19.9996,
              "Long": 75.7361
            },
            {
              "Area": "New Anaz Mandi Rewari",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.3196,
              "Long": 76.611
            },
            {
              "Area": "New Colony",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.418,
              "Long": 76.9839
            },
            {
              "Area": "New Delhi",
              "State": "Delhi",
              "CountryCode": "IN",
              "Lat": 28.7486,
              "Long": 77.3144
            },
            {
              "Area": "New Delhi Central",
              "State": "Delhi",
              "CountryCode": "IN",
              "Lat": 28.6453,
              "Long": 77.2456
            },
            {
              "Area": "New Lamka",
              "State": "Manipur",
              "CountryCode": "IN",
              "Lat": 24.2669,
              "Long": 93.2817
            },
            {
              "Area": "New Nepaligaon",
              "State": "Nagaland",
              "CountryCode": "IN",
              "Lat": 25.9288,
              "Long": 94.3486
            },
            {
              "Area": "New Pac Lines",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 26.5934,
              "Long": 80.6879
            },
            {
              "Area": "New Sectt. Complex",
              "State": "Nagaland",
              "CountryCode": "IN",
              "Lat": 25.662,
              "Long": 94.1084
            },
            {
              "Area": "New Town",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 24.1048,
              "Long": 88.7803
            },
            {
              "Area": "Newai",
              "State": "Rajasthan",
              "CountryCode": "IN",
              "Lat": 26.3168,
              "Long": 76.0194
            },
            {
              "Area": "Newasa",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 19.9993,
              "Long": 76.8033
            },
            {
              "Area": "Neyyattinkara",
              "State": "Kerala",
              "CountryCode": "IN",
              "Lat": 9.1681,
              "Long": 77.1943
            },
            {
              "Area": "Ngopa",
              "State": "Mizoram",
              "CountryCode": "IN",
              "Lat": 23.8827,
              "Long": 93.2195
            },
            {
              "Area": "Niali",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 20.4906,
              "Long": 86.0628
            },
            {
              "Area": "Niamatpur",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.1729,
              "Long": 76.1432
            },
            {
              "Area": "Nichar",
              "State": "Himachal Pradesh",
              "CountryCode": "IN",
              "Lat": 32.0518,
              "Long": 78.0583
            },
            {
              "Area": "Nichar(T)",
              "State": "Himachal Pradesh",
              "CountryCode": "IN",
              "Lat": 32.0518,
              "Long": 78.4126
            },
            {
              "Area": "Nichaulal",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 26.9635,
              "Long": 83.6202
            },
            {
              "Area": "Nichlaul",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 27.3125,
              "Long": 83.7253
            },
            {
              "Area": "Nichlaulal",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 26.6578,
              "Long": 83.3614
            },
            {
              "Area": "Nidadavole",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.9231,
              "Long": 81.709
            },
            {
              "Area": "Nidadavole Mandal",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.9337,
              "Long": 81.6006
            },
            {
              "Area": "Nidadavole Mandalam",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.9445,
              "Long": 81.7453
            },
            {
              "Area": "Nidadavolemandalam",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.95,
              "Long": 81.6924
            },
            {
              "Area": "Nidamangalam",
              "State": "Tamil Nadu",
              "CountryCode": "IN",
              "Lat": 10.9501,
              "Long": 79.6072
            },
            {
              "Area": "Nidamarrumandalam",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.723,
              "Long": 81.439
            },
            {
              "Area": "Nidamarry Mandal",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.7216,
              "Long": 81.4294
            },
            {
              "Area": "Nidhlaul",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 27.2025,
              "Long": 83.5333
            },
            {
              "Area": "Nigdhu",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 29.8426,
              "Long": 76.8847
            },
            {
              "Area": "Nighasan",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 28.4043,
              "Long": 80.9741
            },
            {
              "Area": "Nihal Singh Wala",
              "State": "Punjab",
              "CountryCode": "IN",
              "Lat": 30.77,
              "Long": 75.3679
            },
            {
              "Area": "Nihal Singhwala",
              "State": "Punjab",
              "CountryCode": "IN",
              "Lat": 30.7006,
              "Long": 75.3028
            },
            {
              "Area": "Nihalawas",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.1904,
              "Long": 76.1312
            },
            {
              "Area": "Nihri(S.T)",
              "State": "Himachal Pradesh",
              "CountryCode": "IN",
              "Lat": 31.6314,
              "Long": 77.1857
            },
            {
              "Area": "Nijamabad",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 25.9595,
              "Long": 82.9004
            },
            {
              "Area": "Nijhar",
              "State": "Gujarat",
              "CountryCode": "IN",
              "Lat": 21.8974,
              "Long": 74.1423
            },
            {
              "Area": "Nijkasba",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 21.8532,
              "Long": 87.9147
            },
            {
              "Area": "Nikashi",
              "State": "Assam",
              "CountryCode": "IN",
              "Lat": 26.3679,
              "Long": 91.3877
            },
            {
              "Area": "Nikte",
              "State": "Arunachal Pradesh",
              "CountryCode": "IN",
              "Lat": 28.2358,
              "Long": 94.6742
            },
            {
              "Area": "Nil",
              "State": "Manipur",
              "CountryCode": "IN",
              "Lat": 25.5134,
              "Long": 94.5099
            },
            {
              "Area": "Nil;",
              "State": "Manipur",
              "CountryCode": "IN",
              "Lat": 24.6813,
              "Long": 94.063
            },
            {
              "Area": "Nilagiri",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 21.4898,
              "Long": 86.917
            },
            {
              "Area": "Nilakkottai",
              "State": "Tamil Nadu",
              "CountryCode": "IN",
              "Lat": 10.798,
              "Long": 78.2556
            },
            {
              "Area": "Nilakottai",
              "State": "Tamil Nadu",
              "CountryCode": "IN",
              "Lat": 10.2082,
              "Long": 78.2556
            },
            {
              "Area": "Nilambur",
              "State": "Kerala",
              "CountryCode": "IN",
              "Lat": 11.4491,
              "Long": 76.4378
            },
            {
              "Area": "Nilanga",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 20.4769,
              "Long": 77.3923
            },
            {
              "Area": "Nilda",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.3836,
              "Long": 87.8747
            },
            {
              "Area": "Nilgiri",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 21.6224,
              "Long": 86.9484
            },
            {
              "Area": "Niligiri",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 21.2567,
              "Long": 86.658
            },
            {
              "Area": "Nilokheri",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 29.9422,
              "Long": 77.0141
            },
            {
              "Area": "Nimapada",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 21.8355,
              "Long": 86.0867
            },
            {
              "Area": "Nimbahera",
              "State": "Rajasthan",
              "CountryCode": "IN",
              "Lat": 25.6983,
              "Long": 75.2276
            },
            {
              "Area": "Nimbi",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.4851,
              "Long": 76.4735
            },
            {
              "Area": "Nimdaria",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.7343,
              "Long": 88.5795
            },
            {
              "Area": "Nimichi",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.6389,
              "Long": 88.746
            },
            {
              "Area": "Nimkathana",
              "State": "Rajasthan",
              "CountryCode": "IN",
              "Lat": 28.0444,
              "Long": 76.0059
            },
            {
              "Area": "Nimoth",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.2955,
              "Long": 76.4283
            },
            {
              "Area": "Nimpith Ashram",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.1142,
              "Long": 88.5318
            },
            {
              "Area": "Nindra",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 13.4095,
              "Long": 79.7184
            },
            {
              "Area": "Ningthoukhong",
              "State": "Manipur",
              "CountryCode": "IN",
              "Lat": 24.4065,
              "Long": 93.3452
            },
            {
              "Area": "Niphad",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 20.3389,
              "Long": 76.2302
            },
            {
              "Area": "Nirala Nagar",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 26.5934,
              "Long": 80.6879
            },
            {
              "Area": "Nirjuli",
              "State": "Arunachal Pradesh",
              "CountryCode": "IN",
              "Lat": 27.1329,
              "Long": 93.7465
            },
            {
              "Area": "Nirmal",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 19.415,
              "Long": 78.9721
            },
            {
              "Area": "Nirmali",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 26.445,
              "Long": 86.8336
            },
            {
              "Area": "Nirmand",
              "State": "Himachal Pradesh",
              "CountryCode": "IN",
              "Lat": 31.5499,
              "Long": 77.688
            },
            {
              "Area": "Nischintapur",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.03,
              "Long": 88.2873
            },
            {
              "Area": "Nishchintakoili",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 21.1156,
              "Long": 86.2574
            },
            {
              "Area": "Nissing",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 29.7364,
              "Long": 76.7984
            },
            {
              "Area": "Nissu",
              "State": "Jammu & Kashmir",
              "CountryCode": "IN",
              "Lat": 33.5339,
              "Long": 75.1844
            },
            {
              "Area": "Nistoli",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 28.7416,
              "Long": 77.4102
            },
            {
              "Area": "Nityaberia",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.3687,
              "Long": 88.562
            },
            {
              "Area": "Nityananda",
              "State": "Assam",
              "CountryCode": "IN",
              "Lat": 26.6242,
              "Long": 91.5994
            },
            {
              "Area": "Nityananda Kati",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 23.1406,
              "Long": 88.5427
            },
            {
              "Area": "Niwali",
              "State": "Madhya Pradesh",
              "CountryCode": "IN",
              "Lat": 21.8859,
              "Long": 75.2651
            },
            {
              "Area": "Niwari",
              "State": "Madhya Pradesh",
              "CountryCode": "IN",
              "Lat": 25.4041,
              "Long": 79.2231
            },
            {
              "Area": "Niwas",
              "State": "Madhya Pradesh",
              "CountryCode": "IN",
              "Lat": 23.088,
              "Long": 80.7024
            },
            {
              "Area": "Niz Namati",
              "State": "Assam",
              "CountryCode": "IN",
              "Lat": 26.5736,
              "Long": 91.3877
            },
            {
              "Area": "Nizama Bad",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 25.9641,
              "Long": 82.9958
            },
            {
              "Area": "Nizamabad",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 19.1257,
              "Long": 78.7943
            },
            {
              "Area": "Nizamabad",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 26.1603,
              "Long": 83.0697
            },
            {
              "Area": "Nizamabad **",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 25.9595,
              "Long": 83.1705
            },
            {
              "Area": "Nizamabad Division",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 18.4854,
              "Long": 79.1392
            },
            {
              "Area": "Nizampatnam",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 15.9332,
              "Long": 80.6756
            },
            {
              "Area": "Nizampur R.s.",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.0799,
              "Long": 76.0612
            },
            {
              "Area": "Nizamzbad",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 26.0789,
              "Long": 83.0326
            },
            {
              "Area": "Nizar",
              "State": "Gujarat",
              "CountryCode": "IN",
              "Lat": 21.8974,
              "Long": 74.1423
            },
            {
              "Area": "Nizbahjani",
              "State": "Assam",
              "CountryCode": "IN",
              "Lat": 26.3796,
              "Long": 91.2951
            },
            {
              "Area": "Nizdhamdhama",
              "State": "Assam",
              "CountryCode": "IN",
              "Lat": 26.5004,
              "Long": 91.4784
            },
            {
              "Area": "Nkpalli",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 17.3614,
              "Long": 79.9689
            },
            {
              "Area": "Nkpally",
              "State": "Telangana",
              "CountryCode": "IN",
              "Lat": 17.9857,
              "Long": 81.0042
            },
            {
              "Area": "Nla & Bgsouth",
              "State": "Karnataka",
              "CountryCode": "IN",
              "Lat": 13.1303,
              "Long": 77.7495
            },
            {
              "Area": "Noadih",
              "State": "Jharkhand",
              "CountryCode": "IN",
              "Lat": 23.5559,
              "Long": 84.5347
            },
            {
              "Area": "Noagaon",
              "State": "Tripura",
              "CountryCode": "IN",
              "Lat": 24.1959,
              "Long": 91.8344
            },
            {
              "Area": "Noamundi",
              "State": "Jharkhand",
              "CountryCode": "IN",
              "Lat": 22.2115,
              "Long": 85.5284
            },
            {
              "Area": "Noapara",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.7572,
              "Long": 88.4556
            },
            {
              "Area": "Noapara Madhavpur",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.7572,
              "Long": 88.4556
            },
            {
              "Area": "Nobra",
              "State": "Jammu & Kashmir",
              "CountryCode": "IN",
              "Lat": 34.5469,
              "Long": 77.5563
            },
            {
              "Area": "Nochlaul",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 26.7072,
              "Long": 83.2408
            },
            {
              "Area": "Nodih",
              "State": "Jharkhand",
              "CountryCode": "IN",
              "Lat": 23.5559,
              "Long": 84.4375
            },
            {
              "Area": "Nohar",
              "State": "Rajasthan",
              "CountryCode": "IN",
              "Lat": 29.2749,
              "Long": 75.2011
            },
            {
              "Area": "Nohra",
              "State": "Himachal Pradesh",
              "CountryCode": "IN",
              "Lat": 30.7728,
              "Long": 77.406
            },
            {
              "Area": "Noida",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 28.6302,
              "Long": 77.8448
            },
            {
              "Area": "Nokha",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 25.1655,
              "Long": 84.367
            },
            {
              "Area": "Nokha",
              "State": "Rajasthan",
              "CountryCode": "IN",
              "Lat": 27.7984,
              "Long": 73.4714
            },
            {
              "Area": "Noklak",
              "State": "Nagaland",
              "CountryCode": "IN",
              "Lat": 26.2362,
              "Long": 95.0188
            },
            {
              "Area": "None S.O",
              "State": "Manipur",
              "CountryCode": "IN",
              "Lat": 24.8873,
              "Long": 93.6521
            },
            {
              "Area": "Noney",
              "State": "Manipur",
              "CountryCode": "IN",
              "Lat": 24.8873,
              "Long": 93.6521
            },
            {
              "Area": "Nonglyer",
              "State": "Meghalaya",
              "CountryCode": "IN",
              "Lat": 25.5675,
              "Long": 91.8645
            },
            {
              "Area": "Nongpoh",
              "State": "Meghalaya",
              "CountryCode": "IN",
              "Lat": 25.9023,
              "Long": 91.8769
            },
            {
              "Area": "Nongstoin",
              "State": "Meghalaya",
              "CountryCode": "IN",
              "Lat": 25.6519,
              "Long": 91.6473
            },
            {
              "Area": "Noonhanda",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.3836,
              "Long": 87.8747
            },
            {
              "Area": "Noonmai",
              "State": "Jammu & Kashmir",
              "CountryCode": "IN",
              "Lat": 33.9563,
              "Long": 74.834
            },
            {
              "Area": "Noorpur",
              "State": "Tripura",
              "CountryCode": "IN",
              "Lat": 24.332,
              "Long": 92.0039
            },
            {
              "Area": "Noorsarai",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 25.1717,
              "Long": 85.423
            },
            {
              "Area": "Noorsaran",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 25.3056,
              "Long": 85.2629
            },
            {
              "Area": "Nort Solapur",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 17.8026,
              "Long": 76.4093
            },
            {
              "Area": "North",
              "State": "Delhi",
              "CountryCode": "IN",
              "Lat": 28.7486,
              "Long": 77.2245
            },
            {
              "Area": "North  Solapur",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 17.6484,
              "Long": 75.9936
            },
            {
              "Area": "North 24 Paraganas",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 24.375,
              "Long": 88.7803
            },
            {
              "Area": "North 24 Parganas",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 23.3945,
              "Long": 88.3781
            },
            {
              "Area": "North 24 Pgs",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 23.3945,
              "Long": 88.4493
            },
            {
              "Area": "North Biswanathpur",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.0208,
              "Long": 87.7744
            },
            {
              "Area": "North Goa",
              "State": "Goa",
              "CountryCode": "IN",
              "Lat": 15.4785,
              "Long": 73.8339
            },
            {
              "Area": "North Jadupur",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 24.5656,
              "Long": 87.9504
            },
            {
              "Area": "North Lakhimpur",
              "State": "Assam",
              "CountryCode": "IN",
              "Lat": 27.0636,
              "Long": 93.7857
            },
            {
              "Area": "North Solapur",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 18.1432,
              "Long": 76.1434
            },
            {
              "Area": "North Thingdawl",
              "State": "Mizoram",
              "CountryCode": "IN",
              "Lat": 24.2239,
              "Long": 92.8299
            },
            {
              "Area": "North West Delhi",
              "State": "Delhi",
              "CountryCode": "IN",
              "Lat": 28.7201,
              "Long": 77.1027
            },
            {
              "Area": "Northganganagar",
              "State": "Tripura",
              "CountryCode": "IN",
              "Lat": 24.0447,
              "Long": 91.7553
            },
            {
              "Area": "Northrajupalem Mandalam",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 14.546,
              "Long": 79.9886
            },
            {
              "Area": "Noushera",
              "State": "Jammu & Kashmir",
              "CountryCode": "IN",
              "Lat": 34.14,
              "Long": 74.7964
            },
            {
              "Area": "Nowda",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 23.692,
              "Long": 88.1886
            },
            {
              "Area": "Nowda (murshidabad)",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 23.4827,
              "Long": 88.5215
            },
            {
              "Area": "Nowgam",
              "State": "Jammu & Kashmir",
              "CountryCode": "IN",
              "Lat": 34.14,
              "Long": 75.0932
            },
            {
              "Area": "Nowgong",
              "State": "Madhya Pradesh",
              "CountryCode": "IN",
              "Lat": 25.2877,
              "Long": 79.9596
            },
            {
              "Area": "Nr Palem",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 14.5521,
              "Long": 80.0232
            },
            {
              "Area": "Nr Persopant",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 20.5614,
              "Long": 77.6742
            },
            {
              "Area": "Nrendra Nagar",
              "State": "Uttarakhand",
              "CountryCode": "IN",
              "Lat": 30.4061,
              "Long": 78.2179
            },
            {
              "Area": "Nsarsinghpur",
              "State": "Madhya Pradesh",
              "CountryCode": "IN",
              "Lat": 22.8399,
              "Long": 79.1979
            },
            {
              "Area": "Nsg Camp Manesar",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.3553,
              "Long": 76.9215
            },
            {
              "Area": "Nsi Campus",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 26.5666,
              "Long": 80.9724
            },
            {
              "Area": "Nuagaon",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 22.3333,
              "Long": 84.9667
            },
            {
              "Area": "Nuagaon Block",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 22.237,
              "Long": 84.9568
            },
            {
              "Area": "Nuaon",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 25.3423,
              "Long": 83.7483
            },
            {
              "Area": "Nuapada",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 20.9846,
              "Long": 82.7797
            },
            {
              "Area": "Nuapara",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 20.7328,
              "Long": 82.7145
            },
            {
              "Area": "Nuh",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 28.3681,
              "Long": 77.021
            },
            {
              "Area": "Nuhrat",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 24.8928,
              "Long": 85.2029
            },
            {
              "Area": "Nunacherra",
              "State": "Tripura",
              "CountryCode": "IN",
              "Lat": 24.007,
              "Long": 91.6093
            },
            {
              "Area": "Nungi",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.4126,
              "Long": 88.3292
            },
            {
              "Area": "Nurhat",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 24.7529,
              "Long": 85.4109
            },
            {
              "Area": "Nurpur",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 22.9011,
              "Long": 88.5795
            },
            {
              "Area": "Nurpur",
              "State": "Himachal Pradesh",
              "CountryCode": "IN",
              "Lat": 32.3713,
              "Long": 76.7572
            },
            {
              "Area": "Nurpur(T)",
              "State": "Himachal Pradesh",
              "CountryCode": "IN",
              "Lat": 32.0076,
              "Long": 76.3224
            },
            {
              "Area": "Nursarai",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 25.3129,
              "Long": 85.537
            },
            {
              "Area": "Nusarai",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 25.2208,
              "Long": 85.4559
            },
            {
              "Area": "Nutakki",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.4453,
              "Long": 80.6571
            },
            {
              "Area": "Nuz Id",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.8102,
              "Long": 80.8264
            },
            {
              "Area": "Nuzendla",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 15.9828,
              "Long": 79.8588
            },
            {
              "Area": "Nuzvid",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 17.0268,
              "Long": 81.4066
            },
            {
              "Area": "Nwagarh",
              "State": "Jharkhand",
              "CountryCode": "IN",
              "Lat": 23.0159,
              "Long": 84.2983
            },
            {
              "Area": "Nyapin",
              "State": "Arunachal Pradesh",
              "CountryCode": "IN",
              "Lat": 27.964,
              "Long": 93.5532
            },
            {
              "Area": "O.d. Cheruvu",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 14.0811,
              "Long": 78.4924
            },
            {
              "Area": "OBULAVARIPALLI",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 14.0211,
              "Long": 79.2472
            },
            {
              "Area": "Obra",
              "State": "Bihar",
              "CountryCode": "IN",
              "Lat": 25.0074,
              "Long": 84.4871
            },
            {
              "Area": "Obuladevacheruvu",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 13.7896,
              "Long": 78.4924
            },
            {
              "Area": "Obuladevaracheruvu",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 14.4811,
              "Long": 78.4924
            },
            {
              "Area": "Obulavaripalle",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 14.2071,
              "Long": 79.3387
            },
            {
              "Area": "Odagaon",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 20.3465,
              "Long": 85.1876
            },
            {
              "Area": "Oddanchatram",
              "State": "Tamil Nadu",
              "CountryCode": "IN",
              "Lat": 10.6694,
              "Long": 77.8853
            },
            {
              "Area": "Odhan",
              "State": "Haryana",
              "CountryCode": "IN",
              "Lat": 29.8033,
              "Long": 74.8784
            },
            {
              "Area": "Oef Factory",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 26.5442,
              "Long": 80.1097
            },
            {
              "Area": "Ohardaga",
              "State": "Jharkhand",
              "CountryCode": "IN",
              "Lat": 23.2689,
              "Long": 84.6175
            },
            {
              "Area": "Ohimath",
              "State": "Uttarakhand",
              "CountryCode": "IN",
              "Lat": 30.4798,
              "Long": 79.0188
            },
            {
              "Area": "Okhamandal",
              "State": "Gujarat",
              "CountryCode": "IN",
              "Lat": 23.5216,
              "Long": 69.5361
            },
            {
              "Area": "Okhimath",
              "State": "Uttarakhand",
              "CountryCode": "IN",
              "Lat": 30.6603,
              "Long": 79.461
            },
            {
              "Area": "Okhimatn",
              "State": "Uttarakhand",
              "CountryCode": "IN",
              "Lat": 30.547,
              "Long": 79.1502
            },
            {
              "Area": "Old Malda",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 25.1367,
              "Long": 88.0923
            },
            {
              "Area": "Olpad",
              "State": "Gujarat",
              "CountryCode": "IN",
              "Lat": 22.9786,
              "Long": 73.346
            },
            {
              "Area": "Omalur",
              "State": "Tamil Nadu",
              "CountryCode": "IN",
              "Lat": 12.069,
              "Long": 78.5934
            },
            {
              "Area": "Omerga",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 18.1891,
              "Long": 76.6928
            },
            {
              "Area": "Ompora",
              "State": "Jammu & Kashmir",
              "CountryCode": "IN",
              "Lat": 33.9245,
              "Long": 74.6725
            },
            {
              "Area": "Onda",
              "State": "West Bengal",
              "CountryCode": "IN",
              "Lat": 24.0931,
              "Long": 87.5766
            },
            {
              "Area": "Ongole",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 16.1334,
              "Long": 80.2559
            },
            {
              "Area": "Ongpang Kong",
              "State": "Nagaland",
              "CountryCode": "IN",
              "Lat": 26.3457,
              "Long": 94.4892
            },
            {
              "Area": "Ongpangkong",
              "State": "Nagaland",
              "CountryCode": "IN",
              "Lat": 26.3094,
              "Long": 94.5206
            },
            {
              "Area": "Orai",
              "State": "Uttar Pradesh",
              "CountryCode": "IN",
              "Lat": 26.1197,
              "Long": 79.8919
            },
            {
              "Area": "Orang",
              "State": "Assam",
              "CountryCode": "IN",
              "Lat": 26.7111,
              "Long": 92.6274
            },
            {
              "Area": "Orathanadu",
              "State": "Tamil Nadu",
              "CountryCode": "IN",
              "Lat": 11.4375,
              "Long": 79.3815
            },
            {
              "Area": "Orattanad",
              "State": "Tamil Nadu",
              "CountryCode": "IN",
              "Lat": 11.4375,
              "Long": 79.3815
            },
            {
              "Area": "Orchha",
              "State": "Madhya Pradesh",
              "CountryCode": "IN",
              "Lat": 25.4373,
              "Long": 78.8151
            },
            {
              "Area": "Orkel",
              "State": "Odisha",
              "CountryCode": "IN",
              "Lat": 18.8376,
              "Long": 82.538
            },
            {
              "Area": "Ormanchi",
              "State": "Jharkhand",
              "CountryCode": "IN",
              "Lat": 23.4946,
              "Long": 85.5421
            },
            {
              "Area": "Ormanhji",
              "State": "Jharkhand",
              "CountryCode": "IN",
              "Lat": 23.5139,
              "Long": 85.5038
            },
            {
              "Area": "Ormanjhi",
              "State": "Jharkhand",
              "CountryCode": "IN",
              "Lat": 23.5379,
              "Long": 85.5859
            },
            {
              "Area": "Osian",
              "State": "Rajasthan",
              "CountryCode": "IN",
              "Lat": 27.3323,
              "Long": 73.0261
            },
            {
              "Area": "Osmanabad",
              "State": "Maharashtra",
              "CountryCode": "IN",
              "Lat": 20.0328,
              "Long": 76.7751
            },
            {
              "Area": "Otapidaram",
              "State": "Tamil Nadu",
              "CountryCode": "IN",
              "Lat": 9.2112,
              "Long": 78.123
            },
            {
              "Area": "Ottapalam",
              "State": "Kerala",
              "CountryCode": "IN",
              "Lat": 10.9231,
              "Long": 76.5586
            },
            {
              "Area": "Ottapalam.",
              "State": "Kerala",
              "CountryCode": "IN",
              "Lat": 10.8208,
              "Long": 76.2022
            },
            {
              "Area": "Ottapidaam",
              "State": "Tamil Nadu",
              "CountryCode": "IN",
              "Lat": 8.9,
              "Long": 77.9392
            },
            {
              "Area": "Ottapidaram",
              "State": "Tamil Nadu",
              "CountryCode": "IN",
              "Lat": 9.7656,
              "Long": 78.0998
            },
            {
              "Area": "Ottappalam",
              "State": "Kerala",
              "CountryCode": "IN",
              "Lat": 11.1388,
              "Long": 76.5586
            },
            {
              "Area": "Ottpalam",
              "State": "Kerala",
              "CountryCode": "IN",
              "Lat": 10.9031,
              "Long": 76.3687
            },
            {
              "Area": "Owk",
              "State": "Andhra Pradesh",
              "CountryCode": "IN",
              "Lat": 15.2192,
              "Long": 78.6039
            },
            {
              "Area": "Nabatiye et Tahta",
              "Lat": "33.3833",
              "Long": "35.45",
              "CountryCode": "LB"
            },
            {
              "Area": "Naberezhnyye Chelny",
              "Lat": "55.7",
              "Long": "52.3199",
              "CountryCode": "RU"
            },
            {
              "Area": "Nabeul",
              "Lat": "36.4603",
              "Long": "10.73",
              "CountryCode": "TN"
            },
            {
              "Area": "Nacala",
              "Lat": "-14.5186",
              "Long": "40.715",
              "CountryCode": "MZ"
            },
            {
              "Area": "Naga",
              "Lat": "13.6192",
              "Long": "123.1814",
              "CountryCode": "PH"
            },
            {
              "Area": "Nagano",
              "Lat": "36.65",
              "Long": "138.17",
              "CountryCode": "JP"
            },
            {
              "Area": "Nagaoka",
              "Lat": "37.4504",
              "Long": "138.86",
              "CountryCode": "JP"
            },
            {
              "Area": "Nagasaki",
              "Lat": "32.765",
              "Long": "129.885",
              "CountryCode": "JP"
            },
            {
              "Area": "Nagoya",
              "Lat": "35.155",
              "Long": "136.915",
              "CountryCode": "JP"
            },
            {
              "Area": "Naha",
              "Lat": "26.2072",
              "Long": "127.673",
              "CountryCode": "JP"
            },
            {
              "Area": "Nairobi",
              "Lat": "-1.2833",
              "Long": "36.8167",
              "CountryCode": "KE"
            },
            {
              "Area": "Najran",
              "Lat": "17.5065",
              "Long": "44.1316",
              "CountryCode": "SA"
            },
            {
              "Area": "Nakhodka",
              "Lat": "42.8374",
              "Long": "132.8874",
              "CountryCode": "RU"
            },
            {
              "Area": "Nakhodka",
              "Lat": "67.7504",
              "Long": "77.52",
              "CountryCode": "RU"
            },
            {
              "Area": "Nakhon Pathom",
              "Lat": "13.818",
              "Long": "100.064",
              "CountryCode": "TH"
            },
            {
              "Area": "Nakhon Phanom",
              "Lat": "17.3945",
              "Long": "104.7695",
              "CountryCode": "TH"
            },
            {
              "Area": "Nakhon Ratchasima",
              "Lat": "15",
              "Long": "102.1",
              "CountryCode": "TH"
            },
            {
              "Area": "Nakhon Sawan",
              "Lat": "15.7",
              "Long": "100.07",
              "CountryCode": "TH"
            },
            {
              "Area": "Nakhon Si Thammarat",
              "Lat": "8.4",
              "Long": "99.97",
              "CountryCode": "TH"
            },
            {
              "Area": "Nakuru",
              "Lat": "-0.28",
              "Long": "36.07",
              "CountryCode": "KE"
            },
            {
              "Area": "Naltchik",
              "Lat": "43.4981",
              "Long": "43.6179",
              "CountryCode": "RU"
            },
            {
              "Area": "Nalut",
              "Lat": "31.8804",
              "Long": "10.97",
              "CountryCode": "LY"
            },
            {
              "Area": "Nam Định",
              "Lat": "20.42",
              "Long": "106.2",
              "CountryCode": "VN"
            },
            {
              "Area": "Namangan",
              "Lat": "41",
              "Long": "71.67",
              "CountryCode": "UZ"
            },
            {
              "Area": "Namibe",
              "Lat": "-15.19",
              "Long": "12.16",
              "CountryCode": "AO"
            },
            {
              "Area": "Nampa",
              "Lat": "43.5843",
              "Long": "-116.5626",
              "CountryCode": "US"
            },
            {
              "Area": "Nampo",
              "Lat": "38.7669",
              "Long": "125.4524",
              "CountryCode": "KP"
            },
            {
              "Area": "Nampula",
              "Lat": "-15.136",
              "Long": "39.293",
              "CountryCode": "MZ"
            },
            {
              "Area": "Namur",
              "Lat": "50.4704",
              "Long": "4.87",
              "CountryCode": "BE"
            },
            {
              "Area": "Nan",
              "Lat": "18.7868",
              "Long": "100.7715",
              "CountryCode": "TH"
            },
            {
              "Area": "Nanaimo",
              "Lat": "49.146",
              "Long": "-123.9343",
              "CountryCode": "CA"
            },
            {
              "Area": "Nancha",
              "Lat": "47.1364",
              "Long": "129.2859",
              "CountryCode": "CN"
            },
            {
              "Area": "Nanchang",
              "Lat": "28.68",
              "Long": "115.88",
              "CountryCode": "CN"
            },
            {
              "Area": "Nanchong",
              "Lat": "30.7804",
              "Long": "106.13",
              "CountryCode": "CN"
            },
            {
              "Area": "Nancy",
              "Lat": "48.6837",
              "Long": "6.2",
              "CountryCode": "FR"
            },
            {
              "Area": "Nangong",
              "Lat": "37.3704",
              "Long": "115.37",
              "CountryCode": "CN"
            },
            {
              "Area": "Nanjing",
              "Lat": "32.05",
              "Long": "118.78",
              "CountryCode": "CN"
            },
            {
              "Area": "Nanning",
              "Lat": "22.82",
              "Long": "108.32",
              "CountryCode": "CN"
            },
            {
              "Area": "Nanping",
              "Lat": "26.6304",
              "Long": "118.17",
              "CountryCode": "CN"
            },
            {
              "Area": "Nantes",
              "Lat": "47.2104",
              "Long": "-1.59",
              "CountryCode": "FR"
            },
            {
              "Area": "Nantong",
              "Lat": "32.0304",
              "Long": "120.825",
              "CountryCode": "CN"
            },
            {
              "Area": "Nantou",
              "Lat": "23.9167",
              "Long": "120.6833",
              "CountryCode": "TW"
            },
            {
              "Area": "Nanyang",
              "Lat": "33.0004",
              "Long": "112.53",
              "CountryCode": "CN"
            },
            {
              "Area": "Napa",
              "Lat": "38.2977",
              "Long": "-122.3011",
              "CountryCode": "US"
            },
            {
              "Area": "Naperville",
              "Lat": "41.7483",
              "Long": "-88.1657",
              "CountryCode": "US"
            },
            {
              "Area": "Napier",
              "Lat": "-39.49",
              "Long": "176.9265",
              "CountryCode": "NZ"
            },
            {
              "Area": "Naples",
              "Lat": "40.84",
              "Long": "14.245",
              "CountryCode": "IT"
            },
            {
              "Area": "Narathiwat",
              "Lat": "6.4318",
              "Long": "101.8214",
              "CountryCode": "TH"
            },
            {
              "Area": "Narayanganj",
              "Lat": "23.6204",
              "Long": "90.5",
              "CountryCode": "BD"
            },
            {
              "Area": "Narva",
              "Lat": "59.3776",
              "Long": "28.1603",
              "CountryCode": "EE"
            },
            {
              "Area": "Naryn",
              "Lat": "41.4263",
              "Long": "75.9911",
              "CountryCode": "KG"
            },
            {
              "Area": "Nashua",
              "Lat": "42.7491",
              "Long": "-71.491",
              "CountryCode": "US"
            },
            {
              "Area": "Nashville",
              "Lat": "36.1714",
              "Long": "-86.7844",
              "CountryCode": "US"
            },
            {
              "Area": "Nassau",
              "Lat": "25.0834",
              "Long": "-77.35",
              "CountryCode": "BS"
            },
            {
              "Area": "Natal",
              "Lat": "-5.78",
              "Long": "-35.24",
              "CountryCode": "BR"
            },
            {
              "Area": "Natal",
              "Lat": "-6.9838",
              "Long": "-60.2699",
              "CountryCode": "BR"
            },
            {
              "Area": "National City",
              "Lat": "32.6654",
              "Long": "-117.0983",
              "CountryCode": "US"
            },
            {
              "Area": "Natitingou",
              "Lat": "10.3204",
              "Long": "1.39",
              "CountryCode": "BJ"
            },
            {
              "Area": "Navajoa",
              "Lat": "27.0819",
              "Long": "-109.4546",
              "CountryCode": "MX"
            },
            {
              "Area": "Navoi",
              "Lat": "40.1104",
              "Long": "65.355",
              "CountryCode": "UZ"
            },
            {
              "Area": "Nawabganj",
              "Lat": "24.5804",
              "Long": "88.35",
              "CountryCode": "BD"
            },
            {
              "Area": "Nawabshah",
              "Lat": "26.2454",
              "Long": "68.4",
              "CountryCode": "PK"
            },
            {
              "Area": "Naxcivan",
              "Lat": "39.2092",
              "Long": "45.4122",
              "CountryCode": "AZ"
            },
            {
              "Area": "Naypyidaw",
              "Lat": "19.7666",
              "Long": "96.1186",
              "CountryCode": "MM"
            },
            {
              "Area": "Nazareth",
              "Lat": "32.704",
              "Long": "35.2955",
              "CountryCode": "IL"
            },
            {
              "Area": "Nazran",
              "Lat": "43.233",
              "Long": "44.783",
              "CountryCode": "RU"
            },
            {
              "Area": "Nazret",
              "Lat": "8.55",
              "Long": "39.27",
              "CountryCode": "ET"
            },
            {
              "Area": "Ndjamena",
              "Lat": "12.1131",
              "Long": "15.0491",
              "CountryCode": "TD"
            },
            {
              "Area": "Ndola",
              "Lat": "-12.9999",
              "Long": "28.65",
              "CountryCode": "ZM"
            },
            {
              "Area": "Necochea",
              "Lat": "-38.56",
              "Long": "-58.75",
              "CountryCode": "AR"
            },
            {
              "Area": "Neftekamsk",
              "Lat": "56.0835",
              "Long": "54.2631",
              "CountryCode": "RU"
            },
            {
              "Area": "Nefteyugansk",
              "Lat": "61.0777",
              "Long": "72.7027",
              "CountryCode": "RU"
            },
            {
              "Area": "Nehe",
              "Lat": "48.49",
              "Long": "124.88",
              "CountryCode": "CN"
            },
            {
              "Area": "Neijiang",
              "Lat": "29.5804",
              "Long": "105.05",
              "CountryCode": "CN"
            },
            {
              "Area": "Neiva",
              "Lat": "2.931",
              "Long": "-75.3302",
              "CountryCode": "CO"
            },
            {
              "Area": "Nekemte",
              "Lat": "9.0905",
              "Long": "36.53",
              "CountryCode": "ET"
            },
            {
              "Area": "Nelson",
              "Lat": "-41.2926",
              "Long": "173.2474",
              "CountryCode": "NZ"
            },
            {
              "Area": "Nema",
              "Lat": "16.6171",
              "Long": "-7.25",
              "CountryCode": "MR"
            },
            {
              "Area": "Nenjiang",
              "Lat": "49.18",
              "Long": "125.23",
              "CountryCode": "CN"
            },
            {
              "Area": "NPganj",
              "Lat": "28.0503",
              "Long": "81.6167",
              "CountryCode": "NP"
            },
            {
              "Area": "Neryungri",
              "Lat": "56.674",
              "Long": "124.7104",
              "CountryCode": "RU"
            },
            {
              "Area": "Neuquén",
              "Lat": "-38.95",
              "Long": "-68.06",
              "CountryCode": "AR"
            },
            {
              "Area": "Nevinnomyssk",
              "Lat": "44.6201",
              "Long": "41.95",
              "CountryCode": "RU"
            },
            {
              "Area": "Nevşehir",
              "Lat": "38.624",
              "Long": "34.724",
              "CountryCode": "TR"
            },
            {
              "Area": "New Bedford",
              "Lat": "41.6697",
              "Long": "-70.9428",
              "CountryCode": "US"
            },
            {
              "Area": "New Bern",
              "Lat": "35.0955",
              "Long": "-77.0724",
              "CountryCode": "US"
            },
            {
              "Area": "New Braunfels",
              "Lat": "29.6995",
              "Long": "-98.1153",
              "CountryCode": "US"
            },
            {
              "Area": "New Britain",
              "Lat": "41.6758",
              "Long": "-72.7862",
              "CountryCode": "US"
            },
            {
              "Area": "New Brunswick",
              "Lat": "40.487",
              "Long": "-74.445",
              "CountryCode": "US"
            },
            {
              "Area": "New Haven",
              "Lat": "41.3112",
              "Long": "-72.9245",
              "CountryCode": "US"
            },
            {
              "Area": "New Orleans",
              "Lat": "30.0687",
              "Long": "-89.9288",
              "CountryCode": "US"
            },
            {
              "Area": "New Plymouth",
              "Lat": "-39.0556",
              "Long": "174.0748",
              "CountryCode": "NZ"
            },
            {
              "Area": "New Rochelle",
              "Lat": "40.9305",
              "Long": "-73.7836",
              "CountryCode": "US"
            },
            {
              "Area": "New York",
              "Lat": "40.6943",
              "Long": "-73.9249",
              "CountryCode": "US"
            },
            {
              "Area": "Newark",
              "Lat": "40.7245",
              "Long": "-74.1725",
              "CountryCode": "US"
            },
            {
              "Area": "Newark",
              "Lat": "40.0705",
              "Long": "-82.425",
              "CountryCode": "US"
            },
            {
              "Area": "Newcastle",
              "Lat": "-32.8453",
              "Long": "151.815",
              "CountryCode": "AU"
            },
            {
              "Area": "Newcastle",
              "Lat": "55.0004",
              "Long": "-1.6",
              "CountryCode": "GB"
            },
            {
              "Area": "Newport Beach",
              "Lat": "33.6151",
              "Long": "-117.8669",
              "CountryCode": "US"
            },
            {
              "Area": "Newport News",
              "Lat": "37.1051",
              "Long": "-76.5185",
              "CountryCode": "US"
            },
            {
              "Area": "Newton",
              "Lat": "42.3316",
              "Long": "-71.2084",
              "CountryCode": "US"
            },
            {
              "Area": "Neyshabur",
              "Lat": "36.22",
              "Long": "58.82",
              "CountryCode": "IR"
            },
            {
              "Area": "Nezahualcoyotl",
              "Lat": "19.41",
              "Long": "-99.03",
              "CountryCode": "MX"
            },
            {
              "Area": "Ngaoundéré",
              "Lat": "7.3204",
              "Long": "13.58",
              "CountryCode": "CM"
            },
            {
              "Area": "Nguru",
              "Lat": "12.8804",
              "Long": "10.45",
              "CountryCode": "NG"
            },
            {
              "Area": "Nha Trang",
              "Lat": "12.25",
              "Long": "109.17",
              "CountryCode": "VN"
            },
            {
              "Area": "Niamey",
              "Lat": "13.5167",
              "Long": "2.1167",
              "CountryCode": "NE"
            },
            {
              "Area": "Nice",
              "Lat": "43.715",
              "Long": "7.265",
              "CountryCode": "FR"
            },
            {
              "Area": "Nicosia",
              "Lat": "35.1667",
              "Long": "33.3666",
              "CountryCode": "CY"
            },
            {
              "Area": "Niğde",
              "Lat": "37.976",
              "Long": "34.694",
              "CountryCode": "TR"
            },
            {
              "Area": "Niigata",
              "Lat": "37.92",
              "Long": "139.04",
              "CountryCode": "JP"
            },
            {
              "Area": "Nikopol",
              "Lat": "47.5666",
              "Long": "34.4062",
              "CountryCode": "UA"
            },
            {
              "Area": "Nîmes",
              "Lat": "43.8304",
              "Long": "4.35",
              "CountryCode": "FR"
            },
            {
              "Area": "Ninde",
              "Lat": "26.6804",
              "Long": "119.5301",
              "CountryCode": "CN"
            },
            {
              "Area": "Ningan",
              "Lat": "44.3313",
              "Long": "129.4659",
              "CountryCode": "CN"
            },
            {
              "Area": "Ningbo",
              "Lat": "29.88",
              "Long": "121.55",
              "CountryCode": "CN"
            },
            {
              "Area": "Ninh Bình",
              "Lat": "20.2543",
              "Long": "105.975",
              "CountryCode": "VN"
            },
            {
              "Area": "Niš",
              "Lat": "43.3304",
              "Long": "21.9",
              "CountryCode": "RS"
            },
            {
              "Area": "Niterói",
              "Lat": "-22.9",
              "Long": "-43.1",
              "CountryCode": "BR"
            },
            {
              "Area": "Niyala",
              "Lat": "12.06",
              "Long": "24.89",
              "CountryCode": "SD"
            },
            {
              "Area": "Nizhenvartovsk",
              "Lat": "60.935",
              "Long": "76.58",
              "CountryCode": "RU"
            },
            {
              "Area": "Nizhnekamsk",
              "Lat": "55.6404",
              "Long": "51.82",
              "CountryCode": "RU"
            },
            {
              "Area": "Nizhny Novgorod",
              "Lat": "56.333",
              "Long": "44.0001",
              "CountryCode": "RU"
            },
            {
              "Area": "Nizhny Tagil",
              "Lat": "57.92",
              "Long": "59.975",
              "CountryCode": "RU"
            },
            {
              "Area": "Nizhnyaya Tura",
              "Lat": "58.6436",
              "Long": "59.7983",
              "CountryCode": "RU"
            },
            {
              "Area": "Nizhyn",
              "Lat": "51.0541",
              "Long": "31.8903",
              "CountryCode": "UA"
            },
            {
              "Area": "Nizwa",
              "Lat": "22.9264",
              "Long": "57.5314",
              "CountryCode": "OM"
            },
            {
              "Area": "Nkawkaw",
              "Lat": "6.5505",
              "Long": "-0.78",
              "CountryCode": "GH"
            },
            {
              "Area": "Nkhotakota",
              "Lat": "-12.9163",
              "Long": "34.3",
              "CountryCode": "MW"
            },
            {
              "Area": "Nkongsamba",
              "Lat": "4.9604",
              "Long": "9.94",
              "CountryCode": "CM"
            },
            {
              "Area": "Noblesville",
              "Lat": "40.0353",
              "Long": "-86.006",
              "CountryCode": "US"
            },
            {
              "Area": "Nogales",
              "Lat": "31.305",
              "Long": "-110.945",
              "CountryCode": "MX"
            },
            {
              "Area": "Noginsk",
              "Lat": "55.8704",
              "Long": "38.48",
              "CountryCode": "RU"
            },
            {
              "Area": "Noginsk",
              "Lat": "64.4833",
              "Long": "91.2333",
              "CountryCode": "RU"
            },
            {
              "Area": "Nong Khai",
              "Lat": "17.8733",
              "Long": "102.7479",
              "CountryCode": "TH"
            },
            {
              "Area": "Nongan",
              "Lat": "44.4304",
              "Long": "125.1701",
              "CountryCode": "CN"
            },
            {
              "Area": "Nonthaburi",
              "Lat": "13.8337",
              "Long": "100.4833",
              "CountryCode": "TH"
            },
            {
              "Area": "Norfolk",
              "Lat": "36.8945",
              "Long": "-76.259",
              "CountryCode": "US"
            },
            {
              "Area": "Norilsk",
              "Lat": "69.34",
              "Long": "88.225",
              "CountryCode": "RU"
            },
            {
              "Area": "Normal",
              "Lat": "40.522",
              "Long": "-88.9877",
              "CountryCode": "US"
            },
            {
              "Area": "Norman",
              "Lat": "35.2335",
              "Long": "-97.3471",
              "CountryCode": "US"
            },
            {
              "Area": "Norrköping",
              "Lat": "58.5954",
              "Long": "16.1787",
              "CountryCode": "SE"
            },
            {
              "Area": "North Bay",
              "Lat": "46.3",
              "Long": "-79.45",
              "CountryCode": "CA"
            },
            {
              "Area": "North Charleston",
              "Lat": "32.9086",
              "Long": "-80.0705",
              "CountryCode": "US"
            },
            {
              "Area": "North Las Vegas",
              "Lat": "36.288",
              "Long": "-115.0901",
              "CountryCode": "US"
            },
            {
              "Area": "North Little Rock",
              "Lat": "34.7814",
              "Long": "-92.2378",
              "CountryCode": "US"
            },
            {
              "Area": "North Miami",
              "Lat": "25.9006",
              "Long": "-80.1681",
              "CountryCode": "US"
            },
            {
              "Area": "North Port",
              "Lat": "27.0577",
              "Long": "-82.1976",
              "CountryCode": "US"
            },
            {
              "Area": "North Richland Hills",
              "Lat": "32.8605",
              "Long": "-97.218",
              "CountryCode": "US"
            },
            {
              "Area": "North Shore",
              "Lat": "-36.7913",
              "Long": "174.7758",
              "CountryCode": "NZ"
            },
            {
              "Area": "Norwalk",
              "Lat": "33.9069",
              "Long": "-118.0829",
              "CountryCode": "US"
            },
            {
              "Area": "Norwalk",
              "Lat": "41.1144",
              "Long": "-73.4215",
              "CountryCode": "US"
            },
            {
              "Area": "Norwich",
              "Lat": "41.5495",
              "Long": "-72.0882",
              "CountryCode": "US"
            },
            {
              "Area": "Norwich",
              "Lat": "52.6304",
              "Long": "1.3",
              "CountryCode": "GB"
            },
            {
              "Area": "Nottingham",
              "Lat": "52.9703",
              "Long": "-1.17",
              "CountryCode": "GB"
            },
            {
              "Area": "Nouadhibou",
              "Lat": "20.9",
              "Long": "-17.056",
              "CountryCode": "MR"
            },
            {
              "Area": "Nouakchott",
              "Lat": "18.0864",
              "Long": "-15.9753",
              "CountryCode": "MR"
            },
            {
              "Area": "Nouméa",
              "Lat": "-22.2625",
              "Long": "166.4443",
              "CountryCode": "NC"
            },
            {
              "Area": "Nova Friburgo",
              "Lat": "-22.26",
              "Long": "-42.54",
              "CountryCode": "BR"
            },
            {
              "Area": "Nova Iguaçu",
              "Lat": "-22.74",
              "Long": "-43.47",
              "CountryCode": "BR"
            },
            {
              "Area": "Nova Lima",
              "Lat": "-19.98",
              "Long": "-43.85",
              "CountryCode": "BR"
            },
            {
              "Area": "Nova Viçosa",
              "Lat": "-17.88",
              "Long": "-39.37",
              "CountryCode": "BR"
            },
            {
              "Area": "Novara",
              "Lat": "45.45",
              "Long": "8.62",
              "CountryCode": "IT"
            },
            {
              "Area": "Novato",
              "Lat": "38.092",
              "Long": "-122.5576",
              "CountryCode": "US"
            },
            {
              "Area": "Novi",
              "Lat": "42.4786",
              "Long": "-83.4893",
              "CountryCode": "US"
            },
            {
              "Area": "Novi Sad",
              "Lat": "45.2504",
              "Long": "19.8499",
              "CountryCode": "RS"
            },
            {
              "Area": "Novo Hamburgo",
              "Lat": "-29.7096",
              "Long": "-51.14",
              "CountryCode": "BR"
            },
            {
              "Area": "Novoaltaysk",
              "Lat": "53.3993",
              "Long": "83.9588",
              "CountryCode": "RU"
            },
            {
              "Area": "Novocherkassk",
              "Lat": "47.42",
              "Long": "40.08",
              "CountryCode": "RU"
            },
            {
              "Area": "Novokuybishevsk",
              "Lat": "53.12",
              "Long": "49.9199",
              "CountryCode": "RU"
            },
            {
              "Area": "Novokuznetsk",
              "Lat": "53.75",
              "Long": "87.115",
              "CountryCode": "RU"
            },
            {
              "Area": "Novomoskovsk",
              "Lat": "54.09",
              "Long": "38.22",
              "CountryCode": "RU"
            },
            {
              "Area": "Novorossiysk",
              "Lat": "44.73",
              "Long": "37.7699",
              "CountryCode": "RU"
            },
            {
              "Area": "Novoshakhtinsk",
              "Lat": "47.77",
              "Long": "39.92",
              "CountryCode": "RU"
            },
            {
              "Area": "Novosibirsk",
              "Lat": "55.03",
              "Long": "82.96",
              "CountryCode": "RU"
            },
            {
              "Area": "Novotroitsk",
              "Lat": "51.2",
              "Long": "58.33",
              "CountryCode": "RU"
            },
            {
              "Area": "Novy Urengoy",
              "Lat": "66.0833",
              "Long": "76.6332",
              "CountryCode": "RU"
            },
            {
              "Area": "Nowra",
              "Lat": "-34.8828",
              "Long": "150.6",
              "CountryCode": "AU"
            },
            {
              "Area": "Noyabrsk",
              "Lat": "63.1665",
              "Long": "75.6165",
              "CountryCode": "RU"
            },
            {
              "Area": "Nsukka",
              "Lat": "6.867",
              "Long": "7.3834",
              "CountryCode": "NG"
            },
            {
              "Area": "Nueva San Salvador",
              "Lat": "13.674",
              "Long": "-89.29",
              "CountryCode": "SV"
            },
            {
              "Area": "Nuevitas",
              "Lat": "21.5456",
              "Long": "-77.2644",
              "CountryCode": "CU"
            },
            {
              "Area": "Nuevo Casas Grandes",
              "Lat": "30.4185",
              "Long": "-107.9119",
              "CountryCode": "MX"
            },
            {
              "Area": "Nuevo Laredo",
              "Lat": "27.5",
              "Long": "-99.55",
              "CountryCode": "MX"
            },
            {
              "Area": "Nukus",
              "Lat": "42.47",
              "Long": "59.615",
              "CountryCode": "UZ"
            },
            {
              "Area": "Numan",
              "Lat": "9.4604",
              "Long": "12.04",
              "CountryCode": "NG"
            },
            {
              "Area": "Nürnberg",
              "Lat": "49.45",
              "Long": "11.08",
              "CountryCode": "DE"
            },
            {
              "Area": "Nusaybin",
              "Lat": "37.075",
              "Long": "41.2184",
              "CountryCode": "TR"
            },
            {
              "Area": "Nyagan",
              "Lat": "62.1465",
              "Long": "65.3814",
              "CountryCode": "RU"
            },
            {
              "Area": "Nyanza",
              "Lat": "-2.3496",
              "Long": "29.74",
              "CountryCode": "RW"
            },
            {
              "Area": "Nyeri",
              "Lat": "-0.417",
              "Long": "36.951",
              "CountryCode": "KE"
            },
            {
              "Area": "Nyíregyháza",
              "Lat": "47.9653",
              "Long": "21.7187",
              "CountryCode": "HU"
            },
            {
              "Area": "Nzérékoré",
              "Lat": "7.76",
              "Long": "-8.83",
              "CountryCode": "GN"
            },
            {
              "Area": "O'Fallon",
              "Lat": "38.7851",
              "Long": "-90.7176",
              "CountryCode": "US"
            },
            {
              "Area": "Oak Lawn",
              "Lat": "41.7139",
              "Long": "-87.7528",
              "CountryCode": "US"
            },
            {
              "Area": "Oak Park",
              "Lat": "41.8872",
              "Long": "-87.7899",
              "CountryCode": "US"
            },
            {
              "Area": "Oakland",
              "Lat": "37.7903",
              "Long": "-122.2165",
              "CountryCode": "US"
            },
            {
              "Area": "Oaxaca",
              "Lat": "17.0827",
              "Long": "-96.6699",
              "CountryCode": "MX"
            },
            {
              "Area": "Obihiro",
              "Lat": "42.9304",
              "Long": "143.17",
              "CountryCode": "JP"
            },
            {
              "Area": "Obninsk",
              "Lat": "55.0804",
              "Long": "36.62",
              "CountryCode": "RU"
            },
            {
              "Area": "Obuasi",
              "Lat": "6.1904",
              "Long": "-1.66",
              "CountryCode": "GH"
            },
            {
              "Area": "Ocala",
              "Lat": "29.1803",
              "Long": "-82.1495",
              "CountryCode": "US"
            },
            {
              "Area": "Ocaña",
              "Lat": "8.2404",
              "Long": "-73.35",
              "CountryCode": "CO"
            },
            {
              "Area": "Oceanside",
              "Lat": "33.2247",
              "Long": "-117.3083",
              "CountryCode": "US"
            },
            {
              "Area": "Ocumare del Tuy",
              "Lat": "10.12",
              "Long": "-66.78",
              "CountryCode": "VE"
            },
            {
              "Area": "Odense",
              "Lat": "55.4004",
              "Long": "10.3833",
              "CountryCode": "DK"
            },
            {
              "Area": "Odessa",
              "Lat": "46.49",
              "Long": "30.71",
              "CountryCode": "UA"
            },
            {
              "Area": "Odessa",
              "Lat": "31.8831",
              "Long": "-102.3407",
              "CountryCode": "US"
            },
            {
              "Area": "Ogbomosho",
              "Lat": "8.13",
              "Long": "4.24",
              "CountryCode": "NG"
            },
            {
              "Area": "Ogden",
              "Lat": "41.228",
              "Long": "-111.9677",
              "CountryCode": "US"
            },
            {
              "Area": "Ōita",
              "Lat": "33.2432",
              "Long": "131.5979",
              "CountryCode": "JP"
            },
            {
              "Area": "Okara",
              "Lat": "30.8104",
              "Long": "73.45",
              "CountryCode": "PK"
            },
            {
              "Area": "Okayama",
              "Lat": "34.672",
              "Long": "133.9171",
              "CountryCode": "JP"
            },
            {
              "Area": "Oklahoma City",
              "Lat": "35.4676",
              "Long": "-97.5136",
              "CountryCode": "US"
            },
            {
              "Area": "Oktyabrskiy",
              "Lat": "54.46",
              "Long": "53.46",
              "CountryCode": "RU"
            },
            {
              "Area": "Oktyabrskiy",
              "Lat": "52.6636",
              "Long": "156.2387",
              "CountryCode": "RU"
            },
            {
              "Area": "Olathe",
              "Lat": "38.8838",
              "Long": "-94.8196",
              "CountryCode": "US"
            },
            {
              "Area": "Olavarría",
              "Lat": "-36.9",
              "Long": "-60.33",
              "CountryCode": "AR"
            },
            {
              "Area": "Oldenburg",
              "Lat": "53.13",
              "Long": "8.22",
              "CountryCode": "DE"
            },
            {
              "Area": "Olinda",
              "Lat": "-8",
              "Long": "-34.85",
              "CountryCode": "BR"
            },
            {
              "Area": "OlMLq",
              "Lat": "40.8504",
              "Long": "69.595",
              "CountryCode": "UZ"
            },
            {
              "Area": "Olomouc",
              "Lat": "49.63",
              "Long": "17.25",
              "CountryCode": "CZ"
            },
            {
              "Area": "Olongapo",
              "Lat": "14.8296",
              "Long": "120.2828",
              "CountryCode": "PH"
            },
            {
              "Area": "Olsztyn",
              "Lat": "53.8",
              "Long": "20.48",
              "CountryCode": "PL"
            },
            {
              "Area": "Olympia",
              "Lat": "47.0418",
              "Long": "-122.8959",
              "CountryCode": "US"
            },
            {
              "Area": "Omaha",
              "Lat": "41.2628",
              "Long": "-96.0495",
              "CountryCode": "US"
            },
            {
              "Area": "Omdurman",
              "Lat": "15.6167",
              "Long": "32.48",
              "CountryCode": "SD"
            },
            {
              "Area": "Omsk",
              "Lat": "54.99",
              "Long": "73.4",
              "CountryCode": "RU"
            },
            {
              "Area": "Ondo",
              "Lat": "7.0904",
              "Long": "4.84",
              "CountryCode": "NG"
            },
            {
              "Area": "Ongjin",
              "Lat": "37.9371",
              "Long": "125.3571",
              "CountryCode": "KP"
            },
            {
              "Area": "Onitsha",
              "Lat": "6.1404",
              "Long": "6.78",
              "CountryCode": "NG"
            },
            {
              "Area": "Ontario",
              "Lat": "34.0393",
              "Long": "-117.6064",
              "CountryCode": "US"
            },
            {
              "Area": "Oostanay",
              "Lat": "53.2209",
              "Long": "63.6283",
              "CountryCode": "KZ"
            },
            {
              "Area": "Opole",
              "Lat": "50.685",
              "Long": "17.9313",
              "CountryCode": "PL"
            },
            {
              "Area": "Oradea",
              "Lat": "47.05",
              "Long": "21.92",
              "CountryCode": "RO"
            },
            {
              "Area": "Oral",
              "Lat": "51.2711",
              "Long": "51.335",
              "CountryCode": "KZ"
            },
            {
              "Area": "Oran",
              "Lat": "35.71",
              "Long": "-0.62",
              "CountryCode": "DZ"
            },
            {
              "Area": "Orange",
              "Lat": "33.8038",
              "Long": "-117.8219",
              "CountryCode": "US"
            },
            {
              "Area": "Oranjestad",
              "Lat": "12.5304",
              "Long": "-70.029",
              "CountryCode": "AW"
            },
            {
              "Area": "Ordu",
              "Lat": "41.0004",
              "Long": "37.8699",
              "CountryCode": "TR"
            },
            {
              "Area": "Örebro",
              "Lat": "59.2803",
              "Long": "15.22",
              "CountryCode": "SE"
            },
            {
              "Area": "Orekhovo-Zuevo",
              "Lat": "55.82",
              "Long": "38.98",
              "CountryCode": "RU"
            },
            {
              "Area": "Orel",
              "Lat": "52.97",
              "Long": "36.07",
              "CountryCode": "RU"
            },
            {
              "Area": "Orem",
              "Lat": "40.2983",
              "Long": "-111.6993",
              "CountryCode": "US"
            },
            {
              "Area": "Orenburg",
              "Lat": "51.78",
              "Long": "55.11",
              "CountryCode": "RU"
            },
            {
              "Area": "Orizaba",
              "Lat": "18.85",
              "Long": "-97.13",
              "CountryCode": "MX"
            },
            {
              "Area": "Orland Park",
              "Lat": "41.6075",
              "Long": "-87.8619",
              "CountryCode": "US"
            },
            {
              "Area": "Orlando",
              "Lat": "28.4788",
              "Long": "-81.342",
              "CountryCode": "US"
            },
            {
              "Area": "Orléans",
              "Lat": "47.9004",
              "Long": "1.9",
              "CountryCode": "FR"
            },
            {
              "Area": "Ormac",
              "Lat": "11.0643",
              "Long": "124.6075",
              "CountryCode": "PH"
            },
            {
              "Area": "Orsha",
              "Lat": "54.5153",
              "Long": "30.4215",
              "CountryCode": "BY"
            },
            {
              "Area": "Orsk",
              "Lat": "51.21",
              "Long": "58.6273",
              "CountryCode": "RU"
            },
            {
              "Area": "Oruro",
              "Lat": "-17.98",
              "Long": "-67.13",
              "CountryCode": "BO"
            },
            {
              "Area": "Ōsaka",
              "Lat": "34.75",
              "Long": "135.4601",
              "CountryCode": "JP"
            },
            {
              "Area": "Osh",
              "Lat": "40.5404",
              "Long": "72.79",
              "CountryCode": "KG"
            },
            {
              "Area": "Oshawa",
              "Lat": "43.88",
              "Long": "-78.85",
              "CountryCode": "CA"
            },
            {
              "Area": "Oshkosh",
              "Lat": "44.0228",
              "Long": "-88.5616",
              "CountryCode": "US"
            },
            {
              "Area": "Oshogbo",
              "Lat": "7.7704",
              "Long": "4.56",
              "CountryCode": "NG"
            },
            {
              "Area": "Osijek",
              "Lat": "45.5504",
              "Long": "18.68",
              "CountryCode": "HR"
            },
            {
              "Area": "Oskemen",
              "Lat": "49.99",
              "Long": "82.6149",
              "CountryCode": "KZ"
            },
            {
              "Area": "Oslo",
              "Lat": "59.9167",
              "Long": "10.75",
              "CountryCode": "NO"
            },
            {
              "Area": "Osnabrück",
              "Lat": "52.2804",
              "Long": "8.05",
              "CountryCode": "DE"
            },
            {
              "Area": "Osorno",
              "Lat": "-40.57",
              "Long": "-73.16",
              "CountryCode": "CL"
            },
            {
              "Area": "Ostrava",
              "Lat": "49.8304",
              "Long": "18.25",
              "CountryCode": "CZ"
            },
            {
              "Area": "Otaru",
              "Lat": "43.1887",
              "Long": "140.9783",
              "CountryCode": "JP"
            },
            {
              "Area": "Otradnyy",
              "Lat": "53.3778",
              "Long": "51.3474",
              "CountryCode": "RU"
            },
            {
              "Area": "Ōtsu",
              "Lat": "35.0064",
              "Long": "135.8674",
              "CountryCode": "JP"
            },
            {
              "Area": "Ottawa",
              "Lat": "45.4167",
              "Long": "-75.7",
              "CountryCode": "CA"
            },
            {
              "Area": "Oturkpo",
              "Lat": "7.1904",
              "Long": "8.13",
              "CountryCode": "NG"
            },
            {
              "Area": "Ouagadougou",
              "Lat": "12.3703",
              "Long": "-1.5247",
              "CountryCode": "BF"
            },
            {
              "Area": "Ouahigouya",
              "Lat": "13.5704",
              "Long": "-2.42",
              "CountryCode": "BF"
            },
            {
              "Area": "Ouargla",
              "Lat": "31.97",
              "Long": "5.34",
              "CountryCode": "DZ"
            },
            {
              "Area": "Oudtshoorn",
              "Lat": "-33.58",
              "Long": "22.19",
              "CountryCode": "ZA"
            },
            {
              "Area": "Ouezzane",
              "Lat": "34.8103",
              "Long": "-5.57",
              "CountryCode": "MA"
            },
            {
              "Area": "Ouidah",
              "Lat": "6.3604",
              "Long": "2.09",
              "CountryCode": "BJ"
            },
            {
              "Area": "Oujda",
              "Lat": "34.69",
              "Long": "-1.91",
              "CountryCode": "MA"
            },
            {
              "Area": "Oulu",
              "Lat": "65",
              "Long": "25.47",
              "CountryCode": "FI"
            },
            {
              "Area": "Oum el Bouaghi",
              "Lat": "35.85",
              "Long": "7.15",
              "CountryCode": "DZ"
            },
            {
              "Area": "Ourense",
              "Lat": "42.33",
              "Long": "-7.87",
              "CountryCode": "ES"
            },
            {
              "Area": "Ourinhos",
              "Lat": "-22.97",
              "Long": "-49.87",
              "CountryCode": "BR"
            },
            {
              "Area": "Ovalle",
              "Lat": "-30.59",
              "Long": "-71.2001",
              "CountryCode": "CL"
            },
            {
              "Area": "Overland Park",
              "Lat": "38.887",
              "Long": "-94.687",
              "CountryCode": "US"
            },
            {
              "Area": "Oviedo",
              "Lat": "43.3505",
              "Long": "-5.83",
              "CountryCode": "ES"
            },
            {
              "Area": "Owensboro",
              "Lat": "37.7575",
              "Long": "-87.1172",
              "CountryCode": "US"
            },
            {
              "Area": "Owerri",
              "Lat": "5.493",
              "Long": "7.026",
              "CountryCode": "NG"
            },
            {
              "Area": "Owo",
              "Lat": "7.2004",
              "Long": "5.59",
              "CountryCode": "NG"
            },
            {
              "Area": "Oxford",
              "Lat": "51.7704",
              "Long": "-1.25",
              "CountryCode": "GB"
            },
            {
              "Area": "Oxnard",
              "Lat": "34.1962",
              "Long": "-119.1819",
              "CountryCode": "US"
            },
            {
              "Area": "Oyo",
              "Lat": "7.8504",
              "Long": "3.93",
              "CountryCode": "NG"
            },
            {
              "Area": "Ozamis",
              "Lat": "8.1462",
              "Long": "123.8444",
              "CountryCode": "PH"
            },
              {
                "Area": "P R Gudem",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 18.3172,
                "Long": 79.3498
              },
              {
                "Area": "P. Belsar",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.8957,
                "Long": 85.3067
              },
              {
                "Area": "P. Chamaria ( Goroimari Block)",
                "State": "Assam",
                "CountryCode": "IN",
                "Lat": 26.1314,
                "Long": 91.4625
              },
              {
                "Area": "P.belsar",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.9738,
                "Long": 85.2505
              },
              {
                "Area": "P.dayal",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.9052,
                "Long": 85.0054
              },
              {
                "Area": "P.gannavaram",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 17.1734,
                "Long": 81.9669
              },
              {
                "Area": "P.gannavaram Mandal",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.111,
                "Long": 81.0343
              },
              {
                "Area": "P.r.gudem",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 18.3172,
                "Long": 80.6873
              },
              {
                "Area": "P;arlu",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 25.458,
                "Long": 73.1059
              },
              {
                "Area": "PHANIGIRI",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 18.146,
                "Long": 79.2386
              },
              {
                "Area": "PHULERA",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 27.0217,
                "Long": 75.7243
              },
              {
                "Area": "Pabhoi",
                "State": "Assam",
                "CountryCode": "IN",
                "Lat": 26.971,
                "Long": 93.8695
              },
              {
                "Area": "Paburia",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 20.1508,
                "Long": 84.2973
              },
              {
                "Area": "Pachhad",
                "State": "Himachal Pradesh",
                "CountryCode": "IN",
                "Lat": 31.7362,
                "Long": 77.431
              },
              {
                "Area": "Pachipenta",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 18.998,
                "Long": 83.614
              },
              {
                "Area": "Pachor",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.1685,
                "Long": 80.3428
              },
              {
                "Area": "Pachora",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 21.0569,
                "Long": 75.8383
              },
              {
                "Area": "Pachore",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 23.8612,
                "Long": 76.7935
              },
              {
                "Area": "Pachpadra City",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 26.083,
                "Long": 72.5232
              },
              {
                "Area": "Pachrukhi",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.2471,
                "Long": 84.4066
              },
              {
                "Area": "Padampur",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 29.7089,
                "Long": 74.735
              },
              {
                "Area": "Padampura",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 29.3955,
                "Long": 73.5632
              },
              {
                "Area": "Padapadu",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.6,
                "Long": 81.072
              },
              {
                "Area": "Paddhari",
                "State": "Gujarat",
                "CountryCode": "IN",
                "Lat": 22.4365,
                "Long": 70.6016
              },
              {
                "Area": "Paderu",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 17.9623,
                "Long": 82.7846
              },
              {
                "Area": "Padhar(T)",
                "State": "Himachal Pradesh",
                "CountryCode": "IN",
                "Lat": 31.9951,
                "Long": 76.9407
              },
              {
                "Area": "Padma",
                "State": "Jharkhand",
                "CountryCode": "IN",
                "Lat": 24.206,
                "Long": 85.4132
              },
              {
                "Area": "Padmabil",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 24.1597,
                "Long": 92.0329
              },
              {
                "Area": "Padmapur",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 19.2197,
                "Long": 83.7097
              },
              {
                "Area": "Padra",
                "State": "Gujarat",
                "CountryCode": "IN",
                "Lat": 23.5549,
                "Long": 73.5319
              },
              {
                "Area": "Padrauna",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.9309,
                "Long": 84.1698
              },
              {
                "Area": "Padru",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 25.7356,
                "Long": 72.6504
              },
              {
                "Area": "Padua",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 19.1027,
                "Long": 82.7012
              },
              {
                "Area": "Padum",
                "State": "Jammu & Kashmir",
                "CountryCode": "IN",
                "Lat": 33.5629,
                "Long": 76.9373
              },
              {
                "Area": "Paedhi Belsar",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.9615,
                "Long": 85.2299
              },
              {
                "Area": "Pagidyala",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 15.4222,
                "Long": 78.2746
              },
              {
                "Area": "Paglabari",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 24.019,
                "Long": 91.625
              },
              {
                "Area": "Pahalgam",
                "State": "Jammu & Kashmir",
                "CountryCode": "IN",
                "Lat": 33.9942,
                "Long": 74.9835
              },
              {
                "Area": "Pahargama",
                "State": "Jharkhand",
                "CountryCode": "IN",
                "Lat": 24.8273,
                "Long": 87.2363
              },
              {
                "Area": "Pahari",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 27.7005,
                "Long": 77.0691
              },
              {
                "Area": "Paharmora",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 24.0796,
                "Long": 91.5997
              },
              {
                "Area": "Paharpur",
                "State": "Assam",
                "CountryCode": "IN",
                "Lat": 26.7306,
                "Long": 91.5564
              },
              {
                "Area": "Paharpur",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.5205,
                "Long": 84.6623
              },
              {
                "Area": "Paika",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.5234,
                "Long": 87.6598
              },
              {
                "Area": "Paikamal",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 21.4094,
                "Long": 83.4749
              },
              {
                "Area": "Paikmal",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 21.6758,
                "Long": 83.5792
              },
              {
                "Area": "Paikparahat",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.6191,
                "Long": 88.8788
              },
              {
                "Area": "Pailachhanpur",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.2758,
                "Long": 88.831
              },
              {
                "Area": "Paithan",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 20.0837,
                "Long": 76.5642
              },
              {
                "Area": "Pajhota",
                "State": "Himachal Pradesh",
                "CountryCode": "IN",
                "Lat": 31.7362,
                "Long": 77.3549
              },
              {
                "Area": "Pakala",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 13.7206,
                "Long": 79.359
              },
              {
                "Area": "Pakari Dayal",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.7425,
                "Long": 84.9263
              },
              {
                "Area": "Pakaur",
                "State": "Jharkhand",
                "CountryCode": "IN",
                "Lat": 24.6508,
                "Long": 87.8033
              },
              {
                "Area": "Pakhanjore",
                "State": "Chattisgarh",
                "CountryCode": "IN",
                "Lat": 20.7618,
                "Long": 81.1292
              },
              {
                "Area": "Pakherpora",
                "State": "Jammu & Kashmir",
                "CountryCode": "IN",
                "Lat": 33.8463,
                "Long": 74.8035
              },
              {
                "Area": "Pakri Dayal",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.6184,
                "Long": 84.9247
              },
              {
                "Area": "Pakribarawan",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.1956,
                "Long": 85.8633
              },
              {
                "Area": "Pakribari",
                "State": "Assam",
                "CountryCode": "IN",
                "Lat": 26.7306,
                "Long": 91.5564
              },
              {
                "Area": "Pakribrawana",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 24.9444,
                "Long": 85.6646
              },
              {
                "Area": "Pakur",
                "State": "Jharkhand",
                "CountryCode": "IN",
                "Lat": 24.681,
                "Long": 87.8864
              },
              {
                "Area": "Pakuria",
                "State": "Jharkhand",
                "CountryCode": "IN",
                "Lat": 24.3942,
                "Long": 87.7424
              },
              {
                "Area": "Pakyong",
                "State": "Sikkim",
                "CountryCode": "IN",
                "Lat": 27.2473,
                "Long": 88.5903
              },
              {
                "Area": "Palacode",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 12.489,
                "Long": 78.3383
              },
              {
                "Area": "Palacole",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.5911,
                "Long": 81.1919
              },
              {
                "Area": "Palair",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 17.6435,
                "Long": 81.073
              },
              {
                "Area": "Palakkad",
                "State": "Kerala",
                "CountryCode": "IN",
                "Lat": 10.8711,
                "Long": 76.8363
              },
              {
                "Area": "Palakkodu",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 12.3804,
                "Long": 78.1995
              },
              {
                "Area": "Palakoderu (mdl)",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.7776,
                "Long": 81.6742
              },
              {
                "Area": "Palakoderu Mandalam",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 17.5283,
                "Long": 82.307
              },
              {
                "Area": "Palakoderu(mdl)",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.5842,
                "Long": 81.4741
              },
              {
                "Area": "Palakol (mdl)",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.8946,
                "Long": 81.7417
              },
              {
                "Area": "Palakol(mdl)",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.5911,
                "Long": 81.1919
              },
              {
                "Area": "Palakonda",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 18.682,
                "Long": 83.7712
              },
              {
                "Area": "Palakurthy",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 17.955,
                "Long": 79.6699
              },
              {
                "Area": "Palam",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 19.4656,
                "Long": 76.9493
              },
              {
                "Area": "Palam Road",
                "State": "Haryana",
                "CountryCode": "IN",
                "Lat": 28.4001,
                "Long": 76.9661
              },
              {
                "Area": "Palam Vihar",
                "State": "Haryana",
                "CountryCode": "IN",
                "Lat": 28.4001,
                "Long": 76.9661
              },
              {
                "Area": "Palamaner",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 13.7135,
                "Long": 79.3099
              },
              {
                "Area": "Palampur",
                "State": "Himachal Pradesh",
                "CountryCode": "IN",
                "Lat": 32.1796,
                "Long": 76.9764
              },
              {
                "Area": "Palani",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 11.0299,
                "Long": 77.8657
              },
              {
                "Area": "Palanpur",
                "State": "Gujarat",
                "CountryCode": "IN",
                "Lat": 24.3221,
                "Long": 72.8268
              },
              {
                "Area": "Palasa",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 18.7593,
                "Long": 84.4161
              },
              {
                "Area": "Palasa Mandal",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 18.8031,
                "Long": 84.4101
              },
              {
                "Area": "Palasamudram",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 13.1995,
                "Long": 79.398
              },
              {
                "Area": "Palasbari Circle",
                "State": "Assam",
                "CountryCode": "IN",
                "Lat": 26.1691,
                "Long": 91.6771
              },
              {
                "Area": "Palashbari Circle",
                "State": "Assam",
                "CountryCode": "IN",
                "Lat": 26.1691,
                "Long": 91.6771
              },
              {
                "Area": "Palashipara",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.692,
                "Long": 88.5215
              },
              {
                "Area": "Palayamkottai",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 8.7987,
                "Long": 77.9969
              },
              {
                "Area": "Palayankottai",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 8.7586,
                "Long": 77.9969
              },
              {
                "Area": "Paldhui",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 21.7344,
                "Long": 87.5491
              },
              {
                "Area": "Palem",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 16.684,
                "Long": 78.6796
              },
              {
                "Area": "Palera",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 25.2741,
                "Long": 79.3184
              },
              {
                "Area": "Palghar",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 19.8762,
                "Long": 74.3807
              },
              {
                "Area": "Palhawas",
                "State": "Haryana",
                "CountryCode": "IN",
                "Lat": 28.3572,
                "Long": 76.6202
              },
              {
                "Area": "Palhepur",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.2687,
                "Long": 80.3999
              },
              {
                "Area": "Pali",
                "State": "Chattisgarh",
                "CountryCode": "IN",
                "Lat": 22.9486,
                "Long": 82.6119
              },
              {
                "Area": "Pali",
                "State": "Haryana",
                "CountryCode": "IN",
                "Lat": 28.1729,
                "Long": 76.4583
              },
              {
                "Area": "Pali",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 26.0111,
                "Long": 73.5833
              },
              {
                "Area": "Pali  Mwr",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 25.8937,
                "Long": 73.4269
              },
              {
                "Area": "Pali Marwar",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 25.4763,
                "Long": 73.3952
              },
              {
                "Area": "Pali Mwr",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 26.3503,
                "Long": 74.1921
              },
              {
                "Area": "Palia",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 28.1225,
                "Long": 81.7008
              },
              {
                "Area": "Palibhogipur",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.2843,
                "Long": 80.3637
              },
              {
                "Area": "Paliganj",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.5018,
                "Long": 85.2222
              },
              {
                "Area": "Palin",
                "State": "Arunachal Pradesh",
                "CountryCode": "IN",
                "Lat": 27.964,
                "Long": 93.5532
              },
              {
                "Area": "Palitana",
                "State": "Gujarat",
                "CountryCode": "IN",
                "Lat": 22.0166,
                "Long": 72.2501
              },
              {
                "Area": "Palkot",
                "State": "Jharkhand",
                "CountryCode": "IN",
                "Lat": 23.0451,
                "Long": 84.8378
              },
              {
                "Area": "Palla",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.8451,
                "Long": 88.5958
              },
              {
                "Area": "Palladam",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 12.596,
                "Long": 80.1486
              },
              {
                "Area": "Pallahara",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 21.5727,
                "Long": 85.2941
              },
              {
                "Area": "Pallari",
                "State": "Chattisgarh",
                "CountryCode": "IN",
                "Lat": 21.5983,
                "Long": 82.3219
              },
              {
                "Area": "Pallel",
                "State": "Manipur",
                "CountryCode": "IN",
                "Lat": 24.3613,
                "Long": 94.0672
              },
              {
                "Area": "Pallia",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 27.2474,
                "Long": 81.7008
              },
              {
                "Area": "Pallipat",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 13.2874,
                "Long": 79.94
              },
              {
                "Area": "Pallipattu",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 13.3386,
                "Long": 79.4449
              },
              {
                "Area": "Palojori",
                "State": "Jharkhand",
                "CountryCode": "IN",
                "Lat": 24.3773,
                "Long": 87.5731
              },
              {
                "Area": "Paloncha",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 18.4306,
                "Long": 80.9674
              },
              {
                "Area": "Palpara",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.3836,
                "Long": 87.8747
              },
              {
                "Area": "Palri Panihara",
                "State": "Haryana",
                "CountryCode": "IN",
                "Lat": 28.4851,
                "Long": 76.4735
              },
              {
                "Area": "Palsana",
                "State": "Gujarat",
                "CountryCode": "IN",
                "Lat": 23.0041,
                "Long": 73.5532
              },
              {
                "Area": "Palsanda",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 24.2391,
                "Long": 87.7837
              },
              {
                "Area": "Palsandapur",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.3836,
                "Long": 87.8747
              },
              {
                "Area": "Palta",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.8347,
                "Long": 88.4655
              },
              {
                "Area": "Palus",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 19.3701,
                "Long": 76.5787
              },
              {
                "Area": "Palwal",
                "State": "Haryana",
                "CountryCode": "IN",
                "Lat": 28.3327,
                "Long": 77.4108
              },
              {
                "Area": "Palwancha",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 17.9984,
                "Long": 80.6455
              },
              {
                "Area": "Pamarru",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 17.5795,
                "Long": 82.206
              },
              {
                "Area": "Pamaru",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.9794,
                "Long": 81.6933
              },
              {
                "Area": "Pamdharpur",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 18.3987,
                "Long": 75.0234
              },
              {
                "Area": "Pamgarh",
                "State": "Chattisgarh",
                "CountryCode": "IN",
                "Lat": 21.9262,
                "Long": 82.7379
              },
              {
                "Area": "Pamidi",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 14.9876,
                "Long": 77.8791
              },
              {
                "Area": "Pampore",
                "State": "Jammu & Kashmir",
                "CountryCode": "IN",
                "Lat": 34.0333,
                "Long": 74.9251
              },
              {
                "Area": "Pamulapadu",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 15.8394,
                "Long": 78.4897
              },
              {
                "Area": "Panabasti",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 26.8537,
                "Long": 89.0856
              },
              {
                "Area": "Panakura",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.4042,
                "Long": 87.7175
              },
              {
                "Area": "Panapur",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.166,
                "Long": 84.8555
              },
              {
                "Area": "Panchahari",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.3836,
                "Long": 87.8747
              },
              {
                "Area": "Panchamahals",
                "State": "Gujarat",
                "CountryCode": "IN",
                "Lat": 22.7793,
                "Long": 74.3404
              },
              {
                "Area": "Panchanandapur",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 24.2529,
                "Long": 88.039
              },
              {
                "Area": "Panchberia",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.8889,
                "Long": 88.4146
              },
              {
                "Area": "Panchetgarh",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 24.5163,
                "Long": 87.8093
              },
              {
                "Area": "Panchita",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.1069,
                "Long": 88.8236
              },
              {
                "Area": "Panchkula",
                "State": "Haryana",
                "CountryCode": "IN",
                "Lat": 30.7987,
                "Long": 77.1459
              },
              {
                "Area": "Panchla",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.526,
                "Long": 88.0676
              },
              {
                "Area": "Panchmile",
                "State": "Assam",
                "CountryCode": "IN",
                "Lat": 26.5735,
                "Long": 91.1499
              },
              {
                "Area": "Panchpota",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.5022,
                "Long": 88.8563
              },
              {
                "Area": "Panchrol",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 21.8104,
                "Long": 87.448
              },
              {
                "Area": "Panchuria",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.0208,
                "Long": 87.7744
              },
              {
                "Area": "Pandaak",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.3393,
                "Long": 85.7699
              },
              {
                "Area": "Pandabeswar",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 24.3192,
                "Long": 88.4456
              },
              {
                "Area": "Pandalur",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 11.5524,
                "Long": 76.6838
              },
              {
                "Area": "Pandarak",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.4705,
                "Long": 85.8406
              },
              {
                "Area": "Pandaria",
                "State": "Chattisgarh",
                "CountryCode": "IN",
                "Lat": 22.1871,
                "Long": 81.6914
              },
              {
                "Area": "Pandariya",
                "State": "Chattisgarh",
                "CountryCode": "IN",
                "Lat": 22.3601,
                "Long": 81.4619
              },
              {
                "Area": "Pandaul",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.4057,
                "Long": 86.2179
              },
              {
                "Area": "Pandavapura",
                "State": "Karnataka",
                "CountryCode": "IN",
                "Lat": 12.7023,
                "Long": 76.9898
              },
              {
                "Area": "Pandaveshwar",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 24.2994,
                "Long": 87.8981
              },
              {
                "Area": "Pandaveshwr",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.65,
                "Long": 87.0047
              },
              {
                "Area": "Pandaveswar",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.65,
                "Long": 87.0047
              },
              {
                "Area": "Pandhana",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 22.4434,
                "Long": 76.9775
              },
              {
                "Area": "Pandharpur",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 18.7801,
                "Long": 76.283
              },
              {
                "Area": "Pandhurna",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 22.1214,
                "Long": 78.8555
              },
              {
                "Area": "Pandua",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 24.1703,
                "Long": 88.2864
              },
              {
                "Area": "Panduka",
                "State": "Chattisgarh",
                "CountryCode": "IN",
                "Lat": 21.3432,
                "Long": 82.174
              },
              {
                "Area": "Panerihat",
                "State": "Assam",
                "CountryCode": "IN",
                "Lat": 26.6138,
                "Long": 92.0365
              },
              {
                "Area": "Pangal",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 16.4935,
                "Long": 78.3415
              },
              {
                "Area": "Pangei Yangdong S.O",
                "State": "Manipur",
                "CountryCode": "IN",
                "Lat": 24.9574,
                "Long": 94.0242
              },
              {
                "Area": "Pangi",
                "State": "Himachal Pradesh",
                "CountryCode": "IN",
                "Lat": 33.1184,
                "Long": 76.4793
              },
              {
                "Area": "Panhala",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 18.5613,
                "Long": 74.5193
              },
              {
                "Area": "Pania",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.0015,
                "Long": 87.6242
              },
              {
                "Area": "Panichiary",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 24.3444,
                "Long": 87.9089
              },
              {
                "Area": "Panigaon",
                "State": "Assam",
                "CountryCode": "IN",
                "Lat": 27.169,
                "Long": 94.1258
              },
              {
                "Area": "Paniparul",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 21.7495,
                "Long": 87.5362
              },
              {
                "Area": "Panipat",
                "State": "Haryana",
                "CountryCode": "IN",
                "Lat": 29.8721,
                "Long": 77.1181
              },
              {
                "Area": "Panipat  panipat",
                "State": "Haryana",
                "CountryCode": "IN",
                "Lat": 29.3326,
                "Long": 76.9263
              },
              {
                "Area": "Panisagar",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 24.1597,
                "Long": 92.0329
              },
              {
                "Area": "Panitar",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.6809,
                "Long": 88.9039
              },
              {
                "Area": "Pankhai",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 21.8532,
                "Long": 87.9147
              },
              {
                "Area": "Panki",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.4731,
                "Long": 80.2407
              },
              {
                "Area": "Panki",
                "State": "Jharkhand",
                "CountryCode": "IN",
                "Lat": 24.1043,
                "Long": 84.5376
              },
              {
                "Area": "Panna",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 24.8684,
                "Long": 80.4397
              },
              {
                "Area": "Pannur",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 13.232,
                "Long": 79.767
              },
              {
                "Area": "Panruti",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 11.9033,
                "Long": 79.6238
              },
              {
                "Area": "Pansemal",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 21.9083,
                "Long": 75.1857
              },
              {
                "Area": "Panskura",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.1207,
                "Long": 88.1081
              },
              {
                "Area": "Panskura Ii",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.4325,
                "Long": 87.8594
              },
              {
                "Area": "Panskura-i",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.1207,
                "Long": 87.8175
              },
              {
                "Area": "Panskura-ii",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.1207,
                "Long": 87.8594
              },
              {
                "Area": "Pantha Chowk",
                "State": "Jammu & Kashmir",
                "CountryCode": "IN",
                "Lat": 34.0377,
                "Long": 74.9046
              },
              {
                "Area": "Panthalur",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 11.5437,
                "Long": 76.6831
              },
              {
                "Area": "Panvel",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 20.5376,
                "Long": 75.0529
              },
              {
                "Area": "Panyam",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 15.4894,
                "Long": 78.3545
              },
              {
                "Area": "Panzeth",
                "State": "Jammu & Kashmir",
                "CountryCode": "IN",
                "Lat": 33.5339,
                "Long": 75.1844
              },
              {
                "Area": "Paonta",
                "State": "Himachal Pradesh",
                "CountryCode": "IN",
                "Lat": 30.7433,
                "Long": 77.7664
              },
              {
                "Area": "Papanasam",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 11.2208,
                "Long": 79.3582
              },
              {
                "Area": "Papannapet",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 18.0367,
                "Long": 78.0882
              },
              {
                "Area": "Paparahandi",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 19.35,
                "Long": 82.7452
              },
              {
                "Area": "Pappireddipatti",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 12.1266,
                "Long": 78.4138
              },
              {
                "Area": "Pappiredipatti",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 12.1266,
                "Long": 78.3114
              },
              {
                "Area": "Para",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.5433,
                "Long": 86.7136
              },
              {
                "Area": "Parade",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.5442,
                "Long": 80.1097
              },
              {
                "Area": "Paradip",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 20.7115,
                "Long": 86.6085
              },
              {
                "Area": "Paragana",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.6315,
                "Long": 87.428
              },
              {
                "Area": "Paraisa",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 22.1761,
                "Long": 78.8057
              },
              {
                "Area": "Paraiya",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 24.8645,
                "Long": 84.8834
              },
              {
                "Area": "Parajang",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 21.0411,
                "Long": 85.3528
              },
              {
                "Area": "Paralakhemundi",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 19.8979,
                "Long": 84.4422
              },
              {
                "Area": "Paralkhemundi",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 18.9256,
                "Long": 83.855
              },
              {
                "Area": "Paramakudi",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 9.7088,
                "Long": 78.783
              },
              {
                "Area": "Paramathi Velur",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 11.4902,
                "Long": 78.3373
              },
              {
                "Area": "Paramathi-Velur",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 11.4902,
                "Long": 78.7729
              },
              {
                "Area": "Paramathivelur",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 11.2443,
                "Long": 77.9955
              },
              {
                "Area": "Paramthi Velur",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 11.3972,
                "Long": 77.9709
              },
              {
                "Area": "Paramthivelur",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 11.1746,
                "Long": 78.0742
              },
              {
                "Area": "Paranda",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 19.3105,
                "Long": 76.0388
              },
              {
                "Area": "Parasadepur",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.3801,
                "Long": 80.4141
              },
              {
                "Area": "Parasgad",
                "State": "Karnataka",
                "CountryCode": "IN",
                "Lat": 15.7891,
                "Long": 75.1673
              },
              {
                "Area": "Parasia",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 22.6143,
                "Long": 79.2221
              },
              {
                "Area": "Paratwada",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 21.1977,
                "Long": 77.5561
              },
              {
                "Area": "Paravada",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 18.1752,
                "Long": 83.7157
              },
              {
                "Area": "Paravur",
                "State": "Kerala",
                "CountryCode": "IN",
                "Lat": 11.7352,
                "Long": 76.8295
              },
              {
                "Area": "Parbatpur",
                "State": "Assam",
                "CountryCode": "IN",
                "Lat": 27.1939,
                "Long": 95.3193
              },
              {
                "Area": "Parbatsar",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 27.8037,
                "Long": 75.1435
              },
              {
                "Area": "Parbatta",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.4526,
                "Long": 86.7982
              },
              {
                "Area": "Parbhani",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 19.6096,
                "Long": 77.0393
              },
              {
                "Area": "Parchur",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.0224,
                "Long": 80.3134
              },
              {
                "Area": "Pardi",
                "State": "Gujarat",
                "CountryCode": "IN",
                "Lat": 21.7371,
                "Long": 73.4941
              },
              {
                "Area": "Pardi",
                "State": "Dadra & Nagar Haveli",
                "CountryCode": "IN",
                "Lat": 23.0929,
                "Long": 73.9679
              },
              {
                "Area": "Parghumti",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.4323,
                "Long": 88.373
              },
              {
                "Area": "Parigi",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 14.5099,
                "Long": 78.2267
              },
              {
                "Area": "Parihar",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.7114,
                "Long": 86.2081
              },
              {
                "Area": "Parikudagarh",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 19.5667,
                "Long": 85.25
              },
              {
                "Area": "Parimpora",
                "State": "Jammu & Kashmir",
                "CountryCode": "IN",
                "Lat": 34.14,
                "Long": 74.7964
              },
              {
                "Area": "Park Circus",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.8436,
                "Long": 88.2293
              },
              {
                "Area": "Parkal",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 18.3096,
                "Long": 80.2037
              },
              {
                "Area": "Parlakhemundi",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 19.7296,
                "Long": 84.6466
              },
              {
                "Area": "Parli",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 19.3667,
                "Long": 76.659
              },
              {
                "Area": "Parli Vai.j",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 18.8732,
                "Long": 76.5028
              },
              {
                "Area": "Parli Vaij.",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 19.3667,
                "Long": 76.6364
              },
              {
                "Area": "Parli Vaijinath",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 19.3667,
                "Long": 76.4304
              },
              {
                "Area": "Parlivaij",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 18.8965,
                "Long": 76.5647
              },
              {
                "Area": "Parlu",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 25.8921,
                "Long": 73.1059
              },
              {
                "Area": "Parner",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 20.0761,
                "Long": 75.5161
              },
              {
                "Area": "Paro",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 25.4511,
                "Long": 87.9426
              },
              {
                "Area": "Paroi",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.8923,
                "Long": 87.3704
              },
              {
                "Area": "Parola",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 21.2436,
                "Long": 76.0662
              },
              {
                "Area": "Paroo",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.1791,
                "Long": 85.5245
              },
              {
                "Area": "Parpatna",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.8151,
                "Long": 88.4296
              },
              {
                "Area": "Parsa",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.9326,
                "Long": 85.1125
              },
              {
                "Area": "Parsauli",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.4448,
                "Long": 79.8571
              },
              {
                "Area": "Parsauni",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.576,
                "Long": 85.5397
              },
              {
                "Area": "Parseoni",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 21.5851,
                "Long": 79.3684
              },
              {
                "Area": "Parsibagan",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.7101,
                "Long": 88.3167
              },
              {
                "Area": "Parsioni",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 21.3102,
                "Long": 79.4524
              },
              {
                "Area": "Partabgarh",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 25.3221,
                "Long": 74.8175
              },
              {
                "Area": "Partapgarh",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 24.8287,
                "Long": 74.7797
              },
              {
                "Area": "Partapnagar",
                "State": "Uttarakhand",
                "CountryCode": "IN",
                "Lat": 30.0308,
                "Long": 78.7765
              },
              {
                "Area": "Partur",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 19.8011,
                "Long": 76.2856
              },
              {
                "Area": "Parur",
                "State": "Kerala",
                "CountryCode": "IN",
                "Lat": 10.1039,
                "Long": 76.4103
              },
              {
                "Area": "Parvathagiri",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 17.9552,
                "Long": 79.7992
              },
              {
                "Area": "Parvathipuram",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 18.8043,
                "Long": 83.4677
              },
              {
                "Area": "Parvatipuram",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 18.8359,
                "Long": 83.5534
              },
              {
                "Area": "Parwalpur",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.3536,
                "Long": 85.4559
              },
              {
                "Area": "Parwathagiri",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 17.7617,
                "Long": 79.779
              },
              {
                "Area": "Paschim Bamunia",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.3836,
                "Long": 87.8747
              },
              {
                "Area": "Paschim Dalucherra",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 23.9923,
                "Long": 91.6205
              },
              {
                "Area": "Paschim Ddwarikapur",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 23.9225,
                "Long": 91.6031
              },
              {
                "Area": "Paschim Hmunpui",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 24.1597,
                "Long": 92.0329
              },
              {
                "Area": "Paschim Karingicherra",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 24.0796,
                "Long": 91.5997
              },
              {
                "Area": "Paschim Laxmicherra",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 24.0796,
                "Long": 91.5997
              },
              {
                "Area": "Paschim Madhyampur",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.286,
                "Long": 88.2996
              },
              {
                "Area": "Paschim Malikberia",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.8767,
                "Long": 88.585
              },
              {
                "Area": "Paschim Manikpur",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.871,
                "Long": 88.0316
              },
              {
                "Area": "Paschim Palta",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.5239,
                "Long": 87.8703
              },
              {
                "Area": "Paschim Sonatala",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 24.0796,
                "Long": 91.5997
              },
              {
                "Area": "Paschimbelcherra",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 24.0796,
                "Long": 91.5997
              },
              {
                "Area": "Paschimkalyanpur",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 23.9225,
                "Long": 91.6031
              },
              {
                "Area": "Pashchim Narayanpur",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 24.5939,
                "Long": 87.7973
              },
              {
                "Area": "Pasighat",
                "State": "Arunachal Pradesh",
                "CountryCode": "IN",
                "Lat": 28.4345,
                "Long": 95.3268
              },
              {
                "Area": "Pasight",
                "State": "Arunachal Pradesh",
                "CountryCode": "IN",
                "Lat": 28.3184,
                "Long": 95.077
              },
              {
                "Area": "Pasonda",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 28.685,
                "Long": 77.3526
              },
              {
                "Area": "Pastana",
                "State": "Jammu & Kashmir",
                "CountryCode": "IN",
                "Lat": 33.9306,
                "Long": 75.1134
              },
              {
                "Area": "Patacharkuchi",
                "State": "Assam",
                "CountryCode": "IN",
                "Lat": 26.5167,
                "Long": 91.2667
              },
              {
                "Area": "Pataghat",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.8209,
                "Long": 86.7691
              },
              {
                "Area": "Patah",
                "State": "Chattisgarh",
                "CountryCode": "IN",
                "Lat": 21.0333,
                "Long": 81.5333
              },
              {
                "Area": "Patahi",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.083,
                "Long": 85.689
              },
              {
                "Area": "Patamda",
                "State": "Jharkhand",
                "CountryCode": "IN",
                "Lat": 23.3302,
                "Long": 86.4527
              },
              {
                "Area": "Patan",
                "State": "Chattisgarh",
                "CountryCode": "IN",
                "Lat": 21.7968,
                "Long": 81.6326
              },
              {
                "Area": "Patan",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 23.3722,
                "Long": 79.9765
              },
              {
                "Area": "Patan",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 20.9402,
                "Long": 77.2104
              },
              {
                "Area": "Patan",
                "State": "Gujarat",
                "CountryCode": "IN",
                "Lat": 24.0347,
                "Long": 73.2181
              },
              {
                "Area": "Patan",
                "State": "Jharkhand",
                "CountryCode": "IN",
                "Lat": 24.2266,
                "Long": 84.4036
              },
              {
                "Area": "Patan-Veraval",
                "State": "Gujarat",
                "CountryCode": "IN",
                "Lat": 21.7402,
                "Long": 71.6647
              },
              {
                "Area": "Patan.",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 17.5477,
                "Long": 74.065
              },
              {
                "Area": "Patancheru",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 18.1887,
                "Long": 79.0729
              },
              {
                "Area": "Patarghat",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.8346,
                "Long": 86.8474
              },
              {
                "Area": "Patashpur",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.8386,
                "Long": 88.171
              },
              {
                "Area": "Pataudi",
                "State": "Haryana",
                "CountryCode": "IN",
                "Lat": 28.3255,
                "Long": 76.7786
              },
              {
                "Area": "Patdi",
                "State": "Gujarat",
                "CountryCode": "IN",
                "Lat": 23.3805,
                "Long": 72.5655
              },
              {
                "Area": "Patepur",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.8803,
                "Long": 85.5784
              },
              {
                "Area": "Patera",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 24.2073,
                "Long": 79.8665
              },
              {
                "Area": "Paterhi Belsar",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.9427,
                "Long": 85.3491
              },
              {
                "Area": "Pathadi",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 19.1644,
                "Long": 74.3729
              },
              {
                "Area": "Pathalgaon",
                "State": "Chattisgarh",
                "CountryCode": "IN",
                "Lat": 22.8004,
                "Long": 83.8664
              },
              {
                "Area": "Pathalgoan",
                "State": "Chattisgarh",
                "CountryCode": "IN",
                "Lat": 22.8004,
                "Long": 83.8664
              },
              {
                "Area": "Pathalipahar",
                "State": "Assam",
                "CountryCode": "IN",
                "Lat": 26.782,
                "Long": 93.6636
              },
              {
                "Area": "Pathalipam",
                "State": "Assam",
                "CountryCode": "IN",
                "Lat": 27.4255,
                "Long": 94.2933
              },
              {
                "Area": "Pathanapuram",
                "State": "Kerala",
                "CountryCode": "IN",
                "Lat": 9.1286,
                "Long": 77.0667
              },
              {
                "Area": "Pathankot",
                "State": "Punjab",
                "CountryCode": "IN",
                "Lat": 32.4004,
                "Long": 75.7721
              },
              {
                "Area": "Pathapatnam",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 18.5609,
                "Long": 83.7854
              },
              {
                "Area": "Pathapatnam Mandal",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 18.5609,
                "Long": 83.7854
              },
              {
                "Area": "Pathar Pratima",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.4353,
                "Long": 88.4168
              },
              {
                "Area": "Pathardi",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 19.7058,
                "Long": 76.0529
              },
              {
                "Area": "Pathargama",
                "State": "Jharkhand",
                "CountryCode": "IN",
                "Lat": 25.0221,
                "Long": 87.2372
              },
              {
                "Area": "Patharghata",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.5685,
                "Long": 88.5248
              },
              {
                "Area": "Patharia",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 23.8688,
                "Long": 79.684
              },
              {
                "Area": "Patharia",
                "State": "Chattisgarh",
                "CountryCode": "IN",
                "Lat": 22.2423,
                "Long": 82.7115
              },
              {
                "Area": "Pathariya",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 23.9872,
                "Long": 79.4923
              },
              {
                "Area": "Patharpratima",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.5961,
                "Long": 88.3402
              },
              {
                "Area": "Pathera",
                "State": "Haryana",
                "CountryCode": "IN",
                "Lat": 28.3732,
                "Long": 76.8881
              },
              {
                "Area": "Pathergama",
                "State": "Jharkhand",
                "CountryCode": "IN",
                "Lat": 25.1584,
                "Long": 87.4709
              },
              {
                "Area": "Pathghoria",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.4323,
                "Long": 88.373
              },
              {
                "Area": "Pathna",
                "State": "Jharkhand",
                "CountryCode": "IN",
                "Lat": 25.2076,
                "Long": 87.7409
              },
              {
                "Area": "Pathorighat",
                "State": "Assam",
                "CountryCode": "IN",
                "Lat": 26.6676,
                "Long": 92.4009
              },
              {
                "Area": "Pathra",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.4143,
                "Long": 87.267
              },
              {
                "Area": "Pathri",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 19.3589,
                "Long": 76.703
              },
              {
                "Area": "Pathsala",
                "State": "Assam",
                "CountryCode": "IN",
                "Lat": 26.6325,
                "Long": 91.6412
              },
              {
                "Area": "Pathsimulia",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.5022,
                "Long": 88.5404
              },
              {
                "Area": "Patiala",
                "State": "Punjab",
                "CountryCode": "IN",
                "Lat": 30.4562,
                "Long": 76.5844
              },
              {
                "Area": "Patiali",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 28.1485,
                "Long": 79.1954
              },
              {
                "Area": "Patilana",
                "State": "Gujarat",
                "CountryCode": "IN",
                "Lat": 21.9343,
                "Long": 72.2501
              },
              {
                "Area": "Patipukur",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.6,
                "Long": 88.4
              },
              {
                "Area": "Patisain",
                "State": "Uttarakhand",
                "CountryCode": "IN",
                "Lat": 29.9742,
                "Long": 78.9474
              },
              {
                "Area": "Patiyali",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 27.0839,
                "Long": 79.1286
              },
              {
                "Area": "Patkijuli",
                "State": "Assam",
                "CountryCode": "IN",
                "Lat": 26.7306,
                "Long": 91.5564
              },
              {
                "Area": "Patkura",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 20.4503,
                "Long": 83.0484
              },
              {
                "Area": "Patna",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.5834,
                "Long": 85.2998
              },
              {
                "Area": "Patna",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 21.8672,
                "Long": 85.8491
              },
              {
                "Area": "Patna City",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.5096,
                "Long": 85.3732
              },
              {
                "Area": "Patna Sadar",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.6816,
                "Long": 85.9919
              },
              {
                "Area": "Patnagarh",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 21.052,
                "Long": 83.9932
              },
              {
                "Area": "Patngarh",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 20.5905,
                "Long": 83.1739
              },
              {
                "Area": "Patoda",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 19.2612,
                "Long": 76.3729
              },
              {
                "Area": "Patori",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.8253,
                "Long": 85.8514
              },
              {
                "Area": "Patrasayer",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.141,
                "Long": 88.2308
              },
              {
                "Area": "Patratu",
                "State": "Jharkhand",
                "CountryCode": "IN",
                "Lat": 24.2897,
                "Long": 85.7588
              },
              {
                "Area": "Patsalatadiparru",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.1017,
                "Long": 80.4988
              },
              {
                "Area": "Pattamundai",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 21.2713,
                "Long": 86.7253
              },
              {
                "Area": "Pattan",
                "State": "Jammu & Kashmir",
                "CountryCode": "IN",
                "Lat": 34.1872,
                "Long": 74.638
              },
              {
                "Area": "Patti",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.257,
                "Long": 82.3745
              },
              {
                "Area": "Patti",
                "State": "Punjab",
                "CountryCode": "IN",
                "Lat": 31.4624,
                "Long": 75.1835
              },
              {
                "Area": "Pattikonda",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 15.553,
                "Long": 77.5964
              },
              {
                "Area": "Pattukkottai",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 10.9235,
                "Long": 79.4329
              },
              {
                "Area": "Pattukottai",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 10.6716,
                "Long": 79.4371
              },
              {
                "Area": "Patukottai",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 10.436,
                "Long": 79.3791
              },
              {
                "Area": "Patul",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 25.1367,
                "Long": 88.0923
              },
              {
                "Area": "Pauni",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 21.3208,
                "Long": 79.8015
              },
              {
                "Area": "Paupparapatti",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 12.2023,
                "Long": 78.0584
              },
              {
                "Area": "Pauri",
                "State": "Uttarakhand",
                "CountryCode": "IN",
                "Lat": 30.2209,
                "Long": 79.0403
              },
              {
                "Area": "Paushi",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 24.3444,
                "Long": 87.9089
              },
              {
                "Area": "Pavagada",
                "State": "Karnataka",
                "CountryCode": "IN",
                "Lat": 14.2871,
                "Long": 77.4196
              },
              {
                "Area": "Pavijetpur",
                "State": "Gujarat",
                "CountryCode": "IN",
                "Lat": 23.1577,
                "Long": 73.9551
              },
              {
                "Area": "Pawai",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 24.7562,
                "Long": 80.4008
              },
              {
                "Area": "Pawathagiri",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 17.7762,
                "Long": 79.7056
              },
              {
                "Area": "Paya-medinipur",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 21.6278,
                "Long": 87.5197
              },
              {
                "Area": "Payagpur",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 27.5478,
                "Long": 81.6597
              },
              {
                "Area": "Payagpur **",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 27.5757,
                "Long": 81.9028
              },
              {
                "Area": "Payal",
                "State": "Punjab",
                "CountryCode": "IN",
                "Lat": 31.164,
                "Long": 76.3539
              },
              {
                "Area": "Payasampalle",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 14.5942,
                "Long": 78.5363
              },
              {
                "Area": "Payum",
                "State": "Arunachal Pradesh",
                "CountryCode": "IN",
                "Lat": 28.2358,
                "Long": 94.6742
              },
              {
                "Area": "Peapally",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 15.3544,
                "Long": 77.9407
              },
              {
                "Area": "Pearacherra",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 24.1597,
                "Long": 92.0329
              },
              {
                "Area": "Pebbair",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 16.447,
                "Long": 78.7133
              },
              {
                "Area": "Pechardahar",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 24.0789,
                "Long": 91.8987
              },
              {
                "Area": "Pecharthal",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 24.1597,
                "Long": 92.0329
              },
              {
                "Area": "Peda  Araveedu",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 15.9007,
                "Long": 79.2836
              },
              {
                "Area": "Pedabayalu",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 18.3433,
                "Long": 82.9205
              },
              {
                "Area": "Pedagantyada",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 17.926,
                "Long": 83.3409
              },
              {
                "Area": "Pedakakani",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.4327,
                "Long": 80.6598
              },
              {
                "Area": "Pedakakani Mandal",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.3796,
                "Long": 80.5189
              },
              {
                "Area": "Pedakurapadu",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.5682,
                "Long": 80.2372
              },
              {
                "Area": "Pedakurpadu",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.471,
                "Long": 80.2568
              },
              {
                "Area": "Pedamajjipalem",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 18.1845,
                "Long": 83.262
              },
              {
                "Area": "Pedamanapuram",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 18.446,
                "Long": 83.4121
              },
              {
                "Area": "Pedana",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.7243,
                "Long": 81.1438
              },
              {
                "Area": "Pedanandipadu",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.0879,
                "Long": 80.3965
              },
              {
                "Area": "Pedapadu",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.5842,
                "Long": 81.0381
              },
              {
                "Area": "Pedapalem",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.3131,
                "Long": 80.5147
              },
              {
                "Area": "Pedaparupudi",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.4933,
                "Long": 80.9687
              },
              {
                "Area": "Pedapudi",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 17.6965,
                "Long": 82.8082
              },
              {
                "Area": "Pedavadlapudi",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.4377,
                "Long": 80.6263
              },
              {
                "Area": "Pedda Adiserla Palle",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 17.0638,
                "Long": 79.1658
              },
              {
                "Area": "Pedda Mandadi",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 16.4935,
                "Long": 78.3415
              },
              {
                "Area": "Pedda Vadagur",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 15.0001,
                "Long": 77.7295
              },
              {
                "Area": "Peddakothapally",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 17.0926,
                "Long": 78.5161
              },
              {
                "Area": "Peddamandadi",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 17.1796,
                "Long": 78.7719
              },
              {
                "Area": "Peddamudium",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 14.4599,
                "Long": 78.7836
              },
              {
                "Area": "Peddapalle",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 18.5497,
                "Long": 79.2409
              },
              {
                "Area": "Peddapalli",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 18.5387,
                "Long": 79.0803
              },
              {
                "Area": "Peddapalli",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 18.8095,
                "Long": 79.6251
              },
              {
                "Area": "Peddapanjani",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 13.526,
                "Long": 78.7411
              },
              {
                "Area": "Peddapappur",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 14.8742,
                "Long": 78.1477
              },
              {
                "Area": "Peddapappuru",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 14.9433,
                "Long": 77.9128
              },
              {
                "Area": "Peddapuram",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 17.1793,
                "Long": 82.2141
              },
              {
                "Area": "Peddarachapalli",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 14.6195,
                "Long": 79.1012
              },
              {
                "Area": "Peddavadugur",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 15.0641,
                "Long": 77.7961
              },
              {
                "Area": "Peddavoora",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 16.8399,
                "Long": 79.1442
              },
              {
                "Area": "Peelwa",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 26.8406,
                "Long": 72.5313
              },
              {
                "Area": "Peermade",
                "State": "Kerala",
                "CountryCode": "IN",
                "Lat": 9.9969,
                "Long": 77.1272
              },
              {
                "Area": "Peerumade",
                "State": "Kerala",
                "CountryCode": "IN",
                "Lat": 9.9969,
                "Long": 77.16
              },
              {
                "Area": "Pegadapalli",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 18.7632,
                "Long": 79.2162
              },
              {
                "Area": "Pehowa",
                "State": "Haryana",
                "CountryCode": "IN",
                "Lat": 30.1664,
                "Long": 76.7862
              },
              {
                "Area": "Pehwoa",
                "State": "Haryana",
                "CountryCode": "IN",
                "Lat": 30.0285,
                "Long": 76.6223
              },
              {
                "Area": "Peint",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 20.4939,
                "Long": 75.1496
              },
              {
                "Area": "Pekucherra",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 24.1597,
                "Long": 92.0329
              },
              {
                "Area": "Pelara",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 25.0201,
                "Long": 79.2282
              },
              {
                "Area": "Pellakur",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 14.4268,
                "Long": 79.7747
              },
              {
                "Area": "Pelling",
                "State": "Sikkim",
                "CountryCode": "IN",
                "Lat": 27.3692,
                "Long": 88.2538
              },
              {
                "Area": "Pem",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.1685,
                "Long": 80.3428
              },
              {
                "Area": "Pen",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 19.9808,
                "Long": 77.6997
              },
              {
                "Area": "Penagalur",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 14.4599,
                "Long": 79.4838
              },
              {
                "Area": "Penamaluru Mandal",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.4713,
                "Long": 80.697
              },
              {
                "Area": "Pendlimarri",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 14.4654,
                "Long": 79.0809
              },
              {
                "Area": "Pendra",
                "State": "Chattisgarh",
                "CountryCode": "IN",
                "Lat": 22.9401,
                "Long": 82.1154
              },
              {
                "Area": "Pendra Road",
                "State": "Chattisgarh",
                "CountryCode": "IN",
                "Lat": 23.0076,
                "Long": 82.0664
              },
              {
                "Area": "Pendraroad",
                "State": "Chattisgarh",
                "CountryCode": "IN",
                "Lat": 22.8266,
                "Long": 82.0026
              },
              {
                "Area": "Pendurthi",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 17.8817,
                "Long": 83.3409
              },
              {
                "Area": "Pennagaram",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 12.404,
                "Long": 78.1018
              },
              {
                "Area": "Pentapadu",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.7582,
                "Long": 81.4711
              },
              {
                "Area": "Pentapadu Mandal",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.7497,
                "Long": 81.533
              },
              {
                "Area": "Pentapadu Mandalam",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.9517,
                "Long": 81.6802
              },
              {
                "Area": "Pentapadu Mandall",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.8116,
                "Long": 81.5732
              },
              {
                "Area": "Pentapadumandalam",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.7582,
                "Long": 81.4711
              },
              {
                "Area": "Penuballi",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 17.5969,
                "Long": 80.6873
              },
              {
                "Area": "Penuganchiprolu",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.9044,
                "Long": 80.8006
              },
              {
                "Area": "Penugolanu",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 17.066,
                "Long": 80.972
              },
              {
                "Area": "Penugonda (mdl)",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 17.093,
                "Long": 82.1643
              },
              {
                "Area": "Penukonda",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 14.4811,
                "Long": 77.8512
              },
              {
                "Area": "Penumantra (mdl)",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.7167,
                "Long": 81.7394
              },
              {
                "Area": "Penumuru",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 13.5079,
                "Long": 78.8422
              },
              {
                "Area": "Peraiyur",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 9.915,
                "Long": 77.9748
              },
              {
                "Area": "Perambalur",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 11.6417,
                "Long": 79.2184
              },
              {
                "Area": "Perambur",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 13.0572,
                "Long": 80.2297
              },
              {
                "Area": "Perambur Purasawalkam",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 13.3357,
                "Long": 80.2675
              },
              {
                "Area": "Perambur Purawalkam",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 13.0907,
                "Long": 80.2554
              },
              {
                "Area": "Peravali",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.7663,
                "Long": 81.7359
              },
              {
                "Area": "Peravali (mdl)",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.7514,
                "Long": 81.74
              },
              {
                "Area": "Peravali Mandalam",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.8445,
                "Long": 81.7359
              },
              {
                "Area": "Peravurani",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 10.4315,
                "Long": 79.2314
              },
              {
                "Area": "Peravurni",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 11.1227,
                "Long": 79.3122
              },
              {
                "Area": "Peren",
                "State": "Nagaland",
                "CountryCode": "IN",
                "Lat": 25.9288,
                "Long": 94.3486
              },
              {
                "Area": "Perintalmanna",
                "State": "Kerala",
                "CountryCode": "IN",
                "Lat": 11.0692,
                "Long": 76.2751
              },
              {
                "Area": "Perinthalmanna",
                "State": "Kerala",
                "CountryCode": "IN",
                "Lat": 11.0744,
                "Long": 76.2788
              },
              {
                "Area": "Periyakulam",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 10.1467,
                "Long": 78.0743
              },
              {
                "Area": "Periyapatna",
                "State": "Karnataka",
                "CountryCode": "IN",
                "Lat": 12.825,
                "Long": 76.4421
              },
              {
                "Area": "Perlad",
                "State": "Gujarat",
                "CountryCode": "IN",
                "Lat": 22.4479,
                "Long": 72.7774
              },
              {
                "Area": "Pernem",
                "State": "Goa",
                "CountryCode": "IN",
                "Lat": 15.7833,
                "Long": 74.0735
              },
              {
                "Area": "Perundurai",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 11.5152,
                "Long": 77.9895
              },
              {
                "Area": "Peterbar",
                "State": "Jharkhand",
                "CountryCode": "IN",
                "Lat": 23.7284,
                "Long": 85.9181
              },
              {
                "Area": "Peth",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 20.4939,
                "Long": 74.9598
              },
              {
                "Area": "Petlad",
                "State": "Gujarat",
                "CountryCode": "IN",
                "Lat": 24.0708,
                "Long": 73.2532
              },
              {
                "Area": "Petlawad",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 23.3068,
                "Long": 75.1902
              },
              {
                "Area": "Petlawada",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 22.787,
                "Long": 74.8456
              },
              {
                "Area": "Petrapole",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.6259,
                "Long": 88.6827
              },
              {
                "Area": "Pfutsero",
                "State": "Nagaland",
                "CountryCode": "IN",
                "Lat": 25.8234,
                "Long": 94.2273
              },
              {
                "Area": "Phagwara",
                "State": "Punjab",
                "CountryCode": "IN",
                "Lat": 31.5177,
                "Long": 75.8569
              },
              {
                "Area": "Phagwara Ho",
                "State": "Punjab",
                "CountryCode": "IN",
                "Lat": 31.1797,
                "Long": 75.6257
              },
              {
                "Area": "Phaileng",
                "State": "Mizoram",
                "CountryCode": "IN",
                "Lat": 23.6995,
                "Long": 92.4917
              },
              {
                "Area": "Phalatan",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 20.415,
                "Long": 76.8147
              },
              {
                "Area": "Phalodi",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 27.366,
                "Long": 73.2799
              },
              {
                "Area": "Phaltan",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 20.415,
                "Long": 76.8147
              },
              {
                "Area": "Phandar",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.8223,
                "Long": 87.5059
              },
              {
                "Area": "Phansidewa",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 26.6993,
                "Long": 88.368
              },
              {
                "Area": "Phaphamau",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 25.8695,
                "Long": 81.908
              },
              {
                "Area": "Pharenda",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 27.2025,
                "Long": 83.5333
              },
              {
                "Area": "Phazilpur",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.6856,
                "Long": 88.4668
              },
              {
                "Area": "Phek",
                "State": "Nagaland",
                "CountryCode": "IN",
                "Lat": 25.8234,
                "Long": 94.6195
              },
              {
                "Area": "Phek Sadar",
                "State": "Nagaland",
                "CountryCode": "IN",
                "Lat": 25.7675,
                "Long": 94.4743
              },
              {
                "Area": "Phenhara",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.6184,
                "Long": 84.9247
              },
              {
                "Area": "Phigeshwar",
                "State": "Chattisgarh",
                "CountryCode": "IN",
                "Lat": 21.5574,
                "Long": 82.3708
              },
              {
                "Area": "Phillaur",
                "State": "Punjab",
                "CountryCode": "IN",
                "Lat": 31.3981,
                "Long": 76.156
              },
              {
                "Area": "Phingeshwar",
                "State": "Chattisgarh",
                "CountryCode": "IN",
                "Lat": 21.601,
                "Long": 82.174
              },
              {
                "Area": "Phirangipuram",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.3164,
                "Long": 80.2623
              },
              {
                "Area": "Phirigia",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 20.247,
                "Long": 84.0071
              },
              {
                "Area": "Phiringia",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 20.3966,
                "Long": 84.1597
              },
              {
                "Area": "Phirngia",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 20.247,
                "Long": 84.0071
              },
              {
                "Area": "Phool Pur",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.1603,
                "Long": 83.0697
              },
              {
                "Area": "Phool Pur.",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.047,
                "Long": 83.0697
              },
              {
                "Area": "Phoolpur",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.2599,
                "Long": 83.0948
              },
              {
                "Area": "Phul",
                "State": "Punjab",
                "CountryCode": "IN",
                "Lat": 30.4822,
                "Long": 75.3316
              },
              {
                "Area": "Phul Pur",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.0023,
                "Long": 82.8309
              },
              {
                "Area": "Phulambri",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 20.0215,
                "Long": 75.2735
              },
              {
                "Area": "Phulaparas",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.384,
                "Long": 86.4632
              },
              {
                "Area": "Phulbagan",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.3945,
                "Long": 88.2559
              },
              {
                "Area": "Phulbani",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 20.6178,
                "Long": 84.3568
              },
              {
                "Area": "Phulbani H.O",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 20.8407,
                "Long": 84.1776
              },
              {
                "Area": "Phulidumar",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.0352,
                "Long": 86.8409
              },
              {
                "Area": "Phullen",
                "State": "Mizoram",
                "CountryCode": "IN",
                "Lat": 23.902,
                "Long": 93.0008
              },
              {
                "Area": "Phulparas",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.5997,
                "Long": 86.5046
              },
              {
                "Area": "Phulpur",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.1171,
                "Long": 82.8121
              },
              {
                "Area": "Phulumbri",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 20.4616,
                "Long": 76.2588
              },
              {
                "Area": "Phulwari",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.6716,
                "Long": 85.6585
              },
              {
                "Area": "Phuool Pur",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.1567,
                "Long": 82.8052
              },
              {
                "Area": "Phuphuwar",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.3801,
                "Long": 80.4141
              },
              {
                "Area": "Pichabani",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.3703,
                "Long": 88.2092
              },
              {
                "Area": "Pichatur",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 13.4355,
                "Long": 79.8752
              },
              {
                "Area": "Pichhore",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 25.994,
                "Long": 78.3655
              },
              {
                "Area": "Picnic Garden",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.5668,
                "Long": 88.3016
              },
              {
                "Area": "Piduguralla",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.5246,
                "Long": 79.9255
              },
              {
                "Area": "Pidugurlalla",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.539,
                "Long": 79.9044
              },
              {
                "Area": "Pifa",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.6191,
                "Long": 88.8788
              },
              {
                "Area": "Piler",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 13.8408,
                "Long": 79.0694
              },
              {
                "Area": "Pileru",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 14.3753,
                "Long": 78.7847
              },
              {
                "Area": "Pilibanga",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 29.6297,
                "Long": 74.0534
              },
              {
                "Area": "Pilibangan",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 29.4496,
                "Long": 74.7249
              },
              {
                "Area": "Pilibhit",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 29.0362,
                "Long": 80.3821
              },
              {
                "Area": "Pindipole",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 17.3737,
                "Long": 79.9673
              },
              {
                "Area": "Pindipolu",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 17.3737,
                "Long": 79.9673
              },
              {
                "Area": "Pindra",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 25.4584,
                "Long": 82.8226
              },
              {
                "Area": "Pindra **",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 25.6658,
                "Long": 82.933
              },
              {
                "Area": "Pindwara",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 24.954,
                "Long": 73.1245
              },
              {
                "Area": "Pingla",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.1207,
                "Long": 88.109
              },
              {
                "Area": "Pipaia",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.1206,
                "Long": 86.1557
              },
              {
                "Area": "Pipalhunt",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 25.189,
                "Long": 74.2209
              },
              {
                "Area": "Pipar",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 26.7508,
                "Long": 73.9768
              },
              {
                "Area": "Pipar Road",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 27.203,
                "Long": 73.6302
              },
              {
                "Area": "Piparia",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 22.757,
                "Long": 78.355
              },
              {
                "Area": "Piparia",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.2593,
                "Long": 86.14
              },
              {
                "Area": "Pipariya",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 22.7708,
                "Long": 78.4331
              },
              {
                "Area": "Pipariya",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.1555,
                "Long": 86.1312
              },
              {
                "Area": "Pipergaon",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.3843,
                "Long": 80.3275
              },
              {
                "Area": "Pipili",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 20.4382,
                "Long": 85.8799
              },
              {
                "Area": "Pipla Kashimpur",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 25.4339,
                "Long": 87.8784
              },
              {
                "Area": "Piplacherra",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 24.0447,
                "Long": 91.7553
              },
              {
                "Area": "Piploda",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 23.869,
                "Long": 75.5002
              },
              {
                "Area": "Piploda Baghla",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 23.3317,
                "Long": 75.6684
              },
              {
                "Area": "Pipra",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.9584,
                "Long": 86.6026
              },
              {
                "Area": "Pipra Bazar",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.2477,
                "Long": 86.8001
              },
              {
                "Area": "Piprabazar",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.1161,
                "Long": 86.7791
              },
              {
                "Area": "Piprahi",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.576,
                "Long": 85.8601
              },
              {
                "Area": "Piprakothi",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.3776,
                "Long": 84.9023
              },
              {
                "Area": "Piprarhi",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.158,
                "Long": 85.8601
              },
              {
                "Area": "Pirijkhanbarh",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.3159,
                "Long": 88.0212
              },
              {
                "Area": "Piriyapatna",
                "State": "Karnataka",
                "CountryCode": "IN",
                "Lat": 12.2839,
                "Long": 76.4421
              },
              {
                "Area": "Piro",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.6437,
                "Long": 84.7982
              },
              {
                "Area": "Pirpainti",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.4526,
                "Long": 87.3199
              },
              {
                "Area": "Pirtand",
                "State": "Jharkhand",
                "CountryCode": "IN",
                "Lat": 24.4438,
                "Long": 86.2409
              },
              {
                "Area": "Piru",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.469,
                "Long": 84.6404
              },
              {
                "Area": "Pisangan",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 26.2866,
                "Long": 74.5031
              },
              {
                "Area": "Pissatur",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 13.4712,
                "Long": 79.8667
              },
              {
                "Area": "Pithapukuria",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.5864,
                "Long": 88.4145
              },
              {
                "Area": "Pithapuram",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 17.1885,
                "Long": 82.2528
              },
              {
                "Area": "Pithora",
                "State": "Chattisgarh",
                "CountryCode": "IN",
                "Lat": 21.348,
                "Long": 82.7734
              },
              {
                "Area": "Pithoragarh",
                "State": "Uttarakhand",
                "CountryCode": "IN",
                "Lat": 30.1119,
                "Long": 80.3817
              },
              {
                "Area": "Pithoraharh",
                "State": "Uttarakhand",
                "CountryCode": "IN",
                "Lat": 29.7604,
                "Long": 79.7546
              },
              {
                "Area": "Piyaoli",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 28.2978,
                "Long": 77.7362
              },
              {
                "Area": "Piyong",
                "State": "Arunachal Pradesh",
                "CountryCode": "IN",
                "Lat": 27.4031,
                "Long": 95.9613
              },
              {
                "Area": "Plashipara",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.7245,
                "Long": 88.4213
              },
              {
                "Area": "Poanta Sahib",
                "State": "Himachal Pradesh",
                "CountryCode": "IN",
                "Lat": 30.5667,
                "Long": 77.3474
              },
              {
                "Area": "Pochampalle",
                "State": "Telangana",
                "CountryCode": "IN",
                "Lat": 17.3195,
                "Long": 79.2856
              },
              {
                "Area": "Pochampalli",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 12.7677,
                "Long": 78.5085
              },
              {
                "Area": "Podalakur",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 14.872,
                "Long": 79.8567
              },
              {
                "Area": "Podili",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 15.5159,
                "Long": 79.7526
              },
              {
                "Area": "Podili H.O",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 15.6213,
                "Long": 79.5158
              },
              {
                "Area": "Poduru (mdl)",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 17.2921,
                "Long": 81.6822
              },
              {
                "Area": "Poduru(mdl)",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.6222,
                "Long": 80.8847
              },
              {
                "Area": "Pohri",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 25.8327,
                "Long": 77.8851
              },
              {
                "Area": "Pokaran",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 27.0094,
                "Long": 73.1019
              },
              {
                "Area": "Pokhari",
                "State": "Uttarakhand",
                "CountryCode": "IN",
                "Lat": 30.4953,
                "Long": 79.5787
              },
              {
                "Area": "Poladpur",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 20.9122,
                "Long": 76.3648
              },
              {
                "Area": "Polai Kalan",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 22.8809,
                "Long": 74.6313
              },
              {
                "Area": "Polaki Mandal",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 18.5786,
                "Long": 84.1027
              },
              {
                "Area": "Polavaram",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 17.2475,
                "Long": 81.6437
              },
              {
                "Area": "Polavaram Mandal",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 17.3543,
                "Long": 81.7422
              },
              {
                "Area": "Polavaram Mandalam",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 17.436,
                "Long": 81.6559
              },
              {
                "Area": "Polavarammandal",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.8946,
                "Long": 81.4023
              },
              {
                "Area": "Polavarammandalam",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 17.436,
                "Long": 81.6559
              },
              {
                "Area": "Polba - Dadpur",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.9618,
                "Long": 88.3024
              },
              {
                "Area": "Pollachi",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 11.2997,
                "Long": 77.5939
              },
              {
                "Area": "Polur",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 12.6754,
                "Long": 79.6137
              },
              {
                "Area": "Pombhurna",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 19.9813,
                "Long": 79.57
              },
              {
                "Area": "Ponani",
                "State": "Kerala",
                "CountryCode": "IN",
                "Lat": 11.1321,
                "Long": 76.1558
              },
              {
                "Area": "Ponda",
                "State": "Goa",
                "CountryCode": "IN",
                "Lat": 15.5525,
                "Long": 74.1184
              },
              {
                "Area": "Pondi Uproda",
                "State": "Chattisgarh",
                "CountryCode": "IN",
                "Lat": 22.6326,
                "Long": 82.7637
              },
              {
                "Area": "Pondicherry",
                "State": "Pondicherry",
                "CountryCode": "IN",
                "Lat": 16.5523,
                "Long": 81.4689
              },
              {
                "Area": "Pondicherry",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.5523,
                "Long": 81.4689
              },
              {
                "Area": "Pondichery",
                "State": "Pondicherry",
                "CountryCode": "IN",
                "Lat": 11.9347,
                "Long": 79.5307
              },
              {
                "Area": "Ponduru",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 18.3896,
                "Long": 83.7565
              },
              {
                "Area": "Ponduru Mandal",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 18.386,
                "Long": 83.8481
              },
              {
                "Area": "Ponnani",
                "State": "Kerala",
                "CountryCode": "IN",
                "Lat": 11.1321,
                "Long": 76.1558
              },
              {
                "Area": "Ponnekallu",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.374,
                "Long": 80.3585
              },
              {
                "Area": "Ponneri",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 13.4304,
                "Long": 80.3168
              },
              {
                "Area": "Ponnur",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.5324,
                "Long": 80.6379
              },
              {
                "Area": "Ponnuru",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.2988,
                "Long": 80.4486
              },
              {
                "Area": "Poo(T)",
                "State": "Himachal Pradesh",
                "CountryCode": "IN",
                "Lat": 31.9148,
                "Long": 78.6467
              },
              {
                "Area": "Pooh",
                "State": "Himachal Pradesh",
                "CountryCode": "IN",
                "Lat": 31.9148,
                "Long": 78.5854
              },
              {
                "Area": "Poonamalee",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 13.2431,
                "Long": 80.1632
              },
              {
                "Area": "Poonamallee",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 13.2431,
                "Long": 80.1632
              },
              {
                "Area": "Poonch",
                "State": "Jammu & Kashmir",
                "CountryCode": "IN",
                "Lat": 33.8346,
                "Long": 75.0127
              },
              {
                "Area": "Pooranpur",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 28.5418,
                "Long": 80.2856
              },
              {
                "Area": "Poraiyahat",
                "State": "Jharkhand",
                "CountryCode": "IN",
                "Lat": 24.8596,
                "Long": 87.3121
              },
              {
                "Area": "Poranki",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.4595,
                "Long": 80.6844
              },
              {
                "Area": "Porbaandar",
                "State": "Gujarat",
                "CountryCode": "IN",
                "Lat": 21.4279,
                "Long": 69.9417
              },
              {
                "Area": "Porbandar",
                "State": "Gujarat",
                "CountryCode": "IN",
                "Lat": 22.8198,
                "Long": 72.1464
              },
              {
                "Area": "Poriyahat",
                "State": "Jharkhand",
                "CountryCode": "IN",
                "Lat": 24.8596,
                "Long": 87.3199
              },
              {
                "Area": "Porolda",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.3564,
                "Long": 87.8021
              },
              {
                "Area": "Porompat",
                "State": "Manipur",
                "CountryCode": "IN",
                "Lat": 24.4065,
                "Long": 93.3452
              },
              {
                "Area": "Porsa",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 26.7783,
                "Long": 78.5037
              },
              {
                "Area": "Port  Blair",
                "State": "Andaman & Nicobar Islands",
                "CountryCode": "IN",
                "Lat": 11.6647,
                "Long": 92.7026
              },
              {
                "Area": "Port Blair",
                "State": "Andaman & Nicobar Islands",
                "CountryCode": "IN",
                "Lat": 12.1853,
                "Long": 92.7718
              },
              {
                "Area": "Portblair",
                "State": "Andaman & Nicobar Islands",
                "CountryCode": "IN",
                "Lat": 11.7167,
                "Long": 92.7167
              },
              {
                "Area": "Porumamilla",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 15.0116,
                "Long": 79.25
              },
              {
                "Area": "Pota",
                "State": "Haryana",
                "CountryCode": "IN",
                "Lat": 28.4013,
                "Long": 76.373
              },
              {
                "Area": "Pottangi",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 19.1214,
                "Long": 83.2667
              },
              {
                "Area": "Powayan",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 28.1242,
                "Long": 80.4293
              },
              {
                "Area": "Pragadavaram",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 17.0119,
                "Long": 81.0887
              },
              {
                "Area": "Prakasam",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 15.8212,
                "Long": 79.9261
              },
              {
                "Area": "Pranpura",
                "State": "Haryana",
                "CountryCode": "IN",
                "Lat": 28.2301,
                "Long": 76.4918
              },
              {
                "Area": "Prantij",
                "State": "Gujarat",
                "CountryCode": "IN",
                "Lat": 23.7898,
                "Long": 73.1969
              },
              {
                "Area": "Pratabgarh",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 25.3221,
                "Long": 74.8175
              },
              {
                "Area": "Pratap Nagar",
                "State": "Uttarakhand",
                "CountryCode": "IN",
                "Lat": 30.4374,
                "Long": 78.674
              },
              {
                "Area": "Pratapdighi",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.475,
                "Long": 87.8219
              },
              {
                "Area": "Pratapganj",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.312,
                "Long": 87.0405
              },
              {
                "Area": "Pratapgargh",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 25.189,
                "Long": 74.2209
              },
              {
                "Area": "Pratapgarh",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.2698,
                "Long": 82.3494
              },
              {
                "Area": "Pratapgarh",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 25.3221,
                "Long": 74.8175
              },
              {
                "Area": "Pratapnagar",
                "State": "Uttarakhand",
                "CountryCode": "IN",
                "Lat": 30.5132,
                "Long": 78.674
              },
              {
                "Area": "Pratapngar",
                "State": "Uttarakhand",
                "CountryCode": "IN",
                "Lat": 30.364,
                "Long": 78.674
              },
              {
                "Area": "Pratappur",
                "State": "Jharkhand",
                "CountryCode": "IN",
                "Lat": 24.3558,
                "Long": 84.6626
              },
              {
                "Area": "Pratappur",
                "State": "Chattisgarh",
                "CountryCode": "IN",
                "Lat": 23.9207,
                "Long": 83.3206
              },
              {
                "Area": "Pratbgarh",
                "State": "Rajasthan",
                "CountryCode": "IN",
                "Lat": 24.8287,
                "Long": 74.7797
              },
              {
                "Area": "Prathipadu",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 17.535,
                "Long": 82.21
              },
              {
                "Area": "Prathvipur",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 25.2558,
                "Long": 78.8744
              },
              {
                "Area": "Pratppur",
                "State": "Chattisgarh",
                "CountryCode": "IN",
                "Lat": 23.2597,
                "Long": 82.8802
              },
              {
                "Area": "Pratyakroy",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 24.0447,
                "Long": 91.7553
              },
              {
                "Area": "Pratyekroy",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 24.0447,
                "Long": 91.7553
              },
              {
                "Area": "Prayekroy",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 24.0447,
                "Long": 91.7553
              },
              {
                "Area": "Praytyakroy",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 24.0447,
                "Long": 91.7553
              },
              {
                "Area": "Preet Nagar",
                "State": "Punjab",
                "CountryCode": "IN",
                "Lat": 31.7187,
                "Long": 74.633
              },
              {
                "Area": "Premnagar",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.3805,
                "Long": 80.2158
              },
              {
                "Area": "Prempur Badagaon",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.3801,
                "Long": 80.4141
              },
              {
                "Area": "Premtala",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 24.1597,
                "Long": 92.0329
              },
              {
                "Area": "Pripainti",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.3847,
                "Long": 87.4404
              },
              {
                "Area": "Prithiba",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.8135,
                "Long": 88.6066
              },
              {
                "Area": "Prithvipur",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 25.2634,
                "Long": 80.365
              },
              {
                "Area": "Proddatur",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 14.896,
                "Long": 79.1167
              },
              {
                "Area": "Promodenagar",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 23.9225,
                "Long": 91.6031
              },
              {
                "Area": "Pub Baramchari",
                "State": "Assam",
                "CountryCode": "IN",
                "Lat": 26.3796,
                "Long": 91.2951
              },
              {
                "Area": "Pubchamaria ( Goroimari Block)",
                "State": "Assam",
                "CountryCode": "IN",
                "Lat": 26.1314,
                "Long": 91.4625
              },
              {
                "Area": "Pudukkottai",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 10.4205,
                "Long": 78.8812
              },
              {
                "Area": "Pudukkottai--",
                "State": "Tamil Nadu",
                "CountryCode": "IN",
                "Lat": 10.4384,
                "Long": 78.8913
              },
              {
                "Area": "Puinan",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.9249,
                "Long": 88.2549
              },
              {
                "Area": "Pukhraayan",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.3865,
                "Long": 79.509
              },
              {
                "Area": "Pukhrayan",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.4448,
                "Long": 79.8696
              },
              {
                "Area": "Pukuria",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 25.4822,
                "Long": 87.8715
              },
              {
                "Area": "Pulicherla",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 13.7055,
                "Long": 79.0934
              },
              {
                "Area": "Pulinpur",
                "State": "Tripura",
                "CountryCode": "IN",
                "Lat": 23.9225,
                "Long": 91.6031
              },
              {
                "Area": "Pulivedla",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 14.4599,
                "Long": 78.7836
              },
              {
                "Area": "Pulivendla",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 14.5942,
                "Long": 78.7836
              },
              {
                "Area": "Pulla",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 16.806,
                "Long": 81.3241
              },
              {
                "Area": "Pullalacheruvu",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 15.8333,
                "Long": 79.5489
              },
              {
                "Area": "Pullampeta",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 14.1724,
                "Long": 79.245
              },
              {
                "Area": "Pulwama",
                "State": "Jammu & Kashmir",
                "CountryCode": "IN",
                "Lat": 34.2319,
                "Long": 75.3575
              },
              {
                "Area": "Puncha",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.3504,
                "Long": 88.0861
              },
              {
                "Area": "Pundri",
                "State": "Haryana",
                "CountryCode": "IN",
                "Lat": 29.8898,
                "Long": 76.6864
              },
              {
                "Area": "Pune",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 18.5685,
                "Long": 73.9167
              },
              {
                "Area": "Pune City",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 18.8199,
                "Long": 75.0311
              },
              {
                "Area": "Punganur",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 13.378,
                "Long": 78.5588
              },
              {
                "Area": "Punhana",
                "State": "Haryana",
                "CountryCode": "IN",
                "Lat": 27.9627,
                "Long": 77.1646
              },
              {
                "Area": "Punpun",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.4292,
                "Long": 85.2063
              },
              {
                "Area": "Punra",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.5239,
                "Long": 87.8703
              },
              {
                "Area": "Punsika",
                "State": "Haryana",
                "CountryCode": "IN",
                "Lat": 28.1479,
                "Long": 76.5182
              },
              {
                "Area": "Punwarka",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 29.6573,
                "Long": 78.073
              },
              {
                "Area": "Pupari",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.3624,
                "Long": 85.994
              },
              {
                "Area": "Pupri",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.576,
                "Long": 86.1288
              },
              {
                "Area": "Puraini",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.6115,
                "Long": 87.0464
              },
              {
                "Area": "Purana Kanpur",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.5167,
                "Long": 80.3155
              },
              {
                "Area": "Purandar",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 19.1352,
                "Long": 74.9495
              },
              {
                "Area": "Purandarpur",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.4653,
                "Long": 88.7803
              },
              {
                "Area": "Purandhar",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 19.6874,
                "Long": 75.1606
              },
              {
                "Area": "Purani Tangla",
                "State": "Assam",
                "CountryCode": "IN",
                "Lat": 26.6138,
                "Long": 92.0365
              },
              {
                "Area": "Puranpur",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 28.5418,
                "Long": 80.3821
              },
              {
                "Area": "Purantan Bongaon",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.0762,
                "Long": 88.8272
              },
              {
                "Area": "Puraula",
                "State": "Uttarakhand",
                "CountryCode": "IN",
                "Lat": 30.8746,
                "Long": 78.6107
              },
              {
                "Area": "Purba  Khejurberia",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.795,
                "Long": 88.1206
              },
              {
                "Area": "Purba Madhabpur",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 21.7344,
                "Long": 87.5491
              },
              {
                "Area": "Purba Sankardaha",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.3687,
                "Long": 88.562
              },
              {
                "Area": "Purbaradhapur",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.0093,
                "Long": 87.7037
              },
              {
                "Area": "Purbasthali",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 24.0811,
                "Long": 88.4436
              },
              {
                "Area": "Purbasthali - I",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.5134,
                "Long": 88.3361
              },
              {
                "Area": "Purbasthali - II",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.5315,
                "Long": 88.3224
              },
              {
                "Area": "Purbasthali I",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.601,
                "Long": 88.1273
              },
              {
                "Area": "Puri",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 20.7731,
                "Long": 85.9534
              },
              {
                "Area": "Purna",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 19.2857,
                "Long": 77.1519
              },
              {
                "Area": "Purnahiya",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.158,
                "Long": 85.8601
              },
              {
                "Area": "Purnea",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 26.1101,
                "Long": 87.7449
              },
              {
                "Area": "Purola",
                "State": "Uttarakhand",
                "CountryCode": "IN",
                "Lat": 31.039,
                "Long": 79.0311
              },
              {
                "Area": "Pursura",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.9376,
                "Long": 88.0801
              },
              {
                "Area": "Pursurah",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.9808,
                "Long": 88.5162
              },
              {
                "Area": "Pursurah.",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.8943,
                "Long": 87.9543
              },
              {
                "Area": "Purulia",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 24.6089,
                "Long": 88.3425
              },
              {
                "Area": "Purulia - I",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 24.6089,
                "Long": 87.8815
              },
              {
                "Area": "Purulia - II",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.4194,
                "Long": 86.6102
              },
              {
                "Area": "Purulia Ii",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 23.5693,
                "Long": 87.1521
              },
              {
                "Area": "Purunakatak",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 20.718,
                "Long": 84.456
              },
              {
                "Area": "Purunda",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.3564,
                "Long": 87.8021
              },
              {
                "Area": "Purushottampur",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 19.6269,
                "Long": 84.9338
              },
              {
                "Area": "Purusottampur",
                "State": "Odisha",
                "CountryCode": "IN",
                "Lat": 19.5135,
                "Long": 84.9338
              },
              {
                "Area": "Purwa",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.6092,
                "Long": 80.8128
              },
              {
                "Area": "Purwameer",
                "State": "Uttar Pradesh",
                "CountryCode": "IN",
                "Lat": 26.3801,
                "Long": 80.4141
              },
              {
                "Area": "Pusa",
                "State": "Bihar",
                "CountryCode": "IN",
                "Lat": 25.8058,
                "Long": 85.7765
              },
              {
                "Area": "Pusad",
                "State": "Maharashtra",
                "CountryCode": "IN",
                "Lat": 20.1758,
                "Long": 78.898
              },
              {
                "Area": "Pusapatirega",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 18.1516,
                "Long": 83.6342
              },
              {
                "Area": "Pushparajgarh",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 23.4446,
                "Long": 81.7591
              },
              {
                "Area": "Pushprajgarh",
                "State": "Madhya Pradesh",
                "CountryCode": "IN",
                "Lat": 23.0223,
                "Long": 81.413
              },
              {
                "Area": "Puthalapattu",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 13.448,
                "Long": 78.9484
              },
              {
                "Area": "Puthalpattu",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 13.4673,
                "Long": 79.1383
              },
              {
                "Area": "Putia",
                "State": "West Bengal",
                "CountryCode": "IN",
                "Lat": 22.4653,
                "Long": 88.7803
              },
              {
                "Area": "Putlur",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 14.8426,
                "Long": 78.3731
              },
              {
                "Area": "Putluru",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 14.9159,
                "Long": 77.9604
              },
              {
                "Area": "Puttaparthi",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 14.2051,
                "Long": 78.0086
              },
              {
                "Area": "Puttaparthy",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 14.155,
                "Long": 77.8624
              },
              {
                "Area": "Puttur",
                "State": "Karnataka",
                "CountryCode": "IN",
                "Lat": 13.1529,
                "Long": 76.862
              },
              {
                "Area": "Puttur",
                "State": "Andhra Pradesh",
                "CountryCode": "IN",
                "Lat": 14.0638,
                "Long": 79.8126
              },
              {
                "Area": "Puttur(dk)",
                "State": "Karnataka",
                "CountryCode": "IN",
                "Lat": 12.7931,
                "Long": 75.3247
              },
              {
                "Area": "Pynursla",
                "State": "Meghalaya",
                "CountryCode": "IN",
                "Lat": 25.4998,
                "Long": 91.9012
              },
              {
                "Area": "Pa-an",
                "Lat": "16.85",
                "Long": "97.6167",
                "CountryCode": "MM"
              },
              {
                "Area": "Paarl",
                "Lat": "-33.6996",
                "Long": "18.96",
                "CountryCode": "ZA"
              },
              {
                "Area": "Pabna",
                "Lat": "24.0004",
                "Long": "89.25",
                "CountryCode": "BD"
              },
              {
                "Area": "Pachuca",
                "Lat": "20.1704",
                "Long": "-98.73",
                "CountryCode": "MX"
              },
              {
                "Area": "Padang",
                "Lat": "-0.96",
                "Long": "100.36",
                "CountryCode": "ID"
              },
              {
                "Area": "Padangsidempuan",
                "Lat": "1.3887",
                "Long": "99.2734",
                "CountryCode": "ID"
              },
              {
                "Area": "Pagadian",
                "Lat": "7.853",
                "Long": "123.507",
                "CountryCode": "PH"
              },
              {
                "Area": "Paita",
                "Lat": "-5.09",
                "Long": "-81.12",
                "CountryCode": "PE"
              },
              {
                "Area": "Pakalongan",
                "Lat": "-6.8796",
                "Long": "109.67",
                "CountryCode": "ID"
              },
              {
                "Area": "Pakokku",
                "Lat": "21.332",
                "Long": "95.0866",
                "CountryCode": "MM"
              },
              {
                "Area": "Pakxe",
                "Lat": "15.1221",
                "Long": "105.8183",
                "CountryCode": "LA"
              },
              {
                "Area": "Palangkaraya",
                "Lat": "-2.2096",
                "Long": "113.91",
                "CountryCode": "ID"
              },
              {
                "Area": "Palatine",
                "Lat": "42.1181",
                "Long": "-88.043",
                "CountryCode": "US"
              },
              {
                "Area": "Palembang",
                "Lat": "-2.98",
                "Long": "104.75",
                "CountryCode": "ID"
              },
              {
                "Area": "Palermo",
                "Lat": "38.125",
                "Long": "13.35",
                "CountryCode": "IT"
              },
              {
                "Area": "Palm Bay",
                "Lat": "27.9861",
                "Long": "-80.6628",
                "CountryCode": "US"
              },
              {
                "Area": "Palm Beach Gardens",
                "Lat": "26.8488",
                "Long": "-80.1656",
                "CountryCode": "US"
              },
              {
                "Area": "Palm Coast",
                "Lat": "29.5389",
                "Long": "-81.246",
                "CountryCode": "US"
              },
              {
                "Area": "Palm Desert",
                "Lat": "33.7378",
                "Long": "-116.3695",
                "CountryCode": "US"
              },
              {
                "Area": "Palma",
                "Lat": "39.5743",
                "Long": "2.6542",
                "CountryCode": "ES"
              },
              {
                "Area": "Palma Soriano",
                "Lat": "20.2172",
                "Long": "-75.9988",
                "CountryCode": "CU"
              },
              {
                "Area": "Palmas",
                "Lat": "-10.2377",
                "Long": "-48.2878",
                "CountryCode": "BR"
              },
              {
                "Area": "Palmdale",
                "Lat": "34.5944",
                "Long": "-118.1057",
                "CountryCode": "US"
              },
              {
                "Area": "Palmerston North",
                "Lat": "-40.3527",
                "Long": "175.6072",
                "CountryCode": "NZ"
              },
              {
                "Area": "Palo Alto",
                "Lat": "37.3913",
                "Long": "-122.1467",
                "CountryCode": "US"
              },
              {
                "Area": "Palu",
                "Lat": "-0.907",
                "Long": "119.833",
                "CountryCode": "ID"
              },
              {
                "Area": "Pamplona",
                "Lat": "42.82",
                "Long": "-1.65",
                "CountryCode": "ES"
              },
              {
                "Area": "Pamplona",
                "Lat": "7.3904",
                "Long": "-72.66",
                "CountryCode": "CO"
              },
              {
                "Area": "PA City",
                "Lat": "8.968",
                "Long": "-79.533",
                "CountryCode": "PA"
              },
              {
                "Area": "PA City",
                "Lat": "30.1997",
                "Long": "-85.6003",
                "CountryCode": "US"
              },
              {
                "Area": "Panevežys",
                "Lat": "55.74",
                "Long": "24.37",
                "CountryCode": "LT"
              },
              {
                "Area": "Pangkalpinang",
                "Lat": "-2.08",
                "Long": "106.15",
                "CountryCode": "ID"
              },
              {
                "Area": "Panshi",
                "Lat": "42.9426",
                "Long": "126.0561",
                "CountryCode": "CN"
              },
              {
                "Area": "Panzhihua",
                "Lat": "26.55",
                "Long": "101.73",
                "CountryCode": "CN"
              },
              {
                "Area": "Papeete",
                "Lat": "-17.5334",
                "Long": "-149.5667",
                "CountryCode": "PF"
              },
              {
                "Area": "Paracatu",
                "Lat": "-17.1996",
                "Long": "-46.87",
                "CountryCode": "BR"
              },
              {
                "Area": "ParaCNr",
                "Lat": "33.8992",
                "Long": "70.1008",
                "CountryCode": "PK"
              },
              {
                "Area": "Paragominas",
                "Lat": "-2.9596",
                "Long": "-47.49",
                "CountryCode": "BR"
              },
              {
                "Area": "Parakou",
                "Lat": "9.34",
                "Long": "2.62",
                "CountryCode": "BJ"
              },
              {
                "Area": "Paramaribo",
                "Lat": "5.835",
                "Long": "-55.167",
                "CountryCode": "SR"
              },
              {
                "Area": "Paramount",
                "Lat": "33.8976",
                "Long": "-118.1651",
                "CountryCode": "US"
              },
              {
                "Area": "Paraná",
                "Lat": "-31.7333",
                "Long": "-60.5333",
                "CountryCode": "AR"
              },
              {
                "Area": "Paranaguá",
                "Lat": "-25.5279",
                "Long": "-48.5345",
                "CountryCode": "BR"
              },
              {
                "Area": "Pardubice",
                "Lat": "50.0404",
                "Long": "15.76",
                "CountryCode": "CZ"
              },
              {
                "Area": "Parepare",
                "Lat": "-4.0167",
                "Long": "119.6333",
                "CountryCode": "ID"
              },
              {
                "Area": "Parintins",
                "Lat": "-2.61",
                "Long": "-56.74",
                "CountryCode": "BR"
              },
              {
                "Area": "Paris",
                "Lat": "48.8667",
                "Long": "2.3333",
                "CountryCode": "FR"
              },
              {
                "Area": "Parker",
                "Lat": "39.5083",
                "Long": "-104.7755",
                "CountryCode": "US"
              },
              {
                "Area": "Parkersburg",
                "Lat": "39.2623",
                "Long": "-81.5419",
                "CountryCode": "US"
              },
              {
                "Area": "Parma",
                "Lat": "44.8104",
                "Long": "10.32",
                "CountryCode": "IT"
              },
              {
                "Area": "Parma",
                "Lat": "41.3842",
                "Long": "-81.7286",
                "CountryCode": "US"
              },
              {
                "Area": "Parnaíba",
                "Lat": "-2.91",
                "Long": "-41.77",
                "CountryCode": "BR"
              },
              {
                "Area": "Pasadena",
                "Lat": "29.6584",
                "Long": "-95.1499",
                "CountryCode": "US"
              },
              {
                "Area": "Pasadena",
                "Lat": "34.1598",
                "Long": "-118.139",
                "CountryCode": "US"
              },
              {
                "Area": "Pasay City",
                "Lat": "14.5504",
                "Long": "121",
                "CountryCode": "PH"
              },
              {
                "Area": "Pasco",
                "Lat": "46.2503",
                "Long": "-119.1298",
                "CountryCode": "US"
              },
              {
                "Area": "Passaic",
                "Lat": "40.8574",
                "Long": "-74.1282",
                "CountryCode": "US"
              },
              {
                "Area": "Passau",
                "Lat": "48.567",
                "Long": "13.4666",
                "CountryCode": "DE"
              },
              {
                "Area": "Passo Fundo",
                "Lat": "-28.25",
                "Long": "-52.42",
                "CountryCode": "BR"
              },
              {
                "Area": "Passos",
                "Lat": "-20.71",
                "Long": "-46.61",
                "CountryCode": "BR"
              },
              {
                "Area": "Pasto",
                "Lat": "1.2136",
                "Long": "-77.2811",
                "CountryCode": "CO"
              },
              {
                "Area": "Pasuruan",
                "Lat": "-7.6296",
                "Long": "112.9",
                "CountryCode": "ID"
              },
              {
                "Area": "Paterson",
                "Lat": "40.9147",
                "Long": "-74.1624",
                "CountryCode": "US"
              },
              {
                "Area": "Pathein",
                "Lat": "16.7704",
                "Long": "94.75",
                "CountryCode": "MM"
              },
              {
                "Area": "Pathum Thani",
                "Lat": "14.0171",
                "Long": "100.5333",
                "CountryCode": "TH"
              },
              {
                "Area": "Pati",
                "Lat": "-6.7415",
                "Long": "111.0347",
                "CountryCode": "ID"
              },
              {
                "Area": "Patos",
                "Lat": "-7.0196",
                "Long": "-37.29",
                "CountryCode": "BR"
              },
              {
                "Area": "Patra",
                "Lat": "38.23",
                "Long": "21.73",
                "CountryCode": "GR"
              },
              {
                "Area": "Pattani",
                "Lat": "6.864",
                "Long": "101.25",
                "CountryCode": "TH"
              },
              {
                "Area": "Paulo Afonso",
                "Lat": "-9.3307",
                "Long": "-38.2657",
                "CountryCode": "BR"
              },
              {
                "Area": "Pavlodar",
                "Lat": "52.3",
                "Long": "76.95",
                "CountryCode": "KZ"
              },
              {
                "Area": "Pawtucket",
                "Lat": "41.8743",
                "Long": "-71.3743",
                "CountryCode": "US"
              },
              {
                "Area": "Paysandú",
                "Lat": "-32.33",
                "Long": "-58.08",
                "CountryCode": "UY"
              },
              {
                "Area": "Peabody",
                "Lat": "42.5335",
                "Long": "-70.9724",
                "CountryCode": "US"
              },
              {
                "Area": "Pearland",
                "Lat": "29.5585",
                "Long": "-95.3215",
                "CountryCode": "US"
              },
              {
                "Area": "Pécs",
                "Lat": "46.0804",
                "Long": "18.22",
                "CountryCode": "HU"
              },
              {
                "Area": "Pedro Juan Caballero",
                "Lat": "-22.5446",
                "Long": "-55.76",
                "CountryCode": "PY"
              },
              {
                "Area": "Pekanbaru",
                "Lat": "0.565",
                "Long": "101.425",
                "CountryCode": "ID"
              },
              {
                "Area": "Pelotas",
                "Lat": "-31.75",
                "Long": "-52.33",
                "CountryCode": "BR"
              },
              {
                "Area": "Pematangsiantar",
                "Lat": "2.9614",
                "Long": "99.0615",
                "CountryCode": "ID"
              },
              {
                "Area": "Pemba",
                "Lat": "-12.983",
                "Long": "40.5323",
                "CountryCode": "MZ"
              },
              {
                "Area": "Pembroke Pines",
                "Lat": "26.0128",
                "Long": "-80.3387",
                "CountryCode": "US"
              },
              {
                "Area": "Penápolis",
                "Lat": "-21.41",
                "Long": "-50.08",
                "CountryCode": "BR"
              },
              {
                "Area": "Pensacola",
                "Lat": "30.4427",
                "Long": "-87.1886",
                "CountryCode": "US"
              },
              {
                "Area": "Penza",
                "Lat": "53.18",
                "Long": "45",
                "CountryCode": "RU"
              },
              {
                "Area": "Peoria",
                "Lat": "40.752",
                "Long": "-89.6155",
                "CountryCode": "US"
              },
              {
                "Area": "Peoria",
                "Lat": "33.7844",
                "Long": "-112.2989",
                "CountryCode": "US"
              },
              {
                "Area": "Perabumulih",
                "Lat": "-3.4432",
                "Long": "104.2315",
                "CountryCode": "ID"
              },
              {
                "Area": "Pereira",
                "Lat": "4.8104",
                "Long": "-75.68",
                "CountryCode": "CO"
              },
              {
                "Area": "Pergamino",
                "Lat": "-33.8996",
                "Long": "-60.57",
                "CountryCode": "AR"
              },
              {
                "Area": "Perm",
                "Lat": "58",
                "Long": "56.25",
                "CountryCode": "RU"
              },
              {
                "Area": "Pernik",
                "Lat": "42.61",
                "Long": "23.0227",
                "CountryCode": "BG"
              },
              {
                "Area": "Perpignan",
                "Lat": "42.7",
                "Long": "2.9",
                "CountryCode": "FR"
              },
              {
                "Area": "Perris",
                "Lat": "33.7899",
                "Long": "-117.2233",
                "CountryCode": "US"
              },
              {
                "Area": "Perth",
                "Lat": "-31.955",
                "Long": "115.84",
                "CountryCode": "AU"
              },
              {
                "Area": "Perth Amboy",
                "Lat": "40.5203",
                "Long": "-74.2724",
                "CountryCode": "US"
              },
              {
                "Area": "PEgia",
                "Lat": "43.1104",
                "Long": "12.39",
                "CountryCode": "IT"
              },
              {
                "Area": "Pervouralsk",
                "Lat": "56.91",
                "Long": "59.955",
                "CountryCode": "RU"
              },
              {
                "Area": "Pescara",
                "Lat": "42.4554",
                "Long": "14.2187",
                "CountryCode": "IT"
              },
              {
                "Area": "Peshawar",
                "Lat": "34.005",
                "Long": "71.535",
                "CountryCode": "PK"
              },
              {
                "Area": "Petaluma",
                "Lat": "38.2423",
                "Long": "-122.6267",
                "CountryCode": "US"
              },
              {
                "Area": "Peterborough",
                "Lat": "52.5804",
                "Long": "-0.25",
                "CountryCode": "GB"
              },
              {
                "Area": "Peterborough",
                "Lat": "44.3",
                "Long": "-78.3333",
                "CountryCode": "CA"
              },
              {
                "Area": "Petrolina",
                "Lat": "-9.38",
                "Long": "-40.51",
                "CountryCode": "BR"
              },
              {
                "Area": "Petropavlovsk",
                "Lat": "54.88",
                "Long": "69.22",
                "CountryCode": "KZ"
              },
              {
                "Area": "Petropavlovsk Kamchatskiy",
                "Lat": "53.062",
                "Long": "158.623",
                "CountryCode": "RU"
              },
              {
                "Area": "Petrópolis",
                "Lat": "-22.5095",
                "Long": "-43.2",
                "CountryCode": "BR"
              },
              {
                "Area": "Petrozavodsk",
                "Lat": "61.85",
                "Long": "34.28",
                "CountryCode": "RU"
              },
              {
                "Area": "Pflugerville",
                "Lat": "30.4528",
                "Long": "-97.6022",
                "CountryCode": "US"
              },
              {
                "Area": "Phan Rang",
                "Lat": "11.567",
                "Long": "108.9833",
                "CountryCode": "VN"
              },
              {
                "Area": "Phan Thiet",
                "Lat": "10.9337",
                "Long": "108.1001",
                "CountryCode": "VN"
              },
              {
                "Area": "Pharr",
                "Lat": "26.1686",
                "Long": "-98.1904",
                "CountryCode": "US"
              },
              {
                "Area": "Phetchabun",
                "Lat": "16.419",
                "Long": "101.159",
                "CountryCode": "TH"
              },
              {
                "Area": "Phetchaburi",
                "Lat": "13.1133",
                "Long": "99.9412",
                "CountryCode": "TH"
              },
              {
                "Area": "Philadelphia",
                "Lat": "40.0076",
                "Long": "-75.134",
                "CountryCode": "US"
              },
              {
                "Area": "Phitsanulok",
                "Lat": "16.8283",
                "Long": "100.2729",
                "CountryCode": "TH"
              },
              {
                "Area": "Phnom Penh",
                "Lat": "11.55",
                "Long": "104.9166",
                "CountryCode": "KH"
              },
              {
                "Area": "Phoenix",
                "Lat": "33.5722",
                "Long": "-112.0891",
                "CountryCode": "US"
              },
              {
                "Area": "Phuket",
                "Lat": "7.8765",
                "Long": "98.3815",
                "CountryCode": "TH"
              },
              {
                "Area": "Phyarpon",
                "Lat": "16.2933",
                "Long": "95.6829",
                "CountryCode": "MM"
              },
              {
                "Area": "Piatra-Neamt",
                "Lat": "46.94",
                "Long": "26.383",
                "CountryCode": "RO"
              },
              {
                "Area": "Pico Rivera",
                "Lat": "33.9902",
                "Long": "-118.0888",
                "CountryCode": "US"
              },
              {
                "Area": "Picos",
                "Lat": "-7.08",
                "Long": "-41.44",
                "CountryCode": "BR"
              },
              {
                "Area": "Piedras Negras",
                "Lat": "28.7076",
                "Long": "-100.5317",
                "CountryCode": "MX"
              },
              {
                "Area": "Pietermaritzburg",
                "Lat": "-29.61",
                "Long": "30.39",
                "CountryCode": "ZA"
              },
              {
                "Area": "Pinar del Rio",
                "Lat": "22.4175",
                "Long": "-83.6981",
                "CountryCode": "CU"
              },
              {
                "Area": "Pindamonhangaba",
                "Lat": "-22.92",
                "Long": "-45.47",
                "CountryCode": "BR"
              },
              {
                "Area": "Pinellas Park",
                "Lat": "27.8588",
                "Long": "-82.7076",
                "CountryCode": "US"
              },
              {
                "Area": "Pingdingshan",
                "Lat": "33.7304",
                "Long": "113.3",
                "CountryCode": "CN"
              },
              {
                "Area": "Pingdu",
                "Lat": "36.7904",
                "Long": "119.94",
                "CountryCode": "CN"
              },
              {
                "Area": "Pingliang",
                "Lat": "35.5304",
                "Long": "106.6801",
                "CountryCode": "CN"
              },
              {
                "Area": "Pingtung",
                "Lat": "22.6817",
                "Long": "120.4817",
                "CountryCode": "TW"
              },
              {
                "Area": "Pingxiang",
                "Lat": "27.62",
                "Long": "113.85",
                "CountryCode": "CN"
              },
              {
                "Area": "Pingyi",
                "Lat": "35.5104",
                "Long": "117.62",
                "CountryCode": "CN"
              },
              {
                "Area": "Pingzhen",
                "Lat": "24.9439",
                "Long": "121.2161",
                "CountryCode": "TW"
              },
              {
                "Area": "Pinrang",
                "Lat": "-3.7857",
                "Long": "119.6522",
                "CountryCode": "ID"
              },
              {
                "Area": "Pinsk",
                "Lat": "52.1279",
                "Long": "26.0941",
                "CountryCode": "BY"
              },
              {
                "Area": "Piracicaba",
                "Lat": "-22.71",
                "Long": "-47.64",
                "CountryCode": "BR"
              },
              {
                "Area": "Piraeus",
                "Lat": "37.95",
                "Long": "23.7",
                "CountryCode": "GR"
              },
              {
                "Area": "Pirapora",
                "Lat": "-17.33",
                "Long": "-44.93",
                "CountryCode": "BR"
              },
              {
                "Area": "Pirassununga",
                "Lat": "-21.99",
                "Long": "-47.43",
                "CountryCode": "BR"
              },
              {
                "Area": "Pisa",
                "Lat": "43.7205",
                "Long": "10.4",
                "CountryCode": "IT"
              },
              {
                "Area": "Pisco",
                "Lat": "-13.71",
                "Long": "-76.22",
                "CountryCode": "PE"
              },
              {
                "Area": "Pitești",
                "Lat": "44.8563",
                "Long": "24.8758",
                "CountryCode": "RO"
              },
              {
                "Area": "Pittsburg",
                "Lat": "38.019",
                "Long": "-121.8969",
                "CountryCode": "US"
              },
              {
                "Area": "Pittsburgh",
                "Lat": "40.4396",
                "Long": "-79.9763",
                "CountryCode": "US"
              },
              {
                "Area": "Pittsfield",
                "Lat": "42.4517",
                "Long": "-73.2605",
                "CountryCode": "US"
              },
              {
                "Area": "Piura",
                "Lat": "-5.21",
                "Long": "-80.63",
                "CountryCode": "PE"
              },
              {
                "Area": "Pizen",
                "Lat": "49.7404",
                "Long": "13.36",
                "CountryCode": "CZ"
              },
              {
                "Area": "Placentia",
                "Lat": "33.8807",
                "Long": "-117.8553",
                "CountryCode": "US"
              },
              {
                "Area": "Placetas",
                "Lat": "22.3158",
                "Long": "-79.6555",
                "CountryCode": "CU"
              },
              {
                "Area": "Plainfield",
                "Lat": "40.6154",
                "Long": "-74.4157",
                "CountryCode": "US"
              },
              {
                "Area": "Plano",
                "Lat": "33.0502",
                "Long": "-96.7487",
                "CountryCode": "US"
              },
              {
                "Area": "Plantation",
                "Lat": "26.126",
                "Long": "-80.2617",
                "CountryCode": "US"
              },
              {
                "Area": "Play Ku",
                "Lat": "13.9833",
                "Long": "108",
                "CountryCode": "VN"
              },
              {
                "Area": "Pleasanton",
                "Lat": "37.6664",
                "Long": "-121.8805",
                "CountryCode": "US"
              },
              {
                "Area": "Pleven",
                "Lat": "43.4238",
                "Long": "24.6134",
                "CountryCode": "BG"
              },
              {
                "Area": "Ploiești",
                "Lat": "44.9469",
                "Long": "26.0365",
                "CountryCode": "RO"
              },
              {
                "Area": "Plovdiv",
                "Lat": "42.154",
                "Long": "24.754",
                "CountryCode": "BG"
              },
              {
                "Area": "Plymouth",
                "Lat": "50.3854",
                "Long": "-4.16",
                "CountryCode": "GB"
              },
              {
                "Area": "Plymouth",
                "Lat": "45.0224",
                "Long": "-93.4615",
                "CountryCode": "US"
              },
              {
                "Area": "Pocatello",
                "Lat": "42.8716",
                "Long": "-112.4656",
                "CountryCode": "US"
              },
              {
                "Area": "Poços de Caldas",
                "Lat": "-21.78",
                "Long": "-46.57",
                "CountryCode": "BR"
              },
              {
                "Area": "Podgorica",
                "Lat": "42.466",
                "Long": "19.2663",
                "CountryCode": "ME"
              },
              {
                "Area": "Podolsk",
                "Lat": "55.3804",
                "Long": "37.5299",
                "CountryCode": "RU"
              },
              {
                "Area": "Pohang",
                "Lat": "36.0209",
                "Long": "129.3715",
                "CountryCode": "kr"
              },
              {
                "Area": "Pointe-à-Pitre",
                "Lat": "16.2415",
                "Long": "-61.533",
                "CountryCode": "GP"
              },
              {
                "Area": "Pointe-Noire",
                "Lat": "-4.77",
                "Long": "11.88",
                "CountryCode": "CG"
              },
              {
                "Area": "Poitier",
                "Lat": "46.5833",
                "Long": "0.3333",
                "CountryCode": "FR"
              },
              {
                "Area": "Pokhara",
                "Lat": "28.264",
                "Long": "83.972",
                "CountryCode": "NP"
              },
              {
                "Area": "Pol-e Khomri",
                "Lat": "35.9511",
                "Long": "68.7011",
                "CountryCode": "AF"
              },
              {
                "Area": "Polatlı",
                "Lat": "39.5842",
                "Long": "32.1472",
                "CountryCode": "TR"
              },
              {
                "Area": "Polatsk",
                "Lat": "55.4894",
                "Long": "28.786",
                "CountryCode": "BY"
              },
              {
                "Area": "Polevskoy",
                "Lat": "56.4434",
                "Long": "60.188",
                "CountryCode": "RU"
              },
              {
                "Area": "Polokwane",
                "Lat": "-23.89",
                "Long": "29.45",
                "CountryCode": "ZA"
              },
              {
                "Area": "Poltava",
                "Lat": "49.574",
                "Long": "34.5703",
                "CountryCode": "UA"
              },
              {
                "Area": "Pomona",
                "Lat": "34.0585",
                "Long": "-117.7625",
                "CountryCode": "US"
              },
              {
                "Area": "Pompano Beach",
                "Lat": "26.2428",
                "Long": "-80.1312",
                "CountryCode": "US"
              },
              {
                "Area": "Ponta Delgada",
                "Lat": "37.7483",
                "Long": "-25.6666",
                "CountryCode": "PT"
              },
              {
                "Area": "Ponta Grossa",
                "Lat": "-25.09",
                "Long": "-50.16",
                "CountryCode": "BR"
              },
              {
                "Area": "Ponta Porã",
                "Lat": "-22.53",
                "Long": "-55.73",
                "CountryCode": "BR"
              },
              {
                "Area": "Pontiac",
                "Lat": "42.6493",
                "Long": "-83.2878",
                "CountryCode": "US"
              },
              {
                "Area": "Pontianak",
                "Lat": "-0.03",
                "Long": "109.32",
                "CountryCode": "ID"
              },
              {
                "Area": "Popayán",
                "Lat": "2.42",
                "Long": "-76.61",
                "CountryCode": "CO"
              },
              {
                "Area": "Pori",
                "Lat": "61.4789",
                "Long": "21.7749",
                "CountryCode": "FI"
              },
              {
                "Area": "Porirua",
                "Lat": "-41.1219",
                "Long": "174.8524",
                "CountryCode": "NZ"
              },
              {
                "Area": "Porlamar",
                "Lat": "10.9604",
                "Long": "-63.85",
                "CountryCode": "VE"
              },
              {
                "Area": "Port Arthur",
                "Lat": "29.8554",
                "Long": "-93.9264",
                "CountryCode": "US"
              },
              {
                "Area": "Port Elizabeth",
                "Lat": "-33.97",
                "Long": "25.6",
                "CountryCode": "ZA"
              },
              {
                "Area": "Port Harcourt",
                "Lat": "4.81",
                "Long": "7.01",
                "CountryCode": "NG"
              },
              {
                "Area": "Port Huron",
                "Lat": "42.9822",
                "Long": "-82.4387",
                "CountryCode": "US"
              },
              {
                "Area": "Port Louis",
                "Lat": "-20.1666",
                "Long": "57.5",
                "CountryCode": "MU"
              },
              {
                "Area": "Port Moresby",
                "Lat": "-9.4647",
                "Long": "147.1925",
                "CountryCode": "PG"
              },
              {
                "Area": "Port Orange",
                "Lat": "29.1084",
                "Long": "-81.0136",
                "CountryCode": "US"
              },
              {
                "Area": "Port Saint Lucie",
                "Lat": "27.2796",
                "Long": "-80.3883",
                "CountryCode": "US"
              },
              {
                "Area": "Port Shepstone",
                "Lat": "-30.7195",
                "Long": "30.46",
                "CountryCode": "ZA"
              },
              {
                "Area": "Port SD",
                "Lat": "19.6158",
                "Long": "37.2164",
                "CountryCode": "SD"
              },
              {
                "Area": "Port-au-Prince",
                "Lat": "18.541",
                "Long": "-72.336",
                "CountryCode": "HT"
              },
              {
                "Area": "Port-Gentil",
                "Lat": "-0.72",
                "Long": "8.78",
                "CountryCode": "GA"
              },
              {
                "Area": "Port-of-ES",
                "Lat": "10.652",
                "Long": "-61.517",
                "CountryCode": "TT"
              },
              {
                "Area": "Porterville",
                "Lat": "36.0644",
                "Long": "-119.0337",
                "CountryCode": "US"
              },
              {
                "Area": "Portimão",
                "Lat": "37.1337",
                "Long": "-8.5333",
                "CountryCode": "PT"
              },
              {
                "Area": "Portland",
                "Lat": "45.5372",
                "Long": "-122.65",
                "CountryCode": "US"
              },
              {
                "Area": "Portland",
                "Lat": "43.6773",
                "Long": "-70.2715",
                "CountryCode": "US"
              },
              {
                "Area": "Porto",
                "Lat": "41.15",
                "Long": "-8.62",
                "CountryCode": "PT"
              },
              {
                "Area": "Porto Alegre",
                "Lat": "-30.05",
                "Long": "-51.2",
                "CountryCode": "BR"
              },
              {
                "Area": "Porto Santana",
                "Lat": "-0.0396",
                "Long": "-51.18",
                "CountryCode": "BR"
              },
              {
                "Area": "Porto Seguro",
                "Lat": "-16.4296",
                "Long": "-39.08",
                "CountryCode": "BR"
              },
              {
                "Area": "Porto União",
                "Lat": "-26.2396",
                "Long": "-51.08",
                "CountryCode": "BR"
              },
              {
                "Area": "Porto Velho",
                "Lat": "-8.75",
                "Long": "-63.9",
                "CountryCode": "BR"
              },
              {
                "Area": "Porto-Novo",
                "Lat": "6.4833",
                "Long": "2.6166",
                "CountryCode": "BJ"
              },
              {
                "Area": "Portoviejo",
                "Lat": "-1.06",
                "Long": "-80.46",
                "CountryCode": "EC"
              },
              {
                "Area": "Portsmouth",
                "Lat": "50.8003",
                "Long": "-1.08",
                "CountryCode": "GB"
              },
              {
                "Area": "Portsmouth",
                "Lat": "36.8468",
                "Long": "-76.354",
                "CountryCode": "US"
              },
              {
                "Area": "Portsmouth",
                "Lat": "43.058",
                "Long": "-70.7826",
                "CountryCode": "US"
              },
              {
                "Area": "Posadas",
                "Lat": "-27.3578",
                "Long": "-55.8851",
                "CountryCode": "AR"
              },
              {
                "Area": "Potchefstroom",
                "Lat": "-26.6996",
                "Long": "27.1",
                "CountryCode": "ZA"
              },
              {
                "Area": "Potenza",
                "Lat": "40.642",
                "Long": "15.799",
                "CountryCode": "IT"
              },
              {
                "Area": "Potiskum",
                "Lat": "11.7104",
                "Long": "11.08",
                "CountryCode": "NG"
              },
              {
                "Area": "Potosí",
                "Lat": "-19.5696",
                "Long": "-65.75",
                "CountryCode": "BO"
              },
              {
                "Area": "Potsdam",
                "Lat": "52.4004",
                "Long": "13.07",
                "CountryCode": "DE"
              },
              {
                "Area": "Pottstown",
                "Lat": "40.2508",
                "Long": "-75.6445",
                "CountryCode": "US"
              },
              {
                "Area": "Poughkeepsie",
                "Lat": "41.6949",
                "Long": "-73.921",
                "CountryCode": "US"
              },
              {
                "Area": "Pouso Alegre",
                "Lat": "-22.22",
                "Long": "-45.94",
                "CountryCode": "BR"
              },
              {
                "Area": "Poway",
                "Lat": "32.9871",
                "Long": "-117.0201",
                "CountryCode": "US"
              },
              {
                "Area": "Poza Rica de Hidalgo",
                "Lat": "20.5504",
                "Long": "-97.47",
                "CountryCode": "MX"
              },
              {
                "Area": "Poznań",
                "Lat": "52.4058",
                "Long": "16.8999",
                "CountryCode": "PL"
              },
              {
                "Area": "Prachin Buri",
                "Lat": "14.0572",
                "Long": "101.3768",
                "CountryCode": "TH"
              },
              {
                "Area": "Prague",
                "Lat": "50.0833",
                "Long": "14.466",
                "CountryCode": "CZ"
              },
              {
                "Area": "Praia",
                "Lat": "14.9167",
                "Long": "-23.5167",
                "CountryCode": "CV"
              },
              {
                "Area": "Prescott Valley",
                "Lat": "34.5982",
                "Long": "-112.3178",
                "CountryCode": "US"
              },
              {
                "Area": "Presidencia Roque Saenz Pena",
                "Lat": "-26.79",
                "Long": "-60.45",
                "CountryCode": "AR"
              },
              {
                "Area": "Presidente Prudente",
                "Lat": "-22.12",
                "Long": "-51.39",
                "CountryCode": "BR"
              },
              {
                "Area": "Prešov",
                "Lat": "48.9997",
                "Long": "21.2394",
                "CountryCode": "SK"
              },
              {
                "Area": "Pretoria",
                "Lat": "-25.7069",
                "Long": "28.2294",
                "CountryCode": "ZA"
              },
              {
                "Area": "Prey Veng",
                "Lat": "11.484",
                "Long": "105.324",
                "CountryCode": "KH"
              },
              {
                "Area": "Prijedor",
                "Lat": "44.9804",
                "Long": "16.7",
                "CountryCode": "BA"
              },
              {
                "Area": "Prince George",
                "Lat": "53.9167",
                "Long": "-122.7667",
                "CountryCode": "CA"
              },
              {
                "Area": "Probolinggo",
                "Lat": "-7.7496",
                "Long": "113.15",
                "CountryCode": "ID"
              },
              {
                "Area": "Prokopyevsk",
                "Lat": "53.9",
                "Long": "86.71",
                "CountryCode": "RU"
              },
              {
                "Area": "Providence",
                "Lat": "41.8229",
                "Long": "-71.4186",
                "CountryCode": "US"
              },
              {
                "Area": "Provo",
                "Lat": "40.2458",
                "Long": "-111.6457",
                "CountryCode": "US"
              },
              {
                "Area": "Pskov",
                "Lat": "57.83",
                "Long": "28.3299",
                "CountryCode": "RU"
              },
              {
                "Area": "Pucallpa",
                "Lat": "-8.3689",
                "Long": "-74.535",
                "CountryCode": "PE"
              },
              {
                "Area": "Puch'on",
                "Lat": "37.4989",
                "Long": "126.7831",
                "CountryCode": "kr"
              },
              {
                "Area": "Puebla",
                "Lat": "19.05",
                "Long": "-98.2",
                "CountryCode": "MX"
              },
              {
                "Area": "Pueblo",
                "Lat": "38.2701",
                "Long": "-104.6131",
                "CountryCode": "US"
              },
              {
                "Area": "Puerto Ayacucho",
                "Lat": "5.6639",
                "Long": "-67.6236",
                "CountryCode": "VE"
              },
              {
                "Area": "Puerto Barrios",
                "Lat": "15.7175",
                "Long": "-88.5927",
                "CountryCode": "GT"
              },
              {
                "Area": "Puerto Cabello",
                "Lat": "10.4704",
                "Long": "-68.17",
                "CountryCode": "VE"
              },
              {
                "Area": "Puerto la Cruz",
                "Lat": "10.17",
                "Long": "-64.68",
                "CountryCode": "VE"
              },
              {
                "Area": "Puerto Limon",
                "Lat": "10",
                "Long": "-83.0333",
                "CountryCode": "CR"
              },
              {
                "Area": "Puerto Madryn",
                "Lat": "-42.77",
                "Long": "-65.04",
                "CountryCode": "AR"
              },
              {
                "Area": "Puerto Maldonado",
                "Lat": "-12.6",
                "Long": "-69.1833",
                "CountryCode": "PE"
              },
              {
                "Area": "Puerto Montt",
                "Lat": "-41.47",
                "Long": "-72.93",
                "CountryCode": "CL"
              },
              {
                "Area": "Puerto Plata",
                "Lat": "19.7902",
                "Long": "-70.6902",
                "CountryCode": "DO"
              },
              {
                "Area": "Puerto Princesa",
                "Lat": "9.7543",
                "Long": "118.7444",
                "CountryCode": "PH"
              },
              {
                "Area": "Puerto Vallarta",
                "Lat": "20.6771",
                "Long": "-105.245",
                "CountryCode": "MX"
              },
              {
                "Area": "Pula",
                "Lat": "44.8687",
                "Long": "13.8481",
                "CountryCode": "HR"
              },
              {
                "Area": "Puno",
                "Lat": "-15.8329",
                "Long": "-70.0333",
                "CountryCode": "PE"
              },
              {
                "Area": "Punta Alta",
                "Lat": "-38.88",
                "Long": "-62.08",
                "CountryCode": "AR"
              },
              {
                "Area": "Punta Arenas",
                "Lat": "-53.165",
                "Long": "-70.94",
                "CountryCode": "CL"
              },
              {
                "Area": "Punta del Este",
                "Lat": "-34.97",
                "Long": "-54.95",
                "CountryCode": "UY"
              },
              {
                "Area": "Puntarenas",
                "Lat": "9.9702",
                "Long": "-84.8336",
                "CountryCode": "CR"
              },
              {
                "Area": "Punto Fijo",
                "Lat": "11.72",
                "Long": "-70.21",
                "CountryCode": "VE"
              },
              {
                "Area": "Puqi",
                "Lat": "29.7204",
                "Long": "113.88",
                "CountryCode": "CN"
              },
              {
                "Area": "Pursat",
                "Lat": "12.5337",
                "Long": "103.9167",
                "CountryCode": "KH"
              },
              {
                "Area": "Putian",
                "Lat": "25.4303",
                "Long": "119.02",
                "CountryCode": "CN"
              },
              {
                "Area": "Putrajaya",
                "Lat": "2.914",
                "Long": "101.7019",
                "CountryCode": "MY"
              },
              {
                "Area": "Puyang",
                "Lat": "35.7004",
                "Long": "114.98",
                "CountryCode": "CN"
              },
              {
                "Area": "Puzi",
                "Lat": "23.4611",
                "Long": "120.2419",
                "CountryCode": "TW"
              },
              {
                "Area": "Pyatigorsk",
                "Lat": "44.08",
                "Long": "43.09",
                "CountryCode": "RU"
              },
              {
                "Area": "Pyay",
                "Lat": "18.8165",
                "Long": "95.2114",
                "CountryCode": "MM"
              },
              {
                "Area": "Pyongsan",
                "Lat": "38.3367",
                "Long": "126.3866",
                "CountryCode": "KP"
              },
              {
                "Area": "Pyongyang",
                "Lat": "39.0194",
                "Long": "125.7547",
                "CountryCode": "KP"
              },
              {
                "Area": "Panaji",
                "State": "Goa",
                "CountryCode": "IN",
                "Lat": 15.49678,
                "Long": 73.82783
              },
              {
                "Area": "Ponda",
                "State": "Goa",
                "CountryCode": "IN",
                "Lat": 15.403,
                "Long": 74.028
              },
              
                {
                  "Area": "satgachia",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.0258,
                  "Long": 88.3583
                },
                {
                  "Area": "Qaimoh",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 34.1151,
                  "Long": 74.8647
                },
                {
                  "Area": "Qanmar",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.9509,
                  "Long": 75.0932
                },
                {
                  "Area": "Qasba Kotla",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.9412,
                  "Long": 75.9883
                },
                {
                  "Area": "Qazigund",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.6383,
                  "Long": 75.1844
                },
                {
                  "Area": "Quasba Kotla",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 32.1088,
                  "Long": 76.3177
                },
                {
                  "Area": "Quepem",
                  "State": "Goa",
                  "CountryCode": "IN",
                  "Lat": 15.335,
                  "Long": 74.2443
                },
                {
                  "Area": "Quilandy",
                  "State": "Kerala",
                  "CountryCode": "IN",
                  "Lat": 11.6411,
                  "Long": 76.2482
                },
                {
                  "Area": "Qusba Kotla",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 32.0984,
                  "Long": 76.4549
                },
                {
                  "Area": "Quthbullapur Mandal",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.5902,
                  "Long": 78.6668
                },
                {
                  "Area": "Qutubullapur",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.5371,
                  "Long": 78.4699
                },
                {
                  "Area": "R",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 18.0884,
                  "Long": 78.486
                },
                {
                  "Area": "R H Hall",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.8072,
                  "Long": 74.8689
                },
                {
                  "Area": "R K Nagar",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.0884,
                  "Long": 81.7153
                },
                {
                  "Area": "R N Project",
                  "State": "Arunachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.422,
                  "Long": 93.6719
                },
                {
                  "Area": "R. Amadalavalasa",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.5884,
                  "Long": 83.7432
                },
                {
                  "Area": "R. Saidpur",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.576,
                  "Long": 85.8794
                },
                {
                  "Area": "R.Udaygiri",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 19.4879,
                  "Long": 84.4721
                },
                {
                  "Area": "R.amadalavalasa",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.5472,
                  "Long": 83.7626
                },
                {
                  "Area": "R.c.project",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 23.2202,
                  "Long": 86.0029
                },
                {
                  "Area": "R.c.puram",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.7372,
                  "Long": 77.9095
                },
                {
                  "Area": "R.g. Pur",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.8952,
                  "Long": 86.4112
                },
                {
                  "Area": "R.g.pur",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.9476,
                  "Long": 86.9887
                },
                {
                  "Area": "R.p.barh",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.2758,
                  "Long": 88.831
                },
                {
                  "Area": "R.saidpur",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.576,
                  "Long": 86.0939
                },
                {
                  "Area": "R.udayagiri",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 19.6378,
                  "Long": 84.4721
                },
                {
                  "Area": "RAYA",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.8144,
                  "Long": 77.34
                },
                {
                  "Area": "Raajsamand",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 25.1555,
                  "Long": 73.8895
                },
                {
                  "Area": "Rabale",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 19.1167,
                  "Long": 72.9833
                },
                {
                  "Area": "Racherla",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 15.6213,
                  "Long": 79.5158
                },
                {
                  "Area": "Radaur",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 30.3285,
                  "Long": 76.9422
                },
                {
                  "Area": "Radhakishorepur",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 23.4668,
                  "Long": 91.4007
                },
                {
                  "Area": "Radhakishorepur H.O",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 23.7062,
                  "Long": 91.4203
                },
                {
                  "Area": "Radhanagar",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 23.2518,
                  "Long": 91.4541
                },
                {
                  "Area": "Radhanagari",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.9484,
                  "Long": 77.1326
                },
                {
                  "Area": "Radhanpur",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 23.8876,
                  "Long": 71.973
                },
                {
                  "Area": "Radhapur",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.0447,
                  "Long": 91.7553
                },
                {
                  "Area": "Radhapuram",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 10.4684,
                  "Long": 79.846
                },
                {
                  "Area": "Rae Bareli",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.2432,
                  "Long": 81.5416
                },
                {
                  "Area": "Raebareli",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.366,
                  "Long": 81.5157
                },
                {
                  "Area": "Raebarely",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.3029,
                  "Long": 81.5157
                },
                {
                  "Area": "Rafigang",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 24.8379,
                  "Long": 84.5255
                },
                {
                  "Area": "Rafiganj",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 24.9331,
                  "Long": 84.6859
                },
                {
                  "Area": "Raga",
                  "State": "Arunachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.5535,
                  "Long": 93.7868
                },
                {
                  "Area": "Ragahopur",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.2425,
                  "Long": 86.6173
                },
                {
                  "Area": "Ragampeta",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 17.5302,
                  "Long": 82.3576
                },
                {
                  "Area": "Raghna",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.0447,
                  "Long": 91.7553
                },
                {
                  "Area": "Raghogarh",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.6015,
                  "Long": 78.3381
                },
                {
                  "Area": "Raghopur",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.2906,
                  "Long": 86.9292
                },
                {
                  "Area": "Raghuathpur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.4704,
                  "Long": 86.4988
                },
                {
                  "Area": "Raghunath Pur I",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.4704,
                  "Long": 86.4988
                },
                {
                  "Area": "Raghunathapali",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 22.0798,
                  "Long": 84.638
                },
                {
                  "Area": "Raghunathapalli",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.8315,
                  "Long": 79.3211
                },
                {
                  "Area": "Raghunathganj - I",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.47,
                  "Long": 88.231
                },
                {
                  "Area": "Raghunathganj - II",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.5643,
                  "Long": 88.231
                },
                {
                  "Area": "Raghunathpalle",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.8315,
                  "Long": 79.3211
                },
                {
                  "Area": "Raghunathpalli",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 18.3307,
                  "Long": 79.9204
                },
                {
                  "Area": "Raghunathpally",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.8315,
                  "Long": 79.3211
                },
                {
                  "Area": "Raghunathplli",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.7288,
                  "Long": 79.2399
                },
                {
                  "Area": "Raghunathpur",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 20.416,
                  "Long": 85.2438
                },
                {
                  "Area": "Raghunathpur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.6244,
                  "Long": 88.8278
                },
                {
                  "Area": "Raghunathpur - II",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.4672,
                  "Long": 86.7136
                },
                {
                  "Area": "Raghuraj Nagar",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.6207,
                  "Long": 80.6013
                },
                {
                  "Area": "Raghurajnagar",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 25.0439,
                  "Long": 81.2032
                },
                {
                  "Area": "Raha",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.2333,
                  "Long": 92.5167
                },
                {
                  "Area": "Rahargora",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 23.5378,
                  "Long": 85.9803
                },
                {
                  "Area": "Rahata",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 19.8934,
                  "Long": 76.5295
                },
                {
                  "Area": "Rahatgarh",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.9062,
                  "Long": 78.5642
                },
                {
                  "Area": "Rahmahal",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.678,
                  "Long": 87.691
                },
                {
                  "Area": "Rahpar",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 23.9104,
                  "Long": 70.9827
                },
                {
                  "Area": "Rahta",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 19.6096,
                  "Long": 75.9355
                },
                {
                  "Area": "Rahui",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.3148,
                  "Long": 85.6062
                },
                {
                  "Area": "Rahumcherra",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.1597,
                  "Long": 92.0329
                },
                {
                  "Area": "Rahuri",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 19.5683,
                  "Long": 75.5072
                },
                {
                  "Area": "Raibag",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 16.6447,
                  "Long": 75.3964
                },
                {
                  "Area": "Raibania",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.8952,
                  "Long": 87.1928
                },
                {
                  "Area": "Raichur",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 16.3912,
                  "Long": 77.5405
                },
                {
                  "Area": "Raidighi",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.4339,
                  "Long": 88.3542
                },
                {
                  "Area": "Raidih",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 22.9783,
                  "Long": 84.4751
                },
                {
                  "Area": "Raiganj",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 25.9889,
                  "Long": 88.2859
                },
                {
                  "Area": "Raigarh",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 22.392,
                  "Long": 83.6753
                },
                {
                  "Area": "Raiggarh",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 21.92,
                  "Long": 83.3167
                },
                {
                  "Area": "Raighar",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 19.9097,
                  "Long": 82.5103
                },
                {
                  "Area": "Raigrh",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 21.8047,
                  "Long": 82.8732
                },
                {
                  "Area": "Raikai",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 20.1182,
                  "Long": 84.5795
                },
                {
                  "Area": "Raikal",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 19.0295,
                  "Long": 78.8734
                },
                {
                  "Area": "Raikhan",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.4784,
                  "Long": 88.5822
                },
                {
                  "Area": "Raikia",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 20.1289,
                  "Long": 84.5795
                },
                {
                  "Area": "Raikot",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 31.3755,
                  "Long": 76.3395
                },
                {
                  "Area": "Railganj",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.5167,
                  "Long": 80.3155
                },
                {
                  "Area": "Railmagra",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 25.3642,
                  "Long": 74.5977
                },
                {
                  "Area": "Railway Road",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.4592,
                  "Long": 76.985
                },
                {
                  "Area": "Raina",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.9328,
                  "Long": 88.1499
                },
                {
                  "Area": "Raina - I",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.7617,
                  "Long": 88.0871
                },
                {
                  "Area": "Raina - II",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.2628,
                  "Long": 87.951
                },
                {
                  "Area": "Rainawari",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 34.1758,
                  "Long": 74.9148
                },
                {
                  "Area": "Raiparhty",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.6733,
                  "Long": 79.578
                },
                {
                  "Area": "Raiparthy",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.7388,
                  "Long": 79.6801
                },
                {
                  "Area": "Raipur",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.825,
                  "Long": 85.7842
                },
                {
                  "Area": "Raipur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.0481,
                  "Long": 87.7549
                },
                {
                  "Area": "Raipur",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 26.3784,
                  "Long": 74.491
                },
                {
                  "Area": "Raipur",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 22.9994,
                  "Long": 82.2147
                },
                {
                  "Area": "Raipur  Mwr",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 26.0828,
                  "Long": 74.195
                },
                {
                  "Area": "Raipur - Karchuliyan",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 25.0301,
                  "Long": 81.7307
                },
                {
                  "Area": "Raipur Kukhat",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.5127,
                  "Long": 80.5703
                },
                {
                  "Area": "Raipur Mwr",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 26.0971,
                  "Long": 73.9977
                },
                {
                  "Area": "Raipura",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.4205,
                  "Long": 80.1917
                },
                {
                  "Area": "Rairakhol",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.1823,
                  "Long": 84.4189
                },
                {
                  "Area": "Rairangpur",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 22.0898,
                  "Long": 86.4112
                },
                {
                  "Area": "Raisen",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.6389,
                  "Long": 78.3782
                },
                {
                  "Area": "Raisinghnagar",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 29.5358,
                  "Long": 75.7638
                },
                {
                  "Area": "Raithan",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.9187,
                  "Long": 74.6578
                },
                {
                  "Area": "Raja Sansi",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 31.7237,
                  "Long": 74.941
                },
                {
                  "Area": "Rajaahmundry Rural",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 17.0067,
                  "Long": 81.8297
                },
                {
                  "Area": "Rajabhatkhawa",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 26.7024,
                  "Long": 89.6107
                },
                {
                  "Area": "Rajagangapur",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 22.2164,
                  "Long": 84.6635
                },
                {
                  "Area": "Rajahmundry",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 17.4131,
                  "Long": 82.239
                },
                {
                  "Area": "Rajahmundry (Urban)",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 17.4501,
                  "Long": 82.239
                },
                {
                  "Area": "Rajahmundry Rural",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 17.5702,
                  "Long": 82.2756
                },
                {
                  "Area": "Rajakhera",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 26.9373,
                  "Long": 78.2531
                },
                {
                  "Area": "Rajam",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.4491,
                  "Long": 83.6596
                },
                {
                  "Area": "Rajam Mandal",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.4924,
                  "Long": 83.6711
                },
                {
                  "Area": "Rajampet",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.4599,
                  "Long": 79.2854
                },
                {
                  "Area": "Rajanagar",
                  "State": "Arunachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.9126,
                  "Long": 96.1288
                },
                {
                  "Area": "Rajanagar",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.57,
                  "Long": 79.6699
                },
                {
                  "Area": "Rajanagaram",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 17.5302,
                  "Long": 82.5754
                },
                {
                  "Area": "Rajapakar",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.9655,
                  "Long": 85.3917
                },
                {
                  "Area": "Rajapalayam",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 9.4841,
                  "Long": 78.0053
                },
                {
                  "Area": "Rajapur",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 21.4937,
                  "Long": 77.4601
                },
                {
                  "Area": "Rajarhat",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.7611,
                  "Long": 88.7803
                },
                {
                  "Area": "Rajasamand",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 25.2541,
                  "Long": 73.6953
                },
                {
                  "Area": "Rajauli",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 24.811,
                  "Long": 85.5941
                },
                {
                  "Area": "Rajaun",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.3885,
                  "Long": 87.0588
                },
                {
                  "Area": "Rajaund",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 29.6036,
                  "Long": 76.5362
                },
                {
                  "Area": "Rajauri",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.4224,
                  "Long": 74.3076
                },
                {
                  "Area": "Rajavommangi",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 17.6533,
                  "Long": 82.2338
                },
                {
                  "Area": "Rajballapur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.8794,
                  "Long": 88.2197
                },
                {
                  "Area": "Rajborasambar",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.2202,
                  "Long": 83.4858
                },
                {
                  "Area": "Rajborasamber",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.0865,
                  "Long": 83.2454
                },
                {
                  "Area": "Rajendra Nagar",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.3955,
                  "Long": 78.3347
                },
                {
                  "Area": "Rajendranagar",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.4661,
                  "Long": 78.4914
                },
                {
                  "Area": "Rajendrapur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.8968,
                  "Long": 88.4392
                },
                {
                  "Area": "Rajgamar",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 22.5323,
                  "Long": 82.8768
                },
                {
                  "Area": "Rajgangpur",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 22.0798,
                  "Long": 84.5106
                },
                {
                  "Area": "Rajganj",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 26.731,
                  "Long": 89.0844
                },
                {
                  "Area": "Rajgarah",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 30.7385,
                  "Long": 77.3152
                },
                {
                  "Area": "Rajgarh",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 28.6543,
                  "Long": 76.9693
                },
                {
                  "Area": "Rajgarh",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.6243,
                  "Long": 76.9062
                },
                {
                  "Area": "Rajgarh",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.0912,
                  "Long": 76.4723
                },
                {
                  "Area": "Rajgarh",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.19,
                  "Long": 77.4344
                },
                {
                  "Area": "Rajgarh",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 27.3779,
                  "Long": 95.2828
                },
                {
                  "Area": "Rajgarh(bia)",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.0497,
                  "Long": 77.0932
                },
                {
                  "Area": "Rajgarhi",
                  "State": "Uttarakhand",
                  "CountryCode": "IN",
                  "Lat": 30.9731,
                  "Long": 79.0568
                },
                {
                  "Area": "Rajghar",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.7362,
                  "Long": 77.431
                },
                {
                  "Area": "Rajgir",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.3129,
                  "Long": 85.4803
                },
                {
                  "Area": "Rajibpur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.8767,
                  "Long": 88.585
                },
                {
                  "Area": "Rajim",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 21.7037,
                  "Long": 82.4115
                },
                {
                  "Area": "Rajkandi",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.0447,
                  "Long": 91.7553
                },
                {
                  "Area": "Rajkanika",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 20.7933,
                  "Long": 86.7068
                },
                {
                  "Area": "Rajkot",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 23.2395,
                  "Long": 71.1629
                },
                {
                  "Area": "Rajmahal",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 25.0081,
                  "Long": 87.7409
                },
                {
                  "Area": "Rajnagar",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.9589,
                  "Long": 80.4778
                },
                {
                  "Area": "Rajnagar",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.0447,
                  "Long": 91.7553
                },
                {
                  "Area": "Rajnagar",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.1261,
                  "Long": 87.6915
                },
                {
                  "Area": "Rajnagar",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 23.0809,
                  "Long": 85.96
                },
                {
                  "Area": "Rajnagar",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.4609,
                  "Long": 86.3152
                },
                {
                  "Area": "Rajnagar",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 20.732,
                  "Long": 86.931
                },
                {
                  "Area": "Rajnandgaon",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 21.4513,
                  "Long": 81.3258
                },
                {
                  "Area": "Rajoun",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.3885,
                  "Long": 87.0682
                },
                {
                  "Area": "Rajouri",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.7428,
                  "Long": 74.7129
                },
                {
                  "Area": "Rajpipala",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 21.8315,
                  "Long": 73.2106
                },
                {
                  "Area": "Rajpora",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.9304,
                  "Long": 74.71
                },
                {
                  "Area": "Rajpur",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 22.6229,
                  "Long": 82.8003
                },
                {
                  "Area": "Rajpur",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.6749,
                  "Long": 84.5448
                },
                {
                  "Area": "Rajpur",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 22.0043,
                  "Long": 75.5504
                },
                {
                  "Area": "Rajpura",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 31.2068,
                  "Long": 76.8209
                },
                {
                  "Area": "Rajsamand",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 25.9859,
                  "Long": 74.3868
                },
                {
                  "Area": "Rajsmand",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 25.0827,
                  "Long": 73.9458
                },
                {
                  "Area": "Rajula",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 23.2906,
                  "Long": 72.9648
                },
                {
                  "Area": "Rajupalam",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.945,
                  "Long": 79.2222
                },
                {
                  "Area": "Rajupalem",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 16.4798,
                  "Long": 80.0873
                },
                {
                  "Area": "Rajura",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.4131,
                  "Long": 79.625
                },
                {
                  "Area": "Rakkar",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 32.1088,
                  "Long": 76.43
                },
                {
                  "Area": "Rakkar(S.T)",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.8147,
                  "Long": 76.2691
                },
                {
                  "Area": "Ralegaon",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.4239,
                  "Long": 78.7181
                },
                {
                  "Area": "Ralegoan",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.394,
                  "Long": 78.4486
                },
                {
                  "Area": "Raliawas",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.1588,
                  "Long": 76.7177
                },
                {
                  "Area": "Ram Sanehi Gaht",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.8981,
                  "Long": 81.5271
                },
                {
                  "Area": "Ram Sanehi Ghat",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.0636,
                  "Long": 81.8539
                },
                {
                  "Area": "Rama Devi Chauraha",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.5167,
                  "Long": 80.3155
                },
                {
                  "Area": "Ramabhadrapuram",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.5147,
                  "Long": 83.3001
                },
                {
                  "Area": "Ramachandrapuram",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 17.602,
                  "Long": 82.3082
                },
                {
                  "Area": "Ramachandrapuram",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.8409,
                  "Long": 78.3705
                },
                {
                  "Area": "Ramadugu",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 18.6237,
                  "Long": 79.0923
                },
                {
                  "Area": "Ramagiri",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.4443,
                  "Long": 77.917
                },
                {
                  "Area": "Ramagundam",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 18.8152,
                  "Long": 79.474
                },
                {
                  "Area": "Ramaipur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.3441,
                  "Long": 80.299
                },
                {
                  "Area": "Ramakuppam",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 13.4673,
                  "Long": 79.0143
                },
                {
                  "Area": "Ramanagar",
                  "State": "Uttarakhand",
                  "CountryCode": "IN",
                  "Lat": 29.4516,
                  "Long": 79.1015
                },
                {
                  "Area": "Ramanagar",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 12.7707,
                  "Long": 77.4178
                },
                {
                  "Area": "Ramanagara",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 12.9904,
                  "Long": 77.4178
                },
                {
                  "Area": "Ramanagaram",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 12.6926,
                  "Long": 77.3365
                },
                {
                  "Area": "Ramanathapuram",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 10.287,
                  "Long": 79.1236
                },
                {
                  "Area": "Ramanathpuram",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 9.5066,
                  "Long": 78.499
                },
                {
                  "Area": "Ramangara",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 12.9904,
                  "Long": 77.4491
                },
                {
                  "Area": "Ramangaram",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 12.8014,
                  "Long": 77.3046
                },
                {
                  "Area": "Ramannapeta So",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.2785,
                  "Long": 79.3718
                },
                {
                  "Area": "Ramapuram",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.4599,
                  "Long": 79.0116
                },
                {
                  "Area": "Ramasamudram",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 13.3941,
                  "Long": 78.7333
                },
                {
                  "Area": "Ramathirtam",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.1821,
                  "Long": 83.5498
                },
                {
                  "Area": "Ramban",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.4097,
                  "Long": 75.6497
                },
                {
                  "Area": "Rambas",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.2709,
                  "Long": 76.317
                },
                {
                  "Area": "Rambha",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 19.5253,
                  "Long": 85.1
                },
                {
                  "Area": "Ramchak",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 21.8532,
                  "Long": 87.9147
                },
                {
                  "Area": "Ramchandra Pur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.3901,
                  "Long": 88.4818
                },
                {
                  "Area": "Ramchandraghat",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.0796,
                  "Long": 91.625
                },
                {
                  "Area": "Ramchandrapur Khaspur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.4948,
                  "Long": 88.4232
                },
                {
                  "Area": "Ramdurg",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 16.1195,
                  "Long": 75.455
                },
                {
                  "Area": "Rameswaram",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 9.4401,
                  "Long": 79.3127
                },
                {
                  "Area": "Rameswarpur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.5475,
                  "Long": 88.9444
                },
                {
                  "Area": "Ramgarah",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.3197,
                  "Long": 87.2666
                },
                {
                  "Area": "Ramgarh",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.8959,
                  "Long": 87.5554
                },
                {
                  "Area": "Ramgarh",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.6929,
                  "Long": 87.0587
                },
                {
                  "Area": "Ramgarh",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 32.6061,
                  "Long": 74.9574
                },
                {
                  "Area": "Ramgarh",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.3655,
                  "Long": 86.5274
                },
                {
                  "Area": "Ramgarh",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 27.7506,
                  "Long": 76.9336
                },
                {
                  "Area": "Ramgarh Cantt",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 23.7041,
                  "Long": 85.7588
                },
                {
                  "Area": "Ramgarh Chowk",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.2652,
                  "Long": 86.1312
                },
                {
                  "Area": "Ramgarh Chowkq",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.1717,
                  "Long": 85.9452
                },
                {
                  "Area": "Ramgarhwa",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.8676,
                  "Long": 84.9846
                },
                {
                  "Area": "Ramgiri",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.3503,
                  "Long": 77.3497
                },
                {
                  "Area": "Ramguna",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.1597,
                  "Long": 92.0329
                },
                {
                  "Area": "Ramgunapara",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.1597,
                  "Long": 92.0329
                },
                {
                  "Area": "Ramkanali",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.5693,
                  "Long": 87.1521
                },
                {
                  "Area": "Ramkrishnanagar",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 25.0658,
                  "Long": 92.0396
                },
                {
                  "Area": "Ramnagar",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.1597,
                  "Long": 92.0329
                },
                {
                  "Area": "Ramnagar",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.2563,
                  "Long": 81.4153
                },
                {
                  "Area": "Ramnagar",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.9078,
                  "Long": 88.8599
                },
                {
                  "Area": "Ramnagar",
                  "State": "Uttarakhand",
                  "CountryCode": "IN",
                  "Lat": 29.5478,
                  "Long": 79.3341
                },
                {
                  "Area": "Ramnagar",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 32.894,
                  "Long": 75.5445
                },
                {
                  "Area": "Ramnagar",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.7896,
                  "Long": 81.3231
                },
                {
                  "Area": "Ramnathpur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.6856,
                  "Long": 88.4668
                },
                {
                  "Area": "Rampachodavaram",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 17.5044,
                  "Long": 82.199
                },
                {
                  "Area": "Rampur",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 24.9911,
                  "Long": 83.6067
                },
                {
                  "Area": "Rampur",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.4011,
                  "Long": 91.7368
                },
                {
                  "Area": "Rampur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.4323,
                  "Long": 88.373
                },
                {
                  "Area": "Rampur",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.197,
                  "Long": 77.6324
                },
                {
                  "Area": "Rampur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 29.9496,
                  "Long": 79.3081
                },
                {
                  "Area": "Rampur Baghelan",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.549,
                  "Long": 81.0205
                },
                {
                  "Area": "Rampur Bhatpara",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.5228,
                  "Long": 88.1967
                },
                {
                  "Area": "Rampur Block",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.243,
                  "Long": 91.7368
                },
                {
                  "Area": "Rampur Bushahr",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.5971,
                  "Long": 78.0946
                },
                {
                  "Area": "Rampur Naikin",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.4189,
                  "Long": 81.8353
                },
                {
                  "Area": "Rampur(T)",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.6716,
                  "Long": 78.0946
                },
                {
                  "Area": "Rampur-Baghelan",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.6436,
                  "Long": 81.2193
                },
                {
                  "Area": "Rampura",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.4143,
                  "Long": 87.267
                },
                {
                  "Area": "Rampura Phul",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 30.4858,
                  "Long": 75.5859
                },
                {
                  "Area": "Rampurhat - I",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.2096,
                  "Long": 87.7743
                },
                {
                  "Area": "Rampuri",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.3078,
                  "Long": 76.4474
                },
                {
                  "Area": "Ramsanehighat",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.9963,
                  "Long": 81.8539
                },
                {
                  "Area": "Ramsar",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 25.9741,
                  "Long": 71.7535
                },
                {
                  "Area": "Ramshahar",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 30.9022,
                  "Long": 77.2256
                },
                {
                  "Area": "Ramshankarpur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.1467,
                  "Long": 88.803
                },
                {
                  "Area": "Ramsheher",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 32.0284,
                  "Long": 76.435
                },
                {
                  "Area": "Ramsinghpur",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 28.4771,
                  "Long": 74.1443
                },
                {
                  "Area": "Ramtek",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 21.6667,
                  "Long": 79.5274
                },
                {
                  "Area": "Ranagaht-ii",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.5279,
                  "Long": 88.5543
                },
                {
                  "Area": "Ranaghat",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.4733,
                  "Long": 88.1624
                },
                {
                  "Area": "Ranaghat - I",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.4891,
                  "Long": 88.7637
                },
                {
                  "Area": "Ranaghat - II",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.5544,
                  "Long": 88.637
                },
                {
                  "Area": "Ranaghat-i",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.5408,
                  "Long": 88.637
                },
                {
                  "Area": "Ranaghat-i/ii",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.4891,
                  "Long": 87.8306
                },
                {
                  "Area": "Ranaghat-ii",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.6883,
                  "Long": 88.637
                },
                {
                  "Area": "Ranapur",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 20.0452,
                  "Long": 85.0964
                },
                {
                  "Area": "Ranapur",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 22.2653,
                  "Long": 74.5255
                },
                {
                  "Area": "Ranastalam",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.1973,
                  "Long": 83.6531
                },
                {
                  "Area": "Ranasthalam Mandal",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.1979,
                  "Long": 83.7308
                },
                {
                  "Area": "Ranavav",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 21.6873,
                  "Long": 69.7871
                },
                {
                  "Area": "Ranbirpora",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 34.0397,
                  "Long": 74.7612
                },
                {
                  "Area": "Ranbirsinghpora",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 32.634,
                  "Long": 74.8191
                },
                {
                  "Area": "Ranbonia",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.2471,
                  "Long": 87.8066
                },
                {
                  "Area": "Ranchi",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 23.5,
                  "Long": 85.6927
                },
                {
                  "Area": "Ranebennur",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 15.4365,
                  "Long": 75.8539
                },
                {
                  "Area": "Ranebennur`",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 14.5229,
                  "Long": 75.3702
                },
                {
                  "Area": "Raneshwar",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.6117,
                  "Long": 87.5082
                },
                {
                  "Area": "Raneswar",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.6567,
                  "Long": 87.5082
                },
                {
                  "Area": "Rangachakua",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.7887,
                  "Long": 92.965
                },
                {
                  "Area": "Rangampeta",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 17.5302,
                  "Long": 82.3576
                },
                {
                  "Area": "Rangapara",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.8377,
                  "Long": 92.6688
                },
                {
                  "Area": "Rangar",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.9412,
                  "Long": 74.7578
                },
                {
                  "Area": "Rangareddy",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 18.0884,
                  "Long": 78.9223
                },
                {
                  "Area": "Rangat",
                  "State": "Andaman & Nicobar Islands",
                  "CountryCode": "IN",
                  "Lat": 12.7167,
                  "Long": 92.9155
                },
                {
                  "Area": "Rangauti",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.0789,
                  "Long": 91.8987
                },
                {
                  "Area": "Rangia Block",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.536,
                  "Long": 91.962
                },
                {
                  "Area": "Rangirkhari",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 25.0165,
                  "Long": 92.549
                },
                {
                  "Area": "Rangjuli",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.154,
                  "Long": 91.3041
                },
                {
                  "Area": "Rangli",
                  "State": "Sikkim",
                  "CountryCode": "IN",
                  "Lat": 27.2546,
                  "Long": 88.7126
                },
                {
                  "Area": "Rangli Rangliot",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 27.0886,
                  "Long": 88.5287
                },
                {
                  "Area": "Ranglum",
                  "State": "Arunachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.1318,
                  "Long": 95.7349
                },
                {
                  "Area": "Rangpo",
                  "State": "Sikkim",
                  "CountryCode": "IN",
                  "Lat": 27.2288,
                  "Long": 88.6291
                },
                {
                  "Area": "Rangra Chowk",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.4068,
                  "Long": 87.2063
                },
                {
                  "Area": "Rangrung",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.332,
                  "Long": 92.0039
                },
                {
                  "Area": "Rani",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.118,
                  "Long": 91.4061
                },
                {
                  "Area": "Rani Block",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 25.8083,
                  "Long": 91.2969
                },
                {
                  "Area": "Rani Block ( Palasbari Circle)",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.1349,
                  "Long": 91.5681
                },
                {
                  "Area": "Rani Block ( Palashbari Circle",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.1349,
                  "Long": 91.5681
                },
                {
                  "Area": "Rania",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.4448,
                  "Long": 79.8571
                },
                {
                  "Area": "Rania",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 29.5245,
                  "Long": 74.8369
                },
                {
                  "Area": "Rania",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 23.3313,
                  "Long": 85.3708
                },
                {
                  "Area": "Ranibandh",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.3801,
                  "Long": 87.135
                },
                {
                  "Area": "Ranibari",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.1597,
                  "Long": 92.0329
                },
                {
                  "Area": "Ranibennur",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 14.8033,
                  "Long": 75.8267
                },
                {
                  "Area": "Ranibundh",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.019,
                  "Long": 86.3508
                },
                {
                  "Area": "Ranigaj",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 25.8587,
                  "Long": 81.9485
                },
                {
                  "Area": "Raniganj",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.3617,
                  "Long": 90.3394
                },
                {
                  "Area": "Raniganj",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.1782,
                  "Long": 87.8981
                },
                {
                  "Area": "Raniganj",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 24.9913,
                  "Long": 84.8529
                },
                {
                  "Area": "Raniganj",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.0397,
                  "Long": 82.3331
                },
                {
                  "Area": "Raniganj Mc",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.7668,
                  "Long": 88.4456
                },
                {
                  "Area": "Raniganj Municipality",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.65,
                  "Long": 87.0047
                },
                {
                  "Area": "Ranigaon",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 26.3688,
                  "Long": 75.4513
                },
                {
                  "Area": "Ranihati",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.5022,
                  "Long": 88.5404
                },
                {
                  "Area": "Ranikhet",
                  "State": "Uttarakhand",
                  "CountryCode": "IN",
                  "Lat": 29.9547,
                  "Long": 79.5544
                },
                {
                  "Area": "Raninagar - I",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 25.0226,
                  "Long": 88.231
                },
                {
                  "Area": "Raninagar - II",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 25.0226,
                  "Long": 88.5022
                },
                {
                  "Area": "Raninagar-II",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.9685,
                  "Long": 87.8257
                },
                {
                  "Area": "Ranipool",
                  "State": "Sikkim",
                  "CountryCode": "IN",
                  "Lat": 27.3319,
                  "Long": 88.6019
                },
                {
                  "Area": "Ranipool / Gangtok",
                  "State": "Sikkim",
                  "CountryCode": "IN",
                  "Lat": 27.3319,
                  "Long": 88.6019
                },
                {
                  "Area": "Ranipukur",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.0789,
                  "Long": 91.8987
                },
                {
                  "Area": "Ranirbazar",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 23.6622,
                  "Long": 91.3881
                },
                {
                  "Area": "Ranisai",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.2088,
                  "Long": 88.0387
                },
                {
                  "Area": "Raniswar",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.3197,
                  "Long": 87.2666
                },
                {
                  "Area": "Raniwara",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 24.749,
                  "Long": 72.2051
                },
                {
                  "Area": "Ranka Raj",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.1293,
                  "Long": 83.8963
                },
                {
                  "Area": "Ranni",
                  "State": "Kerala",
                  "CountryCode": "IN",
                  "Lat": 10.0253,
                  "Long": 77.1598
                },
                {
                  "Area": "Ranny",
                  "State": "Kerala",
                  "CountryCode": "IN",
                  "Lat": 10.0253,
                  "Long": 76.7873
                },
                {
                  "Area": "Ranpur",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 20.6174,
                  "Long": 85.2361
                },
                {
                  "Area": "Ranpur",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 22.9027,
                  "Long": 73.1215
                },
                {
                  "Area": "Rapar",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 23.7979,
                  "Long": 70.9146
                },
                {
                  "Area": "Raptadu",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.8082,
                  "Long": 78.0945
                },
                {
                  "Area": "Rapthadu",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.8082,
                  "Long": 78.0945
                },
                {
                  "Area": "Rapur",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.3919,
                  "Long": 79.634
                },
                {
                  "Area": "Rasan",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 21.8995,
                  "Long": 87.5379
                },
                {
                  "Area": "Rasgovindpur",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.8952,
                  "Long": 87.1348
                },
                {
                  "Area": "Rashmi",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 25.1351,
                  "Long": 74.4964
                },
                {
                  "Area": "Rasipuram",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 11.7236,
                  "Long": 78.5445
                },
                {
                  "Area": "Rasmi",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 25.075,
                  "Long": 74.4581
                },
                {
                  "Area": "Rasol",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 20.6298,
                  "Long": 85.3126
                },
                {
                  "Area": "Rasoolpur",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.4013,
                  "Long": 76.373
                },
                {
                  "Area": "Rasra",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.2157,
                  "Long": 84.1055
                },
                {
                  "Area": "Rasulabad",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.7668,
                  "Long": 79.9735
                },
                {
                  "Area": "Rasulpur",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 20.8706,
                  "Long": 84.9206
                },
                {
                  "Area": "Rasulpur Umra",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.2843,
                  "Long": 80.3637
                },
                {
                  "Area": "Ratacherra",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.0447,
                  "Long": 91.7553
                },
                {
                  "Area": "Ratan Lal Nagar",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.418,
                  "Long": 80.298
                },
                {
                  "Area": "Ratangarh",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 28.7731,
                  "Long": 74.8166
                },
                {
                  "Area": "Ratanpur",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 22.3683,
                  "Long": 82.2298
                },
                {
                  "Area": "Ratia",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 23.9225,
                  "Long": 91.6031
                },
                {
                  "Area": "Ratlam",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.869,
                  "Long": 76.3935
                },
                {
                  "Area": "Ratnagiri",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 21.4937,
                  "Long": 77.0805
                },
                {
                  "Area": "Ratnifaridpur",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.1778,
                  "Long": 85.0455
                },
                {
                  "Area": "Rattan Kalan",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.2242,
                  "Long": 76.5554
                },
                {
                  "Area": "Rattanthal",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.3708,
                  "Long": 76.5356
                },
                {
                  "Area": "Rattia",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 29.7361,
                  "Long": 75.8156
                },
                {
                  "Area": "Ratu",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 23.5191,
                  "Long": 85.4941
                },
                {
                  "Area": "Ratua",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 25.4718,
                  "Long": 88.0923
                },
                {
                  "Area": "Ratua -i",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.9399,
                  "Long": 87.878
                },
                {
                  "Area": "Ratua Ii",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 25.1367,
                  "Long": 88.0923
                },
                {
                  "Area": "Ratua-i",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 25.2038,
                  "Long": 87.9268
                },
                {
                  "Area": "Ratua-ii",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 25.1228,
                  "Long": 87.9837
                },
                {
                  "Area": "Raun",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.4127,
                  "Long": 79.0336
                },
                {
                  "Area": "Rauna Par",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.1916,
                  "Long": 82.7297
                },
                {
                  "Area": "Raurkela (M)",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.8782,
                  "Long": 84.638
                },
                {
                  "Area": "Raurkela Industrial Township (ITS)",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.8782,
                  "Long": 84.638
                },
                {
                  "Area": "Rautara",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.1762,
                  "Long": 87.6063
                },
                {
                  "Area": "Rautarapur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.4364,
                  "Long": 87.9624
                },
                {
                  "Area": "Ravangla",
                  "State": "Sikkim",
                  "CountryCode": "IN",
                  "Lat": 27.3059,
                  "Long": 88.3636
                },
                {
                  "Area": "Raver",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 21.3618,
                  "Long": 76.345
                },
                {
                  "Area": "Ravulapalem",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 17.5557,
                  "Long": 82.3102
                },
                {
                  "Area": "Ravulapalem Mandal",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 17.0747,
                  "Long": 81.9825
                },
                {
                  "Area": "Rawabhatta",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 24.8219,
                  "Long": 75.4422
                },
                {
                  "Area": "Rawan",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 21.7132,
                  "Long": 82.1039
                },
                {
                  "Area": "Rawatbhata",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 25.1912,
                  "Long": 75.8626
                },
                {
                  "Area": "Rawatbhatta",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 24.9838,
                  "Long": 75.8626
                },
                {
                  "Area": "Rawatpur Gaon",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.4756,
                  "Long": 80.2763
                },
                {
                  "Area": "Rawatsar",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 29.2714,
                  "Long": 74.549
                },
                {
                  "Area": "Rawatsar.",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 28.9691,
                  "Long": 74.2362
                },
                {
                  "Area": "Raxaul",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 27.0019,
                  "Long": 84.9858
                },
                {
                  "Area": "Rayachoti",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.1076,
                  "Long": 79.0056
                },
                {
                  "Area": "Rayachoty",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.0761,
                  "Long": 78.7772
                },
                {
                  "Area": "Rayadurg",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.8449,
                  "Long": 77.0428
                },
                {
                  "Area": "Rayagada",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 19.5477,
                  "Long": 84.1579
                },
                {
                  "Area": "Rayagada(k)",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 19.1661,
                  "Long": 83.443
                },
                {
                  "Area": "Rayavaram",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 17.3395,
                  "Long": 82.2257
                },
                {
                  "Area": "Raybag",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 15.8071,
                  "Long": 75.0543
                },
                {
                  "Area": "Rayya",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 31.5248,
                  "Long": 75.2475
                },
                {
                  "Area": "Razole",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 17.1885,
                  "Long": 82.0118
                },
                {
                  "Area": "Razole Mandal",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 17.456,
                  "Long": 82.4415
                },
                {
                  "Area": "Rbi Colony",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.5934,
                  "Long": 80.6879
                },
                {
                  "Area": "Rbl",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.3725,
                  "Long": 81.5833
                },
                {
                  "Area": "Reamal",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.5531,
                  "Long": 84.885
                },
                {
                  "Area": "Reapara",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.1832,
                  "Long": 88.0876
                },
                {
                  "Area": "Reasi",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.5759,
                  "Long": 75.527
                },
                {
                  "Area": "Reban Gund",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.9563,
                  "Long": 74.834
                },
                {
                  "Area": "Reddigudem",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 16.9335,
                  "Long": 80.7572
                },
                {
                  "Area": "Redlawada",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.7374,
                  "Long": 79.776
                },
                {
                  "Area": "Regidi Amadalavalasa",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.6089,
                  "Long": 83.763
                },
                {
                  "Area": "Regidi Mandal",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.5788,
                  "Long": 83.7375
                },
                {
                  "Area": "Regonda",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 18.2378,
                  "Long": 79.7992
                },
                {
                  "Area": "Rehala",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.0467,
                  "Long": 84.0038
                },
                {
                  "Area": "Rehli",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.8481,
                  "Long": 79.1459
                },
                {
                  "Area": "Rehti",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 22.8264,
                  "Long": 77.4621
                },
                {
                  "Area": "Reiek",
                  "State": "Mizoram",
                  "CountryCode": "IN",
                  "Lat": 23.5537,
                  "Long": 92.6009
                },
                {
                  "Area": "Remu",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.3836,
                  "Long": 87.8747
                },
                {
                  "Area": "Remuna",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.3726,
                  "Long": 86.1634
                },
                {
                  "Area": "Renapur",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 19.4706,
                  "Long": 77.4042
                },
                {
                  "Area": "Rengali",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.7711,
                  "Long": 84.1802
                },
                {
                  "Area": "Rengali Damsite",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.2544,
                  "Long": 85.1277
                },
                {
                  "Area": "Renigunta",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 13.7735,
                  "Long": 79.5825
                },
                {
                  "Area": "Renjal",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 19.1257,
                  "Long": 78.1847
                },
                {
                  "Area": "Renjura",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 21.9467,
                  "Long": 87.4938
                },
                {
                  "Area": "Rentachintala",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 16.5893,
                  "Long": 79.5651
                },
                {
                  "Area": "Renwal",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 26.9805,
                  "Long": 75.7243
                },
                {
                  "Area": "Reodar",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 24.7121,
                  "Long": 72.6529
                },
                {
                  "Area": "Repalle",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 16.2988,
                  "Long": 80.8296
                },
                {
                  "Area": "Reripur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.8223,
                  "Long": 87.5059
                },
                {
                  "Area": "Resubelpara",
                  "State": "Meghalaya",
                  "CountryCode": "IN",
                  "Lat": 25.8544,
                  "Long": 90.5926
                },
                {
                  "Area": "Revelganj",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.9047,
                  "Long": 84.8253
                },
                {
                  "Area": "Revur",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.4268,
                  "Long": 79.7344
                },
                {
                  "Area": "Rewari",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.3602,
                  "Long": 76.754
                },
                {
                  "Area": "Rg Pur",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.7785,
                  "Long": 85.8314
                },
                {
                  "Area": "Rhenock",
                  "State": "Sikkim",
                  "CountryCode": "IN",
                  "Lat": 27.2114,
                  "Long": 88.6653
                },
                {
                  "Area": "Riga",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.6553,
                  "Long": 85.5397
                },
                {
                  "Area": "Rishieksh",
                  "State": "Uttarakhand",
                  "CountryCode": "IN",
                  "Lat": 30.271,
                  "Long": 78.2925
                },
                {
                  "Area": "Rishikesh",
                  "State": "Uttarakhand",
                  "CountryCode": "IN",
                  "Lat": 30.3541,
                  "Long": 78.2925
                },
                {
                  "Area": "Rithi",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.0327,
                  "Long": 80.4015
                },
                {
                  "Area": "Rivaikuntam",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 9.1675,
                  "Long": 77.7382
                },
                {
                  "Area": "Rlegaon",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.3536,
                  "Long": 78.1674
                },
                {
                  "Area": "Rmagarh",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.4277,
                  "Long": 87.3118
                },
                {
                  "Area": "Robertsganj",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.9825,
                  "Long": 83.0879
                },
                {
                  "Area": "Roddam",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.16,
                  "Long": 78.2626
                },
                {
                  "Area": "Roh",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 24.9444,
                  "Long": 85.7545
                },
                {
                  "Area": "Roha",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.1736,
                  "Long": 77.6997
                },
                {
                  "Area": "Rohak",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.8917,
                  "Long": 76.6118
                },
                {
                  "Area": "Rohanda",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.5864,
                  "Long": 88.4145
                },
                {
                  "Area": "Rohat",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 26.0039,
                  "Long": 73.5206
                },
                {
                  "Area": "Rohini",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.164,
                  "Long": 87.0901
                },
                {
                  "Area": "Rohni",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.0961,
                  "Long": 86.0511
                },
                {
                  "Area": "Rohrai",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.3196,
                  "Long": 76.611
                },
                {
                  "Area": "Rohru",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.7559,
                  "Long": 77.8128
                },
                {
                  "Area": "Rohtak",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 29.0602,
                  "Long": 77.4127
                },
                {
                  "Area": "Rohtas",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.2091,
                  "Long": 84.3504
                },
                {
                  "Area": "Roing",
                  "State": "Arunachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 28.9513,
                  "Long": 95.9028
                },
                {
                  "Area": "Rolla",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 13.9424,
                  "Long": 77.5294
                },
                {
                  "Area": "Rompicherla",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 16.2988,
                  "Long": 80.0915
                },
                {
                  "Area": "Ron",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.4106,
                  "Long": 78.9671
                },
                {
                  "Area": "Ron",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 15.9365,
                  "Long": 76.1496
                },
                {
                  "Area": "Rongjeng",
                  "State": "Meghalaya",
                  "CountryCode": "IN",
                  "Lat": 25.9012,
                  "Long": 90.8733
                },
                {
                  "Area": "Rongra",
                  "State": "Meghalaya",
                  "CountryCode": "IN",
                  "Lat": 25.3941,
                  "Long": 90.4309
                },
                {
                  "Area": "Ronjeng",
                  "State": "Meghalaya",
                  "CountryCode": "IN",
                  "Lat": 25.7027,
                  "Long": 90.8233
                },
                {
                  "Area": "Rooma",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.3801,
                  "Long": 80.4141
                },
                {
                  "Area": "Roopbas",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 27.2457,
                  "Long": 77.6216
                },
                {
                  "Area": "Roorkee",
                  "State": "Uttarakhand",
                  "CountryCode": "IN",
                  "Lat": 29.9614,
                  "Long": 78.1302
                },
                {
                  "Area": "Roorkee",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 29.7793,
                  "Long": 77.7806
                },
                {
                  "Area": "Ropar",
                  "State": "Chandigarh",
                  "CountryCode": "IN",
                  "Lat": 31.1115,
                  "Long": 76.6315
                },
                {
                  "Area": "Ropar",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 31.2016,
                  "Long": 76.746
                },
                {
                  "Area": "Ropar Ho",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 30.9532,
                  "Long": 76.5382
                },
                {
                  "Area": "Rosera",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.7684,
                  "Long": 85.9477
                },
                {
                  "Area": "Rothak",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.8631,
                  "Long": 76.6515
                },
                {
                  "Area": "Rourkela",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.8782,
                  "Long": 84.638
                },
                {
                  "Area": "Rourkela Steel City",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.8782,
                  "Long": 84.638
                },
                {
                  "Area": "Rowa",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.1597,
                  "Long": 92.0329
                },
                {
                  "Area": "Rowta",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.7058,
                  "Long": 92.2266
                },
                {
                  "Area": "Rowtara",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.7774,
                  "Long": 88.5686
                },
                {
                  "Area": "Roza Yakubpur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 28.6472,
                  "Long": 77.4282
                },
                {
                  "Area": "Rr.",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.2099,
                  "Long": 77.607
                },
                {
                  "Area": "Rudaui",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.7397,
                  "Long": 81.6667
                },
                {
                  "Area": "Rudauli",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.8806,
                  "Long": 81.9924
                },
                {
                  "Area": "Rudhauli",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.0005,
                  "Long": 82.8819
                },
                {
                  "Area": "Rudrampur",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 18.0476,
                  "Long": 80.281
                },
                {
                  "Area": "Rudraprayag",
                  "State": "Uttarakhand",
                  "CountryCode": "IN",
                  "Lat": 30.5303,
                  "Long": 79.3713
                },
                {
                  "Area": "Rudraprayg",
                  "State": "Uttarakhand",
                  "CountryCode": "IN",
                  "Lat": 30.2119,
                  "Long": 79.461
                },
                {
                  "Area": "Rudrapur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.5045,
                  "Long": 83.6417
                },
                {
                  "Area": "Rudri",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 20.6709,
                  "Long": 81.5409
                },
                {
                  "Area": "Runija",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.1575,
                  "Long": 75.2629
                },
                {
                  "Area": "Runisaidpur",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.8889,
                  "Long": 85.8324
                },
                {
                  "Area": "Runnisaidpur",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.1511,
                  "Long": 86.0939
                },
                {
                  "Area": "Rupa",
                  "State": "Arunachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.2048,
                  "Long": 92.4008
                },
                {
                  "Area": "Rupacherra",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.007,
                  "Long": 91.6093
                },
                {
                  "Area": "Rupauli",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.5139,
                  "Long": 86.7362
                },
                {
                  "Area": "Rupmari",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.795,
                  "Long": 88.1206
                },
                {
                  "Area": "Rupnagar",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 31.3215,
                  "Long": 76.6332
                },
                {
                  "Area": "Rupsa",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.8144,
                  "Long": 86.3745
                },
                {
                  "Area": "Rupshi",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.1205,
                  "Long": 89.9511
                },
                {
                  "Area": "Rupsi",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.1245,
                  "Long": 90.0224
                },
                {
                  "Area": "Rura",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.676,
                  "Long": 80.0705
                },
                {
                  "Area": "Rynjah",
                  "State": "Meghalaya",
                  "CountryCode": "IN",
                  "Lat": 25.5675,
                  "Long": 91.8645
                },
                {
                  "Area": "S Bala",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 34.2613,
                  "Long": 74.9418
                },
                {
                  "Area": "S Buzurg",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.7338,
                  "Long": 85.5142
                },
                {
                  "Area": "S Kota",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.2236,
                  "Long": 83.2746
                },
                {
                  "Area": "S P Tira",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 30.9127,
                  "Long": 77.0822
                },
                {
                  "Area": "S R Gunj",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 34.0889,
                  "Long": 74.8083
                },
                {
                  "Area": "S Rampur",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.1616,
                  "Long": 83.8932
                },
                {
                  "Area": "S.A.S.Nagar (Mohali)",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 31.0594,
                  "Long": 76.7417
                },
                {
                  "Area": "S.Mydukur",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.7723,
                  "Long": 78.8587
                },
                {
                  "Area": "S.a. Khan",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 31.7046,
                  "Long": 74.9007
                },
                {
                  "Area": "S.a.khan",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 31.7046,
                  "Long": 74.9007
                },
                {
                  "Area": "S.a.nagar",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.5474,
                  "Long": 86.9086
                },
                {
                  "Area": "S.b.raj",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.577,
                  "Long": 86.6884
                },
                {
                  "Area": "S.khawbung",
                  "State": "Mizoram",
                  "CountryCode": "IN",
                  "Lat": 23.079,
                  "Long": 93.2954
                },
                {
                  "Area": "S.kota.",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.1471,
                  "Long": 83.2265
                },
                {
                  "Area": "S.n.puram",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 18.0376,
                  "Long": 80.8918
                },
                {
                  "Area": "S.qudeem",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 29.8561,
                  "Long": 77.8346
                },
                {
                  "Area": "S.r.nagar",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 25.3083,
                  "Long": 82.6562
                },
                {
                  "Area": "S.rampur",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.3015,
                  "Long": 83.8032
                },
                {
                  "Area": "S.s. Kunjpura",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 29.7355,
                  "Long": 77.0093
                },
                {
                  "Area": "S.s.project",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.4268,
                  "Long": 79.7344
                },
                {
                  "Area": "S.solapur",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 17.6746,
                  "Long": 76.1145
                },
                {
                  "Area": "S.v. Peta",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 16.7536,
                  "Long": 81.0397
                },
                {
                  "Area": "S.v.peta",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 16.7666,
                  "Long": 81.0589
                },
                {
                  "Area": "SADAS",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 25.1755,
                  "Long": 74.7515
                },
                {
                  "Area": "SHHAPURA",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 27.1368,
                  "Long": 75.9403
                },
                {
                  "Area": "SULTANGANJ",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.6389,
                  "Long": 78.6777
                },
                {
                  "Area": "Sabajput",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.2758,
                  "Long": 88.831
                },
                {
                  "Area": "Sabalgarh",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.4138,
                  "Long": 77.8688
                },
                {
                  "Area": "Sabang",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.5305,
                  "Long": 88.109
                },
                {
                  "Area": "Sabdalpur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.8464,
                  "Long": 88.5736
                },
                {
                  "Area": "Sabdarnagar",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 25.0597,
                  "Long": 87.9187
                },
                {
                  "Area": "Sabour",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.2705,
                  "Long": 87.1139
                },
                {
                  "Area": "Sabra",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.3564,
                  "Long": 87.8021
                },
                {
                  "Area": "Sabroom",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 23.0015,
                  "Long": 91.7243
                },
                {
                  "Area": "Sabual",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.1597,
                  "Long": 92.0329
                },
                {
                  "Area": "Sachendi",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.4254,
                  "Long": 80.1691
                },
                {
                  "Area": "Sachin",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 21.4053,
                  "Long": 73.2118
                },
                {
                  "Area": "Sadabad",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.684,
                  "Long": 78.21
                },
                {
                  "Area": "Sadak Arjuni",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 21.2649,
                  "Long": 80.2739
                },
                {
                  "Area": "Sadak-Arjuni",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 21.149,
                  "Long": 80.2054
                },
                {
                  "Area": "Sadar",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 23.7062,
                  "Long": 91.4203
                },
                {
                  "Area": "Sadar",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.9903,
                  "Long": 83.773
                },
                {
                  "Area": "Sadar",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.4984,
                  "Long": 84.1733
                },
                {
                  "Area": "Sadar",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.0869,
                  "Long": 85.5813
                },
                {
                  "Area": "Sadar",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.8363,
                  "Long": 77.3887
                },
                {
                  "Area": "Sadar Bazar",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.418,
                  "Long": 76.9839
                },
                {
                  "Area": "Sadar Madhubani",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.2726,
                  "Long": 86.2506
                },
                {
                  "Area": "Sadar Mandi",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.6117,
                  "Long": 76.93
                },
                {
                  "Area": "Sadar Mau",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.102,
                  "Long": 83.7395
                },
                {
                  "Area": "Sadar Munger",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.2907,
                  "Long": 86.5907
                },
                {
                  "Area": "Sadasivpet",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 18.1408,
                  "Long": 78.2157
                },
                {
                  "Area": "Sadat Nagar",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.3498,
                  "Long": 76.5026
                },
                {
                  "Area": "Sader",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.749,
                  "Long": 83.3959
                },
                {
                  "Area": "Sadhanpur Uludanga",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.8464,
                  "Long": 88.5736
                },
                {
                  "Area": "Sadihat",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.2088,
                  "Long": 88.0387
                },
                {
                  "Area": "Sadikpur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.2088,
                  "Long": 88.0387
                },
                {
                  "Area": "Sadinare",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.9509,
                  "Long": 75.0932
                },
                {
                  "Area": "Sadiya",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 27.6999,
                  "Long": 95.6124
                },
                {
                  "Area": "Sadulpur",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 28.9666,
                  "Long": 75.6756
                },
                {
                  "Area": "Sadulsahar",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 29.7142,
                  "Long": 75.2685
                },
                {
                  "Area": "Sadulshahar",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 29.9168,
                  "Long": 75.5395
                },
                {
                  "Area": "Safiabad",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 21.7907,
                  "Long": 87.8635
                },
                {
                  "Area": "Safidon",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 29.4354,
                  "Long": 76.6704
                },
                {
                  "Area": "Safipur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.7892,
                  "Long": 80.8883
                },
                {
                  "Area": "Safirabad",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.5239,
                  "Long": 87.8703
                },
                {
                  "Area": "Safuipur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.2482,
                  "Long": 80.8883
                },
                {
                  "Area": "Sagalee",
                  "State": "Arunachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.422,
                  "Long": 93.6719
                },
                {
                  "Area": "Sagam",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.8072,
                  "Long": 74.8689
                },
                {
                  "Area": "Sagar",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 14.4115,
                  "Long": 75.4236
                },
                {
                  "Area": "Sagar",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.423,
                  "Long": 79.6019
                },
                {
                  "Area": "Sagar",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.3153,
                  "Long": 88.4168
                },
                {
                  "Area": "Sagardighi",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.6278,
                  "Long": 88.2581
                },
                {
                  "Area": "Sagareswar",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.2088,
                  "Long": 88.0387
                },
                {
                  "Area": "Sagari",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.5088,
                  "Long": 83.3603
                },
                {
                  "Area": "Sagbara",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 23.2244,
                  "Long": 73.8538
                },
                {
                  "Area": "Sagri",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.3586,
                  "Long": 83.3351
                },
                {
                  "Area": "Saguna",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.1406,
                  "Long": 88.5427
                },
                {
                  "Area": "Sahajalalpur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 25.0056,
                  "Long": 87.9102
                },
                {
                  "Area": "Sahajanwa",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.6051,
                  "Long": 83.3992
                },
                {
                  "Area": "Sahara",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.0208,
                  "Long": 87.7744
                },
                {
                  "Area": "Saharanpur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 30.0846,
                  "Long": 78.6641
                },
                {
                  "Area": "Saharanpur H.o.",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 30.0317,
                  "Long": 77.949
                },
                {
                  "Area": "Saharanwas",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.2048,
                  "Long": 76.5642
                },
                {
                  "Area": "Saharnpur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 29.9496,
                  "Long": 77.5477
                },
                {
                  "Area": "Saharsa",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.2477,
                  "Long": 86.9205
                },
                {
                  "Area": "Sahaspur Lohara",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 22.091,
                  "Long": 81.3674
                },
                {
                  "Area": "Sahaswan",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 28.2199,
                  "Long": 78.9694
                },
                {
                  "Area": "Sahauran",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 30.7846,
                  "Long": 76.605
                },
                {
                  "Area": "Sahawar",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.7893,
                  "Long": 78.7824
                },
                {
                  "Area": "Sahdai Buzurg",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.3883,
                  "Long": 85.5219
                },
                {
                  "Area": "Sahdei  Bujurg",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.6165,
                  "Long": 85.4685
                },
                {
                  "Area": "Sahdei Bujurg",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.7623,
                  "Long": 85.5137
                },
                {
                  "Area": "Sahdei Buzurg",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.9462,
                  "Long": 85.5219
                },
                {
                  "Area": "Sahebganj",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.3091,
                  "Long": 85.3308
                },
                {
                  "Area": "Sahebkhali",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.4323,
                  "Long": 88.373
                },
                {
                  "Area": "Saheednagar",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 20.3802,
                  "Long": 85.9172
                },
                {
                  "Area": "Sahibganj",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 25.2531,
                  "Long": 87.7147
                },
                {
                  "Area": "Sahid Matangini",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.1207,
                  "Long": 87.8594
                },
                {
                  "Area": "Sahidmatangini",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.1207,
                  "Long": 88.1278
                },
                {
                  "Area": "Sahjanwa",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.8805,
                  "Long": 83.3614
                },
                {
                  "Area": "Sahkund",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.2982,
                  "Long": 87.3047
                },
                {
                  "Area": "Sahpur",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 32.0698,
                  "Long": 76.1695
                },
                {
                  "Area": "Sahpura Niwas",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.0793,
                  "Long": 81.0561
                },
                {
                  "Area": "Sahpuraniwas",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 22.9012,
                  "Long": 80.5718
                },
                {
                  "Area": "Sahson",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 25.5176,
                  "Long": 81.9491
                },
                {
                  "Area": "Saibugh",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.9245,
                  "Long": 74.6725
                },
                {
                  "Area": "Saidabad",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.456,
                  "Long": 78.6476
                },
                {
                  "Area": "Saidabad",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 25.3848,
                  "Long": 82.0039
                },
                {
                  "Area": "Saidapet",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 13.0582,
                  "Long": 80.2572
                },
                {
                  "Area": "Saidapur",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.9846,
                  "Long": 79.2649
                },
                {
                  "Area": "Saidarpar",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.0447,
                  "Long": 91.7553
                },
                {
                  "Area": "Saidpur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 25.7881,
                  "Long": 83.6725
                },
                {
                  "Area": "Saifai",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.9791,
                  "Long": 79.2804
                },
                {
                  "Area": "Saiha",
                  "State": "Mizoram",
                  "CountryCode": "IN",
                  "Lat": 22.5953,
                  "Long": 93.0767
                },
                {
                  "Area": "Saikheda",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 22.8399,
                  "Long": 79.1979
                },
                {
                  "Area": "Saikul",
                  "State": "Manipur",
                  "CountryCode": "IN",
                  "Lat": 25.0285,
                  "Long": 94.1033
                },
                {
                  "Area": "Sailana",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.6716,
                  "Long": 75.5935
                },
                {
                  "Area": "Sailu",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 19.6722,
                  "Long": 77.1544
                },
                {
                  "Area": "Saimoh",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.9306,
                  "Long": 75.1134
                },
                {
                  "Area": "Sainj(S.T)",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.9045,
                  "Long": 77.4002
                },
                {
                  "Area": "Sainkheda",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.3903,
                  "Long": 78.6791
                },
                {
                  "Area": "Sainthia",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.1621,
                  "Long": 87.78
                },
                {
                  "Area": "Saipau",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 26.9038,
                  "Long": 77.8602
                },
                {
                  "Area": "Sairang",
                  "State": "Mizoram",
                  "CountryCode": "IN",
                  "Lat": 23.8623,
                  "Long": 92.6523
                },
                {
                  "Area": "Saitual",
                  "State": "Mizoram",
                  "CountryCode": "IN",
                  "Lat": 24.0409,
                  "Long": 93.1291
                },
                {
                  "Area": "Saja",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 21.8653,
                  "Long": 81.5627
                },
                {
                  "Area": "Sajhanwa",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.6884,
                  "Long": 83.1042
                },
                {
                  "Area": "Sakaldhia",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 25.451,
                  "Long": 83.3333
                },
                {
                  "Area": "Sakaldiha",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 25.8055,
                  "Long": 83.3653
                },
                {
                  "Area": "Sakara",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.9972,
                  "Long": 85.5764
                },
                {
                  "Area": "Sakchi",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 23.0301,
                  "Long": 86.2029
                },
                {
                  "Area": "Sakdah Jadapur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.1406,
                  "Long": 88.5427
                },
                {
                  "Area": "Sakhan Serhmun",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 23.9923,
                  "Long": 91.6205
                },
                {
                  "Area": "Sakhigopal",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 20.0664,
                  "Long": 85.9273
                },
                {
                  "Area": "Sakhinetipalli",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 17.1885,
                  "Long": 82.0118
                },
                {
                  "Area": "Sakhinetipalli Mandal",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 16.524,
                  "Long": 81.7833
                },
                {
                  "Area": "Saklehspur",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 13.0155,
                  "Long": 76.0758
                },
                {
                  "Area": "Sakleshpur",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 13.0627,
                  "Long": 76.1091
                },
                {
                  "Area": "Sakleshpura",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 12.6529,
                  "Long": 76.0758
                },
                {
                  "Area": "Sakltlake",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.4839,
                  "Long": 88.3038
                },
                {
                  "Area": "Sakoli",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 21.1802,
                  "Long": 80.0649
                },
                {
                  "Area": "Sakra",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26,
                  "Long": 85.8294
                },
                {
                  "Area": "Sakri",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 21.1852,
                  "Long": 75.2957
                },
                {
                  "Area": "Sakti",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 22.1021,
                  "Long": 83.0082
                },
                {
                  "Area": "Sakurabad",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.0725,
                  "Long": 84.7993
                },
                {
                  "Area": "Salanpur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 25.493,
                  "Long": 87.9075
                },
                {
                  "Area": "Salari",
                  "State": "Arunachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.2895,
                  "Long": 92.3982
                },
                {
                  "Area": "Salarpur Kalan",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 28.5806,
                  "Long": 77.6045
                },
                {
                  "Area": "Salbani",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.5234,
                  "Long": 87.6598
                },
                {
                  "Area": "Salboni",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.5234,
                  "Long": 87.975
                },
                {
                  "Area": "Salcate",
                  "State": "Goa",
                  "CountryCode": "IN",
                  "Lat": 15.1707,
                  "Long": 73.9674
                },
                {
                  "Area": "Salcete",
                  "State": "Goa",
                  "CountryCode": "IN",
                  "Lat": 15.4025,
                  "Long": 74.0628
                },
                {
                  "Area": "Salcette",
                  "State": "Goa",
                  "CountryCode": "IN",
                  "Lat": 15.3174,
                  "Long": 73.9387
                },
                {
                  "Area": "Salekasa",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 21.5429,
                  "Long": 80.5819
                },
                {
                  "Area": "Salem",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 11.9792,
                  "Long": 79.6244
                },
                {
                  "Area": "Salema",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.0789,
                  "Long": 91.8987
                },
                {
                  "Area": "Salempur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.6626,
                  "Long": 84.0858
                },
                {
                  "Area": "Salepur",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 20.9235,
                  "Long": 85.4212
                },
                {
                  "Area": "Salikotha",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.5034,
                  "Long": 87.9832
                },
                {
                  "Area": "Salipur",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.1926,
                  "Long": 86.2692
                },
                {
                  "Area": "Saljora",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.8223,
                  "Long": 87.5059
                },
                {
                  "Area": "Salkhua",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.8166,
                  "Long": 86.6098
                },
                {
                  "Area": "Salkocha",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.1863,
                  "Long": 90.4478
                },
                {
                  "Area": "Salmara South",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.0675,
                  "Long": 90.2553
                },
                {
                  "Area": "Salo N",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.0286,
                  "Long": 81.454
                },
                {
                  "Area": "Salon",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.4861,
                  "Long": 82.0304
                },
                {
                  "Area": "Salooni",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 32.7786,
                  "Long": 76.5775
                },
                {
                  "Area": "Salsalai",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.5302,
                  "Long": 76.5532
                },
                {
                  "Area": "Salt",
                  "State": "Uttarakhand",
                  "CountryCode": "IN",
                  "Lat": 29.7532,
                  "Long": 79.1865
                },
                {
                  "Area": "Salt Lake",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.4485,
                  "Long": 88.3883
                },
                {
                  "Area": "Saltklake",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.4485,
                  "Long": 88.3883
                },
                {
                  "Area": "Saltlake",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.966,
                  "Long": 88.3883
                },
                {
                  "Area": "Saltora",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.1794,
                  "Long": 87.8621
                },
                {
                  "Area": "Salua",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.1383,
                  "Long": 88.4458
                },
                {
                  "Area": "Saluka",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.3029,
                  "Long": 87.818
                },
                {
                  "Area": "Salumber",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 24.662,
                  "Long": 74.395
                },
                {
                  "Area": "Salur",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.6294,
                  "Long": 83.3793
                },
                {
                  "Area": "Samaana",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 30.0356,
                  "Long": 76.1892
                },
                {
                  "Area": "Samal Barrage",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.0842,
                  "Long": 85.1384
                },
                {
                  "Area": "Samalkot",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 17.0412,
                  "Long": 82.2017
                },
                {
                  "Area": "Samalkota",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 17.1885,
                  "Long": 82.0118
                },
                {
                  "Area": "Samana",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 30.5105,
                  "Long": 76.5169
                },
                {
                  "Area": "Samastipur",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.1138,
                  "Long": 86.3587
                },
                {
                  "Area": "Samatal Padmabil",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.0796,
                  "Long": 91.5997
                },
                {
                  "Area": "Samba",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 32.9073,
                  "Long": 75.0127
                },
                {
                  "Area": "Sambalpur",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.546,
                  "Long": 84.066
                },
                {
                  "Area": "Sambepalle",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.4599,
                  "Long": 78.7836
                },
                {
                  "Area": "Sambhal",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 29.0318,
                  "Long": 78.8593
                },
                {
                  "Area": "Sambhl",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 28.7273,
                  "Long": 78.4618
                },
                {
                  "Area": "Samdari",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 25.865,
                  "Long": 72.8862
                },
                {
                  "Area": "Samgem",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 18.7277,
                  "Long": 79.7689
                },
                {
                  "Area": "Samho",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.4953,
                  "Long": 86.1797
                },
                {
                  "Area": "Sami",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 23.8876,
                  "Long": 72.7228
                },
                {
                  "Area": "Sampatchak",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.6716,
                  "Long": 85.2322
                },
                {
                  "Area": "Sampgaon",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 15.9756,
                  "Long": 75.623
                },
                {
                  "Area": "Samrala",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 30.9575,
                  "Long": 76.2002
                },
                {
                  "Area": "Samrurpar",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.332,
                  "Long": 92.0039
                },
                {
                  "Area": "Samserganj",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.6759,
                  "Long": 88.0333
                },
                {
                  "Area": "Samsernagar",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.4323,
                  "Long": 88.373
                },
                {
                  "Area": "Samudragrah",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.4069,
                  "Long": 88.1497
                },
                {
                  "Area": "Samudrapur",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.7958,
                  "Long": 78.9725
                },
                {
                  "Area": "Samudrapur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.8624,
                  "Long": 88.5891
                },
                {
                  "Area": "Samudraupr",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.6513,
                  "Long": 78.8716
                },
                {
                  "Area": "Sanagar",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.5984,
                  "Long": 86.9715
                },
                {
                  "Area": "Sanakari",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 11.4504,
                  "Long": 77.9709
                },
                {
                  "Area": "Sanand",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 23.4088,
                  "Long": 74.1152
                },
                {
                  "Area": "Sanat Nagar",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.8359,
                  "Long": 74.8589
                },
                {
                  "Area": "Sanawara",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 25.5606,
                  "Long": 71.6244
                },
                {
                  "Area": "Sanchore",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 25.4117,
                  "Long": 73.6186
                },
                {
                  "Area": "Sandelerbill",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.795,
                  "Long": 88.1206
                },
                {
                  "Area": "Sandesh",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.3615,
                  "Long": 84.7027
                },
                {
                  "Area": "Sandeshkhali",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.3568,
                  "Long": 88.8997
                },
                {
                  "Area": "Sandeshkhali - I",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.4323,
                  "Long": 88.562
                },
                {
                  "Area": "Sandeshkhali - II",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.3484,
                  "Long": 88.8997
                },
                {
                  "Area": "Sandheli",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.4389,
                  "Long": 91.4266
                },
                {
                  "Area": "Sandhol(S.T)",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 32.1204,
                  "Long": 76.9929
                },
                {
                  "Area": "Sandila",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.4083,
                  "Long": 81.833
                },
                {
                  "Area": "Sandukarkari",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.007,
                  "Long": 91.6093
                },
                {
                  "Area": "Sandur",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 15.9527,
                  "Long": 76.8155
                },
                {
                  "Area": "Sanekuchi",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.477,
                  "Long": 91.4874
                },
                {
                  "Area": "Sangah",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 30.7616,
                  "Long": 77.4822
                },
                {
                  "Area": "Sangam",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.9181,
                  "Long": 79.7689
                },
                {
                  "Area": "Sangam",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.7008,
                  "Long": 79.7972
                },
                {
                  "Area": "Sangamjagarlamudi",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 16.2703,
                  "Long": 80.5875
                },
                {
                  "Area": "Sangamner",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 19.7568,
                  "Long": 75.6153
                },
                {
                  "Area": "Sanganer",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 26.9295,
                  "Long": 76.0868
                },
                {
                  "Area": "Sangarah",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 30.7728,
                  "Long": 77.406
                },
                {
                  "Area": "Sangareddy",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.9793,
                  "Long": 78.4183
                },
                {
                  "Area": "Sangarh",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 30.7728,
                  "Long": 77.5561
                },
                {
                  "Area": "Sangarha",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 30.6327,
                  "Long": 77.5125
                },
                {
                  "Area": "Sangari",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 29.4394,
                  "Long": 74.4781
                },
                {
                  "Area": "Sangaria",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 29.7989,
                  "Long": 75.2011
                },
                {
                  "Area": "Sangat",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 30.1251,
                  "Long": 74.8555
                },
                {
                  "Area": "Sangau",
                  "State": "Mizoram",
                  "CountryCode": "IN",
                  "Lat": 22.4521,
                  "Long": 93.0196
                },
                {
                  "Area": "Sangaum",
                  "State": "Goa",
                  "CountryCode": "IN",
                  "Lat": 15.1784,
                  "Long": 74.2167
                },
                {
                  "Area": "Sangem",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.9974,
                  "Long": 79.9178
                },
                {
                  "Area": "Sangla",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.3913,
                  "Long": 78.3506
                },
                {
                  "Area": "Sangla(T)",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.5009,
                  "Long": 78.4355
                },
                {
                  "Area": "Sangmeshwar",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 19.6644,
                  "Long": 75.4197
                },
                {
                  "Area": "Sangola",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 19.4807,
                  "Long": 76.4202
                },
                {
                  "Area": "Sangole",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 17.7898,
                  "Long": 76.0546
                },
                {
                  "Area": "Sangrah",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 30.7728,
                  "Long": 77.6736
                },
                {
                  "Area": "Sangrampur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.6191,
                  "Long": 88.8788
                },
                {
                  "Area": "Sangrampur",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 21.1236,
                  "Long": 76.9774
                },
                {
                  "Area": "Sangrampur",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.4752,
                  "Long": 86.7576
                },
                {
                  "Area": "Sangrur",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 30.3341,
                  "Long": 76.1178
                },
                {
                  "Area": "Sangti",
                  "State": "Arunachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.4,
                  "Long": 92.1833
                },
                {
                  "Area": "Sanguem",
                  "State": "Goa",
                  "CountryCode": "IN",
                  "Lat": 15.335,
                  "Long": 74.2254
                },
                {
                  "Area": "Sangwari",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.1646,
                  "Long": 76.6826
                },
                {
                  "Area": "Sanhoula",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.2408,
                  "Long": 87.1089
                },
                {
                  "Area": "Sanicherra",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.1597,
                  "Long": 92.0329
                },
                {
                  "Area": "Sanigawan",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.3843,
                  "Long": 80.3275
                },
                {
                  "Area": "Sanjamala",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 15.5336,
                  "Long": 78.4074
                },
                {
                  "Area": "Sanjaribalod",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 20.5388,
                  "Long": 81.2394
                },
                {
                  "Area": "Sanjhauli",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 24.9794,
                  "Long": 84.0277
                },
                {
                  "Area": "Sankapuram",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 11.8257,
                  "Long": 78.9471
                },
                {
                  "Area": "Sankarakhole",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 20.5083,
                  "Long": 84.2948
                },
                {
                  "Area": "Sankarankoil",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 10.8028,
                  "Long": 77.9152
                },
                {
                  "Area": "Sankarankovil",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 9.5591,
                  "Long": 78.1387
                },
                {
                  "Area": "Sankarapuram",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 12.0563,
                  "Long": 79.2921
                },
                {
                  "Area": "Sankari",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 11.9502,
                  "Long": 78.5063
                },
                {
                  "Area": "Sankaritola",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.8436,
                  "Long": 88.2293
                },
                {
                  "Area": "Sankhavaram",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 17.4211,
                  "Long": 82.4423
                },
                {
                  "Area": "Sankheda",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 22.9273,
                  "Long": 73.6696
                },
                {
                  "Area": "Sankoo",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.803,
                  "Long": 75.9275
                },
                {
                  "Area": "Sankra",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 21.5174,
                  "Long": 82.7284
                },
                {
                  "Area": "Sankrail",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.942,
                  "Long": 88.5234
                },
                {
                  "Area": "Sanmeshwar",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 19.6644,
                  "Long": 75.4197
                },
                {
                  "Area": "Sannad",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 22.7384,
                  "Long": 72.6843
                },
                {
                  "Area": "Sanquelim",
                  "State": "Goa",
                  "CountryCode": "IN",
                  "Lat": 15.1964,
                  "Long": 74.1184
                },
                {
                  "Area": "Sanrapul",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.1454,
                  "Long": 88.6128
                },
                {
                  "Area": "Sansadgopinathpur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.3029,
                  "Long": 87.818
                },
                {
                  "Area": "Santabommali Mandal",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.5809,
                  "Long": 84.0773
                },
                {
                  "Area": "Santaldih",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.2842,
                  "Long": 85.9267
                },
                {
                  "Area": "Santalpur",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 23.8876,
                  "Long": 72.6904
                },
                {
                  "Area": "Santalpurp",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 23.8876,
                  "Long": 71.7985
                },
                {
                  "Area": "Santhabommali",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.5619,
                  "Long": 84.2989
                },
                {
                  "Area": "Santhabommali Mandal",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.5714,
                  "Long": 84.0773
                },
                {
                  "Area": "Santhakaviti Mandal",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.4969,
                  "Long": 83.8278
                },
                {
                  "Area": "Santhipuram",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 13.3402,
                  "Long": 78.7333
                },
                {
                  "Area": "Santinagar",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 23.9225,
                  "Long": 91.6031
                },
                {
                  "Area": "Santinagar",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.4348,
                  "Long": 91.1657
                },
                {
                  "Area": "Santipur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.1392,
                  "Long": 88.5543
                },
                {
                  "Area": "Santirbazar",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 23.0015,
                  "Long": 91.7243
                },
                {
                  "Area": "Santrampur",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 23.3631,
                  "Long": 73.9842
                },
                {
                  "Area": "Santrampura",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 23.2147,
                  "Long": 73.8154
                },
                {
                  "Area": "Santrapur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.4364,
                  "Long": 87.9624
                },
                {
                  "Area": "Santuri",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.6244,
                  "Long": 87.1521
                },
                {
                  "Area": "Sanwer",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 22.9742,
                  "Long": 75.886
                },
                {
                  "Area": "Saoli",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.4532,
                  "Long": 79.9367
                },
                {
                  "Area": "Saoner",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 21.574,
                  "Long": 79.4524
                },
                {
                  "Area": "Saorapin",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.6315,
                  "Long": 87.428
                },
                {
                  "Area": "Sapai",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.3805,
                  "Long": 80.2158
                },
                {
                  "Area": "Sapotara",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 26.7482,
                  "Long": 77.0316
                },
                {
                  "Area": "Sapotrara",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 26.5207,
                  "Long": 76.9639
                },
                {
                  "Area": "Saptara",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 26.5207,
                  "Long": 76.9639
                },
                {
                  "Area": "Sarada",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.4305,
                  "Long": 87.4447
                },
                {
                  "Area": "Saraigarh",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.0348,
                  "Long": 86.9091
                },
                {
                  "Area": "Saraigarh Bhaptiyahi",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.2477,
                  "Long": 86.8001
                },
                {
                  "Area": "Saraipali",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 21.4583,
                  "Long": 83.154
                },
                {
                  "Area": "Saraiya",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.1511,
                  "Long": 85.3308
                },
                {
                  "Area": "Saraiyahat",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.8012,
                  "Long": 87.3199
                },
                {
                  "Area": "Saraiyhat",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.7128,
                  "Long": 87.3199
                },
                {
                  "Area": "Saramgarh",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 21.3821,
                  "Long": 83.287
                },
                {
                  "Area": "Sarangada",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 20.3546,
                  "Long": 84.1848
                },
                {
                  "Area": "Sarangapur",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 18.8761,
                  "Long": 79.2409
                },
                {
                  "Area": "Sarangarh",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 22.0858,
                  "Long": 83.5108
                },
                {
                  "Area": "Sarangpur",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.9539,
                  "Long": 77.1273
                },
                {
                  "Area": "Sarapaka",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.6913,
                  "Long": 80.87
                },
                {
                  "Area": "Sarara",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 25.1995,
                  "Long": 74.6851
                },
                {
                  "Area": "Saraspur",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.1597,
                  "Long": 92.0329
                },
                {
                  "Area": "Sarath",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.4442,
                  "Long": 86.9172
                },
                {
                  "Area": "Saravakota Mandal",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.6022,
                  "Long": 83.976
                },
                {
                  "Area": "Saravakota Mdl",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.5152,
                  "Long": 83.976
                },
                {
                  "Area": "Sarayaha",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.8012,
                  "Long": 87.1784
                },
                {
                  "Area": "Sarayahat",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.8012,
                  "Long": 87.2666
                },
                {
                  "Area": "Sardarpur",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 22.9501,
                  "Long": 75.667
                },
                {
                  "Area": "Sardarshahar",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 28.7786,
                  "Long": 74.8372
                },
                {
                  "Area": "Sardarshahr",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 28.4087,
                  "Long": 74.61
                },
                {
                  "Area": "Sardhana",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 29.35,
                  "Long": 77.8581
                },
                {
                  "Area": "Sardhar",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 22.1395,
                  "Long": 70.9854
                },
                {
                  "Area": "Sardulgarh",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 29.6922,
                  "Long": 75.2361
                },
                {
                  "Area": "Sareli",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 29.3043,
                  "Long": 77.0492
                },
                {
                  "Area": "Sarenga",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.141,
                  "Long": 87.135
                },
                {
                  "Area": "Sarh",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.2342,
                  "Long": 80.3461
                },
                {
                  "Area": "Sarhali",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 31.7022,
                  "Long": 74.8325
                },
                {
                  "Area": "Saria",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 21.6401,
                  "Long": 83.3631
                },
                {
                  "Area": "Saridaspur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.5526,
                  "Long": 88.4901
                },
                {
                  "Area": "Saripur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 21.6278,
                  "Long": 87.5197
                },
                {
                  "Area": "Sariyahat",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.8012,
                  "Long": 87.3199
                },
                {
                  "Area": "Sarkaghat",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 32.1204,
                  "Long": 77.1851
                },
                {
                  "Area": "Sarkaghat(T)",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.6481,
                  "Long": 77.1759
                },
                {
                  "Area": "Sarma",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.0789,
                  "Long": 91.8987
                },
                {
                  "Area": "Sarmera",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.3043,
                  "Long": 85.9533
                },
                {
                  "Area": "Sarnagarh",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 22.0858,
                  "Long": 83.306
                },
                {
                  "Area": "Saroornagar",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.4661,
                  "Long": 78.5576
                },
                {
                  "Area": "Sarpai",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.3444,
                  "Long": 87.9089
                },
                {
                  "Area": "Sarrang",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.6315,
                  "Long": 87.428
                },
                {
                  "Area": "Sarsara",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 20.8118,
                  "Long": 84.3055
                },
                {
                  "Area": "Sarsaul",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.2844,
                  "Long": 80.4893
                },
                {
                  "Area": "Sarsawa",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 30.2001,
                  "Long": 77.8231
                },
                {
                  "Area": "Sarsiwa",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 21.6937,
                  "Long": 82.9721
                },
                {
                  "Area": "Sarta",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.1762,
                  "Long": 87.6063
                },
                {
                  "Area": "Sarth",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 23.9769,
                  "Long": 86.9172
                },
                {
                  "Area": "Sarthebari",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.3629,
                  "Long": 91.2231
                },
                {
                  "Area": "Sarubujjili",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.5147,
                  "Long": 83.8175
                },
                {
                  "Area": "Sarubujjili Mandal",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.6425,
                  "Long": 83.9881
                },
                {
                  "Area": "Sarupathar",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.4573,
                  "Long": 93.8429
                },
                {
                  "Area": "Sarupeta",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.5107,
                  "Long": 91.9216
                },
                {
                  "Area": "Sarvodaya Nagar",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.5167,
                  "Long": 80.3155
                },
                {
                  "Area": "Sarwan",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.7424,
                  "Long": 86.8335
                },
                {
                  "Area": "Sarwar",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 26.2299,
                  "Long": 75.011
                },
                {
                  "Area": "Sasadanga",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.1465,
                  "Long": 88.1117
                },
                {
                  "Area": "Sasan",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.6508,
                  "Long": 84.0735
                },
                {
                  "Area": "Sasaram",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.3349,
                  "Long": 84.3316
                },
                {
                  "Area": "Sashan",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.6541,
                  "Long": 88.5771
                },
                {
                  "Area": "Satalasana",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 24.0213,
                  "Long": 72.7215
                },
                {
                  "Area": "Satana",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.7858,
                  "Long": 75.6932
                },
                {
                  "Area": "Satankulam",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 9.0656,
                  "Long": 78.2424
                },
                {
                  "Area": "Satar Kataiya",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.9159,
                  "Long": 86.5898
                },
                {
                  "Area": "Satara",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.1806,
                  "Long": 76.1932
                },
                {
                  "Area": "Satara  Koregaon",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 17.3254,
                  "Long": 74.4408
                },
                {
                  "Area": "Satara.satara",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.1806,
                  "Long": 75.6891
                },
                {
                  "Area": "Satashi",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.1467,
                  "Long": 88.803
                },
                {
                  "Area": "Satath",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.4442,
                  "Long": 86.8131
                },
                {
                  "Area": "Satbahini",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.8386,
                  "Long": 88.171
                },
                {
                  "Area": "Satbarwa",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.1474,
                  "Long": 84.4631
                },
                {
                  "Area": "Satberi",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.3578,
                  "Long": 88.1922
                },
                {
                  "Area": "Satbhaya",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.5864,
                  "Long": 88.4145
                },
                {
                  "Area": "Satchand",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 23.0015,
                  "Long": 91.7243
                },
                {
                  "Area": "Satgawan",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.7723,
                  "Long": 85.7612
                },
                {
                  "Area": "Sathankulam",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 8.6882,
                  "Long": 78.0491
                },
                {
                  "Area": "Sathiala",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 31.6069,
                  "Long": 75.2749
                },
                {
                  "Area": "Sathion S.O",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.0438,
                  "Long": 83.2192
                },
                {
                  "Area": "Sathisamuka",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.5736,
                  "Long": 91.3017
                },
                {
                  "Area": "Sathu",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.8359,
                  "Long": 74.8589
                },
                {
                  "Area": "Sathupalle",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.4631,
                  "Long": 80.0752
                },
                {
                  "Area": "Sathupalli",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.6604,
                  "Long": 80.869
                },
                {
                  "Area": "Sathy",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 11.7671,
                  "Long": 77.9472
                },
                {
                  "Area": "Sathyamangalam",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 11.778,
                  "Long": 77.9472
                },
                {
                  "Area": "Satilapur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.4761,
                  "Long": 86.8761
                },
                {
                  "Area": "Satkhanda Sahebnagar",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 21.8532,
                  "Long": 87.9147
                },
                {
                  "Area": "Satlasana",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 24.053,
                  "Long": 72.9227
                },
                {
                  "Area": "Satmile",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.871,
                  "Long": 88.0316
                },
                {
                  "Area": "Satnala",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 23.6526,
                  "Long": 91.2372
                },
                {
                  "Area": "Satnali",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.3771,
                  "Long": 75.964
                },
                {
                  "Area": "Satpautia",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.5234,
                  "Long": 87.6598
                },
                {
                  "Area": "Sattar",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.9159,
                  "Long": 86.5655
                },
                {
                  "Area": "Sattari",
                  "State": "Goa",
                  "CountryCode": "IN",
                  "Lat": 15.5826,
                  "Long": 74.2075
                },
                {
                  "Area": "Sattenapalle",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 16.4721,
                  "Long": 80.2199
                },
                {
                  "Area": "Sattur",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 9.686,
                  "Long": 78.1386
                },
                {
                  "Area": "Satura",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.9306,
                  "Long": 75.1134
                },
                {
                  "Area": "Satyabadi",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 20.0664,
                  "Long": 85.8627
                },
                {
                  "Area": "Satyabai",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 19.9463,
                  "Long": 85.8147
                },
                {
                  "Area": "Satyanarayanapuram",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 18,
                  "Long": 80.8773
                },
                {
                  "Area": "Satyavedu",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 13.6365,
                  "Long": 79.9577
                },
                {
                  "Area": "Saukuchi",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.3796,
                  "Long": 91.2951
                },
                {
                  "Area": "Saulabheri",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.3836,
                  "Long": 87.8747
                },
                {
                  "Area": "Saundatti",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 16.1195,
                  "Long": 75.4289
                },
                {
                  "Area": "Saur Bazar",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.8639,
                  "Long": 86.7246
                },
                {
                  "Area": "Sauri",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.3564,
                  "Long": 87.8021
                },
                {
                  "Area": "Sausar",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 21.7915,
                  "Long": 78.9329
                },
                {
                  "Area": "Sautia",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.3836,
                  "Long": 87.8747
                },
                {
                  "Area": "Savalyapuram",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 16.1496,
                  "Long": 79.8913
                },
                {
                  "Area": "Savanur",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 15.1051,
                  "Long": 75.5428
                },
                {
                  "Area": "Savar Kundla",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 21.447,
                  "Long": 71.7423
                },
                {
                  "Area": "Savarkundla",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 21.447,
                  "Long": 71.7423
                },
                {
                  "Area": "Savli",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 23.2644,
                  "Long": 73.7815
                },
                {
                  "Area": "Savner",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 21.4198,
                  "Long": 79.0876
                },
                {
                  "Area": "Sawaimadhopur",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 26.7301,
                  "Long": 76.8551
                },
                {
                  "Area": "Sawali",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.1179,
                  "Long": 79.4438
                },
                {
                  "Area": "Sawantwadi",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 19.9464,
                  "Long": 77.2752
                },
                {
                  "Area": "Sawanwtadi",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 15.8118,
                  "Long": 73.8612
                },
                {
                  "Area": "Sawayajpur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.7261,
                  "Long": 80.2195
                },
                {
                  "Area": "Sayan",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 20.8937,
                  "Long": 73.2555
                },
                {
                  "Area": "Sayestanagar",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.5239,
                  "Long": 87.8703
                },
                {
                  "Area": "Sayla",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 25.4192,
                  "Long": 73.2594
                },
                {
                  "Area": "Sayla",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 24.212,
                  "Long": 72.9571
                },
                {
                  "Area": "Sayra",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 25.0049,
                  "Long": 73.5039
                },
                {
                  "Area": "Sbraj",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.8166,
                  "Long": 86.8278
                },
                {
                  "Area": "Sdar",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.0332,
                  "Long": 85.4957
                },
                {
                  "Area": "Secondranagar",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.614,
                  "Long": 88.5475
                },
                {
                  "Area": "Sector -45",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.418,
                  "Long": 76.9839
                },
                {
                  "Area": "Sector-17",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.418,
                  "Long": 76.9839
                },
                {
                  "Area": "Secunderabad",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.5902,
                  "Long": 78.6839
                },
                {
                  "Area": "Sedam",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 17.5401,
                  "Long": 77.4051
                },
                {
                  "Area": "Sedwa",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 25.7356,
                  "Long": 71.4733
                },
                {
                  "Area": "Seepat",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 22.1074,
                  "Long": 82.2545
                },
                {
                  "Area": "Seetaramapuram",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.3613,
                  "Long": 78.7979
                },
                {
                  "Area": "Seethampeta",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.7351,
                  "Long": 83.9881
                },
                {
                  "Area": "Seethampeta Mandal",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.7883,
                  "Long": 83.8765
                },
                {
                  "Area": "Seethanagaram",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.7269,
                  "Long": 83.4374
                },
                {
                  "Area": "Seetharamapuram",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.4268,
                  "Long": 79.8255
                },
                {
                  "Area": "Segaon",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 22.1473,
                  "Long": 75.7946
                },
                {
                  "Area": "Sehlong",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.4013,
                  "Long": 76.373
                },
                {
                  "Area": "Sehma",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.1904,
                  "Long": 76.1312
                },
                {
                  "Area": "Sehore",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.7839,
                  "Long": 77.7254
                },
                {
                  "Area": "Seijosa",
                  "State": "Arunachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.4852,
                  "Long": 92.0686
                },
                {
                  "Area": "Sekerkote",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 23.4118,
                  "Long": 91.2931
                },
                {
                  "Area": "Sekmai",
                  "State": "Manipur",
                  "CountryCode": "IN",
                  "Lat": 24.9769,
                  "Long": 93.8879
                },
                {
                  "Area": "Selmabad",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.3836,
                  "Long": 87.8747
                },
                {
                  "Area": "Seloo",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.8675,
                  "Long": 78.9172
                },
                {
                  "Area": "Semarjhal",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.2843,
                  "Long": 80.3637
                },
                {
                  "Area": "Senapati",
                  "State": "Manipur",
                  "CountryCode": "IN",
                  "Lat": 24.8782,
                  "Long": 93.9796
                },
                {
                  "Area": "Senapati",
                  "State": "Meghalaya",
                  "CountryCode": "IN",
                  "Lat": 25.3596,
                  "Long": 91.7471
                },
                {
                  "Area": "Sendanga",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.8633,
                  "Long": 88.6131
                },
                {
                  "Area": "Sendhawa",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 21.6918,
                  "Long": 74.6155
                },
                {
                  "Area": "Sendhwa",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 21.7899,
                  "Long": 75.2651
                },
                {
                  "Area": "Sendurai",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 11.357,
                  "Long": 79.3399
                },
                {
                  "Area": "Sengaon",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.0621,
                  "Long": 77.1307
                },
                {
                  "Area": "Senge",
                  "State": "Arunachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.4667,
                  "Long": 92.1
                },
                {
                  "Area": "Sengottai",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 11.2589,
                  "Long": 79.7156
                },
                {
                  "Area": "Senpara Paschim",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.6874,
                  "Long": 79.9367
                },
                {
                  "Area": "Seondha",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.2767,
                  "Long": 78.8159
                },
                {
                  "Area": "Seoni",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 22.493,
                  "Long": 80.2771
                },
                {
                  "Area": "Seoni Malwa",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 22.4704,
                  "Long": 77.4832
                },
                {
                  "Area": "Seorinarayan",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 21.8534,
                  "Long": 83.1009
                },
                {
                  "Area": "Seppa",
                  "State": "Arunachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.4852,
                  "Long": 92.0686
                },
                {
                  "Area": "Seraikalla Kharsawan",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 22.9685,
                  "Long": 85.8806
                },
                {
                  "Area": "Seraikela",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 22.8933,
                  "Long": 85.9923
                },
                {
                  "Area": "Seraikella",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 22.8876,
                  "Long": 85.9351
                },
                {
                  "Area": "Seraikella Kharsawan",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 23.0787,
                  "Long": 85.9898
                },
                {
                  "Area": "Seraikella Kharsawanq",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 23.062,
                  "Long": 85.9254
                },
                {
                  "Area": "Seraikera",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 22.7462,
                  "Long": 85.8646
                },
                {
                  "Area": "Serampore",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.0021,
                  "Long": 88.3052
                },
                {
                  "Area": "Serampur Uttarpara",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.0455,
                  "Long": 88.3471
                },
                {
                  "Area": "Serango",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 19.642,
                  "Long": 84.4422
                },
                {
                  "Area": "Serchhip",
                  "State": "Mizoram",
                  "CountryCode": "IN",
                  "Lat": 23.4434,
                  "Long": 93.0014
                },
                {
                  "Area": "Seri Lingampally",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.3939,
                  "Long": 78.4529
                },
                {
                  "Area": "Serilingampally",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.5902,
                  "Long": 78.6839
                },
                {
                  "Area": "Serkhanchak",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.5034,
                  "Long": 87.9832
                },
                {
                  "Area": "Sermera",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.2347,
                  "Long": 85.8315
                },
                {
                  "Area": "Sethpur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.7774,
                  "Long": 88.5686
                },
                {
                  "Area": "Setrawa",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 26.7508,
                  "Long": 73.6381
                },
                {
                  "Area": "Settur",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.492,
                  "Long": 77.7181
                },
                {
                  "Area": "Sfipur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.2482,
                  "Long": 80.8883
                },
                {
                  "Area": "Shabad",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.2189,
                  "Long": 78.0845
                },
                {
                  "Area": "Shadnagar",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.0647,
                  "Long": 78.2128
                },
                {
                  "Area": "Shagpur",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.786,
                  "Long": 80.9682
                },
                {
                  "Area": "Shah Alam Nagar",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.5474,
                  "Long": 86.9086
                },
                {
                  "Area": "Shahabad",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 30.1502,
                  "Long": 76.8588
                },
                {
                  "Area": "Shahabad",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.1929,
                  "Long": 78.3087
                },
                {
                  "Area": "Shahabad",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 28.6171,
                  "Long": 79.9402
                },
                {
                  "Area": "Shahad",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 21.6961,
                  "Long": 74.3686
                },
                {
                  "Area": "Shahada",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 21.878,
                  "Long": 74.9948
                },
                {
                  "Area": "Shahade",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 21.7382,
                  "Long": 74.5455
                },
                {
                  "Area": "Shahapur",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.0771,
                  "Long": 75.0291
                },
                {
                  "Area": "Shahapur",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 16.8769,
                  "Long": 77.2821
                },
                {
                  "Area": "Shahbad",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 30.1502,
                  "Long": 76.8588
                },
                {
                  "Area": "Shahbad",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 30.2096,
                  "Long": 76.9516
                },
                {
                  "Area": "Shahganj",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 22.9911,
                  "Long": 77.8448
                },
                {
                  "Area": "Shahganj",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.147,
                  "Long": 82.7408
                },
                {
                  "Area": "Shahjahanpur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.9757,
                  "Long": 80.142
                },
                {
                  "Area": "Shahkot",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 31.4944,
                  "Long": 75.6793
                },
                {
                  "Area": "Shahkund",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.2705,
                  "Long": 87.0844
                },
                {
                  "Area": "Shahpur",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 16.7694,
                  "Long": 77.0697
                },
                {
                  "Area": "Shahpur",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.6793,
                  "Long": 85.0884
                },
                {
                  "Area": "Shahpur",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 32.3084,
                  "Long": 76.3801
                },
                {
                  "Area": "Shahpur",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 22.3087,
                  "Long": 78.2461
                },
                {
                  "Area": "Shahpur Bamheta",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 28.6667,
                  "Long": 77.4333
                },
                {
                  "Area": "Shahpur(T)",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 32.1773,
                  "Long": 76.2193
                },
                {
                  "Area": "Shahpura",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.2819,
                  "Long": 81.0561
                },
                {
                  "Area": "Shahpura Niwas",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.0479,
                  "Long": 80.7936
                },
                {
                  "Area": "Shahuwadi",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 17.9153,
                  "Long": 74.4532
                },
                {
                  "Area": "Shaikpet",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.4411,
                  "Long": 78.4699
                },
                {
                  "Area": "Shajapur",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.8473,
                  "Long": 76.8785
                },
                {
                  "Area": "Shajnwa",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.4911,
                  "Long": 83.0284
                },
                {
                  "Area": "Shalonibari",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.4206,
                  "Long": 93.2317
                },
                {
                  "Area": "Shambhuganj",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.4396,
                  "Long": 86.8409
                },
                {
                  "Area": "Shambhupura",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 23.3914,
                  "Long": 74.1934
                },
                {
                  "Area": "Shameerpet",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.6025,
                  "Long": 78.6205
                },
                {
                  "Area": "Shamho",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.2368,
                  "Long": 86.1921
                },
                {
                  "Area": "Shamirpet",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.6025,
                  "Long": 78.6205
                },
                {
                  "Area": "Shamirpet Mandal",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.3898,
                  "Long": 78.4699
                },
                {
                  "Area": "Shamli",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 29.7441,
                  "Long": 77.741
                },
                {
                  "Area": "Shamli **",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 29.468,
                  "Long": 77.2964
                },
                {
                  "Area": "Shamshabad",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.7896,
                  "Long": 79.5385
                },
                {
                  "Area": "Shankarampet (A)",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 18.0773,
                  "Long": 77.9289
                },
                {
                  "Area": "Shankarapatnam",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 18.5497,
                  "Long": 79.2409
                },
                {
                  "Area": "Shankarpally",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.3901,
                  "Long": 78.3279
                },
                {
                  "Area": "Shankarpur",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.0436,
                  "Long": 86.8806
                },
                {
                  "Area": "Shanti Nagar",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.5442,
                  "Long": 80.1097
                },
                {
                  "Area": "Shapur/jawali",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 32.2199,
                  "Long": 75.9986
                },
                {
                  "Area": "Shayam Nagar",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.3498,
                  "Long": 76.5026
                },
                {
                  "Area": "Shayampet",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 18.0544,
                  "Long": 79.5486
                },
                {
                  "Area": "Shegan",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.5297,
                  "Long": 77.0839
                },
                {
                  "Area": "Shegaon",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.9017,
                  "Long": 77.0839
                },
                {
                  "Area": "Shehera",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 23.2917,
                  "Long": 73.7237
                },
                {
                  "Area": "Sheikhpur",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.0756,
                  "Long": 85.9277
                },
                {
                  "Area": "Sheikhpura",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.4276,
                  "Long": 86.1703
                },
                {
                  "Area": "Shekhopur",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.1171,
                  "Long": 85.7688
                },
                {
                  "Area": "Shekhopur Sarai",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.1387,
                  "Long": 85.7316
                },
                {
                  "Area": "Shekhopura Sarai",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.0978,
                  "Long": 85.6957
                },
                {
                  "Area": "Shekhopursarai",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.1171,
                  "Long": 85.7688
                },
                {
                  "Area": "Shekhosarai",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.1319,
                  "Long": 85.8289
                },
                {
                  "Area": "Shekhpur Sarai",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.4276,
                  "Long": 86.1703
                },
                {
                  "Area": "Shella",
                  "State": "Meghalaya",
                  "CountryCode": "IN",
                  "Lat": 25.1786,
                  "Long": 91.6395
                },
                {
                  "Area": "Shenkottai",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 11.2589,
                  "Long": 79.7156
                },
                {
                  "Area": "Sheoganj",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 25.1391,
                  "Long": 73.0989
                },
                {
                  "Area": "Sheohar",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.576,
                  "Long": 85.7873
                },
                {
                  "Area": "Sheoli",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.5912,
                  "Long": 79.9943
                },
                {
                  "Area": "Sheopur",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 25.8826,
                  "Long": 77.3573
                },
                {
                  "Area": "Sheopursarai",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.1572,
                  "Long": 85.6992
                },
                {
                  "Area": "Sheosagar",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.1111,
                  "Long": 84.1907
                },
                {
                  "Area": "Shergahati",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 24.6183,
                  "Long": 84.7142
                },
                {
                  "Area": "Shergahti",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 24.6882,
                  "Long": 84.869
                },
                {
                  "Area": "Shergarh",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 26.7508,
                  "Long": 73.6381
                },
                {
                  "Area": "Sherghati",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 24.814,
                  "Long": 84.936
                },
                {
                  "Area": "Shettur",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.4086,
                  "Long": 76.9656
                },
                {
                  "Area": "Shetturu",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.4242,
                  "Long": 77.3651
                },
                {
                  "Area": "Shevgaon",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 19.7933,
                  "Long": 75.7076
                },
                {
                  "Area": "Shiala",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 17.9519,
                  "Long": 75.7536
                },
                {
                  "Area": "Shiggaon",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 15.0691,
                  "Long": 75.4177
                },
                {
                  "Area": "Shiggoan",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 14.6119,
                  "Long": 75.4068
                },
                {
                  "Area": "Shikaripara",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.6567,
                  "Long": 87.6743
                },
                {
                  "Area": "Shikaripura",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 14.1892,
                  "Long": 75.4289
                },
                {
                  "Area": "Shikarpur",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 14.5566,
                  "Long": 75.5011
                },
                {
                  "Area": "Shikarpur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 28.341,
                  "Long": 78.0141
                },
                {
                  "Area": "Shikarpur Bdo I",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.9808,
                  "Long": 88.7197
                },
                {
                  "Area": "Shikohabad",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.2488,
                  "Long": 78.8605
                },
                {
                  "Area": "Shikripara",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.3424,
                  "Long": 87.2641
                },
                {
                  "Area": "Shilai",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 30.7039,
                  "Long": 77.6559
                },
                {
                  "Area": "Shilla",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 30.7039,
                  "Long": 77.6559
                },
                {
                  "Area": "Shillai",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 30.7494,
                  "Long": 77.7328
                },
                {
                  "Area": "Shillong",
                  "State": "Meghalaya",
                  "CountryCode": "IN",
                  "Lat": 25.5707,
                  "Long": 92.0616
                },
                {
                  "Area": "Shimala",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 28.0919,
                  "Long": 76.0715
                },
                {
                  "Area": "Shimla",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.2381,
                  "Long": 77.7548
                },
                {
                  "Area": "Shimla R",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.1225,
                  "Long": 77.2843
                },
                {
                  "Area": "Shimla Rural(T)",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.1256,
                  "Long": 77.1766
                },
                {
                  "Area": "Shimla Urban(T)",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.1783,
                  "Long": 77.2781
                },
                {
                  "Area": "Shimlar",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.0946,
                  "Long": 77.2625
                },
                {
                  "Area": "Shimoga",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 14.5753,
                  "Long": 75.7305
                },
                {
                  "Area": "Shimogai",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 14.0436,
                  "Long": 75.2207
                },
                {
                  "Area": "Shindkheda",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 21.3579,
                  "Long": 74.9783
                },
                {
                  "Area": "Shinkheda",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 21.1765,
                  "Long": 74.9375
                },
                {
                  "Area": "Shipur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 21.7746,
                  "Long": 87.4726
                },
                {
                  "Area": "Shirahatti",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 15.4311,
                  "Long": 75.7337
                },
                {
                  "Area": "Shirala",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 18.0913,
                  "Long": 75.7536
                },
                {
                  "Area": "Shiratti",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 15.2627,
                  "Long": 75.7337
                },
                {
                  "Area": "Shirhatti",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 15.4311,
                  "Long": 75.6786
                },
                {
                  "Area": "Shirol",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 19.715,
                  "Long": 79.0301
                },
                {
                  "Area": "Shirpur",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 21.5708,
                  "Long": 75.1439
                },
                {
                  "Area": "Shirur",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 19.5759,
                  "Long": 75.6248
                },
                {
                  "Area": "Shirur (Kasar)",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 19.13,
                  "Long": 75.8696
                },
                {
                  "Area": "Shirur Anantpal",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 18.3387,
                  "Long": 76.8401
                },
                {
                  "Area": "Shirur K",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 18.9457,
                  "Long": 76.8963
                },
                {
                  "Area": "Shirur K.",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 18.9457,
                  "Long": 76.8963
                },
                {
                  "Area": "Shirur-Anantpal",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 18.3605,
                  "Long": 76.7751
                },
                {
                  "Area": "Shiurur",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 18.6194,
                  "Long": 74.3342
                },
                {
                  "Area": "Shiv",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 26.3314,
                  "Long": 71.854
                },
                {
                  "Area": "Shivaji Nagar",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.5167,
                  "Long": 80.3155
                },
                {
                  "Area": "Shivaji Nagar",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.418,
                  "Long": 76.9839
                },
                {
                  "Area": "Shivpuri",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 25.8243,
                  "Long": 78.2895
                },
                {
                  "Area": "Shivrajpur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.4448,
                  "Long": 81.236
                },
                {
                  "Area": "Shjkohabad",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.0863,
                  "Long": 78.5022
                },
                {
                  "Area": "Shogapora",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.9245,
                  "Long": 74.6725
                },
                {
                  "Area": "Shoharatgarh",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.1306,
                  "Long": 83.1336
                },
                {
                  "Area": "Shohratgarh",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.2824,
                  "Long": 83.3423
                },
                {
                  "Area": "Sholinganallur",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 12.8745,
                  "Long": 79.763
                },
                {
                  "Area": "Sholipora",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.9245,
                  "Long": 74.6725
                },
                {
                  "Area": "Shopian",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.8643,
                  "Long": 74.6951
                },
                {
                  "Area": "Shopin",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.7648,
                  "Long": 74.8905
                },
                {
                  "Area": "Shorapur",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 17.0062,
                  "Long": 76.9926
                },
                {
                  "Area": "Shorpaur",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 16.4916,
                  "Long": 76.4223
                },
                {
                  "Area": "Shri Amirgadh",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 24.3614,
                  "Long": 72.7055
                },
                {
                  "Area": "Shriamirgadh",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 24.1507,
                  "Long": 72.865
                },
                {
                  "Area": "Shrigoda",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 18.5119,
                  "Long": 74.7017
                },
                {
                  "Area": "Shrigonda",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 19.7434,
                  "Long": 75.3272
                },
                {
                  "Area": "Shrirampur",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 19.5639,
                  "Long": 75.2002
                },
                {
                  "Area": "Shrirampur.",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 21.0725,
                  "Long": 77.3501
                },
                {
                  "Area": "Shrirangapattana",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 12.6297,
                  "Long": 76.8295
                },
                {
                  "Area": "Shrivardhan",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 18.6704,
                  "Long": 73.3791
                },
                {
                  "Area": "Shriwardhan",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 19.9934,
                  "Long": 73.3791
                },
                {
                  "Area": "Shujalpur",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.5797,
                  "Long": 76.7548
                },
                {
                  "Area": "Shyam Nagar",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.3805,
                  "Long": 80.2158
                },
                {
                  "Area": "Shyamnagar",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.8333,
                  "Long": 88.7803
                },
                {
                  "Area": "Shyampur",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.1721,
                  "Long": 77.1285
                },
                {
                  "Area": "Shyampur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.4761,
                  "Long": 86.8761
                },
                {
                  "Area": "Shyampura",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.4268,
                  "Long": 75.9414
                },
                {
                  "Area": "Siaha",
                  "State": "Mizoram",
                  "CountryCode": "IN",
                  "Lat": 22.4521,
                  "Long": 93.0196
                },
                {
                  "Area": "Siaknderpur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.039,
                  "Long": 84.1125
                },
                {
                  "Area": "Sialba Majri",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 30.8446,
                  "Long": 76.7242
                },
                {
                  "Area": "Sialsuk",
                  "State": "Mizoram",
                  "CountryCode": "IN",
                  "Lat": 23.3954,
                  "Long": 92.755
                },
                {
                  "Area": "Siana",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.4013,
                  "Long": 76.373
                },
                {
                  "Area": "Sibhati",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.6809,
                  "Long": 88.9039
                },
                {
                  "Area": "Sibnagar",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.1305,
                  "Long": 92.1555
                },
                {
                  "Area": "Sibsagar",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 27.2053,
                  "Long": 95.0234
                },
                {
                  "Area": "Siddanakonduru",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 15.004,
                  "Long": 79.9691
                },
                {
                  "Area": "Siddapur",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 14.7941,
                  "Long": 74.9504
                },
                {
                  "Area": "Sidddapur",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 14.527,
                  "Long": 74.8059
                },
                {
                  "Area": "Siddikganj",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 22.8742,
                  "Long": 76.6506
                },
                {
                  "Area": "Siddipet",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.888,
                  "Long": 78.505
                },
                {
                  "Area": "Sidhai",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.0447,
                  "Long": 91.7553
                },
                {
                  "Area": "Sidhali",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.2995,
                  "Long": 80.8484
                },
                {
                  "Area": "Sidhauli",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.5177,
                  "Long": 81.1596
                },
                {
                  "Area": "Sidhi",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.2198,
                  "Long": 81.8353
                },
                {
                  "Area": "Sidhout",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.4855,
                  "Long": 79.0812
                },
                {
                  "Area": "Sidhpur",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 24.0327,
                  "Long": 73.2181
                },
                {
                  "Area": "Sidlaghatta",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 13.6242,
                  "Long": 78.2177
                },
                {
                  "Area": "Sidlghatta",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 13.516,
                  "Long": 77.8292
                },
                {
                  "Area": "Sidli (Part-II)",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.3656,
                  "Long": 90.6348
                },
                {
                  "Area": "Sidli Chirang",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.551,
                  "Long": 90.6248
                },
                {
                  "Area": "Sigaam",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.3755,
                  "Long": 83.6735
                },
                {
                  "Area": "Sigadam",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.3656,
                  "Long": 83.651
                },
                {
                  "Area": "Sigadam Mandal",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.4309,
                  "Long": 83.7677
                },
                {
                  "Area": "Sihawal",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.5853,
                  "Long": 82.2396
                },
                {
                  "Area": "Sihira",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.7484,
                  "Long": 80.2084
                },
                {
                  "Area": "Sihor",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 22.2689,
                  "Long": 73.0712
                },
                {
                  "Area": "Sihora",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.839,
                  "Long": 80.8131
                },
                {
                  "Area": "Sihora.",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.6017,
                  "Long": 80.3788
                },
                {
                  "Area": "Sihore",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.3758,
                  "Long": 76.2892
                },
                {
                  "Area": "Sihphir",
                  "State": "Mizoram",
                  "CountryCode": "IN",
                  "Lat": 23.8199,
                  "Long": 92.7411
                },
                {
                  "Area": "Sihunta",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 32.6775,
                  "Long": 76.5485
                },
                {
                  "Area": "Sikandar Pur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 25.9993,
                  "Long": 84.0286
                },
                {
                  "Area": "Sikandarabad",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 28.8173,
                  "Long": 77.695
                },
                {
                  "Area": "Sikandarour",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 25.749,
                  "Long": 83.8132
                },
                {
                  "Area": "Sikandarpur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.0577,
                  "Long": 84.1337
                },
                {
                  "Area": "Sikanderpur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.2157,
                  "Long": 84.1312
                },
                {
                  "Area": "Sikandra",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 24.9843,
                  "Long": 86.2952
                },
                {
                  "Area": "Sikandra",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.8351,
                  "Long": 81.9859
                },
                {
                  "Area": "Sikandrabad",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 28.8173,
                  "Long": 78.0123
                },
                {
                  "Area": "Sikar",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 28.0327,
                  "Long": 76.2885
                },
                {
                  "Area": "Sikarahana",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.7194,
                  "Long": 84.9341
                },
                {
                  "Area": "Sikaripara",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.6567,
                  "Long": 87.2666
                },
                {
                  "Area": "Sikarndrabad",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 28.8173,
                  "Long": 77.695
                },
                {
                  "Area": "Sikarpur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 28.3362,
                  "Long": 78.0576
                },
                {
                  "Area": "Sikharpur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.5864,
                  "Long": 88.4145
                },
                {
                  "Area": "Sikndrabdad",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 28.298,
                  "Long": 77.6637
                },
                {
                  "Area": "Sikrahana",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.6184,
                  "Long": 84.9247
                },
                {
                  "Area": "Silampur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.5656,
                  "Long": 87.9504
                },
                {
                  "Area": "Silampur-ii",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.5656,
                  "Long": 87.9504
                },
                {
                  "Area": "Silao",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.3056,
                  "Long": 85.5591
                },
                {
                  "Area": "Silapathar",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 27.5944,
                  "Long": 94.724
                },
                {
                  "Area": "Silapthar",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 27.5944,
                  "Long": 94.724
                },
                {
                  "Area": "Silchar",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 25.0658,
                  "Long": 92.804
                },
                {
                  "Area": "Siligur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 26.6827,
                  "Long": 88.22
                },
                {
                  "Area": "Siliguri",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 26.731,
                  "Long": 88.9486
                },
                {
                  "Area": "Silli",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 23.4532,
                  "Long": 85.866
                },
                {
                  "Area": "Sillod",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.5645,
                  "Long": 76.1331
                },
                {
                  "Area": "Sillyaberia",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 21.8532,
                  "Long": 87.9147
                },
                {
                  "Area": "Silwani",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.4168,
                  "Long": 78.7098
                },
                {
                  "Area": "Simaria",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.1595,
                  "Long": 85.1178
                },
                {
                  "Area": "Simbhaoli",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 28.7389,
                  "Long": 77.7067
                },
                {
                  "Area": "Simdega",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 22.8083,
                  "Long": 84.6579
                },
                {
                  "Area": "Simen Chapori",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 27.7246,
                  "Long": 94.8545
                },
                {
                  "Area": "Simga",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 21.9346,
                  "Long": 82.174
                },
                {
                  "Area": "Simhadripuram",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.6006,
                  "Long": 78.7836
                },
                {
                  "Area": "Similia",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.7032,
                  "Long": 87.1571
                },
                {
                  "Area": "Similiguda",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 18.905,
                  "Long": 82.972
                },
                {
                  "Area": "Simlaguri",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.4348,
                  "Long": 91.1657
                },
                {
                  "Area": "Simlapal",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.141,
                  "Long": 87.7549
                },
                {
                  "Area": "Simna",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.0447,
                  "Long": 91.7553
                },
                {
                  "Area": "Simri",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.9667,
                  "Long": 85.6756
                },
                {
                  "Area": "Simri Bakhtiapur",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.7554,
                  "Long": 86.5286
                },
                {
                  "Area": "Simri Bakhtiarpur",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.8561,
                  "Long": 86.816
                },
                {
                  "Area": "Simulia",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.4653,
                  "Long": 88.7803
                },
                {
                  "Area": "Simulia",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.4898,
                  "Long": 86.917
                },
                {
                  "Area": "Simulia Durgapur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.6259,
                  "Long": 88.6827
                },
                {
                  "Area": "Simulia Kalibari",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.5455,
                  "Long": 88.9366
                },
                {
                  "Area": "Simulpur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.8794,
                  "Long": 88.2197
                },
                {
                  "Area": "Sinapali",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 20.8167,
                  "Long": 82.5804
                },
                {
                  "Area": "Sinapalli",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 20.3906,
                  "Long": 82.7233
                },
                {
                  "Area": "Sindewahi",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.379,
                  "Long": 79.7237
                },
                {
                  "Area": "Sindgi",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 17.1695,
                  "Long": 76.4906
                },
                {
                  "Area": "Sindhanur",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 16.3788,
                  "Long": 77.3848
                },
                {
                  "Area": "Sindhari",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 25.9464,
                  "Long": 71.98
                },
                {
                  "Area": "Sindhekela",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 20.2285,
                  "Long": 83.0571
                },
                {
                  "Area": "Sindhnur",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 16.0482,
                  "Long": 76.7238
                },
                {
                  "Area": "Sindhudurgkudal",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 17.4896,
                  "Long": 74.3088
                },
                {
                  "Area": "Sindhukumarpara",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 23.9923,
                  "Long": 91.6205
                },
                {
                  "Area": "Sindkhed Raja",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.5111,
                  "Long": 76.817
                },
                {
                  "Area": "Sindkheda",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 21.1868,
                  "Long": 74.9375
                },
                {
                  "Area": "Sindkhede",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 21.3236,
                  "Long": 74.6666
                },
                {
                  "Area": "Sindrani",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.8358,
                  "Long": 88.7482
                },
                {
                  "Area": "Singaijamuna",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.4364,
                  "Long": 87.9624
                },
                {
                  "Area": "Singampunari Block",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 10.4156,
                  "Long": 78.4001
                },
                {
                  "Area": "Singanamala",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.9256,
                  "Long": 77.9714
                },
                {
                  "Area": "Singhat",
                  "State": "Manipur",
                  "CountryCode": "IN",
                  "Lat": 24.0849,
                  "Long": 93.6045
                },
                {
                  "Area": "Singheshwar",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.9283,
                  "Long": 86.726
                },
                {
                  "Area": "Singheshwar",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.0831,
                  "Long": 86.9136
                },
                {
                  "Area": "Singheswar",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.9598,
                  "Long": 86.7213
                },
                {
                  "Area": "Singhwara",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.1842,
                  "Long": 85.7368
                },
                {
                  "Area": "Singi",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 16.8139,
                  "Long": 76.3426
                },
                {
                  "Area": "Singicherra",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.0796,
                  "Long": 91.5997
                },
                {
                  "Area": "Singla",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.7205,
                  "Long": 85.5887
                },
                {
                  "Area": "Singrauli",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.2667,
                  "Long": 82.7041
                },
                {
                  "Area": "Singrauli Colliery",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.2667,
                  "Long": 82.7041
                },
                {
                  "Area": "Singtam",
                  "State": "Sikkim",
                  "CountryCode": "IN",
                  "Lat": 27.2471,
                  "Long": 88.5361
                },
                {
                  "Area": "Singur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.246,
                  "Long": 88.3384
                },
                {
                  "Area": "Sinhapalli",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 20.4657,
                  "Long": 82.8264
                },
                {
                  "Area": "Sini",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 22.7933,
                  "Long": 85.9454
                },
                {
                  "Area": "Sinkhed Raja",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.0077,
                  "Long": 76.3086
                },
                {
                  "Area": "Sinnar",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.9671,
                  "Long": 79.3816
                },
                {
                  "Area": "Sinor",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 23.0923,
                  "Long": 73.6732
                },
                {
                  "Area": "Sipajhar",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.6676,
                  "Long": 92.4009
                },
                {
                  "Area": "Sippi",
                  "State": "Arunachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.9911,
                  "Long": 94.2295
                },
                {
                  "Area": "Sira",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 13.9817,
                  "Long": 77.1008
                },
                {
                  "Area": "Sirajuli",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.6589,
                  "Long": 92.4784
                },
                {
                  "Area": "Sirathu",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 25.8922,
                  "Long": 81.7615
                },
                {
                  "Area": "Siraul Gaus Pur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.9963,
                  "Long": 81.8539
                },
                {
                  "Area": "Siraul Gauspur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.9963,
                  "Long": 81.8539
                },
                {
                  "Area": "Sirauli Gaus Pur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.9746,
                  "Long": 81.4602
                },
                {
                  "Area": "Sirauli Gauspur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.0704,
                  "Long": 81.8539
                },
                {
                  "Area": "Sirauli Gauspur**",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.9963,
                  "Long": 81.8539
                },
                {
                  "Area": "Sircilla",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 18.3532,
                  "Long": 78.6887
                },
                {
                  "Area": "Sirdala",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.1284,
                  "Long": 85.4092
                },
                {
                  "Area": "Sirhi Itra",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.1628,
                  "Long": 80.5482
                },
                {
                  "Area": "Sirhind",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 30.6846,
                  "Long": 76.5585
                },
                {
                  "Area": "Siripuram",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.5969,
                  "Long": 80.6873
                },
                {
                  "Area": "Sirkabad",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.2752,
                  "Long": 86.3502
                },
                {
                  "Area": "Sirkali",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 12.4025,
                  "Long": 79.9866
                },
                {
                  "Area": "Sirkali Tk",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 11.2072,
                  "Long": 79.6065
                },
                {
                  "Area": "Sirmour",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.9842,
                  "Long": 81.898
                },
                {
                  "Area": "Sirohi",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 24.9919,
                  "Long": 74.1061
                },
                {
                  "Area": "Sirohi Behali",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 29.3043,
                  "Long": 77.0492
                },
                {
                  "Area": "Sironcha",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.1179,
                  "Long": 80.2411
                },
                {
                  "Area": "Sironj",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.2898,
                  "Long": 77.8904
                },
                {
                  "Area": "Sirpur",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 19.5584,
                  "Long": 79.4394
                },
                {
                  "Area": "Sirpur (t)",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 19.5615,
                  "Long": 79.6858
                },
                {
                  "Area": "Sirpur(t)",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 19.1343,
                  "Long": 79.4121
                },
                {
                  "Area": "Sirsa",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 30.0833,
                  "Long": 75.5574
                },
                {
                  "Area": "Sirsi",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 14.8866,
                  "Long": 75.1705
                },
                {
                  "Area": "Sirsilla",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 18.5497,
                  "Long": 79.2409
                },
                {
                  "Area": "Siruguppa",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 15.7365,
                  "Long": 77.0745
                },
                {
                  "Area": "Sirvel",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 15.7407,
                  "Long": 79.9128
                },
                {
                  "Area": "Sisai",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 23.3129,
                  "Long": 84.8392
                },
                {
                  "Area": "Sissiborgaon",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 27.5273,
                  "Long": 94.6755
                },
                {
                  "Area": "Sissiborgaron",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 27.5273,
                  "Long": 94.6755
                },
                {
                  "Area": "Sisusadan",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.5034,
                  "Long": 87.9832
                },
                {
                  "Area": "Siswan",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.9521,
                  "Long": 84.4491
                },
                {
                  "Area": "Sitai",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 26.3599,
                  "Long": 89.5546
                },
                {
                  "Area": "Sitalia",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.3243,
                  "Long": 88.9366
                },
                {
                  "Area": "Sitalkuchi",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 26.291,
                  "Long": 89.3436
                },
                {
                  "Area": "Sitamarhi",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.0372,
                  "Long": 85.6152
                },
                {
                  "Area": "Sitamau",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.2955,
                  "Long": 76.5343
                },
                {
                  "Area": "Sitapur",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 23.3578,
                  "Long": 83.4078
                },
                {
                  "Area": "Sitapur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.7977,
                  "Long": 81.1155
                },
                {
                  "Area": "Sitarganj",
                  "State": "Uttarakhand",
                  "CountryCode": "IN",
                  "Lat": 29.3158,
                  "Long": 79.8718
                },
                {
                  "Area": "Sithanagaram",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 17.4501,
                  "Long": 82.1181
                },
                {
                  "Area": "Sithanagram",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 17.064,
                  "Long": 81.6996
                },
                {
                  "Area": "Sitpaur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.449,
                  "Long": 80.8525
                },
                {
                  "Area": "Sittaganj",
                  "State": "Uttarakhand",
                  "CountryCode": "IN",
                  "Lat": 28.9817,
                  "Long": 79.727
                },
                {
                  "Area": "Sittarganj",
                  "State": "Uttarakhand",
                  "CountryCode": "IN",
                  "Lat": 28.9817,
                  "Long": 79.8096
                },
                {
                  "Area": "Sivaganga",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 10.0864,
                  "Long": 78.6605
                },
                {
                  "Area": "Sivagiri",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 9.3579,
                  "Long": 78.1387
                },
                {
                  "Area": "Sivakasi",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 10.3813,
                  "Long": 78.8214
                },
                {
                  "Area": "Sivasagar",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 27.2053,
                  "Long": 94.7353
                },
                {
                  "Area": "Sivigiri",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 9.3579,
                  "Long": 78.1387
                },
                {
                  "Area": "Siwan",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.3314,
                  "Long": 84.8781
                },
                {
                  "Area": "Siwana",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 25.7483,
                  "Long": 72.4224
                },
                {
                  "Area": "Siwani",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.9638,
                  "Long": 75.7649
                },
                {
                  "Area": "Siwn",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.3153,
                  "Long": 84.1987
                },
                {
                  "Area": "Siyalsai",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.8923,
                  "Long": 87.3704
                },
                {
                  "Area": "Siyana",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 28.6853,
                  "Long": 78.4659
                },
                {
                  "Area": "Siyum",
                  "State": "Arunachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.9911,
                  "Long": 94.2295
                },
                {
                  "Area": "Skaleshpur",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 13.0073,
                  "Long": 75.7106
                },
                {
                  "Area": "Slooni",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 32.5574,
                  "Long": 76.1525
                },
                {
                  "Area": "Smit",
                  "State": "Meghalaya",
                  "CountryCode": "IN",
                  "Lat": 25.5232,
                  "Long": 91.9708
                },
                {
                  "Area": "Snagaria",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 29.8467,
                  "Long": 74.4781
                },
                {
                  "Area": "Snagmeshwar",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 15.919,
                  "Long": 74.1636
                },
                {
                  "Area": "Snagola",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 19.4807,
                  "Long": 76.4202
                },
                {
                  "Area": "Sngola",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 17.9232,
                  "Long": 74.8561
                },
                {
                  "Area": "Snpuram",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 18.0238,
                  "Long": 80.859
                },
                {
                  "Area": "So",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 18.0994,
                  "Long": 79.5239
                },
                {
                  "Area": "Soalkuchi Block",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.1959,
                  "Long": 91.5711
                },
                {
                  "Area": "Sobhadra",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.3198,
                  "Long": 83.2412
                },
                {
                  "Area": "Sodarpur-behala",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.399,
                  "Long": 88.0555
                },
                {
                  "Area": "Sodepur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.7379,
                  "Long": 88.3427
                },
                {
                  "Area": "Soegaon",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.639,
                  "Long": 76.1331
                },
                {
                  "Area": "Sogam",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 34.5851,
                  "Long": 74.4269
                },
                {
                  "Area": "Sohagpur",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.1449,
                  "Long": 81.532
                },
                {
                  "Area": "Sohaikumarpur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.6856,
                  "Long": 88.4668
                },
                {
                  "Area": "Sohawal",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.8159,
                  "Long": 82.4447
                },
                {
                  "Area": "Sohawal **",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.6547,
                  "Long": 82.0736
                },
                {
                  "Area": "Sohela",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.3089,
                  "Long": 83.666
                },
                {
                  "Area": "Sohella",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.3604,
                  "Long": 83.666
                },
                {
                  "Area": "Sohna",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.2474,
                  "Long": 77.0669
                },
                {
                  "Area": "Sohsarai",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.2492,
                  "Long": 85.5015
                },
                {
                  "Area": "Sojat",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 26.0803,
                  "Long": 73.9697
                },
                {
                  "Area": "Sojitra",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 23.2676,
                  "Long": 73.0167
                },
                {
                  "Area": "Soladanga",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.286,
                  "Long": 88.2996
                },
                {
                  "Area": "Solan",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.0916,
                  "Long": 77.2657
                },
                {
                  "Area": "Solan(T)",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.0916,
                  "Long": 77.2657
                },
                {
                  "Area": "Solapur",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 17.8026,
                  "Long": 76.4093
                },
                {
                  "Area": "Solapur North",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 18.1742,
                  "Long": 76.1434
                },
                {
                  "Area": "Solapur South",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 18.7325,
                  "Long": 76.4236
                },
                {
                  "Area": "Somandepalle",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 13.9471,
                  "Long": 78.7694
                },
                {
                  "Area": "Somandepalli",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.4811,
                  "Long": 78.7694
                },
                {
                  "Area": "Somarpet",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 12.3244,
                  "Long": 75.8033
                },
                {
                  "Area": "Somdal",
                  "State": "Manipur",
                  "CountryCode": "IN",
                  "Lat": 25.1679,
                  "Long": 94.2891
                },
                {
                  "Area": "Somesar",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 25.3328,
                  "Long": 73.6194
                },
                {
                  "Area": "Someshwar",
                  "State": "Uttarakhand",
                  "CountryCode": "IN",
                  "Lat": 29.8657,
                  "Long": 79.7604
                },
                {
                  "Area": "Sompeta Mandal",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.9442,
                  "Long": 84.5845
                },
                {
                  "Area": "Somvarpet",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 12.9699,
                  "Long": 76.2066
                },
                {
                  "Area": "Somwarpet",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 12.7661,
                  "Long": 76.2066
                },
                {
                  "Area": "Sonaimuri",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.1597,
                  "Long": 92.0329
                },
                {
                  "Area": "Sonajuli",
                  "State": "Arunachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.5535,
                  "Long": 93.7868
                },
                {
                  "Area": "Sonakenia",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.2312,
                  "Long": 88.4785
                },
                {
                  "Area": "Sonakonia",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.6315,
                  "Long": 87.428
                },
                {
                  "Area": "Sonala",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 21.0853,
                  "Long": 76.7145
                },
                {
                  "Area": "Sonamukhi",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.4064,
                  "Long": 87.8749
                },
                {
                  "Area": "Sonamukhi",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.0789,
                  "Long": 91.8987
                },
                {
                  "Area": "Sonamura",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 23.4755,
                  "Long": 91.3204
                },
                {
                  "Area": "Sonapur",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 20.8746,
                  "Long": 83.9417
                },
                {
                  "Area": "Sonapur Block",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.1593,
                  "Long": 91.9722
                },
                {
                  "Area": "Sonarpur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.4126,
                  "Long": 88.3386
                },
                {
                  "Area": "Sonatala",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.019,
                  "Long": 91.625
                },
                {
                  "Area": "Sonawari",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 34.3316,
                  "Long": 74.6488
                },
                {
                  "Area": "Sonbadra",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.8539,
                  "Long": 83.3308
                },
                {
                  "Area": "Sonbarsa",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.576,
                  "Long": 86.833
                },
                {
                  "Area": "Sonbersa",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.576,
                  "Long": 86.693
                },
                {
                  "Area": "Sonbersa Raj",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.7163,
                  "Long": 86.7281
                },
                {
                  "Area": "Sonbhadar",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.3471,
                  "Long": 82.9998
                },
                {
                  "Area": "Sonbhaddra",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.6912,
                  "Long": 82.9536
                },
                {
                  "Area": "Sonbhadr",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.2586,
                  "Long": 83.151
                },
                {
                  "Area": "Sonbhadra",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.9825,
                  "Long": 83.503
                },
                {
                  "Area": "Sondha",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.3796,
                  "Long": 91.2951
                },
                {
                  "Area": "Sonekpur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.8451,
                  "Long": 88.5958
                },
                {
                  "Area": "Sonepur",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.7322,
                  "Long": 85.1208
                },
                {
                  "Area": "Sonepur",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.955,
                  "Long": 85.8091
                },
                {
                  "Area": "Songadh",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 22.15,
                  "Long": 73.7154
                },
                {
                  "Area": "Sonhaula",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.2822,
                  "Long": 87.2831
                },
                {
                  "Area": "Sonipat",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 29.194,
                  "Long": 77.1436
                },
                {
                  "Area": "Sonkutch",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.2127,
                  "Long": 76.7641
                },
                {
                  "Area": "Sono",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 24.897,
                  "Long": 86.3813
                },
                {
                  "Area": "Sonoi",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 24.7908,
                  "Long": 86.1124
                },
                {
                  "Area": "Sonpeth",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 19.2857,
                  "Long": 76.703
                },
                {
                  "Area": "Sonua",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 22.6192,
                  "Long": 85.5131
                },
                {
                  "Area": "Sootea",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.971,
                  "Long": 93.8695
                },
                {
                  "Area": "Sopore",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 34.3682,
                  "Long": 74.6565
                },
                {
                  "Area": "Sorab",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 14.6269,
                  "Long": 75.2493
                },
                {
                  "Area": "Soraba",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 14.4218,
                  "Long": 75.1648
                },
                {
                  "Area": "Soraon",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 25.8695,
                  "Long": 82.703
                },
                {
                  "Area": "Sorbhog",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.4861,
                  "Long": 90.8859
                },
                {
                  "Area": "Soro",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 22.0715,
                  "Long": 87.1571
                },
                {
                  "Area": "Sorojini",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.332,
                  "Long": 92.0039
                },
                {
                  "Area": "Sorore",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 34.3229,
                  "Long": 74.4723
                },
                {
                  "Area": "Sour Bazar",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.0279,
                  "Long": 86.4503
                },
                {
                  "Area": "Sour Bazar",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.9144,
                  "Long": 86.7402
                },
                {
                  "Area": "South 24 Parganas",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.4485,
                  "Long": 88.3883
                },
                {
                  "Area": "South Delhi",
                  "State": "Delhi",
                  "CountryCode": "IN",
                  "Lat": 28.7441,
                  "Long": 77.247
                },
                {
                  "Area": "South Ganganagar",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.0447,
                  "Long": 91.7553
                },
                {
                  "Area": "South Huruah",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.0447,
                  "Long": 91.7553
                },
                {
                  "Area": "South Salmara",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.0672,
                  "Long": 90.511
                },
                {
                  "Area": "South Solapur",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 18.7325,
                  "Long": 76.167
                },
                {
                  "Area": "South West Delhi",
                  "State": "Delhi",
                  "CountryCode": "IN",
                  "Lat": 28.5458,
                  "Long": 77.1793
                },
                {
                  "Area": "Soyat Kalan",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.8473,
                  "Long": 76.3631
                },
                {
                  "Area": "Sp Tira",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.8607,
                  "Long": 77.1279
                },
                {
                  "Area": "Spiti",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 32.3735,
                  "Long": 78.3721
                },
                {
                  "Area": "Spiti       (T)",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 32.4805,
                  "Long": 78.1313
                },
                {
                  "Area": "Sreebhumi",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.6,
                  "Long": 88.4
                },
                {
                  "Area": "Sreemayapur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.601,
                  "Long": 88.1273
                },
                {
                  "Area": "Sreerampur",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.332,
                  "Long": 92.0039
                },
                {
                  "Area": "Sri Avadhutha Kasinayana",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.5354,
                  "Long": 79.0558
                },
                {
                  "Area": "Sri Madhopur",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 27.7039,
                  "Long": 76.0506
                },
                {
                  "Area": "Sribijaynagar",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 29.3955,
                  "Long": 75.3434
                },
                {
                  "Area": "Sribijenagar",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 27.6594,
                  "Long": 75.3434
                },
                {
                  "Area": "Sribijeynagar",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 29.3955,
                  "Long": 75.3434
                },
                {
                  "Area": "Sridharkati",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.4323,
                  "Long": 88.373
                },
                {
                  "Area": "Srigaganagar",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 30.0237,
                  "Long": 73.7378
                },
                {
                  "Area": "Sriganganagar",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 30.1491,
                  "Long": 75.3434
                },
                {
                  "Area": "Srigangangaar",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 29.5781,
                  "Long": 74.0525
                },
                {
                  "Area": "Srigangangar",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 29.7491,
                  "Long": 74.3132
                },
                {
                  "Area": "Srigufwara",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 34.0417,
                  "Long": 74.2404
                },
                {
                  "Area": "Srijangram",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.3148,
                  "Long": 90.4514
                },
                {
                  "Area": "Srikakulam",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.3917,
                  "Long": 83.9581
                },
                {
                  "Area": "Srikakulam Mandal",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.4109,
                  "Long": 83.9878
                },
                {
                  "Area": "Srikalahasti",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 13.7927,
                  "Long": 79.9356
                },
                {
                  "Area": "Srikaranpur",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 29.597,
                  "Long": 74.735
                },
                {
                  "Area": "Srikhanda",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.141,
                  "Long": 87.135
                },
                {
                  "Area": "Srikrishnapur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.4653,
                  "Long": 88.7803
                },
                {
                  "Area": "Srimadhopur",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 27.6366,
                  "Long": 76.6632
                },
                {
                  "Area": "Srinagar",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.4653,
                  "Long": 88.7803
                },
                {
                  "Area": "Srinagar",
                  "State": "Uttarakhand",
                  "CountryCode": "IN",
                  "Lat": 30.2237,
                  "Long": 78.9239
                },
                {
                  "Area": "Srinagar",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 34.1758,
                  "Long": 74.9148
                },
                {
                  "Area": "Srinagar **",
                  "State": "Uttarakhand",
                  "CountryCode": "IN",
                  "Lat": 30.2139,
                  "Long": 79.0192
                },
                {
                  "Area": "Srineri",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 13.4547,
                  "Long": 75.2254
                },
                {
                  "Area": "Sringeri",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 13.5046,
                  "Long": 75.416
                },
                {
                  "Area": "Srinivasapura",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 13.4439,
                  "Long": 78.3428
                },
                {
                  "Area": "Srinivaspur",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 13.5645,
                  "Long": 78.3462
                },
                {
                  "Area": "Srinivsapur",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 13.2724,
                  "Long": 78.1983
                },
                {
                  "Area": "Sriperubudur",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 12.6952,
                  "Long": 79.9479
                },
                {
                  "Area": "Sriperubudur Taluk",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 12.7039,
                  "Long": 79.8292
                },
                {
                  "Area": "Sriperumbudur",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 13.1449,
                  "Long": 80.1761
                },
                {
                  "Area": "Sripur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 25.3699,
                  "Long": 87.874
                },
                {
                  "Area": "Srirampur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.2758,
                  "Long": 88.831
                },
                {
                  "Area": "Srirampur",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 18.6418,
                  "Long": 79.8441
                },
                {
                  "Area": "Srirampur (habibpur)",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 25.0677,
                  "Long": 87.9151
                },
                {
                  "Area": "Srirampur Lambucherra",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.0789,
                  "Long": 91.8987
                },
                {
                  "Area": "Sriranagapatna",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 12.7903,
                  "Long": 76.8062
                },
                {
                  "Area": "Srirangam",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 10.9442,
                  "Long": 78.7428
                },
                {
                  "Area": "Srirangapatna",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 12.8254,
                  "Long": 76.9898
                },
                {
                  "Area": "Srirangarajapuram",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 13.5399,
                  "Long": 79.2351
                },
                {
                  "Area": "Srisailam",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 16.0722,
                  "Long": 78.8682
                },
                {
                  "Area": "Srivaikuntam",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 9.1675,
                  "Long": 78.0737
                },
                {
                  "Area": "Srivilliputhur",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 9.6779,
                  "Long": 78.1501
                },
                {
                  "Area": "Srivilliputtur",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 9.6779,
                  "Long": 78.1501
                },
                {
                  "Area": "Srmera",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.2463,
                  "Long": 85.8169
                },
                {
                  "Area": "Srungavarapukota",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 18.1176,
                  "Long": 83.1908
                },
                {
                  "Area": "Ss Kunjpura",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 29.7355,
                  "Long": 77.0093
                },
                {
                  "Area": "Ss Project",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.4998,
                  "Long": 79.3144
                },
                {
                  "Area": "St.Thomas Mount",
                  "State": "Tamil Nadu",
                  "CountryCode": "IN",
                  "Lat": 12.9623,
                  "Long": 80.1986
                },
                {
                  "Area": "Stn. Jadcherla",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.3183,
                  "Long": 78.122
                },
                {
                  "Area": "Stock Exchange",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.5442,
                  "Long": 80.1097
                },
                {
                  "Area": "Sttenapalle",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 16.3719,
                  "Long": 80.1194
                },
                {
                  "Area": "Stuvartpuram",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 15.9228,
                  "Long": 80.4173
                },
                {
                  "Area": "Suar",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 29.1007,
                  "Long": 79.2852
                },
                {
                  "Area": "Sub Tehsil Dhariwal",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 31.9562,
                  "Long": 75.3239
                },
                {
                  "Area": "Subdega",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 22.2889,
                  "Long": 84.9418
                },
                {
                  "Area": "Subdi",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.5034,
                  "Long": 87.9832
                },
                {
                  "Area": "Subhauli",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.3424,
                  "Long": 80.427
                },
                {
                  "Area": "Subled",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.6227,
                  "Long": 80.6873
                },
                {
                  "Area": "Sudhagad",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.8775,
                  "Long": 75.1809
                },
                {
                  "Area": "Sugauli",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.7639,
                  "Long": 84.7434
                },
                {
                  "Area": "Sugnu",
                  "State": "Manipur",
                  "CountryCode": "IN",
                  "Lat": 24.8782,
                  "Long": 93.9796
                },
                {
                  "Area": "Sujangahr",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 28.2395,
                  "Long": 74.4293
                },
                {
                  "Area": "Sujangarh",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 28.5118,
                  "Long": 75.3883
                },
                {
                  "Area": "Sujanpur",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 32.1133,
                  "Long": 77.0822
                },
                {
                  "Area": "Sujanpur Tira",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.9148,
                  "Long": 76.5054
                },
                {
                  "Area": "Sujathanagar",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.5969,
                  "Long": 80.6873
                },
                {
                  "Area": "Sujathanagarq",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 16.9332,
                  "Long": 79.6976
                },
                {
                  "Area": "Sukantanagar",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 24.1597,
                  "Long": 92.0329
                },
                {
                  "Area": "Sukdwani",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.3484,
                  "Long": 88.8997
                },
                {
                  "Area": "Sukhakhola",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 21.9837,
                  "Long": 87.635
                },
                {
                  "Area": "Sukharole",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.4364,
                  "Long": 87.9624
                },
                {
                  "Area": "Suknacherra",
                  "State": "Tripura",
                  "CountryCode": "IN",
                  "Lat": 23.6526,
                  "Long": 91.2372
                },
                {
                  "Area": "Sulatnpur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.3922,
                  "Long": 82.0516
                },
                {
                  "Area": "Sulkaniabad",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.5455,
                  "Long": 88.9366
                },
                {
                  "Area": "Sulkha",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.1266,
                  "Long": 76.5532
                },
                {
                  "Area": "Sullia",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 13.1529,
                  "Long": 76.5854
                },
                {
                  "Area": "Sullurpeta",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.2839,
                  "Long": 80.2193
                },
                {
                  "Area": "Sultanabad",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 18.5497,
                  "Long": 79.2498
                },
                {
                  "Area": "Sultanganj",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.2907,
                  "Long": 87.291
                },
                {
                  "Area": "Sultanpur",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 31.2589,
                  "Long": 75.8756
                },
                {
                  "Area": "Sultanpur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.6066,
                  "Long": 82.3057
                },
                {
                  "Area": "Sultanpur Lodhi",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 31.386,
                  "Long": 75.3491
                },
                {
                  "Area": "Sultanpur Sadar",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.6066,
                  "Long": 82.384
                },
                {
                  "Area": "Sulthan Batheri",
                  "State": "Kerala",
                  "CountryCode": "IN",
                  "Lat": 11.8146,
                  "Long": 76.3694
                },
                {
                  "Area": "Sulthan Bathery",
                  "State": "Kerala",
                  "CountryCode": "IN",
                  "Lat": 11.8146,
                  "Long": 76.2562
                },
                {
                  "Area": "Sulthanbathery",
                  "State": "Kerala",
                  "CountryCode": "IN",
                  "Lat": 11.8278,
                  "Long": 76.3169
                },
                {
                  "Area": "Sulya",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 12.9225,
                  "Long": 75.5273
                },
                {
                  "Area": "Sumbal",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 34.2517,
                  "Long": 74.6259
                },
                {
                  "Area": "Sumer",
                  "State": "Meghalaya",
                  "CountryCode": "IN",
                  "Lat": 25.6019,
                  "Long": 91.9144
                },
                {
                  "Area": "Sumerpur",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 26.3313,
                  "Long": 74.2144
                },
                {
                  "Area": "Sunabeda",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 20.4682,
                  "Long": 83.7161
                },
                {
                  "Area": "Sunadar Pahari",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 25.0351,
                  "Long": 87.405
                },
                {
                  "Area": "Sunam",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 30.2989,
                  "Long": 76.1611
                },
                {
                  "Area": "Sundar Pahari",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 25.0351,
                  "Long": 87.405
                },
                {
                  "Area": "Sundargarh",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 22.0798,
                  "Long": 84.886
                },
                {
                  "Area": "Sundargarh Town",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 21.748,
                  "Long": 84.886
                },
                {
                  "Area": "Sundarnagar",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 22.7288,
                  "Long": 85.7409
                },
                {
                  "Area": "Sundarnagar(T)",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 32.7479,
                  "Long": 77.1103
                },
                {
                  "Area": "Sundarpahari",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 25.0351,
                  "Long": 87.405
                },
                {
                  "Area": "Sundarpur",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.4653,
                  "Long": 88.7803
                },
                {
                  "Area": "Sunder Nagar",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 32.7479,
                  "Long": 77.1103
                },
                {
                  "Area": "Sunder Pahari",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 25.0351,
                  "Long": 87.405
                },
                {
                  "Area": "Sunderbani",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.3788,
                  "Long": 74.7129
                },
                {
                  "Area": "Sundernagar",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.6816,
                  "Long": 77.2482
                },
                {
                  "Area": "Sunderpahari",
                  "State": "Jharkhand",
                  "CountryCode": "IN",
                  "Lat": 24.7943,
                  "Long": 87.477
                },
                {
                  "Area": "Sundersi",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.3311,
                  "Long": 76.4912
                },
                {
                  "Area": "Sundr Nagar",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.6307,
                  "Long": 76.7728
                },
                {
                  "Area": "Sundrah",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.3732,
                  "Long": 76.8881
                },
                {
                  "Area": "Suni",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.3251,
                  "Long": 77.5384
                },
                {
                  "Area": "Sunni",
                  "State": "Himachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 31.2508,
                  "Long": 77.2156
                },
                {
                  "Area": "Sunpura",
                  "State": "Arunachal Pradesh",
                  "CountryCode": "IN",
                  "Lat": 27.8341,
                  "Long": 95.8779
                },
                {
                  "Area": "Supa",
                  "State": "Karnataka",
                  "CountryCode": "IN",
                  "Lat": 15.4124,
                  "Long": 75.3986
                },
                {
                  "Area": "Supaul",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.2477,
                  "Long": 86.9938
                },
                {
                  "Area": "Sur Singh",
                  "State": "Punjab",
                  "CountryCode": "IN",
                  "Lat": 31.4252,
                  "Long": 74.7489
                },
                {
                  "Area": "Surada",
                  "State": "Odisha",
                  "CountryCode": "IN",
                  "Lat": 19.9776,
                  "Long": 84.8241
                },
                {
                  "Area": "Suradi",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.5004,
                  "Long": 91.4784
                },
                {
                  "Area": "Surajgaraha",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.2368,
                  "Long": 86.1921
                },
                {
                  "Area": "Surajgarh",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 28.3505,
                  "Long": 75.9055
                },
                {
                  "Area": "Surajgarha",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.2778,
                  "Long": 86.4276
                },
                {
                  "Area": "Surajpur",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 23.3592,
                  "Long": 83.2194
                },
                {
                  "Area": "Surajpura",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 25.2586,
                  "Long": 84.2255
                },
                {
                  "Area": "Suraryan",
                  "State": "Jammu & Kashmir",
                  "CountryCode": "IN",
                  "Lat": 33.8072,
                  "Long": 74.8689
                },
                {
                  "Area": "Surat",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 23.1064,
                  "Long": 73.2555
                },
                {
                  "Area": "Surat City",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 23.1064,
                  "Long": 73.2309
                },
                {
                  "Area": "Suratgarh",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 29.3955,
                  "Long": 75.5212
                },
                {
                  "Area": "Surethi",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.3498,
                  "Long": 76.5026
                },
                {
                  "Area": "Sureti Kalan",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.3955,
                  "Long": 75.9426
                },
                {
                  "Area": "Surgana",
                  "State": "Maharashtra",
                  "CountryCode": "IN",
                  "Lat": 20.5596,
                  "Long": 75.1496
                },
                {
                  "Area": "Surguja",
                  "State": "Chattisgarh",
                  "CountryCode": "IN",
                  "Lat": 24.034,
                  "Long": 83.7258
                },
                {
                  "Area": "Suri - I",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.9536,
                  "Long": 87.8073
                },
                {
                  "Area": "Suri - II",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.6854,
                  "Long": 87.7386
                },
                {
                  "Area": "Suria",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.8409,
                  "Long": 88.5552
                },
                {
                  "Area": "Sursand",
                  "State": "Bihar",
                  "CountryCode": "IN",
                  "Lat": 26.6186,
                  "Long": 85.8726
                },
                {
                  "Area": "Survepalli",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.3536,
                  "Long": 79.9969
                },
                {
                  "Area": "Suryap[et",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.1266,
                  "Long": 79.4441
                },
                {
                  "Area": "Suryapet",
                  "State": "Telangana",
                  "CountryCode": "IN",
                  "Lat": 17.4396,
                  "Long": 79.9468
                },
                {
                  "Area": "Susner",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.9467,
                  "Long": 76.3631
                },
                {
                  "Area": "Susunia",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.3564,
                  "Long": 87.8021
                },
                {
                  "Area": "Sutahata",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 22.187,
                  "Long": 88.1375
                },
                {
                  "Area": "Suthalia",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 23.9982,
                  "Long": 77.1006
                },
                {
                  "Area": "Suthana",
                  "State": "Haryana",
                  "CountryCode": "IN",
                  "Lat": 28.1297,
                  "Long": 76.5558
                },
                {
                  "Area": "Suti - I",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.5917,
                  "Long": 88.2538
                },
                {
                  "Area": "Suti - II",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 24.2503,
                  "Long": 88.6182
                },
                {
                  "Area": "Sutia",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.1406,
                  "Long": 88.5427
                },
                {
                  "Area": "Sutrapada",
                  "State": "Gujarat",
                  "CountryCode": "IN",
                  "Lat": 20.8435,
                  "Long": 70.5479
                },
                {
                  "Area": "Suwasara Mandi",
                  "State": "Madhya Pradesh",
                  "CountryCode": "IN",
                  "Lat": 24.2113,
                  "Long": 75.7528
                },
                {
                  "Area": "Svs",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 27.2053,
                  "Long": 95.0234
                },
                {
                  "Area": "Svs.",
                  "State": "Assam",
                  "CountryCode": "IN",
                  "Lat": 26.45,
                  "Long": 94.0833
                },
                {
                  "Area": "Swaijpur",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.2849,
                  "Long": 80.3556
                },
                {
                  "Area": "Swarup Nagar",
                  "State": "Uttar Pradesh",
                  "CountryCode": "IN",
                  "Lat": 26.5167,
                  "Long": 80.3155
                },
                {
                  "Area": "Swarupnagar",
                  "State": "West Bengal",
                  "CountryCode": "IN",
                  "Lat": 23.1406,
                  "Long": 88.8811
                },
                {
                  "Area": "Swau Padamsingh",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 26.1047,
                  "Long": 71.8791
                },
                {
                  "Area": "Swaupadamsingh",
                  "State": "Rajasthan",
                  "CountryCode": "IN",
                  "Lat": 26.1047,
                  "Long": 71.8791
                },
                {
                  "Area": "Sydapuram",
                  "State": "Andhra Pradesh",
                  "CountryCode": "IN",
                  "Lat": 14.4268,
                  "Long": 79.7617
                },
                {
                  "Area": "Qairouan",
                  "Lat": "35.6804",
                  "Long": "10.1",
                  "CountryCode": "TN"
                },
                {
                  "Area": "Qal at Bishah",
                  "Lat": "20.0087",
                  "Long": "42.5987",
                  "CountryCode": "SA"
                },
                {
                  "Area": "Qaraghandy",
                  "Lat": "49.885",
                  "Long": "73.115",
                  "CountryCode": "KZ"
                },
                {
                  "Area": "Qarshi",
                  "Lat": "38.8704",
                  "Long": "65.8",
                  "CountryCode": "UZ"
                },
                {
                  "Area": "Qasserine",
                  "Lat": "35.1804",
                  "Long": "8.83",
                  "CountryCode": "TN"
                },
                {
                  "Area": "Qazvin",
                  "Lat": "36.27",
                  "Long": "50",
                  "CountryCode": "IR"
                },
                {
                  "Area": "Qena",
                  "Lat": "26.1505",
                  "Long": "32.72",
                  "CountryCode": "EG"
                },
                {
                  "Area": "Qingan",
                  "Lat": "46.8719",
                  "Long": "127.5118",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Qingdao",
                  "Lat": "36.09",
                  "Long": "120.33",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Qinggang",
                  "Lat": "46.69",
                  "Long": "126.1",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Qingyuan",
                  "Lat": "23.7004",
                  "Long": "113.0301",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Qinhuangdao",
                  "Lat": "39.9304",
                  "Long": "119.62",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Qinzhou",
                  "Lat": "21.9504",
                  "Long": "108.62",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Qiqihar",
                  "Lat": "47.345",
                  "Long": "123.99",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Qitaihe",
                  "Lat": "45.8",
                  "Long": "130.85",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Qom",
                  "Lat": "34.65",
                  "Long": "50.95",
                  "CountryCode": "IR"
                },
                {
                  "Area": "Qomsheh",
                  "Lat": "32.0115",
                  "Long": "51.8597",
                  "CountryCode": "IR"
                },
                {
                  "Area": "Qoqon",
                  "Lat": "40.5404",
                  "Long": "70.94",
                  "CountryCode": "UZ"
                },
                {
                  "Area": "Quảng Ngãi",
                  "Lat": "15.1504",
                  "Long": "108.83",
                  "CountryCode": "VN"
                },
                {
                  "Area": "Quảng Trị",
                  "Lat": "16.7504",
                  "Long": "107.2",
                  "CountryCode": "VN"
                },
                {
                  "Area": "Quanzhou",
                  "Lat": "24.9",
                  "Long": "118.58",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Quchan",
                  "Lat": "37.1118",
                  "Long": "58.5015",
                  "CountryCode": "IR"
                },
                {
                  "Area": "Québec",
                  "Lat": "46.84",
                  "Long": "-71.2456",
                  "CountryCode": "CA"
                },
                {
                  "Area": "Queens",
                  "Lat": "40.7498",
                  "Long": "-73.7976",
                  "CountryCode": "US"
                },
                {
                  "Area": "Queenstown",
                  "Lat": "-31.8996",
                  "Long": "26.88",
                  "CountryCode": "ZA"
                },
                {
                  "Area": "Quelimane",
                  "Lat": "-17.88",
                  "Long": "36.89",
                  "CountryCode": "MZ"
                },
                {
                  "Area": "Querétaro",
                  "Lat": "20.63",
                  "Long": "-100.38",
                  "CountryCode": "MX"
                },
                {
                  "Area": "Quetta",
                  "Lat": "30.22",
                  "Long": "67.025",
                  "CountryCode": "PK"
                },
                {
                  "Area": "Quetzaltenango",
                  "Lat": "14.83",
                  "Long": "-91.52",
                  "CountryCode": "GT"
                },
                {
                  "Area": "Quezon City",
                  "Lat": "14.6504",
                  "Long": "121.03",
                  "CountryCode": "PH"
                },
                {
                  "Area": "Qui Nhon",
                  "Lat": "13.78",
                  "Long": "109.18",
                  "CountryCode": "VN"
                },
                {
                  "Area": "Quibdó",
                  "Lat": "5.6904",
                  "Long": "-76.66",
                  "CountryCode": "CO"
                },
                {
                  "Area": "Quillacollo",
                  "Lat": "-17.4",
                  "Long": "-66.28",
                  "CountryCode": "BO"
                },
                {
                  "Area": "Quillota",
                  "Lat": "-32.88",
                  "Long": "-71.26",
                  "CountryCode": "CL"
                },
                {
                  "Area": "Quincy",
                  "Lat": "42.2516",
                  "Long": "-71.0183",
                  "CountryCode": "US"
                },
                {
                  "Area": "Quito",
                  "Lat": "-0.215",
                  "Long": "-78.5001",
                  "CountryCode": "EC"
                },
                {
                  "Area": "Qunghirot",
                  "Lat": "43.0704",
                  "Long": "58.9",
                  "CountryCode": "UZ"
                },
                {
                  "Area": "Qurghonteppa",
                  "Lat": "37.8373",
                  "Long": "68.7713",
                  "CountryCode": "TJ"
                },
                {
                  "Area": "Quzhou",
                  "Lat": "28.9704",
                  "Long": "118.87",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Qyzylorda",
                  "Lat": "44.8",
                  "Long": "65.465",
                  "CountryCode": "KZ"
                },
                {
                  "Area": "Raba",
                  "Lat": "-8.45",
                  "Long": "118.7666",
                  "CountryCode": "ID"
                },
                {
                  "Area": "Rabat",
                  "Lat": "34.0253",
                  "Long": "-6.8361",
                  "CountryCode": "MA"
                },
                {
                  "Area": "Rạch Giá",
                  "Lat": "10.0154",
                  "Long": "105.0914",
                  "CountryCode": "VN"
                },
                {
                  "Area": "Racine",
                  "Lat": "42.7274",
                  "Long": "-87.8135",
                  "CountryCode": "US"
                },
                {
                  "Area": "Rafaela",
                  "Lat": "-31.25",
                  "Long": "-61.5",
                  "CountryCode": "AR"
                },
                {
                  "Area": "Rafha",
                  "Lat": "29.6202",
                  "Long": "43.4948",
                  "CountryCode": "SA"
                },
                {
                  "Area": "Ragusa",
                  "Lat": "36.93",
                  "Long": "14.73",
                  "CountryCode": "IT"
                },
                {
                  "Area": "Rahim Yar Khan",
                  "Lat": "28.4202",
                  "Long": "70.2952",
                  "CountryCode": "PK"
                },
                {
                  "Area": "Rajshahi",
                  "Lat": "24.375",
                  "Long": "88.605",
                  "CountryCode": "BD"
                },
                {
                  "Area": "Raleigh",
                  "Lat": "35.8323",
                  "Long": "-78.6439",
                  "CountryCode": "US"
                },
                {
                  "Area": "Ramla",
                  "Lat": "31.9167",
                  "Long": "34.8667",
                  "CountryCode": "IL"
                },
                {
                  "Area": "Rancagua",
                  "Lat": "-34.17",
                  "Long": "-70.74",
                  "CountryCode": "CL"
                },
                {
                  "Area": "Rancho Cordova",
                  "Lat": "38.5739",
                  "Long": "-121.2521",
                  "CountryCode": "US"
                },
                {
                  "Area": "Rancho Cucamonga",
                  "Lat": "34.1247",
                  "Long": "-117.5664",
                  "CountryCode": "US"
                },
                {
                  "Area": "Rangoon",
                  "Lat": "16.7834",
                  "Long": "96.1667",
                  "CountryCode": "MM"
                },
                {
                  "Area": "Rangpur",
                  "Lat": "25.75",
                  "Long": "89.28",
                  "CountryCode": "BD"
                },
                {
                  "Area": "Rapid City",
                  "Lat": "44.0716",
                  "Long": "-103.2205",
                  "CountryCode": "US"
                },
                {
                  "Area": "Ras al Khaymah",
                  "Lat": "25.7915",
                  "Long": "55.9428",
                  "CountryCode": "AE"
                },
                {
                  "Area": "Rashid",
                  "Lat": "31.4604",
                  "Long": "30.39",
                  "CountryCode": "EG"
                },
                {
                  "Area": "Rasht",
                  "Lat": "37.3",
                  "Long": "49.63",
                  "CountryCode": "IR"
                },
                {
                  "Area": "Ratchaburi",
                  "Lat": "13.5419",
                  "Long": "99.8215",
                  "CountryCode": "TH"
                },
                {
                  "Area": "Ravenna",
                  "Lat": "44.4204",
                  "Long": "12.22",
                  "CountryCode": "IT"
                },
                {
                  "Area": "Rawalpindi",
                  "Lat": "33.6",
                  "Long": "73.04",
                  "CountryCode": "PK"
                },
                {
                  "Area": "Reading",
                  "Lat": "51.47",
                  "Long": "-0.98",
                  "CountryCode": "GB"
                },
                {
                  "Area": "Reading",
                  "Lat": "40.34",
                  "Long": "-75.9266",
                  "CountryCode": "US"
                },
                {
                  "Area": "Recife",
                  "Lat": "-8.0756",
                  "Long": "-34.9156",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Reconquista",
                  "Lat": "-29.1395",
                  "Long": "-59.65",
                  "CountryCode": "AR"
                },
                {
                  "Area": "Red Deer",
                  "Lat": "52.2666",
                  "Long": "-113.8",
                  "CountryCode": "CA"
                },
                {
                  "Area": "Redding",
                  "Lat": "40.5698",
                  "Long": "-122.365",
                  "CountryCode": "US"
                },
                {
                  "Area": "Redlands",
                  "Lat": "34.0512",
                  "Long": "-117.171",
                  "CountryCode": "US"
                },
                {
                  "Area": "Redmond",
                  "Lat": "47.6762",
                  "Long": "-122.1166",
                  "CountryCode": "US"
                },
                {
                  "Area": "Redondo Beach",
                  "Lat": "33.8574",
                  "Long": "-118.3766",
                  "CountryCode": "US"
                },
                {
                  "Area": "Redwood City",
                  "Lat": "37.5026",
                  "Long": "-122.2252",
                  "CountryCode": "US"
                },
                {
                  "Area": "Regensburg",
                  "Lat": "49.0204",
                  "Long": "12.12",
                  "CountryCode": "DE"
                },
                {
                  "Area": "Reggio di Calabria",
                  "Lat": "38.115",
                  "Long": "15.6414",
                  "CountryCode": "IT"
                },
                {
                  "Area": "Regina",
                  "Lat": "50.45",
                  "Long": "-104.617",
                  "CountryCode": "CA"
                },
                {
                  "Area": "Registro",
                  "Lat": "-24.49",
                  "Long": "-47.84",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Reims",
                  "Lat": "49.2504",
                  "Long": "4.03",
                  "CountryCode": "FR"
                },
                {
                  "Area": "Rennes",
                  "Lat": "48.1",
                  "Long": "-1.67",
                  "CountryCode": "FR"
                },
                {
                  "Area": "Reno",
                  "Lat": "39.5497",
                  "Long": "-119.8483",
                  "CountryCode": "US"
                },
                {
                  "Area": "Renton",
                  "Lat": "47.4758",
                  "Long": "-122.1905",
                  "CountryCode": "US"
                },
                {
                  "Area": "Resistencia",
                  "Lat": "-27.46",
                  "Long": "-58.99",
                  "CountryCode": "AR"
                },
                {
                  "Area": "Reșița",
                  "Lat": "45.297",
                  "Long": "21.8865",
                  "CountryCode": "RO"
                },
                {
                  "Area": "Revere",
                  "Lat": "42.4191",
                  "Long": "-71.0035",
                  "CountryCode": "US"
                },
                {
                  "Area": "Reykjavík",
                  "Lat": "64.15",
                  "Long": "-21.95",
                  "CountryCode": "IS"
                },
                {
                  "Area": "Reynosa",
                  "Lat": "26.08",
                  "Long": "-98.3",
                  "CountryCode": "MX"
                },
                {
                  "Area": "Rialto",
                  "Lat": "34.1128",
                  "Long": "-117.3885",
                  "CountryCode": "US"
                },
                {
                  "Area": "Ribeirão Preto",
                  "Lat": "-21.17",
                  "Long": "-47.83",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Riberalta",
                  "Lat": "-10.983",
                  "Long": "-66.1",
                  "CountryCode": "BO"
                },
                {
                  "Area": "Richardson",
                  "Lat": "32.9717",
                  "Long": "-96.7092",
                  "CountryCode": "US"
                },
                {
                  "Area": "Richland",
                  "Lat": "46.2826",
                  "Long": "-119.2938",
                  "CountryCode": "US"
                },
                {
                  "Area": "Richmond",
                  "Lat": "37.5295",
                  "Long": "-77.4756",
                  "CountryCode": "US"
                },
                {
                  "Area": "Richmond",
                  "Lat": "37.9477",
                  "Long": "-122.339",
                  "CountryCode": "US"
                },
                {
                  "Area": "Ridder",
                  "Lat": "50.3554",
                  "Long": "83.5149",
                  "CountryCode": "KZ"
                },
                {
                  "Area": "Riga",
                  "Lat": "56.95",
                  "Long": "24.1",
                  "CountryCode": "LV"
                },
                {
                  "Area": "Rijeka",
                  "Lat": "45.33",
                  "Long": "14.45",
                  "CountryCode": "HR"
                },
                {
                  "Area": "Rimnicu Vilcea",
                  "Lat": "45.11",
                  "Long": "24.383",
                  "CountryCode": "RO"
                },
                {
                  "Area": "Rio Branco",
                  "Lat": "-9.9666",
                  "Long": "-67.8",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Rio Claro",
                  "Lat": "-22.41",
                  "Long": "-47.56",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Río Cuarto",
                  "Lat": "-33.13",
                  "Long": "-64.35",
                  "CountryCode": "AR"
                },
                {
                  "Area": "Rio de Janeiro",
                  "Lat": "-22.925",
                  "Long": "-43.225",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Río Gallegos",
                  "Lat": "-51.6333",
                  "Long": "-69.2166",
                  "CountryCode": "AR"
                },
                {
                  "Area": "Rio Grande",
                  "Lat": "-32.0495",
                  "Long": "-52.12",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Rio Largo",
                  "Lat": "-9.48",
                  "Long": "-35.84",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Rio Negro",
                  "Lat": "-26.1",
                  "Long": "-49.79",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Rio Rancho",
                  "Lat": "35.2872",
                  "Long": "-106.6981",
                  "CountryCode": "US"
                },
                {
                  "Area": "Río Tercero",
                  "Lat": "-32.1796",
                  "Long": "-64.12",
                  "CountryCode": "AR"
                },
                {
                  "Area": "Rio Verde",
                  "Lat": "21.93",
                  "Long": "-99.98",
                  "CountryCode": "MX"
                },
                {
                  "Area": "Riobamba",
                  "Lat": "-1.67",
                  "Long": "-78.65",
                  "CountryCode": "EC"
                },
                {
                  "Area": "Riohacha",
                  "Lat": "11.5403",
                  "Long": "-72.91",
                  "CountryCode": "CO"
                },
                {
                  "Area": "Rivera",
                  "Lat": "-30.8996",
                  "Long": "-55.56",
                  "CountryCode": "UY"
                },
                {
                  "Area": "Riverside",
                  "Lat": "33.9381",
                  "Long": "-117.3948",
                  "CountryCode": "US"
                },
                {
                  "Area": "Rivne",
                  "Lat": "50.6166",
                  "Long": "26.2528",
                  "CountryCode": "UA"
                },
                {
                  "Area": "Riyadh",
                  "Lat": "24.6408",
                  "Long": "46.7727",
                  "CountryCode": "SA"
                },
                {
                  "Area": "Rize",
                  "Lat": "41.0208",
                  "Long": "40.5219",
                  "CountryCode": "TR"
                },
                {
                  "Area": "Rizhao",
                  "Lat": "35.4304",
                  "Long": "119.45",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Roanne",
                  "Lat": "46.0333",
                  "Long": "4.0667",
                  "CountryCode": "FR"
                },
                {
                  "Area": "Roanoke",
                  "Lat": "37.2785",
                  "Long": "-79.958",
                  "CountryCode": "US"
                },
                {
                  "Area": "Rochester",
                  "Lat": "43.168",
                  "Long": "-77.6162",
                  "CountryCode": "US"
                },
                {
                  "Area": "Rochester",
                  "Lat": "44.0151",
                  "Long": "-92.4778",
                  "CountryCode": "US"
                },
                {
                  "Area": "Rochester Hills",
                  "Lat": "42.6645",
                  "Long": "-83.1563",
                  "CountryCode": "US"
                },
                {
                  "Area": "Rock Hill",
                  "Lat": "34.9413",
                  "Long": "-81.025",
                  "CountryCode": "US"
                },
                {
                  "Area": "Rockford",
                  "Lat": "42.2598",
                  "Long": "-89.0641",
                  "CountryCode": "US"
                },
                {
                  "Area": "Rockhampton",
                  "Lat": "-23.3639",
                  "Long": "150.52",
                  "CountryCode": "AU"
                },
                {
                  "Area": "Rocklin",
                  "Lat": "38.8075",
                  "Long": "-121.2488",
                  "CountryCode": "US"
                },
                {
                  "Area": "Rockville",
                  "Lat": "39.0834",
                  "Long": "-77.1553",
                  "CountryCode": "US"
                },
                {
                  "Area": "Rocky Mount",
                  "Lat": "35.9676",
                  "Long": "-77.8047",
                  "CountryCode": "US"
                },
                {
                  "Area": "Rodos",
                  "Lat": "36.4412",
                  "Long": "28.2225",
                  "CountryCode": "GR"
                },
                {
                  "Area": "Rogers",
                  "Lat": "36.3173",
                  "Long": "-94.1514",
                  "CountryCode": "US"
                },
                {
                  "Area": "Rome",
                  "Lat": "41.896",
                  "Long": "12.4833",
                  "CountryCode": "IT"
                },
                {
                  "Area": "Rome",
                  "Lat": "34.2662",
                  "Long": "-85.1862",
                  "CountryCode": "US"
                },
                {
                  "Area": "Rondonópolis",
                  "Lat": "-16.4695",
                  "Long": "-54.64",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Rongzhag",
                  "Lat": "30.9504",
                  "Long": "101.9167",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Rosario",
                  "Lat": "-32.9511",
                  "Long": "-60.6663",
                  "CountryCode": "AR"
                },
                {
                  "Area": "Rosemead",
                  "Lat": "34.0688",
                  "Long": "-118.0823",
                  "CountryCode": "US"
                },
                {
                  "Area": "Rosenheim",
                  "Lat": "47.8503",
                  "Long": "12.1333",
                  "CountryCode": "DE"
                },
                {
                  "Area": "Roseville",
                  "Lat": "38.7691",
                  "Long": "-121.3178",
                  "CountryCode": "US"
                },
                {
                  "Area": "Roslavl",
                  "Lat": "53.9509",
                  "Long": "32.8604",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Rostock",
                  "Lat": "54.0704",
                  "Long": "12.15",
                  "CountryCode": "DE"
                },
                {
                  "Area": "Rostov",
                  "Lat": "47.2346",
                  "Long": "39.7127",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Roswell",
                  "Lat": "34.0391",
                  "Long": "-84.3513",
                  "CountryCode": "US"
                },
                {
                  "Area": "Rotorua",
                  "Lat": "-38.1317",
                  "Long": "176.2483",
                  "CountryCode": "NZ"
                },
                {
                  "Area": "Rotterdam",
                  "Lat": "51.92",
                  "Long": "4.48",
                  "CountryCode": "NL"
                },
                {
                  "Area": "Rouen",
                  "Lat": "49.4304",
                  "Long": "1.08",
                  "CountryCode": "FR"
                },
                {
                  "Area": "Round Lake Beach",
                  "Lat": "42.3791",
                  "Long": "-88.0811",
                  "CountryCode": "US"
                },
                {
                  "Area": "Round Rock",
                  "Lat": "30.5252",
                  "Long": "-97.6659",
                  "CountryCode": "US"
                },
                {
                  "Area": "Rowlett",
                  "Lat": "32.9156",
                  "Long": "-96.5488",
                  "CountryCode": "US"
                },
                {
                  "Area": "Roxas",
                  "Lat": "11.5853",
                  "Long": "122.7511",
                  "CountryCode": "PH"
                },
                {
                  "Area": "Royal Oak",
                  "Lat": "42.5084",
                  "Long": "-83.1539",
                  "CountryCode": "US"
                },
                {
                  "Area": "Rubtsovsk",
                  "Lat": "51.52",
                  "Long": "81.21",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Rudny",
                  "Lat": "52.9527",
                  "Long": "63.13",
                  "CountryCode": "KZ"
                },
                {
                  "Area": "Ruhengeri",
                  "Lat": "-1.4996",
                  "Long": "29.63",
                  "CountryCode": "RW"
                },
                {
                  "Area": "Rundu",
                  "Lat": "-17.92",
                  "Long": "19.7499",
                  "CountryCode": "NA"
                },
                {
                  "Area": "Ruse",
                  "Lat": "43.8537",
                  "Long": "25.9733",
                  "CountryCode": "BG"
                },
                {
                  "Area": "Rustavi",
                  "Lat": "41.5704",
                  "Long": "45.05",
                  "CountryCode": "GE"
                },
                {
                  "Area": "Rustenburg",
                  "Lat": "-25.65",
                  "Long": "27.24",
                  "CountryCode": "ZA"
                },
                {
                  "Area": "Ruteng",
                  "Lat": "-8.6118",
                  "Long": "120.4698",
                  "CountryCode": "ID"
                },
                {
                  "Area": "Ryazan",
                  "Lat": "54.62",
                  "Long": "39.72",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Rybinsk",
                  "Lat": "58.0503",
                  "Long": "38.82",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Rzeszów",
                  "Lat": "50.0705",
                  "Long": "22",
                  "CountryCode": "PL"
                },
                {
                  "Area": "Rzhev",
                  "Lat": "56.2574",
                  "Long": "34.3275",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Saarbrücken",
                  "Lat": "49.2504",
                  "Long": "6.97",
                  "CountryCode": "DE"
                },
                {
                  "Area": "Sabanalarga",
                  "Lat": "10.64",
                  "Long": "-74.92",
                  "CountryCode": "CO"
                },
                {
                  "Area": "Sabha",
                  "Lat": "27.0333",
                  "Long": "14.4333",
                  "CountryCode": "LY"
                },
                {
                  "Area": "Sabzewar",
                  "Lat": "36.22",
                  "Long": "57.63",
                  "CountryCode": "IR"
                },
                {
                  "Area": "Sacramento",
                  "Lat": "38.5667",
                  "Long": "-121.4683",
                  "CountryCode": "US"
                },
                {
                  "Area": "Sadah",
                  "Lat": "16.9398",
                  "Long": "43.8498",
                  "CountryCode": "YE"
                },
                {
                  "Area": "Sadiqabad",
                  "Lat": "28.3006",
                  "Long": "70.1302",
                  "CountryCode": "PK"
                },
                {
                  "Area": "Safi",
                  "Lat": "32.32",
                  "Long": "-9.24",
                  "CountryCode": "MA"
                },
                {
                  "Area": "Sagaing",
                  "Lat": "21.88",
                  "Long": "95.962",
                  "CountryCode": "MM"
                },
                {
                  "Area": "Saginaw",
                  "Lat": "43.4199",
                  "Long": "-83.9501",
                  "CountryCode": "US"
                },
                {
                  "Area": "Sagua la Grande",
                  "Lat": "22.809",
                  "Long": "-80.0711",
                  "CountryCode": "CU"
                },
                {
                  "Area": "Sahiwal",
                  "Lat": "30.6717",
                  "Long": "73.1118",
                  "CountryCode": "PK"
                },
                {
                  "Area": "Saida",
                  "Lat": "33.563",
                  "Long": "35.3688",
                  "CountryCode": "LB"
                },
                {
                  "Area": "Saïda",
                  "Lat": "34.8404",
                  "Long": "0.14",
                  "CountryCode": "DZ"
                },
                {
                  "Area": "Saidpur",
                  "Lat": "25.8004",
                  "Long": "89",
                  "CountryCode": "BD"
                },
                {
                  "Area": "Saidu",
                  "Lat": "34.75",
                  "Long": "72.35",
                  "CountryCode": "PK"
                },
                {
                  "Area": "Saint Augustine",
                  "Lat": "29.8979",
                  "Long": "-81.31",
                  "CountryCode": "US"
                },
                {
                  "Area": "Saint Charles",
                  "Lat": "38.7958",
                  "Long": "-90.5159",
                  "CountryCode": "US"
                },
                {
                  "Area": "Saint Clair Shores",
                  "Lat": "42.4921",
                  "Long": "-82.8957",
                  "CountryCode": "US"
                },
                {
                  "Area": "Saint Cloud",
                  "Lat": "45.5339",
                  "Long": "-94.1719",
                  "CountryCode": "US"
                },
                {
                  "Area": "Saint Cloud",
                  "Lat": "28.2303",
                  "Long": "-81.2849",
                  "CountryCode": "US"
                },
                {
                  "Area": "Saint Gallen",
                  "Lat": "47.423",
                  "Long": "9.362",
                  "CountryCode": "CH"
                },
                {
                  "Area": "Saint George",
                  "Lat": "37.0769",
                  "Long": "-113.577",
                  "CountryCode": "US"
                },
                {
                  "Area": "Saint John",
                  "Lat": "45.267",
                  "Long": "-66.0767",
                  "CountryCode": "CA"
                },
                {
                  "Area": "Saint Joseph",
                  "Lat": "39.7598",
                  "Long": "-94.821",
                  "CountryCode": "US"
                },
                {
                  "Area": "Saint Louis",
                  "Lat": "38.6358",
                  "Long": "-90.2451",
                  "CountryCode": "US"
                },
                {
                  "Area": "Saint Paul",
                  "Lat": "44.9477",
                  "Long": "-93.104",
                  "CountryCode": "US"
                },
                {
                  "Area": "Saint Peters",
                  "Lat": "38.7825",
                  "Long": "-90.6061",
                  "CountryCode": "US"
                },
                {
                  "Area": "Saint Petersburg",
                  "Lat": "27.793",
                  "Long": "-82.6652",
                  "CountryCode": "US"
                },
                {
                  "Area": "Saint-Étienne",
                  "Lat": "45.4304",
                  "Long": "4.38",
                  "CountryCode": "FR"
                },
                {
                  "Area": "Sakakah",
                  "Lat": "30",
                  "Long": "40.1333",
                  "CountryCode": "SA"
                },
                {
                  "Area": "Sakata",
                  "Lat": "38.92",
                  "Long": "139.8501",
                  "CountryCode": "JP"
                },
                {
                  "Area": "Sakhon Nakhon",
                  "Lat": "17.1679",
                  "Long": "104.1479",
                  "CountryCode": "TH"
                },
                {
                  "Area": "Saki",
                  "Lat": "41.1923",
                  "Long": "47.1705",
                  "CountryCode": "AZ"
                },
                {
                  "Area": "Salalah",
                  "Lat": "17.0255",
                  "Long": "54.0852",
                  "CountryCode": "OM"
                },
                {
                  "Area": "Salamanca",
                  "Lat": "20.5704",
                  "Long": "-101.2",
                  "CountryCode": "MX"
                },
                {
                  "Area": "Salamanca",
                  "Lat": "40.9704",
                  "Long": "-5.67",
                  "CountryCode": "ES"
                },
                {
                  "Area": "Salatiga",
                  "Lat": "-7.3095",
                  "Long": "110.4901",
                  "CountryCode": "ID"
                },
                {
                  "Area": "Salavat",
                  "Lat": "53.3703",
                  "Long": "55.93",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Saldanha",
                  "Lat": "-33.01",
                  "Long": "17.93",
                  "CountryCode": "ZA"
                },
                {
                  "Area": "Salem",
                  "Lat": "44.9232",
                  "Long": "-123.0245",
                  "CountryCode": "US"
                },
                {
                  "Area": "Salerno",
                  "Lat": "40.6804",
                  "Long": "14.7699",
                  "CountryCode": "IT"
                },
                {
                  "Area": "Salima",
                  "Lat": "-13.7829",
                  "Long": "34.4333",
                  "CountryCode": "MW"
                },
                {
                  "Area": "Salina Cruz",
                  "Lat": "16.1671",
                  "Long": "-95.2",
                  "CountryCode": "MX"
                },
                {
                  "Area": "Salinas",
                  "Lat": "36.6881",
                  "Long": "-121.6316",
                  "CountryCode": "US"
                },
                {
                  "Area": "Salisbury",
                  "Lat": "38.3755",
                  "Long": "-75.5867",
                  "CountryCode": "US"
                },
                {
                  "Area": "Salsk",
                  "Lat": "46.4775",
                  "Long": "41.542",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Salt Lake City",
                  "Lat": "40.7774",
                  "Long": "-111.9301",
                  "CountryCode": "US"
                },
                {
                  "Area": "Salta",
                  "Lat": "-24.7834",
                  "Long": "-65.4166",
                  "CountryCode": "AR"
                },
                {
                  "Area": "Saltillo",
                  "Lat": "25.42",
                  "Long": "-101.005",
                  "CountryCode": "MX"
                },
                {
                  "Area": "Salto",
                  "Lat": "-31.3903",
                  "Long": "-57.9687",
                  "CountryCode": "UY"
                },
                {
                  "Area": "Salvador",
                  "Lat": "-12.97",
                  "Long": "-38.48",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Salzburg",
                  "Lat": "47.8105",
                  "Long": "13.04",
                  "CountryCode": "AT"
                },
                {
                  "Area": "Samalut",
                  "Lat": "28.3004",
                  "Long": "30.71",
                  "CountryCode": "EG"
                },
                {
                  "Area": "Samandagi",
                  "Lat": "36.1171",
                  "Long": "35.9333",
                  "CountryCode": "TR"
                },
                {
                  "Area": "Samara",
                  "Lat": "53.195",
                  "Long": "50.1513",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Samarinda",
                  "Lat": "-0.5",
                  "Long": "117.15",
                  "CountryCode": "ID"
                },
                {
                  "Area": "Samarqand",
                  "Lat": "39.67",
                  "Long": "66.945",
                  "CountryCode": "UZ"
                },
                {
                  "Area": "Samarra",
                  "Lat": "34.194",
                  "Long": "43.875",
                  "CountryCode": "IQ"
                },
                {
                  "Area": "Sammamish",
                  "Lat": "47.6019",
                  "Long": "-122.0419",
                  "CountryCode": "US"
                },
                {
                  "Area": "Sampit",
                  "Lat": "-2.5329",
                  "Long": "112.95",
                  "CountryCode": "ID"
                },
                {
                  "Area": "Samsun",
                  "Lat": "41.28",
                  "Long": "36.3437",
                  "CountryCode": "TR"
                },
                {
                  "Area": "Samut Prakan",
                  "Lat": "13.6069",
                  "Long": "100.6115",
                  "CountryCode": "TH"
                },
                {
                  "Area": "Samut Sakhon",
                  "Lat": "13.536",
                  "Long": "100.274",
                  "CountryCode": "TH"
                },
                {
                  "Area": "San Andrés",
                  "Lat": "12.5621",
                  "Long": "-81.6903",
                  "CountryCode": "CO"
                },
                {
                  "Area": "San Angelo",
                  "Lat": "31.4426",
                  "Long": "-100.4501",
                  "CountryCode": "US"
                },
                {
                  "Area": "San Antonio",
                  "Lat": "29.4722",
                  "Long": "-98.5247",
                  "CountryCode": "US"
                },
                {
                  "Area": "San Antonio",
                  "Lat": "-33.5995",
                  "Long": "-71.61",
                  "CountryCode": "CL"
                },
                {
                  "Area": "San Bernardino",
                  "Lat": "34.1412",
                  "Long": "-117.2936",
                  "CountryCode": "US"
                },
                {
                  "Area": "San Bernardo",
                  "Lat": "-33.6",
                  "Long": "-70.7",
                  "CountryCode": "CL"
                },
                {
                  "Area": "San Carlos",
                  "Lat": "9.658",
                  "Long": "-68.59",
                  "CountryCode": "VE"
                },
                {
                  "Area": "San Carlos de Bariloche",
                  "Lat": "-41.15",
                  "Long": "-71.3",
                  "CountryCode": "AR"
                },
                {
                  "Area": "San Carlos del Zulia",
                  "Lat": "9.0104",
                  "Long": "-71.92",
                  "CountryCode": "VE"
                },
                {
                  "Area": "San Clemente",
                  "Lat": "33.4498",
                  "Long": "-117.6103",
                  "CountryCode": "US"
                },
                {
                  "Area": "San Cristóbal",
                  "Lat": "7.77",
                  "Long": "-72.25",
                  "CountryCode": "VE"
                },
                {
                  "Area": "San Cristóbal",
                  "Lat": "18.416",
                  "Long": "-70.109",
                  "CountryCode": "DO"
                },
                {
                  "Area": "San Cristobal de Las Casas",
                  "Lat": "16.75",
                  "Long": "-92.6334",
                  "CountryCode": "MX"
                },
                {
                  "Area": "San Diego",
                  "Lat": "32.8312",
                  "Long": "-117.1226",
                  "CountryCode": "US"
                },
                {
                  "Area": "San Felipe",
                  "Lat": "10.336",
                  "Long": "-68.746",
                  "CountryCode": "VE"
                },
                {
                  "Area": "San Felipe",
                  "Lat": "-32.75",
                  "Long": "-70.72",
                  "CountryCode": "CL"
                },
                {
                  "Area": "San Fernando",
                  "Lat": "10.2805",
                  "Long": "-61.4594",
                  "CountryCode": "TT"
                },
                {
                  "Area": "San Fernando",
                  "Lat": "-34.58",
                  "Long": "-70.99",
                  "CountryCode": "CL"
                },
                {
                  "Area": "San Fernando de Apure",
                  "Lat": "7.9",
                  "Long": "-67.4699",
                  "CountryCode": "VE"
                },
                {
                  "Area": "San Francisco",
                  "Lat": "37.7562",
                  "Long": "-122.443",
                  "CountryCode": "US"
                },
                {
                  "Area": "San Francisco",
                  "Lat": "-31.43",
                  "Long": "-62.09",
                  "CountryCode": "AR"
                },
                {
                  "Area": "San Francisco de Macorís",
                  "Lat": "19.3",
                  "Long": "-70.25",
                  "CountryCode": "DO"
                },
                {
                  "Area": "San Jose",
                  "Lat": "37.3018",
                  "Long": "-121.8485",
                  "CountryCode": "US"
                },
                {
                  "Area": "San José",
                  "Lat": "9.935",
                  "Long": "-84.0841",
                  "CountryCode": "CR"
                },
                {
                  "Area": "San Juan",
                  "Lat": "-31.55",
                  "Long": "-68.52",
                  "CountryCode": "AR"
                },
                {
                  "Area": "San Juan",
                  "Lat": "18.807",
                  "Long": "-71.229",
                  "CountryCode": "DO"
                },
                {
                  "Area": "San Juan De Los Morros",
                  "Lat": "9.901",
                  "Long": "-67.354",
                  "CountryCode": "VE"
                },
                {
                  "Area": "San Juan del Río",
                  "Lat": "20.38",
                  "Long": "-100",
                  "CountryCode": "MX"
                },
                {
                  "Area": "San Leandro",
                  "Lat": "37.7071",
                  "Long": "-122.1601",
                  "CountryCode": "US"
                },
                {
                  "Area": "San Lorenzo",
                  "Lat": "-25.34",
                  "Long": "-57.52",
                  "CountryCode": "PY"
                },
                {
                  "Area": "San Luis",
                  "Lat": "-33.3",
                  "Long": "-66.35",
                  "CountryCode": "AR"
                },
                {
                  "Area": "San Luis",
                  "Lat": "16.2",
                  "Long": "-89.44",
                  "CountryCode": "GT"
                },
                {
                  "Area": "San Luis Obispo",
                  "Lat": "35.2671",
                  "Long": "-120.6689",
                  "CountryCode": "US"
                },
                {
                  "Area": "San Luis Potosí",
                  "Lat": "22.17",
                  "Long": "-101",
                  "CountryCode": "MX"
                },
                {
                  "Area": "San Marcos",
                  "Lat": "33.1349",
                  "Long": "-117.1744",
                  "CountryCode": "US"
                },
                {
                  "Area": "San Marcos",
                  "Lat": "29.8734",
                  "Long": "-97.9382",
                  "CountryCode": "US"
                },
                {
                  "Area": "San Martín",
                  "Lat": "-33.07",
                  "Long": "-68.49",
                  "CountryCode": "AR"
                },
                {
                  "Area": "San Mateo",
                  "Lat": "37.5522",
                  "Long": "-122.3122",
                  "CountryCode": "US"
                },
                {
                  "Area": "San Miguel",
                  "Lat": "13.4833",
                  "Long": "-88.1833",
                  "CountryCode": "SV"
                },
                {
                  "Area": "San Nicolas",
                  "Lat": "-33.33",
                  "Long": "-60.24",
                  "CountryCode": "AR"
                },
                {
                  "Area": "San Pablo",
                  "Lat": "14.0696",
                  "Long": "121.3226",
                  "CountryCode": "PH"
                },
                {
                  "Area": "San Pedro",
                  "Lat": "-24.2196",
                  "Long": "-64.87",
                  "CountryCode": "AR"
                },
                {
                  "Area": "San Pedro de las Colonias",
                  "Lat": "25.7592",
                  "Long": "-102.9827",
                  "CountryCode": "MX"
                },
                {
                  "Area": "San Pedro de Macorís",
                  "Lat": "18.4504",
                  "Long": "-69.3",
                  "CountryCode": "DO"
                },
                {
                  "Area": "San Pedro Sula",
                  "Lat": "15.5",
                  "Long": "-88.03",
                  "CountryCode": "HN"
                },
                {
                  "Area": "San Rafael",
                  "Lat": "-34.6",
                  "Long": "-68.3333",
                  "CountryCode": "AR"
                },
                {
                  "Area": "San Rafael",
                  "Lat": "37.9905",
                  "Long": "-122.5222",
                  "CountryCode": "US"
                },
                {
                  "Area": "San Ramon",
                  "Lat": "37.7625",
                  "Long": "-121.9365",
                  "CountryCode": "US"
                },
                {
                  "Area": "San Ramón de la Nueva Orán",
                  "Lat": "-23.14",
                  "Long": "-64.32",
                  "CountryCode": "AR"
                },
                {
                  "Area": "San Salvador",
                  "Lat": "13.71",
                  "Long": "-89.203",
                  "CountryCode": "SV"
                },
                {
                  "Area": "San Salvador de Jujuy",
                  "Lat": "-24.1833",
                  "Long": "-65.3",
                  "CountryCode": "AR"
                },
                {
                  "Area": "San Sebastián",
                  "Lat": "43.3204",
                  "Long": "-1.98",
                  "CountryCode": "ES"
                },
                {
                  "Area": "San-Pedro",
                  "Lat": "4.7704",
                  "Long": "-6.64",
                  "CountryCode": "CL"
                },
                {
                  "Area": "Sanaa",
                  "Lat": "15.3547",
                  "Long": "44.2066",
                  "CountryCode": "YE"
                },
                {
                  "Area": "Sanandaj",
                  "Lat": "35.3",
                  "Long": "47.02",
                  "CountryCode": "IR"
                },
                {
                  "Area": "Sancti Spíritus",
                  "Lat": "21.9301",
                  "Long": "-79.4425",
                  "CountryCode": "CU"
                },
                {
                  "Area": "Sandakan",
                  "Lat": "5.843",
                  "Long": "118.108",
                  "CountryCode": "MY"
                },
                {
                  "Area": "Sandy Springs",
                  "Lat": "33.9366",
                  "Long": "-84.3703",
                  "CountryCode": "US"
                },
                {
                  "Area": "Sanford",
                  "Lat": "28.7891",
                  "Long": "-81.2757",
                  "CountryCode": "US"
                },
                {
                  "Area": "Sangolquí",
                  "Lat": "-0.31",
                  "Long": "-78.46",
                  "CountryCode": "EC"
                },
                {
                  "Area": "Şanlıurfa",
                  "Lat": "37.17",
                  "Long": "38.795",
                  "CountryCode": "TR"
                },
                {
                  "Area": "Sanming",
                  "Lat": "26.23",
                  "Long": "117.58",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Santa Ana",
                  "Lat": "33.7366",
                  "Long": "-117.8819",
                  "CountryCode": "US"
                },
                {
                  "Area": "Santa Ana",
                  "Lat": "13.9946",
                  "Long": "-89.5598",
                  "CountryCode": "SV"
                },
                {
                  "Area": "Santa Ana",
                  "Lat": "-13.76",
                  "Long": "-65.58",
                  "CountryCode": "BO"
                },
                {
                  "Area": "Santa Barbara",
                  "Lat": "34.4285",
                  "Long": "-119.7202",
                  "CountryCode": "US"
                },
                {
                  "Area": "Santa Clara",
                  "Lat": "22.4",
                  "Long": "-79.9667",
                  "CountryCode": "CU"
                },
                {
                  "Area": "Santa Clara",
                  "Lat": "37.3646",
                  "Long": "-121.9679",
                  "CountryCode": "US"
                },
                {
                  "Area": "Santa Clarita",
                  "Lat": "34.4155",
                  "Long": "-118.4992",
                  "CountryCode": "US"
                },
                {
                  "Area": "Santa Cruz",
                  "Lat": "-17.7539",
                  "Long": "-63.226",
                  "CountryCode": "BO"
                },
                {
                  "Area": "Santa Cruz",
                  "Lat": "36.9788",
                  "Long": "-122.0346",
                  "CountryCode": "US"
                },
                {
                  "Area": "Santa Cruz de Tenerife",
                  "Lat": "28.47",
                  "Long": "-16.25",
                  "CountryCode": "ES"
                },
                {
                  "Area": "Santa Cruz do Sul",
                  "Lat": "-29.71",
                  "Long": "-52.44",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Santa Fe",
                  "Lat": "-31.6239",
                  "Long": "-60.69",
                  "CountryCode": "AR"
                },
                {
                  "Area": "Santa Fe",
                  "Lat": "35.6619",
                  "Long": "-105.9819",
                  "CountryCode": "US"
                },
                {
                  "Area": "Santa Inês",
                  "Lat": "-3.66",
                  "Long": "-45.39",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Santa Maria",
                  "Lat": "-29.6833",
                  "Long": "-53.8",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Santa Maria",
                  "Lat": "34.9333",
                  "Long": "-120.4432",
                  "CountryCode": "US"
                },
                {
                  "Area": "Santa Marta",
                  "Lat": "11.2472",
                  "Long": "-74.2017",
                  "CountryCode": "CO"
                },
                {
                  "Area": "Santa Monica",
                  "Lat": "34.0232",
                  "Long": "-118.4813",
                  "CountryCode": "US"
                },
                {
                  "Area": "Santa Rosa",
                  "Lat": "38.4465",
                  "Long": "-122.706",
                  "CountryCode": "US"
                },
                {
                  "Area": "Santa Rosa",
                  "Lat": "-36.62",
                  "Long": "-64.3",
                  "CountryCode": "AR"
                },
                {
                  "Area": "Santa Rosa",
                  "Lat": "-27.8695",
                  "Long": "-54.46",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Santana do Livramento",
                  "Lat": "-30.88",
                  "Long": "-55.53",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Santander",
                  "Lat": "43.3805",
                  "Long": "-3.8",
                  "CountryCode": "ES"
                },
                {
                  "Area": "Santarém",
                  "Lat": "-2.4333",
                  "Long": "-54.7",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Santee",
                  "Lat": "32.8555",
                  "Long": "-116.9856",
                  "CountryCode": "US"
                },
                {
                  "Area": "Santiago",
                  "Lat": "-33.45",
                  "Long": "-70.667",
                  "CountryCode": "CL"
                },
                {
                  "Area": "Santiago",
                  "Lat": "19.5",
                  "Long": "-70.67",
                  "CountryCode": "DO"
                },
                {
                  "Area": "Santiago de Compostela",
                  "Lat": "42.8829",
                  "Long": "-8.5411",
                  "CountryCode": "ES"
                },
                {
                  "Area": "Santiago de CU",
                  "Lat": "20.025",
                  "Long": "-75.8213",
                  "CountryCode": "CU"
                },
                {
                  "Area": "Santiago del Estero",
                  "Lat": "-27.7833",
                  "Long": "-64.2667",
                  "CountryCode": "AR"
                },
                {
                  "Area": "Santo André",
                  "Lat": "-23.6528",
                  "Long": "-46.5278",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Santo Ângelo",
                  "Lat": "-28.3",
                  "Long": "-54.28",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Santo Domingo",
                  "Lat": "18.4701",
                  "Long": "-69.9001",
                  "CountryCode": "DO"
                },
                {
                  "Area": "Santos",
                  "Lat": "-23.9537",
                  "Long": "-46.3329",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Sanya",
                  "Lat": "18.2591",
                  "Long": "109.504",
                  "CountryCode": "CN"
                },
                {
                  "Area": "São Borja",
                  "Lat": "-28.6596",
                  "Long": "-56.01",
                  "CountryCode": "BR"
                },
                {
                  "Area": "São Carlos",
                  "Lat": "-22.02",
                  "Long": "-47.89",
                  "CountryCode": "BR"
                },
                {
                  "Area": "São Gabriel",
                  "Lat": "-30.32",
                  "Long": "-54.32",
                  "CountryCode": "BR"
                },
                {
                  "Area": "São João da Boa Vista",
                  "Lat": "-21.98",
                  "Long": "-46.79",
                  "CountryCode": "BR"
                },
                {
                  "Area": "São João del Rei",
                  "Lat": "-21.13",
                  "Long": "-44.25",
                  "CountryCode": "BR"
                },
                {
                  "Area": "São José de Ribamar",
                  "Lat": "-2.55",
                  "Long": "-44.07",
                  "CountryCode": "BR"
                },
                {
                  "Area": "São José do Rio Preto",
                  "Lat": "-20.7996",
                  "Long": "-49.39",
                  "CountryCode": "BR"
                },
                {
                  "Area": "São José dos Campos",
                  "Lat": "-23.2",
                  "Long": "-45.8799",
                  "CountryCode": "BR"
                },
                {
                  "Area": "São José dos Pinhais",
                  "Lat": "-25.57",
                  "Long": "-49.18",
                  "CountryCode": "BR"
                },
                {
                  "Area": "São Luís",
                  "Lat": "-2.516",
                  "Long": "-44.266",
                  "CountryCode": "BR"
                },
                {
                  "Area": "São Mateus",
                  "Lat": "-18.7296",
                  "Long": "-39.86",
                  "CountryCode": "BR"
                },
                {
                  "Area": "São Paulo",
                  "Lat": "-23.5587",
                  "Long": "-46.625",
                  "CountryCode": "BR"
                },
                {
                  "Area": "São Tomé",
                  "Lat": "0.3334",
                  "Long": "6.7333",
                  "CountryCode": "ST"
                },
                {
                  "Area": "Sapele",
                  "Lat": "5.8904",
                  "Long": "5.68",
                  "CountryCode": "NG"
                },
                {
                  "Area": "Sapporo",
                  "Lat": "43.075",
                  "Long": "141.34",
                  "CountryCode": "JP"
                },
                {
                  "Area": "Saraburi",
                  "Lat": "14.5304",
                  "Long": "100.88",
                  "CountryCode": "TH"
                },
                {
                  "Area": "Sarajevo",
                  "Lat": "43.85",
                  "Long": "18.383",
                  "CountryCode": "BA"
                },
                {
                  "Area": "Saransk",
                  "Lat": "54.1704",
                  "Long": "45.18",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Sarapul",
                  "Lat": "56.4791",
                  "Long": "53.7987",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Sarasota",
                  "Lat": "27.3391",
                  "Long": "-82.5439",
                  "CountryCode": "US"
                },
                {
                  "Area": "Saratoga Springs",
                  "Lat": "43.0674",
                  "Long": "-73.7775",
                  "CountryCode": "US"
                },
                {
                  "Area": "Saratov",
                  "Lat": "51.58",
                  "Long": "46.03",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Sargodha",
                  "Lat": "32.0854",
                  "Long": "72.675",
                  "CountryCode": "PK"
                },
                {
                  "Area": "Sarh",
                  "Lat": "9.15",
                  "Long": "18.39",
                  "CountryCode": "TD"
                },
                {
                  "Area": "Sari",
                  "Lat": "36.5504",
                  "Long": "53.1",
                  "CountryCode": "IR"
                },
                {
                  "Area": "Sariwon",
                  "Lat": "38.507",
                  "Long": "125.762",
                  "CountryCode": "KP"
                },
                {
                  "Area": "Sarnia",
                  "Lat": "42.9666",
                  "Long": "-82.4",
                  "CountryCode": "CA"
                },
                {
                  "Area": "Sarqan",
                  "Lat": "45.4203",
                  "Long": "79.9149",
                  "CountryCode": "KZ"
                },
                {
                  "Area": "Sasebo",
                  "Lat": "33.1631",
                  "Long": "129.7177",
                  "CountryCode": "JP"
                },
                {
                  "Area": "Saskatoon",
                  "Lat": "52.17",
                  "Long": "-106.67",
                  "CountryCode": "CA"
                },
                {
                  "Area": "Sassari",
                  "Lat": "40.73",
                  "Long": "8.57",
                  "CountryCode": "IT"
                },
                {
                  "Area": "Satu Mare",
                  "Lat": "47.792",
                  "Long": "22.885",
                  "CountryCode": "RO"
                },
                {
                  "Area": "Savannah",
                  "Lat": "32.0282",
                  "Long": "-81.1786",
                  "CountryCode": "US"
                },
                {
                  "Area": "Savannakhet",
                  "Lat": "16.5376",
                  "Long": "104.773",
                  "CountryCode": "LA"
                },
                {
                  "Area": "Saveh",
                  "Lat": "35.0218",
                  "Long": "50.3314",
                  "CountryCode": "IR"
                },
                {
                  "Area": "Sawahlunto",
                  "Lat": "-0.6663",
                  "Long": "100.7833",
                  "CountryCode": "ID"
                },
                {
                  "Area": "Sayanogorsk",
                  "Lat": "53.0894",
                  "Long": "91.4004",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Saywun",
                  "Lat": "15.943",
                  "Long": "48.7873",
                  "CountryCode": "YE"
                },
                {
                  "Area": "Scarborough",
                  "Lat": "54.2804",
                  "Long": "-0.43",
                  "CountryCode": "GB"
                },
                {
                  "Area": "Schaumburg",
                  "Lat": "42.0307",
                  "Long": "-88.0838",
                  "CountryCode": "US"
                },
                {
                  "Area": "Schenectady",
                  "Lat": "42.8025",
                  "Long": "-73.9276",
                  "CountryCode": "US"
                },
                {
                  "Area": "Schwerin",
                  "Lat": "53.6333",
                  "Long": "11.4167",
                  "CountryCode": "DE"
                },
                {
                  "Area": "Scottsdale",
                  "Lat": "33.6872",
                  "Long": "-111.865",
                  "CountryCode": "US"
                },
                {
                  "Area": "Scranton",
                  "Lat": "41.4044",
                  "Long": "-75.6649",
                  "CountryCode": "US"
                },
                {
                  "Area": "Seaside",
                  "Lat": "36.6224",
                  "Long": "-121.8191",
                  "CountryCode": "US"
                },
                {
                  "Area": "Seattle",
                  "Lat": "47.6211",
                  "Long": "-122.3244",
                  "CountryCode": "US"
                },
                {
                  "Area": "Sebring",
                  "Lat": "27.477",
                  "Long": "-81.453",
                  "CountryCode": "US"
                },
                {
                  "Area": "Sefra",
                  "Lat": "32.7604",
                  "Long": "-0.5799",
                  "CountryCode": "DZ"
                },
                {
                  "Area": "Ségou",
                  "Lat": "13.44",
                  "Long": "-6.26",
                  "CountryCode": "ML"
                },
                {
                  "Area": "Séguéla",
                  "Lat": "7.9504",
                  "Long": "-6.67",
                  "CountryCode": "CL"
                },
                {
                  "Area": "Sekondi",
                  "Lat": "4.9433",
                  "Long": "-1.704",
                  "CountryCode": "GH"
                },
                {
                  "Area": "Semarang",
                  "Lat": "-6.9666",
                  "Long": "110.42",
                  "CountryCode": "ID"
                },
                {
                  "Area": "Semey",
                  "Lat": "50.435",
                  "Long": "80.275",
                  "CountryCode": "KZ"
                },
                {
                  "Area": "Semnan",
                  "Lat": "35.5548",
                  "Long": "53.3743",
                  "CountryCode": "IR"
                },
                {
                  "Area": "Sendai",
                  "Lat": "38.2871",
                  "Long": "141.0217",
                  "CountryCode": "JP"
                },
                {
                  "Area": "Sennar",
                  "Lat": "13.55",
                  "Long": "33.6",
                  "CountryCode": "SD"
                },
                {
                  "Area": "Seoul",
                  "Lat": "37.5663",
                  "Long": "126.9997",
                  "CountryCode": "kr"
                },
                {
                  "Area": "Serang",
                  "Lat": "-6.11",
                  "Long": "106.1496",
                  "CountryCode": "ID"
                },
                {
                  "Area": "Seremban",
                  "Lat": "2.7105",
                  "Long": "101.94",
                  "CountryCode": "MY"
                },
                {
                  "Area": "Seres",
                  "Lat": "41.086",
                  "Long": "23.5497",
                  "CountryCode": "GR"
                },
                {
                  "Area": "Sergiyev Posad",
                  "Lat": "56.33",
                  "Long": "38.17",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Serov",
                  "Lat": "59.615",
                  "Long": "60.585",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Serpukhov",
                  "Lat": "54.9304",
                  "Long": "37.43",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Serrinha",
                  "Lat": "-11.6496",
                  "Long": "-39.01",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Sete Lagoas",
                  "Lat": "-19.4496",
                  "Long": "-44.25",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Sétif",
                  "Lat": "36.18",
                  "Long": "5.4",
                  "CountryCode": "DZ"
                },
                {
                  "Area": "Settat",
                  "Lat": "33.0104",
                  "Long": "-7.62",
                  "CountryCode": "MA"
                },
                {
                  "Area": "Setúbal",
                  "Lat": "38.53",
                  "Long": "-8.9",
                  "CountryCode": "PT"
                },
                {
                  "Area": "Severodvinsk",
                  "Lat": "64.57",
                  "Long": "39.83",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Severomorsk",
                  "Lat": "69.0731",
                  "Long": "33.4231",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Seville",
                  "Lat": "37.405",
                  "Long": "-5.98",
                  "CountryCode": "ES"
                },
                {
                  "Area": "Sfax",
                  "Lat": "34.75",
                  "Long": "10.72",
                  "CountryCode": "TN"
                },
                {
                  "Area": "Sfintu-Gheorghe",
                  "Lat": "45.868",
                  "Long": "25.793",
                  "CountryCode": "RO"
                },
                {
                  "Area": "Shache",
                  "Lat": "38.4261",
                  "Long": "77.25",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Shadrinsk",
                  "Lat": "56.0837",
                  "Long": "63.6333",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Shah Alam",
                  "Lat": "3.0667",
                  "Long": "101.55",
                  "CountryCode": "MY"
                },
                {
                  "Area": "Shahrisabz",
                  "Lat": "39.0618",
                  "Long": "66.8315",
                  "CountryCode": "UZ"
                },
                {
                  "Area": "Shahrud",
                  "Lat": "36.4229",
                  "Long": "54.9629",
                  "CountryCode": "IR"
                },
                {
                  "Area": "Shakhty",
                  "Lat": "47.7204",
                  "Long": "40.27",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Shanghai",
                  "Lat": "31.2165",
                  "Long": "121.4365",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Shangqiu",
                  "Lat": "34.4504",
                  "Long": "115.65",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Shangrao",
                  "Lat": "28.4704",
                  "Long": "117.97",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Shangzhi",
                  "Lat": "45.2204",
                  "Long": "127.97",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Shantou",
                  "Lat": "23.37",
                  "Long": "116.67",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Shanxian",
                  "Lat": "34.7904",
                  "Long": "116.08",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Shaoguan",
                  "Lat": "24.8",
                  "Long": "113.58",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Shaowu",
                  "Lat": "27.3004",
                  "Long": "117.5",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Shaoxing",
                  "Lat": "30.0004",
                  "Long": "120.57",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Shar e Kord",
                  "Lat": "32.321",
                  "Long": "50.854",
                  "CountryCode": "IR"
                },
                {
                  "Area": "Sharjah",
                  "Lat": "25.3714",
                  "Long": "55.4065",
                  "CountryCode": "AE"
                },
                {
                  "Area": "Shashemene",
                  "Lat": "7.2004",
                  "Long": "38.59",
                  "CountryCode": "ET"
                },
                {
                  "Area": "Shashi",
                  "Lat": "30.32",
                  "Long": "112.23",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Shawnee",
                  "Lat": "39.0158",
                  "Long": "-94.8076",
                  "CountryCode": "US"
                },
                {
                  "Area": "Shchekino",
                  "Lat": "54.0143",
                  "Long": "37.5143",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Sheberghan",
                  "Lat": "36.658",
                  "Long": "65.7383",
                  "CountryCode": "AF"
                },
                {
                  "Area": "Sheboygan",
                  "Lat": "43.7447",
                  "Long": "-87.7322",
                  "CountryCode": "US"
                },
                {
                  "Area": "Sheffield",
                  "Lat": "53.3667",
                  "Long": "-1.5",
                  "CountryCode": "GB"
                },
                {
                  "Area": "Sheikhu Pura",
                  "Lat": "31.72",
                  "Long": "73.99",
                  "CountryCode": "PK"
                },
                {
                  "Area": "Shendi",
                  "Lat": "16.6805",
                  "Long": "33.42",
                  "CountryCode": "SD"
                },
                {
                  "Area": "Shenyeng",
                  "Lat": "41.805",
                  "Long": "123.45",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Shenzhen",
                  "Lat": "22.5524",
                  "Long": "114.1221",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Sherbrooke",
                  "Lat": "45.4",
                  "Long": "-71.9",
                  "CountryCode": "CA"
                },
                {
                  "Area": "Sherman",
                  "Lat": "33.6266",
                  "Long": "-96.6195",
                  "CountryCode": "US"
                },
                {
                  "Area": "Shibin el Kom",
                  "Lat": "30.592",
                  "Long": "30.9",
                  "CountryCode": "EG"
                },
                {
                  "Area": "Shihezi",
                  "Lat": "44.3",
                  "Long": "86.0299",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Shijianzhuang",
                  "Lat": "38.05",
                  "Long": "114.48",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Shimonoseki",
                  "Lat": "33.9654",
                  "Long": "130.9454",
                  "CountryCode": "JP"
                },
                {
                  "Area": "Shinyanga",
                  "Lat": "-3.6596",
                  "Long": "33.42",
                  "CountryCode": "TZ"
                },
                {
                  "Area": "Shiraz",
                  "Lat": "29.63",
                  "Long": "52.57",
                  "CountryCode": "IR"
                },
                {
                  "Area": "Shishou",
                  "Lat": "29.7004",
                  "Long": "112.4",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Shiyan",
                  "Lat": "32.57",
                  "Long": "110.78",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Shizuishan",
                  "Lat": "39.2333",
                  "Long": "106.769",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Shizuoka",
                  "Lat": "34.9858",
                  "Long": "138.3854",
                  "CountryCode": "JP"
                },
                {
                  "Area": "Shkodër",
                  "Lat": "42.0685",
                  "Long": "19.5188",
                  "CountryCode": "AL"
                },
                {
                  "Area": "Shoreline",
                  "Lat": "47.7564",
                  "Long": "-122.3426",
                  "CountryCode": "US"
                },
                {
                  "Area": "Shostka",
                  "Lat": "51.8734",
                  "Long": "33.4797",
                  "CountryCode": "UA"
                },
                {
                  "Area": "Shreveport",
                  "Lat": "32.4659",
                  "Long": "-93.7959",
                  "CountryCode": "US"
                },
                {
                  "Area": "Shuangcheng",
                  "Lat": "45.3503",
                  "Long": "126.28",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Shuangyashan",
                  "Lat": "46.6704",
                  "Long": "131.35",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Shulan",
                  "Lat": "44.4091",
                  "Long": "126.9487",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Shumen",
                  "Lat": "43.27",
                  "Long": "26.9294",
                  "CountryCode": "BG"
                },
                {
                  "Area": "Shuozhou",
                  "Lat": "39.3004",
                  "Long": "112.42",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Shuya",
                  "Lat": "56.8543",
                  "Long": "41.3643",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Shuyang",
                  "Lat": "34.1299",
                  "Long": "118.7734",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Shwebo",
                  "Lat": "22.5783",
                  "Long": "95.6929",
                  "CountryCode": "MM"
                },
                {
                  "Area": "Shymkent",
                  "Lat": "42.32",
                  "Long": "69.595",
                  "CountryCode": "KZ"
                },
                {
                  "Area": "Si Racha",
                  "Lat": "13.159",
                  "Long": "100.9287",
                  "CountryCode": "TH"
                },
                {
                  "Area": "Sialkote",
                  "Lat": "32.52",
                  "Long": "74.56",
                  "CountryCode": "PK"
                },
                {
                  "Area": "Šiauliai",
                  "Lat": "55.9386",
                  "Long": "23.325",
                  "CountryCode": "LT"
                },
                {
                  "Area": "Sibay",
                  "Lat": "52.7091",
                  "Long": "58.6387",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Sibiu",
                  "Lat": "45.7971",
                  "Long": "24.1371",
                  "CountryCode": "RO"
                },
                {
                  "Area": "Sibolga",
                  "Lat": "1.75",
                  "Long": "98.8",
                  "CountryCode": "ID"
                },
                {
                  "Area": "Sibu",
                  "Lat": "2.303",
                  "Long": "111.843",
                  "CountryCode": "MY"
                },
                {
                  "Area": "Sidi bel Abbes",
                  "Lat": "35.1903",
                  "Long": "-0.64",
                  "CountryCode": "DZ"
                },
                {
                  "Area": "Siem Reap",
                  "Lat": "13.3666",
                  "Long": "103.85",
                  "CountryCode": "KH"
                },
                {
                  "Area": "Siena",
                  "Lat": "43.317",
                  "Long": "11.35",
                  "CountryCode": "IT"
                },
                {
                  "Area": "Sierra Vista",
                  "Lat": "31.563",
                  "Long": "-110.3153",
                  "CountryCode": "US"
                },
                {
                  "Area": "Siguiri",
                  "Lat": "11.4171",
                  "Long": "-9.1666",
                  "CountryCode": "GN"
                },
                {
                  "Area": "Siirt",
                  "Lat": "37.944",
                  "Long": "41.933",
                  "CountryCode": "TR"
                },
                {
                  "Area": "Sikasso",
                  "Lat": "11.3204",
                  "Long": "-5.68",
                  "CountryCode": "ML"
                },
                {
                  "Area": "Simao",
                  "Lat": "22.7807",
                  "Long": "100.9782",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Simi Valley",
                  "Lat": "34.2663",
                  "Long": "-118.749",
                  "CountryCode": "US"
                },
                {
                  "Area": "Sincelejo",
                  "Lat": "9.2904",
                  "Long": "-75.38",
                  "CountryCode": "CO"
                },
                {
                  "Area": "SG",
                  "Lat": "1.293",
                  "Long": "103.8558",
                  "CountryCode": "SG"
                },
                {
                  "Area": "Singaraja",
                  "Lat": "-8.1152",
                  "Long": "115.0944",
                  "CountryCode": "ID"
                },
                {
                  "Area": "Singida",
                  "Lat": "-4.8196",
                  "Long": "34.74",
                  "CountryCode": "TZ"
                },
                {
                  "Area": "Singkawang",
                  "Lat": "0.912",
                  "Long": "108.9655",
                  "CountryCode": "ID"
                },
                {
                  "Area": "Sinuiju",
                  "Lat": "40.0859",
                  "Long": "124.4213",
                  "CountryCode": "KP"
                },
                {
                  "Area": "Sioux City",
                  "Lat": "42.4959",
                  "Long": "-96.3901",
                  "CountryCode": "US"
                },
                {
                  "Area": "Sioux Falls",
                  "Lat": "43.5397",
                  "Long": "-96.7322",
                  "CountryCode": "US"
                },
                {
                  "Area": "Siping",
                  "Lat": "43.17",
                  "Long": "124.33",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Siracusa",
                  "Lat": "37.0704",
                  "Long": "15.29",
                  "CountryCode": "IT"
                },
                {
                  "Area": "Sirjan",
                  "Lat": "29.47",
                  "Long": "55.73",
                  "CountryCode": "IR"
                },
                {
                  "Area": "Sisophon",
                  "Lat": "13.5838",
                  "Long": "102.9833",
                  "CountryCode": "KH"
                },
                {
                  "Area": "Sittwe",
                  "Lat": "20.14",
                  "Long": "92.88",
                  "CountryCode": "MM"
                },
                {
                  "Area": "Sivas",
                  "Lat": "39.7454",
                  "Long": "37.035",
                  "CountryCode": "TR"
                },
                {
                  "Area": "Skien",
                  "Lat": "59.2",
                  "Long": "9.6",
                  "CountryCode": "NO"
                },
                {
                  "Area": "Skikda",
                  "Lat": "36.8804",
                  "Long": "6.9",
                  "CountryCode": "DZ"
                },
                {
                  "Area": "Skokie",
                  "Lat": "42.0359",
                  "Long": "-87.74",
                  "CountryCode": "US"
                },
                {
                  "Area": "Skopje",
                  "Lat": "42",
                  "Long": "21.4335",
                  "CountryCode": "MK"
                },
                {
                  "Area": "Slatina",
                  "Lat": "44.435",
                  "Long": "24.371",
                  "CountryCode": "RO"
                },
                {
                  "Area": "Slavonski Brod",
                  "Lat": "45.1603",
                  "Long": "18.0156",
                  "CountryCode": "HR"
                },
                {
                  "Area": "Slidell",
                  "Lat": "30.2882",
                  "Long": "-89.7826",
                  "CountryCode": "US"
                },
                {
                  "Area": "Sliven",
                  "Lat": "42.6794",
                  "Long": "26.33",
                  "CountryCode": "BG"
                },
                {
                  "Area": "Slobozia",
                  "Lat": "44.57",
                  "Long": "27.382",
                  "CountryCode": "RO"
                },
                {
                  "Area": "Smolensk",
                  "Lat": "54.7827",
                  "Long": "32.0473",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Smyrna",
                  "Lat": "33.8633",
                  "Long": "-84.5168",
                  "CountryCode": "US"
                },
                {
                  "Area": "Sobral",
                  "Lat": "-3.69",
                  "Long": "-40.35",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Sóc Trăng",
                  "Lat": "9.6037",
                  "Long": "105.98",
                  "CountryCode": "VN"
                },
                {
                  "Area": "Sochi",
                  "Lat": "43.59",
                  "Long": "39.73",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Sodo",
                  "Lat": "6.9",
                  "Long": "37.75",
                  "CountryCode": "ET"
                },
                {
                  "Area": "Sofia",
                  "Lat": "42.6833",
                  "Long": "23.3167",
                  "CountryCode": "BG"
                },
                {
                  "Area": "Sogamoso",
                  "Lat": "5.72",
                  "Long": "-72.94",
                  "CountryCode": "CO"
                },
                {
                  "Area": "Sohag",
                  "Lat": "26.5504",
                  "Long": "31.7",
                  "CountryCode": "EG"
                },
                {
                  "Area": "Sokcho",
                  "Lat": "38.2087",
                  "Long": "128.5912",
                  "CountryCode": "kr"
                },
                {
                  "Area": "Söke",
                  "Lat": "37.7512",
                  "Long": "27.4103",
                  "CountryCode": "TR"
                },
                {
                  "Area": "Sokodé",
                  "Lat": "8.9905",
                  "Long": "1.15",
                  "CountryCode": "TG"
                },
                {
                  "Area": "Sokoto",
                  "Lat": "13.06",
                  "Long": "5.24",
                  "CountryCode": "NG"
                },
                {
                  "Area": "Soledad",
                  "Lat": "10.92",
                  "Long": "-74.77",
                  "CountryCode": "CO"
                },
                {
                  "Area": "Solikamsk",
                  "Lat": "59.67",
                  "Long": "56.75",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Solnechnogorsk",
                  "Lat": "56.1807",
                  "Long": "36.9809",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Solwezi",
                  "Lat": "-12.1796",
                  "Long": "26.4",
                  "CountryCode": "ZM"
                },
                {
                  "Area": "Somerville",
                  "Lat": "42.3908",
                  "Long": "-71.1013",
                  "CountryCode": "US"
                },
                {
                  "Area": "Sơn Tây",
                  "Lat": "21.1382",
                  "Long": "105.505",
                  "CountryCode": "VN"
                },
                {
                  "Area": "Sonbong",
                  "Lat": "42.3377",
                  "Long": "130.4027",
                  "CountryCode": "KP"
                },
                {
                  "Area": "Songea",
                  "Lat": "-10.68",
                  "Long": "35.65",
                  "CountryCode": "TZ"
                },
                {
                  "Area": "Songnam",
                  "Lat": "37.4386",
                  "Long": "127.1378",
                  "CountryCode": "kr"
                },
                {
                  "Area": "Sonsonate",
                  "Lat": "13.72",
                  "Long": "-89.73",
                  "CountryCode": "SV"
                },
                {
                  "Area": "Sorocaba",
                  "Lat": "-23.49",
                  "Long": "-47.47",
                  "CountryCode": "BR"
                },
                {
                  "Area": "Sorong",
                  "Lat": "-0.8554",
                  "Long": "131.285",
                  "CountryCode": "ID"
                },
                {
                  "Area": "Sotik",
                  "Lat": "-0.6796",
                  "Long": "35.12",
                  "CountryCode": "KE"
                },
                {
                  "Area": "Soubré",
                  "Lat": "5.7904",
                  "Long": "-6.61",
                  "CountryCode": "CL"
                },
                {
                  "Area": "Souk Ahras",
                  "Lat": "36.2904",
                  "Long": "7.95",
                  "CountryCode": "DZ"
                },
                {
                  "Area": "Sousse",
                  "Lat": "35.83",
                  "Long": "10.625",
                  "CountryCode": "TN"
                },
                {
                  "Area": "South Bend",
                  "Lat": "41.6771",
                  "Long": "-86.2692",
                  "CountryCode": "US"
                },
                {
                  "Area": "South Gate",
                  "Lat": "33.9447",
                  "Long": "-118.1926",
                  "CountryCode": "US"
                },
                {
                  "Area": "South JO",
                  "Lat": "40.5571",
                  "Long": "-111.9782",
                  "CountryCode": "US"
                },
                {
                  "Area": "South Lyon",
                  "Lat": "42.4614",
                  "Long": "-83.6526",
                  "CountryCode": "US"
                },
                {
                  "Area": "South San Francisco",
                  "Lat": "37.6536",
                  "Long": "-122.4197",
                  "CountryCode": "US"
                },
                {
                  "Area": "Southampton",
                  "Lat": "50.9",
                  "Long": "-1.4",
                  "CountryCode": "GB"
                },
                {
                  "Area": "Southaven",
                  "Lat": "34.9514",
                  "Long": "-89.9787",
                  "CountryCode": "US"
                },
                {
                  "Area": "Southend-on-Sea",
                  "Lat": "51.55",
                  "Long": "0.72",
                  "CountryCode": "GB"
                },
                {
                  "Area": "Southfield",
                  "Lat": "42.4765",
                  "Long": "-83.2605",
                  "CountryCode": "US"
                },
                {
                  "Area": "Soyo",
                  "Lat": "-6.1296",
                  "Long": "12.37",
                  "CountryCode": "AO"
                },
                {
                  "Area": "Spanish Town",
                  "Lat": "17.9833",
                  "Long": "-76.95",
                  "CountryCode": "JM"
                },
                {
                  "Area": "Sparks",
                  "Lat": "39.5729",
                  "Long": "-119.7157",
                  "CountryCode": "US"
                },
                {
                  "Area": "Spartanburg",
                  "Lat": "34.9437",
                  "Long": "-81.9257",
                  "CountryCode": "US"
                },
                {
                  "Area": "Split",
                  "Lat": "43.5204",
                  "Long": "16.47",
                  "CountryCode": "HR"
                },
                {
                  "Area": "Spokane",
                  "Lat": "47.6671",
                  "Long": "-117.433",
                  "CountryCode": "US"
                },
                {
                  "Area": "Spokane Valley",
                  "Lat": "47.6625",
                  "Long": "-117.2346",
                  "CountryCode": "US"
                },
                {
                  "Area": "Springdale",
                  "Lat": "36.1898",
                  "Long": "-94.1573",
                  "CountryCode": "US"
                },
                {
                  "Area": "Springfield",
                  "Lat": "42.1155",
                  "Long": "-72.5395",
                  "CountryCode": "US"
                },
                {
                  "Area": "Springfield",
                  "Lat": "37.1943",
                  "Long": "-93.2915",
                  "CountryCode": "US"
                },
                {
                  "Area": "Springfield",
                  "Lat": "39.7712",
                  "Long": "-89.6539",
                  "CountryCode": "US"
                },
                {
                  "Area": "Springfield",
                  "Lat": "39.9304",
                  "Long": "-83.7961",
                  "CountryCode": "US"
                },
                {
                  "Area": "Springfield",
                  "Lat": "44.0538",
                  "Long": "-122.9811",
                  "CountryCode": "US"
                },
                {
                  "Area": "Springs",
                  "Lat": "-26.2696",
                  "Long": "28.43",
                  "CountryCode": "ZA"
                },
                {
                  "Area": "Sri Jawewardenepura Kotte",
                  "Lat": "6.9",
                  "Long": "79.95",
                  "CountryCode": "LK"
                },
                {
                  "Area": "St. John's",
                  "Lat": "47.585",
                  "Long": "-52.681",
                  "CountryCode": "CA"
                },
                {
                  "Area": "St. Petersburg",
                  "Lat": "59.939",
                  "Long": "30.316",
                  "CountryCode": "RU"
                },
                {
                  "Area": "St.-Brieuc",
                  "Lat": "48.5167",
                  "Long": "-2.7833",
                  "CountryCode": "FR"
                },
                {
                  "Area": "St.-Denis",
                  "Lat": "-20.8789",
                  "Long": "55.4481",
                  "CountryCode": "RE"
                },
                {
                  "Area": "St.-Jerome",
                  "Lat": "45.7666",
                  "Long": "-74",
                  "CountryCode": "CA"
                },
                {
                  "Area": "Stamford",
                  "Lat": "41.1036",
                  "Long": "-73.5583",
                  "CountryCode": "US"
                },
                {
                  "Area": "Standerton",
                  "Lat": "-26.9395",
                  "Long": "29.24",
                  "CountryCode": "ZA"
                },
                {
                  "Area": "Stara Zagora",
                  "Lat": "42.4231",
                  "Long": "25.6227",
                  "CountryCode": "BG"
                },
                {
                  "Area": "Starsy Oskol",
                  "Lat": "51.3004",
                  "Long": "37.84",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Area College",
                  "Lat": "40.7909",
                  "Long": "-77.8568",
                  "CountryCode": "US"
                },
                {
                  "Area": "Arean Island",
                  "Lat": "40.5834",
                  "Long": "-74.1496",
                  "CountryCode": "US"
                },
                {
                  "Area": "Staunton",
                  "Lat": "38.1593",
                  "Long": "-79.0611",
                  "CountryCode": "US"
                },
                {
                  "Area": "Stavanger",
                  "Lat": "58.97",
                  "Long": "5.68",
                  "CountryCode": "NO"
                },
                {
                  "Area": "Stavropol",
                  "Lat": "45.05",
                  "Long": "41.98",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Stepanakert",
                  "Lat": "39.8156",
                  "Long": "46.752",
                  "CountryCode": "AZ"
                },
                {
                  "Area": "Sterling Heights",
                  "Lat": "42.5809",
                  "Long": "-83.0305",
                  "CountryCode": "US"
                },
                {
                  "Area": "Sterlitamak",
                  "Lat": "53.63",
                  "Long": "55.96",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Stockholm",
                  "Lat": "59.3508",
                  "Long": "18.0973",
                  "CountryCode": "SE"
                },
                {
                  "Area": "Stockton",
                  "Lat": "37.9766",
                  "Long": "-121.3112",
                  "CountryCode": "US"
                },
                {
                  "Area": "Stoke",
                  "Lat": "53.0004",
                  "Long": "-2.18",
                  "CountryCode": "GB"
                },
                {
                  "Area": "Stonecrest",
                  "Lat": "33.6843",
                  "Long": "-84.1373",
                  "CountryCode": "US"
                },
                {
                  "Area": "Stralsund",
                  "Lat": "54.3004",
                  "Long": "13.1",
                  "CountryCode": "DE"
                },
                {
                  "Area": "Strasbourg",
                  "Lat": "48.58",
                  "Long": "7.75",
                  "CountryCode": "FR"
                },
                {
                  "Area": "Stuttgart",
                  "Lat": "48.78",
                  "Long": "9.2",
                  "CountryCode": "DE"
                },
                {
                  "Area": "Subotica",
                  "Lat": "46.07",
                  "Long": "19.68",
                  "CountryCode": "RS"
                },
                {
                  "Area": "Suceava",
                  "Lat": "47.6377",
                  "Long": "26.2593",
                  "CountryCode": "RO"
                },
                {
                  "Area": "Sucre",
                  "Lat": "-19.041",
                  "Long": "-65.2595",
                  "CountryCode": "BO"
                },
                {
                  "Area": "Sudbury",
                  "Lat": "46.5",
                  "Long": "-80.9666",
                  "CountryCode": "CA"
                },
                {
                  "Area": "Suez",
                  "Lat": "30.005",
                  "Long": "32.5499",
                  "CountryCode": "EG"
                },
                {
                  "Area": "Suffolk",
                  "Lat": "36.6953",
                  "Long": "-76.6398",
                  "CountryCode": "US"
                },
                {
                  "Area": "Sugar Land",
                  "Lat": "29.5965",
                  "Long": "-95.6293",
                  "CountryCode": "US"
                },
                {
                  "Area": "Suhar",
                  "Lat": "24.362",
                  "Long": "56.7344",
                  "CountryCode": "OM"
                },
                {
                  "Area": "Suihua",
                  "Lat": "46.6304",
                  "Long": "126.98",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Suileng",
                  "Lat": "47.246",
                  "Long": "127.106",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Suining",
                  "Lat": "30.5333",
                  "Long": "105.5333",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Sukabumi",
                  "Lat": "-6.9096",
                  "Long": "106.9",
                  "CountryCode": "ID"
                },
                {
                  "Area": "Sukhumi",
                  "Lat": "43.02",
                  "Long": "41.02",
                  "CountryCode": "GE"
                },
                {
                  "Area": "Sukkur",
                  "Lat": "27.7136",
                  "Long": "68.8486",
                  "CountryCode": "PK"
                },
                {
                  "Area": "Sullana",
                  "Lat": "-4.8896",
                  "Long": "-80.68",
                  "CountryCode": "PE"
                },
                {
                  "Area": "Sumbawanga",
                  "Lat": "-7.9596",
                  "Long": "31.62",
                  "CountryCode": "TZ"
                },
                {
                  "Area": "Sumenep",
                  "Lat": "-7.0049",
                  "Long": "113.8496",
                  "CountryCode": "ID"
                },
                {
                  "Area": "Summerville",
                  "Lat": "33.0005",
                  "Long": "-80.1788",
                  "CountryCode": "US"
                },
                {
                  "Area": "Sumqayt",
                  "Lat": "40.58",
                  "Long": "49.63",
                  "CountryCode": "AZ"
                },
                {
                  "Area": "Sumter",
                  "Lat": "33.9392",
                  "Long": "-80.393",
                  "CountryCode": "US"
                },
                {
                  "Area": "Sumy",
                  "Lat": "50.9243",
                  "Long": "34.7809",
                  "CountryCode": "UA"
                },
                {
                  "Area": "Sunchon",
                  "Lat": "39.4236",
                  "Long": "125.939",
                  "CountryCode": "KP"
                },
                {
                  "Area": "Sunderland",
                  "Lat": "54.92",
                  "Long": "-1.38",
                  "CountryCode": "GB"
                },
                {
                  "Area": "Sundsvall",
                  "Lat": "62.4001",
                  "Long": "17.3167",
                  "CountryCode": "SE"
                },
                {
                  "Area": "Sungai Petani",
                  "Lat": "5.6497",
                  "Long": "100.4793",
                  "CountryCode": "MY"
                },
                {
                  "Area": "Sungaipenuh",
                  "Lat": "-2.0631",
                  "Long": "101.3964",
                  "CountryCode": "ID"
                },
                {
                  "Area": "Sunnyvale",
                  "Lat": "37.3835",
                  "Long": "-122.0257",
                  "CountryCode": "US"
                },
                {
                  "Area": "Sunrise",
                  "Lat": "26.1547",
                  "Long": "-80.2997",
                  "CountryCode": "US"
                },
                {
                  "Area": "Sunyani",
                  "Lat": "7.336",
                  "Long": "-2.336",
                  "CountryCode": "GH"
                },
                {
                  "Area": "Supham Buri",
                  "Lat": "14.471",
                  "Long": "100.129",
                  "CountryCode": "TH"
                },
                {
                  "Area": "Surabaya",
                  "Lat": "-7.2492",
                  "Long": "112.7508",
                  "CountryCode": "ID"
                },
                {
                  "Area": "Surakarta",
                  "Lat": "-7.565",
                  "Long": "110.825",
                  "CountryCode": "ID"
                },
                {
                  "Area": "Surat Thani",
                  "Lat": "9.1501",
                  "Long": "99.3401",
                  "CountryCode": "TH"
                },
                {
                  "Area": "Surgut",
                  "Lat": "61.2599",
                  "Long": "73.425",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Surigao",
                  "Lat": "9.7843",
                  "Long": "125.4888",
                  "CountryCode": "PH"
                },
                {
                  "Area": "Surin",
                  "Lat": "14.8868",
                  "Long": "103.4915",
                  "CountryCode": "TH"
                },
                {
                  "Area": "Surprise",
                  "Lat": "33.6802",
                  "Long": "-112.4525",
                  "CountryCode": "US"
                },
                {
                  "Area": "Surt",
                  "Lat": "31.21",
                  "Long": "16.59",
                  "CountryCode": "LY"
                },
                {
                  "Area": "Suva",
                  "Lat": "-18.133",
                  "Long": "178.4417",
                  "CountryCode": "Fiji"
                },
                {
                  "Area": "Suwon",
                  "Lat": "37.2578",
                  "Long": "127.0109",
                  "CountryCode": "kr"
                },
                {
                  "Area": "Suzhou",
                  "Lat": "33.6361",
                  "Long": "116.9789",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Suzhou",
                  "Lat": "31.3005",
                  "Long": "120.62",
                  "CountryCode": "CN"
                },
                {
                  "Area": "Svobodnyy",
                  "Lat": "51.4062",
                  "Long": "128.1312",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Swansea",
                  "Lat": "51.63",
                  "Long": "-3.95",
                  "CountryCode": "GB"
                },
                {
                  "Area": "Sydney",
                  "Lat": "-33.92",
                  "Long": "151.1852",
                  "CountryCode": "AU"
                },
                {
                  "Area": "Syktyvkar",
                  "Lat": "61.66",
                  "Long": "50.82",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Sylhet",
                  "Lat": "24.9036",
                  "Long": "91.8736",
                  "CountryCode": "BD"
                },
                {
                  "Area": "Syracuse",
                  "Lat": "43.0409",
                  "Long": "-76.1438",
                  "CountryCode": "US"
                },
                {
                  "Area": "Syzran",
                  "Lat": "53.17",
                  "Long": "48.48",
                  "CountryCode": "RU"
                },
                {
                  "Area": "Szczecin",
                  "Lat": "53.4204",
                  "Long": "14.53",
                  "CountryCode": "PL"
                },
                {
                  "Area": "Szeged",
                  "Lat": "46.2504",
                  "Long": "20.15",
                  "CountryCode": "HU"
                },
                {
                  "Area": "Székesfehérvár",
                  "Lat": "47.1947",
                  "Long": "18.4081",
                  "CountryCode": "HU"
                },
                {
                  "Area": "Szolnok",
                  "Lat": "47.1864",
                  "Long": "20.1794",
                  "CountryCode": "HU"
                },
                {
                  "Area": "Szombathely",
                  "Lat": "47.2253",
                  "Long": "16.6287",
                  "CountryCode": "HU"
                },
                  {
                    "Area": "T  Sabo",
                    "State": "Punjab",
                    "CountryCode": "IN",
                    "Lat": 30.0518,
                    "Long": 75.1558
                  },
                  {
                    "Area": "T Naraipura",
                    "State": "Karnataka",
                    "CountryCode": "IN",
                    "Lat": 12.2829,
                    "Long": 76.8237
                  },
                  {
                    "Area": "T Narasipura",
                    "State": "Karnataka",
                    "CountryCode": "IN",
                    "Lat": 12.6487,
                    "Long": 77.202
                  },
                  {
                    "Area": "T Sabo",
                    "State": "Punjab",
                    "CountryCode": "IN",
                    "Lat": 30.3433,
                    "Long": 75.2918
                  },
                  {
                    "Area": "T Sundupalle",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 14.4599,
                    "Long": 79.1224
                  },
                  {
                    "Area": "T. Palem",
                    "State": "Telangana",
                    "CountryCode": "IN",
                    "Lat": 17.333,
                    "Long": 79.8203
                  },
                  {
                    "Area": "T.mahisamunda",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 24.2471,
                    "Long": 87.8066
                  },
                  {
                    "Area": "T.narasapuram",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 17.1003,
                    "Long": 81.1173
                  },
                  {
                    "Area": "T.palem",
                    "State": "Telangana",
                    "CountryCode": "IN",
                    "Lat": 17.5969,
                    "Long": 80.6873
                  },
                  {
                    "Area": "T.sabo",
                    "State": "Punjab",
                    "CountryCode": "IN",
                    "Lat": 30.0518,
                    "Long": 75.152
                  },
                  {
                    "Area": "TARN-TARAN",
                    "State": "Punjab",
                    "CountryCode": "IN",
                    "Lat": 31.7241,
                    "Long": 75.8226
                  },
                  {
                    "Area": "Taankaraa",
                    "State": "Gujarat",
                    "CountryCode": "IN",
                    "Lat": 22.5973,
                    "Long": 70.8981
                  },
                  {
                    "Area": "Tabarijo",
                    "State": "Arunachal Pradesh",
                    "CountryCode": "IN",
                    "Lat": 27.9911,
                    "Long": 94.2295
                  },
                  {
                    "Area": "Tablabari Madhya Ganki",
                    "State": "Tripura",
                    "CountryCode": "IN",
                    "Lat": 23.9225,
                    "Long": 91.6031
                  },
                  {
                    "Area": "Tada",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 14.4268,
                    "Long": 80.1462
                  },
                  {
                    "Area": "Tadepalle",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 16.4957,
                    "Long": 80.6176
                  },
                  {
                    "Area": "Tadepalligudem",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 16.8946,
                    "Long": 81.5937
                  },
                  {
                    "Area": "Tadepalligudem Mandalam",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 16.9153,
                    "Long": 81.6466
                  },
                  {
                    "Area": "Tadepalligudem Mandaolam",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 16.8059,
                    "Long": 81.4021
                  },
                  {
                    "Area": "Tadikalapudi",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 16.9685,
                    "Long": 81.4536
                  },
                  {
                    "Area": "Tadikonda",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 16.546,
                    "Long": 80.0943
                  },
                  {
                    "Area": "Tadimarri",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 14.7011,
                    "Long": 77.969
                  },
                  {
                    "Area": "Tadipatri",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 15.013,
                    "Long": 78.1082
                  },
                  {
                    "Area": "Tadoor",
                    "State": "Telangana",
                    "CountryCode": "IN",
                    "Lat": 16.684,
                    "Long": 78.6796
                  },
                  {
                    "Area": "Tadpatri",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 14.9639,
                    "Long": 78.3346
                  },
                  {
                    "Area": "Tadubi",
                    "State": "Manipur",
                    "CountryCode": "IN",
                    "Lat": 25.4788,
                    "Long": 94.135
                  },
                  {
                    "Area": "Tadvai",
                    "State": "Telangana",
                    "CountryCode": "IN",
                    "Lat": 18.7441,
                    "Long": 80.3565
                  },
                  {
                    "Area": "Tagaria",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 23.5034,
                    "Long": 87.9832
                  },
                  {
                    "Area": "Tagdhar",
                    "State": "Jammu & Kashmir",
                    "CountryCode": "IN",
                    "Lat": 34.3761,
                    "Long": 73.8394
                  },
                  {
                    "Area": "Tagharia",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 22.5526,
                    "Long": 88.4901
                  },
                  {
                    "Area": "Tajpur",
                    "State": "Madhya Pradesh",
                    "CountryCode": "IN",
                    "Lat": 23.2256,
                    "Long": 75.9032
                  },
                  {
                    "Area": "Tajpur",
                    "State": "Haryana",
                    "CountryCode": "IN",
                    "Lat": 28.1729,
                    "Long": 76.1432
                  },
                  {
                    "Area": "Takapura",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 23.5034,
                    "Long": 87.9832
                  },
                  {
                    "Area": "Takhatpur",
                    "State": "Chattisgarh",
                    "CountryCode": "IN",
                    "Lat": 22.3513,
                    "Long": 81.9672
                  },
                  {
                    "Area": "Takipur",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 22.4653,
                    "Long": 88.7803
                  },
                  {
                    "Area": "Taksing",
                    "State": "Arunachal Pradesh",
                    "CountryCode": "IN",
                    "Lat": 27.9911,
                    "Long": 94.2295
                  },
                  {
                    "Area": "Tala",
                    "State": "Maharashtra",
                    "CountryCode": "IN",
                    "Lat": 19.6955,
                    "Long": 74.2979
                  },
                  {
                    "Area": "Talaja",
                    "State": "Gujarat",
                    "CountryCode": "IN",
                    "Lat": 22.0572,
                    "Long": 73.057
                  },
                  {
                    "Area": "Talakondapally",
                    "State": "Telangana",
                    "CountryCode": "IN",
                    "Lat": 17.1958,
                    "Long": 78.5343
                  },
                  {
                    "Area": "Talala",
                    "State": "Gujarat",
                    "CountryCode": "IN",
                    "Lat": 22.4342,
                    "Long": 70.7331
                  },
                  {
                    "Area": "Talappilly",
                    "State": "Kerala",
                    "CountryCode": "IN",
                    "Lat": 11.0036,
                    "Long": 76.4418
                  },
                  {
                    "Area": "Talasara",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 22.1285,
                    "Long": 84.5106
                  },
                  {
                    "Area": "Talasari",
                    "State": "Maharashtra",
                    "CountryCode": "IN",
                    "Lat": 20.1157,
                    "Long": 73.5785
                  },
                  {
                    "Area": "Talbangrua",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 25.3579,
                    "Long": 87.8677
                  },
                  {
                    "Area": "Talbehat",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 25.0907,
                    "Long": 78.512
                  },
                  {
                    "Area": "Talcher",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 21.4586,
                    "Long": 85.4978
                  },
                  {
                    "Area": "Talcher Sadar",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 21.0446,
                    "Long": 85.066
                  },
                  {
                    "Area": "Talda Ratanchak",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 23.5034,
                    "Long": 87.9832
                  },
                  {
                    "Area": "Taldangra",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 23.387,
                    "Long": 87.7549
                  },
                  {
                    "Area": "Talen",
                    "State": "Madhya Pradesh",
                    "CountryCode": "IN",
                    "Lat": 23.5673,
                    "Long": 76.8072
                  },
                  {
                    "Area": "Talgachhi",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 25.337,
                    "Long": 87.8945
                  },
                  {
                    "Area": "Talgram",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 25.3579,
                    "Long": 87.8677
                  },
                  {
                    "Area": "Tali",
                    "State": "Arunachal Pradesh",
                    "CountryCode": "IN",
                    "Lat": 28.0181,
                    "Long": 93.7515
                  },
                  {
                    "Area": "Taliaparamba",
                    "State": "Kerala",
                    "CountryCode": "IN",
                    "Lat": 12.0418,
                    "Long": 75.3473
                  },
                  {
                    "Area": "Taliha",
                    "State": "Arunachal Pradesh",
                    "CountryCode": "IN",
                    "Lat": 27.9911,
                    "Long": 94.2295
                  },
                  {
                    "Area": "Taliparamba",
                    "State": "Kerala",
                    "CountryCode": "IN",
                    "Lat": 12.2595,
                    "Long": 75.8907
                  },
                  {
                    "Area": "Taljhari",
                    "State": "Jharkhand",
                    "CountryCode": "IN",
                    "Lat": 25.2087,
                    "Long": 87.7458
                  },
                  {
                    "Area": "Tallada",
                    "State": "Telangana",
                    "CountryCode": "IN",
                    "Lat": 18.5382,
                    "Long": 80.8438
                  },
                  {
                    "Area": "Tallampahad",
                    "State": "Telangana",
                    "CountryCode": "IN",
                    "Lat": 18.1877,
                    "Long": 80.6902
                  },
                  {
                    "Area": "Tallaproddatur",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 14.8733,
                    "Long": 78.7836
                  },
                  {
                    "Area": "Tallapudi Mandal",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 17.0597,
                    "Long": 81.9387
                  },
                  {
                    "Area": "Tallapudi Mandalam",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 17.1463,
                    "Long": 81.9387
                  },
                  {
                    "Area": "Tallarevu",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 17.1885,
                    "Long": 82.2333
                  },
                  {
                    "Area": "Talod",
                    "State": "Gujarat",
                    "CountryCode": "IN",
                    "Lat": 23.8218,
                    "Long": 73.1637
                  },
                  {
                    "Area": "Taloda",
                    "State": "Maharashtra",
                    "CountryCode": "IN",
                    "Lat": 21.6678,
                    "Long": 74.3369
                  },
                  {
                    "Area": "Talode",
                    "State": "Maharashtra",
                    "CountryCode": "IN",
                    "Lat": 21.615,
                    "Long": 74.3207
                  },
                  {
                    "Area": "Talsa",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 22.7774,
                    "Long": 88.5686
                  },
                  {
                    "Area": "Talsur",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 25.3674,
                    "Long": 87.8421
                  },
                  {
                    "Area": "Taltala",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 22.5553,
                    "Long": 88.3558
                  },
                  {
                    "Area": "Talupula",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 14.267,
                    "Long": 78.3023
                  },
                  {
                    "Area": "Talwandi Sabo",
                    "State": "Punjab",
                    "CountryCode": "IN",
                    "Lat": 30.5368,
                    "Long": 75.3253
                  },
                  {
                    "Area": "Tamar",
                    "State": "Jharkhand",
                    "CountryCode": "IN",
                    "Lat": 23.3605,
                    "Long": 85.8162
                  },
                  {
                    "Area": "Tambaram",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 13.0252,
                    "Long": 80.2153
                  },
                  {
                    "Area": "Tambulpur",
                    "State": "Assam",
                    "CountryCode": "IN",
                    "Lat": 26.335,
                    "Long": 91.2507
                  },
                  {
                    "Area": "Tamei",
                    "State": "Manipur",
                    "CountryCode": "IN",
                    "Lat": 25.3027,
                    "Long": 93.7734
                  },
                  {
                    "Area": "Tamenglong",
                    "State": "Manipur",
                    "CountryCode": "IN",
                    "Lat": 24.9774,
                    "Long": 93.4533
                  },
                  {
                    "Area": "Tamia",
                    "State": "Madhya Pradesh",
                    "CountryCode": "IN",
                    "Lat": 22.6113,
                    "Long": 78.8847
                  },
                  {
                    "Area": "Tamkluk-i",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 22.5931,
                    "Long": 88.0914
                  },
                  {
                    "Area": "Tamkohi",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 26.7125,
                    "Long": 84.2279
                  },
                  {
                    "Area": "Tamkuhi",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 26.9013,
                    "Long": 84.259
                  },
                  {
                    "Area": "Tamkuhi Raj",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 26.7112,
                    "Long": 83.8086
                  },
                  {
                    "Area": "Tamluk",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 24.0696,
                    "Long": 88.2222
                  },
                  {
                    "Area": "Tamluk-i",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 24.0696,
                    "Long": 88.1922
                  },
                  {
                    "Area": "Tamnar",
                    "State": "Chattisgarh",
                    "CountryCode": "IN",
                    "Lat": 21.8385,
                    "Long": 83.3186
                  },
                  {
                    "Area": "Tamsi",
                    "State": "Telangana",
                    "CountryCode": "IN",
                    "Lat": 19.7206,
                    "Long": 78.3782
                  },
                  {
                    "Area": "Tana Gazi",
                    "State": "Rajasthan",
                    "CountryCode": "IN",
                    "Lat": 27.5915,
                    "Long": 76.6853
                  },
                  {
                    "Area": "Tanakal",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 14.4811,
                    "Long": 78.352
                  },
                  {
                    "Area": "Tanakallu",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 13.9403,
                    "Long": 78.352
                  },
                  {
                    "Area": "Tanakpur",
                    "State": "Uttarakhand",
                    "CountryCode": "IN",
                    "Lat": 29.2988,
                    "Long": 80.0697
                  },
                  {
                    "Area": "Tanda",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 26.66,
                    "Long": 83.0636
                  },
                  {
                    "Area": "Tandur",
                    "State": "Telangana",
                    "CountryCode": "IN",
                    "Lat": 17.3122,
                    "Long": 78.2275
                  },
                  {
                    "Area": "Tandwa",
                    "State": "Jharkhand",
                    "CountryCode": "IN",
                    "Lat": 24.1819,
                    "Long": 85.044
                  },
                  {
                    "Area": "Tang",
                    "State": "Arunachal Pradesh",
                    "CountryCode": "IN",
                    "Lat": 27.5667,
                    "Long": 91.9833
                  },
                  {
                    "Area": "Tangarapali",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 22.1872,
                    "Long": 84.8436
                  },
                  {
                    "Area": "Tangarpai",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 21.3382,
                    "Long": 84.1244
                  },
                  {
                    "Area": "Tangarpali",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 22.0798,
                    "Long": 84.9581
                  },
                  {
                    "Area": "Tangarpur",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 22.0798,
                    "Long": 84.5106
                  },
                  {
                    "Area": "Tangdahr",
                    "State": "Jammu & Kashmir",
                    "CountryCode": "IN",
                    "Lat": 34.5319,
                    "Long": 74.2661
                  },
                  {
                    "Area": "Tangdhar",
                    "State": "Jammu & Kashmir",
                    "CountryCode": "IN",
                    "Lat": 34.3761,
                    "Long": 73.8394
                  },
                  {
                    "Area": "Tangi",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 21.7358,
                    "Long": 85.9918
                  },
                  {
                    "Area": "Tangi Choudwar",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 20.7858,
                    "Long": 84.8119
                  },
                  {
                    "Area": "Tangla",
                    "State": "Assam",
                    "CountryCode": "IN",
                    "Lat": 26.6569,
                    "Long": 92.0374
                  },
                  {
                    "Area": "Tangmarg",
                    "State": "Jammu & Kashmir",
                    "CountryCode": "IN",
                    "Lat": 34.0716,
                    "Long": 74.5846
                  },
                  {
                    "Area": "Tangra",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 23.5022,
                    "Long": 88.5404
                  },
                  {
                    "Area": "Tangutur",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 15.0879,
                    "Long": 79.9401
                  },
                  {
                    "Area": "Tanikella",
                    "State": "Telangana",
                    "CountryCode": "IN",
                    "Lat": 17.5969,
                    "Long": 80.7735
                  },
                  {
                    "Area": "Tankara",
                    "State": "Gujarat",
                    "CountryCode": "IN",
                    "Lat": 22.6562,
                    "Long": 70.8981
                  },
                  {
                    "Area": "Tankri",
                    "State": "Haryana",
                    "CountryCode": "IN",
                    "Lat": 28.0832,
                    "Long": 76.4872
                  },
                  {
                    "Area": "Tanua",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 22.8923,
                    "Long": 87.3704
                  },
                  {
                    "Area": "Tanuku",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 16.7593,
                    "Long": 81.6753
                  },
                  {
                    "Area": "Tanuku (mdl)",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 16.7776,
                    "Long": 81.6753
                  },
                  {
                    "Area": "Tanuku Mandal",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 16.7797,
                    "Long": 81.6238
                  },
                  {
                    "Area": "Tanuku Mandalam",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 16.8141,
                    "Long": 81.6576
                  },
                  {
                    "Area": "Tapan",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 24.2416,
                    "Long": 88.4944
                  },
                  {
                    "Area": "Tarab Ganj",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 27.1864,
                    "Long": 81.1374
                  },
                  {
                    "Area": "Tarabfanj",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 26.6987,
                    "Long": 81.8136
                  },
                  {
                    "Area": "Tarabganij",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 26.8694,
                    "Long": 81.8706
                  },
                  {
                    "Area": "Tarabganj",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 27.2263,
                    "Long": 82.2305
                  },
                  {
                    "Area": "Tarabganjj",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 26.8962,
                    "Long": 81.9582
                  },
                  {
                    "Area": "Tarabganu",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 26.8795,
                    "Long": 81.9596
                  },
                  {
                    "Area": "Taragunia",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 22.6259,
                    "Long": 88.6827
                  },
                  {
                    "Area": "Taraiya",
                    "State": "Bihar",
                    "CountryCode": "IN",
                    "Lat": 25.9047,
                    "Long": 84.8785
                  },
                  {
                    "Area": "Tarakeswar",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 23.4607,
                    "Long": 88.2692
                  },
                  {
                    "Area": "Tarakpur",
                    "State": "Tripura",
                    "CountryCode": "IN",
                    "Lat": 24.1597,
                    "Long": 92.0329
                  },
                  {
                    "Area": "Tarana",
                    "State": "Madhya Pradesh",
                    "CountryCode": "IN",
                    "Lat": 23.6815,
                    "Long": 76.7743
                  },
                  {
                    "Area": "Taranagar",
                    "State": "Rajasthan",
                    "CountryCode": "IN",
                    "Lat": 28.8878,
                    "Long": 75.3905
                  },
                  {
                    "Area": "Tarangambadi",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.0997,
                    "Long": 79.8479
                  },
                  {
                    "Area": "Taranganj",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 26.8998,
                    "Long": 81.9931
                  },
                  {
                    "Area": "Taraninagar",
                    "State": "Tripura",
                    "CountryCode": "IN",
                    "Lat": 24.1048,
                    "Long": 92.0073
                  },
                  {
                    "Area": "Taranipur",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 22.881,
                    "Long": 88.8719
                  },
                  {
                    "Area": "Tarapur",
                    "State": "Bihar",
                    "CountryCode": "IN",
                    "Lat": 25.3521,
                    "Long": 87.2352
                  },
                  {
                    "Area": "Tarapur",
                    "State": "Gujarat",
                    "CountryCode": "IN",
                    "Lat": 23.3897,
                    "Long": 73.4062
                  },
                  {
                    "Area": "Tarapura=",
                    "State": "Gujarat",
                    "CountryCode": "IN",
                    "Lat": 23.3897,
                    "Long": 73.2166
                  },
                  {
                    "Area": "Tarari",
                    "State": "Bihar",
                    "CountryCode": "IN",
                    "Lat": 25.469,
                    "Long": 84.5437
                  },
                  {
                    "Area": "Tararui",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 22.3836,
                    "Long": 87.8747
                  },
                  {
                    "Area": "Tarbganj",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 27.0841,
                    "Long": 82.0256
                  },
                  {
                    "Area": "Tarbha",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 21.1888,
                    "Long": 84.2266
                  },
                  {
                    "Area": "Tarha",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 20.8007,
                    "Long": 84.1278
                  },
                  {
                    "Area": "Tarigam",
                    "State": "Jammu & Kashmir",
                    "CountryCode": "IN",
                    "Lat": 33.9563,
                    "Long": 74.834
                  },
                  {
                    "Area": "Tarikee",
                    "State": "Karnataka",
                    "CountryCode": "IN",
                    "Lat": 13.733,
                    "Long": 75.8293
                  },
                  {
                    "Area": "Tarikere",
                    "State": "Karnataka",
                    "CountryCode": "IN",
                    "Lat": 14.0488,
                    "Long": 76.0953
                  },
                  {
                    "Area": "Tarlupadu",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 15.7169,
                    "Long": 79.3124
                  },
                  {
                    "Area": "Tarn Taran",
                    "State": "Punjab",
                    "CountryCode": "IN",
                    "Lat": 31.4693,
                    "Long": 74.9504
                  },
                  {
                    "Area": "Tarsika",
                    "State": "Punjab",
                    "CountryCode": "IN",
                    "Lat": 31.6962,
                    "Long": 75.1668
                  },
                  {
                    "Area": "Tarua",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 22.8223,
                    "Long": 87.5059
                  },
                  {
                    "Area": "Tasgaon",
                    "State": "Maharashtra",
                    "CountryCode": "IN",
                    "Lat": 19.6707,
                    "Long": 75.3975
                  },
                  {
                    "Area": "Tatanagar",
                    "State": "Jharkhand",
                    "CountryCode": "IN",
                    "Lat": 22.7288,
                    "Long": 86.4527
                  },
                  {
                    "Area": "Tato",
                    "State": "Arunachal Pradesh",
                    "CountryCode": "IN",
                    "Lat": 28.2358,
                    "Long": 94.6742
                  },
                  {
                    "Area": "Tatyaganj",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 26.1685,
                    "Long": 80.3428
                  },
                  {
                    "Area": "Taudhakpur",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 26.3843,
                    "Long": 80.3275
                  },
                  {
                    "Area": "Tauru",
                    "State": "Haryana",
                    "CountryCode": "IN",
                    "Lat": 28.3681,
                    "Long": 76.9408
                  },
                  {
                    "Area": "Tawang",
                    "State": "Arunachal Pradesh",
                    "CountryCode": "IN",
                    "Lat": 27.5742,
                    "Long": 91.9244
                  },
                  {
                    "Area": "Teghakhat",
                    "State": "Assam",
                    "CountryCode": "IN",
                    "Lat": 27.3723,
                    "Long": 95.3075
                  },
                  {
                    "Area": "Teghra",
                    "State": "Bihar",
                    "CountryCode": "IN",
                    "Lat": 25.5966,
                    "Long": 86.1308
                  },
                  {
                    "Area": "Tehatta",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 24.5009,
                    "Long": 88.7197
                  },
                  {
                    "Area": "Tehatta - I",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 23.4827,
                    "Long": 88.5215
                  },
                  {
                    "Area": "Tehatta I",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 24.5009,
                    "Long": 88.5469
                  },
                  {
                    "Area": "Tehatta Ii",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 23.9232,
                    "Long": 88.5215
                  },
                  {
                    "Area": "Tehri",
                    "State": "Uttarakhand",
                    "CountryCode": "IN",
                    "Lat": 30.5659,
                    "Long": 79.1427
                  },
                  {
                    "Area": "Tehyri",
                    "State": "Uttarakhand",
                    "CountryCode": "IN",
                    "Lat": 30.4374,
                    "Long": 78.537
                  },
                  {
                    "Area": "Tekari",
                    "State": "Bihar",
                    "CountryCode": "IN",
                    "Lat": 25.0854,
                    "Long": 84.9116
                  },
                  {
                    "Area": "Tekkali",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 18.5492,
                    "Long": 83.9602
                  },
                  {
                    "Area": "Tekkali Mandal",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 18.809,
                    "Long": 83.9602
                  },
                  {
                    "Area": "Telami",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 21.8104,
                    "Long": 87.448
                  },
                  {
                    "Area": "Telaprolu",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 17.0586,
                    "Long": 80.6281
                  },
                  {
                    "Area": "Telhara",
                    "State": "Maharashtra",
                    "CountryCode": "IN",
                    "Lat": 21.0269,
                    "Long": 77.0533
                  },
                  {
                    "Area": "Telhara",
                    "State": "Bihar",
                    "CountryCode": "IN",
                    "Lat": 25.2251,
                    "Long": 85.1836
                  },
                  {
                    "Area": "Teliamura",
                    "State": "Tripura",
                    "CountryCode": "IN",
                    "Lat": 24.007,
                    "Long": 91.6093
                  },
                  {
                    "Area": "Telkoi",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 21.7283,
                    "Long": 85.7051
                  },
                  {
                    "Area": "Tena",
                    "State": "Rajasthan",
                    "CountryCode": "IN",
                    "Lat": 26.3837,
                    "Long": 72.3389
                  },
                  {
                    "Area": "Tenali",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 16.3091,
                    "Long": 80.7028
                  },
                  {
                    "Area": "Tendukheda",
                    "State": "Madhya Pradesh",
                    "CountryCode": "IN",
                    "Lat": 23.1776,
                    "Long": 79.2974
                  },
                  {
                    "Area": "Tenga Market",
                    "State": "Arunachal Pradesh",
                    "CountryCode": "IN",
                    "Lat": 27.3143,
                    "Long": 92.3716
                  },
                  {
                    "Area": "Tengaf Market",
                    "State": "Arunachal Pradesh",
                    "CountryCode": "IN",
                    "Lat": 27.3143,
                    "Long": 92.3716
                  },
                  {
                    "Area": "Tengakhat",
                    "State": "Assam",
                    "CountryCode": "IN",
                    "Lat": 27.3804,
                    "Long": 95.1628
                  },
                  {
                    "Area": "Tengnoupal",
                    "State": "Manipur",
                    "CountryCode": "IN",
                    "Lat": 24.3182,
                    "Long": 94.224
                  },
                  {
                    "Area": "Tengunia",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 22.2758,
                    "Long": 88.831
                  },
                  {
                    "Area": "Tenkasi",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.2589,
                    "Long": 79.7156
                  },
                  {
                    "Area": "Tentuliabhumjan",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 24.3029,
                    "Long": 87.818
                  },
                  {
                    "Area": "Tentulikhunti",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 18.755,
                    "Long": 82.4239
                  },
                  {
                    "Area": "Tenughat",
                    "State": "Jharkhand",
                    "CountryCode": "IN",
                    "Lat": 23.7345,
                    "Long": 85.876
                  },
                  {
                    "Area": "Teonda",
                    "State": "Madhya Pradesh",
                    "CountryCode": "IN",
                    "Lat": 23.776,
                    "Long": 78.2396
                  },
                  {
                    "Area": "Teonthar",
                    "State": "Madhya Pradesh",
                    "CountryCode": "IN",
                    "Lat": 25.1755,
                    "Long": 81.9291
                  },
                  {
                    "Area": "Teori",
                    "State": "Rajasthan",
                    "CountryCode": "IN",
                    "Lat": 26.6545,
                    "Long": 73.775
                  },
                  {
                    "Area": "Teosa",
                    "State": "Maharashtra",
                    "CountryCode": "IN",
                    "Lat": 20.9909,
                    "Long": 78.3858
                  },
                  {
                    "Area": "Tepania",
                    "State": "Tripura",
                    "CountryCode": "IN",
                    "Lat": 23.4955,
                    "Long": 91.3298
                  },
                  {
                    "Area": "Terechia",
                    "State": "Assam",
                    "CountryCode": "IN",
                    "Lat": 26.3796,
                    "Long": 91.2951
                  },
                  {
                    "Area": "Tetaria",
                    "State": "Bihar",
                    "CountryCode": "IN",
                    "Lat": 26.5597,
                    "Long": 84.9846
                  },
                  {
                    "Area": "Tetenbari",
                    "State": "Assam",
                    "CountryCode": "IN",
                    "Lat": 26.8535,
                    "Long": 93.4797
                  },
                  {
                    "Area": "Tetia",
                    "State": "Bihar",
                    "CountryCode": "IN",
                    "Lat": 25.1667,
                    "Long": 86.5614
                  },
                  {
                    "Area": "Tetia Bambar",
                    "State": "Bihar",
                    "CountryCode": "IN",
                    "Lat": 25.1667,
                    "Long": 86.5614
                  },
                  {
                    "Area": "Tetiabambar",
                    "State": "Bihar",
                    "CountryCode": "IN",
                    "Lat": 25.3041,
                    "Long": 86.5614
                  },
                  {
                    "Area": "Tetiya Bambar",
                    "State": "Bihar",
                    "CountryCode": "IN",
                    "Lat": 25.1667,
                    "Long": 86.5614
                  },
                  {
                    "Area": "Tetulbaria",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 22.1465,
                    "Long": 88.1117
                  },
                  {
                    "Area": "Tezpur",
                    "State": "Assam",
                    "CountryCode": "IN",
                    "Lat": 26.782,
                    "Long": 92.65
                  },
                  {
                    "Area": "Tezu",
                    "State": "Arunachal Pradesh",
                    "CountryCode": "IN",
                    "Lat": 27.9126,
                    "Long": 96.1288
                  },
                  {
                    "Area": "Th. Rampur",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 19.6831,
                    "Long": 83.1806
                  },
                  {
                    "Area": "Th.rampur",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 19.6831,
                    "Long": 83.1806
                  },
                  {
                    "Area": "Thadlaskein",
                    "State": "Meghalaya",
                    "CountryCode": "IN",
                    "Lat": 25.5689,
                    "Long": 92.2088
                  },
                  {
                    "Area": "Thadlasken",
                    "State": "Meghalaya",
                    "CountryCode": "IN",
                    "Lat": 25.5689,
                    "Long": 92.2088
                  },
                  {
                    "Area": "Thadoor",
                    "State": "Telangana",
                    "CountryCode": "IN",
                    "Lat": 16.5281,
                    "Long": 78.3517
                  },
                  {
                    "Area": "Thakaurdwara",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 29.0957,
                    "Long": 78.7791
                  },
                  {
                    "Area": "Thakuedwara",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 29.0158,
                    "Long": 78.6966
                  },
                  {
                    "Area": "Thakurchak",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 22.8223,
                    "Long": 87.5059
                  },
                  {
                    "Area": "Thakurdwara",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 29.2537,
                    "Long": 78.8971
                  },
                  {
                    "Area": "Thakurgarh",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 20.863,
                    "Long": 84.786
                  },
                  {
                    "Area": "Thakurnagar",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 23.5034,
                    "Long": 87.9832
                  },
                  {
                    "Area": "Thakurpukur Mahestola",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 22.4069,
                    "Long": 88.1497
                  },
                  {
                    "Area": "Thalapilly",
                    "State": "Kerala",
                    "CountryCode": "IN",
                    "Lat": 10.8701,
                    "Long": 76.4236
                  },
                  {
                    "Area": "Thalasery",
                    "State": "Kerala",
                    "CountryCode": "IN",
                    "Lat": 11.9238,
                    "Long": 75.5995
                  },
                  {
                    "Area": "Thalasseery",
                    "State": "Kerala",
                    "CountryCode": "IN",
                    "Lat": 11.9254,
                    "Long": 75.6818
                  },
                  {
                    "Area": "Thalassery",
                    "State": "Kerala",
                    "CountryCode": "IN",
                    "Lat": 12.0006,
                    "Long": 76.1313
                  },
                  {
                    "Area": "Thali Sain",
                    "State": "Uttarakhand",
                    "CountryCode": "IN",
                    "Lat": 30.0576,
                    "Long": 79.1278
                  },
                  {
                    "Area": "Thalisain",
                    "State": "Uttarakhand",
                    "CountryCode": "IN",
                    "Lat": 30.0215,
                    "Long": 79.2082
                  },
                  {
                    "Area": "Thallarevu",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 16.9468,
                    "Long": 82.1045
                  },
                  {
                    "Area": "Thamna",
                    "State": "Assam",
                    "CountryCode": "IN",
                    "Lat": 26.3602,
                    "Long": 91.6277
                  },
                  {
                    "Area": "Thanagazi",
                    "State": "Rajasthan",
                    "CountryCode": "IN",
                    "Lat": 27.5915,
                    "Long": 76.6246
                  },
                  {
                    "Area": "Thandla",
                    "State": "Madhya Pradesh",
                    "CountryCode": "IN",
                    "Lat": 23.1044,
                    "Long": 75.0302
                  },
                  {
                    "Area": "Thandrampattu",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.1265,
                    "Long": 79.0999
                  },
                  {
                    "Area": "Thane",
                    "State": "Maharashtra",
                    "CountryCode": "IN",
                    "Lat": 19.4115,
                    "Long": 73.7854
                  },
                  {
                    "Area": "Thanesa",
                    "State": "Haryana",
                    "CountryCode": "IN",
                    "Lat": 30.0451,
                    "Long": 76.7862
                  },
                  {
                    "Area": "Thanesar",
                    "State": "Haryana",
                    "CountryCode": "IN",
                    "Lat": 30.1499,
                    "Long": 77.0063
                  },
                  {
                    "Area": "Thanguri",
                    "State": "Assam",
                    "CountryCode": "IN",
                    "Lat": 26.3796,
                    "Long": 91.2951
                  },
                  {
                    "Area": "Thanjavur",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.4375,
                    "Long": 79.4329
                  },
                  {
                    "Area": "Thanwas",
                    "State": "Haryana",
                    "CountryCode": "IN",
                    "Lat": 29.3043,
                    "Long": 77.0492
                  },
                  {
                    "Area": "Tharad",
                    "State": "Gujarat",
                    "CountryCode": "IN",
                    "Lat": 24.5278,
                    "Long": 72.3186
                  },
                  {
                    "Area": "Tharali",
                    "State": "Uttarakhand",
                    "CountryCode": "IN",
                    "Lat": 30.6729,
                    "Long": 79.8621
                  },
                  {
                    "Area": "Tharangambadi",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.9012,
                    "Long": 79.8543
                  },
                  {
                    "Area": "Tharangampadi",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.0378,
                    "Long": 79.7958
                  },
                  {
                    "Area": "Tharthari",
                    "State": "Bihar",
                    "CountryCode": "IN",
                    "Lat": 25.3766,
                    "Long": 85.4559
                  },
                  {
                    "Area": "Thasra",
                    "State": "Gujarat",
                    "CountryCode": "IN",
                    "Lat": 23.1939,
                    "Long": 74.1142
                  },
                  {
                    "Area": "Thathri",
                    "State": "Jammu & Kashmir",
                    "CountryCode": "IN",
                    "Lat": 33.135,
                    "Long": 75.616
                  },
                  {
                    "Area": "Thavanampalle",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 14.1932,
                    "Long": 78.9771
                  },
                  {
                    "Area": "The Dangs",
                    "State": "Gujarat",
                    "CountryCode": "IN",
                    "Lat": 20.7978,
                    "Long": 73.7738
                  },
                  {
                    "Area": "The Mall",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 26.5167,
                    "Long": 80.3155
                  },
                  {
                    "Area": "Their",
                    "State": "Uttarakhand",
                    "CountryCode": "IN",
                    "Lat": 30.3103,
                    "Long": 79.0071
                  },
                  {
                    "Area": "Thelamara",
                    "State": "Assam",
                    "CountryCode": "IN",
                    "Lat": 26.7711,
                    "Long": 92.6276
                  },
                  {
                    "Area": "Thelkapally",
                    "State": "Telangana",
                    "CountryCode": "IN",
                    "Lat": 17.0926,
                    "Long": 78.4895
                  },
                  {
                    "Area": "Theni",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.0424,
                    "Long": 77.5185
                  },
                  {
                    "Area": "Theog",
                    "State": "Himachal Pradesh",
                    "CountryCode": "IN",
                    "Lat": 31.2663,
                    "Long": 77.6324
                  },
                  {
                    "Area": "Therlam",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 18.5436,
                    "Long": 83.5877
                  },
                  {
                    "Area": "Therlam Mandal",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 18.5195,
                    "Long": 83.5861
                  },
                  {
                    "Area": "Thethaitangar",
                    "State": "Jharkhand",
                    "CountryCode": "IN",
                    "Lat": 22.4975,
                    "Long": 84.7187
                  },
                  {
                    "Area": "Thikari",
                    "State": "Madhya Pradesh",
                    "CountryCode": "IN",
                    "Lat": 22.0043,
                    "Long": 76.171
                  },
                  {
                    "Area": "Thimmajipet",
                    "State": "Telangana",
                    "CountryCode": "IN",
                    "Lat": 17.3183,
                    "Long": 78.4072
                  },
                  {
                    "Area": "Thimmapur",
                    "State": "Telangana",
                    "CountryCode": "IN",
                    "Lat": 18.8372,
                    "Long": 79.7454
                  },
                  {
                    "Area": "Thingsai",
                    "State": "Mizoram",
                    "CountryCode": "IN",
                    "Lat": 22.9284,
                    "Long": 93.0987
                  },
                  {
                    "Area": "Thingsulthliah",
                    "State": "Mizoram",
                    "CountryCode": "IN",
                    "Lat": 23.8106,
                    "Long": 92.9156
                  },
                  {
                    "Area": "Thingsulthliah (Part)",
                    "State": "Mizoram",
                    "CountryCode": "IN",
                    "Lat": 23.7846,
                    "Long": 92.8256
                  },
                  {
                    "Area": "Thirthahalli",
                    "State": "Karnataka",
                    "CountryCode": "IN",
                    "Lat": 14.2741,
                    "Long": 75.4609
                  },
                  {
                    "Area": "Thirukkuvalai",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.8494,
                    "Long": 79.7423
                  },
                  {
                    "Area": "Thirumalairayan Pattinam Commune Panchayat",
                    "State": "Pondicherry",
                    "CountryCode": "IN",
                    "Lat": 10.9434,
                    "Long": 79.7558
                  },
                  {
                    "Area": "Thirumangalam",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.1696,
                    "Long": 78.5422
                  },
                  {
                    "Area": "Thirumayam",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.6098,
                    "Long": 78.9858
                  },
                  {
                    "Area": "Thirunallar Commune Panchayat",
                    "State": "Pondicherry",
                    "CountryCode": "IN",
                    "Lat": 10.9261,
                    "Long": 79.792
                  },
                  {
                    "Area": "Thiruporur",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.7093,
                    "Long": 79.8233
                  },
                  {
                    "Area": "Thiruthuraipoondi",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.9516,
                    "Long": 79.652
                  },
                  {
                    "Area": "Thiruvaiyaru",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.9333,
                    "Long": 79.3229
                  },
                  {
                    "Area": "Thiruvalla",
                    "State": "Kerala",
                    "CountryCode": "IN",
                    "Lat": 9.676,
                    "Long": 76.9613
                  },
                  {
                    "Area": "Thiruvallur",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 13.1574,
                    "Long": 79.9529
                  },
                  {
                    "Area": "Thiruvananthapuram",
                    "State": "Kerala",
                    "CountryCode": "IN",
                    "Lat": 9.1681,
                    "Long": 77.0519
                  },
                  {
                    "Area": "Thiruvarur",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.9146,
                    "Long": 79.7668
                  },
                  {
                    "Area": "Thiruvidaimarudur",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.1578,
                    "Long": 79.5873
                  },
                  {
                    "Area": "Thoara",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 22.8358,
                    "Long": 88.7482
                  },
                  {
                    "Area": "Thodupuzha",
                    "State": "Kerala",
                    "CountryCode": "IN",
                    "Lat": 9.934,
                    "Long": 77.0275
                  },
                  {
                    "Area": "Thondamanadu",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 13.7439,
                    "Long": 79.6934
                  },
                  {
                    "Area": "Thondangi",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 17.5465,
                    "Long": 82.4347
                  },
                  {
                    "Area": "Thondur",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 14.4461,
                    "Long": 78.7017
                  },
                  {
                    "Area": "Thoothukkudi",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 9.0787,
                    "Long": 78.0591
                  },
                  {
                    "Area": "Thotlavalluru",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 16.4779,
                    "Long": 80.8534
                  },
                  {
                    "Area": "Thottiam",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.0635,
                    "Long": 78.5704
                  },
                  {
                    "Area": "Thottiyam",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.9936,
                    "Long": 78.5704
                  },
                  {
                    "Area": "Thoubal",
                    "State": "Manipur",
                    "CountryCode": "IN",
                    "Lat": 24.8782,
                    "Long": 93.9796
                  },
                  {
                    "Area": "Thovala",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 8.8335,
                    "Long": 77.4825
                  },
                  {
                    "Area": "Thovalai",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 8.322,
                    "Long": 77.5047
                  },
                  {
                    "Area": "Thrissur",
                    "State": "Kerala",
                    "CountryCode": "IN",
                    "Lat": 10.8662,
                    "Long": 76.4008
                  },
                  {
                    "Area": "Thrithahalli",
                    "State": "Karnataka",
                    "CountryCode": "IN",
                    "Lat": 13.7271,
                    "Long": 75.195
                  },
                  {
                    "Area": "Thsra",
                    "State": "Gujarat",
                    "CountryCode": "IN",
                    "Lat": 22.9407,
                    "Long": 73.4051
                  },
                  {
                    "Area": "Thuamul Rampur",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 19.6831,
                    "Long": 83.1806
                  },
                  {
                    "Area": "Thuamulrampur",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 19.9784,
                    "Long": 83.364
                  },
                  {
                    "Area": "Thunag",
                    "State": "Himachal Pradesh",
                    "CountryCode": "IN",
                    "Lat": 31.6987,
                    "Long": 77.2162
                  },
                  {
                    "Area": "Thunag(T)",
                    "State": "Himachal Pradesh",
                    "CountryCode": "IN",
                    "Lat": 31.6144,
                    "Long": 77.2771
                  },
                  {
                    "Area": "Thungathurthi",
                    "State": "Telangana",
                    "CountryCode": "IN",
                    "Lat": 18.146,
                    "Long": 79.7734
                  },
                  {
                    "Area": "Thungathurthy",
                    "State": "Telangana",
                    "CountryCode": "IN",
                    "Lat": 18.146,
                    "Long": 79.7374
                  },
                  {
                    "Area": "Thuraiyur",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.5191,
                    "Long": 78.8161
                  },
                  {
                    "Area": "Tiangsang",
                    "State": "Tripura",
                    "CountryCode": "IN",
                    "Lat": 24.1597,
                    "Long": 92.0329
                  },
                  {
                    "Area": "Tibbi",
                    "State": "Rajasthan",
                    "CountryCode": "IN",
                    "Lat": 29.6269,
                    "Long": 74.5576
                  },
                  {
                    "Area": "Tigiria",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 20.6286,
                    "Long": 85.7057
                  },
                  {
                    "Area": "Tihidi",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 21.3205,
                    "Long": 86.6296
                  },
                  {
                    "Area": "Tihu",
                    "State": "Assam",
                    "CountryCode": "IN",
                    "Lat": 26.4758,
                    "Long": 91.2669
                  },
                  {
                    "Area": "Tijara",
                    "State": "Rajasthan",
                    "CountryCode": "IN",
                    "Lat": 28.0575,
                    "Long": 76.8949
                  },
                  {
                    "Area": "Tikabali",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 20.2867,
                    "Long": 84.3842
                  },
                  {
                    "Area": "Tikamgar",
                    "State": "Madhya Pradesh",
                    "CountryCode": "IN",
                    "Lat": 25.1798,
                    "Long": 78.9818
                  },
                  {
                    "Area": "Tikamgarh",
                    "State": "Madhya Pradesh",
                    "CountryCode": "IN",
                    "Lat": 26.0382,
                    "Long": 79.2631
                  },
                  {
                    "Area": "Tikari",
                    "State": "Bihar",
                    "CountryCode": "IN",
                    "Lat": 25.0854,
                    "Long": 85.2209
                  },
                  {
                    "Area": "Tikashi",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 23.5034,
                    "Long": 87.9832
                  },
                  {
                    "Area": "Tikra",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 26.3612,
                    "Long": 80.4073
                  },
                  {
                    "Area": "Tikrikilla",
                    "State": "Meghalaya",
                    "CountryCode": "IN",
                    "Lat": 25.5545,
                    "Long": 90.3369
                  },
                  {
                    "Area": "Tilakwada",
                    "State": "Gujarat",
                    "CountryCode": "IN",
                    "Lat": 22.5947,
                    "Long": 73.6475
                  },
                  {
                    "Area": "Tilda",
                    "State": "Chattisgarh",
                    "CountryCode": "IN",
                    "Lat": 21.5009,
                    "Long": 82.0501
                  },
                  {
                    "Area": "Tileibani",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 21.6926,
                    "Long": 84.851
                  },
                  {
                    "Area": "Tilhar",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 28.228,
                    "Long": 80.2705
                  },
                  {
                    "Area": "Tiljala",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 22.5668,
                    "Long": 88.3016
                  },
                  {
                    "Area": "Tiloi",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 26.5595,
                    "Long": 81.9977
                  },
                  {
                    "Area": "Tilouthu",
                    "State": "Bihar",
                    "CountryCode": "IN",
                    "Lat": 25.0921,
                    "Long": 84.3504
                  },
                  {
                    "Area": "Tilsahari",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 26.3801,
                    "Long": 80.4141
                  },
                  {
                    "Area": "Tilthai",
                    "State": "Tripura",
                    "CountryCode": "IN",
                    "Lat": 24.1597,
                    "Long": 92.0329
                  },
                  {
                    "Area": "Timarni",
                    "State": "Madhya Pradesh",
                    "CountryCode": "IN",
                    "Lat": 22.5164,
                    "Long": 77.2483
                  },
                  {
                    "Area": "Tindivaman",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.1238,
                    "Long": 79.3412
                  },
                  {
                    "Area": "Tindivanam",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.485,
                    "Long": 79.9419
                  },
                  {
                    "Area": "Tindvanam",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.4068,
                    "Long": 79.8392
                  },
                  {
                    "Area": "Tinghkhong",
                    "State": "Assam",
                    "CountryCode": "IN",
                    "Lat": 27.3779,
                    "Long": 95.2828
                  },
                  {
                    "Area": "Tingkhong",
                    "State": "Assam",
                    "CountryCode": "IN",
                    "Lat": 27.3779,
                    "Long": 95.2828
                  },
                  {
                    "Area": "Tinsukia",
                    "State": "Assam",
                    "CountryCode": "IN",
                    "Lat": 27.5786,
                    "Long": 95.646
                  },
                  {
                    "Area": "Tint",
                    "State": "Haryana",
                    "CountryCode": "IN",
                    "Lat": 28.1769,
                    "Long": 76.5079
                  },
                  {
                    "Area": "Tiosa",
                    "State": "Maharashtra",
                    "CountryCode": "IN",
                    "Lat": 21.1237,
                    "Long": 78.0704
                  },
                  {
                    "Area": "Tipling",
                    "State": "Assam",
                    "CountryCode": "IN",
                    "Lat": 27.4158,
                    "Long": 95.2775
                  },
                  {
                    "Area": "Tippi",
                    "State": "Arunachal Pradesh",
                    "CountryCode": "IN",
                    "Lat": 27.3143,
                    "Long": 92.3716
                  },
                  {
                    "Area": "Tiptir",
                    "State": "Karnataka",
                    "CountryCode": "IN",
                    "Lat": 13.4588,
                    "Long": 76.6538
                  },
                  {
                    "Area": "Tiptur",
                    "State": "Karnataka",
                    "CountryCode": "IN",
                    "Lat": 13.5202,
                    "Long": 77.0364
                  },
                  {
                    "Area": "Tira Sujanpur(T)",
                    "State": "Himachal Pradesh",
                    "CountryCode": "IN",
                    "Lat": 32.1133,
                    "Long": 76.633
                  },
                  {
                    "Area": "Tirbin",
                    "State": "Arunachal Pradesh",
                    "CountryCode": "IN",
                    "Lat": 27.9314,
                    "Long": 94.7569
                  },
                  {
                    "Area": "Tirchengodu",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.4355,
                    "Long": 78.0021
                  },
                  {
                    "Area": "Tirodi",
                    "State": "Madhya Pradesh",
                    "CountryCode": "IN",
                    "Lat": 21.6116,
                    "Long": 79.7411
                  },
                  {
                    "Area": "Tirol",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 20.7067,
                    "Long": 84.627
                  },
                  {
                    "Area": "Tirora",
                    "State": "Maharashtra",
                    "CountryCode": "IN",
                    "Lat": 21.4041,
                    "Long": 80.2054
                  },
                  {
                    "Area": "Tirppattur-singamounari Block",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 9.9151,
                    "Long": 78.5987
                  },
                  {
                    "Area": "Tirthahalli",
                    "State": "Karnataka",
                    "CountryCode": "IN",
                    "Lat": 14.1192,
                    "Long": 75.8798
                  },
                  {
                    "Area": "Tirtol",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 21.2998,
                    "Long": 86.3694
                  },
                  {
                    "Area": "Tiruannamalai",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.0425,
                    "Long": 79.1088
                  },
                  {
                    "Area": "Tiruannvmalai",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.2256,
                    "Long": 79.2256
                  },
                  {
                    "Area": "Tiruchendur",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.3813,
                    "Long": 78.8214
                  },
                  {
                    "Area": "Tiruchengode",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.615,
                    "Long": 78.5063
                  },
                  {
                    "Area": "Tiruchengodu",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.6741,
                    "Long": 78.3501
                  },
                  {
                    "Area": "Tiruchirappalli",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.324,
                    "Long": 78.8526
                  },
                  {
                    "Area": "Tiruchuli",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 9.68,
                    "Long": 78.3625
                  },
                  {
                    "Area": "Tirukalikundram",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.7311,
                    "Long": 80.2121
                  },
                  {
                    "Area": "Tirukalikundram`",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.5498,
                    "Long": 79.9877
                  },
                  {
                    "Area": "Tirukalilkundram",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.681,
                    "Long": 80.0844
                  },
                  {
                    "Area": "Tirukalukundram",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.5906,
                    "Long": 80.1309
                  },
                  {
                    "Area": "Tirukkoyilur",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.0647,
                    "Long": 79.4032
                  },
                  {
                    "Area": "Tirukkuvalai",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.2578,
                    "Long": 79.6343
                  },
                  {
                    "Area": "Tiruklalikundram",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.5029,
                    "Long": 80.0955
                  },
                  {
                    "Area": "Tirukuvalai",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.8494,
                    "Long": 79.7389
                  },
                  {
                    "Area": "Tiruldih",
                    "State": "Jharkhand",
                    "CountryCode": "IN",
                    "Lat": 23.1846,
                    "Long": 85.5947
                  },
                  {
                    "Area": "Tirulkalikundram",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.5906,
                    "Long": 80.0823
                  },
                  {
                    "Area": "Tirumalagiri",
                    "State": "Telangana",
                    "CountryCode": "IN",
                    "Lat": 17.6025,
                    "Long": 78.6839
                  },
                  {
                    "Area": "Tirumalgiri",
                    "State": "Telangana",
                    "CountryCode": "IN",
                    "Lat": 17.4999,
                    "Long": 79.939
                  },
                  {
                    "Area": "Tirumangalam",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 9.9355,
                    "Long": 78.1451
                  },
                  {
                    "Area": "Tirumangalam Taluk",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 9.7561,
                    "Long": 77.9748
                  },
                  {
                    "Area": "Tirumayaaam",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.3115,
                    "Long": 78.4691
                  },
                  {
                    "Area": "Tirumayaam",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.261,
                    "Long": 78.6824
                  },
                  {
                    "Area": "Tirumayam",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.6122,
                    "Long": 78.9415
                  },
                  {
                    "Area": "Tirunelvel;i",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 9.0617,
                    "Long": 77.6974
                  },
                  {
                    "Area": "Tirunelveli",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 9.1749,
                    "Long": 77.8517
                  },
                  {
                    "Area": "Tirupanandal",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.15,
                    "Long": 79.7389
                  },
                  {
                    "Area": "Tirupathur",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 13.0515,
                    "Long": 79.5064
                  },
                  {
                    "Area": "Tirupati",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 13.3724,
                    "Long": 78.5511
                  },
                  {
                    "Area": "Tirupati (Rural)",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 14.9764,
                    "Long": 79.5233
                  },
                  {
                    "Area": "Tirupati (Urban)",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 16.9362,
                    "Long": 81.2577
                  },
                  {
                    "Area": "Tirupati Rural",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 14.9764,
                    "Long": 79.5233
                  },
                  {
                    "Area": "Tirupattur",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.8247,
                    "Long": 79.0104
                  },
                  {
                    "Area": "Tiruporur",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.6952,
                    "Long": 80.0429
                  },
                  {
                    "Area": "Tiruppanandal",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.0213,
                    "Long": 79.3862
                  },
                  {
                    "Area": "Tiruppathur",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.4339,
                    "Long": 78.6934
                  },
                  {
                    "Area": "Tiruppattur",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.3216,
                    "Long": 78.7239
                  },
                  {
                    "Area": "Tiruppattur -singsmpunariblock",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.3055,
                    "Long": 78.4928
                  },
                  {
                    "Area": "Tiruppattur-",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.3867,
                    "Long": 78.4619
                  },
                  {
                    "Area": "Tiruppattur- Kallal Block",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.0783,
                    "Long": 78.6688
                  },
                  {
                    "Area": "Tiruppattur-singamounariblock",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.3055,
                    "Long": 78.4928
                  },
                  {
                    "Area": "Tiruppattur-singampunari Block",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.4156,
                    "Long": 78.5987
                  },
                  {
                    "Area": "Tiruppattur-singampunariblock",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.4156,
                    "Long": 78.4928
                  },
                  {
                    "Area": "Tiruppur",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.205,
                    "Long": 77.4991
                  },
                  {
                    "Area": "Tiruppuvanam",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 9.9846,
                    "Long": 78.1704
                  },
                  {
                    "Area": "Tirupur",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.5152,
                    "Long": 77.5795
                  },
                  {
                    "Area": "Tirur",
                    "State": "Kerala",
                    "CountryCode": "IN",
                    "Lat": 11.2101,
                    "Long": 76.2846
                  },
                  {
                    "Area": "Tirurangadi",
                    "State": "Kerala",
                    "CountryCode": "IN",
                    "Lat": 11.2727,
                    "Long": 76.2518
                  },
                  {
                    "Area": "Tirutani",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 13.2721,
                    "Long": 79.94
                  },
                  {
                    "Area": "Tiruttani",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 13.2431,
                    "Long": 79.94
                  },
                  {
                    "Area": "Tiruturaipundi",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.2578,
                    "Long": 79.7057
                  },
                  {
                    "Area": "Tiruturipundi",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.6374,
                    "Long": 79.6378
                  },
                  {
                    "Area": "Tiruvadanai",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.9995,
                    "Long": 79.2138
                  },
                  {
                    "Area": "Tiruvalla",
                    "State": "Kerala",
                    "CountryCode": "IN",
                    "Lat": 9.4404,
                    "Long": 76.929
                  },
                  {
                    "Area": "Tiruvallur",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 13.31,
                    "Long": 80.0441
                  },
                  {
                    "Area": "Tiruvanamalai",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.1105,
                    "Long": 79.2411
                  },
                  {
                    "Area": "Tiruvananamalai",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.3257,
                    "Long": 79.1511
                  },
                  {
                    "Area": "Tiruvananmalai",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.3812,
                    "Long": 79.0888
                  },
                  {
                    "Area": "Tiruvanathapuram",
                    "State": "Kerala",
                    "CountryCode": "IN",
                    "Lat": 8.5842,
                    "Long": 76.8766
                  },
                  {
                    "Area": "Tiruvannamaali",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.3812,
                    "Long": 79.0888
                  },
                  {
                    "Area": "Tiruvannamalai",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.5288,
                    "Long": 79.5023
                  },
                  {
                    "Area": "Tiruvannamalai Taluk",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.1302,
                    "Long": 79.2054
                  },
                  {
                    "Area": "Tiruvarur",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.9146,
                    "Long": 79.7788
                  },
                  {
                    "Area": "Tiruvidaimarudur",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.6716,
                    "Long": 79.2413
                  },
                  {
                    "Area": "Tiruvidamarudur",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.0923,
                    "Long": 79.5318
                  },
                  {
                    "Area": "Tiruvnamalai",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.4311,
                    "Long": 79.1677
                  },
                  {
                    "Area": "Tiruvnannamalai",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.2607,
                    "Long": 79.0515
                  },
                  {
                    "Area": "Tiruvottiyur",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 13.1582,
                    "Long": 80.3018
                  },
                  {
                    "Area": "Tiruvuru",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 17.093,
                    "Long": 80.6866
                  },
                  {
                    "Area": "Tiryani",
                    "State": "Telangana",
                    "CountryCode": "IN",
                    "Lat": 19.0479,
                    "Long": 79.1923
                  },
                  {
                    "Area": "Tisri",
                    "State": "Jharkhand",
                    "CountryCode": "IN",
                    "Lat": 24.6634,
                    "Long": 86.2512
                  },
                  {
                    "Area": "Tiswaddi",
                    "State": "Goa",
                    "CountryCode": "IN",
                    "Lat": 15.4723,
                    "Long": 73.8097
                  },
                  {
                    "Area": "Tiswadi",
                    "State": "Goa",
                    "CountryCode": "IN",
                    "Lat": 15.6235,
                    "Long": 73.984
                  },
                  {
                    "Area": "Titabor",
                    "State": "Assam",
                    "CountryCode": "IN",
                    "Lat": 26.8357,
                    "Long": 94.4744
                  },
                  {
                    "Area": "Titagarh]",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 22.7945,
                    "Long": 88.2769
                  },
                  {
                    "Area": "Titilagarh",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 21.1559,
                    "Long": 84.031
                  },
                  {
                    "Area": "Tittagudi",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.8666,
                    "Long": 79.4509
                  },
                  {
                    "Area": "Tittakudi",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.4445,
                    "Long": 79.2664
                  },
                  {
                    "Area": "Tiurkuvalai",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.6519,
                    "Long": 79.6929
                  },
                  {
                    "Area": "Tiurvallur",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.8985,
                    "Long": 79.8127
                  },
                  {
                    "Area": "Tizara",
                    "State": "Rajasthan",
                    "CountryCode": "IN",
                    "Lat": 28.0575,
                    "Long": 76.8949
                  },
                  {
                    "Area": "Tizit",
                    "State": "Nagaland",
                    "CountryCode": "IN",
                    "Lat": 26.3748,
                    "Long": 94.6222
                  },
                  {
                    "Area": "Tlangnuam",
                    "State": "Mizoram",
                    "CountryCode": "IN",
                    "Lat": 23.498,
                    "Long": 92.7292
                  },
                  {
                    "Area": "Tlangnuam (Part)",
                    "State": "Mizoram",
                    "CountryCode": "IN",
                    "Lat": 23.8106,
                    "Long": 92.8891
                  },
                  {
                    "Area": "Todabhim",
                    "State": "Rajasthan",
                    "CountryCode": "IN",
                    "Lat": 27.8021,
                    "Long": 76.9639
                  },
                  {
                    "Area": "Tohana",
                    "State": "Haryana",
                    "CountryCode": "IN",
                    "Lat": 29.7963,
                    "Long": 75.9044
                  },
                  {
                    "Area": "Tondiarpet Fort St George",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 13.1274,
                    "Long": 80.2886
                  },
                  {
                    "Area": "Tondur",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 14.6282,
                    "Long": 78.7836
                  },
                  {
                    "Area": "Tonk",
                    "State": "Rajasthan",
                    "CountryCode": "IN",
                    "Lat": 26.4856,
                    "Long": 76.2959
                  },
                  {
                    "Area": "Topsia",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 22.5668,
                    "Long": 88.3016
                  },
                  {
                    "Area": "Torpa",
                    "State": "Jharkhand",
                    "CountryCode": "IN",
                    "Lat": 23.511,
                    "Long": 85.5071
                  },
                  {
                    "Area": "Tosham",
                    "State": "Haryana",
                    "CountryCode": "IN",
                    "Lat": 28.8716,
                    "Long": 75.8278
                  },
                  {
                    "Area": "Totanala",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 22.3836,
                    "Long": 87.8747
                  },
                  {
                    "Area": "Toto",
                    "State": "Jharkhand",
                    "CountryCode": "IN",
                    "Lat": 23.178,
                    "Long": 84.5818
                  },
                  {
                    "Area": "Town Block Gaya",
                    "State": "Bihar",
                    "CountryCode": "IN",
                    "Lat": 24.9751,
                    "Long": 85.3115
                  },
                  {
                    "Area": "Town Thana Muzaffarpur",
                    "State": "Bihar",
                    "CountryCode": "IN",
                    "Lat": 25.4316,
                    "Long": 87.4771
                  },
                  {
                    "Area": "Tp Gudur",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 14.4081,
                    "Long": 80.1404
                  },
                  {
                    "Area": "Tral",
                    "State": "Jammu & Kashmir",
                    "CountryCode": "IN",
                    "Lat": 33.9271,
                    "Long": 75.1158
                  },
                  {
                    "Area": "Transport Nagar",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 26.418,
                    "Long": 80.298
                  },
                  {
                    "Area": "Tribeniganj",
                    "State": "Bihar",
                    "CountryCode": "IN",
                    "Lat": 26.1986,
                    "Long": 87.0615
                  },
                  {
                    "Area": "Trichy",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.3141,
                    "Long": 78.8823
                  },
                  {
                    "Area": "Trimabakeshwar",
                    "State": "Maharashtra",
                    "CountryCode": "IN",
                    "Lat": 20.4939,
                    "Long": 74.9598
                  },
                  {
                    "Area": "Trimbak",
                    "State": "Maharashtra",
                    "CountryCode": "IN",
                    "Lat": 20.1147,
                    "Long": 73.5291
                  },
                  {
                    "Area": "Trimbakeshwar",
                    "State": "Maharashtra",
                    "CountryCode": "IN",
                    "Lat": 20.6043,
                    "Long": 75.5251
                  },
                  {
                    "Area": "Tripuranthakam",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 16.0145,
                    "Long": 79.5357
                  },
                  {
                    "Area": "Trivandrum",
                    "State": "Kerala",
                    "CountryCode": "IN",
                    "Lat": 8.4467,
                    "Long": 76.9817
                  },
                  {
                    "Area": "Trivendrum",
                    "State": "Kerala",
                    "CountryCode": "IN",
                    "Lat": 8.9043,
                    "Long": 76.7984
                  },
                  {
                    "Area": "Triveniganj",
                    "State": "Bihar",
                    "CountryCode": "IN",
                    "Lat": 26.1293,
                    "Long": 86.9004
                  },
                  {
                    "Area": "Triveniganj",
                    "State": "Bihar",
                    "CountryCode": "IN",
                    "Lat": 26.2477,
                    "Long": 86.9717
                  },
                  {
                    "Area": "Trutani",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 13.2431,
                    "Long": 79.94
                  },
                  {
                    "Area": "Tseminyu",
                    "State": "Nagaland",
                    "CountryCode": "IN",
                    "Lat": 25.8908,
                    "Long": 94.2493
                  },
                  {
                    "Area": "Tsunduru",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 16.079,
                    "Long": 80.568
                  },
                  {
                    "Area": "Ttb",
                    "State": "Assam",
                    "CountryCode": "IN",
                    "Lat": 27.2498,
                    "Long": 94.7987
                  },
                  {
                    "Area": "Tthanesar",
                    "State": "Haryana",
                    "CountryCode": "IN",
                    "Lat": 30.1487,
                    "Long": 76.6856
                  },
                  {
                    "Area": "Tuensang",
                    "State": "Nagaland",
                    "CountryCode": "IN",
                    "Lat": 26.4339,
                    "Long": 94.9348
                  },
                  {
                    "Area": "Tufanganj",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 26.4213,
                    "Long": 89.8222
                  },
                  {
                    "Area": "Tufanganj - I",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 26.3599,
                    "Long": 89.5616
                  },
                  {
                    "Area": "Tufanganj - II",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 26.3771,
                    "Long": 89.7699
                  },
                  {
                    "Area": "Tufuria Kalmapur",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 22.033,
                    "Long": 87.1722
                  },
                  {
                    "Area": "Tuggali",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 15.5336,
                    "Long": 78.0061
                  },
                  {
                    "Area": "Tuichama",
                    "State": "Tripura",
                    "CountryCode": "IN",
                    "Lat": 23.9923,
                    "Long": 91.6205
                  },
                  {
                    "Area": "Tuini",
                    "State": "Uttarakhand",
                    "CountryCode": "IN",
                    "Lat": 30.8621,
                    "Long": 77.8182
                  },
                  {
                    "Area": "Tuipang",
                    "State": "Mizoram",
                    "CountryCode": "IN",
                    "Lat": 22.4918,
                    "Long": 93.0449
                  },
                  {
                    "Area": "Tulashikhar",
                    "State": "Tripura",
                    "CountryCode": "IN",
                    "Lat": 24.0796,
                    "Long": 91.5997
                  },
                  {
                    "Area": "Tuli",
                    "State": "Nagaland",
                    "CountryCode": "IN",
                    "Lat": 26.6645,
                    "Long": 94.7346
                  },
                  {
                    "Area": "Tulihal",
                    "State": "Manipur",
                    "CountryCode": "IN",
                    "Lat": 24.7538,
                    "Long": 93.8855
                  },
                  {
                    "Area": "Tulin",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 23.3807,
                    "Long": 85.9206
                  },
                  {
                    "Area": "Tuljapur",
                    "State": "Maharashtra",
                    "CountryCode": "IN",
                    "Lat": 18.5777,
                    "Long": 76.5082
                  },
                  {
                    "Area": "Tulluru",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 16.4875,
                    "Long": 80.6832
                  },
                  {
                    "Area": "Tulmulla",
                    "State": "Jammu & Kashmir",
                    "CountryCode": "IN",
                    "Lat": 34.1758,
                    "Long": 74.9148
                  },
                  {
                    "Area": "Tulsihatta",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 25.2142,
                    "Long": 87.8895
                  },
                  {
                    "Area": "Tulsipuir",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 27.485,
                    "Long": 82.3776
                  },
                  {
                    "Area": "Tulsipur",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 27.6975,
                    "Long": 82.7426
                  },
                  {
                    "Area": "Tumkur",
                    "State": "Karnataka",
                    "CountryCode": "IN",
                    "Lat": 14.0524,
                    "Long": 77.3081
                  },
                  {
                    "Area": "Tumna",
                    "State": "Haryana",
                    "CountryCode": "IN",
                    "Lat": 28.3498,
                    "Long": 76.5026
                  },
                  {
                    "Area": "Tumsar",
                    "State": "Maharashtra",
                    "CountryCode": "IN",
                    "Lat": 21.585,
                    "Long": 79.8758
                  },
                  {
                    "Area": "Tumudibandha",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 19.9791,
                    "Long": 83.6978
                  },
                  {
                    "Area": "Tumusingha",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 21.0647,
                    "Long": 85.5221
                  },
                  {
                    "Area": "Tundi",
                    "State": "Jharkhand",
                    "CountryCode": "IN",
                    "Lat": 24.0568,
                    "Long": 86.4719
                  },
                  {
                    "Area": "Tuni",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 17.4475,
                    "Long": 82.5461
                  },
                  {
                    "Area": "Tura",
                    "State": "Meghalaya",
                    "CountryCode": "IN",
                    "Lat": 25.7466,
                    "Long": 90.3804
                  },
                  {
                    "Area": "Turaiyur",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 11.5191,
                    "Long": 78.8161
                  },
                  {
                    "Area": "Turkagarh",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 22.3564,
                    "Long": 87.8021
                  },
                  {
                    "Area": "Turkaulia",
                    "State": "Bihar",
                    "CountryCode": "IN",
                    "Lat": 26.6184,
                    "Long": 84.9247
                  },
                  {
                    "Area": "Turrrur",
                    "State": "Telangana",
                    "CountryCode": "IN",
                    "Lat": 17.6085,
                    "Long": 79.6675
                  },
                  {
                    "Area": "Turrur",
                    "State": "Telangana",
                    "CountryCode": "IN",
                    "Lat": 17.6388,
                    "Long": 79.6943
                  },
                  {
                    "Area": "Turumella",
                    "State": "Andhra Pradesh",
                    "CountryCode": "IN",
                    "Lat": 16.4114,
                    "Long": 80.7253
                  },
                  {
                    "Area": "Turuvekere",
                    "State": "Karnataka",
                    "CountryCode": "IN",
                    "Lat": 14.3185,
                    "Long": 77.2668
                  },
                  {
                    "Area": "Tushkhali",
                    "State": "West Bengal",
                    "CountryCode": "IN",
                    "Lat": 22.3484,
                    "Long": 88.8997
                  },
                  {
                    "Area": "Tuslipur",
                    "State": "Uttar Pradesh",
                    "CountryCode": "IN",
                    "Lat": 27.2165,
                    "Long": 82.3883
                  },
                  {
                    "Area": "Tusra",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 21.4432,
                    "Long": 84.4255
                  },
                  {
                    "Area": "Tusura",
                    "State": "Odisha",
                    "CountryCode": "IN",
                    "Lat": 20.4464,
                    "Long": 83.5776
                  },
                  {
                    "Area": "Tuticorin",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 10.3813,
                    "Long": 78.8214
                  },
                  {
                    "Area": "Tuting",
                    "State": "Arunachal Pradesh",
                    "CountryCode": "IN",
                    "Lat": 28.9834,
                    "Long": 94.8568
                  },
                  {
                    "Area": "Tvamalai",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.2256,
                    "Long": 79.2322
                  },
                  {
                    "Area": "Tvmalai",
                    "State": "Tamil Nadu",
                    "CountryCode": "IN",
                    "Lat": 12.2256,
                    "Long": 79.2256
                  },
                  {
                    "Area": "Tyonda",
                    "State": "Madhya Pradesh",
                    "CountryCode": "IN",
                    "Lat": 23.776,
                    "Long": 78.2396
                  },
                  {
                    "Area": "Tyonda S.O",
                    "State": "Madhya Pradesh",
                    "CountryCode": "IN",
                    "Lat": 23.776,
                    "Long": 78.2396
                  },
                  {
                    "Area": "Tabora",
                    "Lat": "-5.02",
                    "Long": "32.8",
                    "CountryCode": "TZ"
                  },
                  {
                    "Area": "Tabriz",
                    "Lat": "38.0863",
                    "Long": "46.3012",
                    "CountryCode": "IR"
                  },
                  {
                    "Area": "Tabuk",
                    "Lat": "28.3838",
                    "Long": "36.555",
                    "CountryCode": "SA"
                  },
                  {
                    "Area": "Tacloban",
                    "Lat": "11.2504",
                    "Long": "125",
                    "CountryCode": "PH"
                  },
                  {
                    "Area": "Tacna",
                    "Lat": "-18",
                    "Long": "-70.25",
                    "CountryCode": "PE"
                  },
                  {
                    "Area": "Tacoma",
                    "Lat": "47.2431",
                    "Long": "-122.4531",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Tacuarembó",
                    "Lat": "-31.71",
                    "Long": "-55.98",
                    "CountryCode": "UY"
                  },
                  {
                    "Area": "Tadmur",
                    "Lat": "34.5504",
                    "Long": "38.2833",
                    "CountryCode": "SY"
                  },
                  {
                    "Area": "Taganrog",
                    "Lat": "47.23",
                    "Long": "38.92",
                    "CountryCode": "RU"
                  },
                  {
                    "Area": "Tahoua",
                    "Lat": "14.9",
                    "Long": "5.2599",
                    "CountryCode": "NE"
                  },
                  {
                    "Area": "Taian",
                    "Lat": "36.2",
                    "Long": "117.1201",
                    "CountryCode": "CN"
                  },
                  {
                    "Area": "Taichung",
                    "Lat": "24.1521",
                    "Long": "120.6817",
                    "CountryCode": "TW"
                  },
                  {
                    "Area": "Tailai",
                    "Lat": "46.3904",
                    "Long": "123.41",
                    "CountryCode": "CN"
                  },
                  {
                    "Area": "Tainan",
                    "Lat": "23",
                    "Long": "120.2",
                    "CountryCode": "TW"
                  },
                  {
                    "Area": "Taipei",
                    "Lat": "25.0358",
                    "Long": "121.5683",
                    "CountryCode": "TW"
                  },
                  {
                    "Area": "Taiping",
                    "Lat": "4.865",
                    "Long": "100.72",
                    "CountryCode": "MY"
                  },
                  {
                    "Area": "Taitung",
                    "Lat": "22.7554",
                    "Long": "121.14",
                    "CountryCode": "TW"
                  },
                  {
                    "Area": "Taiyuan",
                    "Lat": "37.875",
                    "Long": "112.5451",
                    "CountryCode": "CN"
                  },
                  {
                    "Area": "Taizhou",
                    "Lat": "32.4904",
                    "Long": "119.9",
                    "CountryCode": "CN"
                  },
                  {
                    "Area": "Taizz",
                    "Lat": "13.6045",
                    "Long": "44.0394",
                    "CountryCode": "YE"
                  },
                  {
                    "Area": "Takamatsu",
                    "Lat": "34.3447",
                    "Long": "134.0448",
                    "CountryCode": "JP"
                  },
                  {
                    "Area": "Takaoka",
                    "Lat": "36.67",
                    "Long": "137",
                    "CountryCode": "JP"
                  },
                  {
                    "Area": "Talara",
                    "Lat": "-4.58",
                    "Long": "-81.28",
                    "CountryCode": "PE"
                  },
                  {
                    "Area": "Talca",
                    "Lat": "-35.455",
                    "Long": "-71.67",
                    "CountryCode": "CL"
                  },
                  {
                    "Area": "Talcahuano",
                    "Lat": "-36.7167",
                    "Long": "-73.1167",
                    "CountryCode": "CL"
                  },
                  {
                    "Area": "Taldyqorghan",
                    "Lat": "45",
                    "Long": "78.4",
                    "CountryCode": "KZ"
                  },
                  {
                    "Area": "Tall Afar",
                    "Lat": "36.376",
                    "Long": "42.4497",
                    "CountryCode": "IQ"
                  },
                  {
                    "Area": "Tallahassee",
                    "Lat": "30.455",
                    "Long": "-84.2526",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Tallinn",
                    "Lat": "59.4339",
                    "Long": "24.728",
                    "CountryCode": "EE"
                  },
                  {
                    "Area": "Taloqan",
                    "Lat": "36.73",
                    "Long": "69.54",
                    "CountryCode": "AF"
                  },
                  {
                    "Area": "Tamale",
                    "Lat": "9.4004",
                    "Long": "-0.84",
                    "CountryCode": "GH"
                  },
                  {
                    "Area": "Tamanrasset",
                    "Lat": "22.785",
                    "Long": "5.5228",
                    "CountryCode": "DZ"
                  },
                  {
                    "Area": "Tamarac",
                    "Lat": "26.2058",
                    "Long": "-80.2547",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Tamazunchale",
                    "Lat": "21.2704",
                    "Long": "-98.78",
                    "CountryCode": "MX"
                  },
                  {
                    "Area": "Tambacounda",
                    "Lat": "13.7804",
                    "Long": "-13.68",
                    "CountryCode": "SN"
                  },
                  {
                    "Area": "Tambov",
                    "Lat": "52.73",
                    "Long": "41.43",
                    "CountryCode": "RU"
                  },
                  {
                    "Area": "Tampa",
                    "Lat": "27.9937",
                    "Long": "-82.4454",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Tampere",
                    "Lat": "61.5",
                    "Long": "23.75",
                    "CountryCode": "FI"
                  },
                  {
                    "Area": "Tampico",
                    "Lat": "22.3",
                    "Long": "-97.87",
                    "CountryCode": "MX"
                  },
                  {
                    "Area": "Tan An",
                    "Lat": "10.5337",
                    "Long": "106.4167",
                    "CountryCode": "VN"
                  },
                  {
                    "Area": "Tan Tan",
                    "Lat": "28.4304",
                    "Long": "-11.1",
                    "CountryCode": "MA"
                  },
                  {
                    "Area": "Tandil",
                    "Lat": "-37.32",
                    "Long": "-59.15",
                    "CountryCode": "AR"
                  },
                  {
                    "Area": "Tanga",
                    "Lat": "-5.07",
                    "Long": "39.09",
                    "CountryCode": "TZ"
                  },
                  {
                    "Area": "Tangail",
                    "Lat": "24.25",
                    "Long": "89.92",
                    "CountryCode": "BD"
                  },
                  {
                    "Area": "Tangier",
                    "Lat": "35.7473",
                    "Long": "-5.8327",
                    "CountryCode": "MA"
                  },
                  {
                    "Area": "Tangshan",
                    "Lat": "39.6243",
                    "Long": "118.1944",
                    "CountryCode": "CN"
                  },
                  {
                    "Area": "Tanjungpandan",
                    "Lat": "-2.75",
                    "Long": "107.65",
                    "CountryCode": "ID"
                  },
                  {
                    "Area": "Tanjungpinang",
                    "Lat": "0.9168",
                    "Long": "104.4714",
                    "CountryCode": "ID"
                  },
                  {
                    "Area": "Tanta",
                    "Lat": "30.7904",
                    "Long": "31",
                    "CountryCode": "EG"
                  },
                  {
                    "Area": "Taonan",
                    "Lat": "45.3304",
                    "Long": "122.78",
                    "CountryCode": "CN"
                  },
                  {
                    "Area": "Taoyuan",
                    "Lat": "24.9889",
                    "Long": "121.3111",
                    "CountryCode": "TW"
                  },
                  {
                    "Area": "Tapachula",
                    "Lat": "14.9",
                    "Long": "-92.27",
                    "CountryCode": "MX"
                  },
                  {
                    "Area": "Tarakan",
                    "Lat": "3.3",
                    "Long": "117.633",
                    "CountryCode": "ID"
                  },
                  {
                    "Area": "Taranto",
                    "Lat": "40.5084",
                    "Long": "17.23",
                    "CountryCode": "IT"
                  },
                  {
                    "Area": "Taraz",
                    "Lat": "42.9",
                    "Long": "71.365",
                    "CountryCode": "KZ"
                  },
                  {
                    "Area": "Tarbes",
                    "Lat": "43.2333",
                    "Long": "0.0833",
                    "CountryCode": "FR"
                  },
                  {
                    "Area": "Târgoviște",
                    "Lat": "44.938",
                    "Long": "25.459",
                    "CountryCode": "RO"
                  },
                  {
                    "Area": "Târgu Jiu",
                    "Lat": "45.045",
                    "Long": "23.274",
                    "CountryCode": "RO"
                  },
                  {
                    "Area": "Tarija",
                    "Lat": "-21.5167",
                    "Long": "-64.75",
                    "CountryCode": "BO"
                  },
                  {
                    "Area": "Tarlac",
                    "Lat": "15.4838",
                    "Long": "120.5834",
                    "CountryCode": "PH"
                  },
                  {
                    "Area": "Tarma",
                    "Lat": "-11.41",
                    "Long": "-75.73",
                    "CountryCode": "PE"
                  },
                  {
                    "Area": "Tarragona",
                    "Lat": "41.1204",
                    "Long": "1.25",
                    "CountryCode": "ES"
                  },
                  {
                    "Area": "Tarsus",
                    "Lat": "36.9204",
                    "Long": "34.88",
                    "CountryCode": "TR"
                  },
                  {
                    "Area": "Tartagal",
                    "Lat": "-22.55",
                    "Long": "-63.81",
                    "CountryCode": "AR"
                  },
                  {
                    "Area": "Tartu",
                    "Lat": "58.3839",
                    "Long": "26.7099",
                    "CountryCode": "EE"
                  },
                  {
                    "Area": "Tartus",
                    "Lat": "34.8846",
                    "Long": "35.8866",
                    "CountryCode": "SY"
                  },
                  {
                    "Area": "Tashkent",
                    "Lat": "41.3117",
                    "Long": "69.2949",
                    "CountryCode": "UZ"
                  },
                  {
                    "Area": "Tasikmalaya",
                    "Lat": "-7.3254",
                    "Long": "108.2147",
                    "CountryCode": "ID"
                  },
                  {
                    "Area": "Tatabánya",
                    "Lat": "47.55",
                    "Long": "18.433",
                    "CountryCode": "HU"
                  },
                  {
                    "Area": "Tataouine",
                    "Lat": "33",
                    "Long": "10.4667",
                    "CountryCode": "TN"
                  },
                  {
                    "Area": "Tatuí",
                    "Lat": "-23.35",
                    "Long": "-47.86",
                    "CountryCode": "BR"
                  },
                  {
                    "Area": "Tatvan",
                    "Lat": "38.5066",
                    "Long": "42.2816",
                    "CountryCode": "TR"
                  },
                  {
                    "Area": "Taubaté",
                    "Lat": "-23.0195",
                    "Long": "-45.56",
                    "CountryCode": "BR"
                  },
                  {
                    "Area": "Taunggyi",
                    "Lat": "20.782",
                    "Long": "97.038",
                    "CountryCode": "MM"
                  },
                  {
                    "Area": "Taungoo",
                    "Lat": "18.9483",
                    "Long": "96.4179",
                    "CountryCode": "MM"
                  },
                  {
                    "Area": "Taunton",
                    "Lat": "41.9036",
                    "Long": "-71.0943",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Tauranga",
                    "Lat": "-37.6964",
                    "Long": "176.1536",
                    "CountryCode": "NZ"
                  },
                  {
                    "Area": "Tawau",
                    "Lat": "4.271",
                    "Long": "117.896",
                    "CountryCode": "MY"
                  },
                  {
                    "Area": "Taxco",
                    "Lat": "18.5704",
                    "Long": "-99.62",
                    "CountryCode": "MX"
                  },
                  {
                    "Area": "Tây Ninh",
                    "Lat": "11.323",
                    "Long": "106.147",
                    "CountryCode": "VN"
                  },
                  {
                    "Area": "Taylor",
                    "Lat": "42.226",
                    "Long": "-83.2688",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Taylorsville",
                    "Lat": "40.6569",
                    "Long": "-111.9493",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Tayshet",
                    "Lat": "55.9277",
                    "Long": "97.9877",
                    "CountryCode": "RU"
                  },
                  {
                    "Area": "Taza",
                    "Lat": "34.2204",
                    "Long": "-4.02",
                    "CountryCode": "MA"
                  },
                  {
                    "Area": "Tbilisi",
                    "Lat": "41.725",
                    "Long": "44.7908",
                    "CountryCode": "GE"
                  },
                  {
                    "Area": "Tébessa",
                    "Lat": "35.4104",
                    "Long": "8.12",
                    "CountryCode": "DZ"
                  },
                  {
                    "Area": "Tebingtinggi",
                    "Lat": "3.3304",
                    "Long": "99.13",
                    "CountryCode": "ID"
                  },
                  {
                    "Area": "TecOM",
                    "Lat": "18.9204",
                    "Long": "-103.88",
                    "CountryCode": "MX"
                  },
                  {
                    "Area": "Tefé",
                    "Lat": "-3.36",
                    "Long": "-64.7",
                    "CountryCode": "BR"
                  },
                  {
                    "Area": "Tegal",
                    "Lat": "-6.8696",
                    "Long": "109.12",
                    "CountryCode": "ID"
                  },
                  {
                    "Area": "Tegucigalpa",
                    "Lat": "14.102",
                    "Long": "-87.2175",
                    "CountryCode": "HN"
                  },
                  {
                    "Area": "Tehran",
                    "Lat": "35.6719",
                    "Long": "51.4243",
                    "CountryCode": "IR"
                  },
                  {
                    "Area": "Tehuacan",
                    "Lat": "18.4504",
                    "Long": "-97.38",
                    "CountryCode": "MX"
                  },
                  {
                    "Area": "Tejen",
                    "Lat": "37.3786",
                    "Long": "60.496",
                    "CountryCode": "TM"
                  },
                  {
                    "Area": "Tekirdağ",
                    "Lat": "40.9909",
                    "Long": "27.51",
                    "CountryCode": "TR"
                  },
                  {
                    "Area": "Tel Aviv-Yafo",
                    "Lat": "32.08",
                    "Long": "34.77",
                    "CountryCode": "IL"
                  },
                  {
                    "Area": "Telêmaco Borba",
                    "Lat": "-24.33",
                    "Long": "-50.62",
                    "CountryCode": "BR"
                  },
                  {
                    "Area": "Teluk Intan",
                    "Lat": "4.0119",
                    "Long": "101.0314",
                    "CountryCode": "MY"
                  },
                  {
                    "Area": "Tema",
                    "Lat": "5.6404",
                    "Long": "0.01",
                    "CountryCode": "GH"
                  },
                  {
                    "Area": "Temecula",
                    "Lat": "33.4928",
                    "Long": "-117.1314",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Temirtau",
                    "Lat": "50.065",
                    "Long": "72.965",
                    "CountryCode": "KZ"
                  },
                  {
                    "Area": "Tempe",
                    "Lat": "33.3881",
                    "Long": "-111.9318",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Temple",
                    "Lat": "31.1076",
                    "Long": "-97.3894",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Temuco",
                    "Lat": "-38.73",
                    "Long": "-72.58",
                    "CountryCode": "CL"
                  },
                  {
                    "Area": "Tengchong",
                    "Lat": "25.0333",
                    "Long": "98.4666",
                    "CountryCode": "CN"
                  },
                  {
                    "Area": "Teófilo Otoni",
                    "Lat": "-17.87",
                    "Long": "-41.5",
                    "CountryCode": "BR"
                  },
                  {
                    "Area": "Tepic",
                    "Lat": "21.5054",
                    "Long": "-104.88",
                    "CountryCode": "MX"
                  },
                  {
                    "Area": "Teresina",
                    "Lat": "-5.095",
                    "Long": "-42.78",
                    "CountryCode": "BR"
                  },
                  {
                    "Area": "Termiz",
                    "Lat": "37.2329",
                    "Long": "67.2729",
                    "CountryCode": "UZ"
                  },
                  {
                    "Area": "Ternate",
                    "Lat": "0.793",
                    "Long": "127.363",
                    "CountryCode": "ID"
                  },
                  {
                    "Area": "Ternopil",
                    "Lat": "49.536",
                    "Long": "25.5821",
                    "CountryCode": "UA"
                  },
                  {
                    "Area": "Terre Haute",
                    "Lat": "39.4654",
                    "Long": "-87.3763",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Tete",
                    "Lat": "-16.17",
                    "Long": "33.58",
                    "CountryCode": "MZ"
                  },
                  {
                    "Area": "Tetovo",
                    "Lat": "42.0092",
                    "Long": "20.9701",
                    "CountryCode": "MK"
                  },
                  {
                    "Area": "Texarkana",
                    "Lat": "33.4487",
                    "Long": "-94.0815",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Texas City",
                    "Lat": "29.4128",
                    "Long": "-94.9658",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Teziutlán",
                    "Lat": "19.8204",
                    "Long": "-97.36",
                    "CountryCode": "MX"
                  },
                  {
                    "Area": "Thái Bình",
                    "Lat": "20.4503",
                    "Long": "106.333",
                    "CountryCode": "VN"
                  },
                  {
                    "Area": "Thái Nguyên",
                    "Lat": "21.6",
                    "Long": "105.83",
                    "CountryCode": "VN"
                  },
                  {
                    "Area": "Thakhek",
                    "Lat": "17.4112",
                    "Long": "104.8361",
                    "CountryCode": "LA"
                  },
                  {
                    "Area": "Thanh Hóa",
                    "Lat": "19.82",
                    "Long": "105.8",
                    "CountryCode": "VN"
                  },
                  {
                    "Area": "The Hague",
                    "Lat": "52.08",
                    "Long": "4.27",
                    "CountryCode": "NL"
                  },
                  {
                    "Area": "Thessaloniki",
                    "Lat": "40.6961",
                    "Long": "22.885",
                    "CountryCode": "GR"
                  },
                  {
                    "Area": "Thiès",
                    "Lat": "14.8104",
                    "Long": "-16.93",
                    "CountryCode": "SN"
                  },
                  {
                    "Area": "Thika",
                    "Lat": "-1.0396",
                    "Long": "37.09",
                    "CountryCode": "KE"
                  },
                  {
                    "Area": "Thimphu",
                    "Lat": "27.473",
                    "Long": "89.639",
                    "CountryCode": "BT"
                  },
                  {
                    "Area": "Thohoyandou",
                    "Lat": "-22.95",
                    "Long": "30.48",
                    "CountryCode": "ZA"
                  },
                  {
                    "Area": "Thongwa",
                    "Lat": "16.7547",
                    "Long": "96.5193",
                    "CountryCode": "MM"
                  },
                  {
                    "Area": "Thornton",
                    "Lat": "39.9205",
                    "Long": "-104.9443",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Thousand Oaks",
                    "Lat": "34.1914",
                    "Long": "-118.8755",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Thu Dau Mot",
                    "Lat": "10.9691",
                    "Long": "106.6527",
                    "CountryCode": "VN"
                  },
                  {
                    "Area": "Thunder Bay",
                    "Lat": "48.4462",
                    "Long": "-89.275",
                    "CountryCode": "CA"
                  },
                  {
                    "Area": "Tianjin",
                    "Lat": "39.13",
                    "Long": "117.2",
                    "CountryCode": "CN"
                  },
                  {
                    "Area": "Tianshui",
                    "Lat": "34.6",
                    "Long": "105.92",
                    "CountryCode": "CN"
                  },
                  {
                    "Area": "Tiarat",
                    "Lat": "35.3804",
                    "Long": "1.32",
                    "CountryCode": "DZ"
                  },
                  {
                    "Area": "Tidore",
                    "Lat": "0.6964",
                    "Long": "127.436",
                    "CountryCode": "ID"
                  },
                  {
                    "Area": "Tieli",
                    "Lat": "46.9504",
                    "Long": "128.05",
                    "CountryCode": "CN"
                  },
                  {
                    "Area": "Tieling",
                    "Lat": "42.3004",
                    "Long": "123.82",
                    "CountryCode": "CN"
                  },
                  {
                    "Area": "Tigard",
                    "Lat": "45.4237",
                    "Long": "-122.7844",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Tijuana",
                    "Lat": "32.5",
                    "Long": "-117.08",
                    "CountryCode": "MX"
                  },
                  {
                    "Area": "Tikhoretsk",
                    "Lat": "45.8531",
                    "Long": "40.1377",
                    "CountryCode": "RU"
                  },
                  {
                    "Area": "Tikhvin",
                    "Lat": "59.6448",
                    "Long": "33.5144",
                    "CountryCode": "RU"
                  },
                  {
                    "Area": "Tikrit",
                    "Lat": "34.597",
                    "Long": "43.677",
                    "CountryCode": "IQ"
                  },
                  {
                    "Area": "Timbaúba",
                    "Lat": "-7.4996",
                    "Long": "-35.32",
                    "CountryCode": "BR"
                  },
                  {
                    "Area": "Timbuktu",
                    "Lat": "16.7666",
                    "Long": "-3.0166",
                    "CountryCode": "ML"
                  },
                  {
                    "Area": "Timișoara",
                    "Lat": "45.7588",
                    "Long": "21.2234",
                    "CountryCode": "RO"
                  },
                  {
                    "Area": "Timon",
                    "Lat": "-5.115",
                    "Long": "-42.845",
                    "CountryCode": "BR"
                  },
                  {
                    "Area": "Tingo María",
                    "Lat": "-9.2896",
                    "Long": "-75.99",
                    "CountryCode": "PE"
                  },
                  {
                    "Area": "Tinley Park",
                    "Lat": "41.567",
                    "Long": "-87.8051",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "TIRa",
                    "Lat": "41.3275",
                    "Long": "19.8189",
                    "CountryCode": "AL"
                  },
                  {
                    "Area": "Tiraspol",
                    "Lat": "46.8531",
                    "Long": "29.64",
                    "CountryCode": "MD"
                  },
                  {
                    "Area": "Tirgu Mures",
                    "Lat": "46.5582",
                    "Long": "24.5578",
                    "CountryCode": "RO"
                  },
                  {
                    "Area": "Titusville",
                    "Lat": "28.5727",
                    "Long": "-80.8193",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Tizi-Ouzou",
                    "Lat": "36.8",
                    "Long": "4.0333",
                    "CountryCode": "DZ"
                  },
                  {
                    "Area": "Tiznit",
                    "Lat": "29.7104",
                    "Long": "-9.74",
                    "CountryCode": "MA"
                  },
                  {
                    "Area": "Tlaxcala",
                    "Lat": "19.32",
                    "Long": "-98.23",
                    "CountryCode": "MX"
                  },
                  {
                    "Area": "Tlimcen",
                    "Lat": "34.8904",
                    "Long": "-1.32",
                    "CountryCode": "DZ"
                  },
                  {
                    "Area": "Toamasina",
                    "Lat": "-18.1818",
                    "Long": "49.405",
                    "CountryCode": "MG"
                  },
                  {
                    "Area": "Tobolsk",
                    "Lat": "58.1998",
                    "Long": "68.2648",
                    "CountryCode": "RU"
                  },
                  {
                    "Area": "Tokar",
                    "Lat": "18.4333",
                    "Long": "37.7333",
                    "CountryCode": "SD"
                  },
                  {
                    "Area": "Tokat",
                    "Lat": "40.306",
                    "Long": "36.563",
                    "CountryCode": "TR"
                  },
                  {
                    "Area": "Tokmak",
                    "Lat": "42.8299",
                    "Long": "75.2846",
                    "CountryCode": "KG"
                  },
                  {
                    "Area": "Tokushima",
                    "Lat": "34.0674",
                    "Long": "134.5525",
                    "CountryCode": "JP"
                  },
                  {
                    "Area": "Tokyo",
                    "Lat": "35.685",
                    "Long": "139.7514",
                    "CountryCode": "JP"
                  },
                  {
                    "Area": "Toledo",
                    "Lat": "41.6639",
                    "Long": "-83.5822",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Toledo",
                    "Lat": "39.867",
                    "Long": "-4.0167",
                    "CountryCode": "ES"
                  },
                  {
                    "Area": "Toliara",
                    "Lat": "-23.3568",
                    "Long": "43.69",
                    "CountryCode": "MG"
                  },
                  {
                    "Area": "Toluca",
                    "Lat": "19.3304",
                    "Long": "-99.67",
                    "CountryCode": "MX"
                  },
                  {
                    "Area": "Tolyatti",
                    "Lat": "53.4804",
                    "Long": "49.53",
                    "CountryCode": "RU"
                  },
                  {
                    "Area": "Tomakomai",
                    "Lat": "42.6504",
                    "Long": "141.55",
                    "CountryCode": "JP"
                  },
                  {
                    "Area": "Tomsk",
                    "Lat": "56.495",
                    "Long": "84.975",
                    "CountryCode": "RU"
                  },
                  {
                    "Area": "Tongchuan",
                    "Lat": "35.08",
                    "Long": "109.03",
                    "CountryCode": "CN"
                  },
                  {
                    "Area": "Tongliao",
                    "Lat": "43.62",
                    "Long": "122.27",
                    "CountryCode": "CN"
                  },
                  {
                    "Area": "Tongling",
                    "Lat": "30.9504",
                    "Long": "117.78",
                    "CountryCode": "CN"
                  },
                  {
                    "Area": "Tongren",
                    "Lat": "27.6804",
                    "Long": "109.13",
                    "CountryCode": "CN"
                  },
                  {
                    "Area": "Toowoomba",
                    "Lat": "-27.5645",
                    "Long": "151.9555",
                    "CountryCode": "AU"
                  },
                  {
                    "Area": "Topeka",
                    "Lat": "39.0346",
                    "Long": "-95.6956",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Torbat-e Jam",
                    "Lat": "35.2233",
                    "Long": "60.6129",
                    "CountryCode": "IR"
                  },
                  {
                    "Area": "Toronto",
                    "Lat": "43.7",
                    "Long": "-79.42",
                    "CountryCode": "CA"
                  },
                  {
                    "Area": "Tororo",
                    "Lat": "0.7104",
                    "Long": "34.17",
                    "CountryCode": "UG"
                  },
                  {
                    "Area": "Torrance",
                    "Lat": "33.8346",
                    "Long": "-118.3417",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Torreón",
                    "Lat": "25.5701",
                    "Long": "-103.42",
                    "CountryCode": "MX"
                  },
                  {
                    "Area": "Totonicapán",
                    "Lat": "14.914",
                    "Long": "-91.358",
                    "CountryCode": "GT"
                  },
                  {
                    "Area": "Tottori",
                    "Lat": "35.5004",
                    "Long": "134.2333",
                    "CountryCode": "JP"
                  },
                  {
                    "Area": "Touggourt",
                    "Lat": "33.1",
                    "Long": "6.06",
                    "CountryCode": "DZ"
                  },
                  {
                    "Area": "Toulon",
                    "Lat": "43.1342",
                    "Long": "5.9188",
                    "CountryCode": "FR"
                  },
                  {
                    "Area": "Toulouse",
                    "Lat": "43.62",
                    "Long": "1.4499",
                    "CountryCode": "FR"
                  },
                  {
                    "Area": "Tours",
                    "Lat": "47.3804",
                    "Long": "0.6999",
                    "CountryCode": "FR"
                  },
                  {
                    "Area": "Townsville",
                    "Lat": "-19.25",
                    "Long": "146.77",
                    "CountryCode": "AU"
                  },
                  {
                    "Area": "Toyama",
                    "Lat": "36.7",
                    "Long": "137.23",
                    "CountryCode": "JP"
                  },
                  {
                    "Area": "Tra Vinh",
                    "Lat": "9.934",
                    "Long": "106.334",
                    "CountryCode": "VN"
                  },
                  {
                    "Area": "Trablous",
                    "Lat": "34.42",
                    "Long": "35.87",
                    "CountryCode": "LB"
                  },
                  {
                    "Area": "Trabzon",
                    "Lat": "40.98",
                    "Long": "39.72",
                    "CountryCode": "TR"
                  },
                  {
                    "Area": "Tracy",
                    "Lat": "37.726",
                    "Long": "-121.444",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Trang",
                    "Lat": "7.5634",
                    "Long": "99.608",
                    "CountryCode": "TH"
                  },
                  {
                    "Area": "Trelew",
                    "Lat": "-43.25",
                    "Long": "-65.33",
                    "CountryCode": "AR"
                  },
                  {
                    "Area": "Trento",
                    "Lat": "46.0804",
                    "Long": "11.12",
                    "CountryCode": "IT"
                  },
                  {
                    "Area": "Trenton",
                    "Lat": "40.2237",
                    "Long": "-74.764",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Três Lagoas",
                    "Lat": "-20.79",
                    "Long": "-51.72",
                    "CountryCode": "BR"
                  },
                  {
                    "Area": "Treviso",
                    "Lat": "45.67",
                    "Long": "12.24",
                    "CountryCode": "IT"
                  },
                  {
                    "Area": "Trieste",
                    "Lat": "45.6504",
                    "Long": "13.8",
                    "CountryCode": "IT"
                  },
                  {
                    "Area": "Trincomalee",
                    "Lat": "8.569",
                    "Long": "81.233",
                    "CountryCode": "LK"
                  },
                  {
                    "Area": "Trindade",
                    "Lat": "-16.65",
                    "Long": "-49.5",
                    "CountryCode": "BR"
                  },
                  {
                    "Area": "Trinidad",
                    "Lat": "-14.8334",
                    "Long": "-64.9",
                    "CountryCode": "BO"
                  },
                  {
                    "Area": "Tripoli",
                    "Lat": "32.8925",
                    "Long": "13.18",
                    "CountryCode": "LY"
                  },
                  {
                    "Area": "Trnava",
                    "Lat": "48.3666",
                    "Long": "17.6",
                    "CountryCode": "SK"
                  },
                  {
                    "Area": "Trois-Rivières",
                    "Lat": "46.35",
                    "Long": "-72.5499",
                    "CountryCode": "CA"
                  },
                  {
                    "Area": "Troitsk",
                    "Lat": "54.1056",
                    "Long": "61.5702",
                    "CountryCode": "RU"
                  },
                  {
                    "Area": "Tromsø",
                    "Lat": "69.6351",
                    "Long": "18.992",
                    "CountryCode": "NO"
                  },
                  {
                    "Area": "Trondheim",
                    "Lat": "63.4167",
                    "Long": "10.4167",
                    "CountryCode": "NO"
                  },
                  {
                    "Area": "Troy",
                    "Lat": "42.5818",
                    "Long": "-83.1457",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Troyes",
                    "Lat": "48.3404",
                    "Long": "4.0834",
                    "CountryCode": "FR"
                  },
                  {
                    "Area": "Truc Giang",
                    "Lat": "10.235",
                    "Long": "106.375",
                    "CountryCode": "VN"
                  },
                  {
                    "Area": "Trujillo",
                    "Lat": "-8.12",
                    "Long": "-79.02",
                    "CountryCode": "PE"
                  },
                  {
                    "Area": "Trujillo",
                    "Lat": "9.3804",
                    "Long": "-70.44",
                    "CountryCode": "VE"
                  },
                  {
                    "Area": "Tshikapa",
                    "Lat": "-6.41",
                    "Long": "20.77",
                    "CountryCode": "CD"
                  },
                  {
                    "Area": "Tsu",
                    "Lat": "34.7171",
                    "Long": "136.5167",
                    "CountryCode": "JP"
                  },
                  {
                    "Area": "Tsuruoka",
                    "Lat": "38.7004",
                    "Long": "139.8302",
                    "CountryCode": "JP"
                  },
                  {
                    "Area": "Tuapse",
                    "Lat": "44.1148",
                    "Long": "39.0644",
                    "CountryCode": "RU"
                  },
                  {
                    "Area": "Tuban",
                    "Lat": "-6.8995",
                    "Long": "112.05",
                    "CountryCode": "ID"
                  },
                  {
                    "Area": "Tubarão",
                    "Lat": "-28.48",
                    "Long": "-49.02",
                    "CountryCode": "BR"
                  },
                  {
                    "Area": "Tubruq",
                    "Lat": "32.08",
                    "Long": "23.96",
                    "CountryCode": "LY"
                  },
                  {
                    "Area": "Tucson",
                    "Lat": "32.1546",
                    "Long": "-110.8782",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Tucumán",
                    "Lat": "-26.816",
                    "Long": "-65.2166",
                    "CountryCode": "AR"
                  },
                  {
                    "Area": "Tucupita",
                    "Lat": "9.0605",
                    "Long": "-62.06",
                    "CountryCode": "VE"
                  },
                  {
                    "Area": "Tucuruí",
                    "Lat": "-3.68",
                    "Long": "-49.72",
                    "CountryCode": "BR"
                  },
                  {
                    "Area": "Tuguegarao",
                    "Lat": "17.6131",
                    "Long": "121.7269",
                    "CountryCode": "PH"
                  },
                  {
                    "Area": "Tukuyu",
                    "Lat": "-9.2496",
                    "Long": "33.64",
                    "CountryCode": "TZ"
                  },
                  {
                    "Area": "Tula",
                    "Lat": "54.2",
                    "Long": "37.6299",
                    "CountryCode": "RU"
                  },
                  {
                    "Area": "Tulare",
                    "Lat": "36.1996",
                    "Long": "-119.34",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Tulcán",
                    "Lat": "0.822",
                    "Long": "-77.732",
                    "CountryCode": "EC"
                  },
                  {
                    "Area": "Tulcea",
                    "Lat": "45.1993",
                    "Long": "28.7967",
                    "CountryCode": "RO"
                  },
                  {
                    "Area": "Tulsa",
                    "Lat": "36.1284",
                    "Long": "-95.9042",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Tuluá",
                    "Lat": "4.0904",
                    "Long": "-76.21",
                    "CountryCode": "CO"
                  },
                  {
                    "Area": "Tulun",
                    "Lat": "54.5653",
                    "Long": "100.5654",
                    "CountryCode": "RU"
                  },
                  {
                    "Area": "Tumaco",
                    "Lat": "1.81",
                    "Long": "-78.81",
                    "CountryCode": "CO"
                  },
                  {
                    "Area": "Tumbes",
                    "Lat": "-3.57",
                    "Long": "-80.46",
                    "CountryCode": "PE"
                  },
                  {
                    "Area": "Tumen",
                    "Lat": "42.97",
                    "Long": "129.8201",
                    "CountryCode": "CN"
                  },
                  {
                    "Area": "Tunis",
                    "Lat": "36.8028",
                    "Long": "10.1797",
                    "CountryCode": "TN"
                  },
                  {
                    "Area": "Tunja",
                    "Lat": "5.5504",
                    "Long": "-73.37",
                    "CountryCode": "CO"
                  },
                  {
                    "Area": "Tupã",
                    "Lat": "-21.93",
                    "Long": "-50.52",
                    "CountryCode": "BR"
                  },
                  {
                    "Area": "Turbat",
                    "Lat": "25.9918",
                    "Long": "63.0718",
                    "CountryCode": "PK"
                  },
                  {
                    "Area": "Turbo",
                    "Lat": "8.1004",
                    "Long": "-76.74",
                    "CountryCode": "CO"
                  },
                  {
                    "Area": "Turin",
                    "Lat": "45.0704",
                    "Long": "7.67",
                    "CountryCode": "IT"
                  },
                  {
                    "Area": "Turkistan",
                    "Lat": "43.3016",
                    "Long": "68.2549",
                    "CountryCode": "KZ"
                  },
                  {
                    "Area": "Türkmenabat",
                    "Lat": "39.11",
                    "Long": "63.58",
                    "CountryCode": "TM"
                  },
                  {
                    "Area": "Türkmenbaşy",
                    "Lat": "40.023",
                    "Long": "52.9697",
                    "CountryCode": "TM"
                  },
                  {
                    "Area": "Turku",
                    "Lat": "60.4539",
                    "Long": "22.255",
                    "CountryCode": "FI"
                  },
                  {
                    "Area": "Turlock",
                    "Lat": "37.5053",
                    "Long": "-120.8588",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Turnovo",
                    "Lat": "43.0862",
                    "Long": "25.6555",
                    "CountryCode": "BG"
                  },
                  {
                    "Area": "Turpan",
                    "Lat": "42.9354",
                    "Long": "89.165",
                    "CountryCode": "CN"
                  },
                  {
                    "Area": "Tuscaloosa",
                    "Lat": "33.2349",
                    "Long": "-87.5267",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Tustin",
                    "Lat": "33.7309",
                    "Long": "-117.8106",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Tuxpam",
                    "Lat": "20.9604",
                    "Long": "-97.41",
                    "CountryCode": "MX"
                  },
                  {
                    "Area": "Tuxtla Gutiérrez",
                    "Lat": "16.75",
                    "Long": "-93.15",
                    "CountryCode": "MX"
                  },
                  {
                    "Area": "Tuy Hòa",
                    "Lat": "13.082",
                    "Long": "109.316",
                    "CountryCode": "VN"
                  },
                  {
                    "Area": "Tuymazy",
                    "Lat": "54.6048",
                    "Long": "53.6943",
                    "CountryCode": "RU"
                  },
                  {
                    "Area": "Tuzla",
                    "Lat": "44.5505",
                    "Long": "18.68",
                    "CountryCode": "BA"
                  },
                  {
                    "Area": "Tver",
                    "Lat": "56.86",
                    "Long": "35.89",
                    "CountryCode": "RU"
                  },
                  {
                    "Area": "Twin Falls",
                    "Lat": "42.5645",
                    "Long": "-114.4611",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Tyler",
                    "Lat": "32.3184",
                    "Long": "-95.3065",
                    "CountryCode": "US"
                  },
                  {
                    "Area": "Tyumen",
                    "Lat": "57.14",
                    "Long": "65.53",
                    "CountryCode": "RU"
                  },
                  {
                    "Area": "Tzaneen",
                    "Lat": "-23.8195",
                    "Long": "30.17",
                    "CountryCode": "ZA"
                  },
                  
                    {
                      "Area": ".",
                      "State": "Tripura",
                      "CountryCode": "IN",
                      "Lat": 23.6622,
                      "Long": 91.3881
                    },
                    {
                      "Area": "24 Pgs North",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 22.6,
                      "Long": 88.4
                    },
                    {
                      "Area": "24 Prgs (South)",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 22.4839,
                      "Long": 88.3038
                    },
                    {
                      "Area": "U.varam(mdl)",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.7866,
                      "Long": 81.7228
                    },
                    {
                      "Area": "Ucc",
                      "State": "Meghalaya",
                      "CountryCode": "IN",
                      "Lat": 25.5333,
                      "Long": 91.6473
                    },
                    {
                      "Area": "Uchchhal",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 21.5979,
                      "Long": 73.7167
                    },
                    {
                      "Area": "Uchildah",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 22.4784,
                      "Long": 88.5822
                    },
                    {
                      "Area": "Uchudiha",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 22.3836,
                      "Long": 87.8747
                    },
                    {
                      "Area": "Uda Kishanganj",
                      "State": "Bihar",
                      "CountryCode": "IN",
                      "Lat": 25.8093,
                      "Long": 87.0163
                    },
                    {
                      "Area": "Udaamalpet",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 10.6405,
                      "Long": 77.226
                    },
                    {
                      "Area": "Udagamandalam",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 11.5682,
                      "Long": 76.8562
                    },
                    {
                      "Area": "Udail;urwati",
                      "State": "Rajasthan",
                      "CountryCode": "IN",
                      "Lat": 26.9265,
                      "Long": 75.0661
                    },
                    {
                      "Area": "Udailpurwati",
                      "State": "Rajasthan",
                      "CountryCode": "IN",
                      "Lat": 28.0919,
                      "Long": 75.5524
                    },
                    {
                      "Area": "Udaip;urwati",
                      "State": "Rajasthan",
                      "CountryCode": "IN",
                      "Lat": 26.9265,
                      "Long": 75.0661
                    },
                    {
                      "Area": "Udaiplurwati",
                      "State": "Rajasthan",
                      "CountryCode": "IN",
                      "Lat": 27.2612,
                      "Long": 75.967
                    },
                    {
                      "Area": "Udaiprwati",
                      "State": "Rajasthan",
                      "CountryCode": "IN",
                      "Lat": 25.9321,
                      "Long": 75.8057
                    },
                    {
                      "Area": "Udaipur",
                      "State": "Rajasthan",
                      "CountryCode": "IN",
                      "Lat": 24.5712,
                      "Long": 73.6915
                    },
                    {
                      "Area": "Udaipur",
                      "State": "Uttar Pradesh",
                      "CountryCode": "IN",
                      "Lat": 26.3805,
                      "Long": 80.2158
                    },
                    {
                      "Area": "Udaipur",
                      "State": "Himachal Pradesh",
                      "CountryCode": "IN",
                      "Lat": 32.8274,
                      "Long": 76.7485
                    },
                    {
                      "Area": "Udaipur",
                      "State": "Tripura",
                      "CountryCode": "IN",
                      "Lat": 23.7062,
                      "Long": 91.4203
                    },
                    {
                      "Area": "Udaipur (Dharamjaigarh)",
                      "State": "Chattisgarh",
                      "CountryCode": "IN",
                      "Lat": 23.2948,
                      "Long": 83.9171
                    },
                    {
                      "Area": "Udaipura",
                      "State": "Madhya Pradesh",
                      "CountryCode": "IN",
                      "Lat": 23.2449,
                      "Long": 78.774
                    },
                    {
                      "Area": "Udaipurwati",
                      "State": "Rajasthan",
                      "CountryCode": "IN",
                      "Lat": 28.3197,
                      "Long": 75.967
                    },
                    {
                      "Area": "Udaiurwati",
                      "State": "Rajasthan",
                      "CountryCode": "IN",
                      "Lat": 27.1834,
                      "Long": 75.6957
                    },
                    {
                      "Area": "Udakisanganj",
                      "State": "Bihar",
                      "CountryCode": "IN",
                      "Lat": 25.8838,
                      "Long": 86.8176
                    },
                    {
                      "Area": "Udakishanganj",
                      "State": "Bihar",
                      "CountryCode": "IN",
                      "Lat": 25.9153,
                      "Long": 87.0163
                    },
                    {
                      "Area": "Udakishunganj",
                      "State": "Bihar",
                      "CountryCode": "IN",
                      "Lat": 25.6768,
                      "Long": 86.941
                    },
                    {
                      "Area": "Udala",
                      "State": "Odisha",
                      "CountryCode": "IN",
                      "Lat": 22.0209,
                      "Long": 86.7428
                    },
                    {
                      "Area": "Udalguri",
                      "State": "Assam",
                      "CountryCode": "IN",
                      "Lat": 26.7537,
                      "Long": 92.1021
                    },
                    {
                      "Area": "Udamalpet",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 11.093,
                      "Long": 77.5598
                    },
                    {
                      "Area": "Udamalpet Ho",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 10.6355,
                      "Long": 77.2414
                    },
                    {
                      "Area": "Udayagiri",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.9912,
                      "Long": 79.7344
                    },
                    {
                      "Area": "Udayarpalayam",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 11.4068,
                      "Long": 79.4893
                    },
                    {
                      "Area": "Udbadal",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 22.0093,
                      "Long": 87.7037
                    },
                    {
                      "Area": "Udgir",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 18.6554,
                      "Long": 77.1176
                    },
                    {
                      "Area": "Udhagamandalam",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 11.5682,
                      "Long": 76.7769
                    },
                    {
                      "Area": "Udhampur",
                      "State": "Jammu & Kashmir",
                      "CountryCode": "IN",
                      "Lat": 33.2497,
                      "Long": 75.5146
                    },
                    {
                      "Area": "Udhna",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 21.1333,
                      "Long": 72.8179
                    },
                    {
                      "Area": "Udhua",
                      "State": "Jharkhand",
                      "CountryCode": "IN",
                      "Lat": 24.7465,
                      "Long": 87.7409
                    },
                    {
                      "Area": "Udhwa",
                      "State": "Jharkhand",
                      "CountryCode": "IN",
                      "Lat": 24.7465,
                      "Long": 87.4117
                    },
                    {
                      "Area": "Udumalaipettai",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 11.0299,
                      "Long": 77.439
                    },
                    {
                      "Area": "Udumbanchola",
                      "State": "Kerala",
                      "CountryCode": "IN",
                      "Lat": 10.0777,
                      "Long": 77.2199
                    },
                    {
                      "Area": "Udupi",
                      "State": "Karnataka",
                      "CountryCode": "IN",
                      "Lat": 13.6874,
                      "Long": 76.0116
                    },
                    {
                      "Area": "Udwant Nagar",
                      "State": "Bihar",
                      "CountryCode": "IN",
                      "Lat": 25.4512,
                      "Long": 84.6874
                    },
                    {
                      "Area": "Uedhua",
                      "State": "Jharkhand",
                      "CountryCode": "IN",
                      "Lat": 24.6552,
                      "Long": 87.7409
                    },
                    {
                      "Area": "Uedhwa",
                      "State": "Jharkhand",
                      "CountryCode": "IN",
                      "Lat": 24.6552,
                      "Long": 87.7409
                    },
                    {
                      "Area": "Ugrasenpur",
                      "State": "Uttar Pradesh",
                      "CountryCode": "IN",
                      "Lat": 25.5611,
                      "Long": 82.1872
                    },
                    {
                      "Area": "Ujandodhpur",
                      "State": "Tripura",
                      "CountryCode": "IN",
                      "Lat": 24.1048,
                      "Long": 92.0073
                    },
                    {
                      "Area": "Ujjain",
                      "State": "Madhya Pradesh",
                      "CountryCode": "IN",
                      "Lat": 23.4977,
                      "Long": 76.1767
                    },
                    {
                      "Area": "Ukhrul",
                      "State": "Manipur",
                      "CountryCode": "IN",
                      "Lat": 25.6223,
                      "Long": 94.541
                    },
                    {
                      "Area": "Ulabari",
                      "State": "Assam",
                      "CountryCode": "IN",
                      "Lat": 26.3796,
                      "Long": 91.2951
                    },
                    {
                      "Area": "Ullunda",
                      "State": "Odisha",
                      "CountryCode": "IN",
                      "Lat": 20.9615,
                      "Long": 85.3819
                    },
                    {
                      "Area": "Uluberia - I",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 23.2934,
                      "Long": 88.7067
                    },
                    {
                      "Area": "Uluberia - II",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 23.2934,
                      "Long": 88.5234
                    },
                    {
                      "Area": "Uluberia,Howrah",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 23.0454,
                      "Long": 88.0481
                    },
                    {
                      "Area": "Uludanga",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 23.8794,
                      "Long": 88.2197
                    },
                    {
                      "Area": "Ulundurpet",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 12.2935,
                      "Long": 79.656
                    },
                    {
                      "Area": "Ulundurpettai",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 11.7902,
                      "Long": 79.3637
                    },
                    {
                      "Area": "Umarga",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 17.891,
                      "Long": 76.6712
                    },
                    {
                      "Area": "Umargam",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 21.8727,
                      "Long": 73.4056
                    },
                    {
                      "Area": "Umargarm",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 20.4394,
                      "Long": 73.0413
                    },
                    {
                      "Area": "Umari",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 19.3247,
                      "Long": 77.7826
                    },
                    {
                      "Area": "Umaria",
                      "State": "Madhya Pradesh",
                      "CountryCode": "IN",
                      "Lat": 24.0154,
                      "Long": 81.1238
                    },
                    {
                      "Area": "Umarkhed",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 19.7535,
                      "Long": 78.1181
                    },
                    {
                      "Area": "Umarkote",
                      "State": "Odisha",
                      "CountryCode": "IN",
                      "Lat": 19.7709,
                      "Long": 82.7915
                    },
                    {
                      "Area": "Umarpada",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 22.066,
                      "Long": 73.9351
                    },
                    {
                      "Area": "Umbergaon",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 21.8727,
                      "Long": 73.4056
                    },
                    {
                      "Area": "Umerkhed",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 20.272,
                      "Long": 78.1622
                    },
                    {
                      "Area": "Umerkote",
                      "State": "Odisha",
                      "CountryCode": "IN",
                      "Lat": 20.9139,
                      "Long": 84.4388
                    },
                    {
                      "Area": "Umiam",
                      "State": "Meghalaya",
                      "CountryCode": "IN",
                      "Lat": 25.6938,
                      "Long": 92.0758
                    },
                    {
                      "Area": "Umrala",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 21.8813,
                      "Long": 72.6803
                    },
                    {
                      "Area": "Umred",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 21.1763,
                      "Long": 79.4236
                    },
                    {
                      "Area": "Umrer",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 21.1763,
                      "Long": 79.4027
                    },
                    {
                      "Area": "Umreth",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 22.9494,
                      "Long": 73.4051
                    },
                    {
                      "Area": "Umsaw",
                      "State": "Meghalaya",
                      "CountryCode": "IN",
                      "Lat": 25.5333,
                      "Long": 91.6473
                    },
                    {
                      "Area": "Umsning",
                      "State": "Meghalaya",
                      "CountryCode": "IN",
                      "Lat": 25.8095,
                      "Long": 92.0779
                    },
                    {
                      "Area": "Una",
                      "State": "Himachal Pradesh",
                      "CountryCode": "IN",
                      "Lat": 31.6587,
                      "Long": 77.2597
                    },
                    {
                      "Area": "Una",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 21.2215,
                      "Long": 71.1481
                    },
                    {
                      "Area": "Una(T)",
                      "State": "Himachal Pradesh",
                      "CountryCode": "IN",
                      "Lat": 31.5807,
                      "Long": 76.912
                    },
                    {
                      "Area": "Unchahar",
                      "State": "Uttar Pradesh",
                      "CountryCode": "IN",
                      "Lat": 26.2958,
                      "Long": 82.0304
                    },
                    {
                      "Area": "Unchahar **",
                      "State": "Uttar Pradesh",
                      "CountryCode": "IN",
                      "Lat": 26.3247,
                      "Long": 82.0304
                    },
                    {
                      "Area": "Unchehara",
                      "State": "Madhya Pradesh",
                      "CountryCode": "IN",
                      "Lat": 24.4195,
                      "Long": 80.7799
                    },
                    {
                      "Area": "Undi (mdl)",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.5854,
                      "Long": 81.4621
                    },
                    {
                      "Area": "Undi Mandalam",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 17.5283,
                      "Long": 82.307
                    },
                    {
                      "Area": "Undrajavaram Mandalam",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.8436,
                      "Long": 81.688
                    },
                    {
                      "Area": "Undrajavaram Mandalam.",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.837,
                      "Long": 81.6741
                    },
                    {
                      "Area": "Unjha",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 24.2088,
                      "Long": 72.9726
                    },
                    {
                      "Area": "Unna",
                      "State": "Uttar Pradesh",
                      "CountryCode": "IN",
                      "Lat": 26.6058,
                      "Long": 80.8772
                    },
                    {
                      "Area": "Unnaao",
                      "State": "Uttar Pradesh",
                      "CountryCode": "IN",
                      "Lat": 26.2786,
                      "Long": 80.8227
                    },
                    {
                      "Area": "Unnao",
                      "State": "Uttar Pradesh",
                      "CountryCode": "IN",
                      "Lat": 27.2586,
                      "Long": 82.9176
                    },
                    {
                      "Area": "Unokoti",
                      "State": "Tripura",
                      "CountryCode": "IN",
                      "Lat": 24.1597,
                      "Long": 92.0329
                    },
                    {
                      "Area": "Unreth",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 22.9494,
                      "Long": 73.2175
                    },
                    {
                      "Area": "Uparjagatpur",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 22.8223,
                      "Long": 87.5059
                    },
                    {
                      "Area": "Upleta",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 22.2628,
                      "Long": 71.5304
                    },
                    {
                      "Area": "Uppal",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.4447,
                      "Long": 78.5719
                    },
                    {
                      "Area": "Uppalaguptam",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 17.1885,
                      "Long": 82.0975
                    },
                    {
                      "Area": "Uppalaguptam Mandal",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.5533,
                      "Long": 82.0975
                    },
                    {
                      "Area": "Uppalaguptan Mandal",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.5533,
                      "Long": 82.0975
                    },
                    {
                      "Area": "Uppanunthala",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 16.441,
                      "Long": 78.6529
                    },
                    {
                      "Area": "Upper Shillong",
                      "State": "Meghalaya",
                      "CountryCode": "IN",
                      "Lat": 25.5644,
                      "Long": 91.8312
                    },
                    {
                      "Area": "Uppununthala",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 16.441,
                      "Long": 78.6529
                    },
                    {
                      "Area": "Uppunuthala",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 16.434,
                      "Long": 78.4585
                    },
                    {
                      "Area": "Uptakhali",
                      "State": "Tripura",
                      "CountryCode": "IN",
                      "Lat": 24.1597,
                      "Long": 92.0329
                    },
                    {
                      "Area": "Uran",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 19.5495,
                      "Long": 74.7128
                    },
                    {
                      "Area": "Uravakonda",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.966,
                      "Long": 77.4081
                    },
                    {
                      "Area": "Urban Estate",
                      "State": "Haryana",
                      "CountryCode": "IN",
                      "Lat": 28.418,
                      "Long": 76.9839
                    },
                    {
                      "Area": "Urdhabpur",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 22.3159,
                      "Long": 88.0212
                    },
                    {
                      "Area": "Uri",
                      "State": "Jammu & Kashmir",
                      "CountryCode": "IN",
                      "Lat": 34.3229,
                      "Long": 74.4722
                    },
                    {
                      "Area": "Urttar Kashipur",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 22.5864,
                      "Long": 88.4145
                    },
                    {
                      "Area": "Ururi",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 22.3836,
                      "Long": 87.8747
                    },
                    {
                      "Area": "Usilampatti",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 10.3958,
                      "Long": 78.5422
                    },
                    {
                      "Area": "Usthi",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 22.415,
                      "Long": 88.307
                    },
                    {
                      "Area": "Ut Of Pondichery",
                      "State": "Pondicherry",
                      "CountryCode": "IN",
                      "Lat": 11.7017,
                      "Long": 75.5347
                    },
                    {
                      "Area": "Uthamapalayam",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 9.9603,
                      "Long": 77.7791
                    },
                    {
                      "Area": "Uthangarai",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 12.2616,
                      "Long": 78.3755
                    },
                    {
                      "Area": "Uthiramerur",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 12.7022,
                      "Long": 79.9764
                    },
                    {
                      "Area": "Uthukkottai",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 13.3021,
                      "Long": 79.9242
                    },
                    {
                      "Area": "Utiramerur",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 12.6701,
                      "Long": 79.8913
                    },
                    {
                      "Area": "Utnoor",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 19.5403,
                      "Long": 79.0567
                    },
                    {
                      "Area": "Utraula",
                      "State": "Uttar Pradesh",
                      "CountryCode": "IN",
                      "Lat": 27.485,
                      "Long": 82.6808
                    },
                    {
                      "Area": "Uttangarai",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 12.5293,
                      "Long": 78.5856
                    },
                    {
                      "Area": "Uttar Amtalia",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 22.4305,
                      "Long": 87.4447
                    },
                    {
                      "Area": "Uttar Asda",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 21.9467,
                      "Long": 87.4938
                    },
                    {
                      "Area": "Uttar Badalpur",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 22.871,
                      "Long": 88.0316
                    },
                    {
                      "Area": "Uttar Dhanicherra",
                      "State": "Tripura",
                      "CountryCode": "IN",
                      "Lat": 24.1597,
                      "Long": 92.0329
                    },
                    {
                      "Area": "Uttar Dumurkhola",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 22.4364,
                      "Long": 87.9624
                    },
                    {
                      "Area": "Uttar Gobindapur",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 21.7344,
                      "Long": 87.5491
                    },
                    {
                      "Area": "Uttar Kalamdan",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 23.5034,
                      "Long": 87.9832
                    },
                    {
                      "Area": "Uttar Kanpur",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 21.7344,
                      "Long": 87.5491
                    },
                    {
                      "Area": "Uttar Lakshmipur",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 25.1367,
                      "Long": 88.0923
                    },
                    {
                      "Area": "Uttar Ranibarh",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 22.6315,
                      "Long": 87.428
                    },
                    {
                      "Area": "Uttar-tajpur",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 22.3159,
                      "Long": 88.0212
                    },
                    {
                      "Area": "Uttarchebri",
                      "State": "Tripura",
                      "CountryCode": "IN",
                      "Lat": 24.019,
                      "Long": 91.625
                    },
                    {
                      "Area": "Uttarharaschak",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 21.7907,
                      "Long": 87.8635
                    },
                    {
                      "Area": "Uttaripura",
                      "State": "Uttar Pradesh",
                      "CountryCode": "IN",
                      "Lat": 27.11,
                      "Long": 79.8571
                    },
                    {
                      "Area": "Uttarkashi",
                      "State": "Uttarakhand",
                      "CountryCode": "IN",
                      "Lat": 30.9731,
                      "Long": 79.1165
                    },
                    {
                      "Area": "Uttarkasshi",
                      "State": "Uttarakhand",
                      "CountryCode": "IN",
                      "Lat": 30.7404,
                      "Long": 78.7438
                    },
                    {
                      "Area": "Uttarlaljuri",
                      "State": "Tripura",
                      "CountryCode": "IN",
                      "Lat": 23.6526,
                      "Long": 91.2372
                    },
                    {
                      "Area": "Uttarpara",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 22.8847,
                      "Long": 88.0798
                    },
                    {
                      "Area": "Uttiramerur",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 12.7834,
                      "Long": 79.9764
                    },
                    {
                      "Area": "Uttrkashi",
                      "State": "Uttarakhand",
                      "CountryCode": "IN",
                      "Lat": 30.9052,
                      "Long": 78.6794
                    },
                    {
                      "Area": "Uttukottai",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 13.3336,
                      "Long": 80.0405
                    },
                    {
                      "Area": "Uunao",
                      "State": "Uttar Pradesh",
                      "CountryCode": "IN",
                      "Lat": 26.5302,
                      "Long": 80.799
                    },
                    {
                      "Area": "V",
                      "State": "Madhya Pradesh",
                      "CountryCode": "IN",
                      "Lat": 24.0819,
                      "Long": 81.188
                    },
                    {
                      "Area": "V R Puram",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.7712,
                      "Long": 80.9568
                    },
                    {
                      "Area": "V.Madugula",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 17.8961,
                      "Long": 82.8548
                    },
                    {
                      "Area": "VR puram",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 17.1885,
                      "Long": 82.0118
                    },
                    {
                      "Area": "Vada",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 19.7101,
                      "Long": 73.3095
                    },
                    {
                      "Area": "Vadagam",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 23.865,
                      "Long": 72.5427
                    },
                    {
                      "Area": "Vadakara",
                      "State": "Kerala",
                      "CountryCode": "IN",
                      "Lat": 11.7714,
                      "Long": 76.1471
                    },
                    {
                      "Area": "Vadali",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 24.0199,
                      "Long": 73.1637
                    },
                    {
                      "Area": "Vadamalapeta",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 13.7037,
                      "Long": 79.5316
                    },
                    {
                      "Area": "Vadamalpet",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 13.7037,
                      "Long": 79.5316
                    },
                    {
                      "Area": "Vadgam",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 24.3297,
                      "Long": 72.6371
                    },
                    {
                      "Area": "Vadipatti",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 10.9892,
                      "Long": 78.5422
                    },
                    {
                      "Area": "Vadnabar",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 23.405,
                      "Long": 73.0503
                    },
                    {
                      "Area": "Vadnagar",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 23.9321,
                      "Long": 73.0503
                    },
                    {
                      "Area": "Vadodara",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 23.3498,
                      "Long": 73.9423
                    },
                    {
                      "Area": "Vaghodia",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 23.0231,
                      "Long": 73.5319
                    },
                    {
                      "Area": "Vaghodida",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 22.3069,
                      "Long": 73.4928
                    },
                    {
                      "Area": "Vaghoida",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 22.7334,
                      "Long": 73.3473
                    },
                    {
                      "Area": "Vagra",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 22.7493,
                      "Long": 73.5587
                    },
                    {
                      "Area": "Vaibhavwadi",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 16.1343,
                      "Long": 74.0544
                    },
                    {
                      "Area": "Vaijapur",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 20.559,
                      "Long": 75.7456
                    },
                    {
                      "Area": "Vaikom",
                      "State": "Kerala",
                      "CountryCode": "IN",
                      "Lat": 10.4995,
                      "Long": 76.7789
                    },
                    {
                      "Area": "Vaimapalle",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.4769,
                      "Long": 78.5711
                    },
                    {
                      "Area": "Vaimpalle",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.4769,
                      "Long": 78.5711
                    },
                    {
                      "Area": "Vairengte",
                      "State": "Mizoram",
                      "CountryCode": "IN",
                      "Lat": 23.6567,
                      "Long": 92.8299
                    },
                    {
                      "Area": "Vaishali",
                      "State": "Bihar",
                      "CountryCode": "IN",
                      "Lat": 25.9746,
                      "Long": 85.307
                    },
                    {
                      "Area": "Vajrakarur",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 15.1065,
                      "Long": 77.6276
                    },
                    {
                      "Area": "Vajrapukothuru",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 18.7205,
                      "Long": 84.4593
                    },
                    {
                      "Area": "Vajrapukotturu Mandal",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 18.7433,
                      "Long": 84.2494
                    },
                    {
                      "Area": "Vakadu",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.328,
                      "Long": 80.2193
                    },
                    {
                      "Area": "Valangaiman",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 10.904,
                      "Long": 79.4104
                    },
                    {
                      "Area": "Valangaman",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 11.1329,
                      "Long": 79.599
                    },
                    {
                      "Area": "Valapady",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 12.2653,
                      "Long": 78.4582
                    },
                    {
                      "Area": "Valia",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 22.5497,
                      "Long": 73.3604
                    },
                    {
                      "Area": "Valigonda",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.3761,
                      "Long": 79.0213
                    },
                    {
                      "Area": "Valijapur",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 20.0215,
                      "Long": 75.2735
                    },
                    {
                      "Area": "Vallabhangar",
                      "State": "Rajasthan",
                      "CountryCode": "IN",
                      "Lat": 24.5801,
                      "Long": 74.067
                    },
                    {
                      "Area": "Vallabhiopur",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 21.8887,
                      "Long": 71.8793
                    },
                    {
                      "Area": "Vallabhipur",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 22.1572,
                      "Long": 71.9627
                    },
                    {
                      "Area": "Vallabhnagar",
                      "State": "Rajasthan",
                      "CountryCode": "IN",
                      "Lat": 25.0295,
                      "Long": 74.4635
                    },
                    {
                      "Area": "Vallbhiopur",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 21.3808,
                      "Long": 72.0523
                    },
                    {
                      "Area": "Vallbhipur",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 22.1572,
                      "Long": 71.9627
                    },
                    {
                      "Area": "Vallur",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.9016,
                      "Long": 79.1923
                    },
                    {
                      "Area": "Valmikipuram",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.1825,
                      "Long": 79.0143
                    },
                    {
                      "Area": "Valod",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 23.0967,
                      "Long": 74.2515
                    },
                    {
                      "Area": "Valparai",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 11.0299,
                      "Long": 77.2037
                    },
                    {
                      "Area": "Valsad",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 22.2967,
                      "Long": 73.1744
                    },
                    {
                      "Area": "Valva",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 19.076,
                      "Long": 76.2851
                    },
                    {
                      "Area": "Vandavasi",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 12.8198,
                      "Long": 79.941
                    },
                    {
                      "Area": "Vandavsi",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 12.5414,
                      "Long": 79.4551
                    },
                    {
                      "Area": "Vandvasi",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 12.3692,
                      "Long": 79.6527
                    },
                    {
                      "Area": "Vangara",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 18.6887,
                      "Long": 83.6364
                    },
                    {
                      "Area": "Vangara Mandal",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 18.58,
                      "Long": 83.6568
                    },
                    {
                      "Area": "Vangoor",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.6436,
                      "Long": 79.1268
                    },
                    {
                      "Area": "Vaniyambadi",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 13.0087,
                      "Long": 79.81
                    },
                    {
                      "Area": "Vankal",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 22.2243,
                      "Long": 73.4383
                    },
                    {
                      "Area": "Vanranasi",
                      "State": "Uttar Pradesh",
                      "CountryCode": "IN",
                      "Lat": 25.4709,
                      "Long": 82.8421
                    },
                    {
                      "Area": "Vansda",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 23.8473,
                      "Long": 74.3241
                    },
                    {
                      "Area": "Vanthali(s)",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 22.0921,
                      "Long": 69.2751
                    },
                    {
                      "Area": "Vanthli",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 21.2215,
                      "Long": 70.554
                    },
                    {
                      "Area": "Vanur",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 12.1648,
                      "Long": 79.8107
                    },
                    {
                      "Area": "Varadaiahpalem",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 13.8355,
                      "Long": 79.9877
                    },
                    {
                      "Area": "Varanasi",
                      "State": "Uttar Pradesh",
                      "CountryCode": "IN",
                      "Lat": 25.8055,
                      "Long": 83.2519
                    },
                    {
                      "Area": "Varanasi Sadar",
                      "State": "Uttar Pradesh",
                      "CountryCode": "IN",
                      "Lat": 25.3802,
                      "Long": 82.9702
                    },
                    {
                      "Area": "Variav",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 21.2659,
                      "Long": 73.072
                    },
                    {
                      "Area": "Varikuntapadu",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 15.0489,
                      "Long": 79.4632
                    },
                    {
                      "Area": "Varni",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 18.5891,
                      "Long": 78.1237
                    },
                    {
                      "Area": "Vasai",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 19.5992,
                      "Long": 73.474
                    },
                    {
                      "Area": "Vashi",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 19.9303,
                      "Long": 76.4686
                    },
                    {
                      "Area": "Vatsavai",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.9832,
                      "Long": 80.3696
                    },
                    {
                      "Area": "Vav",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 24.4961,
                      "Long": 72.3833
                    },
                    {
                      "Area": "Vayalpad",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 13.776,
                      "Long": 79.2122
                    },
                    {
                      "Area": "Vazhapadi",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 12.2653,
                      "Long": 78.2221
                    },
                    {
                      "Area": "Vedaraniam",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 10.8494,
                      "Long": 79.851
                    },
                    {
                      "Area": "Vedaranyam",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 10.8494,
                      "Long": 79.851
                    },
                    {
                      "Area": "Vedarniam",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 10.5789,
                      "Long": 79.846
                    },
                    {
                      "Area": "Vedasandur",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 10.792,
                      "Long": 78.2901
                    },
                    {
                      "Area": "Vedurukuppam",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 13.6688,
                      "Long": 79.3863
                    },
                    {
                      "Area": "Veenavanka",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 18.4093,
                      "Long": 79.3858
                    },
                    {
                      "Area": "Veepangandla",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 16.806,
                      "Long": 78.2211
                    },
                    {
                      "Area": "Veeraballe",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.262,
                      "Long": 79.0695
                    },
                    {
                      "Area": "Veeraghattam",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 18.7065,
                      "Long": 83.9881
                    },
                    {
                      "Area": "Veerapunayanipalle",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.4577,
                      "Long": 78.4797
                    },
                    {
                      "Area": "Veerapunayunipalle",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.5942,
                      "Long": 78.5363
                    },
                    {
                      "Area": "Veeravalli",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.5627,
                      "Long": 80.8006
                    },
                    {
                      "Area": "Veerullapadu",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.4153,
                      "Long": 81.0443
                    },
                    {
                      "Area": "Velachha",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 21.4333,
                      "Long": 73.0167
                    },
                    {
                      "Area": "Veldanda",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.6436,
                      "Long": 78.8275
                    },
                    {
                      "Area": "Veldurthi",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 15.6452,
                      "Long": 77.9068
                    },
                    {
                      "Area": "Veldurthy",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.3878,
                      "Long": 80.17
                    },
                    {
                      "Area": "Velgatur",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 18.7775,
                      "Long": 79.082
                    },
                    {
                      "Area": "Velgode",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 15.3457,
                      "Long": 78.2082
                    },
                    {
                      "Area": "Velhe",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 19.6219,
                      "Long": 79.007
                    },
                    {
                      "Area": "Vellarikundu",
                      "State": "Kerala",
                      "CountryCode": "IN",
                      "Lat": 12.4628,
                      "Long": 75.2984
                    },
                    {
                      "Area": "Vellaturu",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.1209,
                      "Long": 79.6508
                    },
                    {
                      "Area": "Vellore",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 13.0318,
                      "Long": 79.7691
                    },
                    {
                      "Area": "Vellore Taluk",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 12.7779,
                      "Long": 79.1353
                    },
                    {
                      "Area": "Velpur (mdl)",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 17.3827,
                      "Long": 81.7704
                    },
                    {
                      "Area": "Velr",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 12.4665,
                      "Long": 78.5126
                    },
                    {
                      "Area": "Vempalle",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.4769,
                      "Long": 78.7836
                    },
                    {
                      "Area": "Vemsur",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.5969,
                      "Long": 80.6873
                    },
                    {
                      "Area": "Vemula",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.4384,
                      "Long": 78.3627
                    },
                    {
                      "Area": "Vemuru",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.2988,
                      "Long": 80.7174
                    },
                    {
                      "Area": "Vengalrajukuppam",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 13.4673,
                      "Long": 79.3988
                    },
                    {
                      "Area": "Vengurla",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 19.9464,
                      "Long": 77.2752
                    },
                    {
                      "Area": "Venkata Krishna Puram",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 13.4412,
                      "Long": 79.3634
                    },
                    {
                      "Area": "Venkatachala Satram",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.3274,
                      "Long": 79.9001
                    },
                    {
                      "Area": "Venkatachalam",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.3853,
                      "Long": 80.052
                    },
                    {
                      "Area": "Venkatagiri",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.4268,
                      "Long": 79.7344
                    },
                    {
                      "Area": "Venkatagirikota",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 13.1755,
                      "Long": 78.5726
                    },
                    {
                      "Area": "Venkatapur",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 18.3563,
                      "Long": 79.7992
                    },
                    {
                      "Area": "Venkatapuram",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 18.55,
                      "Long": 80.8643
                    },
                    {
                      "Area": "Vennkatapuram",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 18.2139,
                      "Long": 80.5396
                    },
                    {
                      "Area": "Vepada",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 18.2236,
                      "Long": 83.1636
                    },
                    {
                      "Area": "Veppanthattai",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 11.5174,
                      "Long": 78.983
                    },
                    {
                      "Area": "Veppur",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 11.547,
                      "Long": 78.9859
                    },
                    {
                      "Area": "Verinaag",
                      "State": "Jammu & Kashmir",
                      "CountryCode": "IN",
                      "Lat": 33.9509,
                      "Long": 75.3575
                    },
                    {
                      "Area": "Verka",
                      "State": "Punjab",
                      "CountryCode": "IN",
                      "Lat": 31.8256,
                      "Long": 75.0074
                    },
                    {
                      "Area": "Verrapanayanipalle",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.4536,
                      "Long": 78.4625
                    },
                    {
                      "Area": "Vetapalem",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 15.785,
                      "Long": 80.3066
                    },
                    {
                      "Area": "Vhamgmun",
                      "State": "Tripura",
                      "CountryCode": "IN",
                      "Lat": 24.1597,
                      "Long": 92.0329
                    },
                    {
                      "Area": "Vhangmun",
                      "State": "Tripura",
                      "CountryCode": "IN",
                      "Lat": 24.1597,
                      "Long": 92.0329
                    },
                    {
                      "Area": "Viakasnagar",
                      "State": "Uttarakhand",
                      "CountryCode": "IN",
                      "Lat": 30.394,
                      "Long": 77.8095
                    },
                    {
                      "Area": "Vidapanakal",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 15.1285,
                      "Long": 77.6801
                    },
                    {
                      "Area": "Vidavalur",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.6055,
                      "Long": 80.1111
                    },
                    {
                      "Area": "Vidisha",
                      "State": "Madhya Pradesh",
                      "CountryCode": "IN",
                      "Lat": 23.8927,
                      "Long": 78.2904
                    },
                    {
                      "Area": "Vijaayrai",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.8634,
                      "Long": 81.0099
                    },
                    {
                      "Area": "Vijai Nagar",
                      "State": "Uttar Pradesh",
                      "CountryCode": "IN",
                      "Lat": 26.5167,
                      "Long": 80.3155
                    },
                    {
                      "Area": "Vijapur",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 24.0651,
                      "Long": 73.7794
                    },
                    {
                      "Area": "Vijaragahvgarh",
                      "State": "Madhya Pradesh",
                      "CountryCode": "IN",
                      "Lat": 23.9493,
                      "Long": 80.6641
                    },
                    {
                      "Area": "Vijay Nagar",
                      "State": "Uttar Pradesh",
                      "CountryCode": "IN",
                      "Lat": 26.5167,
                      "Long": 80.3155
                    },
                    {
                      "Area": "Vijayapuram",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 13.4673,
                      "Long": 79.767
                    },
                    {
                      "Area": "Vijayaragahvgarh",
                      "State": "Madhya Pradesh",
                      "CountryCode": "IN",
                      "Lat": 23.9843,
                      "Long": 80.7916
                    },
                    {
                      "Area": "Vijayaraghavgarh",
                      "State": "Madhya Pradesh",
                      "CountryCode": "IN",
                      "Lat": 23.9763,
                      "Long": 80.8641
                    },
                    {
                      "Area": "Vijayaraghvgarh",
                      "State": "Madhya Pradesh",
                      "CountryCode": "IN",
                      "Lat": 23.7931,
                      "Long": 80.7916
                    },
                    {
                      "Area": "Vijayarai",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.8352,
                      "Long": 81.065
                    },
                    {
                      "Area": "Vijayarghavgarh",
                      "State": "Madhya Pradesh",
                      "CountryCode": "IN",
                      "Lat": 23.7931,
                      "Long": 80.7916
                    },
                    {
                      "Area": "Vijayawada",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.5078,
                      "Long": 80.7193
                    },
                    {
                      "Area": "Vijayawada (Rural)",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.5209,
                      "Long": 80.6914
                    },
                    {
                      "Area": "Vijayawada (Urban)",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 17.1751,
                      "Long": 82.1662
                    },
                    {
                      "Area": "Vijaynagar",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 23.9853,
                      "Long": 73.7897
                    },
                    {
                      "Area": "Vijaynagar.",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 23.7294,
                      "Long": 73.134
                    },
                    {
                      "Area": "Vijaypur",
                      "State": "Madhya Pradesh",
                      "CountryCode": "IN",
                      "Lat": 25.9272,
                      "Long": 77.5411
                    },
                    {
                      "Area": "Vijayragahvgarh",
                      "State": "Madhya Pradesh",
                      "CountryCode": "IN",
                      "Lat": 23.7931,
                      "Long": 80.7916
                    },
                    {
                      "Area": "Vijayraghavgarh",
                      "State": "Madhya Pradesh",
                      "CountryCode": "IN",
                      "Lat": 23.9493,
                      "Long": 80.6641
                    },
                    {
                      "Area": "Vijoynagar",
                      "State": "Arunachal Pradesh",
                      "CountryCode": "IN",
                      "Lat": 27.9126,
                      "Long": 96.1288
                    },
                    {
                      "Area": "Vijoypur",
                      "State": "Arunachal Pradesh",
                      "CountryCode": "IN",
                      "Lat": 27.9126,
                      "Long": 96.1288
                    },
                    {
                      "Area": "Vikarabad",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.0587,
                      "Long": 78.4228
                    },
                    {
                      "Area": "Vikas Nagar",
                      "State": "Uttar Pradesh",
                      "CountryCode": "IN",
                      "Lat": 26.418,
                      "Long": 80.298
                    },
                    {
                      "Area": "Vikasnagar",
                      "State": "Uttarakhand",
                      "CountryCode": "IN",
                      "Lat": 30.5073,
                      "Long": 78.1393
                    },
                    {
                      "Area": "Vikasnagar **",
                      "State": "Uttarakhand",
                      "CountryCode": "IN",
                      "Lat": 30.5838,
                      "Long": 78.1384
                    },
                    {
                      "Area": "Vikramgad",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 19.9243,
                      "Long": 73.5785
                    },
                    {
                      "Area": "Vilathikulam",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 9.7368,
                      "Long": 78.3205
                    },
                    {
                      "Area": "Vilathikulam ( Kol)",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 9.2049,
                      "Long": 78.2432
                    },
                    {
                      "Area": "Vilathikulam (kol)",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 9.3498,
                      "Long": 78.3633
                    },
                    {
                      "Area": "Vilavancode",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 10.3953,
                      "Long": 77.8671
                    },
                    {
                      "Area": "Villianur Commune Panchayat",
                      "State": "Pondicherry",
                      "CountryCode": "IN",
                      "Lat": 11.9139,
                      "Long": 79.7557
                    },
                    {
                      "Area": "Villupuram",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 12.3081,
                      "Long": 79.8107
                    },
                    {
                      "Area": "Villupurm",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 11.9911,
                      "Long": 79.4341
                    },
                    {
                      "Area": "Viluppuram",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 12.3081,
                      "Long": 79.7056
                    },
                    {
                      "Area": "Vinjamoor",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.9488,
                      "Long": 79.761
                    },
                    {
                      "Area": "Vinjamur",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.8336,
                      "Long": 79.5799
                    },
                    {
                      "Area": "Vinukonda",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.2988,
                      "Long": 80.0915
                    },
                    {
                      "Area": "Vip Nagar",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 22.966,
                      "Long": 88.2036
                    },
                    {
                      "Area": "Vipanakal",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 15.0129,
                      "Long": 77.1144
                    },
                    {
                      "Area": "Virajpet",
                      "State": "Karnataka",
                      "CountryCode": "IN",
                      "Lat": 13.381,
                      "Long": 76.3199
                    },
                    {
                      "Area": "Virakeralampudur",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 9.2784,
                      "Long": 77.9141
                    },
                    {
                      "Area": "Virakerlamapudur",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 8.3718,
                      "Long": 77.9141
                    },
                    {
                      "Area": "Viramgam",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 23.2582,
                      "Long": 72.6843
                    },
                    {
                      "Area": "Viravasaram (mdl)",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.5842,
                      "Long": 81.4741
                    },
                    {
                      "Area": "Viravasaram(mdl)",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.7374,
                      "Long": 81.5704
                    },
                    {
                      "Area": "Virpur",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 23.2559,
                      "Long": 73.5183
                    },
                    {
                      "Area": "Virudhachalam",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 11.6048,
                      "Long": 79.6154
                    },
                    {
                      "Area": "Virudhunagar",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 11.7353,
                      "Long": 78.8214
                    },
                    {
                      "Area": "Virur",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.872,
                      "Long": 79.6219
                    },
                    {
                      "Area": "Visakhapatnam",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 18.166,
                      "Long": 83.6531
                    },
                    {
                      "Area": "Visakhapatnam (Rural)",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 17.8225,
                      "Long": 83.3639
                    },
                    {
                      "Area": "Visakhapatnam (Urban)",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 18.1021,
                      "Long": 83.6531
                    },
                    {
                      "Area": "Visakhapatnam Rural",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 17.7133,
                      "Long": 83.2808
                    },
                    {
                      "Area": "Visakhapatnam.",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 18.0849,
                      "Long": 83.2455
                    },
                    {
                      "Area": "Visavadar",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 21.4854,
                      "Long": 70.9807
                    },
                    {
                      "Area": "Vishnupur",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 22.9793,
                      "Long": 87.9687
                    },
                    {
                      "Area": "Viskhapatnam",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 18.0141,
                      "Long": 83.2936
                    },
                    {
                      "Area": "Visnagar",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 23.8153,
                      "Long": 73.3428
                    },
                    {
                      "Area": "Vissannapet",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 17.0379,
                      "Long": 81.2402
                    },
                    {
                      "Area": "Vivek Nagar",
                      "State": "Arunachal Pradesh",
                      "CountryCode": "IN",
                      "Lat": 28.2358,
                      "Long": 94.6742
                    },
                    {
                      "Area": "Vizianagaram",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 18.2939,
                      "Long": 83.5262
                    },
                    {
                      "Area": "Vja",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.5627,
                      "Long": 80.8006
                    },
                    {
                      "Area": "Vkhani",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.4307,
                      "Long": 80.6189
                    },
                    {
                      "Area": "Vl",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 12.6976,
                      "Long": 79.5709
                    },
                    {
                      "Area": "Vlr",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 13.0318,
                      "Long": 79.7691
                    },
                    {
                      "Area": "Vlrq",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 12.7537,
                      "Long": 78.893
                    },
                    {
                      "Area": "Voikom",
                      "State": "Kerala",
                      "CountryCode": "IN",
                      "Lat": 9.6875,
                      "Long": 76.7789
                    },
                    {
                      "Area": "Vojili",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.0296,
                      "Long": 79.9744
                    },
                    {
                      "Area": "Voletivaripalem",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 15.6213,
                      "Long": 79.5158
                    },
                    {
                      "Area": "Vontimitta",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.4144,
                      "Long": 79.1041
                    },
                    {
                      "Area": "Vriddhachalam",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 11.8666,
                      "Long": 79.4884
                    },
                    {
                      "Area": "Vriudhunagar",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 10.9844,
                      "Long": 78.4673
                    },
                    {
                      "Area": "Vundrajavaram (mdl)",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.7854,
                      "Long": 81.686
                    },
                    {
                      "Area": "Vungutur",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.6767,
                      "Long": 81.449
                    },
                    {
                      "Area": "Vunguturu",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.5627,
                      "Long": 81.3196
                    },
                    {
                      "Area": "Vunguturu Mandalam",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.8946,
                      "Long": 81.474
                    },
                    {
                      "Area": "Vuyyur",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.4057,
                      "Long": 80.9032
                    },
                    {
                      "Area": "Vuyyuru",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.442,
                      "Long": 80.9187
                    },
                    {
                      "Area": "Vv",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.5397,
                      "Long": 78.9806
                    },
                    {
                      "Area": "Vvpalem",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 18.0405,
                      "Long": 80.7483
                    },
                    {
                      "Area": "Vyara",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 22.15,
                      "Long": 73.7553
                    },
                    {
                      "Area": "Vythiri",
                      "State": "Kerala",
                      "CountryCode": "IN",
                      "Lat": 11.8146,
                      "Long": 76.2001
                    },
                    {
                      "Area": "WAGOORA",
                      "State": "Jammu & Kashmir",
                      "CountryCode": "IN",
                      "Lat": 34.1162,
                      "Long": 74.2995
                    },
                    {
                      "Area": "Wada",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 19.8908,
                      "Long": 73.3095
                    },
                    {
                      "Area": "Wade",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 19.7466,
                      "Long": 73.0878
                    },
                    {
                      "Area": "Wadhwan",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 22.7028,
                      "Long": 72.0544
                    },
                    {
                      "Area": "Wadhwancity",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 23.1615,
                      "Long": 73.0224
                    },
                    {
                      "Area": "Wadhwanicity",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 22.505,
                      "Long": 72.0805
                    },
                    {
                      "Area": "Wadwani",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 19.6881,
                      "Long": 77.9838
                    },
                    {
                      "Area": "Wai",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 20.1806,
                      "Long": 75.6891
                    },
                    {
                      "Area": "Wakro",
                      "State": "Arunachal Pradesh",
                      "CountryCode": "IN",
                      "Lat": 27.7955,
                      "Long": 96.1825
                    },
                    {
                      "Area": "Walaja",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 12.934,
                      "Long": 79.335
                    },
                    {
                      "Area": "Walajapet",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 12.9952,
                      "Long": 79.661
                    },
                    {
                      "Area": "Walajapet Taluk",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 12.934,
                      "Long": 79.335
                    },
                    {
                      "Area": "Wallajah",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 13.0685,
                      "Long": 79.5074
                    },
                    {
                      "Area": "Walva",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 19.076,
                      "Long": 76.2851
                    },
                    {
                      "Area": "Wanaparthy",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.1796,
                      "Long": 78.7719
                    },
                    {
                      "Area": "Wanapathy",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 16.2732,
                      "Long": 78.2248
                    },
                    {
                      "Area": "Wangat",
                      "State": "Jammu & Kashmir",
                      "CountryCode": "IN",
                      "Lat": 34.1758,
                      "Long": 74.9148
                    },
                    {
                      "Area": "Wangjing",
                      "State": "Manipur",
                      "CountryCode": "IN",
                      "Lat": 24.5892,
                      "Long": 94.0639
                    },
                    {
                      "Area": "Wangjing S.O",
                      "State": "Manipur",
                      "CountryCode": "IN",
                      "Lat": 24.5892,
                      "Long": 94.0639
                    },
                    {
                      "Area": "Wangund",
                      "State": "Jammu & Kashmir",
                      "CountryCode": "IN",
                      "Lat": 33.5778,
                      "Long": 75.1861
                    },
                    {
                      "Area": "Wani",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 20.4207,
                      "Long": 79.0784
                    },
                    {
                      "Area": "Wankaner",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 22.6626,
                      "Long": 71.3839
                    },
                    {
                      "Area": "Wanpora",
                      "State": "Jammu & Kashmir",
                      "CountryCode": "IN",
                      "Lat": 33.8072,
                      "Long": 74.8689
                    },
                    {
                      "Area": "Warangal",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 18.2192,
                      "Long": 79.8118
                    },
                    {
                      "Area": "Waraseoni",
                      "State": "Madhya Pradesh",
                      "CountryCode": "IN",
                      "Lat": 21.8333,
                      "Long": 80.1708
                    },
                    {
                      "Area": "Wardha",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 20.8463,
                      "Long": 78.9682
                    },
                    {
                      "Area": "Wardhannapet",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.9968,
                      "Long": 79.7992
                    },
                    {
                      "Area": "Warisaliganj",
                      "State": "Bihar",
                      "CountryCode": "IN",
                      "Lat": 25.0185,
                      "Long": 85.6646
                    },
                    {
                      "Area": "Warora",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 20.6459,
                      "Long": 79.5752
                    },
                    {
                      "Area": "Warud",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 21.5071,
                      "Long": 78.356
                    },
                    {
                      "Area": "Washi",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 19.9303,
                      "Long": 76.4686
                    },
                    {
                      "Area": "Washim",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 20.6196,
                      "Long": 77.8876
                    },
                    {
                      "Area": "Watakala",
                      "State": "Jammu & Kashmir",
                      "CountryCode": "IN",
                      "Lat": 33.8072,
                      "Long": 74.8689
                    },
                    {
                      "Area": "Watgan",
                      "State": "Chattisgarh",
                      "CountryCode": "IN",
                      "Lat": 21.487,
                      "Long": 82.2171
                    },
                    {
                      "Area": "Watrihaal",
                      "State": "Jammu & Kashmir",
                      "CountryCode": "IN",
                      "Lat": 33.9245,
                      "Long": 74.6725
                    },
                    {
                      "Area": "Weir",
                      "State": "Rajasthan",
                      "CountryCode": "IN",
                      "Lat": 27.2457,
                      "Long": 77.6083
                    },
                    {
                      "Area": "West Bunghmun",
                      "State": "Mizoram",
                      "CountryCode": "IN",
                      "Lat": 23.2628,
                      "Long": 92.6304
                    },
                    {
                      "Area": "West Phaileng",
                      "State": "Mizoram",
                      "CountryCode": "IN",
                      "Lat": 23.927,
                      "Long": 92.4897
                    },
                    {
                      "Area": "West Rataceherra",
                      "State": "Tripura",
                      "CountryCode": "IN",
                      "Lat": 24.0447,
                      "Long": 91.7553
                    },
                    {
                      "Area": "West Ratacherra",
                      "State": "Tripura",
                      "CountryCode": "IN",
                      "Lat": 24.0447,
                      "Long": 91.7553
                    },
                    {
                      "Area": "West Singhbhum",
                      "State": "Jharkhand",
                      "CountryCode": "IN",
                      "Lat": 22.7628,
                      "Long": 85.827
                    },
                    {
                      "Area": "West Tripura",
                      "State": "Tripura",
                      "CountryCode": "IN",
                      "Lat": 23.6622,
                      "Long": 91.3881
                    },
                    {
                      "Area": "Wgdt",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.9544,
                      "Long": 81.5721
                    },
                    {
                      "Area": "Williamnagar",
                      "State": "Meghalaya",
                      "CountryCode": "IN",
                      "Lat": 25.6432,
                      "Long": 90.6168
                    },
                    {
                      "Area": "Wokha",
                      "State": "Nagaland",
                      "CountryCode": "IN",
                      "Lat": 26.2617,
                      "Long": 94.3194
                    },
                    {
                      "Area": "Wuyan",
                      "State": "Jammu & Kashmir",
                      "CountryCode": "IN",
                      "Lat": 34.0246,
                      "Long": 74.966
                    },
                    {
                      "Area": "Wyra",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 18.0976,
                      "Long": 80.9028
                    },
                    {
                      "Area": "Y .ramavaram",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 17.6482,
                      "Long": 82.1279
                    },
                    {
                      "Area": "Y Ramavaram",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 17.9655,
                      "Long": 82.0511
                    },
                    {
                      "Area": "Y.k Pora",
                      "State": "Jammu & Kashmir",
                      "CountryCode": "IN",
                      "Lat": 33.5339,
                      "Long": 75.1844
                    },
                    {
                      "Area": "Yadagarigutta",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.4888,
                      "Long": 79.5833
                    },
                    {
                      "Area": "Yadagirigutta",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.4888,
                      "Long": 79.0324
                    },
                    {
                      "Area": "Yadamarri",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 13.4592,
                      "Long": 79.0755
                    },
                    {
                      "Area": "Yadgir",
                      "State": "Karnataka",
                      "CountryCode": "IN",
                      "Lat": 16.9472,
                      "Long": 77.4078
                    },
                    {
                      "Area": "Yadgiri",
                      "State": "Karnataka",
                      "CountryCode": "IN",
                      "Lat": 16.9472,
                      "Long": 77.454
                    },
                    {
                      "Area": "Yadgri",
                      "State": "Karnataka",
                      "CountryCode": "IN",
                      "Lat": 16.9021,
                      "Long": 77.1195
                    },
                    {
                      "Area": "Yadiki",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 15.0953,
                      "Long": 78.1069
                    },
                    {
                      "Area": "Yairipok",
                      "State": "Manipur",
                      "CountryCode": "IN",
                      "Lat": 24.6813,
                      "Long": 94.063
                    },
                    {
                      "Area": "Yamuna Nagar",
                      "State": "Haryana",
                      "CountryCode": "IN",
                      "Lat": 30.3854,
                      "Long": 77.4561
                    },
                    {
                      "Area": "Yamunanagar",
                      "State": "Haryana",
                      "CountryCode": "IN",
                      "Lat": 30.0939,
                      "Long": 77.3216
                    },
                    {
                      "Area": "Yangkang",
                      "State": "Arunachal Pradesh",
                      "CountryCode": "IN",
                      "Lat": 27.1318,
                      "Long": 95.7349
                    },
                    {
                      "Area": "Yaripora",
                      "State": "Jammu & Kashmir",
                      "CountryCode": "IN",
                      "Lat": 33.9563,
                      "Long": 74.834
                    },
                    {
                      "Area": "Yashoda Nagar",
                      "State": "Uttar Pradesh",
                      "CountryCode": "IN",
                      "Lat": 26.5934,
                      "Long": 80.6879
                    },
                    {
                      "Area": "Yatapaka",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 17.602,
                      "Long": 82.0677
                    },
                    {
                      "Area": "Yavatmal",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 20.7045,
                      "Long": 78.4182
                    },
                    {
                      "Area": "Yawal",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 21.2384,
                      "Long": 76.0564
                    },
                    {
                      "Area": "Yearraguntla",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.5942,
                      "Long": 78.5363
                    },
                    {
                      "Area": "Yedpalle",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 18.5261,
                      "Long": 78.1439
                    },
                    {
                      "Area": "Yelandur",
                      "State": "Karnataka",
                      "CountryCode": "IN",
                      "Lat": 12.2641,
                      "Long": 77.0998
                    },
                    {
                      "Area": "Yelbuarga",
                      "State": "Karnataka",
                      "CountryCode": "IN",
                      "Lat": 15.7036,
                      "Long": 75.8823
                    },
                    {
                      "Area": "Yelbulrga",
                      "State": "Karnataka",
                      "CountryCode": "IN",
                      "Lat": 15.5617,
                      "Long": 76.2219
                    },
                    {
                      "Area": "Yelbura",
                      "State": "Karnataka",
                      "CountryCode": "IN",
                      "Lat": 15.3598,
                      "Long": 75.5857
                    },
                    {
                      "Area": "Yelburga",
                      "State": "Karnataka",
                      "CountryCode": "IN",
                      "Lat": 16.0524,
                      "Long": 76.3578
                    },
                    {
                      "Area": "Yeleswaram",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 17.4007,
                      "Long": 82.2039
                    },
                    {
                      "Area": "Yelladu",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.5614,
                      "Long": 80.4588
                    },
                    {
                      "Area": "Yellamanchili",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 17.5491,
                      "Long": 82.8575
                    },
                    {
                      "Area": "Yellandu",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.8703,
                      "Long": 80.9352
                    },
                    {
                      "Area": "Yellandu Colls",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.8703,
                      "Long": 80.4934
                    },
                    {
                      "Area": "Yellanoor",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.7808,
                      "Long": 78.3193
                    },
                    {
                      "Area": "Yellanur",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.6858,
                      "Long": 78.38
                    },
                    {
                      "Area": "Yellapur",
                      "State": "Karnataka",
                      "CountryCode": "IN",
                      "Lat": 14.9997,
                      "Long": 74.8222
                    },
                    {
                      "Area": "Yellareddipet",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 18.4286,
                      "Long": 78.6887
                    },
                    {
                      "Area": "Yellareddy",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 18.5261,
                      "Long": 78.1967
                    },
                    {
                      "Area": "Yellareddypet",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 18.3907,
                      "Long": 80.1059
                    },
                    {
                      "Area": "Yellpaur",
                      "State": "Karnataka",
                      "CountryCode": "IN",
                      "Lat": 14.5245,
                      "Long": 74.8072
                    },
                    {
                      "Area": "Yellpur",
                      "State": "Karnataka",
                      "CountryCode": "IN",
                      "Lat": 14.8986,
                      "Long": 74.8078
                    },
                    {
                      "Area": "Yemmiganur",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 15.6915,
                      "Long": 77.8241
                    },
                    {
                      "Area": "Yeola",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 20.4127,
                      "Long": 74.6755
                    },
                    {
                      "Area": "Yeola.",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 20.152,
                      "Long": 74.4804
                    },
                    {
                      "Area": "Yercaud",
                      "State": "Tamil Nadu",
                      "CountryCode": "IN",
                      "Lat": 11.9338,
                      "Long": 78.5031
                    },
                    {
                      "Area": "Yerpedu",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 13.8945,
                      "Long": 79.6271
                    },
                    {
                      "Area": "Yerragondapalem",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 16.1351,
                      "Long": 79.5158
                    },
                    {
                      "Area": "Yerraguntla",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 14.5942,
                      "Long": 79.3513
                    },
                    {
                      "Area": "Yerravaripalem",
                      "State": "Andhra Pradesh",
                      "CountryCode": "IN",
                      "Lat": 13.7221,
                      "Long": 78.9943
                    },
                    {
                      "Area": "Yerrupalem",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.5969,
                      "Long": 80.6873
                    },
                    {
                      "Area": "Yevla",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 20.1864,
                      "Long": 74.5417
                    },
                    {
                      "Area": "Yingkiong",
                      "State": "Arunachal Pradesh",
                      "CountryCode": "IN",
                      "Lat": 28.6104,
                      "Long": 95.0687
                    },
                    {
                      "Area": "Yoji Yora",
                      "State": "Arunachal Pradesh",
                      "CountryCode": "IN",
                      "Lat": 28.2358,
                      "Long": 94.6742
                    },
                    {
                      "Area": "Yomcha",
                      "State": "Arunachal Pradesh",
                      "CountryCode": "IN",
                      "Lat": 28.1264,
                      "Long": 94.5522
                    },
                    {
                      "Area": "Yupia",
                      "State": "Arunachal Pradesh",
                      "CountryCode": "IN",
                      "Lat": 27.1763,
                      "Long": 93.7551
                    },
                    {
                      "Area": "Zafargadah",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.8626,
                      "Long": 79.467
                    },
                    {
                      "Area": "Zafargaddah",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.8682,
                      "Long": 79.4816
                    },
                    {
                      "Area": "Zafargadh",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.8626,
                      "Long": 79.467
                    },
                    {
                      "Area": "Zafarpur",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 22.6247,
                      "Long": 88.2876
                    },
                    {
                      "Area": "Zaffargaddh",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.8857,
                      "Long": 79.5048
                    },
                    {
                      "Area": "Zaffargadgh",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.7678,
                      "Long": 79.4566
                    },
                    {
                      "Area": "Zaffargadh",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.796,
                      "Long": 79.6801
                    },
                    {
                      "Area": "Zaheerabad",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 18.1636,
                      "Long": 78.5005
                    },
                    {
                      "Area": "Zahirabad",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 17.5806,
                      "Long": 77.6099
                    },
                    {
                      "Area": "Zainabad",
                      "State": "Haryana",
                      "CountryCode": "IN",
                      "Lat": 28.2881,
                      "Long": 76.3823
                    },
                    {
                      "Area": "Zainakote",
                      "State": "Jammu & Kashmir",
                      "CountryCode": "IN",
                      "Lat": 34.14,
                      "Long": 74.7964
                    },
                    {
                      "Area": "Zaithang",
                      "State": "Tripura",
                      "CountryCode": "IN",
                      "Lat": 24.0447,
                      "Long": 91.7553
                    },
                    {
                      "Area": "Zalukie",
                      "State": "Nagaland",
                      "CountryCode": "IN",
                      "Lat": 25.9288,
                      "Long": 94.3486
                    },
                    {
                      "Area": "Zamania",
                      "State": "Uttar Pradesh",
                      "CountryCode": "IN",
                      "Lat": 25.7187,
                      "Long": 83.8313
                    },
                    {
                      "Area": "Zamnia",
                      "State": "Uttar Pradesh",
                      "CountryCode": "IN",
                      "Lat": 25.4932,
                      "Long": 83.7118
                    },
                    {
                      "Area": "Zamurtali",
                      "State": "Tripura",
                      "CountryCode": "IN",
                      "Lat": 23.9923,
                      "Long": 91.6205
                    },
                    {
                      "Area": "Zankhvav",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 22.066,
                      "Long": 73.9351
                    },
                    {
                      "Area": "Zanskar",
                      "State": "Jammu & Kashmir",
                      "CountryCode": "IN",
                      "Lat": 33.6592,
                      "Long": 76.9897
                    },
                    {
                      "Area": "Zari Jamni",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 20.3752,
                      "Long": 78.898
                    },
                    {
                      "Area": "Zawlnuam",
                      "State": "Mizoram",
                      "CountryCode": "IN",
                      "Lat": 23.7123,
                      "Long": 92.4717
                    },
                    {
                      "Area": "Zeerapur",
                      "State": "Madhya Pradesh",
                      "CountryCode": "IN",
                      "Lat": 24.0762,
                      "Long": 76.3904
                    },
                    {
                      "Area": "Zemabawk",
                      "State": "Mizoram",
                      "CountryCode": "IN",
                      "Lat": 23.869,
                      "Long": 92.8769
                    },
                    {
                      "Area": "Zemithang",
                      "State": "Arunachal Pradesh",
                      "CountryCode": "IN",
                      "Lat": 27.4852,
                      "Long": 92.0686
                    },
                    {
                      "Area": "Zira",
                      "State": "Punjab",
                      "CountryCode": "IN",
                      "Lat": 31.1424,
                      "Long": 75.3395
                    },
                    {
                      "Area": "Ziradei",
                      "State": "Bihar",
                      "CountryCode": "IN",
                      "Lat": 26.2593,
                      "Long": 84.8128
                    },
                    {
                      "Area": "Zirakpur",
                      "State": "West Bengal",
                      "CountryCode": "IN",
                      "Lat": 22.6191,
                      "Long": 88.8788
                    },
                    {
                      "Area": "Ziro",
                      "State": "Arunachal Pradesh",
                      "CountryCode": "IN",
                      "Lat": 27.6255,
                      "Long": 93.9391
                    },
                    {
                      "Area": "Zotlang",
                      "State": "Mizoram",
                      "CountryCode": "IN",
                      "Lat": 23.2794,
                      "Long": 92.7735
                    },
                    {
                      "Area": "Zunheboto",
                      "State": "Nagaland",
                      "CountryCode": "IN",
                      "Lat": 26.4339,
                      "Long": 94.7678
                    },
                    {
                      "Area": "vadia",
                      "State": "Gujarat",
                      "CountryCode": "IN",
                      "Lat": 22.1848,
                      "Long": 71.0925
                    },
                    {
                      "Area": "vemulawada",
                      "State": "Telangana",
                      "CountryCode": "IN",
                      "Lat": 18.5336,
                      "Long": 79.5981
                    },
                    {
                      "Area": "zari",
                      "State": "Maharashtra",
                      "CountryCode": "IN",
                      "Lat": 20.0906,
                      "Long": 78.6791
                    },
                    {
                      "Area": "'s-Hertogenbosch",
                      "Lat": "51.6833",
                      "Long": "5.3167",
                      "CountryCode": "NL"
                    },
                    {
                      "Area": "Ubá",
                      "Lat": "-21.1196",
                      "Long": "-42.95",
                      "CountryCode": "BR"
                    },
                    {
                      "Area": "Uberaba",
                      "Lat": "-19.78",
                      "Long": "-47.95",
                      "CountryCode": "BR"
                    },
                    {
                      "Area": "Uberlândia",
                      "Lat": "-18.9",
                      "Long": "-48.28",
                      "CountryCode": "BR"
                    },
                    {
                      "Area": "Ubon Ratchathani",
                      "Lat": "15.25",
                      "Long": "104.83",
                      "CountryCode": "TH"
                    },
                    {
                      "Area": "Udine",
                      "Lat": "46.07",
                      "Long": "13.24",
                      "CountryCode": "IT"
                    },
                    {
                      "Area": "Udon Thani",
                      "Lat": "17.4048",
                      "Long": "102.7893",
                      "CountryCode": "TH"
                    },
                    {
                      "Area": "Ufa",
                      "Lat": "54.79",
                      "Long": "56.04",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Uíge",
                      "Lat": "-7.62",
                      "Long": "15.05",
                      "CountryCode": "AO"
                    },
                    {
                      "Area": "Uitenhage",
                      "Lat": "-33.7596",
                      "Long": "25.39",
                      "CountryCode": "ZA"
                    },
                    {
                      "Area": "Ujungpandang",
                      "Lat": "-5.14",
                      "Long": "119.432",
                      "CountryCode": "ID"
                    },
                    {
                      "Area": "Ukhta",
                      "Lat": "63.56",
                      "Long": "53.69",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Ulaanbaatar",
                      "Lat": "47.9167",
                      "Long": "106.9166",
                      "CountryCode": "MN"
                    },
                    {
                      "Area": "Ulan Ude",
                      "Lat": "51.825",
                      "Long": "107.625",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Ulanhot",
                      "Lat": "46.08",
                      "Long": "122.08",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Ulm",
                      "Lat": "48.4004",
                      "Long": "10",
                      "CountryCode": "DE"
                    },
                    {
                      "Area": "Ulsan",
                      "Lat": "35.5467",
                      "Long": "129.317",
                      "CountryCode": "kr"
                    },
                    {
                      "Area": "Ulyanovsk",
                      "Lat": "54.33",
                      "Long": "48.41",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Uman",
                      "Lat": "48.7543",
                      "Long": "30.2109",
                      "CountryCode": "UA"
                    },
                    {
                      "Area": "Umeå",
                      "Lat": "63.83",
                      "Long": "20.24",
                      "CountryCode": "SE"
                    },
                    {
                      "Area": "Umm Ruwaba",
                      "Lat": "12.9104",
                      "Long": "31.2",
                      "CountryCode": "SD"
                    },
                    {
                      "Area": "Umtata",
                      "Lat": "-31.58",
                      "Long": "28.79",
                      "CountryCode": "ZA"
                    },
                    {
                      "Area": "Umuahia",
                      "Lat": "5.532",
                      "Long": "7.486",
                      "CountryCode": "NG"
                    },
                    {
                      "Area": "Union City",
                      "Lat": "37.603",
                      "Long": "-122.0187",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Union City",
                      "Lat": "40.7674",
                      "Long": "-74.0323",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Upata",
                      "Lat": "8.0204",
                      "Long": "-62.41",
                      "CountryCode": "VE"
                    },
                    {
                      "Area": "Upington",
                      "Lat": "-28.46",
                      "Long": "21.23",
                      "CountryCode": "ZA"
                    },
                    {
                      "Area": "Upland",
                      "Lat": "34.1178",
                      "Long": "-117.6603",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Uppsala",
                      "Lat": "59.8601",
                      "Long": "17.64",
                      "CountryCode": "SE"
                    },
                    {
                      "Area": "Urgentch",
                      "Lat": "41.56",
                      "Long": "60.64",
                      "CountryCode": "UZ"
                    },
                    {
                      "Area": "Urgut",
                      "Lat": "39.4007",
                      "Long": "67.2607",
                      "CountryCode": "UZ"
                    },
                    {
                      "Area": "Urmia",
                      "Lat": "37.53",
                      "Long": "45",
                      "CountryCode": "IR"
                    },
                    {
                      "Area": "Uroteppa",
                      "Lat": "39.9219",
                      "Long": "69.0015",
                      "CountryCode": "TJ"
                    },
                    {
                      "Area": "Uruapan",
                      "Lat": "19.4204",
                      "Long": "-102.07",
                      "CountryCode": "MX"
                    },
                    {
                      "Area": "Uruguaiana",
                      "Lat": "-29.7696",
                      "Long": "-57.09",
                      "CountryCode": "BR"
                    },
                    {
                      "Area": "Ürümqi",
                      "Lat": "43.805",
                      "Long": "87.575",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Uşak",
                      "Lat": "38.6804",
                      "Long": "29.42",
                      "CountryCode": "TR"
                    },
                    {
                      "Area": "Ushuaia",
                      "Lat": "-54.79",
                      "Long": "-68.31",
                      "CountryCode": "AR"
                    },
                    {
                      "Area": "Usolye Sibirskoye",
                      "Lat": "52.765",
                      "Long": "103.645",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Ussuriysk",
                      "Lat": "43.8",
                      "Long": "132.02",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Ust-Ulimsk",
                      "Lat": "57.99",
                      "Long": "102.6333",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Usti Nad Labem",
                      "Lat": "50.663",
                      "Long": "14.081",
                      "CountryCode": "CZ"
                    },
                    {
                      "Area": "Usulután",
                      "Lat": "13.346",
                      "Long": "-88.432",
                      "CountryCode": "SV"
                    },
                    {
                      "Area": "Utica",
                      "Lat": "43.0961",
                      "Long": "-75.226",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Utrecht",
                      "Lat": "52.1003",
                      "Long": "5.12",
                      "CountryCode": "NL"
                    },
                    {
                      "Area": "Utsunomiya",
                      "Lat": "36.55",
                      "Long": "139.87",
                      "CountryCode": "JP"
                    },
                    {
                      "Area": "Uttaradit",
                      "Lat": "17.6316",
                      "Long": "100.0972",
                      "CountryCode": "TH"
                    },
                    {
                      "Area": "Uvinza",
                      "Lat": "-5.1196",
                      "Long": "30.39",
                      "CountryCode": "TZ"
                    },
                    {
                      "Area": "Uvira",
                      "Lat": "-3.37",
                      "Long": "29.14",
                      "CountryCode": "CD"
                    },
                    {
                      "Area": "Uyo",
                      "Lat": "5.008",
                      "Long": "7.85",
                      "CountryCode": "NG"
                    },
                    {
                      "Area": "Uzhgorod",
                      "Lat": "48.63",
                      "Long": "22.25",
                      "CountryCode": "UA"
                    },
                    {
                      "Area": "Vaasa",
                      "Lat": "63.1",
                      "Long": "21.6",
                      "CountryCode": "FI"
                    },
                    {
                      "Area": "Vacaria",
                      "Lat": "-28.4996",
                      "Long": "-50.94",
                      "CountryCode": "BR"
                    },
                    {
                      "Area": "Vacaville",
                      "Lat": "38.3592",
                      "Long": "-121.9686",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Valdivia",
                      "Lat": "-39.795",
                      "Long": "-73.245",
                      "CountryCode": "CL"
                    },
                    {
                      "Area": "Valdosta",
                      "Lat": "30.8503",
                      "Long": "-83.2789",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Valença",
                      "Lat": "-13.3596",
                      "Long": "-39.08",
                      "CountryCode": "BR"
                    },
                    {
                      "Area": "Valencia",
                      "Lat": "10.23",
                      "Long": "-67.98",
                      "CountryCode": "VE"
                    },
                    {
                      "Area": "Valencia",
                      "Lat": "39.485",
                      "Long": "-0.4",
                      "CountryCode": "ES"
                    },
                    {
                      "Area": "Valera",
                      "Lat": "9.32",
                      "Long": "-70.62",
                      "CountryCode": "VE"
                    },
                    {
                      "Area": "Valladolid",
                      "Lat": "41.65",
                      "Long": "-4.75",
                      "CountryCode": "ES"
                    },
                    {
                      "Area": "Valle de la Pascua",
                      "Lat": "9.21",
                      "Long": "-66.02",
                      "CountryCode": "VE"
                    },
                    {
                      "Area": "Valledupar",
                      "Lat": "10.48",
                      "Long": "-73.25",
                      "CountryCode": "CO"
                    },
                    {
                      "Area": "Vallejo",
                      "Lat": "38.1133",
                      "Long": "-122.2359",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Valletta",
                      "Lat": "35.8997",
                      "Long": "14.5147",
                      "CountryCode": "MT"
                    },
                    {
                      "Area": "Valparaíso",
                      "Lat": "-33.0478",
                      "Long": "-71.621",
                      "CountryCode": "CL"
                    },
                    {
                      "Area": "Van",
                      "Lat": "38.4954",
                      "Long": "43.4",
                      "CountryCode": "TR"
                    },
                    {
                      "Area": "Vanadzor",
                      "Lat": "40.8128",
                      "Long": "44.4883",
                      "CountryCode": "AM"
                    },
                    {
                      "Area": "Vancouver",
                      "Lat": "49.2734",
                      "Long": "-123.1216",
                      "CountryCode": "CA"
                    },
                    {
                      "Area": "Vancouver",
                      "Lat": "45.6352",
                      "Long": "-122.597",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Varamin",
                      "Lat": "35.3166",
                      "Long": "51.6466",
                      "CountryCode": "IR"
                    },
                    {
                      "Area": "Varna",
                      "Lat": "43.2156",
                      "Long": "27.8953",
                      "CountryCode": "BG"
                    },
                    {
                      "Area": "Várzea Grande",
                      "Lat": "-15.65",
                      "Long": "-56.14",
                      "CountryCode": "BR"
                    },
                    {
                      "Area": "Vaslui",
                      "Lat": "46.6333",
                      "Long": "27.7333",
                      "CountryCode": "RO"
                    },
                    {
                      "Area": "Västerås",
                      "Lat": "59.63",
                      "Long": "16.54",
                      "CountryCode": "SE"
                    },
                    {
                      "Area": "Växjö",
                      "Lat": "56.8837",
                      "Long": "14.8167",
                      "CountryCode": "SE"
                    },
                    {
                      "Area": "Vejle",
                      "Lat": "55.709",
                      "Long": "9.535",
                      "CountryCode": "DK"
                    },
                    {
                      "Area": "Velikiy Novgorod",
                      "Lat": "58.5",
                      "Long": "31.33",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Velikiye Luki",
                      "Lat": "56.32",
                      "Long": "30.52",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Venado Tuerto",
                      "Lat": "-33.7496",
                      "Long": "-61.97",
                      "CountryCode": "AR"
                    },
                    {
                      "Area": "Venice",
                      "Lat": "45.4387",
                      "Long": "12.335",
                      "CountryCode": "IT"
                    },
                    {
                      "Area": "Veracruz",
                      "Lat": "19.1773",
                      "Long": "-96.16",
                      "CountryCode": "MX"
                    },
                    {
                      "Area": "Vereeniging",
                      "Lat": "-26.6496",
                      "Long": "27.96",
                      "CountryCode": "ZA"
                    },
                    {
                      "Area": "Verona",
                      "Lat": "45.4404",
                      "Long": "10.99",
                      "CountryCode": "IT"
                    },
                    {
                      "Area": "Versailles",
                      "Lat": "48.8005",
                      "Long": "2.1333",
                      "CountryCode": "FR"
                    },
                    {
                      "Area": "Veszprém",
                      "Lat": "47.091",
                      "Long": "17.911",
                      "CountryCode": "HU"
                    },
                    {
                      "Area": "Victoria",
                      "Lat": "48.4333",
                      "Long": "-123.35",
                      "CountryCode": "CA"
                    },
                    {
                      "Area": "Victoria",
                      "Lat": "28.8285",
                      "Long": "-96.985",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Victorville",
                      "Lat": "34.5277",
                      "Long": "-117.3537",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Viedma",
                      "Lat": "-40.8",
                      "Long": "-63",
                      "CountryCode": "AR"
                    },
                    {
                      "Area": "Vienna",
                      "Lat": "48.2",
                      "Long": "16.3666",
                      "CountryCode": "AT"
                    },
                    {
                      "Area": "Vientiane",
                      "Lat": "17.9667",
                      "Long": "102.6",
                      "CountryCode": "LA"
                    },
                    {
                      "Area": "Việt Trì",
                      "Lat": "21.3304",
                      "Long": "105.43",
                      "CountryCode": "VN"
                    },
                    {
                      "Area": "Vigo",
                      "Lat": "42.22",
                      "Long": "-8.73",
                      "CountryCode": "ES"
                    },
                    {
                      "Area": "Vila Velha",
                      "Lat": "-20.3676",
                      "Long": "-40.318",
                      "CountryCode": "BR"
                    },
                    {
                      "Area": "Vila Velha",
                      "Lat": "3.2167",
                      "Long": "-51.2167",
                      "CountryCode": "BR"
                    },
                    {
                      "Area": "Vilhena",
                      "Lat": "-12.7166",
                      "Long": "-60.1166",
                      "CountryCode": "BR"
                    },
                    {
                      "Area": "Villa Carlos Paz",
                      "Lat": "-31.42",
                      "Long": "-64.5",
                      "CountryCode": "AR"
                    },
                    {
                      "Area": "Villa María",
                      "Lat": "-32.41",
                      "Long": "-63.26",
                      "CountryCode": "AR"
                    },
                    {
                      "Area": "Villahermosa",
                      "Lat": "18",
                      "Long": "-92.9",
                      "CountryCode": "MX"
                    },
                    {
                      "Area": "Villavicencio",
                      "Lat": "4.1533",
                      "Long": "-73.635",
                      "CountryCode": "CO"
                    },
                    {
                      "Area": "Vilnius",
                      "Lat": "54.6834",
                      "Long": "25.3166",
                      "CountryCode": "LT"
                    },
                    {
                      "Area": "Viña del Mar",
                      "Lat": "-33.03",
                      "Long": "-71.54",
                      "CountryCode": "CL"
                    },
                    {
                      "Area": "Vineland",
                      "Lat": "39.4653",
                      "Long": "-74.9981",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Vinh",
                      "Lat": "18.7",
                      "Long": "105.68",
                      "CountryCode": "VN"
                    },
                    {
                      "Area": "Vĩnh Long",
                      "Lat": "10.256",
                      "Long": "105.964",
                      "CountryCode": "VN"
                    },
                    {
                      "Area": "Vinnytsya",
                      "Lat": "49.2254",
                      "Long": "28.4816",
                      "CountryCode": "UA"
                    },
                    {
                      "Area": "Virginia Beach",
                      "Lat": "36.7335",
                      "Long": "-76.0435",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Visalia",
                      "Lat": "36.3273",
                      "Long": "-119.3264",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Vista",
                      "Lat": "33.1895",
                      "Long": "-117.2387",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Vitoria",
                      "Lat": "42.85",
                      "Long": "-2.67",
                      "CountryCode": "ES"
                    },
                    {
                      "Area": "Vitória",
                      "Lat": "-20.324",
                      "Long": "-40.366",
                      "CountryCode": "BR"
                    },
                    {
                      "Area": "Vitória da Conquista",
                      "Lat": "-14.85",
                      "Long": "-40.84",
                      "CountryCode": "BR"
                    },
                    {
                      "Area": "Vitsyebsk",
                      "Lat": "55.1887",
                      "Long": "30.1853",
                      "CountryCode": "BY"
                    },
                    {
                      "Area": "Vladikavkaz",
                      "Lat": "43.0504",
                      "Long": "44.67",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Vladimir",
                      "Lat": "56.13",
                      "Long": "40.4099",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Vladivostok",
                      "Lat": "43.13",
                      "Long": "131.91",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Vlorë",
                      "Lat": "40.4774",
                      "Long": "19.4982",
                      "CountryCode": "AL"
                    },
                    {
                      "Area": "Volgodonsk",
                      "Lat": "47.51",
                      "Long": "42.1599",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Volgograd",
                      "Lat": "48.71",
                      "Long": "44.5",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Vologda",
                      "Lat": "59.21",
                      "Long": "39.92",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Volos",
                      "Lat": "39.37",
                      "Long": "22.95",
                      "CountryCode": "GR"
                    },
                    {
                      "Area": "Volsk",
                      "Lat": "52.0347",
                      "Long": "47.3743",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Volta Redonda",
                      "Lat": "-22.5196",
                      "Long": "-44.095",
                      "CountryCode": "BR"
                    },
                    {
                      "Area": "Volzhskiy",
                      "Lat": "48.7948",
                      "Long": "44.7744",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Vorkuta",
                      "Lat": "67.5",
                      "Long": "64.01",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Voronezh",
                      "Lat": "51.73",
                      "Long": "39.27",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Votkinsk",
                      "Lat": "57.0304",
                      "Long": "53.99",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Vratsa",
                      "Lat": "43.21",
                      "Long": "23.5625",
                      "CountryCode": "BG"
                    },
                    {
                      "Area": "Vryheid",
                      "Lat": "-27.76",
                      "Long": "30.79",
                      "CountryCode": "ZA"
                    },
                    {
                      "Area": "Vung Tau",
                      "Lat": "10.3554",
                      "Long": "107.085",
                      "CountryCode": "VN"
                    },
                    {
                      "Area": "Vyazma",
                      "Lat": "55.2122",
                      "Long": "34.2918",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Vyborg",
                      "Lat": "60.7039",
                      "Long": "28.7549",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Vyshnniy Volochek",
                      "Lat": "57.583",
                      "Long": "34.5631",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Vyska",
                      "Lat": "55.3247",
                      "Long": "42.1644",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Wa",
                      "Lat": "10.0604",
                      "Long": "-2.5",
                      "CountryCode": "GH"
                    },
                    {
                      "Area": "Waco",
                      "Lat": "31.5597",
                      "Long": "-97.1883",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Wafangdian",
                      "Lat": "39.6259",
                      "Long": "121.996",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Wagga Wagga",
                      "Lat": "-35.1222",
                      "Long": "147.34",
                      "CountryCode": "AU"
                    },
                    {
                      "Area": "Waitakere",
                      "Lat": "-36.8524",
                      "Long": "174.5543",
                      "CountryCode": "NZ"
                    },
                    {
                      "Area": "Wakayama",
                      "Lat": "34.2231",
                      "Long": "135.1677",
                      "CountryCode": "JP"
                    },
                    {
                      "Area": "Walla Walla",
                      "Lat": "46.067",
                      "Long": "-118.3365",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Walnut Creek",
                      "Lat": "37.9025",
                      "Long": "-122.0398",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Waltham",
                      "Lat": "42.3889",
                      "Long": "-71.2423",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Walvis Bay",
                      "Lat": "-22.9575",
                      "Long": "14.5053",
                      "CountryCode": "NA"
                    },
                    {
                      "Area": "Wamba",
                      "Lat": "2.1404",
                      "Long": "27.99",
                      "CountryCode": "CD"
                    },
                    {
                      "Area": "Wangqing",
                      "Lat": "43.3248",
                      "Long": "129.7343",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Wanzhou",
                      "Lat": "30.82",
                      "Long": "108.4",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Warner Robins",
                      "Lat": "32.598",
                      "Long": "-83.6528",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Warren",
                      "Lat": "42.4934",
                      "Long": "-83.027",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Warri",
                      "Lat": "5.52",
                      "Long": "5.76",
                      "CountryCode": "NG"
                    },
                    {
                      "Area": "Warsaw",
                      "Lat": "52.25",
                      "Long": "21",
                      "CountryCode": "PL"
                    },
                    {
                      "Area": "Warwick",
                      "Lat": "41.7062",
                      "Long": "-71.4334",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Washington",
                      "Lat": "38.9047",
                      "Long": "-77.0163",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Watampone",
                      "Lat": "-4.5328",
                      "Long": "120.3334",
                      "CountryCode": "ID"
                    },
                    {
                      "Area": "Waterbury",
                      "Lat": "41.5583",
                      "Long": "-73.0361",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Waterloo",
                      "Lat": "42.492",
                      "Long": "-92.3522",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Watertown",
                      "Lat": "43.9734",
                      "Long": "-75.9094",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Watsonville",
                      "Lat": "36.9205",
                      "Long": "-121.7706",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Wau",
                      "Lat": "7.7",
                      "Long": "27.99",
                      "CountryCode": "SD"
                    },
                    {
                      "Area": "Waukegan",
                      "Lat": "42.3697",
                      "Long": "-87.8716",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Waukesha",
                      "Lat": "43.0087",
                      "Long": "-88.2464",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Wausau",
                      "Lat": "44.9615",
                      "Long": "-89.6436",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Weifang",
                      "Lat": "36.7204",
                      "Long": "119.1001",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Weihai",
                      "Lat": "37.5",
                      "Long": "122.1",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Weinan",
                      "Lat": "34.5004",
                      "Long": "109.5001",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Weirton",
                      "Lat": "40.406",
                      "Long": "-80.5671",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Welkom",
                      "Lat": "-27.97",
                      "Long": "26.73",
                      "CountryCode": "ZA"
                    },
                    {
                      "Area": "Wellington",
                      "Lat": "-41.3",
                      "Long": "174.7833",
                      "CountryCode": "NZ"
                    },
                    {
                      "Area": "Wellington",
                      "Lat": "26.6464",
                      "Long": "-80.2707",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Wenatchee",
                      "Lat": "47.4338",
                      "Long": "-120.3285",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Wenshan",
                      "Lat": "23.3724",
                      "Long": "104.2497",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Wenzhou",
                      "Lat": "28.02",
                      "Long": "120.6501",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "West Allis",
                      "Lat": "43.0068",
                      "Long": "-88.0296",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "West Bend",
                      "Lat": "43.4184",
                      "Long": "-88.1822",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "West Covina",
                      "Lat": "34.0555",
                      "Long": "-117.9113",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "West Des Moines",
                      "Lat": "41.5527",
                      "Long": "-93.7805",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "West Haven",
                      "Lat": "41.2739",
                      "Long": "-72.9671",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "West JO",
                      "Lat": "40.6024",
                      "Long": "-112.0008",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "West New York",
                      "Lat": "40.7856",
                      "Long": "-74.0093",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "West Palm Beach",
                      "Lat": "26.7467",
                      "Long": "-80.1314",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "West Sacramento",
                      "Lat": "38.5556",
                      "Long": "-121.5504",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "West Valley City",
                      "Lat": "40.6889",
                      "Long": "-112.0115",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Westland",
                      "Lat": "42.3192",
                      "Long": "-83.3805",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Westminster",
                      "Lat": "39.8837",
                      "Long": "-105.0627",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Westminster",
                      "Lat": "33.7523",
                      "Long": "-117.9938",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Weston",
                      "Lat": "26.1006",
                      "Long": "-80.4057",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Whangarei",
                      "Lat": "-35.7256",
                      "Long": "174.323",
                      "CountryCode": "NZ"
                    },
                    {
                      "Area": "Wheaton",
                      "Lat": "41.8561",
                      "Long": "-88.1083",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Wheeling",
                      "Lat": "40.0755",
                      "Long": "-80.6951",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "White Plains",
                      "Lat": "41.022",
                      "Long": "-73.7548",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Whittier",
                      "Lat": "33.9678",
                      "Long": "-118.0188",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Wichita",
                      "Lat": "37.6897",
                      "Long": "-97.3442",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Wichita Falls",
                      "Lat": "33.9072",
                      "Long": "-98.5293",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Wiener Neustadt",
                      "Lat": "47.816",
                      "Long": "16.25",
                      "CountryCode": "AT"
                    },
                    {
                      "Area": "Wiesbaden",
                      "Lat": "50.0804",
                      "Long": "8.25",
                      "CountryCode": "DE"
                    },
                    {
                      "Area": "Willemstad",
                      "Lat": "12.2004",
                      "Long": "-69.02",
                      "CountryCode": "CW"
                    },
                    {
                      "Area": "Williamsburg",
                      "Lat": "37.2693",
                      "Long": "-76.7076",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Williamsport",
                      "Lat": "41.2398",
                      "Long": "-77.0371",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Wilmington",
                      "Lat": "34.21",
                      "Long": "-77.886",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Wilmington",
                      "Lat": "39.7415",
                      "Long": "-75.5413",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Winchester",
                      "Lat": "39.1735",
                      "Long": "-78.1746",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Windhoek",
                      "Lat": "-22.57",
                      "Long": "17.0835",
                      "CountryCode": "NA"
                    },
                    {
                      "Area": "Windsor",
                      "Lat": "42.3333",
                      "Long": "-83.0333",
                      "CountryCode": "CA"
                    },
                    {
                      "Area": "Winnipeg",
                      "Lat": "49.883",
                      "Long": "-97.166",
                      "CountryCode": "CA"
                    },
                    {
                      "Area": "Winston-Salem",
                      "Lat": "36.1029",
                      "Long": "-80.261",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Winter Haven",
                      "Lat": "28.0122",
                      "Long": "-81.7018",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Wollongong",
                      "Lat": "-34.4154",
                      "Long": "150.89",
                      "CountryCode": "AU"
                    },
                    {
                      "Area": "Wonju",
                      "Lat": "37.3551",
                      "Long": "127.9396",
                      "CountryCode": "kr"
                    },
                    {
                      "Area": "Wonsan",
                      "Lat": "39.1605",
                      "Long": "127.4308",
                      "CountryCode": "KP"
                    },
                    {
                      "Area": "Woodbury",
                      "Lat": "44.9057",
                      "Long": "-92.923",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Woodland",
                      "Lat": "38.6712",
                      "Long": "-121.75",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Worcester",
                      "Lat": "42.2705",
                      "Long": "-71.8079",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Worcester",
                      "Lat": "-33.64",
                      "Long": "19.4399",
                      "CountryCode": "ZA"
                    },
                    {
                      "Area": "Wrocław",
                      "Lat": "51.1104",
                      "Long": "17.03",
                      "CountryCode": "PL"
                    },
                    {
                      "Area": "Wuhai",
                      "Lat": "39.6647",
                      "Long": "106.8122",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Wuhan",
                      "Lat": "30.58",
                      "Long": "114.27",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Wuhu",
                      "Lat": "31.3504",
                      "Long": "118.37",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Wukari",
                      "Lat": "7.8704",
                      "Long": "9.78",
                      "CountryCode": "NG"
                    },
                    {
                      "Area": "Wum",
                      "Lat": "6.4004",
                      "Long": "10.07",
                      "CountryCode": "CM"
                    },
                    {
                      "Area": "Wuppertal",
                      "Lat": "51.25",
                      "Long": "7.17",
                      "CountryCode": "DE"
                    },
                    {
                      "Area": "Würzburg",
                      "Lat": "49.8004",
                      "Long": "9.95",
                      "CountryCode": "DE"
                    },
                    {
                      "Area": "Wuwei",
                      "Lat": "37.928",
                      "Long": "102.641",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Wuxi",
                      "Lat": "31.58",
                      "Long": "120.3",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Wuzhou",
                      "Lat": "23.48",
                      "Long": "111.32",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Wyoming",
                      "Lat": "42.8909",
                      "Long": "-85.7066",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Xai-Xai",
                      "Lat": "-25.04",
                      "Long": "33.64",
                      "CountryCode": "MZ"
                    },
                    {
                      "Area": "Xalapa",
                      "Lat": "19.53",
                      "Long": "-96.92",
                      "CountryCode": "MX"
                    },
                    {
                      "Area": "Xanthi",
                      "Lat": "41.1418",
                      "Long": "24.8836",
                      "CountryCode": "GR"
                    },
                    {
                      "Area": "Xapeco",
                      "Lat": "-27.1",
                      "Long": "-52.64",
                      "CountryCode": "BR"
                    },
                    {
                      "Area": "Xiamen",
                      "Lat": "24.45",
                      "Long": "118.08",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Xian",
                      "Lat": "34.275",
                      "Long": "108.895",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Xiangfan",
                      "Lat": "32.02",
                      "Long": "112.13",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Xiangtai",
                      "Lat": "37.05",
                      "Long": "114.5",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Xiangtan",
                      "Lat": "27.8504",
                      "Long": "112.9",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Xiantao",
                      "Lat": "30.3704",
                      "Long": "113.44",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Xianyang",
                      "Lat": "34.3456",
                      "Long": "108.7147",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Xiaogan",
                      "Lat": "30.9204",
                      "Long": "113.9",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Xichang",
                      "Lat": "27.88",
                      "Long": "102.3",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Xigaze",
                      "Lat": "29.25",
                      "Long": "88.8833",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Xilinhot",
                      "Lat": "43.9443",
                      "Long": "116.0443",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Xingyi",
                      "Lat": "25.0904",
                      "Long": "104.89",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Xining",
                      "Lat": "36.62",
                      "Long": "101.77",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Xinqing",
                      "Lat": "48.2363",
                      "Long": "129.5059",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Xinxiang",
                      "Lat": "35.3204",
                      "Long": "113.87",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Xinyang",
                      "Lat": "32.1304",
                      "Long": "114.07",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Xinyi",
                      "Lat": "34.38",
                      "Long": "118.35",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Xinyu",
                      "Lat": "27.8",
                      "Long": "114.93",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Xinzhou",
                      "Lat": "38.4104",
                      "Long": "112.72",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Xuanhua",
                      "Lat": "40.5944",
                      "Long": "115.0243",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Xuanzhou",
                      "Lat": "30.9525",
                      "Long": "118.7553",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Xuchang",
                      "Lat": "34.0204",
                      "Long": "113.82",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Xuzhou",
                      "Lat": "34.28",
                      "Long": "117.18",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yaan",
                      "Lat": "29.9804",
                      "Long": "103.08",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yakeshi",
                      "Lat": "49.2804",
                      "Long": "120.73",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yakima",
                      "Lat": "46.5923",
                      "Long": "-120.5496",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Yakutsk",
                      "Lat": "62.035",
                      "Long": "129.735",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Yala",
                      "Lat": "6.5505",
                      "Long": "101.2851",
                      "CountryCode": "TH"
                    },
                    {
                      "Area": "Yamagata",
                      "Lat": "38.2705",
                      "Long": "140.32",
                      "CountryCode": "JP"
                    },
                    {
                      "Area": "Yamoussoukro",
                      "Lat": "6.8184",
                      "Long": "-5.2755",
                      "CountryCode": "CL"
                    },
                    {
                      "Area": "Yanbu al Bahr",
                      "Lat": "24.0943",
                      "Long": "38.0493",
                      "CountryCode": "SA"
                    },
                    {
                      "Area": "Yancheng",
                      "Lat": "33.3856",
                      "Long": "120.1253",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yangjiang",
                      "Lat": "21.8504",
                      "Long": "111.97",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yangmei",
                      "Lat": "24.9167",
                      "Long": "121.15",
                      "CountryCode": "TW"
                    },
                    {
                      "Area": "Yangquan",
                      "Lat": "37.87",
                      "Long": "113.57",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yangzhou",
                      "Lat": "32.4",
                      "Long": "119.43",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yanji",
                      "Lat": "42.8823",
                      "Long": "129.5128",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yantai",
                      "Lat": "37.5304",
                      "Long": "121.4",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yaounde",
                      "Lat": "3.8667",
                      "Long": "11.5167",
                      "CountryCode": "CM"
                    },
                    {
                      "Area": "Yaroslavl",
                      "Lat": "57.62",
                      "Long": "39.87",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Yasuj",
                      "Lat": "30.659",
                      "Long": "51.594",
                      "CountryCode": "IR"
                    },
                    {
                      "Area": "Yaynangyoung",
                      "Lat": "20.4615",
                      "Long": "94.881",
                      "CountryCode": "MM"
                    },
                    {
                      "Area": "Yazd",
                      "Lat": "31.9201",
                      "Long": "54.37",
                      "CountryCode": "IR"
                    },
                    {
                      "Area": "Ye",
                      "Lat": "15.2533",
                      "Long": "97.8679",
                      "CountryCode": "MM"
                    },
                    {
                      "Area": "Yegoryevsk",
                      "Lat": "55.3848",
                      "Long": "39.0294",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Yei",
                      "Lat": "4.0904",
                      "Long": "30.68",
                      "CountryCode": "SD"
                    },
                    {
                      "Area": "Yekaterinburg",
                      "Lat": "56.85",
                      "Long": "60.6",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Yelets",
                      "Lat": "52.58",
                      "Long": "38.5",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Yên Bái",
                      "Lat": "21.705",
                      "Long": "104.875",
                      "CountryCode": "VN"
                    },
                    {
                      "Area": "Yeosu",
                      "Lat": "34.7368",
                      "Long": "127.7458",
                      "CountryCode": "kr"
                    },
                    {
                      "Area": "Yerevan",
                      "Lat": "40.1812",
                      "Long": "44.5136",
                      "CountryCode": "AM"
                    },
                    {
                      "Area": "Yevlax",
                      "Lat": "40.6172",
                      "Long": "47.15",
                      "CountryCode": "AZ"
                    },
                    {
                      "Area": "Yeysk",
                      "Lat": "46.6988",
                      "Long": "38.2634",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Yibin",
                      "Lat": "28.77",
                      "Long": "104.57",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yichang",
                      "Lat": "30.7",
                      "Long": "111.28",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yichun",
                      "Lat": "27.8333",
                      "Long": "114.4",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yichun",
                      "Lat": "47.6999",
                      "Long": "128.9",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yilan",
                      "Lat": "24.75",
                      "Long": "121.75",
                      "CountryCode": "TW"
                    },
                    {
                      "Area": "Yinchuan",
                      "Lat": "38.468",
                      "Long": "106.273",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yingkow",
                      "Lat": "40.6703",
                      "Long": "122.28",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yining",
                      "Lat": "43.9",
                      "Long": "81.35",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yishui",
                      "Lat": "35.7904",
                      "Long": "118.62",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yiyang",
                      "Lat": "28.6004",
                      "Long": "112.33",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yogyakarta",
                      "Lat": "-7.78",
                      "Long": "110.375",
                      "CountryCode": "ID"
                    },
                    {
                      "Area": "Yokohama",
                      "Lat": "35.32",
                      "Long": "139.58",
                      "CountryCode": "JP"
                    },
                    {
                      "Area": "Yola",
                      "Lat": "9.21",
                      "Long": "12.48",
                      "CountryCode": "NG"
                    },
                    {
                      "Area": "Yongzhou",
                      "Lat": "26.2304",
                      "Long": "111.62",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yonkers",
                      "Lat": "40.9466",
                      "Long": "-73.8674",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Yopal",
                      "Lat": "5.347",
                      "Long": "-72.406",
                      "CountryCode": "CO"
                    },
                    {
                      "Area": "Yorba Linda",
                      "Lat": "33.889",
                      "Long": "-117.7714",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "York",
                      "Lat": "39.9651",
                      "Long": "-76.7315",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "York",
                      "Lat": "53.9704",
                      "Long": "-1.08",
                      "CountryCode": "GB"
                    },
                    {
                      "Area": "Yoshkar Ola",
                      "Lat": "56.6354",
                      "Long": "47.8749",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Youngstown",
                      "Lat": "41.0993",
                      "Long": "-80.6463",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Yozgat",
                      "Lat": "39.818",
                      "Long": "34.815",
                      "CountryCode": "TR"
                    },
                    {
                      "Area": "Yuba City",
                      "Lat": "39.1357",
                      "Long": "-121.6381",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Yucaipa",
                      "Lat": "34.0336",
                      "Long": "-117.0426",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Yuci",
                      "Lat": "37.6804",
                      "Long": "112.73",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yueyang",
                      "Lat": "29.3801",
                      "Long": "113.1",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yulin",
                      "Lat": "22.63",
                      "Long": "110.15",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yulin",
                      "Lat": "38.2833",
                      "Long": "109.7333",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yuma",
                      "Lat": "32.5991",
                      "Long": "-114.5488",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Yumen",
                      "Lat": "39.83",
                      "Long": "97.73",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yunxian",
                      "Lat": "32.8082",
                      "Long": "110.8136",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yurga",
                      "Lat": "55.7258",
                      "Long": "84.8854",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Yuxi",
                      "Lat": "24.38",
                      "Long": "102.57",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Yuzhno Sakhalinsk",
                      "Lat": "46.965",
                      "Long": "142.74",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Zabīd",
                      "Lat": "14.1951",
                      "Long": "43.3155",
                      "CountryCode": "YE"
                    },
                    {
                      "Area": "Zabol",
                      "Lat": "31.0215",
                      "Long": "61.4815",
                      "CountryCode": "IR"
                    },
                    {
                      "Area": "Zacatecas",
                      "Lat": "22.7704",
                      "Long": "-102.58",
                      "CountryCode": "MX"
                    },
                    {
                      "Area": "Zadar",
                      "Lat": "44.1201",
                      "Long": "15.2623",
                      "CountryCode": "HR"
                    },
                    {
                      "Area": "Zagazig",
                      "Lat": "30.5833",
                      "Long": "31.5167",
                      "CountryCode": "EG"
                    },
                    {
                      "Area": "Zagreb",
                      "Lat": "45.8",
                      "Long": "16",
                      "CountryCode": "HR"
                    },
                    {
                      "Area": "Zahedan",
                      "Lat": "29.5",
                      "Long": "60.83",
                      "CountryCode": "IR"
                    },
                    {
                      "Area": "Zahlé",
                      "Lat": "33.8501",
                      "Long": "35.9042",
                      "CountryCode": "LB"
                    },
                    {
                      "Area": "Zakho",
                      "Lat": "37.1445",
                      "Long": "42.6872",
                      "CountryCode": "IQ"
                    },
                    {
                      "Area": "Zalaegerszeg",
                      "Lat": "46.844",
                      "Long": "16.84",
                      "CountryCode": "HU"
                    },
                    {
                      "Area": "Zalantun",
                      "Lat": "48",
                      "Long": "122.72",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Zalău",
                      "Lat": "47.175",
                      "Long": "23.063",
                      "CountryCode": "RO"
                    },
                    {
                      "Area": "Zamboanga",
                      "Lat": "6.92",
                      "Long": "122.08",
                      "CountryCode": "PH"
                    },
                    {
                      "Area": "Zamora",
                      "Lat": "19.9804",
                      "Long": "-102.28",
                      "CountryCode": "MX"
                    },
                    {
                      "Area": "Zanjan",
                      "Lat": "36.67",
                      "Long": "48.5",
                      "CountryCode": "IR"
                    },
                    {
                      "Area": "Zanzibar",
                      "Lat": "-6.16",
                      "Long": "39.2",
                      "CountryCode": "TZ"
                    },
                    {
                      "Area": "Zaozhuang",
                      "Lat": "34.88",
                      "Long": "117.57",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Zaporizhzhya",
                      "Lat": "47.8573",
                      "Long": "35.1768",
                      "CountryCode": "UA"
                    },
                    {
                      "Area": "Zarafshon",
                      "Lat": "41.5822",
                      "Long": "64.2018",
                      "CountryCode": "UZ"
                    },
                    {
                      "Area": "Zaragoza",
                      "Lat": "41.65",
                      "Long": "-0.89",
                      "CountryCode": "ES"
                    },
                    {
                      "Area": "Zárate",
                      "Lat": "-34.0896",
                      "Long": "-59.04",
                      "CountryCode": "AR"
                    },
                    {
                      "Area": "Zaria",
                      "Lat": "11.08",
                      "Long": "7.71",
                      "CountryCode": "NG"
                    },
                    {
                      "Area": "Zarzis",
                      "Lat": "33.5104",
                      "Long": "11.1",
                      "CountryCode": "TN"
                    },
                    {
                      "Area": "Zelenodolsk",
                      "Lat": "55.8406",
                      "Long": "48.655",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Zenica",
                      "Lat": "44.22",
                      "Long": "17.92",
                      "CountryCode": "BA"
                    },
                    {
                      "Area": "Zephyrhills",
                      "Lat": "28.2407",
                      "Long": "-82.1797",
                      "CountryCode": "US"
                    },
                    {
                      "Area": "Zhangjiakou",
                      "Lat": "40.83",
                      "Long": "114.93",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Zhangye",
                      "Lat": "38.93",
                      "Long": "100.45",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Zhangzhou",
                      "Lat": "24.5204",
                      "Long": "117.67",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Zhanjiang",
                      "Lat": "21.2",
                      "Long": "110.38",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Zhanyi",
                      "Lat": "25.6005",
                      "Long": "103.8166",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Zhaodong",
                      "Lat": "46.0804",
                      "Long": "125.98",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Zhaoqing",
                      "Lat": "23.0504",
                      "Long": "112.45",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Zhaotang",
                      "Lat": "27.3204",
                      "Long": "103.72",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Zheleznogorsk",
                      "Lat": "52.3548",
                      "Long": "35.4044",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Zhengzhou",
                      "Lat": "34.755",
                      "Long": "113.6651",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Zhenjiang",
                      "Lat": "32.22",
                      "Long": "119.43",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Zhezqazghan",
                      "Lat": "47.78",
                      "Long": "67.77",
                      "CountryCode": "KZ"
                    },
                    {
                      "Area": "Zhijiang",
                      "Lat": "27.4409",
                      "Long": "109.678",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Zhob",
                      "Lat": "31.349",
                      "Long": "69.4386",
                      "CountryCode": "PK"
                    },
                    {
                      "Area": "Zhongli",
                      "Lat": "24.965",
                      "Long": "121.2168",
                      "CountryCode": "TW"
                    },
                    {
                      "Area": "Zhoukou",
                      "Lat": "33.6304",
                      "Long": "114.63",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Zhuanghe",
                      "Lat": "39.6823",
                      "Long": "122.9619",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Zhubei",
                      "Lat": "24.8333",
                      "Long": "121.0119",
                      "CountryCode": "TW"
                    },
                    {
                      "Area": "Zhucheng",
                      "Lat": "35.99",
                      "Long": "119.3801",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Zhuhai",
                      "Lat": "22.2769",
                      "Long": "113.5678",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Zhuozhou",
                      "Lat": "39.5401",
                      "Long": "115.79",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Zhuzhou",
                      "Lat": "27.83",
                      "Long": "113.15",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Zhytomyr",
                      "Lat": "50.2456",
                      "Long": "28.6622",
                      "CountryCode": "UA"
                    },
                    {
                      "Area": "Zibo",
                      "Lat": "36.8",
                      "Long": "118.05",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Zicheng",
                      "Lat": "30.3004",
                      "Long": "111.5",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Zielona Góra",
                      "Lat": "51.9504",
                      "Long": "15.5",
                      "CountryCode": "PL"
                    },
                    {
                      "Area": "Zigong",
                      "Lat": "29.4",
                      "Long": "104.78",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Ziguinchor",
                      "Lat": "12.59",
                      "Long": "-16.29",
                      "CountryCode": "SN"
                    },
                    {
                      "Area": "Žilina",
                      "Lat": "49.2198",
                      "Long": "18.7494",
                      "CountryCode": "SK"
                    },
                    {
                      "Area": "Zima",
                      "Lat": "53.9331",
                      "Long": "102.0331",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Zinder",
                      "Lat": "13.8",
                      "Long": "8.9833",
                      "CountryCode": "NE"
                    },
                    {
                      "Area": "Zlatoust",
                      "Lat": "55.175",
                      "Long": "59.65",
                      "CountryCode": "RU"
                    },
                    {
                      "Area": "Zlín",
                      "Lat": "49.2304",
                      "Long": "17.65",
                      "CountryCode": "CZ"
                    },
                    {
                      "Area": "Zomba",
                      "Lat": "-15.39",
                      "Long": "35.31",
                      "CountryCode": "MW"
                    },
                    {
                      "Area": "Zonguldak",
                      "Lat": "41.4304",
                      "Long": "31.78",
                      "CountryCode": "TR"
                    },
                    {
                      "Area": "Zouirat",
                      "Lat": "22.7304",
                      "Long": "-12.4833",
                      "CountryCode": "MR"
                    },
                    {
                      "Area": "Zrenjanin",
                      "Lat": "45.3786",
                      "Long": "20.3995",
                      "CountryCode": "RS"
                    },
                    {
                      "Area": "Zumpango",
                      "Lat": "19.8104",
                      "Long": "-99.11",
                      "CountryCode": "MX"
                    },
                    {
                      "Area": "Zunyi",
                      "Lat": "27.7",
                      "Long": "106.92",
                      "CountryCode": "CN"
                    },
                    {
                      "Area": "Zürich",
                      "Lat": "47.38",
                      "Long": "8.55",
                      "CountryCode": "CH"
                    },
                    {
                      "Area": "Zuwarah",
                      "Lat": "32.9344",
                      "Long": "12.0791",
                      "CountryCode": "LY"
                    },
                    {
                      "Area": "Zwolle",
                      "Lat": "52.524",
                      "Long": "6.097",
                      "CountryCode": "NL"
                    },
                    {
                      "Area": "Vasco da Gama",
                      "State": "Goa",
                      "CountryCode": "IN",
                      "Lat": 15.38603,
                      "Long": 73.84404
                    }
];